/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(615);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(146);


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1154);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(1155);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(20);
	var core = __webpack_require__(67);
	var hide = __webpack_require__(49);
	var redefine = __webpack_require__(50);
	var ctx = __webpack_require__(68);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(221);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(647), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(631);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(630);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(100);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(100);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(324);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.commonAlert = commonAlert;
	exports.commonCloseAlert = commonCloseAlert;
	exports.commonModalResize = commonModalResize;
	exports.commonOpenContact = commonOpenContact;
	exports.commonCloseContact = commonCloseContact;
	exports.commonNotify = commonNotify;
	exports.commonCloseNotify = commonCloseNotify;
	exports.commonOpenLogin = commonOpenLogin;
	exports.commonCloseLogin = commonCloseLogin;
	exports.commonRegisterNavChange = commonRegisterNavChange;
	exports.commonContactRequest = commonContactRequest;
	exports.commonFoundationRequest = commonFoundationRequest;
	exports.commonShoppingRequest = commonShoppingRequest;
	exports.commonServiceRequest = commonServiceRequest;
	exports.commonWatchRequest = commonWatchRequest;
	exports.commonGetInstagram = commonGetInstagram;
	exports.commonSummerContactRequest = commonSummerContactRequest;
	exports.commonAuburnContactRequest = commonAuburnContactRequest;
	exports.commonCustomDesignContactRequest = commonCustomDesignContactRequest;
	
	__webpack_require__(148);
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	var _endpoints = __webpack_require__(122);
	
	var endpoint = _interopRequireWildcard(_endpoints);
	
	var _api = __webpack_require__(121);
	
	var api = _interopRequireWildcard(_api);
	
	var _request = __webpack_require__(123);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/******************************
	*******  Synchronous  *********
	******************************/
	
	function commonAlert(text) {
	  var prompt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var theme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var nav = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  return {
	    type: constants.COMMON_ALERT,
	    text: text,
	    prompt: prompt,
	    theme: theme,
	    nav: nav
	  };
	}
	
	function commonCloseAlert() {
	  return {
	    type: constants.COMMON_CLOSE_ALERT
	  };
	}
	
	function commonModalResize() {
	  return {
	    type: constants.COMMON_MODAL_RESIZE
	  };
	}
	
	function commonOpenContact(text) {
	  return {
	    type: constants.COMMON_OPEN_CONTACT
	  };
	}
	
	function commonCloseContact() {
	  return {
	    type: constants.COMMON_CLOSE_CONTACT
	  };
	}
	
	function commonNotify() {
	  return {
	    type: constants.COMMON_NOTIFY
	  };
	}
	
	function commonCloseNotify() {
	  return {
	    type: constants.COMMON_CLOSE_NOTIFY
	  };
	}
	
	function commonOpenLogin() {
	  return {
	    type: constants.COMMON_OPEN_LOGIN
	  };
	}
	
	function commonCloseLogin() {
	  return {
	    type: constants.COMMON_CLOSE_LOGIN
	  };
	}
	
	function commonRegisterNavChange() {
	  return {
	    type: constants.COMMON_NAV_CHANGE
	  };
	}
	
	/******************************
	*******  Asynchronous  ********
	******************************/
	
	function commonContactRequest(contactData) {
	  return function (dispatch) {
	    var url = api.API_URL + endpoint.API_CONTACT;
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(contactData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function commonFoundationRequest(foundationData) {
	  return function (dispatch) {
	    var url = api.API_URL + endpoint.API_FOUNDATION;
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(foundationData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function commonShoppingRequest(shoppingData) {
	  return function (dispatch) {
	    var url = api.API_URL + endpoint.API_SHOPPING;
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(shoppingData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function commonServiceRequest(serviceData) {
	  return function (dispatch) {
	    var url = api.API_URL + endpoint.API_SERVICE;
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(serviceData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function commonWatchRequest(watchData) {
	  return function (dispatch) {
	    var url = api.API_URL + endpoint.API_WATCH;
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(watchData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function commonGetInstagram(watchData) {
	  return function (dispatch) {
	    var url = endpoint.INSTAGRAM_GET_IMAGES;
	
	    return fetch(url, {
	      method: 'get',
	      headers: api.HEADERS
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function commonSummerContactRequest(contactData) {
	  return function (dispatch) {
	    var url = api.API_URL + endpoint.API_SUMMER_CONTACT;
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(contactData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function commonAuburnContactRequest(contactData) {
	  return function (dispatch) {
	    var url = api.API_URL + endpoint.API_AUBURN_CONTACT;
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(contactData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function commonCustomDesignContactRequest(contactData) {
	  return function (dispatch) {
	    var url = api.API_URL + endpoint.API_CUSTOM_DESIGN;
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(contactData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	// export function commonNewsletterSubmit(email) {
	//   return dispatch => {
	//     let url = 'https://diamondsdirect.com/newsletter/subscriber/new/';
	
	//     const params = new FormData();
	//     params.append('email', email.trim());
	
	//     return fetch(url, {
	//       method: 'post',
	//       headers: api.HEADERS,
	//       body: params
	//     })
	//     .then(parseJSON)
	//     .then((resp) => {
	//       if(isOk(resp.status)) {
	//         return Promise.resolve(resp.data);
	//       } else {
	//         return Promise.reject(resp.data);
	//       }
	//     });
	//   }
	// }

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RhinoSelect = function (_React$Component) {
	  _inherits(RhinoSelect, _React$Component);
	
	  function RhinoSelect(props) {
	    _classCallCheck(this, RhinoSelect);
	
	    var _this = _possibleConstructorReturn(this, (RhinoSelect.__proto__ || Object.getPrototypeOf(RhinoSelect)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(RhinoSelect, [{
	    key: 'getParentClass',
	    value: function getParentClass() {
	      var baseClass = this.props.rootClass ? 'RhinoSelect ' + this.props.rootClass : 'RhinoSelect';
	      if (this.props.selectClass) {
	        baseClass = baseClass + ' ' + this.props.selectClass;
	      }
	      if (this.props.error) {
	        baseClass = baseClass + ' error';
	      }
	      return baseClass;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getParentClass() },
	        _react2.default.createElement(
	          'select',
	          {
	            disabled: this.props.disabled,
	            onBlur: (_context = this.props).blurMethod.bind(_context),
	            onChange: (_context = this.props).changeMethod.bind(_context),
	            value: this.props.value !== null ? this.props.value : this.props.options[0].value },
	          this.props.options.map(function (option, i) {
	            return _react2.default.createElement(
	              'option',
	              {
	                key: i,
	                value: option.value,
	                className: !option.value ? 'defaultOption' : 'selectableOption' },
	              option.display
	            );
	          })
	        ),
	        _react2.default.createElement('div', { className: 'select__arrow' })
	      );
	    }
	  }]);
	
	  return RhinoSelect;
	}(_react2.default.Component);
	
	RhinoSelect.defaultProps = {
	  blurMethod: function blurMethod() {},
	  disabled: false,
	  error: false,
	  value: null,
	  selectClass: null
	};
	RhinoSelect.propTypes = {
	  blurMethod: _react.PropTypes.func,
	  changeMethod: _react.PropTypes.func,
	  disabled: _react.PropTypes.bool,
	  error: _react.PropTypes.bool,
	  options: _react.PropTypes.array.isRequired,
	  value: _react.PropTypes.any
	};
	exports.default = RhinoSelect;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.locationValidation = locationValidation;
	exports.nameValidation = nameValidation;
	exports.emailValidation = emailValidation;
	exports.phoneValidation = phoneValidation;
	exports.zipValidation = zipValidation;
	exports.passwordValidation = passwordValidation;
	exports.dateValidation = dateValidation;
	exports.dateNoYearValidation = dateNoYearValidation;
	exports.ccNumberValidation = ccNumberValidation;
	exports.ccCvcValidation = ccCvcValidation;
	exports.idNumberValidation = idNumberValidation;
	exports.messageTextValidation = messageTextValidation;
	
	var _formatting = __webpack_require__(21);
	
	function locationValidation(testName) {
		if (testName === null) {
			return "Enter valid name";
		}
		var testLength = testName.trim().length;
		if (testLength <= 0) {
			return "Enter valid name";
		}
		if (testLength > 100) {
			return "100 characters maximum";
		}
		return null;
	}
	
	function nameValidation(testName) {
		if (testName === null) {
			return "Enter valid name";
		}
		var testLength = testName.trim().length;
		if (testLength <= 0) {
			return "Enter valid name";
		}
		if (testLength > 100) {
			return "100 characters maximum";
		}
		if (testName.match(/[^\w\s]/gi) !== null) {
			return "Enter a valid name";
		}
		return null;
	}
	
	function emailValidation(testEmail) {
		if (testEmail === null) {
			return "Enter valid email address";
		}
		var testLength = testEmail.trim().length;
		if (testLength <= 0) {
			return "Enter email address";
		}
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (!re.test(testEmail)) {
			return "Enter valid email";
		}
		return null;
	}
	
	function phoneValidation(testPhone) {
		if (!testPhone) {
			return "Enter valid phone number";
		}
		var numberString = (0, _formatting.stringToDigits)(testPhone);
		if (numberString.length != 10) {
			return "Phone numbers must have 10 digits";
		}
		return null;
	}
	
	function zipValidation(testZip) {
		if (!testZip) {
			return "Enter valid postal code";
		}
		var numberString = (0, _formatting.stringToDigits)(testZip);
		if (numberString.length != 5 && numberString.length != 9) {
			return "Postal code must have 5 or 9 digits";
		}
		return null;
	}
	
	function passwordValidation(testPassword) {
		if (testPassword === null) {
			return "Enter valid password";
		}
		if (testPassword != testPassword.trim()) {
			return "Cannot begin or end with a space";
		}
		var testLength = testPassword.trim().length;
		if (testLength < 8) {
			return "Must be at least 8 characters";
		}
		return null;
	}
	
	function dateValidation(testDate) {
		if (testDate === null || testDate === '') {
			return "Enter valid date";
		}
		var dateDigits = (0, _formatting.stringToDigits)(testDate);
		if (dateDigits.length != 8) {
			return 'Date must be: MM-DD-YYYY';
		}
		return null;
	}
	function dateNoYearValidation(testDate) {
		if (testDate === null || testDate === '') {
			return "Enter valid day and month";
		}
		var dateDigits = (0, _formatting.stringToDigits)(testDate);
		if (dateDigits.length != 4) {
			return 'Date must be: MM-DD';
		}
		return null;
	}
	
	function ccNumberValidation(testNumber) {
		if (testNumber === null) {
			return "Enter a valid credit card number";
		}
		var isNum = /^\d+$/.test(testNumber);
		var validLenth = testNumber.length >= 14 && testNumber.length <= 16;
		if (!isNum || !validLenth) {
			return "Enter a valid credit card number";
		}
		return null;
	}
	
	function ccCvcValidation(testCVC) {
		if (testCVC === null) {
			return "Enter a valid CVC";
		}
		var isNum = /^\d+$/.test(testCVC);
		var validLenth = testCVC.length == 3 || testCVC.length == 4;
		if (!isNum || !validLenth) {
			return "Enter a valid CVC";
		}
		return null;
	}
	
	function idNumberValidation(testIdNumber) {
		if (testIdNumber === null || testIdNumber === '') {
			return "Enter valid identification number";
		}
		var testLength = testIdNumber.trim().length;
		if (testLength <= 0) {
			return "Enter valid identification number";
		}
		if (testLength > 32) {
			return "32 characters maximum";
		}
		return null;
	}
	
	function messageTextValidation(messageText) {
		if (messageText === null || messageText === '') {
			return "Please enter a message";
		}
		var testLength = messageText.trim().length;
		if (testLength <= 0) {
			return "Please enter a message";
		}
		if (testLength > 65535) {
			return "It's a message, not a novel";
		}
		return null;
	}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(71);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.displayPhone = displayPhone;
	exports.displayPhoneInput = displayPhoneInput;
	exports.displayDate = displayDate;
	exports.displayDateFromDate = displayDateFromDate;
	exports.displayDateInput = displayDateInput;
	exports.displayDateNoYear = displayDateNoYear;
	exports.displayDateNoYearInput = displayDateNoYearInput;
	exports.displayDateFromTimestamp = displayDateFromTimestamp;
	exports.displayVerboseDateFromTimestamp = displayVerboseDateFromTimestamp;
	exports.displayTimeFromTimestamp = displayTimeFromTimestamp;
	exports.stringToDigits = stringToDigits;
	exports.stringStripNonCaps = stringStripNonCaps;
	exports.formatDropdownData = formatDropdownData;
	exports.diamondImgUrl = diamondImgUrl;
	exports.diamondTitle = diamondTitle;
	exports.diamondPrice = diamondPrice;
	exports.formatQuerystring = formatQuerystring;
	exports.titleCase = titleCase;
	exports.compareValue = compareValue;
	exports.formatDbDate = formatDbDate;
	exports.formatDateForDb = formatDateForDb;
	exports.getFormattedMetalType = getFormattedMetalType;
	exports.settingCartDesc = settingCartDesc;
	exports.diamondCartDesc = diamondCartDesc;
	exports.mensBandDescription = mensBandDescription;
	exports.womensBandDescription = womensBandDescription;
	exports.fashionCartDesc = fashionCartDesc;
	exports.fashionRingCartDesc = fashionRingCartDesc;
	exports.bandCartDesc = bandCartDesc;
	exports.getLocationNameById = getLocationNameById;
	exports.getIdByLocation = getIdByLocation;
	
	var _product = __webpack_require__(42);
	
	function displayPhone(phoneString) {
		var digitString = stringToDigits(phoneString);
		return digitString.slice(0, 3) + '.' + digitString.slice(3, 6) + '.' + digitString.slice(6, 10);
	}
	
	function displayPhoneInput(phoneString) {
		var digitString = stringToDigits(phoneString);
		if (digitString.length <= 3) {
			return digitString;
		} else if (digitString.length <= 6) {
			return digitString.slice(0, 3) + '-' + digitString.slice(3, 6);
		} else {
			return digitString.slice(0, 3) + '-' + digitString.slice(3, 6) + '-' + digitString.slice(6, 10);
		}
	}
	
	function displayDate(dateString) {
		if (dateString.trim() == '') {
			return '';
		}
		var digitString = stringToDigits(dateString);
		return digitString.slice(0, 2) + '-' + digitString.slice(2, 4) + '-' + digitString.slice(4, 8);
	}
	
	function displayDateFromDate(jsDate) {
		// if(jsDate.trim() == '') {
		// return '';
		// }
	
		// return jsDate;
		// console.log(jsDate);
	
	
		// let digitString = stringToDigits(dateString);
		// return (digitString.slice(0, 2) + '-' + digitString.slice(2, 4) + '-' + digitString.slice(4, 8));
	
		var dd = jsDate.getDate();
		var mm = jsDate.getMonth() + 1;
		var y = jsDate.getFullYear();
	
		return mm + '/' + dd + '/' + y;
	
		// return 'jsDate';
	}
	
	function displayDateInput(dateString) {
		var digitString = stringToDigits(dateString);
		if (digitString.length < 2) {
			return digitString;
		} else if (digitString.length < 3) {
			return digitString.slice(0, 2) + '-' + digitString.slice(2, 4);
		} else {
			return digitString.slice(0, 2) + '-' + digitString.slice(2, 4) + '-' + digitString.slice(4, 8);
		}
	}
	
	function displayDateNoYear(dateString) {
		if (dateString.trim() == '') {
			return '';
		}
		var digitString = stringToDigits(dateString);
		return digitString.slice(0, 2) + '-' + digitString.slice(2, 4);
	}
	
	function displayDateNoYearInput(dateString) {
		var digitString = stringToDigits(dateString);
		if (digitString.length < 2) {
			return digitString;
		} else {
			return digitString.slice(0, 2) + '-' + digitString.slice(2, 4);
		}
	}
	
	function displayDateFromTimestamp(timestampString) {
		var d = new Date(timestampString);
		return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
	}
	
	function displayVerboseDateFromTimestamp(timestampString) {
		var d = new Date(timestampString);
		var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
		return monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
	}
	
	function displayTimeFromTimestamp(timestampString) {
		var d = new Date(timestampString);
		var hour = d.getHours();
		var suffix = ' AM';
		if (hour > 12) {
			hour -= 12;
			suffix = ' PM';
		}
		if (hour === 0) {
			hour = 12;
		}
		var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
	
		return hour + ':' + minutes + suffix;
	}
	
	function stringToDigits(testString) {
		return testString.replace(/[^0-9]/g, '');
	}
	
	function stringStripNonCaps(testString) {
		return testString.replace(/[^A-Z]/g, '');
	}
	
	function formatDropdownData(dataArray, displayKey, valueKey) {
		var nullLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Select';
	
		var returnArray = [{
			display: nullLabel,
			value: ''
		}];
		for (var i = 0; i < dataArray.length; i++) {
			returnArray.push({
				display: dataArray[i][displayKey],
				value: dataArray[i][valueKey]
			});
		}
		return returnArray;
	}
	
	function diamondImgUrl(diamond) {
		return '';
	}
	
	function diamondTitle(diamond) {
		return diamond.shape + ' ' + parseFloat(diamond.caratWeight).toFixed(2) + ' ' + diamond.color + ' ' + diamond.clarity;
	}
	
	function diamondPrice(diamond) {
		return 'price';
	}
	
	function formatQuerystring(queryObj) {
		var pairsArray = [];
	
		for (var key in queryObj) {
			pairsArray.push(key + '=' + queryObj[key]);
		}
		return pairsArray.join('&');
	}
	
	function titleCase(str) {
	
		if (!str) {
			return '';
		}
	
		var splitStr = str.toLowerCase().split(' ');
		for (var i = 0; i < splitStr.length; i++) {
			if (i === 0 || splitStr[i].length > 3) {
				splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
			}
		}
		return splitStr.join(' ');
	}
	
	function compareValue() {
		var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
		if (!str) {
			return "None";
		} else {
			return titleCase(str);
		}
	}
	
	function formatDbDate() {
		var dbdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
		if (dbdate.trim() == '') {
			return '';
		}
		var splitDate = dbdate.toLowerCase().split('-');
		return splitDate[1] + '-' + splitDate[2] + '-' + splitDate[0];
	}
	
	function formatDateForDb() {
		var dateString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
		if (dateString.trim() == '') {
			return '';
		}
		var digitString = stringToDigits(dateString);
		return digitString.slice(4, 8) + '-' + digitString.slice(0, 2) + '-' + digitString.slice(2, 4);
	}
	
	function getFormattedMetalType(metalType) {
		if (!metalType) {
			return '';
		}
		switch (metalType) {
			case 'WG14':
				return '14k white gold';
			case 'YG14':
				return '14k yellow gold';
			case 'RG14':
				return '14k rose gold';
			case 'GG14':
				return '14k Gray gold';
			case 'WG18':
				return '18k white gold';
			case 'YG18':
				return '18k yellow gold';
			case 'RG18':
				return '18k rose gold';
			case 'GG18':
				return '18k gray gold';
			case 'TT':
				return 'Two-tone';
			case 'PLAT':
				return 'Platinum';
			case 'STEEL':
				return 'Stainless Steel';
			case 'SS':
				return 'Sterling Silver';
			case '18/PT':
				return '18K Platinum';
			case '14/PT':
				return '14K Platinum';
			case 'PALL':
				return 'Palladium';
			case 'TITAN':
				return 'Titanium';
			case 'TUNG':
				return 'Tungsten';
			case 'ELY':
				return 'Elysium';
			case 'COBLT':
				return 'Cobalt';
			case 'TANT':
				return 'Tantalum';
			case 'TRI':
				return 'Tri-color';
			case 'WG/TA':
				return 'White Gold/Tantalum';
			case 'RG/TA':
				return 'Rose Gold/Tantalum';
			case 'YG/TA':
				return 'Yellow Gold/Tantalum';
			case 'TA/TI':
				return 'Tantalum/Titanium';
			case 'WG/PT':
				return 'White Gold/Platinum';
			case 'RG/PT':
				return 'Rose Gold/Platinum';
			case 'YG/PT':
				return 'Yellow Gold/Platinum';
			case 'WG/TI':
				return 'White Gold/Titanium';
			case 'YG/TI':
				return 'Yellow Gold/Titanium';
			case 'RG/TI':
				return 'Rose Gold/Titanium';
			case 'RG/PD':
				return 'Rose Gold/Palladium';
			case 'NOMETAL':
				return 'No metal';
		}
		return metalType;
	}
	
	function settingCartDesc(setting, metalType, ringSize) {
	
		console.log(setting);
	
		var settingDesc = '';
	
		if (setting.vendor && setting.vendor.name && setting.vendor.item_number) {
			settingDesc += (0, _product.designerFormatName)(setting.vendor.name) + ' / ' + setting.vendor.item_number + '<br />';
		}
		settingDesc += '<B>Metal type</B>: ' + getFormattedMetalType(metalType) + '<br />';
		settingDesc += '<B>Carat weight</B>: ' + setting.ttw_dia + '<br />';
		settingDesc += '<B>Finger size</B>: ' + ringSize;
	
		return settingDesc;
	}
	
	function diamondCartDesc(diamond) {
	
		var diamondDesc = '';
	
		diamondDesc += '<B>Stock number</B>: ' + diamond.stockNo + '<br />';
		diamondDesc += '<B>Diamond Shape</B>: ' + diamond.shape + '<br />';
		diamondDesc += '<B>Carat weight</B>: ' + parseFloat(diamond.caratWeight).toFixed(2) + '<br />';
		diamondDesc += '<B>Color</B>: ' + diamond.color + '<br />';
		diamondDesc += '<B>Clarity</B>: ' + diamond.clarity + '<br />';
		diamondDesc += '<B>Diamond Certificate</B>: GIA';
	
		return diamondDesc;
	}
	
	function mensBandDescription(prod, metalType, ringSize) {
	
		// Designer Name / Vendor ID
		// Carat weight:
		// Finger size:
	
		var bandDesc = '';
	
		if (prod.vendor && prod.vendor.name && prod.vendor.item_number) {
			bandDesc += (0, _product.designerFormatName)(prod.vendor.name) + ' / ' + prod.vendor.item_number + '<br />';
		}
	
		bandDesc += '<B>Metal type</B>: ' + getFormattedMetalType(metalType) + '<br />';
		bandDesc += '<B>Carat weight</B>: ' + prod.ttw_dia + '<br />';
		bandDesc += '<B>Finger size</B>: ' + ringSize;
	
		return bandDesc;
	}
	
	function womensBandDescription(prod, metalType, ringSize) {
	
		// Designer Name / Vendor ID
		// Metal type: (INTERNAL NOTE FOR WEST: should be written out as 14k white gold, yellow gold, rose gold / 18k white gold, yellow gold, rose gold / platinum)
		// Carat weight:
		// Finger size:
	
		var bandDesc = '';
	
		if (prod.vendor && prod.vendor.name && prod.vendor.item_number) {
			bandDesc += (0, _product.designerFormatName)(prod.vendor.name) + ' / ' + prod.vendor.item_number + '<br />';
		}
	
		bandDesc += '<B>Metal type</B>: ' + getFormattedMetalType(metalType) + '<br />';
		bandDesc += '<B>Carat weight</B>: ' + prod.ttw_dia + '<br />';
		bandDesc += '<B>Finger size</B>: ' + ringSize;
	
		return bandDesc;
	}
	
	function fashionCartDesc(prod, metalType) {
	
		var fashionDesc = '';
	
		if (prod.vendor && prod.vendor.name && prod.vendor.item_number) {
			fashionDesc += (0, _product.designerFormatName)(prod.vendor.name) + ' / ' + prod.vendor.item_number + '<br />';
		}
	
		fashionDesc += '<B>Metal type</B>: ' + getFormattedMetalType(metalType) + '<br />';
		fashionDesc += '<B>Carat weight</B>: ' + prod.ttw_dia;
	
		return fashionDesc;
	}
	
	function fashionRingCartDesc(prod, metalType, ringSize) {
	
		var fashionDesc = '';
	
		if (prod.vendor && prod.vendor.name && prod.vendor.item_number) {
			fashionDesc += (0, _product.designerFormatName)(prod.vendor.name) + ' / ' + prod.vendor.item_number + '<br />';
		}
	
		fashionDesc += '<B>Metal type</B>: ' + getFormattedMetalType(metalType) + '<br />';
		fashionDesc += '<B>Carat weight</B>: ' + prod.ttw_dia + '<br />';
		fashionDesc += '<B>Finger size</B>: ' + ringSize;
	
		return fashionDesc;
	}
	
	function bandCartDesc(band) {
		var metalType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var ringSize = arguments[2];
	
	
		var bandDesc = '';
	
		if (band.vendor && band.vendor.name) {
			bandDesc += (0, _product.designerFormatName)(band.vendor.name);
		}
		if (band.vendor.item_number) {
			bandDesc += ' / ' + band.vendor.item_number;
		}
		bandDesc += '<br />';
	
		if (metalType) {
			bandDesc += '<B>Metal type</B>: ' + metalType + '<br />';
		}
	
		bandDesc += '<B>Carat weight</B>: ' + band.ttw_dia + '<br />';
		bandDesc += '<B>Finger size</B>: ' + ringSize + '<br />';
	
		return bandDesc;
	}
	
	function getLocationNameById(locNum) {
	
		if (!locNum) {
			return '';
		}
	
		switch (locNum) {
			case 1:
				return 'Charlotte';
			case 2:
				return 'Headquarters';
			case 3:
				return 'Birmingham';
			case 4:
				return 'Raleigh';
			case 5:
				return 'Austin';
			case 6:
				return 'Richmond';
			case 7:
				return 'Charleston';
			case 8:
				return 'Oklahoma City';
			case 9:
				return 'Virginia Beach';
			case 10:
				return 'San Antonio';
			case 11:
				return 'Dallas';
			case 12:
				return 'Indianapolis';
			case 13:
				return 'St. Louis';
			case 14:
				return 'Jacksonville';
			case 15:
				return 'Salt Lake City';
			case 16:
				return 'Columbus';
			case 17:
				return 'Cleveland';
			case 18:
				return 'Frisco';
			case 19:
				return 'Kansas City';
			case 20:
				return 'New Orleans';
			case 21:
				return 'Boca Raton';
			default:
				return '';
		}
	}
	
	function getIdByLocation(locationDisplay) {
		switch (locationDisplay) {
			case 'Charlotte':
				return 1;
			case 'Headquarters':
				return 2;
			case 'Birmingham':
				return 3;
			case 'Raleigh':
				return 4;
			case 'Austin':
				return 5;
			case 'Richmond':
				return 6;
			case 'Charleston':
				return 7;
			case 'Oklahoma City':
				return 8;
			case 'Virginia Beach':
				return 9;
			case 'San Antonio':
				return 10;
			case 'Dallas':
				return 11;
			case 'Indianapolis':
				return 12;
			case 'St. Louis':
				return 13;
			case 'Jacksonville':
				return 14;
			case 'Salt Lake City':
				return 15;
			case 'Columbus':
				return 16;
			case 'Cleveland':
				return 17;
			case 'Frisco':
				return 18;
			case 'Kansas City':
				return 19;
			case 'New Orleans':
				return 20;
			case 'Boca Raton':
				return 21;
			default:
				return '';
		}
	}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var locations = exports.locations = [{
	  display: 'Austin, TX',
	  value: 'infoAUS@diamondsdirect.com'
	}, {
	  display: 'Birmingham, AL',
	  value: 'infoBHM@diamondsdirect.com'
	}, {
	  display: 'Boca Raton, FL',
	  value: 'infoBOCA@diamondsdirect.com'
	}, {
	  display: 'Charleston, SC',
	  value: 'infoCHS@diamondsdirect.com'
	}, {
	  display: 'Charlotte, NC',
	  value: 'infoCLT@diamondsdirect.com'
	}, {
	  display: 'Cleveland, OH',
	  value: 'infoCLE@diamondsdirect.com'
	}, {
	  display: 'Columbus, OH',
	  value: 'infocol@diamondsdirect.com'
	}, {
	  display: 'Dallas, TX',
	  value: 'infoDTX@diamondsdirect.com'
	}, {
	  display: 'Frisco, TX',
	  value: 'infoFRISCO@diamondsdirect.com'
	}, {
	  display: 'Greenville, SC',
	  value: 'infoGVL@diamondsdirect.com'
	}, {
	  display: 'Houston (Baybrook), TX',
	  value: 'infoBAY@diamondsdirect.com'
	}, {
	  display: 'Houston (Galleria), TX',
	  value: 'infoHOU@diamondsdirect.com'
	}, {
	  display: 'Indianapolis, IN',
	  value: 'infoindy@diamondsdirect.com'
	}, {
	  display: 'Jacksonville, FL',
	  value: 'infojax@diamondsdirect.com'
	}, {
	  display: 'Kansas City, KS',
	  value: 'infoKSC@diamondsdirect.com'
	}, {
	  display: 'New Orleans, LA',
	  value: 'infoNOLA@diamondsdirect.com'
	}, {
	  display: 'Oklahoma City, OK',
	  value: 'infoOKC@diamondsdirect.com'
	}, {
	  display: 'Pittsburgh, PA',
	  value: 'infoPITT@diamondsdirect.com'
	}, {
	  display: 'Raleigh, NC',
	  value: 'infoRal@diamondsdirect.com'
	}, {
	  display: 'Richmond, VA',
	  value: 'infoRic@diamondsdirect.com'
	}, {
	  display: 'St. Louis, MO',
	  value: 'infostl@diamondsdirect.com'
	}, {
	  display: 'San Antonio, TX',
	  value: 'infoSAT@diamondsdirect.com'
	}, {
	  display: 'Troy, MI',
	  value: 'infoTROY@diamondsdirect.com'
	}, {
	  display: 'Tysons, VA',
	  value: 'infoTYS@diamondsdirect.com'
	}, {
	  display: 'Virginia Beach, VA',
	  value: 'infoVAB@diamondsdirect.com'
	}];

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.productSaveDiamondResults = productSaveDiamondResults;
	exports.productAppendDiamondResults = productAppendDiamondResults;
	exports.productAddDiamondResults = productAddDiamondResults;
	exports.productSaveResults = productSaveResults;
	exports.productSaveDiamondQueryFilters = productSaveDiamondQueryFilters;
	exports.productResetDiamondQueryFilters = productResetDiamondQueryFilters;
	exports.productSaveProductQueryFilters = productSaveProductQueryFilters;
	exports.productResetProductQueryFilters = productResetProductQueryFilters;
	exports.productClearFilters = productClearFilters;
	exports.productSelectSetting = productSelectSetting;
	exports.productSelectDiamond = productSelectDiamond;
	exports.productCompareSetting = productCompareSetting;
	exports.productCompareDiamond = productCompareDiamond;
	exports.productCompareBand = productCompareBand;
	exports.productCompareFashion = productCompareFashion;
	exports.productSetPage = productSetPage;
	exports.productAttrSize = productAttrSize;
	exports.productAttrMetal = productAttrMetal;
	exports.productToggleFloatingHeader = productToggleFloatingHeader;
	exports.productFetchDiamonds = productFetchDiamonds;
	exports.productAddDiamonds = productAddDiamonds;
	exports.productFetchDiamondById = productFetchDiamondById;
	exports.productFetchProducts = productFetchProducts;
	exports.productFetchBySku = productFetchBySku;
	exports.productFetchSearchResults = productFetchSearchResults;
	exports.productHkDiamondAvailability = productHkDiamondAvailability;
	
	__webpack_require__(148);
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	var _endpoints = __webpack_require__(122);
	
	var endpoint = _interopRequireWildcard(_endpoints);
	
	var _api = __webpack_require__(121);
	
	var api = _interopRequireWildcard(_api);
	
	var _request = __webpack_require__(123);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/******************************
	*******  Synchronous  *********
	******************************/
	
	function productSaveDiamondResults(diamonds) {
	  var diamondCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  return {
	    type: constants.PRODUCT_SAVE_DIAMONDS,
	    diamonds: diamonds,
	    diamondCount: diamondCount
	  };
	}
	
	function productAppendDiamondResults(diamonds) {
	  return {
	    type: constants.PRODUCT_APPEND_DIAMONDS,
	    diamonds: diamonds
	  };
	}
	
	function productAddDiamondResults(diamonds, diamondPage) {
	  return {
	    type: constants.PRODUCT_ADD_DIAMONDS,
	    diamonds: diamonds,
	    diamondPage: diamondPage
	  };
	}
	
	function productSaveResults(products) {
	  var productCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  return {
	    type: constants.PRODUCT_SAVE_SETTINGS,
	    products: products,
	    productCount: productCount
	  };
	}
	
	function productSaveDiamondQueryFilters(filters) {
	  var pageNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return {
	    type: constants.PRODUCT_SAVE_DIAMOND_QUERY,
	    filters: filters,
	    pageNum: pageNum
	  };
	}
	
	function productResetDiamondQueryFilters() {
	  return {
	    type: constants.PRODUCT_RESET_DIAMOND_QUERY
	  };
	}
	
	function productSaveProductQueryFilters(filters, queryType) {
	  var pageNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  return {
	    type: constants.PRODUCT_SAVE_SETTING_QUERY,
	    filters: filters,
	    queryType: queryType,
	    pageNum: pageNum
	  };
	}
	
	function productResetProductQueryFilters(queryType) {
	  return {
	    type: constants.PRODUCT_RESET_PRODUCT_QUERY,
	    queryType: queryType
	  };
	}
	
	function productClearFilters() {
	  return {
	    type: constants.PRODUCT_CLEAR_QUERY
	  };
	}
	
	function productSelectSetting(setting) {
	  var metalType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var ringSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  return {
	    type: constants.PRODUCT_SELECT_SETTING,
	    setting: setting,
	    metalType: metalType,
	    ringSize: ringSize
	  };
	}
	
	function productSelectDiamond(diamond) {
	  return {
	    type: constants.PRODUCT_SELECT_DIAMOND,
	    diamond: diamond
	  };
	}
	
	function productCompareSetting(setting) {
	  return {
	    type: constants.PRODUCT_COMPARE_SETTING,
	    setting: setting
	  };
	}
	
	function productCompareDiamond(diamond) {
	  return {
	    type: constants.PRODUCT_COMPARE_DIAMOND,
	    diamond: diamond
	  };
	}
	
	function productCompareBand(band) {
	  return {
	    type: constants.PRODUCT_COMPARE_BAND,
	    band: band
	  };
	}
	
	function productCompareFashion(jewelry) {
	  return {
	    type: constants.PRODUCT_COMPARE_FASHION,
	    jewelry: jewelry
	  };
	}
	
	function productSetPage() {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	  return {
	    type: constants.PRODUCT_SET_PAGE,
	    page: page
	  };
	}
	
	function productAttrSize() {
	  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return {
	    type: constants.PRODUCT_ATTR_SIZE,
	    size: size
	  };
	}
	
	function productAttrMetal() {
	  var metal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return {
	    type: constants.PRODUCT_ATTR_METAL,
	    metal: metal
	  };
	}
	
	function productToggleFloatingHeader(position) {
	  return {
	    type: constants.PRODUCT_FLOATING_HEADER_TOGGLE,
	    position: position
	  };
	}
	
	/******************************
	*******  Asynchronous  ********
	******************************/
	
	function productFetchDiamonds(queryString) {
	  return function (dispatch) {
	    var url = api.DIAMOND_API + endpoint.PRODUCT_DIAMONDS + '?format=json&' + queryString;
	
	    return fetch(url, {
	      method: 'get',
	      headers: api.HEADERS
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function productAddDiamonds(queryString, pageNum) {
	  return function (dispatch) {
	
	    var pageQueryString = queryString === '' ? 'page=' + pageNum : '&page=' + pageNum;
	
	    var url = api.DIAMOND_API + endpoint.PRODUCT_DIAMONDS + '?format=json&' + queryString + pageQueryString;
	
	    return fetch(url, {
	      method: 'get',
	      headers: api.HEADERS
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function productFetchDiamondById(diamondId) {
	  return function (dispatch) {
	    var url = api.DIAMOND_API + endpoint.PRODUCT_DIAMOND_BY_ID + '?id=' + diamondId;
	    return fetch(url, {
	      method: 'get',
	      headers: api.HEADERS
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function productFetchProducts(queryString) {
	  var signal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  return function (dispatch) {
	    var url = api.PRODUCT_API + endpoint.PRODUCT_SETTINGS + '?' + queryString;
	    return fetch(url, {
	      method: 'get',
	      headers: api.HEADERS,
	      signal: signal
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function productFetchBySku(settingSku) {
	  return function (dispatch) {
	    var url = api.PRODUCT_API + endpoint.PRODUCT_SETTING_BY_SKU + '?sku=' + settingSku;
	    return fetch(url, {
	      method: 'get',
	      headers: api.HEADERS
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function productFetchSearchResults(searchTerm) {
	  var sortVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return function (dispatch) {
	    var url = api.PRODUCT_API + endpoint.PRODUCT_SEARCH + '?q=' + encodeURIComponent(searchTerm);
	    if (sortVal) {
	      url = url + '&sort=' + sortVal;
	    }
	    return fetch(url, {
	      method: 'get',
	      headers: api.HEADERS
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function productHkDiamondAvailability(stockNo) {
	  return function (dispatch) {
	
	    var url = api.MAGENTO_API + endpoint.MAGENTO_CHECK_HK_STATUS + '?stockNo=' + stockNo;
	    return fetch(url, {
	      method: 'get',
	      headers: api.HEADERS
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(160)('wks');
	var uid = __webpack_require__(112);
	var Symbol = __webpack_require__(20).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1091);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(70);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(22)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(16);
	var IE8_DOM_DEFINE = __webpack_require__(349);
	var toPrimitive = __webpack_require__(78);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(32) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var DOMProperty = __webpack_require__(96);
	var ReactDOMComponentFlags = __webpack_require__(425);
	
	var invariant = __webpack_require__(15);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ? process.env.NODE_ENV !== 'production' ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(76);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var ReactDOM = __webpack_require__(28);
	var scroll = __webpack_require__(1222);
	
	function calculateScrollOffset(element, offset, alignment) {
	  var body = document.body,
	      html = document.documentElement;
	  var elementRect = element.getBoundingClientRect();
	  var clientHeight = html.clientHeight;
	  var documentHeight = Math.max( body.scrollHeight, body.offsetHeight, 
	                                 html.clientHeight, html.scrollHeight, html.offsetHeight );
	  offset = offset || 0; // additional offset to top
	  var scrollPosition;
	  switch(alignment) {
	      case 'top': scrollPosition = elementRect.top; break;
	      case 'middle': scrollPosition = elementRect.bottom - clientHeight / 2 - elementRect.height / 2; break;
	      case 'bottom': scrollPosition = elementRect.bottom - clientHeight; break;
	      default: scrollPosition = elementRect.bottom - clientHeight / 2 - elementRect.height / 2; break; //defaul to middle
	    }
	  var maxScrollPosition = documentHeight - clientHeight;
	  return Math.min(scrollPosition + offset + window.pageYOffset,
	                  maxScrollPosition);
	}
	
	module.exports = function (ref, options) {
	  options = options || {
	    offset: 0,
	    align: 'middle'
	  };
	  var element = ReactDOM.findDOMNode(ref);
	  if (element === null) return 0;
	  return scroll(0, calculateScrollOffset(element, options.offset, options.align), options);
	};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(1013);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(1187);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _slider2.default;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(1213);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(118);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(461);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
	  return !(0, _shallowEqual2.default)(props, nextProps);
	});
	
	exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PRIMARY_CUSTOMER_SERVICE = exports.PRIMARY_CUSTOMER_SERVICE = 'online@diamondsdirect.com';

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getProductUrl = getProductUrl;
	exports.getWishlistProductUrl = getWishlistProductUrl;
	exports.reSortDiamonds = reSortDiamonds;
	exports.reSortProducts = reSortProducts;
	exports.getMinPrice = getMinPrice;
	exports.getMetalTypeChildDropdownData = getMetalTypeChildDropdownData;
	exports.calcMetalMarkup = calcMetalMarkup;
	exports.calcChildMetalMarkup = calcChildMetalMarkup;
	exports.designerFormatName = designerFormatName;
	
	var _sort = __webpack_require__(626);
	
	function getProductUrl(productResp) {
	
		if (!productResp || !productResp.product_type) {
			return '';
		}
	
		var settingTypes = ['MOUNTING'];
	
		var bandTypes = ['GTS WED BAND', 'LDS WED BAND'];
	
		var jewelryTypes = ['BRACELET', 'EARRING', 'RING', 'NECKLACE'];
	
		if (settingTypes.includes(productResp.product_type)) {
			return 'setting/' + productResp.sku;
		} else if (bandTypes.includes(productResp.product_type)) {
			return 'band/' + productResp.sku;
		} else if (jewelryTypes.includes(productResp.product_type)) {
			return 'jewelry/' + productResp.sku;
		} else {
			return 'jewelry/' + productResp.sku;
		}
	}
	
	function getWishlistProductUrl(productResp) {
	
		if (!productResp || !productResp.attributes || !productResp.attributes.type) {
			return '';
		}
	
		var settingTypes = ['MOUNTING'];
	
		var bandTypes = ['GTS WED BAND', 'LDS WED BAND'];
	
		var jewelryTypes = ['BRACELET', 'EARRING', 'RING', 'NECKLACE'];
	
		if (settingTypes.includes(productResp.attributes.type)) {
			return 'setting/' + productResp.sku;
		} else if (bandTypes.includes(productResp.attributes.type)) {
			return 'band/' + productResp.sku;
		} else if (jewelryTypes.includes(productResp.attributes.type)) {
			return 'jewelry/' + productResp.sku;
		} else {
			return '';
		}
	}
	
	// Depricated
	
	// export function getMetalTypeDropdownData(price, metalBase) {
	// 	let metalDDData = [
	// 		{
	// 			display: 'Metal Options',
	// 			value: '',
	// 		}
	// 	];
	// 	if(metalBase === null || metalBase === '' || parseInt(metalBase) == 14) {
	// 		return metalDDData.concat([
	// 			{
	// 				display: '14K Yellow Gold',
	// 				value: 'YG14',
	// 			},
	// 			{
	// 				display: '14K White Gold',
	// 				value: 'WG14',
	// 			},
	// 			{
	// 				display: '14K Rose Gold',
	// 				value: 'RG14',
	// 			},
	// 			{
	// 				display: '18K Yellow Gold (+$' + (calcMetalMarkup(price, metalBase, 'YG18')).toString() + ')',
	// 				value: 'YG18',
	// 			},
	// 			{
	// 				display: '18K White Gold (+$' + (calcMetalMarkup(price, metalBase, 'WG18')).toString() + ')',
	// 				value: 'WG18',
	// 			},
	// 			{
	// 				display: '18K Rose Gold (+$' + (calcMetalMarkup(price, metalBase, 'RG18')).toString() + ')',
	// 				value: 'RG18',
	// 			},
	// 			{
	// 				display: 'Platinum (+$' + (calcMetalMarkup(price, metalBase, 'P')).toString() + ')',
	// 				value: 'P',
	// 			},
	// 		]);
	// 	} else {
	// 		return metalDDData.concat([
	// 			{
	// 				display: '18K Yellow Gold',
	// 				value: 'YG18',
	// 			},
	// 			{
	// 				display: '18K White Gold',
	// 				value: 'WG18',
	// 			},
	// 			{
	// 				display: '18K Rose Gold',
	// 				value: 'RG18',
	// 			},
	// 			{
	// 				display: 'Platinum (+$' + (calcMetalMarkup(price, metalBase, 'P')).toString() + ')',
	// 				value: 'P',
	// 			},
	// 		]);
	// 	}
	// }
	
	function reSortDiamonds(rawResults, filters) {
		var filteredResults = [];
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = rawResults[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var res = _step.value;
	
	
				if (filters && filters.priceMin && filters.priceMin > 0) {
					if (res.price < parseInt(filters.priceMin)) {
						continue;
					}
				}
	
				if (filters && filters.priceMax && filters.priceMax > 0) {
					if (res.price > parseInt(filters.priceMax)) {
						continue;
					}
				}
	
				filteredResults.push(res);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	
		if (filters && filters.sort && filters.sort.includes('price')) {
	
			console.log('short be sorting !');
			console.log(filters);
	
			if (filters.sort === 'price') {
				console.log('door a');
				return filteredResults.sort((0, _sort.dynamicSort)('price', false));
			}
			if (filters.sort === '-price') {
				console.log('door b');
				return filteredResults.sort((0, _sort.dynamicSort)('price', true));
			}
		}
		return filteredResults;
	}
	
	function reSortProducts(rawResults, filters) {
	
		console.log('reSortProducts');
	
		var pricedResults = [];
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;
	
		try {
			for (var _iterator2 = rawResults[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var pd = _step2.value;
	
				pricedResults.push(Object.assign({}, pd, {
					realPrice: getMinPrice(pd)
				}));
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}
	
		var filteredResults = [];
		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;
	
		try {
			for (var _iterator3 = pricedResults[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var res = _step3.value;
	
	
				if (filters && filters.priceMin && filters.priceMin > 0) {
					if (res.realPrice < parseInt(filters.priceMin)) {
						continue;
					}
				}
	
				if (filters && filters.priceMax && filters.priceMax > 0) {
					if (res.realPrice > parseInt(filters.priceMax)) {
						continue;
					}
				}
	
				filteredResults.push(res);
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3.return) {
					_iterator3.return();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}
	
		if (filters && filters.sort && filters.sort.includes('price')) {
	
			if (filters.sort === 'sell_price') {
				return filteredResults.sort((0, _sort.dynamicSort)('realPrice', false));
			}
			if (filters.sort === '-sell_price') {
				return filteredResults.sort((0, _sort.dynamicSort)('realPrice', true));
			}
		}
		return filteredResults;
	}
	
	function getMinPrice(product) {
		var minPrice = null;
	
		for (var i = 0; i < product.children.length; i++) {
			if ((minPrice === null || product.children[i].price < minPrice) && product.children[i].price > 0) {
				minPrice = product.children[i].price;
			}
		}
		return minPrice;
	}
	
	function getMetalType(materialType) {
		if (!materialType) {
			return '';
		}
		switch (materialType) {
			case 'YG':
				return 'Yellow Gold';
			case 'WG':
				return 'White Gold';
			case 'RG':
				return 'Rose Gold';
			case 'TT':
				return 'Two-tone';
			case 'GG':
				return 'Gray gold';
			case 'PLAT':
				return 'Platinum';
			case 'STEEL':
				return 'Stainless Steel';
			case 'SS':
				return 'Sterling Silver';
			case '18/PT':
				return '18K Platinum';
			case '14/PT':
				return '14K Platinum';
			case 'PALL':
				return 'Palladium';
			case 'TITAN':
				return 'Titanium';
			case 'TUNG':
				return 'Tungsten';
			case 'ELY':
				return 'Elysium';
			case 'COBLT':
				return 'Cobalt';
			case 'TANT':
				return 'Tantalum';
			case 'TRI':
				return 'Tri-color';
			case 'WG/TA':
				return 'White Gold/Tantalum';
			case 'RG/TA':
				return 'Rose Gold/Tantalum';
			case 'YG/TA':
				return 'Yellow Gold/Tantalum';
			case 'TA/TI':
				return 'Tantalum/Titanium';
			case 'WG/PT':
				return 'White Gold/Platinum';
			case 'RG/PT':
				return 'Rose Gold/Platinum';
			case 'YG/PT':
				return 'Yellow Gold/Platinum';
			case 'WG/TI':
				return 'White Gold/Titanium';
			case 'YG/TI':
				return 'Yellow Gold/Titanium';
			case 'RG/TI':
				return 'Rose Gold/Titanium';
			case 'RG/PD':
				return 'Rose Gold/Palladium';
			default:
				return '';
		}
	}
	
	function getMetalChildName(type, karat, price, minPrice) {
		var karatValue = '';
		var colorValue = getMetalType(type);
		var priceValue = '';
	
		if (karat == 14) {
			karatValue = '14K ';
		} else if (karat == 18) {
			karatValue = '18K ';
		}
	
		if (price > minPrice) {
			priceValue = ' (+$' + (price - minPrice).toString() + ')';
		}
	
		return karatValue + colorValue + priceValue;
	}
	
	function getMetalChildValue(type, karat) {
		return karat ? type + karat.toString() : type;
	}
	
	function getMetalTypeChildElements(product) {
	
		var options = [];
		var minPrice = getMinPrice(product);
	
		for (var i = 0; i < product.children.length; i++) {
	
			var metalKarat = product.children[i].karat;
			var metalPrice = product.children[i].price;
	
			if (metalPrice === 0) {
				continue;
			}
	
			for (var j = 0; j < product.children[i].materials.length; j++) {
	
				var metalType = product.children[i].materials[j].material_type;
				options.push({
					display: getMetalChildName(metalType, metalKarat, metalPrice, minPrice),
					value: getMetalChildValue(metalType, metalKarat)
				});
			}
		}
		return options;
	}
	
	function getMetalTypeChildDropdownData(product) {
	
		var metalDDData = [{
			display: 'Metal Options',
			value: ''
		}];
		return metalDDData.concat(getMetalTypeChildElements(product));
	}
	
	function calcMetalMarkup(price, metalBase, metalType) {
	
		// Markups:
		// 14 -> 18: 13%
		// 14 -> P: 34%
		// 18 -> P: 18.6%
		var markup = 0.0;
	
		if (!metalType || metalType.includes('14')) {
			return 0;
		}
	
		if (metalBase === null || metalBase === '' || parseInt(metalBase) == 14) {
			if (metalType == 'P') {
				markup = 0.34;
			} else if (metalType.includes('18')) {
				markup = 0.13;
			} else {
				return 0;
			}
		} else if (metalType == 'P') {
			markup = 0.186;
		}
		return parseInt(Math.ceil(parseFloat(price) * markup / 10) * 10);
	}
	
	function calcChildMetalMarkup(product, selectedMetalCode) {
	
		var karatSpecificMetals = ['YG14', 'YG18', 'WG14', 'WG18', 'RG14', 'RG18', 'GG14', 'GG18', 'TT14', 'TT18'];
	
		if (!selectedMetalCode) {
			return 0;
		}
	
		var minPrice = getMinPrice(product);
	
		for (var i = 0; i < product.children.length; i++) {
	
			var metalKarat = product.children[i].karat;
			var metalPrice = product.children[i].price;
	
			if (metalPrice === 0) {
				continue;
			}
	
			for (var j = 0; j < product.children[i].materials.length; j++) {
	
				var metalType = product.children[i].materials[j].material_type;
	
				if (metalType == selectedMetalCode) {
					return metalPrice - minPrice;
				}
	
				if (karatSpecificMetals.includes(selectedMetalCode) && selectedMetalCode.includes(metalKarat.toString()) && selectedMetalCode.includes(metalType)) {
					return metalPrice - minPrice;
				}
			}
		}
		return 0;
	}
	
	function designerFormatName(dbDesigner) {
	
		if (!dbDesigner) {
			return '';
		}
	
		switch (dbDesigner) {
			case 'DIAMONDS DIRECT NY':
				return 'Diamonds Direct Designs';
			case 'A. JAFFE':
				return 'A Jaffe';
			case 'AMDEN JEWELRY':
				return 'Amden';
			case 'FREDERICK GOLDMAN, INC DIANA':
				return 'Artcarved';
			case 'BENCHMARK':
				return 'Benchmark';
			case "C. GONSHOR'S FINE JEWELRY":
				return 'C. Gonshor';
			case 'CHRISTIAN BAUER (PENN GEM)':
				return 'Christian Bauer';
			case 'CHRISTOPHER DESIGNS':
				return 'Christopher Designs';
			case 'CLASSIQUE CREATIONS':
				return 'Classique Creations';
			// case 'FREDERICK GOLDMAN, INC DIANA':
			// 	return 'Diana';
			case 'FANA':
				return 'Fana';
			case 'FURRER-JACOT':
				return 'Furrer Jacot';
			case 'GABRIEL&CO':
				return 'Gabriel & Co.';
			// case 'FREDERICK GOLDMAN, INC DIANA':
			// 	return 'Goldman';
			case 'KIRK KARA':
				return 'Kirk Kara';
			case 'MASTOLONI & SONS INC.':
				return 'Mastoloni';
			case 'ODELIA BY AV JEWELRY':
				return 'Odelia';
			case 'SES CREATIONS':
				return 'SES Creations';
			case 'SIMON G. JEWELRY INC.':
				return 'Simon G.';
			case 'SPECTRUM':
				return 'Sylvie';
			case 'TACORI BRIDAL':
				return 'Tacori';
			case 'TACORI FASHION':
				return 'Tacori';
			case 'PAUL WINSTON/ TRUE ROMANCE':
				return 'True Romance';
			case 'VERRAGIO':
				return 'Verragio';
			case 'MICHAEL M':
				return 'Michael M';
			case 'INTERNATIONAL JEWELRY MKTING':
				return 'IJM';
			case 'BRILLIANT ELEMENTS(CARAT WORLD':
				return 'Brilliant Elements';
		}
		return dbDesigner;
	}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (process.env.NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactIs = __webpack_require__(168);
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(421)(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1071)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(320);
	
	var color = _interopRequireWildcard(_colors);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RhinoLoading = function (_React$Component) {
		_inherits(RhinoLoading, _React$Component);
	
		function RhinoLoading(props) {
			_classCallCheck(this, RhinoLoading);
	
			return _possibleConstructorReturn(this, (RhinoLoading.__proto__ || Object.getPrototypeOf(RhinoLoading)).call(this, props));
		}
	
		_createClass(RhinoLoading, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'RhinoLoading' },
					_react2.default.createElement(
						'div',
						{ className: 'loadingImgWrapper' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/loading.gif', alt: 'Diamonds Direct Loading' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'loadingImgPhoneWrapper' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/loading.gif', alt: 'Diamonds Direct Loading' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'loadingMessage' },
						this.props.message
					)
				);
			}
		}]);
	
		return RhinoLoading;
	}(_react2.default.Component);
	
	exports.default = RhinoLoading;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Auth actions
	var AUTH_SAVE = exports.AUTH_SAVE = 'AUTH_SAVE';
	var AUTH_CLEAR = exports.AUTH_CLEAR = 'AUTH_CLEAR';
	
	// Common actions
	var COMMON_ALERT = exports.COMMON_ALERT = 'COMMON_ALERT';
	var COMMON_CLOSE_ALERT = exports.COMMON_CLOSE_ALERT = 'COMMON_CLOSE_ALERT';
	var COMMON_MODAL_RESIZE = exports.COMMON_MODAL_RESIZE = 'COMMON_MODAL_RESIZE';
	var COMMON_OPEN_CONTACT = exports.COMMON_OPEN_CONTACT = 'COMMON_OPEN_CONTACT';
	var COMMON_CLOSE_CONTACT = exports.COMMON_CLOSE_CONTACT = 'COMMON_CLOSE_CONTACT';
	var COMMON_NOTIFY = exports.COMMON_NOTIFY = 'COMMON_NOTIFY';
	var COMMON_CLOSE_NOTIFY = exports.COMMON_CLOSE_NOTIFY = 'COMMON_CLOSE_NOTIFY';
	var COMMON_OPEN_LOGIN = exports.COMMON_OPEN_LOGIN = 'COMMON_OPEN_LOGIN';
	var COMMON_CLOSE_LOGIN = exports.COMMON_CLOSE_LOGIN = 'COMMON_CLOSE_LOGIN';
	var COMMON_NAV_CHANGE = exports.COMMON_NAV_CHANGE = 'COMMON_NAV_CHANGE';
	
	// Header actions
	var HEADER_TOGGLE = exports.HEADER_TOGGLE = 'HEADER_TOGGLE';
	var HEADER_SUBMENU = exports.HEADER_SUBMENU = 'HEADER_SUBMENU';
	
	// Login actions
	// None
	
	// Product actions
	var PRODUCT_SAVE_DIAMOND_QUERY = exports.PRODUCT_SAVE_DIAMOND_QUERY = 'PRODUCT_SAVE_DIAMOND_QUERY';
	var PRODUCT_ADD_DIAMONDS = exports.PRODUCT_ADD_DIAMONDS = 'PRODUCT_ADD_DIAMONDS';
	var PRODUCT_SAVE_DIAMONDS = exports.PRODUCT_SAVE_DIAMONDS = 'PRODUCT_SAVE_DIAMONDS';
	var PRODUCT_APPEND_DIAMONDS = exports.PRODUCT_APPEND_DIAMONDS = 'PRODUCT_APPEND_DIAMONDS';
	var PRODUCT_SAVE_SETTING_QUERY = exports.PRODUCT_SAVE_SETTING_QUERY = 'PRODUCT_SAVE_SETTING_QUERY';
	var PRODUCT_SAVE_SETTINGS = exports.PRODUCT_SAVE_SETTINGS = 'PRODUCT_SAVE_SETTINGS';
	var PRODUCT_SELECT_SETTING = exports.PRODUCT_SELECT_SETTING = 'PRODUCT_SELECT_SETTING';
	var PRODUCT_SELECT_DIAMOND = exports.PRODUCT_SELECT_DIAMOND = 'PRODUCT_SELECT_DIAMOND';
	var PRODUCT_COMPARE_SETTING = exports.PRODUCT_COMPARE_SETTING = 'PRODUCT_COMPARE_SETTING';
	var PRODUCT_COMPARE_DIAMOND = exports.PRODUCT_COMPARE_DIAMOND = 'PRODUCT_COMPARE_DIAMOND';
	var PRODUCT_COMPARE_BAND = exports.PRODUCT_COMPARE_BAND = 'PRODUCT_COMPARE_BAND';
	var PRODUCT_COMPARE_FASHION = exports.PRODUCT_COMPARE_FASHION = 'PRODUCT_COMPARE_FASHION';
	var PRODUCT_CLEAR_QUERY = exports.PRODUCT_CLEAR_QUERY = 'PRODUCT_CLEAR_QUERY';
	var PRODUCT_SET_PAGE = exports.PRODUCT_SET_PAGE = 'PRODUCT_SET_PAGE';
	var PRODUCT_ATTR_SIZE = exports.PRODUCT_ATTR_SIZE = 'PRODUCT_ATTR_SIZE';
	var PRODUCT_ATTR_METAL = exports.PRODUCT_ATTR_METAL = 'PRODUCT_ATTR_METAL';
	var PRODUCT_RESET_DIAMOND_QUERY = exports.PRODUCT_RESET_DIAMOND_QUERY = 'PRODUCT_RESET_DIAMOND_QUERY';
	var PRODUCT_RESET_PRODUCT_QUERY = exports.PRODUCT_RESET_PRODUCT_QUERY = 'PRODUCT_RESET_PRODUCT_QUERY';
	var PRODUCT_FLOATING_HEADER_TOGGLE = exports.PRODUCT_FLOATING_HEADER_TOGGLE = 'PRODUCT_FLOATING_HEADER_TOGGLE';
	
	// Results actions
	var RESULTS_SET_SOURCE = exports.RESULTS_SET_SOURCE = 'RESULTS_SET_SOURCE';
	var RESULTS_SET_SOURCE_LOCATION = exports.RESULTS_SET_SOURCE_LOCATION = 'RESULTS_SET_SOURCE_LOCATION';
	var RESULTS_SET_SORT = exports.RESULTS_SET_SORT = 'RESULTS_SET_SORT';
	
	// User (global) actions
	var USER_LOGOUT = exports.USER_LOGOUT = 'USER_LOGOUT';
	
	// User (non-Global) actions
	var USER_CORE_SET = exports.USER_CORE_SET = 'USER_CORE_SET';
	var USER_PROFILE_SET = exports.USER_PROFILE_SET = 'USER_PROFILE_SET';
	var USER_WISHLISTS_SET = exports.USER_WISHLISTS_SET = 'USER_WISHLISTS_SET';
	var USER_ORDERS_SET = exports.USER_ORDERS_SET = 'USER_ORDERS_SET';
	var USER_EXTERNAL_ORDERS_SET = exports.USER_EXTERNAL_ORDERS_SET = 'USER_EXTERNAL_ORDERS_SET';

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(33);
	var createDesc = __webpack_require__(108);
	module.exports = __webpack_require__(32) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(20);
	var hide = __webpack_require__(49);
	var has = __webpack_require__(57);
	var SRC = __webpack_require__(112)('src');
	var $toString = __webpack_require__(689);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(67).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var fails = __webpack_require__(22);
	var defined = __webpack_require__(76);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(992);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(147);
	
	var ReactCurrentOwner = __webpack_require__(80);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	  process.env.NODE_ENV !== 'production' ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(311);
	var isBuffer = __webpack_require__(932);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cartGuestCartId = cartGuestCartId;
	exports.cartGuestAddItem = cartGuestAddItem;
	exports.cartAddMetalSize = cartAddMetalSize;
	exports.cartAddEngagementRing = cartAddEngagementRing;
	exports.cartLoggedInItems = cartLoggedInItems;
	exports.cartAddDiamond = cartAddDiamond;
	exports.cartAddDiamondJewelry = cartAddDiamondJewelry;
	
	__webpack_require__(148);
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	var _endpoints = __webpack_require__(122);
	
	var endpoint = _interopRequireWildcard(_endpoints);
	
	var _api = __webpack_require__(121);
	
	var api = _interopRequireWildcard(_api);
	
	var _request = __webpack_require__(123);
	
	var _auth = __webpack_require__(88);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/******************************
	*******  Synchronous  *********
	******************************/
	
	// export function productSaveDiamondResults(diamonds) {
	//  return {
	//     type: constants.PRODUCT_SAVE_DIAMONDS,
	//     diamonds
	//   };
	// }
	
	
	/******************************
	*******  Asynchronous  ********
	******************************/
	
	function cartGuestCartId() {
	  return function (dispatch) {
	    var url = api.MAGENTO_API + endpoint.MAGENTO_GET_GUEST_CART;
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function cartGuestAddItem(sku) {
	  var product_desc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var price = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  return function (dispatch) {
	
	    if (price > 0) {
	      window.dataLayer = window.dataLayer || [];
	      window.dataLayer.push({
	        'event': 'add_to_cart',
	        'value': parseFloat(price),
	        'order_quantity': 1,
	        'currency': 'USD',
	        'product_id': sku
	      });
	    }
	
	    // let cartId = getGuestCart();
	    var url = api.MAGENTO_API + endpoint.MAGENTO_ADD_TO_CART;
	    var bodyData = {
	      apikey: 'fji2a23sdfji4og54asdi3jfa23sd2',
	      sku: sku,
	      product_desc: product_desc
	    };
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(bodyData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function cartAddMetalSize(sku, metalType, ringSize, metalBase, metalMod, price, productDesc) {
	  return function (dispatch) {
	
	    window.dataLayer = window.dataLayer || [];
	    window.dataLayer.push({
	      'event': 'add_to_cart',
	      'value': parseFloat(price + metalMod),
	      'order_quantity': 1,
	      'currency': 'USD',
	      'product_id': sku
	    });
	
	    // let cartId = getGuestCart();
	    var url = api.MAGENTO_API + endpoint.MAGENTO_ADD_METAL_SIZE;
	    var bodyData = {
	      apikey: 'fji2a23sdfji4og54asdi3jfa23sd2',
	      sku: sku,
	      metal_type: metalType,
	      ring_size: ringSize,
	      metal_base: metalBase,
	      metal_mod: metalMod,
	      base: price,
	      product_desc: productDesc
	    };
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(bodyData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function cartAddEngagementRing(sku, metal_type, ring_size, metal_base, metal_mod, stock_no, shape, price, setting_desc, diamond_desc) {
	  return function (dispatch) {
	
	    window.dataLayer = window.dataLayer || [];
	    window.dataLayer.push({
	      'event': 'add_to_cart',
	      'value': parseFloat(metal_mod + price),
	      'order_quantity': 2,
	      'currency': 'USD',
	      'product_id': sku
	    });
	
	    // let cartId = getGuestCart();
	    var url = api.MAGENTO_API + endpoint.MAGENTO_ADD_ENGAGEMENT;
	    var bodyData = {
	      apikey: 'fji2a23sdfji4og54asdi3jfa23sd2',
	      sku: sku,
	      metal_type: metal_type,
	      ring_size: ring_size,
	      metal_base: metal_base,
	      metal_mod: metal_mod,
	      stock_no: stock_no,
	      shape: shape.toLowerCase().trim(),
	      price: price,
	      setting_desc: setting_desc,
	      diamond_desc: diamond_desc
	    };
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(bodyData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function cartLoggedInItems() {
	  return function (dispatch) {
	
	    // let url = api.MAGENTO_API + endpoint.MAGENTO_LOGGED_IN_CART;
	    var url = api.MAGENTO_API + endpoint.MAGENTO_CART_COUNT;
	
	    return fetch(url, {
	      method: 'get',
	      headers: api.HEADERS
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function cartAddDiamond(stockNo, price, shape, diamond_desc) {
	  return function (dispatch) {
	
	    window.dataLayer = window.dataLayer || [];
	    window.dataLayer.push({
	      'event': 'add_to_cart',
	      'value': parseFloat(price),
	      'order_quantity': 1,
	      'currency': 'USD',
	      'product_id': stockNo
	    });
	
	    // let cartId = getGuestCart();
	    var url = api.MAGENTO_API + endpoint.MAGENTO_ADD_DIAMOND;
	    var bodyData = {
	      apikey: 'fji2a23sdfji4og54asdi3jfa23sd2',
	      stock_no: stockNo,
	      shape: shape.toLowerCase().trim(),
	      price: price,
	      diamond_desc: diamond_desc
	    };
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(bodyData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function cartAddDiamondJewelry(sku, carat_mod, diamond_desc) {
	  return function (dispatch) {
	
	    window.dataLayer = window.dataLayer || [];
	    window.dataLayer.push({
	      'event': 'add_to_cart',
	      'value': parseFloat(carat_mod),
	      'order_quantity': 1,
	      'currency': 'USD',
	      'product_id': sku
	    });
	
	    // let cartId = getGuestCart();
	    var url = api.MAGENTO_API + endpoint.MAGENTO_ADD_DIAMOND_JEWELRY;
	    var bodyData = {
	      apikey: 'fji2a23sdfji4og54asdi3jfa23sd2',
	      sku: sku,
	      carat_mod: carat_mod,
	      diamond_desc: diamond_desc
	    };
	
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(bodyData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getJsonFromUrl = getJsonFromUrl;
	function getJsonFromUrl(url) {
	
	  if (!url) {
	    url = location.href;
	  }
	
	  var question = url.indexOf("?");
	  var hash = url.indexOf("#");
	
	  if (hash == -1 && question == -1) {
	    return {};
	  }
	
	  if (hash == -1) {
	    hash = url.length;
	  }
	  var query = question == -1 || hash == question + 1 ? url.substring(hash) : url.substring(question + 1, hash);
	  var result = {};
	
	  query.split("&").forEach(function (part) {
	    if (!part) return;
	    part = part.split("+").join(" "); // replace every + with space, regexp-free version
	    var eq = part.indexOf("=");
	    var key = eq > -1 ? part.substr(0, eq) : part;
	    var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
	    var from = key.indexOf("[");
	    if (from == -1) result[decodeURIComponent(key)] = val;else {
	      var to = key.indexOf("]", from);
	      var index = decodeURIComponent(key.substring(from + 1, to));
	      key = decodeURIComponent(key.substring(0, from));
	      if (!result[key]) result[key] = [];
	      if (!index) result[key].push(val);else result[key][index] = val;
	    }
	  });
	  return result;
	}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(159);
	var createDesc = __webpack_require__(108);
	var toIObject = __webpack_require__(60);
	var toPrimitive = __webpack_require__(78);
	var has = __webpack_require__(57);
	var IE8_DOM_DEFINE = __webpack_require__(349);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(32) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(57);
	var toObject = __webpack_require__(35);
	var IE_PROTO = __webpack_require__(257)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(158);
	var defined = __webpack_require__(76);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactDebugTool = __webpack_require__(1106);
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(97);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(300);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(143);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1163);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(445);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1159);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1174);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1160);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1161);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(447);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1162);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(301);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1172);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(452);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1165);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1166);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1170);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(449);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userSaveCore = userSaveCore;
	exports.userSaveProfile = userSaveProfile;
	exports.userSaveWishlists = userSaveWishlists;
	exports.userSaveOrders = userSaveOrders;
	exports.userSaveExternalOrders = userSaveExternalOrders;
	exports.userSetProfile = userSetProfile;
	exports.userGetProfile = userGetProfile;
	exports.userGetUser = userGetUser;
	exports.userGetWishlists = userGetWishlists;
	exports.userCreateWishlist = userCreateWishlist;
	exports.userEditWishlist = userEditWishlist;
	exports.userDeleteWishlist = userDeleteWishlist;
	exports.userWishlistAddItem = userWishlistAddItem;
	exports.userWishlistRemoveItem = userWishlistRemoveItem;
	exports.userShareWishlist = userShareWishlist;
	exports.userGetOrders = userGetOrders;
	exports.userGetExternalOrders = userGetExternalOrders;
	exports.userForgotPassword = userForgotPassword;
	
	__webpack_require__(148);
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	var _endpoints = __webpack_require__(122);
	
	var endpoint = _interopRequireWildcard(_endpoints);
	
	var _api = __webpack_require__(121);
	
	var api = _interopRequireWildcard(_api);
	
	var _request = __webpack_require__(123);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/******************************
	*******  Synchronous  *********
	******************************/
	
	function userSaveCore(user) {
	  return {
	    type: constants.USER_CORE_SET,
	    user: user
	  };
	}
	
	function userSaveProfile(user) {
	  return {
	    type: constants.USER_PROFILE_SET,
	    user: user
	  };
	}
	
	function userSaveWishlists(wishlists) {
	  return {
	    type: constants.USER_WISHLISTS_SET,
	    wishlists: wishlists
	  };
	}
	
	function userSaveOrders(orders) {
	  return {
	    type: constants.USER_ORDERS_SET,
	    orders: orders
	  };
	}
	
	function userSaveExternalOrders(orders) {
	  return {
	    type: constants.USER_EXTERNAL_ORDERS_SET,
	    orders: orders
	  };
	}
	
	/******************************
	*******  Asynchronous  ********
	******************************/
	
	function userSetProfile(profileData) {
	  return function (dispatch) {
	
	    var url = api.USER_API + endpoint.USER_SERVICE_PROFILE;
	    return fetch(url, {
	      method: 'put',
	      headers: (0, _request.userServiceAuth)(api.HEADERS),
	      body: JSON.stringify(profileData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userGetProfile() {
	  return function (dispatch) {
	
	    var url = api.USER_API + endpoint.USER_SERVICE_PROFILE;
	
	    return fetch(url, {
	      method: 'get',
	      headers: (0, _request.userServiceAuth)(api.HEADERS)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userGetUser() {
	  return function (dispatch) {
	
	    var url = api.MAGENTO_API + endpoint.MAGENTO_GET_USER;
	
	    return fetch(url, {
	      method: 'get',
	      headers: (0, _request.userServiceAuth)(api.HEADERS)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userGetWishlists() {
	  return function (dispatch) {
	
	    var url = api.USER_API + endpoint.WISHLISTS_V2;
	    return fetch(url, {
	      method: 'get',
	      headers: (0, _request.userServiceAuth)(api.HEADERS)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userCreateWishlist(name) {
	  return function (dispatch) {
	
	    var url = api.USER_API + endpoint.WISHLISTS_V2;
	    var wishlistData = {
	      name: name
	    };
	
	    return fetch(url, {
	      method: 'post',
	      headers: (0, _request.userServiceAuth)(api.HEADERS),
	      body: JSON.stringify(wishlistData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userEditWishlist(wishlist_id, name) {
	  return function (dispatch) {
	
	    var url = api.USER_API + endpoint.WISHLISTS_V2 + wishlist_id;
	    var wishlistData = {
	      wishlist_id: wishlist_id,
	      name: name
	    };
	
	    return fetch(url, {
	      method: 'put',
	      headers: (0, _request.userServiceAuth)(api.HEADERS),
	      body: JSON.stringify(wishlistData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userDeleteWishlist(wishlist_id) {
	  return function (dispatch) {
	
	    var url = api.USER_API + endpoint.WISHLISTS_V2 + wishlist_id;
	    var wishlistData = {
	      wishlist_id: wishlist_id
	    };
	
	    return fetch(url, {
	      method: 'delete',
	      headers: (0, _request.userServiceAuth)(api.HEADERS),
	      body: JSON.stringify(wishlistData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userWishlistAddItem(wishlist_id, sku) {
	  return function (dispatch) {
	
	    var url = api.USER_API + endpoint.WISHLISTS_V2 + wishlist_id + '/add';
	    var wishlistData = {
	      wishlist_id: wishlist_id,
	      sku: sku
	    };
	
	    return fetch(url, {
	      method: 'post',
	      headers: (0, _request.userServiceAuth)(api.HEADERS),
	      body: JSON.stringify(wishlistData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userWishlistRemoveItem(wishlist_id, item_id) {
	  return function (dispatch) {
	
	    var url = api.USER_API + endpoint.WISHLISTS_V2 + wishlist_id + '/remove';
	    var wishlistData = {
	      wishlist_id: wishlist_id,
	      item_id: item_id
	    };
	
	    return fetch(url, {
	      method: 'post',
	      headers: (0, _request.userServiceAuth)(api.HEADERS),
	      body: JSON.stringify(wishlistData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userShareWishlist(wishlist_id, name, email) {
	  return function (dispatch) {
	
	    var url = api.USER_API + endpoint.WISHLISTS_V2 + wishlist_id + '/share';
	    var wishlistData = {
	      recipient_name: name,
	      recipient_email: email
	    };
	
	    return fetch(url, {
	      method: 'post',
	      headers: (0, _request.userServiceAuth)(api.HEADERS),
	      body: JSON.stringify(wishlistData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userGetOrders(uid) {
	  return function (dispatch) {
	
	    var url = api.MAGENTO_API + endpoint.MAGENTO_GET_ORDERS + '?customer_id=' + String(uid);
	    // let wishlistData = {
	    //   wishlist_id: wishlist_id,
	    //   item_id: item_id,
	    // }
	
	    return fetch(url, {
	      method: 'get',
	      headers: (0, _request.userServiceAuth)(api.HEADERS)
	      // body: JSON.stringify(wishlistData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userGetExternalOrders() {
	  return function (dispatch) {
	
	    var url = api.ORDERS_API + endpoint.ORDERS_GET_EXTERNAL;
	
	    return fetch(url, {
	      method: 'get',
	      headers: (0, _request.userServiceAuth)(api.HEADERS)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function userForgotPassword(email) {
	  return function (dispatch) {
	
	    var url = api.MAGENTO_API + endpoint.MAGENTO_FORGOT_PASSWORD;
	
	    var fpData = {
	      email: email,
	      template: 'email_reset',
	      websiteId: 1
	    };
	
	    return fetch(url, {
	      method: 'put',
	      headers: api.HEADERS,
	      body: JSON.stringify(fpData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(233)('wks');
	var uid = __webpack_require__(175);
	var Symbol = __webpack_require__(91).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(44);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(22);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _childUtils = __webpack_require__(165);
	
	var _events = __webpack_require__(197);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(280);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(415);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  (0, _inherits3.default)(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClick = function (event) {
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.props.onClick(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          disableKeyboardFocus = _props.disableKeyboardFocus,
	          keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.refs.enhancedButton.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.focusTimeout);
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props,
	          centerRipple = _props2.centerRipple,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          disableFocusRipple = _props2.disableFocusRipple,
	          disableKeyboardFocus = _props2.disableKeyboardFocus,
	          disableTouchRipple = _props2.disableTouchRipple,
	          focusRippleColor = _props2.focusRippleColor,
	          focusRippleOpacity = _props2.focusRippleOpacity,
	          touchRippleColor = _props2.touchRippleColor,
	          touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity
	        },
	        children
	      ) : undefined;
	
	      return (0, _childUtils.createChildFragment)({
	        focusRipple: focusRipple,
	        touchRipple: touchRipple,
	        children: touchRipple ? undefined : children
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          centerRipple = _props3.centerRipple,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          disableTouchRipple = _props3.disableTouchRipple,
	          focusRippleColor = _props3.focusRippleColor,
	          focusRippleOpacity = _props3.focusRippleOpacity,
	          href = _props3.href,
	          keyboardFocused = _props3.keyboardFocused,
	          touchRippleColor = _props3.touchRippleColor,
	          touchRippleOpacity = _props3.touchRippleOpacity,
	          onBlur = _props3.onBlur,
	          onClick = _props3.onClick,
	          onFocus = _props3.onFocus,
	          onKeyUp = _props3.onKeyUp,
	          onKeyDown = _props3.onKeyDown,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          onTouchTap = _props3.onTouchTap,
	          style = _props3.style,
	          tabIndex = _props3.tabIndex,
	          type = _props3.type,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'onTouchTap', 'style', 'tabIndex', 'type']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        position: 'relative', // This is needed so that ripples do not bleed past border radius.
	        verticalAlign: href ? 'middle' : null
	      }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          (0, _extends3.default)({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = (0, _extends3.default)({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: 'enhancedButton',
	        disabled: disabled,
	        href: href,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onTouchTap: this.handleTouchTap,
	        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
	      });
	
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      if (!href && containerElement === 'button') {
	        buttonProps.type = type;
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onTouchTap: function onTouchTap() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? EnhancedButton.propTypes = {
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  disableFocusRipple: _react.PropTypes.bool,
	  disableKeyboardFocus: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  focusRippleColor: _react.PropTypes.string,
	  focusRippleOpacity: _react.PropTypes.number,
	  href: _react.PropTypes.string,
	  keyboardFocused: _react.PropTypes.bool,
	  onBlur: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onKeyDown: _react.PropTypes.func,
	  onKeyUp: _react.PropTypes.func,
	  onKeyboardFocus: _react.PropTypes.func,
	  onTouchTap: _react.PropTypes.func,
	  style: _react.PropTypes.object,
	  tabIndex: _react.PropTypes.number,
	  touchRippleColor: _react.PropTypes.string,
	  touchRippleOpacity: _react.PropTypes.number,
	  type: _react.PropTypes.string
	} : void 0;
	exports.default = EnhancedButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var horizontal = _react.PropTypes.oneOf(['left', 'middle', 'right']);
	var vertical = _react.PropTypes.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _react.PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _react.PropTypes.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _react.PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	  zDepth: _react.PropTypes.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.cloneArray = cloneArray;
	function cloneArray(source) {
		var result = [];
		for (var n = 0; n < source.length; n++) {
			result[n] = source[n];
		}
		return result;
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(68);
	var IObject = __webpack_require__(158);
	var toObject = __webpack_require__(35);
	var toLength = __webpack_require__(29);
	var asc = __webpack_require__(241);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(4);
	var core = __webpack_require__(67);
	var fails = __webpack_require__(22);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(24);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(30);
	
	var CallbackQueue = __webpack_require__(423);
	var PooledClass = __webpack_require__(115);
	var ReactFeatureFlags = __webpack_require__(428);
	var ReactReconciler = __webpack_require__(140);
	var Transaction = __webpack_require__(202);
	
	var invariant = __webpack_require__(15);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(371);
	var $export = __webpack_require__(4);
	var shared = __webpack_require__(160)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(375))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(32)) {
	  var LIBRARY = __webpack_require__(94);
	  var global = __webpack_require__(20);
	  var fails = __webpack_require__(22);
	  var $export = __webpack_require__(4);
	  var $typed = __webpack_require__(189);
	  var $buffer = __webpack_require__(262);
	  var ctx = __webpack_require__(68);
	  var anInstance = __webpack_require__(103);
	  var propertyDesc = __webpack_require__(108);
	  var hide = __webpack_require__(49);
	  var redefineAll = __webpack_require__(109);
	  var toInteger = __webpack_require__(70);
	  var toLength = __webpack_require__(29);
	  var toIndex = __webpack_require__(369);
	  var toAbsoluteIndex = __webpack_require__(111);
	  var toPrimitive = __webpack_require__(78);
	  var has = __webpack_require__(57);
	  var classof = __webpack_require__(130);
	  var isObject = __webpack_require__(24);
	  var toObject = __webpack_require__(35);
	  var isArrayIter = __webpack_require__(248);
	  var create = __webpack_require__(105);
	  var getPrototypeOf = __webpack_require__(59);
	  var gOPN = __webpack_require__(106).f;
	  var getIterFn = __webpack_require__(264);
	  var uid = __webpack_require__(112);
	  var wks = __webpack_require__(27);
	  var createArrayMethod = __webpack_require__(75);
	  var createArrayIncludes = __webpack_require__(177);
	  var speciesConstructor = __webpack_require__(161);
	  var ArrayIterators = __webpack_require__(265);
	  var Iterators = __webpack_require__(131);
	  var $iterDetect = __webpack_require__(182);
	  var setSpecies = __webpack_require__(110);
	  var arrayFill = __webpack_require__(240);
	  var arrayCopyWithin = __webpack_require__(341);
	  var $DP = __webpack_require__(33);
	  var $GOPD = __webpack_require__(58);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(376);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (prefixedValue, value, keepUnprefixed) {
	  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type,
	      values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var PooledClass = __webpack_require__(115);
	
	var emptyFunction = __webpack_require__(71);
	var warning = __webpack_require__(19);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (process.env.NODE_ENV !== 'production') {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (process.env.NODE_ENV !== 'production') {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (process.env.NODE_ENV !== 'production') {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (process.env.NODE_ENV !== 'production') {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (process.env.NODE_ENV !== 'production') {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	    process.env.NODE_ENV !== 'production' ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(100);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(222);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(324);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.withOptions = withOptions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(162);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _supports = __webpack_require__(1149);
	
	var supports = _interopRequireWildcard(_supports);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	/* eslint-disable prefer-spread */
	
	function mergeDefaultEventOptions(options) {
	  return (0, _assign2.default)({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(supports.passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  if (supports.addEventListener) {
	    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	
	function off(target, eventName, callback, options) {
	  if (supports.removeEventListener) {
	    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);
	
	
	  (0, _keys2.default)(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	  process.env.NODE_ENV !== "production" ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;
	
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener = function (_Component) {
	  (0, _inherits3.default)(EventListener, _Component);
	
	  function EventListener() {
	    (0, _classCallCheck3.default)(this, EventListener);
	    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: 'applyListeners',
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return EventListener;
	}(_react.Component);
	
	process.env.NODE_ENV !== "production" ? EventListener.propTypes = {
	  /**
	   * You can provide a single child too.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
	} : void 0;
	exports.default = EventListener;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isLoggedIn = isLoggedIn;
	exports.saveLogin = saveLogin;
	exports.logout = logout;
	exports.getGuestCart = getGuestCart;
	exports.saveGuestCart = saveGuestCart;
	
	var _storage = __webpack_require__(171);
	
	var storage = _interopRequireWildcard(_storage);
	
	var _auth = __webpack_require__(219);
	
	var authConstants = _interopRequireWildcard(_auth);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function isLoggedIn() {
	
		var token = storage.get('token');
		var expiry = storage.get('tokenExpiry');
	
		if (!token || token.length < 12) {
			return false;
		}
		if (!expiry || expiry < Date.now()) {
			return false;
		}
		return true;
	}
	
	function saveLogin(token) {
		storage.put('token', token);
		storage.put('tokenExpiry', Date.now() + authConstants.LOGOUT_TIME);
	}
	
	function logout() {
		storage.clear();
	}
	
	function getGuestCart() {
		return storage.get('ddcid');
	}
	
	function saveGuestCart(cid) {
		storage.put('ddcid', cid);
	}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(124)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(91);
	var core = __webpack_require__(43);
	var ctx = __webpack_require__(226);
	var hide = __webpack_require__(125);
	var has = __webpack_require__(102);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(101);
	var IE8_DOM_DEFINE = __webpack_require__(329);
	var toPrimitive = __webpack_require__(235);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(89) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(27)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(49)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(112)('meta');
	var isObject = __webpack_require__(24);
	var has = __webpack_require__(57);
	var setDesc = __webpack_require__(33).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(22)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (process.env.NODE_ENV !== 'production') {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (process.env.NODE_ENV !== 'production') {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName: process.env.NODE_ENV !== 'production' ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	  process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResultsControlsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _formatting = __webpack_require__(21);
	
	var _locations = __webpack_require__(220);
	
	var locations = _interopRequireWildcard(_locations);
	
	var _product = __webpack_require__(42);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var ResultsControls = function (_React$Component) {
	  _inherits(ResultsControls, _React$Component);
	
	  function ResultsControls(props) {
	    _classCallCheck(this, ResultsControls);
	
	    var _this = _possibleConstructorReturn(this, (ResultsControls.__proto__ || Object.getPrototypeOf(ResultsControls)).call(this, props));
	
	    _this.state = {
	      genericValue: ''
	    };
	    return _this;
	  }
	
	  _createClass(ResultsControls, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // if(window.location.host.indexOf('staging') >= 0) { 
	      try {
	        Load_Buttons_Hands();
	      } catch (err) {
	        console.error(err);
	      }
	      // }
	    }
	  }, {
	    key: 'getDropdownOptions',
	    value: function getDropdownOptions() {
	      switch (this.props.resultType) {
	        case 'diamond':
	          return this.getDiamondOptions();
	        case 'setting':
	          return this.getSettingOptions();
	        case 'mensband':
	          return this.getMensBandOptions();
	        case 'womensband':
	          return this.getWomensBandOptions();
	        case 'fashion':
	          return this.getFashionOptions();
	        default:
	          return this.getGenericOptions();
	      }
	    }
	  }, {
	    key: 'getGenericOptions',
	    value: function getGenericOptions() {
	      return [{
	        display: 'Sort by',
	        value: ''
	      }, {
	        display: 'Price (Low to High)',
	        value: 'sell_price'
	      }, {
	        display: 'Price (High to Low)',
	        value: '-sell_price'
	      }, {
	        display: 'Total Carat Weight (Low to High)',
	        value: 'ttw_dia'
	      }, {
	        display: 'Total Carat Weight (High to Low)',
	        value: '-ttw_dia'
	      }];
	    }
	  }, {
	    key: 'getDiamondOptions',
	    value: function getDiamondOptions() {
	      return [{
	        display: 'Sort by',
	        value: ''
	      }, {
	        display: 'Carat (Low to High)',
	        value: 'carat'
	      }, {
	        display: 'Carat (High to Low)',
	        value: '-carat'
	      }, {
	        display: 'Price (Low to High)',
	        value: 'price'
	      }, {
	        display: 'Price (High to Low)',
	        value: '-price'
	      }];
	    }
	  }, {
	    key: 'getSettingOptions',
	    value: function getSettingOptions() {
	      return [{
	        display: 'Sort by',
	        value: ''
	      }, {
	        display: 'Price (Low to High)',
	        value: 'sell_price'
	      }, {
	        display: 'Price (High to Low)',
	        value: '-sell_price'
	      }, {
	        display: 'Total Carat Weight (Low to High)',
	        value: 'ttw_dia'
	      }, {
	        display: 'Total Carat Weight (High to Low)',
	        value: '-ttw_dia'
	      }];
	    }
	  }, {
	    key: 'getWomensBandOptions',
	    value: function getWomensBandOptions() {
	      return [{
	        display: 'Sort by',
	        value: ''
	      }, {
	        display: 'Price (Low to High)',
	        value: 'sell_price'
	      }, {
	        display: 'Price (High to Low)',
	        value: '-sell_price'
	      }, {
	        display: 'Total Carat Weight (Low to High)',
	        value: 'ttw_dia'
	      }, {
	        display: 'Total Carat Weight (High to Low)',
	        value: '-ttw_dia'
	      }];
	    }
	  }, {
	    key: 'getMensBandOptions',
	    value: function getMensBandOptions() {
	      return [{
	        display: 'Sort by',
	        value: ''
	      }, {
	        display: 'Price (Low to High)',
	        value: 'sell_price'
	      }, {
	        display: 'Price (High to Low)',
	        value: '-sell_price'
	      }];
	    }
	  }, {
	    key: 'getFashionOptions',
	    value: function getFashionOptions() {
	      return [{
	        display: 'Sort by',
	        value: ''
	      }, {
	        display: 'Price (Low to High)',
	        value: 'sell_price'
	      }, {
	        display: 'Price (High to Low)',
	        value: '-sell_price'
	      }, {
	        display: 'Total Carat Weight (Low to High)',
	        value: 'ttw_dia'
	      }, {
	        display: 'Total Carat Weight (High to Low)',
	        value: '-ttw_dia'
	      }];
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'changeSortDropdown',
	    value: function changeSortDropdown(evt) {
	      if (this.getCurrentSort() != evt.target.value) {
	        this.updateData(evt.target.value);
	      }
	    }
	  }, {
	    key: 'getResultCount',
	    value: function getResultCount() {
	      if (this.props.resultCount === 0) {
	        return 0;
	      }
	      if (this.props.resultCount) {
	        return parseInt(this.props.resultCount);
	      }
	      return null;
	    }
	  }, {
	    key: 'getCurrentSort',
	    value: function getCurrentSort() {
	      if (this.props.resultType == 'generic') {
	        return this.state.genericValue;
	      } else if (this.props.resultType == 'diamond') {
	        if (this.props.product.diamondFilters && this.props.product.diamondFilters.sort) {
	          return this.props.product.diamondFilters.sort;
	        }
	      } else {
	        if (this.props.product.productFilters && this.props.product.productFilters.sort) {
	          return this.props.product.productFilters.sort;
	        }
	      }
	      return '';
	    }
	  }, {
	    key: 'updateData',
	    value: function updateData(sortVal) {
	      if (this.props.resultType == 'generic') {
	        this.setState({ genericValue: sortVal });
	        return this.updateGenericData(sortVal);
	      }
	      return this.props.resultType == 'diamond' ? this.updateDiamondData(sortVal) : this.updateProductData(sortVal);
	    }
	  }, {
	    key: 'updateGenericData',
	    value: function updateGenericData(sortVal) {
	      this.props.updateMethod(sortVal);
	      return null;
	    }
	  }, {
	    key: 'updateDiamondData',
	    value: function updateDiamondData(sortVal) {
	      var _this2 = this;
	
	      this.props.productSaveDiamondQueryFilters({ 'sort': sortVal });
	      setTimeout(function () {
	        _this2.props.productFetchDiamonds((0, _formatting.formatQuerystring)(_this2.props.product.diamondFilters)).then(function (respData) {
	          var filteredResults = (0, _product.reSortDiamonds)(respData.results, _this2.props.product.diamondFilters);
	          _this2.props.productSaveDiamondResults(filteredResults, respData.count < 100 ? filteredResults.length : respData.count);
	        });
	      }, 150);
	    }
	  }, {
	    key: 'updateProductData',
	    value: function updateProductData(sortVal) {
	      var _this3 = this;
	
	      this.props.productSaveProductQueryFilters({ 'sort': sortVal }, this.props.resultType);
	      setTimeout(function () {
	        _this3.props.productFetchProducts((0, _formatting.formatQuerystring)(_this3.props.product.productFilters)).then(function (respData) {
	
	          var filtersSnapshot = Object.assign({}, _this3.props.product.productFilters);
	          var filteredResults = (0, _product.reSortProducts)(respData.success.products, filtersSnapshot);
	
	          _this3.props.productSaveResults(filteredResults, respData.success.count);
	        });
	      }, 150);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context;
	
	      // if(window.location.host.indexOf('staging') >= 0) { 
	      try {
	        Load_Buttons_Hands();
	      } catch (err) {
	        console.error(err);
	      }
	      // }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ResultsControls' },
	        _react2.default.createElement(
	          'div',
	          { className: 'countWrapper' },
	          this.getResultCount() !== null ? _react2.default.createElement(
	            'div',
	            { className: 'countCopy' },
	            this.getResultCount(),
	            ' ',
	            this.getResultCount() === 1 ? 'result' : 'results'
	          ) : null
	        ),
	        this.props.openFilters ? _react2.default.createElement(
	          'div',
	          { className: 'editWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'editButton', onClick: (_context = this.props).openFilters.bind(_context) },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Filters'
	            )
	          )
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'sortWrapper' },
	          _react2.default.createElement(_RhinoSelect2.default, {
	            options: this.getDropdownOptions(),
	            value: this.getCurrentSort(),
	            changeMethod: this.changeSortDropdown.bind(this),
	            rootClass: 'sortSelect' })
	        )
	      );
	    }
	  }]);
	
	  return ResultsControls;
	}(_react2.default.Component);
	
	ResultsControls.propTypes = {
	  location: _react.PropTypes.object
	};
	ResultsControls.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ResultsControls;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var ResultsControlsContainer = exports.ResultsControlsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ResultsControls);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(633);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(632);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(126);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(68);
	var call = __webpack_require__(352);
	var isArrayIter = __webpack_require__(248);
	var anObject = __webpack_require__(16);
	var toLength = __webpack_require__(29);
	var getIterFn = __webpack_require__(264);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(16);
	var dPs = __webpack_require__(358);
	var enumBugKeys = __webpack_require__(244);
	var IE_PROTO = __webpack_require__(257)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(243)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(246).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(360);
	var hiddenKeys = __webpack_require__(244).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(360);
	var enumBugKeys = __webpack_require__(244);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(50);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(20);
	var dP = __webpack_require__(33);
	var DESCRIPTORS = __webpack_require__(32);
	var SPECIES = __webpack_require__(27)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(70);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (function(e) {
		var t = {};
		function r(n) {
			if (t[n]) return t[n].exports;
			var o = (t[n] = { i: n, l: !1, exports: {} });
			return e[n].call(o.exports, o, o.exports, r), (o.l = !0), o.exports;
		}
		return (
			(r.m = e),
			(r.c = t),
			(r.d = function(e, t, n) {
				r.o(e, t) ||
					Object.defineProperty(e, t, { enumerable: !0, get: n });
			}),
			(r.r = function(e) {
				'undefined' != typeof Symbol &&
					Symbol.toStringTag &&
					Object.defineProperty(e, Symbol.toStringTag, {
						value: 'Module',
					}),
					Object.defineProperty(e, '__esModule', { value: !0 });
			}),
			(r.t = function(e, t) {
				if ((1 & t && (e = r(e)), 8 & t)) return e;
				if (4 & t && 'object' == typeof e && e && e.__esModule) return e;
				var n = Object.create(null);
				if (
					(r.r(n),
					Object.defineProperty(n, 'default', {
						enumerable: !0,
						value: e,
					}),
					2 & t && 'string' != typeof e)
				)
					for (var o in e)
						r.d(
							n,
							o,
							function(t) {
								return e[t];
							}.bind(null, o)
						);
				return n;
			}),
			(r.n = function(e) {
				var t =
					e && e.__esModule
						? function() {
								return e.default;
						  }
						: function() {
								return e;
						  };
				return r.d(t, 'a', t), t;
			}),
			(r.o = function(e, t) {
				return Object.prototype.hasOwnProperty.call(e, t);
			}),
			(r.p = ''),
			r((r.s = 8))
		);
	})([
		function(e, t) {
			e.exports = __webpack_require__(1);
		},
		function(e, t, r) {
			e.exports = r(10)();
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 }),
				(t.default = function() {
					return (
						'undefined' != typeof window &&
						'IntersectionObserver' in window &&
						'isIntersecting' in
							window.IntersectionObserverEntry.prototype
					);
				});
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n = (function() {
					function e(e, t) {
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							(n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								'value' in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n);
						}
					}
					return function(t, r, n) {
						return r && e(t.prototype, r), n && e(t, n), t;
					};
				})(),
				o = u(r(0)),
				i = r(1),
				a = u(r(4)),
				s = u(r(12)),
				l = u(r(2));
			function u(e) {
				return e && e.__esModule ? e : { default: e };
			}
			var c = (function(e) {
				function t(e) {
					!(function(e, t) {
						if (!(e instanceof t))
							throw new TypeError(
								'Cannot call a class as a function'
							);
					})(this, t);
					var r = (function(e, t) {
							if (!e)
								throw new ReferenceError(
									"this hasn't been initialised - super() hasn't been called"
								);
							return !t ||
								('object' != typeof t && 'function' != typeof t)
								? e
								: t;
						})(
							this,
							(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
						),
						n = e.afterLoad,
						o = e.beforeLoad,
						i = e.scrollPosition,
						a = e.visibleByDefault;
					return (
						(r.state = { visible: a }),
						a && (o(), n()),
						(r.onVisible = r.onVisible.bind(r)),
						(r.isScrollTracked = Boolean(
							i &&
								Number.isFinite(i.x) &&
								i.x >= 0 &&
								Number.isFinite(i.y) &&
								i.y >= 0
						)),
						r
					);
				}
				return (
					(function(e, t) {
						if ('function' != typeof t && null !== t)
							throw new TypeError(
								'Super expression must either be null or a function, not ' +
									typeof t
							);
						(e.prototype = Object.create(t && t.prototype, {
							constructor: {
								value: e,
								enumerable: !1,
								writable: !0,
								configurable: !0,
							},
						})),
							t &&
								(Object.setPrototypeOf
									? Object.setPrototypeOf(e, t)
									: (e.__proto__ = t));
					})(t, e),
					n(t, [
						{
							key: 'componentDidUpdate',
							value: function(e, t) {
								t.visible !== this.state.visible &&
									this.props.afterLoad();
							},
						},
						{
							key: 'onVisible',
							value: function() {
								this.props.beforeLoad(),
									this.setState({ visible: !0 });
							},
						},
						{
							key: 'render',
							value: function() {
								if (this.state.visible) return this.props.children;
								var e = this.props,
									t = e.className,
									r = e.delayMethod,
									n = e.delayTime,
									i = e.height,
									u = e.placeholder,
									c = e.scrollPosition,
									f = e.style,
									p = e.threshold,
									d = e.useIntersectionObserver,
									y = e.width;
								return this.isScrollTracked ||
									(d && (0, l.default)())
									? o.default.createElement(a.default, {
											className: t,
											height: i,
											onVisible: this.onVisible,
											placeholder: u,
											scrollPosition: c,
											style: f,
											threshold: p,
											useIntersectionObserver: d,
											width: y,
									  })
									: o.default.createElement(s.default, {
											className: t,
											delayMethod: r,
											delayTime: n,
											height: i,
											onVisible: this.onVisible,
											placeholder: u,
											style: f,
											threshold: p,
											width: y,
									  });
							},
						},
					]),
					t
				);
			})(o.default.Component);
			(c.propTypes = {
				afterLoad: i.PropTypes.func,
				beforeLoad: i.PropTypes.func,
				useIntersectionObserver: i.PropTypes.bool,
				visibleByDefault: i.PropTypes.bool,
			}),
				(c.defaultProps = {
					afterLoad: function() {
						return {};
					},
					beforeLoad: function() {
						return {};
					},
					useIntersectionObserver: !0,
					visibleByDefault: !1,
				}),
				(t.default = c);
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n =
					Object.assign ||
					function(e) {
						for (var t = 1; t < arguments.length; t++) {
							var r = arguments[t];
							for (var n in r)
								Object.prototype.hasOwnProperty.call(r, n) &&
									(e[n] = r[n]);
						}
						return e;
					},
				o = (function() {
					function e(e, t) {
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							(n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								'value' in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n);
						}
					}
					return function(t, r, n) {
						return r && e(t.prototype, r), n && e(t, n), t;
					};
				})(),
				i = u(r(0)),
				a = u(r(5)),
				s = r(1),
				l = u(r(2));
			function u(e) {
				return e && e.__esModule ? e : { default: e };
			}
			var c = function(e) {
					e.forEach(function(e) {
						e.isIntersecting && e.target.onVisible();
					});
				},
				f = {},
				p = function(e) {
					return (
						(f[e] =
							f[e] ||
							new IntersectionObserver(c, { rootMargin: e + 'px' })),
						f[e]
					);
				},
				d = (function(e) {
					function t(e) {
						!(function(e, t) {
							if (!(e instanceof t))
								throw new TypeError(
									'Cannot call a class as a function'
								);
						})(this, t);
						var r = (function(e, t) {
							if (!e)
								throw new ReferenceError(
									"this hasn't been initialised - super() hasn't been called"
								);
							return !t ||
								('object' != typeof t && 'function' != typeof t)
								? e
								: t;
						})(
							this,
							(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
						);
						if (
							((r.supportsObserver =
								!e.scrollPosition &&
								e.useIntersectionObserver &&
								(0, l.default)()),
							r.supportsObserver)
						) {
							var n = e.threshold;
							r.observer = p(n);
						}
						return r;
					}
					return (
						(function(e, t) {
							if ('function' != typeof t && null !== t)
								throw new TypeError(
									'Super expression must either be null or a function, not ' +
										typeof t
								);
							(e.prototype = Object.create(t && t.prototype, {
								constructor: {
									value: e,
									enumerable: !1,
									writable: !0,
									configurable: !0,
								},
							})),
								t &&
									(Object.setPrototypeOf
										? Object.setPrototypeOf(e, t)
										: (e.__proto__ = t));
						})(t, e),
						o(t, [
							{
								key: 'componentDidMount',
								value: function() {
									this.placeholder &&
										this.observer &&
										((this.placeholder.onVisible = this.props.onVisible),
										this.observer.observe(this.placeholder)),
										this.supportsObserver ||
											this.updateVisibility();
								},
							},
							{
								key: 'componentWillUnmount',
								value: function() {
									this.observer &&
										this.observer.unobserve(this.placeholder);
								},
							},
							{
								key: 'componentDidUpdate',
								value: function() {
									this.supportsObserver ||
										this.updateVisibility();
								},
							},
							{
								key: 'getPlaceholderBoundingBox',
								value: function() {
									var e =
											arguments.length > 0 &&
											void 0 !== arguments[0]
												? arguments[0]
												: this.props.scrollPosition,
										t = this.placeholder.getBoundingClientRect(),
										r = a.default.findDOMNode(this.placeholder)
											.style,
										n = {
											left:
												parseInt(
													r.getPropertyValue(
														'margin-left'
													),
													10
												) || 0,
											top:
												parseInt(
													r.getPropertyValue(
														'margin-top'
													),
													10
												) || 0,
										};
									return {
										bottom: e.y + t.bottom + n.top,
										left: e.x + t.left + n.left,
										right: e.x + t.right + n.left,
										top: e.y + t.top + n.top,
									};
								},
							},
							{
								key: 'isPlaceholderInViewport',
								value: function() {
									if (
										'undefined' == typeof window ||
										!this.placeholder
									)
										return !1;
									var e = this.props,
										t = e.scrollPosition,
										r = e.threshold,
										n = this.getPlaceholderBoundingBox(t),
										o = t.y + window.innerHeight,
										i = t.x,
										a = t.x + window.innerWidth,
										s = t.y;
									return Boolean(
										s - r <= n.bottom &&
											o + r >= n.top &&
											i - r <= n.right &&
											a + r >= n.left
									);
								},
							},
							{
								key: 'updateVisibility',
								value: function() {
									this.isPlaceholderInViewport() &&
										this.props.onVisible();
								},
							},
							{
								key: 'render',
								value: function() {
									var e = this,
										t = this.props,
										r = t.className,
										o = t.height,
										a = t.placeholder,
										s = t.style,
										l = t.width;
									if (a && 'function' != typeof a.type)
										return i.default.cloneElement(a, {
											ref: function(t) {
												return (e.placeholder = t);
											},
										});
									var u = n({ display: 'inline-block' }, s);
									return (
										void 0 !== l && (u.width = l),
										void 0 !== o && (u.height = o),
										i.default.createElement(
											'span',
											{
												className: r,
												ref: function(t) {
													return (e.placeholder = t);
												},
												style: u,
											},
											a
										)
									);
								},
							},
						]),
						t
					);
				})(i.default.Component);
			(d.propTypes = {
				onVisible: s.PropTypes.func.isRequired,
				className: s.PropTypes.string,
				height: s.PropTypes.oneOfType([
					s.PropTypes.number,
					s.PropTypes.string,
				]),
				placeholder: s.PropTypes.element,
				threshold: s.PropTypes.number,
				useIntersectionObserver: s.PropTypes.bool,
				scrollPosition: s.PropTypes.shape({
					x: s.PropTypes.number.isRequired,
					y: s.PropTypes.number.isRequired,
				}),
				width: s.PropTypes.oneOfType([
					s.PropTypes.number,
					s.PropTypes.string,
				]),
			}),
				(d.defaultProps = {
					className: '',
					placeholder: null,
					threshold: 100,
					useIntersectionObserver: !0,
				}),
				(t.default = d);
		},
		function(e, t) {
			e.exports = __webpack_require__(28);
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n =
					Object.assign ||
					function(e) {
						for (var t = 1; t < arguments.length; t++) {
							var r = arguments[t];
							for (var n in r)
								Object.prototype.hasOwnProperty.call(r, n) &&
									(e[n] = r[n]);
						}
						return e;
					},
				o = (function() {
					function e(e, t) {
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							(n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								'value' in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n);
						}
					}
					return function(t, r, n) {
						return r && e(t.prototype, r), n && e(t, n), t;
					};
				})(),
				i = p(r(0)),
				a = p(r(5)),
				s = r(1),
				l = p(r(13)),
				u = p(r(14)),
				c = p(r(2)),
				f = p(r(15));
			function p(e) {
				return e && e.__esModule ? e : { default: e };
			}
			function d(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || ('object' != typeof t && 'function' != typeof t)
					? e
					: t;
			}
			var y = function() {
					return 'undefined' == typeof window
						? 0
						: window.scrollX || window.pageXOffset;
				},
				h = function() {
					return 'undefined' == typeof window
						? 0
						: window.scrollY || window.pageYOffset;
				};
			t.default = function(e) {
				var t = (function(t) {
					function r(e) {
						!(function(e, t) {
							if (!(e instanceof t))
								throw new TypeError(
									'Cannot call a class as a function'
								);
						})(this, r);
						var t = d(
							this,
							(r.__proto__ || Object.getPrototypeOf(r)).call(this, e)
						);
						if (
							((t.useIntersectionObserver =
								e.useIntersectionObserver && (0, c.default)()),
							t.useIntersectionObserver)
						)
							return d(t);
						var n = t.onChangeScroll.bind(t);
						return (
							'debounce' === e.delayMethod
								? (t.delayedScroll = (0, l.default)(n, e.delayTime))
								: 'throttle' === e.delayMethod &&
								  (t.delayedScroll = (0, u.default)(
										n,
										e.delayTime
								  )),
							(t.state = { scrollPosition: { x: y(), y: h() } }),
							(t.baseComponentRef = i.default.createRef()),
							t
						);
					}
					return (
						(function(e, t) {
							if ('function' != typeof t && null !== t)
								throw new TypeError(
									'Super expression must either be null or a function, not ' +
										typeof t
								);
							(e.prototype = Object.create(t && t.prototype, {
								constructor: {
									value: e,
									enumerable: !1,
									writable: !0,
									configurable: !0,
								},
							})),
								t &&
									(Object.setPrototypeOf
										? Object.setPrototypeOf(e, t)
										: (e.__proto__ = t));
						})(r, t),
						o(r, [
							{
								key: 'componentDidMount',
								value: function() {
									this.addListeners();
								},
							},
							{
								key: 'componentWillUnmount',
								value: function() {
									this.removeListeners();
								},
							},
							{
								key: 'componentDidUpdate',
								value: function() {
									'undefined' == typeof window ||
										this.useIntersectionObserver ||
										((0, f.default)(
											a.default.findDOMNode(
												this.baseComponentRef.current
											)
										) !== this.scrollElement &&
											(this.removeListeners(),
											this.addListeners()));
								},
							},
							{
								key: 'addListeners',
								value: function() {
									'undefined' == typeof window ||
										this.useIntersectionObserver ||
										((this.scrollElement = (0, f.default)(
											a.default.findDOMNode(
												this.baseComponentRef.current
											)
										)),
										this.scrollElement.addEventListener(
											'scroll',
											this.delayedScroll,
											{ passive: !0 }
										),
										window.addEventListener(
											'resize',
											this.delayedScroll,
											{ passive: !0 }
										),
										this.scrollElement !== window &&
											window.addEventListener(
												'scroll',
												this.delayedScroll,
												{ passive: !0 }
											));
								},
							},
							{
								key: 'removeListeners',
								value: function() {
									'undefined' == typeof window ||
										this.useIntersectionObserver ||
										(this.scrollElement.removeEventListener(
											'scroll',
											this.delayedScroll
										),
										window.removeEventListener(
											'resize',
											this.delayedScroll
										),
										this.scrollElement !== window &&
											window.removeEventListener(
												'scroll',
												this.delayedScroll
											));
								},
							},
							{
								key: 'onChangeScroll',
								value: function() {
									this.useIntersectionObserver ||
										this.setState({
											scrollPosition: { x: y(), y: h() },
										});
								},
							},
							{
								key: 'render',
								value: function() {
									var t = this.props,
										r =
											(t.delayMethod,
											t.delayTime,
											(function(e, t) {
												var r = {};
												for (var n in e)
													t.indexOf(n) >= 0 ||
														(Object.prototype.hasOwnProperty.call(
															e,
															n
														) &&
															(r[n] = e[n]));
												return r;
											})(t, ['delayMethod', 'delayTime'])),
										o = this.useIntersectionObserver
											? null
											: this.state.scrollPosition;
									return i.default.createElement(
										e,
										n(
											{
												ref: this.baseComponentRef,
												scrollPosition: o,
											},
											r
										)
									);
								},
							},
						]),
						r
					);
				})(i.default.Component);
				return (
					(t.propTypes = {
						delayMethod: s.PropTypes.oneOf(['debounce', 'throttle']),
						delayTime: s.PropTypes.number,
						useIntersectionObserver: s.PropTypes.bool,
					}),
					(t.defaultProps = {
						delayMethod: 'throttle',
						delayTime: 300,
						useIntersectionObserver: !0,
					}),
					t
				);
			};
		},
		function(e, t) {
			var r;
			r = (function() {
				return this;
			})();
			try {
				r = r || new Function('return this')();
			} catch (e) {
				'object' == typeof window && (r = window);
			}
			e.exports = r;
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 }),
				(t.trackWindowScroll = t.LazyLoadComponent = t.LazyLoadImage = void 0);
			var n = a(r(9)),
				o = a(r(3)),
				i = a(r(6));
			function a(e) {
				return e && e.__esModule ? e : { default: e };
			}
			(t.LazyLoadImage = n.default),
				(t.LazyLoadComponent = o.default),
				(t.trackWindowScroll = i.default);
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n =
					Object.assign ||
					function(e) {
						for (var t = 1; t < arguments.length; t++) {
							var r = arguments[t];
							for (var n in r)
								Object.prototype.hasOwnProperty.call(r, n) &&
									(e[n] = r[n]);
						}
						return e;
					},
				o = (function() {
					function e(e, t) {
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							(n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								'value' in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n);
						}
					}
					return function(t, r, n) {
						return r && e(t.prototype, r), n && e(t, n), t;
					};
				})(),
				i = l(r(0)),
				a = r(1),
				s = l(r(3));
			function l(e) {
				return e && e.__esModule ? e : { default: e };
			}
			var u = (function(e) {
				function t(e) {
					!(function(e, t) {
						if (!(e instanceof t))
							throw new TypeError(
								'Cannot call a class as a function'
							);
					})(this, t);
					var r = (function(e, t) {
						if (!e)
							throw new ReferenceError(
								"this hasn't been initialised - super() hasn't been called"
							);
						return !t ||
							('object' != typeof t && 'function' != typeof t)
							? e
							: t;
					})(
						this,
						(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
					);
					return (r.state = { loaded: !1 }), r;
				}
				return (
					(function(e, t) {
						if ('function' != typeof t && null !== t)
							throw new TypeError(
								'Super expression must either be null or a function, not ' +
									typeof t
							);
						(e.prototype = Object.create(t && t.prototype, {
							constructor: {
								value: e,
								enumerable: !1,
								writable: !0,
								configurable: !0,
							},
						})),
							t &&
								(Object.setPrototypeOf
									? Object.setPrototypeOf(e, t)
									: (e.__proto__ = t));
					})(t, e),
					o(t, [
						{
							key: 'onImageLoad',
							value: function() {
								var e = this;
								return this.state.loaded
									? null
									: function() {
											e.props.afterLoad(),
												e.setState({ loaded: !0 });
									  };
							},
						},
						{
							key: 'getImg',
							value: function() {
								var e = this.props,
									t =
										(e.afterLoad,
										e.beforeLoad,
										e.delayMethod,
										e.delayTime,
										e.effect,
										e.placeholder,
										e.placeholderSrc,
										e.scrollPosition,
										e.threshold,
										e.useIntersectionObserver,
										e.visibleByDefault,
										e.wrapperClassName,
										e.wrapperProps,
										(function(e, t) {
											var r = {};
											for (var n in e)
												t.indexOf(n) >= 0 ||
													(Object.prototype.hasOwnProperty.call(
														e,
														n
													) &&
														(r[n] = e[n]));
											return r;
										})(e, [
											'afterLoad',
											'beforeLoad',
											'delayMethod',
											'delayTime',
											'effect',
											'placeholder',
											'placeholderSrc',
											'scrollPosition',
											'threshold',
											'useIntersectionObserver',
											'visibleByDefault',
											'wrapperClassName',
											'wrapperProps',
										]));
								return i.default.createElement(
									'img',
									n({ onLoad: this.onImageLoad() }, t)
								);
							},
						},
						{
							key: 'getLazyLoadImage',
							value: function() {
								var e = this.props,
									t = e.beforeLoad,
									r = e.className,
									n = e.delayMethod,
									o = e.delayTime,
									a = e.height,
									l = e.placeholder,
									u = e.scrollPosition,
									c = e.style,
									f = e.threshold,
									p = e.useIntersectionObserver,
									d = e.visibleByDefault,
									y = e.width;
								return i.default.createElement(
									s.default,
									{
										beforeLoad: t,
										className: r,
										delayMethod: n,
										delayTime: o,
										height: a,
										placeholder: l,
										scrollPosition: u,
										style: c,
										threshold: f,
										useIntersectionObserver: p,
										visibleByDefault: d,
										width: y,
									},
									this.getImg()
								);
							},
						},
						{
							key: 'getWrappedLazyLoadImage',
							value: function(e) {
								var t = this.props,
									r = t.effect,
									o = t.height,
									a = t.placeholderSrc,
									s = t.width,
									l = t.wrapperClassName,
									u = t.wrapperProps,
									c = this.state.loaded,
									f = c ? ' lazy-load-image-loaded' : '';
								return i.default.createElement(
									'span',
									n(
										{
											className:
												l +
												' lazy-load-image-background ' +
												r +
												f,
											style: {
												backgroundImage:
													c || !a ? '' : 'url(' + a + ')',
												backgroundSize:
													c || !a ? '' : '100% 100%',
												display: 'inline-block',
												height: o,
												width: s,
											},
										},
										u
									),
									e
								);
							},
						},
						{
							key: 'render',
							value: function() {
								var e = this.props,
									t = e.effect,
									r = e.placeholderSrc,
									n = e.visibleByDefault,
									o = e.wrapperClassName,
									i = e.wrapperProps,
									a = this.getLazyLoadImage();
								return ((t || r) && !n) || o || i
									? this.getWrappedLazyLoadImage(a)
									: a;
							},
						},
					]),
					t
				);
			})(i.default.Component);
			(u.propTypes = {
				afterLoad: a.PropTypes.func,
				beforeLoad: a.PropTypes.func,
				delayMethod: a.PropTypes.string,
				delayTime: a.PropTypes.number,
				effect: a.PropTypes.string,
				placeholderSrc: a.PropTypes.string,
				threshold: a.PropTypes.number,
				useIntersectionObserver: a.PropTypes.bool,
				visibleByDefault: a.PropTypes.bool,
				wrapperClassName: a.PropTypes.string,
				wrapperProps: a.PropTypes.object,
			}),
				(u.defaultProps = {
					afterLoad: function() {
						return {};
					},
					beforeLoad: function() {
						return {};
					},
					delayMethod: 'throttle',
					delayTime: 300,
					effect: '',
					placeholderSrc: null,
					threshold: 100,
					useIntersectionObserver: !0,
					visibleByDefault: !1,
					wrapperClassName: '',
				}),
				(t.default = u);
		},
		function(e, t, r) {
			'use strict';
			var n = r(11);
			function o() {}
			function i() {}
			(i.resetWarningCache = o),
				(e.exports = function() {
					function e(e, t, r, o, i, a) {
						if (a !== n) {
							var s = new Error(
								'Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types'
							);
							throw ((s.name = 'Invariant Violation'), s);
						}
					}
					function t() {
						return e;
					}
					e.isRequired = e;
					var r = {
						array: e,
						bool: e,
						func: e,
						number: e,
						object: e,
						string: e,
						symbol: e,
						any: e,
						arrayOf: t,
						element: e,
						elementType: e,
						instanceOf: t,
						node: e,
						objectOf: t,
						oneOf: t,
						oneOfType: t,
						shape: t,
						exact: t,
						checkPropTypes: i,
						resetWarningCache: o,
					};
					return (r.PropTypes = r), r;
				});
		},
		function(e, t, r) {
			'use strict';
			e.exports = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n = (function() {
					function e(e, t) {
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							(n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								'value' in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n);
						}
					}
					return function(t, r, n) {
						return r && e(t.prototype, r), n && e(t, n), t;
					};
				})(),
				o = s(r(0)),
				i = s(r(4)),
				a = s(r(6));
			function s(e) {
				return e && e.__esModule ? e : { default: e };
			}
			var l = (function(e) {
				function t(e) {
					return (
						(function(e, t) {
							if (!(e instanceof t))
								throw new TypeError(
									'Cannot call a class as a function'
								);
						})(this, t),
						(function(e, t) {
							if (!e)
								throw new ReferenceError(
									"this hasn't been initialised - super() hasn't been called"
								);
							return !t ||
								('object' != typeof t && 'function' != typeof t)
								? e
								: t;
						})(
							this,
							(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
						)
					);
				}
				return (
					(function(e, t) {
						if ('function' != typeof t && null !== t)
							throw new TypeError(
								'Super expression must either be null or a function, not ' +
									typeof t
							);
						(e.prototype = Object.create(t && t.prototype, {
							constructor: {
								value: e,
								enumerable: !1,
								writable: !0,
								configurable: !0,
							},
						})),
							t &&
								(Object.setPrototypeOf
									? Object.setPrototypeOf(e, t)
									: (e.__proto__ = t));
					})(t, e),
					n(t, [
						{
							key: 'render',
							value: function() {
								return o.default.createElement(
									i.default,
									this.props
								);
							},
						},
					]),
					t
				);
			})(o.default.Component);
			t.default = (0, a.default)(l);
		},
		function(e, t, r) {
			(function(t) {
				var r = 'Expected a function',
					n = NaN,
					o = '[object Symbol]',
					i = /^\s+|\s+$/g,
					a = /^[-+]0x[0-9a-f]+$/i,
					s = /^0b[01]+$/i,
					l = /^0o[0-7]+$/i,
					u = parseInt,
					c = 'object' == typeof t && t && t.Object === Object && t,
					f =
						'object' == typeof self &&
						self &&
						self.Object === Object &&
						self,
					p = c || f || Function('return this')(),
					d = Object.prototype.toString,
					y = Math.max,
					h = Math.min,
					b = function() {
						return p.Date.now();
					};
				function v(e) {
					var t = typeof e;
					return !!e && ('object' == t || 'function' == t);
				}
				function m(e) {
					if ('number' == typeof e) return e;
					if (
						(function(e) {
							return (
								'symbol' == typeof e ||
								((function(e) {
									return !!e && 'object' == typeof e;
								})(e) &&
									d.call(e) == o)
							);
						})(e)
					)
						return n;
					if (v(e)) {
						var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
						e = v(t) ? t + '' : t;
					}
					if ('string' != typeof e) return 0 === e ? e : +e;
					e = e.replace(i, '');
					var r = s.test(e);
					return r || l.test(e)
						? u(e.slice(2), r ? 2 : 8)
						: a.test(e)
						? n
						: +e;
				}
				e.exports = function(e, t, n) {
					var o,
						i,
						a,
						s,
						l,
						u,
						c = 0,
						f = !1,
						p = !1,
						d = !0;
					if ('function' != typeof e) throw new TypeError(r);
					function w(t) {
						var r = o,
							n = i;
						return (o = i = void 0), (c = t), (s = e.apply(n, r));
					}
					function O(e) {
						var r = e - u;
						return void 0 === u || r >= t || r < 0 || (p && e - c >= a);
					}
					function g() {
						var e = b();
						if (O(e)) return P(e);
						l = setTimeout(
							g,
							(function(e) {
								var r = t - (e - u);
								return p ? h(r, a - (e - c)) : r;
							})(e)
						);
					}
					function P(e) {
						return (l = void 0), d && o ? w(e) : ((o = i = void 0), s);
					}
					function T() {
						var e = b(),
							r = O(e);
						if (((o = arguments), (i = this), (u = e), r)) {
							if (void 0 === l)
								return (function(e) {
									return (
										(c = e),
										(l = setTimeout(g, t)),
										f ? w(e) : s
									);
								})(u);
							if (p) return (l = setTimeout(g, t)), w(u);
						}
						return void 0 === l && (l = setTimeout(g, t)), s;
					}
					return (
						(t = m(t) || 0),
						v(n) &&
							((f = !!n.leading),
							(a = (p = 'maxWait' in n)
								? y(m(n.maxWait) || 0, t)
								: a),
							(d = 'trailing' in n ? !!n.trailing : d)),
						(T.cancel = function() {
							void 0 !== l && clearTimeout(l),
								(c = 0),
								(o = u = i = l = void 0);
						}),
						(T.flush = function() {
							return void 0 === l ? s : P(b());
						}),
						T
					);
				};
			}.call(this, r(7)));
		},
		function(e, t, r) {
			(function(t) {
				var r = 'Expected a function',
					n = NaN,
					o = '[object Symbol]',
					i = /^\s+|\s+$/g,
					a = /^[-+]0x[0-9a-f]+$/i,
					s = /^0b[01]+$/i,
					l = /^0o[0-7]+$/i,
					u = parseInt,
					c = 'object' == typeof t && t && t.Object === Object && t,
					f =
						'object' == typeof self &&
						self &&
						self.Object === Object &&
						self,
					p = c || f || Function('return this')(),
					d = Object.prototype.toString,
					y = Math.max,
					h = Math.min,
					b = function() {
						return p.Date.now();
					};
				function v(e, t, n) {
					var o,
						i,
						a,
						s,
						l,
						u,
						c = 0,
						f = !1,
						p = !1,
						d = !0;
					if ('function' != typeof e) throw new TypeError(r);
					function v(t) {
						var r = o,
							n = i;
						return (o = i = void 0), (c = t), (s = e.apply(n, r));
					}
					function O(e) {
						var r = e - u;
						return void 0 === u || r >= t || r < 0 || (p && e - c >= a);
					}
					function g() {
						var e = b();
						if (O(e)) return P(e);
						l = setTimeout(
							g,
							(function(e) {
								var r = t - (e - u);
								return p ? h(r, a - (e - c)) : r;
							})(e)
						);
					}
					function P(e) {
						return (l = void 0), d && o ? v(e) : ((o = i = void 0), s);
					}
					function T() {
						var e = b(),
							r = O(e);
						if (((o = arguments), (i = this), (u = e), r)) {
							if (void 0 === l)
								return (function(e) {
									return (
										(c = e),
										(l = setTimeout(g, t)),
										f ? v(e) : s
									);
								})(u);
							if (p) return (l = setTimeout(g, t)), v(u);
						}
						return void 0 === l && (l = setTimeout(g, t)), s;
					}
					return (
						(t = w(t) || 0),
						m(n) &&
							((f = !!n.leading),
							(a = (p = 'maxWait' in n)
								? y(w(n.maxWait) || 0, t)
								: a),
							(d = 'trailing' in n ? !!n.trailing : d)),
						(T.cancel = function() {
							void 0 !== l && clearTimeout(l),
								(c = 0),
								(o = u = i = l = void 0);
						}),
						(T.flush = function() {
							return void 0 === l ? s : P(b());
						}),
						T
					);
				}
				function m(e) {
					var t = typeof e;
					return !!e && ('object' == t || 'function' == t);
				}
				function w(e) {
					if ('number' == typeof e) return e;
					if (
						(function(e) {
							return (
								'symbol' == typeof e ||
								((function(e) {
									return !!e && 'object' == typeof e;
								})(e) &&
									d.call(e) == o)
							);
						})(e)
					)
						return n;
					if (m(e)) {
						var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
						e = m(t) ? t + '' : t;
					}
					if ('string' != typeof e) return 0 === e ? e : +e;
					e = e.replace(i, '');
					var r = s.test(e);
					return r || l.test(e)
						? u(e.slice(2), r ? 2 : 8)
						: a.test(e)
						? n
						: +e;
				}
				e.exports = function(e, t, n) {
					var o = !0,
						i = !0;
					if ('function' != typeof e) throw new TypeError(r);
					return (
						m(n) &&
							((o = 'leading' in n ? !!n.leading : o),
							(i = 'trailing' in n ? !!n.trailing : i)),
						v(e, t, { leading: o, maxWait: t, trailing: i })
					);
				};
			}.call(this, r(7)));
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n = function(e, t) {
					return 'undefined' == typeof getComputedStyle
						? e.style[t]
						: getComputedStyle(e, null).getPropertyValue(t);
				},
				o = function(e) {
					return (
						n(e, 'overflow') + n(e, 'overflow-y') + n(e, 'overflow-x')
					);
				};
			t.default = function(e) {
				if (!(e instanceof HTMLElement)) return window;
				for (
					var t = e;
					t &&
					t !== document.body &&
					t !== document.documentElement &&
					t.parentNode;
	
				) {
					if (/(scroll|auto)/.test(o(t))) return t;
					t = t.parentNode;
				}
				return window;
			};
		},
	]);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var ReactCurrentOwner = __webpack_require__(80);
	
	var warning = __webpack_require__(19);
	var canDefineProperty = __webpack_require__(208);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(457);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (process.env.NODE_ENV !== 'production') {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (process.env.NODE_ENV !== 'production') {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (process.env.NODE_ENV !== 'production') {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (process.env.NODE_ENV !== 'production') {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (process.env.NODE_ENV !== 'production') {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(162);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AntiModal = function (_React$Component) {
	  _inherits(AntiModal, _React$Component);
	
	  function AntiModal(props) {
	    _classCallCheck(this, AntiModal);
	
	    var _this = _possibleConstructorReturn(this, (AntiModal.__proto__ || Object.getPrototypeOf(AntiModal)).call(this, props));
	
	    _this.state = {
	      open: false,
	      closing: false,
	      bodyTop: 0,
	      marginOffset: 0
	    };
	
	    // Bind event listeners
	    _this.adjustHeight = _this.adjustHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(AntiModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.addEventListener('resize', this.adjustHeight, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.adjustHeight, false);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.state.open !== nextProps.open) {
	        if (this.state.open && !nextProps.open && !this.state.closing) {
	          this.closeModal();
	        }
	        if (nextProps.open) {
	          this.openModal();
	        }
	      }
	      if (this.props.resize != nextProps.resize) {
	        this.adjustHeight();
	      }
	    }
	  }, {
	    key: 'getModalBody',
	    value: function getModalBody() {
	      var modal = null;
	      var modals = document.getElementsByClassName('modalBody');
	      for (var i = 0; i < modals.length; i++) {
	        if (getComputedStyle(modals[i], null).display === 'block') {
	          modal = modals[i];
	          break;
	        }
	      }
	      return modal;
	    }
	  }, {
	    key: 'adjustHeight',
	    value: function adjustHeight() {
	      var foundModal = this.getModalBody();
	      if (foundModal) {
	        var offset = (window.innerHeight - (foundModal.offsetHeight + 128)) / 2;
	        this.setState({ marginOffset: offset > 0 ? offset + 'px' : 0 });
	      }
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      var _this2 = this;
	
	      this.setState({ open: true }, function () {
	        var modal = null;
	        do {
	          modal = _this2.getModalBody();
	          setTimeout(function () {
	            if (modal) {
	              var offset = (window.innerHeight - (modal.offsetHeight + 128)) / 2;
	              _this2.setState({
	                bodyTop: '64px',
	                marginOffset: offset > 0 ? offset + 'px' : 0
	              });
	            }
	          }, 25);
	        } while (!modal);
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var _this3 = this;
	
	      this.setState({
	        closing: true,
	        bodyTop: '0'
	      });
	      setTimeout(function () {
	        _this3.setState({
	          open: false,
	          closing: false
	        });
	      }, 400);
	    }
	  }, {
	    key: 'modalStyles',
	    value: function modalStyles() {
	      return {
	        display: this.state.open ? 'block' : 'none'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: this.state.closing ? 'AntiModal out' : 'AntiModal',
	          style: this.modalStyles() },
	        _react2.default.createElement(
	          'div',
	          {
	            className: this.props.theme ? 'modalBody ' + this.props.theme : 'modalBody',
	            style: {
	              display: this.state.open ? 'block' : 'none',
	              top: this.state.bodyTop,
	              marginTop: this.state.marginOffset,
	              marginBottom: this.state.marginOffset === 0 ? '64px' : 0
	            } },
	          this.props.title ? _react2.default.createElement(
	            'div',
	            { className: 'modalTitle modalTitlePositioning' },
	            this.props.title
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'modalChildren' },
	            this.props.children
	          ),
	          this.props.actions ? _react2.default.createElement(
	            'div',
	            { className: 'modalActions modalActionsPositioning' },
	            this.props.actions.map(function (action) {
	              return action;
	            })
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return AntiModal;
	}(_react2.default.Component);
	
	AntiModal.defaultProps = {
	  open: false,
	  resize: 0
	};
	AntiModal.propTypes = {
	  open: _react.PropTypes.bool,
	  resize: _react.PropTypes.number
	};
	exports.default = AntiModal;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResultsPaginationContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import {formatDropdownData} from '../../../../../utils/formatting';
	// import * as locations from '../../../../../constants/locations';
	
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	// import RhinoSelect from '../../../../common/inputs/RhinoSelect';
	
	var ResultsPagination = function (_React$Component) {
	  _inherits(ResultsPagination, _React$Component);
	
	  function ResultsPagination(props) {
	    _classCallCheck(this, ResultsPagination);
	
	    var _this = _possibleConstructorReturn(this, (ResultsPagination.__proto__ || Object.getPrototypeOf(ResultsPagination)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ResultsPagination, [{
	    key: 'incrementPage',
	    value: function incrementPage() {
	      if (this.props.isDiamondPage) {
	        // get more diamonds
	      }
	      this.props.pageNext();
	
	      // if(this.props.isDiamondPage) {
	
	      //   this.props.productAddDiamonds(formatQuerystring(this.props.product.diamondFilters), this.props.product.currentDiamondPage + 1)
	      //   .then((respData) => {
	      //     this.props.productAddDiamondResults(respData.results);
	      //   });
	      // }
	    }
	
	    // TODO: add setpage method
	
	    // TODO: add increment diamond method
	
	  }, {
	    key: 'pageNav',
	    value: function pageNav(newPage) {
	
	      this.props.setPage(parseInt(newPage));
	      // if(this.props.isDiamondPage && newPage > (this.props.pageNum + 1)) {
	
	      //   this.props.productAddDiamonds(formatQuerystring(this.props.product.diamondFilters), this.props.product.currentDiamondPage + 1)
	      //   .then((respData) => {
	      //     this.props.productAddDiamondResults(respData.results);
	      //   });
	      // }
	    }
	  }, {
	    key: 'renderLHS',
	    value: function renderLHS() {
	      var _this2 = this;
	
	      if (this.props.pageNum === 1) {
	        return _react2.default.createElement('div', { className: 'pageLHS' });
	      }
	
	      if (this.props.pageNum == 2) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pageLHS' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this2.props.setPage(1);
	              } },
	            '1'
	          )
	        );
	      }
	
	      if (this.props.pageNum == 3) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pageLHS' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this2.props.setPage(1);
	              } },
	            '1'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this2.props.setPage(2);
	              } },
	            '2'
	          )
	        );
	      }
	
	      if (this.props.pageNum == 4) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pageLHS' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this2.props.setPage(1);
	              } },
	            '1'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this2.props.setPage(2);
	              } },
	            '2'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this2.props.setPage(3);
	              } },
	            '3'
	          )
	        );
	      }
	
	      if (this.props.pageNum >= 5) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pageLHS' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this2.props.setPage(1);
	              } },
	            '1'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pageElipsis' },
	            '\u2026'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this2.props.setPage(parseInt(_this2.props.pageNum) - 1);
	              } },
	            parseInt(this.props.pageNum) - 1
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderRHS',
	    value: function renderRHS() {
	      var _this3 = this;
	
	      var pageDiff = this.getNumberOfPages() - this.props.pageNum;
	
	      if (pageDiff > 3) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pageRHS' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this3.pageNav(_this3.props.pageNum + 1);
	              } },
	            this.props.pageNum + 1
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pageElipsis' },
	            '\u2026'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this3.pageNav(_this3.getNumberOfPages());
	              } },
	            this.getNumberOfPages()
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pageRHS' },
	          this.props.pageNum + 1 <= this.getNumberOfPages() ? _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this3.pageNav(_this3.props.pageNum + 1);
	              } },
	            this.props.pageNum + 1
	          ) : null,
	          this.props.pageNum + 2 <= this.getNumberOfPages() ? _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this3.pageNav(_this3.props.pageNum + 2);
	              } },
	            this.props.pageNum + 2
	          ) : null,
	          this.props.pageNum + 3 <= this.getNumberOfPages() ? _react2.default.createElement(
	            'div',
	            { className: 'pageClickable', onClick: function onClick() {
	                return _this3.pageNav(_this3.props.pageNum + 3);
	              } },
	            this.props.pageNum + 3
	          ) : null
	        );
	      }
	    }
	  }, {
	    key: 'renderDiamondRHS',
	    value: function renderDiamondRHS() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pageRHS' },
	        this.props.pageNum + 1 <= this.getNumberOfPages() ? _react2.default.createElement(
	          'div',
	          { className: 'pageClickable', onClick: function onClick() {
	              return _this4.pageNav(_this4.props.pageNum + 1);
	            } },
	          this.props.pageNum + 1
	        ) : null,
	        this.props.pageNum + 2 <= this.getNumberOfPages() ? _react2.default.createElement(
	          'div',
	          { className: 'pageClickable', onClick: function onClick() {
	              return _this4.pageNav(_this4.props.pageNum + 2);
	            } },
	          this.props.pageNum + 2
	        ) : null,
	        this.props.pageNum + 3 <= this.getNumberOfPages() ? _react2.default.createElement(
	          'div',
	          { className: 'pageClickable', onClick: function onClick() {
	              return _this4.pageNav(_this4.props.pageNum + 1);
	            } },
	          '>'
	        ) : null
	      );
	    }
	  }, {
	    key: 'getNumberOfPages',
	    value: function getNumberOfPages() {
	
	      if (this.props.isDiamondPage === true) {
	
	        if (!this.props.product.diamondResultsCount) {
	          return 1;
	        }
	        return Math.ceil(parseInt(this.props.product.diamondResultsCount) / parseInt(this.props.pageSize));
	      }if (this.props.isSearchPage === true) {
	
	        if (!this.props.searchItems) {
	          return 1;
	        }
	        return Math.ceil(parseInt(this.props.searchItems.length) / parseInt(this.props.pageSize));
	      } else {
	
	        if (!this.props.product.productResultsCount) {
	          return 1;
	        }
	        return Math.ceil(parseInt(this.props.product.productResultsCount) / parseInt(this.props.pageSize));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context;
	
	      // console.log('pageination');
	      // console.log(this.props.resultCount);
	      // console.log(this.props.pageSize);
	      // console.log(this.props.pageNum);
	      // console.log(this.props.pageSize * this.props.pageNum);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ResultsPagination' },
	        this.props.pageNum > 1 ? _react2.default.createElement(
	          'div',
	          { className: 'prevPageWrapper', onClick: (_context = this.props).pagePrev.bind(_context) },
	          '< Previous'
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'pageLabelWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pageLabelLHS' },
	            this.renderLHS()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pageLabelCenter' },
	            !isNaN(this.props.pageNum) ? this.props.pageNum : 1
	          ),
	          this.props.isDiamondPage ? _react2.default.createElement(
	            'div',
	            { className: 'pageLabelRHS' },
	            this.renderDiamondRHS()
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'pageLabelRHS' },
	            this.renderRHS()
	          )
	        ),
	        this.props.pageNum < this.getNumberOfPages() ? _react2.default.createElement(
	          'div',
	          { className: 'nextPageWrapper', onClick: this.incrementPage.bind(this) },
	          'Next >'
	        ) : null
	      );
	    }
	  }]);
	
	  return ResultsPagination;
	}(_react2.default.Component);
	
	ResultsPagination.propTypes = {
	  location: _react.PropTypes.object
	};
	ResultsPagination.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ResultsPagination;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var ResultsPaginationContainer = exports.ResultsPaginationContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ResultsPagination);

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var API_URL = exports.API_URL = 'https://ddipi.diamondsdirect.com/v1';
	
	// export const DIAMOND_API = 'https://stdapi.diamondsdirect.com';
	var DIAMOND_API = exports.DIAMOND_API = 'https://dapi.diamondsdirect.com';
	// export const PRODUCT_API = 'https://ddstprodapi1.diamondsdirect.com';
	var PRODUCT_API = exports.PRODUCT_API = 'https://ddprodapi1.diamondsdirect.com';
	var MAGENTO_API = exports.MAGENTO_API = 'https://staging2.diamondsdirect.com/rest/V1';
	// export const USER_API = 'https://dduserapi2.diamondsdirect.com';
	var USER_API = exports.USER_API = 'https://ddstuserapi1.diamondsdirect.com';
	var ORDERS_API = exports.ORDERS_API = 'https://ddorderapi1.diamondsdirect.com';
	
	var HEADERS = exports.HEADERS = {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	};
	var FILE_HEADERS = exports.FILE_HEADERS = {
		'Accept': 'application/json'
	};

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// GET Requests
	
	// export const USERS_EMAIL_AVAILABLE = '/users/email-available';
	// export const USERS_MANAGER_FETCH = '/users/self';
	
	var PRODUCT_DIAMONDS = exports.PRODUCT_DIAMONDS = '/api/dd2diamond';
	var PRODUCT_DIAMOND_BY_ID = exports.PRODUCT_DIAMOND_BY_ID = '/api/diamond/find_by_id';
	
	var PRODUCT_SETTINGS = exports.PRODUCT_SETTINGS = '/api/products/gallery';
	var PRODUCT_SETTING_BY_SKU = exports.PRODUCT_SETTING_BY_SKU = '/api/products/sku';
	var PRODUCT_SEARCH = exports.PRODUCT_SEARCH = '/api/products/search';
	
	// POST Requests
	var API_CONTACT = exports.API_CONTACT = '/gifts/dd-contact';
	var API_FOUNDATION = exports.API_FOUNDATION = '/gifts/foundation';
	var API_SHOPPING = exports.API_SHOPPING = '/gifts/appointment/shopping';
	var API_SERVICE = exports.API_SERVICE = '/gifts/appointment/service';
	var API_SUMMER_CONTACT = exports.API_SUMMER_CONTACT = '/gifts/summer-contact';
	var API_AUBURN_CONTACT = exports.API_AUBURN_CONTACT = '/gifts/auburn-contact';
	var API_WATCH = exports.API_WATCH = '/gifts/watch';
	var API_CUSTOM_DESIGN = exports.API_CUSTOM_DESIGN = '/gifts/custom-design';
	
	// export const USERS_FORGOT_PASSWORD = '/users/forgot-password';
	// export const USERS_LOGIN = '/users/login';
	// export const USERS_RESET_PASSWORD = '/users/reset-password';
	
	
	// Orders endpoints
	var ORDERS_GET_EXTERNAL = exports.ORDERS_GET_EXTERNAL = '/api/orders/external';
	
	// Wishlist endpoints (Legacy)
	var WISHLISTS_GET = exports.WISHLISTS_GET = '/api/wishlists/all';
	var WISHLISTS_CREATE = exports.WISHLISTS_CREATE = '/api/wishlists/create';
	var WISHLISTS_EDIT = exports.WISHLISTS_EDIT = '/api/wishlists/edit';
	var WISHLISTS_DELETE = exports.WISHLISTS_DELETE = '/api/wishlists/delete';
	var WISHLIST_ITEM_ADD = exports.WISHLIST_ITEM_ADD = '/api/wishlists/add';
	var WISHLIST_ITEM_REMOVE = exports.WISHLIST_ITEM_REMOVE = '/api/wishlists/remove';
	
	// Wishlists endpoits V2
	var WISHLISTS_V2 = exports.WISHLISTS_V2 = '/api/wishlists/';
	// export const WISHLISTS2 = '/api/wishlists';
	// export const WISHLISTS2 = '/api/wishlists';
	
	
	// Magento Requests
	
	// GET Requests
	var MAGENTO_GET_USER = exports.MAGENTO_GET_USER = '/customers/me';
	var MAGENTO_GET_ORDERS = exports.MAGENTO_GET_ORDERS = '/ddorder/fetch';
	var MAGENTO_CHECK_HK_STATUS = exports.MAGENTO_CHECK_HK_STATUS = '/diamondsdirect-diamondorder/check-kh';
	
	// POST Requests
	var MAGENTO_GET_GUEST_CART = exports.MAGENTO_GET_GUEST_CART = '/guest-carts';
	var MAGENTO_ADD_TO_CART = exports.MAGENTO_ADD_TO_CART = '/ddcart/add';
	var MAGENTO_ADD_METAL_SIZE = exports.MAGENTO_ADD_METAL_SIZE = '/ddcart/add-ms';
	var MAGENTO_ADD_ENGAGEMENT = exports.MAGENTO_ADD_ENGAGEMENT = '/ddcart/engagement';
	var MAGENTO_ADD_DIAMOND = exports.MAGENTO_ADD_DIAMOND = '/ddcart/diamond';
	
	var MAGENTO_ADD_DIAMOND_JEWELRY = exports.MAGENTO_ADD_DIAMOND_JEWELRY = '/ddcart/diamond-jewelry';
	
	var MAGENTO_LOGIN = exports.MAGENTO_LOGIN = '/integration/customer/token';
	var MAGENTO_REGISTER = exports.MAGENTO_REGISTER = '/customers';
	var MAGENTO_LOGGED_IN_CART = exports.MAGENTO_LOGGED_IN_CART = '/carts/mine';
	
	// PUT Requests
	var MAGENTO_FORGOT_PASSWORD = exports.MAGENTO_FORGOT_PASSWORD = '/customers/password';
	var MAGENTO_SET_PASSWORD = exports.MAGENTO_SET_PASSWORD = '/customers/me/password';
	
	// Magento Module Request
	var MAGENTO_CART_COUNT = exports.MAGENTO_CART_COUNT = '/ddcart/mine';
	
	// User Requests
	
	var USER_SERVICE_PROFILE = exports.USER_SERVICE_PROFILE = '/api/customers/me';
	
	// Third party requests (full URLS)
	
	var INSTAGRAM_GET_IMAGES = exports.INSTAGRAM_GET_IMAGES = 'https://www.instagram.com/diamondsdirect/?__a=1';

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.parseJSON = parseJSON;
	exports.isOk = isOk;
	exports.authReq = authReq;
	exports.userServiceAuth = userServiceAuth;
	
	var _storage = __webpack_require__(171);
	
	var storage = _interopRequireWildcard(_storage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function parseJSON(response) {
	
		var status = response.status;
		return response.json().then(function (data) {
			return {
				status: status,
				data: data
			};
		});
	}
	
	function isOk(status) {
		if (status >= 200 && status < 300) {
			return true;
		} else {
			return false;
		}
	}
	
	function authReq(headers) {
		var autk = storage.get('token');
		return Object.assign({}, headers, { 'AUTK': autk });
	}
	
	function userServiceAuth(headers) {
		var autk = 'Bearer ' + storage.get('token');
		return Object.assign({}, headers, { 'Authorization': autk });
	}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(92);
	var createDesc = __webpack_require__(156);
	module.exports = __webpack_require__(89) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(330);
	var defined = __webpack_require__(227);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(227);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(66);
	var TAG = __webpack_require__(27)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(33).f;
	var has = __webpack_require__(57);
	var TAG = __webpack_require__(27)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var defined = __webpack_require__(76);
	var fails = __webpack_require__(22);
	var spaces = __webpack_require__(260);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dateTimeFormat = dateTimeFormat;
	exports.addDays = addDays;
	exports.addMonths = addMonths;
	exports.addYears = addYears;
	exports.cloneDate = cloneDate;
	exports.cloneAsDate = cloneAsDate;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getWeekArray = getWeekArray;
	exports.localizedWeekday = localizedWeekday;
	exports.formatIso = formatIso;
	exports.isEqualDate = isEqualDate;
	exports.isBeforeDate = isBeforeDate;
	exports.isAfterDate = isAfterDate;
	exports.isBetweenDates = isBetweenDates;
	exports.monthDiff = monthDiff;
	exports.yearDiff = yearDiff;
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
	var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function dateTimeFormat(locale, options) {
	  process.env.NODE_ENV !== "production" ? (0, _warning2.default)(locale === 'en-US', 'Material-UI: The ' + locale + ' locale is not supported by the built-in DateTimeFormat.\n  Use the `DateTimeFormat` prop to supply an alternative implementation.') : void 0;
	
	  this.format = function (date) {
	    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
	      return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
	    } else if (options.year === 'numeric' && options.month === 'numeric' && options.day === 'numeric') {
	      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
	    } else if (options.year === 'numeric' && options.month === 'long') {
	      return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
	    } else if (options.weekday === 'narrow') {
	      return dayAbbreviation[date.getDay()];
	    } else if (options.year === 'numeric') {
	      return date.getFullYear().toString();
	    } else if (options.day === 'numeric') {
	      return date.getDate();
	    } else {
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: Wrong usage of DateTimeFormat') : void 0;
	    }
	  };
	}
	
	function addDays(d, days) {
	  var newDate = cloneDate(d);
	  newDate.setDate(d.getDate() + days);
	  return newDate;
	}
	
	function addMonths(d, months) {
	  var newDate = cloneDate(d);
	  newDate.setMonth(d.getMonth() + months);
	  return newDate;
	}
	
	function addYears(d, years) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(d.getFullYear() + years);
	  return newDate;
	}
	
	function cloneDate(d) {
	  return new Date(d.getTime());
	}
	
	function cloneAsDate(d) {
	  var clonedDate = cloneDate(d);
	  clonedDate.setHours(0, 0, 0, 0);
	  return clonedDate;
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1);
	}
	
	function getFirstDayOfWeek() {
	  var now = new Date();
	  return new Date(now.setDate(now.getDate() - now.getDay()));
	}
	
	function getWeekArray(d, firstDayOfWeek) {
	  var dayArray = [];
	  var daysInMonth = getDaysInMonth(d);
	  var weekArray = [];
	  var week = [];
	
	  for (var i = 1; i <= daysInMonth; i++) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
	  }
	
	  var addWeek = function addWeek(week) {
	    var emptyDays = 7 - week.length;
	    for (var _i = 0; _i < emptyDays; ++_i) {
	      week[weekArray.length ? 'push' : 'unshift'](null);
	    }
	    weekArray.push(week);
	  };
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      addWeek(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      addWeek(week);
	    }
	  });
	
	  return weekArray;
	}
	
	function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
	  var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
	  var firstDayDate = getFirstDayOfWeek();
	
	  return weekdayFormatter.format(addDays(firstDayDate, day + firstDayOfWeek));
	}
	
	// Convert date to ISO 8601 (YYYY-MM-DD) date string, accounting for current timezone
	function formatIso(date) {
	  return new Date(date.toDateString() + ' 12:00:00 +0000').toISOString().substring(0, 10);
	}
	
	function isEqualDate(d1, d2) {
	  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	}
	
	function isBeforeDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() < date2.getTime();
	}
	
	function isAfterDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() > date2.getTime();
	}
	
	function isBetweenDates(dateToCheck, startDate, endDate) {
	  return !isBeforeDate(dateToCheck, startDate) && !isAfterDate(dateToCheck, endDate);
	}
	
	function monthDiff(d1, d2) {
	  var m = void 0;
	  m = (d1.getFullYear() - d2.getFullYear()) * 12;
	  m += d1.getMonth();
	  m -= d2.getMonth();
	  return m;
	}
	
	function yearDiff(d1, d2) {
	  return ~~(monthDiff(d1, d2) / 12);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(984);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(87);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(413);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _lodash = __webpack_require__(936);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PopoverAnimationDefault = __webpack_require__(993);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	var _iOSHelpers = __webpack_require__(1067);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'none'
	  }
	};
	
	var Popover = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover(props, context) {
	    (0, _classCallCheck3.default)(this, Popover);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));
	
	    _this.timeout = null;
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props,
	          animated = _this$props.animated,
	          animation = _this$props.animation,
	          anchorEl = _this$props.anchorEl,
	          anchorOrigin = _this$props.anchorOrigin,
	          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
	          canAutoPosition = _this$props.canAutoPosition,
	          children = _this$props.children,
	          onRequestClose = _this$props.onRequestClose,
	          style = _this$props.style,
	          targetOrigin = _this$props.targetOrigin,
	          useLayerForClickAway = _this$props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway']);
	
	
	      var styleRoot = style;
	
	      if (!animated) {
	        styleRoot = {
	          position: 'fixed',
	          zIndex: _this.context.muiTheme.zIndex.popover
	        };
	
	        if (!_this.state.open) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
	          children
	        );
	      }
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	
	      return _react2.default.createElement(
	        Animation,
	        (0, _extends3.default)({
	          targetOrigin: targetOrigin,
	          style: styleRoot
	        }, other, {
	          open: _this.state.open && !_this.state.closing
	        }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function (event) {
	      event.preventDefault();
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      if (!_this.refs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.refs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          targetOrigin = _this$props2.targetOrigin,
	          anchorOrigin = _this$props2.anchorOrigin;
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = Math.max(0, targetPosition.top) + 'px';
	      targetEl.style.left = Math.max(0, targetPosition.left) + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open !== this.state.open) {
	        if (nextProps.open) {
	          this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	          this.setState({
	            open: true,
	            closing: false
	          });
	        } else {
	          if (nextProps.animated) {
	            if (this.timeout !== null) return;
	            this.setState({ closing: true });
	            this.timeout = setTimeout(function () {
	              _this2.setState({
	                open: false
	              }, function () {
	                _this2.timeout = null;
	              });
	            }, 500);
	          } else {
	            this.setState({
	              open: false
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleScroll.cancel();
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	
	      // The fixed positioning isn't respected on iOS when an input is focused.
	      // We need to compute the position from the top of the page and not the viewport.
	      if ((0, _iOSHelpers.isIOS)() && document.activeElement.tagName === 'INPUT') {
	        a.bottom = (0, _iOSHelpers.getOffsetTop)(el) + a.height;
	      } else {
	        a.bottom = rect.bottom || a.top + a.height;
	      }
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = (0, _extends3.default)({}, anchor);
	      var t = (0, _extends3.default)({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
	          positions = _getPositions.positions,
	          anchorPos = _getPositions.anchorPos;
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) {
	          targetPosition.top = Math.max(0, newTop);
	        } else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) {
	            targetPosition.top = Math.max(0, newTop);
	          }
	        }
	      }
	
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) {
	          targetPosition.left = Math.max(0, newLeft);
	        } else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) {
	            targetPosition.left = Math.max(0, newLeft);
	          }
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onScroll: this.handleScroll,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: 'layer',
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component);
	
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Popover.propTypes = {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _react.PropTypes.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _react.PropTypes.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _react.PropTypes.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _react.PropTypes.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = Popover;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(284);
	var setInnerHTML = __webpack_require__(204);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(291);
	var setTextContent = __webpack_require__(441);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var EventPluginRegistry = __webpack_require__(198);
	var EventPluginUtils = __webpack_require__(199);
	var ReactErrorUtils = __webpack_require__(288);
	
	var accumulateInto = __webpack_require__(434);
	var forEachAccumulated = __webpack_require__(435);
	var invariant = __webpack_require__(15);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ? process.env.NODE_ENV !== 'production' ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(138);
	var EventPluginUtils = __webpack_require__(199);
	
	var accumulateInto = __webpack_require__(434);
	var forEachAccumulated = __webpack_require__(435);
	var warning = __webpack_require__(19);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1120);
	var ReactInstrumentation = __webpack_require__(62);
	
	var warning = __webpack_require__(19);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (process.env.NODE_ENV !== 'production') {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (process.env.NODE_ENV !== 'production') {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (process.env.NODE_ENV !== 'production') {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (process.env.NODE_ENV !== 'production') {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	      process.env.NODE_ENV !== 'production' ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (process.env.NODE_ENV !== 'production') {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (process.env.NODE_ENV !== 'production') {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	var getEventTarget = __webpack_require__(294);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createMailtoLink = exports.toSearchString = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var toSearchString = exports.toSearchString = function toSearchString() {
	  var searchParams = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  return Object.keys(searchParams).map(function (key) {
	    return key + '=' + encodeURIComponent(searchParams[key]);
	  }).join('&');
	};
	
	var createMailtoLink = exports.createMailtoLink = function createMailtoLink(email, headers) {
	  var link = 'mailto:' + email;
	  if (headers) {
	    link += '?' + toSearchString(headers);
	  }
	  return link;
	};
	
	var Mailto = function (_Component) {
	  _inherits(Mailto, _Component);
	
	  function Mailto() {
	    _classCallCheck(this, Mailto);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Mailto).apply(this, arguments));
	  }
	
	  _createClass(Mailto, [{
	    key: 'render',
	    value: function render() {
	      return this.props.obfuscate ? this.renderObfuscatedLink() : this.renderLink();
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink() {
	      var _props = this.props;
	      var email = _props.email;
	      var obfuscate = _props.obfuscate;
	      var headers = _props.headers;
	      var children = _props.children;
	
	      var others = _objectWithoutProperties(_props, ['email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({ href: createMailtoLink(email, headers) }, others),
	        children
	      );
	    }
	  }, {
	    key: 'renderObfuscatedLink',
	    value: function renderObfuscatedLink() {
	      var _props2 = this.props;
	      var email = _props2.email;
	      var obfuscate = _props2.obfuscate;
	      var headers = _props2.headers;
	      var children = _props2.children;
	
	      var others = _objectWithoutProperties(_props2, ['email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({ onClick: this.handleClick.bind(this), href: 'mailto:obfuscated' }, others),
	        children
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      var _props3 = this.props;
	      var email = _props3.email;
	      var headers = _props3.headers;
	
	      window.location.href = createMailtoLink(email, headers);
	    }
	  }]);
	
	  return Mailto;
	}(_react.Component);
	
	Mailto.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  email: _react.PropTypes.string.isRequired,
	  headers: _react.PropTypes.object,
	  obfuscate: _react.PropTypes.bool
	};
	
	Mailto.defaultProps = {
	  obfuscate: false
	};
	
	exports.default = Mailto;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(98);
	
	var _Actions = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	  process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var ReactBaseClasses = __webpack_require__(456);
	var ReactChildren = __webpack_require__(1197);
	var ReactDOMFactories = __webpack_require__(1198);
	var ReactElement = __webpack_require__(117);
	var ReactPropTypes = __webpack_require__(1200);
	var ReactVersion = __webpack_require__(1202);
	
	var createReactClass = __webpack_require__(1204);
	var onlyChild = __webpack_require__(1206);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (process.env.NODE_ENV !== 'production') {
	  var lowPriorityWarning = __webpack_require__(306);
	  var canDefineProperty = __webpack_require__(208);
	  var ReactElementValidator = __webpack_require__(458);
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (process.env.NODE_ENV !== 'production') {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (process.env.NODE_ENV !== 'production') {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckboxListContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _formatting = __webpack_require__(21);
	
	var _RhinoCheckbox = __webpack_require__(488);
	
	var _RhinoCheckbox2 = _interopRequireDefault(_RhinoCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var CheckboxList = function (_React$Component) {
	  _inherits(CheckboxList, _React$Component);
	
	  function CheckboxList(props) {
	    _classCallCheck(this, CheckboxList);
	
	    var _this = _possibleConstructorReturn(this, (CheckboxList.__proto__ || Object.getPrototypeOf(CheckboxList)).call(this, props));
	
	    var initValues = [];
	    if (_this.props.initData) {
	      initValues = _this.props.initData;
	    }
	
	    _this.state = {
	      allSelected: initValues.length == 'all',
	      selectedValues: initValues
	    };
	    return _this;
	  }
	
	  _createClass(CheckboxList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	      var initValues = [];
	      if (this.props.initData) {
	        initValues = this.props.initData;
	      }
	
	      this.state = {
	        allSelected: initValues.length == 'all',
	        selectedValues: initValues
	      };
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getSelectAllValue',
	    value: function getSelectAllValue() {
	      var returnArray = [];
	
	      for (var i = 0; i < this.props.checkboxData.length; i++) {
	        returnArray.push(this.props.checkboxData[i].value);
	      }
	      return returnArray;
	    }
	
	    // Depricated since we no longer have combined (color & carat) "Metal Type" filters
	
	  }, {
	    key: 'getDataKeys',
	    value: function getDataKeys(keyVal) {
	      if (keyVal == "METAL_COMPOUND") {
	        return ["metal", "metalcarat"];
	      }if (keyVal == 'cut') {
	        return ['cutMin', 'cutMax'];
	      } else {
	        return [keyVal];
	      }
	    }
	  }, {
	    key: 'getDataValues',
	    value: function getDataValues(dataVal) {
	      if (this.props.dataKey == "METAL_COMPOUND") {
	        return [this.getMetalValues(dataVal), this.getMetalCaratValues(dataVal)];
	      } else {
	        return [dataVal];
	      }
	    }
	  }, {
	    key: 'getMetalValues',
	    value: function getMetalValues(dataStr) {
	      var valArray = dataStr.split(',');
	      var returnArray = [];
	      for (var i = 0; i < valArray.length; i++) {
	        if ((0, _formatting.stringStripNonCaps)(valArray[i]) != '') {
	          returnArray.push((0, _formatting.stringStripNonCaps)(valArray[i]));
	        }
	      }
	      return [].concat(_toConsumableArray(new Set(returnArray))).join(",");
	    }
	  }, {
	    key: 'getMetalCaratValues',
	    value: function getMetalCaratValues(dataStr) {
	      var valArray = dataStr.split(',');
	      var returnArray = [];
	      for (var i = 0; i < valArray.length; i++) {
	        if ((0, _formatting.stringToDigits)(valArray[i]) != '') {
	          returnArray.push((0, _formatting.stringToDigits)(valArray[i]));
	        }
	      }
	      return [].concat(_toConsumableArray(new Set(returnArray))).join(",");
	    }
	  }, {
	    key: 'toggleAll',
	    value: function toggleAll() {
	      var _this2 = this;
	
	      this.setState({
	        allSelected: !this.state.allSelected,
	        selectedValues: !this.state.allSelected === true ? this.getSelectAllValue() : []
	      }, function () {
	        _this2.props.refreshData(_this2.props.productType, _this2.getDataKeys(_this2.props.dataKey), _this2.getDataValues(_this2.state.selectedValues.join(",")));
	      });
	    }
	  }, {
	    key: 'toggleValue',
	    value: function toggleValue(evt) {
	      var _this3 = this;
	
	      var radioValue = evt.target.value;
	      var newValues = [];
	      var shouldInsert = !this.state.selectedValues.includes(radioValue);
	
	      for (var i = 0; i < this.state.selectedValues.length; i++) {
	
	        if (radioValue != this.state.selectedValues[i]) {
	          newValues.push(this.state.selectedValues[i]);
	        }
	      }
	
	      if (shouldInsert) {
	        newValues.push(radioValue);
	      }
	
	      this.setState({
	        selectedValues: newValues
	      }, function () {
	
	        if (_this3.props.dataKey !== 'cut') {
	          if (_this3.state.selectedValues.length == _this3.props.checkboxData.length) {
	            _this3.setState({ allSelected: true }, function () {
	              _this3.props.refreshData(_this3.props.productType, _this3.getDataKeys(_this3.props.dataKey), _this3.getDataValues(_this3.state.selectedValues.join(",")));
	            });
	          } else {
	            _this3.setState({ allSelected: false }, function () {
	              _this3.props.refreshData(_this3.props.productType, _this3.getDataKeys(_this3.props.dataKey), _this3.getDataValues(_this3.state.selectedValues.join(",")));
	            });
	          }
	        } else {
	          var cutMin = _this3.state.selectedValues.includes('VG') ? 'VG' : _this3.state.selectedValues.includes('EX') ? 'EX' : 'VG';
	          var cutMax = _this3.state.selectedValues.includes('EX') ? 'EX' : _this3.state.selectedValues.includes('VG') ? 'VG' : 'EX';
	          _this3.props.refreshData(_this3.props.productType, _this3.getDataKeys(_this3.props.dataKey), [cutMin, cutMax]);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'CheckboxList' },
	        this.props.disclaimer ? _react2.default.createElement(
	          'div',
	          { className: 'checkboxDisclaimer' },
	          this.props.disclaimer
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'checkboxListWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'checkboxItem', style: this.props.disableAll ? { display: 'none' } : {} },
	            _react2.default.createElement(
	              'div',
	              { className: 'boxWrapper' },
	              _react2.default.createElement(_RhinoCheckbox2.default, {
	                changeMethod: this.toggleAll.bind(this),
	                selected: this.state.allSelected })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'itemLabel' },
	              'All ',
	              this.props.label
	            )
	          ),
	          _react2.default.createElement('div', { className: 'checkboxHr', style: this.props.disableAll ? { display: 'none' } : {} }),
	          this.props.checkboxData.map(function (datum, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'checkboxItem', key: i },
	              _react2.default.createElement(
	                'div',
	                { className: 'boxWrapper' },
	                _react2.default.createElement(_RhinoCheckbox2.default, _defineProperty({
	                  changeMethod: _this4.toggleValue.bind(_this4), value: i,
	                  selected: _this4.state.selectedValues.includes(datum.value) || _this4.state.allSelected,
	                  disabled: _this4.props.disabled
	                }, 'value', datum.value))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemLabel' },
	                datum.name
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return CheckboxList;
	}(_react2.default.Component);
	
	CheckboxList.propTypes = {
	  location: _react.PropTypes.object
	};
	CheckboxList.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = CheckboxList;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var CheckboxListContainer = exports.CheckboxListContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(CheckboxList);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NumericSliderContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var NumericSlider = function (_React$Component) {
	  _inherits(NumericSlider, _React$Component);
	
	  function NumericSlider(props) {
	    _classCallCheck(this, NumericSlider);
	
	    // let initMin = this.props.initMinValue;
	    // if(!initMin) {
	    //   initMin = this.props.minValue;
	    // }
	
	    // let initMax = this.props.initMaxValue;
	    // if(!initMax) {
	    //   initMax = this.props.maxValue;
	    // }
	
	    var _this = _possibleConstructorReturn(this, (NumericSlider.__proto__ || Object.getPrototypeOf(NumericSlider)).call(this, props));
	
	    _this.state = {
	
	      scaleType: _this.props.scale,
	      numberFormat: _this.props.format,
	
	      cursorLeftPos: _this.logPosFromValue(_this.props.initMinValue),
	      cursorRightPos: _this.logPosFromValue(_this.props.initMaxValue),
	
	      // minValue: this.props.minValue,
	      // maxValue: this.props.maxValue,
	
	      currentMin: _this.props.initMinValue,
	      currentMax: _this.props.initMaxValue,
	
	      dragActive: false,
	      dragElement: null,
	
	      dragStartTime: 0,
	      checkDelay: 3000,
	      lastMinValue: null,
	      lastMaxValue: null
	
	    };
	
	    // Bind event listeners
	    _this.dragStartLeft = _this.dragStartLeft.bind(_this);
	    _this.dragStartRight = _this.dragStartRight.bind(_this);
	    _this.dragEndAll = _this.dragEndAll.bind(_this);
	    _this.moveSlider = _this.moveSlider.bind(_this);
	
	    _this.checkMovement = _this.checkMovement.bind(_this);
	    return _this;
	  }
	
	  _createClass(NumericSlider, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addClickHandlers(0);
	      var checkId = setInterval(this.checkMovement, 1000);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'checkMovement',
	    value: function checkMovement() {
	      if (this.state.dragActive) {
	
	        if (this.state.currentMin == this.state.lastMinValue && this.state.currentMax == this.state.lastMaxValue && Date.now() - this.state.dragStartTime > this.state.checkDelay) {
	          this.dragEndAll();
	        } else {
	          this.setState({
	            lastMinValue: this.state.currentMin,
	            lastMaxValue: this.state.currentMax
	          });
	        }
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	      this.setState({
	        scaleType: this.props.scale,
	        numberFormat: this.props.format,
	
	        cursorLeftPos: this.logPosFromValue(this.props.minValue),
	        cursorRightPos: this.logPosFromValue(this.props.maxValue),
	
	        // minValue: this.props.minValue,
	        // maxValue: this.props.maxValue,
	
	        currentMin: this.props.minValue,
	        currentMax: this.props.maxValue,
	
	        dragActive: false,
	        dragElement: null
	      });
	    }
	  }, {
	    key: 'addClickHandlers',
	    value: function addClickHandlers() {
	      var _this2 = this;
	
	      if (this.leftHandle && this.rightHandle) {
	
	        // Start methods
	        this.leftHandle.addEventListener('mousedown', this.dragStartLeft, false);
	        this.leftHandle.addEventListener('touchstart', this.dragStartLeft, false);
	
	        this.rightHandle.addEventListener('mousedown', this.dragStartRight, false);
	        this.rightHandle.addEventListener('touchstart', this.dragStartRight, false);
	
	        // End methods
	        window.addEventListener('mouseup', this.dragEndAll, false);
	        this.leftHandle.addEventListener('touchend touchcancel', this.dragEndAll, false);
	
	        window.addEventListener('mousemove', this.moveSlider, false);
	        this.leftHandle.addEventListener('touchmove', this.moveSlider, false);
	
	        // this.rightHandle.addEventListener('mouseup', this.dragEndAll, false);
	        // this.rightHandle.addEventListener('touchend touchcancel', this.dragEndAll, false);
	
	        // this.rightHandle.addEventListener('mousemove', this.moveSlider, false);
	        this.rightHandle.addEventListener('touchmove', this.moveSlider, false);
	
	        // window.addEventListener('mouseup', this.dragEndAll, false);
	        // window.addEventListener('touchend touchcancel', this.dragEndAll, false);
	
	        // window.addEventListener('mousemove', this.moveSlider, false);
	        // window.addEventListener('touchmove', this.moveSlider, false);
	      } else {
	        setTimeout(function () {
	          _this2.addClickHandlers();
	        }, 5);
	      }
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'dragStartLeft',
	    value: function dragStartLeft() {
	      this.setState({
	        dragActive: true,
	        dragStartTime: Date.now(),
	        dragElement: 'left'
	      });
	    }
	  }, {
	    key: 'dragStartRight',
	    value: function dragStartRight() {
	      this.setState({
	        dragActive: true,
	        dragStartTime: Date.now(),
	        dragElement: 'right'
	      });
	    }
	  }, {
	    key: 'dragEndAll',
	    value: function dragEndAll() {
	
	      if (this.state.dragActive) {
	
	        console.log(this.props.service);
	        console.log([this.props.minKey, this.props.maxKey]);
	        console.log([this.state.currentMin, this.state.currentMax]);
	
	        this.props.refreshData(this.props.service, [this.props.minKey, this.props.maxKey], [this.state.currentMin, this.state.currentMax]);
	        this.setState({
	          dragActive: false,
	          dragElement: null
	        });
	      }
	    }
	  }, {
	    key: 'clickContained',
	    value: function clickContained(evt) {
	
	      if (this.state.dragActive) {
	
	        var targetElement = evt.target;
	        do {
	          if (targetElement == this.rootObject) {
	            return true;
	          }
	          targetElement = targetElement.parentNode;
	        } while (targetElement);
	
	        // This is a click outside, should let go 
	        return false;
	      }
	    }
	  }, {
	    key: 'moveSlider',
	    value: function moveSlider(evt) {
	
	      if (this.props.disabled) {
	        return;
	      }
	
	      if (this.state.dragActive) {
	
	        if (this.clickContained(evt) === false) {
	          this.dragEndAll();
	          return;
	        }
	
	        var rootElem = this.rootObject.getBoundingClientRect();
	        var rootLeft = rootElem.left;
	        var rootRight = rootElem.right;
	
	        var leftPercent = this.state.cursorLeftPos;
	        var rightPercent = this.state.cursorRightPos;
	
	        if (this.state.dragElement == 'left') {
	
	          var clientX = 0;
	          if (evt.touches) {
	            clientX = evt.touches[0].clientX;
	          } else {
	            clientX = evt.clientX;
	          }
	          var leftLength = clientX - rootLeft;
	
	          if (leftLength < 0) {
	            var _leftLength = 0.00;
	          } else {
	
	            leftPercent = leftLength / (rootRight - rootLeft);
	            if (leftPercent > rightPercent) {
	              leftPercent = rightPercent;
	            }
	          }
	        }
	
	        if (this.state.dragElement == 'right') {
	
	          var _clientX = 0;
	          if (evt.touches) {
	            _clientX = evt.touches[0].clientX;
	          } else {
	            _clientX = evt.clientX;
	          }
	          var rightLength = rootRight - _clientX;
	
	          if (rightLength < 0) {
	            var _rightLength = 1.00;
	          } else {
	
	            rightPercent = 1 - rightLength / (rootRight - rootLeft);
	            if (rightPercent < leftPercent) {
	              rightPercent = leftPercent;
	            }
	          }
	        }
	
	        var curMin = null;
	        var curMax = null;
	        var valueRange = this.props.maxValue - this.props.minValue;
	
	        if (this.state.scaleType == 'log') {
	
	          if (this.state.numberFormat == 'currency') {
	            curMin = Math.round(this.logslider(leftPercent));
	            curMax = Math.round(this.logslider(rightPercent));
	          } else {
	            curMin = Math.round(this.logslider(leftPercent) * 100) / 100;
	            curMax = Math.round(this.logslider(rightPercent) * 100) / 100;
	          }
	        } else {
	          curMin = Math.round(leftPercent * valueRange + this.props.minValue);
	          curMax = Math.round(rightPercent * valueRange + this.props.minValue);
	        }
	
	        this.setState({
	          cursorLeftPos: leftPercent,
	          cursorRightPos: rightPercent,
	          currentMin: curMin,
	          currentMax: curMax
	        });
	      }
	    }
	  }, {
	    key: 'logslider',
	    value: function logslider(position) {
	
	      var minValue = this.props.minValue;
	      var maxValue = this.props.maxValue;
	
	      if (minValue == 0) {
	        if (position == 0) {
	          return 0;
	        }
	        minValue = minValue + 1;
	      }
	
	      var pos = position * 100;
	
	      // pos will be between 0 and 100
	      var minp = 0;
	      var maxp = 100;
	
	      // The result should be between 100 an 10000000
	      var minv = Math.log(minValue);
	      var maxv = Math.log(maxValue);
	
	      // calculate adjustment factor
	      var scale = (maxv - minv) / (maxp - minp);
	
	      return Math.exp(minv + scale * (pos - minp));
	    }
	  }, {
	    key: 'logPosFromValue',
	    value: function logPosFromValue(val) {
	
	      var minValue = this.props.minValue;
	      var maxValue = this.props.maxValue;
	
	      if (minValue == 0) {
	        if (val == 0) {
	          return 0;
	        }
	        minValue = minValue + 1;
	      }
	
	      // pos will be between 0 and 100
	      var minp = 0;
	      var maxp = 100;
	
	      // The result should be between 100 an 10000000
	      var minv = Math.log(minValue);
	      var maxv = Math.log(maxValue);
	
	      // calculate adjustment factor
	      var scale = (maxv - minv) / (maxp - minp);
	
	      return ((Math.log(val) - minv) / scale + minp) / 100;
	    }
	  }, {
	    key: 'linearPosFromValue',
	    value: function linearPosFromValue(val) {
	
	      var minValue = this.props.minValue;
	      var maxValue = this.props.maxValue;
	
	      if (minValue == 0) {
	        if (val == 0) {
	          return 0;
	        }
	        minValue = minValue + 1;
	      }
	
	      // console.log(minValue);
	      // console.log(maxValue);
	
	      // pos will be between 0 and 100
	      var minp = 0;
	      var maxp = 100;
	
	      var numerator = val - minValue;
	      var denominator = maxValue - minValue;
	
	      return numerator / denominator;
	    }
	  }, {
	    key: 'getLeftBarInlineStyles',
	    value: function getLeftBarInlineStyles() {
	      return {
	        width: Math.round(this.state.cursorLeftPos * 100) + '%'
	      };
	    }
	  }, {
	    key: 'getMiddleBarInlineStyles',
	    value: function getMiddleBarInlineStyles() {
	      return {
	        left: Math.round(this.state.cursorLeftPos * 100) + '%',
	        right: Math.round((1 - this.state.cursorRightPos) * 100) + '%'
	      };
	    }
	  }, {
	    key: 'getRightBarInlineStyles',
	    value: function getRightBarInlineStyles() {
	      return {
	        width: Math.round((1 - this.state.cursorRightPos) * 100) + '%'
	      };
	    }
	  }, {
	    key: 'getLeftDotInlineStyles',
	    value: function getLeftDotInlineStyles() {
	      return {
	        left: Math.round(this.state.cursorLeftPos * 100) + '%'
	      };
	    }
	  }, {
	    key: 'getRightDotInlineStyles',
	    value: function getRightDotInlineStyles() {
	      return {
	        left: Math.round(this.state.cursorRightPos * 100) + '%'
	      };
	    }
	  }, {
	    key: 'changeMinValue',
	    value: function changeMinValue(evt) {
	      var _this3 = this;
	
	      var minVal = evt.target.value;
	
	      this.setState({
	        currentMin: minVal
	      }, function () {
	        if (_this3.state.scaleType == 'log') {
	          _this3.setState({ cursorLeftPos: _this3.withinRange(_this3.logPosFromValue(minVal), 0, _this3.state.cursorRightPos) });
	        } else {
	          _this3.setState({ cursorLeftPos: _this3.withinRange(_this3.linearPosFromValue(minVal), 0, _this3.state.cursorRightPos) });
	        }
	      });
	    }
	  }, {
	    key: 'changeMaxValue',
	    value: function changeMaxValue(evt) {
	      var _this4 = this;
	
	      var maxVal = evt.target.value;
	
	      this.setState({
	        currentMax: maxVal
	      }, function () {
	        if (_this4.state.scaleType == 'log') {
	          _this4.setState({ cursorRightPos: _this4.withinRange(_this4.logPosFromValue(maxVal), _this4.state.cursorLeftPos, 1) });
	        } else {
	          _this4.setState({ cursorRightPos: _this4.withinRange(_this4.linearPosFromValue(maxVal), _this4.state.cursorLeftPos, 1) });
	        }
	      });
	    }
	  }, {
	    key: 'checkMinValue',
	    value: function checkMinValue() {
	      var _this5 = this;
	
	      var minVal = parseFloat(this.state.currentMin);
	
	      if (minVal < parseFloat(this.props.minValue)) {
	        minVal = parseFloat(this.props.minValue);
	      }
	      if (minVal > parseFloat(this.state.currentMax)) {
	        minVal = parseFloat(this.state.currentMax);
	      }
	
	      if (this.props.format == 'currency') {
	        minVal = Math.round(minVal);
	      }
	
	      this.setState({
	        currentMin: minVal
	      }, function () {
	        if (_this5.state.scaleType == 'log') {
	          _this5.setState({ cursorLeftPos: _this5.withinRange(_this5.logPosFromValue(minVal), 0, _this5.state.cursorRightPos) });
	        } else {
	          _this5.setState({ cursorLeftPos: _this5.withinRange(_this5.linearPosFromValue(minVal), 0, _this5.state.cursorRightPos) });
	        }
	
	        _this5.props.refreshData(_this5.props.service, [_this5.props.minKey, _this5.props.maxKey], [_this5.state.currentMin, _this5.state.currentMax]);
	      });
	    }
	  }, {
	    key: 'checkMaxValue',
	    value: function checkMaxValue() {
	      var _this6 = this;
	
	      var maxVal = parseFloat(this.state.currentMax);
	
	      if (maxVal > parseFloat(this.props.maxValue)) {
	        maxVal = parseFloat(this.props.maxValue);
	      }
	      if (maxVal < parseFloat(this.state.currentMin)) {
	        maxVal = parseFloat(this.state.currentMin);
	      }
	
	      if (this.props.format == 'currency') {
	        maxVal = Math.round(maxVal);
	      }
	
	      this.setState({
	        currentMax: maxVal
	      }, function () {
	        if (_this6.state.scaleType == 'log') {
	          _this6.setState({ cursorRightPos: _this6.withinRange(_this6.logPosFromValue(maxVal), _this6.state.cursorLeftPos, 1) });
	        } else {
	          _this6.setState({ cursorRightPos: _this6.withinRange(_this6.linearPosFromValue(maxVal), _this6.state.cursorLeftPos, 1) });
	        }
	
	        _this6.props.refreshData(_this6.props.service, [_this6.props.minKey, _this6.props.maxKey], [_this6.state.currentMin, _this6.state.currentMax]);
	      });
	    }
	  }, {
	    key: 'withinRange',
	    value: function withinRange(val, min, max) {
	      if (val < min) {
	        return min;
	      }
	      if (val > max) {
	        return max;
	      }
	      return val;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'NumericSlider', ref: function ref(div) {
	            _this7.rootObject = div;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'sliderWrapper' },
	          _react2.default.createElement('div', { className: 'leftBar sliderBar', style: this.getLeftBarInlineStyles() }),
	          _react2.default.createElement('div', { className: 'middleBar sliderBar', style: this.getMiddleBarInlineStyles() }),
	          _react2.default.createElement('div', { className: 'rightBar sliderBar', style: this.getRightBarInlineStyles() }),
	          _react2.default.createElement('div', { className: 'rightBarTail sliderBar' }),
	          _react2.default.createElement('div', { className: 'leftDot sliderDot', style: this.getLeftDotInlineStyles(), ref: function ref(div) {
	              _this7.leftHandle = div;
	            } }),
	          _react2.default.createElement('div', { className: 'rightDot sliderDot', style: this.getRightDotInlineStyles(), ref: function ref(div) {
	              _this7.rightHandle = div;
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'inputWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'dashWrapper' },
	            '\u2014'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'minValWrapper' },
	            _react2.default.createElement('input', {
	              type: 'number',
	              value: this.state.currentMin,
	              onChange: this.changeMinValue.bind(this),
	              onBlur: this.checkMinValue.bind(this),
	              min: this.props.minValue,
	              max: this.state.currentMax,
	              step: this.props.increment }),
	            this.props.format == 'currency' ? _react2.default.createElement(
	              'div',
	              { className: 'currencySymbol' },
	              '$'
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'maxValWrapper' },
	            _react2.default.createElement('input', {
	              type: 'number',
	              value: this.state.currentMax,
	              onChange: this.changeMaxValue.bind(this),
	              onBlur: this.checkMaxValue.bind(this),
	              min: this.state.currentMin,
	              max: this.props.maxValue,
	              step: this.props.increment }),
	            this.props.format == 'currency' ? _react2.default.createElement(
	              'div',
	              { className: 'currencySymbol' },
	              '$'
	            ) : null,
	            this.props.hasPlus && parseFloat(this.state.currentMax) == parseFloat(this.props.maxValue) ? _react2.default.createElement(
	              'div',
	              { className: 'plusOverlay' },
	              '+'
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return NumericSlider;
	}(_react2.default.Component);
	
	NumericSlider.propTypes = {
	  location: _react.PropTypes.object
	};
	NumericSlider.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = NumericSlider;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var NumericSliderContainer = exports.NumericSliderContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(NumericSlider);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StyleIconsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var StyleIcons = function (_React$Component) {
	  _inherits(StyleIcons, _React$Component);
	
	  function StyleIcons(props) {
	    _classCallCheck(this, StyleIcons);
	
	    var _this = _possibleConstructorReturn(this, (StyleIcons.__proto__ || Object.getPrototypeOf(StyleIcons)).call(this, props));
	
	    var initData = [];
	    if (_this.props.initData) {
	      initData = _this.props.initData;
	    }
	
	    _this.state = {
	      vintage: initData.includes('vintage'),
	      classic: initData.includes('classic'),
	      contemporary: initData.includes('contemporary')
	    };
	    return _this;
	  }
	
	  _createClass(StyleIcons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	      var initData = [];
	
	      this.setState({
	        vintage: initData.includes('vintage'),
	        classic: initData.includes('classic'),
	        contemporary: initData.includes('contemporary')
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'concatValues',
	    value: function concatValues() {
	      var returnArray = [];
	      for (var key in this.state) {
	        if (this.state[key]) {
	          returnArray.push(key.charAt(0).toUpperCase() + key.slice(1));
	        }
	      }
	      if (returnArray.join(',').length) {
	        return [returnArray.join(',')];
	      } else {
	        return [Object.keys(this.state).join(',')];
	      }
	    }
	  }, {
	    key: 'toggleShapeSelect',
	    value: function toggleShapeSelect(shape) {
	      var _this2 = this;
	
	      if (shape == 'vintage') {
	        this.setState({ vintage: !this.state.vintage }, function () {
	          _this2.props.refreshData(_this2.props.searchType, ['style'], _this2.concatValues());
	        });
	      } else if (shape == 'classic') {
	        this.setState({ classic: !this.state.classic }, function () {
	          _this2.props.refreshData(_this2.props.searchType, ['style'], _this2.concatValues());
	        });
	      } else if (shape == 'contemporary') {
	        this.setState({ contemporary: !this.state.contemporary }, function () {
	          _this2.props.refreshData(_this2.props.searchType, ['style'], _this2.concatValues());
	        });
	      }
	    }
	  }, {
	    key: 'selectAllShapes',
	    value: function selectAllShapes() {
	      var _this3 = this;
	
	      var toggleValue = false;
	      for (var key in this.state) {
	        if (!this.state[key]) {
	          toggleValue = true;
	          break;
	        }
	      }
	
	      this.setState({
	        vintage: toggleValue,
	        classic: toggleValue,
	        contemporary: toggleValue
	      }, function () {
	        _this3.props.refreshData(_this3.props.searchType, ['style'], _this3.concatValues());
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'StyleIcons' },
	        _react2.default.createElement(
	          'div',
	          { className: 'iconsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hiddenLoading' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/vintage_1.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/vintage_a_1.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/classic.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/classic_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/contemporary.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/contemporary_a.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.vintage ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('vintage');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/vintage_1.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/vintage_a_1.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Vintage'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.classic ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('classic');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/classic.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/classic_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Classic'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.contemporary ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('contemporary');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/contemporary.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/style/contemporary_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Contemporary'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'allLinkWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'allLink', onClick: this.selectAllShapes.bind(this) },
	            'All'
	          )
	        )
	      );
	    }
	  }]);
	
	  return StyleIcons;
	}(_react2.default.Component);
	
	StyleIcons.propTypes = {
	  location: _react.PropTypes.object
	};
	StyleIcons.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = StyleIcons;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var StyleIconsContainer = exports.StyleIconsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(StyleIcons);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValuesSliderContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var ValuesSlider = function (_React$Component) {
	  _inherits(ValuesSlider, _React$Component);
	
	  function ValuesSlider(props) {
	    _classCallCheck(this, ValuesSlider);
	
	    var _this = _possibleConstructorReturn(this, (ValuesSlider.__proto__ || Object.getPrototypeOf(ValuesSlider)).call(this, props));
	
	    var initMin = _this.props.initMin && _this.props.valuesData.includes(_this.props.initMin) ? _this.props.initMin : _this.props.valuesData[0];
	    var initMax = _this.props.initMax && _this.props.valuesData.includes(_this.props.initMax) ? _this.props.initMax : _this.props.valuesData[_this.props.valuesData.length - 1];
	
	    var initMinPos = 0.00;
	    var initMaxPos = 1.00;
	
	    if (_this.props.initMin && _this.props.valuesData.indexOf(_this.props.initMin) >= 0) {
	      initMinPos = _this.props.valuesData.indexOf(_this.props.initMin) / (_this.props.valuesData.length - 1);
	    }
	
	    if (_this.props.initMax && _this.props.valuesData.indexOf(_this.props.initMax) >= 0) {
	      initMaxPos = _this.props.valuesData.indexOf(_this.props.initMax) / (_this.props.valuesData.length - 1);
	    }
	
	    _this.state = {
	
	      scaleType: _this.props.scale,
	      numberFormat: _this.props.format,
	
	      cursorLeftPos: _this.getClosestPosition(initMinPos),
	      cursorRightPos: _this.getClosestPosition(initMaxPos),
	
	      currentMin: initMin,
	      currentMax: initMax,
	
	      dragActive: false,
	      dragElement: null,
	
	      inputWidth: _this.props.inputWidth ? _this.props.inputWidth : '80px'
	    };
	
	    // Bind event listeners
	    _this.dragStartLeft = _this.dragStartLeft.bind(_this);
	    _this.dragStartRight = _this.dragStartRight.bind(_this);
	    _this.dragEndAll = _this.dragEndAll.bind(_this);
	    _this.moveSlider = _this.moveSlider.bind(_this);
	    return _this;
	  }
	
	  _createClass(ValuesSlider, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addClickHandlers(0);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	      this.setState({
	        scaleType: this.props.scale,
	        numberFormat: this.props.format,
	
	        cursorLeftPos: 0.00,
	        cursorRightPos: 1.00,
	
	        currentMin: this.props.valuesData[0],
	        currentMax: this.props.valuesData[this.props.valuesData.length - 1],
	
	        dragActive: false,
	        dragElement: null,
	
	        inputWidth: this.props.inputWidth ? this.props.inputWidth : '80px'
	      });
	    }
	  }, {
	    key: 'addClickHandlers',
	    value: function addClickHandlers() {
	      var _this2 = this;
	
	      if (this.leftHandle && this.rightHandle) {
	
	        this.leftHandle.addEventListener('mousedown', this.dragStartLeft, false);
	        this.leftHandle.addEventListener('touchstart', this.dragStartLeft, false);
	
	        this.rightHandle.addEventListener('mousedown', this.dragStartRight, false);
	        this.rightHandle.addEventListener('touchstart', this.dragStartRight, false);
	
	        // window.addEventListener('mouseup', this.dragEndAll, false);
	        // window.addEventListener('touchend touchcancel', this.dragEndAll, false);
	
	        // window.addEventListener('mousemove', this.moveSlider, false);
	        // window.addEventListener('touchmove', this.moveSlider, false);
	
	        // End methods
	        window.addEventListener('mouseup', this.dragEndAll, false);
	        this.leftHandle.addEventListener('touchend touchcancel', this.dragEndAll, false);
	
	        window.addEventListener('mousemove', this.moveSlider, false);
	        this.leftHandle.addEventListener('touchmove', this.moveSlider, false);
	
	        this.rightHandle.addEventListener('touchend touchcancel', this.dragEndAll, false);
	        this.rightHandle.addEventListener('touchmove', this.moveSlider, false);
	      } else {
	        setTimeout(function () {
	          _this2.addClickHandlers();
	        }, 5);
	      }
	    }
	  }, {
	    key: 'dragStartLeft',
	    value: function dragStartLeft() {
	
	      if (this.props.disabled) {
	        return;
	      }
	
	      this.setState({
	        dragActive: true,
	        dragElement: 'left'
	      });
	    }
	  }, {
	    key: 'dragStartRight',
	    value: function dragStartRight() {
	
	      if (this.props.disabled) {
	        return;
	      }
	
	      this.setState({
	        dragActive: true,
	        dragElement: 'right'
	      });
	    }
	  }, {
	    key: 'dragEndAll',
	    value: function dragEndAll() {
	
	      if (this.state.dragActive) {
	        if (this.props.translations) {
	          this.props.refreshData(this.props.service, [this.props.minKey, this.props.maxKey], [this.props.translations[this.state.currentMin], this.props.translations[this.state.currentMax]]);
	        } else {
	          this.props.refreshData(this.props.service, [this.props.minKey, this.props.maxKey], [this.state.currentMin, this.state.currentMax]);
	        }
	
	        this.setState({
	          dragActive: false,
	          dragElement: null
	        });
	      }
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getStepSize',
	    value: function getStepSize() {
	      return this.props.valuesData && this.props.valuesData.length > 1 ? 1.0 / (this.props.valuesData.length - 1) : 1.0;
	    }
	  }, {
	    key: 'clickContained',
	    value: function clickContained(evt) {
	
	      if (this.state.dragActive) {
	
	        var targetElement = evt.target;
	        do {
	          if (targetElement == this.rootObject) {
	            return true;
	          }
	          targetElement = targetElement.parentNode;
	        } while (targetElement);
	
	        // This is a click outside, should let go 
	        return false;
	      }
	    }
	  }, {
	    key: 'moveSlider',
	    value: function moveSlider(evt) {
	
	      if (this.props.disabled) {
	        return;
	      }
	
	      if (this.state.dragActive) {
	
	        if (this.clickContained(evt) === false) {
	          this.dragEndAll();
	          return;
	        }
	
	        var rootElem = this.rootObject.getBoundingClientRect();
	        var rootLeft = rootElem.left;
	        var rootRight = rootElem.right;
	
	        var leftPercent = this.state.cursorLeftPos;
	        var rightPercent = this.state.cursorRightPos;
	
	        if (this.state.dragElement == 'left') {
	
	          var clientX = 0;
	          if (evt.touches) {
	            clientX = evt.touches[0].clientX;
	          } else {
	            clientX = evt.clientX;
	          }
	          var leftLength = clientX - rootLeft;
	
	          if (leftLength < 0) {
	            var _leftLength = 0.00;
	          } else {
	
	            leftPercent = leftLength / (rootRight - rootLeft);
	            if (leftPercent > rightPercent) {
	              leftPercent = rightPercent;
	            }
	          }
	        }
	
	        if (this.state.dragElement == 'right') {
	
	          var _clientX = 0;
	          if (evt.touches) {
	            _clientX = evt.touches[0].clientX;
	          } else {
	            _clientX = evt.clientX;
	          }
	          var rightLength = rootRight - _clientX;
	
	          if (rightLength < 0) {
	            var _rightLength = 1.00;
	          } else {
	
	            rightPercent = 1 - rightLength / (rootRight - rootLeft);
	            if (rightPercent < leftPercent) {
	              rightPercent = leftPercent;
	            }
	          }
	        }
	
	        var stepSize = this.getStepSize();
	        // console.log(stepSize);
	
	        // let curMin = null;
	        // let curMax = null;
	        // let valueRange = this.state.maxValue - this.state.minValue;
	
	        // curMin = Math.round(leftPercent * valueRange + this.state.minValue);
	        // curMax = Math.round(rightPercent * valueRange + this.state.minValue);
	
	        var lPos = this.getClosestPosition(leftPercent);
	        var rPos = this.getClosestPosition(rightPercent);
	
	        this.setState({
	          cursorLeftPos: lPos,
	          cursorRightPos: rPos,
	          currentMin: this.props.valuesData[Math.round(lPos / stepSize)],
	          currentMax: this.props.valuesData[Math.round(rPos / stepSize)]
	        });
	      }
	    }
	  }, {
	    key: 'getClosestPosition',
	    value: function getClosestPosition(posPercent) {
	
	      var stepSize = this.getStepSize();
	      var stepList = [];
	
	      for (var i = 0; i < this.props.valuesData.length; i++) {
	        stepList.push(i * stepSize);
	      }
	      var closest = stepList.reduce(function (prev, curr) {
	        return Math.abs(curr - posPercent) < Math.abs(prev - posPercent) ? curr : prev;
	      });
	
	      return closest;
	    }
	  }, {
	    key: 'getLeftBarInlineStyles',
	    value: function getLeftBarInlineStyles() {
	      return {
	        width: Math.round(this.state.cursorLeftPos * 100) + '%'
	      };
	    }
	  }, {
	    key: 'getMiddleBarInlineStyles',
	    value: function getMiddleBarInlineStyles() {
	      return {
	        left: Math.round(this.state.cursorLeftPos * 100) + '%',
	        right: Math.round((1 - this.state.cursorRightPos) * 100) + '%'
	      };
	    }
	  }, {
	    key: 'getRightBarInlineStyles',
	    value: function getRightBarInlineStyles() {
	      return {
	        width: Math.round((1 - this.state.cursorRightPos) * 100) + '%'
	      };
	    }
	  }, {
	    key: 'getLeftDotInlineStyles',
	    value: function getLeftDotInlineStyles() {
	      return {
	        left: Math.round(this.state.cursorLeftPos * 100) + '%'
	      };
	    }
	  }, {
	    key: 'getRightDotInlineStyles',
	    value: function getRightDotInlineStyles() {
	      return {
	        left: Math.round(this.state.cursorRightPos * 100) + '%'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.disabled ? 'ValuesSlider disabled' : 'ValuesSlider', ref: function ref(div) {
	            _this3.rootObject = div;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'sliderWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ticWrapper' },
	            this.props.valuesData.map(function (val, i) {
	              return _react2.default.createElement('div', { className: 'ticElement', style: { left: String(i * _this3.getStepSize() * 100 + '%') }, key: i });
	            })
	          ),
	          _react2.default.createElement('div', { className: 'leftBar sliderBar', style: this.getLeftBarInlineStyles() }),
	          _react2.default.createElement('div', { className: 'middleBar sliderBar', style: this.getMiddleBarInlineStyles() }),
	          _react2.default.createElement('div', { className: 'rightBar sliderBar', style: this.getRightBarInlineStyles() }),
	          _react2.default.createElement('div', { className: 'rightBarTail sliderBar' }),
	          _react2.default.createElement('div', { className: 'leftDot sliderDot', style: this.getLeftDotInlineStyles(), ref: function ref(div) {
	              _this3.leftHandle = div;
	            } }),
	          _react2.default.createElement('div', { className: 'rightDot sliderDot', style: this.getRightDotInlineStyles(), ref: function ref(div) {
	              _this3.rightHandle = div;
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'inputWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'dashWrapper' },
	            '\u2014'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'minValWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'minValData', style: { width: this.state.inputWidth } },
	              this.state.currentMin
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'maxValWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'maxValData', style: { width: this.state.inputWidth } },
	              this.state.currentMax
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ValuesSlider;
	}(_react2.default.Component);
	
	ValuesSlider.propTypes = {
	  location: _react.PropTypes.object
	};
	ValuesSlider.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ValuesSlider;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ValuesSliderContainer = exports.ValuesSliderContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ValuesSlider);

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var limitedSizes = exports.limitedSizes = [{
		display: '5.50',
		value: '5.50'
	}, {
		display: '5.75',
		value: '5.75'
	}, {
		display: '6.00',
		value: '6.00'
	}, {
		display: '6.25',
		value: '6.25'
	}, {
		display: '6.50',
		value: '6.50'
	}, {
		display: '6.75',
		value: '6.75'
	}, {
		display: '7.00',
		value: '7.00'
	}, {
		display: '7.25',
		value: '7.25'
	}, {
		display: '7.50',
		value: '7.50'
	}];
	
	var eternitySizes = exports.eternitySizes = [{
		display: '4.00',
		value: '4.00'
	}, {
		display: '4.50',
		value: '4.50'
	}, {
		display: '5.00',
		value: '5.00'
	}, {
		display: '5.50',
		value: '5.50'
	}, {
		display: '6.00',
		value: '6.00'
	}, {
		display: '6.50',
		value: '6.50'
	}, {
		display: '7.00',
		value: '7.00'
	}, {
		display: '7.50',
		value: '7.50'
	}];
	
	var ringSizes = exports.ringSizes = [{
		display: '3.00',
		value: '3.00'
	}, {
		display: '3.25',
		value: '3.25'
	}, {
		display: '3.50',
		value: '3.50'
	}, {
		display: '3.75',
		value: '3.75'
	}, {
		display: '4.00',
		value: '4.00'
	}, {
		display: '4.25',
		value: '4.25'
	}, {
		display: '4.50',
		value: '4.50'
	}, {
		display: '4.75',
		value: '4.75'
	}, {
		display: '5.00',
		value: '5.00'
	}, {
		display: '5.25',
		value: '5.25'
	}, {
		display: '5.50',
		value: '5.50'
	}, {
		display: '5.75',
		value: '5.75'
	}, {
		display: '6.00',
		value: '6.00'
	}, {
		display: '6.25',
		value: '6.25'
	}, {
		display: '6.50',
		value: '6.50'
	}, {
		display: '6.75',
		value: '6.75'
	}, {
		display: '7.00',
		value: '7.00'
	}, {
		display: '7.25',
		value: '7.25'
	}, {
		display: '7.50',
		value: '7.50'
	}, {
		display: '7.75',
		value: '7.75'
	}, {
		display: '8.00',
		value: '8.00'
	}, {
		display: '8.25',
		value: '8.25'
	}, {
		display: '8.50',
		value: '8.50'
	}, {
		display: '8.75',
		value: '8.75'
	}, {
		display: '9.00',
		value: '9.00'
	}, {
		display: '9.25',
		value: '9.25'
	}, {
		display: '9.50',
		value: '9.50'
	}, {
		display: '9.75',
		value: '9.75'
	}, {
		display: '10.00',
		value: '10.00'
	}, {
		display: '10.25',
		value: '10.25'
	}, {
		display: '10.50',
		value: '10.50'
	}, {
		display: '10.75',
		value: '10.75'
	}, {
		display: '11.00',
		value: '11.00'
	}, {
		display: '11.25',
		value: '11.25'
	}, {
		display: '11.50',
		value: '11.50'
	}, {
		display: '11.75',
		value: '11.75'
	}, {
		display: '12.00',
		value: '12.00'
	}, {
		display: '12.25',
		value: '12.25'
	}, {
		display: '12.50',
		value: '12.50'
	}, {
		display: '12.75',
		value: '12.75'
	}, {
		display: '13.00',
		value: '13.00'
	}, {
		display: '13.25',
		value: '13.25'
	}, {
		display: '13.50',
		value: '13.50'
	}, {
		display: '13.75',
		value: '13.75'
	}, {
		display: '14.00',
		value: '14.00'
	}];
	
	var ringSizesMen = exports.ringSizesMen = [{
		display: '7.00',
		value: '7.00'
	}, {
		display: '7.25',
		value: '7.25'
	}, {
		display: '7.50',
		value: '7.50'
	}, {
		display: '7.75',
		value: '7.75'
	}, {
		display: '8.00',
		value: '8.00'
	}, {
		display: '8.25',
		value: '8.25'
	}, {
		display: '8.50',
		value: '8.50'
	}, {
		display: '8.75',
		value: '8.75'
	}, {
		display: '9.00',
		value: '9.00'
	}, {
		display: '9.25',
		value: '9.25'
	}, {
		display: '9.50',
		value: '9.50'
	}, {
		display: '9.75',
		value: '9.75'
	}, {
		display: '10.00',
		value: '10.00'
	}, {
		display: '10.25',
		value: '10.25'
	}, {
		display: '10.50',
		value: '10.50'
	}, {
		display: '10.75',
		value: '10.75'
	}, {
		display: '11.00',
		value: '11.00'
	}, {
		display: '11.25',
		value: '11.25'
	}, {
		display: '11.50',
		value: '11.50'
	}, {
		display: '11.75',
		value: '11.75'
	}, {
		display: '12.00',
		value: '12.00'
	}, {
		display: '12.25',
		value: '12.25'
	}, {
		display: '12.50',
		value: '12.50'
	}, {
		display: '12.75',
		value: '12.75'
	}, {
		display: '13.00',
		value: '13.00'
	}];
	
	var ringSizesWomen = exports.ringSizesWomen = [{
		display: '4.00',
		value: '4.00'
	}, {
		display: '4.25',
		value: '4.25'
	}, {
		display: '4.50',
		value: '4.50'
	}, {
		display: '4.75',
		value: '4.75'
	}, {
		display: '5.00',
		value: '5.00'
	}, {
		display: '5.25',
		value: '5.25'
	}, {
		display: '5.50',
		value: '5.50'
	}, {
		display: '5.75',
		value: '5.75'
	}, {
		display: '6.00',
		value: '6.00'
	}, {
		display: '6.25',
		value: '6.25'
	}, {
		display: '6.50',
		value: '6.50'
	}, {
		display: '6.75',
		value: '6.75'
	}, {
		display: '7.00',
		value: '7.00'
	}, {
		display: '7.25',
		value: '7.25'
	}, {
		display: '7.50',
		value: '7.50'
	}, {
		display: '7.75',
		value: '7.75'
	}, {
		display: '8.00',
		value: '8.00'
	}, {
		display: '8.25',
		value: '8.25'
	}, {
		display: '8.50',
		value: '8.50'
	}, {
		display: '8.75',
		value: '8.75'
	}, {
		display: '9.00',
		value: '9.00'
	}, {
		display: '9.25',
		value: '9.25'
	}, {
		display: '9.50',
		value: '9.50'
	}, {
		display: '9.75',
		value: '9.75'
	}, {
		display: '10.00',
		value: '10.00'
	}];
	
	var ringFingers = exports.ringFingers = [{
		display: 'Left index',
		value: 'Left index'
	}, {
		display: 'Left middle',
		value: 'Left middle'
	}, {
		display: 'Left ring',
		value: 'Left ring'
	}, {
		display: 'Left pinky',
		value: 'Left pinky'
	}, {
		display: 'Left thumb',
		value: 'Left thumb'
	}, {
		display: 'Right index',
		value: 'Right index'
	}, {
		display: 'Right middle',
		value: 'Right middle'
	}, {
		display: 'Right ring',
		value: 'Right ring'
	}, {
		display: 'Right pinky',
		value: 'Right pinky'
	}, {
		display: 'Right thumb',
		value: 'Right thumb'
	}];

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(322);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(335);
	var enumBugKeys = __webpack_require__(228);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(16);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(66);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(67);
	var global = __webpack_require__(20);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(94) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(16);
	var aFunction = __webpack_require__(44);
	var SPECIES = __webpack_require__(27)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(1021);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addHours = addHours;
	exports.addMinutes = addMinutes;
	exports.addSeconds = addSeconds;
	exports.formatTime = formatTime;
	exports.rad2deg = rad2deg;
	exports.getTouchEventOffsetValues = getTouchEventOffsetValues;
	exports.isInner = isInner;
	function addHours(d, hours) {
	  var newDate = clone(d);
	  newDate.setHours(d.getHours() + hours);
	  return newDate;
	}
	
	function addMinutes(d, minutes) {
	  var newDate = clone(d);
	  newDate.setMinutes(d.getMinutes() + minutes);
	  return newDate;
	}
	
	function addSeconds(d, seconds) {
	  var newDate = clone(d);
	  newDate.setSeconds(d.getMinutes() + seconds);
	  return newDate;
	}
	
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * @param date [Date] A Date object.
	 * @param format [String] One of 'ampm', '24hr', defaults to 'ampm'.
	 * @param pedantic [Boolean] Check time-picker/time-picker.jsx file.
	 *
	 * @return String A string representing the formatted time.
	 */
	function formatTime(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ampm';
	  var pedantic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!date) return '';
	  var hours = date.getHours();
	  var mins = date.getMinutes().toString();
	
	  if (format === 'ampm') {
	    var isAM = hours < 12;
	    hours = hours % 12;
	    var additional = isAM ? ' am' : ' pm';
	    hours = (hours || 12).toString();
	
	    if (mins.length < 2) mins = '0' + mins;
	
	    if (pedantic) {
	      // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
	      if (hours === '12' && mins === '00') {
	        return additional === ' pm' ? '12 noon' : '12 midnight';
	      }
	    }
	
	    return hours + (mins === '00' ? '' : ':' + mins) + additional;
	  }
	
	  hours = hours.toString();
	
	  if (hours.length < 2) hours = '0' + hours;
	  if (mins.length < 2) mins = '0' + mins;
	
	  return hours + ':' + mins;
	}
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(event) {
	  var el = event.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  return {
	    offsetX: event.clientX - boundingRect.left,
	    offsetY: event.clientY - boundingRect.top
	  };
	}
	
	function isInner(props) {
	  if (props.type !== 'hour') {
	    return false;
	  }
	  return props.value < 1 || props.value > 12;
	}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createChildFragment = createChildFragment;
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCreateFragment = __webpack_require__(1076);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createChildFragment(fragments) {
	  var newFragments = {};
	  var validChildrenCount = 0;
	  var firstKey = void 0;
	
	  // Only create non-empty key fragments
	  for (var key in fragments) {
	    var currentChild = fragments[key];
	
	    if (currentChild) {
	      if (validChildrenCount === 0) firstKey = key;
	      newFragments[key] = currentChild;
	      validChildrenCount++;
	    }
	  }
	
	  if (validChildrenCount === 0) return undefined;
	  if (validChildrenCount === 1) return newFragments[firstKey];
	  return (0, _reactAddonsCreateFragment2.default)(newFragments);
	}
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  });
	}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(1193);


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (process.env.NODE_ENV === 'production') {
	  module.exports = __webpack_require__(1153);
	} else {
	  module.exports = __webpack_require__(1152);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(46);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authSave = authSave;
	exports.authClear = authClear;
	exports.authLogin = authLogin;
	exports.authRegister = authRegister;
	
	__webpack_require__(148);
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	var _endpoints = __webpack_require__(122);
	
	var endpoint = _interopRequireWildcard(_endpoints);
	
	var _api = __webpack_require__(121);
	
	var api = _interopRequireWildcard(_api);
	
	var _request = __webpack_require__(123);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/******************************
	*******  Synchronous  *********
	******************************/
	
	function authSave(token, tokenExpiry) {
	  return {
	    type: constants.AUTH_SAVE,
	    token: token,
	    tokenExpiry: tokenExpiry
	  };
	}
	
	// // Exists outside auth reducer in root reducer
	function authClear() {
	  return {
	    type: constants.AUTH_CLEAR
	  };
	}
	
	/******************************
	*******  Asynchronous  ********
	******************************/
	
	function authLogin(username, password) {
	  return function (dispatch) {
	
	    var authData = {
	      username: username,
	      password: password
	    };
	
	    var url = api.MAGENTO_API + endpoint.MAGENTO_LOGIN;
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(authData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}
	
	function authRegister(registerData) {
	  return function (dispatch) {
	
	    var url = api.MAGENTO_API + endpoint.MAGENTO_REGISTER;
	    return fetch(url, {
	      method: 'post',
	      headers: api.HEADERS,
	      body: JSON.stringify(registerData)
	    }).then(_request.parseJSON).then(function (resp) {
	      if ((0, _request.isOk)(resp.status)) {
	        return Promise.resolve(resp.data);
	      } else {
	        return Promise.reject(resp.data);
	      }
	    });
	  };
	}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.put = put;
	exports.get = get;
	exports.remove = remove;
	exports.clear = clear;
	function put(key, value) {
		return window.localStorage.setItem(key, value);
	}
	
	function get(key) {
		return window.localStorage.getItem(key);
	}
	
	function remove(key) {
		return window.localStorage.removeItem(key);
	}
	
	function clear() {
		window.localStorage.clear();
	}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(669)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(331)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(60);
	var toLength = __webpack_require__(29);
	var toAbsoluteIndex = __webpack_require__(111);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(20);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(50);
	var redefineAll = __webpack_require__(109);
	var meta = __webpack_require__(95);
	var forOf = __webpack_require__(104);
	var anInstance = __webpack_require__(103);
	var isObject = __webpack_require__(24);
	var fails = __webpack_require__(22);
	var $iterDetect = __webpack_require__(182);
	var setToStringTag = __webpack_require__(132);
	var inheritIfRequired = __webpack_require__(247);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(372);
	var redefine = __webpack_require__(50);
	var hide = __webpack_require__(49);
	var fails = __webpack_require__(22);
	var defined = __webpack_require__(76);
	var wks = __webpack_require__(27);
	var regexpExec = __webpack_require__(255);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(66);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(24);
	var cof = __webpack_require__(66);
	var MATCH = __webpack_require__(27)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(27)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(94) || !__webpack_require__(22)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(20)[K];
	});


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(130);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(44);
	var ctx = __webpack_require__(68);
	var forOf = __webpack_require__(104);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(4);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(70);
	var defined = __webpack_require__(76);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(20);
	var hide = __webpack_require__(49);
	var uid = __webpack_require__(112);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(20);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (process.env.NODE_ENV !== 'production') {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(977);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toArray2 = __webpack_require__(326);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(118);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(278);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(272);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _menuUtils = __webpack_require__(991);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var desktop = props.desktop,
	      maxHeight = props.maxHeight,
	      width = props.width;
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div bacause the List scales x faster than it scales y
	      zIndex: muiTheme.zIndex.menu,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    selectedMenuItem: {
	      color: muiTheme.menuItem.selectedTextColor
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu(props, context) {
	    (0, _classCallCheck3.default)(this, Menu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getSelectedIndex(props, filteredChildren);
	
	    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
	      props.onMenuItemFocusChange(null, newFocusIndex);
	    }
	    _this.state = {
	      focusIndex: newFocusIndex,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	      var selectedIndex = this.getSelectedIndex(nextProps, filteredChildren);
	
	      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
	        this.props.onMenuItemFocusChange(null, newFocusIndex);
	      }
	      this.setState({
	        focusIndex: newFocusIndex,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var _props = this.props,
	          desktop = _props.desktop,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle;
	
	
	      var selected = this.isChildSelected(child, this.props);
	      var selectedChildrenStyles = {};
	
	      if (selected) {
	        selectedChildrenStyles = (0, _simpleAssign2.default)(styles.selectedMenuItem, selectedMenuItemStyle);
	      }
	
	      var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, menuItemStyle, selectedChildrenStyles);
	
	      var isFocused = childIndex === this.state.focusIndex;
	      var focusState = 'none';
	      if (isFocused) {
	        focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	      }
	
	      return _react2.default.cloneElement(child, {
	        desktop: desktop,
	        focusState: focusState,
	        onTouchTap: function onTouchTap(event) {
	          _this2.handleMenuItemTouchTap(event, child, index);
	          if (child.props.onTouchTap) child.props.onTouchTap(event);
	        },
	        ref: isFocused ? 'focusedMenuItem' : null,
	        style: mergedChildrenStyles
	      });
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex(event) {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(event, keys) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(this.props.children, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && new RegExp('^' + keys, 'i').test(primaryText)) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(event, foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemTouchTap',
	    value: function handleMenuItemTouchTap(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(event, focusIndex, false);
	
	      if (multiple) {
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = (0, _toArray3.default)(menuValue),
	            newMenuValue = _menuValue;
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemTouchTap(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
	      if (this.props.onMenuItemFocusChange) {
	        // Do this even if `newIndex === this.state.focusIndex` to allow users
	        // to detect up-arrow on the first MenuItem or down-arrow on the last.
	        this.props.onMenuItemFocusChange(event, newIndex);
	      }
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'cancelScrollEvent',
	    value: function cancelScrollEvent(event) {
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          autoWidth = _props2.autoWidth,
	          children = _props2.children,
	          desktop = _props2.desktop,
	          disableAutoFocus = _props2.disableAutoFocus,
	          initiallyKeyboardFocused = _props2.initiallyKeyboardFocused,
	          listStyle = _props2.listStyle,
	          maxHeight = _props2.maxHeight,
	          multiple = _props2.multiple,
	          onItemTouchTap = _props2.onItemTouchTap,
	          onEscKeyDown = _props2.onEscKeyDown,
	          onMenuItemFocusChange = _props2.onMenuItemFocusChange,
	          selectedMenuItemStyle = _props2.selectedMenuItemStyle,
	          menuItemStyle = _props2.menuItemStyle,
	          style = _props2.style,
	          value = _props2.value,
	          valueLink = _props2.valueLink,
	          width = _props2.width,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemTouchTap', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var filteredChildren = this.getFilteredChildren(children);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsDisabled = child.props.disabled;
	        var childName = child.type ? child.type.muiName : '';
	        var newChild = child;
	
	        switch (childName) {
	          case 'MenuItem':
	            newChild = childIsDisabled ? _react2.default.cloneElement(child, { desktop: desktop }) : _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	            break;
	
	          case 'Divider':
	            newChild = _react2.default.cloneElement(child, {
	              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
	            });
	            break;
	        }
	
	        if (childName === 'MenuItem' && !childIsDisabled) {
	          menuItemIndex++;
	        }
	
	        return newChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            onWheel: this.handleOnWheel,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            (0, _extends3.default)({}, other, {
	              ref: 'list',
	              style: mergedListStyles
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    _this5.setFocusIndex(event, -1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex(event);
	        } else {
	          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex(event);
	        break;
	      default:
	        if (key && key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(event, hotKeys)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	
	  this.handleOnWheel = function (event) {
	    var scrollContainer = _this5.refs.scrollContainer;
	    // Only scroll lock if the the Menu is scrollable.
	    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;
	
	    var scrollTop = scrollContainer.scrollTop,
	        scrollHeight = scrollContainer.scrollHeight,
	        clientHeight = scrollContainer.clientHeight;
	
	    var wheelDelta = event.deltaY;
	    var isDeltaPositive = wheelDelta > 0;
	
	    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
	      scrollContainer.scrollTop = scrollHeight;
	      return _this5.cancelScrollEvent(event);
	    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	      scrollContainer.scrollTop = 0;
	      return _this5.cancelScrollEvent(event);
	    }
	  };
	};
	
	process.env.NODE_ENV !== "production" ? Menu.propTypes = {
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _react.PropTypes.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function fired when the focus on a `MenuItem` is changed.
	   * There will be some "duplicate" changes reported if two different
	   * focusing event happen, for example if a `MenuItem` is focused via
	   * the keyboard and then it is clicked on.
	   *
	   * @param {object} event The event that triggered the focus change.
	   * The event can be null since the focus can be changed for non-event
	   * reasons such as prop changes.
	   * @param {number} newFocusIndex The index of the newly focused
	   * `MenuItem` or `-1` if focus was lost.
	   */
	  onMenuItemFocusChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _react.PropTypes.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes2.default.stringOrNumber
	} : void 0;
	exports.default = Menu;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableRowColumn = context.muiTheme.tableRowColumn;
	
	
	  var styles = {
	    root: {
	      paddingLeft: tableRowColumn.spacing,
	      paddingRight: tableRowColumn.spacing,
	      height: tableRowColumn.height,
	      textAlign: 'left',
	      fontSize: 13,
	      overflow: 'hidden',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis'
	    }
	  };
	
	  if (_react2.default.Children.count(props.children) === 1 && !isNaN(props.children)) {
	    styles.textAlign = 'right';
	  }
	
	  return styles;
	}
	
	var TableRowColumn = function (_Component) {
	  (0, _inherits3.default)(TableRowColumn, _Component);
	
	  function TableRowColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRowColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRowColumn.__proto__ || (0, _getPrototypeOf2.default)(TableRowColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _this.onMouseEnter = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onHover) {
	          _this.props.onHover(event, _this.props.columnNumber);
	        }
	      }
	    }, _this.onMouseLeave = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onHoverExit) {
	          _this.props.onHoverExit(event, _this.props.columnNumber);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRowColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onClick: this.onClick,
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave
	      };
	
	      return _react2.default.createElement(
	        'td',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        children
	      );
	    }
	  }]);
	  return TableRowColumn;
	}(_react.Component);
	
	TableRowColumn.defaultProps = {
	  hoverable: false
	};
	TableRowColumn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TableRowColumn.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * @ignore
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _react.PropTypes.number,
	  /**
	   * @ignore
	   * If true, this column responds to hover events.
	   */
	  hoverable: _react.PropTypes.bool,
	  /** @ignore */
	  onClick: _react.PropTypes.func,
	  /** @ignore */
	  onHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Callback function for hover exit event.
	   */
	  onHoverExit: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableRowColumn;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (process.env.NODE_ENV !== 'production') {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames: process.env.NODE_ENV !== 'production' ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactErrorUtils = __webpack_require__(288);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (process.env.NODE_ENV !== 'production') {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (process.env.NODE_ENV !== 'production') {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (process.env.NODE_ENV !== 'production') {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (process.env.NODE_ENV !== 'production') {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var EventPluginRegistry = __webpack_require__(198);
	var ReactEventEmitterMixin = __webpack_require__(1110);
	var ViewportMetrics = __webpack_require__(290);
	
	var getVendorPrefixedEventName = __webpack_require__(1145);
	var isEventSupported = __webpack_require__(295);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(141);
	var ViewportMetrics = __webpack_require__(290);
	
	var getEventModifierState = __webpack_require__(293);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	var DOMNamespaces = __webpack_require__(284);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(291);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	  return onDemandSlides;
	};
	
	// return list of slides that need to be present
	var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	  return requiredSlides;
	};
	
	// startIndex that needs to be present
	var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	};
	
	// get width of an element
	var getWidth = exports.getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	var getHeight = exports.getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	};
	
	// whether or not we can go next
	var canGoNext = exports.canGoNext = function canGoNext(spec) {
	  var canGo = true;
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	  return canGo;
	};
	
	// given an object and a list of keys, return new object with given keys
	var extractObject = exports.extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	};
	
	// get initialized state
	var initializedState = exports.initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react2.default.Children.count(spec.children);
	  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
	  var slideWidth = void 0;
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	var slideHandler = exports.slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide = void 0,
	      animationLeft = void 0,
	      finalLeft = void 0;
	  var state = {},
	      nextState = {};
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = { animating: false };
	  } else {
	    finalSlide = animationSlide;
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
	    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        swipeLeft: null
	      };
	    }
	  }
	  return { state: state, nextState: nextState };
	};
	
	var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	    if (infinite) {
	      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	  return targetSlide;
	};
	var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft = void 0,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return { scrolling: true };
	  }
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	  state = _extends({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
	  });
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	  return state;
	};
	var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
	  // reset the state of touch related state variables.
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	  if (scrolling) {
	    return state;
	  }
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	    var slideCount = void 0,
	        newSlide = void 0;
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	      default:
	        slideCount = currentSlide;
	    }
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
	  }
	  return state;
	};
	var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	  return indexes;
	};
	var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	      prevNavigable = navigables[n];
	    }
	  }
	  return index;
	};
	var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	  if (spec.swipeToSlide) {
	    var swipedSlide = void 0;
	    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth = void 0,
	      trackHeight = void 0;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _extends({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	  if (spec.fade) style = { opacity: 1 };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight;
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = _reactDom2.default.findDOMNode(trackRef);
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	var getPreClones = exports.getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	var getPostClones = exports.getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  return spec.slideCount;
	};
	
	var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	    return "left";
	  }
	};
	
	var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	  if (rtl) {
	    return 0;
	  }
	  return slidesToShow - 1;
	};
	
	var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	  return 0;
	};
	
	var canUseDOM = exports.canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (process.env.NODE_ENV !== 'production') {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(463);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1219);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1218);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1217);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(462);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(464);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(54);
	var normalizeHeaderName = __webpack_require__(480);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(307);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(307);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.headerToggle = headerToggle;
	exports.headerSelectSubmenu = headerSelectSubmenu;
	
	__webpack_require__(148);
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	var _endpoints = __webpack_require__(122);
	
	var endpoint = _interopRequireWildcard(_endpoints);
	
	var _api = __webpack_require__(121);
	
	var api = _interopRequireWildcard(_api);
	
	var _request = __webpack_require__(123);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/******************************
	*******  Synchronous  *********
	******************************/
	
	function headerToggle() {
	  return {
	    type: constants.HEADER_TOGGLE
	  };
	}
	
	function headerSelectSubmenu(submenu) {
	  return {
	    type: constants.HEADER_SUBMENU,
	    submenu: submenu
	  };
	}
	
	/******************************
	*******  Asynchronous  ********
	******************************/

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompareProductsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _formatting = __webpack_require__(21);
	
	var _data = __webpack_require__(74);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var CompareProducts = function (_React$Component) {
	  _inherits(CompareProducts, _React$Component);
	
	  function CompareProducts(props) {
	    _classCallCheck(this, CompareProducts);
	
	    var _this = _possibleConstructorReturn(this, (CompareProducts.__proto__ || Object.getPrototypeOf(CompareProducts)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CompareProducts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'selectSetting',
	    value: function selectSetting(product) {
	      this.props.productSelectSetting(product);
	    }
	  }, {
	    key: 'isSettingSelected',
	    value: function isSettingSelected() {
	      return this.props.product.selectedSetting !== null;
	    }
	  }, {
	    key: 'selectDiamond',
	    value: function selectDiamond(diamond) {
	      this.props.productSelectDiamond(diamond);
	    }
	  }, {
	    key: 'isDiamondSelected',
	    value: function isDiamondSelected() {
	      return this.props.product.selectedDiamond !== null;
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'renderFavorites',
	    value: function renderFavorites() {
	      var _this2 = this;
	
	      var faveItems = [null, null, null, null];
	      var settingView = this.props.productType == 'setting';
	      var noItems = false;
	
	      if (settingView) {
	        var selectedLength = this.props.product.compareSettings.length;
	        if (selectedLength === 0) {
	          noItems = true;
	        }
	        for (var i = 0; i < faveItems.length; i++) {
	          if (i < selectedLength) {
	            faveItems[i] = this.props.product.compareSettings[i];
	          }
	        }
	      } else {
	        var _selectedLength = this.props.product.compareDiamonds.length;
	        if (_selectedLength === 0) {
	          noItems = true;
	        }
	        for (var j = 0; j < faveItems.length; j++) {
	          if (j < _selectedLength) {
	            faveItems[j] = this.props.product.compareDiamonds[j];
	          }
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'favesWrapper' },
	        noItems ? _react2.default.createElement(
	          'div',
	          { className: 'noItemsMessage' },
	          'Select products to compare'
	        ) : null,
	        faveItems.map(function (item, k) {
	
	          if (item === null) {
	            return _this2.renderNullFave(k);
	          }
	
	          if (settingView) {
	            return _this2.renderSettingFave(item, k);
	          } else {
	            return _this2.renderDiamondFave(item, k);
	          }
	        })
	      );
	    }
	  }, {
	    key: 'getNullMessage',
	    value: function getNullMessage() {
	      switch (this.props.productType) {
	        case 'diamond':
	          return 'Compare your favorite diamonds here!';
	        case 'setting':
	          return 'Compare your favorite settings here!';
	        default:
	          return 'Compare your favorite jewelry here!';
	      }
	    }
	  }, {
	    key: 'renderNullFave',
	    value: function renderNullFave(idx) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'faveItem faveEmpty', key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'compareInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'compareNumber' },
	            idx + 1
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'heartSection' },
	          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/comparelogo.svg' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.getNullMessage()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSettingFave',
	    value: function renderSettingFave(product, idx) {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'faveItem faveProduct', key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'compareInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'compareNumber' },
	            idx + 1
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveRemove', onClick: function onClick() {
	              return _this3.removeFavoriteProduct(product);
	            } },
	          '\xD7'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveProductInner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'faveImg', onClick: function onClick() {
	                return _this3.internalNav('setting/' + product.sku);
	              } },
	            _react2.default.createElement('img', { src: this.getProductMainImage(product) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveTitle' },
	            _react2.default.createElement(
	              'div',
	              null,
	              product.name.replace(/Ã©/g, 'é')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Total Carat Wt:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              product.ttw_dia,
	              ' Ct.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'favePrice' },
	            '$',
	            product.price.toLocaleString()
	          ),
	          this.props.product.selectedSetting && product.sku === this.props.product.selectedSetting.sku ? _react2.default.createElement(
	            'div',
	            { className: 'faveAdd selected' },
	            'Selected'
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'faveAdd', onClick: function onClick() {
	                return _this3.selectSetting(product);
	              } },
	            'Add to Ring'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDiamondFave',
	    value: function renderDiamondFave(diamond, idx) {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'faveItem faveDiamond', key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'compareInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'compareNumber' },
	            idx + 1
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveRemove', onClick: function onClick() {
	              return _this4.removeFavoriteDiamond(diamond);
	            } },
	          '\xD7'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveProductInner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'faveImg', onClick: function onClick() {
	                return _this4.internalNav('diamond/' + diamond.id);
	              } },
	            _react2.default.createElement('img', { src: diamond.image })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveTitle' },
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _formatting.diamondTitle)(diamond)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Shape:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              diamond.shape
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Carat Weight:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              diamond.caratWeight
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Color:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              diamond.color
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Clarity:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              diamond.clarity
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            diamond.shape.toLowerCase() == 'round' ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'faveDataLabel' },
	                'Cut:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'faveDataValue EllipsisElement' },
	                diamond.cut ? diamond.cut : ''
	              )
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'faveDataLabel' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'faveDataValue EllipsisElement' },
	                '\xA0'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Polish:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              diamond.polish
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Symmetry:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              diamond.symmetry
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Fluorescence:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              diamond.fluorescence
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Measurements:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              diamond.measurement
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'favePrice' },
	            '$',
	            diamond.price.toLocaleString()
	          ),
	          this.props.product.selectedDiamond && diamond.id === this.props.product.selectedDiamond.id ? _react2.default.createElement(
	            'div',
	            { className: 'faveAdd selected' },
	            'Selected'
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'faveAdd', onClick: function onClick() {
	                return _this4.selectDiamond(diamond);
	              } },
	            'Add to Ring'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'removeFavoriteProduct',
	    value: function removeFavoriteProduct(product) {
	
	      var currentIndex = null;
	      var faves = (0, _data.cloneArray)(this.props.product.compareSettings);
	
	      if (this.props.product.compareSettings.length === 1) {
	        this.props.productCompareSetting([]);
	        return;
	      }
	
	      for (var i = 0; i < faves.length; i++) {
	        if (faves[i].sku == product.sku) {
	          currentIndex = i;
	          break;
	        }
	      }
	
	      faves.splice(currentIndex, 1);
	      this.props.productCompareSetting(faves);
	    }
	  }, {
	    key: 'removeFavoriteDiamond',
	    value: function removeFavoriteDiamond(diamond) {
	
	      var currentIndex = null;
	      var faves = (0, _data.cloneArray)(this.props.product.compareDiamonds);
	
	      if (this.props.product.compareDiamonds.length === 1) {
	        this.props.productCompareDiamond([]);
	        return;
	      }
	
	      for (var i = 0; i < faves.length; i++) {
	        if (faves[i].id == diamond.id) {
	          currentIndex = i;
	          break;
	        }
	      }
	
	      faves.splice(currentIndex, 1);
	      this.props.productCompareDiamond(faves);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var RESULT_LIMIT = 24;
	      var pCount = 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'CompareProducts' },
	        this.renderFavorites()
	      );
	    }
	  }]);
	
	  return CompareProducts;
	}(_react2.default.Component);
	
	CompareProducts.propTypes = {
	  location: _react.PropTypes.object
	};
	CompareProducts.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = CompareProducts;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var CompareProductsContainer = exports.CompareProductsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(CompareProducts);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FloatingHeaderContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var FloatingHeader = function (_React$Component) {
	  _inherits(FloatingHeader, _React$Component);
	
	  function FloatingHeader(props) {
	    _classCallCheck(this, FloatingHeader);
	
	    var _this = _possibleConstructorReturn(this, (FloatingHeader.__proto__ || Object.getPrototypeOf(FloatingHeader)).call(this, props));
	
	    _this.state = {
	      scrollPos: 0
	    };
	
	    // Bind event listeners
	    _this.getScrollPos = _this.getScrollPos.bind(_this);
	    return _this;
	  }
	
	  _createClass(FloatingHeader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.product.selectedDiamond === null && prevProps.product.selectedSetting === null) {
	        if (this.isSettingSelected() || this.isDiamondSelected()) {
	          // this.setState({ floatOpen: true });
	          this.props.productToggleFloatingHeader(true);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'getScrollPos',
	    value: function getScrollPos() {
	      this.setState({
	        scrollPos: window.pageYOffset
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'selectDiamond',
	    value: function selectDiamond(diamond) {
	      this.props.productSelectDiamond(diamond);
	    }
	  }, {
	    key: 'isDiamondSelected',
	    value: function isDiamondSelected() {
	      return this.props.product.selectedDiamond !== null;
	    }
	  }, {
	    key: 'selectSetting',
	    value: function selectSetting(product) {
	      this.props.productSelectSetting(product);
	    }
	  }, {
	    key: 'isSettingSelected',
	    value: function isSettingSelected() {
	      return this.props.product.selectedSetting !== null;
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'toggleFloatingHeaderExpand',
	    value: function toggleFloatingHeaderExpand() {
	      // this.setState({ floatOpen: !this.state.floatOpen });
	      this.props.productToggleFloatingHeader(!this.props.product.floatingHeaderOpen);
	    }
	  }, {
	    key: 'getFloatingAssembledMessageContent',
	    value: function getFloatingAssembledMessageContent() {
	      if (!this.isDiamondSelected() && !this.isSettingSelected()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'fhMessage' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Choose a diamond or setting to start building your ring.'
	          )
	        );
	      } else if (!this.isDiamondSelected() && this.isSettingSelected()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'fhMessage' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Choose a diamond to complete your ring.'
	          )
	        );
	      } else if (this.isDiamondSelected() && !this.isSettingSelected()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'fhMessage' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Choose a setting to complete your ring.'
	          )
	        );
	      } else if (this.isDiamondSelected() && this.isSettingSelected()) {
	        var _context;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'fhImageWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'fhMessage' },
	            'Your ' + this.props.product.selectedSetting.name + ' with ' + this.props.product.selectedDiamond.caratWeight + ' carat ' + this.props.product.selectedDiamond.shape + ' diamond'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'fhPrice' },
	            '$',
	            this.getCombinedPrice().toLocaleString()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'addToCartWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'addButton mixedResultsButton', onClick: (_context = this.props).scrollTop.bind(_context) },
	              'Customize'
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getCombinedPrice',
	    value: function getCombinedPrice() {
	      if (this.props.product.selectedSetting && this.props.product.selectedDiamond) {
	        return this.props.product.selectedSetting.price + this.props.product.selectedDiamond.price;
	      }
	      return 1000;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context2,
	          _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'FloatingHeader' },
	        _react2.default.createElement(
	          'div',
	          { className: this.state.scrollPos > 400 ? 'floatingHeader open' : 'floatingHeader' },
	          _react2.default.createElement(
	            'div',
	            { className: 'backgroundSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'labelSection' },
	              _react2.default.createElement(
	                'div',
	                { className: 'labelTitle' },
	                'Create Your Ring'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'labelText compareLabel', onClick: (_context2 = this.props).scrollCompare.bind(_context2) },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'compareIcon' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare_a.svg' })
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Comparing ',
	                  this.props.getFavesLength(),
	                  ' of 4'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'toggleWrapper', onClick: this.toggleFloatingHeaderExpand.bind(this) },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'toggleIcon', style: { display: this.props.product.floatingHeaderOpen ? 'none' : 'flex' } },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'toggleIcon', style: { display: this.props.product.floatingHeaderOpen ? 'flex' : 'none' } },
	                  '\u2014'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.props.product.floatingHeaderOpen ? 'fhOuterWrapper' : 'fhOuterWrapper closed' },
	              _react2.default.createElement(
	                'div',
	                { className: 'fhWrapper' },
	                this.isDiamondSelected() ? _react2.default.createElement(
	                  'div',
	                  { className: 'fhDiamondSection' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'removeX', onClick: function onClick() {
	                        return _this2.props.productSelectDiamond(null);
	                      } },
	                    '\xD7'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'imageWrapper' },
	                    _react2.default.createElement('img', { src: this.props.product.selectedDiamond.image })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'sectionWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'sectionName' },
	                      this.isDiamondSelected() ? (0, _formatting.diamondTitle)(this.props.product.selectedDiamond) : 'No diamond selected'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'sectionPrice' },
	                      '$',
	                      this.isDiamondSelected() ? this.props.product.selectedDiamond.price.toLocaleString() : ''
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'sectionPriceNotice' },
	                      '(diamond only)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'diamondInfoButtonRow' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mixedResultsButton fhButton', onClick: function onClick() {
	                            return _this2.internalNav('diamond/' + _this2.props.product.selectedDiamond.id);
	                          } },
	                        'View'
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'fhDiamondSection' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'fhMessage' },
	                    'No diamond selected'
	                  ),
	                  _react2.default.createElement('div', { className: 'fhAction' })
	                ),
	                this.isSettingSelected() ? _react2.default.createElement(
	                  'div',
	                  { className: 'fhSettingSection' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'removeX', onClick: function onClick() {
	                        return _this2.props.productSelectSetting(null);
	                      } },
	                    '\xD7'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'imageWrapper' },
	                    _react2.default.createElement('img', { src: this.isSettingSelected() ? this.getProductMainImage(this.props.product.selectedSetting) : '/img/ringbuilder/results/setting_sample.jpg' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'sectionWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'sectionName' },
	                      this.isSettingSelected() ? this.props.product.selectedSetting.name : 'Loading setting...'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'sectionPrice' },
	                      '$',
	                      this.isSettingSelected() ? this.props.product.selectedSetting.price.toLocaleString() : ''
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'sectionPriceNotice' },
	                      '(setting only)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'diamondInfoButtonRow' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mixedResultsButton fhButton', onClick: function onClick() {
	                            return _this2.internalNav('setting/' + _this2.props.product.selectedSetting.sku);
	                          } },
	                        'View'
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'fhSettingSection' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'fhMessage' },
	                    'No setting selected'
	                  ),
	                  _react2.default.createElement('div', { className: 'fhAction' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'fhImageSection' },
	                  this.getFloatingAssembledMessageContent()
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FloatingHeader;
	}(_react2.default.Component);
	
	FloatingHeader.propTypes = {
	  location: _react.PropTypes.object
	};
	FloatingHeader.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = FloatingHeader;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var FloatingHeaderContainer = exports.FloatingHeaderContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(FloatingHeader);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GemstoneIconsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var GemstoneIcons = function (_React$Component) {
	  _inherits(GemstoneIcons, _React$Component);
	
	  function GemstoneIcons(props) {
	    _classCallCheck(this, GemstoneIcons);
	
	    var _this = _possibleConstructorReturn(this, (GemstoneIcons.__proto__ || Object.getPrototypeOf(GemstoneIcons)).call(this, props));
	
	    var initData = [];
	    if (_this.props.initData) {
	      initData = _this.props.initData;
	    }
	
	    _this.state = {
	      sapphire: initData.includes('sapphire'),
	      emerald: initData.includes('emerald'),
	      ruby: initData.includes('ruby'),
	      semiprecious: initData.includes('semiprecious')
	    };
	    return _this;
	  }
	
	  _createClass(GemstoneIcons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	      var initData = [];
	      if (this.props.initData) {
	        initData = this.props.initData;
	      }
	
	      this.setState({
	        sapphire: initData.includes('sapphire'),
	        emerald: initData.includes('emerald'),
	        ruby: initData.includes('ruby'),
	        semiprecious: initData.includes('semiprecious')
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'concatValues',
	    value: function concatValues() {
	      var returnArray = [];
	      for (var key in this.state) {
	        if (this.state[key]) {
	          returnArray.push(key);
	        }
	      }
	      if (returnArray.join(',').length) {
	        return [returnArray.join(',')];
	      } else {
	        return [Object.keys(this.state).join(',')];
	      }
	    }
	  }, {
	    key: 'toggleShapeSelect',
	    value: function toggleShapeSelect(shape) {
	      var _this2 = this;
	
	      if (shape == 'sapphire') {
	        this.setState({ sapphire: !this.state.sapphire }, function () {
	          _this2.props.refreshData('womensband', ['womensgem'], _this2.concatValues());
	        });
	      } else if (shape == 'emerald') {
	        this.setState({ emerald: !this.state.emerald }, function () {
	          _this2.props.refreshData('womensband', ['womensgem'], _this2.concatValues());
	        });
	      } else if (shape == 'ruby') {
	        this.setState({ ruby: !this.state.ruby }, function () {
	          _this2.props.refreshData('womensband', ['womensgem'], _this2.concatValues());
	        });
	      } else if (shape == 'semiprecious') {
	        this.setState({ semiprecious: !this.state.semiprecious }, function () {
	          _this2.props.refreshData('womensband', ['womensgem'], _this2.concatValues());
	        });
	      }
	    }
	  }, {
	    key: 'selectAllShapes',
	    value: function selectAllShapes() {
	      var _this3 = this;
	
	      this.setState({
	        sapphire: true,
	        emerald: true,
	        ruby: true,
	        semiprecious: true
	      }, function () {
	        _this3.props.refreshData('womensband', ['womensgem'], _this3.concatValues());
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'GemstoneIcons StyleIcons' },
	        _react2.default.createElement(
	          'div',
	          { className: 'iconsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hiddenLoading' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/gem.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/sapphire.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/emerald.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/ruby.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/semiprecious.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.sapphire ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('sapphire');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/gem.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/sapphire.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Sapphire'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.emerald ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('emerald');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/gem.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/emerald.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Emerald'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.ruby ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('ruby');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/gem.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/ruby.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Ruby'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.semiprecious ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('semiprecious');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/gem.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/gemstone/semiprecious.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Semiprecious'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'allLinkWrapper', style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'allLink', onClick: this.selectAllShapes.bind(this) },
	            'All'
	          )
	        )
	      );
	    }
	  }]);
	
	  return GemstoneIcons;
	}(_react2.default.Component);
	
	GemstoneIcons.propTypes = {
	  location: _react.PropTypes.object
	};
	GemstoneIcons.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = GemstoneIcons;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var GemstoneIconsContainer = exports.GemstoneIconsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(GemstoneIcons);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StackableIconsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var StackableIcons = function (_React$Component) {
	  _inherits(StackableIcons, _React$Component);
	
	  function StackableIcons(props) {
	    _classCallCheck(this, StackableIcons);
	
	    var _this = _possibleConstructorReturn(this, (StackableIcons.__proto__ || Object.getPrototypeOf(StackableIcons)).call(this, props));
	
	    var initData = [];
	    if (_this.props.initData) {
	      initData = _this.props.initData;
	    }
	
	    _this.state = {
	      twist: initData.includes('twist'),
	      geometric: initData.includes('geometric'),
	      bezel: initData.includes('bezel'),
	      vintage: initData.includes('vintage')
	    };
	    return _this;
	  }
	
	  _createClass(StackableIcons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData(evt) {
	      var initData = [];
	      if (this.props.initData) {
	        initData = this.props.initData;
	      }
	
	      this.setState({
	        twist: initData.includes('twist'),
	        geometric: initData.includes('geometric'),
	        bezel: initData.includes('bezel'),
	        vintage: initData.includes('vintage')
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'concatValues',
	    value: function concatValues() {
	      var returnArray = [];
	      for (var key in this.state) {
	        if (this.state[key]) {
	          returnArray.push(key);
	        }
	      }
	      if (returnArray.join(',').length) {
	        return [returnArray.join(',')];
	      } else {
	        return [Object.keys(this.state).join(',')];
	      }
	    }
	  }, {
	    key: 'toggleShapeSelect',
	    value: function toggleShapeSelect(shape) {
	      var _this2 = this;
	
	      if (shape == 'twist') {
	        this.setState({ twist: !this.state.twist }, function () {
	          _this2.props.refreshData('womensband', ['stackable'], _this2.concatValues());
	        });
	      } else if (shape == 'geometric') {
	        this.setState({ geometric: !this.state.geometric }, function () {
	          _this2.props.refreshData('womensband', ['stackable'], _this2.concatValues());
	        });
	      } else if (shape == 'bezel') {
	        this.setState({ bezel: !this.state.bezel }, function () {
	          _this2.props.refreshData('womensband', ['stackable'], _this2.concatValues());
	        });
	      } else if (shape == 'vintage') {
	        this.setState({ vintage: !this.state.vintage }, function () {
	          _this2.props.refreshData('womensband', ['stackable'], _this2.concatValues());
	        });
	      }
	    }
	  }, {
	    key: 'selectAllShapes',
	    value: function selectAllShapes() {
	      var _this3 = this;
	
	      var toggleValue = false;
	      for (var key in this.state) {
	        if (!this.state[key]) {
	          toggleValue = true;
	          break;
	        }
	      }
	
	      this.setState({
	        twist: toggleValue,
	        geometric: toggleValue,
	        bezel: toggleValue,
	        vintage: toggleValue
	      }, function () {
	        _this3.props.refreshData('womensband', ['stackable'], _this3.concatValues());
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'StackableIcons StyleIcons' },
	        _react2.default.createElement(
	          'div',
	          { className: 'iconsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hiddenLoading' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/twist_stack.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/twist_stack_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/geometric_stack.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/geometric_stack_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/bezel.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/bezel_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/vintage_stack.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/vintage_stack_a.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.twist ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('twist');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/twist_stack.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/twist_stack_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Twist'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.geometric ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('geometric');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/geometric_stack.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/geometric_stack_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Geometric'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.bezel ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('bezel');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/bezel.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/bezel_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Bezel'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.vintage ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('vintage');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/vintage_stack.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/stackable/vintage_stack_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Vintage Designs'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'allLinkWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'allLink', onClick: this.selectAllShapes.bind(this) },
	            'All'
	          )
	        )
	      );
	    }
	  }]);
	
	  return StackableIcons;
	}(_react2.default.Component);
	
	StackableIcons.propTypes = {
	  location: _react.PropTypes.object
	};
	StackableIcons.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = StackableIcons;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var StackableIconsContainer = exports.StackableIconsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(StackableIcons);

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WomensDiamondIconsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var WomensDiamondIcons = function (_React$Component) {
	  _inherits(WomensDiamondIcons, _React$Component);
	
	  function WomensDiamondIcons(props) {
	    _classCallCheck(this, WomensDiamondIcons);
	
	    var _this = _possibleConstructorReturn(this, (WomensDiamondIcons.__proto__ || Object.getPrototypeOf(WomensDiamondIcons)).call(this, props));
	
	    var initData = [];
	    if (_this.props.initData) {
	      initData = _this.props.initData;
	    }
	
	    _this.state = {
	      prongset: initData.includes('prongset'),
	      channel: initData.includes('channel'),
	      singleprong: initData.includes('singleprong'),
	      contoured: initData.includes('contoured'),
	      wraps: initData.includes('wraps'),
	      fancy: initData.includes('fancy'),
	      vintage: initData.includes('vintage')
	    };
	    return _this;
	  }
	
	  _createClass(WomensDiamondIcons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	      var initData = [];
	      if (this.props.initData) {
	        initData = this.props.initData;
	      }
	
	      this.setState({
	        prongset: initData.includes('prongset'),
	        channel: initData.includes('channel'),
	        singleprong: initData.includes('singleprong'),
	        contoured: initData.includes('contoured'),
	        wraps: initData.includes('wraps'),
	        fancy: initData.includes('fancy'),
	        vintage: initData.includes('vintage')
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'concatValues',
	    value: function concatValues() {
	      var returnArray = [];
	      for (var key in this.state) {
	        if (this.state[key]) {
	          returnArray.push(key);
	        }
	      }
	      if (returnArray.join(',').length) {
	        return [returnArray.join(',')];
	      } else {
	        return [Object.keys(this.state).join(',')];
	      }
	    }
	  }, {
	    key: 'toggleShapeSelect',
	    value: function toggleShapeSelect(shape) {
	      var _this2 = this;
	
	      if (shape == 'prongset') {
	        this.setState({ prongset: !this.state.prongset }, function () {
	          _this2.props.refreshData('womensband', ['womensdiamond'], _this2.concatValues());
	        });
	      } else if (shape == 'channel') {
	        this.setState({ channel: !this.state.channel }, function () {
	          _this2.props.refreshData('womensband', ['womensdiamond'], _this2.concatValues());
	        });
	      } else if (shape == 'singleprong') {
	        this.setState({ singleprong: !this.state.singleprong }, function () {
	          _this2.props.refreshData('womensband', ['womensdiamond'], _this2.concatValues());
	        });
	      } else if (shape == 'contoured') {
	        this.setState({ contoured: !this.state.contoured }, function () {
	          _this2.props.refreshData('womensband', ['womensdiamond'], _this2.concatValues());
	        });
	      } else if (shape == 'wraps') {
	        this.setState({ wraps: !this.state.wraps }, function () {
	          _this2.props.refreshData('womensband', ['womensdiamond'], _this2.concatValues());
	        });
	      } else if (shape == 'fancy') {
	        this.setState({ fancy: !this.state.fancy }, function () {
	          _this2.props.refreshData('womensband', ['womensdiamond'], _this2.concatValues());
	        });
	      } else if (shape == 'vintage') {
	        this.setState({ vintage: !this.state.vintage }, function () {
	          _this2.props.refreshData('womensband', ['womensdiamond'], _this2.concatValues());
	        });
	      }
	    }
	  }, {
	    key: 'selectAllShapes',
	    value: function selectAllShapes() {
	      var _this3 = this;
	
	      var toggleValue = false;
	      for (var key in this.state) {
	        if (!this.state[key]) {
	          toggleValue = true;
	          break;
	        }
	      }
	
	      this.setState({
	        prongset: toggleValue,
	        channel: toggleValue,
	        singleprong: toggleValue,
	        contoured: toggleValue,
	        wraps: toggleValue,
	        fancy: toggleValue,
	        vintage: toggleValue
	      }, function () {
	        _this3.props.refreshData('womensband', ['womensdiamond'], _this3.concatValues());
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'WomensDiamondIcons StyleIcons' },
	        _react2.default.createElement(
	          'div',
	          { className: 'iconsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hiddenLoading' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/prong_set.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/prong_set_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/channel.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/channel_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/single_prong.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/single_prong_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/contour.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/contour_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/guard.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/guard_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/fancy.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/fancy_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/vintage.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/vintage_a.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.prongset ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('prongset');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/prong_set.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/prong_set_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Prong Set'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.channel ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('channel');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/channel.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/channel_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Channel Set'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.singleprong ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('singleprong');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/single_prong.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/single_prong_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Single Prong'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.contoured ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('contoured');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/contour.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/contour_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Contoured'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.wraps ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('wraps');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/guard.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/guard_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Wraps and Guards'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.fancy ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('fancy');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/fancy.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/fancy_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Fancy Shapes'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.vintage ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('vintage');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/vintage.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/womensdiamond/vintage_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Vintage Designs'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'allLinkWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'allLink', onClick: this.selectAllShapes.bind(this) },
	            'All'
	          )
	        )
	      );
	    }
	  }]);
	
	  return WomensDiamondIcons;
	}(_react2.default.Component);
	
	WomensDiamondIcons.propTypes = {
	  location: _react.PropTypes.object
	};
	WomensDiamondIcons.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = WomensDiamondIcons;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var WomensDiamondIconsContainer = exports.WomensDiamondIconsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(WomensDiamondIcons);

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScheduleServiceFormContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _formatting = __webpack_require__(21);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var ScheduleServiceForm = function (_React$Component) {
	  _inherits(ScheduleServiceForm, _React$Component);
	
	  function ScheduleServiceForm(props) {
	    _classCallCheck(this, ScheduleServiceForm);
	
	    var _this = _possibleConstructorReturn(this, (ScheduleServiceForm.__proto__ || Object.getPrototypeOf(ScheduleServiceForm)).call(this, props));
	
	    var firstEntry = [{ display: 'Select a Location*', 'value': '' }];
	    var finalEntry = [{ display: 'Virtual/Other', 'value': 'online@diamondsdirect.com' }];
	
	    var newArray = firstEntry.concat(locations.locations).concat(finalEntry);
	
	    _this.state = {
	
	      locations: newArray,
	
	      inputFirstName: '',
	      inputLastName: '',
	      inputContactPhone: '',
	      inputContactEmail: '',
	      inputPurchasedBool: '',
	      inputPurchasedName: '',
	      inputLocation: '',
	      inputDescription: '',
	
	      errorFirstName: false,
	      errorLastName: false,
	      errorContactPhone: false,
	      errorContactEmail: false,
	      errorPurchasedBool: false,
	      errorPurchasedName: false,
	      errorLocation: false,
	      errorDescription: false
	    };
	    return _this;
	  }
	
	  _createClass(ScheduleServiceForm, [{
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'changeFirstName',
	    value: function changeFirstName(evt) {
	      var _this2 = this;
	
	      this.setState({ inputFirstName: evt.target.value }, function () {
	        if (_this2.state.errorLastName && !(0, _itemValidation.nameValidation)(_this2.state.inputFirstName)) {
	          _this2.setState({ errorLastName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeLastName',
	    value: function changeLastName(evt) {
	      var _this3 = this;
	
	      this.setState({ inputLastName: evt.target.value }, function () {
	        if (_this3.state.errorLastName && !(0, _itemValidation.nameValidation)(_this3.state.inputLastName)) {
	          _this3.setState({ errorLastName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeContactPhone',
	    value: function changeContactPhone(evt) {
	      var _this4 = this;
	
	      this.setState({ inputContactPhone: (0, _formatting.displayPhoneInput)(evt.target.value) }, function () {
	        if (_this4.state.errorContactPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputContactPhone)) {
	          _this4.setState({ errorContactPhone: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeContactEmail',
	    value: function changeContactEmail(evt) {
	      var _this5 = this;
	
	      this.setState({ inputContactEmail: evt.target.value }, function () {
	        if (_this5.state.errorContactEmail && !(0, _itemValidation.emailValidation)(_this5.state.inputContactEmail)) {
	          _this5.setState({ errorContactEmail: null });
	        }
	      });
	    }
	  }, {
	    key: 'changePurchasedBool',
	    value: function changePurchasedBool(evt) {
	      var _this6 = this;
	
	      this.setState({ inputPurchasedBool: evt.target.value }, function () {
	        if (_this6.state.errorPurchasedBool) {
	          _this6.setState({ errorPurchasedBool: null });
	        }
	      });
	    }
	  }, {
	    key: 'changePurchasedName',
	    value: function changePurchasedName(evt) {
	      var _this7 = this;
	
	      this.setState({ inputPurchasedName: evt.target.value }, function () {
	        if (_this7.state.errorPurchasedName && !(0, _itemValidation.nameValidation)(_this7.state.inputPurchasedName)) {
	          _this7.setState({ errorPurchasedName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeLocation',
	    value: function changeLocation(evt) {
	      var _this8 = this;
	
	      this.setState({ inputLocation: evt.target.value }, function () {
	        if (_this8.state.errorLocation !== null && _this8.state.inputLocation !== '') {
	          _this8.setState({ errorLocation: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeDescription',
	    value: function changeDescription(evt) {
	      var _this9 = this;
	
	      this.setState({ inputDescription: evt.target.value }, function () {
	        if (_this9.state.errorDescription && !(0, _itemValidation.messageTextValidation)(_this9.state.inputDescription)) {
	          _this9.setState({ errorDescription: null });
	        }
	      });
	    }
	  }, {
	    key: 'validateLocation',
	    value: function validateLocation() {}
	  }, {
	    key: 'validateFirstName',
	    value: function validateFirstName(evt) {
	      this.setState({
	        errorFirstName: (0, _itemValidation.nameValidation)(evt.target.value) !== null
	      });
	    }
	  }, {
	    key: 'validateLastName',
	    value: function validateLastName(evt) {
	      this.setState({
	        errorLastName: (0, _itemValidation.nameValidation)(evt.target.value) !== null
	      });
	    }
	  }, {
	    key: 'validateEmailInput',
	    value: function validateEmailInput(evt) {
	      console.log((0, _itemValidation.emailValidation)(evt.target.value));
	      this.setState({
	        errorContactEmail: (0, _itemValidation.emailValidation)(evt.target.value) !== null
	      });
	    }
	  }, {
	    key: 'validatePhoneInput',
	    value: function validatePhoneInput(evt) {
	      this.setState({
	        errorContactPhone: (0, _itemValidation.phoneValidation)(evt.target.value) !== null
	      });
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	
	      var locationError = this.state.inputLocation === '';
	      var purchasedError = this.state.inputPurchasedBool === '';
	      var firstNameError = (0, _itemValidation.nameValidation)(this.state.inputFirstName) !== null;
	      var lastNameError = (0, _itemValidation.nameValidation)(this.state.inputLastName) !== null;
	      var emailError = (0, _itemValidation.emailValidation)(this.state.inputContactEmail) !== null;
	      var phoneError = (0, _itemValidation.phoneValidation)(this.state.inputContactPhone) !== null;
	
	      this.setState({
	        errorFirstName: firstNameError,
	        errorLastName: lastNameError,
	        errorPurchasedBool: purchasedError,
	        errorSalesAssociate: false,
	        errorLocation: locationError,
	        errorShoppingFor: false,
	        errorDetails: false,
	        errorContactPhone: phoneError,
	        errorContactEmail: emailError
	      });
	
	      return !locationError && !purchasedError && !firstNameError && !lastNameError && !emailError && !phoneError;
	    }
	  }, {
	    key: 'submitContactRequest',
	    value: function submitContactRequest() {
	      if (this.validateAll()) {
	
	        var serviceData = {
	          location_email: this.state.inputLocation,
	          purchased_bool: this.state.inputPurchasedBool,
	          first_name: this.state.inputFirstName,
	          last_name: this.state.inputLastName,
	          email: this.state.inputContactEmail,
	          phone: this.state.inputContactPhone,
	          account: this.state.inputPurchasedName,
	          message: this.state.inputDescription
	        };
	
	        this.props.commonServiceRequest(serviceData);
	        this.props.commonAlert('Thank you for submitting an appointment request! A member of our Customer Care Team will follow up with you shortly to finalize your appointment.', 'Continue Shopping', 'visit', '');
	        this.setState({
	          inputFirstName: '',
	          inputLastName: '',
	          inputContactPhone: '',
	          inputContactEmail: '',
	          inputPurchasedBool: '',
	          inputPurchasedName: '',
	          inputLocation: '',
	          inputDescription: '',
	
	          errorFirstName: false,
	          errorLastName: false,
	          errorContactPhone: false,
	          errorContactEmail: false,
	          errorPurchasedBool: false,
	          errorPurchasedName: false,
	          errorLocation: false,
	          errorDescription: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context,
	          _this10 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ScheduleServiceForm' },
	        _react2.default.createElement(
	          'div',
	          { className: 'closeContact', onClick: (_context = this.props).closeMethod.bind(_context) },
	          _react2.default.createElement(
	            'div',
	            { className: 'closeX' },
	            '\xD7'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'formHeader' },
	          'Schedule a Service Appointment'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'formBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement(_RhinoSelect2.default, {
	                selectClass: 'scheduleSelect',
	                required: true,
	                value: this.state.inputLocation,
	                options: this.state.locations,
	                changeMethod: function changeMethod(evt) {
	                  return _this10.changeLocation(evt);
	                },
	                error: this.state.errorLocation })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.errorPurchasedBool ? 'radioYesNoLabel error' : 'radioYesNoLabel' },
	                'Was the item purchased from us?*'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'radioInputRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'radioInputWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'radioInputElement' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorPurchasedBool ? 'radioInput error' : 'radioInput',
	                      type: 'radio',
	                      name: 'radioShopPreviously',
	                      value: 'Yes',
	                      checked: this.state.inputPurchasedBool === 'Yes',
	                      onChange: this.changePurchasedBool.bind(this) })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'radioLabel' },
	                    'Yes'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'radioInputWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'radioInputElement' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorPurchasedBool ? 'radioInput error' : 'radioInput',
	                      type: 'radio',
	                      name: 'radioShopPreviously',
	                      value: 'No',
	                      checked: this.state.inputPurchasedBool === 'No',
	                      onChange: this.changePurchasedBool.bind(this) })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'radioLabel' },
	                    'No'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.inputPurchasedBool === 'Yes' ? 'expandableHalfSection open' : 'expandableHalfSection' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorPurchasedName ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Name on account',
	                  value: this.state.inputPurchasedName,
	                  onChange: this.changePurchasedName.bind(this) })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'formRow' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'formSubheader' },
	              'Your Contact Information'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement('input', {
	                className: this.state.errorFirstName ? 'textInput error' : 'textInput',
	                type: 'text',
	                placeholder: 'First Name*',
	                value: this.state.inputFirstName,
	                onChange: this.changeFirstName.bind(this),
	                onBlur: this.validateFirstName.bind(this) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement('input', {
	                className: this.state.errorLastName ? 'textInput error' : 'textInput',
	                type: 'text',
	                placeholder: 'Last Name*',
	                value: this.state.inputLastName,
	                onChange: this.changeLastName.bind(this),
	                onBlur: this.validateLastName.bind(this) })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow preBanner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement('input', {
	                className: this.state.errorContactEmail ? 'textInput error' : 'textInput',
	                type: 'email',
	                placeholder: 'Email*',
	                value: this.state.inputContactEmail,
	                onChange: this.changeContactEmail.bind(this),
	                onBlur: this.validateEmailInput.bind(this) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement('input', {
	                className: this.state.errorContactPhone ? 'textInput error' : 'textInput',
	                type: 'tel',
	                placeholder: 'Phone*',
	                value: this.state.inputContactPhone,
	                onChange: this.changeContactPhone.bind(this),
	                onBlur: this.validatePhoneInput.bind(this) })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'textareaLabelWrapper' },
	              'Description of services needed (ex: sizing, cleaning, loose diamond, rhodium plating, etc\u2026)*'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'textareaInputWrapper' },
	              _react2.default.createElement('textarea', {
	                className: this.state.errorDescription ? 'textTextarea error' : 'textTextarea',
	                placeholder: '',
	                value: this.state.inputDescription,
	                onChange: this.changeDescription.bind(this) })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'repairNotice' },
	            'Walk-ins always welcome! No appointment needed for routine jewelry cleanings.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'submitButton actionButton', onClick: this.submitContactRequest.bind(this) },
	              'Request an Appointment'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ScheduleServiceForm;
	}(_react2.default.Component);
	
	ScheduleServiceForm.propTypes = {
	  location: _react.PropTypes.object
	};
	ScheduleServiceForm.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ScheduleServiceForm;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ScheduleServiceFormContainer = exports.ScheduleServiceFormContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ScheduleServiceForm);

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScheduleShoppingFormContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _formatting = __webpack_require__(21);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var ScheduleShoppingForm = function (_React$Component) {
	  _inherits(ScheduleShoppingForm, _React$Component);
	
	  function ScheduleShoppingForm(props) {
	    _classCallCheck(this, ScheduleShoppingForm);
	
	    var _this = _possibleConstructorReturn(this, (ScheduleShoppingForm.__proto__ || Object.getPrototypeOf(ScheduleShoppingForm)).call(this, props));
	
	    var firstEntry = [{ display: 'Select a Location*', 'value': '' }];
	    var finalEntry = [{ display: 'Virtual/Other', 'value': 'online@diamondsdirect.com' }];
	
	    var newArray = firstEntry.concat(locations.locations).concat(finalEntry);
	
	    _this.state = {
	
	      locations: newArray,
	
	      inputFirstName: '',
	      inputLastName: '',
	      inputShopPreviously: '',
	      inputSalesAssociate: '',
	      inputLocation: '',
	      inputShoppingFor: new Map(),
	      inputDetails: '',
	      inputContactPhone: '',
	      inputContactEmail: '',
	
	      errorFirstName: false,
	      errorLastName: false,
	      errorShopPreviously: false,
	      errorSalesAssociate: false,
	      errorLocation: false,
	      errorShoppingFor: false,
	      errorDetails: false,
	      errorContactPhone: false,
	      errorContactEmail: false,
	
	      timeData: [{ display: 'Time*', 'value': '' }, { display: '10am - 12pm', 'value': '10am - 12pm' }, { display: '1pm - 3pm', 'value': '1pm - 3pm' }, { display: '4pm - 7pm', 'value': '4pm - 7pm' }],
	
	      dayOpen: false,
	      dayValue: '',
	
	      timeOpen: false,
	      timeValue: ''
	    };
	
	    _this.checkDayClick = _this.checkDayClick.bind(_this);
	    _this.checkTimeClick = _this.checkTimeClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScheduleShoppingForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('click', this.checkDayClick, false);
	      document.addEventListener('click', this.checkTimeClick, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.checkDayClick, false);
	      document.removeEventListener('click', this.checkTimeClick, false);
	    }
	  }, {
	    key: 'checkDayClick',
	    value: function checkDayClick(evt) {
	      if (this.state.dayOpen === true) {
	
	        console.log('checking day');
	
	        var targetElement = evt.target;
	        do {
	          if (targetElement === this.dayBody) {
	            return;
	          }
	          targetElement = targetElement.parentNode;
	        } while (targetElement);
	        this.setState({ dayOpen: false });
	      }
	    }
	  }, {
	    key: 'checkTimeClick',
	    value: function checkTimeClick(evt) {
	      if (this.state.timeOpen === true) {
	        var targetElement = evt.target;
	        do {
	          if (targetElement === this.timeBody) {
	            return;
	          }
	          targetElement = targetElement.parentNode;
	        } while (targetElement);
	        this.setState({ timeOpen: false });
	      }
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'changeFirstName',
	    value: function changeFirstName(evt) {
	      var _this2 = this;
	
	      this.setState({ inputFirstName: evt.target.value }, function () {
	        if (_this2.state.errorFirstName && !(0, _itemValidation.nameValidation)(_this2.state.inputFirstName)) {
	          _this2.setState({ errorFirstName: false });
	        }
	      });
	    }
	  }, {
	    key: 'changeLastName',
	    value: function changeLastName(evt) {
	      var _this3 = this;
	
	      this.setState({ inputLastName: evt.target.value }, function () {
	        if (_this3.state.errorLastName && !(0, _itemValidation.nameValidation)(_this3.state.inputLastName)) {
	          _this3.setState({ errorLastName: false });
	        }
	      });
	    }
	  }, {
	    key: 'changeShopPreviously',
	    value: function changeShopPreviously(evt) {
	      var _this4 = this;
	
	      this.setState({ inputShopPreviously: evt.target.value }, function () {
	        if (_this4.state.errorShopPreviously) {
	          _this4.setState({ errorShopPreviously: false });
	        }
	      });
	    }
	  }, {
	    key: 'changeSalesAssociate',
	    value: function changeSalesAssociate(evt) {
	      var _this5 = this;
	
	      this.setState({ inputSalesAssociate: evt.target.value }, function () {
	        if (_this5.state.errorSalesAssociate && !(0, _itemValidation.nameValidation)(_this5.state.inputSalesAssociate)) {
	          _this5.setState({ errorSalesAssociate: false });
	        }
	      });
	    }
	  }, {
	    key: 'changeLocation',
	    value: function changeLocation(evt) {
	      var _this6 = this;
	
	      this.setState({ inputLocation: evt.target.value }, function () {
	        if (_this6.state.errorLocation !== false && location !== '') {
	          _this6.setState({ errorLocation: false });
	        }
	      });
	    }
	  }, {
	    key: 'changeShoppingFor',
	    value: function changeShoppingFor(evt) {
	      var item = evt.target.name;
	      var isChecked = evt.target.checked;
	      this.setState(function (prevState) {
	        return { inputShoppingFor: prevState.inputShoppingFor.set(item, isChecked) };
	      });
	    }
	  }, {
	    key: 'changeDetails',
	    value: function changeDetails(evt) {
	      var _this7 = this;
	
	      this.setState({ inputDetails: evt.target.value }, function () {
	        if (_this7.state.errorDetails && !(0, _itemValidation.messageTextValidation)(_this7.state.inputDetails)) {
	          _this7.setState({ errorDetails: false });
	        }
	      });
	    }
	  }, {
	    key: 'changeContactPhone',
	    value: function changeContactPhone(evt) {
	      var _this8 = this;
	
	      this.setState({ inputContactPhone: (0, _formatting.displayPhoneInput)(evt.target.value) }, function () {
	        if (_this8.state.errorContactPhone && !(0, _itemValidation.phoneValidation)(_this8.state.inputContactPhone)) {
	          _this8.setState({ errorContactPhone: false });
	        }
	      });
	    }
	  }, {
	    key: 'changeContactEmail',
	    value: function changeContactEmail(evt) {
	      var _this9 = this;
	
	      this.setState({ inputContactEmail: evt.target.value }, function () {
	        if (_this9.state.errorContactEmail && !(0, _itemValidation.emailValidation)(_this9.state.inputContactEmail)) {
	          _this9.setState({ errorContactEmail: false });
	        }
	      });
	    }
	  }, {
	    key: 'validateLocation',
	    value: function validateLocation() {}
	  }, {
	    key: 'validateFirstName',
	    value: function validateFirstName(evt) {
	      this.setState({
	        errorFirstName: (0, _itemValidation.nameValidation)(evt.target.value) !== null
	      });
	    }
	  }, {
	    key: 'validateLastName',
	    value: function validateLastName(evt) {
	      this.setState({
	        errorLastName: (0, _itemValidation.nameValidation)(evt.target.value) !== null
	      });
	    }
	  }, {
	    key: 'validateEmailInput',
	    value: function validateEmailInput(evt) {
	      console.log((0, _itemValidation.emailValidation)(evt.target.value));
	      this.setState({
	        errorContactEmail: (0, _itemValidation.emailValidation)(evt.target.value) !== null
	      });
	    }
	  }, {
	    key: 'validatePhoneInput',
	    value: function validatePhoneInput(evt) {
	      this.setState({
	        errorContactPhone: (0, _itemValidation.phoneValidation)(evt.target.value) !== null
	      });
	    }
	  }, {
	    key: 'toggleDay',
	    value: function toggleDay() {
	      this.setState({ dayOpen: !this.state.dayOpen });
	    }
	  }, {
	    key: 'selectDay',
	    value: function selectDay(clickVal) {
	      var val = clickVal + ',';
	
	      if (this.state.dayValue.includes(val)) {
	        var current = this.state.dayValue;
	        var newVal = current.split(val).join('');
	        this.setState({ dayValue: newVal });
	      } else {
	        this.setState({ dayValue: this.state.dayValue + val });
	      }
	    }
	  }, {
	    key: 'toggleTime',
	    value: function toggleTime() {
	      this.setState({ timeOpen: !this.state.timeOpen });
	    }
	  }, {
	    key: 'selectTime',
	    value: function selectTime(clickVal) {
	      var val = clickVal + ',';
	
	      if (this.state.timeValue.includes(val)) {
	        var current = this.state.timeValue;
	        var newVal = current.split(val).join('');
	        this.setState({ timeValue: newVal });
	      } else {
	        this.setState({ timeValue: this.state.timeValue + val });
	      }
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	
	      var locationError = this.state.inputLocation === '';
	      var previousError = this.state.inputShopPreviously === '';
	      var firstNameError = (0, _itemValidation.nameValidation)(this.state.inputFirstName) !== null;
	      var lastNameError = (0, _itemValidation.nameValidation)(this.state.inputLastName) !== null;
	      var emailError = (0, _itemValidation.emailValidation)(this.state.inputContactEmail) !== null;
	      var phoneError = (0, _itemValidation.phoneValidation)(this.state.inputContactPhone) !== null;
	
	      this.setState({
	        errorFirstName: firstNameError,
	        errorLastName: lastNameError,
	        errorShopPreviously: previousError,
	        errorSalesAssociate: false,
	        errorLocation: locationError,
	        errorShoppingFor: false,
	        errorDetails: false,
	        errorContactPhone: phoneError,
	        errorContactEmail: emailError
	      });
	
	      return !locationError && !previousError && !firstNameError && !lastNameError && !emailError && !phoneError;
	    }
	  }, {
	    key: 'submitContactRequest',
	    value: function submitContactRequest() {
	      if (this.validateAll()) {
	
	        console.log(this.state.inputShoppingFor);
	        console.log(JSON.stringify(this.state.inputShoppingFor));
	
	        var shoppingFor = "";
	        this.state.inputShoppingFor.forEach(function (value, key, map) {
	          if (value) {
	            if (shoppingFor === "") {
	              shoppingFor = key;
	            } else {
	              shoppingFor += "," + key;
	            }
	          }
	        });
	
	        var shoppingData = {
	          location_email: this.state.inputLocation,
	          previous_bool: this.state.inputShopPreviously,
	          first_name: this.state.inputFirstName,
	          last_name: this.state.inputLastName,
	          email: this.state.inputContactEmail,
	          phone: this.state.inputContactPhone,
	          associate: this.state.inputSalesAssociate,
	          shopping_for: shoppingFor,
	          message: this.state.inputDetails,
	          apptDays: this.state.dayValue,
	          apptTime: this.state.timeValue
	        };
	
	        this.props.commonShoppingRequest(shoppingData);
	        this.props.commonAlert('Thank you for submitting an appointment request! A member of our Customer Care Team will follow up with you shortly to finalize your appointment.', 'Continue Shopping', 'visit', '');
	        this.setState({
	          inputFirstName: '',
	          inputLastName: '',
	          inputShopPreviously: '',
	          inputSalesAssociate: '',
	          inputLocation: '',
	          inputShoppingFor: new Map(),
	          inputDetails: '',
	          inputContactPhone: '',
	          inputContactEmail: '',
	
	          dayValue: '',
	          timeValue: '',
	
	          errorFirstName: false,
	          errorLastName: false,
	          errorShopPreviously: false,
	          errorSalesAssociate: false,
	          errorLocation: false,
	          errorShoppingFor: false,
	          errorDetails: false,
	          errorContactPhone: false,
	          errorContactEmail: false
	        });
	      }
	    }
	  }, {
	    key: 'formatList',
	    value: function formatList(list) {
	      if (!list) {
	        return '';
	      }
	      var res = list.replace(/,/g, ', ');
	      return res.trim().slice(0, -1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context,
	          _this10 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ScheduleShoppingForm' },
	        _react2.default.createElement(
	          'div',
	          { className: 'closeContact', onClick: (_context = this.props).closeMethod.bind(_context) },
	          _react2.default.createElement(
	            'div',
	            { className: 'closeX' },
	            '\xD7'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'formHeader' },
	          'Request a Shopping Appointment'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'formBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement(_RhinoSelect2.default, {
	                selectClass: 'scheduleSelect',
	                required: true,
	                options: this.state.locations,
	                changeMethod: function changeMethod(evt) {
	                  return _this10.changeLocation(evt);
	                },
	                value: this.state.inputLocation,
	                error: this.state.errorLocation })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.errorShopPreviously ? 'radioYesNoLabel error' : 'radioYesNoLabel' },
	                'Have you shopped with us previously?*'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'radioInputRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'radioInputWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'radioInputElement' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorShopPreviously ? 'radioInput error' : 'radioInput',
	                      type: 'radio',
	                      name: 'radioShopPreviously',
	                      value: 'Yes',
	                      checked: this.state.inputShopPreviously === 'Yes',
	                      onClick: this.changeShopPreviously.bind(this) })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'radioLabel' },
	                    'Yes'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'radioInputWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'radioInputElement' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorShopPreviously ? 'radioInput error' : 'radioInput',
	                      type: 'radio',
	                      name: 'radioShopPreviously',
	                      value: 'No',
	                      checked: this.state.inputShopPreviously === 'No',
	                      onChange: this.changeShopPreviously.bind(this) })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'radioLabel' },
	                    'No'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.inputShopPreviously === 'Yes' ? 'expandableHalfSection open' : 'expandableHalfSection' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorSalesAssociate ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Your Sales Associate?',
	                  value: this.state.inputSalesAssociate,
	                  onChange: this.changeSalesAssociate.bind(this) })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'formSubheader' },
	              'Your Contact Information'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement('input', {
	                className: this.state.errorFirstName ? 'textInput error' : 'textInput',
	                type: 'text',
	                placeholder: 'First Name*',
	                value: this.state.inputFirstName,
	                onChange: this.changeFirstName.bind(this),
	                onBlur: this.validateFirstName.bind(this) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement('input', {
	                className: this.state.errorLastName ? 'textInput error' : 'textInput',
	                type: 'text',
	                placeholder: 'Last Name*',
	                value: this.state.inputLastName,
	                onChange: this.changeLastName.bind(this),
	                onBlur: this.validateLastName.bind(this) })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow preBanner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement('input', {
	                className: this.state.errorContactEmail ? 'textInput error' : 'textInput',
	                type: 'email',
	                placeholder: 'Email*',
	                value: this.state.inputContactEmail,
	                onChange: this.changeContactEmail.bind(this),
	                onBlur: this.validateEmailInput.bind(this) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'oneHalfSection' },
	              _react2.default.createElement('input', {
	                className: this.state.errorContactPhone ? 'textInput error' : 'textInput',
	                type: 'tel',
	                placeholder: 'Phone*',
	                value: this.state.inputContactPhone,
	                onChange: this.changeContactPhone.bind(this),
	                onBlur: this.validatePhoneInput.bind(this) })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow emRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'shoppingForLabelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'shoppingForPrimary' },
	                'I\'m shopping for:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'shoppingForSecondary' },
	                '(check all that apply)'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shoppingForBodyWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'checkboxInputWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkboxInputElement' },
	                  _react2.default.createElement('input', {
	                    className: 'checkboxInput',
	                    type: 'checkbox',
	                    name: 'Engagement Ring',
	                    checked: this.state.inputShoppingFor.get('Engagement Ring'),
	                    onChange: this.changeShoppingFor.bind(this) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkboxLabel' },
	                  'Engagement Ring'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'checkboxInputWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkboxInputElement' },
	                  _react2.default.createElement('input', {
	                    className: 'checkboxInput',
	                    type: 'checkbox',
	                    name: 'Wedding Bands',
	                    checked: this.state.inputShoppingFor.get('Wedding Bands'),
	                    onChange: this.changeShoppingFor.bind(this) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkboxLabel' },
	                  'Wedding Bands'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'checkboxInputWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkboxInputElement' },
	                  _react2.default.createElement('input', {
	                    className: 'checkboxInput',
	                    type: 'checkbox',
	                    name: 'Upgrade/Trade-in',
	                    checked: this.state.inputShoppingFor.get('Upgrade/Trade-in'),
	                    onChange: this.changeShoppingFor.bind(this) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkboxLabel' },
	                  'Upgrade/Trade-in'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'checkboxInputWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkboxInputElement' },
	                  _react2.default.createElement('input', {
	                    className: 'checkboxInput',
	                    type: 'checkbox',
	                    name: 'Fine jewelry',
	                    checked: this.state.inputShoppingFor.get('Fine jewelry'),
	                    onChange: this.changeShoppingFor.bind(this) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkboxLabel' },
	                  'Fine Jewelry'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'checkboxInputWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkboxInputElement' },
	                  _react2.default.createElement('input', {
	                    className: 'checkboxInput',
	                    type: 'checkbox',
	                    name: 'Lab Grown',
	                    checked: this.state.inputShoppingFor.get('Lab Grown'),
	                    onChange: this.changeShoppingFor.bind(this) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkboxLabel' },
	                  'Lab Grown Diamonds'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'shoppingForLabelWrapper lightBg' },
	              _react2.default.createElement(
	                'div',
	                { className: 'shoppingForPrimary' },
	                'Preferred Appointment Day & Time'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'shoppingForSecondary' },
	                '(select all that apply)'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shoppingForBodyWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'timeElement' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'timeWrapper', ref: function ref(div) {
	                      _this10.dayBody = div;
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'dropElement EllipsisElement', onClick: this.toggleDay.bind(this) },
	                    this.state.dayValue && !this.state.dayOpen ? this.formatList(this.state.dayValue) : 'Select Day'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.dayOpen ? 'expandSection expanded' : 'expandSection' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: this.state.dayValue.includes('Monday') ? 'dropElement selected' : 'dropElement', onClick: function onClick() {
	                          return _this10.selectDay('Monday');
	                        } },
	                      'Monday'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: this.state.dayValue.includes('Tuesday') ? 'dropElement selected' : 'dropElement', onClick: function onClick() {
	                          return _this10.selectDay('Tuesday');
	                        } },
	                      'Tuesday'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: this.state.dayValue.includes('Wednesday') ? 'dropElement selected' : 'dropElement', onClick: function onClick() {
	                          return _this10.selectDay('Wednesday');
	                        } },
	                      'Wednesday'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: this.state.dayValue.includes('Thursday') ? 'dropElement selected' : 'dropElement', onClick: function onClick() {
	                          return _this10.selectDay('Thursday');
	                        } },
	                      'Thursday'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: this.state.dayValue.includes('Friday') ? 'dropElement selected' : 'dropElement', onClick: function onClick() {
	                          return _this10.selectDay('Friday');
	                        } },
	                      'Friday'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: this.state.dayValue.includes('Saturday') ? 'dropElement selected' : 'dropElement', onClick: function onClick() {
	                          return _this10.selectDay('Saturday');
	                        } },
	                      'Saturday'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'timeElement' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'timeWrapper', ref: function ref(div) {
	                      _this10.timeBody = div;
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'dropElement EllipsisElement', onClick: this.toggleTime.bind(this) },
	                    this.state.timeValue && !this.state.timeOpen ? this.formatList(this.state.timeValue) : 'Select Time'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.timeOpen ? 'expandSection expanded' : 'expandSection' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: this.state.timeValue.includes('Morning') ? 'dropElement selected' : 'dropElement', onClick: function onClick() {
	                          return _this10.selectTime('Morning');
	                        } },
	                      'Morning'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: this.state.timeValue.includes('Afternoon') ? 'dropElement selected' : 'dropElement', onClick: function onClick() {
	                          return _this10.selectTime('Afternoon');
	                        } },
	                      'Afternoon'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: this.state.timeValue.includes('Evening') ? 'dropElement selected' : 'dropElement', onClick: function onClick() {
	                          return _this10.selectTime('Evening');
	                        } },
	                      'Evening'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow darkBg' },
	            _react2.default.createElement(
	              'div',
	              { className: 'textareaLabelWrapper' },
	              'Additional Details:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'textareaInputWrapper' },
	              _react2.default.createElement('textarea', {
	                className: this.state.errorDetails ? 'textTextarea error' : 'textTextarea',
	                value: this.state.inputDetails,
	                onChange: this.changeDetails.bind(this) })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow darkBg bottomRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'submitButton actionButton', onClick: this.submitContactRequest.bind(this) },
	              'Request an Appointment'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ScheduleShoppingForm;
	}(_react2.default.Component);
	
	ScheduleShoppingForm.propTypes = {
	  location: _react.PropTypes.object
	};
	ScheduleShoppingForm.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ScheduleShoppingForm;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ScheduleShoppingFormContainer = exports.ScheduleShoppingFormContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ScheduleShoppingForm);

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOGOUT_TIME = exports.LOGOUT_TIME = 1 * 7 * 24 * 60 * 60 * 1000;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var locations = exports.locations = [{
	  key: 'atx',
	  title: 'Diamonds Direct Austin',
	  name: 'Austin, TX',
	  email: 'infoAUS@diamondsdirect.com',
	  phone: '5126919950',
	  address1: '11104 Domain Drive',
	  address2: 'Austin, TX 78758',
	  number: 5
	}, {
	  key: 'bhm',
	  title: 'Diamonds Direct Birmingham',
	  name: 'Birmingham, AL',
	  email: 'infoBHM@diamondsdirect.com',
	  phone: '2052017400',
	  address1: '2800 Cahaba Village Plz.',
	  address2: 'Birmingham, AL 35243',
	  number: 3
	}, {
	  key: 'boc',
	  title: 'Diamonds Direct Boca Raton',
	  name: 'Boca Raton, FL',
	  email: 'infoBOCA@diamondsdirect.com',
	  phone: '5614142091',
	  address1: '21078 St. Andrews Blvd',
	  address2: 'Boca Raton, Florida 33433',
	  number: 21
	}, {
	  key: 'chs',
	  title: 'Diamonds Direct Charleston',
	  name: 'Charleston, SC',
	  email: 'infoCHS@diamondsdirect.com',
	  phone: '8436062558',
	  address1: '1911 Highway 17N',
	  address2: 'Mt. Pleasant, SC 29464',
	  number: 7
	}, {
	  key: 'clt',
	  title: 'Diamonds Direct Charlotte',
	  name: 'Charlotte, NC',
	  email: 'infoCLT@diamondsdirect.com',
	  phone: '7045329041',
	  address1: '4521 Sharon Road',
	  address2: 'Charlotte, NC 28211',
	  number: 1
	}, {
	  key: 'cle',
	  title: 'Diamonds Direct Cleveland',
	  name: 'Cleveland, OH',
	  email: 'infoCLE@diamondsdirect.com',
	  phone: '2162732812',
	  address1: '2101 Richmond Rd.',
	  address2: 'Beachwood, OH 44122',
	  number: 17
	}, {
	  key: 'coh',
	  title: 'Diamonds Direct Columbus',
	  name: 'Columbus, OH',
	  email: 'infocol@diamondsdirect.com',
	  phone: '6145160515',
	  address1: '1330 Polaris Pkwy',
	  address2: 'Columbus, OH 43240',
	  number: 16
	}, {
	  key: 'dfw',
	  title: 'Diamonds Direct Dallas',
	  name: 'Dallas, TX',
	  email: 'infoDTX@diamondsdirect.com',
	  phone: '9723426663',
	  address1: '8127 Preston Rd.',
	  address2: 'Dallas, TX 75225',
	  number: 11
	}, {
	  key: 'ftx',
	  title: 'Diamonds Direct Frisco',
	  name: 'Frisco, TX',
	  email: 'infoFRISCO@diamondsdirect.com',
	  phone: '4698504270',
	  address1: '8440 State Hwy 121, Bldg A',
	  address2: 'Frisco, TX 75034',
	  number: 18
	}, {
	  key: 'gsc',
	  title: 'Diamonds Direct Greenville',
	  name: 'Greenville, SC',
	  email: 'infoGVL@diamondsdirect.com',
	  phone: '8645015090',
	  address1: '8440 State Hwy 121, Bldg A',
	  address2: 'Greenville, SC. 29607',
	  number: 22
	}, {
	  key: 'bay',
	  title: 'Diamonds Direct Houston (Baybrook)',
	  name: 'Baybrook, TX',
	  email: 'infoBAY@diamondsdirect.com',
	  phone: '2816123632',
	  address1: '8610 Gulf Frwy',
	  address2: 'Friendswood, TX 77546',
	  number: 25
	}, {
	  key: 'hou',
	  title: 'Diamonds Direct Houston (Galleria)',
	  name: 'Houston, TX',
	  email: 'infoHOU@diamondsdirect.com',
	  phone: '3462502054',
	  address1: '3115 West Loop S.',
	  address2: 'Houston, TX 77027',
	  number: 23
	}, {
	  key: 'ind',
	  title: 'Diamonds Direct Indianapolis',
	  name: 'Indianapolis, IN',
	  email: 'infoindy@diamondsdirect.com',
	  phone: '3175758555',
	  address1: '8557 North River Road',
	  address2: 'Indianapolis, IN 46240',
	  number: 12
	}, {
	  key: 'jax',
	  title: 'Diamonds Direct Jacksonville',
	  name: 'Jacksonville, FL',
	  email: 'infojax@diamondsdirect.com',
	  phone: '9045155959',
	  address1: '4840 Town Center Parkway',
	  address2: 'Jacksonville, FL 32246',
	  number: 14
	}, {
	  key: 'kcy',
	  title: 'Diamonds Direct Kansas City',
	  name: 'Kansas City, KS',
	  email: 'infoKSC@diamondsdirect.com',
	  phone: '9133121660',
	  address1: '4500 W 119th Street',
	  address2: 'Leawood, KS 66209',
	  number: 19
	}, {
	  key: 'nol',
	  title: 'Diamonds Direct New Orleans',
	  name: 'New Orleans, LA',
	  email: 'infoNOLA@diamondsdirect.com',
	  phone: '5043833900',
	  address1: '3230 Severn Ave',
	  address2: 'Metairie, LA 70002',
	  number: 20
	}, {
	  key: 'nva',
	  title: 'Diamonds Direct Tysons',
	  name: 'Tysons, LA',
	  email: 'infoTYS@diamondsdirect.com',
	  phone: '5713076220',
	  address1: '8113 Leesburg Pike',
	  address2: 'Vienna, VA 22182',
	  number: 26
	}, {
	  key: 'pit',
	  title: 'Diamonds Direct Pittsburgh',
	  name: 'Pittsburgh, PA',
	  email: 'infoPITT@diamondsdirect.com',
	  phone: '4128379070',
	  address1: '5004 McKnight Rd.',
	  address2: 'Pittsburgh, PA 15237',
	  number: 24
	}, {
	  key: 'okc',
	  title: 'Diamonds Direct Oklahoma City',
	  name: 'Oklahoma City, OK',
	  email: 'infoOKC@diamondsdirect.com',
	  phone: '4056088802',
	  address1: '5521 North Pennsylvania Ave',
	  address2: 'Oklahoma City, OK 73112',
	  number: 8
	}, {
	  key: 'ral',
	  title: 'Diamonds Direct Raleigh',
	  name: 'Raleigh, NC',
	  email: 'infoRal@diamondsdirect.com',
	  phone: '9195712881',
	  address1: '4401 Glenwood Avenue',
	  address2: 'Raleigh, NC 27612',
	  number: 4
	}, {
	  key: 'rva',
	  title: 'Diamonds Direct Richmond',
	  name: 'Richmond, VA',
	  email: 'infoRic@diamondsdirect.com',
	  phone: '8049670500',
	  address1: '11131 West Broad Street',
	  address2: 'Glen Allen, VA 23060',
	  number: 6
	}, {
	  key: 'stl',
	  title: 'Diamonds Direct St. Louis',
	  name: 'St. Louis, MO',
	  email: 'infostl@diamondsdirect.com',
	  phone: '3149423777',
	  address1: '11619 Olive Blvd',
	  address2: 'Saint Louis, MO 63141',
	  number: 13
	}, {
	  key: 'san',
	  title: 'Diamonds Direct San Antonio',
	  name: 'San Antonio, TX',
	  email: 'infoSAT@diamondsdirect.com',
	  phone: '2102479197',
	  address1: '15900 La Cantera Pky, Bldg 18',
	  address2: 'San Antonio, TX 78256',
	  number: 10
	}, {
	  key: 'vab',
	  title: 'Diamonds Direct Virginia Beach',
	  name: 'Virginia Beach, VA',
	  email: 'infoVAB@diamondsdirect.com',
	  phone: '7578370288',
	  address1: '4452 Virginia Beach Blvd',
	  address2: 'Virginia Beach, VA 23462',
	  number: 9
	}, {
	  key: 'try',
	  title: 'Diamonds Direct Troy',
	  name: 'Troy, MI',
	  email: 'infoTROY@diamondsdirect.com',
	  phone: '2485095435',
	  address1: '1985 West Big Beaver Rd. Ste 100',
	  address2: 'Troy, MI 48084',
	  number: 27
	}];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(646), __esModule: true };

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(648), __esModule: true };

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(629);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(323);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	/**
	 * toString ref.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Return the type of `val`.
	 *
	 * @param {Mixed} val
	 * @return {String}
	 * @api public
	 */
	
	module.exports = function(val){
	  switch (toString.call(val)) {
	    case '[object Date]': return 'date';
	    case '[object RegExp]': return 'regexp';
	    case '[object Arguments]': return 'arguments';
	    case '[object Array]': return 'array';
	    case '[object Error]': return 'error';
	  }
	
	  if (val === null) return 'null';
	  if (val === undefined) return 'undefined';
	  if (val !== val) return 'nan';
	  if (val && val.nodeType === 1) return 'element';
	
	  val = val.valueOf
	    ? val.valueOf()
	    : Object.prototype.valueOf.apply(val)
	
	  return typeof val;
	};


/***/ }),
/* 225 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(652);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(101);
	var dPs = __webpack_require__(666);
	var enumBugKeys = __webpack_require__(228);
	var IE_PROTO = __webpack_require__(232)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(328)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(657).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(92).f;
	var has = __webpack_require__(102);
	var TAG = __webpack_require__(65)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(233)('keys');
	var uid = __webpack_require__(175);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(43);
	var global = __webpack_require__(91);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(173) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(126);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(91);
	var core = __webpack_require__(43);
	var LIBRARY = __webpack_require__(173);
	var wksExt = __webpack_require__(237);
	var defineProperty = __webpack_require__(92).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(65);


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(674);
	var global = __webpack_require__(91);
	var hide = __webpack_require__(125);
	var Iterators = __webpack_require__(127);
	var TO_STRING_TAG = __webpack_require__(65)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(188)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(35);
	var toAbsoluteIndex = __webpack_require__(111);
	var toLength = __webpack_require__(29);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(685);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(33);
	var createDesc = __webpack_require__(108);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	var document = __webpack_require__(20).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 244 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(27)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(20).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	var setPrototypeOf = __webpack_require__(256).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(131);
	var ITERATOR = __webpack_require__(27)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(105);
	var descriptor = __webpack_require__(108);
	var setToStringTag = __webpack_require__(132);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(49)(IteratorPrototype, __webpack_require__(27)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(94);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(50);
	var hide = __webpack_require__(49);
	var Iterators = __webpack_require__(131);
	var $iterCreate = __webpack_require__(249);
	var setToStringTag = __webpack_require__(132);
	var getPrototypeOf = __webpack_require__(59);
	var ITERATOR = __webpack_require__(27)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(20);
	var macrotask = __webpack_require__(261).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(66)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(44);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(157);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(24);
	var anObject = __webpack_require__(16);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(68)(Function.call, __webpack_require__(58).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(160)('keys');
	var uid = __webpack_require__(112);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(181);
	var defined = __webpack_require__(76);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(70);
	var defined = __webpack_require__(76);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(68);
	var invoke = __webpack_require__(350);
	var html = __webpack_require__(246);
	var cel = __webpack_require__(243);
	var global = __webpack_require__(20);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(66)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(20);
	var DESCRIPTORS = __webpack_require__(32);
	var LIBRARY = __webpack_require__(94);
	var $typed = __webpack_require__(189);
	var hide = __webpack_require__(49);
	var redefineAll = __webpack_require__(109);
	var fails = __webpack_require__(22);
	var anInstance = __webpack_require__(103);
	var toInteger = __webpack_require__(70);
	var toLength = __webpack_require__(29);
	var toIndex = __webpack_require__(369);
	var gOPN = __webpack_require__(106).f;
	var dP = __webpack_require__(33).f;
	var arrayFill = __webpack_require__(240);
	var setToStringTag = __webpack_require__(132);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(20);
	var core = __webpack_require__(67);
	var LIBRARY = __webpack_require__(94);
	var wksExt = __webpack_require__(370);
	var defineProperty = __webpack_require__(33).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(130);
	var ITERATOR = __webpack_require__(27)('iterator');
	var Iterators = __webpack_require__(131);
	module.exports = __webpack_require__(67).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(93);
	var step = __webpack_require__(353);
	var Iterators = __webpack_require__(131);
	var toIObject = __webpack_require__(60);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(250)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(937),
	    getPrototype = __webpack_require__(939),
	    isObjectLike = __webpack_require__(944);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(956);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dialog = __webpack_require__(972);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dialog2.default;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(981);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Subheader = __webpack_require__(401);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var hasSubheader = false;
	
	      var firstChild = _react.Children.toArray(children)[0];
	      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
	        hasSubheader = true;
	      }
	
	      var styles = {
	        root: {
	          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? List.propTypes = {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = List;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(118);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(85);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(135);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(1057);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(1058);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(989);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var insetChildren = props.insetChildren,
	      leftAvatar = props.leftAvatar,
	      leftCheckbox = props.leftCheckbox,
	      leftIcon = props.leftIcon,
	      nestedLevel = props.nestedLevel,
	      rightAvatar = props.rightAvatar,
	      rightIcon = props.rightIcon,
	      rightIconButton = props.rightIconButton,
	      rightToggle = props.rightToggle,
	      secondaryText = props.secondaryText,
	      secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var styles = {
	    root: {
	      backgroundColor: (state.isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleNestedListToggle = function (event) {
	      event.stopPropagation();
	
	      if (_this.props.open === null) {
	        _this.setState({ open: !_this.state.open }, function () {
	          _this.props.onNestedListToggle(_this);
	        });
	      } else {
	        // Exposing `this` in the callback is quite a bad API.
	        // I'm doing a one level deep clone to expose a fake state.open.
	        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
	          state: {
	            open: !_this.state.open
	          }
	        }));
	      }
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonTouchTap = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchEnd(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.open !== null) this.setState({ open: nextProps.open });
	      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      var button = this.refs.enhancedButton;
	
	      if (button) {
	        var buttonEl = _reactDom2.default.findDOMNode(button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props,
	          innerDivStyle = _props.innerDivStyle,
	          style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props,
	          innerDivStyle = _props2.innerDivStyle,
	          style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
	          children = _props3.children,
	          disabled = _props3.disabled,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          hoverColor = _props3.hoverColor,
	          initiallyOpen = _props3.initiallyOpen,
	          innerDivStyle = _props3.innerDivStyle,
	          insetChildren = _props3.insetChildren,
	          leftAvatar = _props3.leftAvatar,
	          leftCheckbox = _props3.leftCheckbox,
	          leftIcon = _props3.leftIcon,
	          nestedItems = _props3.nestedItems,
	          nestedLevel = _props3.nestedLevel,
	          nestedListStyle = _props3.nestedListStyle,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onNestedListToggle = _props3.onNestedListToggle,
	          onTouchStart = _props3.onTouchStart,
	          onTouchTap = _props3.onTouchTap,
	          rightAvatar = _props3.rightAvatar,
	          rightIcon = _props3.rightIcon,
	          rightIconButton = _props3.rightIconButton,
	          rightToggle = _props3.rightToggle,
	          primaryText = _props3.primaryText,
	          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
	          secondaryText = _props3.secondaryText,
	          secondaryTextLines = _props3.secondaryTextLines,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onTouchTap', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onTouchTap: this.handleRightIconButtonTouchTap,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onTouchTap = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({
	            containerElement: 'span'
	          }, other, {
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchEnd: this.handleTouchEnd,
	            onTouchTap: primaryTogglesNestedList ? this.handleNestedListToggle : onTouchTap,
	            ref: 'enhancedButton',
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  open: null,
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ListItem.propTypes = {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _react.PropTypes.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _react.PropTypes.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	  * Override the hover background color.
	  */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _react.PropTypes.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Callbak function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /** @ignore */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Control toggle state of nested list.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _react.PropTypes.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _react.PropTypes.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _react.PropTypes.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ListItem;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(118);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(136);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(1054);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(273);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(194);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var indent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      minHeight: props.desktop ? '32px' : '48px',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
	      paddingRight: props.rightIcon ? indent : sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onTouchTap: function onTouchTap(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onTouchTap) {
	            item.props.onTouchTap(event);
	          }
	        }
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          children = _props.children,
	          desktop = _props.desktop,
	          disabled = _props.disabled,
	          focusState = _props.focusState,
	          innerDivStyle = _props.innerDivStyle,
	          insetChildren = _props.insetChildren,
	          leftIcon = _props.leftIcon,
	          menuItems = _props.menuItems,
	          rightIcon = _props.rightIcon,
	          secondaryText = _props.secondaryText,
	          style = _props.style,
	          animation = _props.animation,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'value']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            animation: animation,
	            anchorOrigin: { horizontal: 'right', vertical: 'top' },
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onTouchTap = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          hoverColor: this.context.muiTheme.menuItem.hoverColor,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.defaultProps = {
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false
	};
	MenuItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? MenuItem.propTypes = {
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _react.PropTypes.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _react.PropTypes.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the menu item.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = MenuItem;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(274);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? PopoverAnimationVertical.propTypes = {
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin.isRequired,
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = PopoverAnimationVertical;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(414);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeaderColumn = context.muiTheme.tableHeaderColumn;
	
	
	  return {
	    root: {
	      fontWeight: 'normal',
	      fontSize: 12,
	      paddingLeft: tableHeaderColumn.spacing,
	      paddingRight: tableHeaderColumn.spacing,
	      height: tableHeaderColumn.height,
	      textAlign: 'left',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis',
	      color: tableHeaderColumn.textColor,
	      position: 'relative'
	    },
	    tooltip: {
	      boxSizing: 'border-box',
	      marginTop: tableHeaderColumn.height / 2
	    }
	  };
	}
	
	var TableHeaderColumn = function (_Component) {
	  (0, _inherits3.default)(TableHeaderColumn, _Component);
	
	  function TableHeaderColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeaderColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeaderColumn.__proto__ || (0, _getPrototypeOf2.default)(TableHeaderColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onMouseEnter = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: true });
	      }
	    }, _this.onMouseLeave = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: false });
	      }
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeaderColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipStyle = _props.tooltipStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style', 'tooltip', 'tooltipStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        onClick: this.onClick
	      };
	
	      var tooltipNode = void 0;
	
	      if (tooltip !== undefined) {
	        tooltipNode = _react2.default.createElement(_Tooltip2.default, {
	          label: tooltip,
	          show: this.state.hovered,
	          style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyle)
	        });
	      }
	
	      return _react2.default.createElement(
	        'th',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        tooltipNode,
	        children
	      );
	    }
	  }]);
	  return TableHeaderColumn;
	}(_react.Component);
	
	TableHeaderColumn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TableHeaderColumn.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _react.PropTypes.number,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  hoverable: _react.PropTypes.bool,
	  /** @ignore */
	  onClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHoverExit: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The string to supply to the tooltip. If not
	   * string is supplied no tooltip will be shown.
	   */
	  tooltip: _react.PropTypes.string,
	  /**
	   * Additional styling that can be applied to the tooltip.
	   */
	  tooltipStyle: _react.PropTypes.object
	} : void 0;
	exports.default = TableHeaderColumn;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(197);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  (0, _inherits3.default)(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.Component);
	
	process.env.NODE_ENV !== "production" ? ClickAwayListener.propTypes = {
	  children: _react.PropTypes.element,
	  onClickAway: _react.PropTypes.func
	} : void 0;
	exports.default = ClickAwayListener;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(87);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(280);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(415);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      position: 'relative',
	      overflow: 'visible',
	      display: 'table',
	      height: 'auto',
	      width: '100%'
	    },
	    input: {
	      position: 'absolute',
	      cursor: 'inherit',
	      pointerEvents: 'all',
	      opacity: 0,
	      width: '100%',
	      height: '100%',
	      zIndex: 2,
	      left: 0,
	      boxSizing: 'border-box',
	      padding: 0,
	      margin: 0
	    },
	    controls: {
	      display: 'flex',
	      width: '100%',
	      height: '100%'
	    },
	    label: {
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      width: 'calc(100% - 60px)',
	      lineHeight: '24px',
	      color: baseTheme.palette.textColor,
	      fontFamily: baseTheme.fontFamily
	    },
	    wrap: {
	      transition: _transitions2.default.easeOut(),
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      flexShrink: 0,
	      width: 60 - baseTheme.spacing.desktopGutterLess,
	      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
	    },
	    ripple: {
	      color: props.rippleColor || baseTheme.palette.primary1Color,
	      height: '200%',
	      width: '200%',
	      top: -12,
	      left: -12
	    }
	  };
	}
	
	var EnhancedSwitch = function (_Component) {
	  (0, _inherits3.default)(EnhancedSwitch, _Component);
	
	  function EnhancedSwitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleChange = function (event) {
	      _this.tabPressed = false;
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      var isInputChecked = _this.refs.checkbox.checked;
	
	      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
	        _this.props.onParentShouldUpdate(isInputChecked);
	      }
	
	      if (_this.props.onSwitch) {
	        _this.props.onSwitch(event, isInputChecked);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var code = (0, _keycode2.default)(event);
	
	      if (code === 'tab') {
	        _this.tabPressed = true;
	      }
	      if (_this.state.isKeyboardFocused && code === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.refs.touchRipple.start(event);
	      }
	    }, _this.handleMouseUp = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleMouseLeave = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleTouchStart = function (event) {
	      _this.refs.touchRipple.start(event);
	    }, _this.handleTouchEnd = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      // setTimeout is needed becuase the focus event fires first
	      // Wait so that we can capture if this was a keyboard focus
	      // or touch focus
	      setTimeout(function () {
	        if (_this.tabPressed) {
	          _this.setState({
	            isKeyboardFocused: true
	          });
	        }
	      }, 150);
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedSwitch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = this.refs.checkbox;
	      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
	        this.props.onParentShouldUpdate(inputNode.checked);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCheckedProp = nextProps.hasOwnProperty('checked');
	      var hasToggledProp = nextProps.hasOwnProperty('toggled');
	      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (hasCheckedProp || hasToggledProp || hasNewDefaultProp) {
	        var switched = nextProps.checked || nextProps.toggled || nextProps.defaultChecked || false;
	
	        this.setState({
	          switched: switched
	        });
	
	        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
	          this.props.onParentShouldUpdate(switched);
	        }
	      }
	    }
	  }, {
	    key: 'isSwitched',
	    value: function isSwitched() {
	      return this.refs.checkbox.checked;
	    }
	
	    // no callback here because there is no event
	
	  }, {
	    key: 'setSwitched',
	    value: function setSwitched(newSwitchedValue) {
	      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	        if (this.props.onParentShouldUpdate) {
	          this.props.onParentShouldUpdate(newSwitchedValue);
	        }
	        this.refs.checkbox.checked = newSwitchedValue;
	      } else {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.checkbox.value;
	    }
	
	    // Checkbox inputs only use SPACE to change their state. Using ENTER will
	    // update the ui but not the input.
	
	
	    /**
	     * Because both the ripples and the checkbox input cannot share pointer
	     * events, the checkbox input takes control of pointer events and calls
	     * ripple animations manually.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          iconStyle = _props.iconStyle,
	          inputStyle = _props.inputStyle,
	          inputType = _props.inputType,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onSwitch = _props.onSwitch,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onParentShouldUpdate = _props.onParentShouldUpdate,
	          disabled = _props.disabled,
	          disableTouchRipple = _props.disableTouchRipple,
	          disableFocusRipple = _props.disableFocusRipple,
	          className = _props.className,
	          rippleColor = _props.rippleColor,
	          rippleStyle = _props.rippleStyle,
	          style = _props.style,
	          switched = _props.switched,
	          switchElement = _props.switchElement,
	          thumbStyle = _props.thumbStyle,
	          trackStyle = _props.trackStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
	      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	      if (thumbStyle) {
	        wrapStyles.marginLeft /= 2;
	        wrapStyles.marginRight /= 2;
	      }
	
	      var labelElement = label && _react2.default.createElement(
	        'label',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var showTouchRipple = !disabled && !disableTouchRipple;
	      var showFocusRipple = !disabled && !disableFocusRipple;
	
	      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
	        ref: 'touchRipple',
	        key: 'touchRipple',
	        style: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        centerRipple: true
	      });
	
	      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	        key: 'focusRipple',
	        innerStyle: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        show: this.state.isKeyboardFocused
	      });
	
	      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];
	
	      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
	        ref: 'checkbox',
	        type: inputType,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
	        name: name,
	        value: value,
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange,
	        onMouseUp: showTouchRipple && this.handleMouseUp,
	        onMouseDown: showTouchRipple && this.handleMouseDown,
	        onMouseLeave: showTouchRipple && this.handleMouseLeave,
	        onTouchStart: showTouchRipple && this.handleTouchStart,
	        onTouchEnd: showTouchRipple && this.handleTouchEnd
	      }));
	
	      // If toggle component (indicated by whether the style includes thumb) manually lay out
	      // elements in order to nest ripple elements
	      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        switchElement,
	        ripples
	      ) : _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: thumbStyle, zDepth: 1, circle: true },
	          ' ',
	          ripples,
	          ' '
	        )
	      );
	
	      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        switchOrThumbElement,
	        labelElement
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        labelElement,
	        switchOrThumbElement
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp
	        }),
	        inputElement,
	        elementsInOrder
	      );
	    }
	  }]);
	  return EnhancedSwitch;
	}(_react.Component);
	
	EnhancedSwitch.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? EnhancedSwitch.propTypes = {
	  checked: _react.PropTypes.bool,
	  className: _react.PropTypes.string,
	  defaultChecked: _react.PropTypes.bool,
	  disableFocusRipple: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  iconStyle: _react.PropTypes.object,
	  inputStyle: _react.PropTypes.object,
	  inputType: _react.PropTypes.string.isRequired,
	  label: _react.PropTypes.node,
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  labelStyle: _react.PropTypes.object,
	  name: _react.PropTypes.string,
	  onBlur: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onMouseDown: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onMouseUp: _react.PropTypes.func,
	  onParentShouldUpdate: _react.PropTypes.func,
	  onSwitch: _react.PropTypes.func,
	  onTouchEnd: _react.PropTypes.func,
	  onTouchStart: _react.PropTypes.func,
	  rippleColor: _react.PropTypes.string,
	  rippleStyle: _react.PropTypes.object,
	  style: _react.PropTypes.object,
	  switchElement: _react.PropTypes.element.isRequired,
	  switched: _react.PropTypes.bool.isRequired,
	  thumbStyle: _react.PropTypes.object,
	  trackStyle: _react.PropTypes.object,
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = EnhancedSwitch;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(118);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(114);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(1043);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  (0, _inherits3.default)(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color,
	          innerStyle = props.innerStyle,
	          opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? FocusRipple.propTypes = {
	  color: _react.PropTypes.string,
	  innerStyle: _react.PropTypes.object,
	  opacity: _react.PropTypes.number,
	  show: _react.PropTypes.bool,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FocusRipple;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(166);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _SlideInChild = __webpack_require__(1045);
	
	var _SlideInChild2 = _interopRequireDefault(_SlideInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideIn = function (_Component) {
	  (0, _inherits3.default)(SlideIn, _Component);
	
	  function SlideIn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SlideIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideIn.__proto__ || (0, _getPrototypeOf2.default)(SlideIn)).call.apply(_ref, [this].concat(args))), _this), _this.getLeaveDirection = function () {
	      return _this.props.direction;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SlideIn, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          direction = _props.direction,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _SlideInChild2.default,
	          {
	            key: child.key,
	            direction: direction,
	            enterDelay: enterDelay,
	            getLeaveDirection: _this2.getLeaveDirection,
	            style: childStyle
	          },
	          child
	        );
	      }, this);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return SlideIn;
	}(_react.Component);
	
	SlideIn.defaultProps = {
	  enterDelay: 0,
	  direction: 'left'
	};
	SlideIn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? SlideIn.propTypes = {
	  childStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  direction: _react.PropTypes.oneOf(['left', 'right', 'up', 'down']),
	  enterDelay: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = SlideIn;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(137);
	var Danger = __webpack_require__(1082);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(62);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(291);
	var setInnerHTML = __webpack_require__(204);
	var setTextContent = __webpack_require__(441);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (process.env.NODE_ENV !== 'production') {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (process.env.NODE_ENV !== 'production') {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (process.env.NODE_ENV !== 'production') {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (process.env.NODE_ENV !== 'production') {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (process.env.NODE_ENV !== 'production') {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (process.env.NODE_ENV !== 'production') {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (process.env.NODE_ENV !== 'production') {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (process.env.NODE_ENV !== 'production') {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactPropTypesSecret = __webpack_require__(433);
	var propTypesFactory = __webpack_require__(420);
	
	var React = __webpack_require__(146);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (process.env.NODE_ENV !== 'production') {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(80);
	var ReactInstanceMap = __webpack_require__(167);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactUpdates = __webpack_require__(79);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (process.env.NODE_ENV !== 'production') {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (process.env.NODE_ENV !== 'production') {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (process.env.NODE_ENV !== 'production') {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var emptyFunction = __webpack_require__(71);
	var warning = __webpack_require__(19);
	
	var validateDOMNesting = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(46);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(168);
	
	var _createReactClass = __webpack_require__(83);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(46);
	
	var _getRouteParams = __webpack_require__(1169);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(299);
	
	var _RouteUtils = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(145);
	
	var _DOMUtils = __webpack_require__(206);
	
	var _DOMStateStorage = __webpack_require__(453);
	
	var _PathUtils = __webpack_require__(98);
	
	var _ExecutionEnvironment = __webpack_require__(303);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1175);
	
	var _PathUtils = __webpack_require__(98);
	
	var _runTransitionHook = __webpack_require__(305);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(205);
	
	var _LocationUtils = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(54);
	var settle = __webpack_require__(473);
	var buildURL = __webpack_require__(475);
	var parseHeaders = __webpack_require__(481);
	var isURLSameOrigin = __webpack_require__(479);
	var createError = __webpack_require__(310);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(477);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 308 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(472);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 311 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContactPageContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	var _ScheduleShoppingForm = __webpack_require__(218);
	
	var _ScheduleServiceForm = __webpack_require__(217);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var ContactPage = function (_React$Component) {
	  _inherits(ContactPage, _React$Component);
	
	  function ContactPage(props) {
	    _classCallCheck(this, ContactPage);
	
	    var _this = _possibleConstructorReturn(this, (ContactPage.__proto__ || Object.getPrototypeOf(ContactPage)).call(this, props));
	
	    var firstEntry = [{ display: 'Location*', 'value': '' }];
	    var finalEntry = [{ display: 'Virtual/Other', 'value': 'online@diamondsdirect.com' }];
	
	    var newArray = firstEntry.concat(locations.locations).concat(finalEntry);
	
	    _this.state = {
	
	      selectedOption: null,
	      selectedForm: null,
	
	      locations: newArray,
	
	      inputName: '',
	      inputEmail: '',
	      inputPhone: '',
	      inputLocation: '',
	      inputMessage: '',
	
	      errorName: null,
	      errorEmail: null,
	      errorPhone: null,
	      errorLocation: null,
	      errorMessage: null,
	
	      formOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(ContactPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Contact Us';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      // window.Intercom('show');
	      acquireIO.max();
	    }
	  }, {
	    key: 'changeName',
	    value: function changeName(evt) {
	      var _this2 = this;
	
	      this.setState({ inputName: evt.target.value }, function () {
	        if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
	          _this2.setState({ errorName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      var _this3 = this;
	
	      this.setState({ inputEmail: evt.target.value }, function () {
	        if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
	          _this3.setState({ errorEmail: null });
	        }
	      });
	    }
	  }, {
	    key: 'changePhone',
	    value: function changePhone(evt) {
	      var _this4 = this;
	
	      this.setState({ inputPhone: evt.target.value }, function () {
	        if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
	          _this4.setState({ errorPhone: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeLocation',
	    value: function changeLocation(evt) {
	      var _this5 = this;
	
	      this.setState({ inputLocation: evt.target.value }, function () {
	        if (_this5.state.errorLocation !== false && location !== '') {
	          _this5.setState({ errorLocation: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeMessage',
	    value: function changeMessage(evt) {
	      var _this6 = this;
	
	      this.setState({ inputMessage: evt.target.value }, function () {
	        if (_this6.state.errorMessage && !(0, _itemValidation.messageTextValidation)(_this6.state.inputMessage)) {
	          _this6.setState({ errorMessage: null });
	        }
	      });
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var hasErrors = true;
	
	      // Required params
	      var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
	      var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
	      var messageError = (0, _itemValidation.messageTextValidation)(this.state.inputMessage);
	      var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
	      // Optional params
	      var phoneError = null;
	      if (this.state.inputPhone) {
	        phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
	      }
	
	      if (nameError === null && emailError === null && phoneError === null && locationError === null && messageError === null) {
	        hasErrors = false;
	      }
	
	      this.setState({
	        errorName: nameError,
	        errorEmail: emailError,
	        errorPhone: phoneError,
	        errorLocation: locationError,
	        errorMessage: messageError
	      });
	
	      return !hasErrors;
	    }
	  }, {
	    key: 'submitContactRequest',
	    value: function submitContactRequest() {
	      var _this7 = this;
	
	      if (this.validateAll()) {
	
	        var contactData = {
	          full_name: this.state.inputName,
	          email: this.state.inputEmail,
	          phone: this.state.inputPhone,
	          location: this.state.inputLocation,
	          message: this.state.inputMessage
	        };
	
	        this.props.commonContactRequest(contactData).then(function () {
	          _this7.context.router.push('/thank-you');
	          // this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly to finalize your virtual appointment.', 'Continue Browsing', 'helping', '');
	        });
	        this.setState({
	          inputName: '',
	          inputEmail: '',
	          inputPhone: '',
	          inputLocation: '',
	          inputMessage: '',
	          errorName: null,
	          errorEmail: null,
	          errorPhone: null,
	          errorLocation: null,
	          errorMessage: null
	        });
	        this.props.commonCloseContact();
	      }
	    }
	  }, {
	    key: 'toggleFormOpen',
	    value: function toggleFormOpen() {
	      this.setState({ formOpen: !this.state.formOpen });
	    }
	  }, {
	    key: 'toggleOption',
	    value: function toggleOption(optionValue) {
	      if (!optionValue) {
	        return;
	      }
	
	      if (optionValue === this.state.selectedOption) {
	        this.setState({ selectedOption: null, selectedForm: null });
	      } else {
	        this.setState({ selectedOption: optionValue, selectedForm: null });
	      }
	    }
	  }, {
	    key: 'toggleForm',
	    value: function toggleForm(formValue) {
	      var _this8 = this;
	
	      if (!formValue) {
	        return;
	      }
	
	      if (formValue === this.state.selectedForm) {
	        this.setState({ selectedForm: null });
	      } else {
	        this.setState({ selectedForm: formValue }, function () {
	          _this8.scrollToForm();
	        });
	      }
	    }
	  }, {
	    key: 'scrollToForm',
	    value: function scrollToForm() {
	      (0, _reactScrollToComponent2.default)(this.formWrapper, {
	        offset: -100,
	        align: 'top',
	        duration: 750,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ContactPage', ref: function ref(div) {
	            _this9.parentForm = div;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleHeader' },
	          'Connect with an Expert'
	        ),
	        _react2.default.createElement('div', { className: 'scheduleLeftBg' }),
	        _react2.default.createElement('div', { className: 'scheduleRightBg' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleBody' },
	          _react2.default.createElement('div', { className: 'scheduleBr' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbText' },
	            'Now more than ever before, we are focused on customizing the Diamonds Direct experience.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'optionsWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'singleOption' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.selectedOption === 'online' ? 'optionItem selected' : 'optionItem', onClick: function onClick() {
	                    return _this9.toggleOption('online');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'optionImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/contact/chat.svg' })
	                ),
	                _react2.default.createElement('div', { className: 'optionBr' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'optionTitle' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Connect with an expert',
	                    _react2.default.createElement('br', null),
	                    'ONLINE'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'optionButton', onClick: this.openIntercom.bind(this) },
	                  'Chat Now'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.selectedOption === 'online' ? 'optionRow open' : 'optionRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'optionRowButton', onClick: this.openIntercom.bind(this) },
	                  'Live Chat with an Expert'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'optionRowButton', onClick: function onClick() {
	                      return _this9.internalNav('video-chat');
	                    } },
	                  'Live Video with an Expert'
	                )
	              ),
	              _react2.default.createElement('div', { className: 'optionFormMobile' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'singleOption' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.selectedOption === 'store' ? 'optionItem selected' : 'optionItem', onClick: function onClick() {
	                    return _this9.toggleOption('store');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'optionImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/contact/video.svg' })
	                ),
	                _react2.default.createElement('div', { className: 'optionBr' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'optionTitle' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Connect with an expert',
	                    _react2.default.createElement('br', null),
	                    'IN STORE'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'optionButton', onClick: function onClick() {
	                      return _this9.internalNav('video-chat');
	                    } },
	                  'Video Chat Now'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.selectedOption === 'store' ? 'optionRow open' : 'optionRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.selectedForm === 'store' ? 'optionRowButton selected' : 'optionRowButton', onClick: function onClick() {
	                      return _this9.toggleForm('store');
	                    } },
	                  'Contact a Store'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.selectedForm === 'shopping' ? 'optionRowButton selected' : 'optionRowButton', onClick: function onClick() {
	                      return _this9.toggleForm('shopping');
	                    } },
	                  'Request an Appointment'
	                )
	              ),
	              _react2.default.createElement('div', { className: 'optionFormMobile' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'singleOption' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.selectedOption === 'service' ? 'optionItem selected' : 'optionItem', onClick: function onClick() {
	                    return _this9.toggleOption('service');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'optionImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/contact/appt.svg' })
	                ),
	                _react2.default.createElement('div', { className: 'optionBr' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'optionTitle' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'SERVICE &',
	                    _react2.default.createElement('br', null),
	                    'REPAIRS'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.formOpen ? 'optionButton selected' : 'optionButton', onClick: this.toggleFormOpen.bind(this) },
	                  'Request Appointment'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.selectedOption === 'service' ? 'optionRow open' : 'optionRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.selectedForm === 'store' ? 'optionRowButton selected' : 'optionRowButton', onClick: function onClick() {
	                      return _this9.toggleForm('store');
	                    } },
	                  'Contact a Store'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.selectedForm === 'service' ? 'optionRowButton selected' : 'optionRowButton', onClick: function onClick() {
	                      return _this9.toggleForm('service');
	                    } },
	                  'Request an Appointment'
	                )
	              ),
	              _react2.default.createElement('div', { className: 'optionFormMobile' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.selectedForm === 'store' ? 'sbFormWrapper openForm' : 'sbFormWrapper', ref: function ref(div) {
	                _this9.formWrapper = div;
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'contactPageForm' },
	              _react2.default.createElement(
	                'div',
	                { className: 'formBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'formRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'oneHalfSection' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorName ? 'textInput error' : 'textInput',
	                      type: 'text',
	                      placeholder: 'Full Name*',
	                      value: this.state.inputName,
	                      onChange: this.changeName.bind(this) })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'oneHalfSection' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorEmail ? 'textInput error' : 'textInput',
	                      type: 'email',
	                      placeholder: 'Email Address*',
	                      value: this.state.inputEmail,
	                      onChange: this.changeEmail.bind(this) })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'formRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'oneHalfSection' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorPhone ? 'textInput error' : 'textInput',
	                      type: 'text',
	                      placeholder: 'Telephone',
	                      value: this.state.inputPhone,
	                      onChange: this.changePhone.bind(this) })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'oneHalfSection' },
	                    _react2.default.createElement(_RhinoSelect2.default, {
	                      selectClass: 'contactSelect contactPageSelect',
	                      required: true,
	                      options: this.state.locations,
	                      changeMethod: function changeMethod(evt) {
	                        return _this9.changeLocation(evt);
	                      },
	                      value: this.state.inputLocation,
	                      error: this.state.errorLocation })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'formRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'textareaInputWrapper' },
	                    _react2.default.createElement('textarea', {
	                      className: this.state.errorMessage ? 'textTextarea error' : 'textTextarea',
	                      placeholder: 'How can we help you?',
	                      value: this.state.inputMessage,
	                      onChange: this.changeMessage.bind(this) })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'repairNotice', style: { display: this.state.selectedOption === 'service' ? 'block' : 'none' } },
	                  'Walk-ins always welcome! No appointment needed for routine jewelry cleanings.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'formRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'submitButton actionButton', onClick: this.submitContactRequest.bind(this) },
	                    'Submit'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.selectedForm === 'shopping' ? 'sbFormWrapper openForm' : 'sbFormWrapper' },
	            _react2.default.createElement(_ScheduleShoppingForm.ScheduleShoppingFormContainer, { closeMethod: function closeMethod() {
	                return _this9.toggleForm('shopping');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.selectedForm === 'service' ? 'sbFormWrapper openForm' : 'sbFormWrapper' },
	            _react2.default.createElement(_ScheduleServiceForm.ScheduleServiceFormContainer, { closeMethod: function closeMethod() {
	                return _this9.toggleForm('service');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbText' },
	            'We look forward to connecting with you!'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'scheduleFooterSpacer' })
	      );
	    }
	  }]);
	
	  return ContactPage;
	}(_react2.default.Component);
	
	ContactPage.propTypes = {
	  location: _react.PropTypes.object
	};
	ContactPage.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ContactPage;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ContactPageContainer = exports.ContactPageContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ContactPage);

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GalleryBreadcrumbsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _formatting = __webpack_require__(21);
	
	var _url = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var GalleryBreadcrumbs = function (_React$Component) {
	  _inherits(GalleryBreadcrumbs, _React$Component);
	
	  function GalleryBreadcrumbs(props) {
	    _classCallCheck(this, GalleryBreadcrumbs);
	
	    var _this = _possibleConstructorReturn(this, (GalleryBreadcrumbs.__proto__ || Object.getPrototypeOf(GalleryBreadcrumbs)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(GalleryBreadcrumbs, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	
	      var pageNum = this.props.product.currentPage ? this.props.product.currentPage : 1;
	
	      var urlData = (0, _url.getJsonFromUrl)();
	      if (urlData && urlData.q) {
	
	        var pageVal = this.props.product.currentPage && this.props.product.currentPage > 1 ? '&p=' + this.props.product.currentPage : '';
	
	        this.internalNav('diamonds-direct-search?q=' + urlData.q + pageVal);
	        return;
	      }
	
	      console.log(this.props);
	
	      if (this.props.productType == 'diamond') {
	        // // Back to non-Kayak view
	        // this.internalNav('gallery/engagement-rings?view=results&mode=diamond&currentPage=' + pageNum + '&tabtype=' + this.props.productType);
	
	        this.internalNav('gallery/engagement-rings?view=results&currentPage=' + pageNum + '&tabtype=' + this.props.productType);
	      } else if (this.props.productType == 'setting') {
	        // // Back to non-Kayak view
	        // this.internalNav('gallery/engagement-rings?view=results&mode=setting&currentPage=' + pageNum + '&tabtype=' + this.props.productType);
	
	        this.internalNav('gallery/engagement-rings?view=results&currentPage=' + pageNum + '&tabtype=' + this.props.productType);
	      } else if (this.props.productType == 'mens') {
	        this.internalNav('gallery/mens-jewelry?view=results&currentPage=' + pageNum + '&tabtype=' + this.props.productType);
	      } else {
	
	        if (this.props.product.productFilters && this.props.product.productFilters.type == 'mensband') {
	          this.internalNav('gallery/wedding-bands/mens?view=results&currentPage=' + pageNum);
	        } else if (this.props.product.productFilters && this.props.product.productFilters.type == 'womensband') {
	          this.internalNav('gallery/wedding-bands/womens?view=results&currentPage=' + pageNum);
	        } else if (this.props.product.productFilters && this.props.product.productFilters.type == 'womensband') {
	          this.internalNav('gallery/wedding-bands/womens?view=results&currentPage=' + pageNum);
	        } else {
	          this.internalNav('gallery/fine-jewelry?' + (0, _formatting.formatQuerystring)(this.props.product.productFilters) + '&currentPage=' + pageNum);
	          // window.history.back();
	        }
	      }
	    }
	  }, {
	    key: 'disableSplashPage',
	    value: function disableSplashPage() {
	      if (this.props.disableSplash) {
	        this.props.disableSplash();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'GalleryBreadcrumbs' },
	        _react2.default.createElement(
	          'div',
	          { className: 'breadcrumbsLHS' },
	          this.props.showingSplashPage ? _react2.default.createElement(
	            'div',
	            { className: 'breadcrumbWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'breadcrumbElement splashBreadcrumbElement currentElement' },
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'breadcrumbElement splashBreadcrumbElement clickableElement desktopView', onClick: this.disableSplashPage.bind(this) },
	              'Back to Results'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'breadcrumbElement splashBreadcrumbElement clickableElement mobileView', onClick: this.disableSplashPage.bind(this) },
	              'Results'
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'breadcrumbWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'breadcrumbElement productBreadcrumbElement currentElement' },
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'breadcrumbElement productBreadcrumbElement clickableElement desktopView', onClick: this.goBack.bind(this) },
	              'Back to Results'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'breadcrumbElement productBreadcrumbElement clickableElement mobileView', onClick: this.goBack.bind(this) },
	              'Back'
	            )
	          )
	        ),
	        !this.props.hideResultCount && false ? _react2.default.createElement(
	          'div',
	          { className: 'breadcrumbsRHS' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pageIndicator' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pageInnerElement' },
	              'Showing 1 - 12 of 127'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pageSizeControls' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pageInnerElement selected' },
	              '12'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pageSeparationElement' },
	              '|'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pageInnerElement' },
	              '24'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pageSeparationElement' },
	              '|'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pageInnerElement' },
	              'All'
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return GalleryBreadcrumbs;
	}(_react2.default.Component);
	
	GalleryBreadcrumbs.propTypes = {
	  location: _react.PropTypes.object
	};
	GalleryBreadcrumbs.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = GalleryBreadcrumbs;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var GalleryBreadcrumbsContainer = exports.GalleryBreadcrumbsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(GalleryBreadcrumbs);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DiamondGridContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _formatting = __webpack_require__(21);
	
	var _data = __webpack_require__(74);
	
	var _product = __webpack_require__(42);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _ResultsControls = __webpack_require__(99);
	
	var _ResultsPagination = __webpack_require__(120);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var DiamondGrid = function (_React$Component) {
	  _inherits(DiamondGrid, _React$Component);
	
	  function DiamondGrid(props) {
	    _classCallCheck(this, DiamondGrid);
	
	    var _this = _possibleConstructorReturn(this, (DiamondGrid.__proto__ || Object.getPrototypeOf(DiamondGrid)).call(this, props));
	
	    _this.state = {
	      scrollPos: 0
	    };
	
	    // Bind event listeners
	    _this.getScrollPos = _this.getScrollPos.bind(_this);
	    return _this;
	  }
	
	  _createClass(DiamondGrid, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'getScrollPos',
	    value: function getScrollPos() {
	      this.setState({
	        scrollPos: window.pageYOffset
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'selectDiamond',
	    value: function selectDiamond(diamond) {
	      this.props.productSelectDiamond(diamond);
	    }
	  }, {
	    key: 'isDiamondSelected',
	    value: function isDiamondSelected() {
	      return this.props.product.selectedDiamond !== null;
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'updateMethod',
	    value: function updateMethod() {
	      console.log('update sort');
	    }
	  }, {
	    key: 'isFavoriteDiamond',
	    value: function isFavoriteDiamond(diamond) {
	      if (!diamond) {
	        return false;
	      }
	
	      for (var i = 0; i < this.props.product.compareDiamonds.length; i++) {
	        if (this.props.product.compareDiamonds[i].id == diamond.id) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'toggleFavoriteDiamond',
	    value: function toggleFavoriteDiamond(diamond) {
	      if (this.isFavoriteDiamond(diamond)) {
	        this.removeFavoriteDiamond(diamond);
	      } else {
	        this.addFavoriteDiamond(diamond);
	      }
	    }
	  }, {
	    key: 'addFavoriteDiamond',
	    value: function addFavoriteDiamond(diamond) {
	      var faves = (0, _data.cloneArray)(this.props.product.compareDiamonds);
	      if (faves.length >= 4) {
	        return;
	      }
	      faves.push(diamond);
	      this.props.productCompareDiamond(faves);
	      this.setState({
	        upperTabSelected: 'picks'
	      });
	    }
	  }, {
	    key: 'removeFavoriteDiamond',
	    value: function removeFavoriteDiamond(diamond) {
	
	      var currentIndex = null;
	      var faves = (0, _data.cloneArray)(this.props.product.compareDiamonds);
	
	      if (this.props.product.compareDiamonds.length === 1) {
	        this.props.productCompareDiamond([]);
	        return;
	      }
	
	      for (var i = 0; i < faves.length; i++) {
	        if (faves[i].id == diamond.id) {
	          currentIndex = i;
	          break;
	        }
	      }
	
	      faves.splice(currentIndex, 1);
	      this.props.productCompareDiamond(faves);
	    }
	  }, {
	    key: 'prevPage',
	    value: function prevPage() {
	      this.props.productSetPage(parseInt(this.props.product.currentPage) - 1);
	      this.props.scrollUp();
	    }
	  }, {
	    key: 'nextPage',
	    value: function nextPage() {
	      var _this2 = this;
	
	      this.props.productAddDiamonds((0, _formatting.formatQuerystring)(this.props.product.diamondFilters), this.props.product.currentDiamondPage + 1).then(function (respData) {
	        var filteredResults = (0, _product.reSortDiamonds)(respData.results, _this2.props.product.diamondFilters);
	        _this2.props.productAddDiamondResults(filteredResults, _this2.props.product.currentDiamondPage + 1);
	      });
	
	      this.props.productSetPage(parseInt(this.props.product.currentPage) + 1);
	      this.props.scrollUp();
	    }
	  }, {
	    key: 'setPage',
	    value: function setPage(pageNum) {
	      var _this3 = this;
	
	      this.props.productAddDiamonds((0, _formatting.formatQuerystring)(this.props.product.diamondFilters), this.props.product.currentDiamondPage + 1).then(function (respData) {
	        var filteredResults = (0, _product.reSortDiamonds)(respData.results, _this3.props.product.diamondFilters);
	        _this3.props.productAddDiamondResults(filteredResults, _this3.props.product.currentDiamondPage + 1);
	      });
	
	      this.props.productSetPage(parseInt(pageNum));
	      this.props.scrollUp();
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	      return window.innerWidth <= 1024;
	    }
	  }, {
	    key: 'getPageCount',
	    value: function getPageCount() {
	      return this.isMobile() ? 24 : 23;
	    }
	  }, {
	    key: 'getDiamondResults',
	    value: function getDiamondResults() {
	
	      var AD_POSITION = 4;
	
	      var resultsArray = [];
	
	      if (!this.props.product.diamondResults || this.props.product.diamondResults.length === 0) {
	        return resultsArray;
	      }
	
	      for (var i = 0; i < this.props.product.diamondResults.length; i++) {
	
	        if (this.props.product.diamondResults[i].image === null) {
	          // continue;
	        }
	
	        if (i >= this.getPageCount() * this.props.product.currentPage) {
	          break;
	        }
	
	        if (i < this.getPageCount() * (this.props.product.currentPage - 1)) {
	          continue;
	        }
	
	        if (!this.isMobile() && resultsArray.length == AD_POSITION) {
	          resultsArray.push({ id: 'ad' });
	        }
	
	        resultsArray.push(this.props.product.diamondResults[i]);
	      }
	      return resultsArray;
	    }
	  }, {
	    key: 'renderProductAd',
	    value: function renderProductAd(keyNum) {
	      var _context;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'productBannerItem adBannerItem', key: keyNum, onClick: (_context = this.props).showSplashPage.bind(_context) },
	        _react2.default.createElement(
	          'div',
	          { className: 'adInnerWrapper engagementAd' },
	          _react2.default.createElement(
	            'div',
	            { className: 'adPrompt' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Browse Top Styles >'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var RESULT_LIMIT = 24;
	      var pCount = 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DiamondGrid' },
	        _react2.default.createElement(_ResultsControls.ResultsControlsContainer, {
	          resultCount: this.props.product.diamondResultsCount,
	          resultType: 'diamond',
	          openFilters: this.props.openFilters }),
	        _react2.default.createElement(
	          'div',
	          { className: 'resultItemsWrapper' },
	          this.props.product.diamondResults && this.props.product.diamondResults.length > 0 ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              this.getDiamondResults().map(function (diamond, j) {
	
	                // if(diamond.image === null || pCount >= RESULT_LIMIT * this.props.product.currentPage) {
	                //   return null;
	                // }
	
	                // if(pCount < RESULT_LIMIT * (this.props.product.currentPage - 1)) {
	                //   pCount++;
	                //   return null;
	                // }
	
	                pCount++;
	
	                if (diamond.id == 'ad') {
	                  return _this4.renderProductAd(j);
	                }
	
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'productBannerItem', key: j },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'productItemInnerWrapper' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/diamond/' + diamond.id },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'diamondItemImgWrapper' },
	                        _react2.default.createElement('img', { src: diamond.image })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'productItemTitle' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          (0, _formatting.diamondTitle)(diamond)
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'diamondItemPrice' },
	                        '$',
	                        diamond.price.toLocaleString()
	                      )
	                    ),
	                    _this4.props.product.selectedDiamond && diamond.id === _this4.props.product.selectedDiamond.id ? _react2.default.createElement(
	                      'div',
	                      { className: 'diamondItemAction mixedResultsButton selected' },
	                      'Selected'
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'diamondItemAction mixedResultsButton', onClick: function onClick() {
	                          return _this4.selectDiamond(diamond);
	                        } },
	                      'Choose Diamond'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'favSelectWrapper', onClick: function onClick() {
	                          return _this4.toggleFavoriteDiamond(diamond);
	                        } },
	                      _this4.isFavoriteDiamond(diamond) ? _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare_a.svg' }) : _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare.svg' })
	                    )
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(_ResultsPagination.ResultsPaginationContainer, {
	              pageNum: parseInt(this.props.product.currentPage),
	              pageNext: this.nextPage.bind(this),
	              pagePrev: this.prevPage.bind(this),
	              setPage: this.setPage.bind(this),
	              pageSize: this.getPageCount(),
	              isDiamondPage: true,
	              resultCount: pCount })
	          ) : _react2.default.createElement(_RhinoLoading2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return DiamondGrid;
	}(_react2.default.Component);
	
	DiamondGrid.propTypes = {
	  location: _react.PropTypes.object
	};
	DiamondGrid.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = DiamondGrid;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var DiamondGridContainer = exports.DiamondGridContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(DiamondGrid);

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SettingGridContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(42);
	
	var _data = __webpack_require__(74);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _ResultsControls = __webpack_require__(99);
	
	var _ResultsPagination = __webpack_require__(120);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var SettingGrid = function (_React$Component) {
	  _inherits(SettingGrid, _React$Component);
	
	  function SettingGrid(props) {
	    _classCallCheck(this, SettingGrid);
	
	    var _this = _possibleConstructorReturn(this, (SettingGrid.__proto__ || Object.getPrototypeOf(SettingGrid)).call(this, props));
	
	    _this.state = {
	      scrollPos: 0
	    };
	
	    // Bind event listeners
	    _this.getScrollPos = _this.getScrollPos.bind(_this);
	    return _this;
	  }
	
	  _createClass(SettingGrid, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'getScrollPos',
	    value: function getScrollPos() {
	      this.setState({
	        scrollPos: window.pageYOffset
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'selectSetting',
	    value: function selectSetting(product) {
	      this.props.productSelectSetting(product);
	    }
	  }, {
	    key: 'isSettingSelected',
	    value: function isSettingSelected() {
	      return this.props.product.selectedSetting !== null;
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'isFavoriteProduct',
	    value: function isFavoriteProduct(product) {
	      if (!product) {
	        return false;
	      }
	
	      for (var i = 0; i < this.props.product.compareSettings.length; i++) {
	        if (this.props.product.compareSettings[i].sku == product.sku) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'toggleFavoriteProduct',
	    value: function toggleFavoriteProduct(product) {
	      if (this.isFavoriteProduct(product)) {
	        this.removeFavoriteProduct(product);
	      } else {
	        this.addFavoriteProduct(product);
	      }
	    }
	  }, {
	    key: 'addFavoriteProduct',
	    value: function addFavoriteProduct(product) {
	      var faves = (0, _data.cloneArray)(this.props.product.compareSettings);
	      if (faves.length >= 4) {
	        return;
	      }
	      faves.push(product);
	      this.props.productCompareSetting(faves);
	      this.setState({
	        upperTabSelected: 'picks'
	      });
	    }
	  }, {
	    key: 'removeFavoriteProduct',
	    value: function removeFavoriteProduct(product) {
	
	      var currentIndex = null;
	      var faves = (0, _data.cloneArray)(this.props.product.compareSettings);
	
	      if (this.props.product.compareSettings.length === 1) {
	        this.props.productCompareSetting([]);
	        return;
	      }
	
	      for (var i = 0; i < faves.length; i++) {
	        if (faves[i].sku == product.sku) {
	          currentIndex = i;
	          break;
	        }
	      }
	
	      faves.splice(currentIndex, 1);
	      this.props.productCompareSetting(faves);
	    }
	  }, {
	    key: 'prevPage',
	    value: function prevPage() {
	      this.props.productSetPage(parseInt(this.props.product.currentPage) - 1);
	      this.props.scrollUp();
	    }
	  }, {
	    key: 'nextPage',
	    value: function nextPage() {
	      this.props.productSetPage(parseInt(this.props.product.currentPage) + 1);
	      this.props.scrollUp();
	    }
	  }, {
	    key: 'setPage',
	    value: function setPage(pageNum) {
	      this.props.productSetPage(parseInt(pageNum));
	      this.props.scrollUp();
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	      return window.innerWidth <= 1024;
	    }
	  }, {
	    key: 'getPageCount',
	    value: function getPageCount() {
	      return this.isMobile() ? 24 : 23;
	    }
	  }, {
	    key: 'getSettingResults',
	    value: function getSettingResults() {
	
	      var AD_POSITION = 4;
	
	      var resultsArray = [];
	
	      if (!this.props.product.productResults || this.props.product.productResults.length === 0) {
	        return resultsArray;
	      }
	
	      for (var i = 0; i < this.props.product.productResults.length; i++) {
	
	        if (i >= this.getPageCount() * this.props.product.currentPage) {
	          break;
	        }
	
	        if (i < this.getPageCount() * (this.props.product.currentPage - 1)) {
	          continue;
	        }
	
	        if (!this.isMobile() && resultsArray.length == AD_POSITION) {
	          resultsArray.push({ sku: 'ad' });
	        }
	
	        resultsArray.push(this.props.product.productResults[i]);
	      }
	
	      return resultsArray;
	    }
	  }, {
	    key: 'renderProductAd',
	    value: function renderProductAd(keyNum) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'productBannerItem adBannerItem', key: keyNum, onClick: function onClick() {
	            return _this2.internalNav('engagement-rings');
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'adInnerWrapper engagementAd' },
	          _react2.default.createElement(
	            'div',
	            { className: 'adPrompt' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Browse Top Styles >'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var RESULT_LIMIT = 24;
	      var pCount = 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'SettingGrid' },
	        _react2.default.createElement(_ResultsControls.ResultsControlsContainer, {
	          resultCount: this.props.product.productResultsCount,
	          resultType: 'setting',
	          openFilters: this.props.openFilters }),
	        _react2.default.createElement(
	          'div',
	          { className: 'resultItemsWrapper' },
	          this.props.product.productResults && this.props.product.productResults.length > 0 ? _react2.default.createElement(
	            'div',
	            null,
	            this.getSettingResults().map(function (product, j) {
	
	              // if(product.image_count === 0 || pCount >= RESULT_LIMIT * this.props.product.currentPage) {
	              //   return null;
	              // }
	
	              // if(pCount < RESULT_LIMIT * (this.props.product.currentPage - 1)) {
	              //   pCount++;
	              //   return null;
	              // }
	
	              if (product.sku == 'ad') {
	                return _this3.renderProductAd(j);
	              }
	
	              pCount++;
	
	              return _react2.default.createElement(
	                'div',
	                { className: 'productBannerItem', key: j },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'productItemInnerWrapper' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/setting/' + product.sku },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'diamondItemImgWrapper' },
	                      _react2.default.createElement('img', { src: _this3.getProductMainImage(product) })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'productItemTitle' },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        product.name.replace(/Ã©/g, 'é')
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'diamondItemPrice' },
	                      '$',
	                      (0, _product.getMinPrice)(product).toLocaleString()
	                    )
	                  ),
	                  _this3.props.product.selectedSetting && product.sku === _this3.props.product.selectedSetting.sku ? _react2.default.createElement(
	                    'div',
	                    { className: 'diamondItemAction mixedResultsButton selected' },
	                    'Selected'
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'diamondItemAction mixedResultsButton', onClick: function onClick() {
	                        return _this3.selectSetting(product);
	                      } },
	                    'Choose Setting'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'favSelectWrapper', onClick: function onClick() {
	                        return _this3.toggleFavoriteProduct(product);
	                      } },
	                    _this3.isFavoriteProduct(product) ? _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare_a.svg' }) : _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare.svg' })
	                  )
	                )
	              );
	            }),
	            _react2.default.createElement(_ResultsPagination.ResultsPaginationContainer, {
	              pageNum: parseInt(this.props.product.currentPage),
	              pageNext: this.nextPage.bind(this),
	              pagePrev: this.prevPage.bind(this),
	              setPage: this.setPage.bind(this),
	              pageSize: this.getPageCount(),
	              resultCount: pCount })
	          ) : _react2.default.createElement(_RhinoLoading2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return SettingGrid;
	}(_react2.default.Component);
	
	SettingGrid.propTypes = {
	  location: _react.PropTypes.object
	};
	SettingGrid.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = SettingGrid;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var SettingGridContainer = exports.SettingGridContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(SettingGrid);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EngagementSplashContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var EngagementSplash = function (_React$Component) {
	  _inherits(EngagementSplash, _React$Component);
	
	  function EngagementSplash(props) {
	    _classCallCheck(this, EngagementSplash);
	
	    var _this = _possibleConstructorReturn(this, (EngagementSplash.__proto__ || Object.getPrototypeOf(EngagementSplash)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(EngagementSplash, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'EngagementSplash' },
	        _react2.default.createElement(
	          'div',
	          { className: 'esSection topSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'topLeftWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'imgWrapper' },
	              _react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/classic.jpg' }),
	              _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/classic.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'promptBox promptBoxTopLeft' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/classic_prod.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'promptWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptTitle' },
	                  'Classic Style'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptCopy' },
	                  'Known for their timeless look, classic settings will never go out of style.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptButton', onClick: function onClick() {
	                      return _this2.internalNav('setting/SMD1439174');
	                    } },
	                  'Shop This Ring'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobileSpacer' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/mobile/contemprorary_bw_m.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'topRightWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'promptBox promptBoxTopRight' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/contemporary_product_a.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'promptWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptTitle' },
	                  'Contemporary Style'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptCopy' },
	                  'Contemporary settings offer a distinctive and modern look to accentuate the center stone.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptButton', onClick: function onClick() {
	                      return _this2.internalNav('setting/SMD1414656');
	                    } },
	                  'Shop This Ring'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'imgWrapper' },
	              _react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/ringimage.jpg' }),
	              _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/ringimage.jpg' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'esSection middleSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'midLeftWrapper' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/vintage_1.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'midRightWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'midRightImgWrapper' },
	              _react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/vintage_bw.jpg' }),
	              _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/mobile/vintage_bw_m.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'promptBox promptBoxMid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/vintage_prod.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'promptWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptTitle' },
	                  'Vintage Style'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptCopy' },
	                  'Vintage settings incorporate breathtaking details like art deco or milgrain.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptButton', onClick: function onClick() {
	                      return _this2.internalNav('setting/SMD1444401');
	                    } },
	                  'Shop This Ring'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'esSection bottomSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bottomLeftWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'blImg' },
	              _react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/kitehalo.jpg' }),
	              _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/mobile/kitehalo_m.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'promptBox promptBoxBottomLeft' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/kitehalo_prod.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'promptWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptTitle' },
	                  'Decorative Kite Halo'
	                ),
	                _react2.default.createElement('div', { className: 'promptCopy' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptButton', onClick: function onClick() {
	                      return _this2.internalNav('setting/SMD1435151');
	                    } },
	                  'Shop This Ring'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bottomRightWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'brImg' },
	              _react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/accents.jpg' }),
	              _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/mobile/accents_m.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'promptBox promptBoxBottomRight' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/accents_prod.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'promptWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptTitle' },
	                  'Enchanting Diamond Accents'
	                ),
	                _react2.default.createElement('div', { className: 'promptCopy' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptButton', onClick: function onClick() {
	                      return _this2.internalNav('setting/SMD1444399');
	                    } },
	                  'Shop This Ring'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EngagementSplash;
	}(_react2.default.Component);
	
	EngagementSplash.propTypes = {
	  location: _react.PropTypes.object
	};
	EngagementSplash.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = EngagementSplash;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var EngagementSplashContainer = exports.EngagementSplashContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(EngagementSplash);

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MensBandsSplashContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var MensBandsSplash = function (_React$Component) {
	  _inherits(MensBandsSplash, _React$Component);
	
	  function MensBandsSplash(props) {
	    _classCallCheck(this, MensBandsSplash);
	
	    var _this = _possibleConstructorReturn(this, (MensBandsSplash.__proto__ || Object.getPrototypeOf(MensBandsSplash)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(MensBandsSplash, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MensBandsSplash' },
	        _react2.default.createElement(
	          'div',
	          { className: 'mbTopSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'topPromptWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'promptBox topPrompt' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptTitle' },
	                  'Two-Tone Style'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptCopy' },
	                  'Popular men\'s wedding bands include metals such as gold, platinum, and titanium. Choose a two-tone style to get everything you want in your forever piece.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ringsWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ringItem' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'ringItemImgWrapper' },
	                    _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/twotone_prod4.png' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptButton', onClick: function onClick() {
	                        return _this2.internalNav('jewelry/B14TT01678');
	                      } },
	                    'Shop This Ring'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ringItem' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'ringItemImgWrapper' },
	                    _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/twotone_prod2.png' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptButton', onClick: function onClick() {
	                        return _this2.internalNav('jewelry/B146M00541');
	                      } },
	                    'Shop This Ring'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ringItem' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'ringItemImgWrapper' },
	                    _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/twotone_prod3.png' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptButton', onClick: function onClick() {
	                        return _this2.internalNav('jewelry/B14TT01362');
	                      } },
	                    'Shop This Ring'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mbBottomSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bottomImgWrapper mobileBottomImgWrapper' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/vintage.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bottomPromptWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'promptBox bottomPrompt' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/vintage_prod.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'promptWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptTitle' },
	                  'Vintage Style'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptCopy' },
	                  'Celebrate your marriage with a wedding band that features intricate metal work created with milgrain and diamond accents for a vintage touch.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptButton', onClick: function onClick() {
	                      return _this2.internalNav('jewelry/BGD00830');
	                    } },
	                  'Shop This Ring'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bottomImgWrapper desktopBottomImgWrapper' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/vintage.jpg' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MensBandsSplash;
	}(_react2.default.Component);
	
	MensBandsSplash.propTypes = {
	  location: _react.PropTypes.object
	};
	MensBandsSplash.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = MensBandsSplash;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var MensBandsSplashContainer = exports.MensBandsSplashContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(MensBandsSplash);

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WomensBandsSplashContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var WomensBandsSplash = function (_React$Component) {
	  _inherits(WomensBandsSplash, _React$Component);
	
	  function WomensBandsSplash(props) {
	    _classCallCheck(this, WomensBandsSplash);
	
	    var _this = _possibleConstructorReturn(this, (WomensBandsSplash.__proto__ || Object.getPrototypeOf(WomensBandsSplash)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(WomensBandsSplash, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'WomensBandsSplash' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wbsTopSection wbsSection' },
	          _react2.default.createElement('div', { className: 'wbCol1 wbImgCol' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'wbCol2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'topPromptHeader' },
	              _react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/dainty2.jpg' }),
	              _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/mobile/dainty2_m.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'topPromptWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptBox promptTop' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/dainty_prod.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptTitle' },
	                    'Dainty Diamond Accents'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptCopy' },
	                    'Take your engagement ring to the next level with enchanting diamond accents that add double the sparkle.'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptButton', onClick: function onClick() {
	                        return _this2.internalNav('jewelry/BLDSM18486');
	                      } },
	                    'Shop This Ring'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wbsMidSection wbsSection' },
	          _react2.default.createElement('div', { className: 'wbCol2 wbImgCol mobile600' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'wbCol1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'midPromptWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptBox promptMid' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/exquisit_prod.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptTitle' },
	                    'Exquisite Details'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptCopy' },
	                    'Intricate milgrain and bezel details give our one-of-a-kind pieces and stunning and vintage touch.'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptButton', onClick: function onClick() {
	                        return _this2.internalNav('jewelry/BLDMD18924');
	                      } },
	                    'Shop This Ring'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'wbCol2 wbImgCol desktop600' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wbsBottomSection wbsSection' },
	          _react2.default.createElement('div', { className: 'wbCol1 wbImgCol' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'wbCol2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'bottomPromptWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptBox promptBottom' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/twist_prod.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptTitle' },
	                    'Trendy Twists'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptCopy' },
	                    'Calling all trendsetters! Our assortment of unique styles includes this seasons latest fads.'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptButton', onClick: function onClick() {
	                        return _this2.internalNav('jewelry/BLDMD06217');
	                      } },
	                    'Shop This Ring'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wbsFooter' },
	          _react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/charming.png' }),
	          _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/mobile/charming_m.jpg' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'footerCopyWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footerCopyTitle' },
	              'Charming Classics'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerCopyBody' },
	              'For a timeless look, classic diamond wedding bands are the perfect balance of simple yet dazzling.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerCopyButton', onClick: function onClick() {
	                  return _this2.internalNav('jewelry/BLDMD21500');
	                } },
	              'Shop This Ring'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return WomensBandsSplash;
	}(_react2.default.Component);
	
	WomensBandsSplash.propTypes = {
	  location: _react.PropTypes.object
	};
	WomensBandsSplash.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = WomensBandsSplash;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var WomensBandsSplashContainer = exports.WomensBandsSplashContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(WomensBandsSplash);

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TeamModalContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactMailto = __webpack_require__(142);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	var _formatting = __webpack_require__(21);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var TeamModal = function (_React$Component) {
	  _inherits(TeamModal, _React$Component);
	
	  function TeamModal(props) {
	    _classCallCheck(this, TeamModal);
	
	    var _this = _possibleConstructorReturn(this, (TeamModal.__proto__ || Object.getPrototypeOf(TeamModal)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(TeamModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.commonModalResize();
	    }
	  }, {
	    key: 'getTeamPhotoUrl',
	    value: function getTeamPhotoUrl() {
	      if (this.props.member) {
	        var bioSrc = 'https://ddw2.diamondsdirect.com/img/store/team/' + this.props.store_id + '/' + this.props.member.picture;
	        return bioSrc;
	      } else {
	        return '';
	      }
	    }
	  }, {
	    key: 'getEmail',
	    value: function getEmail() {
	      if (!this.props.member) {
	        return '';
	      }
	      if (this.props.member.email) {
	        return this.props.member.email;
	      }
	      if (this.props.location && this.props.member.email === '') {
	        return this.props.location.email;
	      } else {
	        return '';
	      }
	      return this.props.member.email;
	    }
	  }, {
	    key: 'getPhone',
	    value: function getPhone() {
	      if (!this.props.member) {
	        return '';
	      }
	      if (this.props.member.phone) {
	        return this.props.member.phone;
	      }
	      if (this.props.location && this.props.member.phone === '') {
	        return this.props.location.phone;
	      } else {
	        return '';
	      }
	      return this.props.member.email;
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      if (!this.props.member) {
	        return '';
	      }
	      if (this.props.member.name) {
	        return this.props.member.name;
	      }
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      if (!this.props.member) {
	        return '';
	      }
	      if (this.props.member.title) {
	        return this.props.member.title;
	      }
	    }
	  }, {
	    key: 'getBio',
	    value: function getBio() {
	      if (!this.props.member) {
	        return [];
	      }
	      if (this.props.member.bio) {
	        return this.props.member.bio;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'TeamModal' },
	        !this.props.member ? _react2.default.createElement(_RhinoLoading2.default, null) : _react2.default.createElement(
	          'div',
	          { className: 'contentWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'closeIcon', onClick: (_context = this.props).closeMethod.bind(_context) },
	            _react2.default.createElement(
	              'div',
	              { className: 'closeX' },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modalLhs' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileName mobileOnly' },
	              this.getName()
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileTitle mobileOnly' },
	              this.getTitle()
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'teamPhoto' },
	              _react2.default.createElement('img', { src: this.getTeamPhotoUrl() })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'contactEmail' },
	              _react2.default.createElement(
	                _reactMailto2.default,
	                { email: this.getEmail() },
	                this.getEmail()
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'contactPhone' },
	              (0, _formatting.displayPhone)(this.getPhone())
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modalRhs' },
	            _react2.default.createElement(
	              'div',
	              { className: 'teamName desktopOnly' },
	              this.getName()
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'teamTitle desktopOnly' },
	              this.getTitle()
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'teamBioWrapper' },
	              this.getBio().map(function (line, i) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'teamBioP', key: i },
	                  line
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamModal;
	}(_react2.default.Component);
	
	TeamModal.propTypes = {
	  item: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  store_id: _react.PropTypes.string
	};
	TeamModal.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react.PropTypes.object.isRequired
	};
	exports.default = TeamModal;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var TeamModalContainer = exports.TeamModalContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(TeamModal);

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/********************************************************************************************
	*****                                                                                   *****
	*****    IMPORTANT! Changes here must also be set in /src/styles/common/_colors.scss    *****
	*****                                                                                   *****
	/*******************************************************************************************/
	
	// Colors
	
	var ERROR_RED = exports.ERROR_RED = '#EB3533';

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var template = {
		template: 'store',
		title: '',
		description: '',
		name: 'Diamonds Direct Charlotte',
		shortName: 'Charlotte',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Charlotte to shop our latest arrivals and exclusive selection of diamond and fine jewelry.', 'Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectsouthpark',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		video: null,
		address: {
			line1: '4521 Sharon Road',
			line2: 'Charlotte, NC 28211'
		},
		googleMapsLink: '',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '7045329041',
		email: 'infoCLT@diamondsdirect.com',
		team: [{
			name: '',
			title: '',
			picture: '',
			email: '',
			phone: '',
			bio: ['', '', '', '', '']
		}],
		sponsorships: [{
			name: '',
			image: ''
		}],
		reviews: {
			googleRead: '',
			googleWrite: ''
		}
	};
	
	var ATX = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Austin',
		title: 'Diamonds Direct Austin - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Austin Location Today!',
		shortName: 'Austin',
		bannerPromo: 'promo.jpg',
		mainDescription: ['While you\'re having a great day exploring The Domain, drop by our showroom across the street from the Westin for your daily dose of diamonds. Our diamond experts will hook you with their unmatched knowledge and selections. This location has been planning puppy proposals and keeping Austin weird since 2012.'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectaustin',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '11104 Domain Drive',
			line2: 'Austin, TX 78758'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Austin/@30.3976246,-97.728506,17z/data=!3m1!4b1!4m5!3m4!1s0x8644cc714d92464b:0xb99ab21cf14e8422!8m2!3d30.39762!4d-97.726312',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '5126919950',
		email: 'infoAus@diamondsdirect.com',
		team: [{
			name: 'Anat Adi-Atias',
			title: 'Senior Vice President',
			picture: 'anat.jpg',
			email: 'Anat@DiamondsDirect.com',
			phone: '',
			bio: ['Anat Adi-Atias, Vice President, was born in Jerusalem, Israel in 1969 and was raised in the Netherlands. In 1987 Anat joined the Israel Defense Force for two years at the IDF Spokesman\'s office, declaring those two years as the years that shaped and formed her into the achiever she is. After the military service, in 1989, Anat moved to Washington, DC and joined the Embassy of Israel for five years at its Congressional Affairs department, working closely with both the US and Israeli diplomatic and political scenes.', 'Anat graduated from the University of Maryland in 1994 and followed her dreams of joining the Hospitality field of Hotel Management. Her first position was Director of Catering Sales at a prominent Washington, DC Hotel. Once moving back to Israel she was solicited by a prominent Hotel in Jerusalem as Guest & Public Relations Manager hosting the movers and shakers of the world, closely engaging with Presidents, Vice Presidents, Prime Ministers and many heads of States and their staff.', 'In 2010, Anat was offered a VP position at Distinctive Diamonds (now Diamonds Direct) in Indianapolis, IN. As an experienced diamond wholesaler, who gained extensive experience in the global diamond industry and served high-end diamond and jewelry retailers for over 12 years, joining the retail side of the business was a natural career decision. It was instantly clear that working closely and directly with the end consumers themselves is the true melting point of all her passions combined. \'The emotional factor of meeting the couple ending up wearing a beautiful diamond has taken the thrill of being part of the diamond industry to a totally different level\'.', 'Anat fell in love with Austin from day one when moving to Austin, TX in 2014 as Vice President of Diamonds Direct. \'Everything feels like home - from the warm weather to the laid back personality of the people of Austin’. She loves checking out the endless BBQ and Texmex restaurants while wearing her Longhorn attire. \'Austin is amazing and I couldn\'t be prouder taking part in "keeping it weird" by exceeding people\'s expectations when it comes to diamonds & jewelry\'.', 'Anat enjoys spending time with David, her husband of 25 years and long awaited for daughter Zoey. They love to play with their adopted Beagle, Brandy, and spend their time together cooking and traveling. Sponsoring local philanthropy, and especially foundations for kids, is a true passion for Anat ever since her very own won the battle herself.']
		}, {
			name: 'Lou Verde',
			title: 'General Manager',
			picture: 'lou_verde.jpg',
			email: 'louv@diamondsdirect.com',
			phone: '',
			bio: ['Lou was born and raised in Rochester, NY. Immediately after high school, he joined the U.S. Navy in September 2001. After graduating at the top of his class he was selected to attend a specialty school where he became an Advanced Weapons Specialist and played a critical role in several operations throughout the world. Lou really enjoyed making a difference and exploring the different cities he visited.', 'After his time in the service, Lou returned to his hometown where he met and then married his best friend Kara. He pursued a career in Hospitality while earning his Bachelor’s degree in Organizational Management. He started at the bottom and learned and worked in every position in hotels until he became a General Manager in only four years. During his career in hospitality, he managed hotels in five different cities before he stumbled upon his new passion for luxury jewelry and sales.', 'Lou joined the Diamonds Direct team in November 2016. After nearly a year of training becoming a Diamonds Expert and graduate from the Gemological Institute of America, Lou took over his first store in Salt Lake City, UT in August 2017. He spends every second of his spare time with his beautiful wife and two children.']
		}, {
			name: 'Jennifer Anderson',
			title: 'Graduate Gemologist & Diamond Expert',
			picture: 'jennifer_anderson.jpg',
			email: 'JenniferA@DiamondsDirect.com',
			phone: '',
			bio: ['Jennifer Anderson, Graduate Gemologist, has been with Diamonds Direct since 2013. She has a Bachelor\'s Degree in Government from The University of Texas.', 'Anderson has been in the diamond and jewelry industry for over 20 years. After college, she pursued her lifelong interest in gemstones and enrolled at the G.I.A., becoming a Graduate Gemologist. She moved to the New York area to attend the Fashion Institute of Technology where she learned jewelry design and fabrication from some of the most respected designers in the world. While studying at the Fashion Institute, Anderson worked for a major diamond wholesaler grading and evaluating loose diamonds.', 'In her free time, Anderson enjoys yoga, water polo, collecting tropical plants and hanging out with her husband and son.']
		}, {
			name: 'Linnea Kullman',
			title: 'Diamond Expert',
			picture: 'linnea_kullman.jpg',
			email: 'Linnea@DiamondsDirect.com',
			phone: '',
			bio: ['Linnea Kullman, Diamond Expert, has been part of the Diamonds Direct family since 2014. She started in the jewelry business in 1997, and since then has worked in almost every aspect of the business including sales, management, buying, and diamond wholesaling. She has been certified as a Diamontologist by the Diamond Council of America and has earned a Diamond Essentials certificate from the Gemological Institute of America.', 'Linnea is a native Texan, born in West Texas and raised in Austin. When she isn\'t busy at the work she loves, she enjoys cooking southern style, traveling, and spending time with her daughter, family, and friends.']
		}, {
			name: 'Aesuk Canterino',
			title: 'Diamond Expert',
			picture: 'aesuk_canterino.jpg',
			email: 'aesuk@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Julia Limas',
			title: 'Back Office',
			picture: 'julia_limas.jpg',
			email: 'JuliaL@DiamondsDirect.com',
			phone: '',
			bio: ['Julia has been with Diamonds Direct since 2015. Julia has sixteen years of experience in the jewelry industry.', 'In her spare time Julia loves to read, watch movies, spend time with friends and family, and her cat Kido.']
		},
		// {
		// 	name: 'Brooke Lopez',
		// 	title: 'Receptionist',
		// 	picture: 'brooke_lopez.jpg',
		// 	email: 'BrookeL@DiamondsDirect.com',
		// 	phone: '',
		// 	bio: [
		// 		'Brooke has been with Diamonds Direct Austin since it opened. In her spare time she enjoys going to Zilker Park, yoga, and fishing with her boyfriend and son.',
		// 	],
		// },
		// {
		// 	name: 'Megan Molina',
		// 	title: 'Bands Specialist & Receptionist',
		// 	picture: 'megan_molina.jpg',
		// 	email: '',
		// 	phone: '',
		// 	bio: [],
		// },
		// {
		// 	name: 'Cesar Rodriguez',
		// 	title: 'Bands Specialist',
		// 	picture: 'cesar_rodriguez.jpg',
		// 	email: 'cesar@diamondsdirect.com',
		// 	phone: '',
		// 	bio: [],
		// },
	
		{
			name: 'Dominic Ly',
			title: 'Shop Manager',
			picture: 'dominicly.jpg',
			email: 'dominic@diamondsdirect.com',
			phone: '',
			bio: []
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://bit.ly/3oufhMm',
			googleWrite: 'https://bit.ly/3oufhMm'
		}
	};
	
	var BAY = {
		template: 'store',
		currentPromo: false,
		title: 'Diamonds Direct Houston (Baybrook) - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Baybrook Location Today!',
		name: 'Diamonds Direct Houston (Baybrook)',
		shortName: 'Houston (Baybrook)',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Baybrook to shop our latest arrivals and exclusive selection of diamond and fine jewelry.', 'Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectbaybrook',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '18610 Gulf Frwy',
			line2: 'Friendswood, TX 77546'
		},
		googleMapsLink: 'https://www.google.com/maps/dir//18610+Gulf+Fwy,+Houston,+TX+77017/@29.6658102,-95.2634147,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x864097c92030883f:0xb9d528f9b9b18989!2m2!1d-95.261226!2d29.6658056!3e0',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '2816123632',
		email: 'infoHBB@diamondsdirect.com',
		team: [{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: ['Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.', 'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.', 'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.', 'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.']
		}, {
			name: 'Tamir Shkargi',
			title: 'Vice President',
			picture: 'Tamir1.jpg',
			email: 'Tamir@diamondsdirect.com',
			phone: '',
			bio: ['Tamir Shkargi joined the Diamonds Direct team 2017. Originally from Israel, Tamir served in the Israeli Military for three years. Upon his completion of service, he embarked on a career with the Israeli government for over ten years. After receiving his degree in Business Administration at Ono Academic College, Tamir decided to move to the United States with his family.', 'Tamir’s new chapter began in Austin, Texas which led him to pursue a career in retail management with Diamonds Direct. It was the remarkable culture and amazing group of people that made Diamonds Direct the perfect fit for Tamir.', 'After managing the Frisco store for nearly two years, he was given the opportunity to bring his talents to Houston and grow the Diamonds Direct family. Tamir greatly looks forward to this new journey with his family and they are excited to call Houston home.', 'Outside of work, Tamir enjoys playing soccer with friends and spending time with his wife and their precious two boys!']
		}, {
			name: 'Rashad Smith',
			title: 'General Manager',
			picture: 'Rashad.jpg',
			email: '',
			phone: '',
			bio: ['Rashad joined the Diamonds Direct team in 2021. With a wealth of diamond knowledge and leadership experience, Rashad is thrilled to lead the Baybrook team as the General Manager.', 'Rashad was a DCA graduate and has earned additional education with the GIA Diamond, Gemstone and Jewelry Essentials as well as GIA Diamond Grading Class. He has also received his AGS Registered Jeweler certification. On top of his amazing diamond education, Rashad comes to Diamonds Direct with a wealth of experience. Rashad has 12 years of retail experience, 10 years of jewelry experience and 8 years of jewelry management experience. His goal is to foster growth within the store and ensure the work environment is always fun and inviting.', 'Outside of work, Rashad enjoys spending time with his wife and his newborn son as well as exploring new places.']
		}, {
			name: 'Hector Hernandez',
			title: 'Bench Jeweler',
			picture: 'Hector.jpg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Rebecca Shanahan',
			title: 'Back Office Manager',
			picture: 'Rebecca.jpg',
			email: '',
			phone: '',
			bio: ['Rebecca serves as our Back Office Manager and has worked in the industry since 2015. She was born in Germany and grew up as an Army brat. Although she has lived in many places, Texas is the one that holds her heart.', 'Before joining Diamonds Direct, Rebecca was in the retail industry for 15 years. She then made a seamless transition into the  jewelry world where she worked for a family-owned jeweler. In this role, she wore many hats ranging from marketing to HR to billing, so Rebecca brings with her a diverse set of skills that allows her to be a true team player.', 'In her free time, she enjoys spending time with her husband and four kids, traveling and watching the Astros.']
		}, {
			name: 'Miranda Bishop',
			title: 'Back Office (FT)',
			picture: 'Miranda.jpg',
			email: '',
			phone: '',
			bio: ['Miranda is a member of the front and back office support staff. She joins Diamonds Direct with over 5 years in the restaurant industry.', 'Miranda is passionate about learning new things, and she is willing to do whatever it takes to make magic happen. Her enthusiasm for life pours out into how she conducts business each day and her passion is in meeting new people and gaining new experiences.', 'In her free time, Miranda loves spending time with her family and friends. She is thrilled for this new adventure in Baybrook!']
		}, {
			name: 'Daniella Garcia',
			title: 'Sales',
			picture: 'Daniella.jpg',
			email: '',
			phone: '',
			bio: ['Daniella joined Diamonds Direct in 2022. She is originally from Massachusetts  but came to Texas in 2009 and has never looked back! She has over 12 years of experience in the luxury retail industry as well as 6 years of experience in the jewelry industry. In addition, Daniella is DCA certified.', 'Daniella has extensive experience in sales, customer service and jewelry design and also has a passion for excellence in the workplace. One of her major strengths is in custom design for her clients. In her spare time, Daniella loves to spend time with family and friends, travel and master the art of charcuterie boards.']
		}, {
			name: 'Clinton Richards',
			title: 'Sales',
			picture: 'Clinton.jpg',
			email: '',
			phone: '',
			bio: ['Clinton joined Diamonds Direct in 2022. Before joining the company, he worked in the industry for over 20 years and is DCA certified. Clinton is originally from Jamaica but loves the amazing city of Houston and all of the opportunities it has to offer.', 'Clinton moved into the luxury industry first through his love of timepieces. He, himself, is an avid collector of fine watches. Throughout his career, Clinton has performed at a very high caliber, winning numerous performance honors. His passion for customer service and experience ensure that any time spent with him is nothing short of spectacular.', 'In his spare time, Clinton loves traveling and watching sports.']
		}, {
			name: 'Kelly Muraco',
			title: 'Sales',
			picture: 'Kelly.jpg',
			email: '',
			phone: '',
			bio: ['Jewelry has been a part of Kelly\'s life since she was 12 years old, spending afternoons with her mother working on custom jewelry designing. Since then, Kelly has been in and around the jewelry industry. Kelly graduated with a Communications Degree and an Associates in Business, and she quickly put that to work in LA where she worked for Entertainment Tonight and Dick Clark Productions.', 'Kelly has extensive experience, including 20 years in the retail industry, with 12 of the years being in luxury jewelry, and also 6 years at Diamonds Direct. She has earned her certification for GIA Applied Jewelry Professional (AJP). While in retail, she worked for clients such as Christian Dior and David Yurman. Her extensive experience and detail-oriented manner make her a stellar diamond expert for our Baybrook team. On top of that, she has an impeccable personality and humor that puts any customer at ease.', 'In her spare time, Kelly enjoys spending time with her family, listening to live music and playing with her dog Bailee.']
		}, {
			name: 'Abbi Johnson',
			title: 'Front Office (FT)',
			picture: 'Abby.jpg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Giselle Diaz',
			title: 'Front Office (PT)',
			picture: 'Giselle.jpg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'DaNel Dotson',
			title: 'Diamond Expert',
			picture: 'DaNel.jpg',
			email: '',
			phone: '',
			bio: ['DaNel joined the Diamonds Direct team in February of 2020. She has over 20 years of experience in the jewelry industry, including serving as the General Manager for several jewelry stores. Before her time in the jewelry industry, DaNel served as a United States Navy Cryptologic Technician, where she supervised a communications center for worldwide military requests for highly classified material. She also served as an owner of a Montessori school for 11 years, which has contributed to her dedication to business, stellar communication skills and amazing character.', 'In her free time, DaNel enjoys cooking for her family and hosting family gatherings. Outside of work, her passion is creating a loving experience for family, friends and kiddos!']
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://www.google.com/search?q=diamonds+direct+baybrook&rlz=1C5CHFA_enUS897US897&oq=diamonds+direct+baybrook&aqs=chrome..69i57j69i60l3.4511j0j4&sourceid=chrome&ie=UTF-8',
			googleWrite: 'https://www.google.com/search?q=diamonds+direct+baybrook&rlz=1C5CHFA_enUS897US897&oq=diamonds+direct+baybrook&aqs=chrome..69i57j69i60l3.4511j0j4&sourceid=chrome&ie=UTF-8'
		}
	};
	
	var BHM = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Birmingham',
		title: 'Diamonds Direct Birmingham - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Birmingham Location Today!',
		shortName: 'Birmingham',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Take a trip over to Cahaba Village in Mountain Brook and find the ring of your dreams. Our showroom may be the only place in the South where Auburn and Alabama fans can coexist since we love supporting both teams! These Best of BHAM-worthy diamond experts are ready to help you through any jewelry buying occasion.'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectbham',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '2800 Cahaba Village Plz.',
			line2: 'Birmingham, AL 35243'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Birmingham/@33.461258,-86.7565564,17z/data=!3m1!4b1!4m5!3m4!1s0x888919c328101159:0x4f5c52ea68cc0f92!8m2!3d33.4612535!4d-86.7543677',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '2052017400',
		email: 'infoBhm@diamondsdirect.com',
		team: [{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: ['Amit Berger, EVP, founded Diamonds Direct Birmingham in 2008. He joined the Diamonds Direct parent company in 1995 in Israel while working in the cutting facility and learning the trade\'s secrets.', 'Born in Israel, Berger grew up working in his family restaurant business and developed his love of customer service and gregarious personality. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry. It was then when he started working for Diamonds Direct\'s parent company in the cutting facility with the founder of the company.', 'In 1997, Berger came to the United States to begin working one on one with big diamond buyers. He traveled back and forth between Israel and 40 different states in the US working for Diamonds Direct\'s parent company in the wholesale division. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work with Diamonds Direct\'s parent company in the wholesale office and selling diamonds to top jewelry stores around the country. Eventually, Berger was running the wholesale division and was in charge of selecting diamonds from the cutting facility in Israel.', 'In the meantime, his brother Itay, had opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the company. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.', 'Berger made the move to Birmingham and opened the second Diamonds Direct location here in Birmingham, AL. He calls Birmingham his home and loves the friendly atmosphere. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. Their favorite thing to do as a family is play with their dog Ziggy and travel.']
		}, {
			name: 'Yoni Padan',
			title: 'Vice President, Birmingham',
			picture: 'yoni2.jpg',
			email: 'Yoni@DiamondsDirect.com',
			phone: '',
			bio: ['Yoni Padan joined Diamonds Direct in January of 2012. He was Born in Israel and moved to the United States in 1989. Padan graduated with an international business degree from the University in Herzliya. In 2008, Padan came back to the US and joined Diamonds Direct in 2012. Since the beginning of his career at Diamonds Direct, he made sure to always keep the special thing that makes Diamonds Direct what is, family. "The family spirit of Diamonds Direct penetrates from our staff to our customers and that is why the relationship between us and the customer is so special. I love what I do, and its great waking up every morning feeling that way."', 'In July of 2012, Yoni met his beautiful wife Natasha. They are now very happily married with three boys, Brandon, Ariel and Daniel. He enjoys spending every free second he has with them.']
		}, {
			name: 'Irene Chucherilova',
			title: 'General Manager',
			picture: 'irene_chucherlova.jpg',
			email: 'irenes@diamondsdirect.com',
			phone: '',
			bio: ['Irene Chucherilova, Diamond Expert, began her career at Diamonds Direct in 2014. She has a Bachelor’s degree in International Business from Ukraine Khmelnytskyi National University. Chucherilova has lived in the United States for 6 years, originally from Ukraine. Before working for Diamonds Direct she worked as a manager of an Advertising company, Khmelnytskyi Bazar. While living in the United States she worked as a manager over La Premier Perfume chain.', 'In her free time Chucherilova enjoys spending time with her son, Andrew, and husband, Luis. She also enjoys zoomba, and spending time with friends.']
		}, {
			name: 'Charles Collins',
			title: 'Diamond Expert',
			picture: 'charlie.jpg',
			email: 'CharlesC@DiamondsDirect.com',
			phone: '',
			bio: ['Charles Collins, Diamond Expert, has been with Diamonds Direct since 2008. He has a Bachelor\'s Degree in Business from The University of Alabama.', 'Collins has been in the diamond and jewelry industry for fourteen years. Previously, Collins served as an Assistant Loose Diamond broker and Special Events Representative for Universal Pacific of New York. During that time, he was in charge of the Gulf Coast market, the Mid West market and the Pacific market. Collins also served at Service Merchandise in Brentwood, Tennessee for four years as a Special Events Representative and as an Assistant Buyer of loose Diamonds.', 'In his free time, Collins likes to cook, play PS3 and spend time with his wife and family.']
		}, {
			name: 'Emily Lobdell',
			title: 'Diamond Expert',
			picture: 'emily_gray.jpg',
			email: 'EmilyL@DiamondsDirect.com',
			phone: '',
			bio: ['Emily Lobdell joined the Diamonds Direct team as a Diamond Expert in 2015. She has a Bachelor\'s Degree in Marketing from Union University in Jackson, Tennessee. Emily has over ten years of experience in the jewelry industry and has previously worked as a buyer and inventory manager for an independent jewelry company. Emily is certified by the Diamond Council of America. In her free time, she enjoys cooking, traveling, and spending time with her husband and cocker spaniel.']
		}, {
			name: 'Gerald Matherly',
			title: 'Diamond Expert',
			picture: 'gerald_matherly.jpg',
			email: 'GeraldM@DiamondsDirect.com',
			phone: '',
			bio: ['Gerald Matherly, Diamond Expert, joined the Diamonds Direct team in 2013. He has a Bachelor\'s Degree in International Studies from Auburn University in Montgomery. Matherly has been in the jewelry industry for over 20 years starting his career at Lorch Diamond Center in Birmingham, AL. He then worked for Brombergs for 13 years. He has also worked for Bailey Banks and Biddle, Kay\'s, and Helzbergs.', 'In his free time Matherly spends time with his daughter, Katlin Rose, he also enjoys reading & cooking.']
		}, {
			name: 'Kimberly Powell',
			title: 'Diamond Expert',
			picture: 'kimberly.jpg',
			email: 'KimberlyP@DiamondsDirect.com',
			phone: '',
			bio: ['Kimberly Powell, Diamond Expert, has been with Diamonds Direct since 2010. She has a Bachelor\'s Degree in Business Administration from the University of Montevallo. Powell is certified by the Diamond Council of America.', 'Previously, Powell was the top Elite Diamond Consultant at Zales Jewelers in Birmingham.', 'Powell has lived in Maylene for five years with her husband and dog. In her free time, Powell enjoys fishing with her husband on their boat, traveling to new places, and exploring the outdoors.']
		}, {
			name: 'Ashley Nolen',
			title: 'Diamond Expert',
			picture: 'ashley-n.jpg',
			email: 'AshleyN@diamondsdirect.com',
			phone: '',
			bio: ['Ashley Nolen joined the Diamonds Direct team in spring of 2017. She is a GIA Accredited Jewelry Professional and has her Diamonds and Diamond Grading certificate through GIA.', 'Nolen has been in the jewelry industry for over 12 years. She grew up in her parent\'s jewelry stores in Indiana and is the last of 7 children to still be in the business.', 'In her free time she likes to read, cook, travel, and spend time outdoors.']
		}, {
			name: 'Yolande Louw',
			title: 'Diamond Expert',
			picture: 'yolande1.jpg',
			email: 'yolandel@diamondsdirect.com',
			phone: '',
			bio: ['Born and raised in South Africa, Yolande started in sales at age 16, mined her first diamond age 17 and then fell in love with the diamond industry. Later, Yolande completed a Bachelor’s degree in Jewelry Design and Manufacture and an advanced CAD design course. She then started her own jewelry manufacturing and design company in South Africa focusing on custom jewelry. Yolande is very passionate about jewelry and her work has been exhibited in London, Las Vegas and other African countries. She is an adventurer at heart and in her spare time she loves the outdoors, traveling, socializing, hiking, art and painting.']
		}, {
			name: 'Dee Carvalho',
			title: 'Diamond Expert',
			picture: 'dee-c.jpg',
			email: 'dee@diamondsdirect.com',
			phone: '',
			bio: ['Dee Carvalho joined the Diamonds Direct team in 2017.  She is from Rio de Janeiro, Brazil.  Carvalho graduated in Physical Education from UAB. She also lived in the Middle East for sixteen years where she worked in various different jewelry exhibitions before moving back to Birmingham.', 'Carvalho enjoys spending time at the beach with her husband and exercising.']
		}, {
			name: 'Lisa Franklin',
			title: 'Sales Consultant',
			picture: 'lisa-franklin.jpg',
			email: 'lisaf@diamondsdirect.com',
			phone: '',
			bio: ['Lisa Franklin joined the Diamonds Direct team in September 2014. She grew up in Mobile, AL and moved to Birmingham four years ago with her husband of 35 years. Franklin has been in the jewelry business for 7 years.', 'In her spare time, she enjoys interior design and spending time with her granddaughter.']
		}, {
			name: 'Jason Manstream',
			title: 'Jeweler',
			picture: 'jason.jpg',
			email: 'Jason@DiamondsDirect.com',
			phone: '',
			bio: ['Jason Manstream has worked as a jeweler for over 20 years, and joined the Diamonds Direct team in Birmingham in 2012. Originally from New York, Manstream moved to Birmingham in 2011 with his wife and 4 kids.']
		}, {
			name: 'Tim Price',
			title: 'Jeweler',
			picture: 'tim-price.jpg',
			email: 'tim@diamondsdirect.com',
			phone: '',
			bio: ['Tim Price joined the Diamonds Direct family in 2017.  He has been creating and repairing jewelry for almost 35 years.', 'Originally from New Jersey, Price lived most of his life in Florida and moved to Birmingham with his wife and children in 2009. He has an affinity for "pop culture" and as a former Disc Jockey, a love for many types of music. He also has a dog named "Diamond," (he says he didn\'t name her).']
		}],
		sponsorships: [{
			name: 'Birmingham Barons',
			image: 'barons.jpg'
		}, {
			name: 'Auburn Tigers',
			image: 'ua.jpg'
		}, {
			name: 'Alabama Crimson Tide',
			image: 'bama.jpg'
		}],
		awards: [{
			name: 'Best of Birmingham',
			image: 'bestof.png'
		}],
		reviews: {
			googleRead: 'https://bit.ly/3oybuNY',
			googleWrite: 'https://bit.ly/3oybuNY'
		}
	};
	
	var BOC = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Boca Raton',
		title: 'Diamonds Direct Boca Raton - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Boca Raton Location Today!',
		shortName: 'Boca Raton',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Boca Raton to shop our latest arrivals and exclusive selection of diamond and fine jewelry. Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectbocaraton',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		video: 'https://player.vimeo.com/video/528920910?badge=0&autopause=0&player_id=0&app_id=58479',
		address: {
			line1: '21078 St. Andrews Blvd',
			line2: 'Boca Raton, Florida 33433'
		},
		googleMapsLink: 'https://www.google.com/maps/dir//21078+St+Andrews+Blvd,+Boca+Raton,+FL+33433/@26.3642086,-80.1388102,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x88d91e78d7629795:0x7ba1f1317c20bdca!2m2!1d-80.1366215!2d26.3642038!3e0',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '5614142091',
		email: 'infoBoca@diamondsdirect.com',
		team: [{
			name: 'Dovy Klarberg',
			title: 'Partner | President South',
			picture: 'dovyk.jpg',
			email: 'Dovy@DiamondsDirect.com',
			phone: '',
			bio: ['Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design.', 'After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.', 'During Dovy\'s time with Diamonds Direct SouthPark, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.', 'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts within Charlotte, NC. He is also focused on making Diamonds Direct SouthPark\'s brand more ingrained in the local community.', 'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.']
		}, {
			name: 'Ayelet Gilady',
			title: 'Vice President',
			picture: 'ayelet.jpg',
			email: 'ayelet@DiamondsDirect.com',
			phone: '',
			bio: ['Ayelet Gilady, Vice President, joined Diamonds Direct in 2015. Prior to joining the Diamonds Direct family, Gilady worked in the Israeli Diamond Exchange where she received her education as a Graduate Gemologist. She made the move to Charleston in 2015 where she opened and led that location for five years.', 'Although Gilady’s current focus is the diamond industry, her professional life began in advertising and business development working for over a decade with the most well established agencies in Israel. This elevated her to the role of CEO and co-owner of her own agency in Tel Aviv. Her aptitude for contracts led her to law school, where she fell in love with commercial and tort law. Gilady is a member of the Israeli Bar Association and was a practicing attorney for two years.', 'Gilady brings a variety of experience to Diamonds Direct- she loves working with people and has a great appreciation for the details required to make the Diamonds Direct brand experience personal and impactful.', 'Gilady also has an enthusiasm for philanthropy and a passion for the advancement of medical research in pediatric cancers as well as The Leukemia & Lymphoma Society and Susan G. Komen.', 'In her free time, Gilady enjoys spending time with her husband and two sons, trying new restaurants and reading. She loves the South Florida sunshine, culture and world renowned beaches.']
		}, {
			name: 'Arne Espling',
			title: 'Master Jeweler/Service Manager',
			picture: 'arne.jpg',
			email: 'arnee@diamondsdirect.com',
			phone: '',
			bio: ['Arne Espling has been with Diamonds Direct since early 2017.', 'Arne has completed several GIA courses, including ones focused on diamonds, diamond grading and colored stones. Arne is a second generation jeweler with over 30 years experience as a jeweler. He is skilled in many areas of fine jewelry including production, fabrication, casting, repair, advanced stone setting, appraisals and gem identification. Previously, Arne has owned and operated multiple independent jewelry stores in Jacksonville, Florida.', 'In his free time, Arne enjoys listening to live music,visiting art museums, collecting vinyl albums and spending time with his family.']
		}, {
			name: 'Lennice Padilla',
			title: 'Diamond Expert',
			picture: 'lennice.jpg',
			email: 'lennicep@diamondsdirect.com',
			phone: '',
			bio: ['Lennice Padilla has been in the jewelry industry for over 15 years and recently joined Diamonds Direct in March of 2020.', 'What she enjoys most about being in the industry is having the opportunity to build lasting relationships with each of her guests and being part of so many special occasions.', 'When Lennince is not working, she enjoys time with family and friends and never skips a Sunday beach day!']
		}, {
			name: 'Ryan Smith',
			title: 'Diamond Expert',
			picture: 'ryan.jpg',
			email: 'ryans@diamondsdirect.com',
			phone: '',
			bio: ['Ryan Smith has been in the jewelry industry for over 18 years. Smith is a GIA Diamond Graduate.', 'What he enjoys most about being in the industry is being part of an important milestone in their life.', 'Outside of work he tries to spend as much time at the beach as possible and enjoy the paradise of living in South Florida.']
		}, {
			name: 'Elyse Forte',
			title: 'Diamond Expert',
			picture: 'elyse.jpg',
			email: 'elysef@diamondsdirect.com',
			phone: '',
			bio: []
		}],
		sponsorships: [],
		awards: [],
		reviews: {
			googleRead: 'https://bit.ly/3ir46jF',
			googleWrite: 'https://bit.ly/3ir46jF'
		}
	};
	
	var CHS = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Charleston',
		title: 'Diamonds Direct Charleston - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Charleston Location Today!',
		shortName: 'Charleston',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Our Charleston showroom is actually located in the beautiful Mount Pleasant Towne Centre on Highway 17 North. We’re here to help tell your Lowcountry love stories, finish off your perfect Fashion Week look and pick the everyday piece for a stroll by the water. Just a quick trip over the Cooper River to find the diamond selection of your dreams.'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectcharleston',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '1911 Highway 17N',
			line2: 'Mt. Pleasant, SC 29464'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Charleston/@32.8322685,-79.8291257,17z/data=!3m1!4b1!4m5!3m4!1s0x88fe721d343de60d:0xca14486e34f940c1!8m2!3d32.832264!4d-79.826937',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '8436062558',
		email: 'infoCHS@diamondsdirect.com',
		team: [{
			name: 'Dovy Klarberg',
			title: 'Partner | President South',
			picture: 'dovy.jpg',
			email: 'dovy@diamondsdirect.com',
			phone: '',
			bio: ['Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design.', 'After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.', 'During Dovy\'s time with Diamonds Direct SouthPark, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.', 'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts within Charlotte, NC. He is also focused on making Diamonds Direct SouthPark\'s brand more ingrained in the local community.', 'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.']
		},
		// {
		// 	name: 'Ayelet Gilady',
		// 	title: 'General Manager',
		// 	picture: 'ayelet_gilady.jpg',
		// 	email: 'ayelet@DiamondsDirect.com',
		// 	phone: '',
		// 	bio: [
		// 		'Ayelet Gilady, General Manager, joined Diamonds Direct in 2015. Before making the move to Charleston, she worked for Diamonds Direct\'s marketing and merchandising team in the Israeli Diamond Exchange in Tel Aviv, Israel. It was there that Gilady received her education as a Graduate Gemologist.',
		// 		'Before working in the diamond industry, Gilady worked for over a decade in advertising and business development in the most well established advertising agencies in Israel. This elevated her to the role to CEO and co-owner of her own agency in Tel Aviv. It was during this time Gilady became curious about the law, as she was working with contracts daily. She then turned her focus to law school, where she fell in love with commercial and Tort law. Gilady is member of the Israeli Bar Association and was a practicing attorney for two years.',
		// 		'Gilady brings a variety of experience to Diamonds Direct- she loves working with people and bringing the details together to solve a challenge. Gilady also plans to become active in the philanthropic community in Charleston, specifically women’s and children\'s organizations.',
		// 		'In her free time, Gilady enjoys spending time with her husband and two children, sightseeing in historic Charleston. The entire Gilady family has fallen in love with Charleston. She also loves reading and exploring the culinary scene in Charleston with her husband.',
		// 	],
		// },
		{
			name: 'Lynn Tu',
			title: 'Vice President, Charleston',
			picture: 'LynnTu.jpg',
			email: 'lynnt@diamondsdirect.com',
			phone: '',
			bio: ['Lynn Tu has been with Diamonds Direct since 2015. She has a Bachelor’s Degree in Marketing from Suffolk University. Tu is also a Diamond Graduate from the Gemological Institute of America (GIA).', 'Tu has over 20+ years of experience in sales and management roles within the diamond and jewelry industry. Before making the move to Charleston, Tu worked in the original Diamonds Direct location in Charlotte, North Carolina where she was a Diamond Expert for four years. Tu brings a variety of experience to the Vice President role and is looking forward to settling into life in the Lowcountry.', 'In her free time, Tu enjoys reading, practicing yoga and traveling.']
		}, {
			name: 'David Alexander',
			title: 'General Manager',
			picture: 'david.jpg',
			email: 'Davida@diamondsdirect.com',
			phone: '',
			bio: ['David Alexander has been with Diamonds Direct since 2016. He has an Associate’s Degree in Science and an Associate’s Degree in Arts. He is also certified by the Diamond Council of America.', 'Alexander has over 6 years in the diamond and jewelry industry. Previously, he was a manager for Signet. Prior to starting his career in jewelry, Alexander was a demolition superintendent.', 'In his free time, Alexander enjoys exercising and hanging out with his three kids.']
		}, {
			name: 'Ginny Kidd',
			title: 'Diamond Expert',
			picture: 'sept28/Ginny.jpg',
			email: 'ginny@diamondsdirect.com',
			phone: '',
			bio: ['Ginny Kidd has been with Diamonds Direct since 2008. She began in the Raleigh location and transferred to the Charleston location for its opening in 2016. She has a Bachelor of Arts degree in Communications from North Carolina State University, where she graduated Magna Cum Laude.', 'Kidd has worn many hats at Diamonds Direct, including customer service, recruiting, and marketing. Previously she was the Marketing Director for a holistic healthcare practice and a Sales Executive for a software company.', 'In her free time, she enjoys trying out new restaurants in Charleston, having cookouts with friends, watching sports, and spending time with her husband and daughter.']
		}, {
			name: 'Linsay Peninger',
			title: 'Diamond Expert',
			picture: 'linsay.jpg',
			email: 'Linsayp@diamondsdirect.com',
			phone: '',
			bio: ['Linsay Peninger has been with Diamonds Direct since 2007. She has a Graduate Diamonds Degree from the Gemological Institute of America (GIA) and has also completed the colored stones course.', 'Peninger has over 20 years in the diamond and jewelry industry. Previously, she managed a local jewelry and watch repair shop and also worked in management for Signet Incorporated.', 'In her free time, Peninger enjoys spending time with her friends, going to the beach, and fishing! She also has a rare hybrid Bengal cat named Reggie!']
		}, {
			name: 'Kim Patterson',
			title: 'Diamond Expert',
			picture: 'sept28/Kim.jpg',
			email: 'Kimp@diamondsdirect.com',
			phone: '',
			bio: ['Kim Patterson has been with Diamonds Direct since March 2017. She has been in the jewelry for over 6 years.', 'Patterson previously worked for Kay Jewelers. Her favorite thing about the jewelry business is being able to work with guests during one of the most intimate purchases of their life.', 'In her free time, Patterson enjoys horseback riding, camping and spending time with my family and good friends.']
		}, {
			name: 'Bo Cochran',
			title: 'Diamond Expert',
			picture: 'oct27/bo.jpg',
			email: 'boc@diamondsdirect.com',
			phone: '',
			bio: ['Bo Cochran has been with Diamonds Direct since August 2019. Cochran was a professional golfer and instructor for over 25 years with different cruise lines. Where he then started his career in the diamond industry. On his free time he enjoys golfing, hanging out at the beach, and spending time with his son and wife.']
		}, {
			name: 'Doug Brown',
			title: 'Diamond Expert',
			picture: 'sept28/Doug.jpg',
			email: 'DougB@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Pat Reilly',
			title: 'Diamond Expert',
			picture: 'sept28/Pat.jpg',
			email: 'PatR@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Cindy Musser',
			title: 'Back Office Manager',
			picture: 'cindy.jpg',
			email: 'cindym@diamondsdirect.com',
			phone: '',
			bio: ['Cindy Musser has been with Diamonds Direct since 2015.', 'Musser previously worked as a bridal manager at Bridal House of Charleston where she helped brides select the perfect wedding gown and accessories for their big day.', 'In her free time, she enjoys reading, cooking for her coworkers, and spending time with friends.']
		}, {
			name: 'Margaret Baker',
			title: 'Front Office Support',
			picture: 'sept28/Margaret.jpg',
			email: '',
			phone: '',
			bio: []
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://bit.ly/3a25W5S',
			googleWrite: 'https://bit.ly/3a25W5S'
		}
	};
	
	var CLE = {
		template: 'store',
		currentPromo: false,
		title: 'Diamonds Direct Cleveland - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Cleveland Location Today!',
		name: 'Diamonds Direct Cleveland',
		shortName: 'Cleveland',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Cleveland to shop our latest arrivals and exclusive selection of diamond and fine jewelry.', 'Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectcleveland',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '2101 Richmond Rd.',
			line2: 'Beachwood, OH 44122'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Cleveland/@41.5006489,-81.498218,17z/data=!3m1!4b1!4m5!3m4!1s0x88310359022d7241:0x50393c6f790adefe!8m2!3d41.5006449!4d-81.4960293',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '2162732812',
		email: 'infoCLE@diamondsdirect.com',
		team: [{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: ['Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.', 'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.', 'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.', 'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.', 'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.']
		}, {
			name: 'Tery Vari',
			title: 'Vice President, OH',
			picture: 'tery.jpg',
			email: 'TeryV@DiamondsDirect.com',
			phone: '',
			bio: ['Tery Vari, Vice President, has been with Diamonds Direct since 2011. He received his Bachelors of Science in Marketing from Ohio State University.', 'Vari has been in the diamond and jewelry industry for over 20 years. Previously, he was the General Manager for Jared, the Galleria of Jewelry and the District Manager for Reeds Jewelers.', 'In his free time, Vari enjoys spending time with his wife and two sons and is active in the community.']
		}, {
			name: 'Steve Smith',
			title: 'General Manager',
			picture: 'oct7/STEVE.jpg',
			email: 'steves@diamondsdirect.com',
			phone: '',
			bio: ['Steve Smith, General Manager, has been with Diamonds Direct since 2012. Smith attended Winthrop University in Rock Hill, SC where he studied Business Administration.', 'Smith has been in the diamond and jewelry industry for 13 years. Previously, he held positions as both Store Manager and Vice President with jewelers in Richmond.', 'In his free time, Smith enjoys spending time with his son Josh, road trips to the beach and working in his yard.']
		}, {
			name: 'Derek Caron',
			title: 'Store Manager',
			picture: 'oct7/DEREK.jpg',
			email: 'derekc@diamondsdirect.com',
			phone: '',
			bio: ['Derek Caron, store manager, joined Diamonds Direct in September of 2017. He started with us in his home town of Virginia Beach, Virginia. Derek was excited to hear that we would be opening our 16th location in Cleveland. He has always loved the Cleveland area and is excited to share his experience and expertise with his new clients at our Beachwood Ohio Showroom.Derek has over 19 years of experience in the jewelry industry. He has completed both the certified gemologist and diamontologist courses with the Diamond Council of America. He attended the Gemological Institute of America and received accreditation as an Accredited Jewelry Professional and also completed the diamond grading laboratory class.Derek is also a musician and loves to find time to relax playing piano or violin. He has two children and loves rooting for Cleveland sports, especially the Cleveland Browns. “Here we go Brownies, here we go! Woof, woof!']
		}, {
			name: 'Craig Benson',
			title: 'Diamond Expert',
			picture: 'oct7/CRAIG.jpg',
			email: 'craigb@diamondsdirect.com',
			phone: '',
			bio: ['Craig has known fine jewelry for his entire life - he ran his family-owned jewelry store in Mentor for the last 30 years. Because Craig has grown up in this business, he is naturally passionate about all aspects of gemology and finding the perfect piece for his clients. He is active in his community, loves playing 18 holes of golf, beach getaways and spending time with his adorable grandson.']
		}, {
			name: 'Don Waddell',
			title: 'Diamond Expert',
			picture: 'oct7/DON.jpg',
			email: 'donw@diamondsdirect.com',
			phone: '',
			bio: ['Don joined the Diamonds Direct family in 2019 as a Diamond Expert and has been thriving in the fine jewelry industry for the last 20 years, working his way up at Jared before joining our Cleveland showroom team. He is a born and raised Ohioan and loves all Cleveland sports, the Buckeyes and good local food. Don loves to spend a day on the golf course and also quality  time with his son and daughter.']
		}, {
			name: 'Deena Novak',
			title: 'Shop Manager',
			picture: 'oct7/DEENA.jpg',
			email: 'deenan@diamondsdirect.com',
			phone: '',
			bio: ['Deena Novak joined Diamonds Direct in April of 2019. Deena was born and raised in the Cleveland area, and has been in the jewelry industry since 2014.', 'Deena graduated from the University of Akron with her Bachelor of Fine Arts focused in metalsmithing. Deena enjoys making art in many different mediums, however hand fabrication of metals is her favorite.', 'Deena loves to paint, spend time in nature, hike, bike and kayak. Deena spends most of her free time with her husband, Jon and her pit bull, Boomerang.']
		}, {
			name: 'Amy Bartkowski',
			title: 'Diamond Expert',
			picture: 'oct7/AMY.jpg',
			email: 'amyb@diamondsdirect.com',
			phone: '',
			bio: ['Amy is Ohio born and raised and has been in the jewelry industry since 2013. Amy joined us in 2021 and is thrilled to be a Diamond Expert on our Cleveland team! Amy enjoys walking, traveling, cooking and baking in her spare time and is also an avid animal lover. Besides the above, Amy is a Cleveland sports fan with her favorite team being the Browns. Amy has always loved many aspects of fine jewelry sales but her favorite part of her career is being part of special moments for guests.']
		}, {
			name: 'Jane Bidinger',
			title: 'Back Office Manager',
			picture: 'oct7/JANE.jpg',
			email: 'janeb@diamondsdirect.com',
			phone: '',
			bio: ['Jane joined the Diamonds Direct family in 2020. She has many years experience in fine jewelry, office, and inventory management. Customer service is one of her top priorities. She attended Louisville School of Art in Louisville, Kentucky where she studied English Composition, Photography and Design. She is an avid photographer and enjoys teaching her skills to new enthusiasts. She, her husband Rich, and their three dogs can be found out on the boat, going to the beach and spending time with family.']
		}, {
			name: 'Morgan Sanders',
			title: 'Receptionist',
			picture: 'oct7/MORGAN.jpg',
			email: 'clereception@diamondsdirect.com',
			phone: '',
			bio: ['Morgan joined our reception team at the Cleveland DD location in 2021. She has experience from Ashcroft and Oak and has used that great experience to become a staple to our team in customer service! While Morgan is a Cleveland native-born and raised, it is a goal of hers to relocate from Cleveland to warmer climates. When she is not greeting and helping our customers, she is studying! Currently, Morgan is enrolled as a Psychology major at Ohio University obtaining a Bachelor’s of Science, and is expecting to graduate in 2022. In between her work and school priorities, Morgan enjoys creating art, working out, relaxing, and shopping.']
		}, {
			name: 'Amber Hollinger',
			title: '',
			picture: 'Amber.jpg',
			email: '',
			phone: '',
			bio: ['Amber joined the Diamonds Direct family in 2021, and came by way of the hospitality industry out of Youngstown, Ohio. She holds a degree in hospitality management with a minor in business management from Youngstown State University. Amber has found excitement in learning more about the fine jewelry industry alongside her manager, Jane, who she has thoroughly enjoyed learning from.  On the weekends, you can find Amber spending quality time with her husband, Steven and their black, 12-year old Pitbull named Henry.']
		}, {
			name: 'Nick Arndt',
			title: 'Jeweler',
			picture: 'Nick.jpg',
			email: '',
			phone: '',
			bio: ['Nick joined the talented Diamonds Direct team in 2021 and so far a highlight of working in the Shop has been getting the opportunity to use what he’s learned over the years to bring quality work to customers, and also setting incredible diamonds! Prior to his jewelry artistry training, he was studying to become a paramedic, but sought a more creative career path.  In his spare time, Nick likes to spend time enjoying life with friends, going to concerts, playing games, and cheering on the Ohio State Buckeyes and the Cleveland Browns.']
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://bit.ly/3uw57Mc',
			googleWrite: 'https://bit.ly/3uw57Mc'
		}
	};
	
	var CLT = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Charlotte',
		title: 'Diamonds Direct Charlotte - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Charlotte Location Today!',
		shortName: 'Charlotte',
		runningPromo: false,
		bannerPromo: 'promo.jpg',
		mainDescription: ['Our flagship location in SouthPark, across from the Cheesecake Factory, is a hidden gem (pun intended!) nestled on the first floor of the Porter Building. These Panther-loving diamond experts are excited to help you find the ring of your dreams, just one of the reasons we\'re one of Charlotte Magazine’s Best of the Best.'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectsouthpark',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '4521 Sharon Road',
			line2: 'Charlotte, NC 28211'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Southpark/@35.1509199,-80.8307646,17z/data=!3m1!4b1!4m5!3m4!1s0x88569e15bb419ee5:0x907d95865d83ce9!8m2!3d35.1509155!4d-80.8285759',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '7045329041',
		email: 'infoCLT@diamondsdirect.com',
		team: [{
			name: 'Dovy Klarberg',
			title: 'Partner | President South',
			picture: 'apr21/DovyKlarberg.jpg',
			email: 'Dovy@DiamondsDirect.com',
			phone: '',
			bio: ['Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design.', 'After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.', 'During Dovy\'s time with Diamonds Direct SouthPark, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.', 'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts within Charlotte, NC. He is also focused on making Diamonds Direct SouthPark\'s brand more ingrained in the local community.', 'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.']
		}, {
			name: 'Mark Czarnecki',
			title: 'Vice President, Charlotte',
			picture: 'apr21/MarkCzarnecki.jpg',
			email: 'MarkC@DiamondsDirect.com',
			phone: '',
			bio: ['Mark Czarnecki, Vice President, Charlotte has been with Diamonds Direct since 2006. Mark has a certification from the Gemological Institute of America (GIA) and has also completed a Registered Jewelers course through the American Gemological Society (AGS).', 'Mark has 28 years of experience in the jewelry industry. He has worked with many other fine jewelers such as Mayors Jewelers in Florida, Columbian Emeralds in St. Thomas, Virgin Islands, and has also worked for White Hall Jewelers as a multi-store supervisor.', 'Mark was born and raised in Green Bay, Wisconsin. He has lived in many places before settling down in Charlotte such as Tampa Florida, Orlando Florida, and St. Thomas, In his free time, he enjoys cheering on the Green Bay Packers, spending time with his wife and three kids and fishing.']
		}, {
			name: 'Eyal Boaron',
			title: 'Store Manager',
			picture: 'apr21/EyalBoaron.jpg',
			email: 'eyal@diamondsdirect.com',
			phone: '',
			bio: ['Eyal Boaron has worked in the diamond and jewelry industry since 2011. Before joining the Diamonds Direct team, Eyal worked in the industry in the Caribbean for four years. In addition to working in the Charlotte store, Eyal has also worked in our Jacksonville and Salt Lake City locations.', 'Eyal served in the Israeli military for three years, which taught him ethics and the true meaning of hard work. He’s taken lessons from his time in the military and applied that to his daily life.', 'In Eyal\'s free time, he enjoys outdoor activities, working out and training to be a future American Ninja Warrior!']
		}, {
			name: 'Kim Tu-Chau',
			title: 'Diamond Expert',
			picture: 'apr21/KimTu-Chau.jpg',
			email: 'KimT@DiamondsDirect.com',
			phone: '',
			bio: ['Kim Tu-Chau, Diamond Expert, has been with Diamonds Direct since 2012. She studied Business Management at Suffolk University of Massachusetts.', 'Tu-Chau has been in the diamond and jewelry industry for over 20 years. Previously, she worked in sales as the Timepiece Manager at Jared, The Galleria of Jewelry.', 'In her free time, Tu-Chau enjoys traveling, listening to music and watching football with her two sons and her husband.']
		}, {
			name: 'Dave Lee',
			title: 'Diamantologist (DCA)',
			picture: 'apr21/DaveLee.jpg',
			email: 'DaveL@DiamondsDirect.com',
			phone: '',
			bio: ['Dave Lee, Diamantologist  (DCA), has been with Diamonds Direct since 2009. He studied law at Fordham University.', 'Lee has worked in various levels in the business including owning his own jewelry store in New York, working in sales at Kay\'s Jewelry and managing Jared, the Galleria of Jewelry in Concord, NC. Before entering the diamond industry, Lee worked in Real Estate.', 'In his free time, Lee enjoys swimming, playing golf and tennis and spending time with his three children.']
		}, {
			name: 'Asim Baksh',
			title: 'Diamond Expert',
			picture: 'apr21/AsimB.jpg',
			email: 'asim@diamondsdirect.com',
			phone: '',
			bio: ['Asim Baksh, Diamond Expert, has been in the luxury jewelry industry for over 14 years. Asim studied Information Technology and Management at the University of the West Indies in Barbados.', 'Previously, Asim has worked with Tiffany & Company as well as family-owned diamond companies. After six years of traveling and loving the adventure, Asim moved to Charlotte to join the Diamonds Direct family. Asim found his passion in helping customers during one of the most amazing times of their life.', 'Outside of work, Asim enjoys spending time with his wife, going to amazing restaurants, traveling, reading, meeting new friends, running and swimming.']
		}, {
			name: 'Evan Johnson',
			title: 'Diamond Expert',
			picture: 'apr21/EvanJohnson.jpg',
			email: 'evanj@diamondsdirect.com',
			phone: '',
			bio: ['Evan Johnson is a bright presence and is always passionate about helping others. Although born and raised in Colorado, he has called Charlotte home for the past ten years.', 'Evan found his home amongst the team shortly after he had his own Diamonds Direct experience. Bringing with him a decade of high-performance customer care and sales experience, he now spends his days with clients helping them pick the ring of their dreams.', 'He enjoys spending his free time with his wife and puppy, primarily watching movies, working out at the gym or trying new foods.']
		}, {
			name: 'Lana Hale',
			title: 'Diamond Expert',
			picture: 'apr21/LanaHale.jpg',
			email: 'lanah@diamondsdirect.com',
			phone: '',
			bio: ['Lana received a Bachelor\'s Degree in Business Management from the University of Rhode Island and is a GIA Accredited Jewelry Professional. Lana was a retail manager for 10 years and has found a true passion in selling diamonds, elevating the customer experience and developing long-term customer relationships.', 'Lana was raised in Philadelphia and when her family moved down to Florida, she joined them after graduating from college. Lana and her husband met working at jewelry stores next to each other in Miami. They decided to buy a home in Charlotte where they could plant roots and start a family.', 'In her free time, Lana loves to box and practice yoga, run marathons, travel and relax at home with their three animals.']
		}, {
			name: 'Christy Hill',
			title: 'Diamond Expert',
			picture: 'apr21/ChristyHill.jpg',
			email: 'christyh@diamondsdirect.com',
			phone: '',
			bio: ['Christy Hill, Diamond Expert has been with Diamonds Direct since 2014. She studied interior design at The Art Institute of Charlotte. Christy is a certified graduate with The Diamond Council of America.', 'Christy has been in the diamond and jewelry industry for over 10 years. Previously, she was in management at Jared The Galleria of Jewelry. Christy was born and raised in Charlotte, North Carolina. In her free time, she enjoys spending time with her son, daughter, and husband. They enjoy the park, the zoo, and the beach.']
		}, {
			name: 'Morgan Quatrano',
			title: 'Diamond Expert',
			picture: 'apr21/MorganQuatrano.jpg',
			email: 'morganq@diamondsdirect.com',
			phone: '',
			bio: ['Morgan Quatrano has been with Diamonds Direct since 2015. Morgan has 6 years of experience in restaurant management and customer service.', 'Morgan knew that wasn\'t her true calling and left that business to come to Diamonds Direct where she started out as a receptionist. From there she decided she to move to the sales floor where she could follow her true passion of helping customers find exactly what they were looking for. Making customers dreams come through is the most rewarding thing to Morgan.', 'As a Charlotte native, Morgan spends her Sundays rooting for the Carolina Panthers. She also spends a lot of time walking her King Charles Cavalier Spaniel, Charlie at Freedom Park. She loves animals and also has a tuxedo cat named, Noel.']
		}, {
			name: 'Crystal Remsen',
			title: 'Diamond Expert',
			picture: 'apr21/CrystalRemsen.jpg',
			email: 'crystalr@diamondsdirect.com',
			phone: '',
			bio: ['Crystal Remsen, Diamond Expert, has been with Diamonds Direct since 2015 and has over 6 years experience in the diamond and Jewelry industry.', 'Her career path took her through Dental Hygiene, Aviation, and Real Estate, ultimately finding her purpose and falling in love with the diamond and fine jewelry world. While she feels lucky enough to show diamonds and jewelry as a career, she finds greatest happiness being part of such a meaningful and special time in her customer\'s lives. She is truly humbled when a client sends her a picture captioning "She said YES!"', 'In her free time Crystal has a love for traveling, boating, and spending time with her husband, their two rescue pups, Allie and Daphne, friends and family.']
		}, {
			name: 'Nancy Seeman',
			title: 'Diamond Expert',
			picture: 'apr21/NancySeeman.jpg',
			email: 'nancys@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Hami Raissi',
			title: 'Diamond Expert',
			picture: 'apr21/HamiRaissi.jpg',
			email: 'hamir@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Patricia Olivera',
			title: 'Diamond Expert',
			picture: 'apr21/PatriciaOlivera.jpg',
			email: 'patriciao@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Sawan Bhargava',
			title: 'Diamond Expert',
			picture: 'apr21/SawanBhargava.jpg',
			email: 'sawanb@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Madison Leopard',
			title: 'Diamond Expert',
			picture: 'apr21/MadisonLeopard.jpg',
			email: 'madisonl@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Beatriz Aguirre',
			title: 'Diamond Expert',
			picture: 'apr21/BeatrizA.jpg',
			email: 'beatriza@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Daniel Turgeon',
			title: 'Timepiece Advisor',
			picture: 'apr21/DanielTurgeon.jpg',
			email: 'danielt@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Diana Zepsa',
			title: 'GIA Diamonds Graduate',
			picture: 'apr21/DianaZepsa.jpg',
			email: 'DianaZ@DiamondsDirect.com',
			phone: '',
			bio: ['Diana Zepsa, Diamond Expert, has been with Diamonds Direct since 2004. She has an Associates Degree in Arts from Central Piedmont Community College. She also holds a Graduate Diamonds Degree from the Gemological Institute of America (GIA).', 'Zepsa worked full-time at Diamonds Direct for six years. She is currently working part-time and is available by appointment only.', 'In her free time, Zepsa enjoys hiking, camping and traveling with her husband and three sons.']
		}, {
			name: 'Sureyya Cam',
			title: 'Master Custom Jeweler',
			picture: 'apr21/SureyyaCam.jpg',
			email: '',
			phone: '',
			bio: ['Sureyya Cam, Master Jeweler, has been with Diamonds Direct for more than 10 years. Originally from Turkey, Cam studied with a Turkish Master Jeweler starting at the young age of nine.', 'Cam moved to the United States at the age of 26 to further his career in Tuscaloosa, Alabama where we worked as the Master Jeweler for Benchmark. Shortly after settling in Alabama, Cam moved to Gastonia, North Carolina where he continued to advance his creative design expertise.', 'With close to 50 years experience in the diamond and jewelry industry, Cam has worked for many notable jewelers in the Charlotte area specializing in repair work and custom jewelry design. Utilizing a CAD-CAM system, Cam is able to help you bring your dream, one of a kind, piece of jewelry to life.', 'Although Cam spends much of his time designing jewelry, he enjoys spending time with his wife, three daughters, two son-in-laws and five grandchildren in his free time.']
		}, {
			name: 'Scott Fisher',
			title: 'Jeweler',
			picture: 'apr21/ScottFisher.jpg',
			email: '',
			phone: '',
			bio: ['Scott Fisher has been with Diamonds Direct for 10 years. Fisher received an Associate\'s Degree in Jewelry, Watch and Clock Repair from Wayne Community College in North Carolina.', 'Fisher has been in the diamond and jewelry industry for over 30 years. Previously he worked as a custom jeweler and repair specialist at Huckaby Jewelers in Charlotte.', 'In his free time, Fisher enjoys spending time with his wife and two daughters, boating and anything outdoors.']
		}, {
			name: 'Don Glefke',
			title: 'Jeweler',
			picture: 'apr21/DonGlefke.jpg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Lotte Sommer',
			title: 'Diamantologist (DCA)',
			picture: 'lotte.jpg',
			email: 'LotteS@DiamondsDirect.com',
			phone: '',
			bio: ['Lotte Sommer, Diamantologist  (DCA), has been with Diamonds Direct since 2011. She has a Bachelor’s Degree in Finance from Hallendorf University in Germany.', 'Sommer has been in the diamond and jewelry business for nine years. Sommer moved to the US and worked as the Global Supply Chain Manager for Bausch & Lomb until 2002. After retiring, Sommer went back to work, this time in the diamond industry, as a sales associate for Whitehall Jewelry. She also worked in sales at Kays and Jared’s Jewelers.', 'Sommer has lived in Charlotte for two years and enjoys reading and spending time with her family and grandchildren in her free time.']
		}],
		sponsorships: [{
			name: 'Carolina Panthers',
			image: 'panthers.jpg'
		}, {
			name: 'Charlotte Knights',
			image: 'knights.jpg'
		}],
		reviews: {
			googleRead: 'https://bit.ly/39WE4jF',
			googleWrite: 'https://bit.ly/39WE4jF'
		}
	};
	
	var COH = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Columbus',
		title: 'Diamonds Direct Columbus - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Columbus Location Today!',
		shortName: 'Columbus',
		bannerPromo: 'promo.jpg',
		mainDescription: ['OH, how we love our beautiful Columbus location in Polaris. The newly-renovated showroom houses thousands of styles for you and your love to browse through. Our Diamond Experts are always eager to walk you through the endless styles, diamonds and custom options that our designers have to offer!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectCOL/',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '1330 Polaris Pkwy',
			line2: 'Columbus, OH 43240'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Columbus/@40.1419728,-82.9845588,17z/data=!3m1!4b1!4m5!3m4!1s0x8838f46353500001:0xb3debb7599304027!8m2!3d40.1419687!4d-82.9823701',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '6145160515',
		email: 'infocol@diamondsdirect.com',
		team: [{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: ['Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.', 'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.', 'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.', 'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.', 'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.']
		}, {
			name: 'Tery Vari',
			title: 'Vice President, OH',
			picture: 'tery.jpg',
			email: 'TeryV@DiamondsDirect.com',
			phone: '',
			bio: ['Tery Vari, Vice President, has been with Diamonds Direct since 2011. He received his Bachelors of Science in Marketing from Ohio State University.', 'Vari has been in the diamond and jewelry industry for over 20 years. Previously, he was the General Manager for Jared, the Galleria of Jewelry and the District Manager for Reeds Jewelers.', 'In his free time, Vari enjoys spending time with his wife and two sons and is active in the community.']
		}, {
			name: 'Nick Stefano',
			title: 'General Manager',
			picture: 'nick-stefano.jpg',
			email: 'nicks@diamondsdirect.com',
			phone: '',
			bio: ['Nick has been with Diamonds Direct since November 2018. He has been in the Jewelry industry for over 13 years and has been in multiple leadership positions throughout Ohio and New Hampshire. Nick has a passion for guest service. He believes that bringing passion and energy to every interaction is tremendously important when building long term relationships personally and professionally.']
		}, {
			name: 'Kat Hoyt',
			title: 'Marketing Coordinator',
			picture: 'kat_hoyt.jpg',
			email: 'KatH@diamondsdirect.com',
			phone: '',
			bio: ['Kat Hoyt has been with Diamonds Direct since 2012.', 'Hoyt has over a decade of experience in the Customer Service Industry. Previously, Hoyt practiced her managerial skills at Hallmark.', 'She is mother to four sons and two dogs, Leo and Oscar. In her free time, she enjoys spending time with her husband, Vic, and her family.']
		}, {
			name: 'Ellen Moretti',
			title: 'Store Manager',
			picture: 'ellen_moretti.jpg',
			email: 'ellenm@diamondsdirect.com',
			phone: '',
			bio: ['Ellen has lived in Columbus, OH her whole life and joined Diamond Direct in February of 2018. She attended the Ohio State University majoring in Fashion Design, but decided to pursue a career in Gemology. She is a G.I.A. Graduate Gemologist and has been part of the industry managing small independent and corporate jewelry stores throughout the Columbus area since 1988. Her favorite part about her job is "I get to play people’s fairy godmother and make dreams come true, that they didn’t think were possible."']
		}, {
			name: 'Aimee Frollini',
			title: 'Diamond Expert',
			picture: 'aimee_frollini.jpg',
			email: 'aimee@diamondsdirect.com',
			phone: '',
			bio: ['Aimee Frollini is a diamond expert with over 27 years of diamond and jewelry experience in the industry.She began her career at an independent jeweler in Columbus Ohio, where she earned her Diamonds and Diamond Grading degree through The Gemological Institute of America.', 'She enjoys cooking and spending time with her husband and two sons.']
		}, {
			name: 'Mary Davis',
			title: 'Diamond Expert',
			picture: 'mary-davis.jpg',
			email: 'maryd@diamondsdirect.com',
			phone: '',
			bio: ['Mary Davis has over 28 years of diamond and jewelry experience. She started her career in 1990 with Signet jewelers Ltd and stayed with them for 25 years managing several stores in the Columbus area. Mary comes with an extensive background in jewelry and a passion for customer service! In her spare time she enjoys gardening, cooking and spending time with family.']
		}, {
			name: 'Taryn Hensel',
			title: 'Diamond Expert',
			picture: 'taryn.jpg',
			email: 'Tarynh@diamondsdirect.com',
			phone: '',
			bio: ['Taryn joined the Diamonds Direct team in September 2019 after spending two years with another major jewelry company. She has an extensive background in customer service and sales. Taryn chose to join the jewelry industry in 2018 as a way to bring together her love for jewelry with her business management degree and customer service experience.', 'Taryn graduated from Wittenberg University in 2008 with a major in Business Management and minor in Geography. While attending Wittenberg, she took a class in silver jewelry making where her love for the art of jewelry took off. Taryn grew up here in Ohio and loves sports, spending time with her family and friends, outdoor activities, beach vacations, and also has a real estate license she utilizes in her free time.']
		}, {
			name: 'Robin Condron',
			title: 'Back Office Manager',
			picture: 'robin.jpg',
			email: 'Robins@diamondsdirect.com',
			phone: '',
			bio: ['Robin Condron has been with Diamonds Direct since February of 2018. She has over 15 years of customer service experience and loves helping people. She has a diverse background in working with everything from animal husbandry to new brides. She can\'t wait to meet you and hear your story.', 'In her spare time she loves spending time with her husband Chris and taking her puppy, Snickerdoddle, to the park.']
		}, {
			name: 'Steve Remias',
			title: 'Diamond Expert',
			picture: 'steve.jpg',
			email: 'StevenR@diamondsdirect.com',
			phone: '',
			bio: ['Steve has been with Diamonds Direct since 2021. He has been in the Jewelry industry for over 10 years and brings extensive experience and passion of luxury brands. Steve earned his Diamond and Diamond Grading certification thought the GIA Gemological Institute of America.', 'Steve is honored to be a part of your special moment and is looking forward to helping you in selecting one of the most special gifts that symbolizes the love you have for one another.']
		}, {
			name: 'Jackie Adams',
			title: 'Back office support',
			picture: 'Jackie.jpg',
			email: 'Jaclyna@diamondsdirect.com',
			phone: '',
			bio: ['Jackie Adams has been with Diamonds Direct since September of 2021. She has a variety of experience in customer service and the hospitality industry. Her passion for providing guest experience has continued to grow at Diamonds Direct.', 'In her spare time she enjoys spending time with her two cats Cinna and Bon and traveling to Arizona to visit her family.']
		}, {
			name: 'Cristian Garcia',
			title: 'Shop Manager',
			picture: 'Cristian.jpg',
			email: 'cristian@diamondsdirect.com',
			phone: '',
			bio: ['Cristian Garcia was born in the Dominican Republic in 1967. He learned the art of jewelry is 1988 and has been working in the industry ever since. Cristian came to the United States in 2000 and has been with Diamonds Direct since 2018.', 'In his free time he enjoys spending time with his family, cooking, fishing and traveling.']
		}, {
			name: 'Ryan Choops',
			title: 'Diamond Expert',
			picture: 'ryan.jpg',
			email: 'Ryanch@diamondsdirect.com',
			phone: '',
			bio: ['Ryan has been in jewelry industry for over 14 years in both sales and management capacities. He has achieved his Diamonds and Diamonds Grading degree through the Gemological Institute of America. He enjoys having a customer first approach with the true goal of finding the perfect piece of jewelry for each and every person.', 'In his off time he enjoys spending as much time with his beautiful wife, wonderful 1 year old son and the two old ladies of the house (dogs). He\'s a huge sports fan and a die hard fan of the one and only Buffalo Bills.']
		}],
		sponsorships: [],
		awards: [{
			name: 'Best Of Columbus',
			image: 'bestof.png'
		}, {
			name: 'Best Of Columbus',
			image: 'bob20.png'
		}, {
			name: 'Best Of Columbus',
			image: 'bob21.jpg'
		}],
		reviews: {
			googleRead: 'https://bit.ly/3mj23Q0',
			googleWrite: 'https://bit.ly/3mj23Q0'
		}
	};
	
	var DFW = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Dallas',
		title: 'Diamonds Direct Dallas - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry & More. Visit Our Dallas Location Today!',
		shortName: 'Dallas',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Be the Star of the show at your next event after shopping with us at our Preston Hollow location. Whether you’re looking for the perfect way to say “I love you” or upgrading your already stunning set, we have the selection to make sure you never wonder if you found the one. Hang out with us long enough and you may see someone from America’s Team!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/DiamondsDirectDTX/',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '8127 Preston Rd.',
			line2: 'Dallas, TX 75225'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Dallas/@32.8619245,-96.8066824,17z/data=!3m1!4b1!4m5!3m4!1s0x864c20dc86a3ba85:0x22e31ce4169e20da!8m2!3d32.86192!4d-96.8044937',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '9723426663',
		email: 'infoDTX@diamondsdirect.com',
		team: [{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: ['Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.', 'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.', 'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.', 'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.']
		}, {
			name: 'Yosi Mayer',
			title: 'Vice President, Dallas',
			picture: 'yosi_mayer.jpg',
			email: 'yosi@diamondsdirect.com',
			phone: '',
			bio: ['Yosi Mayer, Vice President, joined the Diamonds Direct family in 2016.', 'Born in Israel, Mayer served in the Israeli Military for three years in the Paratroopers Brigade. For the past 16 years Mayer has worked in the diamond and jewelry industry all over the world with experience ranging from wholesale to retail.', 'Mayer\'s career in the industry began in 2000, in retail sales for a major jewelry chain in Mexico and the Caribbean. From there, he worked his way up the ladder to manage several stores in a General Manager capacity. In 2008 Mayer decided it was time to move back to Israel, where he continued to work in the industry only this time as a Sales Manager and Buyer for leading wholesale firms at the Israeli Diamond Exchange.', 'In 2016 Mayer met Itay Berger – President of Diamonds Direct and understood that joining the company would allow him to keep pursuing his passion for exceptional customer service, team leading and business development. For that reason, he made the decision to move his family to Dallas.', 'Mayer is married to his high-school sweetheart Liz. They have two lovely daughters and a dog. He enjoys spending time with his family while exploring Dallas and the surrounding areas. He takes interest in learning different cultures and languages and is a self proclaimed foodie, always chasing the next great meal.']
		}, {
			name: 'Chen Glikman',
			title: 'Vice President',
			picture: 'Dallas_Chen.png',
			email: 'chen@diamondsdirect.com',
			phone: '',
			bio: ['Chen Glikman, Vice President, has been with Diamonds Direct since 2016. He attended The Open University in Israel where he studied Communication and Psychology. Previously, Chen was the owner and operator of an event production company in South Florida.', 'Born in Beer Sheva, Israel, Chen joined The Israeli Defense Forces in 2003, where he served for three years as a parachuter. After completing his army service, Chen worked in sales in four different European countries and South Africa for three years. In Israel, he managed an advanced communication company while also working for a boutique event production in Tel Aviv.', 'In 2014, he made his way to the United States where he opened his own events company, bringing and perfecting customer service to the people of South Florida. After discovering this passion, Chen joined the Diamonds Direct team in 2016, becoming a great addition with his sales and service background. He completed his Diamond Training in Diamonds Direct’s cutting facilities in Ramat Gan, Israel.', 'After managing the Virginia Beach store for four years, he was given the opportunity to bring his talents to Dallas and grow the Diamonds Direct family. Chen greatly looks forward to this new journey with his family and they are excited to call Dallas home.', 'In his free time Chen likes to spend time outdoors with his family and work with musicians.']
		}, {
			name: 'Matthew Cadwell',
			title: 'General Manager',
			picture: 'Dallas_Matthew.png',
			email: 'mattcadwell@diamondsdirect.com',
			phone: '',
			bio: ['Matthew Cadwell, General Manager, joined Diamonds Direct in July of 2021. As a native Californian, Matthew developed a love of the outdoors and finds beauty in many natural elements. While going to school for Political Science he started working in the industry and never left! In 2015 Matthew moved to Texas with his wife and 2 daughters. He often says that although he wasn\'t born in Texas, he got here as soon as he could and now feels this is home.', 'In 1997, Matthew began his career in sales with Nordstrom and quickly fell in love with the retail industry, after learning to tailor his personal approach with customers. This passion led him to a career in fine jewelry where he has happily remained to this day.', 'When given the opportunity to lead the Diamonds Direct Dallas team, Matthew was thrilled to join such an esteemed group. Matthew compares Diamonds Direct culture  to "a breath of fresh air" in that every team member has the same, top priority no matter the day - each guest and their experience being second to none.', 'Matthew prides himself in his ability to mentor and enable growth for those with the desire. He enjoys team building and recognizing each individual for their own strengths that allow our team to run as a well-oiled machine. Matthew is also a Diamond Council of America Graduate.', 'Outside of work, Matthew spends his time enjoying the great outdoors and even had the pleasure of being a rock climbing instructor for Joshua Tree National Park where he literally held people off the edge of a cliff! "It\'s amazing what you discover about people when you get to do that," Matthew explains. When he\'s not busy chasing his next great adventure, Matthew loves spending quality time with his wife, Monique and two daughters.']
		}, {
			name: 'Greg Keaton',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'greg_keaton.jpg',
			email: 'GregK@diamondsdirect.com',
			phone: '',
			bio: ['Greg Keaton is a Diamond Council of America graduate and has worked in the jewelry industry for more than 30 years in several capacities across the United States, Canada, the Caribbean, and the Pacific Rim. During this time, he has gained experience in operations, high-end Swiss watch brand management, sales management, and advertising and marketing on a national scale.', 'Keaton grew up in Colorado before he played football and studied Psychology at Southwest Baptist University in Missouri. Keaton moved to Texas, in 1994, and has been with Diamonds Direct since the day they opened in Dallas. In his free time, Keaton enjoys traveling, music, playing golf, sporting events, spending time with his family, his 75lb rescue dog, and anything outdoors.']
		}, {
			name: 'Justin Lehn',
			title: 'Diamond Expert',
			picture: 'Dallas_Justin2.png',
			email: 'JustinL@diamondsdirect.com',
			phone: '',
			bio: ['As a graduate from the University of North Texas, Justin Lehn is a true, native Dallasite!', 'Lehn has years of jewelry experience stemming from his time in diamond buying and management for a large jewelry store chain. Most recently, Lehn played a dual role as Director of Timepieces and Diamond Specialist for Diamond Doctor, making his transition to Diamonds Direct very smooth.', 'In his free time, Lehn’s guilty pleasure is watching Gordon Ramsey\'s televisions shows. He\'s also an avid Dallas Cowboys fan (of course!) and is proud that Diamonds Direct is the official jeweler of the Dallas Cowboys!']
		}, {
			name: 'Graham Silberman',
			title: 'Diamond Expert',
			picture: 'jan17/Dallas_Graham.png',
			email: 'GrahamS@diamondsdirect.com',
			phone: '',
			bio: ['Graham Silberman was born and raised in Johannesburg, South Africa. Prior to dedicating more than 20 years to diamond and jewelry sales in a business to business capacity, Silberman was a professional tennis player.', 'Silberman hung up his racket to become a professional in the jewelry industry here in Dallas. His decades of service in the Metroplex have made him a fixture in the local jewelry scene and he is truly proud to be a part of it.', 'Silberman has been married to his lovely wife, Karen, for 38 years. They share two beautiful daughters and one precious granddaughter. In his free time, Silberman enjoys playing golf and poker.']
		}, {
			name: 'Leslie Zale Greco',
			title: 'Diamond Expert, GIA Graduate Gemologist',
			picture: 'leslie_zale_greco.jpg',
			email: 'LeslieG@diamondsdirect.com',
			phone: '',
			bio: ['Leslie Zale Greco, Graduate Gemologist, has a bachelor\'s degree from the University of Arizona and obtained her Graduate Gemologist degree from the Gemological Institute of America (GIA).', 'Greco has been in the jewelry business for over 40 years. She started in the family business, Zale Corporation, which her grandfather William Zale founded.', 'In her free time, she enjoys reading, cooking, traveling and spending time with her husband and two daughters.']
		}, {
			name: 'Charity Brown',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'jan17/Dallas_Charity.png',
			email: 'charityb@diamondsdirect.com',
			phone: '',
			bio: ['Charity Brown is a Diamond Council of America graduate and began her career in the jewelry industry in 2012. Before joining Diamonds Direct in February 2018, Brown managed Kay Jewelers and Zales stores and was a diamond expert at Bailey Banks and Biddle and Robbins Brothers.', 'Brown\'s hobby is her job! She loves what she does and couldn\'t imagine doing anything else!', 'In October 2012, Brown married her high school sweetheart and best friend, Levi. Together they have four Fur-babies and they love taking their dogs hiking and swimming in their free time.']
		}, {
			name: 'Robert Alvarado',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'jan17/Dallas_Robert.png',
			email: 'RobertA@diamondsdirect.com',
			phone: '',
			bio: ['Robert Alvarado, Diamond Council of America Graduate, joined Diamonds Direct in March of 2017. Born and raised in San Antonio, Texas, Alvarado graduated from Antonian College Preparatory High School and Sul Ross State University in Alpine, Texas where he majored in Wildlife Management and Minored in Biology--and is fluent in Spanish.', 'Alvarado began his career in jewelry and luxury timepieces San Antonio in 1990, and successfully managed stores until beginning his career with Diamonds Direct. Being highly motivated, Alvarado puts his customers first and will go out of his way to do whatever it takes to make sure every customer’s experience is the best.', 'Alvarado is also the on-site Tacori brand ambassador in Dallas.', 'Outside of work Alvarado enjoys international travel. His recent destinations include Greece, Spain, Argentina and Mexico. He also thoroughly enjoys being outdoors and landscaping his home. Alvarado attends many basketball games with his son, watching their favorite team...the San Antonio Spurs (even though I’m in Dallas Mavs territory). He loves spending time with his spouse and their four grandchildren. They also recently welcomed a new dog to the family, Bella!']
		}, {
			name: 'Stephen Metcalf',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'stephen_matcalfe.jpg',
			email: 'Stephen@diamondsdirect.com',
			phone: '',
			bio: ['Stephen Metcalf joined Diamonds Direct in 2018 and is Diamond and Gemologist certified through the Diamond Council of America. He was born and raised in Dallas, Texas so he is a true local in the community!', 'Metcalf has been in the jewelry industry since 2000. Over the past two decades, he has learned all aspects of the business starting with servicing merchandise when he was just 16 years old to becoming a Diamond Expert today. Prior to joining Diamonds Direct, Metcalf spent 15 years working for Zales.', 'Metcalf is a great listener and he focuses on helping people, problem solving, critical thinking and entertaining.', 'Outside of the office, Metcalf enjoys cooking, playing with his two fur babies - a Chihuahua named Pippy and a Schnauzer named Emerson—trying new restaurants, hosting barbeques around his backyard fire, gardening and going to sports games. His favorite things to do in his free time are to travel and to spend time with his family. Two of his favorite destinations are the Bahamas and Mexico. Metcalf is engaged and set to be married in the Fall of 2018 to his beautiful fiancée Courtney!']
		}, {
			name: 'Allan Abramowitz',
			title: 'Diamond Expert, GIA Graduate Gemologist',
			picture: 'jan17/Dallas_Allan.png',
			email: 'AllanA@diamondsdirect.com',
			phone: '',
			bio: ['Allan Abramowitz, Graduate Gemologist, has worked in the jewelry industry for more than 30 years, beginning in New York City where he owned his jewelry storefront. From there, Abramowitz developed a diverse professional background including earning his Graduate Gemologist certificate from the Gemological Institute of America (GIA) and gaining membership to the Diamond Dealers Club in New York City where he worked as an appraiser and diamond buyer.', 'Abramowitz has only one greater passion than diamonds – and that’s cooking. In fact, few people know he took a sabbatical from the jewelry industry to nurture his passion for cooking in NYC where he became a chef at the French Culinary Institute.', 'When he\'s not working with customers or cooking, Abramowitz also enjoys golfing and travel.']
		}, {
			name: 'Thanh Tran',
			title: 'Diamond Expert',
			picture: 'thanh.jpg',
			email: 'Thanht@diamondsdirect.com',
			phone: '',
			bio: ['Thanh Tran joined the Diamonds Direct team in 2020 and is looking forward to sharing her passion for luxury service with clients.', 'Born in Vietnam, Thanh came to the United States at a very young age and is bilingual. She attended Georgia Institute of Technology pursuing a minor in textile engineering but graduated from University of Texas at Dallas in 1999 with a Bachelor of Science degree in Accounting.', 'After completing her studies, Thanh decided to pursue a career in retail and has enjoyed working in the industry since 2004. Thanh\'s favorite part of her job is interacting with people and seeing them smile after handing off their perfect piece. Outside of work, Thanh loves to travel and experience different cultures and cuisines.']
		}, {
			name: 'Karren Garces',
			title: 'Diamond Expert',
			picture: 'Karen.png',
			email: 'karreng@diamondsdirect.com',
			phone: '',
			bio: ['Karren Garces received her Diamond Certification in 2018 and has been fulfilling her passion for fine jewelry and diamonds since 2016, although her years of sales experience span further and wider. She brings her talents of providing excellent customer service and experience to Dallas following her time as a Diamond Expert at the Austin and Frisco Diamonds Direct locations.', 'Karren also has received her Bachelors of Fine Art Degree in Graphic Design and Illustration along with her Masters Degree in Advertising and Public Relations.', 'Karren’s approach to people is genuine and authentic, while she enjoys connecting with her clients on a personal level! Outside of work, her hobbies include art, travel and playing with her furry friends! Above all else, Karren truly finds joy in bringing a smile across someone’s face for years to come.']
		}],
		sponsorships: [{
			name: 'American\'s Team',
			image: 'cowboys.jpg'
		}, {
			name: 'SMU',
			image: 'smu.jpg'
		}],
		reviews: {
			googleRead: 'https://bit.ly/3ishnZw',
			googleWrite: 'https://bit.ly/3ishnZw'
		}
	};
	
	var ECJ = {
		template: 'watch',
		name: 'Diamonds Direct\'s Exclusive Watch Collection',
		title: 'Diamonds Direct Luxury Watch Collection',
		description: 'ECJ Offers the Finest Selection of Watches. Visit Our ECJ Location Today!',
		shortName: 'ECJ',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Timepieces are one of the few items you wear on a daily basis, and it reflects your uniqueness. Here at Diamonds Direct, we offer a range of luxury watches that conform to your identity, personality, and lifestyle. No matter what you want to convey with your watch, our team will work with you to select the right luxury watch suited to your liking. Our watch styles range from classic, to sporty and rugged, and even ultra-modern and trendy. All of the watches we carry are meticulously chosen with form, function, luxury, and style in mind.'],
		bestsellers: {
			title: 'Sophistication is Timeless.',
			items: {
				primary: [{
					image: 'blancpain.jpg',
					title: 'Blancpain',
					subtitle: 'Villeret Wuantieme Phases de Lune'
				}],
				secondary: [{
					image: 'glashitte.jpg',
					title: 'Glashutte',
					subtitle: 'Senator Excellence'
				}, {
					image: 'perrelet.jpg',
					title: 'Perrelet',
					subtitle: 'Jumping Hour'
				}, {
					image: 'hublot1.jpg',
					title: 'Hublot',
					subtitle: 'Big Bang Tourbillion Power Reserve'
				}, {
					image: 'hublot2.jpg',
					title: 'Hublot',
					subtitle: 'Big Bang Unico King Gold Ceramic'
				}]
			}
		},
		bestsellersNew: {
			title: 'Meet some of our best sellers',
			items: {
				primary: [{
					image: 'hublot1_large.jpg',
					title: 'Hublot',
					subtitle: ''
				}],
				secondary: [{
					image: 'franck_small.jpg',
					title: 'Franck Muller',
					subtitle: ''
				}, {
					image: 'blancpain_small.jpg',
					title: 'Blancpain',
					subtitle: ''
				}, {
					image: 'zenith_small.jpg',
					title: 'Zenith',
					subtitle: ''
				}, {
					image: 'aandson_small.jpg',
					title: 'Arnold & Son',
					subtitle: ''
				}]
			}
		},
		facebookUrl: 'https://www.facebook.com/ecjluxe.charlotte',
		instagramUrl: 'https://www.instagram.com/ecjluxecharlotte/',
		address: {
			line1: '4521 Sharon Road',
			line2: 'Charlotte, NC 28211'
		},
		googleMapsLink: '',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '7042959190',
		email: 'watches@diamondsdirect.com',
		team: [{
			name: 'Dovy Klarberg',
			title: 'EVP | Market President',
			picture: 'dovyk.jpg',
			email: 'Dovy@DiamondsDirect.com',
			phone: '',
			bio: ['Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design.', 'After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.', 'During Dovy\'s time with Diamonds Direct SouthPark, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.', 'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts within Charlotte, NC. He is also focused on making Diamonds Direct SouthPark\'s brand more ingrained in the local community.', 'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.']
		}, {
			name: 'Christopher J. Ward',
			title: 'Timepiece Expert',
			picture: 'chrisw.jpg',
			email: 'ChrisW@DiamondsDirect.com',
			phone: '',
			bio: ['Christopher J. Ward, Timepiece Expert, has been part of the ECJ Luxe/Diamonds Direct family since September 2015. He studied business at UNC Wilmington. In addition to extensive timepiece training Chris also has multiple Diamond certifications from the Gemological Institute of America.', 'Chris has worked in various levels including sales for Fink\'s Jewelers in Charlotte, North Carolina.', 'In his free time Chris enjoys watching sports, playing basketball and hanging out with his Siberian Husky Kobi.']
		}],
		sponsorships: [],
		reviews: {},
		designers: [{
			image: 'ap.png'
		}, {
			image: 'b.png'
		}, {
			image: 'brm.png'
		}, {
			image: 'g.png'
		}, {
			image: 'gl.png'
		}, {
			image: 'h.png'
		}, {
			image: 'ML.png'
		}, {
			image: 'p.png'
		}, {
			image: 'sf.png'
		}, {
			image: 'z.png'
		}]
	};
	
	var FTX = {
		template: 'store',
		currentPromo: false,
		title: 'Diamonds Direct Frisco - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry & More. Visit Our Frisco Location Today!',
		name: 'Diamonds Direct Frisco',
		shortName: 'Frisco',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Frisco to shop our latest arrivals and exclusive selection of diamond and fine jewelry.', 'Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectfrisco',
		instagramUrl: '',
		video: 'https://player.vimeo.com/video/365145124',
		address: {
			line1: '8440 State Hwy 121, Building A',
			line2: 'Frisco, TX 75034'
		},
		googleMapsLink: 'https://www.google.com/search?client=safari&rls=en&q=diamonds+direct+frisco&ie=UTF-8&oe=UTF-8',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '4698504270',
		email: 'infoFRISCO@diamondsdirect.com',
		team: [{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@diamondsdirect.com',
			phone: '',
			bio: ['Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.', 'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.', 'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.', 'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.']
		}, {
			name: 'Yosi Mayer',
			title: 'Vice President',
			picture: 'yosi.jpg',
			email: 'yosi@diamondsdirect.com',
			phone: '',
			bio: ['Yosi Mayer, Vice President, joined the Diamonds Direct family in 2016.', 'Born in Israel, Mayer served in the Israeli Military for three years in the Paratroopers Brigade. For the past 16 years Mayer has worked in the diamond and jewelry industry all over the world with experience ranging from wholesale to retail.', 'Mayer\'s career in the industry began in 2000, in retail sales for a major jewelry chain in Mexico and the Caribbean. From there, he worked his way up the ladder to manage several stores in a General Manager capacity. In 2008 Mayer decided it was time to move back to Israel, where he continued to work in the industry only this time as a Sales Manager and Buyer for leading wholesale firms at the Israeli Diamond Exchange.', 'In 2016 Mayer met Itay Berger – President of Diamonds Direct and understood that joining the company would allow him to keep pursuing his passion for exceptional customer service, team leading and business development. For that reason, he made the decision to move his family to Dallas.', 'Mayer is married to his high-school sweetheart Liz. They have two lovely daughters and a dog. He enjoys spending time with his family while exploring Dallas and the surrounding areas. He takes interest in learning different cultures and languages and is a self proclaimed foodie, always chasing the next great meal.']
		}, {
			name: 'Olga Elmanovich',
			title: 'Vice President',
			picture: 'olga.jpg',
			email: 'Olga@diamondsdirect.com',
			phone: '',
			bio: ['Originally from Russia, Elmanovich made her home in the United States in Birmingham, Alabama with her husband, Richard. As she earned a degree in linguistics from the University of Alabama at Birmingham, Olga found her passion for diamonds while working part time for Diamonds Direct. Shortly after completing her college education, she joined Diamonds Direct Birmingham fulltime and switched gears to focus on her diamond education. Olga gained her certification as a GIA Accredited Jewelry Professional and enjoyed her career and growth with the company.', 'In 2018, Olga moved to Kansas City and was brought on to manage the new location. After managing the Leawood store for over two wonderful years, she was presented the opportunity to move to Frisco and continue her journey with Diamonds Direct in Texas. Olga has loved every minute of spending time here in Frisco and looks forward to making new memories here with her family.', 'Today, Olga proudly serves as Vice President of the company, now overseeing the Frisco, Kansas City and Oklahoma City markets.']
		}, {
			name: 'Matt Corbin',
			title: 'General Manager',
			picture: 'matt.png',
			email: 'MattC@diamondsdirect.com',
			phone: '',
			bio: ['Matt Corbin joined the Diamonds Direct team in 2020 and is delighted to be a part of the Frisco family. With over 25 years of experience in the industry, Matt’s passion for exceptional customer service and a top-tier experience remains second to none.', 'Originally from Kansas City, Missouri, Matt set out in the industry working seasonally during the holiday season but shortly thereafter, fell in love with the business and helping guests commemorate life’s most important moments. When presented the opportunity to serve as General Manager, Matt was ecstatic to join such a wonderful team and feels fortunate to call Frisco home. Prior to working for Diamonds Direct, Matt obtained his certification as a GIA Accredited Jewelry Professional as well as his DCA Certification. His favorite part of the Diamonds Direct experience is helping guests create memories that will last a lifetime.', 'Outside of the showroom, Matt loves spending time with his family and watching plenty of sports! He also can often be found cooking an amazing meal in the kitchen or enjoying grilling outdoors.']
		}, {
			name: 'Jessica Baker',
			title: 'Back Office Manager',
			picture: 'Frisco_Jessica.png',
			email: 'JessBaker@diamondsdirect.com',
			phone: '',
			bio: ['Jessica Baker joined Diamonds Direct in 2019 and is pursuing a Bachelor\'s degree in business management. Prior to her time at Diamonds Direct, Jessica worked in sales for over five years and eventually found her true passion working with fine jewelry.', 'Jessica was born in Dover, Delaware and was raised in a military family with family members in both the Air Force and Army. She has lived in seven different states as well as England before calling Texas home!', 'Throughout her time at Diamonds Direct, Jessica has enjoyed learning more about the diamond process and bringing her enthusiasm to the Frisco team. Outside of work, Jessica loves finding a good movie to watch and also enjoys spending time with her dog, Hennessy. As a true creative, Jessica loves to recharge with a good craft or by spending time outdoors.']
		}, {
			name: 'Keith Hudson',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'keithh.jpg',
			email: 'KeithH@diamondsdirect.com',
			phone: '',
			bio: ['Keith Hudson, a graduate of the Diamond Council of America, joined the team in 2019. He has been in the industry for over 30 years and most recently, was a District Manager for the last 25 years.', 'One of Keith\'s favorite parts of working with fine jewelry is seeing customers\' faces light up as they see their final piece, from start to finish!', 'Now happily helping customers celebrate life and love in a direct sales position, Keith is grateful to be a part of the Diamonds Direct family, serving the Frisco community.']
		}, {
			name: 'Heather Kim',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'heatherk.jpg',
			email: 'HeatherK@diamondsdirect.com',
			phone: '',
			bio: ['Heather Kim joined Diamonds Direct in 2019 and has been in the business for over 22 years. Heather was born in Seoul, South Korea and soon after, her family moved to the United States when she was very young. Her family settled down in Virginia where she attended George Mason University, which led her to finding her passion for fine jewelry. Heather\'s career took off as she began working for several other luxury brands as well as serving as eventually serving as a store manager. Learning about diamonds and gemstones is what first attracted Heather to the business and also the enjoyment of helping guests find the piece of their dreams. Heather has obtained both her DCA Diamond and Gemstone Certifications. Outside of work, Heather loves to spend time with her family, cats and puppy. She loves to travel, go to concerts and enjoy the outdoors. Heather has lived in Texas for over ten years and loves calling the Lone Star state home!']
		}, {
			name: 'Marcy Lingner',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'marcyl.jpg',
			email: 'MarcyL@diamondsdirect.com',
			phone: '',
			bio: ['Marcy Lingner, DCA Graduate, attended the University of Illinois and has worked in the industry since 1995 serving as both a manager as well as district manager in her decades of experience. Marcy is delighted to now step into sales which has always been her favorite part of the jewelry industry. Whether selling an engagement ring or a first pair of diamond studs, she loves being part of people’s journey and seeing their joy.', 'Outside of work, Marcy enjoys traveling, cheering on the Buffalo Bills and spending quality time with her family as a loving Grandma!']
		}, {
			name: 'Mark Tremonte',
			title: 'Diamond Expert',
			picture: 'Frisco_Mark.png',
			email: 'MarkT@diamondsdirect.com',
			phone: '',
			bio: ['Mark Tremonte joined the Diamonds Direct team in 2020 and is delighted to assist customers with their most meaningful moments! Mark graduated from the University of South Carolina with a Bachelors degree in Retail Management. He also obtained his DCA Diamond certification and has had a passion for fine jewelry ever since!', 'Mark has been in the business for over thirty years and has held a multitude of different roles, most recently serving as a Regional Sales Director. Mark truly values building relationships with his clients throughout all their exciting stages of life. His favorite part of the industry remains the same, helping clients find the perfect piece for any occasion and leave our doors feeling fantastic.', 'Outside of work, Mark loves to spend time with family, travel, and can never pass up a good round of golf. A true sports aficionado, Mark loves cheering on the Dallas Mavericks and Dallas Stars. Outside of Texas sports, all three of his children are Alabama graduates so Mark also is a huge Crimson Tide fan!']
		}, {
			name: 'Remington Evans',
			title: 'Front Office Support',
			picture: 'Frisco_Remington.png',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Allison Parks',
			title: 'Diamond Expert',
			picture: 'allison_parks.jpg',
			email: 'AllisonP@DiamondsDirect.com',
			phone: '',
			bio: ['Allison Parks, Diamond Expert, has been with Diamonds Direct since 2013. She graduated from Colorado State University with a Bachelor\'s degree in Human Development and Family Studies.', 'Allison has been in the retail and jewelry industry for 8 years. She was previously with Bailey Banks & Biddle where she started in sales and was promoted to Assistant Manager.', 'In her free time Allison enjoys spending time with her husband and 2 children, hiking, and entertaining friends.']
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://bit.ly/2ZFChh0',
			googleWrite: 'https://bit.ly/2ZFChh0'
		}
	};
	
	var GSC = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Greenville',
		title: 'Diamonds Direct Greenville - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Greenville Location Today!',
		shortName: 'Greenville',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Greenville to shop our latest arrivals and exclusive selection of diamond and fine jewelry. Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectgreenville',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '1113 Woodruff Rd.',
			line2: 'Greenville, SC 29607'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Greenville/@34.6844938,-82.1039085,10z/data=!4m8!1m2!2m1!1sdiamond+direct+greenville+sc!3m4!1s0x0:0xa6de24d19cee942d!8m2!3d34.8315593!4d-82.3059654',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '8645015090',
		email: 'infoGVL@diamondsdirect.com',
		team: [{
			name: 'Dovy Klarberg',
			title: 'Partner | President South',
			picture: 'DovyKlarberg.jpg',
			email: 'Dovy@diamondsdirect.com',
			phone: '',
			bio: ['Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design. After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.', 'During Dovy\'s time with Diamonds Direct, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.', 'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts. He is also focused on making Diamonds Direct’s brand more ingrained in the local communities.', 'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.']
		}, {
			name: 'Lynn Tu',
			title: 'Vice President',
			picture: 'LynnTu.jpg',
			email: 'lynnt@diamondsdirect.com',
			phone: '',
			bio: ['Lynn Tu has been with Diamonds Direct since 2015. She has a Bachelor’s Degree in Marketing from Suffolk University. Tu is also a Diamond Graduate from the Gemological Institute of America (GIA).', 'Tu has over 20+ years of experience in sales and management roles within the diamond and jewelry industry. Before making the move to Charleston, Tu worked in the original Diamonds Direct location in Charlotte, North Carolina where she was a Diamond Expert for four years. Tu brings a variety of experience to the Vice President role and is looking forward to settling into life in the Lowcountry.', 'In her free time, Tu enjoys reading, practicing yoga and traveling.']
		}, {
			name: 'Igor Zak',
			title: 'Regional Manager',
			picture: 'Igor.JPG',
			email: 'igorz@diamondsdirect.com',
			phone: '',
			bio: ['Igor Zak joined the Diamonds Direct family in 2019. Originally from Israel, Zak made the move to join the team in our Charlotte, North Carolina showroom after working in our Israeli offices for over a year.', 'Outside of work, Zak loves cheering on FC Barcelona, trying new local pizzerias and spending time with his wife.']
		}, {
			name: 'Arti Patel',
			title: 'Diamond Expert',
			picture: 'Arti.JPG',
			email: 'artip@diamondsdirect.com',
			phone: '',
			bio: ['Arti Patel joined the Diamonds Direct family in November 2020. Patel has been in the diamond and jewelry business since 2012. She enjoys helping people and becoming a part of their family.', 'In her free time, Patel loves traveling, cooking and meeting new and interesting people.']
		}, {
			name: 'Ryan Czarnecki',
			title: 'GIA Diamonds Graduate',
			picture: 'Ryan.JPG',
			email: 'RyanC@diamondsdirect.com',
			phone: '',
			bio: ['Ryan Czarnecki, a GIA Diamonds Graduate, has been a part of the Diamonds Direct team since 2014. Ryan got his start as a Jeweler’s Apprentice in 2014 in the Charlotte, North Carolina location before transitioning to the online team in 2017. In 2021, Ryan made the move to Greenville to continue his career as a Diamond Expert.', 'In his free time, Ryan loves watching football, going fishing and hanging out with his dog Ava.']
		}, {
			name: 'Trace Honeycutt',
			title: 'Diamond Expert',
			picture: 'trace.jpg',
			email: 'TraceH@DiamondsDirect.com',
			phone: '',
			bio: ['Trace Honeycutt, Diamond Expert, has been with Diamonds Direct since 2009. She has a Bachelor\'s Degree in Business Marketing and Business Finance from Gaston College and an Associate\'s Degree in Graphic Arts. Honeycutt also is certified by the Diamond Council of America.', 'Honeycutt has been in the diamond and jewelry business since 2003. Previously, she worked in sales and was the Diamond Department Manager at Jared, The Galleria of Jewelry in Concord, North Carolina.', 'In her free time, Honeycutt enjoys painting, reading and hanging out with her dog, Charlie.']
		}, {
			name: 'William Kraus',
			title: 'Master Jeweler',
			picture: 'William.JPG',
			email: 'williamk@diamondsdirect.com',
			phone: '',
			bio: ['William Kraus started his career in the jewelry industry in 2006. Kraus has been a part of the Diamonds Direct family since 2018.', 'Family adventures while creating memories is what drives William’s success.']
		}, {
			name: 'Marni Hermecz',
			title: 'Back Office Manager',
			picture: 'aug08/MarniHermecz.jpg',
			email: 'marnih@diamondsdirect.com',
			phone: '',
			bio: ['Marni Hermecz has been a part of the Diamonds Direct family since 2017. Hermecz started in the Charlotte, North Carolina location where she worked in Customer Service for two years and Special Orders for two years.', 'Originally from Colorado, Hermecz loves now living in South Carolina with her husband. In her free time, she loves gardening, camping, scuba diving and spending time with her animals outside.']
		}, {
			name: 'Bailey Wills',
			title: 'Back Office Support',
			picture: 'aug08/BaileyWills.jpg',
			email: 'baileyw@diamondsdirect.com',
			phone: '',
			bio: ['Bailey Wills, a Greenville native, joined the Diamonds Direct family in 2021.', 'Outside of work, Wills enjoys taking road trips as well as cooking and baking in her tiny home with her boyfriend.']
		}, {
			name: 'Tania Mitar',
			title: 'Front Office Support',
			picture: 'aug08/TaniaMitar.jpg',
			email: 'taniam@diamondsdirect.com',
			phone: '',
			bio: ['Tania Mitar has been a part of the Diamonds Direct Greenville team opening in 2021. Mitar is a certified gemologist and has been a part of the industry since 2008.', 'In her free time, Mitar loves traveling and spending time with her pets.']
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://bit.ly/3B3t9Ri',
			googleWrite: 'https://bit.ly/3B3t9Ri'
		}
	};
	
	var HOU = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Houston (Galleria)',
		title: 'Diamonds Direct Houston (Galleria) - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Houston (Galleria) Location Today!',
		shortName: 'Houston (Galleria)',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Houston to shop our latest arrivals and exclusive selection of diamond and fine jewelry. Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirecthouston',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '3115 West Loop S.',
			line2: 'Houston, TX 77027'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Houston/@29.7357531,-95.4603983,17z/data=!4m5!3m4!1s0x8640c1fcd9285f59:0x1fbae69128ca2661!8m2!3d29.7357485!4d-95.4582043',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '3462502054',
		email: 'infoHOU@diamondsdirect.com',
		team: [{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: ['Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.', 'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.', 'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.', 'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.']
		}, {
			name: 'Tamir Shkargi',
			title: 'Vice President',
			picture: 'Tamir1.jpg',
			email: 'Tamir@diamondsdirect.com',
			phone: '',
			bio: ['Tamir Shkargi joined the Diamonds Direct team 2017. Originally from Israel, Tamir served in the Israeli Military for three years. Upon his completion of service, he embarked on a career with the Israeli government for over ten years. After receiving his degree in Business Administration at Ono Academic College, Tamir decided to move to the United States with his family.', 'Tamir’s new chapter began in Austin, Texas which led him to pursue a career in retail management with Diamonds Direct. It was the remarkable culture and amazing group of people that made Diamonds Direct the perfect fit for Tamir.', 'After managing the Frisco store for nearly two years, he was given the opportunity to bring his talents to Houston and grow the Diamonds Direct family. Tamir greatly looks forward to this new journey with his family and they are excited to call Houston home.', 'Outside of work, Tamir enjoys playing soccer with friends and spending time with his wife and their precious two boys!']
		}, {
			name: 'Kevin Ferrin',
			title: 'General Manager',
			picture: 'kevin_ferrin.jpg',
			email: '',
			phone: '',
			bio: ['While he was born and raised in Virginia, Kevin Ferrin has deep roots in the Lone Star state and considers himself a Texan at heart. Kevin found his passion for jewelry at a young age, following in his mother’s footsteps. After years of working in “big box” stores, Kevin was ready for a big change. Ferrin joined the Diamonds Direct family in 2017 at the Austin location as a Diamond Expert. With more than two decades of jewelry and management experience, Ferrin quickly proved to be a valuable asset to the company. In 2021, Kevin transitioned into the role of General Manager for the Houston location after completing an extensive training program with Diamonds Direct.', 'During his down time Kevin enjoys spending time with his husband, Sean, and their two fur babies. Kevin is also a passionate traveler having visited countries including Mexico, Ireland and Indonesia.']
		}, {
			name: 'Matt Baba',
			title: 'Store Manager',
			picture: 'Matt.jpg',
			email: '',
			phone: '',
			bio: ['Matt joined Diamonds Direct in 2020. Before joining the company, he worked in the industry for over 20 years and is DCA certified. He prides himself in understanding each customer that walks through the door and tailoring their experience to their needs. His goal is to make the diamond buying experience fun and stress-free for every customer.', 'Matt is passionate about furthering his education and is consistently learning. In fact, he is fluent in English, Arabic and American Sign Language. Outside of work, he enjoys spending time with his family.']
		}, {
			name: 'Alvaro Mercado',
			title: 'Bench Jeweler',
			picture: 'Alvaro.jpg',
			email: '',
			phone: '',
			bio: ['Alvaro joined Diamonds Direct in 2020. He has 12 years of experience working as a jeweler. During that time he also managed to complete his Bachelor’s in supply chain management.', 'As a lifelong learner and tinkerer, Alvaro loves that his job is both creative and technical.  It also offers him the ability to become a part, albeit a small one, of people’s life journey. Something that is truly magical.', 'Born in Nicaragua, and raised in Houston, Texas,  he considers himself a Texan through and through. In his spare time he enjoys cooking for his family. Taking his two year old to the chicken farm and watching him try to pet the chickens. And in quieter moments, he has been known to get lost in a Wikipedia rabbit hole or two.']
		}, {
			name: 'Cynthia Cullen',
			title: 'Diamond Expert',
			picture: 'GA4A9168.jpg',
			email: '',
			phone: '',
			bio: ['Cynthia Cullen, diamond expert, is a graduate of Saddleback College in Southern California. In her early career, Cynthia had a career in show business where she worked as a professional jazz dancer in television and theatre in four different countries. For 21 years, she was based in Milan, Italy. In fact, she still is able to speak Italian fluently!', 'Her passion for jewelry began in 2012. Leading up to this, Cynthia owned her own business of importing Murano Hand Blown Glass designer jewelry to Southern California. Cynthia is thrilled to join the Diamonds Direct team and bring her passion for life and jewelry straight to her clients.', 'In her free time, Cynthia enjoys riding her motorcycle and living life to the fullest!']
		}, {
			name: 'Alexandra Sprague',
			title: 'Diamond Expert',
			picture: 'Alex.jpg',
			email: '',
			phone: '',
			bio: ['Alexandra, Diamond Expert, graduated from Le Cordon Bleu with a pastry degree. Although she had an early passion for pastries, diamonds were always curious to her. She eventually began to further her interest in diamonds and made the shift from pastries to diamonds. It was the best transition in her life!', 'Alexandra comes to Diamonds Direct with over four years in the jewelry industry. She enjoys connecting with each guest on a personal level. Her goal is to continuously go above and beyond to ensure each guest has an amazing experience. She is truly passionate about making each and every guest encounter a special and memorable experience.', 'In her spare time, she enjoys spending time with her 5 year old son, Leo.']
		}, {
			name: 'Callie Ahlfenger',
			title: 'Front Office Support',
			picture: 'Callie.jpg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Victoria Puentes',
			title: 'Front Office Manager',
			picture: 'Victoria.jpg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Natalie Baba',
			title: 'Diamond Expert',
			picture: 'Natalie.jpg',
			email: '',
			phone: '',
			bio: ['Natalie is originally from Orlando, Florida. She joined the Diamonds Direct team in November 2020 and has over ten years of retail sales experience. Her truest joy is building relationships with people, and she considers herself privileged to being a part of their memorable life moments. She prides herself on delivering excellent customer service.', 'Outside of work, Natalie loves date nights with her husband. She is an avid cook and spends much of her time in the kitchen. She loves culture and language and speaks both English and Arabic.']
		}, {
			name: 'Jordan de los Santos',
			title: 'Diamond Expert',
			picture: 'jordan.jpg',
			email: '',
			phone: '',
			bio: ['Jordan joined Diamonds Direct as a Diamond Expert in early 2022. While new to the Diamonds Direct family (and Houston), Jordan has been in the jewelry industry for over six years and is DCA certified. She first started out in the industry by creating a custom piece, and immediately fell in love with the process! The driving force behind her success is her passion for fostering meaningful customer relationships; she gives her all to ensure each customer has an incredible experience.', 'Outside of work, she is passionate about travel (one of her favorite destinations was the Argyle diamond mines in Australia) and music. She also enjoys trying out new recipes in the kitchen!']
		}, {
			name: 'Raven Boudreaux',
			title: 'Diamond Expert',
			picture: 'raven.jpg',
			email: '',
			phone: '',
			bio: ['Raven started with Diamonds Direct as a Diamond Expert in early 2022. She is a Houston native, and has worked in jewelry and luxury sales for over five years. Prior to working in the industry, she worked mainly in design, and has since found her passion in helping customers design their dream pieces. This passion allows her to make lifelong connections with her customers and provide them with amazing and memorable experiences. Most recently, she is working to hone her own knowledge and skill set by studying to become a Graduate Gemologist through GIA.', 'In her spare time, Raven enjoys traveling, outdoor activities , live music, and spending time with her two fur babies.']
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://bit.ly/3l0y6EP',
			googleWrite: 'https://bit.ly/3l0y6EP'
		}
	};
	
	var IND = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Indianapolis',
		title: 'Diamonds Direct Indianapolis - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry & More. Visit Our Indianapolis Location Today!',
		shortName: 'Indianapolis',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Race on over to our beautiful showroom on North River Road for all of your jewelry buying occasions. With over 2,000 engagement ring settings you can be sure you’ve picked the perfect one! Looking for an unforgettable proposal? Ask about our annual Colts proposal giveaway!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/DiamondsDirectINDY',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '8557 North River Road',
			line2: 'Indianapolis, IN 46240'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Indianapolis/@39.9110903,-86.1077493,17z/data=!3m1!4b1!4m5!3m4!1s0x872b0d6dcd3f4c63:0x6a3338974955708e!8m2!3d39.9110862!4d-86.1055606',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '3175758555',
		email: 'infoindy@diamondsdirect.com',
		team: [{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: ['Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.', 'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.', 'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.', 'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.', 'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.']
		}, {
			name: 'Niv Ankawa',
			title: 'Vice President',
			picture: 'mar02/NivAnkawa.jpg',
			email: 'Niv@diamondsdirect.com',
			phone: '',
			bio: ['Niv joined Diamonds Direct in 2018. With over 12 years of experience in the fine jewelry and diamond business, Niv’s expertise comes from his many years managing a store in the Diamond District in New York City.  Prior to the Diamond District, Niv also managed a jewelry store in Miami for 7 years. His strength is his ability to connect with people. He believes client satisfaction is the key to a successful brand.  In his free time Niv enjoys being active, playing soccer, frequents the gym, and is an avid skier. He also loves trying new restaurants and traveling all over the world.']
		}, {
			name: 'Robert Violante',
			title: 'General Manager',
			picture: 'robert2.jpg',
			email: 'robert@diamondsdirect.com',
			phone: '',
			bio: ['Robert has been in the diamond and fine jewelry business for over 20 years. He has managed teams across the country, but for the last 8 years has been proud to call Indiana home.  During his time at Diamonds Direct, Robert has had the unique opportunity to work with his clientele to offer some of the most unique, rare, and one-of-a-kind heirlooms in the business. He also enjoys working with his team to bring customers the very best quality and value on certified diamonds anywhere in the United States. When you can’t find him in the showroom, Robert can typically be found on the lake, enjoying a cigar, or spending time with family.']
		}, {
			name: 'Kalyn Knapke',
			title: 'Diamond Expert',
			picture: 'mar02/KalynKnapke.jpg',
			email: 'Kalyn@diamondsdirect.com',
			phone: '',
			bio: ['Kalyn joined Diamonds Direct 2016, bringing 12 years of jewelry sales experience with her. She loves getting to know her clients and creating lifelong friendships with them. In her free time, Kalyn enjoys spending time with her 2 children and husband. She also loves to play euchre.']
		}, {
			name: 'Kris Cassady',
			title: 'Diamond Expert',
			picture: 'mar02/KrisCassady.jpg',
			email: 'Kris@diamondsdirect.com',
			phone: '',
			bio: ['Kris joined Diamonds Direct in 2012 and has been in the jewelry industry for over 21 years. She loves helping clients with their special occasions and life moments. Kris considers herself lucky to be involved in people’s love stories. When she is not working, Kris enjoys spending time with her two kids and animals. She enjoys landscaping, decorating, and cooking.']
		}, {
			name: 'Selena Powell',
			title: 'Diamond Expert',
			picture: 'mar02/SelenaPowell.jpg',
			email: 'Selena@diamondsdirect.com',
			phone: '',
			bio: ['Selena Powell joined Diamonds Direct in 2015 after working in the jewelry industry for 6 1/2 years, and in luxury sales and management for many years before that. She is the mom of 3 and the grandmother of 2 granddaughters  who she can\'t get enough of. She\'s passionate about her family, her career, and her Golden Doodles.']
		}, {
			name: 'Laura Ekram',
			title: 'Back Office Support, GIA Gemologist',
			picture: 'mar02/LauraEkram.jpg',
			email: 'laurae@diamondsdirect.com',
			phone: '',
			bio: ['Laura joined Diamonds Direct in 2018, after being in the jewelry industry since 2005. She is a GIA Graduate Gemologist, specializing in appraisals and loose diamonds. Laura has worked all over the country for independent & online jewelers as a head appraiser . After marrying her husband she moved to the Pacific Northwest where she worked for a large online diamond retailer as the head appraiser, evaluating all incoming stones and jewelry for the company. In her spare time, she enjoys spending time with her husband and two boys, being outdoors and reading.']
		}, {
			name: 'Deborah Coutcher',
			title: 'Reception',
			picture: 'jun9/Deborah.jpg',
			email: 'indyreception@diamondsdirect.com',
			phone: '',
			bio: ['Deborah joined Diamonds Direct in 2012, after being in jewelry sales and management for 15 years. She enjoys being a part of the support staff and connecting with new people every day. In her spare time, Deborah enjoys painting, playing games, reading, and spending time with her grandchildren.']
		}, {
			name: 'Jami Heffner',
			title: 'Store Operations Manager',
			picture: 'mar02/JamiHeffner.jpg',
			email: 'Jamih@diamondsdirect.com',
			phone: '',
			bio: ['Jami joined Diamonds Direct in 2009, and has over 20 years of experience in the jewelry industry. She has done sales, buying and inventory management. In her free time, Jami loves being a mother to her two sons and spending time with her husband of almost 20 years. She loves watching the many sporting events that her boys are involved in, reading a good book, and spending time outdoors.']
		}, {
			name: 'Kim West',
			title: 'Jeweler',
			picture: 'mar02/KimWest.jpg',
			email: 'kimw@diamondsdirect.com',
			phone: '',
			bio: ['Kim joined Diamonds Direct in 2008 bringing 20 years of experience with her. She started in the jewelry industry straight out of high school, and has been a bench jeweler ever since. She loves her work life at Diamonds Direct. In her spare time, Kim loves spending time with her 3 grown children and house full of animals.']
		}, {
			name: 'Kate Mills',
			title: 'Jeweler',
			picture: 'mar02/KateMills.jpg',
			email: 'kathleenm@diamondsdirect.com',
			phone: '',
			bio: ['Kate Joined Diamonds Direct in 2018 with 10 years of jewelry experience. She graduated from Ball State University with a Bachelor of Fine Arts Degree in Jewelry Design and Metal Smithing. Her daily goal is to drive for self-improvement and encourage others to be the best they can be. In her spare time, Kate loves to build things, craft and spend time with her family.']
		}, {
			name: 'Ross Arterberry',
			title: 'Jeweler',
			picture: 'mar02/RossArterberry.jpg',
			email: 'rossa@diamondsdirect.com',
			phone: '',
			bio: ['Ross joined Diamonds Direct in 2017 bringing 45 years of experience with him. He started his career as a bench jeweler right out of high school, after falling in love with industrial arts in school. Ross has won many design competitions for his work, and specializes in custom design & fabrication. In his spare time, he enjoys fixing up old cars, working on home improvement projects, & spending time with his wife, two children, and two grandchildren.']
		}, {
			name: 'Shelby Hubbard',
			title: 'Diamond Expert',
			picture: 'mar02/ShelbyHubbard.jpg',
			email: 'shelbyh@diamondsdirect.com',
			phone: '',
			bio: ['Shelby joined Diamonds Direct in 2019 after being in the jewelry industry for 5 years. She graduated from Indiana University-Purdue University Indianapolis with a degree in Criminal Justice but loved selling jewelry so much, she decided to continue it after graduation. Her favorite thing about being a Diamond Expert is being a part of the process and story that comes along with each and every client. In her free time, Shelby enjoys traveling, being a Dog Mom to her two fur-babies, and spending time with her boyfriend.']
		}, {
			name: 'Rachel Martin',
			title: 'Diamond Expert',
			picture: 'jun9/Rachel.jpg',
			email: 'rachelmartin@diamondsdirect.com',
			phone: '',
			bio: ['Rachel joined Diamonds Direct in 2019 after being in the jewelry business for 20 years in the greater Indianapolis area. She is honored to be a part of the Diamonds Direct Family. She takes pride in giving her guests the best customer experience, catering to them and creating forever friendships. Building relationships & creating special family heirlooms has been Rachel’s favorite part of her career. In her free time, Rachel loved spending time with her loving husband and 3 beautiful children. She enjoys refinishing furniture, painting murals, cooking, and learning to play the piano.']
		}, {
			name: 'Jenny Ervin',
			title: 'Diamond Expert',
			picture: 'mar02/JennyErvin.jpg',
			email: 'jennye@diamondsdirect.com',
			phone: '',
			bio: ['Jenny joined Diamonds Direct in 2019 with over 28 years in the jewelry industry in the greater Indianapolis area. Jenny specializes in custom design and creating heirloom pieces for her clients. To her, it is not selling jewelry, but creating memories for generations to come. Jenny is the mother of 7 wonderful children and wife to a wonderful man. In her free time, Jenny enjoys sitting on her back porch with her husband and children,reading and spending time with her parents. Family is the most important thing to Jenny, right next to diamonds.']
		}, {
			name: 'Grace Campbell',
			title: 'Back Office Support',
			picture: 'mar02/GraceCampbell.jpg',
			email: 'grace@diamondsdirect.com',
			phone: '',
			bio: ['Grace joined Diamonds Direct in 2011 starting her career in the jewelry industry. She started in reception, knows all departments, and has worked her way up. In her spare time, Grace loves spending time with her 2 beautiful children and 3 adorable dogs.']
		}, {
			name: 'Rebecca Byrd',
			title: 'Back Office Support',
			picture: 'mar02/RebeccaByrd.jpg',
			email: 'rebecca@diamondsdirect.com',
			phone: '',
			bio: ['Rebecca joined Diamonds Direct in 2013. She started in the Customer Care department and has knowledge of the whole store. Rebecca works part- time at the store & helps run her family’s farm the rest of the time. She loves spending time with her husband, baby girl, and 3 pets.']
		}, {
			name: 'Chrystal Behan',
			title: 'Diamond Expert',
			picture: 'jun9/Chrystal.jpg',
			email: '',
			phone: '',
			bio: ['Chrystal joined Diamonds Direct in 2020 with over a decade of fine jewelry and diamond experience. Chrystal loves getting to know her clients, and helping celebrate their life\'s most important moments. In her spare time she enjoys travel, watching football and bonfires.']
		}, {
			name: 'Michael Williams',
			title: 'Diamond Expert',
			picture: 'jun9/MichaelW.jpg',
			email: '',
			phone: '',
			bio: ['Michael joined the Diamonds Direct team in 2018 in our Richmond, VA location. He enjoys being a diamond expert with his clients because it allows him to be a part of one of the most important and memorable experiences of people’s lives. In his free time he has fun going out with his friends, visiting new places and enjoying what life has to offer.']
		}, {
			name: 'Claire Butler',
			title: 'Brand Ambassador',
			picture: 'Claire.jpg',
			email: '',
			phone: '',
			bio: ['Claire joined the Diamonds Direct family in December 2021. She has been in a customer service and marketing role since 2016. Claire enjoys community outreach in her role and loves philanthropy work. In her free time, you can find Claire shopping or going on walks with her dog, Kaiya.']
		}, {
			name: 'Jordan Geiger',
			title: 'Front Office Support',
			picture: 'Jordan.jpg',
			email: '',
			phone: '',
			bio: ['Jordan joined the Diamonds Direct family in January 2022. Jordan has been in a Customer Service role since 2017, and is very customer service oriented. In his free time, he enjoys photography, traveling, and loves trying different kinds of food.']
		}],
		sponsorships: [{
			name: 'Indianapolis Colts',
			image: 'colts.jpg'
		}],
		reviews: {
			googleRead: 'https://bit.ly/2Y6ZisG',
			googleWrite: 'https://bit.ly/2Y6ZisG'
		}
	};
	
	var JAX = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Jacksonville',
		title: 'Diamonds Direct Jacksonville - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Jacksonville Location Today!',
		shortName: 'Jacksonville',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Diamonds always shine a little brighter in the Sunshine State! Visit our new showroom on Town Center Parkway for all your fashion and bridal jewelry needs. Located behind Firebirds, our stunning showroom hosts many fun events throughout the year. Keep an eye on our social media to see what’s coming up next.'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectJAX/',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		video: '',
		address: {
			line1: '4840 Town Center Parkway',
			line2: 'Jacksonville, FL 32246'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Jacksonville/@30.2524911,-81.5336816,17z/data=!3m1!4b1!4m5!3m4!1s0x88e5caa73f881a47:0x78dcc11fdfa9490b!8m2!3d30.2524865!4d-81.5314929',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 7pm'
			}],
			notice: ''
		},
		phone: '9045155959',
		email: 'infojax@diamondsdirect.com',
		team: [{
			name: 'Dovy Klarberg',
			title: 'Partner | President South',
			picture: 'dovyk.jpg',
			email: 'Dovy@DiamondsDirect.com',
			phone: '',
			bio: ['Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design.', 'After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.', 'During Dovy\'s time with Diamonds Direct SouthPark, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.', 'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts within Charlotte, NC. He is also focused on making Diamonds Direct SouthPark\'s brand more ingrained in the local community.', 'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.']
		}, {
			name: 'Kelly Flahardy',
			title: 'General Manager',
			picture: 'nov29/KellyLR.jpg',
			email: 'kellyf@diamondsdirect.com',
			phone: '',
			bio: ['Kelly Flahardy joined the Diamonds Direct family in 2018. He attended The University of Phoenix and has a BS in Business, with a concentration in Green and Sustainable Enterprise Management. In addition, he has achieved several Gemological Institute of America (GIA) certificates, including the GIA diamond grading laboratory. Flahardy has been in the jewelry industry for over 25 years. Previously, he was a multi-site operations manager in Boston and Central Florida. In his free time, Flahardy enjoys spending time with his wife and 3 sons. He is also an avid golfer and wine enthusiast.']
		}, {
			name: 'Heather Hutchinson',
			title: 'Back Office Manager',
			picture: 'nov29/HeatherLR.jpg',
			email: '',
			phone: '',
			bio: ['Heather Hutchinson, Back Office Manager is originally from Columbus, Ohio. Heather moved to Charlotte, NC to begin her career with Diamonds Direct in March 2017, before joining the Jacksonville team! With over 15 years in the industry, diamonds and gemstones are her hobby. She is currently pursuing a career dream by becoming a Graduate Gemologist through the Gemological Institute of America. In her free time she enjoys traveling to visit family all over the world, and spending time with her dog Hansel.']
		}, {
			name: 'Jordan Hardy',
			title: 'Special Orders Manager',
			picture: 'nov29/JordanLR.jpg',
			email: 'jordan@diamondsdirect.com',
			phone: '',
			bio: ['Jordan Hardy, Special Orders Manager has been with Diamonds Direct since August of 2017 and has over 5 years of retail experience. She was born and raised in Florida, and studied cosmetology before starting her career in retail. In her spare time, she does hair and makeup for weddings and special events. When she\'s not working, she enjoys spending time with her family, friends, and kittens.']
		}, {
			name: 'Amy Tomlinson',
			title: 'Diamond Expert',
			picture: 'nov29/AmyLR.jpg',
			email: 'amyt@diamondsdirect.com',
			phone: '',
			bio: ['Amy Tomlinson, Diamond Expert has been with Diamonds Direct since 05/2015. Amy is Diamond and Colored Gemstone certified by DCA (Diamond Council of America).', 'Amy has 15 years of experience in the jewelry industry. She started her jewelry career in Albuquerque, New Mexico for Samuel’s Jewelers. Then she moved to San Antonio, Texas to become an Assistant General Manager for Jared The Galleria of Jewelry.', 'Amy was born and raised in Jacksonville, Florida. After moving around the country for several years, she moved back to Jacksonville in 2015. She enjoys spending time with family, taking her dog for walks, and going out dancing.']
		}, {
			name: 'Nicole Alkhoury',
			title: 'Diamond Expert',
			picture: 'nov29/NicoleLR.jpg',
			email: 'nicolea@diamondsdirect.com',
			phone: '',
			bio: ['Nicole Alkhoury, Diamond Expert, has been with Diamonds Direct since June 2015. Nicole has recently graduated from University of North Florida with her Business Management and Marketing degree. She then received her certification from the Gemological Institute of America as an Applied Jewelry Professional. She absolutely loves being apart of her client\'s journey to pick out their perfect engagement ring and jewelry. Her goal is to make all of her clients feel at home by providing them with the best customer service and an overall memorable shopping experience! In Nicole\'s free time, she loves spending quality time with her family and friends. She also enjoys doing outdoor activities, working out, and trying new food! She loves to travel the world and will never pass up an opportunity to experience a new culture or tradition.']
		}, {
			name: 'Amanda Robinson',
			title: 'Diamond Expert',
			picture: 'nov29/AmandaLR.jpg',
			email: 'Amandar@diamondsdirect.com',
			phone: '',
			bio: ['Amanda has been with Diamonds Direct since January 2020. She has over 5 years in the jewelry industry and is a Certified GIA Applied Jewelry Professional. She is born and raised in Jacksonville, FL. In her free time she enjoys spending time with her husband, going to theme parks, and chasing around their many many fur babies.']
		}, {
			name: 'Zack Armour',
			title: 'Diamond Expert',
			picture: 'nov29/ZackLR.jpg',
			email: 'Zacharya@diamondsdirect.com',
			phone: '',
			bio: ['Zack began working in the jewelry industry as a teenager after high school. He’s been with Diamonds Direct since 2019. He has lived in Jacksonville since he was in elementary school and attended the University of North Florida with a focus in Marketing & Visual Design. Outside of his work at Diamonds Direct, Zack enjoys spending time with his daughter, teaching dance, collecting comic books, and doing graphic design.']
		}, {
			name: 'Alessandra Teodorescu',
			title: 'Diamond Expert',
			picture: 'nov29/AlessandraLR.jpg',
			email: 'alexandra@diamondsdirect.com',
			phone: '',
			bio: ['Alessandra Teodorescu, Diamond Expert has been with Diamonds Direct for since 2017. She has a Bachelor\'s Degree in Biomedical Sciences and Chemistry, and has 7 years of experience in retail and marketing. Alessandra was born and raised in Romania and moved to Jacksonville, Florida to reunite with her family at age 16. In her free time she enjoys cooking, working out, and spending time with her two fur babies Kyra and Esmee.']
		}, {
			name: 'Kayla Yarber',
			title: 'Jeweler',
			picture: 'nov29/KaylaLR.jpg',
			email: 'Kaylay@diamondsdirect.com',
			phone: '',
			bio: ['Kayla Yarber has been a Jeweler with Diamonds Direct since September of 2019. She spent several years overseas with her husband before moving back to the states to raise their two daughters. Finally in 2018 she found a passion for the jewelry industry. Having a background in commercial art provided a cornerstone to reaching the jewelers bench, where she has been for the past two years. In her spare time, she enjoys pursuing her passions of painting and sculpting.']
		}],
		sponsorships: [{
			name: 'Jacksonville Jaguars',
			image: 'jags.jpg'
		}],
		awards: [{
			name: 'Bold City Best Finalist',
			image: 'finalist.png'
		}, {
			name: 'The Fabulist',
			image: 'fabulist.png'
		}, {
			name: 'Best in Jacksonville',
			image: 'best.jpg'
		}],
		reviews: {
			googleRead: 'https://bit.ly/2Wy4GVh',
			googleWrite: 'https://bit.ly/2Wy4GVh'
		}
	};
	
	var KCY = {
		template: 'store',
		currentPromo: false,
		title: 'Diamonds Direct Kansas City - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Kansas City Location Today!',
		name: 'Diamonds Direct Kansas City',
		shortName: 'Kansas City',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Kansas City to shop our latest arrivals and exclusive selection of diamond and fine jewelry.', 'Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectkansascity',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '4500 W 119th Street',
			line2: 'Leawood, KS 66209'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Kansas+City/@38.9134995,-94.6407263,17z/data=!3m1!4b1!4m5!3m4!1s0x87c0e938d263b9cd:0x8cbade0dbc683b53!8m2!3d38.9134953!4d-94.6385376',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '9133121660',
		email: 'infoKSC@diamondsdirect.com',
		team: [{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: ['Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.', 'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.', 'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.', 'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.']
		}, {
			name: 'Olga Elmanovich',
			title: 'Vice President',
			picture: 'sept10/Olga.jpg',
			email: 'olga@diamondsdirect.com',
			phone: '',
			bio: ['Originally from Russia, Elmanovich made her home in the United States in Birmingham, Alabama with her husband, Richard. As she earned a degree in linguistics from the University of Alabama at Birmingham, Olga found her passion for diamonds while working part time for Diamonds Direct. Shortly after completing her college education, she joined Diamonds Direct Birmingham fulltime and switched gears to focus on her diamond education. Olga gained her certification as a GIA Accredited Jewelry Professional and enjoyed her career and growth with the company.', 'In 2018, Olga moved to Kansas City and was brought on to manage the new location. After managing the Leawood store for over two wonderful years, she was presented the opportunity to move to Frisco and continue her journey with Diamonds Direct in Texas. Olga has loved every minute of spending time here in Frisco and looks forward to making new memories here with her family.', 'Today, Olga proudly serves as Vice President of the company, now overseeing the Frisco, Kansas City and Oklahoma City markets.']
		}, {
			name: 'Daniel Waters',
			title: 'General Manager',
			picture: 'sept10/DanielWaters.jpg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Angie Clow',
			title: 'Store Manager, DCA Graduate',
			picture: 'sept10/AngieClow.jpg',
			email: 'angiec@diamondsdirect.com',
			phone: '',
			bio: ['Angie Clow joined Diamonds Direct in September of 2018 with over 20 years of experience in luxury goods.', 'Angie\'s experience includes store management, sales management, marketing and operations. She is a Diamond Council of America Graduate in Diamonds and Gemstones and has also completed several GIA courses. In her undergraduate years, Angie earned a Bachelor of Arts in Psychology and Business. Before entering the diamond business, Angie had a successful career as a banker before discovering her passion for jewelry. Throughout her career, Angie worked for national chains and also private jewelers.', 'Angie and her husband have been married for over 20 years and have 3 children together—1 boy and 2 girls.']
		}, {
			name: 'Jodi Gray',
			title: 'Diamond Expert',
			picture: 'jodi_schoenberger.jpg',
			email: 'Jodi@DiamondsDirect.com',
			phone: '',
			bio: ['Jodi Schoenberger has been with Diamonds Direct since 2009. She has a Bachelor’s Degree in Exercise Science/Pre Med from Brigham Young University in Provo, Utah.', 'Schoenberger was introduced to the jewelry industry after being a customer of Diamonds Direct., and then became part of the Diamonds Direct family. She was previously involved in the fitness industry helping others achieve their health goals.', 'In her free time she enjoys teaching and taking Pure Barre, running, biking, and playing ball with her dog, Eddie.']
		}, {
			name: 'Enrique Chavez',
			title: 'Diamond Expert',
			picture: 'sept10/EnriqueChavez.jpg',
			email: 'enriquec@diamondsdirect.com',
			phone: '',
			bio: ['Enrique Chavez joined Diamonds Direct in September of 2018 as a Diamond Expert.', 'Born and raised in Kansas City, Enrique graduated from Metropolitan Community College in Kansas City with a AAS Degree in Hotel and Restaurant Management.', 'After a successful career in the insurance industry, Enrique found his passion for diamonds and entered the jewelry industry. Enrique has 18 years of jewelry experience in retail and performing jewelry remount shows.', 'In his free time he loves cooking for family and friends. Enrique and his spouse Barbara play an integral part in raising their only grandson Chad who is 10.']
		}, {
			name: 'Astrid Cifuentes',
			title: 'Diamond Expert',
			picture: 'sept10/AstridCifuentes.jpg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Deborah Thompson',
			title: 'Front Office Support',
			picture: 'sept10/DeborahThompson.jpg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Eliana Harvey',
			title: 'Diamond Expert',
			picture: 'sept10/ElianaHarvey.jpg',
			email: '',
			phone: '',
			bio: []
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://bit.ly/2WuQtrY',
			googleWrite: 'https://bit.ly/2WuQtrY'
		}
	};
	
	var NOL = {
		template: 'store',
		currentPromo: false,
		title: 'Diamonds Direct New Orleans - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our New Orleans Location Today!',
		name: 'Diamonds Direct New Orleans',
		shortName: 'New Orleans',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in New Orleans to shop our latest arrivals and exclusive selection of diamond and fine jewelry.', 'Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectnola',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '3230 Severn Ave',
			line2: 'Metairie, LA 70002'
		},
		googleMapsLink: 'https://www.google.com/maps/search/diamonds+direct+New+Orleans/@29.847419,-94.3551887,6z/data=!3m1!4b1',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '5043833900',
		email: 'infoNOLA@diamondsdirect.com',
		team: [{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'amit@diamondsdirect.com',
			phone: '',
			bio: ['Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.', 'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.', 'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.', 'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.']
		}, {
			name: 'Yoni Padan',
			title: 'Vice President',
			picture: 'Yoni.jpg',
			email: 'yoni@diamondsdirect.com',
			phone: '',
			bio: ['Yoni Padan joined Diamonds Direct in January of 2012. He was Born in Israel and moved to the United States in 1989. Padan graduated with an international business degree from the University in Herzliya. In 2008, Padan came back to the US and joined Diamonds Direct in 2012. Since the beginning of his career at Diamonds Direct, he made sure to always keep the special thing that makes Diamonds Direct what is, family. "The family spirit of Diamonds Direct penetrates from our staff to our customers and that is why the relationship between us and the customer is so special. I love what I do, and its great waking up every morning feeling that way."', 'In July of 2012, Yoni met his beautiful wife Natasha. They are now very happily married with three boys, Brandon, Ariel and Daniel. He enjoys spending every free second he has with them.']
		}, {
			name: 'Cesar Fuentes',
			title: 'Store Manager',
			picture: 'Cesar.jpg',
			email: 'CesarF@diamondsdirect.com',
			phone: '',
			bio: ['Cesar Fuentes was born in Mexico and has been a long time native of New Orleans. He has spent 32 years in the jewelry industry on both the wholesale and retail sides. He is passionate about customer service and brings vast knowledge of diamonds to the team.', 'Cesar joined the Diamonds Direct team in 2019 as a Diamond Expert.', 'When Cesar is not assisting clients, he enjoys playing soccer, football, and basketball with his three sons. He also enjoys traveling to the beach with his family and exploring the wonderful things life has to offer.']
		}, {
			name: 'Adissack Chung',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'Adi.jpg',
			email: 'AdiC@diamondsdirect.com',
			phone: '',
			bio: ['Adissack "Adi" Chung has more fun selling jewelry than a flying squirrel at a trampoline park.  He has spent the last 32 years in the jewelry industry, owning his own store on the east coast, managing the entire west coast for a California based jeweler, traveling the United States as a sales representative of a major bridal designer, or floating down a lazy river in Texas.  After Studying at Wingate College in North Carolina, where he majored in business, he began his jewelry career as a salesman for a local jeweler. He enjoyed the area, and the connections that he shared with the community so much, that he purchased the business several years later.', 'After years of successfully servicing the jewelry needs of both Carolinas, Adi needed to return home to his family in California and joined an up and coming local jeweler. When he was satisfied with his contributions and free to pursue his love of traveling, Chung joined a nationally recognized bridal designer and traveled the United States sharing new designs with jewelers and customers alike.', 'When Diamonds Direct New Orleans opened in 2019, Adi joined them and enjoys the culture of Louisiana and the gulf coast.', 'In Chung\'s time outside of work he loves to travel and spend time with his beloved Shelly and their adorable Yorkie puppies.']
		}, {
			name: 'Sasha Sergutin',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'Sasha.jpg',
			email: 'SashaS@diamondsdirect.com',
			phone: '',
			bio: ['Sasha Sergutin was born in the Ukraine and moved to the USA in 1995. She worked in the Automotive Industry as a financial specialist for Ford Motors in the Northeast and Southern States. While her financial career was fulfilling, what she really enjoyed was meeting new clients and finding the perfect solution to their needs. This led to her transition to the jewelry industry over ten years ago. She has worked in various sales and leadership roles where she most enjoyed meeting couples and hearing the stories of how they met and fell in love. Sasha finds that continually increasing her expertise in the world of diamonds helps her to meet the needs of her clients more effectively. She has obtained a Diamontology Certification from the Diamond Council of America and seeks new learning opportunities constantly.', 'Her love of Diamonds and the culture of New Orleans led her to join Diamonds Direct New Orleans in 2019 as a Diamond Expert.', 'When Sergutin is not helping couples in love find the perfect expression of love, she loves to travel the world, experiencing different beaches with her travel companion, a long haired dachshund named Mila (Meel-Meel, to her friends).']
		}, {
			name: 'Leslie Gambino',
			title: 'Back Office Manager',
			picture: 'Leslie.jpg',
			email: 'LeslieGambino@diamondsdirect.com',
			phone: '',
			bio: ['Leslie Gambino is a New Orleans native and graduated from Louisiana State University with a Bachelor of Interior Design. While in design school, she was a brand Ambassador with Dior cosmetics where she was introduced to luxury brands and their clientele in the area.  She’s been in the local jewelry industry for 12 years with Mignon Faget, Ltd. in many roles including sales and operations. Her keen eye for detail and ability to connect with everyone she meets has helped many of her clients find the perfect engagement ring for their love story.', 'Outside of work, she has an extensive bucket list that includes many travel destinations. Currently, Iceland and Greece are on deck along with frequent trips to Disney World and her regularly scheduled 2 Saints away games per year. Who Dat?! When she’s not traveling, she’s making custom decorated sugar cookies and can be found at brunch on Sundays, trying out every new restaurant in the city.', 'She and her boyfriend have 3 cats and 2 dogs and always have a lint roller handy.']
		}, {
			name: 'Geary McDonald',
			title: 'Jeweler',
			picture: 'geary.jpg',
			email: '',
			phone: '',
			bio: ['Geary McDonald has been with Diamonds Direct since we expanded to New Orleans in 2019. He graduated from Natchitoches Vo-Tech Jewelry Tech, and has been a jeweler for over 30 years. He has practiced his trade exclusively on the Gulf Coast for the entirety of his career. In his free time, he enjoys spending time with his wife and daughter.']
		}, {
			name: 'Amanda Fekete',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'Amanda.jpg',
			email: '',
			phone: '',
			bio: []
		}],
		sponsorships: [{
			name: 'Tulane',
			image: 'tulane.jpg'
		}, {
			name: 'LSU',
			image: 'lsu.jpg'
		}, {
			name: 'Jefferson Chamber of Commerce',
			image: 'jeff_chamber.jpg'
		}, {
			name: 'LGBT Chamber of Commerce',
			image: 'gulfsouth_lgbq.jpg'
		}, {
			name: 'New Orleans Chamber of Commerce',
			image: 'nola_chamber.jpg'
		}, {
			name: 'New Orleans Yes Girls',
			image: 'nola_yesgirls.jpg'
		}],
		reviews: {
			googleRead: 'https://bit.ly/3mg8WBp',
			googleWrite: 'https://bit.ly/3mg8WBp'
		}
	};
	
	var NVA = {
		template: 'store',
		currentPromo: false,
		title: 'Diamonds Direct Tysons - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Tysons Location Today!',
		name: 'Diamonds Direct Tysons',
		shortName: 'Tysons',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Tysons to shop our latest arrivals and exclusive selection of diamond and fine jewelry.', 'Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirecttysons',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '8113 Leesburg Pike',
			line2: 'Vienna, VA 22182'
		},
		googleMapsLink: 'https://www.google.com/maps/dir//8113+Leesburg+Pike,+Vienna,+VA+22182/@38.9146128,-77.2281991,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x89b64ae455273ecf:0x548765f386e31436!2m2!1d-77.2260104!2d38.9146086!3e0',
		hours: {
			default: [{
				days: 'Monday - Wednesday',
				hours: '10am - 7pm'
			}, {
				days: 'Thursday',
				hours: '10am - 8pm'
			}, {
				days: 'Friday',
				hours: '10am - 8pm'
			}, {
				days: 'Saturday',
				hours: '10am - 7pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '5713076220',
		email: 'infoTYS@diamondsdirect.com',
		team: [{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: ['Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.', 'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.', 'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.', 'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.', 'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.']
		}, {
			name: 'Ori Ben Amitai',
			title: 'Vice President, Virginia',
			picture: 'ori_amitai.jpg',
			email: 'Ori@DiamondsDirect.com',
			phone: '',
			bio: ['Ori Ben Amitai, Vice President, has been with Diamonds Direct since 2012. He attended Bar -Ilan University in Israel where he studied Industrial Practical Engineering. Previously, Ori was working for the diamond cutting facilities of the company in the Israeli diamond district.', 'Born in Ramat Gan, Israel in 1984 and raised in Herzelia, Ben Amitai joined the Israeli defense forces in 2003 and served for 3 years. The military experience gave him great tools to appreciate the good things in life; his wife, family and close friends. The army experience also taught him a new way of life - always be on time never late, be honest with people, and never be afraid of the truth. In 2012 he started to explore the world of diamonds in the diamond cutting facilities of Diamond’s Direct in Ramat Gan, Israel, where he fell in love with them immediately. After one year of experience in the diamond district he was selected to join the company’s other side of the business, the direct-to-the-public stores. He started his way in the Raleigh location where he learned and work with Barak Henis (Vice President of the Raleigh and the Richmond location). Ori then relocated when the company opened its 4th location in Richmond, Virginia. He sees an amazing future to the Richmond market, and puts all his effort in establishing Diamonds Direct as a strong brand in the community. In his free time Ori likes to travel with his wife and his dog exploring Richmond and its surrounding cities.']
		}, {
			name: 'Rahul Vohra',
			title: 'General Manager',
			picture: 'jun26/Rahul.jpg',
			email: 'rahulv@diamondsdirect.com',
			phone: '',
			bio: ['Rahul Vohra has been with Diamonds Direct since 2020. He has a Bachelor Degree from University of Maryland and has over 25 years experience in the Jewelry industry.', 'He  was born in Silver Spring, Maryland, but has also lived in:  New Jersey, Virginia,Washington DC , North Carolina before settling back home in Maryland. In his free time he enjoys cheering for the Washington Commanders Football Team,spending time with his wife and two kids, and exercising.']
		}, {
			name: 'Ray Sindac',
			title: 'Diamond Expert',
			picture: 'jun26/RAY.jpg',
			email: 'Ray@DiamondsDirect.com',
			phone: '',
			bio: ['Ray Sindac has been with Diamonds Direct since January 2018. He is certified by the Diamond Council of America and has a Bachelor\'s Degree in Business Administration & Management from the University of Maryland University College.', 'Ray started his career in jewelry 13 years ago where he started as a Jewelry Consultant and ended a position as a District Manager. Ray is a father to a wonderful soon-to-be 4-year old boy who is currently obsessed with Monster Jams. He enjoys spending every minute with him.']
		}, {
			name: 'Andrea Mitchell',
			title: 'Diamond Expert',
			picture: 'jun26/ANDREA.jpg',
			email: 'Andreami@diamondsdirect.com',
			phone: '',
			bio: ['Andrea has an impressive luxury sales and management background with more than 15 years experience with Cartier, Bulgari, and Saks Fifth Avenue. She had been selected to attend training sessions in NY, Paris, Switzerland, Dubai, and Italy.', 'Andrea loves spending time with family and friends and has a passion for travel. She is thankful that retail has allowed her to travel and experience many different cultures. She often says that she has been both student and teacher.']
		}, {
			name: 'Kay Suy',
			title: 'Diamond Expert',
			picture: 'jun26/KAY.jpg',
			email: 'Kays@diamondsdirect.com',
			phone: '',
			bio: ['Kay has been in the jewelry business for over 20 years and joined the Diamonds Direct family in 2021. He was born in Cambodia during the war also known as the "Killing Field". Kay and his family knew that they needed to flee Cambodia if they had any hope of any future and eventually landed in Montreal, Quebec Canada. He spent his childhood going to school in France and loved playing ice hockey.  Right after high school, he moved to the Washington, D.C. area and started a small jewelry business with his parents in Georgetown. He eventually left to study at the Gemological Institute of America (G.I.A) in Carlsbad, CA and graduated as an Graduate Gemologist in 2001. He is also a proud father of twin boys: Kayden and Jayden and a little girl named Akira.']
		}, {
			name: 'Linda Foy',
			title: 'Diamond Expert',
			picture: 'jun26/LINDA.jpg',
			email: 'Lindaf@diamondsdirect.com',
			phone: '',
			bio: ['Linda Foy joined the Diamonds Direct team in 2020, sharing her passion for luxury service with clients. Before joining the Diamonds Direct team, Linda worked in the jewelry industry onboard cruise ships in the Caribbean, Alaska and South America for seven years. In addition to working in the Tyson’s Corner store, Linda has also worked in our Dallas, Frisco, and Raleigh locations.', 'In her free time Linda has a love for traveling, cooking, spending time with her daughter, and her pets.']
		}, {
			name: 'Tina Sindac',
			title: 'Back Office Manager',
			picture: 'jun26/TINA.jpg',
			email: 'TinaS@diamondsdirect.com',
			phone: '',
			bio: ['Tina Sindac rejoined the Diamonds Direct family back in May of 2021, and has over 9 years experience with Customer Service, holding many different positions with Diamonds Direct. She graduated from Carson-Newman University in 2011 with a Bachelor\'s Degree in Applied Psychology.   In her spare time she likes to spend time with her nephew and travel throughout the country to see family, friends, and new sights!']
		}, {
			name: 'Lora Price',
			title: 'Shop Manager',
			picture: 'jun26/LORA.jpg',
			email: 'lora@diamondsdirect.com',
			phone: '',
			bio: ['Lora Price has been with Diamonds Direct since 2016. She graduated from VCU with dual Bachelor’s degrees in English and Craft/Material Studies, and respective focuses in mythology and jewelry.', 'In her spare time, she continues to create her own art, go for walks around Richmond, and explore various breweries and restaurants with her friends.']
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://www.google.com/search?q=diamonds+direct+tysons+corner&sxsrf=APq-WBs1_F_YMr4fPKw1kuas2wgk_edWXw%3A1646328568601&source=hp&ei=-PogYvXcHoTLkPIPw9OjgAE&iflsig=AHkkrS4AAAAAYiEJCDx4QFNGyj61yqf8Q_uS5KCFVXY7&oq=diamonds&gs_lcp=Cgdnd3Mtd2l6EAEYADIECCMQJzIECCMQJzIECCMQJzIOCC4QgAQQsQMQxwEQrwEyCwguEIAEEMcBEK8BMgUIABCRAjILCC4QxwEQrwEQkQIyCAguEIAEELEDMgUILhCABDIFCAAQgAQ6BwgjEOoCECc6DQguEMcBEKMCEOoCECc6CgguEMcBEK8BECc6CgguEMcBEK8BEEM6DgguEIAEELEDEMcBEKMCOggIABCxAxCDAToICAAQgAQQsQM6BAgAEEM6BAguEEM6BwguENQCEEM6CgguEMcBEKMCEEM6DQguELEDEMcBEK8BEEM6DgguELEDEMcBEK8BEJECULcJWNAOYMMeaAFwAHgBgAF8iAG_BpIBAzMuNZgBAKABAbABCg&sclient=gws-wiz',
			googleWrite: 'https://www.google.com/search?q=diamonds+direct+tysons+corner&sxsrf=APq-WBs1_F_YMr4fPKw1kuas2wgk_edWXw%3A1646328568601&source=hp&ei=-PogYvXcHoTLkPIPw9OjgAE&iflsig=AHkkrS4AAAAAYiEJCDx4QFNGyj61yqf8Q_uS5KCFVXY7&oq=diamonds&gs_lcp=Cgdnd3Mtd2l6EAEYADIECCMQJzIECCMQJzIECCMQJzIOCC4QgAQQsQMQxwEQrwEyCwguEIAEEMcBEK8BMgUIABCRAjILCC4QxwEQrwEQkQIyCAguEIAEELEDMgUILhCABDIFCAAQgAQ6BwgjEOoCECc6DQguEMcBEKMCEOoCECc6CgguEMcBEK8BECc6CgguEMcBEK8BEEM6DgguEIAEELEDEMcBEKMCOggIABCxAxCDAToICAAQgAQQsQM6BAgAEEM6BAguEEM6BwguENQCEEM6CgguEMcBEKMCEEM6DQguELEDEMcBEK8BEEM6DgguELEDEMcBEK8BEJECULcJWNAOYMMeaAFwAHgBgAF8iAG_BpIBAzMuNZgBAKABAbABCg&sclient=gws-wiz'
		}
	};
	
	var OKC = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Oklahoma City',
		title: 'Diamonds Direct Oklahoma City - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Oklahoma City Location Today!',
		shortName: 'Oklahoma City',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Shopping for your next piece of jewelry will come sooner than you think and our diamond experts are always here to make the purchase a breeze. You’ll leave our showroom across from Penn Square Mall feeling much better than OK about the gift in your bag.'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectokc/',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '5521 North Pennsylvania Ave',
			line2: 'Oklahoma City, OK 73112'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Oklahoma+City/@35.5249928,-97.5502213,17z/data=!3m1!4b1!4m5!3m4!1s0x87b21a6aeb42c02d:0xc3b558b8e6e2aa1b!8m2!3d35.5249885!4d-97.5480326',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '4056088802',
		email: 'infoOKC@diamondsdirect.com',
		team: [{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: ['Amit Berger, EVP, founded Diamonds Direct Birmingham in 2008. He joined the Diamonds Direct parent company in 1995 in Israel while working in the cutting facility and learning the trade\'s secrets.', 'Born in Israel, Berger grew up working in his family restaurant business and developed his love of customer service and gregarious personality. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry. It was then when he started working for Diamonds Direct\'s parent company in the cutting facility with the founder of the company.', 'In 1997, Berger came to the United States to begin working one on one with big diamond buyers. He traveled back and forth between Israel and 40 different states in the US working for Diamonds Direct\'s parent company in the wholesale division. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work with Diamonds Direct\'s parent company in the wholesale office and selling diamonds to top jewelry stores around the country. Eventually, Berger was running the wholesale division and was in charge of selecting diamonds from the cutting facility in Israel.', 'In the meantime, his brother Itay, had opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the company. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.']
		}, {
			name: 'Yosi Mayer',
			title: 'Vice President',
			picture: 'yosi_mayer.jpg',
			email: 'yosi@diamondsdirect.com',
			phone: '',
			bio: ['Yosi Mayer, Vice President, joined the Diamonds Direct family in 2016.', 'Born in Israel, Mayer served in the Israeli Military for three years in the Paratroopers Brigade. For the past 16 years Mayer has worked in the diamond and jewelry industry all over the world with experience ranging from wholesale to retail.', 'Mayer\'s career in the industry began in 2000, in retail sales for a major jewelry chain in Mexico and the Caribbean. From there, he worked his way up the ladder to manage several stores in a General Manager capacity. In 2008 Mayer decided it was time to move back to Israel, where he continued to work in the industry only this time as a Sales Manager and Buyer for leading wholesale firms at the Israeli Diamond Exchange.', 'In 2016 Mayer met Itay Berger – President of Diamonds Direct and understood that joining the company would allow him to keep pursuing his passion for exceptional customer service, team leading and business development. For that reason, he made the decision to move his family to Dallas.', 'Mayer is married to his high-school sweetheart Liz. They have two lovely daughters and a dog. He enjoys spending time with his family while exploring Dallas and the surrounding areas. He takes interest in learning different cultures and languages and is a self proclaimed foodie, always chasing the next great meal.']
		}, {
			name: 'Olga Elmanovich',
			title: 'Vice President',
			picture: 'KC_Olga_Elmanovich.jpg',
			email: 'olga@diamondsdirect.com',
			phone: '',
			bio: ['Originally from Russia, Elmanovich made her home in the United States in Birmingham, Alabama with her husband, Richard. As she earned a degree in linguistics from the University of Alabama at Birmingham, Olga found her passion for diamonds while working part time for Diamonds Direct. Shortly after completing her college education, she joined Diamonds Direct Birmingham fulltime and switched gears to focus on her diamond education. Olga gained her certification as a GIA Accredited Jewelry Professional and enjoyed her career and growth with the company.', 'In 2018, Olga moved to Kansas City and was brought on to manage the new location. After managing the Leawood store for over two wonderful years, she was presented the opportunity to move to Frisco and continue her journey with Diamonds Direct in Texas. Olga has loved every minute of spending time here in Frisco and looks forward to making new memories here with her family.', 'Today, Olga proudly serves as Vice President of the company, now overseeing the Frisco, Kansas City and Oklahoma City markets.']
		}, {
			name: 'Ibrahim Arch',
			title: 'General Manager',
			picture: 'aug27a/Ib2.jpg',
			email: '',
			phone: '',
			bio: ['Ibrahim Arch, General Manager, joined the Diamonds Direct family in 2019.', 'From growing up in the Cayman Islands, to living in the Middle East and his years spent traveling through Europe, Ibrahim brings a unique, international perspective to the Oklahoma City market. Ibrahim’s driving factor is his deep appreciation for and interest in interconnectivity and the human condition. He is passionate about the close relationships he is able to form with his Rhino team and OKC clients. These connections inspire him daily.', 'In and out of the showroom, Ibrahim is a big believer in hard work and service leadership. In his personal time, he cultivates life balance by spending quality time with his family, taking care of his health by exercising and eating healthy and growing as a person through a constant pursuit of knowledge.']
		}, {
			name: 'Alicia Merrick',
			title: 'Marketing & Merchandising Manager',
			picture: 'aug27a/Alicia.jpg',
			email: '',
			phone: '',
			bio: ['Alicia Merrick, Marketing and Merchandising Manager, joined the Diamonds Direct family in 2021. She brings a blended creative background made up of event planning, marketing, and digital media. Originally from Yukon Oklahoma, she graduated with a degree from the University of Central Oklahoma in Strategic Communications and is a current student at the University of Oklahoma- College of Law. She has worked in event and marketing management for Oklahoma City based restaurants, residential housing, and the Chickasaw Nation.', 'In her free time she enjoys traveling and enjoying Oklahoma Cities restaurants and culture.']
		}, {
			name: 'Stevie Barnes',
			title: 'Back Office Support',
			picture: 'steve_barnes.jpg',
			email: 'stevieb@diamondsdirect.com',
			phone: '',
			bio: ['Stevie Barnes, Back Office Support, joined the Diamonds Direct family in 2015.', 'Stevie Barnes joined the Diamonds Direct team in 2015. Barnes began her career in the jewelry industry in 2004, previously working at Helzberg Diamonds and Samuel Gordon Jewelers. Stevie’s customer service skills are a continued asset to the Oklahoma City back office team.', 'Barnes lives in Oklahoma City with her husband. She enjoys spending time with her family and dogs, watching football, and reading.']
		}, {
			name: 'Motoko Hulme-Baldwin',
			title: 'Diamond Expert',
			picture: 'motoko2.jpg',
			email: 'mhulme@diamondsdirect.com',
			phone: '',
			bio: ['From earning a degree in Criminal Justice from the University of Central Oklahoma and starting a family, Motoko brings a compassionate outlook to Diamonds Direct Oklahoma City. Being a DCA Graduate and bringing over 20 years of experience in the professional jewelry industry, Motoko is a light of knowledge to her team. She cares deeply for every customer that enters Diamonds Direct and includes them as the Diamonds Direct family.', 'When she is not in the showroom, Motoko spends her quality time with her intimate family and friends. She can be found riding with her husband in their Slingshot and spending time with her grandsons. Motoko’s greatest achievements with Diamonds Direct have been developing her passion for custom designs while working as a sales representative for prestigious brands.']
		}, {
			name: 'James Harrison',
			title: 'GIA Graduate Gemologist',
			picture: 'aug27a/James.jpg',
			email: 'JamesH@diamondsdirect.com',
			phone: '',
			bio: ['James Harrison, Diamond Expert, joined the Diamonds Direct family in September 2018. His jewelry industry background began in 1982. He Graduated from the esteemed Gemological Institute of America in 1988 receiving his Graduate Gemologist Diploma. He has worked in almost every facet of the industry from diamond and gemstone buyer, Appraiser, Sales and Retail General Manager for the past 20 years.', 'In his free time he enjoys writing songs and playing guitar as well as spending quality time with his wife and son.']
		}, {
			name: 'Steven McKnight',
			title: 'Shop Manager',
			picture: 'aug27a/Steven.jpg',
			email: '',
			phone: '',
			bio: ['Steven McKnight, Shop Manager, Joined the Diamonds Direct family in 2020. Steven is certified from the Institute of Jewelry Training. With a deep rooted knowledge of the jewelry industry, he adds over 30 years of experience to the Diamond Direct family. His knowledge helps to guide Diamonds Direct in all customer needs.', 'In Steven’s free time, he can be found fishing and playing golf.']
		}, {
			name: 'Sarah Permenter',
			title: 'Back Office Manager',
			picture: 'aug27a/Sarah.jpg',
			email: '',
			phone: '',
			bio: ['Sarah Permenter, Back Office Manager, joined the Diamonds Direct family in 2018.', 'Sarah has paved her way through the Oklahoma City store from beginning as the Front Office Manager in 2018. During the transition of moving to a new department- she took the opportunity and flourished! Sarah’s background in Early Childhood Care has enabled her to bring over vast skills such as; dedication and resistance to the Diamonds Direct back office team.', 'In Sarah’s free time she enjoys hiking, watching movies, and spending time with friends.']
		}, {
			name: 'Dana Robinson',
			title: 'Diamond Expert',
			picture: 'aug27a/Dana.jpg',
			email: '',
			phone: '',
			bio: ['Dana Robinson, Diamond Expert, joined the Diamonds Direct family in 2019. Dana offers a extensive background in sales and the jewelry industry. Having spent over 19 years in the industry she has a deepened understanding of the value that each customer brings to the rhino family.', 'When she is not dedicating her time to each of his customers, she enjoys spending time with her family.']
		}, {
			name: 'Nickie McCarty',
			title: 'Diamond Expert',
			picture: 'nickie.jpg',
			email: '',
			phone: '',
			bio: ['Nickie McCarty joined the Diamonds Direct team in 2020. Nickie has held numerous professional roles in sales and insurance. With a passion for people, she relocated from Kentucky to Oklahoma to pursue new career opportunities with Diamonds Direct. Nickie’s continued joy of growth is a continued asset to the Oklahoma City team.', 'When not at Diamonds Direct, she can be found spending time with her friends and family exploring all things fun and exciting in the heart of Oklahoma City.']
		}, {
			name: 'Cindy Graham',
			title: 'Diamond Expert',
			picture: 'CindyG.jpg',
			email: '',
			phone: '',
			bio: ['Cindy Graham, Diamond Expert, joined Diamonds Direct in 2021. She has held over 20 years of experience in the diamond industry and sales as well as is GIA certified. Cindy is knowledgeable and informative for all current and new clients of Diamonds Direct. Cindy’s passion for her role is an asset to the Oklahoma City team.', 'Cindy can be found spending time with her family when not dedicating herself to the Oklahoma City team. She enjoys sports, enjoying OKC’s local entertainment, and meeting everyone she can.']
		}],
		sponsorships: [{
			name: 'Oklahoma Sooners',
			image: 'ou.jpg'
		}],
		reviews: {
			googleRead: 'https://bit.ly/3ipA0x6',
			googleWrite: 'https://bit.ly/3ipA0x6'
		}
	};
	
	var PIT = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Pittsburgh',
		title: 'Diamonds Direct Pittsburgh - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Pittsburgh Location Today!',
		shortName: 'Pittsburgh',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Pittsburgh to shop our latest arrivals and exclusive selection of diamond and fine jewelry. Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectpittsburgh',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '5004 McKnight Rd.',
			line2: 'Pittsburgh, PA 15237'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Pittsburgh/@40.5337875,-80.0126722,17z/data=!3m1!4b1!4m5!3m4!1s0x88348bbcfac54495:0xc67af54422512c31!8m2!3d40.5337834!4d-80.0104782',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '4128379070',
		email: 'infoPITT@diamondsdirect.com',
		team: [{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: ['Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.', 'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.', 'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.', 'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.', 'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.']
		}, {
			name: 'Tery Vari',
			title: 'Vice President, OH',
			picture: 'tery.jpg',
			email: 'TeryV@DiamondsDirect.com',
			phone: '',
			bio: ['Tery Vari, Vice President, has been with Diamonds Direct since 2011. He received his Bachelors of Science in Marketing from Ohio State University.', 'Vari has been in the diamond and jewelry industry for over 20 years. Previously, he was the General Manager for Jared, the Galleria of Jewelry and the District Manager for Reeds Jewelers.', 'In his free time, Vari enjoys spending time with his wife and two sons and is active in the community.']
		}, {
			name: 'Heidi Andrews',
			title: 'General Manager',
			picture: 'dec7/Heidi.jpg',
			email: 'HeidiA@diamondsdirect.com',
			phone: '',
			bio: ['Heidi Andrews started her journey with the Diamonds Direct family in Columbus Ohio in August 2018.', 'In 2004, Andrews had started her career in the jewelry industry as various leadership roles in Ohio, Pennsylvania and North Carolina.', 'To this day she values all the relationships that she has made through the years and seeing all the special moments unfold with every one of them! In her spare time, she enjoys spending time with her husband Duane and their adorable Shih Tzu, Hank.']
		}, {
			name: 'Stuart Bowles',
			title: 'Shop Manager',
			picture: 'dec7/Stuart.jpg',
			email: 'Stuart@diamondsdirect.com',
			phone: '',
			bio: ['Stuart joined the Diamonds Direct family in 2016 in his home state of Indianapolis, and managed our Cleveland shop until Pittsburgh opened in early 2021. He has since earned certifications through Jewelers of America and Stuller.  Stuart maintains many hobbies outside of work such as 3D printing, tabletop gaming, Facebook Marketplace window shopping, as well as avidly pursing a revived passion for archery and outdoor life.  Stuart and his wife Ashley have two boys and have taken a great liking to the wooded hills of northern Pittsburgh, as well as the parks and unique foodie spots available all around them.']
		}, {
			name: 'Mikayla Wykle',
			title: 'Diamond Expert',
			picture: 'apr6/Mikayla.jpeg',
			email: 'MikaylaW@diamondsdirect.com',
			phone: '',
			bio: ['Mikayla Wykle, Diamond Expert, has been with Diamonds Direct since early 2020. She made her way to Diamonds Direct shortly after she received her Bachelors of Science Degree in December of 2019 from Ohio University. Wykle has been in the jewelry industry since roughly 2015. She worked as a Sales Associate and Inventory Control Specialist for five years with another major jewelry company before becoming a part of the Diamonds Direct family. She has a passion for creating an unsurpassed customer experience each and every time someone walks into the showroom.  In her free time, she enjoys playing pool, making music, and creating memories with friends and family.']
		}, {
			name: 'Jessica Hart',
			title: 'Back Office Manager',
			picture: 'apr6/Jessica.jpeg',
			email: 'JessicaH@diamondsdirect.com',
			phone: '',
			bio: ['Jessica Hart, joined the Diamonds Direct family in early 2021. Originally from Lafayette, Indiana, Jessica attended Indiana University Bloomington studying journalism and political science. She has over 14 years experience in the jewelry and retail industries. In her free time, Jessica enjoys reading, travelling with her husband, and watching movies.']
		}, {
			name: 'Melanie Burke-Pohl',
			title: 'Diamond Expert',
			picture: 'dec7/Melanie.jpg',
			email: 'melanieb@diamondsdirect.com',
			phone: '',
			bio: ['Melanie Burke-Pohl joined the Diamonds Direct family in 2021 as a Diamond Expert, but has been in the jewelry industry for over 28 years. She began selling and romancing diamonds at Service Merchandise in 1993. Following that, became a diamond and jewelry buyer for over 23 years at Goldstock Jewelers. After Goldstock closed their doors, she worked at Orr\'s Jewelers. In her spare time, she loves yoga, wine, and enjoying new experiences.']
		}, {
			name: 'Emily Reinhart',
			title: 'Brand Ambassador',
			picture: 'dec7/Emily.jpg',
			email: 'emilyr@diamondsdirect.com',
			phone: '',
			bio: ['Emily came to Diamonds Direct in July 2021 from the fashion industry.  She graduated from the Fashion Institute of Technology in 2015 and started her career in New York City working in a luxury showroom on Fifth Avenue.  Having grown up in the South Hills of Pittsburgh, she moved back in 2018 where she spent some time as a pricing analyst, and more recently a personal stylist.  She loves natural gemstones and using her knowledge to help clients find the right styles for them!']
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://bit.ly/3okQzOy',
			googleWrite: 'https://bit.ly/3okQzOy'
		}
	};
	
	var RAL = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Raleigh',
		title: 'Diamonds Direct Raleigh - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Raleigh Location Today!',
		shortName: 'Raleigh',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Conveniently located outside Crabtree Valley Mall, Diamonds Direct has been proud to call Raleigh home since 2008. Whether you’re shopping for the perfect blue or red accessory for football or basketball season, or popping the question to the love of your life, our diamond experts have you covered!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectcrabtree',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '4401 Glenwood Avenue',
			line2: 'Raleigh, NC 27612'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Crabtree/@35.8391239,-78.678694,17z/data=!3m1!4b1!4m5!3m4!1s0x89acf63f665b90d5:0x31b889ab95b95172!8m2!3d35.8391196!4d-78.6765053',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '9195712881',
		email: 'infoRal@diamondsdirect.com',
		team: [{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'aug27/barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: ['Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.', 'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.', 'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.', 'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.', 'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.']
		}, {
			name: 'Lev Shnaidman',
			title: 'Vice President, Raleigh',
			picture: 'aug27/lev_shnaidman.jpg',
			email: 'Lev@DiamondsDirect.com',
			phone: '',
			bio: ['Lev Shnaidman, Vice President, has been with Diamonds Direct since 2012. He has a Bachelor\'s Degree in Hospitality Management from Florida International University where he graduated Magna Cum Laude.', 'Shnaidman has over 25 years of customer service experience. Previously, he was the Operations Director of Bill Hansen Catering in Miami, Florida. He mastered his diamond education at the Arabov Diamond group headquarters in Tel Aviv, Israel, his native hometown.', 'Shnaidman is husband to wife Nicole and father to two sons. He enjoys watching and playing sports, and spending time with family.']
		}, {
			name: 'Brian Dedrickson',
			title: 'General Manager & Director of Training and Development',
			picture: 'aug27/brian_dedrickson.jpg',
			email: 'BrianD@DiamondsDirect.com',
			phone: '',
			bio: ['Brian Dedrickson, General Manager & Director of Training and Development, has been with Diamonds Direct since 2010. He attended San Francisco State University where he studied Economic Analysis and Financial Forecasting.', 'Dedrickson has been in the diamond and jewelry industry for 30 years. Previously, he was a trainer on diamonds and watches and has managed boutique and couture jewelry stores in Seattle, Washington DC, San Francisco and Saint Louis. Dedrickson has also appeared around the country as a guest speaker and educator on diamonds.', 'In his free time, Dedrickson enjoys spending time with his wife Rhonda, daughter and two grandchildren. He also collects and restores Vintage pre-depression watches, unusual pens and participates in online diamond and vintage watch forums as a moderator.']
		}, {
			name: 'Tessa Kitko',
			title: 'Marketing Manager',
			picture: 'oct18/Tessa.jpg',
			email: 'TessaG@DiamondsDirect.com',
			phone: '',
			bio: ['Tessa has been with Diamonds Direct since 2014, starting in sales before transitioning to the marketing team. She has a BS in Brand Management and Marketing, and a minor in Art Studies, from the College of Textiles at North Carolina State University.', 'Born and raised in Raleigh, Tessa is passionate about her community, as well as sustainable fashion and farming practices. In her free time she sings in an emo cover band and goes foraging with her husband.']
		}, {
			name: 'Laura Gallardo',
			title: 'Diamond Expert',
			picture: 'aug27/laura_gallardo.jpg',
			email: 'LauraG@DiamondsDirect.com',
			phone: '',
			bio: ['Laura Gallardo, Diamond Expert, has been with Diamonds Direct since 2010. She has an Associate\'s Degree in Business Administration. Gallardo also attended the Gemological Institute of America (GIA) in New York.', 'Gallardo has been in the diamond and jewelry industry for over 25 years. Previously, she worked as a Diamond Consultant for Fortunoff on Long Island before moving to North Carolina with her family in 2007. Before getting involved in the industry, Gallardo worked in the Real Estate business.', 'In her free time, Gallardo enjoys spending time with her two children.']
		}, {
			name: 'Lisa Johnson',
			title: 'Diamond Expert',
			picture: 'oct18/Lisa-Johnson.jpg',
			email: 'LisaJ@DiamondsDirect.com',
			phone: '',
			bio: ['Lisa Johnson, Diamond Expert, has been with Diamonds Direct since 2010. She is currently working toward a Bachelor\'s Degree in Business Administration with a concentration in Retail Management and a Minor in Marketing from Strayer University. Johnson currently holds an Associate\'s Degree in Recreation and Therapeutic Therapy from Vance Granville Community College.', 'Johnson has been in the diamond and jewelry industry for twelve years. She was previously a manager at a local independent store and an assistant manager at a local mall retailer.', 'In her free time, Johnson enjoys spending time with her beautiful little girl and family and friends.']
		}, {
			name: 'Liz Schuvart',
			title: 'Graduate Gemologist',
			picture: 'aug27/liz_schuvart.jpg',
			email: 'LizS@DiamondsDirect.com',
			phone: '',
			bio: ['Liz Schuvart, Graduate Gemologist, has been with Diamonds Direct Crabtree since the fall of 2013. She has a Graduate Gemology degree from the Gemological Institute of America and has a bachelor’s degree from Simmons College in Boston.', 'Schuvart has over 20 years of experience in the jewelry field.', 'Schuvart and her husband, along with their two kids and dog, moved from Boston to Raleigh in the summer of 2013. They enjoy exploring the area in their free time.']
		}, {
			name: 'Sylvia Wilcox',
			title: 'Diamond Expert',
			picture: 'oct18/Sylvia.jpg',
			email: 'SylviaW@DiamondsDirect.com',
			phone: '',
			bio: ['Sylvia Wilcox, Diamond Expert, has been with Diamonds Direct since 2010. She has studied the colored stone and diamond program at H. Stern, attended Mayors University and regularly attends sales seminars.', 'Wilcox has been in the diamond and jewelry industry for 22 years and started her journey in St. Thomas where she managed three jewelry stores. She has also worked in management at White Hall Jewelers, Mayor\'s Jewelers, Little Switzerland and worked in sales at Wynn & Co. in Las Vegas.', 'In her free time, Wilcox enjoys traveling, gardening and sailing.']
		}, {
			name: 'Tina Greene',
			title: 'Diamond Expert',
			picture: 'oct18/Tina.jpg',
			email: 'TinaG@DiamondsDirect.com',
			phone: '',
			bio: ['Tina Greene, Diamond Expert, joined Diamonds Direct in July of 2014. She attended North Carolina State University where she studied Meteorology.', 'Greene has over 15 years of experience in the jewelry industry, earning several accreditations from the Gemological Institute of America (GIA) and the American Gemological Society (AGS). Previously she was a store manager for Helzberg Diamonds in the Raleigh area. She has also worked in the D.C. and Atlanta markets.', 'In her free time, Greene enjoys cross-training, weight-lifting, and spending time with friends and family.  Nothing beats Mom\'s Sunday pot roast!']
		}, {
			name: 'Roxie Harden',
			title: 'Shipping & Receiving',
			picture: 'aug27/roxie_harden.jpg',
			email: 'RoxieH@DiamondsDirect.com',
			phone: '',
			bio: ['Roxie Harden, Customer Service Expert, joined Diamonds Direct in November 2015. She has earned several accreditations from Diamond Council of America (DCA), Gemological Institute of America (GIA), and American Gemological Society (AGS).', 'Harden has over 15 years of experience in the jewelry industry and customer service. She has previously been a Store Manager for a small jewelry kiosk, as well as an Office Manager for Helzberg Diamonds in the Raleigh and Fayetteville areas.', 'In her free time, Harden enjoys spending quality time with friends and family and her cat, Casper. She enjoys spending time at the lake. Harden is very active in her church and community outreach projects.']
		}, {
			name: 'Andres Gomez',
			title: 'Shop Manager',
			picture: 'jul15/andres.jpg',
			email: 'Andres@DiamondsDirect.com',
			phone: '',
			bio: ['Andres Gomez was born in Cuba in 1970. Gomez learned the profession of jewelry in 1991 from his talented father. Gomez came to the United States in 1994 and has been working in the industry ever since.In November of 2012, Gomez began a new stage of his life by joining Diamonds Direct and continues to love what he does.', 'In his free time, Gomez likes to spend time with his family and play soccer and baseball with his kids.']
		}, {
			name: 'Cindy Parker',
			title: 'Virtual Diamond Expert',
			picture: 'aug27/cindy_parker.jpg',
			email: 'CindyP@DiamondsDirect.com',
			phone: '',
			bio: ['Cindy Parker has been with Diamonds Direct since April 2016. She attended NC State University where she studied Mechanical Engineering and has been in the jewelry business for over 25 years. She started out operating an independent store, then shifted to sales and management with Sterling Jewelers where she worked in the Cary/Raleigh area for 14 years.', 'In her spare time, she enjoys traveling, flying and spending time with her husband and two children.']
		}, {
			name: 'Austin Witmer',
			title: 'Diamond Expert',
			picture: 'oct18/Austin.jpg',
			email: 'AustinW@DiamondsDirect.com',
			phone: '',
			bio: ['Austin Witmer joined the Diamonds Direct team in August of 2016. Witmer graduated from Liberty University in 2010 with a Bachelor’s degree in Business Finance. Witmer has over ten years of experience in the jewelry industry, both in Raleigh, NC, and in Virginia. He has a strong passion for timepieces and, of course, diamonds!  His easygoing, calm personality doesn’t make him your traditional salesperson, and his goal is for you to earn his trust so he can be your jeweler for life!', 'He has been married to his high school sweetheart, Connie, since 2010, and they have 2 kids. In his free time, he enjoys spending time with his kids, family and friends, trying new restaurants around the Triangle, playing golf, and attending or watching any sports events. Some of his favorite teams are the UNC Tar Heels, Dallas Cowboys, and Baltimore Orioles.']
		}, {
			name: 'Eric Williams',
			title: 'Diamond Expert',
			picture: 'oct18/Eric.jpg',
			email: 'EricW@DiamondsDirect.com',
			phone: '',
			bio: ['Eric Williams, Diamond Expert, joined the Diamonds Direct Crabtree team in June 2016. Certified by the Diamond Council of America with 10 years of dedication to the jewelry industry, Williams offers extensive knowledge and a customer service level second to none.', 'Originally from Richmond, VA, Williams began his career as a Personal Banker for Bank of America Merrill-Lynch. After committing five years to the financial industry specializing in financial planning and insurance, Williams decided to take a chance.', 'In 2007, Williams made a lateral career move and began as a Sales Associate for Sterling Jewelers. Within one year, his work ethic propelled him to Timepiece Department Manager, and he earned a consecutive promotion every year following that. After successfully managing several departments and assisting managers, Williams was entrusted with a store of his own as General Manager in 2012. Williams continued to rise in the company with three more stand-alone stores located in Virginia, Maryland, and North Carolina until 2016 when he was referred to Diamonds Direct.', 'Since bringing his unique and informed approached to his presentations, Williams not only becomes your personal Diamond Expert, but also a trusted friend.', 'In his free time, Williams is a true family man and enjoys sports, travel, entertaining friends, and a good cigar.']
		}, {
			name: 'Paul James Testa',
			title: 'Bench Jeweler',
			picture: 'aug27/paul_testa.jpg',
			email: 'PaulT@DiamondsDirect.com',
			phone: '',
			bio: ['Paul James Testa joined the Diamonds Direct team in August 2017. He has worked in multiple facets of the jewelry industry including cast contracting, repair and assembly since 1992.']
		}, {
			name: 'Prem Sharma',
			title: 'Diamond Expert',
			picture: 'aug27/prem_sharma.jpg',
			email: 'PremS@DiamondsDirect.com',
			phone: '',
			bio: ['Prem Sharma, Diamond Expert, joined the Diamonds Direct family in July 2018.', 'Sharma has been in the jewelry business for over 20 years in the Caribbean island of St. Thomas. He has a passion for selling rare gemstones and diamonds! He would love to help you find an engagement ring that would be a lifetime treasure!', 'Sharma enjoys traveling with his family to new and different places around the world.']
		}, {
			name: 'Kirsten Hower',
			title: 'Customer Care',
			picture: 'jul15/kirsten.jpg',
			email: 'RaleighReception@DiamondsDirect.com',
			phone: '',
			bio: ['Kirsten Hower started at Diamonds Direct in April of 2019. She has had 10 years of customer service experience, in which she tries her best to exceed expectations. Hower plans on beginning her journey in college soon where she will study child development and psychology. She loves spending her free time with her lovely daughter; always teaching her new things, going out to the park, and having princess parties. Her little girl is the light of her life and the reason for everything that she does.']
		}, {
			name: 'Leslie Rosenfeld',
			title: 'Diamond Expert',
			picture: 'oct18/Leslie.jpg',
			email: 'LeslieR@DiamondsDirect.com',
			phone: '',
			bio: ['Leslie has been a part of the  Diamonds Direct Family since February 2021. She is originally from Long Island, New York and moved to North Carolina in March of 2020.', 'Leslie comes with over 10 years of customer service and management experience. As a diamond expert she enjoys being a part of her client\'s special moment!', 'When she’s not making customers smile in the showroom, she enjoys traveling around the country with her boyfriend competing in dart tournaments. She also likes exploring Raleigh and playing with her puppy!']
		}, {
			name: 'Daniel Peiffer',
			title: '',
			picture: 'oct18/Daniel.jpg',
			email: 'DanielP@DiamondsDirect.com',
			phone: '',
			bio: ['Daniel Peiffer joined the Diamonds Direct team in July of 2021. Peiffer graduated from Grove City College in 2018 with a Bachelor’s degree in Communication Studies and Design. Peiffer recently moved from Pittsburgh and brings with him over five years experience in customer service and care. His background blends perfectly with the jewelry industry as he has a strong passion for customers’ satisfaction and, of course, diamonds!', 'Daniel spends his free time with friends, trying new bars around the Triangle, playing tennis, cycling and watching sports. Some of his favorite teams are the Pittsburgh Steelers, Carolina Hurricanes, and the New Zealand All Blacks.']
		}, {
			name: 'Sal Roccaforte',
			title: '',
			picture: 'oct18/Sal.jpg',
			email: 'SalR@DiamondsDirect.com',
			phone: '',
			bio: ['Salvatore Roccaforte is new to the Diamonds Direct family, joining the team in August of 2021. Though originally from New York, he recently moved to North Carolina from Seattle Washington to be closer to family.', 'Salvatore has over 25 years of experience in management and customer service.', 'In his free time he enjoys finding antiques, collectables, and under-valued companies.']
		}, {
			name: 'Destiny Allison',
			title: 'Front Desk',
			picture: 'oct18/Destiny.jpg',
			email: '',
			phone: '',
			bio: ['Destiny Allison started with Diamonds Direct in March of 2021 and always aims to put a smile on everyone\'s face with her bubbly personality!  She has over ten years of customer service experience in the restaurant industry, as well as retail. Before joining the team, Destiny attended culinary school with a major in baking and pastry arts.', 'Destiny enjoys spending time with her little family that includes her husband and her two rescue fur babies, Bailey and Andrei. She is a huge advocate for "Adopt Don\'t Shop" and pit bulls.  In her free time she enjoys binge watching her favorite reality tv shows (the Below Deck Series and Dallas Cowboys Cheerleaders: Making the team), going to the dog park, and trying new recipes. Destiny is also known for being a huge Carolina Hurricanes fan and can be found at every home game!']
		}, {
			name: 'Andi Chappell',
			title: 'Front Desk',
			picture: 'oct18/Andi.jpg',
			email: '',
			phone: '',
			bio: ['Andi Chappell has been part of the Diamonds Direct family since July 2021. She has over ten years experience in customer service and retail.. Andi grew up in a military family and has lived in several states, but has called North Carolina home since 2002.', 'In her free time, Andi enjoys traveling to new places, hunting, and spending time with her son and dog. Her son is the light of her life and the reason for everything she does. One day she plans to own a farmhouse with horses to operate as a venue.']
		}, {
			name: 'Ginger Hollifield',
			title: 'Diamond Expert',
			picture: 'oct18/Ginger.jpg',
			email: 'GingerH@DiamondsDirect.com',
			phone: '',
			bio: ['Ginger Hollifield  joined Diamonds Direct in June of 2021. She has worked in the jewelry industry for almost 20 years, including time spent with Friedman’s as both a sales associate and store manager, and Jared as a Sales consultant and Diamond manager. Prior to becoming part of the Diamonds Direct family, Ginger worked for a local jeweler Bailey’s Fine Jewelry for 10 years. Ginger is accredited with the Diamond Council of America (DCA) and American Gemological Society(AGS).', 'Ginger has been married to her high school sweetheart for 31 years and has three wonderful children. In her free time she enjoys making memories and cookies with her two sweet granddaughters.']
		}, {
			name: 'Viviana Zuccardi',
			title: 'Diamond Expert',
			picture: 'oct18/Viviana.jpg',
			email: 'VivianaZ@DiamondsDirect.com',
			phone: '',
			bio: ['Viviana is a sales professional and social communicator with emphasis in digital marketing. She has her Master’s Degree in Marketing and Commercial Management and is experienced in B2C and B2B sales and advertising, with a focus on new market development and brand recognition. Viviana has been successful in fostering excellent relationships with customers and suppliers through exceptional service and deep understanding of their needs. We are fortunate to have had her join the Diamonds Direct team in April of 2021.', 'Viviana Zuccardi comes from a family of three generations of jewelers in Colombia (the emerald capital of the world). Raised by experts and surrounded by diamonds and Colombian emeralds, it was inevitable that she grew to love and have a passion for the jewelry business! She has traveled the world and attended the best jewelry shows on each continent, discovering new designs and, with each new adventure, falls in love anew with the jewelry industry.']
		}],
		sponsorships: [
		// {
		// 	name: 'North Carolina State',
		// 	image: 'ncstate.jpg',
		// },
		{
			name: 'Carolina Hurricanes',
			image: 'hurricanes.jpg'
		}],
		reviews: {
			googleRead: 'https://bit.ly/3mg7ora',
			googleWrite: 'https://bit.ly/3mg7ora'
		}
	};
	
	var RVA = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Richmond',
		title: 'Diamonds Direct Richmond - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Richmond Location Today!',
		shortName: 'Richmond',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Located in West Broad Village, our showroom is just a short drive from downtown Richmond. In such a historical city, it’s only natural you’d want to make your own history with the one you love. Our diamond experts are always here to help with any occasion you’re shopping for.'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectrichmond',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '11131 West Broad Street',
			line2: 'Glen Allen, VA 23060'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Richmond/@37.6482832,-77.6001329,17z/data=!3m1!4b1!4m5!3m4!1s0x89b13e0a4c7756af:0xb74962c2a45657cb!8m2!3d37.648279!4d-77.5979442',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '8049670500',
		email: 'infoRic@diamondsdirect.com',
		team: [{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: ['Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.', 'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.', 'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.', 'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.', 'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.']
		}, {
			name: 'Ori Ben Amitai',
			title: 'Vice President, Virginia',
			picture: 'ori_amitai.jpg',
			email: 'Ori@DiamondsDirect.com',
			phone: '',
			bio: ['Ori Ben Amitai, Vice President, has been with Diamonds Direct since 2012. He attended Bar -Ilan University in Israel where he studied Industrial Practical Engineering. Previously, Ori was working for the diamond cutting facilities of the company in the Israeli diamond district.', 'Born in Ramat Gan, Israel in 1984 and raised in Herzelia, Ben Amitai joined the Israeli defense forces in 2003 and served for 3 years. The military experience gave him great tools to appreciate the good things in life; his wife, family and close friends. The army experience also taught him a new way of life - always be on time never late, be honest with people, and never be afraid of the truth. In 2012 he started to explore the world of diamonds in the diamond cutting facilities of Diamond’s Direct in Ramat Gan, Israel, where he fell in love with them immediately. After one year of experience in the diamond district he was selected to join the company’s other side of the business, the direct-to-the-public stores. He started his way in the Raleigh location where he learned and work with Barak Henis (Vice President of the Raleigh and the Richmond location). Ori then relocated when the company opened its 4th location in Richmond, Virginia. He sees an amazing future to the Richmond market, and puts all his effort in establishing Diamonds Direct as a strong brand in the community. In his free time Ori likes to travel with his wife and his dog exploring Richmond and its surrounding cities.']
		}, {
			name: 'Dianne Gatto',
			title: 'General Manager & GIA Graduate Gemologist',
			picture: 'dianne_gatto.jpg',
			email: 'DianneG@DiamondsDirect.com',
			phone: '',
			bio: ['Dianne Gatto, Graduate Gemologist, has been with Diamonds Direct since 2012. Gatto graduated from the Gemological institute of America (GIA) in New York City where she earned her Graduate Gemologist Degree.', 'Gatto has been in the diamond and jewelry industry for 29 years. She previously worked for a large independent in the metropolitan DC area, where she was the Operations Manager.', 'In her free time, Gatto enjoys cooking, boating, playing softball and spending time with her boyfriend and dog.']
		}, {
			name: 'Afton Sleichter',
			title: 'Regional Back Office Manager/Graduate Gemologist',
			picture: 'afton_sleichter.jpg',
			email: 'aftons@diamondsdirect.com',
			phone: '',
			bio: ['Afton Sleichter has been with Diamonds Direct since 2014. She has a Bachelor\'s Degree in Art History and a Minor in History from Virginia Commonwealth University.', 'Sleichter has over five years of experience in the jewelry industry and earned her Graduate Gemologist designation from the Gemological Institute of America in 2011. Previously, she worked with an independent store in the Washington, D.C., region.', 'In her free time, the Richmond native enjoys reading, sewing and spending time with her husband, son and dogs.']
		}, {
			name: 'Stephen Bittman',
			title: 'Diamond Expert',
			picture: 'stephen_bittman.jpg',
			email: 'StephenB@diamondsdirect.com',
			phone: '',
			bio: ['Stephen has been with Diamonds Direct since 2013. He was born and raised in Binghamton, New York, a small city in the beautiful upstate region on the New York and Pennsylvania border. He attended Syracuse University, where he studied economics and business. Stephen began his career working for a successful group of Binghamton investment bankers managing various real estate properties.', 'After four years, he joined his Dad in his wholesale jewelry business in Binghamton. Stephen soon began to reshape the business into a retail operation and commenced by developing stores within a 90 mile radius of the home base. He ultimately operated 4 stores in the region, and became the President and Owner of the company. He ran the operations for 30 years and in 2006 chose to explore other opportunities, and left the jewelry business and came to Richmond to become involved in other business ventures. He welcomed the opportunity to re-enter the jewelry field and is very excited to be part of the Diamonds Direct team of professionals.', 'Stephen is married to his wife, Nancy, and they have two children; a daughter and a son-in-law, and a son. They are the proud grandparents to two grandchildren. In his free time Stephen enjoys playing golf, traveling, reading novels and socializing with friends.']
		}, {
			name: 'Katia Clocicova',
			title: 'Diamond Expert',
			picture: 'katia.jpg',
			email: 'katiac@diamondsdirect.com',
			phone: '',
			bio: ['Katia Clocicova has joined Diamonds Direct team in February 2019. She studied global economy and international relations in her country of origin, Republic of Moldova.', 'With over 7 years experience in retail, luxury cosmetics and customer service, Katia is thrilled to be able to guide and help couples to choose the best of what Diamonds Direct has to offer.']
		}, {
			name: 'Ashok Dhansinghani',
			title: 'Diamond Expert',
			picture: 'ashok_dhansinghani.jpg',
			email: 'ashd@diamondsdirect.com',
			phone: '',
			bio: ['Ashok Dhansinghani, known by friends and family as Ash, has been with Diamond Direct since 2013. He studied Business and Commerce in the Stanes University in India.', 'He has been in the diamond and jewelry industry for 22 years. Previously he has worked in Princess Jewelers as an assistant manager. Dhansinghani has worked in diverse markets including Alaska and the U.S. Virgin Islands before finally making Richmond his home.', 'In his free time, Dhansinghani enjoys spending time with his wife and watching sporting events with his two boys. He also enjoys going to movies, reading and spending time with friends.']
		}, {
			name: 'Deneen Ell',
			title: 'Diamond Expert',
			picture: 'deneen_ell.jpg',
			email: 'deneen@diamondsdirect.com',
			phone: '',
			bio: ['Deneen Ell joined the Diamonds Direct team in 2017. She is DCA certified and has experience in both the corporate and luxury jewelry industry. For Deneen, family is first and she is truly passionate about helping couples discover the perfect diamond and ring they have been dreaming of. She is committed to listening carefully to both the needs and the wants of each customer and then skillfully guiding them through the entire purchase process.']
		}, {
			name: 'Dmitriy Gerasimov',
			title: 'Diamond Expert',
			picture: 'dmitriy.jpg',
			email: 'dimag@diamondsdirect.com',
			phone: '',
			bio: ['Dmitriy was born in Russia and immigrated with his parents to Richmond when he was 8 years old. He started his jewelry career over a decade ago and quickly developed a passion for diamonds and helping customers celebrate love. Dmitriy’s favorite part of the job is the relationships that he develops with his clients. He believes it to be an honor to help people with celebrating their happiest life moments; engagements, weddings, anniversaries, the birth of children and everything in between. Dmitriy loves having a part in helping his clients with their most cherished moments.', 'Dmitriy joined the Diamonds Direct Family in February of 2019. He has 12 years of jewelry experience, previously working for a national, corporate jewelry store, as well as a luxury family owned jeweler. He is excited to bring his experience and keen eye for quality to Richmond’s premier diamond retailer. His specialty is selection. Dmitriy meticulously analyzes thousands of diamonds and selects only the best value and quality for each client’s specific needs. He loves that Diamonds Direct gives him the best resources, with the largest inventory and best prices in the industry.', 'When he is not working, Dmitriy loves spending time with his fiancée, Sarah, and daughter Savannah. Self-proclaimed “foodies”, Dmitriy and Sarah love the Richmond restaurant scene. He is also an avid fisherman and enjoys any activity on the water.']
		}, {
			name: 'Denise Popp',
			title: 'Diamond Expert',
			picture: 'popp.jpg',
			email: 'denisep@diamondsdirect.com',
			phone: '',
			bio: ['Denise Popp has been with Diamonds Direct since 2013. She attended Savannah College of Art and Design, where she received her degree in Painting and Art history. Popp has over a decade of customer service and jewelry experience.', 'In her free time, Popp enjoys painting, reading, and spending time with her loved ones.']
		}, {
			name: 'Larisa Seamster',
			title: 'Diamond Expert',
			picture: 'larisa_seamster.jpg',
			email: 'larisas@diamondsdirect.com',
			phone: '',
			bio: ['Larisa started at Diamonds Direct Richmond in 2017, but has been in the jewelry industry since 2003. She is DCA Diamond certified and a graduate of the Gemological Institute of America. She came to the United States from Russia in 1999. She is happily engaged and has 2 amazing children named Victor and Yana. In her free time she loves fishing and boating.']
		}, {
			name: 'Gary Wakefield',
			title: 'Diamond Expert',
			picture: 'gary_wakefield.jpg',
			email: 'garyw@DiamondsDirect.com',
			phone: '',
			bio: ['Gary Wakefield has been living in the Richmond area almost all his life. He was worked in retail, happily serving the people of central Virginia with companies like Merry-Go-Round Enterprises, Sea Dream Leather, and Jared the Galleria of Jewelry. He is now enjoying his exciting journey with Diamonds Direct! Gary and his beautiful wife Charise, enjoy traveling and spending time with friends and their amazing dog, Manhattan (breed shih tzu).']
		}, {
			name: 'Angela Baker',
			title: 'Back Office Manager',
			picture: 'angela_baker.jpg',
			email: 'angelab@diamondsdirect.com',
			phone: '',
			bio: ['Angela Baker was born and raised in Sheffield, England. She has lived in the United States for 20 years, including Baltimore, MD for 18 years and now Richmond,VA. She has been with Diamonds Direct Richmond since March 2017. She has been apart of the Jewelry industry for 20 years and previously worked for a large family owned business in Baltimore. In her free time, she loves to go out to eat with her husband, sample new craft beers on the market and also loves to spend time with her dog.']
		}, {
			name: 'Kasey Bates',
			title: 'Special Orders Manager',
			picture: 'kasey_bates.jpg',
			email: 'kaseyb@diamondsdirect.com',
			phone: '',
			bio: ['Kasey Bates started at Diamonds Direct in 2012 as one of the first receptionists at the Richmond, Virginia location. In 2014, she headed up the Customer Care department, and in 2015 moved to the back office to be the Special Orders Manager.', 'In her free time, Kasey likes to spend time with her husband and their two daughters.']
		}, {
			name: 'Kimary Bourret',
			title: 'Customer Care',
			picture: 'kimary_bourret.jpg',
			email: 'kimaryb@diamondsdirect.com',
			phone: '',
			bio: ['Kimary Bourret has been with Diamonds Direct since November 2016. She was born and raised in Findlay, Ohio but has lived in Virginia since 1986. She has 35 years in the customer service retail industry. She is a certified Master Floral Designer. In her free time she loves being outdoors, whether it be on land or water and especially enjoys spending time with her 6 children!']
		}, {
			name: 'Vickie Pyle',
			title: 'Customer Care',
			picture: 'vickie_pyle.jpg',
			email: 'vickiep@diamondsdirect.com',
			phone: '',
			bio: ['Vickie Pyle has been with Diamonds Direct since 2012. She was born and raised in Richmond, VA where she graduated from Hermitage High School. She has over 25 years in the customer service industry.', 'In her free time, she enjoys dancing and spending time with her son, Andrew.']
		}, {
			name: 'Daniel Eaves',
			title: 'Jeweler',
			picture: 'daniel_eaves.jpg',
			email: 'daniele@diamondsdirect.com',
			phone: '',
			bio: ['Daniel Eaves is a graduate of Virginia Commonwealth University and Cranbrook Art Academy and has worked as a jeweler for over 25 years.', 'He lives on a family farm and enjoys spending time with his wife and two daughters.']
		}, {
			name: 'Matt Silva',
			title: 'Jeweler',
			picture: 'matt_silva.jpg',
			email: 'MattS@DiamondsDirect.com',
			phone: '',
			bio: ['Matt Silva got his start in jewelry from his family. He has been professionally trained, but credits a lot of his learning from his family who own several jewelry stores in Massachusetts, where he apprenticed. Matt came to work at Diamonds Direct in 2014.', 'After moving often as a child of a military family, Matt now calls Virginia home. He is a graduate of Community High School and lives in the Richmond area with his wife and children. He loves to fish and remodel his home in his off time.']
		}, {
			name: 'Jana Prinzivalli',
			title: 'Diamond Expert',
			picture: 'jana.jpg',
			email: 'Janap@diamondsdirect.com',
			phone: '',
			bio: ['Jana has been with Diamonds Direct since 2017. She was born in Western New York, but has called Richmond home for the past 4 years. Jana has over 8 years of customer service experience.', 'In her free time she enjoys traveling and spending time with her husband and three dogs.']
		}, {
			name: 'Bryan Ames',
			title: 'Diamond Expert',
			picture: 'bryan.jpg',
			email: 'bryanames@diamondsdirect.com',
			phone: '',
			bio: ['Bryan Ames recently joined the Diamonds Direct family in November 2020, after having been a loyal customer for seven years previously. Bryan has been involved in luxury retail with over 15 years sales and management experience with Richmond Piano. He was also the owner/operator of a local youth sports franchise; i9 Sports, for several years before selling the business to a participating member. With a strong passion for customer experience, education, and a desire to assist in creating lasting memories with clients, Bryan believes listening intently while giving gentle guidance helps clients achieve these moments, all while having total confidence in their decision making.', 'When Bryan is not in the amazing Diamonds Direct showroom, he and his wife will be found riding their Harleys on country roads exploring quaint little towns for places to eat, shop and just have fun. So far, they have ridden over 18,000 miles together through VA, WV, KY, TN, NC, PA, DC, MD, NY, VT, IN, OH, MI and are looking forward to many more.']
		}, {
			name: 'Jenna Holepit',
			title: 'Diamond Expert',
			picture: 'jenna.jpg',
			email: 'jennah@diamondsdirect.com',
			phone: '',
			bio: ['Jenna was born and raised in Alexandria, Virginia and has been living in the Richmond area on and off since 2013. She has been in the Jewelry industry since 2013, certified with the Diamond Council of America, and has a Bachelor’s Degree of Science in Criminal Justice. She has over 13 years of customer service experience, loves working with people, and enjoys being a part of their celebration experience at Diamonds Direct! Prior to jewelry, Jenna was a licensed hairstylist since 2008, specializing in color and cuts. She now does hair as a hobby. Jenna loves to have fun, laugh, have a good time and build relationships with people while assisting them to find the perfect gift for their loved ones! She truly loves what she does and is honored to be a part of their amazing experience!', 'When Jenna isn’t working at Diamonds Direct, she enjoys spending time with her son, spa days, shopping, kickboxing, traveling different places and a total foodie!”']
		}],
		sponsorships: [{
			name: 'Virginia Commonwealth University',
			image: 'vcu.jpg'
		}, {
			name: 'University of Virginia',
			image: 'sabers.jpg'
		}],
		reviews: {
			googleRead: 'https://bit.ly/39VrcdN',
			googleWrite: 'https://bit.ly/39VrcdN'
		}
	};
	
	var STL = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct St. Louis',
		title: 'Diamonds Direct St Louis - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our St Louis Location Today!',
		shortName: 'St. Louis',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Meet us in St. Louis for every occasion! Shop one-on-one with one of our amazing Diamond Experts in our gorgeous showroom for an unmatched, luxury experience no matter your budget. With top bridal and fashion designers from around the world, you’re sure to get something to make all your friends jealous.'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectSTL',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '11619 Olive Blvd',
			line2: 'Saint Louis, MO 63141'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+St.+Louis/@38.6708739,-90.4414091,17z/data=!3m1!4b1!4m5!3m4!1s0x87df32bd1b83b255:0x5b0c0769af596ae5!8m2!3d38.6708697!4d-90.4392204',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '3149423777',
		email: 'infostl@diamondsdirect.com',
		team: [{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: ['Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.', 'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.', 'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.', 'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.', 'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.']
		}, {
			name: 'Niv Ankawa',
			title: 'Vice President',
			picture: 'niv.jpg',
			email: 'Niv@diamondsdirect.com',
			phone: '',
			bio: ['Niv joined Diamonds Direct in 2018. With over 12 years of experience in the fine jewelry and diamond business, Niv’s expertise comes from his many years managing a store in the Diamond District in New York City. Prior to the Diamond District, Niv also managed a jewelry store in Miami for 7 years. His strength is his ability to connect with people. He believes client satisfaction is the key to a successful brand. In his free time Niv enjoys being active, playing soccer, frequents the gym, and is an avid skier. He also loves trying new restaurants and traveling all over the world.']
		}, {
			name: 'Evan Newbill',
			title: 'General Manager',
			picture: 'evan.jpg',
			email: 'evan@diamondsdirect.com',
			phone: '',
			bio: ['Evan has been with Diamonds Direct since 2017, but started in the jewelry business at just 18 years old. He was born in Florida, raised in Virginia, and now enjoys his home in St. Louis. He has been able to enjoy all of the wonderful things life has to experience from the East Coast to the Midwest. His core philosophies always align with educating the customer, and the customer experience-- above all else. From collaborating with local businesses in the community to welcoming in new clients, he always knows how to make someone feel appreciated and valued. In his spare time, he enjoys going on new adventures with his  three sons.']
		}, {
			name: 'Veroniqua Kaighin',
			title: 'Diamond Expert',
			picture: 'veroniqua_kaighin.jpg',
			email: 'Veroniqua@diamondsdirect.com',
			phone: '',
			bio: ['Veroniqua has been with Diamonds Direct since 2016. Veroniqua has been in the diamond industry since 2006, both in sales and management. She is the mother of four boys, with whom she enjoys spending most of her time with. She also enjoys cooking, boating, running, and spending time on her family farm.']
		}, {
			name: 'Mark Medeiros',
			title: 'Diamond Expert',
			picture: 'aug3/MarkMedeiros.jpg',
			email: 'Markm@diamondsdirect.com',
			phone: '',
			bio: ['Mark has been with Diamonds Direct since 2015. He has over 20 years of experience in the diamond and jewelry industry. He\'s a certified Diamontologist from the Diamond Council of America. Formerly a professional dancer, Mark now spends his free time enjoying golf, tennis, bowling, and traveling, especially to the tropics.']
		}, {
			name: 'Gai Kranz',
			title: 'Diamond Expert, GIA Gemologist',
			picture: 'aug3/GaiKranz.jpg',
			email: 'Gai@diamondsdirect.com',
			phone: '',
			bio: ['Gai is a G.I.A. Graduate Gemologist, and a A.G.S. Certified Gemologist Appraiser. She has been with Diamonds Direct since 2017. She has over 41 years of experience in the St. Louis jewelry industry. In her free time she trains service dogs for handicapped people through Support Dogs Incorporated. She is an identical twin, and has two sons who work for the Saint Louis County Police Force.']
		}, {
			name: 'Sophie Imamovic',
			title: 'Front Office Manager',
			picture: 'aug3/SophieImamovic.jpg',
			email: 'Sophie@diamondsdirect.com',
			phone: '',
			bio: ['Sophie has been with Diamonds Direct since November 2016. Born in Germany she attained her diploma in Computer Programming from London. Sophie previously worked as an interpreter/translator for Bosnian refugees in Germany, and customer service and sales here in the United States. In her free time she loves traveling with her husband, and two daughters.']
		}, {
			name: 'Claudia Davis',
			title: 'Back Office Manager',
			picture: 'aug3/ClaudiaDavis.jpg',
			email: 'Claudiad@diamondsdirect.com',
			phone: '',
			bio: ['Claudia has been with Diamonds Direct since 2017. Claudia started her Diamonds Direct career as a receptionist, and has made her way to her home in the back office as the back office manager. Claudia loves being in the jewelry industry, her favorite part of her job is having the opportunity to be part of so many clients\' love stories. In her free time, Claudia enjoys watching the Saint Louis Blues, and spending time with her friends and family, especially her fur baby, Pacha.']
		},
		// {
		// 	name: 'Adrijana Mehic',
		// 	title: 'Inventory Control',
		// 	picture: 'adrijana_mehic.jpg',
		// 	email: 'Adrijana@diamondsdirect.com',
		// 	phone: '',
		// 	bio: [
		// 		'Adrijana has been with Diamonds Direct since January 2017. She currently works in our back office as inventory control and special orders.',
		// 		'She has six years of customer service experience. She has a cosmetology license from Grabber School of Hair Design.',
		// 		'In her free time she enjoys spending time with family, hanging with friends, and trying new foods. Originally from Bosnia, she moved to California for 11 years and now resides in St. Louis. She enjoys experiencing new things in the St. Louis area.',
		// 	],
		// },
		{
			name: 'Guy Fellers',
			title: 'Master Jeweler',
			picture: 'aug3/GuyFellers.jpg',
			email: 'Guyf@diamondsdirect.com',
			phone: '',
			bio: ['Guy is a Master Jeweler and has been with Diamonds Direct since November 2016. He has over 43 years of experience in custom jewelry, restoration and repair. In his free time he enjoys food, watching the Cardinals, going to the shooting range, fishing, and spending time with his wife.']
		}, {
			name: 'Adam Creviston',
			title: 'Jeweler',
			picture: 'aug3/AdamCreviston.jpg',
			email: 'Adamc@diamondsdirect.com',
			phone: '',
			bio: ['Adam has been with Diamonds Direct since August of 2017.  Prior to working at Diamonds Direct, Adam was a lighting restorationist at an antique shop specializing in architectural style antiques. Adam is originally from Indianapolis, and worked at our sister store before making the move to beautiful Saint Louis. In his free time Adam enjoys spending time with his girlfriend, Portia, and his dog and cat. He also enjoys fishing, hiking, reading, and playing video games.']
		}, {
			name: 'Brendan Willers',
			title: 'Front Office Support',
			picture: 'aug3/BrendanWillers.jpg',
			email: 'brendanw@diamondsdirect.com',
			phone: '',
			bio: ['Brendan has been with Diamonds Direct since 2019. He graduated the University of Central Missouri with a bachelor\'s degree in Communication Studies with an emphasis in relational communication. He also played college soccer at Lewis and Clark Community College. Outside of work, you can catch him watching his beloved Saint Louis Blues and Cardinals. He also loves spending time with family and friends.']
		}, {
			name: 'Noah Wootten',
			title: 'Diamond Expert',
			picture: 'aug3/NoahWootten.jpg',
			email: 'noahw@diamondsdirect.com',
			phone: '',
			bio: ['Noah has been with Diamonds Direct since the summer of 2020. Noah began his employment with Diamonds Direct as Front Office Support, before being moved to Customer Care. His favorite part of the repair desk is taking in priceless family heirloom pieces, and doing whatever necessary to make it a fully functional piece of jewelry again. Noah aspires to grow his career with Diamonds Direct. When he\'s not studying diamonds, Noah enjoys watching Films, Baking, playing Guitar, and listening to Murder-mystery podcasts.']
		}],
		sponsorships: [{
			name: 'St. Louis Blues',
			image: 'blues.jpg'
		}],
		reviews: {
			googleRead: 'https://bit.ly/3acPArz',
			googleWrite: 'https://bit.ly/3acPArz'
		}
	};
	
	var SLC = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Salt Lake City',
		title: 'Diamonds Direct Salt Lake City, Utah - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Salt Lake City, Utah Location Today!',
		shortName: 'Salt Lake',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Located across from Fashion Place Mall, Diamonds Direct Salt Lake is the Deseret’s destination for bridal and fashion jewelry. Jazz up your everyday wardrobe with a piece from one of our many world-renowned designers. Looking for something unique and custom? No problem! Our private label is here to create the ring of your dreams.'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/DiamondsDirectSLC',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '196 E Winchester Street',
			line2: 'Murray, UT 84107'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Salt+Lake+City/@40.6324776,-111.8881016,17z/data=!4m5!3m4!1s0x875289b94525712b:0xdc3f6fd1a50e6dd0!8m2!3d40.6324776!4d-111.8859129',
		hours: {
			default: [{
				days: 'Monday - Saturday',
				hours: '12pm - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '3853884353',
		email: 'infoslc@diamondsdirect.com',
		team: [{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: ['Amit Berger, EVP, founded Diamonds Direct Birmingham in 2008. He joined the Diamonds Direct parent company in 1995 in Israel while working in the cutting facility and learning the trade\'s secrets.', 'Born in Israel, Berger grew up working in his family restaurant business and developed his love of customer service and gregarious personality. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry. It was then when he started working for Diamonds Direct\'s parent company in the cutting facility with the founder of the company.', 'In 1997, Berger came to the United States to begin working one on one with big diamond buyers. He traveled back and forth between Israel and 40 different states in the US working for Diamonds Direct\'s parent company in the wholesale division. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work with Diamonds Direct\'s parent company in the wholesale office and selling diamonds to top jewelry stores around the country. Eventually, Berger was running the wholesale division and was in charge of selecting diamonds from the cutting facility in Israel.', 'In the meantime, his brother Itay, had opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the company. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.', 'Berger made the move to Birmingham and opened the second Diamonds Direct location here in Birmingham, AL. He calls Birmingham his home and loves the friendly atmosphere. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. Their favorite thing to do as a family is play with their dog Ziggy and travel.']
		}, {
			name: 'Michelle Lewis',
			title: 'General Manager',
			picture: 'michelle_lewis.jpg',
			email: 'michellelewis@diamondsdirect.com',
			phone: '',
			bio: ['After working as a sales consultant at Diamonds Direct for 3 years, Michelle became the general manager at Diamonds Direct\'s Salt Lake branch. Michelle is a GIA graduate and has been certified through the Diamond Council of America. She has been in the diamond and jewelry industry for more than 10 years.', 'Michelle worked in the bridal department at Jared\'s for almost 3 years. Prior to her time at Jared\'s she opened a new Helzberg Diamond location and was manager for 6 years.', 'In her free time, Michelle enjoys hiking, skiing, cooking and spending time with her family and her two dogs.']
		}, {
			name: 'Michael Fisher',
			title: 'Diamond Expert',
			picture: 'michael_fisher.jpg',
			email: 'michaelf@diamondsdirect.com',
			phone: '',
			bio: ['Michael has been in the jewelry industry for 43 years. He is an A.G.S and G.I.A. graduate and Diamond expert.', 'In addition to owning and operating his own jewelry store for nearly a decade, Michael has worked his way up and excelled in every capacity in the industry. Along with running Michael Fisher Fine Jewelry, he also owned and operated Fisher Custom Homes for over twenty years building several award-winning million-dollar custom homes.', 'In his spare time, Michael enjoys spending time with his twenty-five grandchildren and lovely wife Stacy.']
		}, {
			name: 'Franzi Kobel',
			title: 'GIA Graduate Gemologist',
			picture: 'franzi_kobel.jpg',
			email: '',
			phone: '',
			bio: ['Franzi\'s journey into the jewelry world started over ten years ago when she worked for an auction company specializing in fine arts, antiques, and estate jewelry. This is where she grew a passion for jewelry and gems and decided to move from Munich to sunny California to attend the Gemological Institute of America. She graduated in 2011 earning the title of Graduate Gemologist.', 'After graduating she returned to Munich but soon realized the U.S. offers a much more exciting market. She put roots in Utah and worked for a small local jewelry store for four years. Franzi joined the Diamonds Direct family in May of 2018. She is passionate about eating, going to concerts, and laughing with her fiance Adam and the friends she calls her "American family."']
		}, {
			name: 'Michelle Lassig',
			title: 'Master Jeweler',
			picture: 'michelle_lassig.jpg',
			email: 'michellelassig@diamondsdirect.com',
			phone: '',
			bio: ['Michelle joined Diamonds Direct Salt Lake City as a Master Jeweler with 20 years of jewelry industry experience, ranging from working in small mom-and-pop shops and large corporations to running her own business.', '"Yes" is Michelle\'s favorite word. Her ultimate goal is to provide superior customer service, with kindness and gratitude. In her spare time, Michelle enjoys being with family and her dog Moses. Michelle loves music, broadway, and chess.']
		}, {
			name: 'Kacey Roberts',
			title: '',
			picture: 'kacey_roberts.jpg',
			email: 'Kaceyr@diamondsdirect.com',
			phone: '',
			bio: ['Kasey Roberts joined the Salt Lake Diamonds Direct team in August of 2018. She has over a decade of experience in the diamond and jewelry industry in the role of sales, customer service, management, training and new store operations.', 'Kasey left jewelry and retail altogether pursuing the opportunity to manage and coordinate operations for several brands of start-ups including event centers, sandwich shops and a financial coaching program. While she found working with front line teams and executive staff rewarding, she missed working face to face with clients and helping them with their most joyous occasions.', 'During her free time, Kacey loves spending time with her two daughters and husband, reading, traveling and spending time with friends.']
		}],
		sponsorships: [{
			name: 'University of Utah',
			image: 'utes.png'
		}],
		reviews: {
			googleRead: 'https://www.google.com/search?hl=en&ei=Xv50W7X1BITctQWQ6bzABQ&q=diamonds+direct+slc&oq=diamonds+direct+slc&gs_l=psy-ab.3..0.19125.19452.0.20308.3.3.0.0.0.0.110.299.1j2.3.0....0...1c.1.64.psy-ab..0.3.299...0i67k1j0i22i30k1.0.bR4dCBszo1E#lrd=0x875289b94525712b:0xdc3f6fd1a50e6dd0,1,,,',
			googleWrite: 'https://www.google.com/search?hl=en&ei=Xv50W7X1BITctQWQ6bzABQ&q=diamonds+direct+slc&oq=diamonds+direct+slc&gs_l=psy-ab.3..0.19125.19452.0.20308.3.3.0.0.0.0.110.299.1j2.3.0....0...1c.1.64.psy-ab..0.3.299...0i67k1j0i22i30k1.0.bR4dCBszo1E#lrd=0x875289b94525712b:0xdc3f6fd1a50e6dd0,1,,,'
		}
	};
	
	var SAN = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct San Antonio',
		title: 'Diamonds Direct San Antonio - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our San Antonio Location Today!',
		shortName: 'San Antonio',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit our beautiful showroom at the Shops at La Cantera to find that perfect gift. Spur on your loved one to come during one of our many events throughout the year, just keep an eye on our website and social media for dates! Don’t forget to tag us in all of your fun photos using #DDFamilyAlbum'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectsanantonio/',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '15900 La Cantera Pky, Bldg 18',
			line2: 'San Antonio, TX 78256'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+San+Antonio/@29.5930009,-98.6204149,17z/data=!3m1!4b1!4m5!3m4!1s0x865c6687423fc153:0x909f03c2b027ea46!8m2!3d29.5929963!4d-98.6182262',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '2102479197',
		email: 'infoSAT@diamondsdirect.com',
		team: [{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: ['Amit Berger, EVP, founded Diamonds Direct Birmingham in 2008. He joined the Diamonds Direct parent company in 1995 in Israel while working in the cutting facility and learning the trade\'s secrets.', 'Born in Israel, Berger grew up working in his family restaurant business and developed his love of customer service and gregarious personality. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry. It was then when he started working for Diamonds Direct\'s parent company in the cutting facility with the founder of the company.', 'In 1997, Berger came to the United States to begin working one on one with big diamond buyers. He traveled back and forth between Israel and 40 different states in the US working for Diamonds Direct\'s parent company in the wholesale division. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work with Diamonds Direct\'s parent company in the wholesale office and selling diamonds to top jewelry stores around the country. Eventually, Berger was running the wholesale division and was in charge of selecting diamonds from the cutting facility in Israel.', 'In the meantime, his brother Itay, had opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the company. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.', 'Berger made the move to Birmingham and opened the second Diamonds Direct location here in Birmingham, AL. He calls Birmingham his home and loves the friendly atmosphere. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. Their favorite thing to do as a family is play with their dog Ziggy and travel.']
		}, {
			name: 'Tamir Shkargi',
			title: 'Vice President',
			picture: 'Tamir1.jpg',
			email: 'Tamir@diamondsdirect.com',
			phone: '',
			bio: ['Tamir Shkargi joined the Diamonds Direct team 2017. Originally from Israel, Tamir served in the Israeli Military for three years. Upon his completion of service, he embarked on a career with the Israeli government for over ten years. After receiving his degree in Business Administration at Ono Academic College, Tamir decided to move to the United States with his family.', 'Tamir’s new chapter began in Austin, Texas which led him to pursue a career in retail management with Diamonds Direct. It was the remarkable culture and amazing group of people that made Diamonds Direct the perfect fit for Tamir.', 'After managing the Frisco store for nearly two years, he was given the opportunity to bring his talents to Houston and grow the Diamonds Direct family. He is thrilled to also take on the San Antonio store to assist in the growth in this market.', 'Outside of work, Tamir enjoys playing soccer with friends and spending time with his wife and their precious two boys!']
		}, {
			name: 'Yaniv Azulay',
			title: 'General Manager',
			picture: 'feb10/yaniv.jpg',
			email: 'YanivA@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Dee Dee Watkins',
			title: 'Store Manager',
			picture: 'feb28/Deedee.jpeg',
			email: 'debraw@DiamondsDirect.com',
			phone: '',
			bio: ['Dee Dee has been passionate about the jewelry industry for over 10 years. She is certified with The Diamond Council of America. Along with her previous education and experience, Diamond\'s Direct has made her a top notch Diamond Expert. She is the proud mother of 5 children, which includes a set of identical twin boys. She enjoys spending time with her family, especially her two grand babies.']
		}, {
			name: 'Nicole Rosenfield',
			title: 'Marketing and Merchandising Manager',
			picture: 'dec21/Nicole-Final.jpg',
			email: 'nicoler@diamondsdirect.com',
			phone: '',
			bio: ['Nicole Rosenfield, Marketing and Merchandising Manager, joined the Diamonds Direct family in 2021. She graduated with a degree in Public Relations and a minor in Business Management from the University of Texas at San Antonio. She brings a blended creative background made up of event planning, marketing, digital media, and project management.', 'In her free time she enjoys reading, trying local restaurants, and being involved in the San Antonio community.']
		}, {
			name: 'Jessica Dean',
			title: 'Back Office Manager',
			picture: 'feb10/jessica.jpg',
			email: 'jessicad@diamondsdirect.com',
			phone: '',
			bio: ['Jessica Dean has been with Diamonds Direct since November 2014. She earned her Bachelor’s Degree in Communication from Meredith College.', 'Dean has been pursuing her career and working in customer service for eight years. Jessica currently works as our Back Office Manager and is a customer service excellence expert.', 'In her free time, Dean enjoys being outside and taking care of her fur baby. She is a Wilmington native and escapes to the beach whenever possible.']
		}, {
			name: 'Theresa Medina-Gholson',
			title: 'Diamond Expert',
			picture: 'feb10/theresa.jpg',
			email: 'theresam@DiamondsDirect.com',
			phone: '',
			bio: ['Theresa Medina-Gholson graduated from The University of the Incarnate Word with a Bachelor of Arts in Theatre as well as her Diamond Council of America certification.', 'Theresa Medina-Gholson was a professional musical theatre actress who performed as a lead vocalist for The Hodge Podge Blues Band, and began selling diamonds in 2010.', 'In her spare time, she enjoys cooking with her new husband, Tracey and is the proud mother of Annabella, age 10.']
		}, {
			name: 'Hilda Mendoza',
			title: 'Diamond Expert',
			picture: 'feb10/hilda.jpg',
			email: 'hilda@diamondsdirect.com',
			phone: '',
			bio: ['Hilda Mendoza is fluent in English/Spanish speaking. First generation American with family native to Mexico.  Hilda has over 14 years of customer service experience and management professionalism. Hilda attended University Primerica in Financial Analyst.  She is a mother of three and the youngest of seven brothers and sisters. In her free time she likes to spend it outdoors in nature enjoying the small things in life.']
		}, {
			name: 'Seth Cornelison',
			title: 'Diamond Expert',
			picture: 'dec21/Seth-Final.jpg',
			email: 'sethc@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Carlos Pazmino',
			title: 'Jeweler',
			picture: 'feb10/carlos.jpg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Jim Litz',
			title: 'Diamond Expert',
			picture: 'feb28/Jim.jpeg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Jocelyn Solis',
			title: 'Back Office Support',
			picture: 'feb28/Jocelyn.jpeg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Brenna Brazzill',
			title: 'Customer Care Representative',
			picture: 'feb28/Brenna.jpeg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Laura Powers',
			title: 'Diamond Expert',
			picture: 'feb28/Laura.jpeg',
			email: '',
			phone: '',
			bio: []
		}, {
			name: 'Veronica Kluver',
			title: 'Back Office Support',
			picture: 'dec21/Veronica-Final.jpg',
			email: 'veronicak@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Sidney Garza',
			title: 'Front Office Reception',
			picture: 'dec21/Sidney-Final.jpg',
			email: 'sidneyg@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Amelia Gomez',
			title: 'Front Office Reception',
			picture: 'Emily.jpg',
			email: 'ameliag@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Tad Garcia',
			title: 'Diamond Expert',
			picture: 'dec21/Tad-Final.jpg',
			email: 'tadg@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Siddharth Suresh',
			title: 'Diamond Expert',
			picture: 'dec21/siddharth.jpg',
			email: 'siddharths@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Rick Souddress',
			title: 'Diamond Expert',
			picture: 'Rick.png',
			email: 'ricks@diamondsdirect.com',
			phone: '',
			bio: []
		}, {
			name: 'Jared Lott',
			title: 'Diamond Expert',
			picture: 'Jared.jpg',
			email: 'JaredL@diamondsdirect.com',
			phone: '',
			bio: ['Jared Lott, Diamond Expert, joined the Diamonds Direct family in 2020. Jared offers a wide ranging background in sales. After attaining a bachelor\'s degree in education he transitioned to new opportunities. Having spent over three years with Samuel Jewelers, he has a deepened understanding of the value that each customer brings to the rhino family.', 'When he is not dedicating his time to each of his customers, he enjoys golfing and fishing.']
		}, {
			name: 'Allison Ramos',
			title: 'Diamond Expert',
			picture: 'ALLISON.jpg',
			email: 'allisonr@diamondsdirect.com',
			phone: '',
			bio: ['Allison Ramos, diamond expert, joined Diamonds Direct in June 2019.  She received a Bachelors of Art in Social Work from the University of Akron.', 'Allison was a practicing Social Worker for Summit County Children\'s Services for 8 years, then left to start a career in the jewelry industry.', 'Allison has been in the diamond and jewelry industry for over 20 years.  Previously she was the General Manager for Jared, the Galleria of Jewelry, and a manager for Alson Jewelers. She enjoys designing jewelry to create the perfect masterpiece for her guests.', 'Allison is an avid animal lover, and currently has two rescue dogs:  Marsh, an American Bulldog, and Gigi, a brindle boxer.  In her free time she enjoys spending time with her son, Brandon and his girlfriend Michelle, and her mother Jacquelyn, as well as many wonderful friends.']
		}, {
			name: 'Juliet Kent',
			title: 'Front Office Support',
			picture: 'Juliet.jpg',
			email: '',
			phone: '',
			bio: []
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://bit.ly/3uxgS58',
			googleWrite: 'https://bit.ly/3uxgS58'
		}
	};
	
	var TRY = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Troy',
		title: 'Diamonds Direct Troy - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our San Antonio Location Today!',
		shortName: 'Troy',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Visit us in Troy to shop our latest arrivals and exclusive selection of diamond and fine jewelry. Stay tuned for promotional events, designer showcases, and more!'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirecttroy',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '1985 West Big Beaver Rd. Ste 100',
			line2: 'Troy, MI 48084'
		},
		googleMapsLink: '',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '2485095435',
		email: 'infoTROY@diamondsdirect.com',
		team: [{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: ['Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.', 'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.', 'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.', 'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.', 'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.']
		}, {
			name: 'Niv Ankawa',
			title: 'Vice President',
			picture: 'NivAnkawa.jpg',
			email: 'Niv@diamondsdirect.com',
			phone: '',
			bio: ['Niv joined Diamonds Direct in 2018. With over 12 years of experience in the fine jewelry and diamond business, Niv’s expertise comes from his many years managing a store in the Diamond District in New York City.  Prior to the Diamond District, Niv also managed a jewelry store in Miami for 7 years. His strength is his ability to connect with people. He believes client satisfaction is the key to a successful brand.  In his free time Niv enjoys being active, playing soccer, frequents the gym, and is an avid skier. He also loves trying new restaurants and traveling all over the world.']
		}, {
			name: 'Jennifer Alter',
			title: 'General Manager',
			picture: 'Jennifer2.jpg',
			email: 'jenniferal@diamondsdirect.com',
			phone: '',
			bio: ['Jennifer Alter began her jewelry career at just 15 years old as a shop jeweler. She worked for a wholesale gemstone company, but one day was recruited to work at a local jewelry store.  This sparked a true passion in Alter, and for the last 30 years, she has worked at two local family owned businesses in the Troy area.  Alter is GIA certified in diamonds as well as design. Today, she is proud to lead the DIamonds Direct Troy team, with over 36 years of jewelry knowledge.   In her spare time, she treasures the time she gets to spend with her son, mutually enjoying his love of hockey.  When she can get away, Alter and her husband love to explore new places in their RV.  Additionally, one of Jennifer’s main passions is spending time in the local community and giving back to local charities as much as possible.  Her favorite quote and the secret to her success is, "Treat others how you want to be treated".']
		}, {
			name: 'Vik Sehdev',
			title: 'Store Manager',
			picture: 'Vik.jpg',
			email: 'viks@diamondsdirect.com',
			phone: '',
			bio: ['Vik Sehdev join the Diamonds Direct family in 2021, but has over 17 years of experience in fine jewelry and diamonds. Sehdev has been apart of almost every aspect of the jewelry industry. From being in the manufacturing and wholesale side, to managing a retail store for the largest Canadian owned jewelry company and to being an owner of an independent jewelry store. Vik’s main strengths include his ability to connect with people, and build strong relationships with them for life. In his free time, he loves to cook, golf, travel the world and explore new restaurants.']
		}, {
			name: 'Jessica LaPonse',
			title: 'Back Office Manager',
			picture: 'Jessica.jpg',
			email: 'Jessical@diamondsdirect.com',
			phone: '',
			bio: ['Jessica LaPonse was born and raised in Michigan. While she is new to the jewelry industry, she has worked in customer service for over 20 years. She first worked as a manager/bartender, as well as in sales as a store manager for two different companies, one in North Carolina and one in Michigan. She loves to learn new things and is looking forward to expanding her knowledge as she grows with the Diamonds Direct team. Jessica is excited about her new adventure into the jewelry business. Jessica is a single mother, who enjoys spending her days away from work with her two fabulous boys. She loves to attend their hockey, soccer practices, and games. She loves to read and travel with her boys and wonderful boyfriend, as well as enjoys going fishing. She also loves being outside, especially if it is on the beach in the sun.']
		}, {
			name: 'Katie VanDuyn',
			title: 'Diamond Expert',
			picture: 'Katie.jpg',
			email: 'katiev@diamondsdirect.com',
			phone: '',
			bio: ['Katie joined the Diamonds Direct family in October 2021. Originally from Grand Rapids, MI, she is now so excited to call the east side her home! Katie began her career in the jewelry industry in 2015 after graduating from Grand Valley State University. Her favorite aspect of the jewelry business is hearing every client’s unique love story! At the end of the day, she wants to help you find the perfect piece to represent your love story.  Outside of work, Katie loves spending time watching movies with her boyfriend and their two cats, Kanye and Chloe.']
		}, {
			name: 'Jennifer (Jen) Evola',
			title: 'Diamond Expert',
			picture: 'JenniferEvola.jpg',
			email: 'jennifere@diamondsdirect.com',
			phone: '',
			bio: ['Jennifer\'s love for jewelry drove her to join the Diamonds Direct family after being in customer service for close to 30 years.  She enjoys nothing more than creating unforgettable memories for life and acquiring new found friendships. Her passion and excitement for her clients’ is what has made her successful in all paths of her career.  Her favorite thing about being a Diamond Expert is being a part of the process and story that comes along with each and every client. Jennifer spends her free time with her sweet husband Greg, and her baby Yorkie, Chloie Coco Chanel.  She enjoys golfing, boating, and spending time with family.']
		}, {
			name: 'Szymon Grochowski',
			title: 'Shop Manager/Jeweler',
			picture: 'Syzmon.jpg',
			email: 'szymong@diamondsdirect.com',
			phone: '',
			bio: ['Szymon Grochowski was born in Warsaw, Poland in 1982 and moved with his family to the United States in 1991. He began learning the trade by working with his master jeweler father in 2005. Since then he worked in numerous companies in North Carolina specializing in repairs, setting, fabrication and design.', 'He has been with Diamonds Direct for over five years and is very excited to continue in Troy, Michigan. In his spare time he loves to spend time with his lovely wife, Aline and two and a half year old daughter, Emily. He stays active by running and practicing Taekwondo. He’s also an avid collector of heavy metal albums on vinyl, loves to travel, and drive fast cars.']
		}, {
			name: 'Eldhose Abraham',
			title: 'HQ Jeweler',
			picture: 'Eldhose.jpg',
			email: '',
			phone: '',
			bio: ['Eldhose Abraham, is originally from India and came to the United States in 2000. He started working as a jeweler at Jared’s in Utica, Michigan. Since then he gained experience and confidence in repairs and diamond setting. He’s excited to continue in Diamonds Direct’s newest location in Troy, Michigan. In his spare time he loves to travel and spend time with his wife, two sons, and daughter.']
		}, {
			name: 'Samatha Douglas',
			title: 'Front Office Support',
			picture: 'Sam.jpg',
			email: 'Samdo@diamondsdirect.com',
			phone: '',
			bio: ['Samantha Douglas joined the Diamonds Direct family in 2021. She is recently engaged and excited to get married in May 2023! She has spent several years in customer service, but is new to the diamond industry. In her spare time, she likes to hang out with friends and family, have game nights, enjoys bike rides, visiting new places and loves to take pictures. She also has a 7-year old french bulldog named Titan.']
		}, {
			name: 'Kristine Parubi',
			title: 'Diamond Expert',
			picture: 'KristineParubi.jpg',
			email: 'kristinep@diamondsdirect.com',
			phone: '',
			bio: ['Kristine joined Diamonds Direct in 2018 with over 16 years of experience working in the Diamond District in New York City. Kristine, first, worked for Diamonds Direct’s manufacturer in New York before moving to Saint Louis to become a Diamond Expert in 2020. Kristine was born in Albania, raised in Bronx, New York, and speaks seven languages. She went to college for nursing, but loved the diamond industry too much to leave. In her spare time, she enjoys being active, watching documentaries, listening to music, and spending time with her family.']
		}, {
			name: 'Hunter Wesley',
			title: 'Front Desk',
			picture: 'Hunter.jpg',
			email: 'Hunterw@diamondsdirect.com',
			phone: '',
			bio: ['Hunter Wesley joined Diamonds Direct in 2022. He is a recent high school graduate from Macomb, MI and is extremely excited to be a part of the Diamonds Direct family! Hunter will also begin studying part-time at a local community college to work towards his bachelor\'s degree. Outside of work, he loves playing hockey and going bowling. In fact - Hunter has been playing hockey for over 15 years!']
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://www.google.com/search?q=diamonds+direct+troy&rlz=1C5CHFA_enUS897US897&sxsrf=APq-WBtkdmzSN73RI14XPPsWegEFmWJP1w%3A1650483428234&ei=5GBgYtf-DYGw0PEPxOmLWA&ved=0ahUKEwjXgMrzsaP3AhUBGDQIHcT0AgsQ4dUDCA4&uact=5&oq=diamonds+direct+troy&gs_lcp=Cgdnd3Mtd2l6EAMyEAguEIAEEIcCEMcBEK8BEBQyBggAEBYQHjIFCAAQhgMyBQgAEIYDMgUIABCGAzIFCAAQhgM6BwgAEEcQsAM6BwgAELADEEM6CggAEOQCELADGAE6EgguEMcBENEDEMgDELADEEMYAjoMCC4QyAMQsAMQQxgCOg8ILhDUAhDIAxCwAxBDGAI6BAgjECc6BAguEEM6DgguEIAEELEDEMcBEKMCOgsILhCABBDHARCjAjoICC4QsQMQgwE6DgguEIAEELEDEMcBENEDOgsIABCABBCxAxCDAToFCAAQkQI6CwguEMcBEK8BEJECOg0ILhCxAxDHARCjAhBDOgcIABCxAxBDOgQIABBDOgoILhDHARCvARBDOgcILhCxAxBDOgoILhDHARCjAhBDOggIABCABBCxAzoICAAQsQMQkQI6CwguEIAEEMcBEK8BOggILhCABBCxAzoFCC4QgAQ6CAguEIAEENQCOgUIABCABDoHCCMQsQIQJzoHCAAQsQMQCjoECAAQCjoKCC4QxwEQrwEQCjoHCCMQsAIQJzoKCC4QxwEQrwEQDToECAAQDUoECEEYAEoECEYYAVDVBViOKmCxLGgGcAF4AIABvwGIAcoWkgEEMy4yMJgBAKABAcgBEMABAdoBBggBEAEYCdoBBggCEAEYCA&sclient=gws-wiz',
			googleWrite: 'https://www.google.com/search?q=diamonds+direct+troy&rlz=1C5CHFA_enUS897US897&sxsrf=APq-WBtkdmzSN73RI14XPPsWegEFmWJP1w%3A1650483428234&ei=5GBgYtf-DYGw0PEPxOmLWA&ved=0ahUKEwjXgMrzsaP3AhUBGDQIHcT0AgsQ4dUDCA4&uact=5&oq=diamonds+direct+troy&gs_lcp=Cgdnd3Mtd2l6EAMyEAguEIAEEIcCEMcBEK8BEBQyBggAEBYQHjIFCAAQhgMyBQgAEIYDMgUIABCGAzIFCAAQhgM6BwgAEEcQsAM6BwgAELADEEM6CggAEOQCELADGAE6EgguEMcBENEDEMgDELADEEMYAjoMCC4QyAMQsAMQQxgCOg8ILhDUAhDIAxCwAxBDGAI6BAgjECc6BAguEEM6DgguEIAEELEDEMcBEKMCOgsILhCABBDHARCjAjoICC4QsQMQgwE6DgguEIAEELEDEMcBENEDOgsIABCABBCxAxCDAToFCAAQkQI6CwguEMcBEK8BEJECOg0ILhCxAxDHARCjAhBDOgcIABCxAxBDOgQIABBDOgoILhDHARCvARBDOgcILhCxAxBDOgoILhDHARCjAhBDOggIABCABBCxAzoICAAQsQMQkQI6CwguEIAEEMcBEK8BOggILhCABBCxAzoFCC4QgAQ6CAguEIAEENQCOgUIABCABDoHCCMQsQIQJzoHCAAQsQMQCjoECAAQCjoKCC4QxwEQrwEQCjoHCCMQsAIQJzoKCC4QxwEQrwEQDToECAAQDUoECEEYAEoECEYYAVDVBViOKmCxLGgGcAF4AIABvwGIAcoWkgEEMy4yMJgBAKABAcgBEMABAdoBBggBEAEYCdoBBggCEAEYCA&sclient=gws-wiz'
		}
	};
	
	var VAB = {
		template: 'store',
		currentPromo: false,
		name: 'Diamonds Direct Virginia Beach',
		title: 'Diamonds Direct Virginia Beach - Engagement Rings, Jewelry, and More',
		description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Virginia Beach Location Today!',
		shortName: 'Virginia Beach',
		bannerPromo: 'promo.jpg',
		mainDescription: ['Looking for the perfect VAB-ulous gift for that special someone? Don’t worry, we’ve got the best selection and diamond experts that Hampton Roads has ever seen. We’re here to make sure you leave knowing you’ve gotten the very best for your budget. Did we mention our heroes in uniform discount?'],
		midBanner: 'banner.jpg',
		midText: ['You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!'],
		midBannerInfo: 'info.jpg',
		facebookUrl: 'https://www.facebook.com/diamondsdirectvabeach/',
		instagramUrl: 'https://www.instagram.com/diamondsdirect/',
		address: {
			line1: '4452 Virginia Beach Blvd',
			line2: 'Virginia Beach, VA 23462'
		},
		googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Virginia+Beach/@36.8439769,-76.1316678,17z/data=!3m1!4b1!4m5!3m4!1s0x89ba950ad92519f5:0xc9f56c5efdc70504!8m2!3d36.8439726!4d-76.1294791',
		hours: {
			default: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: 'Closed'
			}],
			holiday: [{
				days: 'Monday - Friday',
				hours: '10am - 7pm'
			}, {
				days: 'Saturday',
				hours: '10am - 6pm'
			}, {
				days: 'Sunday',
				hours: '12pm - 5pm'
			}],
			notice: ''
		},
		phone: '7578370288',
		email: 'infoVAB@diamondsdirect.com',
		team: [{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: ['Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.', 'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.', 'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.', 'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.', 'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.']
		}, {
			name: 'Ori Ben Amitai',
			title: 'Vice President, Virginia',
			picture: 'ori_amitai.jpg',
			email: 'Ori@DiamondsDirect.com',
			phone: '',
			bio: ['Ori Ben Amitai, Vice President, has been with Diamonds Direct since 2012. He attended Bar -Ilan University in Israel where he studied Industrial Practical Engineering. Previously, Ori was working for the diamond cutting facilities of the company in the Israeli diamond district.', 'Born in Ramat Gan, Israel in 1984 and raised in Herzelia, Ben Amitai joined the Israeli defense forces in 2003 and served for 3 years. The military experience gave him great tools to appreciate the good things in life; his wife, family and close friends. The army experience also taught him a new way of life - always be on time never late, be honest with people, and never be afraid of the truth. In 2012 he started to explore the world of diamonds in the diamond cutting facilities of Diamond’s Direct in Ramat Gan, Israel, where he fell in love with them immediately. After one year of experience in the diamond district he was selected to join the company’s other side of the business, the direct-to-the-public stores. He started his way in the Raleigh location where he learned and work with Barak Henis (Vice President of the Raleigh and the Richmond location). Ori then relocated when the company opened its 4th location in Richmond, Virginia. He sees an amazing future to the Richmond market, and puts all his effort in establishing Diamonds Direct as a strong brand in the community. In his free time Ori likes to travel with his wife and his dog exploring Richmond and its surrounding cities.']
		}, {
			name: 'Mike Beem',
			title: 'General Manager',
			picture: 'beem.jpg',
			email: 'mikeb@diamondsdirect.com',
			phone: '',
			bio: ['Mike Beem, who recently joined Diamonds Direct in October 2018, has been involved in all facets of the jewelry business for more than 36 years.  What started as a part-time job, that enabled him to pay for 100% of his college tuition, evolved into a entire career specializing in fine jewelry.  Mike has managed jewelry stores on both the east and west coasts for large national retailers, family-owned independent stores in Northern Virginia, and even operated his own store, M. Beem Jewelers, in Reston, Virginia for over 12 years.', 'Mike grew up in a military family and graduated from George Mason University with a Bachelors of Science Degree in Public Administration.  He has earned many certifications including Diamonds and Diamond Grading from the Gemological Institute of America (GIA). He has extensive experience with colored gemstones, jewelry design, and estate jewelry.  His biggest joy comes from the loyal following he has built – knowing that his clients return happy and refer their friends and family for his creativity, attention to detail, and outstanding service.  Mike is excited to be apart of the Diamonds Direct family where he can offer the absolute best selection and value in the industry.', 'When not at work, you can find Mike avidly following the Washington Nationals and his beloved GMU Patriots men’s basketball team…and occasionally on the golf course or at the gym.  He, his wife, Maria, and their three sons have just relocated to Virginia Beach and are already ensconced in school, scouts, sports, music and theater.  They’re looking forward to all that Hampton Roads has to offer!']
		}, {
			name: 'Marcella Wishom',
			title: 'Store Manager',
			picture: 'mar09/MarcellaWishom.jpg',
			email: 'marcellaw@diamondsdirect.com',
			phone: '',
			bio: ['Marcella Wishom joined the Diamonds Direct family in October of 2019. She brings with her over 19 years of experience in the jewelry industry working for both national retailers and family-owned independent stores located in the Hampton Roads Region.', 'Marcella holds a Bachelor of Arts Degree in Paralegal Studies from Hampton University. She is certified as a Diamontoligist by the Diamond Council of America (DCA) and she has received an Applied Jewelry Professional Diploma from the Gemological Institute of America (GIA).', 'Marcella is a charismatic, energetic, motivational leader who is passionate about serving others. In her spare time she enjoys volunteering and singing in the community. Marcella’s life mantra is “ Do what you love!”']
		}, {
			name: 'Kim Kellam',
			title: 'Director of Sales',
			picture: 'kim_kellam.jpg',
			email: 'KimK@diamondsdirect.com',
			phone: '',
			bio: ['Kim Kellam is a diamond expert with 27 years of experience in the jewelry industry. She began working for Diamonds Direct in Virginia Beach in January 2016 and is excited to share her knowledge and expertise of diamonds and fine jewelry while providing an excellent atmosphere of great service.', 'Kim grew up in Dubuque, Iowa in a family with 11 siblings, one of whom is her twin sister Kelly.', 'She earned her Bachelors degree from the University of Northern Iowa, then moved to Oklahoma City, where she worked in the retail services industry for several years, in the area of cosmetics and as a store trainer. Kim began her fine jewelry career managing federated lease departments and then worked for an established independent jeweler in Oklahoma City, where she earned her GIA diamonds certification. Kim moved to Virginia Beach, Virginia in 1996 where she continued her work as a sales professional in management, as well as a buyer for a local independent jewelry company for 18 years.', 'Kim is married to her husband Phil and has two stepsons Alex and Jay. In her spare time, she enjoys attending charity events, running, book clubs, being involved in women\'s faith groups, and doing community volunteer service.']
		}, {
			name: 'Tabatha Dennis',
			title: 'Back Office Manager',
			picture: 'Tabatha.jpg',
			email: 'tabathad@diamondsdirect.com',
			phone: '',
			bio: ['Tabatha Dennis joined Diamonds Direct in April 2018 as part of the back office team and was promoted to back office manager a short time later. Tabatha has over 16 years of customer service including 14 years of management experience in a specialty retail store. Tabatha has a passion for coaching and training in a positive and forward-thinking environment.', 'Tabatha has lived all over the United States and came to Virginia Beach in 2005 from a military move and has never left because of building roots with her family. In her spare time, she enjoy going to the beach and spending time with her fiancé.']
		}, {
			name: 'Lonnie L. Phillips, Jr.',
			title: 'Diamond Expert',
			picture: 'lonnie_phillips.jpg',
			email: 'LonnieP@Diamondsdirect.com',
			phone: '',
			bio: ['Lonnie L. Phillips, Jr. has been in sales for over 20 years now. He joined the jewelry industry after leaving the Army in 2010. Lonnie has worked for Reed\'s Jewelers and Jared the Galleria of Jewelry before joining the Diamonds Direct team.', 'In his free time, Lonnie enjoys skiing, attending football games, and mountain biking with his son.']
		}, {
			name: 'Jeff Hawkins',
			title: 'Diamond Expert',
			picture: 'hawkins.jpg',
			email: 'jeffh@diamondsdirect.com',
			phone: '',
			bio: ['Jeff Hawkins joined the Virginia Beach Diamonds Direct team in September 2018 as a Diamond Expert. He brings with him nearly 30 years of jewelry sales and management experience. Twenty-five of those years were spent with Signet Jewelers, where he won numerous awards, including two Manager of the Year Awards and a Hall of Fame Award.', 'Jeff studied Business Management at the University of West Florida and is DCA Certified in diamonds and gemstones. His passion for jewelry stems from the great joy he receives from playing an integral part in his clients gift-giving occasions.  Building a trusting relationship with each of his clients is Jeff\'s goal.  "I want the client to feel confident and fully informed about their choice" says Jeff.', 'During his free time, Jeff loves spending time with family and friends. He is involved in many networking organizations and is an avid soccer player still to this day. Indoor, outdoor, or in the sand, Jeff will play!']
		}, {
			name: 'Jackie Thorne',
			title: 'Diamond Expert',
			picture: 'thorne.jpg',
			email: 'jackiet@diamondsdirect.com',
			phone: '',
			bio: ['Jackie Thorne joined the Diamonds Direct family in October 2018. With over 20 years of experience in the jewelry industry, she demonstrates the highest standards and passion for customer service. Jackie\'s prior roles have included a series of sales and manager positions working for national jewelry retailers as well as local jewelry stores in Hampton Roads.', 'During Jackie\'s free time she loves to cook, travel, and spend time with her family.']
		}, {
			name: 'Anne Pitt',
			title: 'Master Jeweler',
			picture: 'anne_pitt.jpg',
			email: 'AnneP@diamondsdirect.com',
			phone: '',
			bio: ['Anne Pitt has been working as a jeweler for 33 years. She began her Diamonds Direct career in 2015 working as the Corporate Jeweler in Richmond. Anne earned her Bachelors of Fine Arts from Virginia Commonwealth University’s Art School with a major in metals.', 'Through the years Anne has won awards for her craftsmanship, earning Best in Show in metals and a William F. Kehoe award. She also has designed and crafter her own pieces and spent time crafting gallery pieces in her early career.', 'After working in independent jewelry stores Anne moved to work for Jared the Galleria of Jewelry. After several years there Anne found her home with Diamonds Direct. She is now the Master Jeweler for Diamonds Direct in Virginia Beach.']
		}, {
			name: 'Cindy Zhang',
			title: 'Graduate Gemologist',
			picture: 'zhang.jpg',
			email: 'cindyz@diamondsdirect.com',
			phone: '',
			bio: ['Jing \'Cindy\' Zhang, joined the Diamonds Direct family in May 2018. Cindy moved to the United States in 2013, after receiving a bachelor\'s degree in international business in China. For the past 16 years, she has worked in a variety of different industries including print and news editing, international trading, and jewelry sales. Her biggest passions are Fine Jewelry and Gemstones, and is currently a GIA student. Cindy enjoys to travel and loves studying different cultures.']
		}, {
			name: 'Tricia Ramsbottom',
			title: 'Diamond Expert',
			picture: 'Tricia.jpg',
			email: 'PatriciaR@diamondsdirect.com',
			phone: '',
			bio: ['Tricia joined the Diamonds Direct family in November of 2020, but has over 25 years of jewelry experience and has worked in management for other jewelers including Reeds Jewelers and Signet Jewelers. Tricia is also DCA diamond certified. While, of course she has a passion for jewelry and diamonds, the true passion comes from each customer. Every experience and encounter is different and she love helping find that jewel that will forever be a sentiment.  In her spare time, she loves spending time at church, with family, cooking, and finding a new purpose for old things!']
		}, {
			name: 'Tal Feldman',
			title: 'Brand Ambassador',
			picture: 'Tal.jpg',
			email: 'Talf@diamondsdirect.com',
			phone: '',
			bio: ['Tal Feldman joined the Diamonds Direct family in 2020, where she has held multiple roles including: front desk, back office, and now the Brand Ambassador position.', 'Tal was born in Israel, served two years in the Israel Defense Force and after that moved to Switzerland to do her BA in Hospitality. She has worked in the hotel industry for companies like Sandals and the Ritz Carlton where she held roles in wedding planning, restaurant management, event services, and customer service. It was in this industry that she met her husband, who was a Chef in one of the fine dining restaurants. The two moved to Israel for two years, where Feldman worked as an event planner in the hotel and bridal industry. They now live in Virginia Beach and enjoy spending time with their daughter.']
		}],
		sponsorships: [],
		reviews: {
			googleRead: 'https://bit.ly/3D3qkjF',
			googleWrite: 'https://bit.ly/3D3qkjF'
		}
	};
	
	var ALL = exports.ALL = {
		'atx': ATX,
		'bay': BAY,
		'bhm': BHM,
		'boc': BOC,
		'chs': CHS,
		'cle': CLE,
		'clt': CLT,
		'coh': COH,
		'dfw': DFW,
		'ecj': ECJ,
		'ftx': FTX,
		'gsc': GSC,
		'hou': HOU,
		'ind': IND,
		'jax': JAX,
		'kcy': KCY,
		'nol': NOL,
		'nva': NVA,
		'okc': OKC,
		'pit': PIT,
		'ral': RAL,
		'rva': RVA,
		'stl': STL,
		'slc': SLC,
		'san': SAN,
		'try': TRY,
		'vab': VAB
	};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(641), __esModule: true };

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(642), __esModule: true };

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(644), __esModule: true };

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(221);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(322);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(225);
	var TAG = __webpack_require__(65)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(126);
	var document = __webpack_require__(91).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(89) && !__webpack_require__(124)(function () {
	  return Object.defineProperty(__webpack_require__(328)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(225);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(173);
	var $export = __webpack_require__(90);
	var redefine = __webpack_require__(337);
	var hide = __webpack_require__(125);
	var Iterators = __webpack_require__(127);
	var $iterCreate = __webpack_require__(661);
	var setToStringTag = __webpack_require__(231);
	var getPrototypeOf = __webpack_require__(334);
	var ITERATOR = __webpack_require__(65)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(174);
	var createDesc = __webpack_require__(156);
	var toIObject = __webpack_require__(128);
	var toPrimitive = __webpack_require__(235);
	var has = __webpack_require__(102);
	var IE8_DOM_DEFINE = __webpack_require__(329);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(89) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(335);
	var hiddenKeys = __webpack_require__(228).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(102);
	var toObject = __webpack_require__(129);
	var IE_PROTO = __webpack_require__(232)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(102);
	var toIObject = __webpack_require__(128);
	var arrayIndexOf = __webpack_require__(654)(false);
	var IE_PROTO = __webpack_require__(232)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(90);
	var core = __webpack_require__(43);
	var fails = __webpack_require__(124);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(125);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(234);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(327);
	var ITERATOR = __webpack_require__(65)('iterator');
	var Iterators = __webpack_require__(127);
	module.exports = __webpack_require__(43).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(66);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(35);
	var toAbsoluteIndex = __webpack_require__(111);
	var toLength = __webpack_require__(29);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(104);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(44);
	var toObject = __webpack_require__(35);
	var IObject = __webpack_require__(158);
	var toLength = __webpack_require__(29);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(44);
	var isObject = __webpack_require__(24);
	var invoke = __webpack_require__(350);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(33).f;
	var create = __webpack_require__(105);
	var redefineAll = __webpack_require__(109);
	var ctx = __webpack_require__(68);
	var anInstance = __webpack_require__(103);
	var forOf = __webpack_require__(104);
	var $iterDefine = __webpack_require__(250);
	var step = __webpack_require__(353);
	var setSpecies = __webpack_require__(110);
	var DESCRIPTORS = __webpack_require__(32);
	var fastKey = __webpack_require__(95).fastKey;
	var validate = __webpack_require__(113);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(130);
	var from = __webpack_require__(342);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(109);
	var getWeak = __webpack_require__(95).getWeak;
	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(24);
	var anInstance = __webpack_require__(103);
	var forOf = __webpack_require__(104);
	var createArrayMethod = __webpack_require__(75);
	var $has = __webpack_require__(57);
	var validate = __webpack_require__(113);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(180);
	var isObject = __webpack_require__(24);
	var toLength = __webpack_require__(29);
	var ctx = __webpack_require__(68);
	var IS_CONCAT_SPREADABLE = __webpack_require__(27)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(32) && !__webpack_require__(22)(function () {
	  return Object.defineProperty(__webpack_require__(243)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(24);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(16);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(252);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 355 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(32);
	var getKeys = __webpack_require__(107);
	var gOPS = __webpack_require__(184);
	var pIE = __webpack_require__(159);
	var toObject = __webpack_require__(35);
	var IObject = __webpack_require__(158);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(22)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(33);
	var anObject = __webpack_require__(16);
	var getKeys = __webpack_require__(107);
	
	module.exports = __webpack_require__(32) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(60);
	var gOPN = __webpack_require__(106).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(57);
	var toIObject = __webpack_require__(60);
	var arrayIndexOf = __webpack_require__(177)(false);
	var IE_PROTO = __webpack_require__(257)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(32);
	var getKeys = __webpack_require__(107);
	var toIObject = __webpack_require__(60);
	var isEnum = __webpack_require__(159).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(106);
	var gOPS = __webpack_require__(184);
	var anObject = __webpack_require__(16);
	var Reflect = __webpack_require__(20).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(20).parseFloat;
	var $trim = __webpack_require__(133).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(260) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(20).parseInt;
	var $trim = __webpack_require__(133).trim;
	var ws = __webpack_require__(260);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(24);
	var newPromiseCapability = __webpack_require__(254);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 367 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(29);
	var repeat = __webpack_require__(259);
	var defined = __webpack_require__(76);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(70);
	var toLength = __webpack_require__(29);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(27);


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(345);
	var validate = __webpack_require__(113);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(178)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(255);
	__webpack_require__(4)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(32) && /./g.flags != 'g') __webpack_require__(33).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(157)
	});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(345);
	var validate = __webpack_require__(113);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(178)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(20);
	var each = __webpack_require__(75)(0);
	var redefine = __webpack_require__(50);
	var meta = __webpack_require__(95);
	var assign = __webpack_require__(357);
	var weak = __webpack_require__(347);
	var isObject = __webpack_require__(24);
	var validate = __webpack_require__(113);
	var NATIVE_WEAK_MAP = __webpack_require__(113);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(178)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var emptyObject = __webpack_require__(191);
	var _invariant = __webpack_require__(15);
	
	if (process.env.NODE_ENV !== 'production') {
	  var warning = __webpack_require__(19);
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (process.env.NODE_ENV !== 'production') {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (process.env.NODE_ENV !== 'production') {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (process.env.NODE_ENV !== 'production') {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (process.env.NODE_ENV !== 'production') {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (process.env.NODE_ENV !== 'production') {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (process.env.NODE_ENV !== 'production') {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (process.env.NODE_ENV !== 'production') {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (process.env.NODE_ENV !== 'production') {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (process.env.NODE_ENV !== 'production') {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (process.env.NODE_ENV !== 'production') {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (process.env.NODE_ENV !== 'production') {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(71);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (process.env.NODE_ENV !== 'production') {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortPrefixedStyle;
	
	var _isPrefixedProperty = __webpack_require__(930);
	
	var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortPrefixedStyle(style) {
	  return Object.keys(style).sort(function (left, right) {
	    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
	      return -1;
	    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
	      return 1;
	    }
	    return 0;
	  }).reduce(function (sortedStyle, prop) {
	    sortedStyle[prop] = style[prop];
	    return sortedStyle;
	  }, {});
	}
	module.exports = exports['default'];

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(943);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Avatar = __webpack_require__(949);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var selected = props.selected;
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var color = selected ? bottomNavigation.selectedColor : bottomNavigation.unselectedColor;
	
	  var styles = {
	    root: {
	      transition: 'padding-top 0.3s',
	      paddingTop: selected ? 6 : 8,
	      paddingBottom: 10,
	      paddingLeft: 12,
	      paddingRight: 12,
	      minWidth: 80,
	      maxWidth: 168
	    },
	    label: {
	      fontSize: selected ? bottomNavigation.selectedFontSize : bottomNavigation.unselectedFontSize,
	      transition: 'color 0.3s, font-size 0.3s',
	      color: color
	    },
	    icon: {
	      display: 'block',
	      /**
	       * Used to ensure SVG icons are centered
	       */
	      width: '100%'
	    },
	    iconColor: color
	  };
	
	  return styles;
	}
	
	var BottomNavigationItem = function BottomNavigationItem(props, context) {
	  var label = props.label,
	      icon = props.icon,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['label', 'icon', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var styledIcon = (0, _react.cloneElement)(icon, {
	    style: (0, _simpleAssign2.default)({}, styles.icon, icon.props.style),
	    color: icon.props.color || styles.iconColor
	  });
	
	  return _react2.default.createElement(
	    _EnhancedButton2.default,
	    (0, _extends3.default)({}, other, { style: (0, _simpleAssign2.default)({}, styles.root, style) }),
	    styledIcon,
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles(styles.label) },
	      label
	    )
	  );
	};
	
	process.env.NODE_ENV !== "production" ? BottomNavigationItem.propTypes = {
	  /**
	   * Set the icon representing the view for this item.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * Set the label describing the view for this item.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	BottomNavigationItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = BottomNavigationItem;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      padding: 8,
	      position: 'relative'
	    },
	    action: {
	      marginRight: 8
	    }
	  };
	}
	
	var CardActions = function (_Component) {
	  (0, _inherits3.default)(CardActions, _Component);
	
	  function CardActions() {
	    (0, _classCallCheck3.default)(this, CardActions);
	    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        styledChildren
	      );
	    }
	  }]);
	  return CardActions;
	}(_react.Component);
	
	CardActions.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? CardActions.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Action.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardActions;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keyboardArrowUp = __webpack_require__(1051);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(1050);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _IconButton = __webpack_require__(135);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      top: 0,
	      bottom: 0,
	      right: 4,
	      margin: 'auto',
	      position: 'absolute'
	    }
	  };
	}
	
	var CardExpandable = function (_Component) {
	  (0, _inherits3.default)(CardExpandable, _Component);
	
	  function CardExpandable() {
	    (0, _classCallCheck3.default)(this, CardExpandable);
	    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardExpandable, [{
	    key: 'render',
	    value: function render() {
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          onTouchTap: this.props.onExpanding
	        },
	        this.props.expanded ? this.props.openIcon : this.props.closeIcon
	      );
	    }
	  }]);
	  return CardExpandable;
	}(_react.Component);
	
	CardExpandable.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	CardExpandable.defaultProps = {
	  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
	  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
	};
	process.env.NODE_ENV !== "production" ? CardExpandable.propTypes = {
	  closeIcon: _react.PropTypes.node,
	  expanded: _react.PropTypes.bool,
	  onExpanding: _react.PropTypes.func.isRequired,
	  openIcon: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardExpandable;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Avatar = __webpack_require__(385);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontWeight: card.fontWeight,
	      boxSizing: 'border-box',
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    text: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      whiteSpace: 'normal',
	      paddingRight: '90px'
	    },
	    avatar: {
	      marginRight: 16
	    },
	    title: {
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      fontSize: 15
	    },
	    subtitle: {
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block',
	      fontSize: 14
	    }
	  };
	}
	
	var CardHeader = function (_Component) {
	  (0, _inherits3.default)(CardHeader, _Component);
	
	  function CardHeader() {
	    (0, _classCallCheck3.default)(this, CardHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          avatarProp = _props.avatar,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          openIcon = _props.openIcon,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          textStyle = _props.textStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var avatar = avatarProp;
	
	      if ((0, _react.isValidElement)(avatarProp)) {
	        avatar = _react2.default.cloneElement(avatar, {
	          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
	        });
	      } else if (avatar !== null) {
	        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        avatar,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	            subtitle
	          )
	        ),
	        children
	      );
	    }
	  }]);
	  return CardHeader;
	}(_react.Component);
	
	CardHeader.muiName = 'CardHeader';
	CardHeader.defaultProps = {
	  avatar: null
	};
	CardHeader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? CardHeader.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
	   * If `avatar` is an `Avatar` or other element, it will be rendered.
	   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
	   */
	  avatar: _react.PropTypes.node,
	  /**
	   * Can be used to render elements inside the Card Header.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
	   */
	  openIcon: _react.PropTypes.node,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Can be used to render a subtitle in Card Header.
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the text.
	   */
	  textStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render a title in Card Header.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = CardHeader;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardMedia = context.muiTheme.cardMedia;
	
	
	  return {
	    root: {
	      position: 'relative'
	    },
	    overlayContainer: {
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0
	    },
	    overlay: {
	      height: '100%',
	      position: 'relative'
	    },
	    overlayContent: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      left: 0,
	      paddingTop: 8,
	      background: cardMedia.overlayContentBackground
	    },
	    media: {},
	    mediaChild: {
	      verticalAlign: 'top',
	      maxWidth: '100%',
	      minWidth: '100%',
	      width: '100%'
	    }
	  };
	}
	
	var CardMedia = function (_Component) {
	  (0, _inherits3.default)(CardMedia, _Component);
	
	  function CardMedia() {
	    (0, _classCallCheck3.default)(this, CardMedia);
	    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          mediaStyle = _props.mediaStyle,
	          overlay = _props.overlay,
	          overlayContainerStyle = _props.overlayContainerStyle,
	          overlayContentStyle = _props.overlayContentStyle,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
	      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
	      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
	      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      var titleColor = this.context.muiTheme.cardMedia.titleColor;
	      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
	      var color = this.context.muiTheme.cardMedia.color;
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.cloneElement(child, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
	        });
	      });
	
	      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
	        if (child.type.muiName === 'CardHeader' || child.type.muiName === 'CardTitle') {
	          return _react2.default.cloneElement(child, {
	            titleColor: titleColor,
	            subtitleColor: subtitleColor
	          });
	        } else if (child.type.muiName === 'CardText') {
	          return _react2.default.cloneElement(child, {
	            color: color
	          });
	        } else {
	          return child;
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedMediaStyle) },
	          styledChildren
	        ),
	        overlay ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedOverlayContainerStyle) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(extendedOverlayStyle) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(extendedOverlayContentStyle) },
	              overlayChildren
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	  return CardMedia;
	}(_react.Component);
	
	CardMedia.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? CardMedia.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Media.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the Card Media.
	   */
	  mediaStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render overlay element in Card Media.
	   */
	  overlay: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the overlay container.
	   */
	  overlayContainerStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the overlay content.
	   */
	  overlayContentStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the overlay element.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardMedia;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardText = context.muiTheme.cardText;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontSize: 14,
	      color: props.color || cardText.textColor
	    }
	  };
	}
	
	var CardText = function (_Component) {
	  (0, _inherits3.default)(CardText, _Component);
	
	  function CardText() {
	    (0, _classCallCheck3.default)(this, CardText);
	    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          color = _props.color,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        children
	      );
	    }
	  }]);
	  return CardText;
	}(_react.Component);
	
	CardText.muiName = 'CardText';
	CardText.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? CardText.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Text.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the CardText color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardText;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      position: 'relative'
	    },
	    title: {
	      fontSize: 24,
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      lineHeight: '36px'
	    },
	    subtitle: {
	      fontSize: 14,
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block'
	    }
	  };
	}
	
	var CardTitle = function (_Component) {
	  (0, _inherits3.default)(CardTitle, _Component);
	
	  function CardTitle() {
	    (0, _classCallCheck3.default)(this, CardTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
	      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
	      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedTitleStyle) },
	          title
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedSubtitleStyle) },
	          subtitle
	        ),
	        children
	      );
	    }
	  }]);
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.muiName = 'CardTitle';
	CardTitle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? CardTitle.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Title.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Can be used to render a subtitle in the Card Title.
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render a title in the Card Title.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = CardTitle;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(973);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.DropDownMenu = undefined;
	
	var _DropDownMenu2 = __webpack_require__(976);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _MenuItem2 = __webpack_require__(274);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _DropDownMenu3.default;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(325);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _titleBar;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      gridTile = _context$muiTheme.gridTile;
	
	
	  var actionPos = props.actionIcon && props.actionPosition;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'block',
	      height: '100%',
	      overflow: 'hidden'
	    },
	    titleBar: (_titleBar = {
	      position: 'absolute',
	      left: 0,
	      right: 0
	    }, (0, _defineProperty3.default)(_titleBar, props.titlePosition, 0), (0, _defineProperty3.default)(_titleBar, 'height', props.subtitle ? 68 : 48), (0, _defineProperty3.default)(_titleBar, 'background', props.titleBackground), (0, _defineProperty3.default)(_titleBar, 'display', 'flex'), (0, _defineProperty3.default)(_titleBar, 'alignItems', 'center'), _titleBar),
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: actionPos !== 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginRight: actionPos === 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      color: gridTile.textColor,
	      overflow: 'hidden'
	    },
	    title: {
	      fontSize: '16px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: '12px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIcon: {
	      order: actionPos === 'left' ? -1 : 1
	    },
	    childImg: {
	      height: '100%',
	      transform: 'translateX(-50%)',
	      position: 'relative',
	      left: '50%'
	    }
	  };
	  return styles;
	}
	
	var GridTile = function (_Component) {
	  (0, _inherits3.default)(GridTile, _Component);
	
	  function GridTile() {
	    (0, _classCallCheck3.default)(this, GridTile);
	    return (0, _possibleConstructorReturn3.default)(this, (GridTile.__proto__ || (0, _getPrototypeOf2.default)(GridTile)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridTile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'ensureImageCover',
	    value: function ensureImageCover() {
	      var _this2 = this;
	
	      var imgEl = this.refs.img;
	
	      if (imgEl) {
	        (function () {
	          var fit = function fit() {
	            if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
	              var isRtl = _this2.context.muiTheme.isRtl;
	
	              imgEl.style.height = 'auto';
	              if (isRtl) {
	                imgEl.style.right = '0';
	              } else {
	                imgEl.style.left = '0';
	              }
	              imgEl.style.width = '100%';
	              imgEl.style.top = '50%';
	              imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
	            }
	            imgEl.removeEventListener('load', fit);
	            imgEl = null; // prevent closure memory leak
	          };
	          if (imgEl.complete) {
	            fit();
	          } else {
	            imgEl.addEventListener('load', fit);
	          }
	        })();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          subtitle = _props.subtitle,
	          titlePosition = _props.titlePosition,
	          titleBackground = _props.titleBackground,
	          titleStyle = _props.titleStyle,
	          actionIcon = _props.actionIcon,
	          actionPosition = _props.actionPosition,
	          style = _props.style,
	          children = _props.children,
	          containerElement = _props.containerElement,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'titleStyle', 'actionIcon', 'actionPosition', 'style', 'children', 'containerElement']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var titleBar = null;
	
	      if (title) {
	        titleBar = _react2.default.createElement(
	          'div',
	          { key: 'titlebar', style: prepareStyles(styles.titleBar) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.titleWrap) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	              title
	            ),
	            subtitle ? _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.subtitle) },
	              subtitle
	            ) : null
	          ),
	          actionIcon ? _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.actionIcon) },
	            actionIcon
	          ) : null
	        );
	      }
	
	      var newChildren = children;
	
	      // if there is a single image passed as children
	      // clone it and add our styles
	      if (_react2.default.Children.count(children) === 1) {
	        newChildren = _react2.default.Children.map(children, function (child) {
	          if (child.type === 'img') {
	            return _react2.default.cloneElement(child, {
	              key: 'img',
	              ref: 'img',
	              style: prepareStyles((0, _simpleAssign2.default)({}, styles.childImg, child.props.style))
	            });
	          } else {
	            return child;
	          }
	        });
	      }
	
	      var containerProps = (0, _extends3.default)({
	        style: prepareStyles(mergedRootStyles)
	      }, other);
	
	      return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, containerProps, [newChildren, titleBar]) : _react2.default.createElement(containerElement, containerProps, [newChildren, titleBar]);
	    }
	  }]);
	  return GridTile;
	}(_react.Component);
	
	GridTile.defaultProps = {
	  titlePosition: 'bottom',
	  titleBackground: 'rgba(0, 0, 0, 0.4)',
	  actionPosition: 'right',
	  cols: 1,
	  rows: 1,
	  containerElement: 'div'
	};
	GridTile.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? GridTile.propTypes = {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _react.PropTypes.element,
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in whichcase GridTile takes care of making the image "cover" available space
	   * (similar to background-size: cover or to object-fit:cover).
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _react.PropTypes.number,
	  /**
	   * Either a string used as tag name for the tile root element, or a ReactElement.
	   * This is useful when you have, for example, a custom implementation of
	   * a navigation link (that knows about your routes) and you want to use it as the primary tile action.
	   * In case you pass a ReactElement, please ensure that it passes all props,
	   * accepts styles overrides and render it's children.
	   */
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Style used for title bar background.
	   * Useful for setting custom gradients for example
	   */
	  titleBackground: _react.PropTypes.string,
	  /**
	   * Position of the title bar (container of title, subtitle and action icon).
	   */
	  titlePosition: _react.PropTypes.oneOf(['top', 'bottom']),
	  /**
	   * Override the inline-styles of the title element.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = GridTile;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelectable = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colorManipulator = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeSelectable = exports.makeSelectable = function makeSelectable(MyComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(_class, _Component);
	
	    function _class() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3.default)(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
	        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
	          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
	        }
	        return previousValue || _this.isChildSelected(child, _this.props);
	      }, _this.handleItemTouchTap = function (event, item) {
	        var itemValue = item.props.value;
	
	        if (itemValue !== _this.props.value) {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, itemValue);
	          }
	        }
	      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(_class, [{
	      key: 'extendChild',
	      value: function extendChild(child, styles, selectedItemStyle) {
	        var _this2 = this;
	
	        if (child && child.type && child.type.muiName === 'ListItem') {
	          var selected = this.isChildSelected(child, this.props);
	          var selectedChildrenStyles = void 0;
	          if (selected) {
	            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
	          }
	
	          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	          this.keyIndex += 1;
	
	          return _react2.default.cloneElement(child, {
	            onTouchTap: function onTouchTap(event) {
	              _this2.handleItemTouchTap(event, child);
	              if (child.props.onTouchTap) {
	                child.props.onTouchTap(event);
	              }
	            },
	            key: this.keyIndex,
	            style: mergedChildrenStyles,
	            nestedItems: child.props.nestedItems.map(function (child) {
	              return _this2.extendChild(child, styles, selectedItemStyle);
	            }),
	            initiallyOpen: this.isInitiallyOpen(child)
	          });
	        } else {
	          return child;
	        }
	      }
	    }, {
	      key: 'isInitiallyOpen',
	      value: function isInitiallyOpen(child) {
	        if (child.props.initiallyOpen) {
	          return child.props.initiallyOpen;
	        }
	        return this.hasSelectedDescendant(false, child);
	      }
	    }, {
	      key: 'isChildSelected',
	      value: function isChildSelected(child, props) {
	        return props.value === child.props.value;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            selectedItemStyle = _props.selectedItemStyle,
	            other = (0, _objectWithoutProperties3.default)(_props, ['children', 'selectedItemStyle']);
	
	
	        this.keyIndex = 0;
	        var styles = {};
	
	        if (!selectedItemStyle) {
	          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
	          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
	        }
	
	        return _react2.default.createElement(
	          MyComponent,
	          (0, _extends3.default)({}, other, this.state),
	          _react.Children.map(children, function (child) {
	            return _this3.extendChild(child, styles, selectedItemStyle);
	          })
	        );
	      }
	    }]);
	    return _class;
	  }(_react.Component), _class.propTypes = {
	    children: _react.PropTypes.node,
	    onChange: _react.PropTypes.func,
	    selectedItemStyle: _react.PropTypes.object,
	    value: _react.PropTypes.any
	  }, _class.contextTypes = {
	    muiTheme: _react.PropTypes.object.isRequired
	  }, _temp2;
	};
	
	exports.default = makeSelectable;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(194);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(275);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _Menu3.default;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RadioButton = __webpack_require__(399);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioButtonGroup = function (_Component) {
	  (0, _inherits3.default)(RadioButtonGroup, _Component);
	
	  function RadioButtonGroup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButtonGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      numberCheckedRadioButtons: 0,
	      selected: ''
	    }, _this.handleChange = function (event, newSelection) {
	      _this.updateRadioButtons(newSelection);
	
	      // Successful update
	      if (_this.state.numberCheckedRadioButtons === 0) {
	        if (_this.props.onChange) _this.props.onChange(event, newSelection);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RadioButtonGroup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var cnt = 0;
	      var selected = '';
	      var _props = this.props,
	          valueSelected = _props.valueSelected,
	          defaultSelected = _props.defaultSelected;
	
	      if (valueSelected !== undefined) {
	        selected = valueSelected;
	      } else if (defaultSelected !== undefined) {
	        selected = defaultSelected;
	      }
	
	      _react2.default.Children.forEach(this.props.children, function (option) {
	        if (_this2.hasCheckAttribute(option)) cnt++;
	      }, this);
	
	      this.setState({
	        numberCheckedRadioButtons: cnt,
	        selected: selected
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasOwnProperty('valueSelected')) {
	        this.setState({
	          selected: nextProps.valueSelected
	        });
	      }
	    }
	  }, {
	    key: 'hasCheckAttribute',
	    value: function hasCheckAttribute(radioButton) {
	      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
	    }
	  }, {
	    key: 'updateRadioButtons',
	    value: function updateRadioButtons(newSelection) {
	      if (this.state.numberCheckedRadioButtons === 0) {
	        this.setState({ selected: newSelection });
	      } else {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : void 0;
	      }
	    }
	  }, {
	    key: 'getSelectedValue',
	    value: function getSelectedValue() {
	      return this.state.selected;
	    }
	  }, {
	    key: 'setSelectedValue',
	    value: function setSelectedValue(newSelectionValue) {
	      this.updateRadioButtons(newSelectionValue);
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      this.setSelectedValue('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var options = _react2.default.Children.map(this.props.children, function (option) {
	        var _option$props = option.props,
	            name = _option$props.name,
	            value = _option$props.value,
	            label = _option$props.label,
	            onCheck = _option$props.onCheck,
	            other = (0, _objectWithoutProperties3.default)(_option$props, ['name', 'value', 'label', 'onCheck']);
	
	
	        return _react2.default.createElement(_RadioButton2.default, (0, _extends3.default)({}, other, {
	          ref: option.props.value,
	          name: _this3.props.name,
	          key: option.props.value,
	          value: option.props.value,
	          label: option.props.label,
	          labelPosition: _this3.props.labelPosition,
	          onCheck: _this3.handleChange,
	          checked: option.props.value === _this3.state.selected
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: prepareStyles((0, _simpleAssign2.default)({}, this.props.style)),
	          className: this.props.className
	        },
	        options
	      );
	    }
	  }]);
	  return RadioButtonGroup;
	}(_react.Component);
	
	RadioButtonGroup.defaultProps = {
	  style: {}
	};
	RadioButtonGroup.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? RadioButtonGroup.propTypes = {
	  /**
	   * Should be used to pass `RadioButton` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The `value` property of the radio button that will be
	   * selected by default. This takes precedence over the `checked` property
	   * of the `RadioButton` elements.
	   */
	  defaultSelected: _react.PropTypes.any,
	  /**
	   * Where the label will be placed for all child radio buttons.
	   * This takes precedence over the `labelPosition` property of the
	   * `RadioButton` elements.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * The name that will be applied to all child radio buttons.
	   */
	  name: _react.PropTypes.string.isRequired,
	  /**
	   * Callback function that is fired when a radio button has
	   * been checked.
	   *
	   * @param {object} event `change` event targeting the selected
	   * radio button.
	   * @param {*} value The `value` of the selected radio button.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The `value` of the currently selected radio button.
	   */
	  valueSelected: _react.PropTypes.any
	} : void 0;
	exports.default = RadioButtonGroup;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.RadioButtonGroup = exports.RadioButton = undefined;
	
	var _RadioButton2 = __webpack_require__(995);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(398);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.default = _RadioButton3.default;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _typeof2 = __webpack_require__(100);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkCircle = __webpack_require__(1049);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active,
	      completed = _ref.completed,
	      disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme,
	      stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper,
	      textColor = _muiTheme$stepper.textColor,
	      disabledTextColor = _muiTheme$stepper.disabledTextColor,
	      iconColor = _muiTheme$stepper.iconColor,
	      inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      paddingRight: 8
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'not-allowed';
	  }
	
	  return styles;
	};
	
	var renderIcon = function renderIcon(completed, icon, styles) {
	  var iconType = typeof icon === 'undefined' ? 'undefined' : (0, _typeof3.default)(icon);
	
	  if (iconType === 'number' || iconType === 'string') {
	    if (completed) {
	      return _react2.default.createElement(_checkCircle2.default, {
	        color: styles.icon.color,
	        style: styles.icon
	      });
	    }
	
	    return _react2.default.createElement(
	      _SvgIcon2.default,
	      { color: styles.icon.color, style: styles.icon },
	      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: '12',
	          y: '16',
	          textAnchor: 'middle',
	          fontSize: '12',
	          fill: '#fff'
	        },
	        icon
	      )
	    );
	  }
	
	  return icon;
	};
	
	var StepLabel = function StepLabel(props, context) {
	  var active = props.active,
	      children = props.children,
	      completed = props.completed,
	      userIcon = props.icon,
	      iconContainerStyle = props.iconContainerStyle,
	      last = props.last,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'children', 'completed', 'icon', 'iconContainerStyle', 'last', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	  var icon = renderIcon(completed, userIcon, styles);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	    icon && _react2.default.createElement(
	      'span',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.iconContainer, iconContainerStyle)) },
	      icon
	    ),
	    children
	  );
	};
	
	StepLabel.muiName = 'StepLabel';
	
	process.env.NODE_ENV !== "production" ? StepLabel.propTypes = {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * The label text node
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	StepLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	
	exports.default = StepLabel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(1012);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(323);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(154);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(100);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(269);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableRowColumn = __webpack_require__(195);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _ClickAwayListener = __webpack_require__(278);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableBody = function (_Component) {
	  (0, _inherits3.default)(TableBody, _Component);
	
	  function TableBody() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedRows: []
	    }, _this.handleClickAway = function () {
	      if (_this.props.deselectOnClickaway && _this.state.selectedRows.length) {
	        _this.setState({
	          selectedRows: []
	        });
	        if (_this.props.onRowSelection) {
	          _this.props.onRowSelection([]);
	        }
	      }
	    }, _this.onRowClick = function (event, rowNumber) {
	      event.stopPropagation();
	
	      if (_this.props.selectable) {
	        // Prevent text selection while selecting rows.
	        window.getSelection().removeAllRanges();
	        _this.processRowSelection(event, rowNumber);
	      }
	    }, _this.onCellClick = function (event, rowNumber, columnNumber) {
	      event.stopPropagation();
	      if (_this.props.onCellClick) {
	        _this.props.onCellClick(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	    }, _this.onCellHover = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHover) {
	        _this.props.onCellHover(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHover(event, rowNumber);
	    }, _this.onCellHoverExit = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHoverExit) {
	        _this.props.onCellHoverExit(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHoverExit(event, rowNumber);
	    }, _this.onRowHover = function (event, rowNumber) {
	      if (_this.props.onRowHover) {
	        _this.props.onRowHover(rowNumber);
	      }
	    }, _this.onRowHoverExit = function (event, rowNumber) {
	      if (_this.props.onRowHoverExit) {
	        _this.props.onRowHoverExit(rowNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableBody, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ selectedRows: this.calculatePreselectedRows(this.props) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
	        if (!nextProps.allRowsSelected) {
	          this.setState({
	            selectedRows: []
	          });
	        } else {
	          this.setState({
	            selectedRows: this.calculatePreselectedRows(nextProps)
	          });
	        }
	      }
	    }
	  }, {
	    key: 'createRows',
	    value: function createRows() {
	      var _this2 = this;
	
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var rowNumber = 0;
	      var handlers = {
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowClick: this.onRowClick
	      };
	
	      return _react2.default.Children.map(this.props.children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          var _ret2 = function () {
	            var props = {
	              hoverable: _this2.props.showRowHover,
	              selected: _this2.isRowSelected(rowNumber),
	              striped: _this2.props.stripedRows && rowNumber % 2 === 0,
	              rowNumber: rowNumber++
	            };
	
	            if (rowNumber === numChildren) {
	              props.displayBorder = false;
	            }
	
	            var children = [_this2.createRowCheckboxColumn(props)];
	
	            _react2.default.Children.forEach(child.props.children, function (child) {
	              children.push(child);
	            });
	
	            return {
	              v: _react2.default.cloneElement(child, (0, _extends3.default)({}, props, handlers), children)
	            };
	          }();
	
	          if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
	        }
	      });
	    }
	  }, {
	    key: 'createRowCheckboxColumn',
	    value: function createRowCheckboxColumn(rowProps) {
	      if (!this.props.displayRowCheckbox) {
	        return null;
	      }
	
	      var key = rowProps.rowNumber + '-cb';
	      var disabled = !this.props.selectable;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        ref: 'rowSelectCB',
	        name: key,
	        value: 'selected',
	        disabled: disabled,
	        checked: rowProps.selected
	      });
	
	      return _react2.default.createElement(
	        _TableRowColumn2.default,
	        {
	          key: key,
	          columnNumber: 0,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'calculatePreselectedRows',
	    value: function calculatePreselectedRows(props) {
	      // Determine what rows are 'pre-selected'.
	      var preSelectedRows = [];
	
	      if (props.selectable && props.preScanRows) {
	        (function () {
	          var index = 0;
	          _react2.default.Children.forEach(props.children, function (child) {
	            if (_react2.default.isValidElement(child)) {
	              if (child.props.selected && (preSelectedRows.length === 0 || props.multiSelectable)) {
	                preSelectedRows.push(index);
	              }
	
	              index++;
	            }
	          });
	        })();
	      }
	
	      return preSelectedRows;
	    }
	  }, {
	    key: 'isRowSelected',
	    value: function isRowSelected(rowNumber) {
	      if (this.props.allRowsSelected) {
	        return true;
	      }
	
	      for (var i = 0; i < this.state.selectedRows.length; i++) {
	        var selection = this.state.selectedRows[i];
	
	        if ((typeof selection === 'undefined' ? 'undefined' : (0, _typeof3.default)(selection)) === 'object') {
	          if (this.isValueInRange(rowNumber, selection)) return true;
	        } else {
	          if (selection === rowNumber) return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isValueInRange',
	    value: function isValueInRange(value, range) {
	      if (!range) return false;
	
	      if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'processRowSelection',
	    value: function processRowSelection(event, rowNumber) {
	      var selectedRows = this.state.selectedRows;
	
	      if (event.shiftKey && this.props.multiSelectable && selectedRows.length) {
	        var lastIndex = selectedRows.length - 1;
	        var lastSelection = selectedRows[lastIndex];
	
	        if ((typeof lastSelection === 'undefined' ? 'undefined' : (0, _typeof3.default)(lastSelection)) === 'object') {
	          lastSelection.end = rowNumber;
	        } else {
	          selectedRows.splice(lastIndex, 1, { start: lastSelection, end: rowNumber });
	        }
	      } else if ((event.ctrlKey && !event.metaKey || event.metaKey && !event.ctrlKey) && this.props.multiSelectable) {
	        var idx = selectedRows.indexOf(rowNumber);
	        if (idx < 0) {
	          var foundRange = false;
	          for (var i = 0; i < selectedRows.length; i++) {
	            var range = selectedRows[i];
	            if ((typeof range === 'undefined' ? 'undefined' : (0, _typeof3.default)(range)) !== 'object') continue;
	
	            if (this.isValueInRange(rowNumber, range)) {
	              var _selectedRows;
	
	              foundRange = true;
	              var values = this.splitRange(range, rowNumber);
	              (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat((0, _toConsumableArray3.default)(values)));
	            }
	          }
	
	          if (!foundRange) selectedRows.push(rowNumber);
	        } else {
	          selectedRows.splice(idx, 1);
	        }
	      } else {
	        if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
	          selectedRows = [];
	        } else {
	          selectedRows = [rowNumber];
	        }
	      }
	
	      this.setState({ selectedRows: selectedRows });
	      if (this.props.onRowSelection) this.props.onRowSelection(this.flattenRanges(selectedRows));
	    }
	  }, {
	    key: 'splitRange',
	    value: function splitRange(range, splitPoint) {
	      var splitValues = [];
	      var startOffset = range.start - splitPoint;
	      var endOffset = range.end - splitPoint;
	
	      // Process start half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, startOffset)));
	
	      // Process end half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, endOffset)));
	
	      return splitValues;
	    }
	  }, {
	    key: 'genRangeOfValues',
	    value: function genRangeOfValues(start, offset) {
	      var values = [];
	      var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
	      while (offset !== 0) {
	        values.push(start + offset);
	        offset += dir;
	      }
	
	      return values;
	    }
	  }, {
	    key: 'flattenRanges',
	    value: function flattenRanges(selectedRows) {
	      var rows = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(selectedRows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var selection = _step.value;
	
	          if ((typeof selection === 'undefined' ? 'undefined' : (0, _typeof3.default)(selection)) === 'object') {
	            var values = this.genRangeOfValues(selection.end, selection.start - selection.end);
	            rows.push.apply(rows, [selection.end].concat((0, _toConsumableArray3.default)(values)));
	          } else {
	            rows.push(selection);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return rows.sort();
	    }
	  }, {
	    key: 'getColumnId',
	    value: function getColumnId(columnNumber) {
	      var columnId = columnNumber;
	      if (this.props.displayRowCheckbox) {
	        columnId--;
	      }
	
	      return columnId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'tbody',
	          { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	          this.createRows()
	        )
	      );
	    }
	  }]);
	  return TableBody;
	}(_react.Component);
	
	TableBody.muiName = 'TableBody';
	TableBody.defaultProps = {
	  allRowsSelected: false,
	  deselectOnClickaway: true,
	  displayRowCheckbox: true,
	  multiSelectable: false,
	  preScanRows: true,
	  selectable: true,
	  style: {}
	};
	TableBody.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TableBody.propTypes = {
	  /**
	   * @ignore
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _react.PropTypes.bool,
	  /**
	   * Children passed to table body.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Controls whether or not to deselect all selected
	   * rows after clicking outside the table.
	   */
	  deselectOnClickaway: _react.PropTypes.bool,
	  /**
	   * Controls the display of the row checkbox. The default value is true.
	   */
	  displayRowCheckbox: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Callback function for when a cell is clicked.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered. rowNumber
	   * is the row number of the hovered row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer
	   * hovered. rowNumber is the row number of the row
	   * that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a row is selected. selectedRows is an
	   * array of all row selections. IF all rows have been selected,
	   * the string "all" will be returned instead to indicate that
	   * all rows have been selected.
	   */
	  onRowSelection: _react.PropTypes.func,
	  /**
	   * Controls whether or not the rows are pre-scanned to determine
	   * initial state. If your table has a large number of rows and
	   * you are experiencing a delay in rendering, turn off this property.
	   */
	  preScanRows: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * If true, table rows can be selected. If multiple
	   * row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * If true, table rows will be highlighted when
	   * the cursor is hovering over the row. The default
	   * value is false.
	   */
	  showRowHover: _react.PropTypes.bool,
	  /**
	   * If true, every other table row starting
	   * with the first row will be striped. The default value is false.
	   */
	  stripedRows: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableBody;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(154);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableRowColumn = __webpack_require__(195);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableFooter = context.muiTheme.tableFooter;
	
	
	  return {
	    cell: {
	      borderTop: '1px solid ' + tableFooter.borderColor,
	      verticalAlign: 'bottom',
	      padding: 20,
	      textAlign: 'left',
	      whiteSpace: 'nowrap'
	    }
	  };
	}
	
	var TableFooter = function (_Component) {
	  (0, _inherits3.default)(TableFooter, _Component);
	
	  function TableFooter() {
	    (0, _classCallCheck3.default)(this, TableFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          adjustForCheckbox = _props.adjustForCheckbox,
	          children = _props.children,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['adjustForCheckbox', 'children', 'className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var footerRows = _react2.default.Children.map(children, function (child, rowNumber) {
	        var newChildProps = {
	          displayBorder: false,
	          key: 'f-' + rowNumber,
	          rowNumber: rowNumber,
	          style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	        };
	
	        var newDescendants = void 0;
	
	        if (adjustForCheckbox) {
	          newDescendants = [_react2.default.createElement(_TableRowColumn2.default, { key: 'fpcb' + rowNumber, style: { width: 24 } })].concat((0, _toConsumableArray3.default)(_react2.default.Children.toArray(child.props.children)));
	        } else {
	          newDescendants = child.props.children;
	        }
	
	        return _react2.default.cloneElement(child, newChildProps, newDescendants);
	      });
	
	      return _react2.default.createElement(
	        'tfoot',
	        (0, _extends3.default)({ className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        footerRows
	      );
	    }
	  }]);
	  return TableFooter;
	}(_react.Component);
	
	TableFooter.muiName = 'TableFooter';
	TableFooter.defaultProps = {
	  adjustForCheckbox: true,
	  style: {}
	};
	TableFooter.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TableFooter.propTypes = {
	  /**
	   * @ignore
	   * Controls whether or not header rows should be adjusted
	   * for a checkbox column. If the select all checkbox is true,
	   * this property will not influence the number of columns.
	   * This is mainly useful for "super header" rows so that
	   * the checkbox column does not create an offset that needs
	   * to be accounted for manually.
	   */
	  adjustForCheckbox: _react.PropTypes.bool,
	  /**
	   * Children passed to table footer.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableFooter;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(269);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableHeaderColumn = __webpack_require__(277);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeader = context.muiTheme.tableHeader;
	
	
	  return {
	    root: {
	      borderBottom: '1px solid ' + tableHeader.borderColor
	    }
	  };
	}
	
	var TableHeader = function (_Component) {
	  (0, _inherits3.default)(TableHeader, _Component);
	
	  function TableHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeader.__proto__ || (0, _getPrototypeOf2.default)(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckAll = function (event, checked) {
	      if (_this.props.onSelectAll) {
	        _this.props.onSelectAll(checked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeader, [{
	    key: 'createSuperHeaderRows',
	    value: function createSuperHeaderRows() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      if (numChildren === 1) return undefined;
	
	      var superHeaders = [];
	      for (var index = 0; index < numChildren - 1; index++) {
	        var child = this.props.children[index];
	
	        if (!_react2.default.isValidElement(child)) continue;
	
	        var props = {
	          key: 'sh' + index,
	          rowNumber: index
	        };
	        superHeaders.push(this.createSuperHeaderRow(child, props));
	      }
	
	      if (superHeaders.length) return superHeaders;
	    }
	  }, {
	    key: 'createSuperHeaderRow',
	    value: function createSuperHeaderRow(child, props) {
	      var children = [];
	      if (this.props.adjustForCheckbox) {
	        children.push(this.getCheckboxPlaceholder(props));
	      }
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'createBaseHeaderRow',
	    value: function createBaseHeaderRow() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var child = numChildren === 1 ? this.props.children : this.props.children[numChildren - 1];
	      var props = {
	        key: 'h' + numChildren,
	        rowNumber: numChildren
	      };
	
	      var children = [this.getSelectAllCheckboxColumn(props)];
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'getCheckboxPlaceholder',
	    value: function getCheckboxPlaceholder(props) {
	      if (!this.props.adjustForCheckbox) return null;
	
	      var disabled = !this.props.enableSelectAll;
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(_TableHeaderColumn2.default, {
	        key: key,
	        style: {
	          width: 24,
	          cursor: disabled ? 'not-allowed' : 'inherit'
	        }
	      });
	    }
	  }, {
	    key: 'getSelectAllCheckboxColumn',
	    value: function getSelectAllCheckboxColumn(props) {
	      if (!this.props.displaySelectAll) return this.getCheckboxPlaceholder(props);
	
	      var disabled = !this.props.enableSelectAll;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        key: 'selectallcb',
	        name: 'selectallcb',
	        value: 'selected',
	        disabled: disabled,
	        checked: this.props.selectAllSelected,
	        onCheck: this.handleCheckAll
	      });
	
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(
	        _TableHeaderColumn2.default,
	        {
	          key: key,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var superHeaderRows = this.createSuperHeaderRows();
	      var baseHeaderRow = this.createBaseHeaderRow();
	
	      return _react2.default.createElement(
	        'thead',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        superHeaderRows,
	        baseHeaderRow
	      );
	    }
	  }]);
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.muiName = 'TableHeader';
	TableHeader.defaultProps = {
	  adjustForCheckbox: true,
	  displaySelectAll: true,
	  enableSelectAll: true,
	  selectAllSelected: false
	};
	TableHeader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TableHeader.propTypes = {
	  /**
	   * Controls whether or not header rows should be
	   * adjusted for a checkbox column. If the select all
	   * checkbox is true, this property will not influence
	   * the number of columns. This is mainly useful for
	   * "super header" rows so that the checkbox column
	   * does not create an offset that needs to be accounted
	   * for manually.
	   */
	  adjustForCheckbox: _react.PropTypes.bool,
	  /**
	   * Children passed to table header.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Controls whether or not the select all checkbox is displayed.
	   */
	  displaySelectAll: _react.PropTypes.bool,
	  /**
	   * If set to true, the select all button will be interactable.
	   * If set to false, the button will not be interactable.
	   * To hide the checkbox, set displaySelectAll to false.
	   */
	  enableSelectAll: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Callback when select all has been checked.
	   */
	  onSelectAll: _react.PropTypes.func,
	  /**
	   * @ignore
	   * True when select all has been checked.
	   */
	  selectAllSelected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableHeader;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var tableRow = context.muiTheme.tableRow;
	
	
	  var cellBgColor = 'inherit';
	  if (props.hovered || state.hovered) {
	    cellBgColor = tableRow.hoverColor;
	  } else if (props.selected) {
	    cellBgColor = tableRow.selectedColor;
	  } else if (props.striped) {
	    cellBgColor = tableRow.stripeColor;
	  }
	
	  return {
	    root: {
	      borderBottom: props.displayBorder && '1px solid ' + tableRow.borderColor,
	      color: tableRow.textColor,
	      height: tableRow.height
	    },
	    cell: {
	      backgroundColor: cellBgColor
	    }
	  };
	}
	
	var TableRow = function (_Component) {
	  (0, _inherits3.default)(TableRow, _Component);
	
	  function TableRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRow.__proto__ || (0, _getPrototypeOf2.default)(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onCellClick = function (event, columnIndex) {
	      if (_this.props.selectable && _this.props.onCellClick) {
	        _this.props.onCellClick(event, _this.props.rowNumber, columnIndex);
	      }
	      event.ctrlKey = true;
	      _this.onRowClick(event);
	    }, _this.onCellHover = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onCellHover) _this.props.onCellHover(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHover(event);
	      }
	    }, _this.onCellHoverExit = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHoverExit(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRow, [{
	    key: 'onRowClick',
	    value: function onRowClick(event) {
	      if (this.props.selectable && this.props.onRowClick) this.props.onRowClick(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'onRowHover',
	    value: function onRowHover(event) {
	      if (this.props.onRowHover) this.props.onRowHover(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'onRowHoverExit',
	    value: function onRowHoverExit(event) {
	      if (this.props.onRowHoverExit) this.props.onRowHoverExit(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          displayBorder = _props.displayBorder,
	          hoverable = _props.hoverable,
	          hovered = _props.hovered,
	          onCellClick = _props.onCellClick,
	          onCellHover = _props.onCellHover,
	          onCellHoverExit = _props.onCellHoverExit,
	          onRowClick = _props.onRowClick,
	          onRowHover = _props.onRowHover,
	          onRowHoverExit = _props.onRowHoverExit,
	          rowNumber = _props.rowNumber,
	          selectable = _props.selectable,
	          selected = _props.selected,
	          striped = _props.striped,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'displayBorder', 'hoverable', 'hovered', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var rowColumns = _react2.default.Children.map(this.props.children, function (child, columnNumber) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            columnNumber: columnNumber,
	            hoverable: _this2.props.hoverable,
	            key: _this2.props.rowNumber + '-' + columnNumber,
	            onClick: _this2.onCellClick,
	            onHover: _this2.onCellHover,
	            onHoverExit: _this2.onCellHoverExit,
	            style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other),
	        rowColumns
	      );
	    }
	  }]);
	  return TableRow;
	}(_react.Component);
	
	TableRow.defaultProps = {
	  displayBorder: true,
	  hoverable: false,
	  hovered: false,
	  selectable: true,
	  selected: false,
	  striped: false
	};
	TableRow.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TableRow.propTypes = {
	  /**
	   * Children passed to table row.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, row border will be displayed for the row.
	   * If false, no border will be drawn.
	   */
	  displayBorder: _react.PropTypes.bool,
	  /**
	   * Controls whether or not the row reponseds to hover events.
	   */
	  hoverable: _react.PropTypes.bool,
	  /**
	   * Controls whether or not the row should be rendered as being
	   * hovered. This property is evaluated in addition to this.state.hovered
	   * and can be used to synchronize the hovered state with some other
	   * external events.
	   */
	  hovered: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when row is clicked.
	   */
	  onRowClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * Number to identify the row. This property is
	   * automatically populated when used with the TableBody component.
	   */
	  rowNumber: _react.PropTypes.number,
	  /**
	   * If true, table rows can be selected. If multiple row
	   * selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * Indicates that a particular row is selected.
	   * This property can be used to programmatically select rows.
	   */
	  selected: _react.PropTypes.bool,
	  /**
	   * Indicates whether or not the row is striped.
	   */
	  striped: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableRow;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    root: {
	      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
	      fontWeight: 500,
	      fontSize: 14,
	      width: props.width,
	      textTransform: 'uppercase',
	      padding: 0
	    },
	    button: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: props.label && props.icon ? 72 : 48
	    }
	  };
	}
	
	var Tab = function (_Component) {
	  (0, _inherits3.default)(Tab, _Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(_this.props.value, event, _this);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          index = _props.index,
	          onActive = _props.onActive,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          label = _props.label,
	          buttonStyle = _props.buttonStyle,
	          style = _props.style,
	          value = _props.value,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onTouchTap', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (icon && _react2.default.isValidElement(icon)) {
	        var iconProps = {
	          style: {
	            fontSize: 24,
	            color: styles.root.color,
	            marginBottom: label ? 5 : 0
	          }
	        };
	        // If it's svg icon set color via props
	        if (icon.type.muiName !== 'FontIcon') {
	          iconProps.color = styles.root.color;
	        }
	        iconElement = _react2.default.cloneElement(icon, iconProps);
	      }
	
	      var rippleOpacity = 0.3;
	      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity,
	          onTouchTap: this.handleTouchTap
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
	          iconElement,
	          label
	        )
	      );
	    }
	  }]);
	  return Tab;
	}(_react.Component);
	
	Tab.muiName = 'Tab';
	Tab.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Tab.propTypes = {
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _react.PropTypes.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  index: _react.PropTypes.any,
	  /**
	   * Sets the text value of the tab item to the string specified.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * Fired when the active tab changes by touch or tap.
	   * Use this event to specify any functionality when an active tab changes.
	   * For example - we are using this to route to home when the third tab becomes active.
	   * This function will always recieve the active tab as it\'s first argument.
	   */
	  onActive: _react.PropTypes.func,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Defines if the current tab is selected or not.
	   * The Tabs component is responsible for setting this property.
	   */
	  selected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If value prop passed to Tabs component, this value prop is also required.
	   * It assigns a value to the tab so that it can be selected by the Tabs.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  width: _react.PropTypes.string
	} : void 0;
	exports.default = Tab;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _slicedToArray2 = __webpack_require__(223);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timeUtils = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var styles = {
	    root: {
	      directionInvariant: true,
	      display: 'inline-block',
	      position: 'absolute',
	      width: 32,
	      height: 32,
	      borderRadius: '100%',
	      left: 'calc(50% - 16px)',
	      top: 10,
	      textAlign: 'center',
	      paddingTop: 5,
	      userSelect: 'none', /* Chrome all / Safari all */
	      fontSize: '1.1em',
	      pointerEvents: 'none',
	      boxSizing: 'border-box'
	    }
	  };
	
	  var muiTheme = context.muiTheme;
	
	
	  var pos = props.value;
	
	  if (props.type === 'hour') {
	    pos %= 12;
	  } else {
	    pos = pos / 5;
	  }
	
	  var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];
	
	  var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];
	
	  if (props.isSelected) {
	    styles.root.backgroundColor = muiTheme.timePicker.accentColor;
	    styles.root.color = muiTheme.timePicker.selectTextColor;
	  }
	
	  var transformPos = positions[pos];
	
	  if ((0, _timeUtils.isInner)(props)) {
	    styles.root.width = 28;
	    styles.root.height = 28;
	    styles.root.left = 'calc(50% - 14px)';
	    transformPos = innerPositions[pos];
	  }
	
	  var _transformPos = transformPos,
	      _transformPos2 = (0, _slicedToArray3.default)(_transformPos, 2),
	      x = _transformPos2[0],
	      y = _transformPos2[1];
	
	  styles.root.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	  return styles;
	}
	
	var ClockNumber = function (_Component) {
	  (0, _inherits3.default)(ClockNumber, _Component);
	
	  function ClockNumber() {
	    (0, _classCallCheck3.default)(this, ClockNumber);
	    return (0, _possibleConstructorReturn3.default)(this, (ClockNumber.__proto__ || (0, _getPrototypeOf2.default)(ClockNumber)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ClockNumber, [{
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var clockNumber = this.props.value === 0 ? '00' : this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles(styles.root) },
	        clockNumber
	      );
	    }
	  }]);
	  return ClockNumber;
	}(_react.Component);
	
	ClockNumber.defaultProps = {
	  value: 0,
	  type: 'minute',
	  isSelected: false
	};
	ClockNumber.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ClockNumber.propTypes = {
	  isSelected: _react.PropTypes.bool,
	  onSelected: _react.PropTypes.func,
	  type: _react.PropTypes.oneOf(['hour', 'minute']),
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = ClockNumber;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timeUtils = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcAngle(value, base) {
	  value %= base;
	  var angle = 360 / base * value;
	  return angle;
	}
	
	function getStyles(props, context, state) {
	  var hasSelected = props.hasSelected,
	      type = props.type,
	      value = props.value;
	  var inner = state.inner;
	  var timePicker = context.muiTheme.timePicker;
	
	  var angle = type === 'hour' ? calcAngle(value, 12) : calcAngle(value, 60);
	
	  var styles = {
	    root: {
	      height: inner ? '30%' : '40%',
	      background: timePicker.accentColor,
	      width: 2,
	      left: 'calc(50% - 1px)',
	      position: 'absolute',
	      bottom: '50%',
	      transformOrigin: 'bottom',
	      pointerEvents: 'none',
	      transform: 'rotateZ(' + angle + 'deg)'
	    },
	    mark: {
	      boxSizing: 'content-box',
	      background: timePicker.selectTextColor,
	      border: '4px solid ' + timePicker.accentColor,
	      display: hasSelected && 'none',
	      width: 7,
	      height: 7,
	      position: 'absolute',
	      top: -5,
	      left: -6,
	      borderRadius: '100%'
	    }
	  };
	
	  return styles;
	}
	
	var ClockPointer = function (_Component) {
	  (0, _inherits3.default)(ClockPointer, _Component);
	
	  function ClockPointer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockPointer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockPointer.__proto__ || (0, _getPrototypeOf2.default)(ClockPointer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inner: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockPointer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(this.props)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(nextProps)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.value === null) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement('div', { style: prepareStyles(styles.mark) })
	      );
	    }
	  }]);
	  return ClockPointer;
	}(_react.Component);
	
	ClockPointer.defaultProps = {
	  hasSelected: false,
	  value: null,
	  type: 'minute'
	};
	ClockPointer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ClockPointer.propTypes = {
	  hasSelected: _react.PropTypes.bool,
	  type: _react.PropTypes.oneOf(['hour', 'minute']),
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = ClockPointer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var firstChild = props.firstChild,
	      lastChild = props.lastChild;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  var marginHorizontal = baseTheme.spacing.desktopGutter;
	  var marginVertical = (toolbar.height - button.height) / 2;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      marginLeft: firstChild ? -marginHorizontal : undefined,
	      marginRight: lastChild ? -marginHorizontal : undefined,
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'center'
	    },
	    dropDownMenu: {
	      root: {
	        color: toolbar.color, // removes hover color change, we want to keep it
	        marginRight: baseTheme.spacing.desktopGutter,
	        flex: 1,
	        whiteSpace: 'nowrap'
	      },
	      controlBg: {
	        backgroundColor: toolbar.menuHoverColor,
	        borderRadius: 0
	      },
	      underline: {
	        display: 'none'
	      }
	    },
	    button: {
	      margin: marginVertical + 'px ' + marginHorizontal + 'px',
	      position: 'relative'
	    },
	    icon: {
	      root: {
	        cursor: 'pointer',
	        lineHeight: toolbar.height + 'px',
	        paddingLeft: baseTheme.spacing.desktopGutter
	      }
	    },
	    span: {
	      color: toolbar.iconColor,
	      lineHeight: toolbar.height + 'px'
	    }
	  };
	
	  return styles;
	}
	
	var ToolbarGroup = function (_Component) {
	  (0, _inherits3.default)(ToolbarGroup, _Component);
	
	  function ToolbarGroup() {
	    (0, _classCallCheck3.default)(this, ToolbarGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarGroup.__proto__ || (0, _getPrototypeOf2.default)(ToolbarGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarGroup, [{
	    key: 'handleMouseLeaveFontIcon',
	    value: function handleMouseLeaveFontIcon(style) {
	      return function (event) {
	        event.target.style.zIndex = 'auto';
	        event.target.style.color = style.root.color;
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          firstChild = _props.firstChild,
	          lastChild = _props.lastChild,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (!currentChild) {
	          return null;
	        }
	        if (!currentChild.type) {
	          return currentChild;
	        }
	        switch (currentChild.type.muiName) {
	          case 'DropDownMenu':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
	              underlineStyle: styles.dropDownMenu.underline
	            });
	          case 'RaisedButton':
	          case 'FlatButton':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
	            });
	          case 'FontIcon':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
	              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
	              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
	            });
	          case 'ToolbarSeparator':
	          case 'ToolbarTitle':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
	            });
	          default:
	            return currentChild;
	        }
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        newChildren
	      );
	    }
	  }]);
	  return ToolbarGroup;
	}(_react.Component);
	
	ToolbarGroup.defaultProps = {
	  firstChild: false,
	  lastChild: false
	};
	ToolbarGroup.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ToolbarGroup.propTypes = {
	  /**
	   * Can be any node or number of nodes.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
	   * to prevent setting the left gap.
	   */
	  firstChild: _react.PropTypes.bool,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
	   * to prevent setting the right gap.
	   */
	  lastChild: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ToolbarGroup;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      backgroundColor: toolbar.separatorColor,
	      display: 'block',
	      height: baseTheme.spacing.desktopGutterMore,
	      marginLeft: baseTheme.spacing.desktopGutter,
	      width: 1
	    }
	  };
	}
	
	var ToolbarSeparator = function (_Component) {
	  (0, _inherits3.default)(ToolbarSeparator, _Component);
	
	  function ToolbarSeparator() {
	    (0, _classCallCheck3.default)(this, ToolbarSeparator);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarSeparator.__proto__ || (0, _getPrototypeOf2.default)(ToolbarSeparator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarSeparator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
	    }
	  }]);
	  return ToolbarSeparator;
	}(_react.Component);
	
	ToolbarSeparator.muiName = 'ToolbarSeparator';
	ToolbarSeparator.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ToolbarSeparator.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ToolbarSeparator;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      lineHeight: toolbar.height + 'px',
	      fontSize: toolbar.titleFontSize,
	      fontFamily: baseTheme.fontFamily,
	      position: 'relative',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    }
	  };
	}
	
	var ToolbarTitle = function (_Component) {
	  (0, _inherits3.default)(ToolbarTitle, _Component);
	
	  function ToolbarTitle() {
	    (0, _classCallCheck3.default)(this, ToolbarTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarTitle.__proto__ || (0, _getPrototypeOf2.default)(ToolbarTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          text = _props.text,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style', 'text']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        text
	      );
	    }
	  }]);
	  return ToolbarTitle;
	}(_react.Component);
	
	ToolbarTitle.muiName = 'ToolbarTitle';
	ToolbarTitle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ToolbarTitle.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The text to be displayed.
	   */
	  text: _react.PropTypes.string
	} : void 0;
	exports.default = ToolbarTitle;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _AutoLockScrolling = __webpack_require__(1037);
	
	var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var overlay = context.muiTheme.overlay;
	
	
	  var style = {
	    root: {
	      position: 'fixed',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: '-100%',
	      opacity: 0,
	      backgroundColor: overlay.backgroundColor,
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)
	
	      // Two ways to promote overlay to its own render layer
	      willChange: 'opacity',
	      transform: 'translateZ(0)',
	
	      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    }
	  };
	
	  if (props.show) {
	    (0, _simpleAssign2.default)(style.root, {
	      left: 0,
	      opacity: 1,
	      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    });
	  }
	
	  return style;
	}
	
	var Overlay = function (_Component) {
	  (0, _inherits3.default)(Overlay, _Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.refs.overlay.style.opacity = opacity;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoLockScrolling = _props.autoLockScrolling,
	          show = _props.show,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
	      );
	    }
	  }]);
	  return Overlay;
	}(_react.Component);
	
	Overlay.defaultProps = {
	  autoLockScrolling: true,
	  style: {},
	  transitionEnabled: true
	};
	Overlay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Overlay.propTypes = {
	  autoLockScrolling: _react.PropTypes.bool,
	  show: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  transitionEnabled: _react.PropTypes.bool
	} : void 0;
	exports.default = Overlay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(28);
	
	var _dom = __webpack_require__(419);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = function (_Component) {
	  (0, _inherits3.default)(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('touchstart', this.onClickAway);
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('touchstart', this.onClickAway);
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props,
	          open = _props.open,
	          render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('touchstart', this.onClickAway);
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('touchstart', _this2.onClickAway);
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        var layerElement = render();
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? RenderToLayer.propTypes = {
	  componentClickAway: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  render: _react.PropTypes.func.isRequired,
	  useLayerForClickAway: _react.PropTypes.bool
	} : void 0;
	exports.default = RenderToLayer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      zIndex = _context$muiTheme.zIndex,
	      tooltip = _context$muiTheme.tooltip;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: 2,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: 0.9,
	      transform: 'translate(0px, ' + offset + 'px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  (0, _inherits3.default)(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          horizontalPosition = _props.horizontalPosition,
	          label = _props.label,
	          show = _props.show,
	          touch = _props.touch,
	          verticalPosition = _props.verticalPosition,
	          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Tooltip.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  horizontalPosition: _react.PropTypes.oneOf(['left', 'right', 'center']),
	  label: _react.PropTypes.node.isRequired,
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  touch: _react.PropTypes.bool,
	  verticalPosition: _react.PropTypes.oneOf(['top', 'bottom'])
	} : void 0;
	exports.default = Tooltip;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(154);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toArray2 = __webpack_require__(326);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsTransitionGroup = __webpack_require__(166);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _dom = __webpack_require__(419);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(1039);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = (0, _toArray3.default)(_ref),
	      newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      return {
	        directionInvariant: true,
	        height: rippleSize,
	        width: rippleSize,
	        top: top,
	        left: left
	      };
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style;
	      var _state = this.state,
	          hasRipples = _state.hasRipples,
	          ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden',
	          pointerEvents: 'none'
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
	  abortOnScroll: _react.PropTypes.bool,
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TouchRipple;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _getMuiTheme = __webpack_require__(417);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuiThemeProvider = function (_Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? MuiThemeProvider.propTypes = {
	  children: _react.PropTypes.element,
	  muiTheme: _react.PropTypes.object
	} : void 0;
	exports.default = MuiThemeProvider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(154);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(935);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colorManipulator = __webpack_require__(85);
	
	var _lightBaseTheme = __webpack_require__(1046);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(1048);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(1064);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(1065);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(1068);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(1208);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(1047);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _lodash2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme,
	      spacing = _muiTheme.spacing,
	      fontFamily = _muiTheme.fontFamily,
	      palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _lodash2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: palette.canvasColor
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.disabledColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.alternateTextColor,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));
	
	  return muiTheme;
	}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(421);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(168);
	var assign = __webpack_require__(30);
	
	var ReactPropTypesSecret = __webpack_require__(282);
	var checkPropTypes = __webpack_require__(1070);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(115);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(62);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1146);
	var warning = __webpack_require__(19);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	  process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (process.env.NODE_ENV !== 'production') {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var LinkedValueUtils = __webpack_require__(286);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(79);
	
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (process.env.NODE_ENV !== 'production') {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ? process.env.NODE_ENV !== 'production' ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1101);
	
	var containsNode = __webpack_require__(893);
	var focusNode = __webpack_require__(379);
	var getActiveElement = __webpack_require__(380);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var DOMLazyTree = __webpack_require__(137);
	var DOMProperty = __webpack_require__(96);
	var React = __webpack_require__(146);
	var ReactBrowserEventEmitter = __webpack_require__(200);
	var ReactCurrentOwner = __webpack_require__(80);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMContainerInfo = __webpack_require__(1093);
	var ReactDOMFeatureFlags = __webpack_require__(1095);
	var ReactFeatureFlags = __webpack_require__(428);
	var ReactInstanceMap = __webpack_require__(167);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactMarkupChecksum = __webpack_require__(1115);
	var ReactReconciler = __webpack_require__(140);
	var ReactUpdateQueue = __webpack_require__(289);
	var ReactUpdates = __webpack_require__(79);
	
	var emptyObject = __webpack_require__(191);
	var instantiateReactComponent = __webpack_require__(439);
	var invariant = __webpack_require__(15);
	var setInnerHTML = __webpack_require__(204);
	var shouldUpdateReactComponent = __webpack_require__(296);
	var warning = __webpack_require__(19);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (process.env.NODE_ENV !== 'production') {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (process.env.NODE_ENV !== 'production') {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (process.env.NODE_ENV !== 'production') {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (process.env.NODE_ENV !== 'production') {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (process.env.NODE_ENV !== 'production') {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (process.env.NODE_ENV !== 'production') {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var React = __webpack_require__(146);
	
	var invariant = __webpack_require__(15);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(432);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(34);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(30);
	
	var ReactCompositeComponent = __webpack_require__(1090);
	var ReactEmptyComponent = __webpack_require__(427);
	var ReactHostComponent = __webpack_require__(429);
	
	var getNextDebugID = __webpack_require__(1205);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (process.env.NODE_ENV !== 'production') {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (process.env.NODE_ENV !== 'production') {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (process.env.NODE_ENV !== 'production') {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	var escapeTextContentForBrowser = __webpack_require__(203);
	var setInnerHTML = __webpack_require__(204);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(80);
	var REACT_ELEMENT_TYPE = __webpack_require__(1109);
	
	var getIteratorFn = __webpack_require__(1143);
	var invariant = __webpack_require__(15);
	var KeyEscapeUtils = __webpack_require__(285);
	var warning = __webpack_require__(19);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (process.env.NODE_ENV !== 'production') {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (process.env.NODE_ENV !== 'production') {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(83);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(46);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(300);
	
	var _ContextUtils = __webpack_require__(299);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(83);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(46);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(97);
	
	var _PatternUtils = __webpack_require__(143);
	
	var _InternalPropTypes = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(455);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(454);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1180);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(452);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(144);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1167);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1164);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1171);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1168);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1173);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(455);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(454);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(305);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(1072);
	
	var _runTransitionHook = __webpack_require__(305);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(145);
	
	var _PathUtils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(147),
	    _assign = __webpack_require__(30);
	
	var ReactNoopUpdateQueue = __webpack_require__(459);
	
	var canDefineProperty = __webpack_require__(208);
	var emptyObject = __webpack_require__(191);
	var invariant = __webpack_require__(15);
	var lowPriorityWarning = __webpack_require__(306);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (process.env.NODE_ENV !== 'production') {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(80);
	var ReactComponentTreeHook = __webpack_require__(53);
	var ReactElement = __webpack_require__(117);
	
	var checkReactTypeSpec = __webpack_require__(1203);
	
	var canDefineProperty = __webpack_require__(208);
	var getIteratorFn = __webpack_require__(460);
	var warning = __webpack_require__(19);
	var lowPriorityWarning = __webpack_require__(306);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function getSourceInfoErrorAddendum(elementProps) {
	  if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
	    var source = elementProps.__source;
	    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
	    var lineNumber = source.lineNumber;
	    return ' Check your code at ' + fileName + ':' + lineNumber + '.';
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	function getCurrentComponentErrorInfo(parentType) {
	  var info = getDeclarationErrorAddendum();
	
	  if (!info) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      info = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	  return info;
	}
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var memoizer = ownerHasKeyUseWarning.uniqueKey || (ownerHasKeyUseWarning.uniqueKey = {});
	
	  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
	  if (memoizer[currentComponentErrorInfo]) {
	    return;
	  }
	  memoizer[currentComponentErrorInfo] = true;
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  var childOwner = '';
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  process.env.NODE_ENV !== 'production' ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, ReactComponentTreeHook.getCurrentStackAddendum(element)) : void 0;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkReactTypeSpec(componentClass.propTypes, element.props, 'prop', name, element, null);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	    process.env.NODE_ENV !== 'production' ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
	  }
	}
	
	var ReactElementValidator = {
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	    if (!validType) {
	      if (typeof type !== 'function' && typeof type !== 'string') {
	        var info = '';
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	
	        var sourceInfo = getSourceInfoErrorAddendum(props);
	        if (sourceInfo) {
	          info += sourceInfo;
	        } else {
	          info += getDeclarationErrorAddendum();
	        }
	
	        info += ReactComponentTreeHook.getCurrentStackAddendum();
	
	        var currentSource = props !== null && props !== undefined && props.__source !== undefined ? props.__source : null;
	        ReactComponentTreeHook.pushNonStandardWarningStack(true, currentSource);
	        process.env.NODE_ENV !== 'production' ? warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', type == null ? type : typeof type, info) : void 0;
	        ReactComponentTreeHook.popNonStandardWarningStack();
	      }
	    }
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (process.env.NODE_ENV !== 'production') {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            lowPriorityWarning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	};
	
	module.exports = ReactElementValidator;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(19);
	
	function warnNoop(publicInstance, callerName) {
	  if (process.env.NODE_ENV !== 'production') {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	var createHelper = function createHelper(func, helperName) {
	  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (process.env.NODE_ENV !== 'production' && setDisplayName) {
	    var _ret = function () {
	      /* eslint-disable global-require */
	      var wrapDisplayName = __webpack_require__(1215).default;
	      /* eslint-enable global-require */
	
	      if (noArgs) {
	        return {
	          v: function v(BaseComponent) {
	            var Component = func(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          }
	        };
	      }
	
	      return {
	        v: function v() {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          return function (BaseComponent) {
	            var Component = func.apply(undefined, args)(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          };
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  return func;
	};
	
	exports.default = createHelper;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(268);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1227);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(467);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(54);
	var bind = __webpack_require__(311);
	var Axios = __webpack_require__(469);
	var defaults = __webpack_require__(210);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(308);
	axios.CancelToken = __webpack_require__(468);
	axios.isCancel = __webpack_require__(309);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(482);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(308);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(210);
	var utils = __webpack_require__(54);
	var InterceptorManager = __webpack_require__(470);
	var dispatchRequest = __webpack_require__(471);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(54);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(54);
	var transformData = __webpack_require__(474);
	var isCancel = __webpack_require__(309);
	var defaults = __webpack_require__(210);
	var isAbsoluteURL = __webpack_require__(478);
	var combineURLs = __webpack_require__(476);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 472 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(310);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(54);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(54);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 476 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(54);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 478 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(54);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(54);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(54);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 482 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AppContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(628);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _materialUi = __webpack_require__(1036);
	
	var _materialUi2 = _interopRequireDefault(_materialUi);
	
	var _MuiThemeProvider = __webpack_require__(416);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(417);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _antimatter = __webpack_require__(624);
	
	var _antimatter2 = _interopRequireDefault(_antimatter);
	
	var _reactTapEventPlugin = __webpack_require__(1192);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _auth = __webpack_require__(170);
	
	var authActionCreators = _interopRequireWildcard(_auth);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactTapEventPlugin2.default)();
	
	var allActionCreators = Object.assign({}, authActionCreators, cartActionCreators);
	
	var App = function (_React$Component) {
		_inherits(App, _React$Component);
	
		function App(props) {
			_classCallCheck(this, App);
	
			return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));
		}
	
		// getChildContext() {
		// 	return {
		// 		muiTheme: ThemeManager.getMuiTheme(SyncTheme),
		// 	};
		// }
	
	
		_createClass(App, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_MuiThemeProvider2.default,
					{ muiTheme: this.muiTheme },
					this.props.children
				);
			}
		}]);
	
		return App;
	}(_react2.default.Component);
	
	App.childContextTypes = {
		muiTheme: _react2.default.PropTypes.object
	};
	App.muiTheme = (0, _getMuiTheme2.default)(_antimatter2.default);
	exports.default = App;
	
	
	function mapStateToProps(state) {
		return {
			auth: state.auth
		};
	}
	
	var AppContainer = exports.AppContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(App);

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppHeaderWrapperContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _Header = __webpack_require__(544);
	
	var _Footer = __webpack_require__(517);
	
	var _Contact = __webpack_require__(498);
	
	var _RhinoAlert = __webpack_require__(487);
	
	var _RhinoAlert2 = _interopRequireDefault(_RhinoAlert);
	
	var _NotifyAlert = __webpack_require__(486);
	
	var _NotifyAlert2 = _interopRequireDefault(_NotifyAlert);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var AppHeaderWrapper = function (_React$Component) {
	  _inherits(AppHeaderWrapper, _React$Component);
	
	  function AppHeaderWrapper(props) {
	    _classCallCheck(this, AppHeaderWrapper);
	
	    var _this = _possibleConstructorReturn(this, (AppHeaderWrapper.__proto__ || Object.getPrototypeOf(AppHeaderWrapper)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(AppHeaderWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _context;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AppHeaderWrapper' },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_Header.HeaderContainer, null)
	        ),
	        _react2.default.createElement(
	          'main',
	          null,
	          this.props.children
	        ),
	        _react2.default.createElement(
	          'footer',
	          null,
	          _react2.default.createElement(_Footer.FooterContainer, null)
	        ),
	        _react2.default.createElement(_Contact.ContactContainer, null),
	        _react2.default.createElement(_RhinoAlert2.default, {
	          open: this.props.common.alertOpen,
	          alertText: this.props.common.alertText,
	          alertTheme: this.props.common.alertTheme,
	          alertNav: this.props.common.alertNav,
	          closeMethod: (_context = this.props).commonCloseAlert.bind(_context),
	          closeText: this.props.common.alertPrompt }),
	        _react2.default.createElement(_NotifyAlert2.default, {
	          open: this.props.common.notifyOpen,
	          closeMethod: (_context = this.props).commonCloseNotify.bind(_context) })
	      );
	    }
	  }]);
	
	  return AppHeaderWrapper;
	}(_react2.default.Component);
	
	exports.default = AppHeaderWrapper;
	
	
	function mapStateToProps(state) {
	  return {
	    common: state.common
	  };
	}
	
	var AppHeaderWrapperContainer = exports.AppHeaderWrapperContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(AppHeaderWrapper);

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EarringAlert = function (_React$Component) {
	  _inherits(EarringAlert, _React$Component);
	
	  // Available themes
	  // 'thankyou': Used after contact form - default
	  // 'visit': Used after schedule appointments
	
	  function EarringAlert(props) {
	    _classCallCheck(this, EarringAlert);
	
	    var _this = _possibleConstructorReturn(this, (EarringAlert.__proto__ || Object.getPrototypeOf(EarringAlert)).call(this, props));
	
	    _this.state = {
	      fullOpen: false,
	      open: false,
	      closing: false,
	      bodyTop: 0,
	      marginOffset: 0
	    };
	
	    // Bind event listeners
	    _this.adjustHeight = _this.adjustHeight.bind(_this);
	    _this.checkClick = _this.checkClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(EarringAlert, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.addEventListener('resize', this.adjustHeight, false);
	      document.addEventListener('click', this.checkClick, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.adjustHeight, false);
	      document.removeEventListener('click', this.checkClick, false);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.state.open !== nextProps.open) {
	        if (this.state.open && !nextProps.open && !this.state.closing) {
	          this.closeAlert();
	        }
	        if (nextProps.open) {
	          this.openAlert();
	        }
	      }
	    }
	  }, {
	    key: 'checkClick',
	    value: function checkClick(evt) {
	
	      if (this.state.fullOpen === true) {
	        var targetElement = evt.target;
	
	        do {
	          if (targetElement == this.alertBody) {
	            return;
	          }
	          targetElement = targetElement.parentNode;
	        } while (targetElement);
	
	        // This is a click outside, should close
	        this.props.closeMethod();
	      }
	    }
	  }, {
	    key: 'getAlertBody',
	    value: function getAlertBody() {
	      var alert = null;
	      var alerts = document.getElementsByClassName('alertBody');
	      for (var i = 0; i < alerts.length; i++) {
	        if (getComputedStyle(alerts[i], null).display === 'block') {
	          alert = alerts[i];
	          break;
	        }
	      }
	      return alert;
	    }
	  }, {
	    key: 'adjustHeight',
	    value: function adjustHeight() {
	      var foundAlert = this.getAlertBody();
	      if (foundAlert) {
	        var offset = (window.innerHeight - (foundAlert.offsetHeight + 128)) / 2;
	        this.setState({ marginOffset: offset > 0 ? offset + 'px' : 0 });
	      }
	    }
	  }, {
	    key: 'openAlert',
	    value: function openAlert() {
	      var _this2 = this;
	
	      this.setState({ open: true }, function () {
	        var alert = null;
	        do {
	          alert = _this2.getAlertBody();
	          setTimeout(function () {
	            if (alert) {
	              var offset = (window.innerHeight - (alert.offsetHeight + 128)) / 2;
	              _this2.setState({
	                bodyTop: '64px',
	                marginOffset: offset > 0 ? offset + 'px' : 0
	              });
	            }
	          }, 25);
	        } while (!alert);
	      });
	
	      setTimeout(function () {
	        _this2.setState({ fullOpen: true });
	      }, 400);
	    }
	  }, {
	    key: 'closeAlert',
	    value: function closeAlert() {
	      var _this3 = this;
	
	      this.setState({
	        fullOpen: false,
	        closing: true,
	        bodyTop: '0'
	      });
	      setTimeout(function () {
	        _this3.setState({
	          open: false,
	          closing: false
	        });
	      }, 400);
	    }
	  }, {
	    key: 'alertStyles',
	    value: function alertStyles() {
	      return {
	        display: this.state.open ? 'block' : 'none'
	      };
	    }
	  }, {
	    key: 'closeHandler',
	    value: function closeHandler() {
	      if (this.props.alertNav === null) {
	        this.props.closeMethod();
	      } else {
	        window.location.href = '/' + this.props.alertNav;
	      }
	    }
	  }, {
	    key: 'userNav',
	    value: function userNav(page) {
	      this.props.closeMethod();
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'ggEarringNav',
	    value: function ggEarringNav() {
	      window.location.href = 'https://gifts.diamondsdirect.com/';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this,
	          _context;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: this.state.closing ? 'EarringAlert RhinoAlert out' : 'EarringAlert RhinoAlert',
	          style: this.alertStyles() },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'alertBody',
	            ref: function ref(alertBody) {
	              _this4.alertBody = alertBody;
	            },
	            style: {
	              display: this.state.open ? 'block' : 'none',
	              top: this.state.bodyTop,
	              marginTop: this.state.marginOffset,
	              marginBottom: this.state.marginOffset === 0 ? '64px' : 0
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'closeIcon', onClick: (_context = this.props).closeMethod.bind(_context) },
	            _react2.default.createElement(
	              'div',
	              { className: 'closeX' },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'earringBackgroundWrapper' },
	            _react2.default.createElement('img', { className: 'desktopBackground', src: 'https://ddw2.diamondsdirect.com/img/alert/holiday-popup.jpg' }),
	            _react2.default.createElement('img', { className: 'mobileBackground', src: 'https://ddw2.diamondsdirect.com/img/alert/holiday-popup-mobile.jpg' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'holidayTextLink', onClick: function onClick() {
	                  return _this4.userNav('locations');
	                } },
	              'Click here for Locations'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'earringBannerButton shopStoreButton', onClick: function onClick() {
	                  return _this4.userNav('locations');
	                }, style: { display: 'none' } },
	              'Shop in Store'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'earringBannerButton shopOnlineButton', onClick: this.ggEarringNav.bind(this), style: { display: 'none' } },
	              'Shop Online'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EarringAlert;
	}(_react2.default.Component);
	
	EarringAlert.defaultProps = {};
	EarringAlert.propTypes = {
	  alertTheme: _react.PropTypes.string,
	  alertNav: _react.PropTypes.string,
	  closeMethod: _react.PropTypes.func.isRequired,
	  closeText: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired
	};
	exports.default = EarringAlert;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLazyLoadImageComponent = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotifyAlert = function (_React$Component) {
	  _inherits(NotifyAlert, _React$Component);
	
	  function NotifyAlert(props) {
	    _classCallCheck(this, NotifyAlert);
	
	    var _this = _possibleConstructorReturn(this, (NotifyAlert.__proto__ || Object.getPrototypeOf(NotifyAlert)).call(this, props));
	
	    _this.state = {
	      open: false,
	      closing: false,
	      bodyTop: 0,
	      marginOffset: 0
	    };
	
	    // Bind event listeners
	    _this.adjustHeight = _this.adjustHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(NotifyAlert, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.addEventListener('resize', this.adjustHeight, false);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.adjustHeight();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.adjustHeight, false);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.state.open !== nextProps.open) {
	        if (this.state.open && !nextProps.open && !this.state.closing) {
	          this.closeAlert();
	        }
	        if (nextProps.open) {
	          this.openAlert();
	        }
	      }
	    }
	  }, {
	    key: 'getAlertBody',
	    value: function getAlertBody() {
	      var alert = null;
	      var alerts = document.getElementsByClassName('alertBody');
	      for (var i = 0; i < alerts.length; i++) {
	        if (getComputedStyle(alerts[i], null).display === 'block') {
	          alert = alerts[i];
	          break;
	        }
	      }
	      return alert;
	    }
	  }, {
	    key: 'adjustHeight',
	    value: function adjustHeight() {
	
	      // Labor Day Image ~ square
	      var notifyHeight = window.innerWidth > 768 ? 500 : 357;
	      var offset = (window.innerHeight - notifyHeight) / 2;
	
	      // let foundAlert = this.getAlertBody();
	      // if(foundAlert) {
	      // let offset = (window.innerHeight - (foundAlert.offsetHeight)) / 2;
	      this.setState({ marginOffset: offset > 0 ? offset + 'px' : 0 });
	      // }
	    }
	  }, {
	    key: 'openAlert',
	    value: function openAlert() {
	      var _this2 = this;
	
	      this.setState({ open: true }, function () {
	        var alert = null;
	        do {
	          alert = _this2.getAlertBody();
	          setTimeout(function () {
	            if (alert) {
	              var alertHeight = window.innerWidth > 768 ? 500 : 357;
	              var offset = (window.innerHeight - alertHeight) / 2;
	              _this2.setState({
	                bodyTop: '0',
	                marginOffset: offset > 0 ? offset + 'px' : 0
	              });
	            }
	          }, 25);
	        } while (!alert);
	      });
	    }
	  }, {
	    key: 'closeAlert',
	    value: function closeAlert() {
	      var _this3 = this;
	
	      this.setState({
	        closing: true,
	        bodyTop: '0'
	      });
	      setTimeout(function () {
	        _this3.setState({
	          open: false,
	          closing: false
	        });
	      }, 400);
	    }
	  }, {
	    key: 'alertStyles',
	    value: function alertStyles() {
	      return {
	        display: this.state.open ? 'block' : 'none'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: this.state.closing ? 'RhinoAlert out' : 'RhinoAlert',
	          style: this.alertStyles() },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'alertBody notifyBody',
	            onClick: (_context = this.props).closeMethod.bind(_context),
	            style: {
	              display: this.state.open ? 'block' : 'none',
	              top: this.state.bodyTop,
	              marginTop: this.state.marginOffset,
	              marginBottom: this.state.marginOffset === 0 ? '64px' : 0
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'notifyImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/alert/Hurricane-Popup.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'notifyImgMobile' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/alert/hurricane_florence_mobile.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'closeIcon', onClick: (_context = this.props).closeMethod.bind(_context) },
	            _react2.default.createElement(
	              'div',
	              { className: 'closeX' },
	              '\xD7'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NotifyAlert;
	}(_react2.default.Component);
	
	NotifyAlert.defaultProps = {};
	NotifyAlert.propTypes = {
	  closeMethod: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool.isRequired
	};
	exports.default = NotifyAlert;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RhinoAlert = function (_React$Component) {
	  _inherits(RhinoAlert, _React$Component);
	
	  // Available themes
	  // 'thankyou': Used after contact form - default
	  // 'visit': Used after schedule appointments
	
	  function RhinoAlert(props) {
	    _classCallCheck(this, RhinoAlert);
	
	    var _this = _possibleConstructorReturn(this, (RhinoAlert.__proto__ || Object.getPrototypeOf(RhinoAlert)).call(this, props));
	
	    _this.state = {
	      open: false,
	      closing: false,
	      bodyTop: 0,
	      marginOffset: 0
	    };
	
	    // Bind event listeners
	    _this.adjustHeight = _this.adjustHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(RhinoAlert, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.addEventListener('resize', this.adjustHeight, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.adjustHeight, false);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.state.open !== nextProps.open) {
	        if (this.state.open && !nextProps.open && !this.state.closing) {
	          this.closeAlert();
	        }
	        if (nextProps.open) {
	          this.openAlert();
	        }
	      }
	    }
	  }, {
	    key: 'getAlertBody',
	    value: function getAlertBody() {
	      var alert = null;
	      var alerts = document.getElementsByClassName('alertBody');
	      for (var i = 0; i < alerts.length; i++) {
	        if (getComputedStyle(alerts[i], null).display === 'block') {
	          alert = alerts[i];
	          break;
	        }
	      }
	      return alert;
	    }
	  }, {
	    key: 'adjustHeight',
	    value: function adjustHeight() {
	      var foundAlert = this.getAlertBody();
	      if (foundAlert) {
	        var offset = (window.innerHeight - (foundAlert.offsetHeight + 128)) / 2;
	        this.setState({ marginOffset: offset > 0 ? offset + 'px' : 0 });
	      }
	    }
	  }, {
	    key: 'openAlert',
	    value: function openAlert() {
	      var _this2 = this;
	
	      this.setState({ open: true }, function () {
	        var alert = null;
	        do {
	          alert = _this2.getAlertBody();
	          setTimeout(function () {
	            if (alert) {
	              var offset = (window.innerHeight - (alert.offsetHeight + 128)) / 2;
	              _this2.setState({
	                bodyTop: '64px',
	                marginOffset: offset > 0 ? offset + 'px' : 0
	              });
	            }
	          }, 25);
	        } while (!alert);
	      });
	    }
	  }, {
	    key: 'closeAlert',
	    value: function closeAlert() {
	      var _this3 = this;
	
	      this.setState({
	        closing: true,
	        bodyTop: '0'
	      });
	      setTimeout(function () {
	        _this3.setState({
	          open: false,
	          closing: false
	        });
	      }, 400);
	    }
	  }, {
	    key: 'alertStyles',
	    value: function alertStyles() {
	      return {
	        display: this.state.open ? 'block' : 'none'
	      };
	    }
	  }, {
	    key: 'closeHandler',
	    value: function closeHandler() {
	      if (this.props.alertNav === null) {
	        this.props.closeMethod();
	      } else {
	        window.location.href = '/' + this.props.alertNav;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: this.state.closing ? 'RhinoAlert out' : 'RhinoAlert',
	          style: this.alertStyles() },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'alertBody',
	            style: {
	              display: this.state.open ? 'block' : 'none',
	              top: this.state.bodyTop,
	              marginTop: this.state.marginOffset,
	              marginBottom: this.state.marginOffset === 0 ? '64px' : 0
	            } },
	          this.props.alertTheme === null || this.props.alertTheme === 'default' ? null : null,
	          this.props.alertTheme === 'thankyou' ? _react2.default.createElement(
	            'div',
	            { className: 'thankYouImg' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/alert/bubble.svg' })
	          ) : null,
	          this.props.alertTheme === 'visit' ? _react2.default.createElement(
	            'div',
	            { className: 'alertContentWrapper visit' },
	            _react2.default.createElement(
	              'div',
	              { className: 'visitHeader' },
	              'We look forward to your visit!'
	            ),
	            _react2.default.createElement('div', { className: 'visitBr' })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: this.props.alertTheme === null ? 'alertText' : 'alertText ' + this.props.alertTheme },
	            this.props.alertText
	          ),
	          this.props.alertTheme === null || this.props.alertTheme === 'default' ? _react2.default.createElement(
	            'div',
	            { className: 'alertContentWrapper default' },
	            _react2.default.createElement('div', { className: 'defaultBr' })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'closeIcon', onClick: (_context = this.props).closeMethod.bind(_context) },
	            _react2.default.createElement(
	              'div',
	              { className: 'closeX' },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.props.alertTheme === null ? 'alertButton actionButton' : 'alertButton actionButton ' + this.props.alertTheme,
	              onClick: this.closeHandler.bind(this) },
	            this.props.closeText ? _react2.default.createElement(
	              'span',
	              null,
	              this.props.closeText
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              'OK'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RhinoAlert;
	}(_react2.default.Component);
	
	RhinoAlert.defaultProps = {};
	RhinoAlert.propTypes = {
	  alertText: _react.PropTypes.string.isRequired,
	  alertTheme: _react.PropTypes.string,
	  alertNav: _react.PropTypes.string,
	  closeMethod: _react.PropTypes.func.isRequired,
	  closeText: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired
	};
	exports.default = RhinoAlert;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RhinoCheckbox = function (_React$Component) {
	  _inherits(RhinoCheckbox, _React$Component);
	
	  function RhinoCheckbox(props) {
	    _classCallCheck(this, RhinoCheckbox);
	
	    var _this = _possibleConstructorReturn(this, (RhinoCheckbox.__proto__ || Object.getPrototypeOf(RhinoCheckbox)).call(this, props));
	
	    _this.state = {
	      selected: _this.props.selected
	    };
	    return _this;
	  }
	
	  _createClass(RhinoCheckbox, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.state.selected !== nextProps.selected) {
	        this.setState({ selected: nextProps.selected });
	      }
	    }
	  }, {
	    key: 'toggleCheckbox',
	    value: function toggleCheckbox() {
	      this.setState({ selected: !this.state.selected });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RhinoCheckbox' },
	        _react2.default.createElement(
	          'label',
	          { className: 'control control--checkbox' },
	          this.props.label,
	          _react2.default.createElement('input', {
	            type: 'checkbox',
	            disabled: this.props.disabled,
	            checked: this.state.selected,
	            onClick: this.toggleCheckbox.bind(this),
	            onChange: (_context = this.props).changeMethod.bind(_context),
	            value: this.props.value ? this.props.value : '' }),
	          _react2.default.createElement('div', { className: 'control__indicator' })
	        )
	      );
	    }
	  }]);
	
	  return RhinoCheckbox;
	}(_react2.default.Component);
	
	RhinoCheckbox.defaultProps = {
	  disabled: false,
	  label: '',
	  selected: false
	};
	RhinoCheckbox.propTypes = {
	  changeMethod: _react.PropTypes.func,
	  disabled: _react.PropTypes.bool,
	  label: _react.PropTypes.string,
	  selected: _react.PropTypes.bool
	};
	exports.default = RhinoCheckbox;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AboutUsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactMailto = __webpack_require__(142);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var AboutUs = function (_React$Component) {
		_inherits(AboutUs, _React$Component);
	
		function AboutUs(props) {
			_classCallCheck(this, AboutUs);
	
			var _this = _possibleConstructorReturn(this, (AboutUs.__proto__ || Object.getPrototypeOf(AboutUs)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(AboutUs, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				document.title = 'Diamonds Direct | Our Story';
				document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'userNav',
			value: function userNav(page) {
				// this.context.router.push('/' + page);
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'storeNav',
			value: function storeNav(page) {
				// this.context.router.push('/' + page);
				window.location.href = '/' + page;
			}
		}, {
			key: 'jaxNav',
			value: function jaxNav() {
				var win = window.open('http://globaldiamondsusa.com/', '_blank');
				win.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'AboutUs' },
					_react2.default.createElement('img', { src: 'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=misc&pixid=4b33c0b1-6c94-4f15-9e92-13ad551a541e', width: '1', height: '1' }),
					_react2.default.createElement(
						'div',
						{ className: 'aboutNumbers fullWidth' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/outlined/numbersanddiamonds.svg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'aboutConception partialWidth' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/outlined/concept.svg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'aboutYears partialWidth' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/outlined/60years.svg' }),
						_react2.default.createElement(
							'div',
							{ className: 'heritageButton aboutButton', onClick: function onClick() {
									return _this2.userNav('our-heritage');
								} },
							_react2.default.createElement(
								'div',
								{ className: 'aboutButtonText' },
								'Our Heritage'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'aboutChoic partialWidth' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/outlined/choice.svg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'aboutConfidenceTitle partialWidth' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/outlined/confidence_title.svg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'aboutConfidence partialWidth' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/outlined/confidence.svg' }),
						_react2.default.createElement(
							'div',
							{ className: 'guaranteeButton aboutButton', onClick: function onClick() {
									return _this2.userNav('our-guarantees');
								} },
							_react2.default.createElement(
								'div',
								{ className: 'aboutButtonText' },
								'Learn More'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'aboutCommunity fullWidth' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/community25.svg' }),
						_react2.default.createElement(
							'div',
							{ className: 'mapOverlay' },
							_react2.default.createElement(
								'div',
								{ id: 'marker-austin', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('austin');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Austin,\xA0TX'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-birmingham', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('birmingham');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Birmingham,\xA0AL'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-charleston', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('charleston');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Charleston,\xA0SC'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-clt', className: 'map-location-wrapper double-wrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Charlotte,\xA0NC'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-columbus', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('columbus');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Columbus, OH'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-dallas', className: "map-location-wrapper double-wrapper" },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ onClick: function onClick() {
												return _this2.storeNav('dallas');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'store-name' },
											'Dallas,\xA0TX'
										),
										_react2.default.createElement(
											'div',
											{ className: 'store-link' },
											'Visit\xA0Store\xA0Page'
										)
									),
									_react2.default.createElement('div', { className: 'horizontal-rule' }),
									_react2.default.createElement(
										'div',
										{ onClick: function onClick() {
												return _this2.storeNav('frisco');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'store-name' },
											'Frisco,\xA0TX'
										),
										_react2.default.createElement(
											'div',
											{ className: 'store-link' },
											'Visit\xA0Store\xA0Page'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-indy', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('indianapolis');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Indianapolis, IN'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-okc', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('oklahoma-city');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Oklahoma City, OK'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-raleigh', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('raleigh');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Raleigh,\xA0NC'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-richmond', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('richmond');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Richmond,\xA0VA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-stl', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('st-louis');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'St.\xA0Louis,\xA0MO'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-san', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('san-antonio');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'San\xA0Antonio,\xA0TX'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-vab', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('virginia-beach');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Virginia\xA0Beach,\xA0VA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-globaldiamonds', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('jacksonville');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Jacksonville,\xA0FL'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-kcy', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('kansas-city');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Kansas\xA0City,\xA0KS'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-cle', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('cleveland');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Cleveland,\xA0OH'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-nol', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('new-orleans');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'New\xA0Orleans,\xA0LA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-boc', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('boca-raton');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Boca\xA0Raton,\xA0FL'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-try', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('troy');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Troy,\xA0MI'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-hou', className: "map-location-wrapper double-wrapper" },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ onClick: function onClick() {
												return _this2.storeNav('baybrook');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'store-name' },
											'Houston,\xA0TX\xA0(Baybrook)'
										),
										_react2.default.createElement(
											'div',
											{ className: 'store-link' },
											'Visit\xA0Store\xA0Page'
										)
									),
									_react2.default.createElement('div', { className: 'horizontal-rule' }),
									_react2.default.createElement(
										'div',
										{ onClick: function onClick() {
												return _this2.storeNav('houston');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'store-name' },
											'Houston,\xA0TX\xA0(Galleria)'
										),
										_react2.default.createElement(
											'div',
											{ className: 'store-link' },
											'Visit\xA0Store\xA0Page'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-pit', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('pittsburgh');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Pittsburgh,\xA0PA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-gsc', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('greenville');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Greenville,\xA0SC'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-cle', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('cleveland');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Cleveland,\xA0OH'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-nva', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('tysons');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Tysons,\xA0VA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'locateStoreButton aboutButton', onClick: function onClick() {
									return _this2.userNav('locations');
								} },
							_react2.default.createElement(
								'div',
								{ className: 'aboutButtonText' },
								'Visit Us'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'joinTeamButton aboutButton', onClick: function onClick() {
									return _this2.internalNav('careers');
								} },
							_react2.default.createElement(
								'div',
								{ className: 'aboutButtonText' },
								'Join Our Team'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'aboutSocial partialWidth' },
						_react2.default.createElement(
							'div',
							{ className: 'socialWrapper desktopOnly' },
							_react2.default.createElement(
								'div',
								{ className: 'socialLHS' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/social/socialL.jpg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'socialRHS' },
								_react2.default.createElement(
									'div',
									{ className: 'rhsWrapper' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/social/social1.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'rhsWrapper' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/social/social2.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'rhsWrapper' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/social/social3.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'rhsWrapper' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/social/social4.jpg' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'mobileSocialWrapper mobileOnly' },
							_react2.default.createElement(
								'div',
								{ className: 'mobSocialImg' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/social/socialL.jpg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'mobSocialImg' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/social/social1.jpg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'mobSocialImg' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/social/social2.jpg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'mobSocialImg' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/social/social3.jpg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'mobSocialImg' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/social/social4.jpg' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'visitUsButton aboutButton', onClick: function onClick() {
									return _this2.userNav('locations');
								} },
							_react2.default.createElement(
								'div',
								{ className: 'aboutButtonText' },
								'Visit Us'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'aboutDonated fullWidth' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/aboutus/outlined/community_donations.svg' }),
						_react2.default.createElement(
							'div',
							{ className: 'foundationButton aboutButton', onClick: function onClick() {
									return _this2.userNav('our-foundation');
								} },
							_react2.default.createElement(
								'div',
								{ className: 'aboutButtonText' },
								'Learn More'
							)
						)
					)
				);
			}
		}]);
	
		return AboutUs;
	}(_react2.default.Component);
	
	AboutUs.propTypes = {
		location: _react.PropTypes.object
	};
	AboutUs.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = AboutUs;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var AboutUsContainer = exports.AboutUsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(AboutUs);

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _auth = __webpack_require__(88);
	
	var _auth2 = __webpack_require__(170);
	
	var authActionCreators = _interopRequireWildcard(_auth2);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	var _AccountInfo = __webpack_require__(492);
	
	var _AccountWishlist = __webpack_require__(494);
	
	var _AccountOrders = __webpack_require__(493);
	
	var _AccountAppointment = __webpack_require__(491);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, authActionCreators, userActionCreators);
	
	var Account = function (_React$Component) {
	  _inherits(Account, _React$Component);
	
	  function Account(props) {
	    _classCallCheck(this, Account);
	
	    var _this = _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).call(this, props));
	
	    var tabData = [{
	      display: 'Online Account Info',
	      value: 'accountInfo'
	    }, {
	      display: 'Online Wishlist',
	      value: 'wishlist'
	    },
	    // {
	    //   display: 'Open Orders',
	    //   value: 'openOrders'
	    // },
	    {
	      display: 'Online History',
	      value: 'orderHistory'
	    }, {
	      display: 'Request an Appointment',
	      value: 'appointments'
	    }, {
	      display: 'Log Out',
	      value: 'logout'
	    }];
	
	    _this.state = {
	      currentTab: 'accountInfo',
	      firstName: null,
	      mobileTabData: tabData
	    };
	
	    return _this;
	  }
	
	  _createClass(Account, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.user.userCore === null && (0, _auth.isLoggedIn)()) {
	        this.props.userGetUser().then(function (resp) {
	          _this2.props.userSaveCore(resp);
	          _this2.setFirstName(resp.firstname);
	          _this2.props.userGetOrders(resp.id).then(function (orderResp) {
	            _this2.props.userSaveOrders(JSON.parse(orderResp).orders);
	          });
	        });
	      } else {
	        this.props.userGetOrders(this.props.user.userCore.id).then(function (resp) {
	          console.log(JSON.parse(resp));
	          _this2.props.userSaveOrders(JSON.parse(resp).orders);
	        });
	      }
	
	      if (this.props.user.userProfile === null && (0, _auth.isLoggedIn)()) {
	        this.props.userGetProfile().then(function (resp) {
	          _this2.props.userSaveProfile(resp);
	
	          // if(resp.customer.access_orders_history || resp.customer.access_orders_open) {
	
	          //   console.log('get userGetExternalOrders');
	
	          //   this.props.userGetExternalOrders()
	          //   .then((orderResp) => {
	          //     console.log(orderResp.orders);
	          //     this.props.userSaveExternalOrders(orderResp.orders);
	          //   });
	          // }
	        });
	      } else if (this.props.user.userProfile && (this.props.user.userProfile.customer.access_orders_history || this.props.user.userProfile.customer.access_orders_open)) {
	
	        // this.props.userGetExternalOrders()
	        // .then((orderResp) => {
	        //   console.log(orderResp.orders);
	        //   this.props.userSaveExternalOrders(orderResp.orders);
	        // });
	      }
	
	      if (this.props.user.wishlists === null && (0, _auth.isLoggedIn)()) {
	        this.props.userGetWishlists().then(function (respData) {
	          // console.log(this.props);
	          _this2.props.userSaveWishlists(respData.wishlists);
	        });
	      }
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(tab) {
	      if (tab != this.state.currentTab) {
	        this.setState({ currentTab: tab });
	      }
	    }
	  }, {
	    key: 'selectTabFromDropdown',
	    value: function selectTabFromDropdown(evt) {
	      var tab = evt.target.value;
	
	      if (tab == 'logout') {
	        this.logoutUser();
	      } else if (tab != this.state.currentTab) {
	        this.setState({ currentTab: tab });
	      }
	    }
	  }, {
	    key: 'logoutUser',
	    value: function logoutUser() {
	      (0, _auth.logout)();
	      this.props.authClear();
	      window.location.href = '/';
	    }
	  }, {
	    key: 'setFirstName',
	    value: function setFirstName(name) {
	      this.setState({ firstName: name });
	    }
	  }, {
	    key: 'renderAccountBody',
	    value: function renderAccountBody() {
	      var _this3 = this;
	
	      if (this.state.currentTab == 'accountInfo') {
	        return _react2.default.createElement(_AccountInfo.AccountInfoContainer, { setFirstNameMethod: function setFirstNameMethod(val) {
	            return _this3.setFirstName(val);
	          } });
	      } else if (this.state.currentTab == 'wishlist') {
	        return _react2.default.createElement(_AccountWishlist.AccountWishlistContainer, null);
	      } else if (this.state.currentTab == 'openOrders') {
	        return _react2.default.createElement(_AccountOrders.AccountOrdersContainer, { openOrders: true });
	      } else if (this.state.currentTab == 'orderHistory') {
	        return _react2.default.createElement(_AccountOrders.AccountOrdersContainer, { showAll: true });
	      } else if (this.state.currentTab == 'appointments') {
	        return _react2.default.createElement(_AccountAppointment.AccountAppointmentContainer, null);
	      } else {
	        return _react2.default.createElement(_AccountInfo.AccountInfoContainer, { setFirstNameMethod: function setFirstNameMethod(val) {
	            return _this3.setFirstName(val);
	          } });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Account' },
	        _react2.default.createElement(
	          'div',
	          { className: 'accountMenu' },
	          _react2.default.createElement(
	            'div',
	            { className: 'accountMenuWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'accountMenuHeader' },
	              this.state.firstName === null || this.state.firstName === '' ? _react2.default.createElement(
	                'div',
	                { className: 'accountMenuTitle' },
	                'Hello!'
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'accountMenuTitle' },
	                'Hello, ',
	                this.state.firstName,
	                '!'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'accountMenuSubtitle' },
	                'Welcome to your online account dashboard'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'accountItemWrapper' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: this.state.currentTab == 'accountInfo' ? 'accountItem selected' : 'accountItem',
	                  onClick: function onClick() {
	                    return _this4.selectTab('accountInfo');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'accountLabel accountInfoItem' },
	                  'Online Account Info'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: this.state.currentTab == 'wishlist' ? 'accountItem selected' : 'accountItem',
	                  onClick: function onClick() {
	                    return _this4.selectTab('wishlist');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'accountLabel wishlistItem' },
	                  'Online Wishlist'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: this.state.currentTab == 'openOrders' ? 'accountItem selected' : 'accountItem',
	                  onClick: function onClick() {
	                    return _this4.selectTab('openOrders');
	                  },
	                  style: { display: 'none' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'accountLabel openOrdersItem' },
	                  'Open Orders'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: this.state.currentTab == 'orderHistory' ? 'accountItem selected' : 'accountItem',
	                  onClick: function onClick() {
	                    return _this4.selectTab('orderHistory');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'accountLabel orderHistoryItem' },
	                  'Online Orders'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: this.state.currentTab == 'appointments' ? 'accountItem selected' : 'accountItem',
	                  onClick: function onClick() {
	                    return _this4.selectTab('appointments');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'accountLabel appointmentItem' },
	                  'Request an Appointment'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'accountItem',
	                  onClick: this.logoutUser.bind(this) },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'accountLabel logoutItem' },
	                  'Log Out'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'accountItemDropdownWrapper' },
	              _react2.default.createElement(_RhinoSelect2.default, {
	                selectClass: 'scheduleSelect',
	                options: this.state.mobileTabData,
	                value: this.state.currentTab,
	                changeMethod: function changeMethod(evt) {
	                  return _this4.selectTabFromDropdown(evt);
	                } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.currentTab == 'accountInfo' ? 'accountBody infoBody' : 'accountBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'accountBodyWrapper' },
	            this.renderAccountBody()
	          )
	        )
	      );
	    }
	  }]);
	
	  return Account;
	}(_react2.default.Component);
	
	Account.propTypes = {
	  location: _react.PropTypes.object
	};
	Account.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Account;
	
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	}
	
	var AccountContainer = exports.AccountContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Account);

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountAppointmentContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _ScheduleShoppingForm = __webpack_require__(218);
	
	var _ScheduleServiceForm = __webpack_require__(217);
	
	var _ContactPage = __webpack_require__(312);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import {nameValidation, phoneValidation, emailValidation, passwordValidation, dateValidation, dateNoYearValidation, zipValidation} from '../../../../utils/itemValidation';
	// import {displayPhone, displayPhoneInput, displayDate, displayDateInput, displayDateNoYear, displayDateNoYearInput, stringToDigits, formatDropdownData} from '../../../../utils/formatting';
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var AccountAppointment = function (_React$Component) {
	  _inherits(AccountAppointment, _React$Component);
	
	  function AccountAppointment(props) {
	    _classCallCheck(this, AccountAppointment);
	
	    var _this = _possibleConstructorReturn(this, (AccountAppointment.__proto__ || Object.getPrototypeOf(AccountAppointment)).call(this, props));
	
	    _this.state = {
	      selectedForm: null
	    };
	    return _this;
	  }
	
	  _createClass(AccountAppointment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'selectShop',
	    value: function selectShop() {
	      this.setState({ selectedForm: 'SHOP' });
	    }
	  }, {
	    key: 'selectService',
	    value: function selectService() {
	      this.setState({ selectedForm: 'SERVICE' });
	    }
	  }, {
	    key: 'selectVirtual',
	    value: function selectVirtual() {
	      this.setState({ selectedForm: 'VIRTUAL' });
	    }
	  }, {
	    key: 'closeAllForms',
	    value: function closeAllForms() {
	      this.setState({ selectedForm: null });
	    }
	  }, {
	    key: 'scrollDown',
	    value: function scrollDown() {
	      (0, _reactScrollToComponent2.default)(this.formWrapper, {
	        offset: -100,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'renderSelectView',
	    value: function renderSelectView() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ScheduleAppointment' },
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleBody topSpacing' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sbText desktop600' },
	            'Our promise to you is the very best diamond education, personal guidance, and customer service in the industry.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbText mobile600' },
	            'Our promise to you is the very best diamond education, personal guidance, and customer service in the industry.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbPrompt' },
	            'Select a Service'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbButtonRow', ref: function ref(div) {
	                _this2.buttonRow = div;
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.selectedForm === 'SHOP' ? 'sbButton selected' : 'sbButton', onClick: this.selectShop.bind(this) },
	              _react2.default.createElement('div', { className: 'sbButtonIcon jewelryIcon' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'sbButtonLabel' },
	                'Shop\xA0In\xA0Store'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.selectedForm === 'SERVICE' ? 'sbButton selected' : 'sbButton', onClick: this.selectService.bind(this) },
	              _react2.default.createElement('div', { className: 'sbButtonIcon bellIcon' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'sbButtonLabel' },
	                'Service\xA0and\xA0Repairs'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.selectedForm === 'VIRTUAL' ? 'sbButton selected' : 'sbButton', onClick: this.selectVirtual.bind(this) },
	              _react2.default.createElement('div', { className: 'sbButtonIcon virtualIcon' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'sbButtonLabel' },
	                'Virtual\xA0Appointments'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbText' },
	            'If you prefer to bypass the form, you can contact the store nearest you by ',
	            _react2.default.createElement(
	              'span',
	              { className: 'inlineLink', onClick: function onClick() {
	                  return _this2.internalNav('locations');
	                } },
	              'clicking here'
	            ),
	            ' or contact us at ',
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:8008855050', className: 'inlineLink' },
	              '(800) 885-5050'
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'scheduleFooterSpacer' })
	      );
	    }
	  }, {
	    key: 'renderShopForm',
	    value: function renderShopForm() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ScheduleAppointment' },
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sbFormWrapper', ref: function ref(div) {
	                _this3.formWrapper = div;
	              } },
	            _react2.default.createElement(_ScheduleShoppingForm.ScheduleShoppingFormContainer, { closeMethod: this.closeAllForms.bind(this) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'sbFormClose', onClick: this.closeAllForms.bind(this) },
	              'Back <'
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'scheduleFooterSpacer' })
	      );
	    }
	  }, {
	    key: 'renderServiceForm',
	    value: function renderServiceForm() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ScheduleAppointment' },
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sbFormWrapper', ref: function ref(div) {
	                _this4.formWrapper = div;
	              } },
	            _react2.default.createElement(_ScheduleServiceForm.ScheduleServiceFormContainer, { closeMethod: this.closeAllForms.bind(this) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'sbFormClose', onClick: this.closeAllForms.bind(this) },
	              'Back <'
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'scheduleFooterSpacer' })
	      );
	    }
	  }, {
	    key: 'renderVirtualForm',
	    value: function renderVirtualForm() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ScheduleAppointment' },
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sbFormWrapper', ref: function ref(div) {
	                _this5.formWrapper = div;
	              } },
	            _react2.default.createElement(_ContactPage.ContactPageContainer, null),
	            _react2.default.createElement(
	              'div',
	              { className: 'sbFormClose', onClick: this.closeAllForms.bind(this) },
	              'Back <'
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'scheduleFooterSpacer' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AccountAppointment', ref: function ref(div) {
	            _this6.parentForm = div;
	          } },
	        this.state.selectedForm === null ? this.renderSelectView() : null,
	        this.state.selectedForm === 'SHOP' ? this.renderShopForm() : null,
	        this.state.selectedForm === 'SERVICE' ? this.renderServiceForm() : null,
	        this.state.selectedForm === 'VIRTUAL' ? this.renderVirtualForm() : null
	      );
	    }
	  }]);
	
	  return AccountAppointment;
	}(_react2.default.Component);
	
	AccountAppointment.propTypes = {
	  location: _react.PropTypes.object
	};
	AccountAppointment.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = AccountAppointment;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var AccountAppointmentContainer = exports.AccountAppointmentContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(AccountAppointment);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountInfoContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _itemValidation = __webpack_require__(17);
	
	var _formatting = __webpack_require__(21);
	
	var _ringsizes = __webpack_require__(153);
	
	var _states = __webpack_require__(614);
	
	var _locations = __webpack_require__(220);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators, userActionCreators);
	
	var AccountInfo = function (_React$Component) {
	  _inherits(AccountInfo, _React$Component);
	
	  function AccountInfo(props) {
	    _classCallCheck(this, AccountInfo);
	
	    var _this = _possibleConstructorReturn(this, (AccountInfo.__proto__ || Object.getPrototypeOf(AccountInfo)).call(this, props));
	
	    var ringLabel = [{
	      display: 'Size',
	      value: ''
	    }];
	
	    var fingerLabel = [{
	      display: 'Finger',
	      value: ''
	    }];
	
	    // let phoneVal = '';
	    // if(this.props.user.userCore && this.props.user.userCore.addresses && this.props.user.userCore.addresses.length > 0) {
	    //   phoneVal = this.props.user.userCore.addresses[0].telephone;
	    // }
	
	    _this.state = {
	
	      stateDropdownData: (0, _formatting.formatDropdownData)(_states.states, 'name', 'abbreviation', 'State'),
	      locationDropdownData: (0, _formatting.formatDropdownData)(_locations.locations, 'name', 'number', 'Select Location'),
	
	      nameOpen: false,
	      firstName: _this.props.user.userCore && _this.props.user.userCore.firstname ? _this.props.user.userCore.firstname : '',
	      firstNameError: null,
	      lastName: _this.props.user.userCore && _this.props.user.userCore.lastname ? _this.props.user.userCore.lastname : '',
	      lastNameError: null,
	
	      phone: _this.props.user.userProfile && _this.props.user.userProfile.customer && _this.props.user.userProfile.customer.phone ? _this.props.user.userProfile.customer.phone : '',
	      phoneError: null,
	      phoneOpen: false,
	
	      email: _this.props.user.userCore && _this.props.user.userCore.email ? _this.props.user.userCore.email : '',
	      emailError: null,
	      emailOpen: false,
	
	      birthday: _this.props.user.userProfile && _this.props.user.userProfile.customer && _this.props.user.userProfile.customer.date_of_birth ? (0, _formatting.formatDbDate)(_this.props.user.userProfile.customer.date_of_birth) : '',
	      birthdayError: null,
	      birthdayOpen: false,
	
	      soNameOpen: false,
	      soFirstName: _this.props.user.userProfile && _this.props.user.userProfile.spouses && _this.props.user.userProfile.spouses[0] && _this.props.user.userProfile.spouses[0].first_name ? _this.props.user.userProfile.spouses[0].first_name : '',
	      soFirstNameError: null,
	      soLastName: _this.props.user.userProfile && _this.props.user.userProfile.spouses && _this.props.user.userProfile.spouses[0] && _this.props.user.userProfile.spouses[0].last_name ? _this.props.user.userProfile.spouses[0].last_name : '',
	      soLastNameError: null,
	
	      soEmail: _this.props.user.userProfile && _this.props.user.userProfile.spouses && _this.props.user.userProfile.spouses[0] && _this.props.user.userProfile.spouses[0].email ? _this.props.user.userProfile.spouses[0].email : '',
	      soEmailError: null,
	      soEmailOpen: false,
	
	      soBirthday: _this.props.user.userProfile && _this.props.user.userProfile.spouses && _this.props.user.userProfile.spouses[0] && _this.props.user.userProfile.spouses[0].birthdate ? (0, _formatting.formatDbDate)(_this.props.user.userProfile.spouses[0].birthdate) : '',
	      soBirthdayError: null,
	      soBirthdayOpen: false,
	
	      anniversary: _this.props.user.userProfile && _this.props.user.userProfile.customer && _this.props.user.userProfile.customer.anniversary_date ? (0, _formatting.formatDbDate)(_this.props.user.userProfile.customer.anniversary_date) : '',
	      anniversaryError: null,
	      anniversaryOpen: false,
	
	      ringSize: _this.props.user.userProfile && _this.props.user.userProfile.ringSizes ? _this.props.user.userProfile.ringSizes : [],
	      ringSizeOpen: false,
	      ringSizeData: ringLabel.concat(_ringsizes.ringSizes),
	      ringFingerData: fingerLabel.concat(_ringsizes.ringFingers),
	
	      homeAddressId: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[0] && _this.props.user.userProfile.addresses[0].id ? _this.props.user.userProfile.addresses[0].id : null,
	      homeAddressStreet1: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[0] && _this.props.user.userProfile.addresses[0].street1 ? _this.props.user.userProfile.addresses[0].street1 : '',
	      homeAddressStreet2: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[0] && _this.props.user.userProfile.addresses[0].street2 ? _this.props.user.userProfile.addresses[0].street2 : '',
	      homeAddressCity: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[0] && _this.props.user.userProfile.addresses[0].city ? _this.props.user.userProfile.addresses[0].city : '',
	      homeAddressState: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[0] && _this.props.user.userProfile.addresses[0].state ? _this.props.user.userProfile.addresses[0].state : '',
	      homeAddressZip: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[0] && _this.props.user.userProfile.addresses[0].zipcode ? _this.props.user.userProfile.addresses[0].zipcode : '',
	      homeAddressStreet1Error: null,
	      homeAddressStreet2Error: null,
	      homeAddressCityError: null,
	      homeAddressStateError: null,
	      homeAddressZipError: null,
	      homeAddressOpen: false,
	
	      shippingAddressId: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[1] && _this.props.user.userProfile.addresses[1].id ? _this.props.user.userProfile.addresses[1].id : null,
	      shippingAddressStreet1: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[1] && _this.props.user.userProfile.addresses[1].street1 ? _this.props.user.userProfile.addresses[1].street1 : '',
	      shippingAddressStreet2: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[1] && _this.props.user.userProfile.addresses[1].street2 ? _this.props.user.userProfile.addresses[1].street2 : '',
	      shippingAddressCity: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[1] && _this.props.user.userProfile.addresses[1].city ? _this.props.user.userProfile.addresses[1].city : '',
	      shippingAddressState: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[1] && _this.props.user.userProfile.addresses[1].state ? _this.props.user.userProfile.addresses[1].state : '',
	      shippingAddressZip: _this.props.user.userProfile && _this.props.user.userProfile.addresses && _this.props.user.userProfile.addresses[1] && _this.props.user.userProfile.addresses[1].zipcode ? _this.props.user.userProfile.addresses[1].zipcode : '',
	      shippingAddressStreet1Error: null,
	      shippingAddressStreet2Error: null,
	      shippingAddressCityError: null,
	      shippingAddressStateError: null,
	      shippingAddressZipError: null,
	      shippingAddressOpen: false,
	
	      localStore: _this.props.user.userProfile && _this.props.user.userProfile.customer && _this.props.user.userProfile.customer.store_number ? _this.props.user.userProfile.customer.store_number : '',
	      localStoreOpen: false,
	
	      oldPassword: '',
	      newPassword1: '',
	      newPassword2: '',
	      passwordError: false,
	      passwordOpen: false,
	      passwordReset: false,
	
	      optIn: true
	    };
	    return _this;
	  }
	
	  _createClass(AccountInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setFirstNameMethod(this.state.firstName);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.user.userCore === null && this.props.user.userCore != null) {
	
	        this.setState({
	          firstName: this.props.user.userCore.firstname,
	          lastName: this.props.user.userCore.lastname,
	          email: this.props.user.userCore.email
	        });
	      }
	
	      if (prevProps.user.userProfile === null && this.props.user.userProfile != null) {
	
	        var phoneVal = '';
	
	        var homeAddressId = null;
	        var homeAddressStreet1 = '';
	        var homeAddressStreet2 = '';
	        var homeAddressCity = '';
	        var homeAddressState = '';
	        var homeAddressZip = '';
	
	        var shippingAddressId = null;
	        var shippingAddressStreet1 = '';
	        var shippingAddressStreet2 = '';
	        var shippingAddressCity = '';
	        var shippingAddressState = '';
	        var shippingAddressZip = '';
	
	        console.log(this.props.user.userProfile.addresses);
	
	        if (this.props.user.userProfile.addresses && this.props.user.userProfile.addresses.length > 0) {
	          console.log('have addresses!');
	
	          for (var i = 0; i < this.props.user.userProfile.addresses.length; i++) {
	
	            // Right now, only support / look at first two addresses
	            if (i >= 2) {
	              break;
	            }
	
	            // TODO: add address type
	            // Home address
	            if (i === 0) {
	              homeAddressId = this.props.user.userProfile.addresses[i].id ? this.props.user.userProfile.addresses[i].id : null;
	              homeAddressStreet1 = this.props.user.userProfile.addresses[i].street1 ? this.props.user.userProfile.addresses[i].street1 : '';
	              homeAddressStreet2 = this.props.user.userProfile.addresses[i].street2 ? this.props.user.userProfile.addresses[i].street2 : '';
	              homeAddressCity = this.props.user.userProfile.addresses[i].city ? this.props.user.userProfile.addresses[i].city : '';
	              homeAddressState = this.props.user.userProfile.addresses[i].state ? this.props.user.userProfile.addresses[i].state : '';
	              homeAddressZip = this.props.user.userProfile.addresses[i].zipcode ? this.props.user.userProfile.addresses[i].zipcode : '';
	            }
	
	            // Shipping address
	            if (i === 1) {
	              shippingAddressId = this.props.user.userProfile.addresses[i].id ? this.props.user.userProfile.addresses[i].id : null;
	              shippingAddressStreet1 = this.props.user.userProfile.addresses[i].street1 ? this.props.user.userProfile.addresses[i].street1 : '';
	              shippingAddressStreet2 = this.props.user.userProfile.addresses[i].street2 ? this.props.user.userProfile.addresses[i].street2 : '';
	              shippingAddressCity = this.props.user.userProfile.addresses[i].city ? this.props.user.userProfile.addresses[i].city : '';
	              shippingAddressState = this.props.user.userProfile.addresses[i].state ? this.props.user.userProfile.addresses[i].state : '';
	              shippingAddressZip = this.props.user.userProfile.addresses[i].zipcode ? this.props.user.userProfile.addresses[i].zipcode : '';
	            }
	          }
	        } else {
	          console.log('no addresses');
	        }
	
	        // if(this.props.user.userCore.addresses && this.props.user.userCore.addresses.length > 0) {
	
	        //   cityVal = this.props.user.userCore.addresses[0].city;
	        //   zipVal = this.props.user.userCore.addresses[0].postcode;
	
	        //   if(this.props.user.userCore.addresses.street && this.props.user.userCore.addresses.street.length > 0) {
	        //     street1Val = this.props.user.userCore.addresses[0].street[0];
	        //   }
	
	        //   if(this.props.user.userCore.addresses.street && this.props.user.userCore.addresses.street.length > 1) {
	        //     street2Val = this.props.user.userCore.addresses[0].street[1];
	        //   }
	        // }
	
	        this.setState({
	          phone: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.phone ? this.props.user.userProfile.customer.phone : '',
	          birthday: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.date_of_birth ? (0, _formatting.formatDbDate)(this.props.user.userProfile.customer.date_of_birth) : '',
	          soFirstName: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].first_name ? this.props.user.userProfile.spouses[0].first_name : '',
	          soLastName: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].last_name ? this.props.user.userProfile.spouses[0].last_name : '',
	          soEmail: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].email ? this.props.user.userProfile.spouses[0].email : '',
	          soBirthday: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].birthdate ? (0, _formatting.formatDbDate)(this.props.user.userProfile.spouses[0].birthdate) : '',
	          anniversary: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.anniversary_date ? (0, _formatting.formatDbDate)(this.props.user.userProfile.customer.anniversary_date) : '',
	          ringSize: this.props.user.userProfile && this.props.user.userProfile.ringSizes ? this.props.user.userProfile.ringSizes : [],
	          localStore: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.store_number ? this.props.user.userProfile.customer.store_number : '',
	
	          homeAddressId: homeAddressId,
	          homeAddressStreet1: homeAddressStreet1,
	          homeAddressStreet2: homeAddressStreet2,
	          homeAddressCity: homeAddressCity,
	          homeAddressState: homeAddressState,
	          homeAddressZip: homeAddressZip,
	
	          shippingAddressId: shippingAddressId,
	          shippingAddressStreet1: shippingAddressStreet1,
	          shippingAddressStreet2: shippingAddressStreet2,
	          shippingAddressCity: shippingAddressCity,
	          shippingAddressState: shippingAddressState,
	          shippingAddressZip: shippingAddressZip
	        });
	      }
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'syncUserProfile',
	    value: function syncUserProfile(updates) {
	      var _this2 = this;
	
	      var baseData = {
	        firstName: this.state.firstName,
	        lastName: this.state.lastName,
	        email: this.state.email,
	        phone: this.state.phone
	      };
	      var updateData = Object.assign({}, baseData, updates);
	      this.props.userSetProfile(updateData).then(function (resp) {
	        console.log(resp);
	
	        _this2.props.userGetUser().then(function (resp) {
	          _this2.props.userSaveCore(resp);
	        });
	
	        _this2.props.userGetProfile().then(function (resp) {
	          _this2.props.userSaveProfile(resp);
	        });
	      });
	    }
	
	    // =================== //
	    // First and last name //
	    // =================== //
	
	  }, {
	    key: 'openName',
	    value: function openName() {
	      this.setState({ nameOpen: true });
	    }
	  }, {
	    key: 'changeFirstName',
	    value: function changeFirstName(evt) {
	      this.setState({ firstName: evt.target.value });
	    }
	  }, {
	    key: 'validateFirstName',
	    value: function validateFirstName() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        _this3.setState({ firstNameError: (0, _itemValidation.nameValidation)(_this3.state.firstName) });
	      }, 100);
	    }
	  }, {
	    key: 'changeLastName',
	    value: function changeLastName(evt) {
	      this.setState({ lastName: evt.target.value });
	    }
	  }, {
	    key: 'validateLastName',
	    value: function validateLastName() {
	      var _this4 = this;
	
	      setTimeout(function () {
	        _this4.setState({ lastNameError: (0, _itemValidation.nameValidation)(_this4.state.lastName) });
	      }, 100);
	    }
	  }, {
	    key: 'saveName',
	    value: function saveName() {
	      var _this5 = this;
	
	      var firstNameError = (0, _itemValidation.nameValidation)(this.state.firstName);
	      var lastNameError = (0, _itemValidation.nameValidation)(this.state.lastName);
	
	      if (firstNameError || lastNameError) {
	        this.setState({
	          firstNameError: firstNameError,
	          lastNameError: lastNameError
	        });
	      } else {
	        this.setState({ nameOpen: false }, function () {
	          _this5.syncUserProfile({
	            firstName: _this5.state.firstName,
	            lastName: _this5.state.lastName
	          });
	        });
	        this.props.setFirstNameMethod(this.state.firstName);
	      }
	    }
	
	    // ====================== //
	    // SO First and last name //
	    // ====================== //
	
	  }, {
	    key: 'openSoName',
	    value: function openSoName() {
	      this.setState({ soNameOpen: true });
	    }
	  }, {
	    key: 'changeSoFirstName',
	    value: function changeSoFirstName(evt) {
	      this.setState({ soFirstName: evt.target.value });
	    }
	  }, {
	    key: 'validateSoFirstName',
	    value: function validateSoFirstName() {
	      var _this6 = this;
	
	      setTimeout(function () {
	        _this6.setState({ soFirstNameError: (0, _itemValidation.nameValidation)(_this6.state.soFirstName) });
	      }, 100);
	    }
	  }, {
	    key: 'changeSoLastName',
	    value: function changeSoLastName(evt) {
	      this.setState({ soLastName: evt.target.value });
	    }
	  }, {
	    key: 'validateSoLastName',
	    value: function validateSoLastName() {
	      var _this7 = this;
	
	      setTimeout(function () {
	        _this7.setState({ soLastNameError: (0, _itemValidation.nameValidation)(_this7.state.soLastName) });
	      }, 100);
	    }
	  }, {
	    key: 'saveSoName',
	    value: function saveSoName() {
	      var _this8 = this;
	
	      var firstNameError = (0, _itemValidation.nameValidation)(this.state.soFirstName);
	      var lastNameError = (0, _itemValidation.nameValidation)(this.state.soLastName);
	
	      if (firstNameError || lastNameError) {
	        this.setState({
	          soFirstNameError: firstNameError,
	          soLastNameError: lastNameError
	        });
	      } else {
	        this.setState({ soNameOpen: false }, function () {
	          _this8.syncUserProfile({
	            soFirstName: _this8.state.soFirstName,
	            soLastName: _this8.state.soLastName
	          });
	        });
	      }
	    }
	
	    // ===== //
	    // Phone //
	    // ===== //
	
	  }, {
	    key: 'openPhone',
	    value: function openPhone() {
	      this.setState({ phoneOpen: true });
	    }
	  }, {
	    key: 'changePhone',
	    value: function changePhone(evt) {
	      this.setState({ phone: (0, _formatting.stringToDigits)(evt.target.value) });
	    }
	  }, {
	    key: 'validatePhone',
	    value: function validatePhone() {
	      var _this9 = this;
	
	      setTimeout(function () {
	        _this9.setState({ phoneError: (0, _itemValidation.phoneValidation)(_this9.state.phone) });
	      }, 100);
	    }
	  }, {
	    key: 'savePhone',
	    value: function savePhone() {
	      var _this10 = this;
	
	      var phoneError = (0, _itemValidation.phoneValidation)(this.state.phone);
	      if (phoneError) {
	        this.setState({ phoneError: phoneError });
	      } else {
	        this.setState({ phoneOpen: false }, function () {
	          _this10.syncUserProfile({
	            phone: _this10.state.phone
	          });
	        });
	      }
	    }
	
	    // ===== //
	    // Email //
	    // ===== //
	
	  }, {
	    key: 'openEmail',
	    value: function openEmail() {
	      this.setState({ emailOpen: true });
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      this.setState({ email: evt.target.value });
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail() {
	      var _this11 = this;
	
	      setTimeout(function () {
	        _this11.setState({ emailError: (0, _itemValidation.emailValidation)(_this11.state.email) });
	      }, 100);
	    }
	  }, {
	    key: 'saveEmail',
	    value: function saveEmail() {
	      var _this12 = this;
	
	      var emailError = (0, _itemValidation.emailValidation)(this.state.email);
	      if (emailError) {
	        this.setState({ emailError: emailError });
	      } else {
	        this.setState({ emailOpen: false }, function () {
	          _this12.syncUserProfile({
	            email: _this12.state.email
	          });
	        });
	      }
	    }
	
	    // ======== //
	    // SO Email //
	    // ======== //
	
	  }, {
	    key: 'openSoEmail',
	    value: function openSoEmail() {
	      this.setState({ soEmailOpen: true });
	    }
	  }, {
	    key: 'changeSoEmail',
	    value: function changeSoEmail(evt) {
	      this.setState({ soEmail: evt.target.value });
	    }
	  }, {
	    key: 'validateSoEmail',
	    value: function validateSoEmail() {
	      var _this13 = this;
	
	      setTimeout(function () {
	        _this13.setState({ soEmailError: (0, _itemValidation.emailValidation)(_this13.state.soEmail) });
	      }, 100);
	    }
	  }, {
	    key: 'saveSoEmail',
	    value: function saveSoEmail() {
	      var _this14 = this;
	
	      var emailError = (0, _itemValidation.emailValidation)(this.state.soEmail);
	      if (emailError) {
	        this.setState({ soEmailError: emailError });
	      } else {
	        this.setState({ soEmailOpen: false }, function () {
	          _this14.syncUserProfile({
	            soEmail: _this14.state.soEmail
	          });
	        });
	      }
	    }
	
	    // ======== //
	    // Birthday //
	    // ======== //
	
	  }, {
	    key: 'openBirthday',
	    value: function openBirthday() {
	      this.setState({ birthdayOpen: true });
	    }
	  }, {
	    key: 'changeBirthday',
	    value: function changeBirthday(evt) {
	      this.setState({ birthday: (0, _formatting.stringToDigits)(evt.target.value) });
	    }
	  }, {
	    key: 'validateBirthday',
	    value: function validateBirthday() {
	      var _this15 = this;
	
	      if (this.state.birthday.trim() == '') {
	        return;
	      }
	
	      setTimeout(function () {
	        _this15.setState({ birthdayError: (0, _itemValidation.dateValidation)(_this15.state.birthday) });
	      }, 100);
	    }
	  }, {
	    key: 'saveBirthday',
	    value: function saveBirthday() {
	      var _this16 = this;
	
	      var birthdayError = null;
	      if (this.state.birthday.trim().length > 0) {
	        birthdayError = (0, _itemValidation.dateValidation)(this.state.birthday);
	      }
	
	      if (birthdayError) {
	        this.setState({ birthdayError: birthdayError });
	      } else {
	        this.setState({ birthdayOpen: false }, function () {
	          _this16.syncUserProfile({
	            birthday: (0, _formatting.formatDateForDb)(_this16.state.birthday)
	          });
	        });
	      }
	    }
	
	    // =========== //
	    // SO Birthday //
	    // =========== //
	
	  }, {
	    key: 'openSoBirthday',
	    value: function openSoBirthday() {
	      this.setState({ soBirthdayOpen: true });
	    }
	  }, {
	    key: 'changeSoBirthday',
	    value: function changeSoBirthday(evt) {
	      this.setState({ soBirthday: (0, _formatting.stringToDigits)(evt.target.value) });
	    }
	  }, {
	    key: 'validateSoBirthday',
	    value: function validateSoBirthday() {
	      var _this17 = this;
	
	      if (this.state.soBirthday.trim() == '') {
	        return;
	      }
	
	      setTimeout(function () {
	        _this17.setState({ soBirthdayError: (0, _itemValidation.dateValidation)(_this17.state.soBirthday) });
	      }, 100);
	    }
	  }, {
	    key: 'saveSoBirthday',
	    value: function saveSoBirthday() {
	      var _this18 = this;
	
	      var birthdayError = null;
	      if (this.state.soBirthday.trim().length > 0) {
	        birthdayError = (0, _itemValidation.dateValidation)(this.state.soBirthday);
	      }
	
	      if (birthdayError) {
	        this.setState({ soBirthdayError: birthdayError });
	      } else {
	        this.setState({ soBirthdayOpen: false }, function () {
	          _this18.syncUserProfile({
	            soBirthday: (0, _formatting.formatDateForDb)(_this18.state.soBirthday)
	          });
	        });
	      }
	    }
	
	    // =========== //
	    // Anniversary //
	    // =========== //
	
	  }, {
	    key: 'openAnniversary',
	    value: function openAnniversary() {
	      this.setState({ anniversaryOpen: true });
	    }
	  }, {
	    key: 'changeAnniversary',
	    value: function changeAnniversary(evt) {
	      this.setState({ anniversary: evt.target.value });
	    }
	  }, {
	    key: 'validateAnniversary',
	    value: function validateAnniversary() {
	      var _this19 = this;
	
	      setTimeout(function () {
	        _this19.setState({ anniversaryError: (0, _itemValidation.dateValidation)(_this19.state.anniversary) });
	      }, 100);
	    }
	  }, {
	    key: 'saveAnniversary',
	    value: function saveAnniversary() {
	      var _this20 = this;
	
	      var anniversaryError = (0, _itemValidation.dateValidation)(this.state.anniversary);
	      if (anniversaryError) {
	        this.setState({ anniversaryError: anniversaryError });
	      } else {
	        this.setState({ anniversaryOpen: false }, function () {
	          _this20.syncUserProfile({
	            anniversary: (0, _formatting.formatDateForDb)(_this20.state.anniversary)
	          });
	        });
	      }
	    }
	
	    // ========= //
	    // Ring Size //
	    // ========= //
	
	  }, {
	    key: 'openRingSize',
	    value: function openRingSize() {
	      this.setState({ ringSizeOpen: true });
	    }
	  }, {
	    key: 'changeRingSize',
	    value: function changeRingSize(evt, index, type) {
	      var _this21 = this;
	
	      console.log(evt.target.value);
	      console.log(index);
	      console.log(type);
	      // this.setState({ ringSize: evt.target.value });
	
	
	      // ringSize: [
	      //     {
	      //       finger: 'Left ring',
	      //       size: '6.00',
	      //     },
	      //   ],
	
	      var newSizes = [];
	      var addingSize = index >= this.state.ringSize.length;
	
	      for (var i = 0; i < this.state.ringSize.length; i++) {
	        var size = {
	          finger: this.state.ringSize[i].finger,
	          size: this.state.ringSize[i].size
	        };
	        if (i === index) {
	          if (type == 'finger') {
	            size.finger = evt.target.value;
	          } else if (type == 'size') {
	            size.size = evt.target.value;
	          }
	        }
	        newSizes.push(size);
	      }
	      if (addingSize) {
	        var _size = {
	          finger: type == 'finger' ? evt.target.value : '',
	          size: type == 'size' ? evt.target.value : ''
	        };
	        newSizes.push(_size);
	      }
	      this.setState({ ringSize: newSizes }, function () {
	        console.log(_this21.state.ringSize);
	      });
	    }
	  }, {
	    key: 'saveRingSize',
	    value: function saveRingSize() {
	      var _this22 = this;
	
	      this.setState({ ringSizeOpen: false }, function () {
	        _this22.syncUserProfile({
	          ringSizes: _this22.state.ringSize
	        });
	      });
	    }
	  }, {
	    key: 'renderRingSize',
	    value: function renderRingSize(index) {
	      var _this23 = this;
	
	      var ringCount = this.state.ringSize.length;
	      var hasData = index <= ringCount - 1;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'singleItemElement accountElement', key: index },
	        index === 0 ? _react2.default.createElement(
	          'div',
	          { className: 'elementLabel' },
	          'Ring Sizes'
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'elementLabel' },
	          '\xA0'
	        ),
	        !this.state.ringSizeOpen ? _react2.default.createElement(
	          'div',
	          null,
	          hasData ? _react2.default.createElement(
	            'div',
	            { className: 'elementValue' },
	            this.state.ringSize[index].finger + ': ' + this.state.ringSize[index].size
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'elementEdit', onClick: this.openRingSize.bind(this) },
	            hasData ? 'Edit' : 'Add Ring'
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'editWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'editInput' },
	              _react2.default.createElement(
	                'select',
	                {
	                  value: hasData ? this.state.ringSize[index].finger : '',
	                  onChange: function onChange(evt) {
	                    return _this23.changeRingSize(evt, index, 'finger');
	                  },
	                  className: 'fingerSelect' },
	                this.state.ringFingerData.map(function (finger, i) {
	                  return _react2.default.createElement(
	                    'option',
	                    { key: i, value: finger.value },
	                    finger.display
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'select',
	                {
	                  value: hasData ? this.state.ringSize[index].size : '',
	                  onChange: function onChange(evt) {
	                    return _this23.changeRingSize(evt, index, 'size');
	                  },
	                  className: 'sizeSelect' },
	                this.state.ringSizeData.map(function (size, j) {
	                  return _react2.default.createElement(
	                    'option',
	                    { key: j, value: size.value },
	                    size.display
	                  );
	                })
	              )
	            )
	          ),
	          index === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'elementEdit', onClick: this.saveRingSize.bind(this) },
	            'Save'
	          ) : null
	        )
	      );
	    }
	
	    // ============ //
	    // Home Address //
	    // ============ //
	
	  }, {
	    key: 'openHomeAddress',
	    value: function openHomeAddress() {
	      this.setState({ homeAddressOpen: true });
	    }
	  }, {
	    key: 'changeHomeAddressStreet1',
	    value: function changeHomeAddressStreet1(evt) {
	      this.setState({ homeAddressStreet1: evt.target.value });
	    }
	  }, {
	    key: 'changeHomeAddressStreet2',
	    value: function changeHomeAddressStreet2(evt) {
	      this.setState({ homeAddressStreet2: evt.target.value });
	    }
	  }, {
	    key: 'changeHomeAddressCity',
	    value: function changeHomeAddressCity(evt) {
	      this.setState({ homeAddressCity: evt.target.value });
	    }
	  }, {
	    key: 'changeHomeAddressState',
	    value: function changeHomeAddressState(evt) {
	      this.setState({ homeAddressState: evt.target.value });
	    }
	  }, {
	    key: 'changeHomeAddressZip',
	    value: function changeHomeAddressZip(evt) {
	      this.setState({ homeAddressZip: evt.target.value });
	    }
	  }, {
	    key: 'validateHomeAddress',
	    value: function validateHomeAddress() {
	
	      // Required
	      var street1Error = (0, _itemValidation.locationValidation)(this.state.homeAddressStreet1);
	      var street2Error = null;
	      var cityError = (0, _itemValidation.locationValidation)(this.state.homeAddressCity);
	      var stateError = this.state.homeAddressState === '' ? 'Enter a state' : null;
	      var zipError = (0, _itemValidation.zipValidation)(this.state.homeAddressZip);
	
	      // Optional
	      if (this.state.homeAddressStreet2.trim() !== '') {
	        street2Error = (0, _itemValidation.locationValidation)(this.state.homeAddressStreet2);
	      }
	
	      this.setState({
	        homeAddressStreet1Error: street1Error,
	        homeAddressStreet2Error: street2Error,
	        homeAddressCityError: cityError,
	        homeAddressStateError: stateError,
	        homeAddressZipError: zipError
	      });
	
	      if (street1Error === null && street2Error === null && cityError === null && stateError === null && zipError === null) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'saveHomeAddress',
	    value: function saveHomeAddress() {
	      var _this24 = this;
	
	      if (this.validateHomeAddress()) {
	        this.setState({ homeAddressOpen: false }, function () {
	          _this24.syncUserProfile({
	            homeAddressId: _this24.state.homeAddressId,
	            homeAddressStreet1: _this24.state.homeAddressStreet1,
	            homeAddressStreet2: _this24.state.homeAddressStreet2,
	            homeAddressCity: _this24.state.homeAddressCity,
	            homeAddressState: _this24.state.homeAddressState,
	            homeAddressZip: _this24.state.homeAddressZip
	          });
	        });
	      }
	    }
	
	    // ================ //
	    // Shipping Address //
	    // ================ //
	
	  }, {
	    key: 'openShippingAddress',
	    value: function openShippingAddress() {
	      this.setState({ shippingAddressOpen: true });
	    }
	  }, {
	    key: 'changeShippingAddressStreet1',
	    value: function changeShippingAddressStreet1(evt) {
	      this.setState({ shippingAddressStreet1: evt.target.value });
	    }
	  }, {
	    key: 'changeShippingAddressStreet2',
	    value: function changeShippingAddressStreet2(evt) {
	      this.setState({ shippingAddressStreet2: evt.target.value });
	    }
	  }, {
	    key: 'changeShippingAddressCity',
	    value: function changeShippingAddressCity(evt) {
	      this.setState({ shippingAddressCity: evt.target.value });
	    }
	  }, {
	    key: 'changeShippingAddressState',
	    value: function changeShippingAddressState(evt) {
	      this.setState({ shippingAddressState: evt.target.value });
	    }
	  }, {
	    key: 'changeShippingAddressZip',
	    value: function changeShippingAddressZip(evt) {
	      this.setState({ shippingAddressZip: evt.target.value });
	    }
	  }, {
	    key: 'validateShippingAddress',
	    value: function validateShippingAddress() {
	
	      // Required
	      var street1Error = (0, _itemValidation.locationValidation)(this.state.shippingAddressStreet1);
	      var street2Error = null;
	      var cityError = (0, _itemValidation.locationValidation)(this.state.shippingAddressCity);
	      var stateError = this.state.shippingAddressState === '' ? 'Enter a state' : null;
	      var zipError = (0, _itemValidation.zipValidation)(this.state.shippingAddressZip);
	
	      // Optional
	      if (this.state.shippingAddressStreet2.trim() !== '') {
	        street2Error = (0, _itemValidation.locationValidation)(this.state.shippingAddressStreet2);
	      }
	
	      this.setState({
	        shippingAddressStreet1Error: street1Error,
	        shippingAddressStreet2Error: street2Error,
	        shippingAddressCityError: cityError,
	        shippingAddressStateError: stateError,
	        shippingAddressZipError: zipError
	      });
	
	      if (street1Error === null && street2Error === null && cityError === null && stateError === null && zipError === null) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'saveShippingAddress',
	    value: function saveShippingAddress() {
	      var _this25 = this;
	
	      if (this.validateShippingAddress()) {
	        this.setState({ shippingAddressOpen: false }, function () {
	          _this25.syncUserProfile({
	            shippingAddressId: _this25.state.shippingAddressId,
	            shippingAddressStreet1: _this25.state.shippingAddressStreet1,
	            shippingAddressStreet2: _this25.state.shippingAddressStreet2,
	            shippingAddressCity: _this25.state.shippingAddressCity,
	            shippingAddressState: _this25.state.shippingAddressState,
	            shippingAddressZip: _this25.state.shippingAddressZip
	          });
	        });
	      }
	    }
	
	    // =========== //
	    // Local Store //
	    // =========== //
	
	  }, {
	    key: 'openLocalStore',
	    value: function openLocalStore() {
	      this.setState({ localStoreOpen: true });
	    }
	  }, {
	    key: 'changeLocalStore',
	    value: function changeLocalStore(evt) {
	      this.setState({ localStore: evt.target.value });
	    }
	  }, {
	    key: 'saveLocalStore',
	    value: function saveLocalStore() {
	      var _this26 = this;
	
	      this.setState({ localStoreOpen: false }, function () {
	        _this26.syncUserProfile({
	          localStore: _this26.state.localStore
	        });
	      });
	    }
	  }, {
	    key: 'getStoreAddress',
	    value: function getStoreAddress(key, line) {
	
	      if (!key) {
	        return '';
	      }
	      for (var i = 0; i < _locations.locations.length; i++) {
	        if (key == _locations.locations[i]['number']) {
	          return _locations.locations[i]['address' + line];
	        }
	      }
	    }
	  }, {
	    key: 'getStoreTitle',
	    value: function getStoreTitle(key) {
	
	      if (!key) {
	        return '';
	      }
	      for (var i = 0; i < _locations.locations.length; i++) {
	        if (key == _locations.locations[i]['number']) {
	          return _locations.locations[i]['title'];
	        }
	      }
	    }
	  }, {
	    key: 'getStoreEmail',
	    value: function getStoreEmail(key) {
	
	      if (!key) {
	        return '';
	      }
	      for (var i = 0; i < _locations.locations.length; i++) {
	        if (key == _locations.locations[i]['number']) {
	          return _locations.locations[i]['email'];
	        }
	      }
	    }
	  }, {
	    key: 'getStorePhone',
	    value: function getStorePhone(key) {
	
	      if (!key) {
	        return '';
	      }
	      for (var i = 0; i < _locations.locations.length; i++) {
	        if (key == _locations.locations[i]['number']) {
	          return _locations.locations[i]['phone'];
	        }
	      }
	    }
	
	    // ======== //
	    // Password //
	    // ======== //
	
	  }, {
	    key: 'openPassword',
	    value: function openPassword() {
	      this.setState({ passwordOpen: true });
	    }
	  }, {
	    key: 'changeOldPassword',
	    value: function changeOldPassword(evt) {
	      this.setState({ oldPassword: evt.target.value });
	    }
	  }, {
	    key: 'changePassword1',
	    value: function changePassword1(evt) {
	      this.setState({ newPassword1: evt.target.value });
	    }
	  }, {
	    key: 'changePassword2',
	    value: function changePassword2(evt) {
	      this.setState({ newPassword2: evt.target.value });
	    }
	  }, {
	    key: 'savePassword',
	    value: function savePassword() {
	      var passwordError = (0, _itemValidation.passwordValidation)(this.state.newPassword1);
	      if (passwordError === null && this.state.newPassword1 != this.state.newPassword2) {
	        passwordError = 'Passwords must match';
	      } else if (this.state.oldPassword.length === 0) {
	        passwordError = 'Enter current password';
	      }
	      if (passwordError) {
	        this.setState({ passwordError: passwordError });
	      } else {
	        this.setState({
	          passwordOpen: false,
	          oldPassword: '',
	          newPassword1: '',
	          newPassword2: '',
	          passwordReset: true
	        });
	      }
	    }
	
	    // ========== //
	    // Email Opt  //
	    // ========== //
	
	  }, {
	    key: 'toggleEmailPreference',
	    value: function toggleEmailPreference() {
	      var _this27 = this;
	
	      this.setState({ optIn: !this.state.optIn }, function () {
	        _this27.props.commonAlert('Email preferences updated');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this28 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AccountInfo' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sectionTitle' },
	          'Account Info'
	        ),
	        this.props.user.userCore === null ? _react2.default.createElement(
	          'div',
	          { className: 'infoSectionWrapper' },
	          _react2.default.createElement(_RhinoLoading2.default, null)
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'infoSectionWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'accountInfoCopy', style: { marginBottom: '20px' } },
	            'Editing your email address below will not impact open orders, only your account login. Please email ',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:online@diamondsdirect.com' },
	              'online@diamondsdirect.com'
	            ),
	            ' to update contact information related to open orders.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement' },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Name'
	            ),
	            !this.state.nameOpen ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementValue' },
	                this.state.firstName + ' ' + this.state.lastName
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openName.bind(this) },
	                'Edit'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: this.state.firstName,
	                    onChange: this.changeFirstName.bind(this),
	                    onBlur: this.validateFirstName.bind(this),
	                    className: this.state.firstNameError ? 'error' : 'accountInput',
	                    placeholder: 'First Name' })
	                ),
	                this.state.firstNameError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.firstNameError
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: this.state.lastName,
	                    onChange: this.changeLastName.bind(this),
	                    onBlur: this.validateLastName.bind(this),
	                    className: this.state.lastNameError ? 'error' : 'accountInput',
	                    placeholder: 'Last Name' })
	                ),
	                this.state.lastNameError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.lastNameError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.saveName.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement' },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Phone Number'
	            ),
	            !this.state.phoneOpen ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementValue' },
	                (0, _formatting.displayPhone)(this.state.phone)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openPhone.bind(this) },
	                'Edit'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'phone',
	                    value: (0, _formatting.displayPhoneInput)(this.state.phone),
	                    onChange: this.changePhone.bind(this),
	                    onBlur: this.validatePhone.bind(this),
	                    className: this.state.phoneError ? 'error' : 'accountInput' })
	                ),
	                this.state.phoneError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.phoneError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.savePhone.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement' },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Email Address'
	            ),
	            !this.state.emailOpen ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementValue EllipsisElement' },
	                this.state.email
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openEmail.bind(this) },
	                'Edit'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'email',
	                    value: this.state.email,
	                    onChange: this.changeEmail.bind(this),
	                    onBlur: this.validateEmail.bind(this),
	                    className: this.state.emailError ? 'error' : 'accountInput' })
	                ),
	                this.state.emailError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.emailError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.saveEmail.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Birthday'
	            ),
	            !this.state.birthdayOpen ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementValue' },
	                (0, _formatting.displayDateInput)(this.state.birthday)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openBirthday.bind(this) },
	                this.state.birthday === '' ? 'Add' : 'Save'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: (0, _formatting.displayDateInput)(this.state.birthday),
	                    onChange: this.changeBirthday.bind(this),
	                    onBlur: this.validateBirthday.bind(this),
	                    placeholder: 'MM-DD-YYYY',
	                    className: this.state.birthdayError ? 'error' : 'accountInput' })
	                ),
	                this.state.birthdayError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.birthdayError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.saveBirthday.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement' },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Spouse\'s Name'
	            ),
	            !this.state.soNameOpen ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementValue' },
	                this.state.soFirstName + ' ' + this.state.soLastName
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openSoName.bind(this) },
	                'Edit'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: this.state.soFirstName,
	                    onChange: this.changeSoFirstName.bind(this),
	                    onBlur: this.validateSoFirstName.bind(this),
	                    className: this.state.soFirstNameError ? 'error' : 'accountInput',
	                    placeholder: 'First Name' })
	                ),
	                this.state.soFirstNameError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.soFirstNameError
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: this.state.soLastName,
	                    onChange: this.changeSoLastName.bind(this),
	                    onBlur: this.validateSoLastName.bind(this),
	                    className: this.state.soLastNameError ? 'error' : 'accountInput',
	                    placeholder: 'Last Name' })
	                ),
	                this.state.soLastNameError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.soLastNameError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.saveSoName.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement' },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Spouse\'s Email'
	            ),
	            !this.state.soEmailOpen ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementValue' },
	                this.state.soEmail
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openSoEmail.bind(this) },
	                'Edit'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'email',
	                    value: this.state.soEmail,
	                    onChange: this.changeSoEmail.bind(this),
	                    onBlur: this.validateSoEmail.bind(this),
	                    className: this.state.soEmailError ? 'error' : 'accountInput' })
	                ),
	                this.state.soEmailError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.soEmailError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.saveSoEmail.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Spouse\'s Birthday'
	            ),
	            !this.state.soBirthdayOpen ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementValue' },
	                (0, _formatting.displayDateInput)(this.state.soBirthday)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openSoBirthday.bind(this) },
	                this.state.soBirthday === '' ? 'Add' : 'Save'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: (0, _formatting.displayDateInput)(this.state.soBirthday),
	                    onChange: this.changeSoBirthday.bind(this),
	                    onBlur: this.validateSoBirthday.bind(this),
	                    placeholder: 'MM-DD-YYYY',
	                    className: this.state.soBirthdayError ? 'error' : 'accountInput' })
	                ),
	                this.state.soBirthdayError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.soBirthdayError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.saveSoBirthday.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Anniversary'
	            ),
	            !this.state.anniversaryOpen ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementValue' },
	                (0, _formatting.displayDate)(this.state.anniversary)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openAnniversary.bind(this) },
	                this.state.anniversary === '' ? 'Add' : 'Edit'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: (0, _formatting.displayDateInput)(this.state.anniversary),
	                    onChange: this.changeAnniversary.bind(this),
	                    onBlur: this.validateAnniversary.bind(this),
	                    placeholder: 'MM-DD-YYYY',
	                    className: this.state.anniversaryError ? 'error' : 'accountInput' })
	                ),
	                this.state.anniversaryError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.anniversaryError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.saveAnniversary.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          this.state.ringSize.length == 0 ? _react2.default.createElement(
	            'div',
	            null,
	            this.renderRingSize(0)
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            this.state.ringSize.map(function (rsize, i) {
	              if (i > 4) {
	                return null;
	              }
	              return _this28.renderRingSize(i);
	            }),
	            this.state.ringSize.length <= 4 ? _react2.default.createElement(
	              'span',
	              null,
	              this.renderRingSize(this.state.ringSize.length)
	            ) : null
	          ),
	          _react2.default.createElement('div', { className: 'databreak' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'addressItemElement accountElement', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Home Address'
	            ),
	            !this.state.homeAddressOpen ? _react2.default.createElement(
	              'div',
	              null,
	              this.state.homeAddressStreet1 ? _react2.default.createElement(
	                'div',
	                { className: 'elementAddress1 elementValue' },
	                this.state.homeAddressStreet1
	              ) : null,
	              this.state.homeAddressStreet2 ? _react2.default.createElement(
	                'div',
	                { className: 'elementAddress2 elementValue' },
	                this.state.homeAddressStreet2
	              ) : null,
	              this.state.homeAddressCity && this.state.homeAddressState && this.state.homeAddressZip ? _react2.default.createElement(
	                'div',
	                { className: 'elementAddress3 elementValue' },
	                this.state.homeAddressCity + ', ' + this.state.homeAddressState + ' ' + this.state.homeAddressZip
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openHomeAddress.bind(this) },
	                this.state.homeAddressStreet1 === '' ? 'Add' : 'Edit'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput addressInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: this.state.homeAddressStreet1,
	                    onChange: this.changeHomeAddressStreet1.bind(this),
	                    placeholder: 'Street Address',
	                    className: this.state.homeAddressStreet1Error ? 'error' : 'accountInput' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput addressInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: this.state.homeAddressStreet2,
	                    onChange: this.changeHomeAddressStreet2.bind(this),
	                    placeholder: 'Street Address (Optional)',
	                    className: this.state.homeAddressStreet2Error ? 'error' : 'accountInput' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput addressInput' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'cityWrapper' },
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      value: this.state.homeAddressCity,
	                      onChange: this.changeHomeAddressCity.bind(this),
	                      placeholder: 'City',
	                      className: this.state.homeAddressCityError ? 'error' : 'accountInput' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'stateWrapper' },
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        value: this.state.homeAddressState,
	                        onChange: this.changeHomeAddressState.bind(this) },
	                      this.state.stateDropdownData.map(function (state, i) {
	                        return _react2.default.createElement(
	                          'option',
	                          { key: i, value: state.value },
	                          state.display
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'zipWrapper' },
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      value: this.state.homeAddressZip,
	                      onChange: this.changeHomeAddressZip.bind(this),
	                      placeholder: 'Postal Code',
	                      className: this.state.homeAddressZipError ? 'error' : 'accountInput' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.saveHomeAddress.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'addressItemElement accountElement', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Shipping Address'
	            ),
	            !this.state.shippingAddressOpen ? _react2.default.createElement(
	              'div',
	              null,
	              this.state.shippingAddressStreet1 ? _react2.default.createElement(
	                'div',
	                { className: 'elementAddress1 elementValue' },
	                this.state.shippingAddressStreet1
	              ) : null,
	              this.state.shippingAddressStreet2 ? _react2.default.createElement(
	                'div',
	                { className: 'elementAddress2 elementValue' },
	                this.state.shippingAddressStreet2
	              ) : null,
	              this.state.shippingAddressCity && this.state.shippingAddressState && this.state.shippingAddressZip ? _react2.default.createElement(
	                'div',
	                { className: 'elementAddress3 elementValue' },
	                this.state.shippingAddressCity + ', ' + this.state.shippingAddressState + ' ' + this.state.shippingAddressZip
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openShippingAddress.bind(this) },
	                this.state.shippingAddressStreet1 === '' ? 'Add' : 'Edit'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput addressInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: this.state.shippingAddressStreet1,
	                    onChange: this.changeShippingAddressStreet1.bind(this),
	                    placeholder: 'Street Address',
	                    className: this.state.shippingAddressStreet1Error ? 'error' : 'accountInput' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput addressInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: this.state.shippingAddressStreet2,
	                    onChange: this.changeShippingAddressStreet2.bind(this),
	                    placeholder: 'Street Address (Optional)',
	                    className: this.state.shippingAddressStreet2Error ? 'error' : 'accountInput' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput addressInput' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'cityWrapper' },
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      value: this.state.shippingAddressCity,
	                      onChange: this.changeShippingAddressCity.bind(this),
	                      placeholder: 'City',
	                      className: this.state.shippingAddressCityError ? 'error' : 'accountInput' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'stateWrapper' },
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        value: this.state.shippingAddressState,
	                        onChange: this.changeShippingAddressState.bind(this) },
	                      this.state.stateDropdownData.map(function (state, i) {
	                        return _react2.default.createElement(
	                          'option',
	                          { key: i, value: state.value },
	                          state.display
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'zipWrapper' },
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      value: this.state.shippingAddressZip,
	                      onChange: this.changeShippingAddressZip.bind(this),
	                      placeholder: 'Postal Code',
	                      className: this.state.shippingAddressZipError ? 'error' : 'accountInput' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.saveShippingAddress.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'addressItemElement accountElement' },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Your Home Store'
	            ),
	            !this.state.localStoreOpen ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementAddress1 elementValue', style: { fontWeight: '700' } },
	                this.getStoreTitle(this.state.localStore)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementAddress1 elementValue' },
	                this.getStoreAddress(this.state.localStore, 1)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementAddress2 elementValue' },
	                this.getStoreAddress(this.state.localStore, 2)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEmail elementValue' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:' + this.getStoreEmail(this.state.localStore) },
	                  this.getStoreEmail(this.state.localStore)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementPhone elementValue' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'tel:' + this.getStorePhone(this.state.localStore) },
	                  (0, _formatting.displayPhoneInput)(this.getStorePhone(this.state.localStore))
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openLocalStore.bind(this) },
	                'Set My Home Store'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      value: this.state.localStore,
	                      onChange: this.changeLocalStore.bind(this) },
	                    this.state.locationDropdownData.map(function (size, i) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: i, value: size.value },
	                        size.display
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.saveLocalStore.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'passwordItemElement accountElement' },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              this.state.passwordReset ? 'Password Reset' : 'Password'
	            ),
	            !this.state.passwordOpen ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.openPassword.bind(this) },
	                'Change Password'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'editWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput oldPasswordInput' },
	                  _react2.default.createElement('input', {
	                    type: 'password',
	                    placeholder: 'Current password',
	                    value: this.state.oldPassword,
	                    onChange: this.changeOldPassword.bind(this) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'password',
	                    placeholder: 'New password',
	                    value: this.state.newPassword1,
	                    onChange: this.changePassword1.bind(this) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'editInput' },
	                  _react2.default.createElement('input', {
	                    type: 'password',
	                    placeholder: 'Re-enter password',
	                    value: this.state.newPassword2,
	                    onChange: this.changePassword2.bind(this) })
	                ),
	                this.state.passwordError ? _react2.default.createElement(
	                  'div',
	                  { className: 'editError' },
	                  this.state.passwordError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'elementEdit', onClick: this.savePassword.bind(this) },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'databreak' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'optElement accountElement', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Subscription Settings'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'elementValue' },
	              'Stay updated with special events and promotions from Diamonds Direct.'
	            )
	          ),
	          _react2.default.createElement('div', { className: 'databreak', style: { display: 'none' } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Personal Email'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'emailRow' },
	              _react2.default.createElement(
	                'div',
	                { className: 'emailInput' },
	                _react2.default.createElement('input', { type: 'radio', name: 'personal', checked: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'emailLabel' },
	                'Sign me up!'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'emailRow' },
	              _react2.default.createElement(
	                'div',
	                { className: 'emailInput' },
	                _react2.default.createElement('input', { type: 'radio', name: 'personal' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'emailLabel' },
	                'Unsubscribe'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Spouse\'s Email'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'emailRow' },
	              _react2.default.createElement(
	                'div',
	                { className: 'emailInput' },
	                _react2.default.createElement('input', { type: 'radio', name: 'spouse', checked: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'emailLabel' },
	                'Sign me up!'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'emailRow' },
	              _react2.default.createElement(
	                'div',
	                { className: 'emailInput' },
	                _react2.default.createElement('input', { type: 'radio', name: 'spouse' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'emailLabel' },
	                'Unsubscribe'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'singleItemElement accountElement', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'elementLabel' },
	              'Direct Mail'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'emailRow' },
	              _react2.default.createElement(
	                'div',
	                { className: 'emailInput' },
	                _react2.default.createElement('input', { type: 'radio', name: 'direct', checked: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'emailLabel' },
	                'Sign me up!'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'emailRow' },
	              _react2.default.createElement(
	                'div',
	                { className: 'emailInput' },
	                _react2.default.createElement('input', { type: 'radio', name: 'direct' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'emailLabel' },
	                'Unsubscribe'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AccountInfo;
	}(_react2.default.Component);
	
	AccountInfo.propTypes = {
	  location: _react.PropTypes.object
	};
	AccountInfo.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = AccountInfo;
	
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	}
	
	var AccountInfoContainer = exports.AccountInfoContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(AccountInfo);

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountOrdersContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _stores = __webpack_require__(627);
	
	var _formatting = __webpack_require__(21);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators, userActionCreators);
	
	var AccountOrders = function (_React$Component) {
	  _inherits(AccountOrders, _React$Component);
	
	  function AccountOrders(props) {
	    _classCallCheck(this, AccountOrders);
	
	    var _this = _possibleConstructorReturn(this, (AccountOrders.__proto__ || Object.getPrototypeOf(AccountOrders)).call(this, props));
	
	    _this.state = {
	      rangeOpen: false,
	      rangeValue: 'Show All',
	      openOrders: []
	    };
	    return _this;
	  }
	
	  _createClass(AccountOrders, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'getOpenOrders',
	    value: function getOpenOrders() {
	
	      var returnArray = [];
	      var excludeStatuses = ['complete', 'cancelled'];
	
	      if (!this.props.user.orders) {
	        return null;
	      }
	
	      for (var i = 0; i < this.props.user.orders.length; i++) {
	        if (!excludeStatuses.includes(this.props.user.orders[i].status)) {
	          returnArray.push(this.props.user.orders[i]);
	        }
	      }
	      return returnArray;
	    }
	  }, {
	    key: 'getOrders',
	    value: function getOrders() {
	
	      if (!this.props.user.orders) {
	        return null;
	      }
	
	      if (this.props.showAll) {
	        return this.props.user.orders;
	      } else {
	        return this.getOpenOrders();
	      }
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getOrderCount',
	    value: function getOrderCount(order) {
	      if (order.items.length == 1) {
	        return order.items.length + ' product';
	      } else if (order.items.length > 1) {
	        return order.items.length + ' products';
	      }
	      return '';
	    }
	  }, {
	    key: 'getOrderStatus',
	    value: function getOrderStatus(order) {
	      if (!order || !order.status) {
	        return '';
	      }
	      return (0, _formatting.titleCase)(order.status);
	    }
	  }, {
	    key: 'getItemDescription',
	    value: function getItemDescription(item) {
	      if (!item || !item.description) {
	        return '';
	      }
	      // return {__html: item.description};
	      return item.description;
	    }
	  }, {
	    key: 'getDollars',
	    value: function getDollars(price) {
	      return Math.floor(parseFloat(price)).toLocaleString();
	    }
	  }, {
	    key: 'getCents',
	    value: function getCents(price) {
	      return parseFloat(price).toFixed(2).slice(-2);
	    }
	  }, {
	    key: 'toggleRangeOpen',
	    value: function toggleRangeOpen() {
	      this.setState({ rangeOpen: !this.state.rangeOpen });
	    }
	  }, {
	    key: 'updateRange',
	    value: function updateRange(val) {
	      this.setState({ rangeValue: val });
	    }
	  }, {
	    key: 'getShortDate',
	    value: function getShortDate(dateStr) {
	      var dispDate = new Date(dateStr);
	      var options = {
	        month: 'short',
	        day: 'numeric'
	      };
	      return dispDate.toLocaleDateString('default', options);
	    }
	  }, {
	    key: 'isOrderOpen',
	    value: function isOrderOpen(order) {
	      return this.state.openOrders.includes(order.id);
	    }
	  }, {
	    key: 'toggleOrderOpen',
	    value: function toggleOrderOpen(order) {
	
	      var shouldAdd = !this.state.openOrders.includes(order.id);
	      var newArray = [];
	
	      for (var i = 0; i < this.state.openOrders.length; i++) {
	        if (this.state.openOrders[i] != order.id || shouldAdd === true) {
	          newArray.push(this.state.openOrders[i]);
	        }
	      }
	      if (shouldAdd === true) {
	        newArray.push(order.id);
	      }
	      this.setState({ openOrders: newArray });
	    }
	  }, {
	    key: 'sendOptMessage',
	    value: function sendOptMessage() {
	      this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
	    }
	  }, {
	    key: 'getItemImageUrl',
	    value: function getItemImageUrl(imageUrl) {
	      if (!imageUrl) {
	        return null;
	      }
	      return '/pub/media/catalog/product' + imageUrl;
	    }
	  }, {
	    key: 'externalOrderAccess',
	    value: function externalOrderAccess() {
	
	      // Currently not looking at customer access
	      return false;
	
	      // if(this.props.showAll) {
	      //   // Order history
	      //   return this.props.user.userProfile && this.props.user.userProfile.customer.access_orders_history;
	      // } else {
	      //   // Open orders
	      //   return this.props.user.userProfile && this.props.user.userProfile.customer.access_orders_open;
	      // }
	    }
	  }, {
	    key: 'getInStoreDescription',
	    value: function getInStoreDescription(order, m) {
	
	      console.log(m);
	
	      if (m === 11) {
	        return "14K Tacori Pendant";
	      }
	
	      if (order.description) {
	        return order.description;
	      } else {
	        return "In-Store Order (" + (0, _stores.getLocationNameById)(order.trans_loc) + ")";
	      }
	    }
	  }, {
	    key: 'getStorePhone',
	    value: function getStorePhone(order) {
	      var store = (0, _stores.getStoreByNumber)(order.trans_loc);
	      if (!store) {
	        return null;
	      }
	      return store.phone;
	    }
	  }, {
	    key: 'getStoreEmail',
	    value: function getStoreEmail(order) {
	      var store = (0, _stores.getStoreByNumber)(order.trans_loc);
	
	      console.log(store);
	
	      if (!store) {
	        return null;
	      }
	      return store.email;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      console.log(this.props.user.orders);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AccountOrders' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sectionTitle' },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.showAll ? 'Order History' : 'Open Orders'
	          ),
	          this.props.showAll === true ? _react2.default.createElement(
	            'div',
	            { className: this.state.rangeOpen ? 'ordersDropdown open' : 'ordersDropdown', onClick: this.toggleRangeOpen.bind(this), style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'ordersDropdownBody' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dropdownBodyWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dropdownItem', onClick: function onClick() {
	                      return _this2.updateRange('Last 6 Months');
	                    } },
	                  'Last 6 Months'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dropdownItem', onClick: function onClick() {
	                      return _this2.updateRange('Last Year');
	                    } },
	                  'Last Year'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dropdownItem', onClick: function onClick() {
	                      return _this2.updateRange('Last 5 Years');
	                    } },
	                  'Last 5 Years'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dropdownItem', onClick: function onClick() {
	                      return _this2.updateRange('Show All');
	                    } },
	                  'Show All'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ordersDropdownHead' },
	              _react2.default.createElement(
	                'div',
	                { className: 'headDropdownValue' },
	                this.state.rangeValue
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dropdownIcon' },
	                _react2.default.createElement('i', { className: 'fas fa-chevron-right' })
	              )
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ordersWrapper' },
	           false ? _react2.default.createElement(
	            'div',
	            { className: 'optWrapper', style: { display: 'none' } },
	            this.props.openOrders ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'optText' },
	                'Click here to give permission to Diamonds Direct to sync your private, in-store order status to your online account.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'optText' },
	                'Because your privacy and account security is our top priority, this process may take 3 to 5 business days.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'optText' },
	                'For faster in-store order status, please contact the store in which your purchase was made.'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'optText' },
	                'Click here to give permission to Diamonds Direct to sync your in-store order history to your online account.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'optText' },
	                'Because your privacy and account security is our top priority, this process may take 3 to 5 business days.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'optText' },
	                'For faster in-store order status, please contact the store in which your purchase was made.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'optButton', onClick: this.sendOptMessage.bind(this) },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Opt In'
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'optWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'optText' },
	              'Don\u2019t see your pending order or your order history?  '
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'optText' },
	              'Contact ',
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:online@diamondsdirect.com' },
	                'online@diamondsdirect.com'
	              ),
	              ' or call ',
	              _react2.default.createElement(
	                'a',
	                { href: 'tel:8008855050' },
	                '800.885.5050'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'optText' },
	              'We\u2019re here to help!'
	            )
	          ),
	           false ? _react2.default.createElement(
	            'div',
	            { className: 'openOrdersNotice' },
	            'For orders placed in store, please ',
	            _react2.default.createElement(
	              'span',
	              { className: 'openNoticeLink', onClick: function onClick() {
	                  return _this2.internalNav('locations');
	                } },
	              'contact the store'
	            ),
	            ' in which you made your purchase.'
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.user.orders === null ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_RhinoLoading2.default, null)
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              this.props.user.orders.length === 0 ? _react2.default.createElement(
	                'div',
	                { className: 'nullOrder' },
	                'No orders found.'
	              ) : _react2.default.createElement(
	                'div',
	                null,
	                this.props.user.orders.map(function (order, i) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: _this2.isOrderOpen(order) ? 'orderItem open' : 'orderItem', key: i },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'orderHead' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'ohDate' },
	                        _this2.getShortDate(order.created_at)
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'ohCount' },
	                        _this2.getOrderCount(order)
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'ohNotes' },
	                        _this2.getOrderStatus(order)
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'ohPriceWrapper' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ohPriceSign' },
	                          '$'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ohPriceDollars' },
	                          _this2.getDollars(order.total),
	                          '.'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ohPriceCents' },
	                          _this2.getCents(order.total)
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'ohIconWrapper', onClick: function onClick() {
	                            return _this2.toggleOrderOpen(order);
	                          } },
	                        _this2.isOrderOpen(order) ? _react2.default.createElement(
	                          'div',
	                          null,
	                          '\u2014'
	                        ) : _react2.default.createElement(
	                          'div',
	                          null,
	                          '+'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'orderBody' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'orderBodyWrapper' },
	                        order.items.map(function (product, j) {
	                          return _react2.default.createElement(
	                            'div',
	                            { className: 'productWrapper', key: j },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'prodImageWrapper' },
	                              _react2.default.createElement('img', { src: _this2.getItemImageUrl(product.image) })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'prodNameWrapper' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'prodNamePrimary EllipsisElement' },
	                                product.name.replace(/Ã©/g, 'é')
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'prodNameSku EllipsisElement' },
	                                _react2.default.createElement(
	                                  'strong',
	                                  null,
	                                  'SKU'
	                                ),
	                                ': ',
	                                product.sku
	                              ),
	                              _react2.default.createElement('div', { className: 'prodDescription', dangerouslySetInnerHTML: { __html: _this2.getItemDescription(product) } })
	                            ),
	                            _react2.default.createElement('div', { className: 'prodNotesWrapper' }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'prodPriceWrapper' },
	                              '$',
	                              _this2.getDollars(product.price),
	                              '.',
	                              _this2.getCents(product.price)
	                            )
	                          );
	                        })
	                      )
	                    )
	                  );
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ordersDisclaimer', style: { display: 'none' } },
	                  'Dollar amount reflects price at date of original of purchase. ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'disclaimerLink', onClick: function onClick() {
	                        return _this2.internalNav('appointments');
	                      } },
	                    'Connect with an expert'
	                  ),
	                  ' to place a duplicate order or to request up to date product and pricing information.'
	                )
	              )
	            ),
	             false ? _react2.default.createElement(
	              'div',
	              null,
	              this.props.user.externalOrders === null ? _react2.default.createElement('div', { className: 'noExternal' }) : _react2.default.createElement(
	                'div',
	                { className: 'haveExternal' },
	                this.props.user.externalOrders ? _react2.default.createElement(
	                  'div',
	                  null,
	                  this.props.user.externalOrders.map(function (order, m) {
	
	                    if (order.transaction_type != 'SLC') {
	                      return null;
	                    }
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: _this2.isOrderOpen(order) ? 'orderItem open' : 'orderItem', key: m },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'orderHead' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ohDate' },
	                          _this2.getShortDate(order.transaction_date)
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ohCount' },
	                          _this2.getOrderCount(order)
	                        ),
	                        _react2.default.createElement('div', { className: 'ohNotes', style: { display: 'none' } }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ohPriceWrapper' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'ohPriceSign' },
	                            '$'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'ohPriceDollars' },
	                            _this2.getDollars(order.item_sale_price),
	                            '.'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'ohPriceCents' },
	                            _this2.getCents(order.item_sale_price)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ohIconWrapper', onClick: function onClick() {
	                              return _this2.toggleOrderOpen(order);
	                            } },
	                          _this2.isOrderOpen(order) ? _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u2014'
	                          ) : _react2.default.createElement(
	                            'div',
	                            null,
	                            '+'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'orderBody' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'orderBodyWrapper' },
	                          order.items.map(function (product, n) {
	                            return _react2.default.createElement(
	                              'div',
	                              { className: 'productWrapper', key: n },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'prodImageWrapper' },
	                                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/account/instore.jpg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'prodNameWrapper' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'prodNamePrimary EllipsisElement' },
	                                  _this2.getInStoreDescription(order, m)
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'prodNameSku EllipsisElement' },
	                                  'SKU: ',
	                                  product.item_number
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'prodNotesWrapper inStoreNotes' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'iconsLabel' },
	                                  'Need more help?'
	                                ),
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'emailIcon', href: 'mailto:' + _this2.getStoreEmail(order) },
	                                  _react2.default.createElement('i', { className: "far fa-envelope" })
	                                ),
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'phoneIcon', href: 'tel:' + _this2.getStorePhone(order) },
	                                  _react2.default.createElement('i', { className: 'fas fa-phone' })
	                                )
	                              )
	                            );
	                          })
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'inStoreDisclaimer' },
	                    'Dollar amount reflects price at date of original of purchase. ',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'disclaimerLink', onClick: function onClick() {
	                          return _this2.internalNav('appointments');
	                        } },
	                      'Connect with an expert'
	                    ),
	                    ' to place a duplicate order or to request up to date product and pricing information.'
	                  )
	                ) : null
	              )
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return AccountOrders;
	}(_react2.default.Component);
	
	AccountOrders.propTypes = {
	  location: _react.PropTypes.object
	};
	AccountOrders.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = AccountOrders;
	
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	}
	
	var AccountOrdersContainer = exports.AccountOrdersContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(AccountOrders);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountWishlistContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _itemValidation = __webpack_require__(17);
	
	var _data = __webpack_require__(74);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	var _AntiModal = __webpack_require__(119);
	
	var _AntiModal2 = _interopRequireDefault(_AntiModal);
	
	var _WishlistProduct = __webpack_require__(495);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators, userActionCreators);
	
	var AccountWishlist = function (_React$Component) {
	  _inherits(AccountWishlist, _React$Component);
	
	  function AccountWishlist(props) {
	    _classCallCheck(this, AccountWishlist);
	
	    var _this = _possibleConstructorReturn(this, (AccountWishlist.__proto__ || Object.getPrototypeOf(AccountWishlist)).call(this, props));
	
	    _this.state = {
	
	      requestPending: false,
	      serverError: null,
	
	      sortOpen: false,
	      sortValue: '',
	
	      shareModalOpen: false,
	      shareName: '',
	      shareNameError: null,
	      shareEmail: '',
	      shareEmailError: null,
	      toShareId: null,
	
	      nameOpen: false,
	      nameValue: '',
	      nameError: null,
	
	      confirmModalOpen: false,
	      toDeleteId: null
	    };
	    return _this;
	  }
	
	  _createClass(AccountWishlist, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'fetchWishlists',
	    value: function fetchWishlists() {
	      return this.props.user.wishlists ? this.props.user.wishlists : [];
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'toggleSortOpen',
	    value: function toggleSortOpen() {
	      this.setState({ sortOpen: !this.state.sortOpen });
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(val) {
	      this.setState({ sortValue: val });
	    }
	  }, {
	    key: 'changeShareName',
	    value: function changeShareName(evt) {
	      this.setState({ shareName: evt.target.value });
	    }
	  }, {
	    key: 'validateShareName',
	    value: function validateShareName() {
	      this.setState({ shareNameError: (0, _itemValidation.nameValidation)(this.state.shareName) });
	    }
	  }, {
	    key: 'changeShareEmail',
	    value: function changeShareEmail(evt) {
	      this.setState({ shareEmail: evt.target.value });
	    }
	  }, {
	    key: 'validateShareEmail',
	    value: function validateShareEmail() {
	      this.setState({ shareEmailError: (0, _itemValidation.emailValidation)(this.state.shareEmail) });
	    }
	  }, {
	    key: 'openShareModal',
	    value: function openShareModal(listId) {
	      this.setState({
	        shareModalOpen: true,
	        toShareId: listId
	      });
	    }
	  }, {
	    key: 'closeShareModal',
	    value: function closeShareModal() {
	      this.setState({
	        shareModalOpen: false,
	        shareName: '',
	        shareNameError: null,
	        shareEmail: '',
	        shareEmailError: null,
	        requestPending: false,
	        serverError: null,
	        toShareId: null
	      });
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var nameError = (0, _itemValidation.nameValidation)(this.state.shareName);
	      var emailError = (0, _itemValidation.emailValidation)(this.state.shareEmail);
	
	      this.setState({
	        shareNameError: nameError,
	        shareEmailError: emailError
	      });
	
	      if (nameError === null && emailError === null) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(evt) {
	      var _this2 = this;
	
	      evt.preventDefault();
	      if (this.validateAll()) {
	        this.setState({
	          requestPending: true
	        });
	        this.props.userShareWishlist(this.state.toShareId, this.state.shareName, this.state.shareEmail).then(function () {
	          _this2.props.commonAlert('Wishlist shared!', null);
	          _this2.closeShareModal();
	        });
	      }
	    }
	  }, {
	    key: 'toggleNameOpen',
	    value: function toggleNameOpen() {
	      this.setState({ nameOpen: !this.state.nameOpen });
	    }
	  }, {
	    key: 'changeName',
	    value: function changeName(evt) {
	      this.setState({ nameValue: evt.target.value });
	    }
	  }, {
	    key: 'createWishlist',
	    value: function createWishlist() {
	      var _this3 = this;
	
	      if (!this.state.nameValue) {
	        return;
	      }
	
	      this.toggleNameOpen();
	
	      this.props.userCreateWishlist(this.state.nameValue).then(function (resp) {
	
	        _this3.props.userGetWishlists().then(function (respData) {
	          _this3.props.userSaveWishlists(respData.wishlists);
	        });
	
	        _this3.setState({
	          nameValue: '',
	          nameError: null
	        });
	      });
	    }
	  }, {
	    key: 'deleteList',
	    value: function deleteList(listId) {
	      var _this4 = this;
	
	      if (!listId) {
	        return;
	      }
	
	      this.props.userDeleteWishlist(listId).then(function (resp) {
	        _this4.props.userGetWishlists().then(function (respData) {
	          _this4.props.userSaveWishlists(respData.wishlists);
	        });
	        _this4.closeConfirmModal();
	      });
	    }
	  }, {
	    key: 'openConfirmModal',
	    value: function openConfirmModal(listId) {
	      this.setState({
	        confirmModalOpen: true,
	        toDeleteId: listId
	      });
	    }
	  }, {
	    key: 'closeConfirmModal',
	    value: function closeConfirmModal() {
	      this.setState({
	        confirmModalOpen: false,
	        toDeleteId: null
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AccountWishlist' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sectionTitle' },
	          'Your Wishlists',
	          _react2.default.createElement(
	            'div',
	            { className: this.state.sortOpen ? 'wishlistSortDropdown open' : 'wishlistSortDropdown', onClick: this.toggleSortOpen.bind(this) },
	            _react2.default.createElement(
	              'div',
	              { className: 'wishlistLabel' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wlLabelValue' },
	                'Sort by ',
	                this.state.sortValue
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'wlIcon' },
	                _react2.default.createElement('i', { className: 'fas fa-chevron-right' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'wishlistLabelBody', style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'wishlistLabelBodyWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sortItem', onClick: function onClick() {
	                      return _this5.updateSort('Name');
	                    } },
	                  'Name'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sortItem', onClick: function onClick() {
	                      return _this5.updateSort('Date Created');
	                    } },
	                  'Date Created'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wishlistSectionWrapper' },
	          this.fetchWishlists().length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'nullOrder' },
	            'No wishlists created.'
	          ) : null,
	          this.fetchWishlists().map(function (wishlist, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'wishlistWrapper', key: i },
	              _react2.default.createElement(
	                'div',
	                { className: 'wishlistNameWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'wishlistNameValue' },
	                  wishlist.name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'wishlistShare', onClick: function onClick() {
	                      return _this5.openShareModal(wishlist.id);
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shareIcon' },
	                    _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/account/share.svg' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shareText' },
	                    'Share'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'wishlistDeleteIcon', onClick: function onClick() {
	                      return _this5.openConfirmModal(wishlist.id);
	                    } },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/account/smallx.svg' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'wishlistProductsWrapper' },
	                wishlist.items && wishlist.items.length === 0 ? _react2.default.createElement(
	                  'div',
	                  { className: 'nullOrder' },
	                  'No special pieces yet...'
	                ) : _react2.default.createElement(
	                  'div',
	                  null,
	                  wishlist.items.map(function (product, j) {
	                    return _react2.default.createElement(_WishlistProduct.WishlistProductContainer, {
	                      key: j,
	                      sku: product.sku,
	                      wishlistId: wishlist.id,
	                      itemId: product.id });
	                  })
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'createWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'createLink' },
	            this.state.nameOpen ? _react2.default.createElement(
	              'div',
	              { className: 'createLinkIcon' },
	              '-'
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'createLinkIcon' },
	              '+'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'createLinkValue', onClick: this.toggleNameOpen.bind(this) },
	              'Create new wishlist'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.nameOpen ? 'createForm expanded' : 'createForm' },
	              _react2.default.createElement(
	                'div',
	                { className: 'cfInner' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'cfInput' },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: this.state.nameValue,
	                    onChange: this.changeName.bind(this) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'cfButton', onClick: this.createWishlist.bind(this) },
	                  '+ Add'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _AntiModal2.default,
	          {
	            open: this.state.confirmModalOpen,
	            closeMethod: this.closeConfirmModal.bind(this),
	            resize: this.props.common.modalResize,
	            theme: 'wishlistShare wishlistDeleteConfirm' },
	          _react2.default.createElement(
	            'div',
	            { className: 'shareModalWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'shareClose', onClick: this.closeConfirmModal.bind(this) },
	              _react2.default.createElement(
	                'div',
	                { className: 'closeX' },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shareModalTitle' },
	              'Are you sure?'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shareModalHr' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/account/iconline_1.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shareModalText' },
	              'This action can\'t be undone'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shareButtonWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'shareSecondary', onClick: this.closeConfirmModal.bind(this) },
	                'Cancel'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'sharePrimary', onClick: function onClick() {
	                    return _this5.deleteList(_this5.state.toDeleteId);
	                  } },
	                'Delete'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _AntiModal2.default,
	          {
	            open: this.state.shareModalOpen,
	            closeMethod: this.closeShareModal.bind(this),
	            resize: this.props.common.modalResize,
	            theme: 'wishlistShare' },
	          _react2.default.createElement(
	            'div',
	            { className: 'shareModalWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'shareClose', onClick: this.closeShareModal.bind(this) },
	              _react2.default.createElement(
	                'div',
	                { className: 'closeX' },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shareModalTitle' },
	              'Share Your Wishlist'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shareModalHr' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/account/iconline_1.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shareFormWrapper' },
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.handleSubmit.bind(this), className: 'shareForm' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shareInputRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shareInputLabel' },
	                    'Share With:'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shareInputWrapper' },
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      value: this.state.shareName,
	                      onChange: this.changeShareName.bind(this),
	                      onBlur: this.validateShareName.bind(this),
	                      className: this.state.shareNameError ? 'shareInput error' : 'shareInput',
	                      placeholder: 'Enter Name' })
	                  ),
	                  this.state.shareNameError ? _react2.default.createElement(
	                    'div',
	                    { className: 'shareInputError' },
	                    this.state.shareNameError
	                  ) : null
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shareInputRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shareInputLabel' },
	                    'Email:'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shareInputWrapper' },
	                    _react2.default.createElement('input', {
	                      type: 'email',
	                      value: this.state.shareEmail,
	                      onChange: this.changeShareEmail.bind(this),
	                      onBlur: this.validateShareEmail.bind(this),
	                      className: this.state.shareEmailError ? 'shareInput error' : 'shareInput',
	                      placeholder: 'Enter Email' })
	                  ),
	                  this.state.shareEmailError ? _react2.default.createElement(
	                    'div',
	                    { className: 'shareInputError' },
	                    this.state.shareEmailError
	                  ) : null
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shareInputRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shareSubmitWrapper' },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'submit',
	                        className: 'shareSubmitButton dd2ActionButton',
	                        disabled: this.state.requestPending },
	                      'Share'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AccountWishlist;
	}(_react2.default.Component);
	
	AccountWishlist.propTypes = {
	  location: _react.PropTypes.object
	};
	AccountWishlist.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = AccountWishlist;
	
	
	function mapStateToProps(state) {
	  return {
	    common: state.common,
	    user: state.user
	  };
	}
	
	var AccountWishlistContainer = exports.AccountWishlistContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(AccountWishlist);

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WishlistProductContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _itemValidation = __webpack_require__(17);
	
	var _data = __webpack_require__(74);
	
	var _product = __webpack_require__(42);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../../actions/common';
	
	
	var allActionCreators = Object.assign({}, productActionCreators, userActionCreators);
	
	var WishlistProduct = function (_React$Component) {
	  _inherits(WishlistProduct, _React$Component);
	
	  function WishlistProduct(props) {
	    _classCallCheck(this, WishlistProduct);
	
	    var _this = _possibleConstructorReturn(this, (WishlistProduct.__proto__ || Object.getPrototypeOf(WishlistProduct)).call(this, props));
	
	    _this.state = {
	      product: null
	    };
	    return _this;
	  }
	
	  _createClass(WishlistProduct, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.productFetchBySku(this.props.sku).then(function (respData) {
	        _this2.setState({ product: respData.success });
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'removeFromWishlist',
	    value: function removeFromWishlist() {
	      var _this3 = this;
	
	      this.props.userWishlistRemoveItem(this.props.wishlistId, this.props.itemId).then(function (respData) {
	        _this3.props.userGetWishlists().then(function (respData) {
	          _this3.props.userSaveWishlists(respData.wishlists);
	        });
	      });
	    }
	  }, {
	    key: 'getImageUrl',
	    value: function getImageUrl() {
	      if (!this.state.product && !this.state.product.sku) {
	        return '';
	      }
	      return 'https://dd2-temp-img.s3.amazonaws.com/' + this.state.product.sku + '/0.jpg';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var pName = this.state.product ? this.state.product.name : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'WishlistProduct' },
	        this.state.product === null ? _react2.default.createElement(
	          'div',
	          { className: 'loadingPlaceholder' },
	          _react2.default.createElement(
	            'div',
	            { className: 'lpImg' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/loading.gif' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'lbText' },
	            'Loading'
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'productWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'productImageWrapper', onClick: function onClick() {
	                return _this4.internalNav((0, _product.getWishlistProductUrl)(_this4.state.product));
	              } },
	            _react2.default.createElement('img', { src: this.getImageUrl() })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'productNameWrapper', onClick: function onClick() {
	                return _this4.internalNav((0, _product.getWishlistProductUrl)(_this4.state.product));
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'shareIcon', style: { display: 'none' } },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/account/share.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'productNameValue' },
	              pName.replace(/Ã©/g, 'é')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'productPriceWrapper' },
	            '$',
	            (0, _product.getMinPrice)(this.state.product)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'productNoteWrapper', style: { display: 'none' } },
	            'add note'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'productRemoveIcon', onClick: this.removeFromWishlist.bind(this) },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/account/smallx.svg' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return WishlistProduct;
	}(_react2.default.Component);
	
	WishlistProduct.propTypes = {
	  location: _react.PropTypes.object
	};
	WishlistProduct.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = WishlistProduct;
	
	
	function mapStateToProps(state) {
	  return {
	    common: state.common,
	    user: state.user
	  };
	}
	
	var WishlistProductContainer = exports.WishlistProductContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(WishlistProduct);

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AsSeenContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var AsSeen = function (_React$Component) {
	  _inherits(AsSeen, _React$Component);
	
	  function AsSeen(props) {
	    _classCallCheck(this, AsSeen);
	
	    var _this = _possibleConstructorReturn(this, (AsSeen.__proto__ || Object.getPrototypeOf(AsSeen)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(AsSeen, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AsSeen' },
	        _react2.default.createElement(
	          'div',
	          { className: 'asSeenTitle' },
	          'As Seen In'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'asSeenRow' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowImg imageRight' },
	            _react2.default.createElement('img', { src: 'https://s3.amazonaws.com/dd-website/img/asseen/people.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowBox boxLeft' },
	            _react2.default.createElement(
	              'div',
	              { className: 'assBoxWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxTitle' },
	                'People.com'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxButtonRow' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'assBoxButton',
	                    onClick: function onClick() {
	                      return _this2.openNew('https://people.com/human-interest/wife-renews-vows-with-husband-11-years-after-bachelorette-party-accident-left-her-paralyzed/');
	                    } },
	                  'See the article'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'asSeenRow rightBox' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowImg imageLeft' },
	            _react2.default.createElement('img', { src: 'https://s3.amazonaws.com/dd-website/img/asseen/nytimes.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowBox boxRight' },
	            _react2.default.createElement(
	              'div',
	              { className: 'assBoxWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxTitle' },
	                'New York Times'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxButtonRow' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'assBoxButton', onClick: function onClick() {
	                      return _this2.openNew('https://www.nytimes.com/2020/05/08/fashion/weddings/the-little-wedding-on-the-deck.html');
	                    } },
	                  'See the article'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'asSeenRow' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowImg imageRight' },
	            _react2.default.createElement('img', { src: 'https://s3.amazonaws.com/dd-website/img/asseen/nowweddings.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowBox boxLeft' },
	            _react2.default.createElement(
	              'div',
	              { className: 'assBoxWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxTitle' },
	                'Now Weddings Magazine'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxSubtitle' },
	                'October 2020 Issue'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxButtonRow' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'assBoxButton', onClick: function onClick() {
	                      return _this2.internalNav('setting/SMD1426855');
	                    } },
	                  'Shop similar styles'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'assBoxButton', onClick: function onClick() {
	                      return _this2.openNew('https://issuu.com/nowmagazine504/docs/now_weddings_oct_2020_issue_final');
	                    } },
	                  'See the article'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'asSeenRow rightBox' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowImg imageLeft' },
	            _react2.default.createElement('img', { src: 'https://s3.amazonaws.com/dd-website/img/asseen/independent.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowBox boxRight' },
	            _react2.default.createElement(
	              'div',
	              { className: 'assBoxWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxTitle' },
	                'The Independent'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxSubtitle' },
	                'Tie the Knot Issue'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxButtonRow' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'assBoxButton', onClick: function onClick() {
	                      return _this2.internalNav('setting/SMD1444416');
	                    } },
	                  'Shop similar styles'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'assBoxButton', onClick: function onClick() {
	                      return _this2.openNew('https://issuu.com/kcindependent/docs/08.08.20_bridal_complete');
	                    } },
	                  'See the article'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'asSeenRow' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowImg imageRight' },
	            _react2.default.createElement('img', { src: 'https://s3.amazonaws.com/dd-website/img/asseen/virginia.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowBox boxLeft' },
	            _react2.default.createElement(
	              'div',
	              { className: 'assBoxWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxTitle' },
	                'Virginia Bride Magazine'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxSubtitle' },
	                'Spring 2021 Issue'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxButtonRow' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'assBoxButton', onClick: function onClick() {
	                      return _this2.internalNav('setting/SMD1435151');
	                    } },
	                  'Shop similar styles'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'asSeenRow rightBox' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowImg imageLeft' },
	            _react2.default.createElement('img', { src: 'https://s3.amazonaws.com/dd-website/img/asseen/alabama.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assRowBox boxRight' },
	            _react2.default.createElement(
	              'div',
	              { className: 'assBoxWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxTitle' },
	                'Alabama Weddings Magazine'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxSubtitle' },
	                '20th Anniversary Edition'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'assBoxButtonRow' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'assBoxButton', onClick: function onClick() {
	                      return _this2.internalNav('jewelry/PRLFE00688');
	                    } },
	                  'Shop similar styles'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'assBoxButton', onClick: function onClick() {
	                      return _this2.openNew('https://issuu.com/alabamaweddings/docs/aw21_issu');
	                    } },
	                  'See the article'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AsSeen;
	}(_react2.default.Component);
	
	AsSeen.propTypes = {
	  location: _react.PropTypes.object
	};
	AsSeen.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = AsSeen;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var AsSeenContainer = exports.AsSeenContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(AsSeen);

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.CareersContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Careers = function (_React$Component) {
		_inherits(Careers, _React$Component);
	
		function Careers(props) {
			_classCallCheck(this, Careers);
	
			var _this = _possibleConstructorReturn(this, (Careers.__proto__ || Object.getPrototypeOf(Careers)).call(this, props));
	
			_this.state = {
				buttonSelected: 'humility',
				learnMore: false
			};
			return _this;
		}
	
		_createClass(Careers, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				document.title = 'Diamonds Direct Careers - Engagement Rings, Jewelry, and More';
				document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
			}
		}, {
			key: 'newTabNav',
			value: function newTabNav(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'userNav',
			value: function userNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'selectButton',
			value: function selectButton(val) {
				this.setState({ buttonSelected: val });
			}
		}, {
			key: 'toggleLearnMore',
			value: function toggleLearnMore() {
				this.setState({ learnMore: !this.state.learnMore });
			}
		}, {
			key: 'nextSlide',
			value: function nextSlide() {
				this.sliderObject.slickNext();
			}
		}, {
			key: 'prevSlide',
			value: function prevSlide() {
				this.sliderObject.slickPrev();
			}
		}, {
			key: 'renderRotatingBanner',
			value: function renderRotatingBanner() {
				var _this2 = this;
	
				var settings = {
					dots: false,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					speed: 500,
					autoplaySpeed: 10000,
					cssEase: "linear",
					arrows: false
				};
				return _react2.default.createElement(
					'div',
					{ className: 'familyRotatingBanner' },
					_react2.default.createElement(
						'div',
						{ className: 'bannerLeft', onClick: this.prevSlide.bind(this) },
						_react2.default.createElement('div', { className: 'leftArrow' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'bannerRight', onClick: this.nextSlide.bind(this) },
						_react2.default.createElement('div', { className: 'rightArrow' })
					),
					_react2.default.createElement(
						_reactSlick2.default,
						_extends({ ref: function ref(slider) {
								_this2.sliderObject = slider;
							} }, settings),
						_react2.default.createElement(
							'div',
							{ className: 'rotatingBannerItem' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/careers/family1.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'rotatingBannerItem' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/careers/family2.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'rotatingBannerItem' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/careers/family3.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'rotatingBannerItem' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/careers/family4.jpg' })
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Careers' },
					_react2.default.createElement(
						'div',
						{ className: 'whoWeAreBlock' },
						_react2.default.createElement('div', { className: 'whoWeAreBackground' }),
						_react2.default.createElement(
							'div',
							{ className: 'imageTile' },
							_react2.default.createElement(
								'div',
								{ className: 'imageLabel' },
								'Who We Are'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'copyTile' },
							_react2.default.createElement(
								'div',
								{ className: 'mainCopy' },
								_react2.default.createElement(
									'span',
									{ className: 'textEm' },
									'We are'
								),
								' a rare company in that we exist for our customers. Extraordinary service is the result of anticipating each customer\u2019s unique needs and providing the solution before the customer is even aware of it. Our road to success starts with great people who share a common vision: to create life-long relationships with everyone who walks through our doors. We create this exceptional customer experience by starting with a one-of-a-kind employment experience. We are a family made up of individuals with a like-minded approach to hard work and a diversified way of charging at barriers that stand in our way. When we add in that we are SERIOUS about having FUN, we feel that there is no better place to work! We hope that you will explore an opportunity with us and discover how rewarding it is to be a Rhino on our team!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'copyWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'copyButton', onClick: function onClick() {
											return _this3.newTabNav('https://signetjewelers.wd1.myworkdayjobs.com/en-US/Diamonds_Direct');
										} },
									'We are Hiring!'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'cultureBlock' },
						_react2.default.createElement(
							'div',
							{ className: 'cultureHeader' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/careers/culture.jpg' }),
							_react2.default.createElement(
								'div',
								{ className: 'cultureLabel' },
								'Rhino Culture'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'cultureButtons' },
							_react2.default.createElement(
								'div',
								{ className: 'copyWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'copyTitle' },
									'We call ourselves ',
									_react2.default.createElement(
										'span',
										{ className: 'titleEm' },
										'RHINOS'
									),
									'...'
								),
								_react2.default.createElement(
									'div',
									{ className: 'copyBody' },
									'Being a rhino is being entrepreneurial at heart. It means owning your job and what you accomplish no matter which role you hold within the company. Rhinos have this innate, internal personal drive. Below are some characteristics that we feel capture our rhino spirit.'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'buttonWrapper' },
								_react2.default.createElement('div', {
									className: this.state.buttonSelected == 'humility' ? 'humilityButton cultureButton selected' : 'humilityButton cultureButton',
									onClick: function onClick() {
										return _this3.selectButton('humility');
									} }),
								_react2.default.createElement('div', {
									className: this.state.buttonSelected == 'ethic' ? 'ethicButton cultureButton selected' : 'ethicButton cultureButton',
									onClick: function onClick() {
										return _this3.selectButton('ethic');
									} }),
								_react2.default.createElement('div', {
									className: this.state.buttonSelected == 'passion' ? 'passionButton cultureButton selected' : 'passionButton cultureButton',
									onClick: function onClick() {
										return _this3.selectButton('passion');
									} }),
								_react2.default.createElement('div', {
									className: this.state.buttonSelected == 'ownership' ? 'ownershipButton cultureButton selected' : 'ownershipButton cultureButton',
									onClick: function onClick() {
										return _this3.selectButton('ownership');
									} })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'buttonResults' },
							_react2.default.createElement(
								'div',
								{ className: this.state.buttonSelected == 'humility' ? 'humilityResult buttonResult selected' : 'humilityResult buttonResult' },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										'No one is more important than anyone else. It takes everyone to make this business work.'
									),
									_react2.default.createElement(
										'li',
										null,
										'Admit your mistakes. Failing is how you learn, but you have to admit that you failed to learn the lesson.'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: this.state.buttonSelected == 'ethic' ? 'ethicResult buttonResult selected' : 'ethicResult buttonResult' },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										'Be excited and happy to come to work every day.'
									),
									_react2.default.createElement(
										'li',
										null,
										'Do whatever it takes to get the job done.'
									),
									_react2.default.createElement(
										'li',
										null,
										'"That\u2019s not my job" just does NOT exist here.'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: this.state.buttonSelected == 'passion' ? 'passionResult buttonResult selected' : 'passionResult buttonResult' },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										'Love what you do. It feels a lot less like work when you have a passion for what you do.'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: this.state.buttonSelected == 'ownership' ? 'ownershipResult buttonResult selected' : 'ownershipResult buttonResult' },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										'We all have the same goal and can only exceed our goals by working together.'
									),
									_react2.default.createElement(
										'li',
										null,
										'Do not let anything stand in your way. Work hard and be creative. Rhinos are unstoppable once they start charging.'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'differenceBlock' },
						_react2.default.createElement('img', { className: 'diffDesktop', src: 'https://ddw2.diamondsdirect.com/img/careers/dddif.svg' }),
						_react2.default.createElement('img', { className: 'diffMobile', src: 'https://ddw2.diamondsdirect.com/img/careers/dddif_mobile.jpg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'familyBlock' },
						_react2.default.createElement(
							'div',
							{ className: 'familyTitle' },
							'WE ARE A ',
							_react2.default.createElement(
								'span',
								{ className: 'titleEm' },
								'RHINO'
							),
							' FAMILY'
						),
						_react2.default.createElement(
							'div',
							{ className: 'rotatingBannerWrapper' },
							this.renderRotatingBanner()
						),
						_react2.default.createElement(
							'div',
							{ className: 'familySubtitle' },
							'Get a glimpse into our Rhino Culture! Check us out on:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'familySocialWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'socialIcon', onClick: function onClick() {
										return _this3.newTabNav('https://twitter.com/ddopportunities');
									} },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/careers/twitter.svg' })
							),
							_react2.default.createElement(
								'span',
								null,
								'\xA0&\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'socialIcon', onClick: function onClick() {
										return _this3.newTabNav('https://www.linkedin.com/company/diamonds-direct/');
									} },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/careers/in.svg' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'benefitsBlock' },
						_react2.default.createElement(
							'div',
							{ className: 'benefitsTitle' },
							'Our Benefits'
						),
						_react2.default.createElement(
							'div',
							{ className: 'benefitsText' },
							'At Diamonds Direct, our true strength lies in our passionate, knowledgable and hard working people. We work together, as a team, to create the best shopping experience for our customers. We value each and every team member and offer competitive benefits to our Rhinos.'
						),
						_react2.default.createElement(
							'div',
							{ className: this.state.learnMore ? 'learnMoreBody open' : 'learnMoreBody' },
							_react2.default.createElement(
								'ul',
								null,
								_react2.default.createElement(
									'li',
									null,
									'Competitive Compensation'
								),
								_react2.default.createElement(
									'li',
									null,
									'Bonus Potential'
								),
								_react2.default.createElement(
									'li',
									null,
									'Medical'
								),
								_react2.default.createElement(
									'li',
									null,
									'Health Advocate'
								),
								_react2.default.createElement(
									'li',
									null,
									'Dental'
								),
								_react2.default.createElement(
									'li',
									null,
									'Vision'
								),
								_react2.default.createElement(
									'li',
									null,
									'Life Insurance'
								)
							),
							_react2.default.createElement(
								'ul',
								null,
								_react2.default.createElement(
									'li',
									null,
									'Voluntary Life Insurance'
								),
								_react2.default.createElement(
									'li',
									null,
									'Long-Term Disability'
								),
								_react2.default.createElement(
									'li',
									null,
									'Short-Term Disability'
								),
								_react2.default.createElement(
									'li',
									null,
									'Flexible Spending Account (FSA)'
								),
								_react2.default.createElement(
									'li',
									{ className: 'indent' },
									'Medical'
								),
								_react2.default.createElement(
									'li',
									{ className: 'indent' },
									'Dependent Care'
								),
								_react2.default.createElement(
									'li',
									null,
									'Retirement 401K Plan (with a match)'
								)
							),
							_react2.default.createElement(
								'ul',
								null,
								_react2.default.createElement(
									'li',
									null,
									'Up to 4 Weeks of Paid Time Off'
								),
								_react2.default.createElement(
									'li',
									null,
									'Paid Holidays'
								),
								_react2.default.createElement(
									'li',
									null,
									'Bereavement Leave'
								),
								_react2.default.createElement(
									'li',
									null,
									'Employee Assistance Program'
								),
								_react2.default.createElement(
									'li',
									null,
									'An attractive employee discount'
								),
								_react2.default.createElement(
									'li',
									null,
									'Perks at Work Program'
								),
								_react2.default.createElement(
									'li',
									null,
									'Travel Perks'
								),
								_react2.default.createElement(
									'li',
									null,
									'Relocation Assistance'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'learnMoreToggle', onClick: this.toggleLearnMore.bind(this) },
							this.state.learnMore === false ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'learnMoreText' },
									'Learn More'
								),
								_react2.default.createElement(
									'div',
									{ className: 'learnMoreDownArrow' },
									_react2.default.createElement('i', { className: 'fas fa-chevron-down' })
								)
							) : null,
							this.state.learnMore === true ? _react2.default.createElement(
								'div',
								{ className: 'learnMoreUpArrow' },
								_react2.default.createElement('i', { className: 'fas fa-chevron-up' })
							) : null
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'buttonBlock' },
						_react2.default.createElement(
							'div',
							{ className: 'actionButton jobsButton', onClick: function onClick() {
									return _this3.newTabNav('https://signetjewelers.wd1.myworkdayjobs.com/en-US/Diamonds_Direct');
								} },
							'CHECK OUT OUR JOB OPENINGS'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'buttonSubtext' },
						'If you have questions or need assistance with the job application, please email ',
						_react2.default.createElement(
							'a',
							{ href: 'mailto:careers@diamondsdirect.com' },
							'careers@diamondsdirect.com'
						),
						' or call ',
						_react2.default.createElement(
							'a',
							{ href: 'tel:7045329041' },
							'704-532-9041'
						),
						' and ask to speak with Courtney Love or Kimberly Berry.'
					),
					_react2.default.createElement(
						'div',
						{ className: 'eeoStatement' },
						'Diamonds Direct empowers all of our team members from across the company to make contributions that enhance the employee and customer experience. We are passionate about diversity and inclusion as well as promoting an environment where recruitment, hiring and promotional decisions are made with fondness for our differences.'
					)
				);
			}
		}]);
	
		return Careers;
	}(_react2.default.Component);
	
	Careers.propTypes = {
		location: _react.PropTypes.object
	};
	Careers.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Careers;
	
	
	function mapStateToProps(state) {
		return {
			header: state.header
		};
	}
	
	var CareersContainer = exports.CareersContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Careers);

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContactContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactLazyLoadImageComponent = __webpack_require__(116);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Contact = function (_React$Component) {
	  _inherits(Contact, _React$Component);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, (Contact.__proto__ || Object.getPrototypeOf(Contact)).call(this, props));
	
	    var firstEntry = [{ display: 'Location*', 'value': '' }];
	    var finalEntry = [{ display: 'Virtual/Other', 'value': 'online@diamondsdirect.com' }];
	
	    var newArray = firstEntry.concat(locations.locations).concat(finalEntry);
	
	    _this.state = {
	      locations: newArray,
	      open: _this.props.common.contactOpen,
	      closing: false,
	      inputName: '',
	      inputEmail: '',
	      inputPhone: '',
	      inputLocation: '',
	      inputMessage: '',
	      errorName: null,
	      errorEmail: null,
	      errorPhone: null,
	      errorLocation: null,
	      errorMessage: null,
	      scrollPos: 0
	    };
	
	    _this.getScrollPos = _this.getScrollPos.bind(_this);
	    return _this;
	  }
	
	  _createClass(Contact, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.addEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'getScrollPos',
	    value: function getScrollPos() {
	      this.setState({
	        scrollPos: window.pageYOffset
	      });
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      // acquireIO.max();
	      acquireIO.max();
	    }
	  }, {
	    key: 'getContactClass',
	    value: function getContactClass() {
	      var baseClass = this.state.scrollPos > 30 ? 'Contact scrolled ' : 'Contact ';
	      if (this.state.closing) {
	        return baseClass + 'closing';
	      } else {
	        return this.props.common.contactOpen ? baseClass + 'open' : baseClass + 'closed';
	      }
	    }
	  }, {
	    key: 'getHeaderClass',
	    value: function getHeaderClass() {
	      return this.state.scrollPos > 30 ? 'Header following' : 'Header';
	    }
	  }, {
	    key: 'closeContact',
	    value: function closeContact() {
	      var _this2 = this;
	
	      this.setState({ closing: true });
	      setTimeout(function () {
	        _this2.setState({
	          open: false,
	          closing: false
	        }, function () {
	          _this2.props.commonCloseContact();
	        });
	      }, 500);
	    }
	  }, {
	    key: 'catchClick',
	    value: function catchClick(evt) {
	      evt.stopPropagation();
	    }
	  }, {
	    key: 'changeName',
	    value: function changeName(evt) {
	      var _this3 = this;
	
	      this.setState({ inputName: evt.target.value }, function () {
	        if (_this3.state.errorName && !(0, _itemValidation.nameValidation)(_this3.state.inputName)) {
	          _this3.setState({ errorName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      var _this4 = this;
	
	      this.setState({ inputEmail: evt.target.value }, function () {
	        if (_this4.state.errorEmail && !(0, _itemValidation.emailValidation)(_this4.state.inputEmail)) {
	          _this4.setState({ errorEmail: null });
	        }
	      });
	    }
	  }, {
	    key: 'changePhone',
	    value: function changePhone(evt) {
	      var _this5 = this;
	
	      this.setState({ inputPhone: evt.target.value }, function () {
	        if (_this5.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this5.state.inputPhone)) {
	          _this5.setState({ errorPhone: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeMessage',
	    value: function changeMessage(evt) {
	      var _this6 = this;
	
	      this.setState({ inputMessage: evt.target.value }, function () {
	        if (_this6.state.errorMessage && !(0, _itemValidation.messageTextValidation)(_this6.state.inputMessage)) {
	          _this6.setState({ errorMessage: null });
	        }
	      });
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var hasErrors = true;
	
	      // Required params
	      var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
	      var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
	      var messageError = (0, _itemValidation.messageTextValidation)(this.state.inputMessage);
	      var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
	      // Optional params
	      var phoneError = null;
	      if (this.state.inputPhone) {
	        phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
	      }
	
	      if (nameError === null && emailError === null && phoneError === null && locationError === null && messageError === null) {
	        hasErrors = false;
	      }
	
	      this.setState({
	        errorName: nameError,
	        errorEmail: emailError,
	        errorPhone: phoneError,
	        errorLocation: locationError,
	        errorMessage: messageError
	      });
	
	      return !hasErrors;
	    }
	  }, {
	    key: 'submitContactRequest',
	    value: function submitContactRequest() {
	      if (this.validateAll()) {
	
	        var contactData = {
	          full_name: this.state.inputName,
	          email: this.state.inputEmail,
	          phone: this.state.inputPhone,
	          location: this.state.inputLocation,
	          message: this.state.inputMessage
	        };
	
	        this.props.commonContactRequest(contactData);
	        // this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
	        this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly to finalize your virtual appointment.', 'Continue Browsing', 'helping', '');
	        this.setState({
	          inputName: '',
	          inputEmail: '',
	          inputPhone: '',
	          inputLocation: '',
	          inputMessage: '',
	          errorName: null,
	          errorEmail: null,
	          errorPhone: null,
	          errorLocation: null,
	          errorMessage: null
	        });
	        this.props.commonCloseContact();
	      }
	    }
	
	    // Formerly used with City/State Dropdown
	
	  }, {
	    key: 'selectLocation',
	    value: function selectLocation(evt) {
	      var _this7 = this;
	
	      this.setState({ inputLocation: evt.target.value }, function () {
	        if (_this7.state.errorLocation !== false && location !== '') {
	          _this7.setState({ errorLocation: null });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getContactClass.call(this), onClick: this.closeContact.bind(this) },
	        _react2.default.createElement(
	          'div',
	          { className: 'contactBody', onClick: this.catchClick.bind(this) },
	          _react2.default.createElement(
	            'div',
	            { className: 'closeContact', onClick: this.closeContact.bind(this) },
	            _react2.default.createElement(
	              'div',
	              { className: 'closeX' },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'formLogo' },
	              _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/ddlogowhite.svg', alt: 'Diamonds Direct' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'formBody' },
	              _react2.default.createElement(
	                'div',
	                { className: 'formTitle', style: { display: 'none' } },
	                'We\'d love to hear from you!'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formText' },
	                'Our experts are standing by to help you!'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formText' },
	                'Please fill out the form below to request a virtual or in-store appointment and a member of our team will be in touch with you as soon as possible!'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formRow' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorName ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Full Name*',
	                  value: this.state.inputName,
	                  onChange: this.changeName.bind(this) }),
	                _react2.default.createElement('input', {
	                  className: this.state.errorEmail ? 'textInput error' : 'textInput',
	                  type: 'email',
	                  placeholder: 'Email Address*',
	                  value: this.state.inputEmail,
	                  onChange: this.changeEmail.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formRow' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorPhone ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Telephone',
	                  value: this.state.inputPhone,
	                  onChange: this.changePhone.bind(this) }),
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  selectClass: 'contactSelect',
	                  required: true,
	                  value: this.state.inputLocation,
	                  options: this.state.locations,
	                  changeMethod: function changeMethod(evt) {
	                    return _this8.selectLocation(evt);
	                  },
	                  error: this.state.errorLocation })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formRow' },
	                _react2.default.createElement('textarea', {
	                  className: this.state.errorMessage ? 'textTextarea error' : 'textTextarea',
	                  placeholder: 'How can we help you?',
	                  value: this.state.inputMessage,
	                  onChange: this.changeMessage.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formRow' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'contactSubmit secondaryButton',
	                    onClick: this.submitContactRequest.bind(this) },
	                  'Submit'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formText', style: { marginTop: '15px' } },
	                'We look forward to assisting you!'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'phonePrompt', style: { display: 'none' } },
	              'Call Us: ',
	              _react2.default.createElement(
	                'a',
	                { href: 'tel:8008855050' },
	                '(800) 885.5050'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'chatButton actionButton iconButton', onClick: this.openIntercom.bind(this), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'buttonIcon' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/icons/chat-white.svg' })
	              ),
	              'Chat with Us'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	
	
	function mapStateToProps(state) {
	  return {
	    common: state.common
	  };
	}
	
	var ContactContainer = exports.ContactContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Contact);

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PressContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Press = function (_React$Component) {
	  _inherits(Press, _React$Component);
	
	  function Press(props) {
	    _classCallCheck(this, Press);
	
	    var _this = _possibleConstructorReturn(this, (Press.__proto__ || Object.getPrototypeOf(Press)).call(this, props));
	
	    var firstEntry = [{ display: 'Location*', 'value': '' }];
	    var finalEntry = [{ display: 'Virtual/Other', 'value': 'online@diamondsdirect.com' }];
	
	    var newArray = firstEntry.concat(locations.locations).concat(finalEntry);
	
	    _this.state = {
	      locations: newArray,
	
	      inputName: '',
	      inputEmail: '',
	      inputPhone: '',
	      inputLocation: '',
	      inputMessage: '',
	
	      errorName: null,
	      errorEmail: null,
	      errorPhone: null,
	      errorLocation: null,
	      errorMessage: null
	
	    };
	    return _this;
	  }
	
	  _createClass(Press, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.title = 'Diamonds Direct - Contact Us';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'changeName',
	    value: function changeName(evt) {
	      var _this2 = this;
	
	      this.setState({ inputName: evt.target.value }, function () {
	        if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
	          _this2.setState({ errorName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      var _this3 = this;
	
	      this.setState({ inputEmail: evt.target.value }, function () {
	        if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
	          _this3.setState({ errorEmail: null });
	        }
	      });
	    }
	  }, {
	    key: 'changePhone',
	    value: function changePhone(evt) {
	      var _this4 = this;
	
	      this.setState({ inputPhone: evt.target.value }, function () {
	        if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
	          _this4.setState({ errorPhone: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeLocation',
	    value: function changeLocation(evt) {
	      var _this5 = this;
	
	      this.setState({ inputLocation: evt.target.value }, function () {
	        if (_this5.state.errorLocation !== false && location !== '') {
	          _this5.setState({ errorLocation: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeMessage',
	    value: function changeMessage(evt) {
	      var _this6 = this;
	
	      this.setState({ inputMessage: evt.target.value }, function () {
	        if (_this6.state.errorMessage && !(0, _itemValidation.messageTextValidation)(_this6.state.inputMessage)) {
	          _this6.setState({ errorMessage: null });
	        }
	      });
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var hasErrors = true;
	
	      // Required params
	      var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
	      var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
	      var messageError = (0, _itemValidation.messageTextValidation)(this.state.inputMessage);
	      var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
	      // Optional params
	      var phoneError = null;
	      if (this.state.inputPhone) {
	        phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
	      }
	
	      if (nameError === null && emailError === null && phoneError === null && locationError === null && messageError === null) {
	        hasErrors = false;
	      }
	
	      this.setState({
	        errorName: nameError,
	        errorEmail: emailError,
	        errorPhone: phoneError,
	        errorLocation: locationError,
	        errorMessage: messageError
	      });
	
	      return !hasErrors;
	    }
	  }, {
	    key: 'submitContactRequest',
	    value: function submitContactRequest() {
	      var _this7 = this;
	
	      if (this.validateAll()) {
	
	        var contactData = {
	          full_name: this.state.inputName,
	          email: this.state.inputEmail,
	          phone: this.state.inputPhone,
	          location: this.state.inputLocation,
	          message: this.state.inputMessage
	        };
	
	        this.props.commonPressRequest(contactData).then(function () {
	          // this.context.router.push('/thank-you');
	          _this7.props.commonAlert('Thank you for submitting a inquiry! A member of our team will follow up with you shortly.', 'Continue Browsing', 'helping', '');
	        });
	        this.setState({
	          inputName: '',
	          inputEmail: '',
	          inputPhone: '',
	          inputLocation: '',
	          inputMessage: '',
	          errorName: null,
	          errorEmail: null,
	          errorPhone: null,
	          errorLocation: null,
	          errorMessage: null
	        });
	        this.props.commonCloseContact();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Press', ref: function ref(div) {
	            _this8.parentForm = div;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleHeader' },
	          'Press Inquiry'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleBody' },
	          _react2.default.createElement('div', { className: 'scheduleBr' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbText' },
	            'Thank you for your interest in Diamonds Direct'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbText' },
	            'Please fill out the press inquiry form below and a member of our Public Relations team will be in touch ASAP'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbFormWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'contactPageForm' },
	              _react2.default.createElement(
	                'div',
	                { className: 'formBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'formRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'oneHalfSection' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorName ? 'textInput error' : 'textInput',
	                      type: 'text',
	                      placeholder: 'Full Name*',
	                      value: this.state.inputName,
	                      onChange: this.changeName.bind(this) })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'oneHalfSection' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorEmail ? 'textInput error' : 'textInput',
	                      type: 'email',
	                      placeholder: 'Email Address*',
	                      value: this.state.inputEmail,
	                      onChange: this.changeEmail.bind(this) })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'formRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'oneHalfSection' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorPhone ? 'textInput error' : 'textInput',
	                      type: 'text',
	                      placeholder: 'Telephone',
	                      value: this.state.inputPhone,
	                      onChange: this.changePhone.bind(this) })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'oneHalfSection' },
	                    _react2.default.createElement('input', {
	                      className: this.state.errorLocation ? 'textInput error' : 'textInput',
	                      type: 'text',
	                      placeholder: 'Media Outlet*',
	                      value: this.state.inputLocation,
	                      onChange: this.changeLocation.bind(this) })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'formRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'textareaInputWrapper' },
	                    _react2.default.createElement('textarea', {
	                      className: this.state.errorMessage ? 'textTextarea error' : 'textTextarea',
	                      placeholder: 'The detials of your inquiry, including deadline*',
	                      value: this.state.inputMessage,
	                      onChange: this.changeMessage.bind(this) })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'formRow' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'submitButton actionButton', onClick: this.submitContactRequest.bind(this) },
	                    'Submit'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'scheduleFooterSpacer' })
	      );
	    }
	  }]);
	
	  return Press;
	}(_react2.default.Component);
	
	Press.propTypes = {
	  location: _react.PropTypes.object
	};
	Press.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Press;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var PressContainer = exports.PressContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Press);

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ThankYouContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _AntiModal = __webpack_require__(119);
	
	var _AntiModal2 = _interopRequireDefault(_AntiModal);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var ThankYou = function (_React$Component) {
	    _inherits(ThankYou, _React$Component);
	
	    function ThankYou(props) {
	        _classCallCheck(this, ThankYou);
	
	        var _this = _possibleConstructorReturn(this, (ThankYou.__proto__ || Object.getPrototypeOf(ThankYou)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ThankYou, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.title = 'Diamonds Direct Custom Design';
	            document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	        }
	    }, {
	        key: 'newTabNav',
	        value: function newTabNav(page) {
	            var win = window.open(page, '_blank');
	            win.focus();
	        }
	    }, {
	        key: 'userNav',
	        value: function userNav(page) {
	            window.location.href = '/' + page;
	        }
	    }, {
	        key: 'internalNav',
	        value: function internalNav(page) {
	            this.context.router.push('/' + page);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ThankYou' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'thankYouHeader' },
	                    'Thank You!'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'thankYouBody' },
	                    _react2.default.createElement('div', { className: 'thankYouBr' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tyText' },
	                        'Thank you for submitting an appointment request! A member of our team will follow up shortly to finalize your appointment.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tyText', style: { display: 'none' } },
	                        'A member of our remote team will be in touch with you soon!'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tyButtonRow' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tyButton tyButtonPrimary', onClick: function onClick() {
	                                    return _this2.internalNav('/');
	                                } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                'CONTINUE SHOPPING'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tyButton tyButtonPrimary', onClick: function onClick() {
	                                    return _this2.internalNav('covid-19-updates');
	                                }, style: { display: 'none' } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                'COVID-19 UPDATES'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tyButton', onClick: function onClick() {
	                                    return _this2.userNav('gallery/engagement-rings?tabtype=setting');
	                                }, style: { display: 'none' } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                'SHOP ENGAGEMENT RINGS'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tyButton', onClick: function onClick() {
	                                    return _this2.userNav('gallery/wedding-bands/womens');
	                                }, style: { display: 'none' } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                'SHOP WEDDING BANDS'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tyHoursSection', style: { display: 'none' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tyHoursHeader' },
	                            'Please note, our Customer Service and Sales Hours are:'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tyHoursWrapper' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'tyHoursBlock' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'tyBlockDays' },
	                                    'Monday - Saturday'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'tyBlockHours' },
	                                    '10am to 6pm'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'tyHoursBlock' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'tyBlockDays' },
	                                    'Sunday'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'tyBlockHours' },
	                                    '12pm to 6pm'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tyHoursTimezone' },
	                            '(Eastern Time Zone)'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tyText', style: { display: 'none' } },
	                        'If you\'ve contacted us after hours, we will reach out to you promptly at the start of our next business day.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tyText', style: { display: 'none' } },
	                        'We look forward to assisting you!'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ThankYou;
	}(_react2.default.Component);
	
	ThankYou.propTypes = {
	    location: _react.PropTypes.object
	};
	ThankYou.contextTypes = {
	    store: _react.PropTypes.any,
	    router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ThankYou;
	
	
	function mapStateToProps(state) {
	    return {
	        common: state.common,
	        header: state.header
	    };
	}
	
	var ThankYouContainer = exports.ThankYouContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ThankYou);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideoChatContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var VideoChat = function (_React$Component) {
	  _inherits(VideoChat, _React$Component);
	
	  function VideoChat(props) {
	    _classCallCheck(this, VideoChat);
	
	    var _this = _possibleConstructorReturn(this, (VideoChat.__proto__ || Object.getPrototypeOf(VideoChat)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(VideoChat, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Contact Us';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openVideoChat',
	    value: function openVideoChat() {
	      acquireIO.max('video');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'VideoChat' },
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleHeader' },
	          'Live Video Chat'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleBody' },
	          _react2.default.createElement('div', { className: 'scheduleBr' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'vidWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'vidLeftCol' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/contact/live_video.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'vidRightCol' },
	              _react2.default.createElement(
	                'div',
	                { className: 'vidTitle' },
	                'Welcome to Diamonds Direct Live Video Chat!'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'vidP' },
	                'Diamonds Direct Live Video is a one-of-a-kind experience that connects you face-to-face with a live diamond expert. Whether it\'s from the comfort of your home, office, or even the coffee shop, our diamond experts have the tools to help you make the right decision.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'vidButton', onClick: this.openVideoChat.bind(this) },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Click Here to Speak to an Expert by Video Call'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'vidP' },
	                'When prompted, please allow access to your webcam and microphone for the optimal video chat experience.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'vidLegal' },
	                'We have experts available to connect Monday through Saturday from 10am to 6pm.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'vidMobileImg' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/contact/live_video.jpg' })
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'scheduleFooterSpacer' })
	      );
	    }
	  }]);
	
	  return VideoChat;
	}(_react2.default.Component);
	
	VideoChat.propTypes = {
	  location: _react.PropTypes.object
	};
	VideoChat.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = VideoChat;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var VideoChatContainer = exports.VideoChatContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(VideoChat);

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.CustomDesignContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _AntiModal = __webpack_require__(119);
	
	var _AntiModal2 = _interopRequireDefault(_AntiModal);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var CustomDesign = function (_React$Component) {
		_inherits(CustomDesign, _React$Component);
	
		function CustomDesign(props) {
			_classCallCheck(this, CustomDesign);
	
			var _this = _possibleConstructorReturn(this, (CustomDesign.__proto__ || Object.getPrototypeOf(CustomDesign)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			var locationArray = firstEntry.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				videoModalOpen: false,
				formModalOpen: false,
	
				sliderSettings: {
					dots: false,
					infinite: true,
					slidesToShow: 2,
					slidesToScroll: 2,
					centerMode: false,
					autoplay: true,
					speed: 500,
					autoplaySpeed: 5000,
					cssEase: "linear",
					arrows: false
				},
	
				locations: locationArray,
	
				inputName: '',
				inputLastName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputJewelry: '',
				inputDiamond: '',
				inputMetal: '',
	
				errorName: null,
				errorLastName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorJewelry: null,
				errorDiamond: null,
				errorMetal: null
	
			};
			return _this;
		}
	
		_createClass(CustomDesign, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				document.title = 'Diamonds Direct Custom Design';
				document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
			}
		}, {
			key: 'newTabNav',
			value: function newTabNav(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'userNav',
			value: function userNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'openVideoModal',
			value: function openVideoModal() {
				this.setState({ videoModalOpen: true });
			}
		}, {
			key: 'closeVideoModal',
			value: function closeVideoModal() {
				this.setState({ videoModalOpen: false });
			}
		}, {
			key: 'openFormModal',
			value: function openFormModal() {
				this.setState({ formModalOpen: true });
			}
		}, {
			key: 'closeFormModal',
			value: function closeFormModal() {
				this.setState({ formModalOpen: false });
			}
		}, {
			key: 'nextSlide',
			value: function nextSlide() {
				this.sliderObject.slickNext();
			}
		}, {
			key: 'prevSlide',
			value: function prevSlide() {
				this.sliderObject.slickPrev();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeLastName',
			value: function changeLastName(evt) {
				var _this3 = this;
	
				this.setState({ inputLastName: evt.target.value }, function () {
					if (_this3.state.errorLastName && !(0, _itemValidation.nameValidation)(_this3.state.inputLastName)) {
						_this3.setState({ errorLastName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this4 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this4.state.errorEmail && !(0, _itemValidation.emailValidation)(_this4.state.inputEmail)) {
						_this4.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this5 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this5.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this5.state.inputPhone)) {
						_this5.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this6 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this6.state.errorLocation !== false && _this6.state.inputLocation !== '') {
						_this6.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeJewelry',
			value: function changeJewelry(evt) {
				this.setState({ inputJewelry: evt.target.value });
			}
		}, {
			key: 'changeDiamond',
			value: function changeDiamond(evt) {
				this.setState({ inputDiamond: evt.target.value });
			}
		}, {
			key: 'changeMetal',
			value: function changeMetal(evt) {
				this.setState({ inputMetal: evt.target.value });
			}
		}, {
			key: 'changeMessage',
			value: function changeMessage(evt) {
				this.setState({ inputMessage: evt.target.value }, function () {
					// if(this.state.errorMessage !== false && this.state.inputMessage !== '') {
					// 	this.setState({errorMessage: null});
					// }
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName + this.state.inputLastName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation,
						jewelry: this.state.inputJewelry,
						diamond: this.state.inputDiamond,
						metal: this.state.inputMetal,
						description: this.state.inputMessage
					};
	
					this.props.commonCustomDesignContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping');
					this.setState({
						inputName: '',
						inputLastName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputMessage: '',
						inputJewelry: '',
						inputDiamond: '',
						inputMetal: '',
						formModalOpen: false,
						errorName: null,
						errorLastName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this7 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var lastNameError = (0, _itemValidation.nameValidation)(this.state.inputLastName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorLastName: lastNameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this7.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this8 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'CustomDesign' },
					_react2.default.createElement(
						'div',
						{ className: 'designHeader' },
						'Custom Designs'
					),
					_react2.default.createElement(
						'div',
						{ className: 'designSubheader' },
						_react2.default.createElement(
							'div',
							{ className: 'subheaderDiamond' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/diamond.png' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'subheaderTitle' },
							'Designed with you. Created for you.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'subheaderText' },
							'Designing a custom ring is a simple, easy process. Tell us what you want and our designers & custom design jewelry specialists will bring your inspiration to life!'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'stepsWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'stepTop' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/custom1.png' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'stepBody' },
							_react2.default.createElement(
								'div',
								{ className: 'imgElement rightImg imgOne' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/custom2.png' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'stepElement leftStep stepOne' },
								_react2.default.createElement(
									'div',
									{ className: 'stepNumber' },
									'1'
								),
								_react2.default.createElement(
									'div',
									{ className: 'stepText' },
									'Send us a sketch, links, photos, or write a description of your dream jewelry.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'stepArrow' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/arrow_rp.svg' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'stepElement rightStep stepTwo' },
								_react2.default.createElement(
									'div',
									{ className: 'stepNumber' },
									'2'
								),
								_react2.default.createElement(
									'div',
									{ className: 'stepText' },
									'Our designers will create a 3D design of your ring for you to review and approve.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'stepArrow' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/arrow_lp.svg' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'stepElement leftStep stepThree' },
								_react2.default.createElement(
									'div',
									{ className: 'stepNumber' },
									'3'
								),
								_react2.default.createElement(
									'div',
									{ className: 'stepText' },
									'Once the 3D design is approved, we will create a wax version of the ring using 3D printers.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'stepArrow' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/arrow_rp.svg' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'stepElement rightStep stepFour' },
								_react2.default.createElement(
									'div',
									{ className: 'stepNumber' },
									'4'
								),
								_react2.default.createElement(
									'div',
									{ className: 'stepText' },
									'Upon final approval, we cast your design in the desired metal. The ring is passed on to our goldsmiths, engravers, and diamond setters who hand finish your special creation just as you imagined.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'stepArrow' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/arrow_lp.svg' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'imgElement leftImg imgTwo' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/custom3.png' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'stepBottom' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/custom4.png' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'buttonWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formButton', onClick: this.openFormModal.bind(this) },
							'Let\'s Get Started'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: this.state.formModalOpen ? 'formExpansionWrapper open' : 'formExpansionWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInputWrapper' },
								_react2.default.createElement('input', {
									className: this.state.errorName ? 'textInput error' : 'textInput',
									type: 'text',
									placeholder: 'First Name*',
									value: this.state.inputName,
									onChange: this.changeName.bind(this) })
							),
							_react2.default.createElement(
								'div',
								{ className: 'formInputWrapper' },
								_react2.default.createElement('input', {
									className: this.state.errorLastName ? 'textInput error' : 'textInput',
									type: 'text',
									placeholder: 'Last Name*',
									value: this.state.inputLastName,
									onChange: this.changeLastName.bind(this) })
							),
							_react2.default.createElement(
								'div',
								{ className: 'formInputWrapper' },
								_react2.default.createElement('input', {
									className: this.state.errorEmail ? 'textInput error' : 'textInput',
									type: 'email',
									placeholder: 'Email Address*',
									value: this.state.inputEmail,
									onChange: this.changeEmail.bind(this) })
							),
							_react2.default.createElement(
								'div',
								{ className: 'formInputWrapper' },
								_react2.default.createElement('input', {
									className: this.state.errorPhone ? 'textInput error' : 'textInput',
									type: 'text',
									placeholder: 'Telephone',
									value: this.state.inputPhone,
									onChange: this.changePhone.bind(this) })
							),
							_react2.default.createElement(
								'div',
								{ className: 'formInputWrapper' },
								_react2.default.createElement(_RhinoSelect2.default, {
									selectClass: 'customSelect',
									required: true,
									value: this.state.inputLocation,
									options: this.state.locations,
									changeMethod: function changeMethod(evt) {
										return _this8.changeLocation(evt);
									},
									error: this.state.errorLocation !== null })
							),
							_react2.default.createElement(
								'div',
								{ className: 'formInputWrapper' },
								_react2.default.createElement('input', {
									className: this.state.errorJewelry ? 'textInput error' : 'textInput',
									type: 'text',
									placeholder: 'Jewelry Type',
									value: this.state.inputJewelry,
									onChange: this.changeJewelry.bind(this) })
							),
							_react2.default.createElement(
								'div',
								{ className: 'formInputWrapper' },
								_react2.default.createElement('input', {
									className: this.state.errorDiamond ? 'textInput error' : 'textInput',
									type: 'text',
									placeholder: 'Diamond Shape',
									value: this.state.inputDiamond,
									onChange: this.changeDiamond.bind(this) })
							),
							_react2.default.createElement(
								'div',
								{ className: 'formInputWrapper' },
								_react2.default.createElement('input', {
									className: this.state.errorMetal ? 'textInput error' : 'textInput',
									type: 'text',
									placeholder: 'Metal Type',
									value: this.state.inputMetal,
									onChange: this.changeMetal.bind(this) })
							),
							_react2.default.createElement(
								'div',
								{ className: 'textareaInputWrapper' },
								_react2.default.createElement('textarea', {
									className: this.state.errorMessage ? 'textTextarea error' : 'textTextarea',
									placeholder: 'Design description',
									value: this.state.inputMessage,
									onChange: this.changeMessage.bind(this) })
							),
							_react2.default.createElement(
								'div',
								{ className: 'formActionRow' },
								_react2.default.createElement(
									'button',
									{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
									'Submit Request'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'imagesWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'videoIcon', onClick: this.openVideoModal.bind(this) },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/videoFrame.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'imagesSlider' },
							_react2.default.createElement(
								_reactSlick2.default,
								_extends({ ref: function ref(slider) {
										_this8.sliderObject = slider;
									} }, this.state.sliderSettings),
								_react2.default.createElement(
									'div',
									{ className: 'customDesignBanner rotatingBannerItem gridItem' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/001s.jpg' }),
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/002s.jpg' }),
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/003s.jpg' }),
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/004s.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'customDesignBanner rotatingBannerItem' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/005l.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'customDesignBanner rotatingBannerItem gridItem' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/006s.jpg' }),
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/007s.jpg' }),
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/008s.jpg' }),
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/009s.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'customDesignBanner rotatingBannerItem' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/customdesign/010l.jpg' })
								)
							)
						)
					),
					_react2.default.createElement(
						_AntiModal2.default,
						{
							open: this.state.videoModalOpen,
							closeMethod: this.closeVideoModal.bind(this),
							resize: this.props.common.modalResize,
							theme: 'customDesignVideo' },
						_react2.default.createElement(
							'div',
							{ className: 'closeIcon', onClick: this.closeVideoModal.bind(this) },
							'\xD7'
						),
						this.state.videoModalOpen ? _react2.default.createElement('iframe', { className: 'modalVideo', src: 'https://player.vimeo.com/video/118063536', frameborder: '0', allowfullscreen: true }) : null
					)
				);
			}
		}]);
	
		return CustomDesign;
	}(_react2.default.Component);
	
	CustomDesign.propTypes = {
		location: _react.PropTypes.object
	};
	CustomDesign.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = CustomDesign;
	
	
	function mapStateToProps(state) {
		return {
			common: state.common,
			header: state.header
		};
	}
	
	var CustomDesignContainer = exports.CustomDesignContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(CustomDesign);

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.DesignersContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Designers = function (_React$Component) {
		_inherits(Designers, _React$Component);
	
		function Designers(props) {
			_classCallCheck(this, Designers);
	
			var _this = _possibleConstructorReturn(this, (Designers.__proto__ || Object.getPrototypeOf(Designers)).call(this, props));
	
			_this.state = {
				logoBlock: null,
				bandBlock: null
			};
			return _this;
		}
	
		_createClass(Designers, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				document.title = 'Diamonds Direct Designers';
				document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
			}
		}, {
			key: 'newTabNav',
			value: function newTabNav(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'userNav',
			value: function userNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'scrollToBlock',
			value: function scrollToBlock() {
	
				var target = this.controlBlock;
				if (this.state.logoBlock === 'engagement') {
					target = this.engagementBlock;
				} else if (this.state.logoBlock === 'band') {
					target = this.bandBlock;
				} else if (this.state.logoBlock === 'jewelry') {
					target = this.jewelryBlock;
				}
	
				setTimeout(function () {
					(0, _reactScrollToComponent2.default)(target, {
						offset: -200,
						align: 'top',
						duration: 1000,
						ease: 'inOutCube'
					});
				}, 400);
			}
		}, {
			key: 'scrollToBand',
			value: function scrollToBand() {
	
				var target = this.bandBlock;
				if (this.state.bandBlock === 'hers') {
					target = this.herBlock;
				} else if (this.state.bandBlock === 'his') {
					target = this.hisBlock;
				}
	
				setTimeout(function () {
					(0, _reactScrollToComponent2.default)(target, {
						offset: -200,
						align: 'top',
						duration: 1000,
						ease: 'inOutCube'
					});
				}, 400);
			}
		}, {
			key: 'toggleLogoBlock',
			value: function toggleLogoBlock(key) {
				var _this2 = this;
	
				if (this.state.logoBlock == key) {
					this.setState({ logoBlock: null, bandBlock: null }, function () {
						_this2.scrollToBlock();
					});
				} else {
					this.setState({ logoBlock: key, bandBlock: null }, function () {
						_this2.scrollToBlock();
					});
				}
			}
		}, {
			key: 'toggleBandBlock',
			value: function toggleBandBlock(key) {
				var _this3 = this;
	
				if (this.state.bandBlock == key) {
					this.setState({ bandBlock: null }, function () {
						_this3.scrollToBand();
					});
				} else {
					this.setState({ bandBlock: key }, function () {
						_this3.scrollToBand();
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Designers' },
					_react2.default.createElement(
						'div',
						{ className: 'designersHeader', onClick: function onClick() {
								return _this4.internalNav('designer/diamonds-direct-designs');
							} },
						_react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/designers/newdddbanner_c.jpg' }),
						_react2.default.createElement('img', { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/designers/newdddbanner_mobile.jpg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'dddBanner', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'dddLogoSide' },
							_react2.default.createElement(
								'div',
								{ className: 'dddLogoWrapper' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/dddlogo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'dddTextWrapper' },
								'Introducing our exclusive line of classic and modern jewelry. Only from Diamonds Direct.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'dddImageSide' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/rings.png' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'displayBlock' },
						_react2.default.createElement(
							'div',
							{ className: 'controlsWrapper', ref: function ref(div) {
									_this4.controlBlock = div;
								} },
							_react2.default.createElement(
								'div',
								{
									className: this.state.logoBlock == 'engagement' ? 'controlButton selected' : 'controlButton',
									onClick: function onClick() {
										return _this4.toggleLogoBlock('engagement');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'textWrapper' },
									'See Engagement',
									_react2.default.createElement('br', null),
									'Ring Designers'
								),
								_react2.default.createElement(
									'div',
									{ className: 'arrowWrapper' },
									_react2.default.createElement('div', { className: 'arrowDown' }),
									_react2.default.createElement('div', { className: 'arrowUp' })
								)
							),
							_react2.default.createElement(
								'div',
								{
									className: this.state.logoBlock == 'band' ? 'controlButton selected' : 'controlButton',
									onClick: function onClick() {
										return _this4.toggleLogoBlock('band');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'textWrapper' },
									'See Wedding',
									_react2.default.createElement('br', null),
									'Band Designers'
								),
								_react2.default.createElement(
									'div',
									{ className: 'arrowWrapper' },
									_react2.default.createElement('div', { className: 'arrowDown' }),
									_react2.default.createElement('div', { className: 'arrowUp' })
								)
							),
							_react2.default.createElement(
								'div',
								{
									className: this.state.logoBlock == 'jewelry' ? 'controlButton selected' : 'controlButton',
									onClick: function onClick() {
										return _this4.toggleLogoBlock('jewelry');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'textWrapper' },
									'See Fine Jewelry',
									_react2.default.createElement('br', null),
									'Designers'
								),
								_react2.default.createElement(
									'div',
									{ className: 'arrowWrapper' },
									_react2.default.createElement('div', { className: 'arrowDown' }),
									_react2.default.createElement('div', { className: 'arrowUp' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'displayWrapper' },
							_react2.default.createElement(
								'div',
								{ className: this.state.logoBlock == 'engagement' ? 'ringDesignersWrapper toggleElement open' : 'ringDesignersWrapper toggleElement', ref: function ref(div) {
										_this4.engagementBlock = div;
									} },
								_react2.default.createElement(
									'div',
									{ className: 'logosWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/simon-g-jewelry');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/simong.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/verragio');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/verragio.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/christopher-designs');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/christopher.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/henri-daussi');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/daussi.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/tacori');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/c-gonshor');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/gonshor.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/fana');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/fana.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/artcarved');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/artcarved.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/diamonds-direct-designs');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/dddesigns.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/ses');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/ses.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/classique');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/classique.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/coast-diamond');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/coast.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/sylvie-collection');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/sylvie.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/michael-m');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/michaelm2.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/a-jaffe');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/ajaffe.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/jack-kelege');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/kelege.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/uneek');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/uneek.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/kirk-kara');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/kirkkara.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/jeff-cooper');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/jeffcooper.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/amden');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/amden.jpg' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'closeIcon' },
									_react2.default.createElement(
										'div',
										{ className: 'arrowWrapper' },
										_react2.default.createElement('div', { className: 'closeArrow', onClick: function onClick() {
												return _this4.toggleLogoBlock(null);
											} })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: this.state.logoBlock == 'band' ? 'bandDesignersWrapper toggleElement open' : 'bandDesignersWrapper toggleElement', ref: function ref(div) {
										_this4.bandBlock = div;
									} },
								_react2.default.createElement(
									'div',
									{ className: 'bandsControlWrapper' },
									_react2.default.createElement(
										'div',
										{
											className: this.state.bandBlock == 'hers' ? 'bandControlButton selected' : 'bandControlButton', onClick: function onClick() {
												return _this4.toggleBandBlock('hers');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'bandButtonText' },
											'Bands for Her'
										),
										_react2.default.createElement(
											'div',
											{ className: 'bandButtonImage' },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/herband.png' })
										)
									),
									_react2.default.createElement(
										'div',
										{
											className: this.state.bandBlock == 'his' ? 'bandControlButton selected' : 'bandControlButton', onClick: function onClick() {
												return _this4.toggleBandBlock('his');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'bandButtonText' },
											'Bands for Him'
										),
										_react2.default.createElement(
											'div',
											{ className: 'bandButtonImage' },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/himband.png' })
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: this.state.bandBlock == 'hers' ? 'herBandsWrapper bandToggleElement open' : 'herBandsWrapper bandToggleElement', ref: function ref(div) {
											_this4.herBlock = div;
										} },
									_react2.default.createElement(
										'div',
										{ className: 'logosWrapper' },
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/simon-g-jewelry');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/simong.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/verragio');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/verragio.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/christopher-designs');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/christopher.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/henri-daussi');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/daussi.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/tacori');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/c-gonshor');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/gonshor.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/fana');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/fana.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/artcarved');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/artcarved.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/diamonds-direct-designs');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/dddesigns.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/ses');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/ses.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/classique');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/classique.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/true-romance');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/trueromance.jpg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/coast-diamond');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/coast.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/sylvie-collection');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/sylvie.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/michael-m');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/michaelm2.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/a-jaffe');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/ajaffe.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/jack-kelege');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/kelege.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/uneek');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/uneek.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/kirk-kara');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/kirkkara.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/novell');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/novell.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/jeff-cooper');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/jeffcooper.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/amden');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/amden.jpg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/benchmark');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/benchmark.svg' })
										)
									),
									this.state.bandBlock !== null ? _react2.default.createElement(
										'div',
										{ className: 'closeIcon' },
										_react2.default.createElement(
											'div',
											{ className: 'arrowWrapper' },
											_react2.default.createElement('div', { className: 'closeArrow', onClick: function onClick() {
													return _this4.toggleBandBlock(null);
												} })
										)
									) : null
								),
								_react2.default.createElement(
									'div',
									{ className: this.state.bandBlock == 'his' ? 'hisBandsWrapper bandToggleElement open' : 'hisBandsWrapper bandToggleElement', ref: function ref(div) {
											_this4.hisBlock = div;
										} },
									_react2.default.createElement(
										'div',
										{ className: 'logosWrapper' },
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/simon-g-jewelry');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/simong.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/verragio');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/verragio.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/henri-daussi');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/daussi.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/tacori');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/artcarved');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/artcarved.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/diamonds-direct-designs');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/dddesigns.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/true-romance');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/trueromance.jpg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/furrer-jacot');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/furrerjacot.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/christian-bauer');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/bauer.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/michael-m');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/michaelm2.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/a-jaffe');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/ajaffe.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/novell');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/novell.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/jeff-cooper');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/jeffcooper.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/per-amore');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/peramore.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'logoElement', onClick: function onClick() {
													return _this4.internalNav('designer/benchmark');
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/benchmark.svg' })
										)
									),
									this.state.bandBlock !== null ? _react2.default.createElement(
										'div',
										{ className: 'closeIcon' },
										_react2.default.createElement(
											'div',
											{ className: 'arrowWrapper' },
											_react2.default.createElement('div', { className: 'closeArrow', onClick: function onClick() {
													return _this4.toggleBandBlock(null);
												} })
										)
									) : null
								),
								this.state.bandBlock === null ? _react2.default.createElement(
									'div',
									{ className: 'closeIcon' },
									_react2.default.createElement(
										'div',
										{ className: 'arrowWrapper' },
										_react2.default.createElement('div', { className: 'closeArrow', onClick: function onClick() {
												return _this4.toggleLogoBlock(null);
											} })
									)
								) : null
							),
							_react2.default.createElement(
								'div',
								{ className: this.state.logoBlock == 'jewelry' ? 'jewelryDesignersWrapper toggleElement open' : 'jewelryDesignersWrapper toggleElement', ref: function ref(div) {
										_this4.jewelryBlock = div;
									} },
								_react2.default.createElement(
									'div',
									{ className: 'logosWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/simon-g-jewelry');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/simong.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/christopher-designs');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/christopher.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/tacori');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/fana');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/fana.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/diamonds-direct-designs');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/dddesigns.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/ses');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/ses.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/michael-m');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/michaelm2.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/jack-kelege');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/kelege.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/mastoloni');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/mastoloni.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/uneek');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/uneek.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/pejay');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/pejay.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/amden');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/amden.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'logoElement', onClick: function onClick() {
												return _this4.internalNav('designer/odelia');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/logos/odelia.jpg' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'closeIcon' },
									_react2.default.createElement(
										'div',
										{ className: 'arrowWrapper' },
										_react2.default.createElement('div', { className: 'closeArrow', onClick: function onClick() {
												return _this4.toggleLogoBlock(null);
											} })
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'premierBanner', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'bannerHeader' },
							_react2.default.createElement(
								'div',
								{ className: 'textWrapper' },
								'Our Premier Brands'
							),
							_react2.default.createElement('div', { className: 'underlineWrapper' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'elementWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'premierElement ddd', onClick: function onClick() {
										return _this4.userNav('instantsearchplus/result/?q=diamonds%20direct%20designs');
									} },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/dddlogo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'premierElement tacori', onClick: function onClick() {
										return _this4.userNav('designersbioprod/?dsgnr=Tacori&typ=Bridal');
									} },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/tacorilogo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'premierElement christopher', onClick: function onClick() {
										return _this4.userNav('designersbioprod/?dsgnr=Christopher+Designs&typ=Bridal');
									} },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/christopherlogo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'premierElement verragio', onClick: function onClick() {
										return _this4.userNav('designersbioprod/?dsgnr=Verragio&typ=Bridal');
									} },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/verragiologo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'premierElement henriDaussi', onClick: function onClick() {
										return _this4.userNav('designersbioprod/?dsgnr=Henri+Daussi&typ=Bridal');
									} },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/daussilogo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'premierElement simonG', onClick: function onClick() {
										return _this4.userNav('designersbioprod/?dsgnr=Simon+G.&typ=Bridal');
									} },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/simonglogo.svg' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'bridalBanner', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'bannerHeader' },
							_react2.default.createElement(
								'div',
								{ className: 'textWrapper' },
								'Bridal Designers'
							),
							_react2.default.createElement('div', { className: 'underlineWrapper' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'bannerSubheader' },
							'For the most important day of your life.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'linksWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'linkColumn' },
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=A.Jaffe&typ=Bridal');
										} },
									'A. Jaffe'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('amden');
										} },
									'Amden'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=ArtCarved&typ=Bridal');
										} },
									'Artcarved'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink noLink' },
									'Benchmark'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Coast&typ=Bridal');
										} },
									'Coast'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('instantsearchplus/result/?q=diamonds%20direct%20designs');
										} },
									'DD Designs'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('fana');
										} },
									'Fana'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('furrer-jacot');
										} },
									'Furrer Jacot'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'linkColumn' },
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Jeff+Cooper&typ=Bridal');
										} },
									'Jeff Cooper'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Kirk+Kara&typ=Bridal');
										} },
									'Kirk Kara'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('michael-m');
										} },
									'Michael M'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('novell');
										} },
									'Novell'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Sylvie&typ=Bridal');
										} },
									'Sylvie'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Tacori&typ=Bridal');
										} },
									'Tacori'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('true-romance');
										} },
									'True Romance/Paul'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink noLink' },
									'Winston'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'linkColumn' },
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Christian+Bauer&typ=Bridal');
										} },
									'Christian Bauer'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Christopher+Designs&typ=Bridal');
										} },
									'Christopher Designs'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink noLink' },
									'Classique'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink noLink' },
									'Per Amore'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Gottlieb&typ=Bridal');
										} },
									'Gottlieb'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Henri+Daussi&typ=Bridal');
										} },
									'Henri Daussi'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Jack+Kelege&typ=Bridal');
										} },
									'Jack Kelege'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink fourRow' },
									'\xA0'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'linkColumn' },
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Verragio&typ=Bridal');
										} },
									'Verragio'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=C.+Gonshor&typ=Bridal');
										} },
									'C. Gonshor'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink noLink' },
									'Gabriel'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('pejay');
										} },
									'PeJay'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Uneek&typ=Bridal');
										} },
									'Uneek'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('ses');
										} },
									'SES'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Simon+G.&typ=Bridal');
										} },
									'Simon G'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink fourRow' },
									'\xA0'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'fashionBanner', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'bannerHeader' },
							_react2.default.createElement(
								'div',
								{ className: 'textWrapper' },
								'Fashion Designers'
							),
							_react2.default.createElement('div', { className: 'underlineWrapper' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'bannerSubheader' },
							'A jewelry piece for any occasion.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'linksWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'linkColumn' },
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('amden');
										} },
									'Amden'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('fana');
										} },
									'Fana'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink noLink' },
									'Gabriel'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink fourRow', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Henri+Daussi&typ=Bridal');
										} },
									'Henri Daussi'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'linkColumn' },
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Jack+Kelege&typ=Bridal');
										} },
									'Jack Kelege'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Mastoloni&typ=Fashion');
										} },
									'Mastoloni'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('michael-m');
										} },
									'Michael M'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink fourRow' },
									'\xA0'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'linkColumn' },
								_react2.default.createElement(
									'div',
									{ className: 'designerLink noLink' },
									'Odelia'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('pejay');
										} },
									'PeJay'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('ses');
										} },
									'SES'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink fourRow' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink twoRow', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Henri+Daussi&typ=Bridal');
										} },
									'Henri Daussi'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'linkColumn' },
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Simon+G.&typ=Bridal');
										} },
									'Simon G'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Tacori&typ=Bridal');
										} },
									'Tacori'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink', onClick: function onClick() {
											return _this4.userNav('designersbioprod/?dsgnr=Uneek&typ=Bridal');
										} },
									'Uneek'
								),
								_react2.default.createElement(
									'div',
									{ className: 'designerLink fourRow' },
									'\xA0'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'bottomWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'bottomBlock' },
							_react2.default.createElement(
								'div',
								{ className: 'halfBlock', onClick: function onClick() {
										return _this4.internalNav('custom-design');
									} },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/custom.jpg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'halfBlock', onClick: function onClick() {
										return _this4.openNew('https://diamondsdirecttimepieces.com/');
									} },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/watch.jpg' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'bottomBlock', onClick: function onClick() {
									return _this4.internalNav('appointments');
								} },
							_react2.default.createElement(
								'div',
								{ className: 'fullBlock' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/instore.jpg' }),
								_react2.default.createElement(
									'div',
									{ className: 'imgOverlay' },
									_react2.default.createElement(
										'div',
										{ className: 'overlayTitle' },
										'See a Designer in Store'
									),
									_react2.default.createElement(
										'div',
										{ className: 'overlaySubtitle' },
										'Click Here to Make an Appointment'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Designers;
	}(_react2.default.Component);
	
	Designers.propTypes = {
		location: _react.PropTypes.object
	};
	Designers.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Designers;
	
	
	function mapStateToProps(state) {
		return {
			common: state.common,
			header: state.header
		};
	}
	
	var DesignersContainer = exports.DesignersContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Designers);

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SingleDesignerContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _designerpages = __webpack_require__(611);
	
	var designers = _interopRequireWildcard(_designerpages);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var SingleDesigner = function (_React$Component) {
		_inherits(SingleDesigner, _React$Component);
	
		function SingleDesigner(props) {
			_classCallCheck(this, SingleDesigner);
	
			var _this = _possibleConstructorReturn(this, (SingleDesigner.__proto__ || Object.getPrototypeOf(SingleDesigner)).call(this, props));
	
			var designer = designers.ALL[_this.props.route.designer_code];
			if (!designer) {
				_this.context.router.push('/designers-links');
			}
	
			_this.state = {
				designer: designer
			};
			return _this;
		}
	
		_createClass(SingleDesigner, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (this.state.designer.titleName) {
					document.title = this.state.designer.titleName + ' Engagement & Wedding Rings - Diamonds Direct';
					document.getElementsByTagName("META")[7].content = "Shop Beautiful " + this.state.designer.titleName + " Engagement or Wedding Rings Online or at one of our Nationwide Diamonds Direct Locations!";
				} else {
					document.title = 'Designer Engagement & Wedding Rings - Diamonds Direct';
					document.getElementsByTagName("META")[7].content = "Shop Beautiful Engagement or Wedding Rings Online or at one of our Nationwide Diamonds Direct Locations!";
				}
			}
		}, {
			key: 'newTabNav',
			value: function newTabNav(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'userNav',
			value: function userNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'SingleDesigner' },
					_react2.default.createElement(
						'div',
						{ className: 'designerBanner desktopOnly', style: { backgroundImage: 'url("https://ddw2.diamondsdirect.com/img/designers/singledesigner/desktop/' + this.props.route.designer_code + '_banner.jpg")' } },
						_react2.default.createElement(
							'div',
							{ className: 'bannerOverlay' },
							_react2.default.createElement(
								'div',
								{ className: 'bannerLogo' },
								_react2.default.createElement('img', {
									src: this.state.designer.logoImg ? 'https://ddw2.diamondsdirect.com/img/designers/logos/' + this.state.designer.logoImg : 'https://ddw2.diamondsdirect.com/img/designers/logos/' + this.props.route.designer_code + '.svg',
									style: this.state.designer.logoStyle ? this.state.designer.logoStyle : {} })
							),
							_react2.default.createElement(
								'div',
								{ className: this.state.designer.links ? 'bannerDescription multipleLinks' : 'bannerDescription' },
								this.state.designer.description.map(function (desc, i) {
									return _react2.default.createElement(
										'div',
										{ className: 'descriptionP', key: i },
										desc
									);
								})
							),
							this.state.designer.links ? _react2.default.createElement(
								'div',
								{ className: 'bannerButtons multipleButtons' },
								this.state.designer.links.map(function (linkData, i) {
									return _react2.default.createElement(
										'div',
										{ className: 'onlineButton bannerButton shortButton', key: i },
										_react2.default.createElement(
											'div',
											{ className: 'buttonText', onClick: function onClick() {
													return _this2.userNav(linkData.url);
												} },
											'Shop ',
											linkData.name,
											'\xA0\xA0',
											_react2.default.createElement(
												'span',
												{ className: 'buttonArrow' },
												_react2.default.createElement('i', { className: "fas fa-caret-right" })
											)
										)
									);
								}),
								_react2.default.createElement(
									'div',
									{ className: 'instoreButton bannerButton shortButton' },
									_react2.default.createElement(
										'div',
										{ className: 'buttonText', onClick: function onClick() {
												return _this2.internalNav('locations');
											} },
										'Shop In Store\xA0\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'buttonArrow' },
											_react2.default.createElement('i', { className: "fas fa-caret-right" })
										)
									)
								)
							) : _react2.default.createElement(
								'div',
								{ className: 'bannerButtons' },
								this.state.designer.shopLink ? _react2.default.createElement(
									'div',
									{ className: 'onlineButton bannerButton' },
									_react2.default.createElement(
										'div',
										{ className: 'buttonText', onClick: function onClick() {
												return _this2.internalNav(_this2.state.designer.shopLink);
											} },
										'Shop ',
										this.state.designer.displayName,
										' Online\xA0\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'buttonArrow' },
											_react2.default.createElement('i', { className: "fas fa-caret-right" })
										)
									)
								) : null,
								_react2.default.createElement(
									'div',
									{ className: 'instoreButton bannerButton' },
									_react2.default.createElement(
										'div',
										{ className: 'buttonText', onClick: function onClick() {
												return _this2.internalNav('locations');
											} },
										'Shop ',
										this.state.designer.displayName,
										' In Store\xA0\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'buttonArrow' },
											_react2.default.createElement('i', { className: "fas fa-caret-right" })
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'designerMobileWrapper mobileOnly' },
						_react2.default.createElement(
							'div',
							{ className: 'designerMobileBanner' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/designers/singledesigner/mobile/' + this.props.route.designer_code + '_mobile.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'mobileLogo' },
							_react2.default.createElement('img', { src: this.state.designer.logoImg ? 'https://ddw2.diamondsdirect.com/img/designers/logos/' + this.state.designer.logoImg : 'https://ddw2.diamondsdirect.com/img/designers/logos/' + this.props.route.designer_code + '.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'mobileDescription' },
							this.state.designer.description.map(function (desc, i) {
								return _react2.default.createElement(
									'div',
									{ className: 'descriptionP', key: i },
									desc
								);
							})
						),
						_react2.default.createElement(
							'div',
							{ className: 'mobileButtons' },
							this.state.designer.links ? _react2.default.createElement(
								'div',
								null,
								this.state.designer.links.map(function (linkData, i) {
									return _react2.default.createElement(
										'div',
										{ className: 'mobileOnlineButton mobileBannerButton', key: i },
										_react2.default.createElement(
											'div',
											{ className: 'buttonText', onClick: function onClick() {
													return _this2.userNav(linkData.url);
												} },
											'Shop ',
											linkData.name,
											'\xA0\xA0',
											_react2.default.createElement(
												'span',
												{ className: 'buttonArrow' },
												_react2.default.createElement('i', { className: "fas fa-caret-right" })
											)
										)
									);
								})
							) : _react2.default.createElement(
								'div',
								null,
								this.state.designer.shopLink ? _react2.default.createElement(
									'div',
									{ className: 'mobileOnlineButton mobileBannerButton' },
									_react2.default.createElement(
										'div',
										{ className: 'buttonText', onClick: function onClick() {
												return _this2.userNav(_this2.state.designer.shopLink);
											} },
										'Shop ',
										this.state.designer.displayName,
										' Online\xA0\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'buttonArrow' },
											_react2.default.createElement('i', { className: "fas fa-caret-right" })
										)
									)
								) : null
							),
							_react2.default.createElement(
								'div',
								{ className: 'mobileInstoreButton mobileBannerButton' },
								_react2.default.createElement(
									'div',
									{ className: 'buttonText', onClick: function onClick() {
											return _this2.internalNav('locations');
										} },
									'Shop ',
									this.state.designer.displayName,
									' In Store\xA0\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'buttonArrow' },
										_react2.default.createElement('i', { className: "fas fa-caret-right" })
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return SingleDesigner;
	}(_react2.default.Component);
	
	SingleDesigner.propTypes = {
		location: _react.PropTypes.object
	};
	SingleDesigner.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = SingleDesigner;
	
	
	function mapStateToProps(state) {
		return {
			common: state.common,
			header: state.header
		};
	}
	
	var SingleDesignerContainer = exports.SingleDesignerContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(SingleDesigner);

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DiamondBraceletsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators);
	
	var DiamondBracelets = function (_React$Component) {
	  _inherits(DiamondBracelets, _React$Component);
	
	  function DiamondBracelets(props) {
	    _classCallCheck(this, DiamondBracelets);
	
	    var _this = _possibleConstructorReturn(this, (DiamondBracelets.__proto__ || Object.getPrototypeOf(DiamondBracelets)).call(this, props));
	
	    _this.state = {
	      price1: 2100,
	      price2: 1150,
	
	      carat1: '',
	      carat2: '',
	
	      imageIndex1: null,
	      imageIndex2: null,
	
	      errorCode: '',
	
	      overrideImage2: false,
	
	      loadingButton: null
	    };
	
	    _this.imageList1 = ['tennis-square.jpeg', 'tennis-alt1.jpg', 'tennis-alt2.jpg'];
	
	    _this.imageList2 = ['bangle-square.jpg', 'bangle1.jpg', 'bangle2.jpg'];
	    return _this;
	  }
	
	  _createClass(DiamondBracelets, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'getCW1',
	    value: function getCW1() {
	      return [{
	        display: 'Select Carat Weight',
	        value: ''
	      }, {
	        display: '1.06 ctw',
	        value: 2100
	      }, {
	        display: '2.00 ctw',
	        value: 3200
	      }, {
	        display: '3.00 ctw',
	        value: 4300
	      }, {
	        display: '4.00 ctw',
	        value: 6050
	      }, {
	        display: '5.00 ctw',
	        value: 8000
	      }, {
	        display: '6.00 ctw',
	        value: 8950
	      }, {
	        display: '7.00 ctw',
	        value: 11050
	      }, {
	        display: '8.35 ctw',
	        value: 12500
	      }, {
	        display: '10.20 ctw',
	        value: 19050
	      }];
	    }
	  }, {
	    key: 'getCW2',
	    value: function getCW2() {
	      return [{
	        display: 'Select Carat Weight',
	        value: ''
	      }, {
	        display: '0.35 ctw',
	        value: 1150
	      }, {
	        display: '0.59 ctw',
	        value: 1490
	      }, {
	        display: '1.00 ctw',
	        value: 2480
	      }, {
	        display: '1.50 ctw',
	        value: 3150
	      }, {
	        display: '2.00 ctw',
	        value: 4130
	      }, {
	        display: '3.00 ctw',
	        value: 5720
	      }, {
	        display: '5.20 ctw',
	        value: 10600
	      }];
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'changeCarat1',
	    value: function changeCarat1(evt) {
	      var _this2 = this;
	
	      this.setState({
	        carat1: evt.target.value,
	        imageIndex1: this.state.imageIndex1 === null ? 1 : this.state.imageIndex1
	      }, function () {
	        if (_this2.state.errorCode == 'carat1') {
	          _this2.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'changeCarat2',
	    value: function changeCarat2(evt) {
	      var _this3 = this;
	
	      this.setState({
	        carat2: evt.target.value,
	        imageIndex2: this.state.imageIndex2 === null ? 1 : this.state.imageIndex2
	      }, function () {
	        if (_this3.state.errorCode == 'carat2') {
	          _this3.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'getBraceletImg1',
	    value: function getBraceletImg1(braceletCaratCost) {
	      var currentIndex = this.state.imageIndex1 === null ? 0 : this.state.imageIndex1;
	      return _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/' + this.imageList1[currentIndex] });
	    }
	  }, {
	    key: 'getBraceletImg2',
	    value: function getBraceletImg2(braceletCaratCost) {
	      var currentIndex = this.state.imageIndex2 === null ? 0 : this.state.imageIndex2;
	      return _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/' + this.imageList2[currentIndex] });
	    }
	  }, {
	    key: 'getCaratWeight',
	    value: function getCaratWeight(sku, price) {
	      if (!sku) {
	        return '';
	      }
	
	      var dataBlock = [];
	
	      switch (sku) {
	        case 'DBRTB':
	          dataBlock = this.getCW1();
	          break;
	        case 'DBRBB':
	          dataBlock = this.getCW2();
	          break;
	        default:
	          dataBlock = this.getCW2();
	      }
	
	      for (var i = 0; i < dataBlock.length; i++) {
	        if (dataBlock[i].value == price) {
	          return dataBlock[i].display;
	        }
	      }
	      return '';
	    }
	  }, {
	    key: 'getBraceletDesc',
	    value: function getBraceletDesc(sku, price) {
	      var addSku = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	
	      var diaDesc = '';
	      var caratWeight = this.getCaratWeight(sku, price);
	
	      if (addSku) {
	        diaDesc += '<B>SKU</B>: ' + addSku + '<br />';
	      }
	      if (caratWeight) {
	        diaDesc += '<B>Carat Weight</B>: ' + caratWeight + ' (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)<br />';
	      }
	      diaDesc += '<B>Metal type</B>: 14 karat white gold<br /><B>Color</B>: The average color range for bracelets is G - H<br /><B>Clarity</B>: The average clarity range for bracelets is SI';
	      return diaDesc;
	    }
	  }, {
	    key: 'getASCSkuValue',
	    value: function getASCSkuValue(skuValue) {
	
	      if (skuValue == 'DBRBB' && this.state.carat2) {
	        if (this.state.carat2 == 1150) {
	          return 'GBANG00736';
	        } else if (this.state.carat2 == 1490) {
	          return 'GBANG00594';
	        } else if (this.state.carat2 == 2480) {
	          return 'GBANG00545';
	        } else if (this.state.carat2 == 3150) {
	          return 'GBANG03077';
	        } else if (this.state.carat2 == 4130) {
	          return 'GBANG02332';
	        } else if (this.state.carat2 == 5720) {
	          return 'GBANG03083';
	        } else if (this.state.carat2 == 10600) {
	          return 'GBANG00554';
	        } else {
	          return skuValue;
	        }
	      }
	      return skuValue;
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(sku, caratPrice, code) {
	      var _this4 = this;
	
	      if (!this.state[code]) {
	        this.setState({ errorCode: code });
	        return;
	      }
	
	      this.setState({ loadingButton: code });
	
	      console.log(this.getASCSkuValue(sku));
	      var modifiedSku = this.getASCSkuValue(sku);
	
	      if (sku !== modifiedSku) {
	        this.props.cartGuestAddItem(modifiedSku, this.getBraceletDesc(sku, caratPrice, modifiedSku), caratPrice).then(function (resp) {
	          console.log(resp);
	          _this4.externalNav('checkout/cart');
	        }).catch(function (errResp) {
	          _this4.setState({ loadingButton: null });
	        });
	      } else {
	        // export function cartAddDiamondJewelry(stockNo, sku, carat_mod, diamond_desc) {
	        this.props.cartAddDiamondJewelry(modifiedSku, caratPrice, this.getBraceletDesc(sku, caratPrice)).then(function (resp) {
	          console.log(resp);
	          _this4.externalNav('checkout/cart');
	        }).catch(function (errResp) {
	          _this4.setState({ loadingButton: null });
	        });
	      }
	    }
	  }, {
	    key: 'getToggleStyle',
	    value: function getToggleStyle(orderPrice, suffix) {
	      if (!orderPrice) {
	        return {};
	      } else {
	        return {
	          display: 'block'
	        };
	      }
	    }
	  }, {
	    key: 'increaseImageIndex1',
	    value: function increaseImageIndex1() {
	      var nextIndex = this.state.imageIndex1 === null ? 1 : this.state.imageIndex1 + 1;
	      this.setState({ imageIndex1: nextIndex >= this.imageList1.length ? 0 : nextIndex });
	    }
	  }, {
	    key: 'increaseImageIndex2',
	    value: function increaseImageIndex2() {
	      var nextIndex = this.state.imageIndex2 === null ? 1 : this.state.imageIndex2 + 1;
	      this.setState({ imageIndex2: nextIndex >= this.imageList2.length ? 0 : nextIndex });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DiamondBracelets DiamondPage' },
	        _react2.default.createElement('link', { rel: 'preload', href: 'https://ddw2.diamondsdirect.com/img/diamondpages/products2/tennis-alt1.jpg', as: 'image' }),
	        _react2.default.createElement('link', { rel: 'preload', href: 'https://ddw2.diamondsdirect.com/img/diamondpages/products2/tennis-alt2.jpg', as: 'image' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'dpBreadcrumbs' },
	          'Diamond Bracelets'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dpProductsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'dpProduct' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpItemWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductImg braceletImg' },
	                this.getBraceletImg1(this.state.carat1),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'imageToggle', style: this.getToggleStyle(this.state.carat1, '1'), onClick: function onClick() {
	                      return _this5.increaseImageIndex1();
	                    } },
	                  _react2.default.createElement('i', { className: 'fas fa-exchange-alt' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductTitle' },
	                'Tennis Bracelet'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductConfigElement' },
	                this.state.errorCode == 'carat1' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpErrorMessage' },
	                  'Please select a carat weight'
	                ) : null,
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  options: this.getCW1(),
	                  value: this.state.carat1,
	                  changeMethod: this.changeCarat1.bind(this),
	                  rootClass: 'productSelect' })
	              ),
	              _react2.default.createElement('div', { className: 'dpBr' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpPrice' },
	                '$',
	                (this.state.carat1 ? this.state.carat1 : this.state.price1).toLocaleString()
	              ),
	              this.state.loadingButton == 'carat1' ? _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart dpLoading' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                  '\xA0\xA0\xA0Adding to Cart'
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart', onClick: function onClick() {
	                    return _this5.addToCart('DBRTB', _this5.state.carat1 ? _this5.state.carat1 : _this5.state.price1, 'carat1');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Add to Cart'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dpProduct' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpItemWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductImg braceletImg' },
	                this.getBraceletImg2(this.state.carat2),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'imageToggle', style: this.getToggleStyle(this.state.carat2, '2'), onClick: function onClick() {
	                      return _this5.increaseImageIndex2();
	                    } },
	                  _react2.default.createElement('i', { className: 'fas fa-exchange-alt' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductTitle' },
	                'Bangle Bracelet'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductConfigElement' },
	                this.state.errorCode == 'carat2' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpErrorMessage' },
	                  'Please select a carat weight'
	                ) : null,
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  options: this.getCW2(),
	                  value: this.state.carat2,
	                  changeMethod: this.changeCarat2.bind(this),
	                  rootClass: 'productSelect' })
	              ),
	              _react2.default.createElement('div', { className: 'dpBr' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpPrice' },
	                '$',
	                (this.state.carat2 ? this.state.carat2 : this.state.price2).toLocaleString()
	              ),
	              this.state.loadingButton == 'carat2' ? _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart dpLoading' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                  '\xA0\xA0\xA0Adding to Cart'
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart', onClick: function onClick() {
	                    return _this5.addToCart('DBRBB', _this5.state.carat2 ? _this5.state.carat2 : _this5.state.price2, 'carat2');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Add to Cart'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dpLegal' },
	          '*Please note: All diamond bracelets are set in 14 karat white gold.',
	          _react2.default.createElement('br', null),
	          'The average color range is G - H and the average clarity range is SI',
	          _react2.default.createElement('br', null),
	          'The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%.',
	          _react2.default.createElement('br', null),
	          'The standard length of the Tennis Bracelet is seven inches.',
	          _react2.default.createElement('br', null),
	          'Carat weight reflects the amount of diamonds around the bangle. Some bangles may appear smaller due to the metal to diamond ratio.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'braceletsCustomSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'scWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'braceletsCustomRight' },
	              _react2.default.createElement(
	                'div',
	                { className: 'scTitle' },
	                'Custom Bracelets'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'scBody' },
	                'Diamonds Direct can handcraft a diamond bracelet to meet any expectations! For certified diamonds, fancy colors, or fancy shape diamonds our diamond experts can help select diamonds to make the perfect bracelet.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'scButtonWrapper', onClick: function onClick() {
	                    return _this5.internalNav('custom-design');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'scButton' },
	                  'Create Custom'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DiamondBracelets;
	}(_react2.default.Component);
	
	DiamondBracelets.propTypes = {
	  location: _react.PropTypes.object
	};
	DiamondBracelets.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = DiamondBracelets;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var DiamondBraceletsContainer = exports.DiamondBraceletsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(DiamondBracelets);

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DiamondNecklacesContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators);
	
	var DiamondNecklaces = function (_React$Component) {
	  _inherits(DiamondNecklaces, _React$Component);
	
	  function DiamondNecklaces(props) {
	    _classCallCheck(this, DiamondNecklaces);
	
	    var _this = _possibleConstructorReturn(this, (DiamondNecklaces.__proto__ || Object.getPrototypeOf(DiamondNecklaces)).call(this, props));
	
	    _this.state = {
	
	      input1Metal: '',
	      input1Length: '',
	      input1Carat: '',
	
	      error1Metal: '',
	      error1Length: '',
	      error1Carat: '',
	
	      loadingButton: null,
	
	      imageIndex1: 0,
	
	      imgWrapHeight1: 0
	    };
	
	    _this.imgWrapper1 = null;
	
	    _this.imageList1 = ['flat.png', 'lifestyle.png'];
	
	    _this.metalTypeOptions = [{
	      display: 'Select Metal Color',
	      value: ''
	    }, {
	      display: '14K White Gold',
	      value: 'WG'
	    }, {
	      display: '14K Yellow Gold',
	      value: 'YG'
	    }];
	
	    _this.lengthOptions = [{
	      display: 'Select Necklace Length',
	      value: ''
	    }, {
	      display: '16 inch',
	      value: '16'
	    }, {
	      display: '18 inch',
	      value: '18'
	    }];
	
	    _this.caratOptions = [{
	      display: 'Select Carat Weight',
	      value: ''
	    }, {
	      display: '3.00 ctw',
	      value: 3
	    }, {
	      display: '5.00 ctw',
	      value: 5
	    }, {
	      display: '7.00 ctw',
	      value: 7
	    }, {
	      display: '9.00 ctw',
	      value: 9
	    }];
	
	    _this.info1 = {
	      YG16: [{
	        caratWeight: 3,
	        image: 'NFANC33744.jpg',
	        sku: 'NFANC33744',
	        price: 5750
	      }, {
	        caratWeight: 5,
	        image: 'NFANC33605.jpg',
	        sku: 'NFANC33605',
	        price: 7920
	      }, {
	        caratWeight: 7,
	        image: 'NFANC33753.jpg',
	        sku: 'NFANC33753',
	        price: 9600
	      }, {
	        caratWeight: 9,
	        image: 'NFANC33750.jpg',
	        sku: 'NFANC33750',
	        price: 12600
	      }],
	      YG18: [{
	        caratWeight: 3,
	        image: 'NFANC33599.jpg',
	        sku: 'NFANC33599',
	        price: 5750
	      }, {
	        caratWeight: 5,
	        image: 'NFANC33591.jpg',
	        sku: 'NFANC33591',
	        price: 7920
	      }, {
	        caratWeight: 7,
	        image: 'NFANC33598.jpg',
	        sku: 'NFANC33598',
	        price: 9600
	      }, {
	        caratWeight: 9,
	        image: 'NFANC33594.jpg',
	        sku: 'NFANC33594',
	        price: 12600
	      }],
	      WG16: [{
	        caratWeight: 3,
	        image: 'NFANC33585.jpg',
	        sku: 'NFANC33585',
	        price: 5750
	      }, {
	        caratWeight: 5,
	        image: 'NFANC33588.jpg',
	        sku: 'NFANC33588',
	        price: 7920
	      }, {
	        caratWeight: 7,
	        image: 'NFANC33579.jpg',
	        sku: 'NFANC33579',
	        price: 9600
	      }, {
	        caratWeight: 9,
	        image: 'NFANC33756.jpg',
	        sku: 'NFANC33756',
	        price: 12600
	      }],
	      WG18: [{
	        caratWeight: 3,
	        image: 'NFANC32237.jpg',
	        sku: 'NFANC32237',
	        price: 5750
	      }, {
	        caratWeight: 5,
	        image: 'NFANC29560.jpg',
	        sku: 'NFANC29560',
	        price: 7920
	      }, {
	        caratWeight: 7,
	        image: 'NFANC32240.jpg',
	        sku: 'NFANC32240',
	        price: 9600
	      }, {
	        caratWeight: 9,
	        image: 'NFANC29565.jpg',
	        sku: 'NFANC29565',
	        price: 12600
	      }]
	    };
	
	    _this.imgWrapRef = null;
	
	    _this.checkHeight = _this.checkHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(DiamondNecklaces, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      window.addEventListener('resize', this.checkHeight, false);
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	
	      this.checkHeight();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.checkHeight, false);
	    }
	  }, {
	    key: 'checkHeight',
	    value: function checkHeight() {
	      if (this.imgWrapRef) {
	        try {
	          if (this.imgWrapRef.getBoundingClientRect().height != this.state.imgWrapHeight1 && this.state.imgWrapHeight1 > 200) {
	            this.setState({ imgWrapHeight1: this.imgWrapRef.getBoundingClientRect().height });
	          }
	        } catch (err) {
	          console.error(err);
	        }
	      }
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'changeMetal',
	    value: function changeMetal(evt, idx) {
	      var _this2 = this;
	
	      this.setState({
	        input1Metal: evt.target.value
	      }, function () {
	        if (_this2.state.error1Metal) {
	          _this2.setState({ error1Metal: '' });
	        }
	        if (_this2.state.input1Metal && _this2.state.input1Length && _this2.state.input1Carat) {
	          _this2.setState({ imageIndex1: 2 });
	        }
	      });
	    }
	  }, {
	    key: 'changeLength',
	    value: function changeLength(evt, idx) {
	      var _this3 = this;
	
	      this.setState({
	        input1Length: evt.target.value
	      }, function () {
	        if (_this3.state.error1Length) {
	          _this3.setState({ error1Length: '' });
	        }
	        if (_this3.state.input1Metal && _this3.state.input1Length && _this3.state.input1Carat) {
	          _this3.setState({ imageIndex1: 2 });
	        }
	      });
	    }
	  }, {
	    key: 'changeCarat',
	    value: function changeCarat(evt, idx) {
	      var _this4 = this;
	
	      this.setState({
	        input1Carat: evt.target.value
	      }, function () {
	        if (_this4.state.error1Carat) {
	          _this4.setState({ error1Carat: '' });
	        }
	        if (_this4.state.input1Metal && _this4.state.input1Length && _this4.state.input1Carat) {
	          _this4.setState({ imageIndex1: 2 });
	        }
	      });
	    }
	  }, {
	    key: 'defaultImg',
	    value: function defaultImg() {
	      return _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/necklaces/' + this.imageList1[0] });
	    }
	  }, {
	    key: 'getNecklace1Img',
	    value: function getNecklace1Img() {
	
	      var heightStyle = this.state.imgWrapHeight1 ? { height: this.state.imgWrapHeight1 + 'px' } : {};
	
	      if (this.state.imageIndex1 === 2) {
	        if (this.state.input1Metal && this.state.input1Length && this.state.input1Carat) {
	          var nObj = this.getNecklaceObj();
	          if (nObj.image) {
	            return _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/necklaces/' + nObj.image, style: heightStyle });
	          }
	        } else {
	          return this.defaultImg();
	        }
	      } else {
	        return _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/necklaces/' + this.imageList1[this.state.imageIndex1], style: heightStyle });
	      }
	
	      return this.defaultImg();
	    }
	  }, {
	    key: 'getBraceletDesc',
	    value: function getBraceletDesc(caratWeight) {
	      var addSku = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	
	      var diaDesc = '';
	
	      if (addSku) {
	        diaDesc += '<B>SKU</B>: ' + addSku + '<br />';
	      }
	      if (caratWeight) {
	        diaDesc += '<B>Carat Weight</B>: ' + parseFloat(caratWeight).toFixed(2) + ' (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)<br />';
	      }
	      diaDesc += '<B>Metal type</B>: 14 karat ' + (this.state.input1Metal == 'YG' ? 'yellow' : 'white') + ' gold<br /><B>Chain Length</B>: ' + parseFloat(this.state.input1Length).toFixed(1) + ' in<br /><B>Color</B>: The average color range for necklaces is I - J<br /><B>Clarity</B>: The average clarity range for necklaces is SI';
	      return diaDesc;
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(sku, caratPrice, code) {
	      var _this5 = this;
	
	      if (!this.state.input1Carat) {
	        this.setState({ error1Carat: 'Please select a carat weight' });
	      }
	
	      if (!this.state.input1Length) {
	        this.setState({ error1Length: 'Please select a length' });
	      }
	
	      if (!this.state.input1Metal) {
	        this.setState({ error1Metal: 'Please select a metal type' });
	      }
	
	      var necklaceObj = this.getNecklaceObj();
	      if (!necklaceObj) {
	        return null;
	      }
	
	      // {
	      //       caratWeight: 5,
	      //       image: 'NFANC33591.jpg', 
	      //       sku: 'NFANC33591', 
	      //       price: 7920, 
	      //     },
	
	      this.setState({ loadingButton: code });
	
	      // this.props.cartGuestAddItem(sku, this.getBraceletDesc(necklaceObj.caratWeight, necklaceObj.sku), necklaceObj.price)
	      // .then((resp) => {
	      //   this.externalNav('checkout/cart');
	      // })
	      // .catch((errResp) => {
	      //   this.setState({ loadingButton: null });
	      // });
	
	      this.props.cartAddDiamondJewelry(necklaceObj.sku, necklaceObj.price, this.getBraceletDesc(necklaceObj.caratWeight, necklaceObj.sku)).then(function (resp) {
	        _this5.externalNav('checkout/cart');
	      }).catch(function (errResp) {
	        _this5.setState({ loadingButton: null });
	      });
	    }
	  }, {
	    key: 'getNecklaceObj',
	    value: function getNecklaceObj() {
	
	      if (!this.state.input1Metal || !this.state.input1Length || !this.state.input1Carat) {
	        return null;
	      }
	
	      var dataRef = this.info1;
	      var idx = '' + this.state.input1Metal + this.state.input1Length;
	
	      if (!dataRef[idx]) {
	        return null;
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = dataRef[idx][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var no = _step.value;
	
	          if (parseInt(this.state.input1Carat) && parseInt(this.state.input1Carat) == no.caratWeight) {
	            return no;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'defaultPrice',
	    value: function defaultPrice() {
	      if (!this.state.input1Carat) {
	        return this.info1['YG16'][0].price;
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this.info1['YG16'][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var no = _step2.value;
	
	          if (parseInt(this.state.input1Carat) && parseInt(this.state.input1Carat) == parseInt(no.caratWeight)) {
	            return no.price;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return this.info1['YG16'][0].price;
	    }
	  }, {
	    key: 'getNecklace1Price',
	    value: function getNecklace1Price() {
	      if (!this.state.input1Metal || !this.state.input1Length || !this.state.input1Carat) {
	        return this.defaultPrice();
	      }
	
	      var nObj = this.getNecklaceObj();
	      if (nObj.price) {
	        return nObj.price;
	      }
	
	      return this.defaultPrice();
	    }
	  }, {
	    key: 'rotateImage',
	    value: function rotateImage() {
	      var imgLength = this.state.input1Metal && this.state.input1Length && this.state.input1Carat ? 3 : 2;
	      var newIdx = this.state.imageIndex1 === imgLength - 1 ? 0 : this.state.imageIndex1 + 1;
	      this.setState({
	        imageIndex1: newIdx
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DiamondNecklaces DiamondPage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dPagePreload' },
	          this.imageList1.map(function (img, k) {
	            return _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/necklaces/' + img });
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dpBreadcrumbs' },
	          'Diamond Necklaces'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dpProductsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'dpProduct single' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpItemWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductImg necklaceImg', ref: function ref(div) {
	                    _this6.imgWrapRef = div;
	                  } },
	                this.getNecklace1Img(),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'imageToggle', onClick: function onClick() {
	                      return _this6.rotateImage();
	                    }, style: { display: 'block' } },
	                  _react2.default.createElement('i', { className: 'fas fa-exchange-alt' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductTitle' },
	                'Tennis Necklace'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductConfigElement inline' },
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  options: this.metalTypeOptions,
	                  value: this.state.input1Metal,
	                  changeMethod: function changeMethod(evt) {
	                    return _this6.changeMetal(evt, 1);
	                  },
	                  rootClass: 'productSelect' }),
	                this.state.error1Metal ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpErrorMessage' },
	                  this.state.error1Metal
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductConfigElement inline middle' },
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  options: this.lengthOptions,
	                  value: this.state.input1Length,
	                  changeMethod: function changeMethod(evt) {
	                    return _this6.changeLength(evt, 1);
	                  },
	                  rootClass: 'productSelect' }),
	                this.state.error1Length ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpErrorMessage' },
	                  this.state.error1Length
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductConfigElement inline' },
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  options: this.caratOptions,
	                  value: this.state.input1Carat,
	                  changeMethod: function changeMethod(evt) {
	                    return _this6.changeCarat(evt, 1);
	                  },
	                  rootClass: 'productSelect' }),
	                this.state.error1Carat ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpErrorMessage' },
	                  this.state.error1Carat
	                ) : null
	              ),
	              _react2.default.createElement('div', { className: 'dpBr' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpPrice' },
	                '$',
	                this.getNecklace1Price().toLocaleString()
	              ),
	              this.state.loadingButton == 'carat1' ? _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart dpLoading' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                  '\xA0\xA0\xA0Adding to Cart'
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart', onClick: function onClick() {
	                    return _this6.addToCart('DIATENNECK', _this6.state.carat1 ? _this6.state.carat1 : _this6.state.price1, 'carat1');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Add to Cart'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DiamondNecklaces;
	}(_react2.default.Component);
	
	DiamondNecklaces.propTypes = {
	  location: _react.PropTypes.object
	};
	DiamondNecklaces.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = DiamondNecklaces;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var DiamondNecklacesContainer = exports.DiamondNecklacesContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(DiamondNecklaces);

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DiamondPendantsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators);
	
	var DiamondPendants = function (_React$Component) {
	  _inherits(DiamondPendants, _React$Component);
	
	  function DiamondPendants(props) {
	    _classCallCheck(this, DiamondPendants);
	
	    var _this = _possibleConstructorReturn(this, (DiamondPendants.__proto__ || Object.getPrototypeOf(DiamondPendants)).call(this, props));
	
	    _this.state = {
	      price1: 650,
	      price2: 700,
	      price3: 1200,
	      price4: 690,
	      price5: 990,
	
	      carat1: '',
	      carat2: '',
	      carat3: '',
	      carat4: '',
	      carat5: '',
	
	      errorCode: '',
	
	      loadingButton: null
	    };
	    return _this;
	  }
	
	  _createClass(DiamondPendants, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'getCW1',
	    value: function getCW1() {
	      return [{
	        display: 'Select Carat Weight',
	        value: ''
	      }, {
	        display: '0.25 ctw',
	        value: 650
	      }, {
	        display: '0.30 ctw',
	        value: 850
	      }, {
	        display: '0.50 ctw',
	        value: 1500
	      }, {
	        display: '0.70 ctw',
	        value: 2400
	      }, {
	        display: '1.00 ctw',
	        value: 4500
	      }];
	    }
	  }, {
	    key: 'getCW2',
	    value: function getCW2() {
	      return [{
	        display: 'Select Carat Weight',
	        value: ''
	      }, {
	        display: '0.25 ctw',
	        value: 700
	      }, {
	        display: '0.30 ctw',
	        value: 900
	      }, {
	        display: '0.50 ctw',
	        value: 1600
	      }, {
	        display: '0.70 ctw',
	        value: 2500
	      }, {
	        display: '1.00 ctw',
	        value: 4500
	      }];
	    }
	  }, {
	    key: 'getCW3',
	    value: function getCW3() {
	      return [{
	        display: 'Select Carat Weight',
	        value: ''
	      }, {
	        display: '0.30 ctw',
	        value: 1200
	      }, {
	        display: '0.50 ctw',
	        value: 1950
	      }, {
	        display: '0.70 ctw',
	        value: 3000
	      }, {
	        display: '1.00 ctw',
	        value: 5400
	      }, {
	        display: '1.50 ctw',
	        value: 11500
	      }];
	    }
	  }, {
	    key: 'getCW4',
	    value: function getCW4() {
	      return [{
	        display: 'Select Carat Weight',
	        value: ''
	      }, {
	        display: '0.25 ctw',
	        value: 690
	      }, {
	        display: '0.50 ctw',
	        value: 1210
	      }, {
	        display: '0.75 ctw',
	        value: 2090
	      }, {
	        display: '1.00 ctw',
	        value: 3260
	      }, {
	        display: '1.50 ctw',
	        value: 5600
	      }];
	    }
	  }, {
	    key: 'getCW5',
	    value: function getCW5() {
	      return [{
	        display: 'Select Carat Weight',
	        value: ''
	      }, {
	        display: '0.33 ctw',
	        value: 990
	      }, {
	        display: '0.50 ctw',
	        value: 1280
	      }, {
	        display: '0.80 ctw',
	        value: 2120
	      },
	      // {
	      //   display: '0.90 ctw',
	      //   value: 2850,
	      // },
	      {
	        display: '1.00 ctw',
	        value: 3470
	      }, {
	        display: '1.50 ctw',
	        value: 5300
	      }];
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'changeCarat1',
	    value: function changeCarat1(evt) {
	      var _this2 = this;
	
	      this.setState({ carat1: evt.target.value }, function () {
	        if (_this2.state.errorCode == 'carat1') {
	          _this2.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'changeCarat2',
	    value: function changeCarat2(evt) {
	      var _this3 = this;
	
	      this.setState({ carat2: evt.target.value }, function () {
	        if (_this3.state.errorCode == 'carat2') {
	          _this3.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'changeCarat3',
	    value: function changeCarat3(evt) {
	      var _this4 = this;
	
	      this.setState({ carat3: evt.target.value }, function () {
	        if (_this4.state.errorCode == 'carat3') {
	          _this4.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'changeCarat4',
	    value: function changeCarat4(evt) {
	      var _this5 = this;
	
	      this.setState({ carat4: evt.target.value }, function () {
	        if (_this5.state.errorCode == 'carat4') {
	          _this5.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'changeCarat5',
	    value: function changeCarat5(evt) {
	      var _this6 = this;
	
	      this.setState({ carat5: evt.target.value }, function () {
	        if (_this6.state.errorCode == 'carat5') {
	          _this6.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'getCaratWeight',
	    value: function getCaratWeight(sku, price) {
	      if (!sku) {
	        return '';
	      }
	
	      var dataBlock = [];
	
	      switch (sku) {
	        case 'DPDRD':
	          dataBlock = this.getCW1();
	          break;
	        case 'DPDPS':
	          dataBlock = this.getCW2();
	          break;
	        case 'DPDHA':
	          dataBlock = this.getCW3();
	          break;
	        case 'DPD3RD':
	          dataBlock = this.getCW4();
	          break;
	        case 'DPD3PS':
	          dataBlock = this.getCW5();
	          break;
	      }
	
	      for (var i = 0; i < dataBlock.length; i++) {
	        if (dataBlock[i].value == price) {
	          return dataBlock[i].display;
	        }
	      }
	      return '';
	    }
	  }, {
	    key: 'getPendantDesc',
	    value: function getPendantDesc(sku, price) {
	
	      // Diamond Solitaire Pendant (INTERNAL NOTE FOR WEST: for Round or Princess only)
	      // Shape:
	      // Carat Weight:  (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)
	      // Metal type: 14 karat white gold (INTERNAL NOTE FOR WEST: all pendants will be in 14 karat white gold, special requests will be noted elsewhere for the time being)
	      // Color: The average color range for pendants is I – J
	      // Clarity: The average clarity range for pendants is SI2 - I1
	
	
	      // Round Diamond Halo Pendant
	      // Carat Weight:  (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)
	      // Metal type: 14 karat white gold (INTERNAL NOTE FOR WEST: all pendants will be in 14 karat white gold, special requests will be noted elsewhere for the time being)
	      // Color: The average color range for pendants is I – J
	      // Clarity: The average clarity range for pendants is SI2 - I1
	
	
	      // Graduating Three Stone Pendant INTERNAL NOTE FOR WEST: for Round or Princess only)
	      // Shape:
	      // Carat Weight:  (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)
	      // Metal type: 14 karat white gold (INTERNAL NOTE FOR WEST: all pendants will be in 14 karat white gold, special requests will be noted elsewhere for the time being)
	      // Color: The average color range for pendants is I – J
	      // Clarity: The average clarity range for pendants is SI2 - I1
	
	      var diaDesc = '';
	
	      if (sku == 'DPDRD' || sku == 'DPD3RD') {
	        diaDesc += '<B>Shape</B>: Round<br />';
	      } else if (sku == 'DPDPS' || sku == 'DPD3PS') {
	        diaDesc += '<B>Shape</B>: Princess<br />';
	      }
	
	      var caratWeight = this.getCaratWeight(sku, price);
	      if (caratWeight) {
	        diaDesc += '<B>Carat Weight</B>: ' + caratWeight + ' (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)<br />';
	      }
	
	      diaDesc += '<B>Metal type</B>: 14 karat white gold<br /><B>Color</B>: The average color range for pendants is I – J<br /><B>Clarity</B>: The average clarity range for pendants is SI2 - I1';
	      return diaDesc;
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(sku, caratPrice, code) {
	      var _this7 = this;
	
	      if (!this.state[code]) {
	        this.setState({ errorCode: code });
	        return;
	      }
	
	      this.setState({ loadingButton: code });
	
	      // export function cartAddDiamondJewelry(stockNo, sku, carat_mod, diamond_desc) {
	      this.props.cartAddDiamondJewelry(sku, caratPrice, this.getPendantDesc(sku, caratPrice)).then(function (resp) {
	        console.log(resp);
	        _this7.externalNav('checkout/cart');
	      }).catch(function (errResp) {
	        _this7.setState({ loadingButton: null });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DiamondPendants DiamondPage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dpBreadcrumbs' },
	          'Diamond Pendants'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dpProductsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'dpProduct' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpItemWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/PrincessPendantRound-a.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductTitle' },
	                'Round Solitaire Pendant'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductConfigElement' },
	                this.state.errorCode == 'carat1' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpErrorMessage' },
	                  'Please select a carat weight'
	                ) : null,
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  options: this.getCW1(),
	                  value: this.state.carat1,
	                  changeMethod: this.changeCarat1.bind(this),
	                  rootClass: 'productSelect' })
	              ),
	              _react2.default.createElement('div', { className: 'dpBr' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpPrice' },
	                '$',
	                (this.state.carat1 ? this.state.carat1 : this.state.price1).toLocaleString()
	              ),
	              this.state.loadingButton == 'carat1' ? _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart dpLoading' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                  '\xA0\xA0\xA0Adding to Cart'
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart', onClick: function onClick() {
	                    return _this8.addToCart('DPDRD', _this8.state.carat1 ? _this8.state.carat1 : _this8.state.price1, 'carat1');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Add to Cart'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dpProduct' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpItemWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/PrincessSolPendant-a.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductTitle' },
	                'Princess Solitaire Pendant'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductConfigElement' },
	                this.state.errorCode == 'carat2' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpErrorMessage' },
	                  'Please select a carat weight'
	                ) : null,
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  options: this.getCW2(),
	                  value: this.state.carat2,
	                  changeMethod: this.changeCarat2.bind(this),
	                  rootClass: 'productSelect' })
	              ),
	              _react2.default.createElement('div', { className: 'dpBr' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpPrice' },
	                '$',
	                (this.state.carat2 ? this.state.carat2 : this.state.price2).toLocaleString()
	              ),
	              this.state.loadingButton == 'carat2' ? _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart dpLoading' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                  '\xA0\xA0\xA0Adding to Cart'
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart', onClick: function onClick() {
	                    return _this8.addToCart('DPDPS', _this8.state.carat2 ? _this8.state.carat2 : _this8.state.price2, 'carat2');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Add to Cart'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dpProduct' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpItemWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/products2/halo_pendant.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductTitle' },
	                'Halo Pendant'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductConfigElement' },
	                this.state.errorCode == 'carat3' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpErrorMessage' },
	                  'Please select a carat weight'
	                ) : null,
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  options: this.getCW3(),
	                  value: this.state.carat3,
	                  changeMethod: this.changeCarat3.bind(this),
	                  rootClass: 'productSelect' })
	              ),
	              _react2.default.createElement('div', { className: 'dpBr' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpPrice' },
	                '$',
	                (this.state.carat3 ? this.state.carat3 : this.state.price3).toLocaleString()
	              ),
	              this.state.loadingButton == 'carat3' ? _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart dpLoading' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                  '\xA0\xA0\xA0Adding to Cart'
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart', onClick: function onClick() {
	                    return _this8.addToCart('DPDHA', _this8.state.carat3 ? _this8.state.carat3 : _this8.state.price3, 'carat3');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Add to Cart'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dpProduct' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpItemWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/products/pendant4.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductTitle' },
	                'Graduated 3-Stone Round Pendant'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductConfigElement' },
	                this.state.errorCode == 'carat4' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpErrorMessage' },
	                  'Please select a carat weight'
	                ) : null,
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  options: this.getCW4(),
	                  value: this.state.carat4,
	                  changeMethod: this.changeCarat4.bind(this),
	                  rootClass: 'productSelect' })
	              ),
	              _react2.default.createElement('div', { className: 'dpBr' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpPrice' },
	                '$',
	                (this.state.carat4 ? this.state.carat4 : this.state.price4).toLocaleString()
	              ),
	              this.state.loadingButton == 'carat4' ? _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart dpLoading' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                  '\xA0\xA0\xA0Adding to Cart'
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart', onClick: function onClick() {
	                    return _this8.addToCart('DPD3RD', _this8.state.carat4 ? _this8.state.carat4 : _this8.state.price4, 'carat4');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Add to Cart'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dpProduct' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpItemWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/products/pendant5.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductTitle' },
	                'Graduated 3-Stone Princess Pendant'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductConfigElement' },
	                this.state.errorCode == 'carat5' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpErrorMessage' },
	                  'Please select a carat weight'
	                ) : null,
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  options: this.getCW5(),
	                  value: this.state.carat5,
	                  changeMethod: this.changeCarat5.bind(this),
	                  rootClass: 'productSelect' })
	              ),
	              _react2.default.createElement('div', { className: 'dpBr' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpPrice' },
	                '$',
	                (this.state.carat5 ? this.state.carat5 : this.state.price5).toLocaleString()
	              ),
	              this.state.loadingButton == 'carat5' ? _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart dpLoading' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                  '\xA0\xA0\xA0Adding to Cart'
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart', onClick: function onClick() {
	                    return _this8.addToCart('DPD3PS', _this8.state.carat5 ? _this8.state.carat5 : _this8.state.price5, 'carat5');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Add to Cart'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dpProduct' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpItemWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/pendants_icon.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpProductTitle' },
	                'CUSTOM PENDANTS'
	              ),
	              _react2.default.createElement('div', { className: 'dpBr' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpText' },
	                'Diamonds Direct can handcraft a diamond pendant to meet any expectations! For certified diamonds, fancy colors, or fancy shape diamonds our diamond experts can help select diamonds to make the perfect pendant.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dpAddToCart', onClick: function onClick() {
	                    return _this8.internalNav('custom-design');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Create Custom'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dpLegal' },
	          '*Please note: All diamond pendants are set in 14 karat white gold.',
	          _react2.default.createElement('br', null),
	          'The average color range is I - J and the average clarity range SI2 - I1',
	          _react2.default.createElement('br', null),
	          'The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%.'
	        )
	      );
	    }
	  }]);
	
	  return DiamondPendants;
	}(_react2.default.Component);
	
	DiamondPendants.propTypes = {
	  location: _react.PropTypes.object
	};
	DiamondPendants.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = DiamondPendants;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var DiamondPendantsContainer = exports.DiamondPendantsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(DiamondPendants);

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DiamondStudsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators);
	
	var DiamondStuds = function (_React$Component) {
	  _inherits(DiamondStuds, _React$Component);
	
	  function DiamondStuds(props) {
	    _classCallCheck(this, DiamondStuds);
	
	    var _this = _possibleConstructorReturn(this, (DiamondStuds.__proto__ || Object.getPrototypeOf(DiamondStuds)).call(this, props));
	
	    _this.state = {
	      price1: 380,
	      price1a: 380,
	      price2: 380,
	      price3: 1300,
	
	      carat1: '',
	      carat1a: '',
	      carat2: '',
	      carat3: '',
	
	      prong1: '',
	
	      overrideImage1: false,
	      overrideImage1a: false,
	      overrideImage2: false,
	      overrideImage3: false,
	
	      errorCode: '',
	
	      loadingButton: null
	    };
	    return _this;
	  }
	
	  _createClass(DiamondStuds, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getCW1',
	    value: function getCW1() {
	      return [{
	        display: 'Select Carat Weight',
	        value: ''
	      }, {
	        display: '0.25 ctw',
	        value: 380
	      }, {
	        display: '0.33 ctw',
	        value: 550
	      }, {
	        display: '0.50 ctw',
	        value: 850
	      }, {
	        display: '0.70 ctw',
	        value: 1450
	      }, {
	        display: '1.00 ctw',
	        value: 2500
	      }, {
	        display: '1.40 ctw',
	        value: 4400
	      }, {
	        display: '2.00 ctw',
	        value: 9500
	      }];
	    }
	  }, {
	    key: 'getCW2',
	    value: function getCW2() {
	      return [{
	        display: 'Select Carat Weight',
	        value: ''
	      }, {
	        display: '0.25 ctw',
	        value: 380
	      }, {
	        display: '0.33 ctw',
	        value: 600
	      }, {
	        display: '0.50 ctw',
	        value: 1000
	      }, {
	        display: '0.70 ctw',
	        value: 1750
	      }, {
	        display: '1.00 ctw',
	        value: 3200
	      }, {
	        display: '1.40 ctw',
	        value: 5800
	      }, {
	        display: '2.00 ctw',
	        value: 11500
	      }];
	    }
	  }, {
	    key: 'getCW3',
	    value: function getCW3() {
	      return [{
	        display: 'Select Carat Weight',
	        value: ''
	      }, {
	        display: '0.50 ctw',
	        value: 1300
	      }, {
	        display: '0.75 ctw',
	        value: 1900
	      },
	      // {
	      //   display: '0.95 ctw',
	      //   value: 2400,
	      // },
	      {
	        display: '1.15 ctw',
	        value: 4000
	      }, {
	        display: '1.50 ctw',
	        value: 6000
	      }, {
	        display: '2.00 ctw',
	        value: 12000
	      }];
	    }
	  }, {
	    key: 'getProngs',
	    value: function getProngs() {
	      return [{
	        display: 'Select Prongs',
	        value: ''
	      }, {
	        display: 'Three Prong',
	        value: '3prong'
	      }, {
	        display: 'Four Prong',
	        value: '4prong'
	      }];
	    }
	  }, {
	    key: 'changeCarat1',
	    value: function changeCarat1(evt) {
	      var _this2 = this;
	
	      this.setState({
	        carat1: evt.target.value,
	        overrideImage1: false
	      }, function () {
	        if (_this2.state.errorCode == 'carat1') {
	          _this2.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'changeCarat1a',
	    value: function changeCarat1a(evt) {
	      var _this3 = this;
	
	      this.setState({
	        carat1a: evt.target.value,
	        overrideImage1a: false
	      }, function () {
	        if (_this3.state.errorCode == 'carat1a') {
	          _this3.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'changeCarat2',
	    value: function changeCarat2(evt) {
	      var _this4 = this;
	
	      this.setState({
	        carat2: evt.target.value,
	        overrideImage2: false
	      }, function () {
	        if (_this4.state.errorCode == 'carat2') {
	          _this4.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'changeCarat3',
	    value: function changeCarat3(evt) {
	      var _this5 = this;
	
	      this.setState({
	        carat3: evt.target.value,
	        overrideImage3: false
	      }, function () {
	        if (_this5.state.errorCode == 'carat3') {
	          _this5.setState({ errorCode: '' });
	        }
	      });
	    }
	  }, {
	    key: 'changeProng',
	    value: function changeProng(evt) {
	      this.setState({ prong1: evt.target.value });
	    }
	  }, {
	    key: 'getCaratWeight',
	    value: function getCaratWeight(sku, price) {
	      if (!sku) {
	        return '';
	      }
	
	      var dataBlock = [];
	
	      switch (sku) {
	        case 'DSTRD':
	          dataBlock = this.getCW1();
	          break;
	        case 'DSTRD4':
	          dataBlock = this.getCW1();
	          break;
	        case 'DSTPS':
	          dataBlock = this.getCW2();
	          break;
	        case 'DSTHA':
	          dataBlock = this.getCW3();
	          break;
	      }
	
	      for (var i = 0; i < dataBlock.length; i++) {
	        if (dataBlock[i].value == price) {
	          return dataBlock[i].display;
	        }
	      }
	      return '';
	    }
	  }, {
	    key: 'getStudsDesc',
	    value: function getStudsDesc(sku, price) {
	
	      // Diamond stud earrings (INTERNAL NOTE FOR WEST: for Round or Princess only)  
	      // Shape:
	      // Carat Weight:  (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)
	      // Metal type: 14 karat white gold (INTERNAL NOTE FOR WEST: all studs will be in 14 karat white gold, special requests will be noted elsewhere for the time being)
	      // Color: The average color range for studs is I – J
	      // Clarity: The average clarity range for studs is SI2 - I1
	
	
	      // Round Halo stud earrings
	      // Carat Weight:  (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)
	      // Metal type: 14 karat white gold (INTERNAL NOTE FOR WEST: all studs will be in 14 karat white gold, special requests will be noted elsewhere for the time being)
	      // Color: The average color range for studs is I – J
	      // Clarity: The average clarity range for studs is SI2 - I1
	
	      var diaDesc = '';
	      var colorString = 'H - I';
	      var clarityString = 'I1';
	
	      if (sku == 'DSTRD' || sku == 'DSTRD4') {
	        diaDesc += '<B>Shape</B>: Round<br />';
	        colorString = 'I - J';
	        clarityString = 'I1';
	      } else if (sku == 'DSTPS') {
	        diaDesc += '<B>Shape</B>: Princess<br />';
	        colorString = 'G - H';
	        clarityString = 'VS - SI';
	      }
	
	      var caratWeight = this.getCaratWeight(sku, price);
	      if (caratWeight) {
	        diaDesc += '<B>Carat Weight</B>: ' + caratWeight + ' (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)<br />';
	      }
	
	      diaDesc += '<B>Metal type</B>: 14 karat white gold<br /><B>Color</B>: The average color range for studs is ' + colorString + '<br /><B>Clarity</B>: The average clarity range for studs is ' + clarityString;
	      return diaDesc;
	    }
	  }, {
	    key: 'getStudImage',
	    value: function getStudImage(studCaratCost) {
	
	      if (!studCaratCost || this.state.overrideImage1) {
	        return _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/products2/three_prong_studs.jpg' });
	      }
	
	      return _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/newear.svg' });
	    }
	  }, {
	    key: 'getStud4Image',
	    value: function getStud4Image(studCaratCost) {
	
	      if (!studCaratCost || this.state.overrideImage1a) {
	        return _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/products2/four_prong_studs.jpg' });
	      }
	
	      return _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/newear.svg' });
	    }
	  }, {
	    key: 'getDiamondImageStyle',
	    value: function getDiamondImageStyle(studCaratCost, suffix) {
	
	      var stateKey = 'overrideImage' + suffix;
	
	      if (!studCaratCost || this.state[stateKey]) {
	        return {};
	      }
	
	      // ear-width: 700px
	      // image-width: 2000
	
	      // 1mm = 1.4%
	
	      var builtStyles = {
	        display: 'block'
	      };
	
	      var caratWeight = null;
	
	      switch (parseInt(studCaratCost)) {
	        case 380:
	          caratWeight = 0.25;
	          break;
	        case 550:
	          caratWeight = 0.33;
	          break;
	        case 850:
	          caratWeight = 0.50;
	          break;
	        case 1450:
	          caratWeight = 0.70;
	          break;
	        case 2500:
	          caratWeight = 1.00;
	          break;
	        case 4400:
	          caratWeight = 1.40;
	          break;
	        case 9500:
	          caratWeight = 2.00;
	          break;
	        default:
	          break;
	      }
	
	      var diamondWidth = this.getDiamondSize(caratWeight);
	
	      builtStyles.width = diamondWidth.toString() + '%';
	      builtStyles.height = diamondWidth.toString() + '%';
	      builtStyles.top = (82 - diamondWidth / 2).toString() + '%'; // Stud center: 82%
	      builtStyles.left = (60 - diamondWidth / 2).toString() + '%'; // Stud center 60%
	
	      return builtStyles;
	    }
	
	    // Returns double of size
	
	  }, {
	    key: 'getDiamondSize',
	    value: function getDiamondSize(caratWeight) {
	
	      // Image width: (used jpg) 2000px;
	      // Ear diameter: 700px;
	
	      // let earWidth = 25.0mm;
	      // let oneCtWidth = 6.5mm;
	
	      // d = 6.5(cw)^1.5
	
	      // 6.5 = a(cw)^(2/3)
	
	      // 2r
	
	      // 4/3 pi r^3 = cw
	
	
	      // 0.75*cw = pi r^3
	
	      // 2(0.25*cw)^1/3 = 2r
	
	
	      var widthMM = 6.5 * Math.pow(caratWeight, 0.33333333);
	
	      // 1mm = 1.4%    
	      return widthMM * 1.4;
	    }
	  }, {
	    key: 'getDiamondRadius',
	    value: function getDiamondRadius() {
	      var widthMM = 6.5 * Math.pow(caratWeight, 0.33333333);
	      return widthMM * 1.4 / 2;
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(sku, caratPrice, code) {
	      var _this6 = this;
	
	      if (!caratPrice) {
	        this.setState({ errorCode: code });
	        return;
	      }
	
	      this.setState({ loadingButton: code });
	
	      // export function cartAddDiamondJewelry(stockNo, sku, carat_mod, diamond_desc) {
	      this.props.cartAddDiamondJewelry(sku, caratPrice, this.getStudsDesc(sku, caratPrice)).then(function (resp) {
	        console.log(resp);
	        _this6.externalNav('checkout/cart');
	      }).catch(function (errResp) {
	        _this6.setState({ loadingButton: null });
	      });
	    }
	  }, {
	    key: 'getToggleStyle',
	    value: function getToggleStyle(orderPrice, suffix) {
	      if (!orderPrice) {
	        return {};
	      } else {
	        return {
	          display: 'block'
	        };
	      }
	    }
	  }, {
	    key: 'toggleImageOverride',
	    value: function toggleImageOverride(suffix) {
	
	      var stateKey = 'overrideImage' + suffix;
	
	      this.setState(_defineProperty({}, stateKey, !this.state[stateKey]));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DiamondStuds DiamondPage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dpBreadcrumbs' },
	          'Diamond Studs'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dpProductsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'dpRowWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpProduct' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpItemWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductImg studSizing' },
	                  this.getStudImage(this.state.carat1),
	                  _react2.default.createElement('div', { className: 'diamondPositioning', style: this.getDiamondImageStyle(this.state.carat1, '1') }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'imageToggle', style: this.getToggleStyle(this.state.carat1, '1'), onClick: function onClick() {
	                        return _this7.toggleImageOverride('1');
	                      } },
	                    _react2.default.createElement('i', { className: 'fas fa-exchange-alt' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductTitle' },
	                  'Round Three-Prong Studs'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductConfigElement' },
	                  this.state.errorCode == 'carat1' ? _react2.default.createElement(
	                    'div',
	                    { className: 'dpErrorMessage' },
	                    'Please select a carat weight'
	                  ) : null,
	                  _react2.default.createElement(_RhinoSelect2.default, {
	                    options: this.getCW1(),
	                    value: this.state.carat1,
	                    changeMethod: this.changeCarat1.bind(this),
	                    rootClass: 'productSelect' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductConfigElement', style: { display: 'none' } },
	                  _react2.default.createElement(_RhinoSelect2.default, {
	                    options: this.getProngs(),
	                    value: this.state.prong1,
	                    changeMethod: this.changeProng.bind(this),
	                    rootClass: 'productSelect' })
	                ),
	                _react2.default.createElement('div', { className: 'dpBr' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpPrice' },
	                  '$',
	                  (this.state.carat1 ? this.state.carat1 : this.state.price1).toLocaleString()
	                ),
	                this.state.loadingButton == 'carat1' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpAddToCartAAA dpLoading' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                    '\xA0\xA0\xA0Adding to Cart'
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'dpAddToCart', onClick: function onClick() {
	                      return _this7.addToCart('DSTRD', _this7.state.carat1, 'carat1');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Add to Cart'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'dpProduct' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpItemWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductImg studSizing' },
	                  this.getStud4Image(this.state.carat1a),
	                  _react2.default.createElement('div', { className: 'diamondPositioning', style: this.getDiamondImageStyle(this.state.carat1a, '1a') }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'imageToggle', style: this.getToggleStyle(this.state.carat1a, '1a'), onClick: function onClick() {
	                        return _this7.toggleImageOverride('1a');
	                      } },
	                    _react2.default.createElement('i', { className: 'fas fa-exchange-alt' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductTitle' },
	                  'Round Four-Prong Studs'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductConfigElement' },
	                  this.state.errorCode == 'carat1a' ? _react2.default.createElement(
	                    'div',
	                    { className: 'dpErrorMessage' },
	                    'Please select a carat weight'
	                  ) : null,
	                  _react2.default.createElement(_RhinoSelect2.default, {
	                    options: this.getCW1(),
	                    value: this.state.carat1a,
	                    changeMethod: this.changeCarat1a.bind(this),
	                    rootClass: 'productSelect' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductConfigElement', style: { display: 'none' } },
	                  _react2.default.createElement(_RhinoSelect2.default, {
	                    options: this.getProngs(),
	                    value: this.state.prong1,
	                    changeMethod: this.changeProng.bind(this),
	                    rootClass: 'productSelect' })
	                ),
	                _react2.default.createElement('div', { className: 'dpBr' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpPrice' },
	                  '$',
	                  (this.state.carat1a ? this.state.carat1a : this.state.price1a).toLocaleString()
	                ),
	                this.state.loadingButton == 'carat1a' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpAddToCartAAA dpLoading' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                    '\xA0\xA0\xA0Adding to Cart'
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'dpAddToCart', onClick: function onClick() {
	                      return _this7.addToCart('DSTRD4', _this7.state.carat1a, 'carat1a');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Add to Cart'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dpRowWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dpProduct' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpItemWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/products2/princess_studs.jpg' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductTitle' },
	                  'Princess Studs'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductConfigElement' },
	                  this.state.errorCode == 'carat2' ? _react2.default.createElement(
	                    'div',
	                    { className: 'dpErrorMessage' },
	                    'Please select a carat weight'
	                  ) : null,
	                  _react2.default.createElement(_RhinoSelect2.default, {
	                    options: this.getCW2(),
	                    value: this.state.carat2,
	                    changeMethod: this.changeCarat2.bind(this),
	                    rootClass: 'productSelect' })
	                ),
	                _react2.default.createElement('div', { className: 'dpBr' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpPrice' },
	                  '$',
	                  (this.state.carat2 ? this.state.carat2 : this.state.price2).toLocaleString()
	                ),
	                this.state.loadingButton == 'carat2' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpAddToCart dpLoading' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                    '\xA0\xA0\xA0Adding to Cart'
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'dpAddToCart', onClick: function onClick() {
	                      return _this7.addToCart('DSTPS', _this7.state.carat2, 'carat2');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Add to Cart'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'dpProduct' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dpItemWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/products2/halo_studs.jpg' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductTitle' },
	                  'Round Halo Studs'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpProductConfigElement' },
	                  this.state.errorCode == 'carat3' ? _react2.default.createElement(
	                    'div',
	                    { className: 'dpErrorMessage' },
	                    'Please select a carat weight'
	                  ) : null,
	                  _react2.default.createElement(_RhinoSelect2.default, {
	                    options: this.getCW3(),
	                    value: this.state.carat3,
	                    changeMethod: this.changeCarat3.bind(this),
	                    rootClass: 'productSelect' })
	                ),
	                _react2.default.createElement('div', { className: 'dpBr' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dpPrice' },
	                  '$',
	                  (this.state.carat3 ? this.state.carat3 : this.state.price3).toLocaleString()
	                ),
	                this.state.loadingButton == 'carat3' ? _react2.default.createElement(
	                  'div',
	                  { className: 'dpAddToCart dpLoading' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                    '\xA0\xA0\xA0Adding to Cart'
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'dpAddToCart', onClick: function onClick() {
	                      return _this7.addToCart('DSTHA', _this7.state.carat3, 'carat3');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Add to Cart'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dpLegal' },
	          '*Please note: All diamond studs are set in 14 karat white gold.',
	          _react2.default.createElement('br', null),
	          'The average color range for round studs is I - J and the average clarity range I1.',
	          _react2.default.createElement('br', null),
	          'The average color range for princess studs is G \u2013 H and the clarity range is VS-SI.',
	          _react2.default.createElement('br', null),
	          'The average color range for round halo studs is H-I and average clarity is I1.',
	          _react2.default.createElement('br', null),
	          'Please chat in or ',
	          _react2.default.createElement(
	            'a',
	            { href: '/contact-us' },
	            'contact us'
	          ),
	          ' to purchase studs of a different quality.',
	          _react2.default.createElement('br', null),
	          'The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'studsCustomSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'scWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'studsCustomLeft' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/diamondpages/studs_icon.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'studsCustomRight' },
	              _react2.default.createElement(
	                'div',
	                { className: 'scTitle' },
	                'Custom Studs'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'scBody' },
	                'Diamonds Direct can handcraft diamond studs to meet any expectations! For certified diamonds, fancy colors, or fancy shape diamonds our diamond experts can help select diamond to make the perfect pair of earrings.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'scButtonWrapper', onClick: function onClick() {
	                    return _this7.internalNav('custom-design');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'scButton' },
	                  'Create Custom'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DiamondStuds;
	}(_react2.default.Component);
	
	DiamondStuds.propTypes = {
	  location: _react.PropTypes.object
	};
	DiamondStuds.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = DiamondStuds;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var DiamondStudsContainer = exports.DiamondStudsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(DiamondStuds);

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EducationConflictContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var EducationConflict = function (_React$Component) {
	  _inherits(EducationConflict, _React$Component);
	
	  function EducationConflict(props) {
	    _classCallCheck(this, EducationConflict);
	
	    var _this = _possibleConstructorReturn(this, (EducationConflict.__proto__ || Object.getPrototypeOf(EducationConflict)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(EducationConflict, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Conflict Free Diamonds';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'EducationConflict' },
	        _react2.default.createElement('div', { className: 'ecTopBr' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ecBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ecTr ecTr1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ecTd tdMobile' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/conflict/topimg_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ecTd' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ecTitle' },
	                'CONFLICT FREE DIAMONDS AND THE KIMBERLEY PROCESS'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ecP' },
	                'At Diamonds Direct, we are proud to say our diamonds originate from a conflict free source. We can confidently stand behind this promise to you, not only because we are involved in the entire diamond manufacturing process; from the mine, to the cutting and polishing, to delivering the stone to the customer, but also because of an industry wide practice called The Kimberley Process Certification Scheme.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ecP' },
	                'The Kimberley Process is an international system established in 2003 to monitor the trade of rough diamonds. Spearheaded by the United Nations, this process ensures money generated from diamond trading and manufacturing does not finance unethical working environments, war, and anti-government or rebellious movements.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ecTd tdDesktop' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/conflict/topimg.png' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ecTr ecTr2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ecTd tdDesktop' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/conflict/conflictfree.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ecTd tdMobile' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/conflict/conflictfree_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ecTd' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ecP' },
	                'The Kimberley Process restricts diamond importing and exporting to member countries. All diamond shipments crossing international borders are sent in a tamper resistant container with a government validated Kimberley Process Certificate. All certificates are resistant to forgery and numbered uniquely to match each shipment.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ecP' },
	                'Ultimately, The Kimberley Process prevents "blood diamonds" from entering the mainstream diamond markets and protects the consumer from purchasing an unethical diamond. The photos seen here demonstrate diamond shipments coming in and out of Diamonds Direct\u2019s manufacturing facility in Tel Aviv, Israel. Each is clearly marked with The Kimberley Process seal.'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EducationConflict;
	}(_react2.default.Component);
	
	EducationConflict.propTypes = {
	  location: _react.PropTypes.object
	};
	EducationConflict.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = EducationConflict;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var EducationConflictContainer = exports.EducationConflictContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(EducationConflict);

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EducationDiamondContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var EducationDiamond = function (_React$Component) {
	  _inherits(EducationDiamond, _React$Component);
	
	  function EducationDiamond(props) {
	    _classCallCheck(this, EducationDiamond);
	
	    var _this = _possibleConstructorReturn(this, (EducationDiamond.__proto__ || Object.getPrototypeOf(EducationDiamond)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(EducationDiamond, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Education';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'EducationDiamond EducationPage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'eduHeader' },
	          'Diamond Education'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'eduBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'edHeader' },
	            _react2.default.createElement(
	              'div',
	              { className: 'edhTitle' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/4cs.svg' })
	            ),
	            _react2.default.createElement('div', { className: 'edBr' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'edHeaderText' },
	              _react2.default.createElement(
	                'div',
	                { className: 'edhTextWrapper' },
	                'Selecting the perfect diamond starts with a little education. We begin with the 4 C\u2019s: Carat, Cut, Color, and Clarity.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'shopDiamondsWrapper' },
	            _react2.default.createElement(
	              'span',
	              { className: 'ttLink', onClick: function onClick() {
	                  return _this2.internalNav('gallery/engagement-rings?mode=diamond');
	                } },
	              'Shop Diamonds >'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'fourSection desktopOnly' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/desktop/4cs.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'fourSection mobileOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: 'fsMobTopImage' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/mobile/4csbanner_m.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'fsMobInfoElement fsElem1' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/mobile/cut_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'fsMobInfoElement fsElem2' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/mobile/carat_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'fsMobMidImage' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/mobile/4cs2_m.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'fsMobInfoElement fsElem3' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/mobile/clarity_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'fsMobInfoElement fsElem4' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/mobile/color_m.png' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'gradingSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'gradingDiamonds' },
	              _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/education/diamond/desktop/loosediamonds.png' }),
	              _react2.default.createElement('img', { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/education/diamond/mobile/loosediamonds_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gradingTitle' },
	              'Additional Diamond Grading Criteria'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gradingWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'gradingItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'giImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/polish.svg' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'giLabel' },
	                  'POLISH'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'giText' },
	                  'Grading for polish quality refers to the overall craftsmanship of the finished diamond. Are the edges sharp? Are the facets smooth and flat? Polishing wheel marks should not be visible without magnification.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'gradingItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'giImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/symmetry.svg' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'giLabel' },
	                  'SYMMETRY'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'giText' },
	                  'Symmetrical diamonds reflect more light, adding to the overall sparkle. Gemologists review more than 20 different symmetry features in order to grade how perfectly the facets and cut angles align.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'gradingItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'giImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/diamond/flourescence.svg' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'giLabel' },
	                  'FLUORESCENCE'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'giText' },
	                  'Fluorescence measures the color of the light emitted by a diamond under an ultraviolet light. While diamond professionals often prefer a fluorescence grade of \u201Cnone\u201D, \u201CFaint\u201D or \u201CMedium\u201D grades will offer a better value in lower diamond colors.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'measurementSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'msTitle' },
	              'MEASUREMENTS & PROPORTIONS'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'msCopy' },
	              'The diamond measurement and proportions define a diamond\u2019s overall visual appeal. Some diamonds are cut to emphasize the total carat weight, while others are designed to enhance brilliance and luster. Gemologists use these measures to precisely measure each diamond\u2019s unique personality.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'msBody' },
	              _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/education/diamond/desktop/measurements.jpg' }),
	              _react2.default.createElement('img', { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/education/diamond/mobile/measurements_m.jpg' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'certSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'csInnerWrapper' },
	              _react2.default.createElement('div', { className: 'csImage' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'csText' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'cstTitle' },
	                  'CERTIFIED DIAMONDS'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'cstBody' },
	                  'A certification is an independent quality report on a specific diamond. It is issued by a diamond grading laboratory with no affiliation to any retail outlet, giving the con- sumer a completely objective opinion on the diamond\u2019s quality. The certification in- cludes the exact measurements, proportions, color grade, clarity grade, cut grade and carat weight of the diamond. It also includes specifics that most jewelers do not have the equipment or the knowledge to determine, such as the diamond\u2019s fluores- cence, polish, and symmetry. Each certification has its own number, the date which it was analyzed, and a plot chart which shows the internal and external characteristics of the diamond. The leading diamond laboratory in the world and the one that is setting the diamond grading standard is the Gemological Institute of America (G.I.A.).'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EducationDiamond;
	}(_react2.default.Component);
	
	EducationDiamond.propTypes = {
	  location: _react.PropTypes.object
	};
	EducationDiamond.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = EducationDiamond;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var EducationDiamondContainer = exports.EducationDiamondContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(EducationDiamond);

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EducationGemContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var EducationGem = function (_React$Component) {
	  _inherits(EducationGem, _React$Component);
	
	  function EducationGem(props) {
	    _classCallCheck(this, EducationGem);
	
	    var _this = _possibleConstructorReturn(this, (EducationGem.__proto__ || Object.getPrototypeOf(EducationGem)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(EducationGem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Education';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'EducationGem EducationPage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'eduHeader' },
	          'Colored Stones & Pearls'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'eduBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'gemSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'gemImg' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/desktop/gemtop.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemText' },
	              _react2.default.createElement(
	                'div',
	                { className: 'gemTitle' },
	                'GEMSTONES'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'gemP' },
	                'Though Diamonds Direct is synonymous with diamonds, we are also proud to offer an extensive collection of fine, precious, and semi-precious gemstones. From loose stones to completed jewelry pieces- we have a collection of colored stones that will exceed your expectations. Our skilled diamond experts are extremely knowledgeable about colored gemstones and will help you choose the perfect colored gemstone jewelry to suit both your budget and your special someone.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'gemP' },
	                'The most commonly requested precious gemstones are sapphire, ruby, and emerald. When determining the value and quality of a precious gemstone, color is the primary characteristic to take into consideration. Gemologists divide gemstone color into three categories: hue, tone and intensity.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'gemP', style: { textAlign: 'center' } },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'gemLink', onClick: function onClick() {
	                      return _this2.internalNav('gallery/fine-jewelry?type=ring,earring,necklace,bracelet');
	                    } },
	                  'Shop Gemstone Jewelry >'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'birthSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'birthBox' },
	              _react2.default.createElement(
	                'div',
	                { className: 'boxWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'gemTitle titleSmall' },
	                  'BIRTHSTONES'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'boxBr' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/icons/iconline.svg' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'boxP' },
	                  'Birthstones are gemstones that correspond with a birth month. Each birthstone has a unique meaning, making birthstone jewelry a wonderful birthday gift or push present.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'boxGemWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/january.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'JANUARY'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Garnet'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/february.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'FEBRUARY'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Amethyst'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/march.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'MARCH'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Aquamarine'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/april.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'APRIL'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Diamond'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/may.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'MAY'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Emerald'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/june.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'JUNE'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Pearl / Alexandrite'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/july.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'JULY'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Ruby'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/august.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'AUGUST'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Peridot'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/september.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'SEPTEMBER'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Sapphire'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/october.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'OCTOBER'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Opal / Pink Tourmaline'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/november.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'NOVEMBER'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Citrine'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'boxGemItem' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemImg' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/birthstones/december.jpg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemMonth' },
	                      'DECEMBER'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'boxGemLabel' },
	                      'Topaz'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pearlSection mobileOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pearlMobTopImg' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/mobile/pearl-neck_m.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemTitle pearlMobileTitle' },
	              'PEARLS'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemP pearlGemP' },
	              'A pearl is formed when a foreign object, such as a grain of sand, accidentally finds its way into an oyster or mollusk. In an effort to heal, the mollusk secretes layers of a crystalline material called nacre upon the object lodged inside. After a period of time, the layers of nacre appear smooth, hard and luminescent- and a pearl is born!'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemP pearlGemP' },
	              'Natural pearls, formed by the process identified above are very rare and very expensive because this process is based solely on chance. To accommodate the growing retail market, most pearls sold today are cultured pearls. Cultured pearls are made with the help of humans inserting an object into an oyster. The oyster is placed in to warm water while slightly open to help the pearl form over a period of several years.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemP pearlGemP', style: { textAlign: 'center', margin: '20px 0' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'gemLink', onClick: function onClick() {
	                    return _this2.internalNav('gallery/fine-jewelry?type=ring,earring,necklace,bracelet&gemstone=pearl');
	                  } },
	                'Shop Pearl Jewelry >'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemInfo gemInfo1' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/mobile/luster_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemInfo gemInfo2' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/mobile/shape_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemMobMidImage' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/mobile/pearlchar_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemInfo gemInfo3' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/mobile/size_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemInfo gemInfo4' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/mobile/color_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemMobLastImage' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/mobile/pearl_neck2_m.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemOriginSection' },
	              _react2.default.createElement(
	                'div',
	                { className: 'gemTitle' },
	                'PEARL ORIGINS'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'gemP' },
	                'In addition to quality, pearls are identified and labeled based on their origin:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'pearlLocation' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'plName' },
	                  'AKOYA'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'plBody' },
	                  'Cultured in China and Japan. Most known for their luster, akoya pearls are considered the classic pearl. They are generally white or cream colored with overtone colors of rose, silver or cream. Sizes range from 2 to 11 mm.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'pearlLocation' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'plName' },
	                  'CHINESE FRESHWATER'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'plBody' },
	                  'Cultivated in mussels in lakes and rivers, these pearls grow in an awesome variety of colors and shapes. These pearls are very affordable.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'pearlLocation' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'plName' },
	                  'SOUTH SEA PEARLS'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'plBody' },
	                  'Cultured from the silver or white-lip oyster, primarily in the northern waters of Australia, Indonesia and the Philippines, these pearls grow to exceptional size; 10 to 20 mm. These are highly prized and precious.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'pearlLocation' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'plName' },
	                  'TAHITIAN PEARLS'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'plBody' },
	                  'Cultured from the black-lip oyster in the waters of the South Pacific, these pearls come in larger sizes, from 10 to 20 mm, and a varia- tion of colors including black, gray, burgundy, peacock and gold. Mystical and dark, the popu- larity of Tahitian pearls has surged in recent years, making strands of these pearls one of the most sought-after pieces of jewelry.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pearlSection desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: 'gemTitle' },
	              'PEARLS'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemP halfWidth' },
	              'A pearl is formed when a foreign object, such as a grain of sand, accidentally finds its way into an oyster or mollusk. In an effort to heal, the mollusk secrets layers of a crystalline material called nacre upon the object lodged inside. After a period of time, the layers of nacre appear smooth, hard and luminescent- and a pearl is born!'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'gemP' },
	              'Natural pearls, formed by the process identified above are very rare and very expensive because this process is based solely on chance. To accommodate the growing retail market, most pearls sold today are cultured pearls. Cultured pearls are made with the help of humans inserting an object into an oyster. The oyster is placed in warm water while slightly open to help the pearl form over a period of several years. The process of creating cultured pearls began in japan in the late 19th century and has aided the industry in creating pearls of varying shape, color, size and quality in mass quantities.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pearlCharSection desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pearlTopArea' },
	              _react2.default.createElement(
	                'div',
	                { className: 'pearlTextArea' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'gemTitle titleSmall' },
	                  'PEARL CHARACTERISTICS'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pearlP' },
	                  'Pearl quality can vary dramatically, and just like other gemstones, only a tiny percentage are considered beautiful enough for use in jewelry. Characteristics that con- tribute to the value of a pearl are luster and nacre thickness, surface, shape, color and size.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pearlP', style: { textAlign: 'center', margin: '20px 0' } },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'gemLink', onClick: function onClick() {
	                        return _this2.internalNav('gallery/fine-jewelry?type=ring,earring,necklace,bracelet&gemstone=pearl');
	                      } },
	                    'Shop Pearl Jewelry >'
	                  )
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/desktop/pearlchar.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pearlBottomArea' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/gem/desktop/originsb.jpg' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EducationGem;
	}(_react2.default.Component);
	
	EducationGem.propTypes = {
	  location: _react.PropTypes.object
	};
	EducationGem.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = EducationGem;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var EducationGemContainer = exports.EducationGemContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(EducationGem);

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EducationLabGrownContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var EducationLabGrown = function (_React$Component) {
	  _inherits(EducationLabGrown, _React$Component);
	
	  function EducationLabGrown(props) {
	    _classCallCheck(this, EducationLabGrown);
	
	    var _this = _possibleConstructorReturn(this, (EducationLabGrown.__proto__ || Object.getPrototypeOf(EducationLabGrown)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(EducationLabGrown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Lab Grown Diamonds';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'EducationLabGrown EducationPage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'eduHeader' },
	          'Lab Grown Diamonds'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'labHoliday' },
	          _react2.default.createElement(
	            'div',
	            { className: 'holidayWrapper' },
	            _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/education/lab/holiday.jpg' }),
	            _react2.default.createElement('img', { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/education/lab/holiday_m.jpg' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'holidayAction', onClick: function onClick() {
	                  return _this2.internalNav('contact-us');
	                } },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Connect With An Expert'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'eduBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'labHeader' },
	            _react2.default.createElement(
	              'div',
	              { className: 'labHeaderImage desktopOnly' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/lab/header_text.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labHeaderImage mobileOnly' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/lab/header_m.jpg' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'labCopy' },
	            _react2.default.createElement(
	              'div',
	              { className: 'labCopyBlock mobile' },
	              _react2.default.createElement(
	                'div',
	                { className: 'copyTitle' },
	                'What are Lab Grown Diamonds?'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'copyP' },
	                'Lab grown diamonds are created in a controlled environment mimicking the way natural diamonds are formed. The end result is a man-made diamond with the same chemical and physical properties as natural diamonds.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'labCompare' },
	            _react2.default.createElement(
	              'div',
	              { className: 'blockWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'compareBlock' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'compareIcon' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'compareIconWrapper' },
	                    _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/lab/natural.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'compareTitle' },
	                  'Natural Diamonds'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'compareProConWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'compareLabel' },
	                    'PRO:'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'compareValue' },
	                    'Rarity'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'compareProConWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'compareLabel' },
	                    'CON:'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'compareValue' },
	                    'Price is higher per carat'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'compareBlock' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'compareIcon' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'compareIconWrapper' },
	                    _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/lab/lab.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'compareTitle' },
	                  'Lab Grown Diamonds'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'compareProConWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'compareLabel' },
	                    'PRO:'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'compareValue' },
	                    'Affordability'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'compareProConWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'compareLabel' },
	                    'CON:'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'compareValue' },
	                    'Limited resale and upgrade potential'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'labCopy' },
	            _react2.default.createElement(
	              'div',
	              { className: 'labCopyBlock', style: { margin: '0' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'copyTitle' },
	                'What differentiates a natural diamond from a lab-grown one?'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'copyP' },
	                'Although natural and lab grown diamonds have many similarities, there are two main differences that you should be aware of: Natural diamonds were formed millions, or even billions, of years ago below the Earth\u2019s surface. The oldest lab grown diamonds were made decades ago and formed under conditions designed by humans in large factories or lab facilities. Natural diamonds have greater inherent value due to limited supply. The rarity of natural diamonds ensures they retain their value over time so that natural diamonds can be resold, traded in, and upgraded in the future. Lab grown diamond prices are typically much lower because they are mass-manufactured and readily available in unlimited quantities. Manufactured diamond pricing has historically decreased annually by as much as 30% in a year, which impacts its value. While the savings are perhaps enticing, it\u2019s essential to understand that lab grown diamonds do not retain their value after purchase.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'labCompare' },
	            _react2.default.createElement(
	              'div',
	              { className: 'compareCopyWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ccTitle' },
	                'Selection, Guidance & Value Redefined.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ccP' },
	                'As always, Diamonds Direct is here to provide expert guidance and diamond education to empower you, our customers, to make buying decisions that meet your specific needs and wishes.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'labGrid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'labRow copyRight' },
	              _react2.default.createElement('div', { className: 'imageBlock' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'copyBlock' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'copyBlockLiner' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rcTitle' },
	                    'Explore our Lab Grown Diamond Collection in Store'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rcP', style: { display: 'inline-block', textDecoration: 'underline' } },
	                    'Lab Grown'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rcP' },
	                    'Loose & Mounted Diamond Engagement'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rcP' },
	                    'Diamond Studs'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rcP' },
	                    'Diamond Pendants'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rcP' },
	                    'Diamond Tennis Bracelets'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'lcActions' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'lcAction', onClick: function onClick() {
	                          return _this2.internalNav('locations');
	                        } },
	                      'Find a Location'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labRow copyLeft' },
	              _react2.default.createElement('div', { className: 'imageBlock' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'copyBlock' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'copyBlockLiner' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'lcP' },
	                    'Our experts have an expansive selection of lab grown and natural diamonds at their fingertips. We are ready to guide you through our inventory and educate you on the pros and cons of both diamond types in an effort to help you make a buying decision that suits your needs.'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'lcTitle' },
	                    'Connect with an Expert'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'lcActions' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'lcAction', onClick: function onClick() {
	                          return _this2.internalNav('contact-us');
	                        } },
	                      'Connect With An Expert'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EducationLabGrown;
	}(_react2.default.Component);
	
	EducationLabGrown.propTypes = {
	  location: _react.PropTypes.object
	};
	EducationLabGrown.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = EducationLabGrown;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var EducationLabGrownContainer = exports.EducationLabGrownContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(EducationLabGrown);

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EducationMetalContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var EducationMetal = function (_React$Component) {
	  _inherits(EducationMetal, _React$Component);
	
	  function EducationMetal(props) {
	    _classCallCheck(this, EducationMetal);
	
	    var _this = _possibleConstructorReturn(this, (EducationMetal.__proto__ || Object.getPrototypeOf(EducationMetal)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(EducationMetal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Education';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'EducationMetal EducationPage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'eduHeader' },
	          'Metals of Fine Jewelry'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'eduBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'topSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'topImgBlock' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/metals/top.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'topTextBlock' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ttP' },
	                'In today\'s jewelry industry, there are many different types of metals commonly used in manufacturing jewelry. It is important to understand the differences between each metal when choosing an engagement ring or wedding band.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ttP' },
	                'In a diverse market, the metal types are commonly split up into two families- the precious metal family and the alternative metal family. The precious metal family includes platinum, gold, and palladium and is most noted for its inherent value and durability. The most intrinsically valued of these metals is platinum.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ttLink', onClick: function onClick() {
	                    return _this2.externalNav('gallery/fine-jewelry?type=ring,earring,bracelet,necklace');
	                  } },
	                'Shop Fine Jewelry >'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'metalsSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'metalsWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'metalItem imgRight' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'miImgWrapper' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/metals/platinum-a.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'miTextWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miElemNumber' },
	                    '78'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miElemSymbol' },
	                    'Pt'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miTitle' },
	                    'Platinum'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miP' },
	                    'Platinum is a naturally white metal that maintains its white color and finish for a lifetime. Platinum is also a hypoallergenic metal because few alloys are used to make the metal jewelry quality. Platinum reigns supreme in the jewelry industry because it is a solid, heavy metal that will maintain its density for generations.'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miP' },
	                    'Though platinum is dense, it is still very malleable- which works in the ring\'s favor. When a platinum ring is polished, bumped, dropped, or nicked, the platinum simply moves to the side, and can be polished back into place to look good as new. Many jewelers refer to platinum as \u2018heirloom quality\' for this reason.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'metalItem imgLeft' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'miImgWrapper' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/metals/gold-a.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'miTextWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miElemNumber' },
	                    '79'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miElemSymbol' },
	                    'Au'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miTitle' },
	                    'Gold'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miP' },
	                    'Gold is a precious metal that is naturally yellow. It comes from the earth as a very soft metal and is mixed with alloys to make it hard enough to use in jewelry design. The ratio of gold to alloys is denoted by the karat measurement. For example, 24 karat gold is pure gold, 18 karat gold is 75% pure gold and 14 karat gold is about 58.33% pure gold.'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miP' },
	                    'By mixing in various alloys, gold can also be made to appear different colors such as black, green, red, and most commonly white. White gold gets its white tint by combining yellow gold with alloys like palladium, nickel, and zinc. A white gold piece of jewelry is also dipped in rhodium once it is polished and completed. This is what makes a white gold piece of jewelry rival a platinum piece. Through time, it is common for the rhodium plating to wear off the surface of the ring and to reveal a more yellow patina. A white gold ring can be re-dipped in rhodium easily and often to help maintain its white finish.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'metalItem imgRight' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'miImgWrapper' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/metals/palladium-a.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'miTextWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miElemNumber' },
	                    '46'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miElemSymbol' },
	                    'Pd'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miTitle' },
	                    'Palladium'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'miP' },
	                    'Palladium is an element found in the family of platinum group metals. For that reason, palladium has similar characteristics to platinum. One similarity is color, as palladium is a naturally white metal and will maintain this color for a lifetime. Palladium is also hypoallergenic like platinum. Palladium\'s primary difference from platinum is an important one- it is far less dense. For that reason, it is not recommended to use palladium when setting diamonds with prongs alone. Palladium\'s most common use within our industry is to create men\'s wedding bands.'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'altSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'asTitle' },
	              'ALTERNATIVE METALS'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'asP' },
	              'Alternative metals are unique because these metal types are commonly used in other applications outside the jewelry industry like machinery, surgical tools, and artificial joint replacements. Within the jewelry industry - alternative metals are most commonly used in men\'s wedding bands.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'asP' },
	              'One of the most noted distinctions from the precious metal family is cost, as alternative metals cost far less than precious metals. This is because alternative metals are not made from materials that are considered valuable commodities. In jewelry design, the most commonly used alternative metals are tungsten carbide, titanium, and cobalt.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'asP' },
	              'Tungsten carbide, titanium, and cobalt all share similar characteristics. They are very hard, scratch resistant, shiny, light grey metals. Most are also hypoallergenic. Because of these characteristics, these alternative metals do not require much maintenance. Alternatively, due to hardness, these rings cannot be sized or engraved. They can also be very brittle and have been known to chip, crack, or shatter when dropped or slammed against a hard surface.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'asP' },
	              'Regardless of certain risks in choosing a ring made of an alternative metal, Diamonds Direct works only with the most reputable wedding band designers who stand behind their product. These designers will provide you with a lifetime guarantee that will cover you if a ring needs to be exchanged due to sizing or exterior damage.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'asLink', onClick: function onClick() {
	                  return _this2.externalNav('gallery/wedding-bands/mens');
	                } },
	              'Shop Men\'s Bands >'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EducationMetal;
	}(_react2.default.Component);
	
	EducationMetal.propTypes = {
	  location: _react.PropTypes.object
	};
	EducationMetal.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = EducationMetal;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var EducationMetalContainer = exports.EducationMetalContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(EducationMetal);

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EducationStyleContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var EducationStyle = function (_React$Component) {
	  _inherits(EducationStyle, _React$Component);
	
	  function EducationStyle(props) {
	    _classCallCheck(this, EducationStyle);
	
	    var _this = _possibleConstructorReturn(this, (EducationStyle.__proto__ || Object.getPrototypeOf(EducationStyle)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(EducationStyle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Education';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'EducationStyle EducationPage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'eduHeader' },
	          'Engagement Ring Styles'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'eduBody' },
	          _react2.default.createElement('div', { className: 'eduStyleHeaderSection' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'eduStylesWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'esInnerWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'esItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiImgWrapper' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/solitaire.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiBoxWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'esiBoxInnerWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbTitle' },
	                      'Solitaire'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbBr' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbP' },
	                      'Of the prong settings, the most common is the solitaire setting featuring one diamond. The solitaire setting draws all of our attention to the stone with little to distract us like other stones or fancy metalwork.'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbLink', onClick: function onClick() {
	                          return _this2.internalNav('gallery/engagement-rings?mode=setting&settingtype=solitaire&style=contemporary,vintage,classic');
	                        } },
	                      'Shop Solitaire Rings >'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiImgWrapper' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/threestone.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiBoxWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'esiBoxInnerWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbTitle' },
	                      'Three-Stone'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbBr' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbP' },
	                      'The three-stone setting is a versatile setting that can be used for engagement, anniversary, or any occasion. The three stones, set closely together, are said to symbolize the couple\u2019s past, present, and future.'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbLink', onClick: function onClick() {
	                          return _this2.internalNav('gallery/engagement-rings?mode=setting&settingtype=threestone&style=contemporary,vintage,classic');
	                        } },
	                      'Shop Three-Stone Rings >'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiImgWrapper' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/halo.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiBoxWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'esiBoxInnerWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbTitle' },
	                      'Halo'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbBr' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbP' },
	                      'The halo setting refers to the placement of diamonds or other gemstones in a concentric circle or square around a center stone. The halo setting makes the center stone appear larger\u2014a great option to boost the appearance of any center stone\u2014and it increases the overall sparkle of the ring.'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbLink', onClick: function onClick() {
	                          return _this2.internalNav('gallery/engagement-rings?mode=setting&settingtype=halo&style=contemporary,vintage,classic');
	                        } },
	                      'Shop Halo Rings >'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiImgWrapper' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/pave.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiBoxWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'esiBoxInnerWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbTitle' },
	                      'Pav\xE9'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbBr' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbP' },
	                      'The pav\xE9 setting, pronounced "pa-vay", comes from the French word "to pave", as in paved with diamonds. By closely setting small diamonds together with minimal visibility of the tiny metal beads or prongs holding the stones in place, the effect is one of continuous sparkle.'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbLink', onClick: function onClick() {
	                          return _this2.internalNav('gallery/engagement-rings?mode=setting&settingtype=pave&style=contemporary,vintage,classic');
	                        } },
	                      'Shop Pav\xE9 Rings >'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiImgWrapper' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/channel.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiBoxWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'esiBoxInnerWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbTitle' },
	                      'Channel'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbBr' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbP' },
	                      'The channel setting is a secure way to set smaller diamonds in a row into the band of the ring, making a metal channel of sparkling stones flush with the shank. Since there are no prongs, this setting is also a good option for a snag-free and secure design.'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbLink', onClick: function onClick() {
	                          return _this2.internalNav('gallery/engagement-rings?mode=setting&settingtype=pave&style=contemporary');
	                        } },
	                      'Shop Channel Rings >'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiImgWrapper' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/sharedprong1.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'esiBoxWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'esiBoxInnerWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbTitle' },
	                      'Shared Prong'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbBr' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbP' },
	                      'A sophisticated look, the shared prong engagement ring is distinguished by the diamonds in the mounting set into prongs shared by the neighboring diamond. This look allows for fewer prongs and less metal covering each diamond, permitting more light return and sparkle.'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'esbLink', onClick: function onClick() {
	                          return _this2.internalNav('gallery/engagement-rings?mode=setting&settingtype=solitaire,halo,pave,threestone&style=contemporary');
	                        } },
	                      'Shop Shared Prong Rings >'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'eduStyleFooterSection' })
	        )
	      );
	    }
	  }]);
	
	  return EducationStyle;
	}(_react2.default.Component);
	
	EducationStyle.propTypes = {
	  location: _react.PropTypes.object
	};
	EducationStyle.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = EducationStyle;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var EducationStyleContainer = exports.EducationStyleContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(EducationStyle);

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FaqContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _faq = __webpack_require__(613);
	
	var faq = _interopRequireWildcard(_faq);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Faq = function (_React$Component) {
	  _inherits(Faq, _React$Component);
	
	  function Faq(props) {
	    _classCallCheck(this, Faq);
	
	    var _this = _possibleConstructorReturn(this, (Faq.__proto__ || Object.getPrototypeOf(Faq)).call(this, props));
	
	    _this.state = {
	      selectedSubject: null,
	      selectedQuestion: null,
	      searchText: ''
	    };
	    return _this;
	  }
	
	  _createClass(Faq, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.title = 'Diamonds Direct - Frequently Asked Questions';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'userNav',
	    value: function userNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openContact',
	    value: function openContact() {
	      this.props.commonOpenContact();
	    }
	  }, {
	    key: 'getAutocompleteQuestions',
	    value: function getAutocompleteQuestions() {
	
	      var matchedQuestions = [];
	      var maxLength = 10;
	      var matchCount = 0;
	      var searchTerm = this.state.searchText.toLowerCase();
	      var backupTerm = null;
	
	      switch (searchTerm) {
	        case 'returns':
	          backupTerm = 'return';
	          break;
	        case 'payments':
	          backupTerm = 'payment';
	          break;
	        case 'warranty':
	          backupTerm = 'warranties';
	          break;
	        case 'warranties':
	          backupTerm = 'warranty';
	          break;
	      }
	
	      for (var i = 0; i < faq.QUESTIONS.length; i++) {
	
	        var index = faq.QUESTIONS[i].title.toLowerCase().indexOf(searchTerm);
	        if (index >= 0) {
	
	          var questionObj = faq.QUESTIONS[i];
	          questionObj['resultIndex'] = index;
	          questionObj['resultTerm'] = searchTerm;
	
	          matchedQuestions.push(questionObj);
	          matchCount++;
	
	          continue;
	        }
	
	        if (backupTerm) {
	          index = faq.QUESTIONS[i].title.toLowerCase().indexOf(backupTerm);
	          if (index >= 0) {
	
	            var _questionObj = faq.QUESTIONS[i];
	            _questionObj['resultIndex'] = index;
	            _questionObj['resultTerm'] = backupTerm;
	
	            matchedQuestions.push(_questionObj);
	            matchCount++;
	          }
	        }
	
	        if (matchedQuestions.length >= 8) {
	          break;
	        }
	      }
	
	      return matchedQuestions;
	    }
	  }, {
	    key: 'changeSearchText',
	    value: function changeSearchText(evt) {
	      this.setState({ searchText: evt.target.value });
	    }
	  }, {
	    key: 'getSectionName',
	    value: function getSectionName(subject) {
	      switch (subject) {
	        case 'ordering':
	          return 'Shopping, Shipping, and Special Orders';
	        case 'payment':
	          return 'Payment Method and Financing';
	        case 'warranty':
	          return 'Warranties and Repair Policy';
	        case 'upgrade':
	          return 'Upgrades and Trade-Ins';
	        case 'returns':
	          return 'Return Policy';
	        case 'privacy':
	          return 'Privacy and Security';
	        default:
	          return 'Frequently Asked Questions';
	      }
	    }
	  }, {
	    key: 'toggleQuestion',
	    value: function toggleQuestion(question) {
	      if (this.state.selectedQuestion === null || this.state.selectedQuestion && this.state.selectedQuestion.title != question.title) {
	        this.setState({ selectedQuestion: question });
	        console.log('question');
	      } else {
	        this.setState({ selectedQuestion: null });
	      }
	    }
	  }, {
	    key: 'toggleSubject',
	    value: function toggleSubject(subject) {
	      if (this.state.selectedSubject !== subject) {
	        this.setState({ selectedSubject: subject });
	        this.scrollToBlock(subject);
	      } else {
	        this.setState({ selectedSubject: null, selectedQuestion: null });
	      }
	    }
	  }, {
	    key: 'closeSubject',
	    value: function closeSubject() {
	      this.setState({ selectedSubject: null, selectedQuestion: null });
	    }
	  }, {
	    key: 'getQuestionClass',
	    value: function getQuestionClass(question) {
	      if (this.state.selectedQuestion !== null && this.state.selectedQuestion.title == question.title) {
	        return 'questionEntry open';
	      } else {
	        return 'questionEntry';
	      }
	    }
	  }, {
	    key: 'scrollToBlock',
	    value: function scrollToBlock(subject) {
	
	      var section = null;
	      switch (subject) {
	        case 'ordering':
	          section = this.orderingBlock;
	          break;
	        case 'payment':
	          section = this.paymentBlock;
	          break;
	        case 'warranty':
	          section = this.warrantyBlock;
	          break;
	        case 'upgrade':
	          section = this.upgradeBlock;
	          break;
	        case 'returns':
	          section = this.returnBlock;
	          break;
	        case 'privacy':
	          section = this.privacyBlock;
	          break;
	      }
	
	      if (section) {
	        (0, _reactScrollToComponent2.default)(section, {
	          offset: 0,
	          align: 'top',
	          duration: 800,
	          ease: 'inOutCube'
	        });
	      }
	    }
	  }, {
	    key: 'renderQuestionAccordian',
	    value: function renderQuestionAccordian(subject) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.state.selectedSubject === subject ? 'questionAccordian open' : 'questionAccordian' },
	        _react2.default.createElement(
	          'div',
	          { className: 'accordianWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'accordianClose', onClick: this.closeSubject.bind(this) },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/faq/x.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'accordianTitle' },
	            this.getSectionName(subject)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'accordianBr' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/faq/logo_line.svg' })
	          ),
	          faq.QUESTIONS.map(function (question, i) {
	
	            if (subject !== question.subject) {
	              return null;
	            }
	
	            return _react2.default.createElement(
	              'div',
	              { className: _this2.getQuestionClass(question), key: i, onClick: function onClick() {
	                  return _this2.toggleQuestion(question);
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'questionTitle' },
	                _react2.default.createElement('div', { className: 'titleArrow' }),
	                question.title
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'questionBody' },
	                _react2.default.createElement('div', { className: 'bodyWrapper', dangerouslySetInnerHTML: { __html: question.body } })
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'autosuggestClass',
	    value: function autosuggestClass() {
	      return this.state.searchText.length >= 2 ? 'searchSuggestions open' : 'searchSuggestions';
	    }
	  }, {
	    key: 'openSearchQuestion',
	    value: function openSearchQuestion(question) {
	      this.setState({
	        selectedSubject: question.subject,
	        selectedQuestion: question,
	        searchText: ''
	      });
	      this.scrollToBlock(question.subject);
	    }
	  }, {
	    key: 'formattedTitle',
	    value: function formattedTitle(question) {
	
	      var titleCopy = question.title;
	      var formattedTitle = titleCopy.slice(0, question.resultIndex) + '<span class="searchEm">' + titleCopy.slice(question.resultIndex, question.resultIndex + question.resultTerm.length) + '</span>' + titleCopy.slice(question.resultIndex + question.resultTerm.length);
	
	      return formattedTitle;
	    }
	  }, {
	    key: 'getBlockClass',
	    value: function getBlockClass(subject) {
	      var classSubject = subject;
	      if (subject == 'returns') {
	        classSubject = 'return';
	      }
	
	      if (this.state.selectedSubject == subject) {
	        return 'faqSubjectBlock open ' + classSubject + 'Block';
	      } else {
	        return 'faqSubjectBlock ' + classSubject + 'Block';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var autocompleteQuestions = this.getAutocompleteQuestions();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Faq' },
	        _react2.default.createElement(
	          'div',
	          { className: 'faqHeader' },
	          _react2.default.createElement(
	            'div',
	            { className: 'headerInnerWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faqIcon' },
	              'Faq'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faqHeaderText' },
	              'For orders placed at one of our locations please ',
	              _react2.default.createElement(
	                'span',
	                { className: 'headerLink', onClick: this.openContact.bind(this) },
	                'contact a store nearest you'
	              ),
	              '. For orders placed online please reply to your order confirmation email or email us at ',
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:online@diamondsdirect.com' },
	                'online@diamondsdirect.com'
	              ),
	              '.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faqSearch' },
	          _react2.default.createElement(
	            'div',
	            { className: 'searchTitleWrapper' },
	            'We\'re here to help!'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'searchInputWrapper' },
	            _react2.default.createElement('input', { type: 'text', placeholder: 'Search FAQ', value: this.state.searchText, onChange: this.changeSearchText.bind(this) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'searchIcon' },
	              _react2.default.createElement('i', { className: 'fas fa-search' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.autosuggestClass() },
	              _react2.default.createElement(
	                'div',
	                { className: 'searchInnerWrapper' },
	                autocompleteQuestions.length > 0 ? _react2.default.createElement(
	                  'div',
	                  { className: 'suggestionsWrapper' },
	                  autocompleteQuestions.map(function (question, i) {
	                    return _react2.default.createElement('div', { className: 'suggestionEntry', onClick: function onClick() {
	                        return _this3.openSearchQuestion(question);
	                      }, key: i, dangerouslySetInnerHTML: { __html: _this3.formattedTitle(question) } });
	                  })
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'suggestionContact' },
	                  'No Match? ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'contactLink', onClick: this.openContact.bind(this) },
	                    'Contact Us!'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faqBlocks' },
	          _react2.default.createElement(
	            'div',
	            { className: this.getBlockClass('ordering'), onClick: function onClick() {
	                return _this3.toggleSubject('ordering');
	              }, ref: function ref(div) {
	                _this3.orderingBlock = div;
	              } },
	            _react2.default.createElement('div', { className: 'blockIcon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockTitle' },
	              'Shopping, Shipping, and Special Orders'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockPrompt' },
	              'Click Here >'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobileAccordian' },
	            this.renderQuestionAccordian('ordering')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getBlockClass('warranty'), onClick: function onClick() {
	                return _this3.toggleSubject('warranty');
	              }, ref: function ref(div) {
	                _this3.warrantyBlock = div;
	              } },
	            _react2.default.createElement('div', { className: 'blockIcon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockTitle' },
	              'Warranties and Repair Policy'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockPrompt' },
	              'Click Here >'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tabletAccordian' },
	            this.renderQuestionAccordian('ordering')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tabletAccordian' },
	            this.renderQuestionAccordian('warranty')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobileAccordian' },
	            this.renderQuestionAccordian('warranty')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getBlockClass('upgrade'), onClick: function onClick() {
	                return _this3.toggleSubject('upgrade');
	              }, ref: function ref(div) {
	                _this3.upgradeBlock = div;
	              } },
	            _react2.default.createElement('div', { className: 'blockIcon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockTitle' },
	              'Upgrades and Trade-Ins'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockPrompt' },
	              'Click Here >'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'desktopAccordian' },
	            this.renderQuestionAccordian('ordering')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'desktopAccordian' },
	            this.renderQuestionAccordian('warranty')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'desktopAccordian' },
	            this.renderQuestionAccordian('upgrade')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobileAccordian' },
	            this.renderQuestionAccordian('upgrade')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getBlockClass('payment'), onClick: function onClick() {
	                return _this3.toggleSubject('payment');
	              }, ref: function ref(div) {
	                _this3.paymentBlock = div;
	              } },
	            _react2.default.createElement('div', { className: 'blockIcon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockTitle' },
	              'Payment Method and Financing'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockPrompt' },
	              'Click Here >'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tabletAccordian' },
	            this.renderQuestionAccordian('upgrade')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tabletAccordian' },
	            this.renderQuestionAccordian('payment')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobileAccordian' },
	            this.renderQuestionAccordian('payment')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getBlockClass('returns'), onClick: function onClick() {
	                return _this3.toggleSubject('returns');
	              }, ref: function ref(div) {
	                _this3.returnBlock = div;
	              } },
	            _react2.default.createElement('div', { className: 'blockIcon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockTitle' },
	              'Return Policy'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockPrompt' },
	              'Click Here >'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobileAccordian' },
	            this.renderQuestionAccordian('returns')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getBlockClass('privacy'), onClick: function onClick() {
	                return _this3.toggleSubject('privacy');
	              }, ref: function ref(div) {
	                _this3.privacyBlock = div;
	              } },
	            _react2.default.createElement('div', { className: 'blockIcon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockTitle' },
	              'Privacy and Security'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'blockPrompt' },
	              'Click Here >'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'desktopAccordian' },
	            this.renderQuestionAccordian('payment')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'desktopAccordian' },
	            this.renderQuestionAccordian('returns')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'desktopAccordian' },
	            this.renderQuestionAccordian('privacy')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tabletAccordian' },
	            this.renderQuestionAccordian('returns')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tabletAccordian' },
	            this.renderQuestionAccordian('privacy')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobileAccordian' },
	            this.renderQuestionAccordian('privacy')
	          )
	        )
	      );
	    }
	  }]);
	
	  return Faq;
	}(_react2.default.Component);
	
	Faq.propTypes = {
	  location: _react.PropTypes.object
	};
	Faq.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Faq;
	
	
	function mapStateToProps(state) {
	  return {
	    common: state.common,
	    header: state.header
	  };
	}
	
	var FaqContainer = exports.FaqContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Faq);

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FinanceContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var Finance = function (_React$Component) {
	  _inherits(Finance, _React$Component);
	
	  function Finance(props) {
	    _classCallCheck(this, Finance);
	
	    var _this = _possibleConstructorReturn(this, (Finance.__proto__ || Object.getPrototypeOf(Finance)).call(this, props));
	
	    _this.state = {
	      toggled: false
	    };
	    return _this;
	  }
	
	  _createClass(Finance, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Special Financing';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'toggleLegal',
	    value: function toggleLegal() {
	      this.setState({ toggled: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Finance' },
	        _react2.default.createElement(
	          'div',
	          { className: 'finHeader' },
	          _react2.default.createElement(
	            'div',
	            { className: 'finTitle' },
	            'DIAMONDS DIRECT SPECIAL FINANCING',
	            _react2.default.createElement(
	              'span',
	              { className: 'sup' },
	              '1,2'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'finBr' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/icons/iconline.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'finIconRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'finIcon' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finIconImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/icons/credit.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finIconLabel' },
	                'Quick credit decisions'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finIcon' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finIconImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/icons/online.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finIconLabel' },
	                'Convenient online application'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finIcon' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finIconImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/icons/account.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finIconLabel' },
	                'Easy-to-use online account management and bill payment'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finIcon' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finIconImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/icons/immediate.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finIconLabel' },
	                'Immediate access to revolving line'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finIcon' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finIconImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/icons/purchase.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finIconLabel' },
	                'Ability to make repeat purchases'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'finBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'finBackgroundWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'finBackgroundLeft' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/bgdiamonds.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finBackgroundRight' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/bgring.jpg' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'finCardSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'finCardLeft' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finCardLeftImageWrapper' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/card.png' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finCardRight' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finCardRightTextWrapper' },
	                'Diamonds Direct credit card issued by Wells Fargo Bank, N.A. is our primary financing option. If approved, you will receive a revolving credit line that you can use immediately. After applying, please choose "Diamonds Direct Credit Card" at checkout.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'finColumnsHeader' },
	            _react2.default.createElement(
	              'div',
	              { className: 'finColHeaderTitle' },
	              'Current Financing Offers'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finColHeaderLine' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/finance/icons/iconline.svg' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'finColumnsWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'finColumn firstCol' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finColTitle' },
	                'No Interest if Paid in Full'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finColSubtitle' },
	                'within 12 Months with Regular Monthly Payments'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finColP finPBold' },
	                'Interest will be charged to your account from the purchase date if the purchase balance is not paid in full within the promotional period.',
	                _react2.default.createElement(
	                  'sup',
	                  null,
	                  '1'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finColSubtitle' },
	                'with minimum purchase amount of $480'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finColLearnMore', style: { display: this.state.toggled ? 'none' : 'block' }, onClick: this.toggleLegal.bind(this) },
	                'Learn More'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finColP', style: { display: this.state.toggled ? 'block' : 'none' } },
	                _react2.default.createElement(
	                  'sup',
	                  null,
	                  '*'
	                ),
	                'The Diamonds Direct credit card is issued by Wells Fargo Bank, N.A. Special terms apply to qualifying purchases of $480 or more charged with approved credit. Minimum monthly payments are required during the promotional (special terms) period. Interest will be charged to your account from the purchase date at the APR for Purchases if the purchase balance is not paid in full within the promotional period. Paying only the minimum monthly payment will not pay off the purchase balance before the end of the promotional period. For new accounts, the APR for Purchases is 28.99%. If you are charged interest in any billing cycle, the minimum interest charge will be $1.00. This information is accurate as of 08/01/2020 and is subject to change. For current information, call us at ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'tel:8004315921' },
	                  '1-800-431-5921'
	                ),
	                '. Offer expires 12/31/2022.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finOr' },
	              'or'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finColumn' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finColTitle' },
	                'Special Rate of 9.99% APR'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finColSubtitle' },
	                'with 48 Equal Monthly Payments',
	                _react2.default.createElement(
	                  'sup',
	                  null,
	                  '2'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finColLearnMore', style: { display: this.state.toggled ? 'none' : 'block' }, onClick: this.toggleLegal.bind(this) },
	                'Learn More'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finColP', style: { display: this.state.toggled ? 'block' : 'none' } },
	                _react2.default.createElement(
	                  'sup',
	                  null,
	                  '2'
	                ),
	                'The Diamonds Direct credit card is issued by Wells Fargo Bank, N.A. Special terms apply to qualifying purchases charged with approved credit. The special terms APR of 9.99% will apply to the qualifying purchase, and 48 monthly payments equal to 2.5567% of the original special terms balance are required. The advertised terms are an estimate assuming required monthly payments are made on the payment due date; no other balances are currently carried or will be carried on the account; and no additional charges are or will be added to the account. Because your actual account activity may be different than the assumptions used, or because of rounding, the number of payments or the final payment amount could be different than the advertised terms. The special terms APR will continue to apply until all qualifying purchases are paid in full. The APR for Purchases will apply to certain fees such as a late payment fee or if you use the card for other transactions. For new accounts, the APR for Purchases is 28.99%. If you are charged interest in any billing cycle, the minimum interest charge will be $1.00. This information is accurate as of 08/01/2020 and is subject to change. For current information, call us at ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'tel:8004315921' },
	                  '1-800-431-5921'
	                ),
	                '. Offer expires 12/31/2022.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'finBox' },
	            _react2.default.createElement(
	              'div',
	              { className: 'finBoxLeft finBoxSection' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finBoxTitle' },
	                'Ready to Apply?'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finBoxCopy' },
	                'One easy application process to see if you qualify for financing.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finBoxButton', onClick: function onClick() {
	                    return _this2.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
	                  } },
	                'Apply Now'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finBoxRight finBoxSection' },
	              _react2.default.createElement(
	                'div',
	                { className: 'finBoxTitle' },
	                'Already Approved?'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finBoxCopy' },
	                'Use the Diamonds Direct credit card to checkout from your cart now.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'finBoxButton', onClick: function onClick() {
	                    return _this2.externalNav('checkout/cart');
	                  } },
	                'Checkout Now'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'finApply' },
	            _react2.default.createElement(
	              'div',
	              { className: 'finApplyQuestion' },
	              'Have questions about applying or using your Diamonds Direct Credit Card?'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finApplyButton', onClick: function onClick() {
	                  return _this2.externalNav('contact-us');
	                } },
	              'Contact Us'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'finLegal', style: { display: 'none' } },
	            _react2.default.createElement(
	              'sup',
	              null,
	              '*2'
	            ),
	            'After completing your application, please checkout normally, choosing "Diamonds Direct Credit Card\u201D as your way of payment.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Finance;
	}(_react2.default.Component);
	
	Finance.propTypes = {
	  location: _react.PropTypes.object
	};
	Finance.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Finance;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var FinanceContainer = exports.FinanceContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Finance);

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactLazyLoadImageComponent = __webpack_require__(116);
	
	var _axios = __webpack_require__(466);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	
	    _this.state = {
	      newsletterEmail: '',
	      emailSubmitted: false
	    };
	    return _this;
	  }
	
	  _createClass(Footer, [{
	    key: 'userNav',
	    value: function userNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'locateStoreChange',
	    value: function locateStoreChange(evt) {
	      if (evt.target.value !== '') {
	        this.userNav(evt.target.value);
	      }
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openContact',
	    value: function openContact() {
	      this.props.commonOpenContact();
	    }
	  }, {
	    key: 'submitNewsletter',
	    value: function submitNewsletter() {
	      if ((0, _itemValidation.emailValidation)(this.state.newsletterEmail) === null) {
	        // Submit email
	        this.setState({ emailSubmitted: true });
	        // this.props.commonNewsletterSubmit(this.state.newsletterEmail);
	
	        var params = new FormData();
	        params.append('email', this.state.newsletterEmail.trim());
	
	        _axios2.default.post('https://diamondsdirect.com/newsletter/subscriber/new/', params, {
	          method: 'post',
	          withCredentials: true,
	          headers: { 'Content-Type': 'multipart/form-data' }
	        }).then(function (response) {
	          // this.setState({message:response.data.message});
	          // setTimeout(()=>{
	          // this.setState({message:''});
	          // },10000);
	        }).catch(function (error) {
	          console.error(error);
	        });
	      }
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      this.setState({ newsletterEmail: evt.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Footer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'topFooter' },
	          this.state.emailSubmitted ? _react2.default.createElement(
	            'div',
	            { className: 'newsletterWrapper desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: 'newsletterConfirmation' },
	              'Thank you and stay tuned!'
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'newsletterWrapper desktopOnly' },
	            _react2.default.createElement('input', { type: 'email', placeholder: 'Join the Newsletter', onChange: this.changeEmail.bind(this) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'newsletterSubmit', onClick: this.submitNewsletter.bind(this) },
	              'Join'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'midLogoWrapper', onClick: function onClick() {
	                return _this2.userNav('');
	              } },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { className: 'footerLogo', src: 'https://ddw2.diamondsdirect.com/img/icons/footer/ddhorizontal.svg' }),
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { className: 'footerIcon', src: 'https://ddw2.diamondsdirect.com/img/header/ddicon.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'locateWrapper desktopOnly' },
	            _react2.default.createElement(
	              'select',
	              { onChange: this.locateStoreChange.bind(this), name: 'storeSelection' },
	              _react2.default.createElement(
	                'option',
	                { value: '' },
	                'Locate A Store'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'austin' },
	                'Austin, TX'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'birmingham' },
	                'Birmingham, AL'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'boca-raton' },
	                'Boca Raton, FL'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'charleston' },
	                'Charleston, SC'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'charlotte' },
	                'Charlotte, NC'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'cleveland' },
	                'Cleveland, OH'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'columbus' },
	                'Columbus, OH'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'dallas' },
	                'Dallas, TX'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'frisco' },
	                'Frisco, TX'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'greenville' },
	                'Greenville, SC'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'baybrook' },
	                'Houston (Baybrook), TX'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'houston' },
	                'Houston (Galleria), TX'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'indianapolis' },
	                'Indianapolis, IN'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'jacksonville' },
	                'Jacksonville, FL'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'kansas-city' },
	                'Kansas City, KS'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'new-orleans' },
	                'New Orleans, LA'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'oklahoma-city' },
	                'Oklahoma City, OK'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'pittsburgh' },
	                'Pittsburgh, PA'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'raleigh' },
	                'Raleigh, NC'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'richmond' },
	                'Richmond, VA'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'st-louis' },
	                'St Louis, MO'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'san-antonio' },
	                'San Antonio, TX'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'troy' },
	                'Troy, MI'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'tysons' },
	                'Tysons, VA'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'virginia-beach' },
	                'Virginia Beach, VA'
	              )
	            ),
	            _react2.default.createElement('div', { className: 'selectArrow' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'midFooter midDesktop' },
	          _react2.default.createElement(
	            'div',
	            { className: 'linkColumn' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footerTitle' },
	              'Support & Service'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('contact-us');
	                } },
	              'Contact Us'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('frequently-asked-questions');
	                } },
	              'FAQs'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('appointments');
	                } },
	              'Request an Appointment'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink longLink', onClick: function onClick() {
	                  return _this2.internalNav('our-guarantees');
	                } },
	              'Warranties & Guarantees'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink shortLink', onClick: function onClick() {
	                  return _this2.internalNav('our-guarantees');
	                } },
	              'Guarantees'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('financing');
	                } },
	              'Payment Options'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('heroes');
	                } },
	              'Hero Discount'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('locations');
	                } },
	              'Store Locator'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: this.openIntercom.bind(this) },
	              'Chat Now'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'linkColumn' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footerTitle' },
	              'Shop'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('diamond-pendants');
	                } },
	              'Pendants'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.userNav('gallery/wedding-bands/womens');
	                } },
	              'Wedding Bands'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.userNav('gallery/fine-jewelry?type=earring');
	                } },
	              'Earrings'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.userNav('gallery/fine-jewelry?type=necklace');
	                } },
	              'Necklaces'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.userNav('gallery/engagement-rings?tabtype=setting');
	                } },
	              'Engagement Rings'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('diamond-bracelets');
	                } },
	              'Bracelets'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.userNav('gallery/fine-jewelry?type=ring');
	                } },
	              'Fashion Rings'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.userNav('custom-design');
	                } },
	              'Custom Design'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'linkColumn desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footerTitle' },
	              'About Us'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('about-us');
	                } },
	              'Our Story'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink longLink', onClick: function onClick() {
	                  return _this2.internalNav('education/conflict-free');
	                } },
	              'Conflict Free Diamonds'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink shortLink', onClick: function onClick() {
	                  return _this2.internalNav('education/conflict-free');
	                } },
	              'Conflict Free'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('our-foundation');
	                } },
	              'Community Giving'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.openNew('http://blog.diamondsdirect.com/');
	                } },
	              'Blog'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('careers');
	                } },
	              'Careers'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('privacy-policy');
	                } },
	              'Privacy'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('terms-of-use');
	                } },
	              'Terms of Use'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.openNew('https://www.trustpilot.com/review/www.diamondsdirect.com');
	                } },
	              'Customer Reviews'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'midFooter midMobile' },
	          _react2.default.createElement(
	            'div',
	            { className: 'linkColumn' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.userNav('gallery/engagement-rings?tabtype=setting');
	                } },
	              'Engagement Rings'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.userNav('gallery/wedding-bands/womens');
	                } },
	              'Wedding Bands'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.userNav('gallery/fine-jewelry?type=necklace');
	                } },
	              'Necklaces'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('diamond-bracelets');
	                } },
	              'Bracelets'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'linkColumn' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('frequently-asked-questions');
	                } },
	              'FAQs'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('financing');
	                } },
	              'Payment Options'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('locations');
	                } },
	              'Store Locator'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLink', onClick: function onClick() {
	                  return _this2.internalNav('careers');
	                } },
	              'Careers'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bottomFooter' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bottomMidWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'phonePrompt' },
	              _react2.default.createElement(
	                'a',
	                { href: 'tel:8008855050' },
	                '800.885.5050'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerSocial' },
	              _react2.default.createElement('div', { className: 'footerIconWrapper facebookIcon', onClick: function onClick() {
	                  return _this2.openNew('https://www.facebook.com/diamondsdirectstore/');
	                } }),
	              _react2.default.createElement('div', { className: 'footerIconWrapper glassdoorIcon', onClick: function onClick() {
	                  return _this2.openNew('https://www.glassdoor.com/Overview/Working-at-Diamonds-Direct-EI_IE1284378.11,26.htm');
	                } }),
	              _react2.default.createElement('div', { className: 'footerIconWrapper instagramIcon', onClick: function onClick() {
	                  return _this2.openNew('https://www.instagram.com/diamondsdirect/');
	                } }),
	              _react2.default.createElement('div', { className: 'footerIconWrapper linkedinIcon', onClick: function onClick() {
	                  return _this2.openNew('https://www.linkedin.com/company/diamonds-direct/jobs');
	                } }),
	              _react2.default.createElement('div', { className: 'footerIconWrapper pinterestIcon', onClick: function onClick() {
	                  return _this2.openNew('https://www.pinterest.com/diamondsdirect/');
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'emailPrompt', onClick: this.openContact.bind(this), style: { display: 'none' } },
	              'Contact Us'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'blogPrompt', onClick: function onClick() {
	                  return _this2.openNew('http://blog.diamondsdirect.com/');
	                }, style: { display: 'none' } },
	              'Blog'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'footerLHS', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'bottomLink', onClick: function onClick() {
	                  return _this2.internalNav('privacy-policy');
	                } },
	              'Privacy'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'bottomLink', onClick: function onClick() {
	                  return _this2.internalNav('terms-of-use');
	                } },
	              'Terms of Use'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'footerRHS' },
	            _react2.default.createElement(
	              'div',
	              { className: 'badgeWrapper' },
	              _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/icons/footer/weddingwire.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'badgeWrapper' },
	              _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/icons/footer/knot.svg' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react2.default.Component);
	
	Footer.propTypes = {
	  location: _react.PropTypes.object
	};
	Footer.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Footer;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var FooterContainer = exports.FooterContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Footer);

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FoundationContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _AntiModal = __webpack_require__(119);
	
	var _AntiModal2 = _interopRequireDefault(_AntiModal);
	
	var _FoundationRequest = __webpack_require__(519);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Foundation = function (_React$Component) {
		_inherits(Foundation, _React$Component);
	
		function Foundation(props) {
			_classCallCheck(this, Foundation);
	
			var _this = _possibleConstructorReturn(this, (Foundation.__proto__ || Object.getPrototypeOf(Foundation)).call(this, props));
	
			_this.state = {
				open: false
			};
			return _this;
		}
	
		_createClass(Foundation, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				document.title = 'Diamonds Direct Foundation';
				document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
			}
		}, {
			key: 'newTabNav',
			value: function newTabNav(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'userNav',
			value: function userNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'nextSlide',
			value: function nextSlide() {
				this.sliderObject.slickNext();
			}
		}, {
			key: 'prevSlide',
			value: function prevSlide() {
				this.sliderObject.slickPrev();
			}
		}, {
			key: 'renderRotatingBanner',
			value: function renderRotatingBanner() {
				var _this2 = this;
	
				var settings = {
					dots: false,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					variableWidth: true,
					autoplay: true,
					speed: 500,
					autoplaySpeed: 5000,
					cssEase: "linear",
					arrows: false
				};
				return _react2.default.createElement(
					'div',
					{ className: 'foundationRotatingBanner' },
					_react2.default.createElement(
						'div',
						{ className: 'bannerLeft', onClick: this.prevSlide.bind(this) },
						_react2.default.createElement('div', { className: 'leftArrow' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'bannerRight', onClick: this.nextSlide.bind(this) },
						_react2.default.createElement('div', { className: 'rightArrow' })
					),
					_react2.default.createElement(
						_reactSlick2.default,
						_extends({ ref: function ref(slider) {
								_this2.sliderObject = slider;
							} }, settings),
						_react2.default.createElement(
							'div',
							{ className: 'foundationBanner rotatingBannerItem' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/foundation2.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'foundationBanner rotatingBannerItem' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/beemighty5.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'foundationBanner rotatingBannerItem' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/blingyrings.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'foundationBanner rotatingBannerItem' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/beemighty2.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'foundationBanner rotatingBannerItem' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/kylebusch.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'foundationBanner rotatingBannerItem' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/foundation3.jpg' })
						)
					)
				);
			}
		}, {
			key: 'openModal',
			value: function openModal() {
				this.setState({ open: true });
			}
		}, {
			key: 'closeModal',
			value: function closeModal() {
				this.setState({ open: false });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Foundation' },
					_react2.default.createElement(
						'div',
						{ className: 'foundationHeader' },
						_react2.default.createElement('img', { className: 'headerLogo', src: 'https://ddw2.diamondsdirect.com/img/foundation/foundation.svg' }),
						_react2.default.createElement(
							'span',
							{ className: 'textWrapper' },
							'The Diamonds Direct Foundation'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'nkBanner', onClick: function onClick() {
								return _this3.internalNav('no-kid-hungry');
							}, style: { display: 'none' } },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/DD_nokid_foundationb.jpg' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/DD_nokid_foundation_m.jpg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'foundationBodyWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'foundationImageBlock' },
							_react2.default.createElement(
								'div',
								{ className: 'foundationImageWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'foundationImageTopRow' },
									_react2.default.createElement(
										'div',
										{ className: 'foundationImageElement' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/foundation2.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'foundationImageElement' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/beemighty5.jpg' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'foundationImageBottomRow' },
									_react2.default.createElement(
										'div',
										{ className: 'foundationImageElement firstBottom' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/blingyrings.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'foundationImageElement secondBottom' },
										_react2.default.createElement(
											'div',
											{ className: 'foundationInnerElementWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'foundationInnerElementTopRow' },
												_react2.default.createElement(
													'div',
													{ className: 'foundationInnerElementImage innerTop' },
													_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/beemighty2.jpg' })
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'foundationInnerElementBottomRow' },
												_react2.default.createElement(
													'div',
													{ className: 'foundationInnerElementImage' },
													_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/kylebusch.jpg' })
												),
												_react2.default.createElement(
													'div',
													{ className: 'foundationInnerElementImage', style: { marginLeft: '10px' } },
													_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/foundation3.jpg' })
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'foundationCopyBlock' },
							_react2.default.createElement(
								'div',
								{ className: 'foundationIconWrapper' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/foundation/foundation.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'foundationCopyP' },
								'We are dedicated to giving back to the communities we call home. The Diamonds Direct Foundation was established in 2004 to provide support to local nonprofit organizations, with special emphasis on women\'s and children\'s philanthropies.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'foundationCopyP' },
								'Our goal is to build long-term relationships with our nonprofit partners and work closely with them to develop fundraising programs that mutually benefit both organizations.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'foundationCopyP' },
								'If your organization is interested in working with the Diamonds Direct Foundation, please complete the donation request form below.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'foundationOpenRequestButton actionButton', onClick: this.openModal.bind(this) },
								'Donation Request Form'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'foundationBannerWrapper' },
							this.renderRotatingBanner()
						)
					),
					_react2.default.createElement(
						_AntiModal2.default,
						{
							open: this.state.open,
							closeMethod: this.closeModal.bind(this),
							resize: this.props.common.modalResize,
							theme: 'teamBio' },
						_react2.default.createElement(_FoundationRequest.FoundationRequestContainer, {
							closeMethod: this.closeModal.bind(this),
							modalOpen: this.state.open })
					)
				);
			}
		}]);
	
		return Foundation;
	}(_react2.default.Component);
	
	Foundation.propTypes = {
		location: _react.PropTypes.object
	};
	Foundation.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Foundation;
	
	
	function mapStateToProps(state) {
		return {
			common: state.common,
			header: state.header
		};
	}
	
	var FoundationContainer = exports.FoundationContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Foundation);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FoundationRequestContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var FoundationRequest = function (_React$Component) {
	  _inherits(FoundationRequest, _React$Component);
	
	  function FoundationRequest(props) {
	    _classCallCheck(this, FoundationRequest);
	
	    var _this = _possibleConstructorReturn(this, (FoundationRequest.__proto__ || Object.getPrototypeOf(FoundationRequest)).call(this, props));
	
	    _this.state = {
	
	      orgName: '',
	      orgMission: '',
	      eventDescription: '',
	      donationUsed: '',
	      donationBenefits: '',
	      hearAbout: '',
	      eventLocationCity: '',
	      eventLocationState: '',
	      eventLocationVenue: '',
	      eventLocationDate: '',
	      eventLocationTime: '',
	      eventGuestExpected: '',
	      otherJewelers: null,
	      otherDonation: '',
	      priorDonation: null,
	      priorDonationWhat: '',
	      contactName: '',
	      contactEmail: '',
	      contactPhone: '',
	      taxId: '',
	
	      errorOrgName: false,
	      errorOrgMission: false,
	      errorEventDescription: false,
	      errorDonationUsed: false,
	      errorDonationBenefits: false,
	      errorHearAbout: false,
	      errorEventLocationCity: false,
	      errorEventLocationState: false,
	      errorEventLocationVenue: false,
	      errorEventLocationDate: false,
	      errorEventLocationTime: false,
	      errorEventGuestExpected: false,
	      errorOtherJewelers: false,
	      errorOtherDonation: false,
	      errorPriorDonation: false,
	      errorPriorDonationWhat: false,
	      errorContactName: false,
	      errorContactEmail: false,
	      errorContactPhone: false,
	      errorTaxId: false
	    };
	    return _this;
	  }
	
	  _createClass(FoundationRequest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.commonModalResize();
	    }
	  }, {
	    key: 'changeOrgName',
	    value: function changeOrgName(evt) {
	      this.setState({ orgName: evt.target.value });
	    }
	  }, {
	    key: 'changeOrgMission',
	    value: function changeOrgMission(evt) {
	      this.setState({ orgMission: evt.target.value });
	    }
	  }, {
	    key: 'changeOrgDescription',
	    value: function changeOrgDescription(evt) {
	      this.setState({ eventDescription: evt.target.value });
	    }
	  }, {
	    key: 'changeDonationUsed',
	    value: function changeDonationUsed(evt) {
	      this.setState({ donationUsed: evt.target.value });
	    }
	  }, {
	    key: 'changeDonationBenefits',
	    value: function changeDonationBenefits(evt) {
	      this.setState({ donationBenefits: evt.target.value });
	    }
	  }, {
	    key: 'changeHearAbout',
	    value: function changeHearAbout(evt) {
	      this.setState({ hearAbout: evt.target.value });
	    }
	  }, {
	    key: 'changeEventLocationCity',
	    value: function changeEventLocationCity(evt) {
	      this.setState({ eventLocationCity: evt.target.value });
	    }
	  }, {
	    key: 'changeEventLocationState',
	    value: function changeEventLocationState(evt) {
	      this.setState({ eventLocationState: evt.target.value });
	    }
	  }, {
	    key: 'changeEventLocationVenue',
	    value: function changeEventLocationVenue(evt) {
	      this.setState({ eventLocationVenue: evt.target.value });
	    }
	  }, {
	    key: 'changeEventLocationDate',
	    value: function changeEventLocationDate(evt) {
	      this.setState({ eventLocationDate: evt.target.value });
	    }
	  }, {
	    key: 'changeEventLocationTime',
	    value: function changeEventLocationTime(evt) {
	      this.setState({ eventLocationTime: evt.target.value });
	    }
	  }, {
	    key: 'changeEventGuestExpected',
	    value: function changeEventGuestExpected(evt) {
	      this.setState({ eventGuestExpected: evt.target.value });
	    }
	  }, {
	    key: 'changeOtherJewelers',
	    value: function changeOtherJewelers(evt) {
	      this.setState({ otherJewelers: evt.target.value });
	    }
	  }, {
	    key: 'changeOtherDonation',
	    value: function changeOtherDonation(evt) {
	      this.setState({ otherDonation: evt.target.value });
	    }
	  }, {
	    key: 'changePriorDonation',
	    value: function changePriorDonation(evt) {
	      this.setState({ priorDonation: evt.target.value });
	    }
	  }, {
	    key: 'changePriorDonationWhat',
	    value: function changePriorDonationWhat(evt) {
	      this.setState({ priorDonationWhat: evt.target.value });
	    }
	  }, {
	    key: 'changeContactName',
	    value: function changeContactName(evt) {
	      this.setState({ contactName: evt.target.value });
	    }
	  }, {
	    key: 'changeContactEmail',
	    value: function changeContactEmail(evt) {
	      this.setState({ contactEmail: evt.target.value });
	    }
	  }, {
	    key: 'changeContactPhone',
	    value: function changeContactPhone(evt) {
	      this.setState({ contactPhone: evt.target.value });
	    }
	  }, {
	    key: 'changeTaxId',
	    value: function changeTaxId(evt) {
	      this.setState({ taxId: evt.target.value });
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      return true;
	    }
	  }, {
	    key: 'submitRequest',
	    value: function submitRequest() {
	      if (this.validateAll()) {
	
	        var foundationData = {
	          orgName: this.state.orgName,
	          orgMission: this.state.orgMission,
	          eventDescription: this.state.eventDescription,
	          donationUsed: this.state.donationUsed,
	          donationBenefits: this.state.donationBenefits,
	          hearAbout: this.state.hearAbout,
	          eventLocationCity: this.state.eventLocationCity,
	          eventLocationState: this.state.eventLocationState,
	          eventLocationVenue: this.state.eventLocationVenue,
	          eventLocationDate: this.state.eventLocationDate,
	          eventLocationTime: this.state.eventLocationTime,
	          eventGuestExpected: this.state.eventGuestExpected,
	          otherJewelers: this.state.otherJewelers,
	          otherDonation: this.state.otherDonation,
	          priorDonation: this.state.priorDonation,
	          priorDonationWhat: this.state.priorDonationWhat,
	          contactName: this.state.contactName,
	          contactEmail: this.state.contactEmail,
	          contactPhone: this.state.contactPhone,
	          taxId: this.state.taxId
	        };
	
	        this.props.commonFoundationRequest(foundationData);
	        this.props.commonAlert('We have received your submission and will be in touch shortly.', 'Continue');
	        this.props.closeMethod();
	
	        this.setState({
	          orgName: '',
	          orgMission: '',
	          eventDescription: '',
	          donationUsed: '',
	          donationBenefits: '',
	          hearAbout: '',
	          eventLocationCity: '',
	          eventLocationState: '',
	          eventLocationVenue: '',
	          eventLocationDate: '',
	          eventLocationTime: '',
	          eventGuestExpected: '',
	          otherJewelers: null,
	          otherDonation: '',
	          priorDonation: null,
	          priorDonationWhat: '',
	          contactName: '',
	          contactEmail: '',
	          contactPhone: '',
	          taxId: '',
	
	          errorOrgName: false,
	          errorOrgMission: false,
	          errorEventDescription: false,
	          errorDonationUsed: false,
	          errorDonationBenefits: false,
	          errorHearAbout: false,
	          errorEventLocationCity: false,
	          errorEventLocationState: false,
	          errorEventLocationVenue: false,
	          errorEventLocationDate: false,
	          errorEventLocationTime: false,
	          errorEventGuestExpected: false,
	          errorOtherJewelers: false,
	          errorOtherDonation: false,
	          errorPriorDonation: false,
	          errorPriorDonationWhat: false,
	          errorContactName: false,
	          errorContactEmail: false,
	          errorContactPhone: false,
	          errorTaxId: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'FoundationRequest' },
	        _react2.default.createElement(
	          'div',
	          { className: 'closeIcon', onClick: (_context = this.props).closeMethod.bind(_context) },
	          _react2.default.createElement(
	            'div',
	            { className: 'closeX' },
	            '\xD7'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'requestTitle' },
	          'Donation Request Form'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'requestBr' },
	          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/icons/lines/iconline_thin.svg' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'requestColumn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              'Legal name of your organization:'
	            ),
	            _react2.default.createElement('input', { type: 'text', onChange: this.changeOrgName.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              'The mission of your organization:'
	            ),
	            _react2.default.createElement('textarea', { onChange: this.changeOrgMission.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              'A brief description of the event:'
	            ),
	            _react2.default.createElement('textarea', { onChange: this.changeOrgDescription.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              'How will our donation be used?'
	            ),
	            _react2.default.createElement('textarea', { onChange: this.changeDonationUsed.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              'What promotional benefits would we receive for the requested donation?'
	            ),
	            _react2.default.createElement('textarea', { onChange: this.changeDonationBenefits.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              'How did you hear about the Diamonds Direct Foundation?'
	            ),
	            _react2.default.createElement('input', { type: 'text', onChange: this.changeHearAbout.bind(this) })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'requestColumn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inputLabel' },
	            'Location of event:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper twoThirdsWidth' },
	            _react2.default.createElement('input', { type: 'text', placeholder: 'City', onChange: this.changeEventLocationCity.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper oneThirdsWidth secondInput' },
	            _react2.default.createElement('input', { type: 'text', placeholder: 'State', onChange: this.changeEventLocationState.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement('input', { type: 'text', placeholder: 'Venue', onChange: this.changeEventLocationVenue.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper oneThirdsWidth' },
	            _react2.default.createElement('input', { type: 'text', placeholder: 'mm/dd/yyyy', onChange: this.changeEventLocationDate.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper twoThirdsWidth secondInput' },
	            _react2.default.createElement('input', { type: 'text', placeholder: '5:00pm - 9:00pm', onChange: this.changeEventLocationTime.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper halfWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              '# of Guests Expected:'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper halfWidth secondInput' },
	            _react2.default.createElement('input', { type: 'number', onChange: this.changeEventGuestExpected.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              'Are any other jewelers participating?'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'radioWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'radioElement' },
	                _react2.default.createElement('input', { type: 'radio', name: 'other', value: 'Yes', onChange: this.changeOtherJewelers.bind(this) }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'radioLabel' },
	                  'Yes'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'radioElement' },
	                _react2.default.createElement('input', { type: 'radio', name: 'other', value: 'No', onChange: this.changeOtherJewelers.bind(this) }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'radioLabel' },
	                  'No'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              'If so, what are they donating?'
	            ),
	            _react2.default.createElement('input', { type: 'text', onChange: this.changeOtherDonation.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              'Have we donated to your organization before?'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'radioWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'radioElement' },
	                _react2.default.createElement('input', { type: 'radio', name: 'prior', value: 'Yes', onChange: this.changePriorDonation.bind(this) }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'radioLabel' },
	                  'Yes'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'radioElement' },
	                _react2.default.createElement('input', { type: 'radio', name: 'prior', value: 'No', onChange: this.changePriorDonation.bind(this) }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'radioLabel' },
	                  'No'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inputLabel' },
	              'If so, when and what?'
	            ),
	            _react2.default.createElement('input', { type: 'text', onChange: this.changePriorDonationWhat.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputLabel' },
	            'Contact:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement('input', { type: 'text', placeholder: 'Name', onChange: this.changeContactName.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper fullWidth' },
	            _react2.default.createElement('input', { type: 'email', placeholder: 'Email', onChange: this.changeContactEmail.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper halfWidth' },
	            _react2.default.createElement('input', { type: 'text', placeholder: 'Phone', onChange: this.changeContactPhone.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper halfWidth secondInput' },
	            _react2.default.createElement('input', { type: 'text', placeholder: '501c3 Tax ID', onChange: this.changeTaxId.bind(this) })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'submitWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'submitButton actionButton', onClick: this.submitRequest.bind(this) },
	            'Submit'
	          )
	        )
	      );
	    }
	  }]);
	
	  return FoundationRequest;
	}(_react2.default.Component);
	
	FoundationRequest.propTypes = {
	  location: _react.PropTypes.object
	};
	FoundationRequest.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = FoundationRequest;
	
	
	function mapStateToProps(state) {
	  return {
	    header: state.header
	  };
	}
	
	var FoundationRequestContainer = exports.FoundationRequestContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(FoundationRequest);

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GalleryContainer = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _url = __webpack_require__(56);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(42);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _GalleryBreadcrumbs = __webpack_require__(313);
	
	var _EngagementSplash = __webpack_require__(316);
	
	var _EngagementSplash2 = _interopRequireDefault(_EngagementSplash);
	
	var _EngagementFilters = __webpack_require__(527);
	
	var _MixedResults = __webpack_require__(536);
	
	var _DiamondResults = __webpack_require__(533);
	
	var _SettingResults = __webpack_require__(537);
	
	var _MensBandsSplash = __webpack_require__(317);
	
	var _MensBandsSplash2 = _interopRequireDefault(_MensBandsSplash);
	
	var _MensBandsFilters = __webpack_require__(529);
	
	var _BandResults = __webpack_require__(532);
	
	var _WomensBandsSplash = __webpack_require__(318);
	
	var _WomensBandsSplash2 = _interopRequireDefault(_WomensBandsSplash);
	
	var _WomensBandsFilters = __webpack_require__(531);
	
	var _FashionSplash = __webpack_require__(541);
	
	var _FashionSplash2 = _interopRequireDefault(_FashionSplash);
	
	var _FashionFilters = __webpack_require__(528);
	
	var _FashionResults = __webpack_require__(534);
	
	var _MensJewelryFilters = __webpack_require__(530);
	
	var _MensJewelryResults = __webpack_require__(535);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var Gallery = function (_React$Component) {
	  _inherits(Gallery, _React$Component);
	
	  function Gallery(props) {
	    _classCallCheck(this, Gallery);
	
	    var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, props));
	
	    var getData = (0, _url.getJsonFromUrl)();
	    var hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
	
	    var allowedModes = ['mixed', 'diamond', 'setting'];
	    var modeVal = 'mixed';
	    if (hasQuerystring && getData.mode) {
	      modeVal = getData.mode;
	    }
	    if (!allowedModes.includes(modeVal)) {
	      modeVal = 'mixed';
	    }
	
	    if (getData && getData.view == 'results') {}
	
	    _this.state = {
	
	      scrollPos: 0,
	      filtersOpen: window.innerWidth > 1024 ? true : false,
	
	      lastRequest: null,
	      resultsLoaded: false,
	      requestPending: hasQuerystring,
	      getData: getData,
	
	      diamondLastRequest: null,
	      diamondRequestPending: false,
	      diamondResultsLoaded: true,
	
	      engagementMode: modeVal,
	
	      // displaySplash: !hasQuerystring || ((Object.entries(getData).length === 1) && (getData.mode == 'diamond' || getData.mode == 'setting')),
	      displaySplash: false,
	
	      mixedResultsTab: getData && getData.tabtype && getData.tabtype == 'setting' ? 'setting' : 'diamond'
	    };
	
	    // if(hasQuerystring && !((Object.entries(getData).length === 1) && (getData.mode == 'diamond' || getData.mode == 'setting'))) {
	    var pageNum = _this.props.product.currentPage ? _this.props.product.currentPage : 1;
	    _this.fetchInitResults(getData, pageNum);
	    // }
	
	    // Bind event listeners
	    _this.monitorWidth = _this.monitorWidth.bind(_this);
	    _this.getScrollPos = _this.getScrollPos.bind(_this);
	    // this.locationChange = ::this.locationChange;
	
	    // Request controllers
	    _this.productController = null;
	    return _this;
	  }
	
	  _createClass(Gallery, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	
	      window.addEventListener('resize', this.monitorWidth, false);
	      window.addEventListener('scroll', this.getScrollPos, false);
	      // document.addEventListener('change', this.locationChange, false);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	
	      if (this.props.route.productMode != prevProps.route.productMode) {
	        this.setState({ displaySplash: true, filtersOpen: true });
	        this.props.productSaveResults(null);
	      }
	
	      try {
	        Load_Buttons_Hands();
	      } catch (err) {
	        console.error(err);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.monitorWidth, false);
	      window.removeEventListener('scroll', this.getScrollPos, false);
	
	      if (this.productController) {
	        this.productController.abort();
	      }
	    }
	  }, {
	    key: 'monitorWidth',
	    value: function monitorWidth() {
	      // let foundModal = this.getModalBody();
	      if (window.innerWidth <= 1024 && this.state.displaySplash === true && this.state.filtersOpen === false) {
	        this.setState({ filtersOpen: true }, function () {
	          // this.setTimeout(() => {
	          //   this.setState({ displaySplash: false });
	          // }, 500);
	        });
	      }
	    }
	  }, {
	    key: 'getScrollPos',
	    value: function getScrollPos() {
	      this.setState({
	        scrollPos: window.pageYOffset
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'fetchInitResults',
	    value: function fetchInitResults(receivedData) {
	      var currentPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	
	      if (this.props.route.productMode != "engagement") {
	        this.updateData((0, _formatting.formatQuerystring)(receivedData));
	      } else {
	
	        // Price excluded
	        var diamondKeys = ["shape", "caratMin", "caratMax", "color", "clarityMin", "clarityMax", "cutMin", "cutMax", "polMin", "polMax", "symMin", "symMax", "fluorMin", "fluorMax", "depthMin", "depthMax", "tableMin", "tableMax"];
	
	        var settingData = {};
	        var diamondData = {};
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = Object.entries(receivedData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _step$value = _slicedToArray(_step.value, 2),
	                key = _step$value[0],
	                value = _step$value[1];
	
	            if (diamondKeys.includes(key)) {
	              diamondData[key] = value;
	            } else {
	              settingData[key] = value;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        this.updateEngagementSilently(settingData, currentPage);
	        this.updateDiamondDataSilently(diamondData, currentPage);
	      }
	    }
	
	    // Update setting product data
	
	  }, {
	    key: 'updateData',
	    value: function updateData(queryString) {
	      var _this2 = this;
	
	      var thisRequest = Date.now();
	
	      if (this.productController) {
	        this.productController.abort();
	      }
	      var productController = new AbortController();
	      this.productController = productController;
	
	      this.setState({
	        requestPending: true,
	        lastRequest: thisRequest,
	        displaySplash: false
	      }, function () {
	
	        // Limited request
	        console.log('Limited request');
	        _this2.props.productFetchProducts(queryString + '&limit=50', productController.signal).then(function (respData) {
	
	          if (thisRequest == _this2.state.lastRequest) {
	
	            var filtersSnapshot = Object.assign({}, _this2.props.product.productFilters);
	            var filteredResults = (0, _product.reSortProducts)(respData.success.products, filtersSnapshot);
	
	            _this2.props.productSaveResults(filteredResults, respData.success.count);
	            _this2.setState({
	              requestPending: false,
	              resultsLoaded: true
	            }, function () {
	
	              // Full request
	              _this2.props.productFetchProducts(queryString, productController.signal).then(function (respData) {
	
	                if (thisRequest == _this2.state.lastRequest) {
	                  var filteredResults2 = (0, _product.reSortProducts)(respData.success.products, filtersSnapshot);
	                  _this2.props.productSaveResults(filteredResults2, respData.success.count);
	                }
	              }).catch(function (errResp) {
	                if (productController.signal.aborted) {
	                  // Request aborted; do nothing
	                }
	              });
	            });
	          }
	        }).catch(function (errResp) {
	          if (productController.signal.aborted) {
	            // Request aborted; do nothing
	          }
	        });
	      });
	    }
	  }, {
	    key: 'updateEngagementSilently',
	    value: function updateEngagementSilently() {
	      var _this3 = this;
	
	      var queryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var currentPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	
	      this.props.productSaveProductQueryFilters(queryData, 'setting', currentPage);
	      setTimeout(function () {
	
	        if (_this3.productController) {
	          _this3.productController.abort();
	        }
	        var productController = new AbortController();
	        _this3.productController = productController;
	
	        var queryString = (0, _formatting.formatQuerystring)(_this3.props.product.productFilters);
	
	        _this3.props.productFetchProducts(queryString + '&limit=50', productController.signal).then(function (respData) {
	
	          var filtersSnapshot = Object.assign({}, _this3.props.product.productFilters);
	          var filteredResults = (0, _product.reSortProducts)(respData.success.products, filtersSnapshot);
	
	          _this3.props.productSaveResults(filteredResults, respData.success.count);
	          _this3.setState({
	            resultsLoaded: true,
	            displaySplash: false
	          }, function () {
	            _this3.props.productFetchProducts(queryString, productController.signal).then(function (respData) {
	              var filteredResults2 = (0, _product.reSortProducts)(respData.success.products, filtersSnapshot);
	              _this3.props.productSaveResults(filteredResults2, respData.success.count);
	            }).catch(function (errResp) {
	              if (productController.signal.aborted) {
	                // Request aborted; do nothing
	              }
	            });
	          });
	        }).catch(function (errResp) {
	          if (productController.signal.aborted) {
	            // Request aborted; do nothing
	          }
	        });
	      }, 200);
	    }
	  }, {
	    key: 'updateDiamondData',
	    value: function updateDiamondData(queryString) {
	      var _this4 = this;
	
	      var thisRequest = Date.now();
	
	      this.setState({
	        diamondRequestPending: true,
	        diamondLastRequest: thisRequest,
	        displaySplash: false
	      }, function () {
	
	        _this4.props.productFetchDiamonds(queryString).then(function (respData) {
	
	          if (thisRequest == _this4.state.diamondLastRequest) {
	            var filteredResults = (0, _product.reSortDiamonds)(respData.results, _this4.props.product.diamondFilters);
	            _this4.props.productSaveDiamondResults(filteredResults, respData.count < 100 ? filteredResults.length : respData.count);
	            _this4.setState({
	              diamondRequestPending: false,
	              diamondResultsLoaded: true
	            });
	
	            // Fire engagement search if one not present
	            // if(this.props.product.productResults === null) {
	            //   this.updateEngagementSilently();
	            // }
	          } else {}
	        });
	      });
	    }
	  }, {
	    key: 'addDiamondData',
	    value: function addDiamondData() {
	      var _this5 = this;
	
	      var queryString = (0, _formatting.formatQuerystring)(Object.assign({}, this.props.product.diamondFilters, { page: this.props.product.diamondFilters + 1 }));
	      this.props.productFetchDiamonds(queryString).then(function (respData) {
	        var filteredResults = (0, _product.reSortDiamonds)(respData.results, _this5.props.product.diamondFilters);
	        _this5.props.productAppendDiamondResults(filteredResults);
	      });
	    }
	  }, {
	    key: 'updateDiamondDataSilently',
	    value: function updateDiamondDataSilently() {
	      var _this6 = this;
	
	      var queryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var currentPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	
	      this.props.productSaveDiamondQueryFilters(queryData, currentPage);
	      setTimeout(function () {
	        _this6.props.productFetchDiamonds((0, _formatting.formatQuerystring)(_this6.props.product.diamondFilters)).then(function (respData) {
	          var filteredResults = (0, _product.reSortDiamonds)(respData.results, _this6.props.product.diamondFilters);
	          _this6.props.productSaveDiamondResults(filteredResults, filteredResults.length < 100 ? filteredResults.length : respData.count);
	          _this6.setState({
	            diamondResultsLoaded: true,
	            displaySplash: false
	          });
	        });
	      }, 200);
	    }
	  }, {
	    key: 'unconditionalSubmit',
	    value: function unconditionalSubmit() {
	      var _this7 = this;
	
	      this.updateData((0, _formatting.formatQuerystring)(this.props.product.productFilters));
	      this.updateDiamondData((0, _formatting.formatQuerystring)(this.props.product.diamondFilters));
	
	      setTimeout(function () {
	        _this7.setState({ filtersOpen: false });
	      }, 100);
	    }
	  }, {
	    key: 'dataRefresh',
	    value: function dataRefresh() {
	      var _this8 = this;
	
	      var thisRequest = Date.now();
	      this.setState({
	        requestPending: true,
	        lastRequest: thisRequest
	      }, function () {
	        setTimeout(function () {
	          if (thisRequest == _this8.state.lastRequest) {
	            _this8.setState({
	              requestPending: false,
	              resultsLoaded: true
	            });
	          }
	        }, 250);
	      });
	    }
	  }, {
	    key: 'openFilters',
	    value: function openFilters() {
	      this.setState({ filtersOpen: true });
	    }
	  }, {
	    key: 'openAndScroll',
	    value: function openAndScroll() {
	      (0, _reactScrollToComponent2.default)(this.galleryTop, {
	        offset: 0,
	        align: 'top',
	        duration: 300,
	        ease: 'inOutCube'
	      });
	      this.setState({ filtersOpen: true });
	    }
	  }, {
	    key: 'closeFilters',
	    value: function closeFilters() {
	      var shouldSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	
	      if (window.innerWidth <= 1024 && shouldSearch) {
	        this.unconditionalSubmit();
	      }
	      this.setState({ filtersOpen: false });
	    }
	  }, {
	    key: 'setEngagementMode',
	    value: function setEngagementMode(modeVal) {
	      var _this9 = this;
	
	      this.setState({ engagementMode: modeVal }, function () {
	        console.log(_this9.state.engagementMode);
	      });
	    }
	  }, {
	    key: 'updateMixedResultsTab',
	    value: function updateMixedResultsTab(tabVal) {
	      this.setState({ mixedResultsTab: tabVal });
	    }
	  }, {
	    key: 'renderFilters',
	    value: function renderFilters() {
	      switch (this.props.route.productMode) {
	        case "engagement":
	          return _react2.default.createElement(_EngagementFilters.EngagementFiltersContainer, {
	            setMode: this.setEngagementMode.bind(this),
	            setMixedResultsTab: this.updateMixedResultsTab.bind(this),
	            updateMethod: this.updateData.bind(this),
	            updateDiamondsMethod: this.updateDiamondData.bind(this),
	            closeMethod: this.closeFilters.bind(this) });
	        case "mensbands":
	          return _react2.default.createElement(_MensBandsFilters.MensBandsFiltersContainer, {
	            updateMethod: this.updateData.bind(this),
	            closeMethod: this.closeFilters.bind(this) });
	        case "womensbands":
	          return _react2.default.createElement(_WomensBandsFilters.WomensBandsFiltersContainer, {
	            updateMethod: this.updateData.bind(this),
	            closeMethod: this.closeFilters.bind(this) });
	        case "fashion":
	          return _react2.default.createElement(_FashionFilters.FashionFiltersContainer, {
	            updateMethod: this.updateData.bind(this),
	            closeMethod: this.closeFilters.bind(this) });
	        case "mens":
	          return _react2.default.createElement(_MensJewelryFilters.MensJewelryFiltersContainer, {
	            updateMethod: this.updateData.bind(this),
	            closeMethod: this.closeFilters.bind(this) });
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'renderSplashPage',
	    value: function renderSplashPage() {
	      switch (this.props.route.productMode) {
	        case "engagement":
	          return _react2.default.createElement(_EngagementSplash2.default, null);
	        case "mensbands":
	          return _react2.default.createElement(_MensBandsSplash2.default, null);
	        case "womensbands":
	          return _react2.default.createElement(_WomensBandsSplash2.default, null);
	        case "fashion":
	          return _react2.default.createElement(_FashionSplash2.default, null);
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'renderResultsSection',
	    value: function renderResultsSection() {
	      switch (this.props.route.productMode) {
	        case "engagement":
	          return this.getEngagementResultsTemplate();
	        case "mensbands":
	          return _react2.default.createElement(_BandResults.BandResultsContainer, {
	            updateMethod: this.dataRefresh.bind(this),
	            showSplashPage: this.showSplashPage.bind(this),
	            gender: 'mensband',
	            openFilters: this.openAndScroll.bind(this) });
	        case "womensbands":
	          return _react2.default.createElement(_BandResults.BandResultsContainer, {
	            updateMethod: this.dataRefresh.bind(this),
	            showSplashPage: this.showSplashPage.bind(this),
	            gender: 'womensband',
	            openFilters: this.openAndScroll.bind(this) });
	        case "fashion":
	          return _react2.default.createElement(_FashionResults.FashionResultsContainer, {
	            updateMethod: this.dataRefresh.bind(this),
	            showSplashPage: this.showSplashPage.bind(this),
	            openFilters: this.openAndScroll.bind(this) });
	        case "mens":
	          return _react2.default.createElement(_FashionResults.FashionResultsContainer, {
	            updateMethod: this.dataRefresh.bind(this),
	            showSplashPage: this.showSplashPage.bind(this),
	            showAd: false,
	            openFilters: this.openAndScroll.bind(this) });
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'getEngagementResultsTemplate',
	    value: function getEngagementResultsTemplate() {
	      switch (this.state.engagementMode) {
	        case "mixed":
	          return _react2.default.createElement(_MixedResults.MixedResultsContainer, _defineProperty({
	            updateMethod: this.dataRefresh.bind(this),
	            openFilters: this.openFilters.bind(this),
	            tabValue: this.state.mixedResultsTab,
	            showSplashPage: this.showSplashPage.bind(this)
	          }, 'openFilters', this.openAndScroll.bind(this)));
	        case "diamond":
	          return _react2.default.createElement(_DiamondResults.DiamondResultsContainer, {
	            updateMethod: this.dataRefresh.bind(this),
	            setParentMode: this.setEngagementMode.bind(this),
	            showSplashPage: this.showSplashPage.bind(this),
	            openFilters: this.openAndScroll.bind(this) });
	        case "setting":
	          return _react2.default.createElement(_SettingResults.SettingResultsContainer, {
	            updateMethod: this.dataRefresh.bind(this),
	            setParentMode: this.setEngagementMode.bind(this),
	            showSplashPage: this.showSplashPage.bind(this),
	            openFilters: this.openAndScroll.bind(this) });
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'showSplashPage',
	    value: function showSplashPage() {
	
	      // console.log(this.galleryTop);
	
	      (0, _reactScrollToComponent2.default)(this.galleryTop, {
	        offset: 0,
	        align: 'top',
	        duration: 300,
	        ease: 'inOutCube'
	      });
	
	      this.setState({ displaySplash: true });
	    }
	  }, {
	    key: 'hideSplashPage',
	    value: function hideSplashPage() {
	      (0, _reactScrollToComponent2.default)(this.galleryTop, {
	        offset: 0,
	        align: 'top',
	        duration: 300,
	        ease: 'inOutCube'
	      });
	      this.setState({ displaySplash: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this;
	
	      // if(window.location.host.indexOf('staging') >= 0) { 
	      try {
	        Load_Buttons_Hands();
	      } catch (err) {
	        console.error(err);
	      }
	      // }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Gallery', ref: function ref(div) {
	            _this10.galleryTop = div;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'rbBreadcrumbsWrapper' },
	          _react2.default.createElement(_GalleryBreadcrumbs.GalleryBreadcrumbsContainer, {
	            showingResults: this.state.requestPending == false,
	            showingSplashPage: this.state.displaySplash,
	            disableSplash: this.hideSplashPage.bind(this) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.filtersOpen ? 'rbFiltersWrapper filtersOpen' : 'rbFiltersWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'filtersIndicator', onClick: this.openAndScroll.bind(this) },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.scrollPos > 80 ? 'indicatorIcon floating' : 'indicatorIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/search4.svg' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.filtersOpen ? 'filterWrapper filtersOpen' : 'filterWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'closeFilters', onClick: this.closeFilters.bind(this) },
	              _react2.default.createElement(
	                'div',
	                null,
	                '\xD7'
	              )
	            ),
	            this.renderFilters()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.filtersOpen ? 'rbResultsWrapper filtersOpen' : 'rbResultsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rbResultsLoaded' },
	            this.state.displaySplash === true ? _react2.default.createElement(
	              'div',
	              null,
	              this.renderSplashPage()
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'rbProductResults' },
	              this.renderResultsSection()
	            )
	          )
	        ),
	        this.state.filtersOpen ? _react2.default.createElement(
	          'div',
	          { className: 'mobileFooterButton mobileSearchBar', onClick: function onClick() {
	              return _this10.closeFilters(true);
	            } },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Search'
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return Gallery;
	}(_react2.default.Component);
	
	Gallery.propTypes = {
	  location: _react.PropTypes.object
	};
	Gallery.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Gallery;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var GalleryContainer = exports.GalleryContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Gallery);

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CarvedIconsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var CarvedIcons = function (_React$Component) {
	  _inherits(CarvedIcons, _React$Component);
	
	  function CarvedIcons(props) {
	    _classCallCheck(this, CarvedIcons);
	
	    var _this = _possibleConstructorReturn(this, (CarvedIcons.__proto__ || Object.getPrototypeOf(CarvedIcons)).call(this, props));
	
	    var initData = [];
	    if (_this.props.initData) {
	      initData = _this.props.initData;
	    }
	
	    _this.state = {
	      classic: initData.includes('classic'),
	      milgrain: initData.includes('milgrain'),
	      textured: initData.includes('textured'),
	      engraved: initData.includes('engraved'),
	      diamond: initData.includes('diamond')
	    };
	    return _this;
	  }
	
	  _createClass(CarvedIcons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	      var initData = [];
	      if (this.props.initData) {
	        initData = this.props.initData;
	      }
	
	      this.setState({
	        classic: initData.includes('classic'),
	        milgrain: initData.includes('milgrain'),
	        textured: initData.includes('textured'),
	        engraved: initData.includes('engraved'),
	        diamond: initData.includes('diamond')
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'concatValues',
	    value: function concatValues() {
	      var returnArray = [];
	      for (var key in this.state) {
	        if (this.state[key]) {
	          returnArray.push(key);
	        }
	      }
	      if (returnArray.join(',').length) {
	        return [returnArray.join(',')];
	      } else {
	        return [Object.keys(this.state).join(',')];
	      }
	    }
	  }, {
	    key: 'toggleShapeSelect',
	    value: function toggleShapeSelect(shape) {
	      var _this2 = this;
	
	      if (shape == 'classic') {
	        this.setState({ classic: !this.state.classic }, function () {
	          _this2.props.refreshData('mensband', ['carved'], _this2.concatValues());
	        });
	      } else if (shape == 'milgrain') {
	        this.setState({ milgrain: !this.state.milgrain }, function () {
	          _this2.props.refreshData('mensband', ['carved'], _this2.concatValues());
	        });
	      } else if (shape == 'textured') {
	        this.setState({ textured: !this.state.textured }, function () {
	          _this2.props.refreshData('mensband', ['carved'], _this2.concatValues());
	        });
	      } else if (shape == 'engraved') {
	        this.setState({ engraved: !this.state.engraved }, function () {
	          _this2.props.refreshData('mensband', ['carved'], _this2.concatValues());
	        });
	      } else if (shape == 'diamond') {
	        this.setState({ diamond: !this.state.diamond }, function () {
	          _this2.props.refreshData('mensband', ['carved'], _this2.concatValues());
	        });
	      }
	    }
	  }, {
	    key: 'selectAllShapes',
	    value: function selectAllShapes() {
	      var _this3 = this;
	
	      var toggleValue = false;
	      for (var key in this.state) {
	        if (!this.state[key]) {
	          toggleValue = true;
	          break;
	        }
	      }
	
	      this.setState({
	        classic: toggleValue,
	        milgrain: toggleValue,
	        textured: toggleValue,
	        engraved: toggleValue,
	        diamond: toggleValue
	      }, function () {
	        _this3.props.refreshData('mensband', ['carved'], _this3.concatValues());
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'CarvedIcons StyleIcons' },
	        _react2.default.createElement(
	          'div',
	          { className: 'iconsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hiddenLoading' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/beveled.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/beveled_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/engraved.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/engraved_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/milgrain.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/milgrain_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/textured.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/textured_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/channel.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/channel_a.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.milgrain ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('milgrain');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/milgrain.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/milgrain_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Milgrain'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.textured ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('textured');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/textured.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/textured_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Textured'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.engraved ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('engraved');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/engraved.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/engraved_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Engraved'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.classic ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('classic');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/beveled.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/carved/beveled_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Classic'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.diamond ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('diamond');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/channel.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/channel_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Diamond'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'allLinkWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'allLink', onClick: this.selectAllShapes.bind(this) },
	            'All'
	          )
	        )
	      );
	    }
	  }]);
	
	  return CarvedIcons;
	}(_react2.default.Component);
	
	CarvedIcons.propTypes = {
	  location: _react.PropTypes.object
	};
	CarvedIcons.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = CarvedIcons;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var CarvedIconsContainer = exports.CarvedIconsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(CarvedIcons);

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorRadiosContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var ColorRadios = function (_React$Component) {
	  _inherits(ColorRadios, _React$Component);
	
	  function ColorRadios(props) {
	    _classCallCheck(this, ColorRadios);
	
	    var _this = _possibleConstructorReturn(this, (ColorRadios.__proto__ || Object.getPrototypeOf(ColorRadios)).call(this, props));
	
	    var colorArray = _this.props.initData ? _this.props.initData : [];
	    _this.state = {
	      d: colorArray.includes('d'),
	      e: colorArray.includes('e'),
	      f: colorArray.includes('f'),
	      g: colorArray.includes('g'),
	      h: colorArray.includes('h'),
	      i: colorArray.includes('i'),
	      j: colorArray.includes('j'),
	      k: colorArray.includes('k'),
	      l: colorArray.includes('l'),
	      m: colorArray.includes('m')
	    };
	    return _this;
	  }
	
	  _createClass(ColorRadios, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	
	      var colorArray = this.props.initData ? this.props.initData : [];
	      this.setState({
	        d: colorArray.includes('d'),
	        e: colorArray.includes('e'),
	        f: colorArray.includes('f'),
	        g: colorArray.includes('g'),
	        h: colorArray.includes('h'),
	        i: colorArray.includes('i'),
	        j: colorArray.includes('j'),
	        k: colorArray.includes('k'),
	        l: colorArray.includes('l'),
	        m: colorArray.includes('m')
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'concatValues',
	    value: function concatValues() {
	      var returnArray = [];
	      for (var key in this.state) {
	        if (this.state[key]) {
	          returnArray.push(key.toUpperCase());
	        }
	      }
	      if (returnArray.join(',').length) {
	        return [returnArray.join(',')];
	      } else {
	        return [Object.keys(this.state).join(',')];
	      }
	    }
	  }, {
	    key: 'toggleColor',
	    value: function toggleColor(color) {
	      var _this2 = this;
	
	      if (color == 'd') {
	        this.setState({ d: !this.state.d }, function () {
	          _this2.props.refreshData('diamonds', ['color'], _this2.concatValues());
	        });
	      } else if (color == 'e') {
	        this.setState({ e: !this.state.e }, function () {
	          _this2.props.refreshData('diamonds', ['color'], _this2.concatValues());
	        });
	      } else if (color == 'f') {
	        this.setState({ f: !this.state.f }, function () {
	          _this2.props.refreshData('diamonds', ['color'], _this2.concatValues());
	        });
	      } else if (color == 'g') {
	        this.setState({ g: !this.state.g }, function () {
	          _this2.props.refreshData('diamonds', ['color'], _this2.concatValues());
	        });
	      } else if (color == 'h') {
	        this.setState({ h: !this.state.h }, function () {
	          _this2.props.refreshData('diamonds', ['color'], _this2.concatValues());
	        });
	      } else if (color == 'i') {
	        this.setState({ i: !this.state.i }, function () {
	          _this2.props.refreshData('diamonds', ['color'], _this2.concatValues());
	        });
	      } else if (color == 'j') {
	        this.setState({ j: !this.state.j }, function () {
	          _this2.props.refreshData('diamonds', ['color'], _this2.concatValues());
	        });
	      } else if (color == 'k') {
	        this.setState({ k: !this.state.k }, function () {
	          _this2.props.refreshData('diamonds', ['color'], _this2.concatValues());
	        });
	      } else if (color == 'l') {
	        this.setState({ l: !this.state.l }, function () {
	          _this2.props.refreshData('diamonds', ['color'], _this2.concatValues());
	        });
	      } else if (color == 'm') {
	        this.setState({ m: !this.state.m }, function () {
	          _this2.props.refreshData('diamonds', ['color'], _this2.concatValues());
	        });
	      }
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      var _this3 = this;
	
	      this.setState({
	        d: true,
	        e: true,
	        f: true,
	        g: true,
	        h: true,
	        i: true,
	        j: true,
	        k: true,
	        l: true,
	        m: true
	      }, function () {
	        _this3.props.refreshData('diamonds', ['color'], _this3.concatValues());
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ColorRadios' },
	        _react2.default.createElement(
	          'div',
	          { className: 'radioRowWrapper' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.d ? 'radioItem selected' : 'radioItem',
	              onClick: function onClick() {
	                return _this4.toggleColor('d');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip' },
	              'D'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.e ? 'radioItem selected' : 'radioItem',
	              onClick: function onClick() {
	                return _this4.toggleColor('e');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip' },
	              'E'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.f ? 'radioItem selected' : 'radioItem',
	              onClick: function onClick() {
	                return _this4.toggleColor('f');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip' },
	              'F'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.g ? 'radioItem selected' : 'radioItem',
	              onClick: function onClick() {
	                return _this4.toggleColor('g');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip' },
	              'G'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.h ? 'radioItem selected' : 'radioItem',
	              onClick: function onClick() {
	                return _this4.toggleColor('h');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip' },
	              'H'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.i ? 'radioItem selected' : 'radioItem',
	              onClick: function onClick() {
	                return _this4.toggleColor('i');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip' },
	              'I'
	            )
	          ),
	          _react2.default.createElement('div', { className: 'lineBreak' }),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.j ? 'radioItem selected' : 'radioItem',
	              onClick: function onClick() {
	                return _this4.toggleColor('j');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip' },
	              'J'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.k ? 'radioItem selected' : 'radioItem',
	              onClick: function onClick() {
	                return _this4.toggleColor('k');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip' },
	              'K'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.l ? 'radioItem selected' : 'radioItem',
	              onClick: function onClick() {
	                return _this4.toggleColor('l');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip' },
	              'L'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.m ? 'radioItem selected' : 'radioItem',
	              onClick: function onClick() {
	                return _this4.toggleColor('m');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip' },
	              'M'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'radioItem allItem', onClick: this.selectAll.bind(this) },
	            _react2.default.createElement(
	              'div',
	              { className: 'radioPip allPip' },
	              'All'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'allLinkWrapper', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'allLink', onClick: this.selectAll.bind(this) },
	              'Select All'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ColorRadios;
	}(_react2.default.Component);
	
	ColorRadios.propTypes = {
	  location: _react.PropTypes.object
	};
	ColorRadios.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ColorRadios;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ColorRadiosContainer = exports.ColorRadiosContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ColorRadios);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FinishIconsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var FinishIcons = function (_React$Component) {
	  _inherits(FinishIcons, _React$Component);
	
	  function FinishIcons(props) {
	    _classCallCheck(this, FinishIcons);
	
	    var _this = _possibleConstructorReturn(this, (FinishIcons.__proto__ || Object.getPrototypeOf(FinishIcons)).call(this, props));
	
	    var initData = [];
	    if (_this.props.initData) {
	      initData = _this.props.initData;
	    }
	
	    _this.state = {
	      polished: initData.includes('polished'),
	      matte: initData.includes('matte')
	    };
	    return _this;
	  }
	
	  _createClass(FinishIcons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	      var initData = [];
	      this.setState({
	        polished: initData.includes('polished'),
	        matte: initData.includes('matte')
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'concatValues',
	    value: function concatValues() {
	      var returnArray = [];
	      for (var key in this.state) {
	        if (this.state[key]) {
	          returnArray.push(key);
	        }
	      }
	      if (returnArray.join(',').length) {
	        return [returnArray.join(',')];
	      } else {
	        return [Object.keys(this.state).join(',')];
	      }
	    }
	  }, {
	    key: 'toggleShapeSelect',
	    value: function toggleShapeSelect(shape) {
	      var _this2 = this;
	
	      if (shape == 'polished') {
	        this.setState({ polished: !this.state.polished }, function () {
	          _this2.props.refreshData('mensband', ['finish'], _this2.concatValues());
	        });
	      } else if (shape == 'matte') {
	        this.setState({ matte: !this.state.matte }, function () {
	          _this2.props.refreshData('mensband', ['finish'], _this2.concatValues());
	        });
	      }
	    }
	  }, {
	    key: 'selectAllShapes',
	    value: function selectAllShapes() {
	      var _this3 = this;
	
	      var toggleValue = false;
	      for (var key in this.state) {
	        if (!this.state[key]) {
	          toggleValue = true;
	          break;
	        }
	      }
	
	      this.setState({
	        polished: toggleValue,
	        matte: toggleValue
	      }, function () {
	        _this3.props.refreshData('mensband', ['finish'], _this3.concatValues());
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'FinishIcons StyleIcons' },
	        _react2.default.createElement(
	          'div',
	          { className: 'iconsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hiddenLoading' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/finish/hpolish.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/finish/hpolish_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/finish/matte.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/finish/matte_a.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.polished ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('polished');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/finish/hpolish.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/finish/hpolish_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'High Polish'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.matte ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('matte');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/finish/matte.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/finish/matte_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Matte'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'allLinkWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'allLink', onClick: this.selectAllShapes.bind(this) },
	            'All'
	          )
	        )
	      );
	    }
	  }]);
	
	  return FinishIcons;
	}(_react2.default.Component);
	
	FinishIcons.propTypes = {
	  location: _react.PropTypes.object
	};
	FinishIcons.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = FinishIcons;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var FinishIconsContainer = exports.FinishIconsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(FinishIcons);

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MensDiamondIconsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var MensDiamondIcons = function (_React$Component) {
	  _inherits(MensDiamondIcons, _React$Component);
	
	  function MensDiamondIcons(props) {
	    _classCallCheck(this, MensDiamondIcons);
	
	    var _this = _possibleConstructorReturn(this, (MensDiamondIcons.__proto__ || Object.getPrototypeOf(MensDiamondIcons)).call(this, props));
	
	    var initData = [];
	    if (_this.props.initData) {
	      initData = _this.props.initData;
	    }
	
	    _this.state = {
	      accented: initData.includes('accented'),
	      channel: initData.includes('channel')
	    };
	    return _this;
	  }
	
	  _createClass(MensDiamondIcons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData(evt) {
	      var initData = [];
	      if (this.props.initData) {
	        initData = this.props.initData;
	      }
	
	      this.setState({
	        accented: initData.includes('accented'),
	        channel: initData.includes('channel')
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'concatValues',
	    value: function concatValues() {
	      var returnArray = [];
	      for (var key in this.state) {
	        if (this.state[key]) {
	          returnArray.push(key);
	        }
	      }
	      if (returnArray.join(',').length) {
	        return [returnArray.join(',')];
	      } else {
	        return [Object.keys(this.state).join(',')];
	      }
	    }
	  }, {
	    key: 'toggleShapeSelect',
	    value: function toggleShapeSelect(shape) {
	      var _this2 = this;
	
	      if (shape == 'accented') {
	        this.setState({ accented: !this.state.accented }, function () {
	          _this2.props.refreshData('mensband', ['mensdiamond'], _this2.concatValues());
	        });
	      } else if (shape == 'channel') {
	        this.setState({ channel: !this.state.channel }, function () {
	          _this2.props.refreshData('mensband', ['mensdiamond'], _this2.concatValues());
	        });
	      }
	    }
	  }, {
	    key: 'selectAllShapes',
	    value: function selectAllShapes() {
	      var _this3 = this;
	
	      var toggleValue = false;
	      for (var key in this.state) {
	        if (!this.state[key]) {
	          toggleValue = true;
	          break;
	        }
	      }
	
	      this.setState({
	        accented: toggleValue,
	        channel: toggleValue
	      }, function () {
	        _this3.props.refreshData('mensband', ['mensdiamond'], _this3.concatValues());
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MensDiamondIcons StyleIcons' },
	        _react2.default.createElement(
	          'div',
	          { className: 'iconsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hiddenLoading' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/accented.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/accented_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/channel.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/channel_a.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.accented ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('accented');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/accented.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/accented_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Accented'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.channel ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('channel');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/channel.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/mensdiamond/channel_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Chennel Set'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'allLinkWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'allLink', onClick: this.selectAllShapes.bind(this) },
	            'All'
	          )
	        )
	      );
	    }
	  }]);
	
	  return MensDiamondIcons;
	}(_react2.default.Component);
	
	MensDiamondIcons.propTypes = {
	  location: _react.PropTypes.object
	};
	MensDiamondIcons.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = MensDiamondIcons;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var MensDiamondIconsContainer = exports.MensDiamondIconsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(MensDiamondIcons);

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SettingTypeIconsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var SettingTypeIcons = function (_React$Component) {
	  _inherits(SettingTypeIcons, _React$Component);
	
	  function SettingTypeIcons(props) {
	    _classCallCheck(this, SettingTypeIcons);
	
	    var _this = _possibleConstructorReturn(this, (SettingTypeIcons.__proto__ || Object.getPrototypeOf(SettingTypeIcons)).call(this, props));
	
	    var initData = [];
	    if (_this.props.initData) {
	      initData = _this.props.initData;
	    }
	
	    _this.state = {
	      solitaire: initData.includes('solitaire'),
	      threeStone: initData.includes('threestone'),
	      halo: initData.includes('halo'),
	      pave: initData.includes('pave')
	    };
	    return _this;
	  }
	
	  _createClass(SettingTypeIcons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	
	      var initData = [];
	      if (this.props.initData) {
	        initData = this.props.initData;
	      }
	
	      this.setState({
	        solitaire: initData.includes('solitaire'),
	        threeStone: initData.includes('threestone'),
	        halo: initData.includes('halo'),
	        pave: initData.includes('pave')
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'concatValues',
	    value: function concatValues() {
	      var returnArray = [];
	      for (var key in this.state) {
	        if (this.state[key]) {
	          returnArray.push(key.charAt(0).toUpperCase() + key.slice(1));
	        }
	      }
	      if (returnArray.join(',').length) {
	        return [returnArray.join(',')];
	      } else {
	        return [Object.keys(this.state).join(',')];
	      }
	    }
	  }, {
	    key: 'toggleShapeSelect',
	    value: function toggleShapeSelect(shape) {
	      var _this2 = this;
	
	      if (shape == 'solitaire') {
	        this.setState({ solitaire: !this.state.solitaire }, function () {
	          _this2.props.refreshData('settings', ['settingtype'], _this2.concatValues());
	        });
	      } else if (shape == 'threeStone') {
	        this.setState({ threeStone: !this.state.threeStone }, function () {
	          _this2.props.refreshData('settings', ['settingtype'], _this2.concatValues());
	        });
	      } else if (shape == 'halo') {
	        this.setState({ halo: !this.state.halo }, function () {
	          _this2.props.refreshData('settings', ['settingtype'], _this2.concatValues());
	        });
	      } else if (shape == 'pave') {
	        this.setState({ pave: !this.state.pave }, function () {
	          _this2.props.refreshData('settings', ['settingtype'], _this2.concatValues());
	        });
	      }
	    }
	  }, {
	    key: 'selectAllShapes',
	    value: function selectAllShapes() {
	      var _this3 = this;
	
	      var toggleValue = false;
	      for (var key in this.state) {
	        if (!this.state[key]) {
	          toggleValue = true;
	          break;
	        }
	      }
	
	      this.setState({
	        solitaire: toggleValue,
	        threeStone: toggleValue,
	        halo: toggleValue,
	        pave: toggleValue
	      }, function () {
	        _this3.props.refreshData('settings', ['settingtype'], _this3.concatValues());
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'SettingTypeIcons' },
	        _react2.default.createElement(
	          'div',
	          { className: 'iconsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hiddenLoading' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/solitaire.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/solitaire_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/three_stone.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/three_stone_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/halo.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/halo_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/pave.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/pave_a.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.solitaire ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('solitaire');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/solitaire.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/solitaire_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Solitaire'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.threeStone ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('threeStone');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/three_stone.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/three_stone_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Three Stone'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.halo ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('halo');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/halo.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/halo_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Halo'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.pave ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('pave');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/pave.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/settingtype/pave_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Diamond Accented'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'allLinkWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'allLink', onClick: this.selectAllShapes.bind(this) },
	            'All'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SettingTypeIcons;
	}(_react2.default.Component);
	
	SettingTypeIcons.propTypes = {
	  location: _react.PropTypes.object
	};
	SettingTypeIcons.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = SettingTypeIcons;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var SettingTypeIconsContainer = exports.SettingTypeIconsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(SettingTypeIcons);

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShapeIconsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var ShapeIcons = function (_React$Component) {
	  _inherits(ShapeIcons, _React$Component);
	
	  function ShapeIcons(props) {
	    _classCallCheck(this, ShapeIcons);
	
	    var _this = _possibleConstructorReturn(this, (ShapeIcons.__proto__ || Object.getPrototypeOf(ShapeIcons)).call(this, props));
	
	    var initData = [];
	    if (_this.props.initData) {
	      initData = _this.props.initData;
	    }
	
	    _this.state = {
	      round: initData.includes('round'),
	      pear: initData.includes('pear'),
	      heart: initData.includes('heart'),
	      oval: initData.includes('oval'),
	      cushion: initData.includes('cushion'),
	      emerald: initData.includes('emerald'),
	      radiant: initData.includes('radiant'),
	      marquise: initData.includes('marquise'),
	      asscher: initData.includes('asscher'),
	      princess: initData.includes('princess')
	    };
	
	    // this.resetData = ::this.resetData;
	    return _this;
	  }
	
	  _createClass(ShapeIcons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // this.props.resetElement(this.resetData);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.resetElement != prevProps.resetElement) {
	        this.resetData();
	      }
	    }
	  }, {
	    key: 'resetData',
	    value: function resetData() {
	
	      var initData = [];
	      if (this.props.initData) {
	        initData = this.props.initData;
	      }
	
	      this.setState({
	        round: initData.includes('round'),
	        pear: initData.includes('pear'),
	        heart: initData.includes('heart'),
	        oval: initData.includes('oval'),
	        cushion: initData.includes('cushion'),
	        emerald: initData.includes('emerald'),
	        radiant: initData.includes('radiant'),
	        marquise: initData.includes('marquise'),
	        asscher: initData.includes('asscher'),
	        princess: initData.includes('princess')
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'concatValues',
	    value: function concatValues() {
	      var returnArray = [];
	      for (var key in this.state) {
	        if (this.state[key]) {
	          returnArray.push(key.charAt(0).toUpperCase() + key.slice(1));
	        }
	      }
	      if (returnArray.join(',').length > 0) {
	        return [returnArray.join(',')];
	      } else {
	        return [Object.keys(this.state).join(',')];
	      }
	    }
	  }, {
	    key: 'toggleShapeSelect',
	    value: function toggleShapeSelect(shape) {
	      var _this2 = this;
	
	      if (shape == 'round') {
	        this.setState({ round: !this.state.round }, function () {
	          _this2.props.refreshData('diamonds', ['shape'], _this2.concatValues());
	        });
	      } else if (shape == 'pear') {
	        this.setState({ pear: !this.state.pear }, function () {
	          _this2.props.refreshData('diamonds', ['shape'], _this2.concatValues());
	        });
	      } else if (shape == 'heart') {
	        this.setState({ heart: !this.state.heart }, function () {
	          _this2.props.refreshData('diamonds', ['shape'], _this2.concatValues());
	        });
	      } else if (shape == 'oval') {
	        this.setState({ oval: !this.state.oval }, function () {
	          _this2.props.refreshData('diamonds', ['shape'], _this2.concatValues());
	        });
	      } else if (shape == 'cushion') {
	        this.setState({ cushion: !this.state.cushion }, function () {
	          _this2.props.refreshData('diamonds', ['shape'], _this2.concatValues());
	        });
	      } else if (shape == 'emerald') {
	        this.setState({ emerald: !this.state.emerald }, function () {
	          _this2.props.refreshData('diamonds', ['shape'], _this2.concatValues());
	        });
	      } else if (shape == 'radiant') {
	        this.setState({ radiant: !this.state.radiant }, function () {
	          _this2.props.refreshData('diamonds', ['shape'], _this2.concatValues());
	        });
	      } else if (shape == 'marquise') {
	        this.setState({ marquise: !this.state.marquise }, function () {
	          _this2.props.refreshData('diamonds', ['shape'], _this2.concatValues());
	        });
	      } else if (shape == 'asscher') {
	        this.setState({ asscher: !this.state.asscher }, function () {
	          _this2.props.refreshData('diamonds', ['shape'], _this2.concatValues());
	        });
	      } else if (shape == 'princess') {
	        this.setState({ princess: !this.state.princess }, function () {
	          _this2.props.refreshData('diamonds', ['shape'], _this2.concatValues());
	        });
	      }
	    }
	  }, {
	    key: 'selectAllShapes',
	    value: function selectAllShapes() {
	      var _this3 = this;
	
	      var toggleValue = false;
	      for (var key in this.state) {
	        if (!this.state[key]) {
	          toggleValue = true;
	          break;
	        }
	      }
	
	      this.setState({
	        round: toggleValue,
	        pear: toggleValue,
	        heart: toggleValue,
	        oval: toggleValue,
	        cushion: toggleValue,
	        emerald: toggleValue,
	        radiant: toggleValue,
	        marquise: toggleValue,
	        asscher: toggleValue,
	        princess: toggleValue
	      }, function () {
	        _this3.props.refreshData('diamonds', ['shape'], _this3.concatValues());
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ShapeIcons' },
	        _react2.default.createElement(
	          'div',
	          { className: 'iconsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hiddenLoading' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/round.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/round_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/pear.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/pear_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/heart.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/heart_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/oval.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/oval_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/cushion.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/cushion_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/emerald.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/emerald_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/radiant.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/radiant_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/marquis.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/marquis_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/asscher.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/asscher_a.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/princess.svg' }),
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/princess_a.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.round ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('round');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/round.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/round_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Round'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.cushion ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('cushion');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/cushion.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/cushion_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Cushion'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.oval ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('oval');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/oval.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/oval_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Oval'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.princess ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('princess');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/princess.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/princess_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Princess'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.emerald ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('emerald');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/emerald.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/emerald_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Emerald'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconRow' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.pear ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('pear');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/pear.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/pear_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Pear'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.radiant ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('radiant');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/radiant.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/radiant_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Radiant'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.marquise ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('marquise');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/marquis.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/marquis_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Marquise'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.asscher ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('asscher');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/asscher.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/asscher_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Asscher'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.heart ? 'shapeIconWrapper selected' : 'shapeIconWrapper',
	                onClick: function onClick() {
	                  return _this4.toggleShapeSelect('heart');
	                } },
	              _react2.default.createElement('img', { className: 'imgNotSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/heart.svg' }),
	              _react2.default.createElement('img', { className: 'imgSelected', src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/shape/heart_a.svg' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Heart'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'allLinkWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'allLink', onClick: this.selectAllShapes.bind(this) },
	            'All'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShapeIcons;
	}(_react2.default.Component);
	
	ShapeIcons.propTypes = {
	  location: _react.PropTypes.object
	};
	ShapeIcons.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ShapeIcons;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ShapeIconsContainer = exports.ShapeIconsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ShapeIcons);

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EngagementFiltersContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _url = __webpack_require__(56);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	var _CheckboxList = __webpack_require__(149);
	
	var _CheckboxList2 = _interopRequireDefault(_CheckboxList);
	
	var _ColorRadios = __webpack_require__(522);
	
	var _ColorRadios2 = _interopRequireDefault(_ColorRadios);
	
	var _NumericSlider = __webpack_require__(150);
	
	var _NumericSlider2 = _interopRequireDefault(_NumericSlider);
	
	var _ShapeIcons = __webpack_require__(526);
	
	var _ShapeIcons2 = _interopRequireDefault(_ShapeIcons);
	
	var _StyleIcons = __webpack_require__(151);
	
	var _StyleIcons2 = _interopRequireDefault(_StyleIcons);
	
	var _SettingTypeIcons = __webpack_require__(525);
	
	var _SettingTypeIcons2 = _interopRequireDefault(_SettingTypeIcons);
	
	var _ValuesSlider = __webpack_require__(152);
	
	var _ValuesSlider2 = _interopRequireDefault(_ValuesSlider);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var EngagementFilters = function (_React$Component) {
	  _inherits(EngagementFilters, _React$Component);
	
	  function EngagementFilters(props) {
	    var _this$state;
	
	    _classCallCheck(this, EngagementFilters);
	
	    var _this = _possibleConstructorReturn(this, (EngagementFilters.__proto__ || Object.getPrototypeOf(EngagementFilters)).call(this, props));
	
	    var urlData = (0, _url.getJsonFromUrl)();
	    var getData = Object.assign({}, _this.props.product.diamondFilters, _this.props.product.productFilters, urlData);
	    var urlKeys = Object.keys(urlData);
	    var getKeys = Object.keys(getData);
	    var hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
	
	    // Default Values
	    var diamondsEnabledValue = true;
	    var settingsEnabledValue = true;
	
	    if (hasQuerystring && urlData.mode) {
	
	      var modeVal = urlData.mode;
	      if (modeVal == 'diamond') {
	        settingsEnabledValue = false;
	      }
	      if (modeVal == 'setting') {
	        diamondsEnabledValue = false;
	      }
	    }
	
	    _this.initDiamondFilters = {
	      // shape: 'Round,Oval,Cushion',
	      // caratMin: 0.50,
	      // caratMax: 4.00,
	      // color: 'F,G,H,I',
	      // clarityMin: 'SI2',
	      // clarityMax: 'VS2',
	    };
	
	    _this.initSettingFilters = {};
	
	    _this.state = (_this$state = {
	
	      diamondsEnabled: diamondsEnabledValue,
	      settingsEnabled: settingsEnabledValue,
	
	      diamondPriceOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	      settingPriceOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	
	      diamondPriceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
	      diamondPriceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,
	
	      budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	      priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
	      priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,
	
	      shapesOpen: diamondsEnabledValue === true && (getKeys.includes('shape') || diamondsEnabledValue === true),
	      shapeValues: getKeys.includes('shape') ? getData['shape'].toLowerCase().split(',') : [],
	
	      caratOpen: diamondsEnabledValue === true && (urlKeys.includes('caratMin') || urlKeys.includes('caratMax') || diamondsEnabledValue === true && settingsEnabledValue === false),
	      caratMin: getKeys.includes('caratMin') ? parseFloat(getData['caratMin']) : 0.50,
	      caratMax: getKeys.includes('caratMax') ? parseFloat(getData['caratMax']) : 5.0,
	
	      colorOpen: diamondsEnabledValue === true && urlKeys.includes('color'),
	      colorValues: getKeys.includes('color') ? getData['color'].toLowerCase().split(',') : [],
	
	      clarityOpen: diamondsEnabledValue === true && (urlKeys.includes('clarityMin') || urlKeys.includes('clarityMax')),
	      clarityMin: getKeys.includes('clarityMin') ? getData['clarityMin'] : 'SI2',
	      clarityMax: getKeys.includes('clarityMax') ? getData['clarityMax'] : 'IF',
	      clarityValues: ['IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2'],
	
	      // certificationOpen: false,
	
	      cutOpen: getKeys.includes('cutMin') || getKeys.includes('cutMax'),
	      cutMin: getKeys.includes('cutMin') ? getData['cutMin'] : 'Very Good',
	      cutMax: getKeys.includes('cutMax') ? getData['cutMax'] : 'Excellent',
	      cutValues: ['Excellent', 'Very Good'],
	      cutTranslate: {
	        'Very Good': 'VG',
	        'Excellent': 'EX'
	      },
	
	      designersOpen: getKeys.includes('designers'),
	      designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,
	
	      // diamondAdvancedOpen: getKeys.includes('cutMin') || getKeys.includes('cutMax') || getKeys.includes('polMin') || getKeys.includes('polMax') || getKeys.includes('symMin') || getKeys.includes('symMax') || getKeys.includes('fluorMin') || getKeys.includes('fluorMax') || getKeys.includes('depthMin') || getKeys.includes('depthMax') || getKeys.includes('tableMin') || getKeys.includes('tableMax'),
	      diamondAdvancedOpen: false,
	
	      polishValues: ['Excellent', 'Very Good', 'Good'],
	      polishMin: getKeys.includes('polMin') ? getData['polMin'] : 'Good',
	      polishMax: getKeys.includes('polMax') ? getData['polMax'] : 'Excellent',
	      polishTranslate: {
	        'Good': 'GD',
	        'Very Good': 'VG',
	        'Excellent': 'EX'
	      },
	
	      symmetryValues: ['Excellent', 'Very Good', 'Good'],
	      symmetryMin: getKeys.includes('symMin') ? getData['symMin'] : 'Good',
	      symmetryMax: getKeys.includes('symMax') ? getData['symMax'] : 'Excellent',
	      symmetryTranslate: {
	        'Good': 'GD',
	        'Very Good': 'VG',
	        'Excellent': 'EX'
	      },
	
	      // fluorescenceValues: ['Very Strong', 'Strong', 'Medium', 'Faint', 'None'],
	      fluorescenceValues: ['None', 'Faint', 'Medium', 'Strong', 'Very Strong'],
	      fluorescenceMin: getKeys.includes('fluorMin') ? getData['fluorMin'] : 'None',
	      fluorescenceMax: getKeys.includes('fluorMax') ? getData['fluorMax'] : 'Very Strong',
	
	      typeOpen: getKeys.includes('settingtype') || settingsEnabledValue === true,
	      typeValues: getKeys.includes('settingtype') ? getData['settingtype'].toLowerCase().split(',') : [],
	
	      stylesOpen: getKeys.includes('style') || diamondsEnabledValue === false && settingsEnabledValue === true,
	      styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : []
	
	    }, _defineProperty(_this$state, 'designersOpen', getKeys.includes('designers')), _defineProperty(_this$state, 'designersValues', getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null), _defineProperty(_this$state, 'metalTypesOpen', getKeys.includes('metal')), _defineProperty(_this$state, 'metalTypesValues', getKeys.includes('metal') ? getData['metal'].toUpperCase().split(',') : null), _defineProperty(_this$state, 'settingAdvancedOpen', getKeys.includes('mmWidthMin') || getKeys.includes('mmWidthMax') || getKeys.includes('continuity')), _defineProperty(_this$state, 'mmWidthMin', getKeys.includes('mmWidthMin') ? getData['mmWidthMin'] : 1.5), _defineProperty(_this$state, 'mmWidthMax', getKeys.includes('mmWidthMax') ? getData['mmWidthMax'] : 4), _defineProperty(_this$state, 'diamondQueryFilters', {}), _defineProperty(_this$state, 'settingQueryFilters', {}), _this$state);
	    return _this;
	  }
	
	  _createClass(EngagementFilters, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.common.registerNavChange && this.props.common.registerNavChange && prevProps.common.registerNavChange != this.props.common.registerNavChange) {
	
	        var urlData = (0, _url.getJsonFromUrl)();
	        var getData = Object.assign({}, this.props.product.diamondFilters, this.props.product.productFilters, urlData);
	        var getKeys = Object.keys(getData);
	        var hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
	
	        // Default Values
	        var diamondsEnabledValue = true;
	        var settingsEnabledValue = true;
	
	        if (hasQuerystring && getData.mode) {
	
	          var modeVal = getData.mode;
	          if (modeVal == 'diamond') {
	            settingsEnabledValue = false;
	          }
	          if (modeVal == 'setting') {
	            diamondsEnabledValue = false;
	          }
	        }
	
	        this.setState({
	
	          diamondsEnabled: diamondsEnabledValue,
	          settingsEnabled: settingsEnabledValue,
	
	          diamondPriceOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	          settingPriceOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	
	          diamondPriceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
	          diamondPriceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,
	
	          budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	          priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
	          priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,
	
	          shapesOpen: diamondsEnabledValue === true && (getKeys.includes('shape') || diamondsEnabledValue === true),
	          shapeValues: getKeys.includes('shape') ? getData['shape'].toLowerCase().split(',') : [],
	
	          caratOpen: diamondsEnabledValue === true && (getKeys.includes('caratMin') || getKeys.includes('caratMax') || diamondsEnabledValue === true && settingsEnabledValue === false),
	          caratMin: getKeys.includes('caratMin') ? parseFloat(getData['caratMin']) : 0.50,
	          caratMax: getKeys.includes('caratMax') ? parseFloat(getData['caratMax']) : 5.0,
	
	          colorOpen: diamondsEnabledValue === true && (getKeys.includes('color') || diamondsEnabledValue === true && settingsEnabledValue === false),
	          colorValues: getKeys.includes('color') ? getData['color'].toLowerCase().split(',') : [],
	
	          clarityOpen: diamondsEnabledValue === true && (getKeys.includes('clarityMin') || getKeys.includes('clarityMax') || diamondsEnabledValue === true && settingsEnabledValue === false),
	          clarityMin: getKeys.includes('clarityMin') ? getData['clarityMin'] : 'SI2',
	          clarityMax: getKeys.includes('clarityMax') ? getData['clarityMax'] : 'IF',
	          clarityValues: ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF'],
	
	          // certificationOpen: false,
	
	          cutOpen: getKeys.includes('cutMin') || getKeys.includes('cutMax'),
	          cutMin: getKeys.includes('cutMin') ? getData['cutMin'] : 'Good',
	          cutMax: getKeys.includes('cutMax') ? getData['cutMax'] : 'Excellent',
	          cutValues: ['Good', 'Very Good', 'Excellent'],
	          cutTranslate: {
	            'Good': 'GD',
	            'Very Good': 'VG',
	            'Excellent': 'EX'
	          },
	
	          // diamondAdvancedOpen: getKeys.includes('cutMin') || getKeys.includes('cutMax') || getKeys.includes('polMin') || getKeys.includes('polMax') || getKeys.includes('symMin') || getKeys.includes('symMax') || getKeys.includes('fluorMin') || getKeys.includes('fluorMax') || getKeys.includes('depthMin') || getKeys.includes('depthMax') || getKeys.includes('tableMin') || getKeys.includes('tableMax'),
	          diamondAdvancedOpen: false,
	
	          polishValues: ['Fair', 'Good', 'Very Good', 'Excellent'],
	          polishMin: getKeys.includes('polMin') ? getData['polMin'] : 'Fair',
	          polishMax: getKeys.includes('polMax') ? getData['polMax'] : 'Excellent',
	          polishTranslate: {
	            'Good': 'GD',
	            'Very Good': 'VG',
	            'Excellent': 'EX'
	          },
	
	          symmetryValues: ['Fair', 'Good', 'Very Good', 'Excellent'],
	          symmetryMin: getKeys.includes('symMin') ? getData['symMin'] : 'Fair',
	          symmetryMax: getKeys.includes('symMax') ? getData['symMax'] : 'Excellent',
	          symmetryTranslate: {
	            'Good': 'GD',
	            'Very Good': 'VG',
	            'Excellent': 'EX'
	          },
	
	          // fluorescenceValues: ['Very Strong', 'Strong', 'Medium', 'Faint', 'None'],
	          fluorescenceValues: ['None', 'Faint', 'Medium', 'Strong', 'Very Strong'],
	          fluorescenceMin: getKeys.includes('fluorMin') ? getData['fluorMin'] : 'None',
	          fluorescenceMax: getKeys.includes('fluorMax') ? getData['fluorMax'] : 'Very Strong',
	
	          typeOpen: getKeys.includes('settingtype') || settingsEnabledValue === true,
	          typeValues: getKeys.includes('settingtype') ? getData['settingtype'].toLowerCase().split(',') : [],
	
	          stylesOpen: getKeys.includes('style') || diamondsEnabledValue === false && settingsEnabledValue === true,
	          styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : [],
	
	          designersOpen: getKeys.includes('designers'),
	          designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,
	
	          metalTypesOpen: getKeys.includes('metal'),
	          metalTypesValues: getKeys.includes('metal') ? getData['metal'].toUpperCase().split(',') : null,
	
	          settingAdvancedOpen: getKeys.includes('mmWidthMin') || getKeys.includes('mmWidthMax') || getKeys.includes('continuity'),
	          mmWidthMin: getKeys.includes('mmWidthMin') ? getData['mmWidthMin'] : 1.5,
	          mmWidthMax: getKeys.includes('mmWidthMax') ? getData['mmWidthMax'] : 4,
	
	          diamondQueryFilters: {},
	          settingQueryFilters: {},
	
	          lastDiamondReset: Date.now(),
	          lastSettingReset: Date.now()
	        });
	      }
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'monitorWidth',
	    value: function monitorWidth() {}
	  }, {
	    key: 'getContinuityData',
	    value: function getContinuityData() {
	      return [{
	        name: 'Half',
	        value: 'half'
	      }, {
	        name: 'Three-Quarters',
	        value: 'threequarters'
	      }, {
	        name: 'Eternity',
	        value: 'full'
	      }];
	    }
	  }, {
	    key: 'getDesignerData',
	    value: function getDesignerData() {
	      return [{
	        name: 'Diamonds Direct Designs',
	        value: 'dddesigns'
	      }, {
	        name: 'A Jaffe',
	        value: 'ajaffe'
	      },
	      // {
	      //   name: 'Amden',
	      //   value: 'amden',
	      // },
	      {
	        name: 'Artcarved',
	        value: 'artcarved'
	      },
	      // {
	      //   name: 'Benchmark',
	      //   value: 'benchmark',
	      // },
	      {
	        name: 'C. Gonshor',
	        value: 'cgonshor'
	      },
	      // {
	      //   name: 'Christian Bauer',
	      //   value: 'christianbauer',
	      // },
	      // {
	      //   name: 'Christopher Designs',
	      //   value: 'christopherdesigns',
	      // },
	      {
	        name: 'Classique Creations',
	        value: 'classique'
	      }, {
	        name: 'Coast',
	        value: 'coast'
	      },
	      // {
	      //   name: 'Diama',
	      //   value: 'diana',
	      // },
	      // {
	      //   name: 'FJ Kashi',
	      //   value: 'fjkashi',
	      // },
	      {
	        name: 'Fana',
	        value: 'fana'
	      },
	      // {
	      //   name: 'Furrer Jacot',
	      //   value: 'furrerjacot',
	      // },
	      // {
	      //   name: 'Gabriel & Co.',
	      //   value: 'gabrielco',
	      // },
	      // {
	      //   name: 'Goldman',
	      //   value: 'goldman',
	      // },
	      // {
	      //   name: 'Gottlieb & Sons',
	      //   value: 'gattlieb',
	      // },
	      // {
	      //   name: 'H. Levi & Co.',
	      //   value: 'hlevi',
	      // },
	      // {
	      //   name: 'Henri Daussi',
	      //   value: 'henridaussi',
	      // },
	      // {
	      //   name: 'Jack Kelege',
	      //   value: 'jackkelege',
	      // },
	      // {
	      //   name: 'Jeff Cooper',
	      //   value: 'jeffcooper',
	      // },
	      {
	        name: 'Kirk Kara',
	        value: 'kirkkara'
	      },
	      // {
	      //   name: 'Mastoloni',
	      //   value: 'mastoloni',
	      // },
	      // {
	      //   name: 'Novell',
	      //   value: 'novel',
	      // },
	      // {
	      //   name: 'Odelia',
	      //   value: 'odelia',
	      // },
	      // {
	      //   name: 'PeJay Creations',
	      //   value: 'pejay',
	      // },
	      // {
	      //   name: 'Rebeka',
	      //   value: 'rebeka',
	      // },
	      {
	        name: 'Michael M.',
	        value: 'michaelm'
	      }, {
	        name: 'SES',
	        value: 'ses'
	      }, {
	        name: 'Simon G.',
	        value: 'simong'
	      }, {
	        name: 'Sylvie',
	        value: 'sylvie'
	      }, {
	        name: 'Tacori',
	        value: 'tacori'
	      },
	      // {
	      //   name: 'True Romance',
	      //   value: 'trueromanace',
	      // },
	      {
	        name: 'Uneek',
	        value: 'uneek'
	      }, {
	        name: 'Verragio',
	        value: 'verragio'
	      }];
	    }
	  }, {
	    key: 'getMetalTypeData',
	    value: function getMetalTypeData() {
	      return [{
	        name: 'White Gold',
	        value: 'WG'
	      }, {
	        name: 'Yellow Gold',
	        value: 'YG'
	      }, {
	        name: 'Rose Gold',
	        value: 'RG'
	      }, {
	        name: 'Platinum',
	        value: 'PLAT'
	      }];
	    }
	  }, {
	    key: 'checkToEnableDiamonds',
	    value: function checkToEnableDiamonds() {
	      if (!this.state.diamondsEnabled) {
	        this.toggleDiamondSection();
	      }
	    }
	  }, {
	    key: 'checkToEnableSettings',
	    value: function checkToEnableSettings() {
	      if (!this.state.settingsEnabled) {
	        this.toggleSettingSection();
	      }
	    }
	  }, {
	    key: 'toggleFilterElement',
	    value: function toggleFilterElement(element) {
	
	      if (!element) {
	        return;
	      }
	
	      if (element == 'budget') {
	        this.setState({ budgetOpen: !this.state.budgetOpen });
	      } else if (element == 'shape' && this.state.diamondsEnabled) {
	        this.setState({ shapesOpen: !this.state.shapesOpen });
	      } else if (element == 'carat' && this.state.diamondsEnabled) {
	        this.setState({ caratOpen: !this.state.caratOpen });
	      } else if (element == 'color' && this.state.diamondsEnabled) {
	        this.setState({ colorOpen: !this.state.colorOpen });
	      } else if (element == 'clarity' && this.state.diamondsEnabled) {
	        this.setState({ clarityOpen: !this.state.clarityOpen });
	      } else if (element == 'cut' && this.state.diamondsEnabled) {
	        this.setState({ cutOpen: !this.state.cutOpen });
	      } else if (element == 'type' && this.state.settingsEnabled) {
	        this.setState({ typeOpen: !this.state.typeOpen });
	      } else if (element == 'style' && this.state.settingsEnabled) {
	        this.setState({ stylesOpen: !this.state.stylesOpen });
	      } else if (element == 'designer' && this.state.settingsEnabled) {
	        this.setState({ designersOpen: !this.state.designersOpen });
	      } else if (element == 'metal' && this.state.settingsEnabled) {
	        this.setState({ metalTypesOpen: !this.state.metalTypesOpen });
	      } else if (element == 'diamondAdvanced' && this.state.diamondsEnabled) {
	        this.setState({ diamondAdvancedOpen: !this.state.diamondAdvancedOpen });
	      } else if (element == 'settingAdvanced' && this.state.settingsEnabled) {
	        this.setState({ settingAdvancedOpen: !this.state.settingAdvancedOpen });
	      } else if (element == 'diamondPrice' && this.state.diamondsEnabled) {
	        this.setState({ diamondPriceOpen: !this.state.diamondPriceOpen });
	      } else if (element == 'settingPrice' && this.state.settingsEnabled) {
	        this.setState({ settingPriceOpen: !this.state.settingPriceOpen });
	      }
	    }
	  }, {
	    key: 'getElementClass',
	    value: function getElementClass(element) {
	
	      if (!element) {
	        return;
	      }
	
	      if (element == 'budget') {
	        return this.state.budgetOpen ? 'filterItem open' : 'filterItem';
	      } else if (element == 'shape') {
	        return this.state.shapesOpen ? 'filterItem open' : 'filterItem';
	      } else if (element == 'carat') {
	        return this.state.caratOpen ? 'filterItem open' : 'filterItem';
	      } else if (element == 'color') {
	        return this.state.colorOpen ? 'filterItem open' : 'filterItem';
	      } else if (element == 'clarity') {
	        return this.state.clarityOpen ? 'filterItem open' : 'filterItem';
	      } else if (element == 'cut') {
	        return this.state.cutOpen ? 'filterItem open' : 'filterItem';
	      } else if (element == 'type') {
	        return this.state.typeOpen ? 'filterItem open' : 'filterItem';
	      } else if (element == 'style') {
	        return this.state.stylesOpen ? 'filterItem open' : 'filterItem';
	      } else if (element == 'designer') {
	        return this.state.designersOpen ? 'filterItem longOpen' : 'filterItem';
	      } else if (element == 'metal') {
	        return this.state.metalTypesOpen ? 'filterItem midOpen' : 'filterItem';
	      } else if (element == 'diamondAdvanced') {
	        return this.state.diamondAdvancedOpen ? 'filterItem longOpen' : 'filterItem';
	      } else if (element == 'settingAdvanced') {
	        return this.state.settingAdvancedOpen ? 'filterItem longOpen' : 'filterItem';
	      } else if (element == 'diamondPrice') {
	        return this.state.diamondPriceOpen ? 'filterItem open' : 'filterItem';
	      } else if (element == 'settingPrice') {
	        return this.state.settingPriceOpen ? 'filterItem open' : 'filterItem';
	      }
	    }
	  }, {
	    key: 'toggleDiamondSection',
	    value: function toggleDiamondSection() {
	      var _this2 = this;
	
	      this.setState({ diamondsEnabled: !this.state.diamondsEnabled }, function () {
	        if (_this2.state.diamondsEnabled === false) {
	          _this2.setState({
	            shapesOpen: false,
	            caratOpen: false,
	            colorOpen: false,
	            clarityOpen: false,
	            cutOpen: false
	          });
	          if (_this2.state.settingsEnabled === false) {
	            _this2.setState({ settingsEnabled: true }, function () {
	              _this2.filtersUpdated();
	            });
	          } else {
	            _this2.filtersUpdated();
	          }
	        } else {
	          _this2.filtersUpdated();
	        }
	        _this2.setEngagementMode();
	      });
	    }
	  }, {
	    key: 'toggleSettingSection',
	    value: function toggleSettingSection() {
	      var _this3 = this;
	
	      this.setState({ settingsEnabled: !this.state.settingsEnabled }, function () {
	        if (_this3.state.settingsEnabled === false) {
	          _this3.setState({
	            typeOpen: false,
	            stylesOpen: false,
	            designersOpen: false,
	            metalTypesOpen: false
	          });
	          if (_this3.state.diamondsEnabled === false) {
	            _this3.setState({ diamondsEnabled: true }, function () {
	              _this3.filtersUpdated();
	            });
	          } else {
	            _this3.filtersUpdated();
	          }
	        } else {
	          _this3.filtersUpdated();
	        }
	        _this3.setEngagementMode();
	      });
	    }
	  }, {
	    key: 'setEngagementMode',
	    value: function setEngagementMode() {
	
	      if (this.state.diamondsEnabled && this.state.settingsEnabled) {
	        this.props.setMode('mixed');
	      } else if (this.state.diamondsEnabled && !this.state.settingsEnabled) {
	        this.props.setMode('diamond');
	      } else if (!this.state.diamondsEnabled && this.state.settingsEnabled) {
	        this.props.setMode('setting');
	      } else {
	        this.props.setMode('mixed');
	      }
	    }
	  }, {
	    key: 'createQuerystring',
	    value: function createQuerystring() {
	      var pairsArray = [];
	
	      for (var key in this.props.product.diamondFilters) {
	        pairsArray.push(key + '=' + this.props.product.diamondFilters[key]);
	      }
	      return pairsArray.join('&');
	    }
	  }, {
	    key: 'createSettingQuerystring',
	    value: function createSettingQuerystring() {
	
	      var pairsArray = [];
	
	      for (var key in this.props.product.productFilters) {
	        pairsArray.push(key + '=' + this.props.product.productFilters[key]);
	      }
	      return pairsArray.join('&');
	    }
	  }, {
	    key: 'filtersUpdated',
	    value: function filtersUpdated() {
	      var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var _this4 = this;
	
	      var filterKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var filterValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	
	      if (filterType == 'diamonds' || filterType == 'all') {
	
	        var newFilters = {};
	
	        for (var i = 0; i < filterKeys.length; i++) {
	          if (filterKeys[i] == 'caratMax' && filterValues[i] >= 5.0) {
	            newFilters[filterKeys[i]] = parseFloat(filterValues[i]) * 4;
	          } else {
	            newFilters[filterKeys[i]] = filterValues[i];
	          }
	        }
	
	        this.props.productSaveDiamondQueryFilters(newFilters);
	        setTimeout(function () {
	          _this4.props.updateDiamondsMethod(_this4.createQuerystring());
	        }, 150);
	      }
	
	      if (filterType == 'settings' || filterType == 'all') {
	
	        var _newFilters = {};
	
	        for (var _i = 0; _i < filterKeys.length; _i++) {
	          _newFilters[filterKeys[_i]] = filterValues[_i];
	        }
	
	        _newFilters['type'] = 'engagement';
	
	        this.props.productSaveProductQueryFilters(_newFilters, 'setting');
	        setTimeout(function () {
	          _this4.props.updateMethod(_this4.createSettingQuerystring());
	        }, 150);
	      }
	
	      if (filterType == 'settings') {
	        this.props.updateDiamondsMethod(this.createQuerystring());
	      } else if (filterType == 'diamonds') {
	
	        this.props.productSaveProductQueryFilters({ 'type': 'engagement' }, 'setting');
	        setTimeout(function () {
	          _this4.props.updateMethod(_this4.createSettingQuerystring());
	        }, 150);
	        // this.props.updateMethod(this.createSettingQuerystring());
	      }
	
	      if (filterType == 'settings') {
	        this.props.setMixedResultsTab('setting');
	      }
	
	      if (filterType == 'diamonds') {
	        this.props.setMixedResultsTab('diamond');
	      }
	    }
	  }, {
	    key: 'searchAction',
	    value: function searchAction() {
	      this.filtersUpdated('all', [], []);
	      this.props.closeMethod(false);
	    }
	  }, {
	    key: 'resetDiamondFilters',
	    value: function resetDiamondFilters() {
	      var _this5 = this;
	
	      this.setState({
	        priceMin: 100,
	        priceMax: 500000,
	
	        shapeValues: [],
	
	        caratMin: 0.50,
	        caratMax: 5.0,
	
	        colorValues: [],
	
	        clarityMin: 'SI2',
	        clarityMax: 'IF',
	
	        cutMin: 'Very Good',
	        cutMax: 'Excellent',
	
	        polishMin: 'Fair',
	        polishMax: 'Excellent',
	
	        symmetryMin: 'Fair',
	        symmetryMax: 'Excellent',
	
	        fluorescenceMin: 'None',
	        fluorescenceMax: 'Very Strong'
	      });
	
	      this.setState({ lastDiamondReset: Date.now() });
	
	      this.props.productResetDiamondQueryFilters();
	      setTimeout(function () {
	        _this5.props.updateDiamondsMethod(_this5.createQuerystring());
	      }, 150);
	    }
	  }, {
	    key: 'resetSettingFilters',
	    value: function resetSettingFilters() {
	      var _this6 = this;
	
	      this.setState({
	        typeValues: [],
	
	        styleValues: [],
	
	        designersValues: null,
	
	        metalTypesValues: null,
	
	        mmWidthMin: 1.5,
	        mmWidthMax: 4
	      });
	
	      this.setState({ lastSettingReset: Date.now() });
	
	      this.props.productResetProductQueryFilters('setting');
	      setTimeout(function () {
	        _this6.props.updateMethod(_this6.createSettingQuerystring());
	      }, 150);
	    }
	  }, {
	    key: 'getCutOptions',
	    value: function getCutOptions() {
	      return [{
	        name: 'Excellent',
	        value: 'EX'
	      }, {
	        name: 'Very Good',
	        value: 'VG'
	      }];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'EngagementFilters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'rbFilterWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rbInternalWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.diamondsEnabled ? 'diamondSection' : 'diamondSection disabled', onClick: this.checkToEnableDiamonds.bind(this) },
	              _react2.default.createElement(
	                'div',
	                { className: 'headerItem filterItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue', onClick: this.toggleDiamondSection.bind(this) },
	                      'Diamond Filters'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', onClick: function onClick() {
	                          return _this7.resetDiamondFilters();
	                        } },
	                      'Reset'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIconRadio', onClick: this.toggleDiamondSection.bind(this) },
	                    this.state.diamondsEnabled ? _react2.default.createElement('div', { className: 'filterIconRadioInner' }) : null
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'filterBody' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('shape') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('shape');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Shape'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', style: { display: 'none' } },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_ShapeIcons2.default, {
	                      refreshData: this.filtersUpdated.bind(this),
	                      initData: this.state.shapeValues,
	                      resetElement: this.state.lastDiamondReset })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('carat') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('carat');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Carat'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'infoVal' },
	                        'Diamond carat weight is the measurement of how much a diamond weighs. A metric \u2018carat\u2019 is defined as 200 milligrams. Each carat can be subdivided into 100 \u2018points\u2019. This allows precise measurements to the hundredth decimal place.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_NumericSlider2.default, {
	                      minValue: 0.50,
	                      maxValue: 5.00,
	                      hasPlus: true,
	                      initMinValue: this.state.caratMin,
	                      initMaxValue: this.state.caratMax,
	                      minKey: 'caratMin',
	                      maxKey: 'caratMax',
	                      service: 'diamonds',
	                      format: 'decimal',
	                      scale: 'log',
	                      increment: 0.01,
	                      refreshData: this.filtersUpdated.bind(this),
	                      resetElement: this.state.lastDiamondReset })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('color') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('color');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Color'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'infoVal' },
	                        'The diamond color evaluation of most gem-quality diamonds is based on the absence of color. The scale begins with the letter D, representing colorless, and continues, with increasing presence of color to the letter Z.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_ColorRadios2.default, {
	                      refreshData: this.filtersUpdated.bind(this),
	                      initData: this.state.colorValues,
	                      resetElement: this.state.lastDiamondReset })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('clarity') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('clarity');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Clarity'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset' },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'infoVal' },
	                        'The process of creating a diamond in nature can result in a variety of internal characteristics called \u2018inclusions\u2019 and external characteristics called \'blemishes\'. The diamond clarity scale begins with internally flawless and goes all the way to included.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_ValuesSlider2.default, {
	                      valuesData: this.state.clarityValues,
	                      refreshData: this.filtersUpdated.bind(this),
	                      minKey: 'clarityMax',
	                      maxKey: 'clarityMin',
	                      initMin: this.state.clarityMax,
	                      initMax: this.state.clarityMin,
	                      service: 'diamonds',
	                      inputWidth: '60px',
	                      resetElement: this.state.lastDiamondReset })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('diamondPrice') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('diamondPrice');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Diamond Price Range'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', style: { display: 'none' } },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'infoVal' },
	                        'The process of creating a diamond in nature can result in a variety of internal characteristics called \u2018inclusions\u2019 and external characteristics called \'blemishes\'. The diamond clarity scale begins with internally flawless and goes all the way to included.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_NumericSlider2.default, {
	                      minValue: 100,
	                      maxValue: 500000,
	                      initMinValue: this.state.diamondPriceMin,
	                      initMaxValue: this.state.diamondPriceMax,
	                      minKey: 'priceMin',
	                      maxKey: 'priceMax',
	                      service: 'diamonds',
	                      format: 'currency',
	                      scale: 'log',
	                      increment: 100,
	                      refreshData: this.filtersUpdated.bind(this),
	                      resetElement: this.state.lastDiamondReset })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('diamondAdvanced') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('diamondAdvanced');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Advanced'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', style: { display: 'none' } },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: this.props.product.diamondFilters.shape && this.props.product.diamondFilters.shape.indexOf('Round') >= 0 ? 'advancedItemWrapper' : 'advancedItemWrapper disabled' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedTitle' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advTitleLabel', style: { marginBottom: '10px' } },
	                          'Cut'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advancedInfo' },
	                          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'infoVal' },
	                            'Diamonds are renowned for their ability to transmit light and sparkle so intensely. We often think of a diamond\u2019s cut as shape (round, emerald, pear), but a diamond\u2019s cut grade is really about how well a diamond\u2019s facets interact with light.'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedControl' },
	                        _react2.default.createElement(_CheckboxList2.default, {
	                          label: 'Cuts',
	                          productType: 'diamonds',
	                          dataKey: 'cut',
	                          refreshData: this.filtersUpdated.bind(this),
	                          checkboxData: this.getCutOptions(),
	                          initData: this.state.cutValues,
	                          disabled: this.props.product.diamondFilters.shape && this.props.product.diamondFilters.shape.includes('Round') ? false : true,
	                          disableAll: true,
	                          resetElement: this.state.lastDiamondReset })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'cutNote' },
	                        'Cut grade applies to round diamonds only'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'advancedItemWrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedTitle' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advTitleLabel' },
	                          'Polish'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advancedInfo' },
	                          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'infoVal' },
	                            'Grading for polish quality refers to the overall craftsmanship of the finished diamond. Are the edges sharp? Are the facets smooth and flat? Polishing wheel marks should not be visible without magnification.'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedControl' },
	                        _react2.default.createElement(_ValuesSlider2.default, {
	                          valuesData: this.state.polishValues,
	                          refreshData: this.filtersUpdated.bind(this),
	                          inputWidth: '120px',
	                          minKey: 'polMax',
	                          maxKey: 'polMin',
	                          initMin: this.state.polishMax,
	                          initMax: this.state.polishMin,
	                          service: 'diamonds',
	                          translations: this.state.polishTranslate,
	                          resetElement: this.state.lastDiamondReset })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'advancedItemWrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedTitle' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advTitleLabel' },
	                          'Symmetry'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advancedInfo' },
	                          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'infoVal' },
	                            'Symmetrical diamonds reflect more light, adding to the overall sparkle. Gemologists review more than 20 different symmetry features in order to grade how perfectly the facets and cut angles align.'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedControl' },
	                        _react2.default.createElement(_ValuesSlider2.default, {
	                          valuesData: this.state.symmetryValues,
	                          refreshData: this.filtersUpdated.bind(this),
	                          inputWidth: '120px',
	                          minKey: 'symMax',
	                          maxKey: 'symMin',
	                          initMin: this.state.symmetryMax,
	                          initMax: this.state.symmetryMin,
	                          service: 'diamonds',
	                          translations: this.state.symmetryTranslate,
	                          resetElement: this.state.lastDiamondReset })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'advancedItemWrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedTitle' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advTitleLabel' },
	                          'Fluorescence'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advancedInfo' },
	                          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'infoVal' },
	                            'Fluorescence measures the color of the light emitted by a diamond under an ultraviolet light. While diamond professionals often prefer a fluorescence grade of "none",  "faint" or "medium" grades will offer a better value in lower diamond colors.'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedControl' },
	                        _react2.default.createElement(_ValuesSlider2.default, {
	                          valuesData: this.state.fluorescenceValues,
	                          refreshData: this.filtersUpdated.bind(this),
	                          inputWidth: '120px',
	                          minKey: 'fluorMin',
	                          maxKey: 'fluorMax',
	                          initMin: this.state.fluorescenceMin,
	                          initMax: this.state.fluorescenceMax,
	                          service: 'diamonds',
	                          resetElement: this.state.lastDiamondReset })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'advancedItemWrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedTitle' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advTitleLabel' },
	                          'Depth %'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advancedInfo' },
	                          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'infoVal' },
	                            'Depth percentage expresses a width to depth ratio for the diamond, and is a key determinant in grading a stone cut.'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedControl' },
	                        _react2.default.createElement(_NumericSlider2.default, {
	                          minValue: 45,
	                          maxValue: 86,
	                          initMinValue: 45,
	                          initMaxValue: 86,
	                          minKey: 'depthMin',
	                          maxKey: 'depthMax',
	                          service: 'diamonds',
	                          format: 'integer',
	                          scale: 'linear',
	                          increment: 1,
	                          refreshData: this.filtersUpdated.bind(this),
	                          resetElement: this.state.lastDiamondReset })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'advancedItemWrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedTitle' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advTitleLabel' },
	                          'Table %'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'advancedInfo' },
	                          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'upInfo infoVal' },
	                            'The width of the table (top facet) in relation to the overall diameter of the diamond establishes the diamond table percentage. Too large, and the diamond can appear flat and translucent.'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedControl' },
	                        _react2.default.createElement(_NumericSlider2.default, {
	                          minValue: 49,
	                          maxValue: 89,
	                          initMinValue: 49,
	                          initMaxValue: 89,
	                          minKey: 'tableMin',
	                          maxKey: 'tableMax',
	                          service: 'diamonds',
	                          format: 'integer',
	                          scale: 'linear',
	                          increment: 0.01,
	                          refreshData: this.filtersUpdated.bind(this),
	                          resetElement: this.state.lastDiamondReset })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'advancedItemWrapper', style: { display: 'none' } },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedTitle' },
	                        'Diamond Price Range'
	                      ),
	                      _react2.default.createElement('div', { className: 'advancedControl' })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.settingsEnabled ? 'settingSection' : 'settingSection disabled', onClick: this.checkToEnableSettings.bind(this) },
	              _react2.default.createElement(
	                'div',
	                { className: 'headerItem filterItem' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue', onClick: this.toggleSettingSection.bind(this) },
	                      'Setting Filters'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', onClick: function onClick() {
	                          return _this7.resetSettingFilters();
	                        } },
	                      'Reset'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIconRadio', onClick: this.toggleSettingSection.bind(this) },
	                    this.state.settingsEnabled ? _react2.default.createElement('div', { className: 'filterIconRadioInner' }) : null
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'filterBody' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('type') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('type');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Type'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', style: { display: 'none' } },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_SettingTypeIcons2.default, {
	                      refreshData: this.filtersUpdated.bind(this),
	                      initData: this.state.typeValues,
	                      resetElement: this.state.lastSettingReset })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('style') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('style');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Style'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', style: { display: 'none' } },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_StyleIcons2.default, {
	                      searchType: 'settings',
	                      refreshData: this.filtersUpdated.bind(this),
	                      initData: this.state.styleValues,
	                      resetElement: this.state.lastSettingReset })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('designer') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('designer');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Designer'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', style: { display: 'none' } },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_CheckboxList2.default, {
	                      label: 'Designers',
	                      productType: 'settings',
	                      dataKey: 'designers',
	                      refreshData: this.filtersUpdated.bind(this),
	                      checkboxData: this.getDesignerData(),
	                      initData: this.state.designersValues,
	                      resetElement: this.state.lastSettingReset })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('metal') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('metal');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Metal'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', style: { display: 'none' } },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_CheckboxList2.default, {
	                      label: 'Metals',
	                      productType: 'settings',
	                      dataKey: 'metal',
	                      refreshData: this.filtersUpdated.bind(this),
	                      checkboxData: this.getMetalTypeData(),
	                      initData: this.state.metalTypesValues,
	                      resetElement: this.state.lastSettingReset })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('settingPrice') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('settingPrice');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Setting Price Range'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', style: { display: 'none' } },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'infoVal' },
	                        'The process of creating a diamond in nature can result in a variety of internal characteristics called \u2018inclusions\u2019 and external characteristics called \'blemishes\'. The diamond clarity scale begins with internally flawless and goes all the way to included.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_NumericSlider2.default, {
	                      minValue: 100,
	                      maxValue: 500000,
	                      initMinValue: 100,
	                      initMaxValue: this.state.priceMax,
	                      minKey: 'priceMin',
	                      maxKey: 'priceMax',
	                      service: 'settings',
	                      format: 'currency',
	                      scale: 'log',
	                      increment: 100,
	                      refreshData: this.filtersUpdated.bind(this),
	                      resetElement: this.state.lastSettingReset })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getElementClass('settingAdvanced'), style: { display: 'none' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead', onClick: function onClick() {
	                      return _this7.toggleFilterElement('settingAdvanced');
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue' },
	                      'Advanced'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', style: { display: 'none' } },
	                      _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon' },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon' },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'advancedItemWrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedTitle' },
	                        'MM Width'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedControl' },
	                        _react2.default.createElement(_NumericSlider2.default, {
	                          minValue: 1.5,
	                          maxValue: 4,
	                          initMinValue: this.state.mmWidthMin,
	                          initMaxValue: this.state.mmWidthMax,
	                          minKey: 'mmWidthMin',
	                          maxKey: 'mmWidthMax',
	                          service: 'settings',
	                          format: 'integer',
	                          scale: 'linear',
	                          increment: 0.1,
	                          refreshData: this.filtersUpdated.bind(this),
	                          resetElement: this.state.lastSettingReset })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'advancedItemWrapper', style: { display: 'none' } },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedTitle' },
	                        'Diamond Continuity'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'advancedControl' },
	                        _react2.default.createElement(_CheckboxList2.default, {
	                          label: 'Diamond Continuity',
	                          productType: 'settings',
	                          dataKey: 'continuity',
	                          refreshData: this.filtersUpdated.bind(this),
	                          checkboxData: this.getContinuityData(),
	                          resetElement: this.state.lastSettingReset })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'budgetSection', style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'budgetItem ' + this.getElementClass('budget') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue', onClick: function onClick() {
	                          return _this7.toggleFilterElement('budget');
	                        } },
	                      'Total Price Range'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterReset', onClick: function onClick() {
	                          return _this7.resetBudgetFilters();
	                        } },
	                      'Reset'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon', onClick: function onClick() {
	                        return _this7.toggleFilterElement('budget');
	                      } },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon', onClick: function onClick() {
	                        return _this7.toggleFilterElement('budget');
	                      } },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_NumericSlider2.default, {
	                      minValue: 100,
	                      maxValue: 500000,
	                      initMinValue: this.state.priceMin,
	                      initMaxValue: this.state.priceMax,
	                      format: 'currency',
	                      scale: 'log',
	                      increment: 10,
	                      refreshData: this.filtersUpdated.bind(this),
	                      resetElement: function resetElement(click) {
	                        return _this7.resetBudgetFilters = click;
	                      } })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'submitSection' },
	              _react2.default.createElement(
	                'button',
	                { className: 'filterSubmitButton dd2ActionButton', onClick: this.searchAction.bind(this) },
	                'Search'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'filterSeparation' })
	      );
	    }
	  }]);
	
	  return EngagementFilters;
	}(_react2.default.Component);
	
	EngagementFilters.propTypes = {
	  location: _react.PropTypes.object
	};
	EngagementFilters.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = EngagementFilters;
	
	
	function mapStateToProps(state) {
	  return {
	    common: state.common,
	    product: state.product
	  };
	}
	
	var EngagementFiltersContainer = exports.EngagementFiltersContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(EngagementFilters);

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FashionFiltersContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _url = __webpack_require__(56);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	var _CheckboxList = __webpack_require__(149);
	
	var _CheckboxList2 = _interopRequireDefault(_CheckboxList);
	
	var _NumericSlider = __webpack_require__(150);
	
	var _NumericSlider2 = _interopRequireDefault(_NumericSlider);
	
	var _GemstoneIcons = __webpack_require__(214);
	
	var _GemstoneIcons2 = _interopRequireDefault(_GemstoneIcons);
	
	var _StackableIcons = __webpack_require__(215);
	
	var _StackableIcons2 = _interopRequireDefault(_StackableIcons);
	
	var _WomensDiamondIcons = __webpack_require__(216);
	
	var _WomensDiamondIcons2 = _interopRequireDefault(_WomensDiamondIcons);
	
	var _StyleIcons = __webpack_require__(151);
	
	var _StyleIcons2 = _interopRequireDefault(_StyleIcons);
	
	var _ValuesSlider = __webpack_require__(152);
	
	var _ValuesSlider2 = _interopRequireDefault(_ValuesSlider);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var FashionFilters = function (_React$Component) {
	  _inherits(FashionFilters, _React$Component);
	
	  function FashionFilters(props) {
	    _classCallCheck(this, FashionFilters);
	
	    var _this = _possibleConstructorReturn(this, (FashionFilters.__proto__ || Object.getPrototypeOf(FashionFilters)).call(this, props));
	
	    var getData = (0, _url.getJsonFromUrl)();
	    var getKeys = Object.keys(getData);
	    var hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
	
	    _this.state = {
	
	      budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	      priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
	      priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,
	
	      jewelryTypeOpen: getKeys.includes('type'),
	      jewelryTypeValues: getKeys.includes('type') ? getData['type'].toLowerCase().split(',') : null,
	
	      metalsOpen: getKeys.includes('metals'),
	      metalsValues: getKeys.includes('metals') ? getData['metals'].toUpperCase().split(',') : null,
	
	      gemstoneOpen: getKeys.includes('gemstone'),
	      gemstoneValues: getKeys.includes('gemstone') ? getData['gemstone'].toLowerCase().split(',') : null,
	
	      designersOpen: getKeys.includes('designers'),
	      designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,
	
	      styleOpen: getKeys.includes('style'),
	      styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : [],
	
	      lastReset: Date.now()
	    };
	
	    if (hasQuerystring) {
	
	      var pageNum = getData.currentPage ? parseInt(getData.currentPage) : 1;
	
	      _this.props.productSaveProductQueryFilters(getData, 'fashion', pageNum);
	      setTimeout(function () {
	        _this.props.updateMethod((0, _formatting.formatQuerystring)(_this.props.product.productFilters));
	      }, 150);
	    } else {
	      _this.props.productSaveProductQueryFilters(getData, 'fashion', 1);
	      setTimeout(function () {
	        _this.props.updateMethod((0, _formatting.formatQuerystring)(_this.props.product.productFilters));
	      }, 150);
	    }
	    return _this;
	  }
	
	  _createClass(FashionFilters, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      if (prevProps.common.registerNavChange && this.props.common.registerNavChange && prevProps.common.registerNavChange != this.props.common.registerNavChange) {
	
	        // TODO: refactor into method called on load and change
	        var getData = (0, _url.getJsonFromUrl)();
	        var getKeys = Object.keys(getData);
	        var hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
	
	        this.setState({
	
	          budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	          priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
	          priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,
	
	          jewelryTypeOpen: getKeys.includes('type'),
	          jewelryTypeValues: getKeys.includes('type') ? getData['type'].toLowerCase().split(',') : null,
	
	          metalsOpen: getKeys.includes('metals'),
	          metalsValues: getKeys.includes('metals') ? getData['metals'].toUpperCase().split(',') : null,
	
	          gemstoneOpen: getKeys.includes('gemstone'),
	          gemstoneValues: getKeys.includes('gemstone') ? getData['gemstone'].toLowerCase().split(',') : null,
	
	          designersOpen: getKeys.includes('designer'),
	          designersValues: getKeys.includes('designer') ? getData['designer'].toLowerCase().split(',') : null,
	
	          styleOpen: getKeys.includes('style'),
	          styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : []
	        });
	
	        if (hasQuerystring) {
	          this.props.productSaveProductQueryFilters(getData, 'fashion', 1);
	          setTimeout(function () {
	            _this2.props.updateMethod((0, _formatting.formatQuerystring)(_this2.props.product.productFilters));
	          }, 150);
	        }
	      }
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getDesignerData',
	    value: function getDesignerData() {
	      return [{
	        name: 'Diamonds Direct Designs',
	        value: 'dddesigns'
	      }, {
	        name: 'Amden',
	        value: 'amden'
	      },
	      // {
	      //   name: 'Christopher Designs',
	      //   value: 'christopherdesigns',
	      // },
	      {
	        name: 'Classique Creations',
	        value: 'classique'
	      },
	      // {
	      //   name: 'FJ Kashi',
	      //   value: 'fjkashi',
	      // },
	      {
	        name: 'Fana',
	        value: 'fana'
	      },
	      // {
	      //   name: 'Gabriel & Co',
	      //   value: 'gabrielco',
	      // },
	      {
	        name: 'KC Designs',
	        value: 'kcdesigns'
	      }, {
	        name: 'Mastoloni',
	        value: 'mastoloni'
	      }, {
	        name: 'Odelia',
	        value: 'odelia'
	      }, {
	        name: 'Pejay Creations',
	        value: 'pejay'
	      }, {
	        name: 'Rebeka Hakimi',
	        value: 'rebeka'
	      }, {
	        name: 'SES',
	        value: 'ses'
	      }, {
	        name: 'Simon G.',
	        value: 'simong'
	      }, {
	        name: 'Tacori',
	        value: 'tacorif'
	      }, {
	        name: 'Uneek',
	        value: 'uneek'
	      }];
	    }
	  }, {
	    key: 'getMetalTypeData',
	    value: function getMetalTypeData() {
	      return [{
	        name: 'White Gold',
	        value: 'WG'
	      }, {
	        name: 'Yellow Gold',
	        value: 'YG'
	      }, {
	        name: 'Rose Gold',
	        value: 'RG'
	      },
	      // {
	      //   name: 'Platinum',
	      //   value: 'PLAT',
	      // },
	      {
	        name: 'Sterling Silver',
	        value: 'SS'
	      }];
	    }
	  }, {
	    key: 'getGemstoneData',
	    value: function getGemstoneData() {
	      return [{
	        name: 'Alexandrite',
	        value: 'alexandrite'
	      }, {
	        name: 'Amethyst',
	        value: 'amethyst'
	      }, {
	        name: 'Aquamarine',
	        value: 'aquamarine'
	      }, {
	        name: 'Chalcedony',
	        value: 'chalcedony'
	      }, {
	        name: 'Citrine',
	        value: 'citrine'
	      }, {
	        name: 'Diamond',
	        value: 'diamond'
	      }, {
	        name: 'Emerald',
	        value: 'emerald'
	      }, {
	        name: 'Garnet',
	        value: 'garnet'
	      }, {
	        name: 'Morganite',
	        value: 'morganite'
	      }, {
	        name: 'Onyx',
	        value: 'onyx'
	      }, {
	        name: 'Opal',
	        value: 'opal'
	      }, {
	        name: 'Pearl',
	        value: 'pearl'
	      }, {
	        name: 'Peridot',
	        value: 'peridot'
	      }, {
	        name: 'Prasiolite',
	        value: 'prasiolite'
	      },
	      // {
	      //   name: 'Quartz',
	      //   value: 'quartz',
	      // },
	      {
	        name: 'Sapphire',
	        value: 'sapphire'
	      }, {
	        name: 'Ruby',
	        value: 'ruby'
	      }, {
	        name: 'Tanzanite',
	        value: 'tanzanite'
	      }, {
	        name: 'Topaz',
	        value: 'topaz'
	      }, {
	        name: 'Tourmaline',
	        value: 'tourmaline'
	      }, {
	        name: 'Turquoise',
	        value: 'turquoise'
	      }];
	    }
	  }, {
	    key: 'getJewelryTypeData',
	    value: function getJewelryTypeData() {
	      return [{
	        name: 'Rings',
	        value: 'ring'
	      }, {
	        name: 'Earrings',
	        value: 'earring'
	      }, {
	        name: 'Pendants',
	        value: 'necklace'
	      }, {
	        name: 'Bracelets',
	        value: 'bracelet'
	      }];
	    }
	  }, {
	    key: 'toggleFilterElement',
	    value: function toggleFilterElement(element) {
	
	      if (!element) {
	        return;
	      }
	
	      switch (element) {
	        case 'budget':
	          this.setState({ budgetOpen: !this.state.budgetOpen });
	          return;
	        case 'type':
	          this.setState({ jewelryTypeOpen: !this.state.jewelryTypeOpen });
	          return;
	        case 'metals':
	          this.setState({ metalsOpen: !this.state.metalsOpen });
	          return;
	        case 'gemstone':
	          this.setState({ gemstoneOpen: !this.state.gemstoneOpen });
	          return;
	        case 'designer':
	          this.setState({ designersOpen: !this.state.designersOpen });
	          return;
	        case 'style':
	          this.setState({ styleOpen: !this.state.styleOpen });
	          return;
	        default:
	          return;
	      }
	    }
	  }, {
	    key: 'getElementClass',
	    value: function getElementClass(element) {
	
	      if (!element) {
	        return 'filterItem';
	      }
	
	      switch (element) {
	        case 'budget':
	          return this.state.budgetOpen ? 'filterItem open' : 'filterItem';
	        case 'type':
	          return this.state.jewelryTypeOpen ? 'filterItem open' : 'filterItem';
	        case 'metals':
	          return this.state.metalsOpen ? 'filterItem open' : 'filterItem';
	        case 'gemstone':
	          return this.state.gemstoneOpen ? 'filterItem longOpen' : 'filterItem';
	        case 'designer':
	          return this.state.designersOpen ? 'filterItem longOpen' : 'filterItem';
	        case 'style':
	          return this.state.styleOpen ? 'filterItem open' : 'filterItem';
	        default:
	          return 'filterItem';
	      }
	    }
	  }, {
	    key: 'filtersUpdated',
	    value: function filtersUpdated() {
	      var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var _this3 = this;
	
	      var filterKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var filterValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	
	      var newFilters = {};
	
	      console.log(this.props.product.productFilters);
	      console.log(this.props.product.productFilters.type);
	
	      if (this.props.product.productFilters && this.props.product.productFilters.type) {
	        // Do nothing
	      } else {
	        newFilters = {
	          type: 'ring,earring,necklace,bracelet'
	        };
	      }
	
	      for (var i = 0; i < filterKeys.length; i++) {
	        newFilters[filterKeys[i]] = filterValues[i];
	      }
	
	      this.props.productSaveProductQueryFilters(newFilters, 'fashion');
	      setTimeout(function () {
	        _this3.props.updateMethod((0, _formatting.formatQuerystring)(_this3.props.product.productFilters));
	      }, 200);
	    }
	  }, {
	    key: 'searchAction',
	    value: function searchAction() {
	      this.filtersUpdated('fashion', [], []);
	      this.props.closeMethod(false);
	    }
	  }, {
	    key: 'resetBandFilters',
	    value: function resetBandFilters() {
	      var _this4 = this;
	
	      this.setState({
	
	        priceMin: 100,
	        priceMax: 500000,
	
	        jewelryTypeValues: null,
	
	        metalsValues: null,
	
	        gemstoneValues: null,
	
	        designersValues: null,
	
	        styleValues: [],
	
	        lastReset: Date.now()
	
	      });
	
	      this.props.productResetProductQueryFilters('fashion');
	      setTimeout(function () {
	        _this4.props.updateMethod((0, _formatting.formatQuerystring)(_this4.props.product.productFilters));
	      }, 150);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'FashionFilters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'rbFilterWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rbInternalWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'headerItem filterItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Fashion Jewelry'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', onClick: function onClick() {
	                        return _this5.resetBandFilters();
	                      } },
	                    'Reset'
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'filterBody' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('type') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this5.toggleFilterElement('type');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Jewelry Types'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Jewelry Types',
	                    productType: 'fashion',
	                    dataKey: 'type',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getJewelryTypeData(),
	                    initData: this.state.jewelryTypeValues,
	                    resetElement: null })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('metals') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this5.toggleFilterElement('metals');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Metals'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Metals',
	                    productType: 'fashion',
	                    dataKey: 'metals',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getMetalTypeData(),
	                    initData: this.state.metalsValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('gemstone') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this5.toggleFilterElement('gemstone');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Gemstone'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Gemstones',
	                    productType: 'fashion',
	                    dataKey: 'gemstone',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getGemstoneData(),
	                    initData: this.state.gemstoneValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('designer') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this5.toggleFilterElement('designer');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Designers'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Designers',
	                    productType: 'settings',
	                    dataKey: 'designers',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getDesignerData(),
	                    initData: this.state.designersValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('style'), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this5.toggleFilterElement('style');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Style'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_StyleIcons2.default, {
	                    searchType: 'fashion',
	                    refreshData: this.filtersUpdated.bind(this),
	                    initData: this.state.styleValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'budgetSection' },
	              _react2.default.createElement(
	                'div',
	                { className: 'budgetItem ' + this.getElementClass('budget') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue', onClick: function onClick() {
	                          return _this5.toggleFilterElement('budget');
	                        } },
	                      'Price Range'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon', onClick: function onClick() {
	                        return _this5.toggleFilterElement('budget');
	                      } },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon', onClick: function onClick() {
	                        return _this5.toggleFilterElement('budget');
	                      } },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_NumericSlider2.default, {
	                      minValue: 100,
	                      maxValue: 500000,
	                      initMinValue: this.state.priceMin,
	                      initMaxValue: this.state.priceMax,
	                      minKey: 'priceMin',
	                      maxKey: 'priceMax',
	                      service: 'fashion',
	                      format: 'currency',
	                      scale: 'log',
	                      increment: 100,
	                      refreshData: this.filtersUpdated.bind(this),
	                      resetElement: this.state.lastReset })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'submitSection' },
	              _react2.default.createElement(
	                'button',
	                { className: 'filterSubmitButton dd2ActionButton', onClick: this.searchAction.bind(this) },
	                'Search'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'filterSeparation' })
	      );
	    }
	  }]);
	
	  return FashionFilters;
	}(_react2.default.Component);
	
	FashionFilters.propTypes = {
	  location: _react.PropTypes.object
	};
	FashionFilters.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = FashionFilters;
	
	
	function mapStateToProps(state) {
	  return {
	    common: state.common,
	    product: state.product
	  };
	}
	
	var FashionFiltersContainer = exports.FashionFiltersContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(FashionFilters);

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MensBandsFiltersContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _url = __webpack_require__(56);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	var _CheckboxList = __webpack_require__(149);
	
	var _CheckboxList2 = _interopRequireDefault(_CheckboxList);
	
	var _NumericSlider = __webpack_require__(150);
	
	var _NumericSlider2 = _interopRequireDefault(_NumericSlider);
	
	var _CarvedIcons = __webpack_require__(521);
	
	var _CarvedIcons2 = _interopRequireDefault(_CarvedIcons);
	
	var _FinishIcons = __webpack_require__(523);
	
	var _FinishIcons2 = _interopRequireDefault(_FinishIcons);
	
	var _MensDiamondIcons = __webpack_require__(524);
	
	var _MensDiamondIcons2 = _interopRequireDefault(_MensDiamondIcons);
	
	var _StyleIcons = __webpack_require__(151);
	
	var _StyleIcons2 = _interopRequireDefault(_StyleIcons);
	
	var _ValuesSlider = __webpack_require__(152);
	
	var _ValuesSlider2 = _interopRequireDefault(_ValuesSlider);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var MensBandsFilters = function (_React$Component) {
	  _inherits(MensBandsFilters, _React$Component);
	
	  function MensBandsFilters(props) {
	    _classCallCheck(this, MensBandsFilters);
	
	    var _this = _possibleConstructorReturn(this, (MensBandsFilters.__proto__ || Object.getPrototypeOf(MensBandsFilters)).call(this, props));
	
	    var urlData = (0, _url.getJsonFromUrl)();
	    var getData = Object.assign({}, _this.props.product.productFilters, urlData);
	    var getKeys = Object.keys(getData);
	    var hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
	
	    _this.state = {
	
	      budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	      priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
	      priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,
	
	      // This is likely not necesary, as this will "link" to future
	      polishedOpen: getKeys.includes('polished'),
	
	      finishOpen: getKeys.includes('finish') || true,
	      finishValues: getKeys.includes('finish') ? getData['finish'].toLowerCase().split(',') : [],
	
	      carvedOpen: getKeys.includes('carved') || true,
	      carvedValues: getKeys.includes('carved') ? getData['carved'].toLowerCase().split(',') : [],
	
	      mensDiamondOpen: getKeys.includes('mensdiamond'),
	      mensDiamondValues: getKeys.includes('mensdiamond') ? getData['mensdiamond'].toLowerCase().split(',') : [],
	
	      metalsOpen: getKeys.includes('metals'),
	      metalsValues: getKeys.includes('metals') ? getData['metals'].toUpperCase().split(',') : null,
	
	      altMetalsOpen: getKeys.includes('altmetals'),
	      altMetalsValues: getKeys.includes('altmetals') ? getData['altmetals'].toLowerCase().split(',') : null,
	
	      designersOpen: getKeys.includes('designers'),
	      designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,
	
	      styleOpen: getKeys.includes('style'),
	      styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : [],
	
	      queryFilters: {},
	
	      lastReset: Date.now()
	    };
	
	    if (hasQuerystring) {
	
	      var pageNum = getData.currentPage ? parseInt(getData.currentPage) : 1;
	
	      _this.props.productSaveProductQueryFilters(getData, 'mensband', pageNum);
	      setTimeout(function () {
	        _this.props.updateMethod((0, _formatting.formatQuerystring)(_this.props.product.productFilters));
	      }, 150);
	    } else {
	      _this.props.productSaveProductQueryFilters(getData, 'mensband', 1);
	      setTimeout(function () {
	        _this.props.updateMethod((0, _formatting.formatQuerystring)(_this.props.product.productFilters));
	      }, 150);
	    }
	    return _this;
	  }
	
	  _createClass(MensBandsFilters, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getAltMetalData',
	    value: function getAltMetalData() {
	      return [{
	        name: 'Carbon Fiber',
	        value: 'carbonfiber'
	      }, {
	        name: 'Tantalum',
	        value: 'tantalum'
	      }];
	    }
	  }, {
	    key: 'getDesignerData',
	    value: function getDesignerData() {
	      return [{
	        name: 'ArtCarved',
	        value: 'artcarved'
	      }, {
	        name: 'Benchmark',
	        value: 'benchmark'
	      }, {
	        name: 'Christian Bauer',
	        value: 'christianbauer'
	      },
	      // {
	      //   name: 'Coast',
	      //   value: 'coast',
	      // },
	      {
	        name: 'Furrer Jacot',
	        value: 'furrerjacot'
	      },
	      // {
	      //   name: 'Kirk Kara',
	      //   value: 'kirkkara',
	      // },
	      {
	        name: 'Novell',
	        value: 'novel'
	      }, {
	        name: 'Simon G.',
	        value: 'simong'
	      }, {
	        name: 'Tacori',
	        value: 'tacori'
	      }, {
	        name: 'True Romance',
	        value: 'trueromanace'
	      }, {
	        name: 'Verragio',
	        value: 'verragio'
	      }];
	    }
	  }, {
	    key: 'getMetalTypeData',
	    value: function getMetalTypeData() {
	      return [{
	        name: 'Yellow Gold',
	        value: 'YG'
	      }, {
	        name: 'White Gold',
	        value: 'WG'
	      }, {
	        name: 'Rose Gold',
	        value: 'RG'
	      }, {
	        name: 'Gray Gold',
	        value: 'GG'
	      }, {
	        name: 'Platinum',
	        value: 'PLAT'
	      }, {
	        name: 'Mixed Metal',
	        value: 'TT,TRI'
	      },
	      // {
	      //   name: 'Carbon Fiber',
	      //   value: 'CARBON',
	      // },
	      {
	        name: 'Tantalum',
	        value: 'TANT'
	      }];
	    }
	  }, {
	    key: 'toggleFilterElement',
	    value: function toggleFilterElement(element) {
	
	      if (!element) {
	        return;
	      }
	
	      switch (element) {
	        case 'budget':
	          this.setState({ budgetOpen: !this.state.budgetOpen });
	          return;
	        case 'polished':
	          this.setState({ polishedOpen: !this.state.polishedOpen });
	          return;
	        case 'finish':
	          this.setState({ finishOpen: !this.state.finishOpen });
	          return;
	        case 'carved':
	          this.setState({ carvedOpen: !this.state.carvedOpen });
	          return;
	        case 'mensdiamond':
	          this.setState({ mensDiamondOpen: !this.state.mensDiamondOpen });
	          return;
	        case 'metals':
	          this.setState({ metalsOpen: !this.state.metalsOpen });
	          return;
	        case 'altmetals':
	          this.setState({ altMetalsOpen: !this.state.altMetalsOpen });
	          return;
	        case 'designers':
	          this.setState({ designersOpen: !this.state.designersOpen });
	          return;
	        case 'style':
	          this.setState({ styleOpen: !this.state.styleOpen });
	          return;
	        default:
	          return;
	      }
	    }
	  }, {
	    key: 'getElementClass',
	    value: function getElementClass(element) {
	
	      if (!element) {
	        return 'filterItem';
	      }
	
	      switch (element) {
	        case 'budget':
	          return this.state.budgetOpen ? 'filterItem open' : 'filterItem';
	        case 'polished':
	          return this.state.polishedOpen ? 'filterItem open' : 'filterItem';
	        case 'finish':
	          return this.state.finishOpen ? 'filterItem open' : 'filterItem';
	        case 'carved':
	          return this.state.carvedOpen ? 'filterItem open' : 'filterItem';
	        case 'mensdiamond':
	          return this.state.mensDiamondOpen ? 'filterItem open' : 'filterItem';
	        case 'metals':
	          return this.state.metalsOpen ? 'filterItem longOpen' : 'filterItem';
	        case 'altmetals':
	          return this.state.altMetalsOpen ? 'filterItem open' : 'filterItem';
	        case 'designers':
	          return this.state.designersOpen ? 'filterItem longOpen' : 'filterItem';
	        case 'style':
	          return this.state.styleOpen ? 'filterItem open' : 'filterItem';
	        default:
	          return 'filterItem';
	      }
	    }
	  }, {
	    key: 'filtersUpdated',
	    value: function filtersUpdated() {
	      var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var _this2 = this;
	
	      var filterKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var filterValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	
	      // console.log(filterType);
	
	      var newFilters = {};
	      for (var i = 0; i < filterKeys.length; i++) {
	        newFilters[filterKeys[i]] = filterValues[i];
	      }
	
	      if (filterType) {
	        newFilters['type'] = filterType;
	      }
	
	      // console.log(newFilters);
	
	      this.props.productSaveProductQueryFilters(newFilters, 'mensband');
	      setTimeout(function () {
	        _this2.props.updateMethod((0, _formatting.formatQuerystring)(_this2.props.product.productFilters));
	      }, 200);
	    }
	  }, {
	    key: 'searchAction',
	    value: function searchAction() {
	      this.filtersUpdated('mensband', [], []);
	      this.props.closeMethod(false);
	    }
	  }, {
	    key: 'resetBandFilters',
	    value: function resetBandFilters() {
	      var _this3 = this;
	
	      this.setState({
	
	        priceMin: 100,
	        priceMax: 500000,
	
	        finishValues: [],
	
	        carvedValues: [],
	
	        mensDiamondValues: [],
	
	        metalsValues: null,
	
	        altMetalsValues: null,
	
	        designersValues: null,
	
	        styleValues: [],
	
	        lastReset: Date.now()
	
	      });
	
	      this.props.productResetProductQueryFilters('mensband');
	      setTimeout(function () {
	        _this3.props.updateMethod((0, _formatting.formatQuerystring)(_this3.props.product.productFilters));
	      }, 150);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MensBandsFilters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'rbFilterWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rbInternalWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'headerItem filterItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Men\'s Bands'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', onClick: function onClick() {
	                        return _this4.resetBandFilters();
	                      } },
	                    'Reset'
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'filterBody' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('polished'), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('polished');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Polished'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement('div', { className: 'controlsWrapper' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('finish') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('finish');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Finish'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_FinishIcons2.default, {
	                    refreshData: this.filtersUpdated.bind(this),
	                    initData: this.state.finishValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('carved') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('carved');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Style'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CarvedIcons2.default, {
	                    refreshData: this.filtersUpdated.bind(this),
	                    initData: this.state.carvedValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('mensdiamond'), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('mensdiamond');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Diamond'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_MensDiamondIcons2.default, {
	                    refreshData: this.filtersUpdated.bind(this),
	                    initData: this.state.mensDiamondValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('metals') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('metals');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Metals'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Metals',
	                    productType: 'mensband',
	                    dataKey: 'metals',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getMetalTypeData(),
	                    initData: this.state.metalsValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('altmetals'), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('altmetals');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Alternative Metals'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Metals',
	                    productType: 'mensband',
	                    dataKey: 'altmetals',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getAltMetalData(),
	                    initData: this.state.altMetalsValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('designers') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('designers');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Designers'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Designers',
	                    productType: 'mensband',
	                    dataKey: 'designers',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getDesignerData(),
	                    initData: this.state.designersValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('style'), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('style');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Style'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_StyleIcons2.default, {
	                    searchType: 'mensband',
	                    refreshData: this.filtersUpdated.bind(this),
	                    initData: this.state.styleValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'budgetSection' },
	              _react2.default.createElement(
	                'div',
	                { className: 'budgetItem ' + this.getElementClass('budget') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue', onClick: function onClick() {
	                          return _this4.toggleFilterElement('budget');
	                        } },
	                      'Price Range'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon', onClick: function onClick() {
	                        return _this4.toggleFilterElement('budget');
	                      } },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon', onClick: function onClick() {
	                        return _this4.toggleFilterElement('budget');
	                      } },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_NumericSlider2.default, {
	                      minValue: 100,
	                      maxValue: 500000,
	                      initMinValue: this.state.priceMin,
	                      initMaxValue: this.state.priceMax,
	                      minKey: 'priceMin',
	                      maxKey: 'priceMax',
	                      service: 'mensband',
	                      format: 'currency',
	                      scale: 'log',
	                      increment: 100,
	                      refreshData: this.filtersUpdated.bind(this),
	                      resetElement: this.state.lastReset })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'submitSection' },
	              _react2.default.createElement(
	                'button',
	                { className: 'filterSubmitButton dd2ActionButton', onClick: this.searchAction.bind(this) },
	                'Search'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'filterSeparation' })
	      );
	    }
	  }]);
	
	  return MensBandsFilters;
	}(_react2.default.Component);
	
	MensBandsFilters.propTypes = {
	  location: _react.PropTypes.object
	};
	MensBandsFilters.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = MensBandsFilters;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var MensBandsFiltersContainer = exports.MensBandsFiltersContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(MensBandsFilters);

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MensJewelryFiltersContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _url = __webpack_require__(56);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	var _CheckboxList = __webpack_require__(149);
	
	var _CheckboxList2 = _interopRequireDefault(_CheckboxList);
	
	var _NumericSlider = __webpack_require__(150);
	
	var _NumericSlider2 = _interopRequireDefault(_NumericSlider);
	
	var _GemstoneIcons = __webpack_require__(214);
	
	var _GemstoneIcons2 = _interopRequireDefault(_GemstoneIcons);
	
	var _StackableIcons = __webpack_require__(215);
	
	var _StackableIcons2 = _interopRequireDefault(_StackableIcons);
	
	var _WomensDiamondIcons = __webpack_require__(216);
	
	var _WomensDiamondIcons2 = _interopRequireDefault(_WomensDiamondIcons);
	
	var _StyleIcons = __webpack_require__(151);
	
	var _StyleIcons2 = _interopRequireDefault(_StyleIcons);
	
	var _ValuesSlider = __webpack_require__(152);
	
	var _ValuesSlider2 = _interopRequireDefault(_ValuesSlider);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var MensJewelryFilters = function (_React$Component) {
	  _inherits(MensJewelryFilters, _React$Component);
	
	  function MensJewelryFilters(props) {
	    _classCallCheck(this, MensJewelryFilters);
	
	    var _this = _possibleConstructorReturn(this, (MensJewelryFilters.__proto__ || Object.getPrototypeOf(MensJewelryFilters)).call(this, props));
	
	    var getData = (0, _url.getJsonFromUrl)();
	    var getKeys = Object.keys(getData);
	    var hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
	
	    _this.state = {
	
	      budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	      priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
	      priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,
	
	      jewelryTypeOpen: true,
	      jewelryTypeValues: getKeys.includes('type') ? getData['type'].toLowerCase().split(',') : ['mring', 'mnecklace', 'chains', 'mbracelet'],
	
	      metalsOpen: getKeys.includes('metals'),
	      metalsValues: getKeys.includes('metals') ? getData['metals'].toUpperCase().split(',') : null,
	
	      gemstoneOpen: getKeys.includes('gemstone'),
	      gemstoneValues: getKeys.includes('gemstone') ? getData['gemstone'].toLowerCase().split(',') : null,
	
	      designersOpen: getKeys.includes('designers'),
	      designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,
	
	      styleOpen: getKeys.includes('style'),
	      styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : [],
	
	      lastReset: Date.now()
	    };
	
	    if (hasQuerystring) {
	
	      var pageNum = getData.currentPage ? parseInt(getData.currentPage) : 1;
	
	      _this.props.productSaveProductQueryFilters(getData, 'mens', pageNum);
	      setTimeout(function () {
	        _this.props.updateMethod((0, _formatting.formatQuerystring)(_this.props.product.productFilters));
	      }, 150);
	    } else {
	      _this.props.productSaveProductQueryFilters(getData, 'mens', 1);
	      setTimeout(function () {
	        _this.props.updateMethod((0, _formatting.formatQuerystring)(_this.props.product.productFilters));
	      }, 150);
	    }
	    return _this;
	  }
	
	  _createClass(MensJewelryFilters, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      if (prevProps.common.registerNavChange && this.props.common.registerNavChange && prevProps.common.registerNavChange != this.props.common.registerNavChange) {
	
	        // TODO: refactor into method called on load and change
	        var getData = (0, _url.getJsonFromUrl)();
	        var getKeys = Object.keys(getData);
	        var hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
	
	        this.setState({
	
	          budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	          priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
	          priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,
	
	          jewelryTypeOpen: getKeys.includes('type'),
	          jewelryTypeValues: getKeys.includes('type') ? getData['type'].toLowerCase().split(',') : ['mring', 'mnecklace', 'chains', 'mbracelet'],
	
	          metalsOpen: getKeys.includes('metals'),
	          metalsValues: getKeys.includes('metals') ? getData['metals'].toUpperCase().split(',') : null,
	
	          gemstoneOpen: getKeys.includes('gemstone'),
	          gemstoneValues: getKeys.includes('gemstone') ? getData['gemstone'].toLowerCase().split(',') : null,
	
	          designersOpen: getKeys.includes('designer'),
	          designersValues: getKeys.includes('designer') ? getData['designer'].toLowerCase().split(',') : null,
	
	          styleOpen: getKeys.includes('style'),
	          styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : []
	        });
	
	        if (hasQuerystring) {
	          this.props.productSaveProductQueryFilters(getData, 'mens', 1);
	          setTimeout(function () {
	            _this2.props.updateMethod((0, _formatting.formatQuerystring)(_this2.props.product.productFilters));
	          }, 150);
	        }
	      }
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getDesignerData',
	    value: function getDesignerData() {
	      return [{
	        name: 'Diamonds Direct Designs',
	        value: 'dddesigns'
	      }, {
	        name: 'Amden',
	        value: 'amden'
	      },
	      // {
	      //   name: 'Christopher Designs',
	      //   value: 'christopherdesigns',
	      // },
	      {
	        name: 'Classique Creations',
	        value: 'classique'
	      },
	      // {
	      //   name: 'FJ Kashi',
	      //   value: 'fjkashi',
	      // },
	      {
	        name: 'Fana',
	        value: 'fana'
	      },
	      // {
	      //   name: 'Gabriel & Co',
	      //   value: 'gabrielco',
	      // },
	      {
	        name: 'KC Designs',
	        value: 'kcdesigns'
	      }, {
	        name: 'Mastoloni',
	        value: 'mastoloni'
	      }, {
	        name: 'Odelia',
	        value: 'odelia'
	      }, {
	        name: 'Pejay Creations',
	        value: 'pejay'
	      }, {
	        name: 'Rebeka Hakimi',
	        value: 'rebeka'
	      }, {
	        name: 'SES',
	        value: 'ses'
	      }, {
	        name: 'Simon G.',
	        value: 'simong'
	      }, {
	        name: 'Tacori',
	        value: 'tacorif'
	      }, {
	        name: 'Uneek',
	        value: 'uneek'
	      }];
	    }
	  }, {
	    key: 'getMetalTypeData',
	    value: function getMetalTypeData() {
	      return [{
	        name: 'White Gold',
	        value: 'WG'
	      }, {
	        name: 'Yellow Gold',
	        value: 'YG'
	      }, {
	        name: 'Rose Gold',
	        value: 'RG'
	      }];
	    }
	  }, {
	    key: 'getGemstoneData',
	    value: function getGemstoneData() {
	      return [
	      // {
	      //   name: 'Alexandrite',
	      //   value: 'alexandrite',
	      // },
	      // {
	      //   name: 'Amethyst',
	      //   value: 'amethyst',
	      // },
	      // {
	      //   name: 'Aquamarine',
	      //   value: 'aquamarine',
	      // },
	      // {
	      //   name: 'Chalcedony',
	      //   value: 'chalcedony',
	      // },
	      // {
	      //   name: 'Citrine',
	      //   value: 'citrine',
	      // },
	      {
	        name: 'Diamond',
	        value: 'diamond'
	      },
	      // {
	      //   name: 'Emerald',
	      //   value: 'emerald',
	      // },
	      // {
	      //   name: 'Garnet',
	      //   value: 'garnet',
	      // },
	      {
	        name: 'Lapis',
	        value: 'lapis'
	      },
	      // {
	      //   name: 'Morganite',
	      //   value: 'morganite',
	      // },
	      {
	        name: 'Onyx',
	        value: 'onyx'
	      }];
	    }
	  }, {
	    key: 'getJewelryTypeData',
	    value: function getJewelryTypeData() {
	      return [{
	        name: 'Rings',
	        value: 'mring'
	      }, {
	        name: 'Pendants',
	        value: 'mnecklace'
	      }, {
	        name: 'Chains',
	        value: 'chains'
	      }, {
	        name: 'Bracelets',
	        value: 'mbracelet'
	      }];
	    }
	  }, {
	    key: 'toggleFilterElement',
	    value: function toggleFilterElement(element) {
	
	      if (!element) {
	        return;
	      }
	
	      switch (element) {
	        case 'budget':
	          this.setState({ budgetOpen: !this.state.budgetOpen });
	          return;
	        case 'type':
	          this.setState({ jewelryTypeOpen: !this.state.jewelryTypeOpen });
	          return;
	        case 'metals':
	          this.setState({ metalsOpen: !this.state.metalsOpen });
	          return;
	        case 'gemstone':
	          this.setState({ gemstoneOpen: !this.state.gemstoneOpen });
	          return;
	        case 'designer':
	          this.setState({ designersOpen: !this.state.designersOpen });
	          return;
	        case 'style':
	          this.setState({ styleOpen: !this.state.styleOpen });
	          return;
	        default:
	          return;
	      }
	    }
	  }, {
	    key: 'getElementClass',
	    value: function getElementClass(element) {
	
	      if (!element) {
	        return 'filterItem';
	      }
	
	      switch (element) {
	        case 'budget':
	          return this.state.budgetOpen ? 'filterItem open' : 'filterItem';
	        case 'type':
	          return this.state.jewelryTypeOpen ? 'filterItem open' : 'filterItem';
	        case 'metals':
	          return this.state.metalsOpen ? 'filterItem open' : 'filterItem';
	        case 'gemstone':
	          return this.state.gemstoneOpen ? 'filterItem longOpen' : 'filterItem';
	        case 'designer':
	          return this.state.designersOpen ? 'filterItem longOpen' : 'filterItem';
	        case 'style':
	          return this.state.styleOpen ? 'filterItem open' : 'filterItem';
	        default:
	          return 'filterItem';
	      }
	    }
	  }, {
	    key: 'filtersUpdated',
	    value: function filtersUpdated() {
	      var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var _this3 = this;
	
	      var filterKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var filterValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	
	      var newFilters = {};
	
	      console.log(this.props.product.productFilters);
	      console.log(this.props.product.productFilters.type);
	
	      if (this.props.product.productFilters && this.props.product.productFilters.type) {
	        // Do nothing
	      } else {
	        newFilters = {
	          type: 'mring,mnecklace,chains,mbracelet'
	        };
	      }
	
	      for (var i = 0; i < filterKeys.length; i++) {
	        newFilters[filterKeys[i]] = filterValues[i];
	      }
	
	      this.props.productSaveProductQueryFilters(newFilters, 'mens');
	      setTimeout(function () {
	        _this3.props.updateMethod((0, _formatting.formatQuerystring)(_this3.props.product.productFilters));
	      }, 200);
	    }
	  }, {
	    key: 'searchAction',
	    value: function searchAction() {
	      this.filtersUpdated('mens', [], []);
	      this.props.closeMethod(false);
	    }
	  }, {
	    key: 'resetBandFilters',
	    value: function resetBandFilters() {
	      var _this4 = this;
	
	      this.setState({
	
	        priceMin: 100,
	        priceMax: 500000,
	
	        jewelryTypeValues: null,
	
	        metalsValues: null,
	
	        gemstoneValues: null,
	
	        designersValues: null,
	
	        styleValues: [],
	
	        lastReset: Date.now()
	
	      });
	
	      this.props.productResetProductQueryFilters('mens');
	      setTimeout(function () {
	        _this4.props.updateMethod((0, _formatting.formatQuerystring)(_this4.props.product.productFilters));
	      }, 150);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MensJewelryFilters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'rbFilterWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rbInternalWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'headerItem filterItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Men\'s Jewelry'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', onClick: function onClick() {
	                        return _this5.resetBandFilters();
	                      } },
	                    'Reset'
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'filterBody' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('type') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this5.toggleFilterElement('type');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Jewelry Types'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Jewelry Types',
	                    productType: 'mens',
	                    dataKey: 'type',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getJewelryTypeData(),
	                    initData: this.state.jewelryTypeValues,
	                    resetElement: null })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('metals') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this5.toggleFilterElement('metals');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Metals'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Metals',
	                    productType: 'mens',
	                    dataKey: 'metals',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getMetalTypeData(),
	                    initData: this.state.metalsValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('gemstone') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this5.toggleFilterElement('gemstone');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Gemstone'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Gemstones',
	                    productType: 'mens',
	                    dataKey: 'gemstone',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getGemstoneData(),
	                    initData: this.state.gemstoneValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('designer'), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this5.toggleFilterElement('designer');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Designers'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Designers',
	                    productType: 'settings',
	                    dataKey: 'designers',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getDesignerData(),
	                    initData: this.state.designersValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('style'), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this5.toggleFilterElement('style');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Style'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_StyleIcons2.default, {
	                    searchType: 'mens',
	                    refreshData: this.filtersUpdated.bind(this),
	                    initData: this.state.styleValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'budgetSection' },
	              _react2.default.createElement(
	                'div',
	                { className: 'budgetItem ' + this.getElementClass('budget') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue', onClick: function onClick() {
	                          return _this5.toggleFilterElement('budget');
	                        } },
	                      'Price Range'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon', onClick: function onClick() {
	                        return _this5.toggleFilterElement('budget');
	                      } },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon', onClick: function onClick() {
	                        return _this5.toggleFilterElement('budget');
	                      } },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_NumericSlider2.default, {
	                      minValue: 100,
	                      maxValue: 500000,
	                      initMinValue: this.state.priceMin,
	                      initMaxValue: this.state.priceMax,
	                      minKey: 'priceMin',
	                      maxKey: 'priceMax',
	                      service: 'mens',
	                      format: 'currency',
	                      scale: 'log',
	                      increment: 100,
	                      refreshData: this.filtersUpdated.bind(this),
	                      resetElement: this.state.lastReset })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'submitSection' },
	              _react2.default.createElement(
	                'button',
	                { className: 'filterSubmitButton dd2ActionButton', onClick: this.searchAction.bind(this) },
	                'Search'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'filterSeparation' })
	      );
	    }
	  }]);
	
	  return MensJewelryFilters;
	}(_react2.default.Component);
	
	MensJewelryFilters.propTypes = {
	  location: _react.PropTypes.object
	};
	MensJewelryFilters.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = MensJewelryFilters;
	
	
	function mapStateToProps(state) {
	  return {
	    common: state.common,
	    product: state.product
	  };
	}
	
	var MensJewelryFiltersContainer = exports.MensJewelryFiltersContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(MensJewelryFilters);

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WomensBandsFiltersContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _url = __webpack_require__(56);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	var _CheckboxList = __webpack_require__(149);
	
	var _CheckboxList2 = _interopRequireDefault(_CheckboxList);
	
	var _NumericSlider = __webpack_require__(150);
	
	var _NumericSlider2 = _interopRequireDefault(_NumericSlider);
	
	var _GemstoneIcons = __webpack_require__(214);
	
	var _GemstoneIcons2 = _interopRequireDefault(_GemstoneIcons);
	
	var _StackableIcons = __webpack_require__(215);
	
	var _StackableIcons2 = _interopRequireDefault(_StackableIcons);
	
	var _WomensDiamondIcons = __webpack_require__(216);
	
	var _WomensDiamondIcons2 = _interopRequireDefault(_WomensDiamondIcons);
	
	var _StyleIcons = __webpack_require__(151);
	
	var _StyleIcons2 = _interopRequireDefault(_StyleIcons);
	
	var _ValuesSlider = __webpack_require__(152);
	
	var _ValuesSlider2 = _interopRequireDefault(_ValuesSlider);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var WomensBandsFilters = function (_React$Component) {
	  _inherits(WomensBandsFilters, _React$Component);
	
	  function WomensBandsFilters(props) {
	    _classCallCheck(this, WomensBandsFilters);
	
	    var _this = _possibleConstructorReturn(this, (WomensBandsFilters.__proto__ || Object.getPrototypeOf(WomensBandsFilters)).call(this, props));
	
	    console.log(_this.props.product.productFilters);
	
	    var urlData = (0, _url.getJsonFromUrl)();
	    var getData = Object.assign({}, _this.props.product.productFilters, urlData);
	    var getKeys = Object.keys(getData);
	    var hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
	
	    _this.state = {
	
	      budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
	      priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
	      priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,
	
	      // This is likely not necesary, as this will "link" to future
	      polishedOpen: getKeys.includes('polished'),
	
	      womensDiamondOpen: true,
	      womensDiamondValues: getKeys.includes('womensdiamond') ? getData['womensdiamond'].toLowerCase().split(',') : [],
	
	      stackableOpen: true,
	      stackableValues: getKeys.includes('stackable') ? getData['stackable'].toLowerCase().split(',') : [],
	
	      gemstoneOpen: getKeys.includes('gemstone'),
	      gemstoneValues: getKeys.includes('gemstone') ? getData['gemstone'].toLowerCase().split(',') : [],
	
	      metalsOpen: getKeys.includes('metals'),
	      metalsValues: getKeys.includes('metals') ? getData['metals'].toUpperCase().split(',') : null,
	
	      designersOpen: getKeys.includes('designers'),
	      designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,
	
	      styleOpen: getKeys.includes('style'),
	      styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : [],
	
	      lastReset: Date.now()
	    };
	
	    if (hasQuerystring) {
	
	      var pageNum = getData.currentPage ? parseInt(getData.currentPage) : 1;
	
	      _this.props.productSaveProductQueryFilters(getData, 'womensband', pageNum);
	      setTimeout(function () {
	        _this.props.updateMethod((0, _formatting.formatQuerystring)(_this.props.product.productFilters));
	      }, 150);
	    } else {
	      _this.props.productSaveProductQueryFilters(getData, 'womensband', 1);
	      setTimeout(function () {
	        _this.props.updateMethod((0, _formatting.formatQuerystring)(_this.props.product.productFilters));
	      }, 150);
	    }
	    return _this;
	  }
	
	  _createClass(WomensBandsFilters, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getMetalTypeData',
	    value: function getMetalTypeData() {
	      return [{
	        name: 'White Gold',
	        value: 'WG'
	      }, {
	        name: 'Yellow Gold',
	        value: 'YG'
	      }, {
	        name: 'Rose Gold',
	        value: 'RG'
	      }, {
	        name: 'Platinum',
	        value: 'PLAT'
	      }];
	    }
	  }, {
	    key: 'getDesignerData',
	    value: function getDesignerData() {
	      return [{
	        name: 'Diamonds Direct Designs',
	        value: 'dddesigns'
	      }, {
	        name: 'A Jaffe',
	        value: 'ajaffe'
	      }, {
	        name: 'Amden',
	        value: 'amden'
	      }, {
	        name: 'Artcarved',
	        value: 'artcarved'
	      }, {
	        name: 'C. Gonshor',
	        value: 'cgonshor'
	      },
	      // {
	      //   name: 'Christopher Designs',
	      //   value: 'christopherdesigns',
	      // },
	      {
	        name: 'Classique Creations',
	        value: 'classique'
	      }, {
	        name: 'Coast',
	        value: 'coast'
	      }, {
	        name: 'Fana',
	        value: 'fana'
	      },
	      // {
	      //   name: 'Henri Daussi',
	      //   value: 'henridaussi',
	      // },
	      // {
	      //   name: 'Jack Kelege',
	      //   value: 'jackkelege',
	      // },
	      // {
	      //   name: 'Jeff Cooper',
	      //   value: 'jeffcooper',
	      // },
	      {
	        name: 'KC Designs',
	        value: 'kcdesigns'
	      }, {
	        name: 'Kirk Kara',
	        value: 'kirkkara'
	      }, {
	        name: 'Novell',
	        value: 'novel'
	      }, {
	        name: 'SES',
	        value: 'ses'
	      }, {
	        name: 'Simon G.',
	        value: 'simong'
	      }, {
	        name: 'Sylvie',
	        value: 'sylvie'
	      }, {
	        name: 'Tacori',
	        value: 'tacori'
	      }, {
	        name: 'True Romance',
	        value: 'trueromanace'
	      }, {
	        name: 'Uneek',
	        value: 'uneek'
	      }, {
	        name: 'Verragio',
	        value: 'verragio'
	      }, {
	        name: 'Michael M.',
	        value: 'michaelm'
	      }];
	    }
	  }, {
	    key: 'getGemstoneData',
	    value: function getGemstoneData() {
	      return [{
	        name: 'Alexandrite',
	        value: 'alexandrite'
	      }, {
	        name: 'Amethyst',
	        value: 'amethyst'
	      }, {
	        name: 'Aquamarine',
	        value: 'aquamarine'
	      }, {
	        name: 'Blue Topaz',
	        value: 'topaz'
	      }, {
	        name: 'Citrine',
	        value: 'citrine'
	      }, {
	        name: 'Diamond',
	        value: 'diamond'
	      }, {
	        name: 'Emerald',
	        value: 'emerald'
	      }, {
	        name: 'Garnet',
	        value: 'garnet'
	      }, {
	        name: 'Morganite',
	        value: 'morganite'
	      }, {
	        name: 'Opal',
	        value: 'opal'
	      }, {
	        name: 'Peridot',
	        value: 'peridot'
	      }, {
	        name: 'Ruby',
	        value: 'ruby'
	      }, {
	        name: 'Sapphire',
	        value: 'sapphire'
	      }];
	    }
	  }, {
	    key: 'toggleFilterElement',
	    value: function toggleFilterElement(element) {
	
	      if (!element) {
	        return;
	      }
	
	      switch (element) {
	        case 'budget':
	          this.setState({ budgetOpen: !this.state.budgetOpen });
	          return;
	        case 'polished':
	          this.setState({ polishedOpen: !this.state.polishedOpen });
	          return;
	        case 'womensdiamond':
	          this.setState({ womensDiamondOpen: !this.state.womensDiamondOpen });
	          return;
	        case 'stackable':
	          this.setState({ stackableOpen: !this.state.stackableOpen });
	          return;
	        case 'gemstone':
	          this.setState({ gemstoneOpen: !this.state.gemstoneOpen });
	          return;
	        case 'metals':
	          this.setState({ metalsOpen: !this.state.metalsOpen });
	          return;
	        case 'designers':
	          this.setState({ designersOpen: !this.state.designersOpen });
	          return;
	        case 'style':
	          this.setState({ styleOpen: !this.state.styleOpen });
	          return;
	        default:
	          return;
	      }
	    }
	  }, {
	    key: 'getElementClass',
	    value: function getElementClass(element) {
	
	      if (!element) {
	        return 'filterItem';
	      }
	
	      switch (element) {
	        case 'budget':
	          return this.state.budgetOpen ? 'filterItem open' : 'filterItem';
	        case 'polished':
	          return this.state.polishedOpen ? 'filterItem open' : 'filterItem';
	        case 'womensdiamond':
	          return this.state.womensDiamondOpen ? 'filterItem open' : 'filterItem';
	        case 'stackable':
	          return this.state.stackableOpen ? 'filterItem open' : 'filterItem';
	        case 'gemstone':
	          return this.state.gemstoneOpen ? 'filterItem longOpen' : 'filterItem';
	        case 'metals':
	          return this.state.metalsOpen ? 'filterItem open' : 'filterItem';
	        case 'designers':
	          return this.state.designersOpen ? 'filterItem longOpen' : 'filterItem';
	        case 'style':
	          return this.state.styleOpen ? 'filterItem open' : 'filterItem';
	        default:
	          return 'filterItem';
	      }
	    }
	  }, {
	    key: 'filtersUpdated',
	    value: function filtersUpdated() {
	      var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var _this2 = this;
	
	      var filterKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var filterValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	
	      console.log(filterType);
	
	      var newFilters = {};
	      for (var i = 0; i < filterKeys.length; i++) {
	        newFilters[filterKeys[i]] = filterValues[i];
	      }
	
	      if (filterType) {
	        console.log('in type');
	        newFilters['type'] = filterType;
	        console.log(newFilters);
	      }
	
	      this.props.productSaveProductQueryFilters(newFilters, 'womensband');
	      setTimeout(function () {
	        _this2.props.updateMethod((0, _formatting.formatQuerystring)(_this2.props.product.productFilters));
	      }, 200);
	    }
	  }, {
	    key: 'searchAction',
	    value: function searchAction() {
	      this.filtersUpdated('womensband', [], []);
	      this.props.closeMethod(false);
	    }
	  }, {
	    key: 'resetBandFilters',
	    value: function resetBandFilters() {
	      var _this3 = this;
	
	      this.setState({
	
	        priceMin: 100,
	        priceMax: 500000,
	
	        womensDiamondValues: [],
	
	        stackableValues: [],
	
	        gemstoneValues: [],
	
	        metalsValues: null,
	
	        designersValues: null,
	
	        styleValues: [],
	
	        lastReset: Date.now()
	
	      });
	
	      this.props.productResetProductQueryFilters('womensband');
	      setTimeout(function () {
	        _this3.props.updateMethod((0, _formatting.formatQuerystring)(_this3.props.product.productFilters));
	      }, 150);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'WomensBandsFilters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'rbFilterWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rbInternalWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'headerItem filterItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Women\'s Bands'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', onClick: function onClick() {
	                        return _this4.resetBandFilters();
	                      } },
	                    'Reset'
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'filterBody' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('polished'), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('polished');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Polished'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement('div', { className: 'controlsWrapper' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('womensdiamond') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('womensdiamond');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Diamond'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_WomensDiamondIcons2.default, {
	                    refreshData: this.filtersUpdated.bind(this),
	                    initData: this.state.womensDiamondValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('stackable') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('stackable');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Stackable'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_StackableIcons2.default, {
	                    refreshData: this.filtersUpdated.bind(this),
	                    initData: this.state.stackableValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('gemstone') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('gemstone');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Gemstone'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'none' } },
	                    _react2.default.createElement(_GemstoneIcons2.default, {
	                      refreshData: this.filtersUpdated.bind(this),
	                      initData: this.state.gemstoneValues,
	                      resetElement: this.state.lastReset })
	                  ),
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Gemstones',
	                    productType: 'womensband',
	                    dataKey: 'gemstone',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getGemstoneData(),
	                    initData: this.state.gemstoneValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('metals') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('metals');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Metals'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Metals',
	                    productType: 'womensband',
	                    dataKey: 'metals',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getMetalTypeData(),
	                    initData: this.state.metalsValues,
	                    disclaimer: 'Most bands available in all metal colors.',
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('designers') },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('designers');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Designers'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_CheckboxList2.default, {
	                    label: 'Designers',
	                    productType: 'womensband',
	                    dataKey: 'designers',
	                    refreshData: this.filtersUpdated.bind(this),
	                    checkboxData: this.getDesignerData(),
	                    initData: this.state.designersValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getElementClass('style'), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'filterHead', onClick: function onClick() {
	                    return _this4.toggleFilterElement('style');
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterLabel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterValue' },
	                    'Style'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterReset', style: { display: 'none' } },
	                    _react2.default.createElement('img', { src: '/img/ringbuilder/filter/info.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon' },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterIcon openIcon' },
	                  '\u2014'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'filterBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'controlsWrapper' },
	                  _react2.default.createElement(_StyleIcons2.default, {
	                    searchType: 'womensband',
	                    refreshData: this.filtersUpdated.bind(this),
	                    initData: this.state.styleValues,
	                    resetElement: this.state.lastReset })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'budgetSection' },
	              _react2.default.createElement(
	                'div',
	                { className: 'budgetItem ' + this.getElementClass('budget') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterHead' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterLabel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'filterValue', onClick: function onClick() {
	                          return _this4.toggleFilterElement('budget');
	                        } },
	                      'Price Range'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon', onClick: function onClick() {
	                        return _this4.toggleFilterElement('budget');
	                      } },
	                    '+'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filterIcon openIcon', onClick: function onClick() {
	                        return _this4.toggleFilterElement('budget');
	                      } },
	                    '\u2014'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'filterBody' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'controlsWrapper' },
	                    _react2.default.createElement(_NumericSlider2.default, {
	                      minValue: 100,
	                      maxValue: 500000,
	                      initMinValue: this.state.priceMin,
	                      initMaxValue: this.state.priceMax,
	                      minKey: 'priceMin',
	                      maxKey: 'priceMax',
	                      service: 'womensband',
	                      format: 'currency',
	                      scale: 'log',
	                      increment: 100,
	                      refreshData: this.filtersUpdated.bind(this),
	                      resetElement: this.state.lastReset })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'submitSection' },
	              _react2.default.createElement(
	                'button',
	                { className: 'filterSubmitButton dd2ActionButton', onClick: this.searchAction.bind(this) },
	                'Search'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'filterSeparation' })
	      );
	    }
	  }]);
	
	  return WomensBandsFilters;
	}(_react2.default.Component);
	
	WomensBandsFilters.propTypes = {
	  location: _react.PropTypes.object
	};
	WomensBandsFilters.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = WomensBandsFilters;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var WomensBandsFiltersContainer = exports.WomensBandsFiltersContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(WomensBandsFilters);

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BandResultsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _data = __webpack_require__(74);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(42);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _ResultsControls = __webpack_require__(99);
	
	var _ResultsPagination = __webpack_require__(120);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var BandResults = function (_React$Component) {
	  _inherits(BandResults, _React$Component);
	
	  function BandResults(props) {
	    _classCallCheck(this, BandResults);
	
	    var _this = _possibleConstructorReturn(this, (BandResults.__proto__ || Object.getPrototypeOf(BandResults)).call(this, props));
	
	    _this.state = {
	      scrollPos: 0,
	      tabSelected: 'results',
	
	      resultsOpen: true
	    };
	
	    // Bind event listeners
	    _this.getScrollPos = _this.getScrollPos.bind(_this);
	    return _this;
	  }
	
	  _createClass(BandResults, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'getScrollPos',
	    value: function getScrollPos() {
	      this.setState({
	        scrollPos: window.pageYOffset
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(tabVal) {
	      this.setState({ tabSelected: tabVal });
	    }
	  }, {
	    key: 'getFavesLength',
	    value: function getFavesLength() {
	      return this.props.product.compareBands.length.toString();
	    }
	  }, {
	    key: 'isFavoriteProduct',
	    value: function isFavoriteProduct(product) {
	      if (!product) {
	        return false;
	      }
	
	      for (var i = 0; i < this.props.product.compareBands.length; i++) {
	        if (this.props.product.compareBands[i].sku == product.sku) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'toggleFavoriteProduct',
	    value: function toggleFavoriteProduct(product) {
	      if (this.isFavoriteProduct(product)) {
	        this.removeFavoriteProduct(product);
	      } else {
	        this.addFavoriteProduct(product);
	      }
	    }
	  }, {
	    key: 'addFavoriteProduct',
	    value: function addFavoriteProduct(product) {
	      var faves = (0, _data.cloneArray)(this.props.product.compareBands);
	      if (faves.length >= 4) {
	        return;
	      }
	      faves.push(product);
	      this.props.productCompareBand(faves);
	      // this.setState({ 
	      //   tabSelected: 'compare',
	      // });
	    }
	  }, {
	    key: 'removeFavoriteProduct',
	    value: function removeFavoriteProduct(product) {
	
	      var currentIndex = null;
	      var faves = (0, _data.cloneArray)(this.props.product.compareBands);
	
	      if (this.props.product.compareBands.length === 1) {
	        this.props.productCompareBand([]);
	        return;
	      }
	
	      for (var i = 0; i < faves.length; i++) {
	        if (faves[i].sku == product.sku) {
	          currentIndex = i;
	          break;
	        }
	      }
	
	      faves.splice(currentIndex, 1);
	      this.props.productCompareBand(faves);
	    }
	  }, {
	    key: 'renderFavorites',
	    value: function renderFavorites() {
	      var _this2 = this;
	
	      var faveItems = [null, null, null, null];
	      var noItems = false;
	
	      var selectedLength = this.props.product.compareBands.length;
	      if (selectedLength === 0) {
	        noItems = true;
	      }
	      for (var i = 0; i < faveItems.length; i++) {
	        if (i < selectedLength) {
	          faveItems[i] = this.props.product.compareBands[i];
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'favesWrapper' },
	        noItems ? _react2.default.createElement(
	          'div',
	          { className: 'noItemsMessage' },
	          'Select products to compare'
	        ) : null,
	        faveItems.map(function (item, k) {
	
	          if (item === null) {
	            return _this2.renderNullFave(k);
	          }
	
	          if (_this2.props.gender == 'mensband') {
	            return _this2.renderMensBandFave(item, k);
	          } else {
	            return _this2.renderWomensBandFave(item, k);
	          }
	        })
	      );
	    }
	  }, {
	    key: 'renderNullFave',
	    value: function renderNullFave(idx) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'faveItem faveEmpty', key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'compareInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'compareNumber' },
	            idx + 1
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'heartSection' },
	          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/comparelogo.svg' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Compare men\'s and women\'s wedding bands here!'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderWomensBandFave',
	    value: function renderWomensBandFave(product, idx) {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'faveItem faveProduct', key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'compareInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'compareNumber' },
	            idx + 1
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveRemove', onClick: function onClick() {
	              return _this3.removeFavoriteProduct(product);
	            } },
	          '\xD7'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveProductInner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'faveImg', onClick: function onClick() {
	                return _this3.internalNav('band/' + product.sku);
	              } },
	            _react2.default.createElement('img', { src: this.getProductMainImage(product) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveTitle' },
	            _react2.default.createElement(
	              'div',
	              null,
	              product.name.replace(/Ã©/g, 'é')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Total Carat Wt:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              product.ttw_dia,
	              ' Ct.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'favePrice' },
	            '$',
	            (0, _product.getMinPrice)(product).toLocaleString()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveAdd', onClick: function onClick() {
	                return _this3.internalNav('band/' + product.sku);
	              } },
	            'View'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMensBandFave',
	    value: function renderMensBandFave(product, idx) {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'faveItem faveProduct', key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'compareInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'compareNumber' },
	            idx + 1
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveRemove', onClick: function onClick() {
	              return _this4.removeFavoriteProduct(product);
	            } },
	          '\xD7'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveProductInner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'faveImg', onClick: function onClick() {
	                return _this4.internalNav('band/' + product.sku);
	              } },
	            _react2.default.createElement('img', { src: this.getProductMainImage(product) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveTitle' },
	            _react2.default.createElement(
	              'div',
	              null,
	              product.name.replace(/Ã©/g, 'é')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Metal Type:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              (0, _formatting.compareValue)(product.metal_type)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'MM Width:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              product.mm_width ? product.mm_width + ' mm' : ''
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'favePrice' },
	            '$',
	            (0, _product.getMinPrice)(product).toLocaleString()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveAdd', onClick: function onClick() {
	                return _this4.internalNav('band/' + product.sku);
	              } },
	            'View'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'prevPage',
	    value: function prevPage() {
	      this.props.productSetPage(parseInt(this.props.product.currentPage) - 1);
	      this.scrollToResults();
	    }
	  }, {
	    key: 'nextPage',
	    value: function nextPage() {
	      this.props.productSetPage(parseInt(this.props.product.currentPage) + 1);
	      this.scrollToResults();
	    }
	  }, {
	    key: 'setPage',
	    value: function setPage(pageNum) {
	      this.props.productSetPage(parseInt(pageNum));
	      this.scrollToResults();
	    }
	  }, {
	    key: 'scrollToResults',
	    value: function scrollToResults() {
	      if (!this.resultsSection) {
	        return;
	      }
	      (0, _reactScrollToComponent2.default)(this.resultsSection, {
	        offset: 0,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	      return window.innerWidth <= 1024;
	    }
	  }, {
	    key: 'getPageCount',
	    value: function getPageCount() {
	      return this.isMobile() ? 24 : 23;
	    }
	  }, {
	    key: 'getBandResults',
	    value: function getBandResults() {
	
	      var AD_POSITION = 4;
	
	      var resultsArray = [];
	
	      if (!this.props.product.productResults || this.props.product.productResults.length === 0) {
	        return resultsArray;
	      }
	
	      for (var i = 0; i < this.props.product.productResults.length; i++) {
	
	        if (i >= this.getPageCount() * this.props.product.currentPage) {
	          break;
	        }
	
	        if (i < this.getPageCount() * (this.props.product.currentPage - 1)) {
	          continue;
	        }
	
	        if (!this.isMobile() && resultsArray.length == AD_POSITION) {
	          resultsArray.push({ sku: 'ad' });
	        }
	
	        resultsArray.push(this.props.product.productResults[i]);
	      }
	      return resultsArray;
	    }
	  }, {
	    key: 'renderProductAd',
	    value: function renderProductAd(keyNum) {
	      var _this5 = this;
	
	      if (this.props.gender == 'mensband') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'bandItem adBannerItem', key: keyNum, onClick: function onClick() {
	              return _this5.internalNav('mens-bands');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'adInnerWrapper mensBandAd' },
	            _react2.default.createElement(
	              'div',
	              { className: 'adPrompt' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Browse Top Styles >'
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'bandItem adBannerItem', key: keyNum, onClick: function onClick() {
	              return _this5.internalNav('womens-bands');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'adInnerWrapper womensBandAd' },
	            _react2.default.createElement(
	              'div',
	              { className: 'adPrompt' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Browse Top Styles >'
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var RESULT_LIMIT = 24;
	      var bCount = 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'BandResults' },
	        _react2.default.createElement(
	          'div',
	          { className: 'labelSection', style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'labelTitle' },
	            'Featured Rings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resultsWrapper', ref: function ref(div) {
	              _this6.resultsSection = div;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'results' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this6.selectTab('results');
	                } },
	              'Results'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'compare' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this6.selectTab('compare');
	                } },
	              'Compare Bands (',
	              this.getFavesLength(),
	              ' of 4)'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper mobileOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'results' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this6.selectTab('results');
	                } },
	              'Results'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'compare' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this6.selectTab('compare');
	                } },
	              'Compare (',
	              this.getFavesLength(),
	              ' of 4)'
	            )
	          ),
	          this.state.tabSelected == 'results' ? _react2.default.createElement(
	            'div',
	            { className: 'resultsBody', ref: function ref(div) {
	                _this6.resultsBody = div;
	              } },
	            _react2.default.createElement(_ResultsControls.ResultsControlsContainer, {
	              resultCount: this.props.product.productResultsCount,
	              resultType: this.props.gender,
	              openFilters: this.props.openFilters }),
	            _react2.default.createElement(
	              'div',
	              { className: 'resultItemsWrapper' },
	              this.props.product.productResults !== null ? _react2.default.createElement(
	                'div',
	                null,
	                this.props.product.productResults.length === 0 ? _react2.default.createElement(
	                  'div',
	                  { className: 'noResults' },
	                  'No results matching your search criteria.  Please adjust the filters and try again.'
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'resultsInternalWrapper' },
	                  this.getBandResults().map(function (product, j) {
	
	                    // if(product.image_count === 0 || bCount >= RESULT_LIMIT * this.props.product.currentPage) {
	                    //   return null;
	                    // }
	
	                    // if(bCount < RESULT_LIMIT * (this.props.product.currentPage - 1)) {
	                    //   bCount++;
	                    //   return null;
	                    // }
	
	                    if (product.sku == 'ad') {
	                      return _this6.renderProductAd(j);
	                    }
	
	                    bCount++;
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: _this6.isFavoriteProduct(product) ? 'bandItem favProduct' : 'bandItem', key: j },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'productItemInnerWrapper' },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: '/jewelry/' + product.sku },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'diamondItemImgWrapper' },
	                            _react2.default.createElement('img', { src: _this6.getProductMainImage(product) })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'productItemTitle' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              product.name.replace(/Ã©/g, 'é')
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'diamondItemPrice' },
	                            '$',
	                            (0, _product.getMinPrice)(product).toLocaleString()
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'favSelectWrapper', onClick: function onClick() {
	                              return _this6.toggleFavoriteProduct(product);
	                            } },
	                          _this6.isFavoriteProduct(product) ? _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare_a.svg' }) : _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare.svg' })
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(_ResultsPagination.ResultsPaginationContainer, {
	                    pageNum: parseInt(this.props.product.currentPage),
	                    pageNext: this.nextPage.bind(this),
	                    pagePrev: this.prevPage.bind(this),
	                    setPage: this.setPage.bind(this),
	                    pageSize: this.getPageCount(),
	                    resultCount: bCount })
	                )
	              ) : _react2.default.createElement(_RhinoLoading2.default, null)
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'picksPreview' },
	            this.renderFavorites()
	          )
	        )
	      );
	    }
	  }]);
	
	  return BandResults;
	}(_react2.default.Component);
	
	BandResults.propTypes = {
	  location: _react.PropTypes.object
	};
	BandResults.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = BandResults;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var BandResultsContainer = exports.BandResultsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(BandResults);

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DiamondResultsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _formatting = __webpack_require__(21);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	var _FloatingHeader = __webpack_require__(213);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	var _DiamondGrid = __webpack_require__(314);
	
	var _CompareProducts = __webpack_require__(212);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators, productActionCreators);
	
	var DiamondResults = function (_React$Component) {
	  _inherits(DiamondResults, _React$Component);
	
	  function DiamondResults(props) {
	    _classCallCheck(this, DiamondResults);
	
	    var _this = _possibleConstructorReturn(this, (DiamondResults.__proto__ || Object.getPrototypeOf(DiamondResults)).call(this, props));
	
	    _this.state = {
	      upperTabSelected: 'best',
	      nextStepsOpen: false,
	      addingToCart: false,
	
	      assembledOpen: true,
	
	      openedClass: ' opened'
	    };
	    return _this;
	  }
	
	  _createClass(DiamondResults, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	
	    // getDiamondDrawing(diamond) {
	    //   switch(diamond.shape) {
	    //     case 'Round':
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/round.svg';
	    //     case 'Pear':
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/pear.svg';
	    //     case 'Heart':
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/pear.svg';
	    //     case 'Oval':
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/round.svg';
	    //     case 'Cushion':
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/cushion.svg';
	    //     case 'Emerald':
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/emerald_1.svg';
	    //     case 'Radiant':
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/radiant.svg';
	    //     case 'Marquise':
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/round.svg';
	    //     case 'Asscher':
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/asscher.svg';
	    //     case 'Princess':
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/princess.svg';
	    //     default:
	    //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/round.svg';      
	    //   }
	    // }
	
	  }, {
	    key: 'scrollTop',
	    value: function scrollTop() {
	      (0, _reactScrollToComponent2.default)(this.topSection, {
	        offset: 0,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	      this.setState({ upperTabSelected: 'best' });
	    }
	  }, {
	    key: 'scrollCompare',
	    value: function scrollCompare() {
	      (0, _reactScrollToComponent2.default)(this.topSection, {
	        offset: 0,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	      this.setState({ upperTabSelected: 'picks' });
	    }
	  }, {
	    key: 'getFavesLength',
	    value: function getFavesLength() {
	      return this.props.product.compareDiamonds.length.toString();
	    }
	  }, {
	    key: 'selectDiamond',
	    value: function selectDiamond(diamond) {
	      this.props.productSelectDiamond(diamond);
	    }
	  }, {
	    key: 'isDiamondSelected',
	    value: function isDiamondSelected() {
	      return this.props.product.selectedDiamond !== null;
	    }
	  }, {
	    key: 'selectUpperTab',
	    value: function selectUpperTab(tabVal) {
	      this.setState({ upperTabSelected: tabVal });
	    }
	  }, {
	    key: 'toggleNextSteps',
	    value: function toggleNextSteps() {
	      this.setState({ nextStepsOpen: !this.state.nextStepsOpen });
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart() {
	      var _this2 = this;
	
	      var shapeString = this.props.product.selectedDiamond.shape;
	
	      this.setState({ addingToCart: true });
	
	      this.props.cartAddDiamond(this.props.product.selectedDiamond.stockNo, this.props.product.selectedDiamond.price, shapeString.toLowerCase().trim(), (0, _formatting.diamondCartDesc)(this.props.product.selectedDiamond)).then(function (resp) {
	        console.log(resp);
	        _this2.externalNav('checkout/cart');
	      }).catch(function (errResp) {
	        _this2.setState({ addingToCart: false });
	      });
	    }
	  }, {
	    key: 'addSetting',
	    value: function addSetting() {
	      this.props.setParentMode('mixed');
	      // this.internalNav('gallery/engagement-rings');
	    }
	  }, {
	    key: 'scrollToResults',
	    value: function scrollToResults() {
	      if (!this.resultsSection) {
	        return;
	      }
	      (0, _reactScrollToComponent2.default)(this.resultsSection, {
	        offset: 0,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'toggleAssembled',
	    value: function toggleAssembled() {
	      var _this3 = this;
	
	      this.setState({
	        assembledOpen: !this.state.assembledOpen,
	        openedClass: ''
	      }, function () {
	        if (_this3.state.assembledOpen) {
	          setTimeout(function () {
	            _this3.setState({ openedClass: ' opened' });
	          }, 500);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this,
	          _context;
	
	      var RESULT_LIMIT = 24;
	
	      var dCount = 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DiamondResults', ref: function ref(div) {
	            _this4.topSection = div;
	          } },
	        _react2.default.createElement(_FloatingHeader.FloatingHeaderContainer, {
	          scrollTop: this.scrollTop.bind(this),
	          scrollCompare: this.scrollCompare.bind(this),
	          getFavesLength: this.getFavesLength.bind(this) }),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.assembledOpen ? 'assembledWrapper open ' + this.state.openedClass : 'assembledWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledToggle', onClick: this.toggleAssembled.bind(this) },
	            this.state.assembledOpen ? _react2.default.createElement(
	              'div',
	              { className: 'assembledToggleIcon' },
	              '\u2014'
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'assembledToggleIcon' },
	              '+'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledTabsWrapper desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this4.selectUpperTab('best');
	                } },
	              'Your Diamond'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this4.selectUpperTab('picks');
	                } },
	              'Compare Diamonds (',
	              this.getFavesLength(),
	              ' of 4)'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledTabsWrapper mobileOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this4.selectUpperTab('best');
	                } },
	              'Your Diamond'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this4.selectUpperTab('picks');
	                } },
	              'Compare'
	            )
	          ),
	          this.state.upperTabSelected == 'best' ? _react2.default.createElement(
	            'div',
	            { className: 'assembledPreview' },
	            _react2.default.createElement('div', { className: 'assembledVBR' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'assembledComponentWrapper fullWidth' },
	              this.isDiamondSelected() ? _react2.default.createElement(
	                'div',
	                { className: 'diamondComponentWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'diamondComponentImageWrapper' },
	                  _react2.default.createElement('img', { src: this.props.product.selectedDiamond.image })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'diamondComponentInfoWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'diamondInfoTitleRow' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'diamondInfoTitle' },
	                      (0, _formatting.diamondTitle)(this.props.product.selectedDiamond)
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'removeLink', onClick: function onClick() {
	                          return _this4.props.productSelectDiamond(null);
	                        } },
	                      'remove'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'diamondInfoCustomRow' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'diamondInfoPrice' },
	                      '$',
	                      this.props.product.selectedDiamond.price.toLocaleString()
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'priceNotice' },
	                      '(diamond\xA0\xA0only)'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'diamondInfoButtonRow' },
	                    this.state.addingToCart ? _react2.default.createElement(
	                      'div',
	                      { className: 'nextStepsInCart' },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                        '\xA0\xA0\xA0Adding to Cart'
	                      )
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'nextStepsWrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'nextStepsElement', onClick: this.toggleNextSteps.bind(this) },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'nextStepsHead' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'nextStepsLabel' },
	                            'Next Steps'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'nextStepsIcon' },
	                            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/down.svg' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: this.state.nextStepsOpen ? 'nextStepsBody open' : 'nextStepsBody' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'nextStepsBodyWrapper' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'nextStepsItem', onClick: function onClick() {
	                                  return _this4.addToCart();
	                                } },
	                              'Add to Cart'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'nextStepsItem', onClick: function onClick() {
	                                  return _this4.internalNav('diamond/' + _this4.props.product.selectedDiamond.id);
	                                } },
	                              'View Diamond'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'nextStepsItem', onClick: function onClick() {
	                                  return _this4.addSetting();
	                                } },
	                              'Add to Ring'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'nextStepsItem', onClick: function onClick() {
	                                  return _this4.internalNav('contact-us');
	                                } },
	                              'Request an Appointment'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'diamondMessageWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'diamondNullMessage' },
	                  'Choose a diamond below to get started!'
	                )
	              )
	            )
	          ) : _react2.default.createElement(_CompareProducts.CompareProductsContainer, { productType: 'diamond' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resultsWrapper', ref: function ref(div) {
	              _this4.resultsSection = div;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'resultTab selectedTab' },
	              'Diamond Results'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsBody', ref: function ref(div) {
	                _this4.resultsBody = div;
	              } },
	            _react2.default.createElement(_DiamondGrid.DiamondGridContainer, {
	              updateMethod: (_context = this.props).updateMethod.bind(_context),
	              scrollUp: this.scrollToResults.bind(this),
	              showSplashPage: (_context = this.props).showSplashPage.bind(_context),
	              openFilters: this.props.openFilters })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DiamondResults;
	}(_react2.default.Component);
	
	DiamondResults.propTypes = {
	  location: _react.PropTypes.object
	};
	DiamondResults.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = DiamondResults;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var DiamondResultsContainer = exports.DiamondResultsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(DiamondResults);

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FashionResultsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _data = __webpack_require__(74);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(42);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _ResultsControls = __webpack_require__(99);
	
	var _ResultsPagination = __webpack_require__(120);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var FashionResults = function (_React$Component) {
	  _inherits(FashionResults, _React$Component);
	
	  function FashionResults(props) {
	    _classCallCheck(this, FashionResults);
	
	    var _this = _possibleConstructorReturn(this, (FashionResults.__proto__ || Object.getPrototypeOf(FashionResults)).call(this, props));
	
	    _this.state = {
	      scrollPos: 0,
	      tabSelected: 'results'
	    };
	
	    // Bind event listeners
	    _this.getScrollPos = _this.getScrollPos.bind(_this);
	    return _this;
	  }
	
	  _createClass(FashionResults, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'getScrollPos',
	    value: function getScrollPos() {
	      this.setState({
	        scrollPos: window.pageYOffset
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(tabVal) {
	      this.setState({ tabSelected: tabVal });
	    }
	  }, {
	    key: 'getFavesLength',
	    value: function getFavesLength() {
	      return this.props.product.compareFashion.length.toString();
	    }
	  }, {
	    key: 'isFavoriteProduct',
	    value: function isFavoriteProduct(product) {
	      if (!product) {
	        return false;
	      }
	
	      for (var i = 0; i < this.props.product.compareFashion.length; i++) {
	        if (this.props.product.compareFashion[i].sku == product.sku) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'toggleFavoriteProduct',
	    value: function toggleFavoriteProduct(product) {
	      if (this.isFavoriteProduct(product)) {
	        this.removeFavoriteProduct(product);
	      } else {
	        this.addFavoriteProduct(product);
	      }
	    }
	  }, {
	    key: 'addFavoriteProduct',
	    value: function addFavoriteProduct(product) {
	      var faves = (0, _data.cloneArray)(this.props.product.compareFashion);
	      if (faves.length >= 4) {
	        return;
	      }
	      faves.push(product);
	      this.props.productCompareFashion(faves);
	      // this.setState({ 
	      //   tabSelected: 'compare',
	      // });
	    }
	  }, {
	    key: 'removeFavoriteProduct',
	    value: function removeFavoriteProduct(product) {
	
	      var currentIndex = null;
	      var faves = (0, _data.cloneArray)(this.props.product.compareFashion);
	
	      if (this.props.product.compareFashion.length === 1) {
	        this.props.productCompareFashion([]);
	        return;
	      }
	
	      for (var i = 0; i < faves.length; i++) {
	        if (faves[i].sku == product.sku) {
	          currentIndex = i;
	          break;
	        }
	      }
	
	      faves.splice(currentIndex, 1);
	      this.props.productCompareFashion(faves);
	    }
	  }, {
	    key: 'renderFavorites',
	    value: function renderFavorites() {
	      var _this2 = this;
	
	      var faveItems = [null, null, null, null];
	      var noItems = false;
	
	      var selectedLength = this.props.product.compareFashion.length;
	      if (selectedLength === 0) {
	        noItems = true;
	      }
	      for (var i = 0; i < faveItems.length; i++) {
	        if (i < selectedLength) {
	          faveItems[i] = this.props.product.compareFashion[i];
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'favesWrapper' },
	        noItems ? _react2.default.createElement(
	          'div',
	          { className: 'noItemsMessage' },
	          'Select products to compare'
	        ) : null,
	        faveItems.map(function (item, k) {
	
	          if (item === null) {
	            return _this2.renderNullFave(k);
	          }
	          return _this2.renderBandFave(item, k);
	        })
	      );
	    }
	  }, {
	    key: 'renderNullFave',
	    value: function renderNullFave(idx) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'faveItem faveEmpty', key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'compareInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'compareNumber' },
	            idx + 1
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'heartSection' },
	          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/comparelogo.svg' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Compare your favorite fashion jewelry here!'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderBandFave',
	    value: function renderBandFave(product, idx) {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'faveItem faveProduct', key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'compareInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'compareNumber' },
	            idx + 1
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveRemove', onClick: function onClick() {
	              return _this3.removeFavoriteProduct(product);
	            } },
	          '\xD7'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveProductInner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'faveImg' },
	            _react2.default.createElement('img', { src: this.getProductMainImage(product) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveTitle' },
	            _react2.default.createElement(
	              'div',
	              null,
	              product.name.replace(/Ã©/g, 'é')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Total Carat Wt:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              product.ttw_dia,
	              ' Ct.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Metal Type:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              (0, _formatting.compareValue)(product.metal_type)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Gemstone:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              (0, _formatting.compareValue)(product.gemstone)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'favePrice' },
	            '$',
	            (0, _product.getMinPrice)(product).toLocaleString()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveAdd', onClick: function onClick() {
	                return _this3.internalNav('jewelry/' + product.sku);
	              } },
	            'View'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'prevPage',
	    value: function prevPage() {
	      this.props.productSetPage(parseInt(this.props.product.currentPage) - 1);
	      this.scrollToResults();
	    }
	  }, {
	    key: 'nextPage',
	    value: function nextPage() {
	      this.props.productSetPage(parseInt(this.props.product.currentPage) + 1);
	      this.scrollToResults();
	    }
	  }, {
	    key: 'setPage',
	    value: function setPage(pageNum) {
	      this.props.productSetPage(parseInt(pageNum));
	      this.scrollToResults();
	    }
	  }, {
	    key: 'scrollToResults',
	    value: function scrollToResults() {
	      if (!this.resultsSection) {
	        return;
	      }
	      (0, _reactScrollToComponent2.default)(this.resultsSection, {
	        offset: 0,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	      // return window.innerWidth <= 1024;
	      return false;
	    }
	  }, {
	    key: 'getPageCount',
	    value: function getPageCount() {
	      return this.props.showAd === false ? 24 : 23;
	    }
	  }, {
	    key: 'getFashionResults',
	    value: function getFashionResults() {
	
	      var AD_POSITION = 4;
	
	      var resultsArray = [];
	
	      if (!this.props.product.productResults || this.props.product.productResults.length === 0) {
	        return resultsArray;
	      }
	
	      for (var i = 0; i < this.props.product.productResults.length; i++) {
	
	        if (i >= this.getPageCount() * this.props.product.currentPage) {
	          break;
	        }
	
	        if (i < this.getPageCount() * (this.props.product.currentPage - 1)) {
	          continue;
	        }
	
	        if (this.props.showAd !== false && resultsArray.length == AD_POSITION) {
	          resultsArray.push({ sku: 'ad' });
	        }
	
	        resultsArray.push(this.props.product.productResults[i]);
	      }
	      return resultsArray;
	    }
	  }, {
	    key: 'renderProductAd',
	    value: function renderProductAd(keyNum) {
	      var _this4 = this;
	
	      var adClass = 'fashionRingAd';
	      var adHref = 'fashion-rings';
	      var adCopy = 'Browse Top Styles';
	      var adVariant = parseInt(this.props.product.currentPage) % 2 === 1 ? '1' : '2';
	
	      if (this.props.product && this.props.product.productFilters && this.props.product.productFilters.type && this.props.product.productFilters.type.includes('earring')) {
	        adClass = 'fashionEarringAd';
	        adHref = 'fashion-earrings';
	
	        if (adVariant === '2') {
	          adHref = 'diamond-studs';
	          adCopy = 'Shop Diamond Studs';
	        }
	      } else if (this.props.product && this.props.product.productFilters && this.props.product.productFilters.type && this.props.product.productFilters.type.includes('necklace')) {
	        adClass = 'fashionNecklaceAd';
	        adHref = 'fashion-necklaces';
	
	        if (adVariant === '2') {
	          adHref = 'diamond-pendants';
	          adCopy = 'Shop Diamond Pendants';
	        }
	      } else if (this.props.product && this.props.product.productFilters && this.props.product.productFilters.type && this.props.product.productFilters.type.includes('bracelet')) {
	        adClass = 'fashionBraceletAd';
	
	        adHref = 'diamond-bracelets';
	        adCopy = 'Shop Tennis Bracelets';
	
	        if (adVariant === '2') {
	          adHref = 'fashion-bracelets';
	          adCopy = 'Browse Top Styles';
	        }
	      }
	
	      var compositClass = adClass + adVariant;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bandItem adBannerItem', key: keyNum, onClick: function onClick() {
	            return _this4.internalNav(adHref);
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'adInnerWrapper ' + compositClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'adPrompt' },
	            _react2.default.createElement(
	              'div',
	              null,
	              adCopy,
	              ' >'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var RESULT_LIMIT = 24;
	      var bCount = 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'FashionResults' },
	        _react2.default.createElement(
	          'div',
	          { className: 'labelSection', style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'labelTitle' },
	            'Featured Rings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resultsWrapper', ref: function ref(div) {
	              _this5.resultsSection = div;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'results' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this5.selectTab('results');
	                } },
	              'Results'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'compare' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this5.selectTab('compare');
	                } },
	              'Compare Jewelry (',
	              this.getFavesLength(),
	              ' of 4)'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper mobileOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'results' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this5.selectTab('results');
	                } },
	              'Results'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'compare' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this5.selectTab('compare');
	                } },
	              'Compare (',
	              this.getFavesLength(),
	              ' of 4)'
	            )
	          ),
	          this.state.tabSelected == 'results' ? _react2.default.createElement(
	            'div',
	            { className: 'resultsBody', ref: function ref(div) {
	                _this5.resultsBody = div;
	              } },
	            _react2.default.createElement(_ResultsControls.ResultsControlsContainer, {
	              resultCount: this.props.product.productResultsCount,
	              resultType: 'fashion',
	              openFilters: this.props.openFilters }),
	            _react2.default.createElement(
	              'div',
	              { className: 'resultItemsWrapper' },
	              this.props.product.productResults !== null ? _react2.default.createElement(
	                'div',
	                null,
	                this.props.product.productResults.length === 0 ? _react2.default.createElement(
	                  'div',
	                  { className: 'noResults' },
	                  'No results matching your search criteria.  Please adjust the filters and try again.'
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'resultsInternalWrapper' },
	                  this.getFashionResults().map(function (product, j) {
	
	                    // if(product.image_count === 0 || bCount >= RESULT_LIMIT * this.props.product.currentPage) {
	                    //   return null;
	                    // }
	
	                    // if(bCount < RESULT_LIMIT * (this.props.product.currentPage - 1)) {
	                    //   bCount++;
	                    //   return null;
	                    // }
	
	                    if (product.sku == 'ad') {
	                      return _this5.renderProductAd(j);
	                    }
	
	                    bCount++;
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: _this5.isFavoriteProduct(product) ? 'bandItem favProduct' : 'bandItem', key: j },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'productItemInnerWrapper' },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: '/jewelry/' + product.sku },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'diamondItemImgWrapper' },
	                            _react2.default.createElement('img', { src: _this5.getProductMainImage(product) })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'productItemTitle' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              product.name.replace(/Ã©/g, 'é')
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'diamondItemPrice' },
	                            '$',
	                            (0, _product.getMinPrice)(product).toLocaleString()
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'favSelectWrapper', onClick: function onClick() {
	                              return _this5.toggleFavoriteProduct(product);
	                            } },
	                          _this5.isFavoriteProduct(product) ? _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare_a.svg' }) : _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare.svg' })
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(_ResultsPagination.ResultsPaginationContainer, {
	                    pageNum: parseInt(this.props.product.currentPage),
	                    pageNext: this.nextPage.bind(this),
	                    pagePrev: this.prevPage.bind(this),
	                    setPage: this.setPage.bind(this),
	                    pageSize: this.getPageCount(),
	                    resultCount: bCount })
	                )
	              ) : _react2.default.createElement(_RhinoLoading2.default, null)
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'picksPreview' },
	            this.renderFavorites()
	          )
	        )
	      );
	    }
	  }]);
	
	  return FashionResults;
	}(_react2.default.Component);
	
	FashionResults.propTypes = {
	  location: _react.PropTypes.object
	};
	FashionResults.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = FashionResults;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var FashionResultsContainer = exports.FashionResultsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(FashionResults);

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MensJewelryResultsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _data = __webpack_require__(74);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(42);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _ResultsControls = __webpack_require__(99);
	
	var _ResultsPagination = __webpack_require__(120);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var MensJewelryResults = function (_React$Component) {
	  _inherits(MensJewelryResults, _React$Component);
	
	  function MensJewelryResults(props) {
	    _classCallCheck(this, MensJewelryResults);
	
	    var _this = _possibleConstructorReturn(this, (MensJewelryResults.__proto__ || Object.getPrototypeOf(MensJewelryResults)).call(this, props));
	
	    _this.state = {
	      scrollPos: 0,
	      tabSelected: 'results'
	    };
	
	    // Bind event listeners
	    _this.getScrollPos = _this.getScrollPos.bind(_this);
	    return _this;
	  }
	
	  _createClass(MensJewelryResults, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.getScrollPos, false);
	    }
	  }, {
	    key: 'getScrollPos',
	    value: function getScrollPos() {
	      this.setState({
	        scrollPos: window.pageYOffset
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(tabVal) {
	      this.setState({ tabSelected: tabVal });
	    }
	  }, {
	    key: 'getFavesLength',
	    value: function getFavesLength() {
	      return this.props.product.compareFashion.length.toString();
	    }
	  }, {
	    key: 'isFavoriteProduct',
	    value: function isFavoriteProduct(product) {
	      if (!product) {
	        return false;
	      }
	
	      for (var i = 0; i < this.props.product.compareFashion.length; i++) {
	        if (this.props.product.compareFashion[i].sku == product.sku) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'toggleFavoriteProduct',
	    value: function toggleFavoriteProduct(product) {
	      if (this.isFavoriteProduct(product)) {
	        this.removeFavoriteProduct(product);
	      } else {
	        this.addFavoriteProduct(product);
	      }
	    }
	  }, {
	    key: 'addFavoriteProduct',
	    value: function addFavoriteProduct(product) {
	      var faves = (0, _data.cloneArray)(this.props.product.compareFashion);
	      if (faves.length >= 4) {
	        return;
	      }
	      faves.push(product);
	      this.props.productCompareFashion(faves);
	      // this.setState({ 
	      //   tabSelected: 'compare',
	      // });
	    }
	  }, {
	    key: 'removeFavoriteProduct',
	    value: function removeFavoriteProduct(product) {
	
	      var currentIndex = null;
	      var faves = (0, _data.cloneArray)(this.props.product.compareFashion);
	
	      if (this.props.product.compareFashion.length === 1) {
	        this.props.productCompareFashion([]);
	        return;
	      }
	
	      for (var i = 0; i < faves.length; i++) {
	        if (faves[i].sku == product.sku) {
	          currentIndex = i;
	          break;
	        }
	      }
	
	      faves.splice(currentIndex, 1);
	      this.props.productCompareFashion(faves);
	    }
	  }, {
	    key: 'renderFavorites',
	    value: function renderFavorites() {
	      var _this2 = this;
	
	      var faveItems = [null, null, null, null];
	      var noItems = false;
	
	      var selectedLength = this.props.product.compareFashion.length;
	      if (selectedLength === 0) {
	        noItems = true;
	      }
	      for (var i = 0; i < faveItems.length; i++) {
	        if (i < selectedLength) {
	          faveItems[i] = this.props.product.compareFashion[i];
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'favesWrapper' },
	        noItems ? _react2.default.createElement(
	          'div',
	          { className: 'noItemsMessage' },
	          'Select products to compare'
	        ) : null,
	        faveItems.map(function (item, k) {
	
	          if (item === null) {
	            return _this2.renderNullFave(k);
	          }
	          return _this2.renderBandFave(item, k);
	        })
	      );
	    }
	  }, {
	    key: 'renderNullFave',
	    value: function renderNullFave(idx) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'faveItem faveEmpty', key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'compareInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'compareNumber' },
	            idx + 1
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'heartSection' },
	          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/comparelogo.svg' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Compare your favorite men\'s jewelry here!'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderBandFave',
	    value: function renderBandFave(product, idx) {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'faveItem faveProduct', key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'compareInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'compareNumber' },
	            idx + 1
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveRemove', onClick: function onClick() {
	              return _this3.removeFavoriteProduct(product);
	            } },
	          '\xD7'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faveProductInner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'faveImg' },
	            _react2.default.createElement('img', { src: this.getProductMainImage(product) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveTitle' },
	            _react2.default.createElement(
	              'div',
	              null,
	              product.name.replace(/Ã©/g, 'é')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Total Carat Wt:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              product.ttw_dia,
	              ' Ct.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow', style: { display: 'none' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Metal Type:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              (0, _formatting.compareValue)(product.metal_type)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveDataRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataLabel' },
	              'Gemstone:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'faveDataValue EllipsisElement' },
	              (0, _formatting.compareValue)(product.gemstone)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'favePrice' },
	            '$',
	            (0, _product.getMinPrice)(product).toLocaleString()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'faveAdd', onClick: function onClick() {
	                return _this3.internalNav('jewelry/' + product.sku);
	              } },
	            'View'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'prevPage',
	    value: function prevPage() {
	      this.props.productSetPage(parseInt(this.props.product.currentPage) - 1);
	      this.scrollToResults();
	    }
	  }, {
	    key: 'nextPage',
	    value: function nextPage() {
	      this.props.productSetPage(parseInt(this.props.product.currentPage) + 1);
	      this.scrollToResults();
	    }
	  }, {
	    key: 'setPage',
	    value: function setPage(pageNum) {
	      this.props.productSetPage(parseInt(pageNum));
	      this.scrollToResults();
	    }
	  }, {
	    key: 'scrollToResults',
	    value: function scrollToResults() {
	      if (!this.resultsSection) {
	        return;
	      }
	      (0, _reactScrollToComponent2.default)(this.resultsSection, {
	        offset: 0,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	      // return window.innerWidth <= 1024;
	      return false;
	    }
	  }, {
	    key: 'getPageCount',
	    value: function getPageCount() {
	      return this.isMobile() ? 24 : 23;
	    }
	  }, {
	    key: 'getMensJewelryResults',
	    value: function getMensJewelryResults() {
	
	      var AD_POSITION = 4;
	
	      var resultsArray = [];
	
	      if (!this.props.product.productResults || this.props.product.productResults.length === 0) {
	        return resultsArray;
	      }
	
	      for (var i = 0; i < this.props.product.productResults.length; i++) {
	
	        if (i >= this.getPageCount() * this.props.product.currentPage) {
	          break;
	        }
	
	        if (i < this.getPageCount() * (this.props.product.currentPage - 1)) {
	          continue;
	        }
	
	        if (!this.isMobile() && resultsArray.length == AD_POSITION) {
	          resultsArray.push({ sku: 'ad' });
	        }
	
	        resultsArray.push(this.props.product.productResults[i]);
	      }
	      return resultsArray;
	    }
	  }, {
	    key: 'renderProductAd',
	    value: function renderProductAd(keyNum) {
	      var _this4 = this;
	
	      var adClass = 'fashionRingAd';
	      var adHref = 'fashion-rings';
	      var adCopy = 'Browse Top Styles';
	      var adVariant = parseInt(this.props.product.currentPage) % 2 === 1 ? '1' : '2';
	
	      if (this.props.product && this.props.product.productFilters && this.props.product.productFilters.type && this.props.product.productFilters.type.includes('earring')) {
	        adClass = 'fashionEarringAd';
	        adHref = 'fashion-earrings';
	
	        if (adVariant === '2') {
	          adHref = 'diamond-studs';
	          adCopy = 'Shop Diamond Studs';
	        }
	      } else if (this.props.product && this.props.product.productFilters && this.props.product.productFilters.type && this.props.product.productFilters.type.includes('necklace')) {
	        adClass = 'fashionNecklaceAd';
	        adHref = 'fashion-necklaces';
	
	        if (adVariant === '2') {
	          adHref = 'diamond-pendants';
	          adCopy = 'Shop Diamond Pendants';
	        }
	      } else if (this.props.product && this.props.product.productFilters && this.props.product.productFilters.type && this.props.product.productFilters.type.includes('bracelet')) {
	        adClass = 'fashionBraceletAd';
	
	        adHref = 'diamond-bracelets';
	        adCopy = 'Shop Tennis Bracelets';
	
	        if (adVariant === '2') {
	          adHref = 'fashion-bracelets';
	          adCopy = 'Browse Top Styles';
	        }
	      }
	
	      var compositClass = adClass + adVariant;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bandItem adBannerItem', key: keyNum, onClick: function onClick() {
	            return _this4.internalNav(adHref);
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'adInnerWrapper ' + compositClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'adPrompt' },
	            _react2.default.createElement(
	              'div',
	              null,
	              adCopy,
	              ' >'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var RESULT_LIMIT = 24;
	      var bCount = 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MensJewelryResults' },
	        _react2.default.createElement(
	          'div',
	          { className: 'labelSection', style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'labelTitle' },
	            'Featured Rings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resultsWrapper', ref: function ref(div) {
	              _this5.resultsSection = div;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'results' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this5.selectTab('results');
	                } },
	              'Results'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'compare' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this5.selectTab('compare');
	                } },
	              'Compare Jewelry (',
	              this.getFavesLength(),
	              ' of 4)'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper mobileOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'results' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this5.selectTab('results');
	                } },
	              'Results'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.tabSelected == 'compare' ? 'resultsTab selectedTab' : 'resultsTab', onClick: function onClick() {
	                  return _this5.selectTab('compare');
	                } },
	              'Compare (',
	              this.getFavesLength(),
	              ' of 4)'
	            )
	          ),
	          this.state.tabSelected == 'results' ? _react2.default.createElement(
	            'div',
	            { className: 'resultsBody', ref: function ref(div) {
	                _this5.resultsBody = div;
	              } },
	            _react2.default.createElement(_ResultsControls.ResultsControlsContainer, {
	              resultCount: this.props.product.productResultsCount,
	              resultType: 'fashion' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'resultItemsWrapper' },
	              this.props.product.productResults !== null ? _react2.default.createElement(
	                'div',
	                null,
	                this.props.product.productResults.length === 0 ? _react2.default.createElement(
	                  'div',
	                  { className: 'noResults' },
	                  'No results matching your search criteria.  Please adjust the filters and try again.'
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'resultsInternalWrapper' },
	                  this.getMensJewelryResults().map(function (product, j) {
	
	                    // if(product.image_count === 0 || bCount >= RESULT_LIMIT * this.props.product.currentPage) {
	                    //   return null;
	                    // }
	
	                    // if(bCount < RESULT_LIMIT * (this.props.product.currentPage - 1)) {
	                    //   bCount++;
	                    //   return null;
	                    // }
	
	                    if (product.sku == 'ad') {
	                      return _this5.renderProductAd(j);
	                    }
	
	                    bCount++;
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: _this5.isFavoriteProduct(product) ? 'bandItem favProduct' : 'bandItem', key: j },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'productItemInnerWrapper' },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: '/jewelry/' + product.sku },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'diamondItemImgWrapper' },
	                            _react2.default.createElement('img', { src: _this5.getProductMainImage(product) })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'productItemTitle' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              product.name.replace(/Ã©/g, 'é')
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'diamondItemPrice' },
	                            '$',
	                            (0, _product.getMinPrice)(product).toLocaleString()
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'favSelectWrapper', onClick: function onClick() {
	                              return _this5.toggleFavoriteProduct(product);
	                            } },
	                          _this5.isFavoriteProduct(product) ? _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare_a.svg' }) : _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare.svg' })
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(_ResultsPagination.ResultsPaginationContainer, {
	                    pageNum: parseInt(this.props.product.currentPage),
	                    pageNext: this.nextPage.bind(this),
	                    pagePrev: this.prevPage.bind(this),
	                    setPage: this.setPage.bind(this),
	                    pageSize: this.getPageCount(),
	                    resultCount: bCount })
	                )
	              ) : _react2.default.createElement(_RhinoLoading2.default, null)
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'picksPreview' },
	            this.renderFavorites()
	          )
	        )
	      );
	    }
	  }]);
	
	  return MensJewelryResults;
	}(_react2.default.Component);
	
	MensJewelryResults.propTypes = {
	  location: _react.PropTypes.object
	};
	MensJewelryResults.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = MensJewelryResults;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var MensJewelryResultsContainer = exports.MensJewelryResultsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(MensJewelryResults);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MixedResultsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _url = __webpack_require__(56);
	
	var _data = __webpack_require__(74);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(42);
	
	var _ringsizes = __webpack_require__(153);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _FloatingHeader = __webpack_require__(213);
	
	var _SettingGrid = __webpack_require__(315);
	
	var _DiamondGrid = __webpack_require__(314);
	
	var _CompareProducts = __webpack_require__(212);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators, productActionCreators);
	
	var MixedResults = function (_React$Component) {
	  _inherits(MixedResults, _React$Component);
	
	  function MixedResults(props) {
	    _classCallCheck(this, MixedResults);
	
	    var _this = _possibleConstructorReturn(this, (MixedResults.__proto__ || Object.getPrototypeOf(MixedResults)).call(this, props));
	
	    var ringLabel = [{
	      display: 'Size',
	      value: ''
	    }];
	
	    var urlData = (0, _url.getJsonFromUrl)();
	
	    _this.state = {
	      resultsDisplayType: urlData && urlData.tabtype && urlData.tabtype == 'setting' ? 'setting' : 'diamond',
	      upperTabSelected: 'best',
	
	      ringSizeData: ringLabel.concat(_ringsizes.ringSizes),
	
	      ringSize: _this.props.product && _this.props.product.attrSize ? _this.props.product.attrSize : '',
	      metalType: _this.props.product && _this.props.product.attrMetal ? _this.props.product.attrMetal : '',
	      validationMessage: '',
	
	      metalPriceDiff: 0,
	
	      hadTabUpdate: urlData && urlData.tabtype ? true : false,
	
	      addingToCart: false,
	
	      assembledOpen: true,
	
	      openedClass: ' opened'
	    };
	
	    // console.log('this.state');
	    // console.log(this.state);
	    return _this;
	  }
	
	  _createClass(MixedResults, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	
	      if (this.props.tabValue != prevProps.tabValue) {
	        if (this.props.tabValue != this.state.resultsDisplayType) {
	          this.setState({ resultsDisplayType: this.props.tabValue });
	        }
	      }
	
	      if (!this.state.hadTabUpdate) {
	        this.setState({
	          resultsDisplayType: this.props.tabValue,
	          hadTabUpdate: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getMetals',
	    value: function getMetals() {
	      if (!this.props.product.selectedSetting || !this.props.product.selectedSetting.price) {
	        return [];
	      }
	      return (0, _product.getMetalTypeChildDropdownData)(this.props.product.selectedSetting);
	    }
	  }, {
	    key: 'changeMetalType',
	    value: function changeMetalType(evt) {
	      var _this2 = this;
	
	      this.setState({
	        metalType: evt.target.value,
	        validationMessage: ''
	      }, function () {
	        _this2.props.productSelectSetting(_this2.props.product.selectedSetting, _this2.state.metalType, _this2.props.product.attrSize);
	      });
	    }
	  }, {
	    key: 'changeRingSize',
	    value: function changeRingSize(evt) {
	      var _this3 = this;
	
	      this.setState({
	        ringSize: evt.target.value,
	        validationMessage: ''
	      }, function () {
	        _this3.props.productSelectSetting(_this3.props.product.selectedSetting, _this3.props.product.attrMetal, _this3.state.ringSize);
	      });
	    }
	  }, {
	    key: 'selectDiamond',
	    value: function selectDiamond(diamond) {
	      this.props.productSelectDiamond(diamond);
	      this.setState({ upperTabSelected: 'best' });
	    }
	  }, {
	    key: 'isDiamondSelected',
	    value: function isDiamondSelected() {
	      return this.props.product.selectedDiamond !== null;
	    }
	  }, {
	    key: 'selectSetting',
	    value: function selectSetting(product) {
	      this.props.productSelectSetting(product);
	      this.setState({ upperTabSelected: 'best' });
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'isSettingSelected',
	    value: function isSettingSelected() {
	      return this.props.product.selectedSetting !== null;
	    }
	  }, {
	    key: 'setResultsDisplayType',
	    value: function setResultsDisplayType(displayValue) {
	
	      if (displayValue != this.state.resultsDisplayType) {
	        this.props.productSetPage(1);
	      }
	
	      this.setState({ resultsDisplayType: displayValue });
	    }
	  }, {
	    key: 'selectUpperTab',
	    value: function selectUpperTab(tabVal) {
	      this.setState({ upperTabSelected: tabVal });
	    }
	  }, {
	    key: 'getFavesLength',
	    value: function getFavesLength() {
	      if (this.state.resultsDisplayType == 'setting') {
	        return this.props.product.compareSettings.length.toString();
	      } else {
	        return this.props.product.compareDiamonds.length.toString();
	      }
	    }
	  }, {
	    key: 'getCombinedPrice',
	    value: function getCombinedPrice() {
	      if (this.props.product.selectedSetting && this.props.product.selectedDiamond) {
	        return this.getProductPrice() + this.props.product.selectedDiamond.price;
	      }
	      return '';
	    }
	  }, {
	    key: 'getMetalKarat',
	    value: function getMetalKarat(setting) {
	      if (!setting) {
	        return 14;
	      }
	      var setVal = setting.karat;
	      if (setting.attributes) {
	        setVal = setting.attributes.karat;
	      }
	      if (!setVal) {
	        setVal = 14;
	      }
	      return setVal;
	    }
	  }, {
	    key: 'scrollToSettings',
	    value: function scrollToSettings() {
	      if (!this.settingControlRow) {
	        return;
	      }
	      (0, _reactScrollToComponent2.default)(this.settingControlRow, {
	        offset: -200,
	        align: 'middle',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart() {
	      var _this4 = this;
	
	      if (!this.state.metalType) {
	        this.setState({ validationMessage: 'Please select a metal type' });
	        this.scrollToSettings();
	        return;
	      }
	
	      if (!this.state.ringSize) {
	        this.setState({ validationMessage: 'Please select a ring size' });
	        this.scrollToSettings();
	        return;
	      }
	
	      var markup = parseInt((0, _product.calcChildMetalMarkup)(this.props.product.selectedSetting, this.state.metalType));
	      var shapeString = this.props.product.selectedDiamond.shape;
	
	      this.setState({ addingToCart: true });
	
	      this.props.productFetchBySku(this.props.product.selectedSetting.sku).then(function (respData) {
	
	        _this4.props.cartAddEngagementRing(_this4.props.product.selectedSetting.sku, _this4.state.metalType, _this4.state.ringSize, _this4.getMetalKarat(_this4.props.product.selectedSetting), parseInt((0, _product.getMinPrice)(_this4.props.product.selectedSetting)) + markup, _this4.props.product.selectedDiamond.stockNo, shapeString.toLowerCase().trim(), _this4.props.product.selectedDiamond.price, (0, _formatting.settingCartDesc)(respData.success, _this4.state.metalType, _this4.state.ringSize), (0, _formatting.diamondCartDesc)(_this4.props.product.selectedDiamond)).then(function (resp) {
	          console.log(resp);
	          _this4.externalNav('checkout/cart');
	        }).catch(function (errResp) {
	          _this4.setState({ addingToCart: false });
	        });
	      }).catch(function (errResp) {
	        _this4.setState({ addingToCart: false });
	      });
	    }
	  }, {
	    key: 'getAssembledMessageContent',
	    value: function getAssembledMessageContent() {
	      if (!this.isDiamondSelected() && !this.isSettingSelected()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'assembledMessage' },
	          'Choose a diamond or setting to start building your ring.'
	        );
	      } else if (!this.isDiamondSelected() && this.isSettingSelected()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'assembledMessage' },
	          'Choose a diamond to complete your ring.'
	        );
	      } else if (this.isDiamondSelected() && !this.isSettingSelected()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'assembledMessage' },
	          'Choose a setting to complete your ring.'
	        );
	      } else if (this.isDiamondSelected() && this.isSettingSelected()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'assembledInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledMessage fullRing' },
	            'Your ' + this.props.product.selectedSetting.name + ' with ' + this.props.product.selectedDiamond.caratWeight + ' carat ' + this.props.product.selectedDiamond.shape + ' diamond'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledPrice' },
	            '$',
	            this.getCombinedPrice(),
	            '*'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'addToCartWrapper' },
	            this.state.addingToCart ? _react2.default.createElement(
	              'div',
	              { className: 'addButton mixedResultsButton' },
	              _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	              '\xA0\xA0\xA0Adding to Cart'
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'addButton mixedResultsButton', onClick: this.addToCart.bind(this) },
	              'Add to Cart'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledNotice' },
	            '*Total price may vary based on ring size or setting metal type.'
	          )
	        );
	      }
	    }
	  }, {
	    key: 'scrollToResults',
	    value: function scrollToResults() {
	      if (!this.resultsSection) {
	        return;
	      }
	      (0, _reactScrollToComponent2.default)(this.resultsSection, {
	        offset: -200,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'scrollDiamond',
	    value: function scrollDiamond() {
	      this.scrollToResults();
	      this.setState({ resultsDisplayType: 'diamond' });
	    }
	  }, {
	    key: 'scrollSetting',
	    value: function scrollSetting() {
	      this.scrollToResults();
	      this.setState({ resultsDisplayType: 'setting' });
	    }
	  }, {
	    key: 'scrollTop',
	    value: function scrollTop() {
	      (0, _reactScrollToComponent2.default)(this.topSection, {
	        offset: 0,
	        align: 'middle',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	      this.setState({ upperTabSelected: 'best' });
	    }
	  }, {
	    key: 'scrollCompare',
	    value: function scrollCompare() {
	      (0, _reactScrollToComponent2.default)(this.topSection, {
	        offset: 0,
	        align: 'middle',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	      this.setState({ upperTabSelected: 'picks' });
	    }
	  }, {
	    key: 'openFiltersScroll',
	    value: function openFiltersScroll() {
	      (0, _reactScrollToComponent2.default)(this.topSection, {
	        offset: 0,
	        align: 'middle',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	      this.props.openFilters();
	    }
	  }, {
	    key: 'getProductPrice',
	    value: function getProductPrice() {
	      if (!this.props.product.selectedSetting) {
	        return '';
	      }
	      return parseInt((0, _product.getMinPrice)(this.props.product.selectedSetting)) + parseInt((0, _product.calcChildMetalMarkup)(this.props.product.selectedSetting, this.state.metalType));
	      // return parseInt(this.props.product.selectedSetting.price);
	    }
	  }, {
	    key: 'toggleAssembled',
	    value: function toggleAssembled() {
	      var _this5 = this;
	
	      this.setState({
	        assembledOpen: !this.state.assembledOpen,
	        openedClass: ''
	      }, function () {
	        if (_this5.state.assembledOpen) {
	          setTimeout(function () {
	            _this5.setState({ openedClass: ' opened' });
	          }, 500);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this,
	          _context;
	
	      var RESULT_LIMIT = 24;
	
	      var pCount = 0;
	      var dCount = 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MixedResults' },
	        _react2.default.createElement(_FloatingHeader.FloatingHeaderContainer, {
	          scrollTop: this.scrollTop.bind(this),
	          scrollCompare: this.scrollCompare.bind(this),
	          getFavesLength: this.getFavesLength.bind(this) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'labelSection', ref: function ref(div) {
	              _this6.topSection = div;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'labelTitle', style: { display: 'none' } },
	            'Build Your Ring'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'labelText', style: { display: 'none' } },
	            'We\'ve taken your search criteria and created a ring that matches your style and budget.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.assembledOpen ? 'assembledWrapper open ' + this.state.openedClass : 'assembledWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledToggle', onClick: this.toggleAssembled.bind(this) },
	            this.state.assembledOpen ? _react2.default.createElement(
	              'div',
	              { className: 'assembledToggleIcon' },
	              '\u2014'
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'assembledToggleIcon' },
	              '+'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledTabsWrapper desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this6.selectUpperTab('best');
	                } },
	              'Create Your Ring'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this6.selectUpperTab('picks');
	                } },
	              this.state.resultsDisplayType == 'setting' ? 'Compare Settings' : 'Compare Diamonds',
	              ' (',
	              this.getFavesLength(),
	              ' of 4)'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledTabsWrapper mobileOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this6.selectUpperTab('best');
	                } },
	              'Your Ring'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this6.selectUpperTab('picks');
	                } },
	              'Compare'
	            )
	          ),
	          this.state.upperTabSelected == 'best' ? _react2.default.createElement(
	            'div',
	            { className: 'assembledPreview' },
	            _react2.default.createElement(
	              'div',
	              { className: 'assembledComponentWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'assembledImageWrapper smallViews' },
	                this.getAssembledMessageContent()
	              ),
	              this.isDiamondSelected() ? _react2.default.createElement(
	                'div',
	                { className: 'diamondComponentWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'diamondComponentImageWrapper' },
	                  _react2.default.createElement('img', { src: this.props.product.selectedDiamond.image })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'diamondComponentInfoWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'diamondInfoTitleRow' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'diamondInfoTitle' },
	                      (0, _formatting.diamondTitle)(this.props.product.selectedDiamond)
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'removeLink', onClick: function onClick() {
	                          return _this6.props.productSelectDiamond(null);
	                        } },
	                      'remove'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'diamondInfoCustomRow' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'diamondInfoPrice' },
	                      '$',
	                      this.props.product.selectedDiamond.price.toLocaleString()
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'diamondInfoPriceNotice' },
	                      '(diamond only)'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'diamondInfoButtonRow' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'assembledButton mixedResultsButton', onClick: function onClick() {
	                          return _this6.internalNav('diamond/' + _this6.props.product.selectedDiamond.id);
	                        } },
	                      'View'
	                    )
	                  )
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'diamondComponentWrapper nullElement' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'diamondComponentNullWrapper nullElement' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'diamondInfoTitleRow' },
	                    'Browse diamonds to create your unique ring!'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'scrollButton', onClick: this.scrollDiamond.bind(this) },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      'Browse Diamonds'
	                    )
	                  )
	                )
	              ),
	              this.isSettingSelected() ? _react2.default.createElement(
	                'div',
	                { className: 'settingComponentWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingComponentImageWrapper' },
	                  _react2.default.createElement('img', { src: this.getProductMainImage(this.props.product.selectedSetting) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingComponentInfoWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingInfoTitleRow' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'settingInfoTitle' },
	                      this.props.product.selectedSetting.name
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'removeLink', onClick: function onClick() {
	                          return _this6.props.productSelectSetting(null);
	                        } },
	                      'remove'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingInfoCustomRow' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'settingInfoPrice' },
	                      '$',
	                      this.getProductPrice()
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'settingInfoPriceNotice' },
	                      '(setting only)'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingInfoButtonRow', ref: function ref(div) {
	                        _this6.settingControlRow = div;
	                      } },
	                    this.state.validationMessage ? _react2.default.createElement(
	                      'div',
	                      { className: 'validationMessage' },
	                      this.state.validationMessage
	                    ) : null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'dropdownWrapper' },
	                      _react2.default.createElement(_RhinoSelect2.default, {
	                        options: this.getMetals(),
	                        value: this.state.metalType,
	                        changeMethod: this.changeMetalType.bind(this),
	                        rootClass: 'resultsSelect' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'dropdownWrapper' },
	                      _react2.default.createElement(_RhinoSelect2.default, {
	                        options: this.state.ringSizeData,
	                        value: this.state.ringSize,
	                        changeMethod: this.changeRingSize.bind(this),
	                        rootClass: 'resultsSelect' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'assembledButton mixedResultsButton', onClick: function onClick() {
	                          return _this6.internalNav('setting/' + _this6.props.product.selectedSetting.sku);
	                        } },
	                      'View'
	                    )
	                  )
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'settingComponentWrapper nullElement' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingComponentNullWrapper nullElement' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingInfoTitleRow' },
	                    'Browse settings to create your unique ring!'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'scrollButton', onClick: this.scrollSetting.bind(this) },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      'Browse Settings'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'assembledImageWrapper' },
	              this.getAssembledMessageContent()
	            )
	          ) : _react2.default.createElement(_CompareProducts.CompareProductsContainer, { productType: this.state.resultsDisplayType })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resultsWrapper', ref: function ref(div) {
	              _this6.resultsSection = div;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.resultsDisplayType == 'diamond' ? 'resultTab selectedTab' : 'resultTab', onClick: function onClick() {
	                  return _this6.setResultsDisplayType('diamond');
	                } },
	              'Diamond Results'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.resultsDisplayType == 'setting' ? 'resultTab selectedTab' : 'resultTab', onClick: function onClick() {
	                  return _this6.setResultsDisplayType('setting');
	                } },
	              'Setting Results'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper mobileOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.resultsDisplayType == 'diamond' ? 'resultTab selectedTab' : 'resultTab', onClick: function onClick() {
	                  return _this6.setResultsDisplayType('diamond');
	                } },
	              'Diamonds'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.resultsDisplayType == 'setting' ? 'resultTab selectedTab' : 'resultTab', onClick: function onClick() {
	                  return _this6.setResultsDisplayType('setting');
	                } },
	              'Settings'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsBody', ref: function ref(div) {
	                _this6.resultsBody = div;
	              } },
	            this.state.resultsDisplayType == 'setting' ? _react2.default.createElement(
	              'div',
	              { className: 'bodyLabel', style: { display: 'none' } },
	              'Choose a setting from the selection below to add to your selected ring:'
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'bodyLabel', style: { display: 'none' } },
	              'Choose a diamond from the selection below to add to your selected ring:'
	            ),
	            this.state.resultsDisplayType == 'setting' ? _react2.default.createElement(_SettingGrid.SettingGridContainer, {
	              updateMethod: (_context = this.props).updateMethod.bind(_context),
	              scrollUp: this.scrollToResults.bind(this),
	              showSplashPage: (_context = this.props).showSplashPage.bind(_context),
	              openFilters: this.props.openFilters }) : _react2.default.createElement(_DiamondGrid.DiamondGridContainer, {
	              updateMethod: (_context = this.props).updateMethod.bind(_context),
	              scrollUp: this.scrollToResults.bind(this),
	              showSplashPage: (_context = this.props).showSplashPage.bind(_context),
	              openFilters: this.props.openFilters })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MixedResults;
	}(_react2.default.Component);
	
	MixedResults.propTypes = {
	  location: _react.PropTypes.object
	};
	MixedResults.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = MixedResults;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var MixedResultsContainer = exports.MixedResultsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(MixedResults);

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SettingResultsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(42);
	
	var _ringsizes = __webpack_require__(153);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _ResultsControls = __webpack_require__(99);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	var _FloatingHeader = __webpack_require__(213);
	
	var _SettingGrid = __webpack_require__(315);
	
	var _CompareProducts = __webpack_require__(212);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators, productActionCreators);
	
	var SettingResults = function (_React$Component) {
	  _inherits(SettingResults, _React$Component);
	
	  function SettingResults(props) {
	    _classCallCheck(this, SettingResults);
	
	    var _this = _possibleConstructorReturn(this, (SettingResults.__proto__ || Object.getPrototypeOf(SettingResults)).call(this, props));
	
	    var ringLabel = [{
	      display: 'Size',
	      value: ''
	    }];
	
	    _this.state = {
	      upperTabSelected: 'best',
	      nextStepsOpen: false,
	
	      ringSizeData: ringLabel.concat(_ringsizes.ringSizes),
	
	      ringSize: _this.props.product && _this.props.product.attrSize ? _this.props.product.attrSize : '',
	      metalType: _this.props.product && _this.props.product.attrMetal ? _this.props.product.attrMetal : '',
	      validationMessage: '',
	      addingToCart: false,
	
	      assembledOpen: true,
	
	      openedClass: ' opened'
	    };
	    return _this;
	  }
	
	  _createClass(SettingResults, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'getMetals',
	    value: function getMetals() {
	      if (!this.props.product.selectedSetting || !this.props.product.selectedSetting.price) {
	        return [];
	      }
	      return (0, _product.getMetalTypeChildDropdownData)(this.props.product.selectedSetting);
	    }
	  }, {
	    key: 'changeMetalType',
	    value: function changeMetalType(evt) {
	      var _this2 = this;
	
	      this.setState({
	        metalType: evt.target.value,
	        validationMessage: ''
	      }, function () {
	        _this2.props.productSelectSetting(_this2.props.product.selectedSetting, _this2.state.metalType, _this2.props.product.attrSize);
	      });
	    }
	  }, {
	    key: 'changeRingSize',
	    value: function changeRingSize(evt) {
	      var _this3 = this;
	
	      this.setState({
	        ringSize: evt.target.value,
	        validationMessage: ''
	      }, function () {
	        _this3.props.productSelectSetting(_this3.props.product.selectedSetting, _this3.props.product.attrMetal, _this3.state.ringSize);
	      });
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'setResultsDisplayType',
	    value: function setResultsDisplayType(displayValue) {
	      this.setState({ resultsDisplayType: displayValue });
	    }
	  }, {
	    key: 'scrollTop',
	    value: function scrollTop() {
	      (0, _reactScrollToComponent2.default)(this.topSection, {
	        offset: 0,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	      this.setState({ upperTabSelected: 'best' });
	    }
	  }, {
	    key: 'scrollCompare',
	    value: function scrollCompare() {
	      (0, _reactScrollToComponent2.default)(this.topSection, {
	        offset: 0,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	      this.setState({ upperTabSelected: 'picks' });
	    }
	  }, {
	    key: 'getFavesLength',
	    value: function getFavesLength() {
	      return this.props.product.compareSettings.length.toString();
	    }
	  }, {
	    key: 'isSettingSelected',
	    value: function isSettingSelected() {
	      return this.props.product.selectedSetting !== null;
	    }
	  }, {
	    key: 'selectSetting',
	    value: function selectSetting(product) {
	      this.props.productSelectSetting(product);
	    }
	  }, {
	    key: 'selectUpperTab',
	    value: function selectUpperTab(tabVal) {
	      this.setState({ upperTabSelected: tabVal });
	    }
	  }, {
	    key: 'toggleNextSteps',
	    value: function toggleNextSteps() {
	      this.setState({ nextStepsOpen: !this.state.nextStepsOpen });
	    }
	  }, {
	    key: 'getMetalKarat',
	    value: function getMetalKarat(setting) {
	      if (!setting) {
	        return 14;
	      }
	      var setVal = setting.karat;
	      if (setting.attributes) {
	        setVal = setting.attributes.karat;
	      }
	      if (!setVal) {
	        setVal = 14;
	      }
	      return setVal;
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart() {
	      var _this4 = this;
	
	      if (!this.state.metalType) {
	        this.setState({ validationMessage: 'Please select a metal type' });
	        return;
	      }
	
	      if (!this.state.ringSize) {
	        this.setState({ validationMessage: 'Please select a ring size' });
	        return;
	      }
	
	      var markup = parseInt((0, _product.calcChildMetalMarkup)(this.props.product.selectedSetting, this.state.metalType));
	      var basePrice = (0, _product.getMinPrice)(this.props.product.selectedSetting);
	
	      this.setState({ addingToCart: true });
	
	      this.props.productFetchBySku(this.props.product.selectedSetting.sku).then(function (respData) {
	
	        _this4.props.cartAddMetalSize(_this4.props.product.selectedSetting.sku, _this4.state.metalType, _this4.state.ringSize, _this4.getMetalKarat(_this4.props.product.selectedSetting), markup, basePrice, (0, _formatting.settingCartDesc)(respData.success, _this4.state.metalType, _this4.state.ringSize)).then(function (resp) {
	          console.log(resp);
	          _this4.externalNav('checkout/cart');
	        }).catch(function (errResp) {
	          _this4.setState({ addingToCart: false });
	        });
	      }).catch(function (errResp) {
	        _this4.setState({ addingToCart: false });
	      });
	    }
	  }, {
	    key: 'addDiamond',
	    value: function addDiamond() {
	      this.props.setParentMode('mixed');
	      // this.internalNav('gallery/engagement-rings');
	    }
	  }, {
	    key: 'scrollToResults',
	    value: function scrollToResults() {
	      if (!this.resultsSection) {
	        return;
	      }
	      (0, _reactScrollToComponent2.default)(this.resultsSection, {
	        offset: 0,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'getProductPrice',
	    value: function getProductPrice() {
	      if (!this.props.product.selectedSetting) {
	        return '';
	      }
	      console.log(this.props.product.selectedSetting);
	      console.log(this.props.product.selectedSetting.price);
	      return parseInt((0, _product.getMinPrice)(this.props.product.selectedSetting)) + parseInt((0, _product.calcChildMetalMarkup)(this.props.product.selectedSetting, this.state.metalType));
	      // return parseInt(this.props.product.selectedSetting.price);
	    }
	  }, {
	    key: 'toggleAssembled',
	    value: function toggleAssembled() {
	      var _this5 = this;
	
	      this.setState({
	        assembledOpen: !this.state.assembledOpen,
	        openedClass: ''
	      }, function () {
	        if (_this5.state.assembledOpen) {
	          setTimeout(function () {
	            _this5.setState({ openedClass: ' opened' });
	          }, 500);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this,
	          _context;
	
	      var RESULT_LIMIT = 24;
	
	      var pCount = 0;
	      var dCount = 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'SettingResults', ref: function ref(div) {
	            _this6.topSection = div;
	          } },
	        _react2.default.createElement(_FloatingHeader.FloatingHeaderContainer, {
	          scrollTop: this.scrollTop.bind(this),
	          scrollCompare: this.scrollCompare.bind(this),
	          getFavesLength: this.getFavesLength.bind(this) }),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.assembledOpen ? 'assembledWrapper open ' + this.state.openedClass : 'assembledWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledToggle', onClick: this.toggleAssembled.bind(this) },
	            this.state.assembledOpen ? _react2.default.createElement(
	              'div',
	              { className: 'assembledToggleIcon' },
	              '\u2014'
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'assembledToggleIcon' },
	              '+'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledTabsWrapper desktopOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this6.selectUpperTab('best');
	                } },
	              'Your Setting'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this6.selectUpperTab('picks');
	                } },
	              'Compare Settings (',
	              this.getFavesLength(),
	              ' of 4)'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assembledTabsWrapper mobileOnly' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this6.selectUpperTab('best');
	                } },
	              'Your Setting'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab', onClick: function onClick() {
	                  return _this6.selectUpperTab('picks');
	                } },
	              'Compare'
	            )
	          ),
	          this.state.upperTabSelected == 'best' ? _react2.default.createElement(
	            'div',
	            { className: 'assembledPreview' },
	            _react2.default.createElement('div', { className: 'assembledVBR' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'assembledComponentWrapper fullWidth' },
	              this.isSettingSelected() ? _react2.default.createElement(
	                'div',
	                { className: 'settingComponentWrapper', style: { borderBottom: 'none' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingComponentImageWrapper' },
	                  _react2.default.createElement('img', { src: this.getProductMainImage(this.props.product.selectedSetting) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingComponentInfoWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingInfoTitleRow' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'settingInfoTitle' },
	                      this.props.product.selectedSetting.name
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'removeLink', onClick: function onClick() {
	                          return _this6.props.productSelectSetting(null);
	                        } },
	                      'remove'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingInfoCustomRow' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'settingInfoPrice' },
	                      '$',
	                      this.getProductPrice()
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'priceNotice' },
	                      '(setting\xA0\xA0only)'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingInfoCustomWrapper' },
	                    this.state.validationMessage ? _react2.default.createElement(
	                      'div',
	                      { className: 'configError' },
	                      this.state.validationMessage
	                    ) : null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'metalTypeOptions' },
	                      _react2.default.createElement(_RhinoSelect2.default, {
	                        options: this.getMetals(),
	                        value: this.state.metalType,
	                        changeMethod: this.changeMetalType.bind(this),
	                        rootClass: 'productSelect' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'ringSizeSelect' },
	                      _react2.default.createElement(_RhinoSelect2.default, {
	                        options: this.state.ringSizeData,
	                        value: this.state.ringSize,
	                        changeMethod: this.changeRingSize.bind(this),
	                        rootClass: 'productSelect' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingInfoButtonRow' },
	                    this.state.addingToCart ? _react2.default.createElement(
	                      'div',
	                      { className: 'nextStepsInCart' },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	                        '\xA0\xA0\xA0Adding to Cart'
	                      )
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'nextStepsWrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'nextStepsElement', onClick: this.toggleNextSteps.bind(this) },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'nextStepsHead' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'nextStepsLabel' },
	                            'Next Steps'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'nextStepsIcon' },
	                            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/down.svg' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: this.state.nextStepsOpen ? 'nextStepsBody open' : 'nextStepsBody' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'nextStepsBodyWrapper' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'nextStepsItem', onClick: function onClick() {
	                                  return _this6.addToCart();
	                                } },
	                              'Add to Cart'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'nextStepsItem', onClick: function onClick() {
	                                  return _this6.internalNav('setting/' + _this6.props.product.selectedSetting.sku);
	                                } },
	                              'View Setting'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'nextStepsItem', onClick: function onClick() {
	                                  return _this6.addDiamond();
	                                } },
	                              'Add to Ring'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'nextStepsItem', onClick: function onClick() {
	                                  return _this6.internalNav('contact-us');
	                                } },
	                              'Request an Appointment'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'settingMessageWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingNullMessage' },
	                  'Choose a setting below to get started!'
	                )
	              )
	            )
	          ) : _react2.default.createElement(_CompareProducts.CompareProductsContainer, { productType: 'setting' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resultsWrapper', ref: function ref(div) {
	              _this6.resultsSection = div;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'resultTab selectedTab' },
	              'Setting Results'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsBody', ref: function ref(div) {
	                _this6.resultsBody = div;
	              } },
	            _react2.default.createElement(_SettingGrid.SettingGridContainer, {
	              updateMethod: (_context = this.props).updateMethod.bind(_context),
	              scrollUp: this.scrollToResults.bind(this),
	              showSplashPage: (_context = this.props).showSplashPage.bind(_context),
	              openFilters: this.props.openFilters })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SettingResults;
	}(_react2.default.Component);
	
	SettingResults.propTypes = {
	  location: _react.PropTypes.object
	};
	SettingResults.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = SettingResults;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var SettingResultsContainer = exports.SettingResultsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(SettingResults);

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductGridContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _formatting = __webpack_require__(21);
	
	var _product = __webpack_require__(42);
	
	var _data = __webpack_require__(74);
	
	var _url = __webpack_require__(56);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _ResultsControls = __webpack_require__(99);
	
	var _ResultsPagination = __webpack_require__(120);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var ProductGrid = function (_React$Component) {
	  _inherits(ProductGrid, _React$Component);
	
	  function ProductGrid(props) {
	    _classCallCheck(this, ProductGrid);
	
	    // let urlData = getJsonFromUrl();
	    // let hasQuerystring = Object.entries(urlData).length > 0 && urlData.constructor === Object;
	
	    // let startingPage = '';
	    // if(hasQuerystring && urlData.p) {
	    //   startingPage = urlData.q;
	    // }
	
	
	    var _this = _possibleConstructorReturn(this, (ProductGrid.__proto__ || Object.getPrototypeOf(ProductGrid)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ProductGrid, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getProductMainImage',
	    value: function getProductMainImage(product) {
	      if (product.image_count > 0) {
	        return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
	      }
	    }
	  }, {
	    key: 'prevPage',
	    value: function prevPage() {
	      this.props.productSetPage(this.props.product.currentPage - 1);
	      this.props.scrollUp();
	    }
	  }, {
	    key: 'nextPage',
	    value: function nextPage() {
	      this.props.productSetPage(this.props.product.currentPage + 1);
	      this.props.scrollUp();
	    }
	  }, {
	    key: 'setPage',
	    value: function setPage(pageNum) {
	      this.props.productSetPage(parseInt(pageNum));
	      this.props.scrollUp();
	    }
	  }, {
	    key: 'getSearchQueryString',
	    value: function getSearchQueryString() {
	      if (!this.props.searchQuery) {
	        return '';
	      }
	
	      var pageVal = this.props.product.currentPage && this.props.product.currentPage > 1 ? '&p=' + this.props.product.currentPage : '';
	
	      return '?q=' + encodeURIComponent(this.props.searchQuery) + pageVal;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context,
	          _this2 = this;
	
	      var RESULT_LIMIT = 24;
	      var pCount = 0;
	
	      console.log(this.props.product.currentPage);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProductGrid' },
	        _react2.default.createElement(_ResultsControls.ResultsControlsContainer, {
	          resultCount: this.props.productCount,
	          resultType: 'generic',
	          updateMethod: (_context = this.props).updateMethod.bind(_context) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'resultItemsWrapper' },
	          !this.props.searchPending ? _react2.default.createElement(
	            'div',
	            null,
	            this.props.products.length === 0 ? _react2.default.createElement(
	              'div',
	              { className: 'resultItemsNoResults' },
	              'No jewelry found. Please adjust your search and try again.'
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              this.props.products.map(function (product, j) {
	
	                if (product.image_count === 0 || pCount >= RESULT_LIMIT * _this2.props.product.currentPage) {
	                  return null;
	                }
	
	                if (pCount < RESULT_LIMIT * (_this2.props.product.currentPage - 1)) {
	                  pCount++;
	                  return null;
	                }
	
	                pCount++;
	
	                if (product.product_type === 'diamond') {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'productBannerItem', key: j },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/diamond/' + product.id },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'productItemInnerWrapper' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'diamondItemImgWrapper' },
	                          _react2.default.createElement('img', { src: product.image })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'productItemTitle' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            (0, _formatting.diamondTitle)(product)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'diamondItemPrice' },
	                          '$',
	                          product.price.toLocaleString()
	                        )
	                      )
	                    )
	                  );
	                }
	
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'productBannerItem', key: j },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/' + (0, _product.getProductUrl)(product) + _this2.getSearchQueryString() },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'productItemInnerWrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'diamondItemImgWrapper' },
	                        _react2.default.createElement('img', { src: _this2.getProductMainImage(product) })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'productItemTitle' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          product.name.replace(/Ã©/g, 'é')
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'diamondItemPrice' },
	                        '$',
	                        (0, _product.getMinPrice)(product).toLocaleString()
	                      )
	                    )
	                  )
	                );
	              }),
	              _react2.default.createElement(_ResultsPagination.ResultsPaginationContainer, {
	                pageNum: parseInt(this.props.product.currentPage),
	                pageNext: this.nextPage.bind(this),
	                pagePrev: this.prevPage.bind(this),
	                setPage: this.setPage.bind(this),
	                pageSize: RESULT_LIMIT,
	                isSearchPage: true,
	                searchItems: this.props.products,
	                resultCount: pCount })
	            )
	          ) : _react2.default.createElement(_RhinoLoading2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return ProductGrid;
	}(_react2.default.Component);
	
	ProductGrid.propTypes = {
	  location: _react.PropTypes.object
	};
	ProductGrid.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductGrid;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product
	  };
	}
	
	var ProductGridContainer = exports.ProductGridContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductGrid);

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BraceletSplashContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var BraceletSplash = function (_React$Component) {
	  _inherits(BraceletSplash, _React$Component);
	
	  function BraceletSplash(props) {
	    _classCallCheck(this, BraceletSplash);
	
	    var _this = _possibleConstructorReturn(this, (BraceletSplash.__proto__ || Object.getPrototypeOf(BraceletSplash)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BraceletSplash, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'splashNav',
	    value: function splashNav(sku) {
	      this.internalNav('jewelry/' + sku);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'BraceletSplash' },
	        _react2.default.createElement(
	          'div',
	          { className: 'bsTitle' },
	          'Bracelets'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bsTop' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bsBox' },
	            _react2.default.createElement(
	              'div',
	              { className: 'bsBoxTitle' },
	              'Trendy Bangles'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'bsBoxCopy' },
	              'This fashion-forward Tacori bangle features two sky-blue topaz ovals in an open-concept design.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'bsBoxButtonWrapper' },
	              _react2.default.createElement(
	                'button',
	                { className: 'bsBoxButton', onClick: function onClick() {
	                    return _this2.splashNav('TACSS00087');
	                  } },
	                'Shop this Bracelet'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bsMid' },
	          _react2.default.createElement('div', { className: 'bsMidLeft' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'bsMidRight' },
	            _react2.default.createElement(
	              'div',
	              { className: 'bsMidImgWrapper' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bracelet/tennis.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'bsMidTitle' },
	              'Tennis Bracelets'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'bsMidCopy' },
	              'This bracelet provides ample sparkle on its own or can be stacked for a trendy look.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'bsMidButtonWrapper' },
	              _react2.default.createElement(
	                'button',
	                { className: 'bsBoxButton', onClick: function onClick() {
	                    return _this2.splashNav('TB20000325');
	                  } },
	                'Shop this Bracelet'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bsBottom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bsBottomLeft' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bracelet/pearls.png' }),
	            _react2.default.createElement(
	              'button',
	              { className: 'bsBoxButton bsButtonBottomLeft', onClick: function onClick() {
	                  return _this2.splashNav('PRLMS00397');
	                } },
	              'Shop this Bracelet'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bsBottomRight' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bracelet/diamond.png' }),
	            _react2.default.createElement(
	              'button',
	              { className: 'bsBoxButton bsButtonBottomRight', onClick: function onClick() {
	                  return _this2.splashNav('GBANG01774');
	                } },
	              'Shop this Bracelet'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BraceletSplash;
	}(_react2.default.Component);
	
	BraceletSplash.propTypes = {
	  location: _react.PropTypes.object
	};
	BraceletSplash.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = BraceletSplash;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var BraceletSplashContainer = exports.BraceletSplashContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(BraceletSplash);

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EarringSplashContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var EarringSplash = function (_React$Component) {
	  _inherits(EarringSplash, _React$Component);
	
	  function EarringSplash(props) {
	    _classCallCheck(this, EarringSplash);
	
	    var _this = _possibleConstructorReturn(this, (EarringSplash.__proto__ || Object.getPrototypeOf(EarringSplash)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(EarringSplash, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'splashNav',
	    value: function splashNav(sku) {
	      this.internalNav('jewelry/' + sku);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'EarringSplash' },
	        _react2.default.createElement(
	          'div',
	          { className: 'esTop' },
	          _react2.default.createElement(
	            'div',
	            { className: 'esTopRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'esItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/saphhoop.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemButtonWrapper' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'esItemButton', onClick: function onClick() {
	                      return _this2.splashNav('ECLST01656');
	                    } },
	                  'Shop this Earring'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'esItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/goldhoop.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemButtonWrapper' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'esItemButton', onClick: function onClick() {
	                      return _this2.splashNav('EHOOP03171');
	                    } },
	                  'Shop this Earring'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'esItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/diamondhoop.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemButtonWrapper' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'esItemButton', onClick: function onClick() {
	                      return _this2.splashNav('EHOOP01639');
	                    } },
	                  'Shop this Earring'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'esMid' },
	          _react2.default.createElement('div', { className: 'esMidLeft' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'esMidRight' },
	            _react2.default.createElement(
	              'div',
	              { className: 'esMidItemImg' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/butterfly.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'esMidItemTitle' },
	              'Diamond Accented Butterfly Studs'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'esMidItemCopy' },
	              'These nature-inspired butterfly studs sparkle with round brilliant diamonds.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'esMidItemButtonWrapper' },
	              _react2.default.createElement(
	                'button',
	                { className: 'esItemButton', onClick: function onClick() {
	                    return _this2.splashNav('EFAND12750');
	                  } },
	                'Shop this Earring'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'esBottom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'esBottomRow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'esItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/emerald.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemButtonWrapper' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'esItemButton', onClick: function onClick() {
	                      return _this2.splashNav('ECLST05118');
	                    } },
	                  'Shop this Earring'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'esItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/ruby.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemButtonWrapper' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'esItemButton', onClick: function onClick() {
	                      return _this2.splashNav('ECLST03032');
	                    } },
	                  'Shop this Earring'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'esItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/aqua.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'esItemButtonWrapper' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'esItemButton', onClick: function onClick() {
	                      return _this2.splashNav('TACSS00080');
	                    } },
	                  'Shop this Earring'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EarringSplash;
	}(_react2.default.Component);
	
	EarringSplash.propTypes = {
	  location: _react.PropTypes.object
	};
	EarringSplash.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = EarringSplash;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var EarringSplashContainer = exports.EarringSplashContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(EarringSplash);

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FashionSplashContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var FashionSplash = function (_React$Component) {
	  _inherits(FashionSplash, _React$Component);
	
	  function FashionSplash(props) {
	    _classCallCheck(this, FashionSplash);
	
	    var _this = _possibleConstructorReturn(this, (FashionSplash.__proto__ || Object.getPrototypeOf(FashionSplash)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(FashionSplash, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'FashionSplash' },
	        _react2.default.createElement(
	          'div',
	          { className: 'fsTitle' },
	          'Shop Your Style'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fsTopSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'fsBanner' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/top.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'itemWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'fashionItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'fashionItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/fash_rings.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'fashionItemButton' },
	                'Fashion Rings'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'fashionItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'fashionItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/fash_earring.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'fashionItemButton' },
	                'Fashion Earrings'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'fashionItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'fashionItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/fash_pendants.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'fashionItemButton' },
	                'Fashion Pendants'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fsMidSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'midCol1' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/studs.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'midCol2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'midPromptWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'promptBox promptMid' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptImg' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/studs_prod.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'promptWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptTitle' },
	                    'Diamond Studs'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptCopy' },
	                    'Diamond studs are a girl\'s best friend! Add elegant sparkle to any look. Perfect for everyday wear or a great gift for someone special.'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'promptButton' },
	                    'Shop Diamond Studs'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fsBottomSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bottomCol1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'smallItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'smallItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/am_chain.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'smallItemLabel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'itemName' },
	                  'Amethyst Chain Bracelet'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'itemPrice' },
	                  '$260'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'smallItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'smallItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/hoops.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'smallItemLabel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'itemName' },
	                  'Diamond Hoop Earrings'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'itemPrice' },
	                  '$3,020'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'smallItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'smallItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/pearl.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'smallItemLabel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'itemName' },
	                  'Pearl Cocktail Ring'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'itemPrice' },
	                  '$730'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'smallItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'smallItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bangle.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'smallItemLabel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'itemName' },
	                  'Diamond Bangle'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'itemPrice' },
	                  '$2,840'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bottomCol2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'largeItem' },
	              _react2.default.createElement(
	                'div',
	                { className: 'largeItemImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/large.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'smallItemLabel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'itemName' },
	                  'Bumble Bee Pendant'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'itemPrice' },
	                  '$1,320'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FashionSplash;
	}(_react2.default.Component);
	
	FashionSplash.propTypes = {
	  location: _react.PropTypes.object
	};
	FashionSplash.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = FashionSplash;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var FashionSplashContainer = exports.FashionSplashContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(FashionSplash);

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NecklaceSplashContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var NecklaceSplash = function (_React$Component) {
	  _inherits(NecklaceSplash, _React$Component);
	
	  function NecklaceSplash(props) {
	    _classCallCheck(this, NecklaceSplash);
	
	    var _this = _possibleConstructorReturn(this, (NecklaceSplash.__proto__ || Object.getPrototypeOf(NecklaceSplash)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(NecklaceSplash, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'splashNav',
	    value: function splashNav(sku) {
	      this.internalNav('jewelry/' + sku);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'NecklaceSplash' },
	        _react2.default.createElement(
	          'div',
	          { className: 'nsFloatingImg' },
	          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/layered.png' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'nsTitle' },
	          'Necklaces'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'nsTopSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'nsTopBg' },
	            _react2.default.createElement(
	              'div',
	              { className: 'nsTopBgImg1' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/layered.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'nsTopBgImg2' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/delicate.jpg' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'nsTopBlockOuterWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'nsTopBlock' },
	              _react2.default.createElement(
	                'div',
	                { className: 'nsTopBlockWrapper nsTopBlockWrapperLeft' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nsTopBlockTitle' },
	                  'LAYERED LOOKS'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nsTopBlockCopy' },
	                  'Make a statement with this sterling silver chain necklace showcasing a medley of blue topaz.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nsTopBlockButton', onClick: function onClick() {
	                      return _this2.splashNav('TACSS00065');
	                    } },
	                  'SHOP THIS NECKLACE'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'nsMobileInterloper' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/delicate.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'nsTopBlockOuterWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'nsTopBlock' },
	              _react2.default.createElement(
	                'div',
	                { className: 'nsTopBlockWrapper nsTopBlockWrapperRight' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nsTopBlockTitle' },
	                  'DELICATE PENDANTS'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nsTopBlockCopy' },
	                  'This stunning pendant features a beautiful pairing of diamonds and blue sapphires.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nsTopBlockButton', onClick: function onClick() {
	                      return _this2.splashNav('NCOST04895');
	                    } },
	                  'SHOP THIS NECKLACE'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'nsWeirdHangingOutImg' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/delicate.png' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'nsBottomSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'nsbLeft', onClick: function onClick() {
	                return _this2.splashNav('NFANC08317');
	              }, style: { curson: 'pointer' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'outerImg' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/floral.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'nsbLabel' },
	              'Floral Diamond Pendant'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'nsbMid', style: { curson: 'pointer' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'midImg', onClick: function onClick() {
	                  return _this2.splashNav('NFANC16283');
	                } },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/leaf.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'nsbLabel' },
	              'Diamond Leaf Necklace'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'midImg', onClick: function onClick() {
	                  return _this2.splashNav('NFANC15797');
	                }, style: { curson: 'pointer' } },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/cross.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'nsbLabel' },
	              'Diamond Cross Pendant'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'nsbRight', onClick: function onClick() {
	                return _this2.splashNav('PRL8N00053');
	              }, style: { curson: 'pointer' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'outerImg' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/pearl.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'nsbLabel' },
	              'Pearl Necklace'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NecklaceSplash;
	}(_react2.default.Component);
	
	NecklaceSplash.propTypes = {
	  location: _react.PropTypes.object
	};
	NecklaceSplash.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = NecklaceSplash;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var NecklaceSplashContainer = exports.NecklaceSplashContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(NecklaceSplash);

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RingSplashContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var RingSplash = function (_React$Component) {
	  _inherits(RingSplash, _React$Component);
	
	  function RingSplash(props) {
	    _classCallCheck(this, RingSplash);
	
	    var _this = _possibleConstructorReturn(this, (RingSplash.__proto__ || Object.getPrototypeOf(RingSplash)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(RingSplash, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'splashNav',
	    value: function splashNav(sku) {
	      this.internalNav('jewelry/' + sku);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RingSplash' },
	        _react2.default.createElement(
	          'div',
	          { className: 'rsTop' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rsTopWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rsTopTitle' },
	              'Fine Details'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'rsTopCopy' },
	              'A gorgeous Simon G. ring features swirls and milgrain detail with white and yellow diamonds.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'rsTopButtonWrapper' },
	              _react2.default.createElement(
	                'button',
	                { className: 'rsTopButton', onClick: function onClick() {
	                    return _this2.splashNav('BLDXL09226');
	                  } },
	                'Shop this Ring'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'rsMid rsMid1' },
	          _react2.default.createElement('div', { className: 'rsMidLeft rsMidImg' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'rsMidRight rsMidBody' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rsMidBodyWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rsMidBodyImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/statement.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'rsMidBodyTitle' },
	                'Statement Rings'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'rsMidBodyCopy' },
	                'This sterling silver Tacori ring features a bold blue topaz stone in a six prong setting.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'rsMidBodyButtonWrapper' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'rsMidBodyButton', onClick: function onClick() {
	                      return _this2.splashNav('TACSS00093');
	                    } },
	                  'Shop this Ring'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'rsMid rsMid2', style: { margin: '0' } },
	          _react2.default.createElement('div', { className: 'rsMidRight rsMidImg rsMidImgMobile' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'rsMidLeft rsMidBody' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rsMidBodyWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rsMidBodyImg' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/bands.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'rsMidBodyTitle' },
	                'Diamond Bands'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'rsMidBodyCopy' },
	                'A classic ring showcasing five clusters of dazzling round brilliant diamonds.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'rsMidBodyButtonWrapper' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'rsMidBodyButton', onClick: function onClick() {
	                      return _this2.splashNav('BLDXL06325');
	                    } },
	                  'Shop this Ring'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'rsMidRight rsMidImg rsMidImgDesktop' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'rsBottom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rsBottomWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rsBottomTitle' },
	              'Gemstone Rings'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'rsBottomCopy' },
	              'This ring is elegant and striking with an eye-catching pear shaped blue sapphire.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'rsBottomButtonWrapper' },
	              _react2.default.createElement(
	                'button',
	                { className: 'rsBottomButton', onClick: function onClick() {
	                    return _this2.splashNav('SAPPH02930');
	                  } },
	                'Shop this Ring'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RingSplash;
	}(_react2.default.Component);
	
	RingSplash.propTypes = {
	  location: _react.PropTypes.object
	};
	RingSplash.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = RingSplash;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var RingSplashContainer = exports.RingSplashContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(RingSplash);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactMailto = __webpack_require__(142);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	var _reactLazyLoadImageComponent = __webpack_require__(116);
	
	var _contacts = __webpack_require__(41);
	
	var _auth = __webpack_require__(88);
	
	var _Menu = __webpack_require__(559);
	
	var _MobileMenu = __webpack_require__(560);
	
	var _Login = __webpack_require__(557);
	
	var _Register = __webpack_require__(558);
	
	var _EarringAlert = __webpack_require__(485);
	
	var _EarringAlert2 = _interopRequireDefault(_EarringAlert);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _header = __webpack_require__(211);
	
	var headerActionCreators = _interopRequireWildcard(_header);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators, commonActionCreators, headerActionCreators, userActionCreators);
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.state = {
	      menuOpen: false,
	      searchOpen: false,
	      searchValue: '',
	      scrollPos: 0,
	      earringOpen: false,
	      displayRegister: false,
	      cartCount: null
	    };
	
	    // console.log(getGuestCart());
	    // if(!getGuestCart()) {
	    //   this.props.cartGuestCartId()
	    //   .then((response) => {
	    //     console.log(response);
	    //     saveGuestCart(response);
	    //   });
	    // }
	
	    // if(isLoggedIn()) {
	    _this.props.cartLoggedInItems().then(function (response) {
	
	      var respObj = JSON.parse(response);
	
	      if (respObj && respObj.success) {
	        _this.setState({ cartCount: parseInt(respObj.success.qty) });
	      }
	    });
	    // }
	
	    // Bind event listeners
	    _this.getScrollPos = _this.getScrollPos.bind(_this);
	    _this.checkLoginClick = _this.checkLoginClick.bind(_this);
	    _this.checkSliver = _this.checkSliver.bind(_this);
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('click', this.checkLoginClick, false);
	      window.addEventListener('scroll', this.getScrollPos, false);
	
	      this.checkId = setInterval(this.checkSliver, 100);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // if(prevProps.loginOpen === false && this.props.common.loginOpen === true) {
	
	      // }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.checkLoginClick, false);
	      window.removeEventListener('scroll', this.getScrollPos, false);
	
	      clearInterval(this.checkId);
	    }
	  }, {
	    key: 'checkSliver',
	    value: function checkSliver() {
	      if (this.firstSliver && window.location.href && window.location.href.includes('/gallery/')) {
	        this.firstSliver.style.display = 'flex';
	      } else {
	        if (this.firstSliver) {
	          this.firstSliver.style.display = 'none';
	        }
	      }
	      // if(this.secondSliver && window.location.href && window.location.href.includes('new-orleans')) {
	      //   this.secondSliver.style.display = 'flex';
	      // } else {
	      //   if(this.secondSliver) {
	      //     this.secondSliver.style.display = 'none';
	      //   }
	      // }
	      this.secondSliver.style.display = 'none';
	    }
	  }, {
	    key: 'checkLoginClick',
	    value: function checkLoginClick(evt) {
	
	      if (window.innerWidth <= 1024) {
	        return;
	      }
	
	      if (window.innerWidth - evt.clientX <= 360 && evt.clientY < 50) {
	        return;
	      }
	
	      if (this.props.common.loginOpen === true) {
	        var targetElement = evt.target;
	
	        do {
	          if (targetElement.className == 'loginInnerWrapper') {
	            return;
	          }
	
	          if (targetElement == this.loginBody) {
	            return;
	          }
	          targetElement = targetElement.parentNode;
	        } while (targetElement);
	
	        // This is a click outside, should close
	
	        // TODO add a timestamp so can't close instantaniously after opening
	
	        // this.props.commonCloseLogin();
	      }
	    }
	  }, {
	    key: 'getScrollPos',
	    value: function getScrollPos() {
	      this.setState({
	        scrollPos: window.pageYOffset
	      });
	    }
	  }, {
	    key: 'homeNav',
	    value: function homeNav() {
	      this.context.router.push('/');
	    }
	  }, {
	    key: 'userNav',
	    value: function userNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'giftGuideNav',
	    value: function giftGuideNav() {
	      window.location.href = 'https://gifts.diamondsdirect.com';
	    }
	  }, {
	    key: 'toggleMenu',
	    value: function toggleMenu() {
	      this.setState({ menuOpen: !this.state.menuOpen });
	    }
	  }, {
	    key: 'toggleSearch',
	    value: function toggleSearch() {
	      this.setState({ searchOpen: !this.state.searchOpen });
	    }
	  }, {
	    key: 'changeSearch',
	    value: function changeSearch(evt) {
	      this.setState({
	        searchValue: evt.target.value
	      });
	    }
	  }, {
	    key: 'keyPressSearch',
	    value: function keyPressSearch(evt) {
	      if (evt.key === 'Enter') {
	        this.submitSearch();
	      }
	    }
	  }, {
	    key: 'submitSearch',
	    value: function submitSearch() {
	      var _this2 = this;
	
	      if (this.state.searchValue !== '') {
	        this.userNav('diamonds-direct-search?p=init&q=' + this.state.searchValue);
	        this.setState({
	          searchOpen: false
	        }, function () {
	          setTimeout(function () {
	            _this2.setState({ searchValue: '' });
	          }, 500);
	        });
	      }
	    }
	  }, {
	    key: 'getHeaderClass',
	    value: function getHeaderClass() {
	      return this.state.scrollPos > 30 ? 'Header following' : 'Header';
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openContact',
	    value: function openContact() {
	      // this.props.commonOpenContact();
	      this.internalNav('contact-us');
	    }
	  }, {
	    key: 'openEarringAlert',
	    value: function openEarringAlert() {
	      var _this3 = this;
	
	      this.setState({ earringOpen: true }, function () {
	        console.log(_this3.state);
	      });
	    }
	  }, {
	    key: 'closeEarringAlert',
	    value: function closeEarringAlert() {
	      this.setState({ earringOpen: false });
	    }
	  }, {
	    key: 'openLogin',
	    value: function openLogin() {
	      this.props.commonOpenLogin();
	    }
	  }, {
	    key: 'toggleLoginType',
	    value: function toggleLoginType() {
	      console.log('toggly toggle');
	      this.setState({ displayRegister: !this.state.displayRegister });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this,
	          _context;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getHeaderClass() },
	        _react2.default.createElement(_Menu.MenuContainer, null),
	        _react2.default.createElement(_MobileMenu.MobileMenuContainer, null),
	        _react2.default.createElement(
	          'div',
	          {
	            className: this.props.common.loginOpen ? 'loginWrapper open' : 'loginWrapper', ref: function ref(div) {
	              _this4.loginBody = div;
	            } },
	          this.state.displayRegister ? _react2.default.createElement(_Register.RegisterContainer, { toggleMethod: this.toggleLoginType.bind(this) }) : _react2.default.createElement(_Login.LoginContainer, { toggleMethod: this.toggleLoginType.bind(this) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'lhs' },
	          _react2.default.createElement('div', { className: 'menuWrapper desktop1024', onClick: (_context = this.props).headerToggle.bind(_context) }),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobileMenu mobile1024', onClick: (_context = this.props).headerToggle.bind(_context) },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/header/mobile-menu.svg', alt: 'Menu' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'centerIcon', onClick: this.homeNav.bind(this) },
	          _react2.default.createElement(
	            'div',
	            { className: 'iconWrapper iconNoFollow' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { className: 'desktopIcon', src: 'https://ddw2.diamondsdirect.com/img/header/ddlogo.svg', alt: 'Diamonds Direct Logo' }),
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { className: 'mobileIcon', src: 'https://ddw2.diamondsdirect.com/img/header/ddicon.svg', alt: 'Diamonds Direct Logo' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconWrapper iconFollow' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/header/ddicon.svg', alt: 'Diamonds Direct Logo' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'rhs' },
	          _react2.default.createElement(
	            'div',
	            { className: 'smallLinkWrapper desktop1024' },
	            _react2.default.createElement(
	              'div',
	              { className: 'smallLink', onClick: this.openContact.bind(this) },
	              'Contact Us'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'smallLink', onClick: function onClick() {
	                  return _this4.internalNav('financing');
	                } },
	              'Financing'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'smallLink', onClick: function onClick() {
	                  return _this4.internalNav('locations');
	                }, style: { display: 'none' } },
	              'Locate a Store'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'smallLink', onClick: function onClick() {
	                  return _this4.internalNav('frequently-asked-questions');
	                } },
	              'FAQ'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'smallLink headerChat', onClick: this.openIntercom.bind(this) },
	              'Chat'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconLinkWrapper desktop1024' },
	            _react2.default.createElement(
	              'div',
	              { className: 'iconLink', onClick: function onClick() {
	                  return _this4.userNav('checkout/cart');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'iconImg cartImg' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/icons/header/cart.svg', alt: 'Shopping cart' }),
	                this.state.cartCount ? _react2.default.createElement(
	                  'div',
	                  { className: 'cartBubble' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    this.state.cartCount
	                  )
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Cart'
	              )
	            ),
	            (0, _auth.isLoggedIn)() ? _react2.default.createElement(
	              'div',
	              { className: 'iconLink', onClick: function onClick() {
	                  return _this4.internalNav('account');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'iconImg' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/icons/header/account.svg', alt: 'Account' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'My Account'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'iconLink', onClick: this.openLogin.bind(this) },
	              _react2.default.createElement(
	                'div',
	                { className: 'iconImg' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/icons/header/account.svg', alt: 'Account' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Log In'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'iconLink', onClick: this.toggleSearch.bind(this) },
	              _react2.default.createElement(
	                'div',
	                { className: 'iconImg' },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Search'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'iconLink', onClick: this.openIntercom.bind(this), style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'iconImg' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/header/chat.svg', alt: 'Chat' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'iconLabel' },
	                'Chat'
	              )
	            ),
	            _react2.default.createElement('div', { className: 'ggLink', onClick: this.giftGuideNav.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'giftIcon mobile1024', onClick: this.giftGuideNav.bind(this) },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/header/gift-guide/gg_box.svg', alt: 'Gift Guide' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'giftIcon mobile1024 mobileThird', onClick: this.toggleSearch.bind(this) },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/header/glass.png', alt: 'Search Diamonds Direct' })
	          ),
	          (0, _auth.isLoggedIn)() ? _react2.default.createElement(
	            'div',
	            { className: 'giftIcon mobile1024', onClick: function onClick() {
	                return _this4.internalNav('account');
	              }, style: { display: 'none' } },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/icons/header/account.svg', alt: 'Account' })
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'giftIcon mobile1024', onClick: this.openLogin.bind(this), style: { display: 'none' } },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/icons/header/account.svg', alt: 'Account' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'cartIcon mobile1024', onClick: function onClick() {
	                return _this4.userNav('checkout/cart');
	              } },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/icons/header/cart.svg', alt: 'Shopping cart' }),
	            this.state.cartCount ? _react2.default.createElement(
	              'div',
	              { className: 'cartBubble' },
	              _react2.default.createElement(
	                'div',
	                null,
	                this.state.cartCount
	              )
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.searchOpen ? 'open iconSearchWrapper' : 'iconSearchWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'iconSearch' },
	              _react2.default.createElement(
	                'div',
	                { className: 'inputWrapper' },
	                _react2.default.createElement('input', { type: 'text', onChange: this.changeSearch.bind(this), onKeyPress: this.keyPressSearch.bind(this), placeholder: 'Search Diamonds Direct' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actionWrapper', onClick: this.submitSearch.bind(this) },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'earringEventBanner', id: 'blackFridaySliverBanner', ref: function ref(div) {
	              _this4.firstSliver = div;
	            } },
	          _react2.default.createElement(
	            'span',
	            { style: { color: '#FFFFFF', textDecoration: 'none' }, onClick: this.openIntercom.bind(this) },
	            _react2.default.createElement(
	              'div',
	              { className: 'desktopMessage' },
	              'More inventory is available in our showrooms. ',
	              _react2.default.createElement(
	                'span',
	                { style: { textDecoration: 'underline', fontWeight: '700', marginLeft: '8px' } },
	                'Chat for details!'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileMessage' },
	              'More inventory is available in our showrooms. ',
	              _react2.default.createElement(
	                'span',
	                { style: { textDecoration: 'underline', fontWeight: '700', marginLeft: '8px' } },
	                'Chat for details!'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'earringEventBanner', id: 'blackFridaySliverBanner2', ref: function ref(div) {
	              _this4.secondSliver = div;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'desktopMessage' },
	            'Due to Hurricane Ida, our New Orleans showroom is closed. We are still available to help! See below.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobileMessage' },
	            'Due to Hurricane Ida, our New Orleans showroom is closed. We are still available to help!'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react2.default.Component);
	
	Header.propTypes = {
	  location: _react.PropTypes.object
	};
	Header.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Header;
	
	
	function mapStateToProps(state) {
	  return {
	    auth: state.auth,
	    common: state.common,
	    header: state.header
	  };
	}
	
	var HeaderContainer = exports.HeaderContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Header);

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeritageContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var Heritage = function (_React$Component) {
	  _inherits(Heritage, _React$Component);
	
	  function Heritage(props) {
	    _classCallCheck(this, Heritage);
	
	    var _this = _possibleConstructorReturn(this, (Heritage.__proto__ || Object.getPrototypeOf(Heritage)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Heritage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Our Heritage';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'nextSlide',
	    value: function nextSlide() {
	      this.sliderObject.slickNext();
	    }
	  }, {
	    key: 'prevSlide',
	    value: function prevSlide() {
	      this.sliderObject.slickPrev();
	    }
	  }, {
	    key: 'getSliderSettings',
	    value: function getSliderSettings() {
	      return {
	        dots: false,
	        infinite: true,
	        slidesToShow: 3,
	        slidesToScroll: 1,
	        autoplay: true,
	        speed: 500,
	        autoplaySpeed: 2500,
	        cssEase: "linear",
	        arrows: false,
	        adaptiveHeight: true
	      };
	    }
	  }, {
	    key: 'getMobileSliderSettings',
	    value: function getMobileSliderSettings() {
	      return {
	        dots: false,
	        infinite: true,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: true,
	        speed: 500,
	        autoplaySpeed: 2500,
	        cssEase: "linear",
	        arrows: false,
	        adaptiveHeight: true
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Heritage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'heritageSection desktopOnly' },
	          _react2.default.createElement(
	            'div',
	            { className: 'colsWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'heritageCol1' },
	              _react2.default.createElement('div', { className: 'heritageSpacer' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'hRingsWrapper' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/rings.png' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'quoteWrapper' },
	                '\u201CBuying a diamond is one of the biggest decisions of your life. We will eliminate all the confusion and pressure from this experience and guide you through this process to ensure you find the right diamond to love.\u201D'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'nameWrapper' },
	                '\u2014 Itay Berger, President'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'heritageCol2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'pageWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pageTitle' },
	                  'Our Heritage'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pageP' },
	                  'For decades, the diamond has been a symbol of love and commitment. The gift of diamond jewelry acts as a beautiful metaphor, setting your love in stone. It is timeless, steadfast and sparkles with the eternal flame of your love for one another. Love, passion, and commitment are the reasons we dedicated decades of diamond expertise into developing the Diamonds Direct experience.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pageBreak' },
	                  _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/heritage/svg/iconline.svg' }),
	                  _react2.default.createElement('img', { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/heritage/svg/iconline_m.svg' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pageP' },
	                  'Diamonds Direct began as a wholesale operation, based out of both Israel and the United States, that cut and sold diamonds to jewelry stores across the country. In 1995, we opened our first showroom and completely changed the landscape of fine jewelry retail by simply eliminating the middleman and selling diamonds directly to the end customer for far less than traditional jewelry stores.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pageBreak' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/svg/ringline.svg' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pageP' },
	                  'Our direct approach quickly made an impact on the jewelry industry because we paired these resources with superior guidance, education, and customer service. The Diamonds Direct experience is born from our signature approach to selection and customer service. Our mission to provide a no risk shopping environment endures today. We empower customers with diamond industry insights and products that are backed by our unmatched guarantees and warranties. We practice a personal approach while eliminating pressure and confusion during the diamond shopping experience, ensuring all customers have the opportunity to maximize their individual budget and make the best buying decision possible.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pageBreak' },
	                  _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/heritage/svg/usaline.svg' }),
	                  _react2.default.createElement('img', { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/heritage/svg/usaline_m.svg' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pageP' },
	                  'As word spread, our flagship location in Charlotte, NC began pulling customers from across the southeast. Today, Diamonds Direct and our family of companies are proud to serve customers across the United States. At Diamonds Direct our motivations are simple: our passion and commitment is fueled by our desire to help you demonstrate your love for that special someone. The heart of all that we do is centered around your love, and we\u2019re grateful you chose to celebrate that with us.'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'heritageSection heritageMobileSection mobileOnly' },
	          _react2.default.createElement(
	            'div',
	            { className: 'heritageMobBanner' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/banner_m.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pageWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pageTitle' },
	              'Our Heritage'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pageP' },
	              'For decades, the diamond has been a symbol of love and commitment. The gift of diamond jewelry acts as a beautiful metaphor, setting your love in stone. It is timeless, steadfast and sparkles with the eternal flame of your love for one another. Love, passion, and commitment are the reasons we dedicated decades of diamond expertise into developing the Diamonds Direct experience.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pageBreak' },
	              _react2.default.createElement('img', { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/heritage/svg/iconline_m.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pageP' },
	              'Diamonds Direct began as a wholesale operation, based out of both Israel and the United States, that cut and sold diamonds to jewelry stores across the country. In 1995, we opened our first showroom and completely changed the landscape of fine jewelry retail by simply eliminating the middleman and selling diamonds directly to the end customer for far less than traditional jewelry stores.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hRingsWrapper' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/rings_m.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'noPageWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pageP' },
	              'Our direct approach quickly made an impact on the jewelry industry because we paired these resources with superior guidance, education, and customer service. The Diamonds Direct experience is born from our signature approach to selection and customer service. Our mission to provide a no risk shopping environment endures today. We empower customers with diamond industry insights and products that are backed by our unmatched guarantees and warranties. We practice a personal approach while eliminating pressure and confusion during the diamond shopping experience, ensuring all customers have the opportunity to maximize their individual budget and make the best buying decision possible.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pageBreak' },
	              _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/heritage/svg/usaline.svg' }),
	              _react2.default.createElement('img', { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/heritage/svg/usaline_m.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pageP' },
	              'As word spread, our flagship location in Charlotte, NC began pulling customers from across the southeast. Today, Diamonds Direct and our family of companies are proud to serve customers across the United States. At Diamonds Direct our motivations are simple: our passion and commitment is fueled by our desire to help you demonstrate your love for that special someone. The heart of all that we do is centered around your love, and we\u2019re grateful you chose to celebrate that with us.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobQuoteWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'quoteWrapper' },
	              '\u201CBuying a diamond is one of the biggest decisions of your life. We will eliminate all the confusion and pressure from this experience and guide you through this process to ensure you find the right diamond to love.\u201D'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'nameWrapper' },
	              '\u2014 Itay Berger, President'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'awardsSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'awardsTitle' },
	            'Our Awards'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'awardsWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'bannerLeft', onClick: this.prevSlide.bind(this) },
	              _react2.default.createElement('div', { className: 'leftArrow' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'bannerRight', onClick: this.nextSlide.bind(this) },
	              _react2.default.createElement('div', { className: 'rightArrow' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'desktopOnly' },
	              _react2.default.createElement(
	                _reactSlick2.default,
	                _extends({ ref: function ref(slider) {
	                    _this2.sliderObject = slider;
	                  } }, this.getSliderSettings()),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/best.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/mon/bestof.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/mon/cova2018.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/mon/fabulist.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/mon/finalist.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/2019-Best-of.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/2020_bobs_winner-3.png' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileOnly' },
	              _react2.default.createElement(
	                _reactSlick2.default,
	                _extends({ ref: function ref(slider) {
	                    _this2.sliderObject = slider;
	                  } }, this.getMobileSliderSettings()),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/best.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/mon/bestof.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/mon/cova2018.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/mon/fabulist.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/mon/finalist.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/2019-Best-of.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'awardItem rotatingBannerItem' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/heritage/new/2020_bobs_winner-3.png' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Heritage;
	}(_react2.default.Component);
	
	Heritage.propTypes = {
	  location: _react.PropTypes.object
	};
	Heritage.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Heritage;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var HeritageContainer = exports.HeritageContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Heritage);

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.HeroesContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Heroes = function (_React$Component) {
		_inherits(Heroes, _React$Component);
	
		function Heroes(props) {
			_classCallCheck(this, Heroes);
	
			var _this = _possibleConstructorReturn(this, (Heroes.__proto__ || Object.getPrototypeOf(Heroes)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(Heroes, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				document.title = 'Diamonds Direct Heroes in Uniform - Engagement Rings, Jewelry, and More';
				document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
			}
		}, {
			key: 'newTabNav',
			value: function newTabNav(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'userNav',
			value: function userNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'Heroes' },
					_react2.default.createElement(
						'div',
						{ className: 'blocksWrapper' },
						_react2.default.createElement('div', { className: 'imageBlock' }),
						_react2.default.createElement(
							'div',
							{ className: 'contentBlock' },
							_react2.default.createElement(
								'div',
								{ className: 'heroesTitle' },
								'Heroes in Uniform'
							),
							_react2.default.createElement(
								'div',
								{ className: 'heroesText', style: { marginBottom: '20px' } },
								'We invite you to take advantage of one of these exclusive offers:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'heroesSubtitle' },
								'15% Off*'
							),
							_react2.default.createElement(
								'div',
								{ className: 'heroesOr' },
								'or'
							),
							_react2.default.createElement(
								'div',
								{ className: 'heroesSubtitle' },
								'Special Financing for 3 Years with Approved Credit'
							),
							_react2.default.createElement(
								'div',
								{ className: 'heroesText' },
								'Active duty military and veterans, police, fire, paramedics and nurses are eligible to receive this promotion. To redeem this special offer:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'heroesText' },
								_react2.default.createElement(
									'span',
									{ className: 'textEm' },
									'In Store:'
								),
								' Present a valid, non-classified form of identification to your Diamond\xA0Expert.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'heroesText' },
								_react2.default.createElement(
									'span',
									{ className: 'textEm' },
									'Online:'
								),
								' Email ',
								_react2.default.createElement(
									'a',
									{ href: 'mailto:online@diamondsdirect.com' },
									'online@diamondsdirect.com'
								),
								' and we will respond with check-out instructions.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'heroesHandwriting' },
								'We thank our hometown heroes for',
								_react2.default.createElement('br', null),
								'your service and courage!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'hereosLegal' },
								'*This offer can\u2019t be combined with other offers or special financing. 15% off does not apply to certified diamonds or price protected designer lines. Deposit may be required on special orders.'
							)
						)
					)
				);
			}
		}]);
	
		return Heroes;
	}(_react2.default.Component);
	
	Heroes.propTypes = {
		location: _react.PropTypes.object
	};
	Heroes.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Heroes;
	
	
	function mapStateToProps(state) {
		return {
			header: state.header
		};
	}
	
	var HeroesContainer = exports.HeroesContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Heroes);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.HomeContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactLazyLoadImageComponent = __webpack_require__(116);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Home = function (_React$Component) {
		_inherits(Home, _React$Component);
	
		function Home(props) {
			_classCallCheck(this, Home);
	
			var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));
	
			_this.state = {
				discoverVideo: false
			};
			return _this;
		}
	
		_createClass(Home, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				document.title = 'Diamonds Direct - Engagement Rings, Jewelry, and More';
				document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				// setTimeout(() => {
				// 	this.props.commonNotify();
				// }, 1000);
			}
		}, {
			key: 'newTabNav',
			value: function newTabNav(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'userNav',
			value: function userNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'giftsNav',
			value: function giftsNav(page) {
				window.location.href = 'https://gifts.diamondsdirect.com';
			}
		}, {
			key: 'getDiscoverVideoClass',
			value: function getDiscoverVideoClass() {
				return this.state.discoverVideo ? 'videoElement watchVideo' : 'videoElement imgCover';
			}
		}, {
			key: 'ggEarringNav',
			value: function ggEarringNav() {
				window.location.href = 'https://gifts.diamondsdirect.com/';
			}
		}, {
			key: 'startVideo',
			value: function startVideo() {
				var _this2 = this;
	
				this.setState({
					discoverVideo: true
				}, function () {
					_this2.discover.play();
				});
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
	
			// <source src="https://s3.amazonaws.com/dd-website/img/home/videobannera.mp4" type="video/mp4" />
	
	
			// Hurricane Banner
			// <div className='hurricaneBanner'>
			// 		<div className='hurricaneContentWrapper'>
			// 			<div className='hurricaneInnerWrapper'>
			// 				<div>
			// 					Dear Customers, some of our locations may experience closures and/or delays this week due to Hurricane Florence. We are actively taking measures to ensure all staff and merchandise is secure during this time. Please also be aware that our shipping partner, FedEx, has released a nationwide bulletin warning of shipping delays across the Southeast due to the storm. We thank you for your trust and patience as we work through the challenges this storm may present. Our number one goal is your satisfaction and our team of diamond experts is prepared to answer all of your questions during this time. To inquire about store hours and orders placed instore, please visit our <span className='hurricaneStrong' onClick={() => {this.internalNav('locations')}}>locations page</span> and contact the store nearest you. For online orders, please utilize our <span className='hurricaneStrong' onClick={::this.openIntercom}>chat feature</span> or call <span className='hurricaneStrong' style={{cursor: 'default'}}><a href='tel:7047144626'>704-714-4626</a></span>. From all of us at Diamonds Direct, stay safe out there!
			// 				</div>
			// 			</div>
			// 		</div>
			// 	</div>
	
			// <div className='homeBanner'>
			// 	  <img className='desktop600' src='https://s3.amazonaws.com/dd-website/img/home/ca2018/homepage-b.jpg' />
			// 		<img className='mobile600' src='https://s3.amazonaws.com/dd-website/img/home/ca2018/homepage_mobile-b.jpg' />
			// 		<div className={'bannerOverlay caBannerOverlay desktop600'}>
			// 			<div className={'bannerButton caBannerButton'} onClick={() => this.userNav('locations')}>Visit Us</div>
			// 		</div>
			// 		<div className={'mobileBannerOverlay mobile600'}>
			// 			<div className={'bannerButton caBannerButton'} onClick={() => this.userNav('locations')}>Visit Us</div>
			// 		</div>
			// 	</div>
	
	
			// <div className={'mobileBannerOverlay mobile600'}>
			// 			<div className='bannerHeadline'>Your&nbsp;love.&nbsp; Our&nbsp;passion.</div>
			// 			<div className='bannerButton' onClick={() => this.userNav('catalogsearch/advanced/?a=1&prod_type=engagement&attr=&opt=&dsgnr_id=&prc_min=1&prc_max=20000&order_by=rnd&limit=12&pg_no=1&url_prod_type=&q=')}>Engagement Rings</div>
			// 		</div>
	
		}, {
			key: 'nextSlide',
			value: function nextSlide() {
				this.sliderObject.slickNext();
			}
		}, {
			key: 'prevSlide',
			value: function prevSlide() {
				this.sliderObject.slickPrev();
			}
		}, {
			key: 'renderRotatingBanner',
			value: function renderRotatingBanner() {
				var _this3 = this;
	
				var settings = {
					dots: false,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					speed: 500,
					autoplaySpeed: 5000,
					cssEase: "linear",
					arrows: false,
					adaptiveHeight: true
				};
	
				return _react2.default.createElement(
					'div',
					{ className: 'homeRotatingBanner' },
					_react2.default.createElement(
						'div',
						{ className: 'bannerLeft', onClick: this.prevSlide.bind(this) },
						_react2.default.createElement('div', { className: 'leftArrow' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'bannerRight', onClick: this.nextSlide.bind(this) },
						_react2.default.createElement('div', { className: 'rightArrow' })
					),
					_react2.default.createElement(
						_reactSlick2.default,
						_extends({ ref: function ref(slider) {
								_this3.sliderObject = slider;
							} }, settings),
						_react2.default.createElement(
							'div',
							{ className: 'homeBanner rotatingBannerItem', onClick: function onClick() {
									return _this3.internalNav('holiday');
								} },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/ee_homepage.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/ee_homepage_m.jpg' }),
							_react2.default.createElement(
								'div',
								{ className: 'promoBannerButton variant4', onClick: function onClick() {
										return _this3.internalNav('holiday');
									} },
								_react2.default.createElement(
									'div',
									null,
									'Shop Now'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'homeBanner rotatingBannerItem' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2022/decfi_homepage.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2022/decfi_homepage_m.jpg' }),
							_react2.default.createElement(
								'div',
								{ className: 'promoBannerButton', onClick: function onClick() {
										return _this3.internalNav('3yearfinancing');
									} },
								_react2.default.createElement(
									'div',
									null,
									'Learn More'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'homeBanner rotatingBannerItem' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex2.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex2_m.jpg' }),
							_react2.default.createElement(
								'div',
								{ className: 'promoBannerButton variant2', onClick: this.giftsNav.bind(this) },
								_react2.default.createElement(
									'div',
									null,
									'Shop Now'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'homeBanner rotatingBannerItem' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex_m.jpg' }),
							_react2.default.createElement(
								'div',
								{ className: 'promoBannerButton variant3', onClick: function onClick() {
										return _this3.internalNav('locations');
									} },
								_react2.default.createElement(
									'div',
									null,
									'Find a Location'
								)
							)
						)
					)
				);
			}
		}, {
			key: 'renderOldDefaultBanner',
			value: function renderOldDefaultBanner() {
				var _this4 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'homeBanner' },
					_react2.default.createElement(
						'video',
						{ className: 'desktop600', autoPlay: true, playsInline: true, muted: 'muted', loop: true, id: 'videobanner', ref: function ref(vid) {
								_this4.homeDesktop = vid;
							} },
						_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/home/dd_homepage_m2019.mp4', type: 'video/mp4' }),
						_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { className: 'desktop600', src: 'https://s3.amazonaws.com/dd-website/img/home/homepagebanner.jpg', alt: 'Diamonds Direct' })
					),
					_react2.default.createElement(
						'video',
						{ className: 'mobile600', autoPlay: true, playsInline: true, muted: 'muted', loop: true, id: 'videobanner', ref: function ref(vid) {
								_this4.homeMobile = vid;
							} },
						_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/home/dd_homepage_mobile_m2019.mp4', type: 'video/mp4' }),
						_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { className: 'mobile600', src: 'https://s3.amazonaws.com/dd-website/img/home/mobile_homepage.jpg', alt: 'Diamonds Direct' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'bannerOverlay desktop600' },
						_react2.default.createElement(
							'div',
							{ className: 'bannerHeadline' },
							'Your\xA0love.\xA0 Our\xA0passion.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'bannerButton', onClick: function onClick() {
									return _this4.internalNav('gallery/engagement-rings');
								} },
							'Engagement Rings'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'mobileBannerOverlay mobile600' },
						_react2.default.createElement(
							'div',
							{ className: 'bannerHeadline' },
							'Your\xA0love.\xA0 Our\xA0passion.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'bannerButton', onClick: function onClick() {
									return _this4.internalNav('gallery/engagement-rings');
								} },
							'Engagement Rings'
						)
					)
				);
			}
		}, {
			key: 'renderDefaultBanner',
			value: function renderDefaultBanner() {
				var _this5 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'homeBanner2 newBanner22' },
					_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { className: 'desktop600', src: 'https://s3.amazonaws.com/dd-website/img/home/homepage.jpg' }),
					_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { className: 'mobile600', src: 'https://s3.amazonaws.com/dd-website/img/home/homepage_m.jpg' }),
					_react2.default.createElement(
						'div',
						{ className: 'bannerOverlay desktop600' },
						_react2.default.createElement(
							'div',
							{ className: 'bannerButton', onClick: function onClick() {
									return _this5.internalNav('gallery/engagement-rings');
								} },
							_react2.default.createElement(
								'div',
								null,
								'Engagement Rings'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'mobileBannerOverlay mobile600' },
						_react2.default.createElement(
							'div',
							{ className: 'bannerButton', onClick: function onClick() {
									return _this5.internalNav('gallery/engagement-rings');
								} },
							_react2.default.createElement(
								'div',
								null,
								'Engagement Rings'
							)
						)
					)
				);
			}
		}, {
			key: 'renderValentines2019Banner',
			value: function renderValentines2019Banner() {
				var _this6 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'homeBanner' },
					_react2.default.createElement(
						'video',
						{ className: 'desktop600', autoPlay: true, playsInline: true, muted: 'muted', loop: true, id: 'videobanner', ref: function ref(vid) {
								_this6.homeDesktop = vid;
							} },
						_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/home/promo-banners/valentines2019/homepage.mp4', type: 'video/mp4' })
					),
					_react2.default.createElement(
						'video',
						{ className: 'mobile600', autoPlay: true, playsInline: true, muted: 'muted', loop: true, id: 'videobanner', ref: function ref(vid) {
								_this6.homeDesktop = vid;
							} },
						_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/home/promo-banners/valentines2019/homepage_mobile.mp4', type: 'video/mp4' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'valentinesBannerOverlay bannerOverlay desktop600' },
						_react2.default.createElement(
							'div',
							{ className: 'valentinesBannerButton', onClick: function onClick() {
									return _this6.userNav('valentinesday');
								} },
							'Learn More'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'valentinesBannerOverlay bannerOverlay mobile600' },
						_react2.default.createElement(
							'div',
							{ className: 'valentinesBannerButton', onClick: function onClick() {
									return _this6.userNav('valentinesday');
								} },
							'Learn More'
						)
					)
				);
			}
		}, {
			key: 'renderSpring2019Banner',
			value: function renderSpring2019Banner() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'homeBanner' },
					_react2.default.createElement(
						'video',
						{ className: 'desktop600', autoPlay: true, playsInline: true, muted: 'muted', loop: true, id: 'videobanner', ref: function ref(vid) {
								_this7.homeDesktop = vid;
							} },
						_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/home/promo-banners/spring2019/dd_spring_b.mp4', type: 'video/mp4' })
					),
					_react2.default.createElement(
						'video',
						{ className: 'mobile600', autoPlay: true, playsInline: true, muted: 'muted', loop: true, id: 'videobanner', ref: function ref(vid) {
								_this7.homeDesktop = vid;
							} },
						_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/home/promo-banners/spring2019/dd_spring_mobile_b.mp4', type: 'video/mp4' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'valentinesBannerOverlay bannerOverlay desktop600' },
						_react2.default.createElement(
							'div',
							{ className: 'valentinesBannerButton', onClick: function onClick() {
									return _this7.internalNav('spring');
								} },
							'Learn More'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'valentinesBannerOverlay bannerOverlay mobile600' },
						_react2.default.createElement(
							'div',
							{ className: 'valentinesBannerButton', onClick: function onClick() {
									return _this7.internalNav('spring');
								} },
							'Learn More'
						)
					)
				);
			}
		}, {
			key: 'renderMothers2019Banner',
			value: function renderMothers2019Banner() {
				var _this8 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'homeBanner' },
					_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/home/promo-banners/mothers2019/mday_homepage_a.jpg' }),
					_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/home/promo-banners/mothers2019/mday_homepage_mobile.jpg' }),
					_react2.default.createElement(
						'div',
						{ className: 'mothersBannerButton desktop600', onClick: function onClick() {
								return _this8.internalNav('mothersday');
							} },
						'Go to Financing Terms*'
					),
					_react2.default.createElement('div', { className: 'motherOverlay', onClick: function onClick() {
							return _this8.internalNav('mothersday');
						} })
				);
			}
		}, {
			key: 'renderSummer2019Banner',
			value: function renderSummer2019Banner() {
				var _this9 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'homeBanner' },
					_react2.default.createElement(
						'video',
						{ className: 'desktop600', autoPlay: true, playsInline: true, muted: 'muted', loop: true, id: 'videobanner', ref: function ref(vid) {
								_this9.homeDesktop = vid;
							} },
						_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/home/promo-banners/summer2019/summer_homepage2.mp4', type: 'video/mp4' })
					),
					_react2.default.createElement(
						'video',
						{ className: 'mobile600', autoPlay: true, playsInline: true, muted: 'muted', loop: true, id: 'videobanner', ref: function ref(vid) {
								_this9.homeDesktop = vid;
							} },
						_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/home/promo-banners/summer2019/summer_mobile_banner2.mp4', type: 'video/mp4' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'summerBannerOverlay bannerOverlay desktop600' },
						_react2.default.createElement(
							'div',
							{ className: 'summerBannerButton', onClick: function onClick() {
									return _this9.internalNav('summer');
								} },
							'Learn More'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'summerBannerOverlay bannerOverlay mobile600' },
						_react2.default.createElement(
							'div',
							{ className: 'summerBannerButton', onClick: function onClick() {
									return _this9.internalNav('summer');
								} },
							'Learn More'
						)
					)
				);
			}
		}, {
			key: 'renderFall2019Banner',
			value: function renderFall2019Banner() {
				var _this10 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'homeBanner' },
					_react2.default.createElement(
						'video',
						{ className: 'desktop600', autoPlay: true, playsInline: true, muted: 'muted', loop: true, id: 'videobanner', ref: function ref(vid) {
								_this10.homeDesktop = vid;
							} },
						_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/promopages/fall2019/home.mp4', type: 'video/mp4' })
					),
					_react2.default.createElement(
						'video',
						{ className: 'mobile600', autoPlay: true, playsInline: true, muted: 'muted', loop: true, id: 'videobanner', ref: function ref(vid) {
								_this10.homeDesktop = vid;
							} },
						_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/promopages/fall2019/home_mobile.mp4', type: 'video/mp4' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'fallBannerOverlay bannerOverlay desktop600' },
						_react2.default.createElement(
							'div',
							{ className: 'fallBannerButton', onClick: function onClick() {
									return _this10.internalNav('5yearfinancing');
								} },
							'*Go to Financing Terms'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'fallBannerOverlay bannerOverlay mobile600' },
						_react2.default.createElement(
							'div',
							{ className: 'fallBannerButton', onClick: function onClick() {
									return _this10.internalNav('5yearfinancing');
								} },
							'*Go to Financing Terms'
						)
					)
				);
			}
		}, {
			key: 'renderNoKidHungryBanner',
			value: function renderNoKidHungryBanner() {
				var _this11 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'homeBanner rotatingBannerItem' },
					_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/DD_nokid_banner_x.jpg' }),
					_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/DD_nokid_banner_x_m.jpg' }),
					_react2.default.createElement(
						'div',
						{ className: 'mothersBannerButton noKidBannerButton', onClick: function onClick() {
								return _this11.internalNav('no-kid-hungry');
							} },
						'Learn More'
					)
				);
			}
		}, {
			key: 'renderHoliday2022Banner',
			value: function renderHoliday2022Banner() {
				return _react2.default.createElement(
					'div',
					{ className: 'homeBanner rotatingBannerItem' },
					_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex2.jpg' }),
					_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex2_m.jpg' }),
					_react2.default.createElement(
						'div',
						{ className: 'promoBannerButton variant2', onClick: this.giftsNav.bind(this) },
						_react2.default.createElement(
							'div',
							null,
							'Shop Now'
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this12 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Home' },
					_react2.default.createElement('img', { src: 'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=content&pixid=7333a400-055a-4ea4-a1b7-835149f34435', width: '1', height: '1' }),
					_react2.default.createElement(
						'div',
						{ className: 'homePreBanner' },
						_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/home/prebanner/pandorapencil_bg.jpg', alt: 'Pandora' }),
						_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/home/prebanner/pandorapencil_bgmobile.jpg', alt: 'Pandora' }),
						_react2.default.createElement(
							'div',
							{ className: 'preBannerOverlay' },
							_react2.default.createElement(
								'div',
								{ className: 'desktopOnly preBannerContent', onClick: function onClick() {
										return _this12.newTabNav('http://pandora.com/DiamondsDirect');
									} },
								'Listen to Winter Wonderland by Diamonds Direct on \xA0',
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/home/prebanner/Pandora_2016_logo.svg' }),
								' and jingle while you shop! \xA0',
								_react2.default.createElement(
									'span',
									{ className: 'listenLink' },
									'Listen Now'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'mobileOnly preBannerContent', onClick: function onClick() {
										return _this12.newTabNav('http://pandora.com/DiamondsDirect');
									} },
								_react2.default.createElement(
									'span',
									{ className: 'listenLink' },
									'Listen'
								),
								' to our Winter Wonderland station on \xA0',
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/home/prebanner/Pandora_2016_logo.svg' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						this.renderRotatingBanner()
					),
					_react2.default.createElement(
						'div',
						{ className: 'bestsellersWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'bestTitle' },
							'Gift earrings and save! This weekend only!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'bestItems' },
							_react2.default.createElement(
								'div',
								{ className: 'bestLHS' },
								_react2.default.createElement(
									'div',
									{ className: 'largeItemWrapper', onClick: function onClick() {
											return _this12.userNav('jewelry/EFAND20939');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'largeImg holidayImgLarge' },
										_react2.default.createElement(
											'div',
											{ className: 'largeScreen' },
											_react2.default.createElement(
												'div',
												{ className: 'largeScreenText' },
												_react2.default.createElement(
													'div',
													{ className: 'largeScreenTitle' },
													'Floating Diamond Chain Drop Earrings'
												),
												_react2.default.createElement(
													'div',
													{ className: 'largeScreenSubtitle' },
													'Starting at $1,250'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Floating Diamond Chain Drop Earrings'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Starting at $1,250'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'bestRHS' },
								_react2.default.createElement(
									'div',
									{ className: 'itemGridWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'smallItemRow' },
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('jewelry/EFAND17698');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg holidayImg1' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Diamond Quad Stud Earrings'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Starting at $4,950'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Diamond Quad Stud Earrings'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Starting at $4,950'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('jewelry/EFAND19614');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg holidayImg2' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Diamond Paperclip Link Earrings'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Starting at $2,750'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Diamond Paperclip Link Earrings'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Starting at $2,750'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'smallItemRow' },
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('jewelry/EFAND17563');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg holidayImg3' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Graduated Seven Stone Earrings'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Starting at $2,650'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Graduated Seven Stone Earrings'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Starting at $2,650'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('diamond-studs');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg holidayImg4' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Diamond Studs'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Starting at $380'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Diamond Studs'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Starting at $380'
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'bestMobile mobileOnly' },
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('jewelry/EFAND20939');
										} },
									_react2.default.createElement('div', { className: 'mobileImg holidayImgLarge' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Floating Diamond Chain Drop Earrings'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Starting at $1,250'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('jewelry/EFAND17698');
										} },
									_react2.default.createElement('div', { className: 'mobileImg holidayImg1' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Diamond Quad Stud Earrings'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Starting at $4,950'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('jewelry/EFAND19614');
										} },
									_react2.default.createElement('div', { className: 'mobileImg holidayImg2' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Diamond Paperclip Link Earrings'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Starting at $2,750'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('jewelry/EFAND17563');
										} },
									_react2.default.createElement('div', { className: 'mobileImg holidayImg3' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Graduated Seven Stone Earrings'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Starting at $2,650'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('diamond-studs');
										} },
									_react2.default.createElement('div', { className: 'mobileImg holidayImg4' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Diamond Studs'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Starting at $380'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'homeMidWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'sectionRow' },
							_react2.default.createElement(
								'div',
								{ className: 'rowImage imageLeft' },
								_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://s3.amazonaws.com/dd-website/img/influence/new1.png', alt: 'Shop Engagement' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'rowContent contentRight' },
								_react2.default.createElement(
									'div',
									{ className: 'contentWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'contentTitle' },
										'Love First'
									),
									_react2.default.createElement(
										'div',
										{ className: 'contentBody' },
										'Diamonds Direct is your source for lab-grown and natural diamonds this holiday season!'
									),
									_react2.default.createElement(
										'div',
										{ className: 'contentCTA', onClick: function onClick() {
												return _this12.internalNav('education/lab-grown');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'ctaLabel' },
											'Learn More'
										),
										_react2.default.createElement('div', { className: 'ctaUnderline ctaEngagement' })
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'sectionRow' },
							_react2.default.createElement(
								'div',
								{ className: 'rowImage imageRight' },
								_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://s3.amazonaws.com/dd-website/img/influence/new2.jpg', alt: 'Virtual appointments' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'rowContent contentLeft' },
								_react2.default.createElement(
									'div',
									{ className: 'contentWrapper videoChatWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'contentTitle' },
										'Appointments'
									),
									_react2.default.createElement(
										'div',
										{ className: 'contentBody' },
										'Need guidance? Our experts are here to help! Connect with an expert in-store or online.'
									),
									_react2.default.createElement(
										'div',
										{ className: 'contentCTA', onClick: function onClick() {
												return _this12.internalNav('contact-us');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'ctaLabel' },
											'Connect with an Expert'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'contentCTA' },
										_react2.default.createElement('div', { className: 'ctaUnderline ctaAppointment' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'contentCTA', onClick: function onClick() {
												return _this12.internalNav('video-chat');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'ctaLabel videoLabel' },
											'Video Chat Now'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'sectionRow' },
							_react2.default.createElement(
								'div',
								{ className: 'rowImage imageLeft' },
								_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://s3.amazonaws.com/dd-website/img/influence/holiday_influence.jpg', alt: 'Shop Influencer Jewelry Box' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'rowContent contentRight' },
								_react2.default.createElement(
									'div',
									{ className: 'contentWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'contentTitle' },
										'Influencer Jewelry Box'
									),
									_react2.default.createElement(
										'div',
										{ className: 'contentBody' },
										'Need inspiration? Browse influencer jewelry boxes for top holiday gift ideas.'
									),
									_react2.default.createElement(
										'div',
										{ className: 'contentCTA', onClick: function onClick() {
												return _this12.internalNav('jewelry-box');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'ctaLabel' },
											'Shop Influencer Jewelry Box'
										),
										_react2.default.createElement('div', { className: 'ctaUnderline ctaEngagement' })
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'bestsellersWrapper verragioBestsellers topBestsellers' },
						_react2.default.createElement(
							'div',
							{ className: 'bestTitle' },
							'Top Holiday Gifts'
						),
						_react2.default.createElement(
							'div',
							{ className: 'bestItems' },
							_react2.default.createElement(
								'div',
								{ className: 'bestLHS' },
								_react2.default.createElement(
									'div',
									{ className: 'largeItemWrapper', onClick: function onClick() {
											return _this12.userNav('setting/SMD1817108');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'largeImg novImgLarge' },
										_react2.default.createElement(
											'div',
											{ className: 'largeScreen' },
											_react2.default.createElement(
												'div',
												{ className: 'largeScreenText' },
												_react2.default.createElement(
													'div',
													{ className: 'largeScreenTitle' },
													'Vintage-Inspired Engagement Setting'
												),
												_react2.default.createElement(
													'div',
													{ className: 'largeScreenSubtitle' },
													'Priced at $1,650'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Vintage-Inspired Engagement Setting'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Priced at $1,650'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'bestRHS' },
								_react2.default.createElement(
									'div',
									{ className: 'itemGridWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'smallItemRow' },
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('jewelry/BLDMD19406');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg novImg1' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Single-Prong Diamond Band'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Starting at $1,430'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Single-Prong Diamond Band'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Starting at $1,430'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('jewelry/BLDSM20917');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg novImg2' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Milgrain Diamond Band'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Priced at $890'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Milgrain Diamond Band'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Priced at $890'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'smallItemRow' },
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('setting/SMD1463388');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg novImg3' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Marquise Halo Setting'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Priced at $2,060'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Marquise Halo Setting'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Priced at $2,060'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('jewelry/BDSAP03625');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg novImg4' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Sapphire & Diamond Band'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Starting at $1,150'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Sapphire & Diamond Band'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Starting at $1,150'
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'bestMobile mobileOnly' },
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('setting/SMD1817108');
										} },
									_react2.default.createElement('div', { className: 'mobileImg novImgLarge' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Vintage-Inspired Engagement Setting'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Priced at $1,650'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('jewelry/BLDMD19406');
										} },
									_react2.default.createElement('div', { className: 'mobileImg novImg1' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Single-Prong Diamond Band'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Starting at $1,430'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('jewelry/BLDSM20917');
										} },
									_react2.default.createElement('div', { className: 'mobileImg novImg2' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Milgrain Diamond Band'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Priced at $890'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('setting/SMD1463388');
										} },
									_react2.default.createElement('div', { className: 'mobileImg novImg3' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Marquise Halo Setting'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Priced at $2,060'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('jewelry/BDSAP03625');
										} },
									_react2.default.createElement('div', { className: 'mobileImg novImg4' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Sapphire & Diamond Band'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Starting at $1,150'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'homeMidWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'sectionRow' },
							_react2.default.createElement(
								'div',
								{ className: 'rowImage imageRight' },
								_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://s3.amazonaws.com/dd-website/img/influence/new3.jpg', alt: 'Shop Fine Jewelry' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'rowContent contentLeft' },
								_react2.default.createElement(
									'div',
									{ className: 'contentWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'contentTitle' },
										'Celebrate Everything'
									),
									_react2.default.createElement(
										'div',
										{ className: 'contentBody' },
										'At Diamonds Direct, your love is our passion and we\u2019re dedicated to helping you find the perfect ring.'
									),
									_react2.default.createElement(
										'div',
										{ className: 'contentCTA', onClick: function onClick() {
												return _this12.internalNav('gallery/fine-jewelry?type=ring,earring,bracelet,necklace');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'ctaLabel' },
											'Shop Engagement'
										),
										_react2.default.createElement('div', { className: 'ctaUnderline ctaFashion' })
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'bestsellersWrapper verragioBestsellers', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'bestTitle' },
							'Now Trending: Vintage-Inspired Engagement Rings'
						),
						_react2.default.createElement(
							'div',
							{ className: 'bestItems' },
							_react2.default.createElement(
								'div',
								{ className: 'bestLHS' },
								_react2.default.createElement(
									'div',
									{ className: 'largeItemWrapper', onClick: function onClick() {
											return _this12.userNav('classique-engagement-ring-Z1836.html?qvw=1');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'largeImg novImgLarge' },
										_react2.default.createElement(
											'div',
											{ className: 'largeScreen' },
											_react2.default.createElement(
												'div',
												{ className: 'largeScreenText' },
												_react2.default.createElement(
													'div',
													{ className: 'largeScreenTitle' },
													'Classique Scalloped Milgrain Ring'
												),
												_react2.default.createElement(
													'div',
													{ className: 'largeScreenSubtitle' },
													'Priced at $970'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Classique Scalloped Milgrain Ring'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Priced at $970'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'bestRHS' },
								_react2.default.createElement(
									'div',
									{ className: 'itemGridWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'smallItemRow' },
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('simon-g-engagement-ring-TR529.html?qvw=1');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg novImg1' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Simon G. Pav\xE9 Swirl Ring'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Starting at $1,826'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Simon G. Pav\xE9 Swirl Ring'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Starting at $1,826'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('classique-engagement-ring-Z1737MM10X5.0Y4.html');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg novImg2' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Classique Milgrain Halo Ring'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Priced at $1,610'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Classique Milgrain Halo Ring'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Priced at $1,610'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'smallItemRow' },
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('classique-engagement-ring-Z1721EE8.0X6.0Y4.html');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg novImg3' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Classique Cluster Halo Ring'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Priced at $1,390'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Classique Cluster Halo Ring'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Priced at $1,390'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper', onClick: function onClick() {
													return _this12.userNav('sylvie-engagement-ring-S1132.html');
												} },
											_react2.default.createElement(
												'div',
												{ className: 'smallImg novImg4' },
												_react2.default.createElement(
													'div',
													{ className: 'smallScreen' },
													_react2.default.createElement(
														'div',
														{ className: 'smallScreenText' },
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenTitle' },
															'Sylvie Vintage Bezel Ring'
														),
														_react2.default.createElement(
															'div',
															{ className: 'smallScreenSubtitle' },
															'Starting at $2,750'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													'Sylvie Vintage Bezel Ring'
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													'Starting at $2,750'
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'bestMobile mobileOnly' },
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('classique-engagement-ring-Z1836.html?qvw=1');
										} },
									_react2.default.createElement('div', { className: 'mobileImg novImgLarge' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Classique Scalloped Milgrain Ring'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Priced at $970'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('simon-g-engagement-ring-TR529.html?qvw=1');
										} },
									_react2.default.createElement('div', { className: 'mobileImg novImg1' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Simon G. Pav\xE9 Swirl Ring'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Starting at $1,826'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('classique-engagement-ring-Z1737MM10X5.0Y4.html');
										} },
									_react2.default.createElement('div', { className: 'mobileImg novImg2' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Classique Milgrain Halo Ring'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Priced at $1,610'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('classique-engagement-ring-Z1721EE8.0X6.0Y4.html');
										} },
									_react2.default.createElement('div', { className: 'mobileImg novImg3' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Classique Cluster Halo Ring'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Priced at $1,390'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper', onClick: function onClick() {
											return _this12.userNav('sylvie-engagement-ring-S1132.html');
										} },
									_react2.default.createElement('div', { className: 'mobileImg novImg4' }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											'Sylvie Vintage Bezel Ring'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											'Starting at $2,750'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'storyWrapper', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: this.getDiscoverVideoClass() },
							_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://s3.amazonaws.com/dd-website/img/home/video_thumb.jpg', onClick: this.startVideo.bind(this), alt: 'Click to start video' }),
							_react2.default.createElement('div', { className: 'videoSprite', onClick: this.startVideo.bind(this) }),
							_react2.default.createElement(
								'video',
								{ controls: true, controlsList: 'nodownload', id: 'discovervideo', ref: function ref(vid) {
										_this12.discover = vid;
									} },
								_react2.default.createElement('source', { src: 'https://s3.amazonaws.com/dd-website/img/home/aboutuslbr.mp4', type: 'video/mp4' }),
								_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://s3.amazonaws.com/dd-website/img/home/video_thumb.jpg', alt: 'Click to start video' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'videoDescription' },
							_react2.default.createElement(
								'div',
								{ className: 'videoDescriptoinWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'videoDescriptoinTitle' },
									'Our Story'
								),
								_react2.default.createElement(
									'div',
									{ className: 'videoDescriptoinBody' },
									'No mere accessory, your jewelry is a statement to the world. With our unparalleled selection you are sure to find the perfect piece for you.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'videoDescriptoinCTA', onClick: function onClick() {
											return _this12.userNav('about-us');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'videoCtaLabel' },
										'Discover More'
									),
									_react2.default.createElement('div', { className: 'videoCtaUnderline videoCtaDiscover' })
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'bottomLinks', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'linkWrapper', onClick: function onClick() {
									return _this12.internalNav('heroes');
								} },
							_react2.default.createElement(
								'div',
								{ className: 'linkImgWrapper' },
								_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://s3.amazonaws.com/dd-website/img/home/military.jpg', alt: 'Military Discount' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'linkLabelWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'linkLabelTitle' },
									'Military Discount'
								),
								_react2.default.createElement(
									'div',
									{ className: 'linkLabelBody' },
									'Special discount for military, police, fire, and paramedics.'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'linkWrapper', onClick: function onClick() {
									return _this12.userNav('appointments');
								} },
							_react2.default.createElement(
								'div',
								{ className: 'linkImgWrapper' },
								_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://s3.amazonaws.com/dd-website/img/home/appt_03.jpg', alt: 'Chat with an Expert' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'linkLabelWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'linkLabelTitle' },
									'Chat with an Expert'
								),
								_react2.default.createElement(
									'div',
									{ className: 'linkLabelBody' },
									'Make an appointment with a diamond expert for personalized care and assistance.'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'linkWrapper', onClick: function onClick() {
									return _this12.userNav('our-foundation');
								} },
							_react2.default.createElement(
								'div',
								{ className: 'linkImgWrapper' },
								_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://s3.amazonaws.com/dd-website/img/home/community.jpg', alt: 'Community Giving' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'linkLabelWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'linkLabelTitle' },
									'Community Giving'
								),
								_react2.default.createElement(
									'div',
									{ className: 'linkLabelBody' },
									'Giving back is at the heart of everything we do. Learn more about The Diamonds Direct Foundation.'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Home;
	}(_react2.default.Component);
	
	Home.propTypes = {
		location: _react.PropTypes.object
	};
	Home.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Home;
	
	
	function mapStateToProps(state) {
		return {
			header: state.header
		};
	}
	
	var HomeContainer = exports.HomeContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Home);

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfluencersContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var Influencers = function (_React$Component) {
	  _inherits(Influencers, _React$Component);
	
	  function Influencers(props) {
	    _classCallCheck(this, Influencers);
	
	    var _this = _possibleConstructorReturn(this, (Influencers.__proto__ || Object.getPrototypeOf(Influencers)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Influencers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Influencers' },
	        _react2.default.createElement(
	          'div',
	          { className: 'influencerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'influencersTitle' },
	            'Influencer Jewelry Box'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'influencerRow copyLeft' },
	            _react2.default.createElement('div', { className: 'influencerImg influencerBkb' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'influencerCopy' },
	              _react2.default.createElement(
	                'div',
	                { className: 'icWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icTitle' },
	                  'Brighton Keller Butler'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icHandle', onClick: function onClick() {
	                      return _this2.openNew('https://www.instagram.com/brightonbutler/');
	                    } },
	                  '@brightonbutler'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icLink', onClick: function onClick() {
	                      return _this2.internalNav('jewelry-box/brightonbutler');
	                    } },
	                  'See Brighton\'s Picks',
	                  _react2.default.createElement('span', { className: 'icLinkArrow' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'influencerRow copyRight' },
	            _react2.default.createElement('div', { className: 'influencerImg influencerCw' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'influencerCopy' },
	              _react2.default.createElement(
	                'div',
	                { className: 'icWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icTitle' },
	                  'Courtney Williams'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icHandle', onClick: function onClick() {
	                      return _this2.openNew('https://www.instagram.com/courtnwilliams/');
	                    } },
	                  '@courtnwilliams'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icLink', onClick: function onClick() {
	                      return _this2.internalNav('jewelry-box/courtnwilliams');
	                    } },
	                  'See Courtney\'s Picks',
	                  _react2.default.createElement('span', { className: 'icLinkArrow' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'influencerRow copyLeft' },
	            _react2.default.createElement('div', { className: 'influencerImg influencerJp' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'influencerCopy' },
	              _react2.default.createElement(
	                'div',
	                { className: 'icWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icTitle' },
	                  'Jennifer Palpallotoc Perrault'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icHandle', onClick: function onClick() {
	                      return _this2.openNew('https://www.instagram.com/hauteofftherack/');
	                    } },
	                  '@hauteofftherack'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icLink', onClick: function onClick() {
	                      return _this2.internalNav('jewelry-box/hauteofftherack');
	                    } },
	                  'See Jennifer\'s Picks',
	                  _react2.default.createElement('span', { className: 'icLinkArrow' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'influencerRow copyRight' },
	            _react2.default.createElement('div', { className: 'influencerImg influencerAa' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'influencerCopy' },
	              _react2.default.createElement(
	                'div',
	                { className: 'icWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icTitle' },
	                  'Aubrey Alley'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icHandle', onClick: function onClick() {
	                      return _this2.openNew('https://www.instagram.com/aubrey.alley/');
	                    } },
	                  '@aubrey.alley'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icLink', onClick: function onClick() {
	                      return _this2.internalNav('jewelry-box/aubreyalley');
	                    } },
	                  'See Aubrey\'s Picks',
	                  _react2.default.createElement('span', { className: 'icLinkArrow' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'influencerRow copyLeft' },
	            _react2.default.createElement('div', { className: 'influencerImg influencerMr' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'influencerCopy' },
	              _react2.default.createElement(
	                'div',
	                { className: 'icWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icTitle' },
	                  'Megan Runion'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icHandle', onClick: function onClick() {
	                      return _this2.openNew('https://www.instagram.com/meganrunionmcr/');
	                    } },
	                  '@meganrunionmcr'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icLink', onClick: function onClick() {
	                      return _this2.internalNav('jewelry-box/meganrunionmcr');
	                    } },
	                  'See Megan\'s Picks',
	                  _react2.default.createElement('span', { className: 'icLinkArrow' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Influencers;
	}(_react2.default.Component);
	
	Influencers.propTypes = {
	  location: _react.PropTypes.object
	};
	Influencers.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Influencers;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var InfluencersContainer = exports.InfluencersContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Influencers);

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfluenceAubreyalleyContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var InfluenceAubreyalley = function (_React$Component) {
	  _inherits(InfluenceAubreyalley, _React$Component);
	
	  function InfluenceAubreyalley(props) {
	    _classCallCheck(this, InfluenceAubreyalley);
	
	    var _this = _possibleConstructorReturn(this, (InfluenceAubreyalley.__proto__ || Object.getPrototypeOf(InfluenceAubreyalley)).call(this, props));
	
	    var firstEntryNotReq = [{ display: 'Location*', 'value': '' }];
	    var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	    var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
	    _this.state = {
	      locations: newArray,
	      inputName: '',
	      inputEmail: '',
	      inputPhone: '',
	      inputLocation: '',
	      inputMessage: '',
	      inputDesigner: '',
	      designerLocation: '',
	      errorName: null,
	      errorEmail: null,
	      errorPhone: null,
	      errorLocation: null,
	      errorMessage: null,
	      errorDesigner: null,
	      errorDesignerLocation: null
	    };
	    return _this;
	  }
	
	  _createClass(InfluenceAubreyalley, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'changeName',
	    value: function changeName(evt) {
	      var _this2 = this;
	
	      this.setState({ inputName: evt.target.value }, function () {
	        if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
	          _this2.setState({ errorName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      var _this3 = this;
	
	      this.setState({ inputEmail: evt.target.value }, function () {
	        if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
	          _this3.setState({ errorEmail: null });
	        }
	      });
	    }
	  }, {
	    key: 'changePhone',
	    value: function changePhone(evt) {
	      var _this4 = this;
	
	      this.setState({ inputPhone: evt.target.value }, function () {
	        if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
	          _this4.setState({ errorPhone: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeLocation',
	    value: function changeLocation(evt) {
	      var _this5 = this;
	
	      this.setState({ inputLocation: evt.target.value }, function () {
	        if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
	          _this5.setState({ errorLocation: null });
	        }
	      });
	    }
	  }, {
	    key: 'submitContactRequest',
	    value: function submitContactRequest() {
	      if (this.validateAll()) {
	
	        var contactData = {
	          full_name: this.state.inputName,
	          email: this.state.inputEmail,
	          phone: this.state.inputPhone,
	          location: this.state.inputLocation
	        };
	
	        console.log(this.props);
	        this.props.commonSummerContactRequest(contactData);
	        this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
	        this.setState({
	          inputName: '',
	          inputEmail: '',
	          inputPhone: '',
	          inputLocation: '',
	          inputDesigner: '',
	          errorName: null,
	          errorEmail: null,
	          errorPhone: null,
	          errorLocation: null
	        });
	      }
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var _this6 = this;
	
	      var hasErrors = true;
	
	      // Required params
	      var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
	      var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
	      var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
	      // Optional params
	      var phoneError = null;
	      if (this.state.inputPhone) {
	        phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
	      }
	
	      if (nameError === null && emailError === null && phoneError === null && locationError === null) {
	        hasErrors = false;
	      }
	
	      this.setState({
	        errorName: nameError,
	        errorEmail: emailError,
	        errorPhone: phoneError,
	        errorLocation: locationError
	      }, function () {
	        console.log(_this6.state);
	      });
	
	      return !hasErrors;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'InfluenceAubreyalley InfluencePage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ipHeader' },
	          _react2.default.createElement('img', { className: 'desktopHeader', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/aa_banner.jpg', alt: 'Diamonds Direct' }),
	          _react2.default.createElement('img', { className: 'mobileHeader', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/aa_banner_m.jpg', alt: 'Diamonds Direct' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow1' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_1.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_m_1.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link11 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC26447');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link11m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC26447');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow2' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_2.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_m_2.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link21 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC11599');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link22 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/BLDMD19310');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link23 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('band/BLDMD21696');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link21m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC11599');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link22m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/BLDMD19310');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link23m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('band/BLDMD21696');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow3' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_3.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_m_3.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link31 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND17506');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link32 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND12318');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link33 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EHOOP03859');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link31m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND17506');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow4' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_4.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_m_4.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link41 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC23877');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link42 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC26249');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link43 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC24136');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link41m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND12318');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link42m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EHOOP03859');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow5' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_5.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_m_5.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link51 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/BLDSM13100');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link52 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND07264');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link51m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC23877');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link52m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC26249');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link53m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC24136');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow6' },
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/aa/text/aa_m_6.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link61m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/BLDSM13100');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link62m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND07264');
	              } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipCustom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'customTitleWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'customTitle' },
	              'Custom Jewelry Creation'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'customBody' },
	            'We\'d love to work with you to create the perfect piece! Book an appointment today to make your ideas come to life with a diamond expert.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipForm' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formInnerWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'formP' },
	              'Prefer to shop in person? Walk-in visits are always welcome! But, if you\u2019d like to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'formWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorName ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Full Name*',
	                  value: this.state.inputName,
	                  onChange: this.changeName.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorEmail ? 'textInput error' : 'textInput',
	                  type: 'email',
	                  placeholder: 'Email Address*',
	                  value: this.state.inputEmail,
	                  onChange: this.changeEmail.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorPhone ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Telephone',
	                  value: this.state.inputPhone,
	                  onChange: this.changePhone.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  selectClass: 'influenceSelect',
	                  required: true,
	                  value: this.state.inputLocation,
	                  options: this.state.locations,
	                  changeMethod: function changeMethod(evt) {
	                    return _this7.changeLocation(evt);
	                  },
	                  error: this.state.errorLocation !== null })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formActionRow' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'formAction', onClick: this.submitContactRequest.bind(this) },
	                  'Request an appointment'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluenceAubreyalley;
	}(_react2.default.Component);
	
	InfluenceAubreyalley.propTypes = {
	  location: _react.PropTypes.object
	};
	InfluenceAubreyalley.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = InfluenceAubreyalley;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var InfluenceAubreyalleyContainer = exports.InfluenceAubreyalleyContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(InfluenceAubreyalley);

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfluenceBrightonbutlerContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var InfluenceBrightonbutler = function (_React$Component) {
	  _inherits(InfluenceBrightonbutler, _React$Component);
	
	  function InfluenceBrightonbutler(props) {
	    _classCallCheck(this, InfluenceBrightonbutler);
	
	    var _this = _possibleConstructorReturn(this, (InfluenceBrightonbutler.__proto__ || Object.getPrototypeOf(InfluenceBrightonbutler)).call(this, props));
	
	    var firstEntryNotReq = [{ display: 'Location*', 'value': '' }];
	    var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	    var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
	    _this.state = {
	      locations: newArray,
	      inputName: '',
	      inputEmail: '',
	      inputPhone: '',
	      inputLocation: '',
	      inputMessage: '',
	      inputDesigner: '',
	      designerLocation: '',
	      errorName: null,
	      errorEmail: null,
	      errorPhone: null,
	      errorLocation: null,
	      errorMessage: null,
	      errorDesigner: null,
	      errorDesignerLocation: null
	    };
	    return _this;
	  }
	
	  _createClass(InfluenceBrightonbutler, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'changeName',
	    value: function changeName(evt) {
	      var _this2 = this;
	
	      this.setState({ inputName: evt.target.value }, function () {
	        if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
	          _this2.setState({ errorName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      var _this3 = this;
	
	      this.setState({ inputEmail: evt.target.value }, function () {
	        if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
	          _this3.setState({ errorEmail: null });
	        }
	      });
	    }
	  }, {
	    key: 'changePhone',
	    value: function changePhone(evt) {
	      var _this4 = this;
	
	      this.setState({ inputPhone: evt.target.value }, function () {
	        if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
	          _this4.setState({ errorPhone: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeLocation',
	    value: function changeLocation(evt) {
	      var _this5 = this;
	
	      this.setState({ inputLocation: evt.target.value }, function () {
	        if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
	          _this5.setState({ errorLocation: null });
	        }
	      });
	    }
	  }, {
	    key: 'submitContactRequest',
	    value: function submitContactRequest() {
	      if (this.validateAll()) {
	
	        var contactData = {
	          full_name: this.state.inputName,
	          email: this.state.inputEmail,
	          phone: this.state.inputPhone,
	          location: this.state.inputLocation
	        };
	
	        console.log(this.props);
	        this.props.commonSummerContactRequest(contactData);
	        this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
	        this.setState({
	          inputName: '',
	          inputEmail: '',
	          inputPhone: '',
	          inputLocation: '',
	          inputDesigner: '',
	          errorName: null,
	          errorEmail: null,
	          errorPhone: null,
	          errorLocation: null
	        });
	      }
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var _this6 = this;
	
	      var hasErrors = true;
	
	      // Required params
	      var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
	      var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
	      var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
	      // Optional params
	      var phoneError = null;
	      if (this.state.inputPhone) {
	        phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
	      }
	
	      if (nameError === null && emailError === null && phoneError === null && locationError === null) {
	        hasErrors = false;
	      }
	
	      this.setState({
	        errorName: nameError,
	        errorEmail: emailError,
	        errorPhone: phoneError,
	        errorLocation: locationError
	      }, function () {
	        console.log(_this6.state);
	      });
	
	      return !hasErrors;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'InfluenceBrightonbutler InfluencePage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ipHeader' },
	          _react2.default.createElement('img', { className: 'desktopHeader', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/bkb_banner.jpg', alt: 'Diamonds Direct' }),
	          _react2.default.createElement('img', { className: 'mobileHeader', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/text/bkb_banner_m_1.jpg', alt: 'Diamonds Direct' }),
	          _react2.default.createElement('div', { className: 'overlayLink linkH1m mobileLink', onClick: function onClick() {
	              return _this7.internalNav('jewelry/EHOOP00494');
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow1' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/text/bkb_1.png', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link11 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EHOOP00494');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow2' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/text/bkb_2.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/text/bkb_m_2.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link21 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/TB20000325');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link21m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/TB20000325');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow3' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/text/bkb_3.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/text/bkb_m_3.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link31 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND17506');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link32 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND05797');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link33 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC15869');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link31m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND17506');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow4' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/text/bkb_4.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/text/bkb_m_4.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link41 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC09521');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link41m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND05797');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow5' },
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/text/bkb_m_5.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link51m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC15869');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow6' },
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/bkb/text/bkb_m_6.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link61m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/NFANC09521');
	              } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipCustom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'customTitleWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'customTitle' },
	              'Custom Jewelry Creation'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'customBody' },
	            'We\'d love to work with you to create the perfect piece! Book an appointment today to make your ideas come to life with a diamond expert.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipForm' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formInnerWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'formP' },
	              'Prefer to shop in person? Walk-in visits are always welcome! But, if you\u2019d like to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'formWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorName ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Full Name*',
	                  value: this.state.inputName,
	                  onChange: this.changeName.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorEmail ? 'textInput error' : 'textInput',
	                  type: 'email',
	                  placeholder: 'Email Address*',
	                  value: this.state.inputEmail,
	                  onChange: this.changeEmail.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorPhone ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Telephone',
	                  value: this.state.inputPhone,
	                  onChange: this.changePhone.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  selectClass: 'influenceSelect',
	                  required: true,
	                  value: this.state.inputLocation,
	                  options: this.state.locations,
	                  changeMethod: function changeMethod(evt) {
	                    return _this7.changeLocation(evt);
	                  },
	                  error: this.state.errorLocation !== null })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formActionRow' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'formAction', onClick: this.submitContactRequest.bind(this) },
	                  'Request an appointment'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluenceBrightonbutler;
	}(_react2.default.Component);
	
	InfluenceBrightonbutler.propTypes = {
	  location: _react.PropTypes.object
	};
	InfluenceBrightonbutler.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = InfluenceBrightonbutler;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var InfluenceBrightonbutlerContainer = exports.InfluenceBrightonbutlerContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(InfluenceBrightonbutler);

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfluenceCourtnwilliamsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var InfluenceCourtnwilliams = function (_React$Component) {
	  _inherits(InfluenceCourtnwilliams, _React$Component);
	
	  function InfluenceCourtnwilliams(props) {
	    _classCallCheck(this, InfluenceCourtnwilliams);
	
	    var _this = _possibleConstructorReturn(this, (InfluenceCourtnwilliams.__proto__ || Object.getPrototypeOf(InfluenceCourtnwilliams)).call(this, props));
	
	    var firstEntryNotReq = [{ display: 'Location*', 'value': '' }];
	    var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	    var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
	    _this.state = {
	      locations: newArray,
	      inputName: '',
	      inputEmail: '',
	      inputPhone: '',
	      inputLocation: '',
	      inputMessage: '',
	      inputDesigner: '',
	      designerLocation: '',
	      errorName: null,
	      errorEmail: null,
	      errorPhone: null,
	      errorLocation: null,
	      errorMessage: null,
	      errorDesigner: null,
	      errorDesignerLocation: null
	    };
	    return _this;
	  }
	
	  _createClass(InfluenceCourtnwilliams, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'changeName',
	    value: function changeName(evt) {
	      var _this2 = this;
	
	      this.setState({ inputName: evt.target.value }, function () {
	        if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
	          _this2.setState({ errorName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      var _this3 = this;
	
	      this.setState({ inputEmail: evt.target.value }, function () {
	        if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
	          _this3.setState({ errorEmail: null });
	        }
	      });
	    }
	  }, {
	    key: 'changePhone',
	    value: function changePhone(evt) {
	      var _this4 = this;
	
	      this.setState({ inputPhone: evt.target.value }, function () {
	        if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
	          _this4.setState({ errorPhone: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeLocation',
	    value: function changeLocation(evt) {
	      var _this5 = this;
	
	      this.setState({ inputLocation: evt.target.value }, function () {
	        if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
	          _this5.setState({ errorLocation: null });
	        }
	      });
	    }
	  }, {
	    key: 'submitContactRequest',
	    value: function submitContactRequest() {
	      if (this.validateAll()) {
	
	        var contactData = {
	          full_name: this.state.inputName,
	          email: this.state.inputEmail,
	          phone: this.state.inputPhone,
	          location: this.state.inputLocation
	        };
	
	        console.log(this.props);
	        this.props.commonSummerContactRequest(contactData);
	        this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
	        this.setState({
	          inputName: '',
	          inputEmail: '',
	          inputPhone: '',
	          inputLocation: '',
	          inputDesigner: '',
	          errorName: null,
	          errorEmail: null,
	          errorPhone: null,
	          errorLocation: null
	        });
	      }
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var _this6 = this;
	
	      var hasErrors = true;
	
	      // Required params
	      var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
	      var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
	      var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
	      // Optional params
	      var phoneError = null;
	      if (this.state.inputPhone) {
	        phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
	      }
	
	      if (nameError === null && emailError === null && phoneError === null && locationError === null) {
	        hasErrors = false;
	      }
	
	      this.setState({
	        errorName: nameError,
	        errorEmail: emailError,
	        errorPhone: phoneError,
	        errorLocation: locationError
	      }, function () {
	        console.log(_this6.state);
	      });
	
	      return !hasErrors;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'InfluenceCourtnwilliams InfluencePage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ipHeader' },
	          _react2.default.createElement('img', { className: 'desktopHeader', src: 'https://ddw2.diamondsdirect.com/img/influence/cw/cw_banner.jpg', alt: 'Diamonds Direct' }),
	          _react2.default.createElement('img', { className: 'mobileHeader', src: 'https://ddw2.diamondsdirect.com/img/influence/cw/text/cw_banner_m_1.jpg', alt: 'Diamonds Direct' }),
	          _react2.default.createElement('div', { className: 'overlayLink linkH1 mobileLink', onClick: function onClick() {
	              return _this7.internalNav('jewelry/EFAND14535');
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow1' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/cw/text/cw_1.png', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link11 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EFAND14535');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow2' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/cw/text/cw_2.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/cw/text/cw_m_2.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link21 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/BLDXL09226');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link21m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/BLDXL09226');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow3' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/cw/text/cw_3.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/cw/text/cw_m_3.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link31 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/TACSS00203');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link32 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/TACSS00156');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link33 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/PRLFE00688');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link31m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/TACSS00203');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow4' },
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/cw/text/cw_m_4.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link41 mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/TACSS00156');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link42 mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/PRLFE00688');
	              } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipCustom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'customTitleWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'customTitle' },
	              'Custom Jewelry Creation'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'customBody' },
	            'We\'d love to work with you to create the perfect piece! Book an appointment today to make your ideas come to life with a diamond expert.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipForm' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formInnerWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'formP' },
	              'Prefer to shop in person? Walk-in visits are always welcome! But, if you\u2019d like to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'formWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorName ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Full Name*',
	                  value: this.state.inputName,
	                  onChange: this.changeName.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorEmail ? 'textInput error' : 'textInput',
	                  type: 'email',
	                  placeholder: 'Email Address*',
	                  value: this.state.inputEmail,
	                  onChange: this.changeEmail.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorPhone ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Telephone',
	                  value: this.state.inputPhone,
	                  onChange: this.changePhone.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  selectClass: 'influenceSelect',
	                  required: true,
	                  value: this.state.inputLocation,
	                  options: this.state.locations,
	                  changeMethod: function changeMethod(evt) {
	                    return _this7.changeLocation(evt);
	                  },
	                  error: this.state.errorLocation !== null })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formActionRow' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'formAction', onClick: this.submitContactRequest.bind(this) },
	                  'Request an appointment'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluenceCourtnwilliams;
	}(_react2.default.Component);
	
	InfluenceCourtnwilliams.propTypes = {
	  location: _react.PropTypes.object
	};
	InfluenceCourtnwilliams.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = InfluenceCourtnwilliams;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var InfluenceCourtnwilliamsContainer = exports.InfluenceCourtnwilliamsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(InfluenceCourtnwilliams);

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfluenceHauteofftherackContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var InfluenceHauteofftherack = function (_React$Component) {
	  _inherits(InfluenceHauteofftherack, _React$Component);
	
	  function InfluenceHauteofftherack(props) {
	    _classCallCheck(this, InfluenceHauteofftherack);
	
	    var _this = _possibleConstructorReturn(this, (InfluenceHauteofftherack.__proto__ || Object.getPrototypeOf(InfluenceHauteofftherack)).call(this, props));
	
	    var firstEntryNotReq = [{ display: 'Location*', 'value': '' }];
	    var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	    var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
	    _this.state = {
	      locations: newArray,
	      inputName: '',
	      inputEmail: '',
	      inputPhone: '',
	      inputLocation: '',
	      inputMessage: '',
	      inputDesigner: '',
	      designerLocation: '',
	      errorName: null,
	      errorEmail: null,
	      errorPhone: null,
	      errorLocation: null,
	      errorMessage: null,
	      errorDesigner: null,
	      errorDesignerLocation: null
	    };
	    return _this;
	  }
	
	  _createClass(InfluenceHauteofftherack, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'changeName',
	    value: function changeName(evt) {
	      var _this2 = this;
	
	      this.setState({ inputName: evt.target.value }, function () {
	        if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
	          _this2.setState({ errorName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      var _this3 = this;
	
	      this.setState({ inputEmail: evt.target.value }, function () {
	        if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
	          _this3.setState({ errorEmail: null });
	        }
	      });
	    }
	  }, {
	    key: 'changePhone',
	    value: function changePhone(evt) {
	      var _this4 = this;
	
	      this.setState({ inputPhone: evt.target.value }, function () {
	        if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
	          _this4.setState({ errorPhone: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeLocation',
	    value: function changeLocation(evt) {
	      var _this5 = this;
	
	      this.setState({ inputLocation: evt.target.value }, function () {
	        if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
	          _this5.setState({ errorLocation: null });
	        }
	      });
	    }
	  }, {
	    key: 'submitContactRequest',
	    value: function submitContactRequest() {
	      if (this.validateAll()) {
	
	        var contactData = {
	          full_name: this.state.inputName,
	          email: this.state.inputEmail,
	          phone: this.state.inputPhone,
	          location: this.state.inputLocation
	        };
	
	        console.log(this.props);
	        this.props.commonSummerContactRequest(contactData);
	        this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
	        this.setState({
	          inputName: '',
	          inputEmail: '',
	          inputPhone: '',
	          inputLocation: '',
	          inputDesigner: '',
	          errorName: null,
	          errorEmail: null,
	          errorPhone: null,
	          errorLocation: null
	        });
	      }
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var _this6 = this;
	
	      var hasErrors = true;
	
	      // Required params
	      var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
	      var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
	      var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
	      // Optional params
	      var phoneError = null;
	      if (this.state.inputPhone) {
	        phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
	      }
	
	      if (nameError === null && emailError === null && phoneError === null && locationError === null) {
	        hasErrors = false;
	      }
	
	      this.setState({
	        errorName: nameError,
	        errorEmail: emailError,
	        errorPhone: phoneError,
	        errorLocation: locationError
	      }, function () {
	        console.log(_this6.state);
	      });
	
	      return !hasErrors;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'InfluenceHauteofftherack InfluencePage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ipHeader' },
	          _react2.default.createElement('img', { className: 'desktopHeader', src: 'https://ddw2.diamondsdirect.com/img/influence/jp/jp_banner.jpg', alt: 'Diamonds Direct' }),
	          _react2.default.createElement('img', { className: 'mobileHeader', src: 'https://ddw2.diamondsdirect.com/img/influence/jp/jp_banner_m.jpg', alt: 'Diamonds Direct' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow1' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/jp/text/jp_1.png', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/jp/text/jp_m_1.png', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link11 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/GBANG02440');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link12 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/BLDLG07490');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link11m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/BLDLG07490');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow2' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/jp/text/jp_2.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/jp/text/jp_m_2.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link21 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('band/BLDMD21696');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link22 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/GBANG02229');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link23 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('band/BLDSM08838');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link21m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/GBANG02440');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow3' },
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/jp/text/jp_m_3.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link31 mobileLink', onClick: function onClick() {
	                return _this7.internalNav('band/BLDMD21696');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow4' },
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/jp/text/jp_m_4.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link41 mobileLink', onClick: function onClick() {
	                return _this7.internalNav('band/BLDSM08838');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow5' },
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/jp/text/jp_m_5.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link51 mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/GBANG02229');
	              } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipCustom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'customTitleWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'customTitle' },
	              'Custom Jewelry Creation'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'customBody' },
	            'We\'d love to work with you to create the perfect piece! Book an appointment today to make your ideas come to life with a diamond expert.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipForm' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formInnerWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'formP' },
	              'Prefer to shop in person? Walk-in visits are always welcome! But, if you\u2019d like to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'formWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorName ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Full Name*',
	                  value: this.state.inputName,
	                  onChange: this.changeName.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorEmail ? 'textInput error' : 'textInput',
	                  type: 'email',
	                  placeholder: 'Email Address*',
	                  value: this.state.inputEmail,
	                  onChange: this.changeEmail.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorPhone ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Telephone',
	                  value: this.state.inputPhone,
	                  onChange: this.changePhone.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  selectClass: 'influenceSelect',
	                  required: true,
	                  value: this.state.inputLocation,
	                  options: this.state.locations,
	                  changeMethod: function changeMethod(evt) {
	                    return _this7.changeLocation(evt);
	                  },
	                  error: this.state.errorLocation !== null })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formActionRow' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'formAction', onClick: this.submitContactRequest.bind(this) },
	                  'Request an appointment'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluenceHauteofftherack;
	}(_react2.default.Component);
	
	InfluenceHauteofftherack.propTypes = {
	  location: _react.PropTypes.object
	};
	InfluenceHauteofftherack.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = InfluenceHauteofftherack;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var InfluenceHauteofftherackContainer = exports.InfluenceHauteofftherackContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(InfluenceHauteofftherack);

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfluenceMeganrunionmcrContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var InfluenceMeganrunionmcr = function (_React$Component) {
	  _inherits(InfluenceMeganrunionmcr, _React$Component);
	
	  function InfluenceMeganrunionmcr(props) {
	    _classCallCheck(this, InfluenceMeganrunionmcr);
	
	    var _this = _possibleConstructorReturn(this, (InfluenceMeganrunionmcr.__proto__ || Object.getPrototypeOf(InfluenceMeganrunionmcr)).call(this, props));
	
	    var firstEntryNotReq = [{ display: 'Location*', 'value': '' }];
	    var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	    var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
	    _this.state = {
	      locations: newArray,
	      inputName: '',
	      inputEmail: '',
	      inputPhone: '',
	      inputLocation: '',
	      inputMessage: '',
	      inputDesigner: '',
	      designerLocation: '',
	      errorName: null,
	      errorEmail: null,
	      errorPhone: null,
	      errorLocation: null,
	      errorMessage: null,
	      errorDesigner: null,
	      errorDesignerLocation: null
	    };
	    return _this;
	  }
	
	  _createClass(InfluenceMeganrunionmcr, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'changeName',
	    value: function changeName(evt) {
	      var _this2 = this;
	
	      this.setState({ inputName: evt.target.value }, function () {
	        if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
	          _this2.setState({ errorName: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      var _this3 = this;
	
	      this.setState({ inputEmail: evt.target.value }, function () {
	        if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
	          _this3.setState({ errorEmail: null });
	        }
	      });
	    }
	  }, {
	    key: 'changePhone',
	    value: function changePhone(evt) {
	      var _this4 = this;
	
	      this.setState({ inputPhone: evt.target.value }, function () {
	        if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
	          _this4.setState({ errorPhone: null });
	        }
	      });
	    }
	  }, {
	    key: 'changeLocation',
	    value: function changeLocation(evt) {
	      var _this5 = this;
	
	      this.setState({ inputLocation: evt.target.value }, function () {
	        if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
	          _this5.setState({ errorLocation: null });
	        }
	      });
	    }
	  }, {
	    key: 'submitContactRequest',
	    value: function submitContactRequest() {
	      if (this.validateAll()) {
	
	        var contactData = {
	          full_name: this.state.inputName,
	          email: this.state.inputEmail,
	          phone: this.state.inputPhone,
	          location: this.state.inputLocation
	        };
	
	        console.log(this.props);
	        this.props.commonSummerContactRequest(contactData);
	        this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
	        this.setState({
	          inputName: '',
	          inputEmail: '',
	          inputPhone: '',
	          inputLocation: '',
	          inputDesigner: '',
	          errorName: null,
	          errorEmail: null,
	          errorPhone: null,
	          errorLocation: null
	        });
	      }
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var _this6 = this;
	
	      var hasErrors = true;
	
	      // Required params
	      var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
	      var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
	      var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
	      // Optional params
	      var phoneError = null;
	      if (this.state.inputPhone) {
	        phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
	      }
	
	      if (nameError === null && emailError === null && phoneError === null && locationError === null) {
	        hasErrors = false;
	      }
	
	      this.setState({
	        errorName: nameError,
	        errorEmail: emailError,
	        errorPhone: phoneError,
	        errorLocation: locationError
	      }, function () {
	        console.log(_this6.state);
	      });
	
	      return !hasErrors;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'InfluenceMeganrunionmcr InfluencePage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ipHeader' },
	          _react2.default.createElement('img', { className: 'desktopHeader', src: 'https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_banner.jpg', alt: 'Diamonds Direct' }),
	          _react2.default.createElement('img', { className: 'mobileHeader', src: 'https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_banner_m.jpg', alt: 'Diamonds Direct' }),
	          _react2.default.createElement('div', { className: 'overlayLink linkH1 desktopLink', onClick: function onClick() {
	              return _this7.internalNav('jewelry/PRL9N00122');
	            } }),
	          _react2.default.createElement('div', { className: 'overlayLink linkH1m mobileLink', onClick: function onClick() {
	              return _this7.internalNav('jewelry/PRL9N00122');
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow1' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_1.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_m_1.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link11 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EHOOP00498');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link12 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('band/BLDLG00689');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link14 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/GBANG00545');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link11m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EHOOP00498');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow2' },
	            _react2.default.createElement('img', { className: 'desktopRow', src: 'https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_2.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_m_2.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link21 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/TB10000258');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link22 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('diamond-pendants');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link23 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('diamond-studs');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link24 desktopLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EHOOP01005');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link21m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/GBANG00545');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link23m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('band/BLDLG00689');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow3' },
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_m_3.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link31m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/TB10000258');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link32m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('diamond-pendants');
	              } }),
	            _react2.default.createElement('div', { className: 'overlayLink link33m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('diamond-studs');
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ipRow ipRow4' },
	            _react2.default.createElement('img', { className: 'mobileRow', src: 'https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_m_4.jpg', alt: 'Diamonds Direct' }),
	            _react2.default.createElement('div', { className: 'overlayLink link41m mobileLink', onClick: function onClick() {
	                return _this7.internalNav('jewelry/EHOOP01005');
	              } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipCustom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'customTitleWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'customTitle' },
	              'Custom Jewelry Creation'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'customBody' },
	            'We\'d love to work with you to create the perfect piece! Book an appointment today to make your ideas come to life with a diamond expert.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ipForm' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formInnerWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'formP' },
	              'Prefer to shop in person? Walk-in visits are always welcome! But, if you\u2019d like to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'formWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorName ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Full Name*',
	                  value: this.state.inputName,
	                  onChange: this.changeName.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorEmail ? 'textInput error' : 'textInput',
	                  type: 'email',
	                  placeholder: 'Email Address*',
	                  value: this.state.inputEmail,
	                  onChange: this.changeEmail.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement('input', {
	                  className: this.state.errorPhone ? 'textInput error' : 'textInput',
	                  type: 'text',
	                  placeholder: 'Telephone',
	                  value: this.state.inputPhone,
	                  onChange: this.changePhone.bind(this) })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formInputWrapper' },
	                _react2.default.createElement(_RhinoSelect2.default, {
	                  selectClass: 'influenceSelect',
	                  required: true,
	                  value: this.state.inputLocation,
	                  options: this.state.locations,
	                  changeMethod: function changeMethod(evt) {
	                    return _this7.changeLocation(evt);
	                  },
	                  error: this.state.errorLocation !== null })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'formActionRow' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'formAction', onClick: this.submitContactRequest.bind(this) },
	                  'Request an appointment'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluenceMeganrunionmcr;
	}(_react2.default.Component);
	
	InfluenceMeganrunionmcr.propTypes = {
	  location: _react.PropTypes.object
	};
	InfluenceMeganrunionmcr.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = InfluenceMeganrunionmcr;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var InfluenceMeganrunionmcrContainer = exports.InfluenceMeganrunionmcrContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(InfluenceMeganrunionmcr);

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrivacyContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var Privacy = function (_React$Component) {
	  _inherits(Privacy, _React$Component);
	
	  function Privacy(props) {
	    _classCallCheck(this, Privacy);
	
	    var _this = _possibleConstructorReturn(this, (Privacy.__proto__ || Object.getPrototypeOf(Privacy)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Privacy, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Privacy Policy';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Privacy' },
	        _react2.default.createElement(
	          'div',
	          { className: 'headerSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'privacyTitle' },
	            'Privacy Policy'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'privacySubtitle' },
	            'This Application collects some Personal Data from its Users'
	          ),
	          _react2.default.createElement('div', { className: 'prBr' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'prIconTitle' },
	            'Personal Data collected for the following purposes and using the following services:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'prIconWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'prIcon' },
	              _react2.default.createElement(
	                'div',
	                { className: 'priImgWrapper' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/legal/privacy/analytics.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'priTitle' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Analytics'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'priItems' },
	                'Google Analytics, Google AdWords conversion tracking and Google Analytics with anonymized IP'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'priData' },
	                'Personal Data: Cookie and Usage Data'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'prIcon' },
	              _react2.default.createElement(
	                'div',
	                { className: 'priImgWrapper' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/legal/privacy/external.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'priTitle' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Displaying content from external platforms'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'priItems' },
	                'Google Maps widget, Youtube video widget, and Vimeo video'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'priData' },
	                'Personal Data: Cookie and Usage Data'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'prIcon' },
	              _react2.default.createElement(
	                'div',
	                { className: 'priImgWrapper' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/legal/privacy/remarketing.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'priTitle' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Remarketing and Behavioral Targeting'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'priItems' },
	                'AdRoll'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'priData' },
	                'Personal Data: Cookie and Usage Data'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contactSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'policyPage contactPage' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ppContactTitle' },
	              'Contact Information'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ppContactP' },
	              'Data Owner:',
	              _react2.default.createElement('br', null),
	              'Diamonds Direct USA Inc., ',
	              _react2.default.createElement(
	                'a',
	                { className: 'legalLink', href: 'mailto:info@diamonds-direct.com' },
	                'info@diamonds-direct.com'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'policySection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'policyWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'policyGrey' },
	              _react2.default.createElement(
	                'div',
	                { className: 'greyMainTitle' },
	                'Full Policy'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyBr' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/legal/privacy/iconline.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'Effective date: January 31, 2019'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'Diamonds Direct USA Inc. ("us", "we", or "our") operates the ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', href: 'https://diamondsdirect.com' },
	                  'https://diamondsdirect.com'
	                ),
	                ' website (hereinafter referred to as the "Service").'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'This page informs you of our policies regarding the collection, use and disclosure of personal data when you use our Service and the choices you have associated with that data.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', href: 'https://diamondsdirect.com/terms-of-use' },
	                  'https://diamondsdirect.com/terms-of-use'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'policyPage' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ppMainTitle' },
	                'Definitions and Legal References'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppBr' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/legal/privacy/iconline.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppSectionTitle' },
	                'Service'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'Service is the ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', href: 'https://diamondsdirect.com' },
	                  'https://diamondsdirect.com'
	                ),
	                ' website operated by Diamonds Direct USA Inc.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppSectionTitle' },
	                'Personal Data'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'Personal Data means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppSectionTitle' },
	                'Usage Data'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'Usage Data is data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppSectionTitle' },
	                'Cookies'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'Cookies are small files stored on your device (computer or mobile device).'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppSectionTitle' },
	                'Data Controller'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'Data Controller means the natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal information are, or are to be, processed.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'For the purpose of this Privacy Policy, we are a Data Controller of your Personal Data.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppSectionTitle' },
	                'Data Processors (or Service Providers)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of the Data Controller.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'We may use the services of various Service Providers in order to process your data more effectively.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppSectionTitle' },
	                'Data Subject (or User)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'Data Subject is any living individual who is using our Service and is the subject of Personal Data.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'policyGrey' },
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Information Collection and Use'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'We collect several different types of information for various purposes to provide and improve our Service to you.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Types of Data Collected'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySubtitle' },
	                'Personal Data'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                'While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Email address'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'First name and last name'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Phone number'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Address, State, Province, ZIP/Postal code, City'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Cookies and Usage Data'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                'We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send or by contacting us.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySubtitle' },
	                'Usage Data'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                'We may also collect information on how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer\'s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySubtitle' },
	                'Tracking Cookies Data'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                'We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                'Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyze our Service.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                'You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                'Examples of Cookies we use:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Session Cookies. We use Session Cookies to operate our Service.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Preference Cookies. We use Preference Cookies to remember your preferences and various settings.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Security Cookies. We use Security Cookies for security purposes.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Use of Data'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'Diamonds Direct USA Inc. uses the collected data for various purposes:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To provide and maintain our Service'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To notify you about changes to our Service'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To allow you to participate in interactive features of our Service when you choose to do so'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To provide customer support'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To gather analysis or information so that we can improve our Service'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To monitor the usage of our Service'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To detect, prevent and address technical issues'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Retention of Data'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'Diamonds Direct USA Inc. will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes and enforce our legal agreements and policies.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'Diamonds Direct USA Inc. will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer periods.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Transfer of Data'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'Your information, including Personal Data, may be transferred to \u2014 and maintained on \u2014 computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'Diamonds Direct USA Inc. will take the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Disclosure of Data'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySubtitle' },
	                'Legal Requirements'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                'Diamonds Direct USA Inc. may disclose your Personal Data in the good faith belief that such action is necessary to:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP ppIndent' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To comply with a legal obligation'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To protect and defend the rights or property of Diamonds Direct USA Inc.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To prevent or investigate possible wrongdoing in connection with the Service'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To protect the personal safety of users of the Service or the public'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'To protect against legal liability'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Security of Data'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Our Policy on "Do Not Track" Signals under the California Online Protection Act (CalOPPA)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'We do not support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'policyPage' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ppMainTitle' },
	                'Your Data Protection Rights Under the General Data Protection Regulation (GDPR)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppBr' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/legal/privacy/iconline.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'If you are a resident of the European Economic Area (EEA), you have certain data protection rights. Diamonds Direct USA Inc. aims to take reasonable steps to allow you to correct, amend, delete or limit the use of your Personal Data.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'If you wish to be informed about what Personal Data we hold about you and if you want it to be removed from our systems, please contact us.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'In certain circumstances, you have the following data protection rights:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ppEm' },
	                  'The right to access, update or delete the information we have on you.'
	                ),
	                'Whenever made possible, you can access, update or request deletion of your Personal Data directly within your account settings section. If you are unable to perform these actions yourself, please contact us to assist you.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ppEm' },
	                  'The right of rectification.'
	                ),
	                'You have the right to have your information rectified if that information is inaccurate or incomplete.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ppEm' },
	                  'The right to object.'
	                ),
	                'You have the right to object to our processing of your Personal Data.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ppEm' },
	                  'The right of restriction.'
	                ),
	                'You have the right to request that we restrict the processing of your personal information.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ppEm' },
	                  'The right to data portability.'
	                ),
	                'You have the right to be provided with a copy of the information we have on you in a structured, machine-readable and commonly used format.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ppEm' },
	                  'The right to withdraw consent.'
	                ),
	                'You also have the right to withdraw your consent at any time where Diamonds Direct USA Inc. relied on your consent to process your personal information.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'Please note that we may ask you to verify your identity before responding to such requests.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'You have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA).'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'policyPage', style: { marginTop: '40px' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'ppMainTitle' },
	                'Service Providers'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppBr' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/legal/privacy/iconline.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'We may employ third party companies and individuals to facilitate our Service ("Service Providers"), provide the Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppSectionTitle' },
	                'Analytics'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'We may use third-party Service Providers to monitor and analyze the use of our Service.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppProvider' },
	                'Google Analytics'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualise and personalise the ads of its own advertising network.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'You can opt-out of having made your activity on the Service available to Google Analytics by installing the Google Analytics opt-out browser add-on. The add-on prevents the Google Analytics JavaScript (ga.js, analytics.js and dc.js) from sharing information with Google Analytics about visits activity.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://policies.google.com/privacy?hl=en' },
	                  'https://policies.google.com/privacy?hl=en'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppSectionTitle' },
	                'Behavioral Remarketing'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'Diamonds Direct USA Inc. uses remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimize and serve ads based on your past visits to our Service.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppProvider' },
	                'Google Ads (Adwords)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Google Ads (AdWords) remarketing service is provided by Google Inc.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'You can opt-out of Google Analytics for Display Advertising and customise the Google Display Network ads by visiting the Google Ads Settings page: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://www.google.com/settings/ads' },
	                  'https://www.google.com/settings/ads'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Google also recommends installing the Google Analytics Opt-out Browser Add-on - ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://tools.google.com/dlpage/gaoptout' },
	                  'https://tools.google.com/dlpage/gaoptout'
	                ),
	                ' - for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://policies.google.com/privacy?hl=en' },
	                  'https://policies.google.com/privacy?hl=en'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppProvider' },
	                'Bing Ads Remarketing'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Bing Ads remarketing service is provided by Microsoft Inc.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'You can opt-out of Bing Ads interest-based ads by following their instructions: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads' },
	                  'https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'You can learn more about the privacy practices and policies of Microsoft by visiting their Privacy Policy page: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://privacy.microsoft.com/en-us/PrivacyStatement' },
	                  'https://privacy.microsoft.com/en-us/PrivacyStatement'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppProvider' },
	                'Twitter'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Twitter remarketing service is provided by Twitter Inc.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'You can opt-out from Twitter\'s interest-based ads by following their instructions: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://support.twitter.com/articles/20170405' },
	                  'https://support.twitter.com/articles/20170405'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'You can learn more about the privacy practices and policies of Twitter by visiting their Privacy Policy page: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://twitter.com/privacy' },
	                  'https://twitter.com/privacy'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppProvider' },
	                'Facebook'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Facebook remarketing service is provided by Facebook Inc.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'You can learn more about interest-based advertising from Facebook by visiting this page: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://www.facebook.com/help/164968693837950' },
	                  'https://www.facebook.com/help/164968693837950'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'To opt-out from Facebook\'s interest-based ads, follow these instructions from Facebook: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://www.facebook.com/help/568137493302217' },
	                  'https://www.facebook.com/help/568137493302217'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in the USA ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'http://www.aboutads.info/choices/' },
	                  'http://www.aboutads.info/choices/'
	                ),
	                ', the Digital Advertising Alliance of Canada in Canada ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'http://youradchoices.ca/' },
	                  'http://youradchoices.ca/'
	                ),
	                ' or the European Interactive Digital Advertising Alliance in Europe ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'http://www.youronlinechoices.eu/' },
	                  'http://www.youronlinechoices.eu/'
	                ),
	                ', or opt-out using your mobile device settings.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'For more information on the privacy practices of Facebook, please visit Facebook\'s Data Policy: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://www.facebook.com/privacy/explanation' },
	                  'https://www.facebook.com/privacy/explanation'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppProvider' },
	                'Pinterest'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Pinterest remarketing service is provided by Pinterest Inc.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'You can opt-out from Pinterest\'s interest-based ads by enabling the "Do Not Track" functionality of your web browser or by following Pinterest instructions: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'http://help.pinterest.com/en/articles/personalization-and-data' },
	                  'http://help.pinterest.com/en/articles/personalization-and-data'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'You can learn more about the privacy practices and policies of Pinterest by visiting their Privacy Policy page: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://about.pinterest.com/en/privacy-policy' },
	                  'https://about.pinterest.com/en/privacy-policy'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppSectionTitle' },
	                'Payments'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'We may provide paid products and/or services within the Service. In that case, we use third-party services for payment processing (e.g. payment processors).'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp' },
	                'The payment processors we work with are:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppProvider' },
	                'PayPal / Braintree'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Their Privacy Policy can be viewed at ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://www.paypal.com/webapps/mpp/ua/privacy-full' },
	                  'https://www.paypal.com/webapps/mpp/ua/privacy-full'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppProvider' },
	                'Authorize.net'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Their Privacy Policy can be viewed at ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://www.authorize.net/company/privacy/' },
	                  'https://www.authorize.net/company/privacy/'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppProvider' },
	                'First Data / Fiserv'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ppp ppIndent' },
	                'Their Privacy Policy can be viewed at ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'legalLink', target: '_blank', href: 'https://merchants.fiserv.com/en-us/privacy/' },
	                  'https://merchants.fiserv.com/en-us/privacy/'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'policyGrey' },
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Links to Other Sites'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party\'s site. We strongly advise you to review the Privacy Policy of every site you visit.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Children\'s Privacy'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'Our Service does not address anyone under the age of 18 ("Children").'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Changes to This Privacy Policy'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greySectionTitle' },
	                'Contact Us'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                'If you have any questions about this Privacy Policy, please contact us:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'greyP' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'By email: ',
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'legalLink', href: 'mailto:info@diamondsdirect.com' },
	                      'info@diamondsdirect.com'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'By visiting this page on our website: ',
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'legalLink', href: 'https://diamondsdirect.com/privacy-policy' },
	                      'https://diamondsdirect.com/privacy-policy'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Privacy;
	}(_react2.default.Component);
	
	Privacy.propTypes = {
	  location: _react.PropTypes.object
	};
	Privacy.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Privacy;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var PrivacyContainer = exports.PrivacyContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Privacy);

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TermsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var Terms = function (_React$Component) {
	  _inherits(Terms, _React$Component);
	
	  function Terms(props) {
	    _classCallCheck(this, Terms);
	
	    var _this = _possibleConstructorReturn(this, (Terms.__proto__ || Object.getPrototypeOf(Terms)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Terms, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Terms of Service';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Terms' },
	        _react2.default.createElement(
	          'div',
	          { className: 'termsWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'termsTitle' },
	            'Terms & Conditions'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsBr' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/legal/privacy/iconline.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'OVERVIEW'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'This website is owned and operated by Diamonds Direct Online USA, LLC, which does business as Diamonds Direct. Throughout the site, the terms \u201Cwe\u201D, \u201Cus\u201D and \u201Cour\u201D refer to Diamonds Direct. Diamonds Direct offers this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'By visiting our site and/ or purchasing something from us, you engage in our \u201CService\u201D and agree to be bound by the following terms and conditions (\u201CTerms of Service\u201D, \u201CTerms\u201D), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/ or contributors of content.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 1 - ONLINE STORE TERMS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You must not transmit any worms or viruses or any code of a destructive nature.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'A breach or violation of any of the Terms will result in an immediate termination of your Services.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 2 - GENERAL CONDITIONS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We reserve the right to refuse service to anyone for any reason at any time.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'This site may contain certain historical information. Historical information, necessarily, is not current and is provided for your reference only. We reserve the right to modify the contents of this site at any time, but we have no obligation to update any information on our site. You agree that it is your responsibility to monitor changes to our site.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 4 - MODIFICATIONS TO THE SERVICE AND PRICES'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Prices for our products are subject to change without notice.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 5 - PRODUCTS OR SERVICES (if applicable)'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange only according to our Return Policy.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor\'s display of any color will be accurate.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis. We reserve the right to limit the quantities of any products or services that we offer. All descriptions of products or product pricing are subject to change at anytime without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time. Any offer for any product or service made on this site is void where prohibited.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 6 - ACCURACY OF BILLING AND ACCOUNT INFORMATION'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the e-mail and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers or distributors.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You agree to provide current, complete and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'For more detail, please review our Returns Policy.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 7 - OPTIONAL TOOLS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We may provide you with access to third-party tools over which we neither monitor nor have any control nor input.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You acknowledge and agree that we provide access to such tools \u201Das is\u201D and \u201Cas available\u201D without any warranties, representations or conditions of any kind and without any endorsement. We shall have no liability whatsoever arising from or relating to your use of optional third-party tools.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Any use by you of optional tools offered through the site is entirely at your own risk and discretion and you should ensure that you are familiar with and approve of the terms on which tools are provided by the relevant third-party provider(s).'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We may also, in the future, offer new services and/or features through the website (including, the release of new tools and resources). Such new features and/or services shall also be subject to these Terms of Service.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 8 - THIRD-PARTY LINKS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Certain content, products and services available via our Service may include materials from third-parties.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third-parties.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party\'s policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third-party.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 9 - USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'If, at our request, you send certain specific submissions (for example contest entries) or without a request from us you send creative ideas, suggestions, proposals, plans, or other materials, whether online, by email, by postal mail, or otherwise (collectively, \'comments\'), you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate and otherwise use in any medium any comments that you forward to us. We are and shall be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for any comments; or (3) to respond to any comments.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We may, but have no obligation to, monitor, edit or remove content that we determine in our sole discretion are unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party\u2019s intellectual property or these Terms of Service.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You agree that your comments will not violate any right of any third-party, including copyright, trademark, privacy, personality or other personal or proprietary right. You further agree that your comments will not contain libelous or otherwise unlawful, abusive or obscene material, or contain any computer virus or other malware that could in any way affect the operation of the Service or any related website. You may not use a false e-mail address, pretend to be someone other than yourself, or otherwise mislead us or third-parties as to the origin of any comments. You are solely responsible for any comments you make and their accuracy. We take no responsibility and assume no liability for any comments posted by you or any third-party.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 10 - PERSONAL INFORMATION'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Your submission of personal information through the store is governed by our Privacy Policy, which is incorporated into these Terms of Service by reference. To view our Privacy Policy, visit ',
	            _react2.default.createElement(
	              'a',
	              { className: 'legalLink', href: 'https://diamondsdirect.com/privacy-policy' },
	              'https://diamondsdirect.com/privacy-policy'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 11 - ERRORS, INACCURACIES AND OMISSIONS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Occasionally there may be information on our site or in the Service that contains typographical errors, inaccuracies or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times and availability. We reserve the right to correct any errors, inaccuracies or omissions, and to change or update information or cancel orders if any information in the Service or on any related website is inaccurate at any time without prior notice (including after you have submitted your order).'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We undertake no obligation to update, amend or clarify information in the Service or on any related website, including without limitation, pricing information, except as required by law. No specified update or refresh date applied in the Service or on any related website, should be taken to indicate that all information in the Service or on any related website has been modified or updated.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 12 - PROHIBITED USES'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 13 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or error-free.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You agree that from time to time we may remove the service for indefinite periods of time or cancel the service at any time, without notice to you.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided \'as is\' and \'as available\' for your use, without any representation, warranties or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'In no case shall Diamonds Direct, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 14 - INDEMNIFICATION'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You agree to indemnify, defend and hold harmless Diamonds Direct and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including reasonable attorneys\u2019 fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 15 - SEVERABILITY'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 16 - TERMINATION'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'The obligations and liabilities of the parties incurred prior to the date these Terms of Service are terminated shall survive the termination of this agreement for all purposes.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'These Terms of Service are effective until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof).'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 17 - ENTIRE AGREEMENT'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'These Terms of Service and any policies or operating rules posted by us on this site or in respect to The Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service).'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Any ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 18 - GOVERNING LAW'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of North Carolina, United States.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 19 - CHANGES TO TERMS OF SERVICE'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'You can review the most current version of the Terms of Service at any time at this page.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsHeader' },
	            'SECTION 20 - CONTACT INFORMATION'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'termsP' },
	            'Questions about the Terms of Service should be sent to us at ',
	            _react2.default.createElement(
	              'a',
	              { className: 'legalLink', href: 'mailto:online@diamondsdirect.com' },
	              'online@diamondsdirect.com'
	            ),
	            '.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Terms;
	}(_react2.default.Component);
	
	Terms.propTypes = {
	  location: _react.PropTypes.object
	};
	Terms.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Terms;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var TermsContainer = exports.TermsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Terms);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LocationsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactMailto = __webpack_require__(142);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var Locations = function (_React$Component) {
		_inherits(Locations, _React$Component);
	
		function Locations(props) {
			_classCallCheck(this, Locations);
	
			return _possibleConstructorReturn(this, (Locations.__proto__ || Object.getPrototypeOf(Locations)).call(this, props));
		}
	
		_createClass(Locations, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				document.title = 'Diamonds Direct | Locations';
				document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
			}
		}, {
			key: 'storeNav',
			value: function storeNav(page) {
				this.context.router.push('/' + page);
				// window.location.href = '/' + page;
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Locations' },
					_react2.default.createElement(
						'div',
						{ className: 'locations-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'map-wrapper' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/locations/map-background-5.png', className: 'map-background' }),
							_react2.default.createElement(
								'div',
								{ id: 'marker-austin', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('austin');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Austin,\xA0TX'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-birmingham', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('birmingham');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Birmingham,\xA0AL'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-charleston', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('charleston');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Charleston,\xA0SC'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-clt', className: 'map-location-wrapper double-wrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ onClick: function onClick() {
												return _this2.storeNav('charlotte');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'store-name' },
											'Charlotte,\xA0NC'
										),
										_react2.default.createElement(
											'div',
											{ className: 'store-link' },
											'Visit\xA0Store\xA0Page'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-cleveland', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('cleveland');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Cleveland, OH'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-columbus', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('columbus');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Columbus, OH'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-dallas', className: 'map-location-wrapper double-wrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ onClick: function onClick() {
												return _this2.storeNav('dallas');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'store-name' },
											'Dallas,\xA0TX'
										),
										_react2.default.createElement(
											'div',
											{ className: 'store-link' },
											'Visit\xA0Store\xA0Page'
										)
									),
									_react2.default.createElement('div', { className: 'horizontal-rule' }),
									_react2.default.createElement(
										'div',
										{ onClick: function onClick() {
												return _this2.storeNav('frisco');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'store-name' },
											'Frisco,\xA0TX'
										),
										_react2.default.createElement(
											'div',
											{ className: 'store-link' },
											'Visit\xA0Store\xA0Page'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-indy', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('indianapolis');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Indianapolis, IN'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-hou', className: 'map-location-wrapper double-wrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ onClick: function onClick() {
												return _this2.storeNav('baybrook');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'store-name' },
											'Houston,\xA0TX\xA0(Baybrook)'
										),
										_react2.default.createElement(
											'div',
											{ className: 'store-link' },
											'Visit\xA0Store\xA0Page'
										)
									),
									_react2.default.createElement('div', { className: 'horizontal-rule' }),
									_react2.default.createElement(
										'div',
										{ onClick: function onClick() {
												return _this2.storeNav('houston');
											} },
										_react2.default.createElement(
											'div',
											{ className: 'store-name' },
											'Houston,\xA0TX\xA0(Galleria)'
										),
										_react2.default.createElement(
											'div',
											{ className: 'store-link' },
											'Visit\xA0Store\xA0Page'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-kansas-city', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('kansas-city');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Kansas City, KS'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-nol', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('new-orleans');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'New Orleans, LA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-okc', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('oklahoma-city');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Oklahoma City, OK'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-pit', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('pittsburgh');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Pittsburgh, PA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-raleigh', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('raleigh');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Raleigh,\xA0NC'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-richmond', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('richmond');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Richmond,\xA0VA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-stl', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('st-louis');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'St.\xA0Louis,\xA0MO'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-san', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('san-antonio');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'San\xA0Antonio,\xA0TX'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-vab', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('virginia-beach');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Virginia\xA0Beach,\xA0VA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-boc', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('boca-raton');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Boca\xA0Raton,\xA0FL'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-globaldiamonds', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('jacksonville');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Jacksonville,\xA0FL'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit\xA0Store\xA0Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-gsc', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('greenville');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Greenville,\xA0SC'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-nva', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('tysons');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Tysons,\xA0VA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'marker-try', className: 'map-location-wrapper', onClick: function onClick() {
										return _this2.storeNav('troy');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'marker-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'store-marker' },
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'store-label' },
									_react2.default.createElement(
										'div',
										{ className: 'store-name' },
										'Troy,\xA0MI'
									),
									_react2.default.createElement(
										'div',
										{ className: 'store-link' },
										'Visit Store Page'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'appointmentButtonWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'appointmentButton', onClick: function onClick() {
										return _this2.internalNav('virtual');
									} },
								'Request an Appointment'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'locations-grid' },
						_react2.default.createElement(
							'div',
							{ className: 'block-link-section' },
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('austin');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Austin, TX'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('birmingham');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Birmingham, AL'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('boca-raton');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Boca Raton, FL'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('charleston');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Charleston, SC'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('charlotte');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Charlotte, NC'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('cleveland');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Cleveland, OH'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('columbus');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Columbus, OH'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('dallas');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Dallas, TX'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('frisco');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Frisco, TX'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('greenville');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Greenville, SC'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('baybrook');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block double-block' },
									_react2.default.createElement(
										'div',
										{ className: 'block-header' },
										'Houston, TX'
									),
									_react2.default.createElement(
										'div',
										{ className: 'block-subheader' },
										'Baybrook'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('houston');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block double-block' },
									_react2.default.createElement(
										'div',
										{ className: 'block-header' },
										'Houston, TX'
									),
									_react2.default.createElement(
										'div',
										{ className: 'block-subheader' },
										'Galleria'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('indianapolis');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Indianapolis, IN'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('jacksonville');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Jacksonville, FL'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('kansas-city');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Kansas City, KS'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('new-orleans');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'New Orleans, LA'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('oklahoma-city');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Oklahoma City, OK'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('pittsburgh');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Pittsburgh, PA'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('raleigh');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Raleigh, NC'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('richmond');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Richmond, VA'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('st-louis');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'St. Louis, MO'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('san-antonio');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'San Antonio, TX'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('troy');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Troy, MI'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('tysons');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Tysons, VA'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'block-link', onClick: function onClick() {
										return _this2.storeNav('virginia-beach');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'location-block' },
									'Virginia Beach, VA'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'locationsFooter' },
						_react2.default.createElement(
							'div',
							{ className: 'footerLine' },
							'Want a store near you?'
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'footerLine' },
								'Drop us a '
							),
							_react2.default.createElement(
								'div',
								{ className: 'footerButton' },
								_react2.default.createElement(
									_reactMailto2.default,
									{ email: _contacts.PRIMARY_CUSTOMER_SERVICE },
									'hint'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Locations;
	}(_react2.default.Component);
	
	Locations.propTypes = {
		location: _react.PropTypes.object
	};
	Locations.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Locations;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var LocationsContainer = exports.LocationsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Locations);

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoginContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _itemValidation = __webpack_require__(17);
	
	var _auth = __webpack_require__(88);
	
	var _auth2 = __webpack_require__(219);
	
	var authConstants = _interopRequireWildcard(_auth2);
	
	var _auth3 = __webpack_require__(170);
	
	var authActionCreators = _interopRequireWildcard(_auth3);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, authActionCreators, commonActionCreators, userActionCreators);
	
	var Login = function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this.state = {
	
	      requestPending: false,
	      serverError: null,
	
	      email: '',
	      password: '',
	      emailError: null,
	      passwordError: null,
	
	      forgotMode: false
	    };
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'closeLogin',
	    value: function closeLogin() {
	      this.props.commonCloseLogin();
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      this.setState({ email: evt.target.value });
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword(evt) {
	      this.setState({ password: evt.target.value });
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail() {
	      this.setState({ emailError: (0, _itemValidation.emailValidation)(this.state.email) });
	    }
	  }, {
	    key: 'validatePassword',
	    value: function validatePassword() {
	      this.setState({ passwordError: (0, _itemValidation.passwordValidation)(this.state.password) });
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var emailError = (0, _itemValidation.emailValidation)(this.state.email);
	      var passwordError = (0, _itemValidation.passwordValidation)(this.state.password);
	
	      this.setState({
	        emailError: emailError,
	        passwordError: passwordError
	      });
	      if (emailError === null && passwordError === null) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(evt) {
	      var _this2 = this;
	
	      evt.preventDefault();
	
	      if (this.validateAll()) {
	
	        this.setState({
	          requestPending: true,
	          serverError: null
	        });
	
	        this.props.authLogin(this.state.email, this.state.password).then(function (resp) {
	          _this2.setState({
	            requestPending: false,
	            serverError: null,
	
	            email: '',
	            password: '',
	            emailError: null,
	            passwordError: null
	          }, function () {
	
	            (0, _auth.saveLogin)(resp);
	            _this2.props.authSave(resp, Date.now() + authConstants.LOGOUT_TIME);
	
	            setTimeout(function () {
	              _this2.props.userGetUser().then(function (resp) {
	
	                console.log('userGetUser');
	                console.log(resp);
	
	                _this2.props.userSaveCore(resp);
	              });
	            }, 25);
	
	            _this2.internalNav('account');
	            _this2.closeLogin();
	          });
	        }).catch(function (resp) {
	          _this2.setState({
	            requestPending: false,
	            serverError: 'Incorrect email/password combination.'
	          });
	        });
	      }
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail() {
	      var emailError = (0, _itemValidation.emailValidation)(this.state.email);
	
	      this.setState({
	        emailError: emailError
	      });
	      return emailError === null;
	    }
	  }, {
	    key: 'handleForgotSubmit',
	    value: function handleForgotSubmit(evt) {
	      var _this3 = this;
	
	      evt.preventDefault();
	
	      if (this.validateEmail()) {
	
	        this.setState({
	          requestPending: true,
	          serverError: null
	        });
	
	        this.props.userForgotPassword(this.state.email).then(function (resp) {
	          _this3.setState({
	            requestPending: false,
	            serverError: null,
	
	            email: '',
	            password: '',
	            emailError: null,
	            passwordError: null
	          });
	          _this3.props.commonAlert('If there is an account associated with this email address, we will send an email with instructions for resetting your password.', 'Continue', 'default');
	        }).catch(function (resp) {
	          _this3.setState({
	            requestPending: false,
	            serverError: null
	          });
	          _this3.props.commonAlert('If there is an account associated with this email address, we will send an email with instructions for resetting your password.', 'Continue', 'default');
	        });
	      }
	    }
	  }, {
	    key: 'handleToggle',
	    value: function handleToggle(evt) {
	      evt.stopPropagation();
	      this.props.toggleMethod();
	    }
	  }, {
	    key: 'toggleForgot',
	    value: function toggleForgot() {
	      this.setState({
	        forgotMode: !this.state.forgotMode,
	        emailError: null,
	        passwordError: null
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Login' },
	        _react2.default.createElement(
	          'div',
	          { className: 'loginClose', onClick: this.closeLogin.bind(this) },
	          _react2.default.createElement(
	            'div',
	            { className: 'closeX' },
	            '\xD7'
	          )
	        ),
	        this.state.forgotMode ? _react2.default.createElement(
	          'div',
	          { className: 'loginInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'loginTitle' },
	            'Forgot Password?'
	          ),
	          _react2.default.createElement('div', { className: 'loginHr' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'loginText' },
	            'Enter your email to reset your password, and we will send you a link to reset your password.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'loginFormWrapper' },
	            _react2.default.createElement(
	              'form',
	              { className: 'loginForm', onSubmit: this.handleForgotSubmit.bind(this) },
	              this.state.serverError ? _react2.default.createElement(
	                'div',
	                { className: 'loginFormError' },
	                this.state.serverError
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputLabel' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'authForgotEmail' },
	                    'Email'
	                  )
	                ),
	                _react2.default.createElement('input', {
	                  id: 'authForgotEmail',
	                  type: 'email',
	                  className: this.state.emailError ? 'error' : '',
	                  value: this.state.email,
	                  onChange: this.changeEmail.bind(this),
	                  onBlur: this.validateEmail.bind(this) }),
	                this.state.emailError ? _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputError' },
	                  this.state.emailError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'forgotPasswordRow' },
	                _react2.default.createElement(
	                  'span',
	                  { onClick: this.toggleForgot.bind(this) },
	                  'Back to Login'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginFormButtonWrapper' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'loginFormButton dd2ActionButton',
	                      disabled: this.state.requestPending,
	                      type: 'submit' },
	                    'Reset'
	                  )
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'loginInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'loginTitle' },
	            'Sign In'
	          ),
	          _react2.default.createElement('div', { className: 'loginHr' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'loginText' },
	            'Welcome back to Diamonds Direct please sign into your online account'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'loginFormWrapper' },
	            _react2.default.createElement(
	              'form',
	              { className: 'loginForm', onSubmit: this.handleSubmit.bind(this) },
	              this.state.serverError ? _react2.default.createElement(
	                'div',
	                { className: 'loginFormError' },
	                this.state.serverError
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputLabel' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'authEmail' },
	                    'Email'
	                  )
	                ),
	                _react2.default.createElement('input', {
	                  id: 'authEmail',
	                  type: 'email',
	                  className: this.state.emailError ? 'error' : '',
	                  value: this.state.email,
	                  onChange: this.changeEmail.bind(this),
	                  onBlur: this.validateEmail.bind(this) }),
	                this.state.emailError ? _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputError' },
	                  this.state.emailError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputLabel' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'authPass' },
	                    'Password'
	                  )
	                ),
	                _react2.default.createElement('input', {
	                  id: 'authPass',
	                  type: 'password',
	                  className: this.state.passwordError ? 'error' : '',
	                  value: this.state.password,
	                  onChange: this.changePassword.bind(this),
	                  onBlur: this.validatePassword.bind(this) }),
	                this.state.passwordError ? _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputError' },
	                  this.state.passwordError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'forgotPasswordRow' },
	                _react2.default.createElement(
	                  'span',
	                  { onClick: this.toggleForgot.bind(this) },
	                  'Forgot Password?'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginFormButtonWrapper' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'loginFormButton dd2ActionButton',
	                      disabled: this.state.requestPending,
	                      type: 'submit' },
	                    'Sign In'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'toggleArea' },
	            _react2.default.createElement(
	              'div',
	              { className: 'toggleText' },
	              'Don\'t have a Diamonds Direct online account?'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'toggleLink', onClick: this.handleToggle.bind(this) },
	              'Create an account.'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react2.default.Component);
	
	Login.propTypes = {
	  location: _react.PropTypes.object
	};
	Login.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Login;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var LoginContainer = exports.LoginContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Login);

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegisterContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _itemValidation = __webpack_require__(17);
	
	var _auth = __webpack_require__(88);
	
	var _auth2 = __webpack_require__(219);
	
	var authConstants = _interopRequireWildcard(_auth2);
	
	var _auth3 = __webpack_require__(170);
	
	var authActionCreators = _interopRequireWildcard(_auth3);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, authActionCreators, commonActionCreators, userActionCreators);
	
	var Register = function (_React$Component) {
	  _inherits(Register, _React$Component);
	
	  function Register(props) {
	    _classCallCheck(this, Register);
	
	    var _this = _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).call(this, props));
	
	    _this.state = {
	
	      requestPending: false,
	      serverError: null,
	
	      firstName: '',
	      lastName: '',
	      email: '',
	      phone: '',
	      password1: '',
	      password2: '',
	
	      firstNameError: null,
	      lastNameError: null,
	      emailError: null,
	      phoneError: null,
	      password1Error: null,
	      password2Error: null,
	
	      validationMessage: ''
	    };
	
	    _this.altMessage = 'A customer with the same email address already exists.';
	    return _this;
	  }
	
	  _createClass(Register, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'closeLogin',
	    value: function closeLogin() {
	      this.props.commonCloseLogin();
	    }
	  }, {
	    key: 'changeFirstName',
	    value: function changeFirstName(evt) {
	      this.setState({ firstName: evt.target.value });
	    }
	  }, {
	    key: 'changeLastName',
	    value: function changeLastName(evt) {
	      this.setState({ lastName: evt.target.value });
	    }
	  }, {
	    key: 'changeEmail',
	    value: function changeEmail(evt) {
	      this.setState({ email: evt.target.value });
	    }
	  }, {
	    key: 'changePhone',
	    value: function changePhone(evt) {
	      this.setState({ phone: evt.target.value });
	    }
	  }, {
	    key: 'changePassword1',
	    value: function changePassword1(evt) {
	      this.setState({ password1: evt.target.value });
	    }
	  }, {
	    key: 'changePassword2',
	    value: function changePassword2(evt) {
	      this.setState({ password2: evt.target.value });
	    }
	  }, {
	    key: 'validateFirstName',
	    value: function validateFirstName() {
	      this.setState({ firstNameError: (0, _itemValidation.nameValidation)(this.state.firstName) });
	    }
	  }, {
	    key: 'validateLastName',
	    value: function validateLastName() {
	      this.setState({ lastNameError: (0, _itemValidation.nameValidation)(this.state.lastName) });
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail() {
	      this.setState({ emailError: (0, _itemValidation.emailValidation)(this.state.email) });
	    }
	  }, {
	    key: 'validatePhone',
	    value: function validatePhone() {
	      this.setState({ phoneError: (0, _itemValidation.phoneValidation)(this.state.phone) });
	    }
	  }, {
	    key: 'validatePassword1',
	    value: function validatePassword1() {
	      this.setState({ password1Error: (0, _itemValidation.passwordValidation)(this.state.password1) });
	    }
	  }, {
	    key: 'validatePassword2',
	    value: function validatePassword2() {
	      this.setState({ password2Error: this.state.password1 == this.state.password2 ? null : 'Passwords must match' });
	    }
	  }, {
	    key: 'privacyNav',
	    value: function privacyNav() {
	      this.closeLogin();
	      this.internalNav('privacy-policy');
	    }
	  }, {
	    key: 'validateAll',
	    value: function validateAll() {
	      var firstNameError = (0, _itemValidation.nameValidation)(this.state.firstName);
	      var lastNameError = (0, _itemValidation.nameValidation)(this.state.lastName);
	      var emailError = (0, _itemValidation.emailValidation)(this.state.email);
	      var phoneError = (0, _itemValidation.phoneValidation)(this.state.phone);
	      var password1Error = (0, _itemValidation.passwordValidation)(this.state.password1);
	      var password2Error = this.state.password1 == this.state.password2 ? null : 'Passwords must match';
	
	      this.setState({
	        firstNameError: firstNameError,
	        lastNameError: lastNameError,
	        emailError: emailError,
	        phoneError: phoneError,
	        password1Error: password1Error,
	        password2Error: password2Error
	      });
	      if (firstNameError === null && lastNameError === null && emailError === null && phoneError === null && password1Error === null && password2Error === null) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(evt) {
	      var _this2 = this;
	
	      evt.preventDefault();
	
	      if (this.validateAll()) {
	
	        this.setState({
	          requestPending: true,
	          serverError: null
	        });
	
	        var firstNameDatum = this.state.firstName.replace(/[^\w\s]/gi, '');
	        var lastNameDatum = this.state.lastName.replace(/[^\w\s]/gi, '');
	        var emailDatum = this.state.email;
	        var phoneDatum = this.state.phone;
	
	        var registerData = {
	          customer: {
	            firstname: this.state.firstName,
	            lastname: this.state.lastName,
	            email: this.state.email
	          },
	          password: this.state.password1
	        };
	
	        this.props.authRegister(registerData).then(function (resp) {
	          console.log(resp);
	
	          _this2.props.authLogin(_this2.state.email, _this2.state.password1).then(function (resp) {
	            _this2.setState({
	              requestPending: false,
	              serverError: null,
	
	              firstName: '',
	              lastName: '',
	              email: '',
	              phone: '',
	              password1: '',
	              password2: '',
	
	              firstNameError: null,
	              lastNameError: null,
	              emailError: null,
	              phoneError: null,
	              password1Error: null,
	              password2Error: null,
	
	              validationMessage: ''
	            }, function () {
	              (0, _auth.saveLogin)(resp);
	              _this2.props.authSave(resp, Date.now() + authConstants.LOGOUT_TIME);
	
	              setTimeout(function () {
	
	                console.log(_this2.props);
	
	                var baseData = {
	                  firstName: firstNameDatum,
	                  lastName: lastNameDatum,
	                  email: emailDatum,
	                  phone: phoneDatum
	                };
	                _this2.props.userSetProfile(baseData).then(function (resp) {
	                  _this2.internalNav('account');
	                });
	              }, 25);
	              _this2.closeLogin();
	            });
	          });
	        }).catch(function (resp) {
	
	          var testMessage = 'A customer with the same email address already exists in an associated website.';
	
	          _this2.setState({
	            validationMessage: resp.message.includes(testMessage) ? _this2.altMessage : resp.message,
	            requestPending: false
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Register' },
	        _react2.default.createElement(
	          'div',
	          { className: 'loginClose', onClick: this.closeLogin.bind(this) },
	          _react2.default.createElement(
	            'div',
	            { className: 'closeX' },
	            '\xD7'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loginInnerWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'loginTitle' },
	            'Create an Account'
	          ),
	          _react2.default.createElement('div', { className: 'loginHr' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'loginText' },
	            'Your Diamonds Direct online account will allow you to manage your orders, addresses, and payment methods.'
	          ),
	          this.state.validationMessage ? _react2.default.createElement(
	            'div',
	            { className: 'errorMessage' },
	            this.state.validationMessage,
	            this.state.validationMessage == this.altMessage ? _react2.default.createElement(
	              'span',
	              {
	                className: 'signInLink',
	                onClick: (_context = this.props).toggleMethod.bind(_context),
	                style: {
	                  fontSize: '14px',
	                  textDecoration: 'underline',
	                  cursor: 'pointer',
	                  color: '#4B2D53',
	                  padding: '0 0 0 0',
	                  margin: '0 0 0 10px'
	                } },
	              'Sign In'
	            ) : null
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'loginFormWrapper' },
	            _react2.default.createElement(
	              'form',
	              { className: 'loginForm', onSubmit: this.handleSubmit.bind(this) },
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputLabel' },
	                  'First Name'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  className: this.state.firstNameError ? 'error' : '',
	                  value: this.state.firstName,
	                  onChange: this.changeFirstName.bind(this),
	                  onBlur: this.validateFirstName.bind(this) }),
	                this.state.firstNameError ? _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputError' },
	                  this.state.firstNameError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputLabel' },
	                  'Last Name'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  className: this.state.lastNameError ? 'error' : '',
	                  value: this.state.lastName,
	                  onChange: this.changeLastName.bind(this),
	                  onBlur: this.validateLastName.bind(this) }),
	                this.state.lastNameError ? _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputError' },
	                  this.state.lastNameError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputLabel' },
	                  'Email'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'email',
	                  className: this.state.emailError ? 'error' : '',
	                  value: this.state.email,
	                  onChange: this.changeEmail.bind(this),
	                  onBlur: this.validateEmail.bind(this) }),
	                this.state.emailError ? _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputError' },
	                  this.state.emailError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputLabel' },
	                  'Phone Number'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'phone',
	                  className: this.state.phoneError ? 'error' : '',
	                  value: this.state.phone,
	                  onChange: this.changePhone.bind(this),
	                  onBlur: this.validatePhone.bind(this) }),
	                this.state.phoneError ? _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputError' },
	                  this.state.phoneError
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputLabel' },
	                  'Password'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'password',
	                  className: this.state.password1Error ? 'error' : '',
	                  value: this.state.password1,
	                  onChange: this.changePassword1.bind(this),
	                  onBlur: this.validatePassword1.bind(this) }),
	                this.state.password1Error ? _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputError' },
	                  this.state.password1Error
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputLabel' },
	                  'Re-enter Password'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'password',
	                  className: this.state.password2Error ? 'error' : '',
	                  value: this.state.password2,
	                  onChange: this.changePassword2.bind(this),
	                  onBlur: this.validatePassword2.bind(this) }),
	                this.state.password2Error ? _react2.default.createElement(
	                  'div',
	                  { className: 'loginInputError' },
	                  this.state.password2Error
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormRow' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loginFormButtonWrapper' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'registerFormButton dd2ActionButton',
	                      disabled: this.state.requestPending,
	                      type: 'submit' },
	                    'Create Account'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'toggleArea' },
	            _react2.default.createElement(
	              'div',
	              { className: 'toggleText' },
	              'Already have a Diamonds Direct account?'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'toggleLink', onClick: (_context = this.props).toggleMethod.bind(_context) },
	              'Sign into an existing account.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'toggleLink privacyLink', onClick: this.privacyNav.bind(this) },
	              'Privacy Policy'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Register;
	}(_react2.default.Component);
	
	Register.propTypes = {
	  location: _react.PropTypes.object
	};
	Register.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Register;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var RegisterContainer = exports.RegisterContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Register);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactLazyLoadImageComponent = __webpack_require__(116);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _header = __webpack_require__(211);
	
	var headerActionCreators = _interopRequireWildcard(_header);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators, headerActionCreators, productActionCreators);
	
	var Menu = function (_React$Component) {
	  _inherits(Menu, _React$Component);
	
	  function Menu(props) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));
	
	    _this.state = {};
	
	    // Bind event listeners
	    _this.checkClick = _this.checkClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('click', this.checkClick, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.checkClick, false);
	    }
	  }, {
	    key: 'checkClick',
	    value: function checkClick(evt) {
	
	      if (window.innerWidth <= 1024) {
	        return;
	      }
	
	      if (evt.clientX < 100 && evt.clientY < 100) {
	        return;
	      }
	
	      if (this.props.header.menuOpen === true) {
	        var targetElement = evt.target;
	
	        do {
	          if (targetElement == this.menuBody || targetElement == this.subMenuBody) {
	            return;
	          }
	          targetElement = targetElement.parentNode;
	        } while (targetElement);
	
	        // This is a click outside, should close
	        this.props.headerToggle();
	      }
	    }
	  }, {
	    key: 'userNav',
	    value: function userNav(page) {
	      this.props.headerToggle();
	      // this.context.router.push('/' + page);
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      var _this2 = this;
	
	      this.props.headerToggle();
	      this.props.commonRegisterNavChange();
	      this.props.productClearFilters();
	      setTimeout(function () {
	        _this2.context.router.push('/' + page);
	      }, 25);
	    }
	  }, {
	    key: 'giftGuideNav',
	    value: function giftGuideNav() {
	      window.location.href = 'https://gifts.diamondsdirect.com';
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	      this.props.headerToggle();
	    }
	  }, {
	    key: 'getMenuClass',
	    value: function getMenuClass() {
	      return this.props.header.menuOpen ? 'Menu open' : 'Menu';
	    }
	  }, {
	    key: 'getSubmenuClass',
	    value: function getSubmenuClass() {
	      if (this.props.header.menuSubmenu === 'engagement-rings' || this.props.header.menuSubmenu === 'diamonds' || this.props.header.menuSubmenu === 'wedding-bands' || this.props.header.menuSubmenu === 'designers' || this.props.header.menuSubmenu === 'fine-jewelry' || this.props.header.menuSubmenu === 'education' || this.props.header.menuSubmenu === 'about-us') {
	        return 'menuSubmenu open';
	      } else {
	        return 'menuSubmenu';
	      }
	    }
	  }, {
	    key: 'getMenuEntryClass',
	    value: function getMenuEntryClass(submenu) {
	      return this.props.header.menuSubmenu === submenu ? 'menuEntry expanded' : 'menuEntry expandable';
	    }
	  }, {
	    key: 'openSubmenu',
	    value: function openSubmenu(submenu) {
	      if (this.props.header.menuSubmenu !== submenu) {
	        this.props.headerSelectSubmenu(submenu);
	      } else {
	        this.props.headerSelectSubmenu(null);
	      }
	    }
	  }, {
	    key: 'renderSubmenu',
	    value: function renderSubmenu() {
	      if (this.props.header.menuSubmenu === 'diamonds') {
	        return this.renderDiamonds();
	      } else if (this.props.header.menuSubmenu === 'engagement-rings') {
	        return this.renderEngagementRings();
	      } else if (this.props.header.menuSubmenu === 'wedding-bands') {
	        return this.renderWeddingBands();
	      } else if (this.props.header.menuSubmenu === 'designers') {
	        return this.renderDesigners();
	      } else if (this.props.header.menuSubmenu === 'fine-jewelry') {
	        return this.renderFineJewelry();
	      } else if (this.props.header.menuSubmenu === 'education') {
	        return this.renderEducation();
	      } else if (this.props.header.menuSubmenu === 'about-us') {
	        return this.renderAboutUs();
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderDiamonds',
	    value: function renderDiamonds() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'diamondsSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'diamondsWrapper', onClick: function onClick() {
	              return _this3.userNav('gallery/engagement-rings?mode=diamond');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'diamondsImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/diamonds.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'diamondsLabel' },
	            'Diamonds'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'diamondsWrapper', onClick: function onClick() {
	              return _this3.userNav('gallery/engagement-rings');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'diamondsImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/create.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'diamondsLabel' },
	            'Create Your Ring'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'diamondsWrapper', onClick: function onClick() {
	              return _this3.internalNav('education/diamonds');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'diamondsImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/education/diamond.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'diamondsLabel' },
	            'Diamond Education'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'diamondsWrapper', onClick: function onClick() {
	              return _this3.internalNav('education/conflict-free');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'diamondsImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/diamonds/conflictfree.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'diamondsLabel' },
	            'Conflict Free'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEngagementRings',
	    value: function renderEngagementRings() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'engagementSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'subTitle', onClick: function onClick() {
	              return _this4.internalNav('gallery/engagement-rings?mode=setting');
	            }, style: { display: 'none' } },
	          'View All Engagement Rings'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this4.internalNav('gallery/engagement-rings?settingtype=solitaire');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/solitaire.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Solitaire'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this4.internalNav('gallery/engagement-rings?settingtype=threestone');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/threestone.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Three-Stone'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this4.internalNav('gallery/engagement-rings?settingtype=pave');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/pave.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Prong & Pave'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this4.internalNav('gallery/engagement-rings');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/channel.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Channel'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this4.internalNav('gallery/engagement-rings?settingtype=halo');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/halo.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Halo'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'subTitle' },
	          'Engagement Rings'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this4.userNav('gallery/engagement-rings?mode=setting');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/settings.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Settings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this4.userNav('gallery/engagement-rings');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/create.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Create your Ring'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this4.internalNav('frequently-asked-questions');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/about-us/faq.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'FAQ'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderWeddingBands',
	    value: function renderWeddingBands() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'weddingSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'subTitle' },
	          'Wedding Bands'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bandWrapper', onClick: function onClick() {
	              return _this5.userNav('gallery/wedding-bands/womens');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'bandImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/wedding/ladiesbands.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bandLabel' },
	            'Women\'s Bands'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bandWrapper', onClick: function onClick() {
	              return _this5.userNav('gallery/wedding-bands/mens');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'bandImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/wedding/mensbands.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bandLabel' },
	            'Men\'s Bands'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDesigners',
	    value: function renderDesigners() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'designersSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'designersWrapper', onClick: function onClick() {
	              return _this6.internalNav('designers-links');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'designersImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/designers/designers.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'designersLabel' },
	            'Designers'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'designersWrapper', onClick: function onClick() {
	              return _this6.internalNav('designer/diamonds-direct-designs');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'designersImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/designers/dddesigns.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'designersLabel' },
	            'Diamonds Direct Designs'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'designersWrapper', onClick: function onClick() {
	              return _this6.internalNav('custom-design');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'designersImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/designers/custom_designs.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'designersLabel' },
	            'Custom Design'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderFineJewelry',
	    value: function renderFineJewelry() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'fineJewelrySub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'menuSectionHeader' },
	          'Classic Diamond Jewelry'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.internalNav('diamond-studs');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/diamond_studs.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamond Studs'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.internalNav('diamond-pendants');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/diamond_pendant.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamond Pendants'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.internalNav('diamond-bracelets');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/diamond_bracelet.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamond Bracelets'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.internalNav('diamond-necklaces');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/tennis_necklace.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamond Necklaces'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'menuSectionHeader' },
	          'Fashion Jewelry'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'menuSectionSubHeader' },
	          'Diamond, Gemstone, and Pearl Jewelry'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.userNav('gallery/fine-jewelry?type=ring');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_ring.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Rings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.userNav('gallery/fine-jewelry?type=earring');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_earring.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Earrings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.userNav('gallery/fine-jewelry?type=necklace');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_necklace.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Necklaces & Pendants'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.userNav('gallery/fine-jewelry?type=bracelet');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_bracelet.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Bracelets'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEducation',
	    value: function renderEducation() {
	      var _this8 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'educationSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'educationWrapper', onClick: function onClick() {
	              return _this8.internalNav('education/diamonds');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'educationImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/education/diamond.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'educationLabel' },
	            'Diamond Education'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'educationWrapper', onClick: function onClick() {
	              return _this8.internalNav('education/gems-and-pearls');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'educationImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/education/pearlandgems.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'educationLabel' },
	            'Gemstone & Pearl Education'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'educationWrapper', onClick: function onClick() {
	              return _this8.internalNav('education/metals');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'educationImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/education/metals.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'educationLabel' },
	            'Metals of Fine Jewelry'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'educationWrapper', onClick: function onClick() {
	              return _this8.internalNav('education/styles');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'educationImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/education/ringstyles.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'educationLabel' },
	            'Ring Styles'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'educationWrapper', onClick: function onClick() {
	              return _this8.openNew('https://blog.diamondsdirect.com/');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'educationImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/blog1.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'educationLabel' },
	            'Our Blog'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderAboutUs',
	    value: function renderAboutUs() {
	      var _this9 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'aboutUsSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'subTitle' },
	          'Our Difference'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this9.internalNav('about-us');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/about-us/ourstory.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Our Story'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this9.internalNav('our-heritage');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/about-us/heritage.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Our Heritage'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this9.internalNav('our-guarantees');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/about-us/promise.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Warranties & Guarantees'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ringWrapper', onClick: function onClick() {
	              return _this9.internalNav('our-foundation');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/about-us/foundation.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamonds Direct Foundation'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'changeSearch',
	    value: function changeSearch(evt) {
	      this.setState({
	        searchValue: evt.target.value
	      });
	    }
	  }, {
	    key: 'keyPressSearch',
	    value: function keyPressSearch(evt) {
	      if (evt.key === 'Enter') {
	        this.submitSearch();
	      }
	    }
	  }, {
	    key: 'submitSearch',
	    value: function submitSearch() {
	      if (this.state.searchValue !== '') {
	        this.userNav('diamonds-direct-search?p=init&q=' + this.state.searchValue);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this,
	          _context;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: this.getMenuClass(), ref: function ref(menuBody) {
	              _this10.menuBody = menuBody;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'closeIcon', onClick: (_context = this.props).headerToggle.bind(_context) },
	            _react2.default.createElement(
	              'div',
	              { className: 'closeX' },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'menuWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'logoWrapper', onClick: function onClick() {
	                  return _this10.userNav('');
	                } },
	              _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/header/ddlogo.svg', alt: 'Diamonds Direct' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getMenuEntryClass('engagement-rings'), onClick: function onClick() {
	                  return _this10.openSubmenu('engagement-rings');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Engagement Rings'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerArrow' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/menuarrow.svg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getMenuEntryClass('diamonds'), onClick: function onClick() {
	                  return _this10.openSubmenu('diamonds');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Diamonds'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerArrow' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/menuarrow.svg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getMenuEntryClass('wedding-bands'), onClick: function onClick() {
	                  return _this10.openSubmenu('wedding-bands');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Wedding Bands'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerArrow' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/menuarrow.svg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getMenuEntryClass('fine-jewelry'), onClick: function onClick() {
	                  return _this10.openSubmenu('fine-jewelry');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Fine Jewelry'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerArrow' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/menuarrow.svg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'menuEntry', onClick: function onClick() {
	                  return _this10.internalNav('gallery/mens-jewelry');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Men\'s Jewelry'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'menuEntry', onClick: function onClick() {
	                  return _this10.openNew('https://diamondsdirecttimepieces.com/');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Watches'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getMenuEntryClass('education'), onClick: function onClick() {
	                  return _this10.openSubmenu('education');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Education'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerArrow' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/menuarrow.svg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getMenuEntryClass('designers'), onClick: function onClick() {
	                  return _this10.openSubmenu('designers');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Designers'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerArrow' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/menuarrow.svg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.getMenuEntryClass('about-us'), onClick: function onClick() {
	                  return _this10.openSubmenu('about-us');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Our Difference'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerArrow' },
	                _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/menuarrow.svg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'menuEntry', onClick: function onClick() {
	                  return _this10.internalNav('frequently-asked-questions');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'FAQs'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'menuEntry', onClick: function onClick() {
	                  return _this10.internalNav('financing');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Financing'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'menuEntry', onClick: function onClick() {
	                  return _this10.internalNav('locations');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Store Locations'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'menuEntry', onClick: function onClick() {
	                  return _this10.internalNav('contact-us');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'drawerLabel' },
	                'Book Appointment'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'menuSearch', style: { display: 'none' } },
	              _react2.default.createElement('input', { type: 'text', onChange: this.changeSearch.bind(this), onKeyPress: this.keyPressSearch.bind(this), placeholder: 'Search Diamonds Direct' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'searchButton', onClick: this.submitSearch.bind(this) },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ggWrapper', style: { display: 'none' } },
	              _react2.default.createElement('div', { className: 'ggLink', onClick: this.giftGuideNav.bind(this) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'menuButton', onClick: this.openIntercom.bind(this) },
	              'Let\'s Chat'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.getSubmenuClass(), ref: function ref(subMenuBody) {
	              _this10.subMenuBody = subMenuBody;
	            } },
	          this.renderSubmenu()
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react2.default.Component);
	
	Menu.propTypes = {
	  location: _react.PropTypes.object
	};
	Menu.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Menu;
	
	
	function mapStateToProps(state) {
	  return {
	    header: state.header
	  };
	}
	
	var MenuContainer = exports.MenuContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Menu);

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MobileMenuContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactLazyLoadImageComponent = __webpack_require__(116);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _header = __webpack_require__(211);
	
	var headerActionCreators = _interopRequireWildcard(_header);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators, headerActionCreators, productActionCreators);
	
	var MobileMenu = function (_React$Component) {
	  _inherits(MobileMenu, _React$Component);
	
	  function MobileMenu(props) {
	    _classCallCheck(this, MobileMenu);
	
	    var _this = _possibleConstructorReturn(this, (MobileMenu.__proto__ || Object.getPrototypeOf(MobileMenu)).call(this, props));
	
	    _this.state = {
	      searchValue: ''
	    };
	
	    // Bind event listeners
	    _this.checkClick = _this.checkClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(MobileMenu, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.addEventListener('click', this.checkClick, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.checkClick, false);
	    }
	  }, {
	    key: 'checkClick',
	    value: function checkClick(evt) {
	
	      if (window.innerWidth > 1024) {
	        return;
	      }
	
	      if (evt.clientX < 100 && evt.clientY < 100) {
	        return;
	      }
	
	      if (this.props.header.menuOpen === true) {
	        var targetElement = evt.target;
	
	        do {
	          if (targetElement == this.menuBody) {
	            return;
	          }
	          targetElement = targetElement.parentNode;
	        } while (targetElement);
	
	        // This is a click outside, should close
	        this.props.headerToggle();
	      }
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	      this.props.headerToggle();
	    }
	  }, {
	    key: 'userNav',
	    value: function userNav(page) {
	      this.props.headerToggle();
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      var _this2 = this;
	
	      this.props.headerToggle();
	      this.props.commonRegisterNavChange();
	      this.props.productClearFilters();
	      setTimeout(function () {
	        _this2.context.router.push('/' + page);
	      }, 25);
	    }
	  }, {
	    key: 'giftGuideNav',
	    value: function giftGuideNav() {
	      window.location.href = 'https://gifts.diamondsdirect.com';
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'getMenuClass',
	    value: function getMenuClass() {
	      return this.props.header.menuOpen ? 'MobileMenu open' : 'MobileMenu';
	    }
	  }, {
	    key: 'getMenuEntryClass',
	    value: function getMenuEntryClass(submenu) {
	      return this.props.header.menuSubmenu === submenu ? 'menuEntry expanded' : 'menuEntry expandable';
	    }
	  }, {
	    key: 'openSubmenu',
	    value: function openSubmenu(submenu) {
	      if (this.props.header.menuSubmenu !== submenu) {
	        this.props.headerSelectSubmenu(submenu);
	      } else {
	        this.props.headerSelectSubmenu(null);
	      }
	    }
	  }, {
	    key: 'renderDiamonds',
	    value: function renderDiamonds() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'diamondsSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this3.userNav('gallery/engagement-rings?mode=diamond');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamonds'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this3.userNav('gallery/engagement-rings');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Create Your Ring'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this3.internalNav('education/diamonds');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamond Education'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this3.internalNav('education/conflict-free');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Conflict Free'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEngagementRings',
	    value: function renderEngagementRings() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'engagementSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this4.userNav('gallery/engagement-rings?mode=setting&style=solitaire');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/solitaire.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Solitaire Rings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this4.userNav('gallery/engagement-rings?mode=setting&style=threestone');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/threestone.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Three-Stone Rings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this4.userNav('gallery/engagement-rings?mode=setting&style=halo');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/halo.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Halo Rings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this4.userNav('gallery/engagement-rings?mode=setting&style=pave');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/pave.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Pave Rings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this4.userNav('gallery/engagement-rings?mode=setting&style=channel');
	            }, style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/engagement/channel.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Channel Rings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobileSubmenuButton', onClick: function onClick() {
	              return _this4.userNav('gallery/engagement-rings?mode=setting');
	            }, style: { display: 'none' } },
	          'View All Engagement Rings'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this4.userNav('gallery/engagement-rings?mode=setting');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Settings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this4.userNav('gallery/engagement-rings');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Create Your Ring'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderWeddingBands',
	    value: function renderWeddingBands() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'weddingSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this5.userNav('gallery/wedding-bands/womens');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/wedding/ladiesbands.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Women\'s Bands'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this5.userNav('gallery/wedding-bands/mens');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/wedding/mensbands.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Men\'s Bands'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDesigners',
	    value: function renderDesigners() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'designersSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this6.internalNav('designers-links');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Designers'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this6.internalNav('designer/diamonds-direct-designs');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamonds Direct Designs'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this6.internalNav('custom-design/');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Custom Design'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderFineJewelry',
	    value: function renderFineJewelry() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'fineJewelrySub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'mobileMenuSectionHeader' },
	          'Classic Diamond Jewelry'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper firstEntry', onClick: function onClick() {
	              return _this7.userNav('diamond-studs');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/diamond_studs.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamond Studs'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.userNav('diamond-pendants');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/diamond_pendant.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamond Pendants'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.userNav('diamond-bracelets');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/diamond_bracelet.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamond Bracelets'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.internalNav('diamond-necklaces');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/tennis_necklace.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamond Necklaces'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobileMenuSectionHeader' },
	          'Fashion Jewelry'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobileMenuSectionSubHeader' },
	          'Diamond, Gemstone, and Pearl Jewelry'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper firstEntry', onClick: function onClick() {
	              return _this7.userNav('gallery/fine-jewelry?type=ring');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_ring.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Rings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.userNav('gallery/fine-jewelry?type=earring');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_earring.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Earrings'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.userNav('gallery/fine-jewelry?type=necklace');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_necklace.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Necklaces & Pendants'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this7.userNav('gallery/fine-jewelry?type=bracelet');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringImg' },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_bracelet.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Bracelets'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEducation',
	    value: function renderEducation() {
	      var _this8 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'educationSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this8.internalNav('education/diamonds');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamond Education'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this8.internalNav('education/gems-and-pearls');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Gemstone & Pearl Education'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this8.internalNav('education/metals');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Metals of Fine Jewelry'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this8.internalNav('education/styles');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Ring Styles'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this8.openNew('https://blog.diamondsdirect.com/');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Our Blog'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderAboutUs',
	    value: function renderAboutUs() {
	      var _this9 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'aboutUsSub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this9.internalNav('about-us');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Our Story'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this9.internalNav('our-heritage');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Our Heritage'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this9.internalNav('our-guarantees');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Warranties & Guarantees'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemWrapper', onClick: function onClick() {
	              return _this9.internalNav('our-foundation');
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'ringLabel' },
	            'Diamonds Direct Foundation'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'changeSearch',
	    value: function changeSearch(evt) {
	      this.setState({
	        searchValue: evt.target.value
	      });
	    }
	  }, {
	    key: 'keyPressSearch',
	    value: function keyPressSearch(evt) {
	      if (evt.key === 'Enter') {
	        this.submitSearch();
	      }
	    }
	  }, {
	    key: 'submitSearch',
	    value: function submitSearch() {
	      if (this.state.searchValue !== '') {
	        this.userNav('diamonds-direct-search?p=init&q=' + this.state.searchValue);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this,
	          _context;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getMenuClass(), ref: function ref(menuBody) {
	            _this10.menuBody = menuBody;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'closeIcon', onClick: (_context = this.props).headerToggle.bind(_context) },
	          _react2.default.createElement(
	            'div',
	            { className: 'closeX' },
	            '\xD7'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'menuWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'logoWrapper', onClick: function onClick() {
	                return _this10.internalNav('');
	              } },
	            _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: 'https://ddw2.diamondsdirect.com/img/header/ddlogo.svg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getMenuEntryClass('engagement-rings'), onClick: function onClick() {
	                return _this10.openSubmenu('engagement-rings');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Engagement Rings'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileSubmenu' },
	              this.renderEngagementRings()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getMenuEntryClass('diamonds'), onClick: function onClick() {
	                return _this10.openSubmenu('diamonds');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Diamonds'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileSubmenu' },
	              this.renderDiamonds()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getMenuEntryClass('wedding-bands'), onClick: function onClick() {
	                return _this10.openSubmenu('wedding-bands');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Wedding Bands'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileSubmenu' },
	              this.renderWeddingBands()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getMenuEntryClass('fine-jewelry'), onClick: function onClick() {
	                return _this10.openSubmenu('fine-jewelry');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Fine Jewelry'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileSubmenu' },
	              this.renderFineJewelry()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'menuEntry', onClick: function onClick() {
	                return _this10.internalNav('gallery/mens-jewelry');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Men\'s Jewelry'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'menuEntry', onClick: function onClick() {
	                return _this10.openNew('https://diamondsdirecttimepieces.com/');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Watches'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getMenuEntryClass('education'), onClick: function onClick() {
	                return _this10.openSubmenu('education');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Education'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileSubmenu' },
	              this.renderEducation()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getMenuEntryClass('designers'), onClick: function onClick() {
	                return _this10.openSubmenu('designers');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Designers'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileSubmenu' },
	              this.renderDesigners()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.getMenuEntryClass('about-us'), onClick: function onClick() {
	                return _this10.openSubmenu('about-us');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Our Difference'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileSubmenu' },
	              this.renderAboutUs()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'menuEntry', onClick: function onClick() {
	                return _this10.internalNav('frequently-asked-questions');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'FAQs'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'menuEntry', onClick: function onClick() {
	                return _this10.internalNav('financing');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Financing'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'menuEntry', onClick: function onClick() {
	                return _this10.internalNav('locations');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Store Locations'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'menuEntry', onClick: function onClick() {
	                return _this10.internalNav('contact-us');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'mobileLabel' },
	              'Book Appointment'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'menuSearch', style: { display: 'none' } },
	            _react2.default.createElement('input', { type: 'text', onChange: this.changeSearch.bind(this), onKeyPress: this.keyPressSearch.bind(this), placeholder: 'Search' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'searchButton', onClick: this.submitSearch.bind(this) },
	              _react2.default.createElement('i', { className: 'fas fa-search' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ggWrapper', style: { display: 'none' } },
	            _react2.default.createElement('div', { className: 'ggLink', onClick: this.giftGuideNav.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'menuButton', onClick: this.openIntercom.bind(this) },
	            'Let\'s Chat'
	          )
	        )
	      );
	    }
	  }]);
	
	  return MobileMenu;
	}(_react2.default.Component);
	
	MobileMenu.propTypes = {
	  location: _react.PropTypes.object
	};
	MobileMenu.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = MobileMenu;
	
	
	function mapStateToProps(state) {
	  return {
	    header: state.header
	  };
	}
	
	var MobileMenuContainer = exports.MobileMenuContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(MobileMenu);

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductPageContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _product = __webpack_require__(42);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	var _GalleryBreadcrumbs = __webpack_require__(313);
	
	var _ProductSettingBanner = __webpack_require__(567);
	
	var _ProductDiamondBanner = __webpack_require__(563);
	
	var _ProductJewelryBanner = __webpack_require__(566);
	
	var _ProductDetails = __webpack_require__(562);
	
	var _ProductDetails2 = _interopRequireDefault(_ProductDetails);
	
	var _ProductDiamondCarat = __webpack_require__(564);
	
	var _ProductDiamondCarat2 = _interopRequireDefault(_ProductDiamondCarat);
	
	var _ProductSimilarSetting = __webpack_require__(570);
	
	var _ProductSimilarSetting2 = _interopRequireDefault(_ProductSimilarSetting);
	
	var _ProductSimilarDiamond = __webpack_require__(569);
	
	var _ProductSimilarDiamond2 = _interopRequireDefault(_ProductSimilarDiamond);
	
	var _ProductSettingPairs = __webpack_require__(568);
	
	var _ProductSettingPairs2 = _interopRequireDefault(_ProductSettingPairs);
	
	var _ProductDiamondsDirectDifference = __webpack_require__(565);
	
	var _ProductDiamondsDirectDifference2 = _interopRequireDefault(_ProductDiamondsDirectDifference);
	
	var _ProductSocial = __webpack_require__(571);
	
	var _RhinoLoading = __webpack_require__(47);
	
	var _RhinoLoading2 = _interopRequireDefault(_RhinoLoading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators, userActionCreators);
	
	var ProductPage = function (_React$Component) {
	  _inherits(ProductPage, _React$Component);
	
	  function ProductPage(props) {
	    _classCallCheck(this, ProductPage);
	
	    var _this = _possibleConstructorReturn(this, (ProductPage.__proto__ || Object.getPrototypeOf(ProductPage)).call(this, props));
	
	    var diamondPage = _this.props.route.product_type == 'diamond';
	    var settingPage = _this.props.route.product_type == 'setting';
	    var jewelryPage = _this.props.route.product_type == 'jewelry';
	
	    _this.state = {
	      isDiamondPage: diamondPage,
	      isSettingPage: settingPage,
	      isJewelryPage: jewelryPage,
	      detailsOpen: false,
	
	      diamondDetails: null,
	      settingDetails: null,
	      jewelryDetails: null,
	
	      jewelryType: null
	    };
	
	    if (_this.state.isDiamondPage) {
	
	      _this.props.productFetchDiamondById(_this.props.params.lookupKey).then(function (respData) {
	        _this.setState({ diamondDetails: respData });
	      });
	    } else if (_this.state.isSettingPage) {
	
	      _this.props.productFetchBySku(_this.props.params.lookupKey).then(function (respData) {
	        _this.setState({ settingDetails: respData.success });
	      });
	    } else if (_this.state.isJewelryPage) {
	
	      _this.props.productFetchBySku(_this.props.params.lookupKey).then(function (respData) {
	        console.log(respData.success);
	        _this.setState({
	          jewelryDetails: respData.success,
	          jewelryType: respData.success && respData.success.attributes && respData.success.attributes.type && respData.success.attributes.type.includes('GTS ') ? 'mens' : null
	        });
	      });
	    }
	    return _this;
	  }
	
	  _createClass(ProductPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.user.wishlists === null) {
	        this.props.userGetWishlists().then(function (respData) {
	          _this2.props.userSaveWishlists(respData.wishlists);
	        });
	      }
	    }
	  }, {
	    key: 'getProductDetails',
	    value: function getProductDetails() {
	
	      var detail_list = [];
	
	      if (!this.state.settingDetails) {
	        return detail_list;
	      }
	
	      var styleString = '';
	      if (this.state.settingDetails && this.state.settingDetails.attributes && this.state.settingDetails.attributes.style) {
	        styleString = this.state.settingDetails.attributes.style;
	      }
	
	      // console.log(this.state.settingDetails);
	      // console.log(this.state.settingDetails.style);
	
	      var respArray = [{
	        key: 'SKU',
	        value: this.state.settingDetails && this.state.settingDetails.sku ? this.state.settingDetails.sku : ''
	      }, {
	        key: 'Designer',
	        value: this.state.settingDetails && this.state.settingDetails.vendor && this.state.settingDetails.vendor.name ? (0, _product.designerFormatName)(this.state.settingDetails.vendor.name) : ''
	      }, {
	        key: 'Type',
	        value: this.state.settingDetails && this.state.settingDetails.attributes && this.state.settingDetails.attributes.settingtype ? this.state.settingDetails.attributes.settingtype : ''
	      }];
	
	      if (this.state.settingDetails.ttw_dia && parseFloat(this.state.settingDetails.ttw_dia) > 0) {
	        respArray.push({
	          key: 'Diamond CW',
	          value: this.state.settingDetails ? this.state.settingDetails.ttw_dia + ' Ct' : ''
	        });
	      }
	      if (this.state.settingDetails.tty_gem && parseFloat(this.state.settingDetails.tty_gem) > 0) {
	        respArray.push({
	          key: 'Gem CW',
	          value: this.state.settingDetails ? this.state.settingDetails.tty_gem + ' Ct' : ''
	        });
	      }
	      if (this.state.settingDetails.length && parseFloat(this.state.settingDetails.length) > 0 && this.state.settingDetails.length_units) {
	        respArray.push({
	          key: 'Length',
	          value: this.state.settingDetails ? this.state.settingDetails.length.toFixed(1) + ' ' + this.state.settingDetails.length_units.toLowerCase() : ''
	        });
	      }
	      if (this.state.settingDetails.stone1_csw && parseFloat(this.state.settingDetails.stone1_csw) > 0) {
	        respArray.push({
	          key: 'CSW',
	          value: this.state.settingDetails ? this.state.settingDetails.stone1_csw + ' Ct' : ''
	        });
	      }
	
	      return respArray;
	    }
	  }, {
	    key: 'getDiamondDetails',
	    value: function getDiamondDetails() {
	
	      if (!this.state.diamondDetails) {
	        return [];
	      }
	
	      if (this.state.diamondDetails.shape === 'Round') {
	        return [{
	          key: 'DIAMOND ID',
	          value: this.state.diamondDetails.id
	        }, {
	          key: 'CUT',
	          value: this.state.diamondDetails.cut
	        }, {
	          key: 'CARAT WEIGHT',
	          value: parseFloat(this.state.diamondDetails.caratWeight).toFixed(2).toString()
	        }, {
	          key: 'POLISH',
	          value: this.state.diamondDetails.polish
	        }, {
	          key: 'COLOR',
	          value: this.state.diamondDetails.color
	        }, {
	          key: 'SYMMETRY',
	          value: this.state.diamondDetails.symmetry
	        }, {
	          key: 'CLARITY',
	          value: this.state.diamondDetails.clarity
	        }, {
	          key: 'FLUORESCENCE',
	          value: this.state.diamondDetails.fluorescence
	        }, {
	          key: 'MEASUREMENTS',
	          value: this.state.diamondDetails.measurement
	        }, {
	          key: 'CERTIFICATION',
	          value: this.state.diamondDetails.lab
	        }];
	      } else {
	        return [{
	          key: 'DIAMOND ID',
	          value: this.state.diamondDetails.id
	        }, {
	          key: 'CARAT WEIGHT',
	          value: parseFloat(this.state.diamondDetails.caratWeight).toFixed(2).toString()
	        }, {
	          key: 'POLISH',
	          value: this.state.diamondDetails.polish
	        }, {
	          key: 'COLOR',
	          value: this.state.diamondDetails.color
	        }, {
	          key: 'SYMMETRY',
	          value: this.state.diamondDetails.symmetry
	        }, {
	          key: 'CLARITY',
	          value: this.state.diamondDetails.clarity
	        }, {
	          key: 'FLUORESCENCE',
	          value: this.state.diamondDetails.fluorescence
	        }, {
	          key: 'MEASUREMENTS',
	          value: this.state.diamondDetails.measurement
	        }, {
	          key: 'CERTIFICATION',
	          value: this.state.diamondDetails.lab
	        }];
	      }
	    }
	  }, {
	    key: 'getJewelryDetails',
	    value: function getJewelryDetails() {
	
	      if (!this.state.jewelryDetails) {
	        return [];
	      }
	
	      var respArray = [{
	        key: 'SKU',
	        value: this.state.jewelryDetails && this.state.jewelryDetails.sku ? this.state.jewelryDetails.sku : ''
	      }, {
	        key: 'Designer',
	        value: this.state.jewelryDetails && this.state.jewelryDetails.vendor && this.state.jewelryDetails.vendor.name ? (0, _product.designerFormatName)(this.state.jewelryDetails.vendor.name) : ''
	      }];
	
	      if (this.state.jewelryDetails.attributes && this.state.jewelryDetails.attributes.diameter) {
	        respArray.push({
	          key: 'Diameter',
	          value: this.state.jewelryDetails.attributes.diameter.charAt(0).toUpperCase() + this.state.jewelryDetails.attributes.diameter.slice(1).toLowerCase()
	        });
	      }
	      if (this.state.jewelryDetails.ttw_dia && parseFloat(this.state.jewelryDetails.ttw_dia) > 0) {
	        respArray.push({
	          key: 'Diamond CW',
	          value: this.state.jewelryDetails ? this.state.jewelryDetails.ttw_dia + ' Ct' : ''
	        });
	      }
	      if (this.state.jewelryDetails.tty_gem && parseFloat(this.state.jewelryDetails.tty_gem) > 0) {
	        respArray.push({
	          key: 'Gem CW',
	          value: this.state.jewelryDetails ? this.state.jewelryDetails.tty_gem + ' Ct' : ''
	        });
	      }
	      if (this.state.jewelryDetails.length && parseFloat(this.state.jewelryDetails.length) > 0 && this.state.jewelryDetails.length_units) {
	        respArray.push({
	          key: 'Length',
	          value: this.state.jewelryDetails ? this.state.jewelryDetails.length.toFixed(1) + ' ' + this.state.jewelryDetails.length_units.toLowerCase() : ''
	        });
	      }
	      if (this.state.jewelryDetails.stone1_csw && parseFloat(this.state.jewelryDetails.stone1_csw) > 0) {
	        respArray.push({
	          key: 'CSW',
	          value: this.state.jewelryDetails ? this.state.jewelryDetails.stone1_csw + ' Ct' : ''
	        });
	      }
	
	      return respArray;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'renderBannerSection',
	    value: function renderBannerSection() {
	      if (this.state.isSettingPage) {
	        return _react2.default.createElement(_ProductSettingBanner.ProductSettingBannerContainer, { scrollMethod: this.scrollToDDDifference.bind(this), productData: this.state.settingDetails });
	      } else if (this.state.isDiamondPage) {
	        return _react2.default.createElement(_ProductDiamondBanner.ProductDiamondBannerContainer, { scrollMethod: this.scrollToDDDifference.bind(this), productData: this.state.diamondDetails });
	      } else if (this.state.isJewelryPage) {
	        return _react2.default.createElement(_ProductJewelryBanner.ProductJewelryBannerContainer, { scrollMethod: this.scrollToDDDifference.bind(this), productData: this.state.jewelryDetails });
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderDetailsSection',
	    value: function renderDetailsSection() {
	      if (this.state.isSettingPage) {
	        return _react2.default.createElement(_ProductDetails2.default, { details: this.getProductDetails(), diamondDetails: false });
	      } else if (this.state.isDiamondPage) {
	        return _react2.default.createElement(_ProductDetails2.default, { details: this.getDiamondDetails(), diamondDetails: true });
	      } else {
	        return _react2.default.createElement(_ProductDetails2.default, { details: this.getJewelryDetails(), diamondDetails: false, genericPage: true });
	      }
	    }
	  }, {
	    key: 'renderSimilarSection',
	    value: function renderSimilarSection() {
	      if (this.state.isSettingPage) {
	        // return <ProductSimilarSetting />;
	        return null;
	      } else if (this.state.isDiamondPage) {
	        // return <ProductSimilarDiamond />;
	        return null;
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'scrollToDDDifference',
	    value: function scrollToDDDifference() {
	      (0, _reactScrollToComponent2.default)(this.diffSection, {
	        offset: 0,
	        align: 'middle',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'haveProductData',
	    value: function haveProductData() {
	      if (this.state.isDiamondPage && this.state.diamondDetails !== null) {
	        return true;
	      }
	      if (this.state.isSettingPage && this.state.settingDetails !== null) {
	        return true;
	      }
	      if (this.state.isJewelryPage && this.state.jewelryDetails !== null) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProductPage' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_GalleryBreadcrumbs.GalleryBreadcrumbsContainer, {
	            hideResultCount: true,
	            productPage: true,
	            productType: this.state.jewelryType ? this.state.jewelryType : this.props.route.product_type,
	            productName: this.state.isDiamondPage ? 'Diamond' : 'Setting' })
	        ),
	        this.haveProductData() ? _react2.default.createElement(
	          'div',
	          { className: 'productPageWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bannerSectionWrapper' },
	            this.renderBannerSection()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'detailSectionWrapper' },
	            this.renderDetailsSection()
	          ),
	          this.state.isDiamondPage && false ? _react2.default.createElement(
	            'div',
	            { className: 'caratSectionWrapper' },
	            _react2.default.createElement(_ProductDiamondCarat2.default, { shape: this.state.diamondDetails.shape, carat_weight: this.state.diamondDetails.caratWeight })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'similarSectionWrapper' },
	            this.renderSimilarSection()
	          ),
	          this.state.isSettingPage && false ? _react2.default.createElement(
	            'div',
	            { className: 'pairsSectionWrapper' },
	            _react2.default.createElement(_ProductSettingPairs2.default, null)
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'differenceWrapper', ref: function ref(div) {
	                _this3.diffSection = div;
	              } },
	            _react2.default.createElement(_ProductDiamondsDirectDifference2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'socialWrapper' },
	            _react2.default.createElement(_ProductSocial.ProductSocialContainer, null)
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'productPageWrapper' },
	          _react2.default.createElement(_RhinoLoading2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return ProductPage;
	}(_react2.default.Component);
	
	ProductPage.propTypes = {
	  location: _react.PropTypes.object
	};
	ProductPage.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductPage;
	
	
	function mapStateToProps(state) {
	  return {
	    user: state.user
	  };
	}
	
	var ProductPageContainer = exports.ProductPageContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductPage);

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductDetailsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var ProductDetails = function (_React$Component) {
	  _inherits(ProductDetails, _React$Component);
	
	  function ProductDetails(props) {
	    _classCallCheck(this, ProductDetails);
	
	    var _this = _possibleConstructorReturn(this, (ProductDetails.__proto__ || Object.getPrototypeOf(ProductDetails)).call(this, props));
	
	    _this.state = {
	      expanded: _this.props.diamondDetails
	    };
	    return _this;
	  }
	
	  _createClass(ProductDetails, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'toggleExpanded',
	    value: function toggleExpanded() {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  }, {
	    key: 'getSectionTitle',
	    value: function getSectionTitle() {
	      if (this.props.diamondDetails) {
	        return 'Diamond Details';
	      } else if (this.props.genericPage) {
	        return 'Jewelry Details';
	      } else {
	        return 'Setting Details';
	      }
	    }
	  }, {
	    key: 'getGetSettingImgUrl',
	    value: function getGetSettingImgUrl() {
	
	      var typevalue = null;
	      for (var i = 0; i < this.props.details.length; i++) {
	        if (this.props.details[i].key == 'Type') {
	          typevalue = this.props.details[i].value;
	          break;
	        }
	      }
	
	      if (!typevalue) {
	        return 'solitaire_1.svg';
	      }
	
	      switch (typevalue) {
	        case 'SOLITAIRE':
	          return 'solitaire_1.svg';
	        case '3-STONE':
	          return 'three_stone_1.svg';
	        case 'HALO':
	          return 'halo_1.svg';
	        case 'DIAMOND ACCENTED':
	          return 'pave_1.svg';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProductDetails' },
	        _react2.default.createElement(
	          'div',
	          { className: 'detailsHeader', onClick: this.toggleExpanded.bind(this) },
	          _react2.default.createElement(
	            'div',
	            { className: 'headerLabel' },
	            this.getSectionTitle()
	          ),
	          this.state.expanded ? _react2.default.createElement(
	            'div',
	            { className: 'headerIcon' },
	            '\u2014'
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'headerIcon' },
	            '+'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.expanded ? 'detailsBody expanded' : 'detailsBody' },
	          !this.props.diamondDetails && !this.props.genericPage ? _react2.default.createElement(
	            'div',
	            { className: 'detailSettingDiagram' },
	            _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/details/' + this.getGetSettingImgUrl() })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: this.props.diamondDetails ? 'detailBodyWrapper diamondDetail' : 'detailBodyWrapper settingDetail' },
	            this.props.details.map(function (deet, i) {
	              return _react2.default.createElement(
	                'div',
	                { className: _this2.props.diamondDetails ? 'detailItem diamondDetail' : 'detailItem settingDetail', key: i },
	                _this2.props.diamondDetails ? _react2.default.createElement(
	                  'div',
	                  { className: 'detailLabel' },
	                  deet.key
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'detailLabel' },
	                  deet.key,
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'detailValue' },
	                  deet.value
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductDetails;
	}(_react2.default.Component);
	
	ProductDetails.propTypes = {
	  location: _react.PropTypes.object
	};
	ProductDetails.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductDetails;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ProductDetailsContainer = exports.ProductDetailsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductDetails);

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductDiamondBannerContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _formatting = __webpack_require__(21);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators, productActionCreators);
	
	var ProductDiamondBanner = function (_React$Component) {
	  _inherits(ProductDiamondBanner, _React$Component);
	
	  function ProductDiamondBanner(props) {
	    _classCallCheck(this, ProductDiamondBanner);
	
	    var _this = _possibleConstructorReturn(this, (ProductDiamondBanner.__proto__ || Object.getPrototypeOf(ProductDiamondBanner)).call(this, props));
	
	    _this.state = {
	      nextStepsOpen: false,
	      inCart: false,
	
	      hkOOS: false
	    };
	    return _this;
	  }
	
	  _createClass(ProductDiamondBanner, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.productData.vendor == 'HK') {
	        this.props.productHkDiamondAvailability(this.props.productData.stockNo).then(function (resp) {
	          try {
	            var respJson = JSON.parse(decodeURI(resp));
	            if (respJson.Data && respJson.Data[0]) {
	              if (respJson.Data[0]['Status'] === "NotAvailable") {
	                _this2.setState({
	                  hkOOS: true
	                });
	              }
	            }
	          } catch (err) {
	            console.error(err);
	          }
	        }).catch(function (errResp) {
	          console.error(errResp);
	        });
	      }
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'toggleNextSteps',
	    value: function toggleNextSteps() {
	      this.setState({ nextStepsOpen: !this.state.nextStepsOpen });
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'getShippingDate',
	    value: function getShippingDate() {
	
	      var DIAMOND_LEAD_DAYS = 46;
	      var today = new Date();
	
	      today.setDate(today.getDate() + DIAMOND_LEAD_DAYS);
	      return today;
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart() {
	      var _this3 = this;
	
	      this.setState({ inCart: true });
	
	      var shapeString = this.props.productData.shape;
	
	      this.props.cartAddDiamond(this.props.productData.stockNo, this.props.productData.price, shapeString.toLowerCase().trim(), (0, _formatting.diamondCartDesc)(this.props.productData)).then(function (resp) {
	        console.log(resp);
	        _this3.externalNav('checkout/cart');
	      }).catch(function (resp) {
	        _this3.setState({ inCart: false });
	      });
	    }
	  }, {
	    key: 'addSetting',
	    value: function addSetting() {
	      this.props.productSelectDiamond(this.props.productData);
	      this.internalNav('gallery/engagement-rings?view=results&tabtype=setting');
	    }
	  }, {
	    key: 'backToResults',
	    value: function backToResults() {
	      var pageNum = this.props.product.currentPage ? this.props.product.currentPage : 1;
	      this.internalNav('gallery/engagement-rings?view=results&currentPage=' + pageNum + '&tabtype=diamond');
	    }
	  }, {
	    key: 'isOutOfStock',
	    value: function isOutOfStock() {
	      if (this.props.productData && this.props.productData.status && this.props.productData.status === 3) {
	        return true;
	      }
	      if (this.state.hkOOS) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'getSimilarLink',
	    value: function getSimilarLink() {
	
	      var caratMin = parseFloat(this.props.productData.caratWeight).toFixed(2).toString();
	      var caratMax = (1.1 * parseFloat(this.props.productData.caratWeight)).toFixed(2).toString();
	      var color = this.props.productData.color.toUpperCase();
	      var clarity = this.props.productData.clarity;
	      var shape = this.props.productData.shape.toLowerCase();
	
	      return 'gallery/engagement-rings?mode=diamond&caratMin=' + caratMin + '&caratMax=' + caratMax + '&color=' + color + '&clarityMin=' + clarity + '&clarityMax=' + clarity + '&shape=' + shape;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      if (!this.props.productData) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProductDiamondBanner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'imageSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'primaryImageWrapper' },
	            _react2.default.createElement('img', { src: this.props.productData.image })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'thumbnailsWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'thumbWrapper', style: { display: 'none' } },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/dview_thumb1.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'thumbWrapper' },
	              _react2.default.createElement('img', { src: this.props.productData.image })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'thumbWrapper', style: { display: 'none' } },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/dview_thumb3.jpg' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'descriptionSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'diamondTitle' },
	            (0, _formatting.diamondTitle)(this.props.productData)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'priceWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'priceSign' },
	              '$'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'priceValue' },
	              this.isOutOfStock() ? '-' : this.props.productData.price.toLocaleString()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'priceNotice' },
	            '(diamond\xA0\xA0only)'
	          ),
	          this.isOutOfStock() ? _react2.default.createElement(
	            'div',
	            { className: 'oosNotice' },
	            'This diamond is no longer available. ',
	            _react2.default.createElement(
	              'span',
	              { className: 'oosLink', onClick: function onClick() {
	                  return _this4.internalNav(_this4.getSimilarLink());
	                } },
	              'Find something similar?'
	            )
	          ) : null,
	          this.state.inCart ? _react2.default.createElement(
	            'div',
	            { className: 'nextStepsInCart' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
	              '\xA0\xA0\xA0Adding to Cart'
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'nextStepsWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'nextStepsElement', onClick: this.toggleNextSteps.bind(this) },
	              _react2.default.createElement(
	                'div',
	                { className: 'nextStepsHead' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nextStepsLabel' },
	                  'Next Steps'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nextStepsIcon' },
	                  _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/down.svg' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.nextStepsOpen ? 'nextStepsBody open' : 'nextStepsBody' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nextStepsBodyWrapper' },
	                  !this.isOutOfStock() ? _react2.default.createElement(
	                    'div',
	                    { className: 'nextStepsItem', onClick: function onClick() {
	                        return _this4.addToCart();
	                      } },
	                    'Add to Cart'
	                  ) : null,
	                  !this.isOutOfStock() ? _react2.default.createElement(
	                    'div',
	                    { className: 'nextStepsItem', onClick: function onClick() {
	                        return _this4.addSetting();
	                      } },
	                    'Add to Ring'
	                  ) : null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'nextStepsItem', onClick: function onClick() {
	                        return _this4.backToResults();
	                      } },
	                    'Back to Results'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'nextStepsItem', onClick: function onClick() {
	                        return _this4.internalNav('contact-us');
	                      } },
	                    'Request an Appointment'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'shippingInfoWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'shippingDateLine', style: { display: 'none' } },
	              'Estimated Shipping Date: ',
	              (0, _formatting.displayDateFromDate)(this.getShippingDate())
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shippingContactLine', style: { display: 'none' } },
	              'Need it sooner?\xA0',
	              _react2.default.createElement(
	                'span',
	                { className: 'clickableText', onClick: this.openIntercom.bind(this) },
	                'Speak to an Expert'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shippingFreeLine' },
	              'Free shipping and free lifetime jewelry care with every purchase -\xA0',
	              _react2.default.createElement(
	                'span',
	                { className: 'clickableText', onClick: function onClick() {
	                    return _this4.props.scrollMethod();
	                  } },
	                'Learn More'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'actionsWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'actionItem', style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'actionIcon hint' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/hint.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actionLabel' },
	                'Drop a Hint'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'actionItem', onClick: function onClick() {
	                  return _this4.internalNav('contact-us');
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'actionIcon' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/consult.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actionLabel' },
	                'Consult an Expert'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'actionItem', style: { display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'actionIcon' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/wishlist.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actionLabel' },
	                'Add to Wishlist'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductDiamondBanner;
	}(_react2.default.Component);
	
	ProductDiamondBanner.propTypes = {
	  location: _react.PropTypes.object
	};
	ProductDiamondBanner.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductDiamondBanner;
	
	
	function mapStateToProps(state) {
	  return {
	    product: state.product,
	    user: state.user
	  };
	}
	
	var ProductDiamondBannerContainer = exports.ProductDiamondBannerContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductDiamondBanner);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductDiamondCaratContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var ProductDiamondCarat = function (_React$Component) {
	  _inherits(ProductDiamondCarat, _React$Component);
	
	  function ProductDiamondCarat(props) {
	    _classCallCheck(this, ProductDiamondCarat);
	
	    var _this = _possibleConstructorReturn(this, (ProductDiamondCarat.__proto__ || Object.getPrototypeOf(ProductDiamondCarat)).call(this, props));
	
	    _this.state = {
	      expanded: false
	    };
	
	    console.log(_this.props);
	    return _this;
	  }
	
	  _createClass(ProductDiamondCarat, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'toggleExpanded',
	    value: function toggleExpanded() {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  }, {
	    key: 'getDiamondUrl',
	    value: function getDiamondUrl() {
	
	      if (!this.props.shape) {
	        return '';
	      }
	
	      switch (this.props.shape) {
	        case 'Round':
	          return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/round.svg';
	        case 'Princess':
	          return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/princess.svg';
	        case 'Cushion':
	          return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/cushion.svg';
	        case 'Emerald':
	          return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/emerald.svg';
	        case 'Radiant':
	          return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/radiant.svg';
	        case 'Oval':
	          return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/oval.svg';
	        case 'Pear':
	          return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/pear.svg';
	        case 'Asscher':
	          return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/asscher.svg';
	        case 'Marquise':
	          return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/marquis.svg';
	        default:
	          return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/round.svg';
	      }
	    }
	  }, {
	    key: 'getSliderOffset',
	    value: function getSliderOffset() {
	      if (this.props.carat_weight >= 5) {
	        return '100';
	      } else {
	        var rangeSpan = 5 - 0.2;
	        var percent = this.props.carat_weight / rangeSpan * 100;
	        return percent.toString() + '%';
	      }
	    }
	  }, {
	    key: 'getDiamondSize',
	    value: function getDiamondSize() {
	
	      // Image size: 600x700px;
	      // Ring diameter: 12px;
	
	      // let bandWidth = 1.8mm;
	      // let oneCtWidth = 6.5mm;
	
	      // d = 6.5(cw)^1.5
	
	      // 6.5 = a(cw)^(2/3)
	
	      // 2r
	
	      // 4/3 pi r^3 = cw
	
	
	      // 0.75*cw = pi r^3
	
	      // 2(0.25*cw)^1/3 = 2r
	
	
	      var widthMM = 6.25 * Math.pow(this.props.carat_weight, 0.33333333);
	
	      // 1mm = 1.1111111%    
	      return (widthMM * 1.11111).toString() + '%';
	    }
	  }, {
	    key: 'getDiamondRadius',
	    value: function getDiamondRadius() {
	      var widthMM = 6.25 * Math.pow(this.props.carat_weight, 0.33333333);
	      return (widthMM * 1.11111 / 2).toString() + '%';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      if (!this.props.shape || !this.props.carat_weight) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProductDiamondCarat' },
	        _react2.default.createElement(
	          'div',
	          { className: 'caratHeader', onClick: this.toggleExpanded.bind(this) },
	          _react2.default.createElement(
	            'div',
	            { className: 'headerLabel' },
	            'Diamond Carat Size Guide'
	          ),
	          this.state.expanded ? _react2.default.createElement(
	            'div',
	            { className: 'headerIcon' },
	            '\u2014'
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'headerIcon' },
	            '+'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.expanded ? 'caratBodyWrapper expanded' : 'caratBodyWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'handSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'handImgWrapper' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/hand_2.svg' }),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'diamondImgWrapper',
	                  style: {
	                    width: this.getDiamondSize(),
	                    height: this.getDiamondSize(),
	                    top: 'calc(55.0% - ' + this.getDiamondRadius() + ')',
	                    left: 'calc(36% - ' + this.getDiamondRadius() + ')'
	                  } },
	                _react2.default.createElement('img', { src: this.getDiamondUrl() })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sliderSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'caratSliderWrapper' },
	              _react2.default.createElement('div', { className: 'caratSliderTrack' }),
	              _react2.default.createElement('div', { className: 'caratSliderElement', style: { left: this.getSliderOffset() } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'caratSliderLabelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'labelLeft' },
	                '0.2 Ct'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'labelCurrent', style: { left: 'calc(' + this.getSliderOffset() + ' - 20px)' } },
	                this.props.carat_weight + ' Ct'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'labelRight' },
	                '5 Ct'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'caratTextWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'caratText' },
	                'Diamond carat weight is the measurement of how much a diamond weighs. A metric \u201Ccarat\u201D is defined as 200 mg. Each carat can be subdivided into 100 points. This allows very precise measurements.'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductDiamondCarat;
	}(_react2.default.Component);
	
	ProductDiamondCarat.propTypes = {
	  location: _react.PropTypes.object
	};
	ProductDiamondCarat.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductDiamondCarat;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ProductDiamondCaratContainer = exports.ProductDiamondCaratContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductDiamondCarat);

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductDiamondsDirectDifferenceContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var ProductDiamondsDirectDifference = function (_React$Component) {
	  _inherits(ProductDiamondsDirectDifference, _React$Component);
	
	  function ProductDiamondsDirectDifference(props) {
	    _classCallCheck(this, ProductDiamondsDirectDifference);
	
	    var _this = _possibleConstructorReturn(this, (ProductDiamondsDirectDifference.__proto__ || Object.getPrototypeOf(ProductDiamondsDirectDifference)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ProductDiamondsDirectDifference, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProductDiamondsDirectDifference', onClick: function onClick() {
	            return _this2.internalNav('our-guarantees');
	          }, style: { cursor: 'pointer' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'differenceTitle' },
	          'The Diamonds Direct Difference'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'differenceBrWrapper' },
	          _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/iconline.svg' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'differencesWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'differenceItem' },
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/upgrade.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceItemTitle' },
	              '110% Lifetime Upgrade'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceText' },
	              'Trade in your original engagement diamond, solitaire diamond pendant or diamond studs and get 110% of your original purchase toward your new purchase!'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'differenceItem' },
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/warranty.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceItemTitle' },
	              'Lifetime Warranty'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceText' },
	              'With every Diamonds Direct purchase you\u2019ll receive lifetime coverage on routine jewelry maintenance.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'differenceItem' },
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/care.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceItemTitle' },
	              'Free Lifetime Jewelry Care'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceText' },
	              'Your purchase includes complimentary jewelry care for life, including free cleanings, prong tightening, rhodium plating and more!'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'differenceItem' },
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/appraisal.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceItemTitle' },
	              'Certificate & Appraisal'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceText' },
	              'All purchases over $1,000 will include an appraisal for insurance purchases. In addition, a GIA certificate will accompany all GIA diamond purchases.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'differenceItem' },
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/shipping.svg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceItemTitle' },
	              'Free Shipping'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'differenceText' },
	              'FREE, secure, insured shipping with FedEx hassle-free returns for 30 days.'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductDiamondsDirectDifference;
	}(_react2.default.Component);
	
	ProductDiamondsDirectDifference.propTypes = {
	  location: _react.PropTypes.object
	};
	ProductDiamondsDirectDifference.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductDiamondsDirectDifference;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ProductDiamondsDirectDifferenceContainer = exports.ProductDiamondsDirectDifferenceContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductDiamondsDirectDifference);

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ProductJewelryBannerContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _formatting = __webpack_require__(21);
	
	var _auth = __webpack_require__(88);
	
	var _product = __webpack_require__(42);
	
	var _url = __webpack_require__(56);
	
	var _ringsizes = __webpack_require__(153);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators, commonActionCreators, userActionCreators);
	
	var ProductJewelryBanner = function (_React$Component) {
		_inherits(ProductJewelryBanner, _React$Component);
	
		function ProductJewelryBanner(props) {
			_classCallCheck(this, ProductJewelryBanner);
	
			var _this = _possibleConstructorReturn(this, (ProductJewelryBanner.__proto__ || Object.getPrototypeOf(ProductJewelryBanner)).call(this, props));
	
			var ringLabel = [{
				display: 'Size',
				value: ''
			}];
	
			_this.state = {
				addingToCart: false,
				nextStepsOpen: false,
				wgOpen: false,
				ygOpen: false,
				rgOpen: false,
				imageIndex: 0,
	
				limitedSizeData: ringLabel.concat(_ringsizes.limitedSizes),
				ringSizeData: ringLabel.concat(_ringsizes.ringSizes),
				ringSizeDataMen: ringLabel.concat(_ringsizes.ringSizesMen),
				ringSizeDataWomen: ringLabel.concat(_ringsizes.ringSizesWomen),
				eternitySizeData: ringLabel.concat(_ringsizes.eternitySizes),
	
				ringSize: _this.props.product && _this.props.product.attrSize ? _this.props.product.attrSize : '',
				metalType: _this.props.product && _this.props.product.attrMetal ? _this.props.product.attrMetal : '',
				validationMessage: '',
	
				wishlistExpanded: false,
				selectedWishlistId: null,
				wishlistValidation: null,
				wishlistRequestPending: false,
	
				metalPriceDiff: _this.props.product && _this.props.product.attrMetal ? (0, _product.calcChildMetalMarkup)(_this.props.productData, _this.props.product.attrMetal) : 0
			};
			return _this;
		}
	
		_createClass(ProductJewelryBanner, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.hasNoMetal()) {
					this.setState({
						metalType: 'NOMETAL',
						metalPriceDiff: 0
					});
				}
	
				// Code to trick try me to show up
				// if(window.location.host.indexOf('staging') >= 0) {
				try {
					if (cls_InovaDiamonds_Iframe) {
						cls_InovaDiamonds_Iframe.clear_Data_715();
						cls_InovaDiamonds_Iframe.init_Session();
					}
				} catch (err) {
					console.error(err);
				}
				// }
			}
		}, {
			key: 'getMetalTypeOptions',
			value: function getMetalTypeOptions() {
				if (!this.props.productData || !this.props.productData.price || !this.props.productData.attributes) {
					return [];
				}
				return (0, _product.getMetalTypeChildDropdownData)(this.props.productData);
			}
	
			// Product Type Reference
			// const allTypes = [
			// 		'LDS WED BAND',
			// 		'GTS WED BAND',
			// 		'RING',
			// 		'EARRING',
			// 		'NECKLACE',
			// 		'BRACELET'
			// 	];
	
		}, {
			key: 'needsMetalType',
			value: function needsMetalType() {
	
				// const needsMetalType = [
				// 	'LDS WED BAND',
				// ];
	
				// if(this.props.productData && this.props.productData.attributes.type && needsMetalType.includes(this.props.productData.attributes.type)) {
				// 	return true;
				// }
				// return false;
	
				return true;
			}
		}, {
			key: 'needsRingSize',
			value: function needsRingSize() {
	
				var needsRingSize = ['LDS WED BAND', 'GTS WED BAND', 'RING', 'GTS RING'];
	
				if (this.props.productData && this.props.productData.attributes.type && needsRingSize.includes(this.props.productData.attributes.type)) {
					return true;
				}
				return false;
			}
		}, {
			key: 'getRingSize',
			value: function getRingSize() {
				var mensSizes = ['GTS WED BAND', 'GTS RING'];
	
				if (this.props.productData && this.props.productData.attributes.type && mensSizes.includes(this.props.productData.attributes.type)) {
					return this.state.ringSizeDataMen;
				} else {
					return this.state.ringSizeDataWomen;
				}
				return this.state.ringSizeData;
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'toggleNextSteps',
			value: function toggleNextSteps() {
				this.setState({ nextStepsOpen: !this.state.nextStepsOpen });
			}
		}, {
			key: 'toggleWgOpen',
			value: function toggleWgOpen() {
				var _this2 = this;
	
				this.setState({ wgOpen: !this.state.wgOpen }, function () {
					if (_this2.state.wgOpen) {
						_this2.setState({
							ygOpen: false,
							rgOpen: false
						});
					}
				});
			}
		}, {
			key: 'toggleYgOpen',
			value: function toggleYgOpen() {
				var _this3 = this;
	
				this.setState({ ygOpen: !this.state.ygOpen }, function () {
					if (_this3.state.ygOpen) {
						_this3.setState({
							wgOpen: false,
							rgOpen: false
						});
					}
				});
			}
		}, {
			key: 'toggleRgOpen',
			value: function toggleRgOpen() {
				var _this4 = this;
	
				this.setState({ rgOpen: !this.state.rgOpen }, function () {
					if (_this4.state.rgOpen) {
						_this4.setState({
							wgOpen: false,
							ygOpen: false
						});
					}
				});
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'setImageIndex',
			value: function setImageIndex(idx) {
				this.setState({ imageIndex: idx });
			}
		}, {
			key: 'getShippingDate',
			value: function getShippingDate() {
	
				var SETTING_LEAD_DAYS = 15;
				var today = new Date();
	
				today.setDate(today.getDate() + SETTING_LEAD_DAYS);
				return today;
			}
		}, {
			key: 'getProductName',
			value: function getProductName() {
				if (!this.props.productData || !this.props.productData.name) {
					return '';
				} else {
					var pName = this.props.productData.name;
					return pName.replace(/Ã©/g, 'é');
				}
			}
		}, {
			key: 'getProductDescription',
			value: function getProductDescription() {
				if (!this.props.productData || !this.props.productData.description) {
					return '';
				} else {
					var desc = this.props.productData.description;
					return desc.replace(/Ã©/g, 'é');
				}
			}
		}, {
			key: 'getProductPrice',
			value: function getProductPrice() {
				// if(!this.props.productData || !this.props.productData.price) {
				// 	return '';
				// } else {
				// 	return (parseInt(this.props.productData.price) + parseInt(this.state.metalPriceDiff));
				// }
				if (!(0, _product.getMinPrice)(this.props.productData)) {
					return '';
				} else {
					return parseInt((0, _product.getMinPrice)(this.props.productData)) + parseInt(this.state.metalPriceDiff);
				}
			}
		}, {
			key: 'getProductMedia',
			value: function getProductMedia() {
	
				// console.log(!this.props.productData);
				// console.log(this.props.productData.image_count <= 0);
				// console.log(!this.props.productData || this.props.productData.image_count <= 0);
	
	
				if (!this.props.productData || this.props.productData.image_count <= 0) {
					return [];
				} else {
					var images = [];
					for (var i = 0; i < this.props.productData.image_count; i++) {
						images.push('https://dd2-temp-img.s3.amazonaws.com/' + this.props.productData.sku + '/' + i + '.jpg');
						if (i >= 10) {
							break;
						}
					}
	
					if (this.props.productData.video_count) {
						for (var j = 0; j < this.props.productData.video_count; j++) {
							images.push('https://dd2-temp-img.s3.amazonaws.com/' + this.props.productData.sku + '/' + j + '.mp4');
							if (j >= 10) {
								break;
							}
						}
					}
	
					return images;
				}
			}
		}, {
			key: 'getMetalKarat',
			value: function getMetalKarat(setting) {
				if (!setting) {
					return 14;
				}
				var setVal = setting.karat;
				if (setting.attributes) {
					setVal = setting.attributes.karat;
				}
				if (!setVal) {
					setVal = 14;
				}
				return setVal;
			}
		}, {
			key: 'getJewelryDesc',
			value: function getJewelryDesc() {
	
				if (!this.props.productData || !this.props.productData.attributes) {
					return '';
				}
	
				if (this.props.productData.attributes && this.props.productData.attributes.type == 'LDS WED BAND') {
					return (0, _formatting.womensBandDescription)(this.props.productData, this.state.metalType, this.state.ringSize);
				} else if (this.props.productData.attributes.type == 'GTS WED BAND') {
					return (0, _formatting.mensBandDescription)(this.props.productData, this.state.metalType, this.state.ringSize);
				} else if (this.props.productData.attributes.type == 'RING' || this.props.productData.attributes.type == 'GTS RING') {
					return (0, _formatting.fashionRingCartDesc)(this.props.productData, this.state.metalType, this.state.ringSize);
				} else {
					return (0, _formatting.fashionCartDesc)(this.props.productData, this.state.metalType);
				}
			}
		}, {
			key: 'hasNoPrice',
			value: function hasNoPrice(product) {
	
				if (!this.props.productData || !this.props.productData.attributes) {
					return false;
				}
	
				var noPriceSkus = ['CUSTM00001', 'CUSTM00002', 'CUSTM00003', 'CUSTM00004', 'CUSTM00005', 'CUSTM00006', 'CUSTM00007', 'CUSTM00008', 'CUSTM00009', 'CUSTM00010', 'CUSTM00011', 'CUSTM00012', 'CUSTM00013', 'CUSTM00014', 'CUSTM00015', 'CUSTM00016', 'CUSTM00020', 'CUSTM00021', 'CUSTM00022', 'CUSTM00027', 'CUSTM00028', 'CUSTM00029', 'CUSTM00030'];
	
				return noPriceSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'hasNoMetal',
			value: function hasNoMetal(product) {
	
				if (!this.props.productData || !this.props.productData.attributes) {
					return false;
				}
	
				var noMetalSkus = ['PRL8N00018', 'PRL6N00146', 'CUSTM00001', 'CUSTM00002', 'CUSTM00003', 'CUSTM00004', 'CUSTM00005', 'CUSTM00006', 'CUSTM00007', 'CUSTM00008', 'CUSTM00009', 'CUSTM00010', 'CUSTM00011', 'CUSTM00012', 'CUSTM00013', 'CUSTM00014', 'CUSTM00015', 'CUSTM00016', 'CUSTM00020', 'CUSTM00021', 'CUSTM00022', 'CUSTM00027', 'CUSTM00028', 'CUSTM00029', 'CUSTM00030'];
	
				return noMetalSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'hasAltMessage001',
			value: function hasAltMessage001() {
				if (!this.props.productData || !this.props.productData.attributes) {
					return false;
				}
	
				var altMessage = ['E4FAN00110', 'E4FAN00077', 'E4FAN00033'];
	
				return altMessage.includes(this.props.productData.sku);
			}
		}, {
			key: 'addToCart',
			value: function addToCart() {
				var _this5 = this;
	
				var sendMetalType = this.needsMetalType();
				// const sendRingSize = this.needsRingSize();
	
				if (this.hasNoMetal()) {
					this.setState({
						metalType: 'NOMETAL',
						metalPriceDiff: 0
					});
				}
	
				if (this.needsMetalType() && !this.state.metalType && !this.hasNoMetal()) {
					this.setState({ validationMessage: 'Please select a metal type' });
					return;
				}
	
				if (this.needsRingSize() && !this.state.ringSize) {
					this.setState({ validationMessage: 'Please select a ring size' });
					return;
				}
	
				this.setState({ addingToCart: true });
	
				if (sendMetalType || this.props.productData.attributes.type == 'RING' || this.props.productData.attributes.type == 'GTS RING') {
	
					var markup = !this.hasNoMetal() ? parseInt((0, _product.calcChildMetalMarkup)(this.props.productData, this.state.metalType)) : 0;
					var basePrice = (0, _product.getMinPrice)(this.props.productData);
					var desc = this.getJewelryDesc(this.props.productData, this.state.metalType, this.state.ringSize);
	
					// function cartAddMetalSize(sku, metalType, ringSize, metalBase, metalMod)
					this.props.cartAddMetalSize(this.props.productData.sku, this.state.metalType, this.state.ringSize, this.getMetalKarat(this.props.productData), markup, basePrice, desc).then(function (resp) {
						console.log(resp);
						_this5.externalNav('checkout/cart');
					}).catch(function (errResp) {
						_this5.setState({ addingToCart: false });
					});
				} else {
	
					this.props.cartGuestAddItem(this.props.productData.sku, this.getJewelryDesc(), this.getProductPrice()).then(function (resp) {
						console.log(resp);
						_this5.externalNav('checkout/cart');
					}).catch(function (errResp) {
						_this5.setState({ addingToCart: false });
					});
				}
			}
		}, {
			key: 'addDiamond',
			value: function addDiamond() {
				this.props.productSelectSetting(this.props.productData);
				this.internalNav('gallery/engagement-rings');
			}
		}, {
			key: 'changeMetalType',
			value: function changeMetalType(evt) {
				var _this6 = this;
	
				this.setState({
					metalType: evt.target.value,
					validationMessage: ''
				}, function () {
					var priceDiff = (0, _product.calcChildMetalMarkup)(_this6.props.productData, _this6.state.metalType);
					_this6.setState({ metalPriceDiff: priceDiff });
				});
			}
		}, {
			key: 'changeRingSize',
			value: function changeRingSize(evt) {
				this.setState({
					ringSize: evt.target.value,
					validationMessage: ''
				});
			}
		}, {
			key: 'addToWishlist',
			value: function addToWishlist() {
				if ((0, _auth.isLoggedIn)()) {
					this.toggleWishlist();
				} else {
					this.props.commonOpenLogin();
				}
			}
		}, {
			key: 'toggleWishlist',
			value: function toggleWishlist() {
				var _this7 = this;
	
				this.setState({
					wishlistExpanded: !this.state.wishlistExpanded
					// wishlistRequestPending: false,
				}, function () {
					if (_this7.state.wishlistExpanded) {
						_this7.setState({ wishlistRequestPending: false });
					}
				});
			}
		}, {
			key: 'changeWishlist',
			value: function changeWishlist(evt) {
				if (evt.target.value == 'create') {
					this.internalNav('account');
				} else {
					this.setState({ selectedWishlistId: evt.target.value });
				}
			}
		}, {
			key: 'saveAddToWishlist',
			value: function saveAddToWishlist() {
				var _this8 = this;
	
				if (!this.state.selectedWishlistId) {
					this.setState({ wishlistValidation: 'Please select a wishlist' });
				}
	
				this.setState({ wishlistRequestPending: true });
				this.props.userWishlistAddItem(this.state.selectedWishlistId, this.props.productData.sku).then(function (resp) {
	
					_this8.props.commonAlert('Added to wishlist!', 'Continue', 'default');
					_this8.toggleWishlist();
					// this.setState({ wishlistRequestPending: false });
	
					_this8.props.userGetWishlists().then(function (respData) {
						_this8.props.userSaveWishlists(respData.wishlists);
					});
				});
			}
		}, {
			key: 'getWishlistList',
			value: function getWishlistList() {
				var dropdownData = (0, _formatting.formatDropdownData)(this.props.user.wishlists, 'name', 'id', 'Select Wishlist');
				var createElement = {
					display: 'Create New Wishlist',
					value: 'create'
				};
				return dropdownData.concat(createElement);
			}
		}, {
			key: 'getRoyalTNotice',
			value: function getRoyalTNotice() {
	
				if (!this.props.productData || !this.props.productData.sku) {
					return '';
				}
	
				var royalSkus = ['SMDPL06228', 'SMDPL06540', 'SMDPL06537', 'SMDPL06539', 'SMDPL13016', 'SMDPL13017', 'SMDPL13018', 'SMDPL10951'];
	
				return royalSkus.includes(this.props.productData.sku) ? 'Minimum 2 carat center stone required' : '';
			}
		}, {
			key: 'hasEternitySize',
			value: function hasEternitySize() {
				if (!this.props.productData || !this.props.productData.sku) {
					return '';
				}
	
				var sizeSkus = ['BLDXL09033', 'BLDLG07535', 'BLDMD16242', 'BLDXL09325', 'BLDXL09326', 'BLDXL09353', 'BLDXL09354', 'BLDLG07493', 'BLDLG10577', 'BLDMD22544', 'BLDMD22546', 'BLDSM15215', 'BLDSM15216', 'BLDSM19811', 'BLDXL09335', 'BLDMD19310', 'BLDMD20797', 'BLDLG00689', 'BLDXL05912', 'BLDXL06711', 'BLDLG00539', 'BLDLG00870', 'BLDLG00916', 'BLDMD03842', 'BLDXL05775', 'BLDLG01719', 'BLDMD02500', 'BLDXL01568', 'BLDXL02985', 'BLDXL05597', 'BLDMD19733', 'BLDXL12439', 'BLDSM16887', 'BDSAP01562', 'BDSAP03470', 'BDSAP03473', 'BDSAP03498', 'BLDLG05316', 'BLDLG09879', 'BLDSM02317', 'BLDXL11509', 'BLDXL16381', 'BLDMD17662', 'BLDXL19649', 'BLDXL19655', 'BLDXL19663', 'BLDXL19679', 'BLDXL19683', 'BLDXL19687', 'BLDXL19689', 'BLDXL19700', 'BLDXL19696', 'BLDXL19708', 'BLDXL19714', 'BLDXL19716', 'BLDXL19719', 'BLDXL19720', 'BLDLG15370', 'BLDMD31667', 'BLDXL11675', 'BDSAP03475', 'BLDXL17019', 'BDSAP03501', 'BDSAP05496', 'BDSAP03496', 'BDSAP04925'];
	
				return sizeSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'hasLimitedSize',
			value: function hasLimitedSize() {
				if (!this.props.productData || !this.props.productData.sku) {
					return '';
				}
	
				var sizeSkus = ['BLDXL19696', 'BLDXL19700', 'BLDXL19708', 'BLDXL19714', 'BLDXL19716', 'BLDXL19719', 'BLDXL19720', 'BLDXL19649', 'BLDXL19655', 'BLDXL19679', 'BLDXL19663', 'BLDXL19683', 'BLDXL19687', 'BLDXL19689', 'BLDMD16242', 'BLDXL09325', 'BLDLG07535', 'BLDXL09353', 'BLDXL09354', 'BLDXL09326'];
				return sizeSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'altSizeMessage',
			value: function altSizeMessage() {
				if (!this.props.productData || !this.props.productData.sku) {
					return '';
				}
	
				var sizeSkus = ['BLDMD16242', 'BLDXL09325', 'BLDLG07535', 'BLDXL09353', 'BLDXL09354', 'BLDXL09326'];
				return sizeSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'skipMetalType',
			value: function skipMetalType() {
				if (!this.props.productData || !this.props.productData.sku) {
					return '';
				}
	
				var skipSkus = ['PRL6N00146'];
				return skipSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'getSizeNotice',
			value: function getSizeNotice() {
	
				var hasLimited = this.hasLimitedSize();
				var isEternity = this.hasEternitySize();
				var altMessage = this.altSizeMessage();
				var altMessage2 = this.hasAltMessage001();
	
				if (altMessage2) {
					return 'The total carat weight may vary up to 5%. The average color range is G-I, and the average clarity range is SI1-SI2.';
				}
	
				if (altMessage) {
					return 'Total carat weight and number of diamonds varies by finger size. If the size you need is not listed, please chat with a virtual sales associate.';
				}
	
				if (hasLimited) {
					return 'Total carat weight and number of diamonds varies by finger size. The quality of the diamonds is H-I color and VS clarity. If the size you need is not listed, please chat with a virtual sales associate.';
				}
	
				if (isEternity) {
					return 'Total carat weight and number of diamonds varies by finger size. If the size you need is not listed, please chat with a virtual sales associate.';
				}
	
				return '';
			}
		}, {
			key: 'getMainMedia',
			value: function getMainMedia() {
				if (this.isMediaVideo(this.getProductMedia()[this.state.imageIndex])) {
					return _react2.default.createElement(
						'video',
						{ autoPlay: true, playsInline: true, muted: 'muted', loop: true },
						_react2.default.createElement('source', { src: this.getProductMedia()[this.state.imageIndex], type: 'video/mp4' })
					);
				} else {
					return _react2.default.createElement('img', { src: this.getProductMedia()[this.state.imageIndex] });
				}
			}
		}, {
			key: 'getThumbMedia',
			value: function getThumbMedia(srcStr) {
	
				if (!srcStr) {
					return null;
				}
	
				if (this.isMediaVideo(srcStr)) {
					return _react2.default.createElement(
						'span',
						null,
						_react2.default.createElement('img', { src: srcStr.replace('.mp4', '.jpg') }),
						_react2.default.createElement(
							'div',
							{ className: 'playWrapper' },
							_react2.default.createElement('i', { className: 'fas fa-play' })
						)
					);
				} else {
					return _react2.default.createElement('img', { src: srcStr });
				}
			}
		}, {
			key: 'isMediaVideo',
			value: function isMediaVideo(srcStr) {
				return srcStr ? srcStr.includes('.mp4') : false;
			}
		}, {
			key: 'getRingSizeList',
			value: function getRingSizeList() {
				if (this.hasEternitySize()) {
					return this.state.eternitySizeData;
				}
				if (this.hasLimitedSize()) {
					return this.state.limitedSizeData;
				}
				return this.getRingSize();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'ProductJewelryBanner' },
					_react2.default.createElement(
						'div',
						{ className: 'imageSection' },
						_react2.default.createElement(
							'div',
							{ className: 'primaryImageWrapper' },
							this.getProductMedia().length > this.state.imageIndex ? _react2.default.createElement(
								'span',
								null,
								this.getMainMedia()
							) : null
						),
						_react2.default.createElement(
							'div',
							{ className: 'thumbnailsWrapper' },
							this.getProductMedia().map(function (img, j) {
								return _react2.default.createElement(
									'div',
									{ className: 'thumbWrapper', onClick: function onClick() {
											return _this9.setImageIndex(j);
										}, key: j },
									_react2.default.createElement(
										'span',
										null,
										_this9.getThumbMedia(img)
									)
								);
							})
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'descriptionSection' },
						_react2.default.createElement(
							'div',
							{ className: 'settingTitle' },
							this.getProductName()
						),
						_react2.default.createElement(
							'div',
							{ className: 'settingDescription' },
							this.getProductDescription()
						),
						this.getRoyalTNotice() ? _react2.default.createElement(
							'div',
							{ className: 'settingRoyalTNotice' },
							this.getRoyalTNotice()
						) : null,
						this.getSizeNotice() ? _react2.default.createElement(
							'div',
							{ className: 'settingRoyalTNotice' },
							this.getSizeNotice()
						) : null,
						_react2.default.createElement(
							'div',
							{ className: 'settingConfigWrapper' },
							this.state.validationMessage ? _react2.default.createElement(
								'div',
								{ className: 'configError' },
								this.state.validationMessage
							) : null,
							this.needsMetalType() && !this.hasNoMetal() ? _react2.default.createElement(
								'div',
								{ className: this.needsRingSize() ? 'metalTypeOptions' : 'metalTypeOptions singleOption' },
								_react2.default.createElement(_RhinoSelect2.default, {
									options: this.getMetalTypeOptions(),
									value: this.state.metalType,
									changeMethod: this.changeMetalType.bind(this),
									rootClass: 'productSelect' })
							) : null,
							this.needsRingSize() ? _react2.default.createElement(
								'div',
								{ className: 'ringSizeSelect' },
								_react2.default.createElement(_RhinoSelect2.default, {
									options: this.getRingSizeList(),
									value: this.state.ringSize,
									changeMethod: this.changeRingSize.bind(this),
									rootClass: 'productSelect' })
							) : null
						),
						_react2.default.createElement(
							'div',
							{ className: 'priceWrapper', style: { display: this.hasNoPrice() ? 'none' : 'block' } },
							_react2.default.createElement(
								'div',
								{ className: 'priceSign' },
								'$'
							),
							_react2.default.createElement(
								'div',
								{ className: 'priceValue' },
								this.getProductPrice().toLocaleString()
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'priceNotice', style: { display: 'none' } },
							'Price\xA0\xA0is\xA0\xA0for\xA0\xA0setting\xA0\xA0only'
						),
						this.state.addingToCart ? _react2.default.createElement(
							'div',
							{ className: 'nextStepsInCart' },
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
								'\xA0\xA0\xA0Adding to Cart'
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'nextStepsWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'nextStepsElement', onClick: this.toggleNextSteps.bind(this) },
								_react2.default.createElement(
									'div',
									{ className: 'nextStepsHead' },
									_react2.default.createElement(
										'div',
										{ className: 'nextStepsLabel' },
										'Next Steps'
									),
									_react2.default.createElement(
										'div',
										{ className: 'nextStepsIcon' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/down.svg' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: this.state.nextStepsOpen ? 'nextStepsBody open' : 'nextStepsBody' },
									_react2.default.createElement(
										'div',
										{ className: 'nextStepsBodyWrapper' },
										_react2.default.createElement(
											'div',
											{ className: 'nextStepsItem', onClick: function onClick() {
													return _this9.addToCart();
												} },
											'Add to Cart'
										),
										_react2.default.createElement(
											'div',
											{ className: 'nextStepsItem', onClick: function onClick() {
													return _this9.internalNav('contact-us');
												} },
											'Request an Appointment'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'shippingInfoWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'shippingDateLine', style: { display: 'none' } },
								'Estimated Shipping Date: ',
								(0, _formatting.displayDateFromDate)(this.getShippingDate())
							),
							_react2.default.createElement(
								'div',
								{ className: 'shippingContactLine', style: { display: 'none' } },
								'Need it sooner?\xA0',
								_react2.default.createElement(
									'span',
									{ className: 'clickableText', onClick: this.openIntercom.bind(this) },
									'Speak to an Expert'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'shippingFreeLine' },
								'Free shipping and free lifetime jewelry care with every purchase -\xA0',
								_react2.default.createElement(
									'span',
									{ className: 'clickableText', onClick: function onClick() {
											return _this9.props.scrollMethod();
										} },
									'Learn More'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'actionsWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'actionItem', style: { display: 'none' } },
								_react2.default.createElement(
									'div',
									{ className: 'actionIcon hint' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/hint.svg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'actionLabel' },
									'Drop a Hint'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'actionItem', onClick: function onClick() {
										return _this9.internalNav('contact-us');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'actionIcon' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/consult.svg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'actionLabel' },
									'Consult an Expert'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'actionItem', onClick: this.addToWishlist.bind(this) },
								_react2.default.createElement(
									'div',
									{ className: 'actionIcon' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/wishlist.svg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'actionLabel' },
									'Add to Wishlist'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: this.state.wishlistExpanded ? 'wishlistConfigs expanded' : 'wishlistConfigs' },
							this.props.user.wishlists !== null ? _react2.default.createElement(
								'div',
								null,
								this.props.user.wishlists.length === 0 ? _react2.default.createElement(
									'div',
									{ className: 'noWishlistPrompt' },
									_react2.default.createElement(
										'div',
										{ className: 'nwText' },
										'No wishlists created'
									),
									_react2.default.createElement(
										'div',
										{ className: 'nwButton', onClick: function onClick() {
												return _this9.internalNav('account');
											} },
										'Create'
									)
								) : _react2.default.createElement(
									'div',
									{ className: 'selectWishlistPrompt' },
									this.state.wishlistValidation ? _react2.default.createElement(
										'div',
										{ className: 'wlPrompt' },
										this.state.wishlistValidation
									) : null,
									_react2.default.createElement(
										'div',
										{ className: 'selectPrompt' },
										'Add to which wishlist?'
									),
									_react2.default.createElement(
										'div',
										{ className: 'selectWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											options: this.getWishlistList(),
											value: this.state.selectedWishlistId,
											changeMethod: this.changeWishlist.bind(this),
											rootClass: 'productSelect' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'selectButtonWrapper', style: { display: this.state.wishlistRequestPending ? 'inline-block' : 'none' } },
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
											'\xA0\xA0\xA0Adding to Wishlist'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'selectButtonWrapper', onClick: this.saveAddToWishlist.bind(this), style: { display: this.state.wishlistRequestPending ? 'none' : 'inline-block' } },
										_react2.default.createElement(
											'div',
											null,
											'Add to Wishlist'
										)
									)
								)
							) : null
						)
					)
				);
			}
		}]);
	
		return ProductJewelryBanner;
	}(_react2.default.Component);
	
	ProductJewelryBanner.propTypes = {
		location: _react.PropTypes.object
	};
	ProductJewelryBanner.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductJewelryBanner;
	
	
	function mapStateToProps(state) {
		return {
			user: state.user
		};
	}
	
	var ProductJewelryBannerContainer = exports.ProductJewelryBannerContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductJewelryBanner);

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ProductSettingBannerContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _formatting = __webpack_require__(21);
	
	var _auth = __webpack_require__(88);
	
	var _product = __webpack_require__(42);
	
	var _url = __webpack_require__(56);
	
	var _ringsizes = __webpack_require__(153);
	
	var _cart = __webpack_require__(55);
	
	var cartActionCreators = _interopRequireWildcard(_cart);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _product2 = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product2);
	
	var _user = __webpack_require__(64);
	
	var userActionCreators = _interopRequireWildcard(_user);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, cartActionCreators, commonActionCreators, productActionCreators, userActionCreators);
	
	var ProductSettingBanner = function (_React$Component) {
		_inherits(ProductSettingBanner, _React$Component);
	
		function ProductSettingBanner(props) {
			_classCallCheck(this, ProductSettingBanner);
	
			var _this = _possibleConstructorReturn(this, (ProductSettingBanner.__proto__ || Object.getPrototypeOf(ProductSettingBanner)).call(this, props));
	
			var ringLabel = [{
				display: 'Size',
				value: ''
			}];
	
			_this.state = {
				addingToCart: false,
				nextStepsOpen: false,
				wgOpen: false,
				ygOpen: false,
				rgOpen: false,
				imageIndex: 0,
	
				ringSizeData: ringLabel.concat(_ringsizes.ringSizesWomen),
				limitedSizeData: ringLabel.concat(_ringsizes.limitedSizes),
				eternitySizeData: ringLabel.concat(_ringsizes.eternitySizes),
	
				ringSize: _this.props.product && _this.props.product.attrSize ? _this.props.product.attrSize : '',
				metalType: _this.props.product && _this.props.product.attrMetal ? _this.props.product.attrMetal : '',
				validationMessage: '',
	
				wishlistExpanded: false,
				selectedWishlistId: null,
				wishlistValidation: null,
				wishlistRequestPending: false,
	
				metalPriceDiff: _this.props.product && _this.props.product.attrMetal ? (0, _product.calcChildMetalMarkup)(_this.props.productData, _this.props.product.attrMetal) : 0
			};
			return _this;
		}
	
		_createClass(ProductSettingBanner, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				// Code to trick try me to show up
				// if(window.location.host.indexOf('staging') >= 0) {
				try {
					if (cls_InovaDiamonds_Iframe) {
						cls_InovaDiamonds_Iframe.clear_Data_715();
						cls_InovaDiamonds_Iframe.init_Session();
					}
				} catch (err) {
					console.error(err);
				}
				// }
			}
		}, {
			key: 'getMetalTypeOptions',
			value: function getMetalTypeOptions() {
				if (!this.props.productData || !this.props.productData.price || !this.props.productData.attributes) {
					return [];
				}
				return (0, _product.getMetalTypeChildDropdownData)(this.props.productData);
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'changeMetalType',
			value: function changeMetalType(evt) {
				var _this2 = this;
	
				this.setState({
					metalType: evt.target.value,
					validationMessage: ''
				}, function () {
	
					var priceDiff = (0, _product.calcChildMetalMarkup)(_this2.props.productData, _this2.state.metalType);
					console.log(priceDiff);
	
					_this2.setState({ metalPriceDiff: priceDiff });
				});
			}
		}, {
			key: 'changeRingSize',
			value: function changeRingSize(evt) {
				this.setState({
					ringSize: evt.target.value,
					validationMessage: ''
				});
			}
		}, {
			key: 'toggleNextSteps',
			value: function toggleNextSteps() {
				this.setState({ nextStepsOpen: !this.state.nextStepsOpen });
			}
		}, {
			key: 'toggleWgOpen',
			value: function toggleWgOpen() {
				var _this3 = this;
	
				this.setState({ wgOpen: !this.state.wgOpen }, function () {
					if (_this3.state.wgOpen) {
						_this3.setState({
							ygOpen: false,
							rgOpen: false
						});
					}
				});
			}
		}, {
			key: 'toggleYgOpen',
			value: function toggleYgOpen() {
				var _this4 = this;
	
				this.setState({ ygOpen: !this.state.ygOpen }, function () {
					if (_this4.state.ygOpen) {
						_this4.setState({
							wgOpen: false,
							rgOpen: false
						});
					}
				});
			}
		}, {
			key: 'toggleRgOpen',
			value: function toggleRgOpen() {
				var _this5 = this;
	
				this.setState({ rgOpen: !this.state.rgOpen }, function () {
					if (_this5.state.rgOpen) {
						_this5.setState({
							wgOpen: false,
							ygOpen: false
						});
					}
				});
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'setImageIndex',
			value: function setImageIndex(idx) {
				this.setState({ imageIndex: idx });
			}
		}, {
			key: 'getShippingDate',
			value: function getShippingDate() {
	
				var SETTING_LEAD_DAYS = 15;
				var today = new Date();
	
				today.setDate(today.getDate() + SETTING_LEAD_DAYS);
				return today;
			}
		}, {
			key: 'getProductName',
			value: function getProductName() {
				if (!this.props.productData || !this.props.productData.name) {
					return '';
				} else {
					var pName = this.props.productData.name;
					return pName.replace(/Ã©/g, 'é');
				}
			}
		}, {
			key: 'getProductDescription',
			value: function getProductDescription() {
				if (!this.props.productData || !this.props.productData.description) {
					return '';
				} else {
					var desc = this.props.productData.description;
					return desc.replace(/Ã©/g, 'é');
				}
			}
		}, {
			key: 'getProductPrice',
			value: function getProductPrice() {
				if (!(0, _product.getMinPrice)(this.props.productData)) {
					return '';
				} else {
					return parseInt((0, _product.getMinPrice)(this.props.productData)) + parseInt(this.state.metalPriceDiff);
				}
			}
		}, {
			key: 'getMetalBase',
			value: function getMetalBase() {
				return this.props.productData.attributes.karat ? this.props.productData.attributes.karat : 14;
			}
		}, {
			key: 'getProductMedia',
			value: function getProductMedia() {
	
				// console.log(this.props.productData);
				// console.log(this.props.productData.image_count <= 0);
				// console.log(!this.props.productData || this.props.productData.image_count <= 0);
	
	
				if (!this.props.productData || this.props.productData.image_count <= 0) {
					return [];
				} else {
					var images = [];
					for (var i = 0; i < this.props.productData.image_count; i++) {
						images.push('https://dd2-temp-img.s3.amazonaws.com/' + this.props.productData.sku + '/' + i + '.jpg');
					}
	
					if (this.props.productData.video_count) {
						for (var j = 0; j < this.props.productData.video_count; j++) {
							images.push('https://dd2-temp-img.s3.amazonaws.com/' + this.props.productData.sku + '/' + j + '.mp4');
						}
					}
	
					return images;
				}
			}
		}, {
			key: 'addToCart',
			value: function addToCart() {
				var _this6 = this;
	
				if (!this.state.metalType) {
					this.setState({ validationMessage: 'Please select a metal type' });
					return;
				}
	
				if (!this.state.ringSize) {
					this.setState({ validationMessage: 'Please select a ring size' });
					return;
				}
	
				this.setState({ addingToCart: true });
	
				// sku, metalType, ringSize, metalBase, metalMod
				this.props.cartAddMetalSize(this.props.productData.sku, this.state.metalType, this.state.ringSize, this.getMetalBase(), this.state.metalPriceDiff, (0, _product.getMinPrice)(this.props.productData), (0, _formatting.settingCartDesc)(this.props.productData, this.state.metalType, this.state.ringSize)).then(function (resp) {
					_this6.externalNav('checkout/cart');
				}).catch(function (errResp) {
					_this6.setState({ addingToCart: false });
				});
			}
		}, {
			key: 'addDiamond',
			value: function addDiamond() {
				this.props.productSelectSetting(this.props.productData, this.state.metalType, this.state.ringSize);
				this.internalNav('gallery/engagement-rings?view=results&tabtype=diamond');
			}
		}, {
			key: 'backToResults',
			value: function backToResults() {
				var pageNum = this.props.product.currentPage ? this.props.product.currentPage : 1;
				var urlData = (0, _url.getJsonFromUrl)();
				if (urlData && urlData.q) {
	
					var pageVal = this.props.product.currentPage && this.props.product.currentPage > 1 ? '&p=' + this.props.product.currentPage : '';
	
					this.internalNav('diamonds-direct-search?q=' + urlData.q + pageVal);
					return;
				}
	
				this.internalNav('gallery/engagement-rings?view=results&currentPage=' + pageNum + '&tabtype=setting');
			}
		}, {
			key: 'addToWishlist',
			value: function addToWishlist() {
				if ((0, _auth.isLoggedIn)()) {
					this.toggleWishlist();
				} else {
					this.props.commonOpenLogin();
				}
			}
		}, {
			key: 'toggleWishlist',
			value: function toggleWishlist() {
				var _this7 = this;
	
				this.setState({
					wishlistExpanded: !this.state.wishlistExpanded
					// wishlistRequestPending: false,
				}, function () {
					if (_this7.state.wishlistExpanded) {
						_this7.setState({ wishlistRequestPending: false });
					}
				});
			}
		}, {
			key: 'changeWishlist',
			value: function changeWishlist(evt) {
				if (evt.target.value == 'create') {
					this.internalNav('account');
				} else {
					this.setState({ selectedWishlistId: evt.target.value });
				}
			}
		}, {
			key: 'saveAddToWishlist',
			value: function saveAddToWishlist() {
				var _this8 = this;
	
				if (!this.state.selectedWishlistId) {
					this.setState({ wishlistValidation: 'Please select a wishlist' });
				}
	
				this.setState({ wishlistRequestPending: true });
				this.props.userWishlistAddItem(this.state.selectedWishlistId, this.props.productData.sku).then(function (resp) {
	
					_this8.props.commonAlert('Added to wishlist!', 'Continue', 'default');
					_this8.toggleWishlist();
					// this.setState({ wishlistRequestPending: false });
	
					_this8.props.userGetWishlists().then(function (respData) {
						_this8.props.userSaveWishlists(respData.wishlists);
					});
				});
			}
		}, {
			key: 'getWishlistList',
			value: function getWishlistList() {
				var dropdownData = (0, _formatting.formatDropdownData)(this.props.user.wishlists, 'name', 'id', 'Select Wishlist');
				var createElement = {
					display: 'Create New Wishlist',
					value: 'create'
				};
				return dropdownData.concat(createElement);
			}
		}, {
			key: 'getRoyalTNotice',
			value: function getRoyalTNotice() {
	
				if (!this.props.productData || !this.props.productData.sku) {
					return '';
				}
	
				var royalSkus = ['SMDPL06228', 'SMDPL06540', 'SMDPL06537', 'SMDPL06539', 'SMDPL13016', 'SMDPL13017', 'SMDPL13018', 'SMDPL10951'];
	
				return royalSkus.includes(this.props.productData.sku) ? 'Minimum 2 carat center stone required' : '';
			}
		}, {
			key: 'hasEternitySize',
			value: function hasEternitySize() {
				if (!this.props.productData || !this.props.productData.sku) {
					return '';
				}
	
				var sizeSkus = ['BLDXL09033', 'BLDLG07535', 'BLDMD16242', 'BLDXL09325', 'BLDXL09326', 'BLDXL09353', 'BLDXL09354', 'BLDLG07493', 'BLDLG10577', 'BLDMD22544', 'BLDMD22546', 'BLDSM15215', 'BLDSM15216', 'BLDSM19811', 'BLDXL09335', 'BLDMD19310', 'BLDMD20797', 'BLDLG00689', 'BLDXL05912', 'BLDXL06711', 'BLDLG00539', 'BLDLG00870', 'BLDLG00916', 'BLDMD03842', 'BLDXL05775', 'BLDLG01719', 'BLDMD02500', 'BLDXL01568', 'BLDXL02985', 'BLDXL05597', 'BLDMD19733', 'BLDXL12439', 'BLDSM16887', 'BDSAP01562', 'BDSAP03470', 'BDSAP03473', 'BDSAP03498', 'BLDLG05316', 'BLDLG09879', 'BLDSM02317', 'BLDXL11509', 'BLDXL16381', 'BLDMD17662', 'BLDXL19649', 'BLDXL19655', 'BLDXL19663', 'BLDXL19679', 'BLDXL19683', 'BLDXL19687', 'BLDXL19689', 'BLDXL19700', 'BLDXL19696', 'BLDXL19708', 'BLDXL19714', 'BLDXL19716', 'BLDXL19719', 'BLDXL19720', 'BLDLG15370', 'BLDMD31667', 'BLDXL11675', 'BDSAP03475', 'BLDXL17019', 'BDSAP03501', 'BDSAP05496', 'BDSAP03496', 'BDSAP04925'];
	
				return sizeSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'hasLimitedSize',
			value: function hasLimitedSize() {
				if (!this.props.productData || !this.props.productData.sku) {
					return '';
				}
	
				var sizeSkus = ['BLDXL19696', 'BLDXL19700', 'BLDXL19708', 'BLDXL19714', 'BLDXL19716', 'BLDXL19719', 'BLDXL19720', 'BLDXL19649', 'BLDXL19655', 'BLDXL19679', 'BLDXL19663', 'BLDXL19683', 'BLDXL19687', 'BLDXL19689', 'BLDMD16242', 'BLDXL09325', 'BLDLG07535', 'BLDXL09353', 'BLDXL09354', 'BLDXL09326'];
	
				return sizeSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'altSizeMessage',
			value: function altSizeMessage() {
				if (!this.props.productData || !this.props.productData.sku) {
					return '';
				}
	
				var sizeSkus = ['BLDMD16242', 'BLDXL09325', 'BLDLG07535', 'BLDXL09353', 'BLDXL09354', 'BLDXL09326'];
				return sizeSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'skipMetalType',
			value: function skipMetalType() {
				if (!this.props.productData || !this.props.productData.sku) {
					return '';
				}
	
				var skipSkus = ['PRL6N00146'];
				return skipSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'hasNoPrice',
			value: function hasNoPrice(product) {
	
				if (!this.props.productData || !this.props.productData.attributes) {
					return false;
				}
	
				var noPriceSkus = ['CUSTM00001', 'CUSTM00002', 'CUSTM00003', 'CUSTM00004', 'CUSTM00005', 'CUSTM00006', 'CUSTM00007', 'CUSTM00008', 'CUSTM00009', 'CUSTM00010', 'CUSTM00011', 'CUSTM00012', 'CUSTM00013', 'CUSTM00014', 'CUSTM00015', 'CUSTM00016', 'CUSTM00020', 'CUSTM00021', 'CUSTM00022', 'CUSTM00027', 'CUSTM00028', 'CUSTM00029', 'CUSTM00030'];
	
				return noPriceSkus.includes(this.props.productData.sku);
			}
		}, {
			key: 'getSizeNotice',
			value: function getSizeNotice() {
	
				var hasLimited = this.hasLimitedSize();
				var altMessage = this.altSizeMessage();
	
				if (!hasLimited) {
					return '';
				}
	
				if (altMessage) {
					return 'Total carat weight and number of diamonds varies by finger size. If the size you need is not listed, please chat with a virtual sales associate.';
				}
	
				return 'Total carat weight and number of diamonds varies by finger size. The quality of the diamonds is H-I color and VS clarity. If the size you need is not listed, please chat with a virtual sales associate.';
			}
		}, {
			key: 'getMainMedia',
			value: function getMainMedia() {
				if (this.isMediaVideo(this.getProductMedia()[this.state.imageIndex])) {
					return _react2.default.createElement(
						'video',
						{ autoPlay: true, playsInline: true, muted: 'muted', loop: true },
						_react2.default.createElement('source', { src: this.getProductMedia()[this.state.imageIndex], type: 'video/mp4' })
					);
				} else {
					console.log(this.getProductMedia()[this.state.imageIndex]);
					return _react2.default.createElement('img', { src: this.getProductMedia()[this.state.imageIndex] });
				}
			}
		}, {
			key: 'getThumbMedia',
			value: function getThumbMedia(srcStr) {
	
				if (!srcStr) {
					return null;
				}
	
				if (this.isMediaVideo(srcStr)) {
					return _react2.default.createElement(
						'span',
						null,
						_react2.default.createElement('img', { src: srcStr.replace('.mp4', '.jpg') }),
						_react2.default.createElement(
							'div',
							{ className: 'playWrapper' },
							_react2.default.createElement('i', { className: 'fas fa-play' })
						)
					);
				} else {
					return _react2.default.createElement('img', { src: srcStr });
				}
			}
		}, {
			key: 'isMediaVideo',
			value: function isMediaVideo(srcStr) {
				return srcStr ? srcStr.includes('.mp4') : false;
			}
		}, {
			key: 'getRingSizeList',
			value: function getRingSizeList() {
				if (this.hasEternitySize()) {
					return this.state.eternitySizeData;
				}
				if (this.hasLimitedSize()) {
					return this.state.limitedSizeData;
				}
				return this.state.ringSizeData;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'ProductSettingBanner' },
					_react2.default.createElement(
						'div',
						{ className: 'imageSection' },
						_react2.default.createElement(
							'div',
							{ className: 'primaryImageWrapper' },
							this.getProductMedia().length > this.state.imageIndex ? _react2.default.createElement(
								'span',
								null,
								this.getMainMedia()
							) : null
						),
						_react2.default.createElement(
							'div',
							{ className: 'thumbnailsWrapper' },
							this.getProductMedia().map(function (img, j) {
								return _react2.default.createElement(
									'div',
									{ className: 'thumbWrapper', onClick: function onClick() {
											return _this9.setImageIndex(j);
										}, key: j },
									_react2.default.createElement(
										'span',
										null,
										_this9.getThumbMedia(img)
									)
								);
							})
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'descriptionSection' },
						_react2.default.createElement(
							'div',
							{ className: 'settingTitle' },
							this.getProductName()
						),
						_react2.default.createElement(
							'div',
							{ className: 'settingDescription' },
							this.getProductDescription()
						),
						this.getRoyalTNotice() ? _react2.default.createElement(
							'div',
							{ className: 'settingRoyalTNotice' },
							this.getRoyalTNotice()
						) : null,
						this.getSizeNotice() ? _react2.default.createElement(
							'div',
							{ className: 'settingRoyalTNotice' },
							this.getSizeNotice()
						) : null,
						_react2.default.createElement(
							'div',
							{ className: 'settingConfigWrapper' },
							this.state.validationMessage ? _react2.default.createElement(
								'div',
								{ className: 'configError' },
								this.state.validationMessage
							) : null,
							!this.skipMetalType() ? _react2.default.createElement(
								'div',
								{ className: 'metalTypeOptions' },
								_react2.default.createElement(_RhinoSelect2.default, {
									options: this.getMetalTypeOptions(),
									value: this.state.metalType,
									changeMethod: this.changeMetalType.bind(this),
									rootClass: 'productSelect' })
							) : null,
							_react2.default.createElement(
								'div',
								{ className: 'ringSizeSelect' },
								_react2.default.createElement(_RhinoSelect2.default, {
									options: this.getRingSizeList(),
									value: this.state.ringSize,
									changeMethod: this.changeRingSize.bind(this),
									rootClass: 'productSelect' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'priceWrapper', style: { display: this.hasNoPrice() ? 'none' : 'block' } },
							_react2.default.createElement(
								'div',
								{ className: 'priceSign' },
								'$'
							),
							_react2.default.createElement(
								'div',
								{ className: 'priceValue' },
								this.getProductPrice().toLocaleString()
							)
						),
						!this.hasNoPrice() ? _react2.default.createElement(
							'div',
							{ className: 'priceNotice settingPriceNotice' },
							'(setting\xA0\xA0only)'
						) : null,
						this.state.addingToCart ? _react2.default.createElement(
							'div',
							{ className: 'nextStepsInCart' },
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
								'\xA0\xA0\xA0Adding to Cart'
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'nextStepsWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'nextStepsElement', onClick: this.toggleNextSteps.bind(this) },
								_react2.default.createElement(
									'div',
									{ className: 'nextStepsHead' },
									_react2.default.createElement(
										'div',
										{ className: 'nextStepsLabel' },
										'Next Steps'
									),
									_react2.default.createElement(
										'div',
										{ className: 'nextStepsIcon' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/down.svg' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: this.state.nextStepsOpen ? 'nextStepsBody open' : 'nextStepsBody' },
									_react2.default.createElement(
										'div',
										{ className: 'nextStepsBodyWrapper' },
										_react2.default.createElement(
											'div',
											{ className: 'nextStepsItem', onClick: function onClick() {
													return _this9.addToCart();
												} },
											'Add to Cart'
										),
										_react2.default.createElement(
											'div',
											{ className: 'nextStepsItem', onClick: function onClick() {
													return _this9.addDiamond();
												} },
											'Add to Ring'
										),
										_react2.default.createElement(
											'div',
											{ className: 'nextStepsItem', onClick: function onClick() {
													return _this9.backToResults();
												} },
											'Back to Results'
										),
										_react2.default.createElement(
											'div',
											{ className: 'nextStepsItem', onClick: function onClick() {
													return _this9.internalNav('contact-us');
												} },
											'Request an Appointment'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'shippingInfoWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'shippingDateLine', style: { display: 'none' } },
								'Estimated Shipping Date: ',
								(0, _formatting.displayDateFromDate)(this.getShippingDate())
							),
							_react2.default.createElement(
								'div',
								{ className: 'shippingContactLine', style: { display: 'none' } },
								'Need it sooner?\xA0',
								_react2.default.createElement(
									'span',
									{ className: 'clickableText', onClick: this.openIntercom.bind(this) },
									'Speak to an Expert'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'shippingFreeLine' },
								'Free shipping and free lifetime jewelry care with every purchase -\xA0',
								_react2.default.createElement(
									'span',
									{ className: 'clickableText', onClick: function onClick() {
											return _this9.props.scrollMethod();
										} },
									'Learn More'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'actionsWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'actionItem', style: { display: 'none' } },
								_react2.default.createElement(
									'div',
									{ className: 'actionIcon hint' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/hint.svg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'actionLabel' },
									'Drop a Hint'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'actionItem', onClick: function onClick() {
										return _this9.internalNav('contact-us');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'actionIcon' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/consult.svg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'actionLabel' },
									'Consult an Expert'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'actionItem', onClick: this.addToWishlist.bind(this) },
								_react2.default.createElement(
									'div',
									{ className: 'actionIcon' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/productpage/wishlist.svg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'actionLabel' },
									'Add to Wishlist'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: this.state.wishlistExpanded ? 'wishlistConfigs expanded' : 'wishlistConfigs' },
							this.props.user.wishlists !== null ? _react2.default.createElement(
								'div',
								null,
								this.props.user.wishlists.length === 0 ? _react2.default.createElement(
									'div',
									{ className: 'noWishlistPrompt' },
									_react2.default.createElement(
										'div',
										{ className: 'nwText' },
										'No wishlists created'
									),
									_react2.default.createElement(
										'div',
										{ className: 'nwButton', onClick: function onClick() {
												return _this9.internalNav('account');
											} },
										'Create'
									)
								) : _react2.default.createElement(
									'div',
									{ className: 'selectWishlistPrompt' },
									this.state.wishlistValidation ? _react2.default.createElement(
										'div',
										{ className: 'wlPrompt' },
										this.state.wishlistValidation
									) : null,
									_react2.default.createElement(
										'div',
										{ className: 'selectPrompt' },
										'Add to which wishlist?'
									),
									_react2.default.createElement(
										'div',
										{ className: 'selectWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											options: this.getWishlistList(),
											value: this.state.selectedWishlistId,
											changeMethod: this.changeWishlist.bind(this),
											rootClass: 'productSelect' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'selectButtonWrapper', style: { display: this.state.wishlistRequestPending ? 'inline-block' : 'none' } },
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement('i', { className: 'fas fa-spinner fa-pulse' }),
											'\xA0\xA0\xA0Adding to Wishlist'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'selectButtonWrapper', onClick: this.saveAddToWishlist.bind(this), style: { display: this.state.wishlistRequestPending ? 'none' : 'inline-block' } },
										_react2.default.createElement(
											'div',
											null,
											'Add to Wishlist'
										)
									)
								)
							) : null
						)
					)
				);
			}
		}]);
	
		return ProductSettingBanner;
	}(_react2.default.Component);
	
	ProductSettingBanner.propTypes = {
		location: _react.PropTypes.object
	};
	ProductSettingBanner.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductSettingBanner;
	
	
	function mapStateToProps(state) {
		return {
			product: state.product,
			user: state.user
		};
	}
	
	var ProductSettingBannerContainer = exports.ProductSettingBannerContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductSettingBanner);

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductSettingPairsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var ProductSettingPairs = function (_React$Component) {
	  _inherits(ProductSettingPairs, _React$Component);
	
	  function ProductSettingPairs(props) {
	    _classCallCheck(this, ProductSettingPairs);
	
	    var _this = _possibleConstructorReturn(this, (ProductSettingPairs.__proto__ || Object.getPrototypeOf(ProductSettingPairs)).call(this, props));
	
	    var bandData = [{
	      image: '/img/productpage/Image70.png',
	      description: 'Nexus Wedding Band',
	      price: 1099
	    }, {
	      image: '/img/productpage/Image71.png',
	      description: 'Oko Wedding Band',
	      price: 2499
	    }, {
	      image: '/img/productpage/Image73.png',
	      description: 'Tacori Solitaire Ring',
	      price: 768
	    }];
	
	    _this.state = {
	      bands: bandData,
	      expanded: false
	    };
	    return _this;
	  }
	
	  _createClass(ProductSettingPairs, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'toggleExpanded',
	    value: function toggleExpanded() {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProductSettingPairs' },
	        _react2.default.createElement(
	          'div',
	          { className: 'productPairsHeader', onClick: this.toggleExpanded.bind(this) },
	          _react2.default.createElement(
	            'div',
	            { className: 'productPairsTitle' },
	            'Pairs Well With'
	          ),
	          this.state.expanded ? _react2.default.createElement(
	            'div',
	            { className: 'headerIcon' },
	            '\u2014'
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'headerIcon' },
	            '+'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.expanded ? 'productPairsWrapper expanded' : 'productPairsWrapper' },
	          this.state.bands.map(function (band, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'settingItemWrapper', key: i },
	              _react2.default.createElement(
	                'div',
	                { className: 'settingItemInnerWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingImageWrapper' },
	                  _react2.default.createElement('img', { src: band.image })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingInfoWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingTitleWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      band.description
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingPrice' },
	                    '$',
	                    band.price.toLocaleString()
	                  )
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ProductSettingPairs;
	}(_react2.default.Component);
	
	ProductSettingPairs.propTypes = {
	  location: _react.PropTypes.object
	};
	ProductSettingPairs.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductSettingPairs;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ProductSettingPairsContainer = exports.ProductSettingPairsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductSettingPairs);

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductSimilarDiamondContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var ProductSimilarDiamond = function (_React$Component) {
	  _inherits(ProductSimilarDiamond, _React$Component);
	
	  function ProductSimilarDiamond(props) {
	    _classCallCheck(this, ProductSimilarDiamond);
	
	    var _this = _possibleConstructorReturn(this, (ProductSimilarDiamond.__proto__ || Object.getPrototypeOf(ProductSimilarDiamond)).call(this, props));
	
	    var diamondData = [{
	      image: '/img/productpage/diamond_main.png',
	      description: 'Round 1.02 F SI1',
	      price: 3402
	    }, {
	      image: '/img/productpage/diamond_main.png',
	      description: 'Round 0.89 D IF',
	      price: 2200
	    }, {
	      image: '/img/productpage/diamond_main.png',
	      description: 'Round 1.48 E VS1',
	      price: 8394
	    }];
	
	    _this.state = {
	      diamonds: diamondData
	    };
	    return _this;
	  }
	
	  _createClass(ProductSimilarDiamond, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProductSimilarDiamond' },
	        _react2.default.createElement(
	          'div',
	          { className: 'productSimilarTitle' },
	          'Similar Diamonds'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'productSimilarRefresh' },
	          _react2.default.createElement('img', { src: '/img/productpage/refresh.svg' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'productSimilarWrapper' },
	          this.state.diamonds.map(function (diamond, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'diamondItemWrapper', key: i },
	              _react2.default.createElement(
	                'div',
	                { className: 'diamondItemInnerWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'diamondImageWrapper' },
	                  _react2.default.createElement('img', { src: diamond.image })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'diamondInfoWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'diamondTitleWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      diamond.description
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'diamondPrice' },
	                    '$',
	                    diamond.price.toLocaleString()
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'diamondItemButtonWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'itemButton productSimilarButton' },
	                    'Change Diamond'
	                  )
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ProductSimilarDiamond;
	}(_react2.default.Component);
	
	ProductSimilarDiamond.propTypes = {
	  location: _react.PropTypes.object
	};
	ProductSimilarDiamond.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductSimilarDiamond;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ProductSimilarDiamondContainer = exports.ProductSimilarDiamondContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductSimilarDiamond);

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductSimilarSettingContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var ProductSimilarSetting = function (_React$Component) {
	  _inherits(ProductSimilarSetting, _React$Component);
	
	  function ProductSimilarSetting(props) {
	    _classCallCheck(this, ProductSimilarSetting);
	
	    var _this = _possibleConstructorReturn(this, (ProductSimilarSetting.__proto__ || Object.getPrototypeOf(ProductSimilarSetting)).call(this, props));
	
	    var settingData = [{
	      image: '/img/ringbuilder/results/setting_sample.jpg',
	      description: 'Simon G. Solitaire Ring',
	      price: 6554
	    }, {
	      image: '/img/ringbuilder/results/setting_sample.jpg',
	      description: 'Fana Solitaire Ring',
	      price: 1737
	    }, {
	      image: '/img/ringbuilder/results/setting_sample.jpg',
	      description: 'Jeff Cooper Solitaire Ring',
	      price: 1689
	    }];
	
	    _this.state = {
	      settings: settingData
	    };
	    return _this;
	  }
	
	  _createClass(ProductSimilarSetting, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProductSimilarSetting' },
	        _react2.default.createElement(
	          'div',
	          { className: 'productSimilarTitle' },
	          'Similar Rings'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'productSimilarRefresh' },
	          _react2.default.createElement('img', { src: '/img/productpage/refresh.svg' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'productSimilarWrapper' },
	          this.state.settings.map(function (setting, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'settingItemWrapper', key: i },
	              _react2.default.createElement(
	                'div',
	                { className: 'settingItemInnerWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingImageWrapper' },
	                  _react2.default.createElement('img', { src: setting.image })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingInfoWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingTitleWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      setting.description
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'settingPrice' },
	                    '$',
	                    setting.price.toLocaleString()
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'settingItemButtonWrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'itemButton productSimilarButton' },
	                    'Change Ring'
	                  )
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ProductSimilarSetting;
	}(_react2.default.Component);
	
	ProductSimilarSetting.propTypes = {
	  location: _react.PropTypes.object
	};
	ProductSimilarSetting.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductSimilarSetting;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ProductSimilarSettingContainer = exports.ProductSimilarSettingContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductSimilarSetting);

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ProductSocialContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactIgFeed = __webpack_require__(1150);
	
	var _reactIgFeed2 = _interopRequireDefault(_reactIgFeed);
	
	var _reactInstagramEmbed = __webpack_require__(1151);
	
	var _reactInstagramEmbed2 = _interopRequireDefault(_reactInstagramEmbed);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import 'react-ig-feed/dist/index.css'
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var ProductSocial = function (_React$Component) {
		_inherits(ProductSocial, _React$Component);
	
		function ProductSocial(props) {
			_classCallCheck(this, ProductSocial);
	
			var _this = _possibleConstructorReturn(this, (ProductSocial.__proto__ || Object.getPrototypeOf(ProductSocial)).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(ProductSocial, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				// var feed = new Instafeed({
				//     accessToken: 'EAAFA6QMYig8BAA0Jwnif01t9gOF9gqZBXtT2yX3udi01zUtPnGj9DGMirmDKjln1WWkjxA8gnUnpf6XZBQCx4P0E3U8KcZAXZB8ZBg3SIKmurO6WzmTtFJZArZCrIDZAipOmmHCd2B2I9ZAfJWJwsfgshDzOWhfvFffvkuqRIRCW30aQvwzTbbnAlmkXA7A1gco8xHciptg0ngFXXH6FA0vgu'
				//   });
				//   console.log(feed);
				//   feed.run();
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
	
			// 352844500208143
			// 20ecbdea627b6960a68cd59a7628f7b1
	
			// a612d94186390a5e05a10ccd1a4c53e3
	
			// EAAFA6QMYig8BAA0Jwnif01t9gOF9gqZBXtT2yX3udi01zUtPnGj9DGMirmDKjln1WWkjxA8gnUnpf6XZBQCx4P0E3U8KcZAXZB8ZBg3SIKmurO6WzmTtFJZArZCrIDZAipOmmHCd2B2I9ZAfJWJwsfgshDzOWhfvFffvkuqRIRCW30aQvwzTbbnAlmkXA7A1gco8xHciptg0ngFXXH6FA0vgu
	
			// from RH
			// IGQVJXWWFKOU81aUd3WjZAkdEJGQzhRSnF1TExRdnUyQ2Uxc0lNLTJFbW5DNWRVdTJENkpXVTNGT2tyb1ZArSmV1eTdvNnk0eDg0UnItRzRLSFpzcnhJT0haX2o4alZAERzlHbFp0REFSWFlYekdUb29WcQZDZD
	
	
			// 			<div className='igWrapper'>
			// 				<InstagramEmbed
			// 				  url='https://www.instagram.com/diamondsdirect'
			// 				  clientAccessToken='514122350324351|a612d94186390a5e05a10ccd1a4c53e3'
			// 				  maxWidth={320}
			// 				  hideCaption={false}
			// 				  containerTagName='div'
			// 				  protocol=''
			// 				  injectScript
			// 				  onLoading={() => {}}
			// 				  onSuccess={() => {}}
			// 				  onAfterRender={() => {}}
			// 				  onFailure={() => {}} />
			// 			</div>
			// 			<div id="instafeed"></div>
	
			// IGQVJXWWFKOU81aUd3WjZAkdEJGQzhRSnF1TExRdnUyQ2Uxc0lNLTJFbW5DNWRVdTJENkpXVTNGT2tyb1ZArSmV1eTdvNnk0eDg0UnItRzRLSFpzcnhJT0haX2o4alZAERzlHbFp0REFSWFlYekdUb29WcQZDZD
	
			// IGQVJVLU1IMjZAjZAkRkbWFkeWJPLVJNYzBKOVlyVWVYZAmotX2pOX3ZAvLVdNTHJDNzd2V2dPZAlM1UVE1TXBjUjM4ZA0dGVlY3WXVHUUlBZA2pkSjlWeDNWMkotbVFteTU1b3I2dHBfREw2ZA09TdjlWTFBmVgZDZD
	
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'ProductSocial' },
					_react2.default.createElement(
						'div',
						{ className: 'socialTitle' },
						'Diamonds Direct on Social'
					),
					_react2.default.createElement(
						'div',
						{ className: 'socialImagesWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'igWrapper' },
							_react2.default.createElement(_reactIgFeed2.default, { token: 'IGQVJVLU1IMjZAjZAkRkbWFkeWJPLVJNYzBKOVlyVWVYZAmotX2pOX3ZAvLVdNTHJDNzd2V2dPZAlM1UVE1TXBjUjM4ZA0dGVlY3WXVHUUlBZA2pkSjlWeDNWMkotbVFteTU1b3I2dHBfREw2ZA09TdjlWTFBmVgZDZD', counter: '6' })
						)
					)
				);
			}
		}]);
	
		return ProductSocial;
	}(_react2.default.Component);
	
	ProductSocial.propTypes = {
		location: _react.PropTypes.object
	};
	ProductSocial.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ProductSocial;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var ProductSocialContainer = exports.ProductSocialContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ProductSocial);

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Auburn2022Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Auburn2022 = function (_React$Component) {
		_inherits(Auburn2022, _React$Component);
	
		function Auburn2022(props) {
			_classCallCheck(this, Auburn2022);
	
			var _this = _possibleConstructorReturn(this, (Auburn2022.__proto__ || Object.getPrototypeOf(Auburn2022)).call(this, props));
	
			_this.state = {
				inputName: '',
				inputLastName: '',
				inputEmail: '',
				inputPhone: '',
	
				errorName: null,
				errorLastName: null,
				errorEmail: null,
				errorPhone: null
			};
			return _this;
		}
	
		_createClass(Auburn2022, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeLastName',
			value: function changeLastName(evt) {
				var _this3 = this;
	
				this.setState({ inputLastName: evt.target.value }, function () {
					if (_this3.state.errorLastName && !(0, _itemValidation.nameValidation)(_this3.state.inputLastName)) {
						_this3.setState({ errorLastName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this4 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this4.state.errorEmail && !(0, _itemValidation.emailValidation)(_this4.state.inputEmail)) {
						_this4.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this5 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this5.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this5.state.inputPhone)) {
						_this5.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						first_name: this.state.inputName,
						last_name: this.state.inputLastName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone
					};
	
					this.props.commonAuburnContactRequest(contactData);
	
					this.props.commonAlert('Thank you for registering!', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputLastName: '',
						inputEmail: '',
						inputPhone: '',
						errorName: null,
						errorLastName: null,
						errorEmail: null,
						errorPhone: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var lastNameError = (0, _itemValidation.nameValidation)(this.state.inputLastName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
	
				if (nameError === null && lastNameError === null && emailError === null && phoneError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorLastName: lastNameError,
					errorEmail: emailError,
					errorPhone: phoneError
				});
				return !hasErrors;
			}
		}, {
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement(
					'div',
					{ className: 'Auburn2022' },
					_react2.default.createElement(
						'div',
						{ className: 'bannerWrapper' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/auburn2022/auburnlander.jpg' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/auburn2022/auburnlander_m.jpg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP left' },
									'Register below for a chance to be this year\'s Diamonds Direct Ultimate Fan Giveaway winner! One lucky winner will win:'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formP narrow' },
									'two tickets to the Auburn vs. Texas A&M game ',
									_react2.default.createElement(
										'span',
										{ className: 'emBig' },
										'|'
									),
									' pre-game hospitality passes fan gear ',
									_react2.default.createElement(
										'span',
										{ className: 'emBig' },
										'|'
									),
									' and a $250 Diamonds Direct gift certificate.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'The contest runs 10',
									_react2.default.createElement(
										'span',
										{ className: 'em' },
										'/'
									),
									'17',
									_react2.default.createElement(
										'span',
										{ className: 'em' },
										'/'
									),
									'22 - 11',
									_react2.default.createElement(
										'span',
										{ className: 'em' },
										'/'
									),
									'7',
									_react2.default.createElement(
										'span',
										{ className: 'em' },
										'/'
									),
									'22'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'First Name',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorLastName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Last Name',
											value: this.state.inputLastName,
											onChange: this.changeLastName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Phone Number',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Submit Form'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'legalWrapper' },
						'Winner will be chosen at random. No purchase necessary, must be 18 or older to win. Winner must be able to attend the game and arrange their own travel if necessary. The prize is non-transferable and for the 11/12/2022 home game only.'
					)
				);
			}
		}]);
	
		return Auburn2022;
	}(_react2.default.Component);
	
	exports.default = Auburn2022;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Auburn2022Container = exports.Auburn2022Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Auburn2022);

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.BlackFriday2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var BlackFriday2021 = function (_React$Component) {
		_inherits(BlackFriday2021, _React$Component);
	
		function BlackFriday2021(props) {
			_classCallCheck(this, BlackFriday2021);
	
			var _this = _possibleConstructorReturn(this, (BlackFriday2021.__proto__ || Object.getPrototypeOf(BlackFriday2021)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesignerLocation: null,
	
				bgWidth: 0,
				bgHeight: 0
			};
	
			// Bind event listeners
			_this.adjustBackground = _this.adjustBackground.bind(_this);
			return _this;
		}
	
		_createClass(BlackFriday2021, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				window.addEventListener('resize', this.adjustBackground, false);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.adjustBackground();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				window.removeEventListener('resize', this.adjustBackground, false);
			}
		}, {
			key: 'adjustBackground',
			value: function adjustBackground() {
	
				var clientWidth = this.topBox.clientWidth;
				var clientHeight = this.topBox.clientHeight;
	
				this.setState({
					bgWidth: clientWidth,
					bgHeight: clientHeight
				});
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'giftsNav',
			value: function giftsNav() {
				window.location.href = 'https://gifts.diamondsdirect.com';
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'getLocationDesigners',
			value: function getLocationDesigners() {
				return [];
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeDesigner',
			value: function changeDesigner(evt) {
				this.setState({ inputDesigner: evt.target.value });
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'getShowDates',
			value: function getShowDates(code) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = this.state.designerLocationArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var l = _step.value;
	
						if (l.value === code) {
							return l.dates;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'getShowLink',
			value: function getShowLink(code) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = this.state.designerLocationArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var l = _step2.value;
	
						if (l.value === code) {
							return l.page;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'designerNav',
			value: function designerNav(page) {
				if (!page) {
					return;
				}
				this.internalNav(page);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'BlackFriday2021' },
					_react2.default.createElement('img', { src: 'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=lead&pixid=7333a400-055a-4ea4-a1b7-835149f34435', width: '1', height: '1' }),
					_react2.default.createElement(
						'div',
						{ className: 'headerSection' },
						_react2.default.createElement(
							'div',
							{ className: 'headerSectionWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/blackfriday2021/bf_lander_banner.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/blackfriday2021/bf_lander_banner_m.jpg' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'topSection' },
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'To help you celebrate with the ones you love most this year, we\'re putting together some ',
							_react2.default.createElement(
								'strong',
								null,
								'amazing surprises!'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'Check in with us online or in-store to take advantage of:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'topTitleImg' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/blackfriday2021/20percent_3.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'topDate' },
							'November 26 - 29'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Full Name*',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email Address*',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Telephone',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											selectClass: 'summerSelect',
											required: true,
											value: this.state.inputLocation,
											options: this.state.locations,
											changeMethod: function changeMethod(evt) {
												return _this7.changeLocation(evt);
											},
											error: this.state.errorLocation !== null })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Request an appointment'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'holidaySection', onClick: function onClick() {
								return _this7.internalNav('financing');
							} },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/blackfriday2021/financing.jpg' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/blackfriday2021/financing_m.jpg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'ggSection' },
						_react2.default.createElement(
							'div',
							{ className: 'ggTitle' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/holidaygg.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggLine' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/iline.svg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/iline_m.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Diamonds Direct invites you to enjoy this holiday season with a little extra sparkle! From now until the ball drops we\u2019ll be toasting to the best part of the year.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggButton', onClick: this.giftsNav.bind(this) },
							'Shop Holiday Gifts'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggItemRow' },
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDXL18079');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg1' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Emerald Diamond Halo Ring'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDMD30060');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg2' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Simon G. Butterfly Diamond Ring'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/NFANC29328');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg3' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Baguette Diamond Circle Pendant'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/EFAND14379');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg4' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Diamond Floral Inspired Studs'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'legalSection' },
						_react2.default.createElement(
							'div',
							{ className: 'legalInnerWrapper' },
							'*Discount excludes certified diamonds and price protected lines. Cannot be combined with other offers.'
						)
					)
				);
			}
		}]);
	
		return BlackFriday2021;
	}(_react2.default.Component);
	
	BlackFriday2021.propTypes = {
		location: _react.PropTypes.object
	};
	BlackFriday2021.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = BlackFriday2021;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var BlackFriday2021Container = exports.BlackFriday2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(BlackFriday2021);

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Covid19Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _covidlocations = __webpack_require__(610);
	
	var locations = _interopRequireWildcard(_covidlocations);
	
	var _itemValidation = __webpack_require__(17);
	
	var _contacts = __webpack_require__(41);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var Covid19 = function (_React$Component) {
		_inherits(Covid19, _React$Component);
	
		function Covid19(props) {
			_classCallCheck(this, Covid19);
	
			var _this = _possibleConstructorReturn(this, (Covid19.__proto__ || Object.getPrototypeOf(Covid19)).call(this, props));
	
			var firstEntry = [{ display: 'Select location', 'value': '' }];
			var newArray = firstEntry.concat(locations.locations);
	
			_this.state = {
				locations: newArray,
				dropdownValue: null,
				openDrawers: [],
	
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
	
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
	
				formOpen: false
			};
			return _this;
		}
	
		_createClass(Covid19, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && location !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeMessage',
			value: function changeMessage(evt) {
				var _this6 = this;
	
				this.setState({ inputMessage: evt.target.value }, function () {
					if (_this6.state.errorMessage && !(0, _itemValidation.messageTextValidation)(_this6.state.inputMessage)) {
						_this6.setState({ errorMessage: null });
					}
				});
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var messageError = (0, _itemValidation.messageTextValidation)(this.state.inputMessage);
				var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null && messageError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError,
					errorMessage: messageError
				});
	
				return !hasErrors;
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				var _this7 = this;
	
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation,
						message: this.state.inputMessage
					};
	
					this.props.commonContactRequest(contactData).then(function () {
						_this7.context.router.push('/thank-you');
						// this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly to finalize your virtual appointment.', 'Continue Browsing', 'helping', '');
					});
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputMessage: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null,
						errorMessage: null
					});
					this.props.commonCloseContact();
				}
			}
		}, {
			key: 'showStoreSection',
			value: function showStoreSection() {
				switch (this.state.dropdownValue) {
					case null:
						// return this.nullResult();
						return null;
					case '':
						return this.nullResult();
					case 'atx':
						return this.atxResult();
					case 'bhm':
						return this.bhmResult();
					case 'boc':
						return this.bocResult();
					case 'chs':
						return this.chsResult();
					case 'clt':
						return this.cltResult();
					case 'cle':
						return this.cleResult();
					case 'coh':
						return this.cohResult();
					case 'dfw':
						return this.dfwResult();
					case 'ftx':
						return this.ftxResult();
					case 'gsc':
						return this.gscResult();
					case 'hou':
						return this.houResult();
					case 'ind':
						return this.indResult();
					case 'jax':
						return this.jaxResult();
					case 'kcy':
						return this.kcyResult();
					case 'nol':
						return this.nolResult();
					case 'okc':
						return this.okcResult();
					case 'pit':
						return this.pitResult();
					case 'ral':
						return this.ralResult();
					case 'rva':
						return this.rvaResult();
					case 'stl':
						return this.stlResult();
					case 'slc':
						return this.slcResult();
					case 'san':
						return this.sanResult();
					case 'vab':
						return this.vabResult();
					default:
						return this.allResult();
				}
			}
		}, {
			key: 'chsResult',
			value: function chsResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Charleston, SC'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:8436062558' },
											'843-606-2558'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoCHS@diamondsdirect.com' },
											'infoCHS@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'allResult',
			value: function allResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'All other locations'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									'span',
									{ style: { color: '#FF0000' } },
									'Virtual and remote shopping services are available for these locations.'
								),
								' Click ',
								_react2.default.createElement(
									'a',
									{ href: '/virtual' },
									'HERE'
								),
								' to initiate an appointment.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Free shipping is available for purchases made online and via phone.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Free shipping is available for select completed orders and repairs. To learn if your order qualifies for shipping, please email us at ',
								_react2.default.createElement(
									'a',
									{ href: 'mailto:remoteservice@diamondsdirect.com' },
									'remoteservice@diamondsdirect.com'
								),
								' or call us at ',
								_react2.default.createElement(
									'a',
									{ href: 'tel:8008855050' },
									'1-800-885-5050'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'At this time, we cannot accept repairs or accommodate in-store shopping at these locations.'
							)
						)
					)
				);
			}
		}, {
			key: 'okcResult',
			value: function okcResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Oklahoma City, OK'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:4056088802' },
											'405-608-8802'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoOKC@diamondsdirect.com' },
											'infoOKC@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'atxResult',
			value: function atxResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Austin, TX'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:5126919950' },
											'512-691-9950'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoAUS@diamondsdirect.com' },
											'infoAUS@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'bhmResult',
			value: function bhmResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Birmingham, AL'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:2052017400' },
											'205-201-7400'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoBHM@diamondsdirect.com' },
											'infoBHM@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'bocResult',
			value: function bocResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Boca Raton, FL'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:5614142091' },
											'561-414-2091'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoBoca@diamondsdirect.com' },
											'infoBoca@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'cltResult',
			value: function cltResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Charlotte, NC'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:7045329041' },
											'704-532-9041'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoclt@diamondsdirect.com' },
											'infoclt@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'cleResult',
			value: function cleResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Cleveland, OH'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:2162732812' },
											'216-273-2812'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoCLE@diamondsdirect.com' },
											'infoCLE@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'cohResult',
			value: function cohResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Columbus, OH'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:6145160515' },
											'614-516-0515'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoCOL@diamondsdirect.com' },
											'infoCOL@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'dfwResult',
			value: function dfwResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Dallas, TX'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:9723426663' },
											'972-342-6663'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoDTX@diamondsdirect.com' },
											'infoDTX@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'ftxResult',
			value: function ftxResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Frisco, TX'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:4698504270' },
											'469-850-4270'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoFRISCO@diamondsdirect.com' },
											'infoFRISCO@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'gscResult',
			value: function gscResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Greenville, SC'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:8645015090' },
											'864-501-5090'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoGVL@diamondsdirect.com' },
											'infoGVL@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'houResult',
			value: function houResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Houston, TX'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:3462502054' },
											'346-250-2054'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoHOU@diamondsdirect.com' },
											'infoHOU@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
	
			// houResult() {
			// 	return <div className='locationWrapper'>
			// 		<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Houston, TX</div>
			// 		<div className='covidP covidPIndent'>
			// 			<ul className='primaryList'>
			// 				<li>This location is opening soon! To request an in-store or virtual appointment for this location, <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
			// 			</ul>
			// 		</div>
			// 	</div>
			// }
	
		}, {
			key: 'indResult',
			value: function indResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Indianapolis, IN'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:3175758555' },
											'317-575-8555'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoindy@diamondsdirect.com' },
											'infoindy@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'jaxResult',
			value: function jaxResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Jacksonville, FL'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:9045155959' },
											'904-515-5959'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoJAX@diamondsdirect.com' },
											'infoJAX@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'kcyResult',
			value: function kcyResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Kansas City, KS'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:9133121660' },
											'913-312-1660'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoksc@diamondsdirect.com' },
											'infoksc@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'pitResult',
			value: function pitResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Pittsburgh, PA'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:4128379070' },
											'412-837-9070'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoPITT@diamondsdirect.com' },
											'infoPITT@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
	
			// pitResult() {
			// 	return <div className='locationWrapper'>
			// 		<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Pittsburgh, PA</div>
			// 		<div className='covidP covidPIndent'>
			// 			<ul className='primaryList'>
			// 				<li>This location is opening soon! To request an in-store or virtual appointment for this location, <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
			// 			</ul>
			// 		</div>
			// 	</div>
			// }
	
		}, {
			key: 'nolResult',
			value: function nolResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'New Orleans, LA'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:5043833900' },
											'504-383-3900'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoNOLA@diamondsdirect.com' },
											'infoNOLA@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'ralResult',
			value: function ralResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Raleigh, NC'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:9195712881' },
											'919-571-2881'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:inforal@diamondsdirect.com' },
											'inforal@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'rvaResult',
			value: function rvaResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Richmond, VA'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:8049670500' },
											'804-967-0500'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoRIC@diamondsdirect.com' },
											'infoRIC@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'stlResult',
			value: function stlResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'St. Louis, MO'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:3149423777' },
											'314-942-3777'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoSTL@diamondsdirect.com' },
											'infoSTL@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'slcResult',
			value: function slcResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Salt Lake City, UT'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'Virtual and remote shopping services are still available for this location. ',
								_react2.default.createElement(
									'a',
									{ href: '/virtual' },
									'Click here to initiate an appointment'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Free shipping is available for purchases made online and via phone.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Free shipping is available for select completed orders and repairs. To learn if your order qualifies for shipping, please email us at ',
								_react2.default.createElement(
									'a',
									{ href: 'mailto:infoSLC@diamondsdirect.com' },
									'infoSLC@diamondsdirect.com'
								),
								'.'
							)
						)
					)
				);
			}
		}, {
			key: 'sanResult',
			value: function sanResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'San Antonio, TX'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:2102479197' },
											'210-247-9197'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoSAT@diamondsdirect.com' },
											'infoSAT@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'vabResult',
			value: function vabResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent covidLocation', style: { display: 'none' } },
						'Virginia Beach, VA'
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent' },
						_react2.default.createElement(
							'ul',
							{ className: 'primaryList' },
							_react2.default.createElement(
								'li',
								null,
								'This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.'
							),
							_react2.default.createElement(
								'li',
								null,
								'In-store walk-ins are welcome. To request an in-store or virtual appointment for this location ',
								_react2.default.createElement(
									'span',
									{ onClick: this.scrollToContact.bind(this), className: 'scrollLink' },
									'click here'
								),
								'.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Contactless curbside pick-up is available. Please contact us to coordinate.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'tel:7578370288' },
											'757-837-0288'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:infoVAB@diamondsdirect.com' },
											'infoVAB@diamondsdirect.com'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'chatLink', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'nullResult',
			value: function nullResult() {
				return _react2.default.createElement(
					'div',
					{ className: 'locationWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'covidP covidPIndent', style: { textAlign: 'center', display: 'none' } },
						'Select a location to get further details'
					)
				);
			}
		}, {
			key: 'changeViewLocation',
			value: function changeViewLocation(evt) {
				var _this8 = this;
	
				this.setState({
					dropdownValue: evt.target.value
				}, function () {
					console.log(_this8.state.dropdownValue);
				});
			}
		}, {
			key: 'isDrawerOpen',
			value: function isDrawerOpen(key) {
				return this.state.openDrawers.includes(key);
			}
		}, {
			key: 'toggleDrawer',
			value: function toggleDrawer(key) {
				var clone = this.cloneArray(this.state.openDrawers);
				var i = this.state.openDrawers.indexOf(key);
	
				if (i === -1) {
					clone.push(key);
				} else {
					clone.splice(i, 1);
				}
				this.setState({ openDrawers: clone });
			}
		}, {
			key: 'drawerIndicator',
			value: function drawerIndicator(key) {
				if (this.isDrawerOpen(key)) {
					return '-';
				} else {
					return '+';
				}
			}
		}, {
			key: 'cloneArray',
			value: function cloneArray(source) {
				var result = [];
				for (var n = 0; n < source.length; n++) {
					result[n] = source[n];
				}
				return result;
			}
		}, {
			key: 'scrollToContact',
			value: function scrollToContact() {
				(0, _reactScrollToComponent2.default)(this.covidSection, {
					offset: 0,
					align: 'middle',
					duration: 1000,
					ease: 'inOutCube'
				});
			}
		}, {
			key: 'toggleFormOpen',
			value: function toggleFormOpen() {
				this.setState({ formOpen: !this.state.formOpen });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Covid19' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/covid19/banners/covid_banner.jpg', alt: 'Diamonds Direct COVID-19 Updates' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/covid19/banners/covid_banner_m.jpg', alt: 'Diamonds Direct COVID-19 Updates' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'titleArea' },
							_react2.default.createElement(
								'div',
								{ className: 'mainTitle' },
								'COVID-19 Protocols'
							),
							_react2.default.createElement(
								'div',
								{ className: 'titleCopy' },
								'As your trusted jeweler, we are taking every measure to ensure you feel safe and comfortable shopping with us. We are following all state and local mandates regarding public health and safety to ensure the health and wellbeing of our customers and employees. Here is how we are taking action:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'titleCopy' },
								_react2.default.createElement(
									'strong',
									null,
									'Curbside Pick-Up:'
								),
								' Curbside pick-up is available at all Diamonds Direct locations. To coordinate your pick up, please contact your ',
								_react2.default.createElement(
									'span',
									{ className: 'titleLink', onClick: function onClick() {
											return _this9.internalNav('locations');
										} },
									'local showroom'
								),
								'.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'titleCopy' },
								_react2.default.createElement(
									'strong',
									null,
									'In-Store Appointments:'
								),
								' Requesting an in-store appointment is a great way for our experts to help you shop with us efficiently and safely. Though appointments are not required, they help us meet your personal needs while maintaining social distancing in our showroom. To request an in-store appointment, ',
								_react2.default.createElement(
									'span',
									{ className: 'titleLink', onClick: this.scrollToContact.bind(this) },
									'click here'
								),
								'.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'bodyArea' },
							_react2.default.createElement(
								'div',
								{ className: 'iconArea' },
								_react2.default.createElement(
									'div',
									{ className: 'bodyTitle' },
									'We are operating our showrooms with recommended health and safety protocols, including:'
								),
								_react2.default.createElement(
									'div',
									{ className: 'iconWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'iconItem' },
										_react2.default.createElement(
											'div',
											{ className: 'itemIcon' },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/wellness.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemTitle' },
											'Wellness Checks'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemBody' },
											'All experts and team members are encouraged to conduct self-wellness checks prior to entering our workspaces. If employees are not feeling well, they are encouraged to stay home.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'iconItem' },
										_react2.default.createElement(
											'div',
											{ className: 'itemIcon' },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/mask.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemTitle' },
											'Wearing Masks'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemBody' },
											'For the safety of the Diamonds Direct team and our guests, all staff will be wearing masks for all of our protection. We kindly ask that our customers wear face coverings as well. We appreciate your cooperation!'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'iconItem' },
										_react2.default.createElement(
											'div',
											{ className: 'itemIcon' },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/hand.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemTitle' },
											'Hand Sanitizing'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemBody' },
											'Experts and team members are encouraged to frequently wash their hands for 20 seconds or more throughout the day. Hand sanitizing stations are available in all showrooms for employees and guests as well.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'iconItem' },
										_react2.default.createElement(
											'div',
											{ className: 'itemIcon' },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/cleaning.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemTitle' },
											'Enhanced Cleaning'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemBody' },
											'Our showrooms have increased their sanitation and disinfecting protocols. All high-touch surfaces are thoroughly sanitized before opening, throughout the business day, and after closing to ensure the safety of our customers and team.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'iconItem' },
										_react2.default.createElement(
											'div',
											{ className: 'itemIcon rulerIcon' },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/distancing.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemTitle' },
											'Social Distancing'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemBody' },
											'Team members and guests are encouraged to maintain a social distance of 6 feet or more where possible in our showrooms.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'iconItem' },
										_react2.default.createElement(
											'div',
											{ className: 'itemIcon' },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/shopping.svg' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemTitle' },
											'Contactless Shopping'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemBody' },
											'Experience the Diamonds Direct difference from anywhere at www.diamondsdirect.com. Connect with a diamond expert using our video chat and virtual appointment tools.'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'storeArea' },
								_react2.default.createElement(
									'div',
									{ className: 'bodyTitle' },
									'View operational updates for the location nearest you:'
								),
								_react2.default.createElement(
									'div',
									{ className: 'storeDropDownWrapper' },
									_react2.default.createElement(_RhinoSelect2.default, {
										selectClass: 'contactSelect',
										value: this.state.dropdownValue,
										options: this.state.locations,
										changeMethod: function changeMethod(evt) {
											return _this9.changeViewLocation(evt);
										} })
								),
								_react2.default.createElement(
									'div',
									{ className: 'storeResultsWrapper' },
									!this.state.dropdownValue ? _react2.default.createElement(
										'div',
										null,
										this.nullResult()
									) : _react2.default.createElement(
										'div',
										null,
										this.showStoreSection()
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'covidContact', ref: function ref(div) {
								_this9.covidSection = div;
							} },
						_react2.default.createElement(
							'div',
							{ className: 'covidTitle' },
							'Connect with an Expert'
						),
						_react2.default.createElement(
							'div',
							{ className: 'covidCopy', style: { display: 'none' } },
							'Our diamond experts have the resources to assist you from the comfort of your home via live chat, video chat, text, phone call, and email. All online orders qualify for free, secure shipping and hassle-free, 30-day returns. Contactless curbside pick-up is available at all locations. To request an in-store or virtual appointment, please fill out the form below:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'scheduleBody' },
							_react2.default.createElement('div', { className: 'scheduleBr' }),
							_react2.default.createElement(
								'div',
								{ className: 'sbText' },
								'Our diamond experts have the resources to assist you from the comfort of your home via live chat, video chat, text, phone call, and email. All online orders qualify for free, secure shipping and hassle-free, 30-day returns. Contactless curbside pick-up is available at all locations. To request an in-store or virtual appointment, please fill out the form below:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'optionsWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'optionItem' },
									_react2.default.createElement(
										'div',
										{ className: 'optionImg' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/contact/chat.svg' })
									),
									_react2.default.createElement('div', { className: 'optionBr' }),
									_react2.default.createElement(
										'div',
										{ className: 'optionTitle' },
										_react2.default.createElement(
											'div',
											null,
											'Chat with Live Experts Now'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'optionButton', onClick: this.openIntercom.bind(this) },
										'Chat Now'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'optionItem' },
									_react2.default.createElement(
										'div',
										{ className: 'optionImg' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/contact/video.svg' })
									),
									_react2.default.createElement('div', { className: 'optionBr' }),
									_react2.default.createElement(
										'div',
										{ className: 'optionTitle' },
										_react2.default.createElement(
											'div',
											null,
											'Live Video with Experts Now'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'optionButton', onClick: function onClick() {
												return _this9.internalNav('video-chat');
											} },
										'Video Chat Now'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'optionItem' },
									_react2.default.createElement(
										'div',
										{ className: 'optionImg' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/contact/appt.svg' })
									),
									_react2.default.createElement('div', { className: 'optionBr' }),
									_react2.default.createElement(
										'div',
										{ className: 'optionTitle' },
										_react2.default.createElement(
											'div',
											null,
											'In-Store Appointment'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: this.state.formOpen ? 'optionButton selected' : 'optionButton', onClick: this.toggleFormOpen.bind(this) },
										'Request Appointment'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: this.state.formOpen ? 'sbFormWrapper openForm' : 'sbFormWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'contactPageForm' },
									_react2.default.createElement(
										'div',
										{ className: 'formBody' },
										_react2.default.createElement(
											'div',
											{ className: 'formRow' },
											_react2.default.createElement(
												'div',
												{ className: 'oneHalfSection' },
												_react2.default.createElement('input', {
													className: this.state.errorName ? 'textInput error' : 'textInput',
													type: 'text',
													placeholder: 'Full Name*',
													value: this.state.inputName,
													onChange: this.changeName.bind(this) })
											),
											_react2.default.createElement(
												'div',
												{ className: 'oneHalfSection' },
												_react2.default.createElement('input', {
													className: this.state.errorEmail ? 'textInput error' : 'textInput',
													type: 'email',
													placeholder: 'Email Address*',
													value: this.state.inputEmail,
													onChange: this.changeEmail.bind(this) })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'formRow' },
											_react2.default.createElement(
												'div',
												{ className: 'oneHalfSection' },
												_react2.default.createElement('input', {
													className: this.state.errorPhone ? 'textInput error' : 'textInput',
													type: 'text',
													placeholder: 'Telephone',
													value: this.state.inputPhone,
													onChange: this.changePhone.bind(this) })
											),
											_react2.default.createElement(
												'div',
												{ className: 'oneHalfSection' },
												_react2.default.createElement(_RhinoSelect2.default, {
													selectClass: 'contactSelect contactPageSelect',
													required: true,
													options: this.state.locations,
													changeMethod: function changeMethod(evt) {
														return _this9.changeLocation(evt);
													},
													value: this.state.inputLocation,
													error: this.state.errorLocation })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'formRow' },
											_react2.default.createElement(
												'div',
												{ className: 'textareaInputWrapper' },
												_react2.default.createElement('textarea', {
													className: this.state.errorMessage ? 'textTextarea error' : 'textTextarea',
													placeholder: 'How can we help you?',
													value: this.state.inputMessage,
													onChange: this.changeMessage.bind(this) })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'formRow' },
											_react2.default.createElement(
												'div',
												{ className: 'submitButton actionButton', onClick: this.submitContactRequest.bind(this) },
												'Submit'
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'sbText' },
								'We look forward to connecting with you!'
							)
						)
					)
				);
			}
		}]);
	
		return Covid19;
	}(_react2.default.Component);
	
	Covid19.propTypes = {
		location: _react.PropTypes.object
	};
	Covid19.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Covid19;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Covid19Container = exports.Covid19Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Covid19);

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.December2018Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var December2018 = function (_React$Component) {
		_inherits(December2018, _React$Component);
	
		function December2018(props) {
			_classCallCheck(this, December2018);
	
			return _possibleConstructorReturn(this, (December2018.__proto__ || Object.getPrototypeOf(December2018)).call(this, props));
		}
	
		_createClass(December2018, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'December2018' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: '/img/promopages/december2018/landing_dis.jpg', alt: 'Diamonds Direct December Financing' }),
						_react2.default.createElement('img', { className: 'mobile600', src: '/img/promopages/december2018/landing_dis_mobile.jpg', alt: 'Diamonds Direct December Financing' }),
						_react2.default.createElement(
							'a',
							{ href: 'tel:8004315921' },
							_react2.default.createElement('div', { className: 'phoneLinkOverlay' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'bodyWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'promoText' },
								'Make this holiday season bright with our exclusive December Financing Event:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoActionBox' },
								_react2.default.createElement(
									'div',
									{ className: 'boxTitle' },
									'0% APR for 36 Months*'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxDisclaimer' },
									'Subject to credit approval.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxDates' },
									'Available Dec. 1-31'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxButton', onClick: function onClick() {
											return _this2.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
										} },
									'Learn More & Apply'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxDisclaimer2' },
									'Special financing cannot be combined with other discounts or offers. See representative for details.'
								)
							)
						)
					)
				);
			}
		}]);
	
		return December2018;
	}(_react2.default.Component);
	
	December2018.propTypes = {
		location: _react.PropTypes.object
	};
	December2018.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = December2018;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var December2018Container = exports.December2018Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(December2018);

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.December2019Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var December2019 = function (_React$Component) {
		_inherits(December2019, _React$Component);
	
		function December2019(props) {
			_classCallCheck(this, December2019);
	
			return _possibleConstructorReturn(this, (December2019.__proto__ || Object.getPrototypeOf(December2019)).call(this, props));
		}
	
		_createClass(December2019, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'December2019' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2019/dd_decfi2019_landingpage.jpg', alt: 'Diamonds Direct December Financing' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2019/dd_decfi2019_landingpage_mobile.jpg', alt: 'Diamonds Direct December Financing' }),
						_react2.default.createElement(
							'a',
							{ href: 'tel:8004315921' },
							_react2.default.createElement('div', { className: 'phoneLinkOverlay' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'bodyWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'promoText' },
								'Let your love shine bright this holiday season with our exclusive December financing event.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoActionBox' },
								_react2.default.createElement(
									'div',
									{ className: 'boxTitle' },
									'0% APR for 36 Months*'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxDisclaimer' },
									'Subject to credit approval.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxDates' },
									'Available Dec. 1-31'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxButton', onClick: function onClick() {
											return _this2.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
										} },
									'*Learn More & Apply'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxDisclaimer2' },
									'Special financing cannot be combined with other discounts or offers. See representative for details.'
								)
							)
						)
					)
				);
			}
		}]);
	
		return December2019;
	}(_react2.default.Component);
	
	December2019.propTypes = {
		location: _react.PropTypes.object
	};
	December2019.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = December2019;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var December2019Container = exports.December2019Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(December2019);

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.December2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var December2021 = function (_React$Component) {
		_inherits(December2021, _React$Component);
	
		function December2021(props) {
			_classCallCheck(this, December2021);
	
			var _this = _possibleConstructorReturn(this, (December2021.__proto__ || Object.getPrototypeOf(December2021)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesignerLocation: null,
	
				bgWidth: 0,
				bgHeight: 0
			};
	
			// Bind event listeners
			_this.adjustBackground = _this.adjustBackground.bind(_this);
			return _this;
		}
	
		_createClass(December2021, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				window.addEventListener('resize', this.adjustBackground, false);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.adjustBackground();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				window.removeEventListener('resize', this.adjustBackground, false);
			}
		}, {
			key: 'adjustBackground',
			value: function adjustBackground() {
	
				var clientWidth = this.topBox.clientWidth;
				var clientHeight = this.topBox.clientHeight;
	
				this.setState({
					bgWidth: clientWidth,
					bgHeight: clientHeight
				});
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'giftsNav',
			value: function giftsNav() {
				var pg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
				window.location.href = 'https://gifts.diamondsdirect.com/' + pg;
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'getLocationDesigners',
			value: function getLocationDesigners() {
				return [];
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeDesigner',
			value: function changeDesigner(evt) {
				this.setState({ inputDesigner: evt.target.value });
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'getShowDates',
			value: function getShowDates(code) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = this.state.designerLocationArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var l = _step.value;
	
						if (l.value === code) {
							return l.dates;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'getShowLink',
			value: function getShowLink(code) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = this.state.designerLocationArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var l = _step2.value;
	
						if (l.value === code) {
							return l.page;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'designerNav',
			value: function designerNav(page) {
				if (!page) {
					return;
				}
				this.internalNav(page);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'December2021' },
					_react2.default.createElement('img', { src: 'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=lead&pixid=7333a400-055a-4ea4-a1b7-835149f34435', width: '1', height: '1' }),
					_react2.default.createElement(
						'div',
						{ className: 'headerSection' },
						_react2.default.createElement(
							'div',
							{ className: 'headerSectionWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2021/decfi_lander_banner.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2021/decfi_lander_banner_m.jpg' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'topSection' },
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'To help you celebrate with the ones you love most this year, we\'re putting together some ',
							_react2.default.createElement(
								'strong',
								null,
								'amazing surprises!'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'Check in with us online or in-store to take advantage of:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'boxSection' },
							_react2.default.createElement(
								'div',
								{ className: 'fuBox' },
								_react2.default.createElement(
									'div',
									{ className: 'box1' },
									'0% APR for 4 Years*'
								),
								_react2.default.createElement(
									'div',
									{ className: 'box2' },
									'Subject to credit approval.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'box3' },
									'Available Now - Dec. 31'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxButton', onClick: function onClick() {
											return _this7.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
										} },
									_react2.default.createElement(
										'div',
										null,
										'Ready to Apply'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'topGallery' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2021/defi_editorial.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2021/defi_editorial_m.jpg' }),
							_react2.default.createElement('div', { className: 'ol ol1', onClick: function onClick() {
									return _this7.internalNav('setting/SMD1444898');
								} }),
							_react2.default.createElement('div', { className: 'ol ol2', onClick: function onClick() {
									return _this7.internalNav('band/BGD03286');
								} }),
							_react2.default.createElement('div', { className: 'ol ol3', onClick: function onClick() {
									return _this7.internalNav('jewelry/BLDLG14382');
								} }),
							_react2.default.createElement('div', { className: 'ol ol4', onClick: function onClick() {
									return _this7.internalNav('band/BLDSM09944');
								} }),
							_react2.default.createElement('div', { className: 'ol ol5', onClick: function onClick() {
									return _this7.giftsNav('necklaces');
								} })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Full Name*',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email Address*',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Telephone',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											selectClass: 'summerSelect',
											required: true,
											value: this.state.inputLocation,
											options: this.state.locations,
											changeMethod: function changeMethod(evt) {
												return _this7.changeLocation(evt);
											},
											error: this.state.errorLocation !== null })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Request an appointment'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'ggSection' },
						_react2.default.createElement(
							'div',
							{ className: 'ggTitle' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/december2021/defi_gg.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggLine' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/iline.svg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/iline_m.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Diamonds Direct invites you to enjoy this holiday season with a little extra sparkle! From now until the ball drops we\u2019ll be toasting to the best part of the year.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggButton', onClick: function onClick() {
									return _this7.giftsNav();
								} },
							'Shop Holiday Gifts'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggItemRow' },
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDXL18079');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg1' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Emerald Diamond Halo Ring'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDMD30060');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg2' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Simon G. Butterfly Diamond Ring'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/NFANC29328');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg3' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Baguette Diamond Circle Pendant'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/EFAND14379');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg4' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Diamond Floral Inspired Studs'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'legalSection' },
						_react2.default.createElement(
							'div',
							{ className: 'legalInnerWrapper' },
							'*Discount excludes certified diamonds and price protected lines. Cannot be combined with other offers.'
						)
					)
				);
			}
		}]);
	
		return December2021;
	}(_react2.default.Component);
	
	December2021.propTypes = {
		location: _react.PropTypes.object
	};
	December2021.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = December2021;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var December2021Container = exports.December2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(December2021);

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Earring2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Earring2021 = function (_React$Component) {
		_inherits(Earring2021, _React$Component);
	
		function Earring2021(props) {
			_classCallCheck(this, Earring2021);
	
			var _this = _possibleConstructorReturn(this, (Earring2021.__proto__ || Object.getPrototypeOf(Earring2021)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesignerLocation: null,
	
				bgWidth: 0,
				bgHeight: 0
			};
	
			// Bind event listeners
			_this.adjustBackground = _this.adjustBackground.bind(_this);
			return _this;
		}
	
		_createClass(Earring2021, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				window.addEventListener('resize', this.adjustBackground, false);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.adjustBackground();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				window.removeEventListener('resize', this.adjustBackground, false);
			}
		}, {
			key: 'adjustBackground',
			value: function adjustBackground() {
	
				var clientWidth = this.topBox.clientWidth;
				var clientHeight = this.topBox.clientHeight;
	
				this.setState({
					bgWidth: clientWidth,
					bgHeight: clientHeight
				});
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'giftsNav',
			value: function giftsNav() {
				var pg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
				window.location.href = 'https://gifts.diamondsdirect.com/' + pg;
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'getLocationDesigners',
			value: function getLocationDesigners() {
				return [];
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeDesigner',
			value: function changeDesigner(evt) {
				this.setState({ inputDesigner: evt.target.value });
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'getShowDates',
			value: function getShowDates(code) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = this.state.designerLocationArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var l = _step.value;
	
						if (l.value === code) {
							return l.dates;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'getShowLink',
			value: function getShowLink(code) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = this.state.designerLocationArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var l = _step2.value;
	
						if (l.value === code) {
							return l.page;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'designerNav',
			value: function designerNav(page) {
				if (!page) {
					return;
				}
				this.internalNav(page);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Earring2021' },
					_react2.default.createElement('img', { src: 'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=lead&pixid=7333a400-055a-4ea4-a1b7-835149f34435', width: '1', height: '1' }),
					_react2.default.createElement(
						'div',
						{ className: 'headerSection' },
						_react2.default.createElement(
							'div',
							{ className: 'headerSectionWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/ee_banner.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/ee_banner_m.jpg' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'topSection' },
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'To help you celebrate with the ones you love most this year, we\'re putting together some ',
							_react2.default.createElement(
								'strong',
								null,
								'amazing surprises!'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'Check in with us online or in-store to take advantage of:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'topTitleImg' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/25percent.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'topGallery' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/editorial.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/editorial_m.jpg' }),
							_react2.default.createElement('div', { className: 'ol ol1', onClick: function onClick() {
									return _this7.internalNav('jewelry/EFAND18102');
								} }),
							_react2.default.createElement('div', { className: 'ol ol2', onClick: function onClick() {
									return _this7.internalNav('diamond-studs');
								} }),
							_react2.default.createElement('div', { className: 'ol ol3', onClick: function onClick() {
									return _this7.internalNav('jewelry/ECLST05682');
								} }),
							_react2.default.createElement('div', { className: 'ol ol4', onClick: function onClick() {
									return _this7.internalNav('jewelry/EFAND17506');
								} })
						),
						_react2.default.createElement(
							'div',
							{ className: 'topLegal' },
							'*Discount excludes certified diamonds and price protected lines. Cannot be combined with other offers.'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Full Name*',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email Address*',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Telephone',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											selectClass: 'summerSelect',
											required: true,
											value: this.state.inputLocation,
											options: this.state.locations,
											changeMethod: function changeMethod(evt) {
												return _this7.changeLocation(evt);
											},
											error: this.state.errorLocation !== null })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Request an appointment'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'ggSection' },
						_react2.default.createElement(
							'div',
							{ className: 'ggTitle' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/gg.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggLine' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/iline.svg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/iline_m.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Diamonds Direct invites you to enjoy this holiday season with a little extra sparkle! From now until the ball drops we\u2019ll be toasting to the best part of the year.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggButton', onClick: function onClick() {
									return _this7.giftsNav();
								} },
							'Shop Holiday Gifts'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggItemRow' },
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDXL18079');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg1' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Emerald Diamond Halo Ring'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDMD30060');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg2' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Simon G. Butterfly Diamond Ring'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/NFANC29328');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg3' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Baguette Diamond Circle Pendant'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/EFAND14379');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg4' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Diamond Floral Inspired Studs'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Earring2021;
	}(_react2.default.Component);
	
	Earring2021.propTypes = {
		location: _react.PropTypes.object
	};
	Earring2021.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Earring2021;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Earring2021Container = exports.Earring2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Earring2021);

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Earring2022Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Earring2022 = function (_React$Component) {
		_inherits(Earring2022, _React$Component);
	
		function Earring2022(props) {
			_classCallCheck(this, Earring2022);
	
			var _this = _possibleConstructorReturn(this, (Earring2022.__proto__ || Object.getPrototypeOf(Earring2022)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Earring2022, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				// this.giftsNav();
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'getLocationDesigners',
			value: function getLocationDesigners() {
				return [];
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeDesigner',
			value: function changeDesigner(evt) {
				this.setState({ inputDesigner: evt.target.value });
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'getShowDates',
			value: function getShowDates(code) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = this.state.designerLocationArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var l = _step.value;
	
						if (l.value === code) {
							return l.dates;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'getShowLink',
			value: function getShowLink(code) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = this.state.designerLocationArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var l = _step2.value;
	
						if (l.value === code) {
							return l.page;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'designerNav',
			value: function designerNav(page) {
				if (!page) {
					return;
				}
				this.internalNav(page);
			}
		}, {
			key: 'giftsNav',
			value: function giftsNav(page) {
				window.location.href = 'https://gifts.diamondsdirect.com';
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Earring2022' },
					_react2.default.createElement(
						'div',
						{ className: 'headerSection' },
						_react2.default.createElement(
							'div',
							{ className: 'headerSectionWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/header.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/header_m.jpg' }),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'shopButton', onClick: function onClick() {
										return _this7.internalNav('gallery/engagement-rings');
									}, style: { display: 'none' } },
								'Shop Now'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'shopSection', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'shopButtonWrapper' },
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'shopButton' },
								'Shop Online Now'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'shopTilesWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'shopTile', onClick: function onClick() {
										return _this7.internalNav('gallery/wedding-bands/womens');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'shopImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/studs.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'shopTileButton' },
									_react2.default.createElement(
										'div',
										null,
										'Shop Wedding Bands'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'shopTile', onClick: function onClick() {
										return _this7.internalNav('gallery/engagement-rings?mode=setting');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'shopImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/engagement.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'shopTileButton' },
									_react2.default.createElement(
										'div',
										null,
										'Shop Engagement'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'shopTile', onClick: function onClick() {
										return _this7.internalNav('gallery/fine-jewelry?type=ring,earring,necklace,bracelet');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'shopImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/pendants.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'shopTileButton' },
									_react2.default.createElement(
										'div',
										null,
										'Shop Fashion'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'titleSection' },
						_react2.default.createElement(
							'div',
							{ className: 'title1' },
							'It\u2019s not too late to shop for the perfect holiday gift!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'title2' },
							'25% OFF ALL EARRINGS',
							_react2.default.createElement(
								'sup',
								null,
								'*'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'title3' },
							'Ready to wrap for the one you love!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'title4' },
							'Available online now or in stores December 9 -11'
						),
						_react2.default.createElement(
							'div',
							{ className: 'titleAction', onClick: function onClick() {
									return _this7.internalNav('gallery/fine-jewelry?type=earring');
								} },
							'Shop Earrings'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'looksSection' },
						_react2.default.createElement(
							'div',
							{ className: 'looksWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/edit.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/edit_m.jpg' }),
							_react2.default.createElement(_reactRouter.Link, { to: '/diamond-studs', className: 'lb lb1' }),
							_react2.default.createElement(_reactRouter.Link, { to: '/jewelry/PRLFE00688', className: 'lb lb2' }),
							_react2.default.createElement(_reactRouter.Link, { to: '/jewelry/EFAND18662', className: 'lb lb3' }),
							_react2.default.createElement(_reactRouter.Link, { to: '/jewelry/EFAND17506', className: 'lb lb4' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Walk-in visits are always welcome! But if you\'d prefer to set up an appointment online or in-store, please use the form below and we will follow up to confirm!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Full Name*',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email Address*',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Telephone',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											selectClass: 'summerSelect',
											required: true,
											value: this.state.inputLocation,
											options: this.state.locations,
											changeMethod: function changeMethod(evt) {
												return _this7.changeLocation(evt);
											},
											error: this.state.errorLocation !== null })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Request an appointment'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'midHeaderSection', onClick: function onClick() {
								return _this7.internalNav('financing');
							} },
						_react2.default.createElement(
							'div',
							{ className: 'midHeaderSectionWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/dec_fi.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/dec_fi_m.jpg' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'ggSection' },
						_react2.default.createElement(
							'div',
							{ className: 'ggTitle' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/ee_gg.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggLine' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/gg_iconline.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggButton', onClick: this.giftsNav.bind(this) },
							'Shop Holiday Gifts'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggItemRow' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/jewelry/BLDXL18079', className: 'ggItem' },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg1' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Emerald Diamond Halo Ring'
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/jewelry/ECLST07283', className: 'ggItem' },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg2' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Sapphire and Diamond Hoop Earrings'
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/jewelry/NFANC22315', className: 'ggItem' },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg3' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Diamond Dangle Station Necklace'
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/band/BLDSM23102', className: 'ggItem' },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg4' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Inlay Matte Diamond Band'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'legalSection' },
						_react2.default.createElement(
							'div',
							{ className: 'legalInnerWrapper' },
							'*Discount excludes GIA certified diamonds and price-protected designer lines. Cannot be combined with other offers. Inquire for details.'
						)
					)
				);
			}
		}]);
	
		return Earring2022;
	}(_react2.default.Component);
	
	Earring2022.propTypes = {
		location: _react.PropTypes.object
	};
	Earring2022.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Earring2022;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Earring2022Container = exports.Earring2022Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Earring2022);

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Fall2018Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var Fall2018 = function (_React$Component) {
		_inherits(Fall2018, _React$Component);
	
		function Fall2018(props) {
			_classCallCheck(this, Fall2018);
	
			return _possibleConstructorReturn(this, (Fall2018.__proto__ || Object.getPrototypeOf(Fall2018)).call(this, props));
		}
	
		_createClass(Fall2018, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Fall2018' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: '/img/promopages/fall2018/landingpagebanner_disclaimer_a.jpg', alt: 'Diamonds Direct Fall' }),
						_react2.default.createElement('img', { className: 'mobile600', src: '/img/promopages/fall2018/landingpagebanner_disclaimermobile_a.jpg', alt: 'Diamonds Direct Fall' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'bodyWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'promoText' },
								'Make this Fall the beginning of something special with our exclusive September Financing Event:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoActionBox' },
								_react2.default.createElement(
									'div',
									{ className: 'boxTitle' },
									'0% APR for 60 Months*'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxDisclaimer' },
									'Subject to credit approval.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxDates' },
									'Available Sept. 1-30'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxButton', onClick: function onClick() {
											return _this2.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
										} },
									'Learn More & Apply'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'specialHoursTitle' },
								'Special Hours:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'specialHoursInfo' },
								'Sunday, September 30th, 12\xA0p.m. - 6\xA0p.m.'
							)
						)
					)
				);
			}
		}]);
	
		return Fall2018;
	}(_react2.default.Component);
	
	Fall2018.propTypes = {
		location: _react.PropTypes.object
	};
	Fall2018.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Fall2018;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Fall2018Container = exports.Fall2018Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Fall2018);

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Fall2019Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var Fall2019 = function (_React$Component) {
		_inherits(Fall2019, _React$Component);
	
		function Fall2019(props) {
			_classCallCheck(this, Fall2019);
	
			return _possibleConstructorReturn(this, (Fall2019.__proto__ || Object.getPrototypeOf(Fall2019)).call(this, props));
		}
	
		_createClass(Fall2019, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Fall2019' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/fall2019/landing.jpg', alt: 'Diamonds Direct Fall' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/fall2019/landing_mobile.jpg', alt: 'Diamonds Direct Fall' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'bodyWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'bodyContent' },
								_react2.default.createElement('div', { className: 'leftBackground' }),
								_react2.default.createElement(
									'div',
									{ className: 'contentLeft' },
									_react2.default.createElement(
										'div',
										{ className: 'leftText' },
										'Shower the star in your life with affection with our exclusive fall financing event.'
									),
									_react2.default.createElement(
										'div',
										{ className: 'leftDateTitle' },
										'Special Hours:'
									),
									_react2.default.createElement(
										'div',
										{ className: 'leftDate' },
										'Sunday, September 29th'
									),
									_react2.default.createElement(
										'div',
										{ className: 'leftDate' },
										'12 p.m. - 6 p.m.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'contentRight' },
									_react2.default.createElement(
										'div',
										{ className: 'boxTitle' },
										'0% APR for 60 Months*'
									),
									_react2.default.createElement(
										'div',
										{ className: 'boxDisclaimer' },
										'Subject to credit approval.'
									),
									_react2.default.createElement(
										'div',
										{ className: 'boxDates' },
										'Available Aug. 31 - Sept. 30'
									),
									_react2.default.createElement(
										'div',
										{ className: 'boxButton', onClick: function onClick() {
												return _this2.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
											} },
										'*Learn More & Apply'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Fall2019;
	}(_react2.default.Component);
	
	Fall2019.propTypes = {
		location: _react.PropTypes.object
	};
	Fall2019.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Fall2019;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Fall2019Container = exports.Fall2019Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Fall2019);

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Holiday2018Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var Holiday2018 = function (_React$Component) {
		_inherits(Holiday2018, _React$Component);
	
		function Holiday2018(props) {
			_classCallCheck(this, Holiday2018);
	
			return _possibleConstructorReturn(this, (Holiday2018.__proto__ || Object.getPrototypeOf(Holiday2018)).call(this, props));
		}
	
		_createClass(Holiday2018, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'Holiday2018' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: '/img/promopages/holiday2018/landing_page_banner-a.jpg', alt: 'Diamonds Direct Holiday' }),
						_react2.default.createElement('img', { className: 'mobile600', src: '/img/promopages/holiday2018/landing_page_mobile-a.jpg', alt: 'Diamonds Direct Holiday' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'promoText' },
							'This winter, make all of their Sparkling Winter Wishes come true with our in-store exclusive Winter Event. Enjoy:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'promoHighlightSection' },
							'20% Special Savings*'
						),
						_react2.default.createElement(
							'div',
							{ className: 'promoText', style: { margin: '0' } },
							'Internationally renowned designers have curated ',
							_react2.default.createElement(
								'span',
								{ className: 'light-em' },
								'exclusive collections'
							),
							' for each of our stores. Visit our locations to learn more!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'summerLocationBlock' },
							_react2.default.createElement(
								'div',
								{ className: 'summerLocationItem' },
								_react2.default.createElement(
									'div',
									{ className: 'summerDates' },
									'Nov. 9-11'
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocations' },
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/columbus' },
										'Columbus,\xA0OH'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/virginia-beach' },
										'Virginia\xA0Beach,\xA0VA'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'summerLocationItem' },
								_react2.default.createElement(
									'div',
									{ className: 'summerDates' },
									'Nov. 16-18'
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocations' },
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/charlotte' },
										'Charlotte,\xA0NC'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/jacksonville' },
										'Jacksonville,\xA0FL'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/birmingham' },
										'Birmingham,\xA0AL'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/dallas' },
										'Dallas,\xA0TX'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/indianapolis' },
										'Indianapolis,\xA0IN'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/richmond' },
										'Richmond,\xA0VA'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'summerLocationItem' },
								_react2.default.createElement(
									'div',
									{ className: 'summerDates' },
									'Nov. 30 - Dec. 2'
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocations' },
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/oklahoma-city' },
										'Oklahoma\xA0City,\xA0OK'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/sanantonio' },
										'San\xA0Antonio,\xA0TX'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/austin' },
										'Austin,\xA0TX'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/charleston' },
										'Charleston,\xA0SC'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/salt-lake-city' },
										'Salt\xA0Lake\xA0City,\xA0UT'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/raleigh' },
										'Raleigh,\xA0NC'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/st-louis' },
										'St.\xA0Louis,\xA0MO'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'summerLocationItem' },
								_react2.default.createElement(
									'div',
									{ className: 'summerDates' },
									'Dec. 7 - 9'
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocations' },
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/kansas-city' },
										'Kansas\xA0City,\xA0KS'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'dislaimerLine' },
							'* In-store only, excludes price protected lines and certified diamonds'
						)
					)
				);
			}
		}]);
	
		return Holiday2018;
	}(_react2.default.Component);
	
	Holiday2018.propTypes = {
		location: _react.PropTypes.object
	};
	Holiday2018.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Holiday2018;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Holiday2018Container = exports.Holiday2018Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Holiday2018);

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Holiday2019Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var Holiday2019 = function (_React$Component) {
		_inherits(Holiday2019, _React$Component);
	
		function Holiday2019(props) {
			_classCallCheck(this, Holiday2019);
	
			return _possibleConstructorReturn(this, (Holiday2019.__proto__ || Object.getPrototypeOf(Holiday2019)).call(this, props));
		}
	
		_createClass(Holiday2019, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'scrollToDates',
			value: function scrollToDates() {
				(0, _reactScrollToComponent2.default)(this.biosSection, {
					offset: 0,
					align: 'middle',
					duration: 1000,
					ease: 'inOutCube'
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Holiday2019' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://s3.amazonaws.com/dd-website/img/promopages/holiday2019/landingbanner_a.jpg', alt: 'Diamonds Direct Summer' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://s3.amazonaws.com/dd-website/img/promopages/holiday2019/landingbanner_mobile_a.jpg', alt: 'Diamonds Direct Summer' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'preBoxText' },
						_react2.default.createElement(
							'div',
							{ className: 'holidayTextLarge' },
							'Only Diamonds Direct has multiple offers for you to sparkle and save this holiday season!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'notabutton' },
							'SHOP IN STORE'
						),
						_react2.default.createElement(
							'div',
							{ className: 'holidayText' },
							'You\u2019re invited to our Holiday Designer Showcase!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'holidayTextAgain' },
							'Five stores left for the sale of the season! ',
							_react2.default.createElement(
								'strong',
								null,
								'Dec. 6 - 8'
							),
							'.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'holidayPercent' },
							'20% Savings'
						),
						_react2.default.createElement(
							'div',
							{ className: 'holidayTextOnceMore' },
							'on engagement ring settings, wedding bands AND fine fashion jewelry like diamond studs, pendants, bracelets and more!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'holidayTextForTheFifthTimeInADifferentStyleWhyGodWhy' },
							'Visit a Showroom Near You:'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody', ref: function ref(div) {
								_this2.biosSection = div;
							} },
						_react2.default.createElement(
							'div',
							{ className: 'promoBodyInner' },
							_react2.default.createElement(
								'div',
								{ className: 'springLocationBlock' },
								_react2.default.createElement(
									'div',
									{ className: "springLocationItem" },
									_react2.default.createElement(
										'div',
										{ className: "springDates pastDate" },
										_react2.default.createElement(
											'div',
											{ className: 'desktopOnly' },
											'Nov. 15-17\xA0\xA0\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'mobileOnly' },
											'Nov. 15-17'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: "springLocations pastDate" },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/charleston' },
											'Charleston,\xA0SC'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/oklahoma-city' },
											'Oklahoma\xA0City,\xA0OK'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/richmond' },
											'Richmond,\xA0VA'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/indianapolis' },
											'Indianapolis,\xA0IN'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/jacksonville' },
											'Jacksonville,\xA0FL'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/columbus' },
											'Columbus,\xA0OH'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/kansas-city' },
											'Kansas\xA0City,\xA0KS'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'springLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: "springDates pastDate" },
										_react2.default.createElement(
											'div',
											{ className: 'desktopOnly' },
											'Nov. 22-24\xA0\xA0\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'mobileOnly' },
											'Nov. 22-24'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: "springLocations pastDate" },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/charlotte' },
											'Charlotte,\xA0NC'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/birmingham' },
											'Birmingham,\xA0AL'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/raleigh' },
											'Raleigh,\xA0NC'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/virginia-beach' },
											'Virginia\xA0Beach,\xA0VA'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/frisco' },
											'Frisco,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/dallas' },
											'Dallas,\xA0TX'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/cleveland' },
											'Cleveland,\xA0OH'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: "springLocationItem doubleLine" },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										_react2.default.createElement(
											'div',
											{ className: 'desktopOnly' },
											'Dec. 6-8\xA0\xA0\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'mobileOnly' },
											'Dec. 6-8'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: "springLocations" },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/austin' },
											'Austin,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/san-antonio' },
											'San\xA0Antonio,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/st-louis' },
											'St.\xA0Louis,\xA0MO'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/salt-lake-city' },
											'Salt\xA0Lake\xA0City,\xA0UT'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/new-orleans' },
											'New\xA0Orleans,\xA0LA'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'footerButton' },
							_react2.default.createElement(
								'div',
								{ className: 'onlineButton', onClick: function onClick() {
										return _this2.externalNav('catalogsearch/advanced/?a=1&prod_type=engagement&attr=&opt=&dsgnr_id=&prc_min=1&prc_max=20000&order_by=rnd&limit=12&pg_no=1&url_prod_type=&q=');
									} },
								_react2.default.createElement(
									'div',
									null,
									'Shop Online'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'footerText1' },
							'Enjoy 20% savings'
						),
						_react2.default.createElement(
							'div',
							{ className: 'footerText2' },
							'On select engagement ring settings.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'footerText3' },
							'November 15',
							_react2.default.createElement(
								'sup',
								null,
								'th'
							),
							' \u2013 December 8',
							_react2.default.createElement(
								'sup',
								null,
								'th'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'footerText4' },
							'Discount applied in cart'
						),
						_react2.default.createElement(
							'div',
							{ className: 'promoLegal' },
							'*Discount excludes certified diamonds and price-protected lines.',
							_react2.default.createElement('br', null),
							'Cannot be combined with other offers.'
						)
					)
				);
			}
		}]);
	
		return Holiday2019;
	}(_react2.default.Component);
	
	Holiday2019.propTypes = {
		location: _react.PropTypes.object
	};
	Holiday2019.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Holiday2019;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Holiday2019Container = exports.Holiday2019Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Holiday2019);

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Holiday2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Holiday2021 = function (_React$Component) {
		_inherits(Holiday2021, _React$Component);
	
		function Holiday2021(props) {
			_classCallCheck(this, Holiday2021);
	
			var _this = _possibleConstructorReturn(this, (Holiday2021.__proto__ || Object.getPrototypeOf(Holiday2021)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesignerLocation: null,
	
				bgWidth: 0,
				bgHeight: 0
			};
	
			// Bind event listeners
			_this.adjustBackground = _this.adjustBackground.bind(_this);
			return _this;
		}
	
		_createClass(Holiday2021, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				window.addEventListener('resize', this.adjustBackground, false);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.adjustBackground();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				window.removeEventListener('resize', this.adjustBackground, false);
			}
		}, {
			key: 'adjustBackground',
			value: function adjustBackground() {
	
				var clientWidth = this.topBox.clientWidth;
				var clientHeight = this.topBox.clientHeight;
	
				this.setState({
					bgWidth: clientWidth,
					bgHeight: clientHeight
				});
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'giftsNav',
			value: function giftsNav() {
				window.location.href = 'https://gifts.diamondsdirect.com';
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'getLocationDesigners',
			value: function getLocationDesigners() {
				return [];
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeDesigner',
			value: function changeDesigner(evt) {
				this.setState({ inputDesigner: evt.target.value });
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'getShowDates',
			value: function getShowDates(code) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = this.state.designerLocationArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var l = _step.value;
	
						if (l.value === code) {
							return l.dates;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'getShowLink',
			value: function getShowLink(code) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = this.state.designerLocationArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var l = _step2.value;
	
						if (l.value === code) {
							return l.page;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'designerNav',
			value: function designerNav(page) {
				if (!page) {
					return;
				}
				this.internalNav(page);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Holiday2021' },
					_react2.default.createElement('img', { src: 'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=lead&pixid=7333a400-055a-4ea4-a1b7-835149f34435', width: '1', height: '1' }),
					_react2.default.createElement(
						'div',
						{ className: 'headerSection' },
						_react2.default.createElement(
							'div',
							{ className: 'headerSectionWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/holiday_head.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/holiday_head_m.jpg' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'topSection' },
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'To help you celebrate with the ones you love most this year, we\'re putting together some ',
							_react2.default.createElement(
								'strong',
								null,
								'amazing surprises!'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'Check in with us online or in-store to take advantage of:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'topTitleImg' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/20percent.svg' }),
							_react2.default.createElement(
								'div',
								{ className: 'star' },
								'*'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'topBox', ref: function ref(div) {
									_this7.topBox = div;
								} },
							_react2.default.createElement(
								'div',
								{ className: 'topBoxBg' },
								_react2.default.createElement('img', {
									style: {
										width: this.state.bgWidth + 'px',
										height: this.state.bgHeight + 'px'
									},
									src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/notrectangle.jpg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'weekWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'weekDate' },
									'November 12 - 14'
								),
								_react2.default.createElement('div', { className: 'weekHr' }),
								_react2.default.createElement(
									'div',
									{ className: 'weekDateRow' },
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('birmingham');
											} },
										'Birmingham, AL'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('austin');
											} },
										'Austin, TX'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('richmond');
											} },
										'Richmond, VA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('indianapolis');
											} },
										'Indianapolis, IN'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'weekDateRow' },
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('columbus');
											} },
										'Columbus, OH'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('kansas-city');
											} },
										'Kansas City, KS'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('pittsburgh');
											} },
										'Pittsburgh, PA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('greenville');
											} },
										'Greenville, SC'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'weekWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'weekDate' },
									'November 19 - 21'
								),
								_react2.default.createElement('div', { className: 'weekHr' }),
								_react2.default.createElement(
									'div',
									{ className: 'weekDateRow' },
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('charlotte');
											} },
										'Charlotte, NC'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('raleigh');
											} },
										'Raleigh, NC'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('charleston');
											} },
										'Charleston, SC'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('oklahoma-city');
											} },
										'Oklahoma City, OK'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'weekDateRow' },
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('virginia-beach');
											} },
										'Virginia Beach, VA'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('san-antonio');
											} },
										'San Antonio, TX'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('dallas');
											} },
										'Dallas, TX'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('frisco');
											} },
										'Frisco, TX'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'weekDateRow' },
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('jacksonville');
											} },
										'Jacksonville, FL'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('cleveland');
											} },
										'Cleveland, OH'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('new-orleans');
											} },
										'New Orleans, LA'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'weekDateRow' },
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('houston');
											} },
										'Houston, TX'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('st-louis');
											} },
										'St. Louis, MO'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekVr' },
										'|'
									),
									_react2.default.createElement(
										'div',
										{ className: 'weekLink', onClick: function onClick() {
												return _this7.internalNav('boca-Raton');
											} },
										'Boca Raton, FL'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'and an expanded selection from our favorite designers.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'topGallery' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/editorial.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/editorial_m.jpg' }),
							_react2.default.createElement('div', { className: 'ol ol1', onClick: function onClick() {
									return _this7.internalNav('jewelry/BLDSM22599');
								} }),
							_react2.default.createElement('div', { className: 'ol ol2', onClick: function onClick() {
									return _this7.internalNav('setting/SMD1444898');
								} }),
							_react2.default.createElement('div', { className: 'ol ol3', onClick: function onClick() {
									return _this7.internalNav('setting/SMD1467015');
								} }),
							_react2.default.createElement('div', { className: 'ol ol4', onClick: function onClick() {
									return _this7.internalNav('setting/SMD1466102');
								} }),
							_react2.default.createElement('div', { className: 'ol ol5', onClick: function onClick() {
									return _this7.internalNav('band/BGD03286');
								} })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Full Name*',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email Address*',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Telephone',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											selectClass: 'summerSelect',
											required: true,
											value: this.state.inputLocation,
											options: this.state.locations,
											changeMethod: function changeMethod(evt) {
												return _this7.changeLocation(evt);
											},
											error: this.state.errorLocation !== null })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Request an appointment'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'ggSection' },
						_react2.default.createElement(
							'div',
							{ className: 'ggTitle' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/holidaygg.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggLine' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/iline.svg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/iline_m.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Diamonds Direct invites you to enjoy this holiday season with a little extra sparkle! From now until the ball drops we\u2019ll be toasting to the best part of the year.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggButton', onClick: this.giftsNav.bind(this) },
							'Shop Holiday Gifts'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggItemRow' },
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDXL18079');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg1' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Emerald Diamond Halo Ring'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDMD30060');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg2' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Simon G. Butterfly Diamond Ring'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/NFANC29328');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg3' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Baguette Diamond Circle Pendant'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/EFAND14379');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg4' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Diamond Floral Inspired Studs'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'legalSection' },
						_react2.default.createElement(
							'div',
							{ className: 'legalInnerWrapper' },
							'*Discount excludes certified diamonds and price protected lines. Cannot be combined with other offers.'
						)
					)
				);
			}
		}]);
	
		return Holiday2021;
	}(_react2.default.Component);
	
	Holiday2021.propTypes = {
		location: _react.PropTypes.object
	};
	Holiday2021.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Holiday2021;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Holiday2021Container = exports.Holiday2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Holiday2021);

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Holiday2022Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(63);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Holiday2022 = function (_React$Component) {
		_inherits(Holiday2022, _React$Component);
	
		function Holiday2022(props) {
			_classCallCheck(this, Holiday2022);
	
			var _this = _possibleConstructorReturn(this, (Holiday2022.__proto__ || Object.getPrototypeOf(Holiday2022)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Holiday2022, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				// this.giftsNav();
			}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'getLocationDesigners',
			value: function getLocationDesigners() {
				return [];
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeDesigner',
			value: function changeDesigner(evt) {
				this.setState({ inputDesigner: evt.target.value });
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'getShowDates',
			value: function getShowDates(code) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = this.state.designerLocationArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var l = _step.value;
	
						if (l.value === code) {
							return l.dates;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'getShowLink',
			value: function getShowLink(code) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = this.state.designerLocationArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var l = _step2.value;
	
						if (l.value === code) {
							return l.page;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'designerNav',
			value: function designerNav(page) {
				if (!page) {
					return;
				}
				this.internalNav(page);
			}
		}, {
			key: 'giftsNav',
			value: function giftsNav(page) {
				window.location.href = 'https://gifts.diamondsdirect.com';
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Holiday2022' },
					_react2.default.createElement(
						'div',
						{ className: 'headerSection' },
						_react2.default.createElement(
							'div',
							{ className: 'headerSectionWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2022/lander/header.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2022/lander/header_m.jpg' }),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'shopButton', onClick: function onClick() {
										return _this7.internalNav('gallery/engagement-rings');
									}, style: { display: 'none' } },
								'Shop Now'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'shopSection', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'shopButtonWrapper' },
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'shopButton' },
								'Shop Online Now'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'shopTilesWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'shopTile', onClick: function onClick() {
										return _this7.internalNav('gallery/wedding-bands/womens');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'shopImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/studs.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'shopTileButton' },
									_react2.default.createElement(
										'div',
										null,
										'Shop Wedding Bands'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'shopTile', onClick: function onClick() {
										return _this7.internalNav('gallery/engagement-rings?mode=setting');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'shopImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/engagement.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'shopTileButton' },
									_react2.default.createElement(
										'div',
										null,
										'Shop Engagement'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'shopTile', onClick: function onClick() {
										return _this7.internalNav('gallery/fine-jewelry?type=ring,earring,necklace,bracelet');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'shopImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/pendants.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'shopTileButton' },
									_react2.default.createElement(
										'div',
										null,
										'Shop Fashion'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'titleSection' },
						_react2.default.createElement(
							'div',
							{ className: 'mainTitle', style: { display: 'none' } },
							'VISIT US IN STORE'
						),
						_react2.default.createElement(
							'div',
							{ className: 'iconLineWrapper', style: { display: 'none' } },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2022/iconline.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'titleP' },
							'To help you celebrate with the ones you love most this year, we\'re putting together some ',
							_react2.default.createElement(
								'strong',
								null,
								'amazing surprises!'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'titleP' },
							'Check in with us online or in-store to take advantage of:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'titleBox' },
							_react2.default.createElement(
								'div',
								{ className: 'titleBoxLiner' },
								_react2.default.createElement(
									'div',
									{ className: 'titleBig' },
									'0% APR for 3 Years',
									_react2.default.createElement(
										'sup',
										null,
										'*'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'titleDisclaimer' },
									'Subject to credit approval.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'titleDates' },
									'Available Now - Dec. 31'
								),
								_react2.default.createElement(
									'div',
									{ className: 'titleAction', onClick: function onClick() {
											return _this7.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
										} },
									'Ready to Apply'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'topSection', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'topRow' },
							_react2.default.createElement(
								'div',
								{ className: 'topRowRight copyBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'topDates' },
									'Nov. 11 - 13'
								),
								_react2.default.createElement('div', { className: 'topDatesHr' }),
								_react2.default.createElement(
									'div',
									{ className: 'topDateColumnWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'topDateColumn' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/austin', className: 'storeLink' },
											'Austin,\xA0TX'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/oklahoma-city', className: 'storeLink' },
											'Oklahoma\xA0City,\xA0OK'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/san-antonio', className: 'storeLink' },
											'San\xA0Antonio,\xA0TX'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/kansas-city', className: 'storeLink' },
											'Kansas\xA0City,\xA0KS'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/tysons', className: 'storeLink' },
											'Tysons,\xA0VA'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/charleston', className: 'storeLink' },
											'Charleston,\xA0SC'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'topDateColumn' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/virginia-beach', className: 'storeLink' },
											'Virginia\xA0Beach,\xA0VA'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/indianapolis', className: 'storeLink' },
											'Indianapolis,\xA0IN'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/columbus', className: 'storeLink' },
											'Columbus,\xA0OH'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/new-orleans', className: 'storeLink' },
											'New\xA0Orleans,\xA0LA'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/troy', className: 'storeLink' },
											'Troy,\xA0MI'
										)
									),
									_react2.default.createElement('div', { className: 'topDateVr' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'topRowLeft copyBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'topDates' },
									'Nov. 18 - 20'
								),
								_react2.default.createElement('div', { className: 'topDatesHr' }),
								_react2.default.createElement(
									'div',
									{ className: 'topDateColumnWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'topDateColumn' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/charlotte', className: 'storeLink' },
											'Charlotte,\xA0NC'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/raleigh', className: 'storeLink' },
											'Raleigh,\xA0NC'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/dallas', className: 'storeLink' },
											'Dallas,\xA0TX'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/frisco', className: 'storeLink' },
											'Frisco,\xA0TX'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/cleveland', className: 'storeLink' },
											'Cleveland,\xA0OH'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/houston', className: 'storeLink' },
											'Houston,\xA0TX'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/pittsburgh', className: 'storeLink' },
											'Pittsburgh,\xA0PA'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'topDateColumn' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/birmingham', className: 'storeLink' },
											'Birmingham,\xA0AL'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/richmond', className: 'storeLink' },
											'Richmond,\xA0VA'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/st-louis', className: 'storeLink' },
											'St.\xA0Louis,\xA0MO'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/boca-raton', className: 'storeLink' },
											'Boca\xA0Raton,\xA0FL'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/baybrook', className: 'storeLink' },
											'Baybrook,\xA0TX'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/greenville', className: 'storeLink' },
											'Greenville,\xA0SC'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/jacksonville', className: 'storeLink' },
											'Jacksonville,\xA0FL*'
										)
									),
									_react2.default.createElement('div', { className: 'topDateVr' })
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'midSection', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'midP' },
							'Missed your local showroom\u2019s event? Enjoy 20% savings online now!'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'looksSection' },
						_react2.default.createElement(
							'div',
							{ className: 'looksWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2022/lander/editorial.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/december2022/lander/editorial_m.jpg' }),
							_react2.default.createElement(_reactRouter.Link, { to: '/jewelry/EHOOP05010', className: 'lb lb1' }),
							_react2.default.createElement(_reactRouter.Link, { to: '/jewelry/TB10000257', className: 'lb lb2' }),
							_react2.default.createElement(_reactRouter.Link, { to: '/band/B14MS03511', className: 'lb lb3' }),
							_react2.default.createElement(_reactRouter.Link, { to: '/setting/SMD1450920', className: 'lb lb4' }),
							_react2.default.createElement(_reactRouter.Link, { to: '/band/BLDSM17257', className: 'lb lb5' }),
							_react2.default.createElement(_reactRouter.Link, { to: '/jewelry/NCOST08045', className: 'lb lb6' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Walk-in visits are always welcome! But if you\'d prefer to set up an appointment online or in-store, please use the form below and we will follow up to confirm!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Full Name*',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email Address*',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Telephone',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											selectClass: 'summerSelect',
											required: true,
											value: this.state.inputLocation,
											options: this.state.locations,
											changeMethod: function changeMethod(evt) {
												return _this7.changeLocation(evt);
											},
											error: this.state.errorLocation !== null })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Request an appointment'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'ggSection' },
						_react2.default.createElement(
							'div',
							{ className: 'ggTitle' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/december2022/lander/defi_gg.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggLine' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/gg_iconline.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Diamonds Direct invites you to enjoy this holiday season with a little extra sparkle! From now until the ball drops we\u2019ll be toasting to the best part of the year.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggButton', onClick: this.giftsNav.bind(this) },
							'Shop Holiday Gifts'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggItemRow' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/jewelry/BLDLG15656', className: 'ggItem' },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg1' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Three Row Diamond Stackable Ring'
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/jewelry/PRLFE01094', className: 'ggItem' },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg2' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Double Halo Pearl and Diamond Stud Earrings'
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/jewelry/NFANC29328', className: 'ggItem' },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg3' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Baguette Circle Diamond Pendant'
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/jewelry/EMER03342', className: 'ggItem' },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg4' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Emerald and Mixed Diamond Halo Ring'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'legalSection', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'legalInnerWrapper' },
							'*Discount excludes GIA certified diamonds and price-protected designer lines. Cannot be combined with other offers. Inquire for details.'
						)
					)
				);
			}
		}]);
	
		return Holiday2022;
	}(_react2.default.Component);
	
	Holiday2022.propTypes = {
		location: _react.PropTypes.object
	};
	Holiday2022.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Holiday2022;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Holiday2022Container = exports.Holiday2022Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Holiday2022);

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.June2022Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var June2022 = function (_React$Component) {
		_inherits(June2022, _React$Component);
	
		function June2022(props) {
			_classCallCheck(this, June2022);
	
			var _this = _possibleConstructorReturn(this, (June2022.__proto__ || Object.getPrototypeOf(June2022)).call(this, props));
	
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputDesigner: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesigner: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(June2022, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					console.log(this.props);
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputDesigner: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'June2022' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/june2022/ext/lander/landingpage_banner.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/june2022/ext/lander/landingpage_banner_m.jpg', alt: 'Diamonds Direct' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'midSection' },
						_react2.default.createElement(
							'div',
							{ className: 'midSectionWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'imageColumn' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/june2022/lander/editorial.jpg', alt: 'Diamonds Direct June Financing' }),
								_react2.default.createElement('div', { className: 'img1 imageOverlay', onClick: function onClick() {
										return _this7.internalNav('jewelry/GMISC16054');
									} }),
								_react2.default.createElement('div', { className: 'img2 imageOverlay', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDSM20393');
									} }),
								_react2.default.createElement('div', { className: 'img3 imageOverlay', onClick: function onClick() {
										return _this7.internalNav('jewelry/EHOOP01639');
									} })
							),
							_react2.default.createElement(
								'div',
								{ className: 'copyColumn' },
								_react2.default.createElement(
									'div',
									{ className: 'copyColumnWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'copyP' },
										'No matter where you are, add a little extra sparkle to your Summer with our On Cloud Nine June Financing Event!'
									),
									_react2.default.createElement(
										'div',
										{ className: 'copyP' },
										'Shop with us online or in-store and take advantage of:'
									),
									_react2.default.createElement('div', { className: 'copyVr' }),
									_react2.default.createElement(
										'div',
										{ className: 'copyTitle' },
										'0% APR for 5 Years*'
									),
									_react2.default.createElement(
										'div',
										{ className: 'copySubtitle' },
										'Subject to credit approval.'
									),
									_react2.default.createElement(
										'div',
										{ className: 'copyDates' },
										'Now - July 2'
									),
									_react2.default.createElement(
										'div',
										{ className: 'copyButton', onClick: function onClick() {
												return _this7.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
											} },
										_react2.default.createElement(
											'div',
											null,
											'Ready to Apply'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'imageColumnMobile' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/june2022/lander/editorial.jpg', alt: 'Diamonds Direct June Financing' }),
								_react2.default.createElement('div', { className: 'img1 imageOverlay', onClick: function onClick() {
										return _this7.internalNav('jewelry/GMISC16054');
									} }),
								_react2.default.createElement('div', { className: 'img2 imageOverlay', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDSM20393');
									} }),
								_react2.default.createElement('div', { className: 'img3 imageOverlay', onClick: function onClick() {
										return _this7.internalNav('jewelry/EHOOP01639');
									} })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formBoxWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formInnerWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formP' },
								'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'formWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorName ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Full Name*',
										value: this.state.inputName,
										onChange: this.changeName.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorEmail ? 'textInput error' : 'textInput',
										type: 'email',
										placeholder: 'Email Address*',
										value: this.state.inputEmail,
										onChange: this.changeEmail.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorPhone ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Telephone',
										value: this.state.inputPhone,
										onChange: this.changePhone.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement(_RhinoSelect2.default, {
										selectClass: 'summerSelect',
										required: true,
										value: this.state.inputLocation,
										options: this.state.locations,
										changeMethod: function changeMethod(evt) {
											return _this7.changeLocation(evt);
										},
										error: this.state.errorLocation !== null })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formActionRow' },
									_react2.default.createElement(
										'button',
										{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
										'Request an appointment'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return June2022;
	}(_react2.default.Component);
	
	June2022.propTypes = {
		location: _react.PropTypes.object
	};
	June2022.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = June2022;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var June2022Container = exports.June2022Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(June2022);

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Mothers2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Mothers2021 = function (_React$Component) {
		_inherits(Mothers2021, _React$Component);
	
		function Mothers2021(props) {
			_classCallCheck(this, Mothers2021);
	
			var _this = _possibleConstructorReturn(this, (Mothers2021.__proto__ || Object.getPrototypeOf(Mothers2021)).call(this, props));
	
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputDesigner: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesigner: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Mothers2021, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					console.log(this.props);
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputDesigner: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Mothers2021' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/june2021/lander/header_a.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/june2021/lander/header_a_m.jpg', alt: 'Diamonds Direct' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'cheersBlock' },
						_react2.default.createElement(
							'div',
							{ className: 'cheersBlockWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'cbLeft' },
								_react2.default.createElement(
									'div',
									{ className: 'cbLeftWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'cbLeftCopy' },
										'No matter where you are, add a little extra sparkle to your Summer with our Paradise Awaits June Financing Event!'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'cbRight' },
								_react2.default.createElement(
									'div',
									{ className: 'cbRightWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'cbrSuperTitle' },
										'Shop with us and take advantage of:'
									),
									_react2.default.createElement(
										'div',
										{ className: 'cbrTitle' },
										'0% APR for 5 Years*'
									),
									_react2.default.createElement(
										'div',
										{ className: 'cbrDisc' },
										'Subject to credit approval.'
									),
									_react2.default.createElement(
										'div',
										{ className: 'cbrDates' },
										'Available June 1 - July 3'
									),
									_react2.default.createElement(
										'div',
										{ className: 'cbrButton', onClick: function onClick() {
												return _this7.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
											} },
										'Learn More & Apply'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'itemRow cbItems', style: { marginBottom: '25px' } },
								_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/june2021/lander/lander_jewelry.jpg', alt: 'Diamonds Direct' }),
								_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/june2021/lander/lander_jewelry_m.jpg', alt: 'Diamonds Direct' }),
								_react2.default.createElement('div', { className: 'cbiLink cbiTopLeft', onClick: function onClick() {
										return _this7.internalNav('setting/SMD1445393');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbiTopRight', onClick: function onClick() {
										return _this7.internalNav('setting/SMDTT02867');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbiBottomLeft', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDXL15035');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbiRight', onClick: function onClick() {
										return _this7.internalNav('setting/SMD1444401');
									} })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formBoxWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formInnerWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formP' },
								'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'formWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorName ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Full Name*',
										value: this.state.inputName,
										onChange: this.changeName.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorEmail ? 'textInput error' : 'textInput',
										type: 'email',
										placeholder: 'Email Address*',
										value: this.state.inputEmail,
										onChange: this.changeEmail.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorPhone ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Telephone',
										value: this.state.inputPhone,
										onChange: this.changePhone.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement(_RhinoSelect2.default, {
										selectClass: 'summerSelect',
										required: true,
										value: this.state.inputLocation,
										options: this.state.locations,
										changeMethod: function changeMethod(evt) {
											return _this7.changeLocation(evt);
										},
										error: this.state.errorLocation !== null })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formActionRow' },
									_react2.default.createElement(
										'button',
										{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
										'Request an appointment'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'blockSection' },
						_react2.default.createElement(
							'div',
							{ className: 'blockSectionWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'blockItem fianceBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/fiancees.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock rightCopy' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbTitle' },
												'CHEERS TO THE FIANCEES'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbCopy' },
												'To the ones who are ready to open a new chapter.'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.openNew('https://gifts.diamondsdirect.com/summer');
													} },
												'Shop Summer Weddings'
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'itemRow' },
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('band/B147M01806');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/B147M01806.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('setting/SMD1444401');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/SMD1444401.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('band/BLDSM22659');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/BLDSM22659.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('setting/SMD1439174');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/wedding4.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'blockItem newlywedBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock mobileMakeup' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/newlyweds.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbTitle' },
												'CHEERS TO THE NEWLYWEDS'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbCopy' },
												'To the ones whose love endured through it all.'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.openNew('https://gifts.diamondsdirect.com/anniversary');
													} },
												'Shop Anniversary Gifts'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock rightImg' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/newlyweds.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'itemRow' },
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock doubleItem', onClick: function onClick() {
												return _this7.internalNav('jewelry/BLDXL05912');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/anniversary2.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('diamond-studs');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/ddrhe.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('diamond-pendants');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/ddrhp.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'blockItem gradBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/grads.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock rightCopy' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbTitle' },
												'CHEERS TO THE GRADUATES'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbCopy' },
												'To the ones who worked so hard to succeed.'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.openNew('https://gifts.diamondsdirect.com/under-1k');
													} },
												'Shop Gifts Under $1000'
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'blockItem dadBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock mobileMakeup' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/dads.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbTitle' },
												'CHEERS TO THE DADS'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbCopy' },
												'To the ones who you can always count on.'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.openNew('https://gifts.diamondsdirect.com/watches');
													} },
												'Shop Watches'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock rightImg' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/dads.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'itemRow' },
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.openNew('https://ecjluxenc.com/collections/hublot/products/big-bang-steel-ceramic');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/bb_steel_ceramic.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.openNew('https://ecjluxenc.com/collections/blancpain/products/fifty-fathoms-bathyscaphe-10');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/ff_bathyscaphe.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.openNew('https://ecjluxenc.com/collections/blancpain/products/fifty-fathoms-automatique-titanium-on-blue-sail-canvas');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/FF_automatique.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.openNew('https://ecjluxenc.com/collections/maurice-lacroix/products/copy-of-aikon-automatic-42mm-anthracite');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/aikon.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Mothers2021;
	}(_react2.default.Component);
	
	Mothers2021.propTypes = {
		location: _react.PropTypes.object
	};
	Mothers2021.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Mothers2021;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Mothers2021Container = exports.Mothers2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Mothers2021);

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Mothers2022Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Mothers2022 = function (_React$Component) {
		_inherits(Mothers2022, _React$Component);
	
		function Mothers2022(props) {
			_classCallCheck(this, Mothers2022);
	
			var _this = _possibleConstructorReturn(this, (Mothers2022.__proto__ || Object.getPrototypeOf(Mothers2022)).call(this, props));
	
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputDesigner: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesigner: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Mothers2022, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					console.log(this.props);
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputDesigner: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Mothers2022' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/mother_lander.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/mother_lander_m.jpg', alt: 'Diamonds Direct' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'copySection' },
						_react2.default.createElement(
							'div',
							{ className: 'copyTitle' },
							'Save 20% on Mother\u2019s Day gifts through May 7th*'
						),
						_react2.default.createElement(
							'div',
							{ className: 'copyCopy' },
							'Mother\u2019s Day is the perfect time to build your time capsule jewelry collection to pass down for generations to come. Now through May 7th, shop classic diamond jewelry that will shine forever!'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'blockSection' },
						_react2.default.createElement(
							'div',
							{ className: 'blockSectionWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'blockItem fianceBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/studs.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock rightCopy' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.internalNav('diamond-studs');
													} },
												_react2.default.createElement(
													'div',
													null,
													'Shop Diamond Studs'
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'blockItem newlywedBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock mobileMakeup' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/pendants.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.internalNav('diamond-pendants');
													} },
												_react2.default.createElement(
													'div',
													null,
													'Shop Diamond Pendants'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock rightImg' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/pendants.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'blockItem gradBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/bracelets.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock rightCopy' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.internalNav('diamond-bracelets');
													} },
												_react2.default.createElement(
													'div',
													null,
													'Shop Diamond Bracelets'
												)
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formBoxWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formInnerWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formP' },
								'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'formWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorName ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Full Name*',
										value: this.state.inputName,
										onChange: this.changeName.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorEmail ? 'textInput error' : 'textInput',
										type: 'email',
										placeholder: 'Email Address*',
										value: this.state.inputEmail,
										onChange: this.changeEmail.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorPhone ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Telephone',
										value: this.state.inputPhone,
										onChange: this.changePhone.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement(_RhinoSelect2.default, {
										selectClass: 'summerSelect',
										required: true,
										value: this.state.inputLocation,
										options: this.state.locations,
										changeMethod: function changeMethod(evt) {
											return _this7.changeLocation(evt);
										},
										error: this.state.errorLocation !== null })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formActionRow' },
									_react2.default.createElement(
										'button',
										{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
										'Request an appointment'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'legalSection' },
						'*Discount excludes certified diamonds and price protected lines. Cannot be combined with other offers.'
					)
				);
			}
		}]);
	
		return Mothers2022;
	}(_react2.default.Component);
	
	Mothers2022.propTypes = {
		location: _react.PropTypes.object
	};
	Mothers2022.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Mothers2022;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Mothers2022Container = exports.Mothers2022Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Mothers2022);

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.NoKidHungryContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var NoKidHungry = function (_React$Component) {
		_inherits(NoKidHungry, _React$Component);
	
		function NoKidHungry(props) {
			_classCallCheck(this, NoKidHungry);
	
			return _possibleConstructorReturn(this, (NoKidHungry.__proto__ || Object.getPrototypeOf(NoKidHungry)).call(this, props));
		}
	
		_createClass(NoKidHungry, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'NoKidHungry' },
					_react2.default.createElement(
						'div',
						{ className: 'nkHeader' },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/nkh_logo.svg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'nkCopyRow' },
						_react2.default.createElement(
							'div',
							{ className: 'nkCopyWrapper' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/nkh_copya.svg' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'nkInvolved' },
						_react2.default.createElement(
							'div',
							{ className: 'nkInvolvedWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'nkInvolvedTitle' },
								'Here is how you can get involved:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'nkInvolvedItemWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'nkInvolvedItem' },
									_react2.default.createElement(
										'div',
										{ className: 'nkItemIcon' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/auction.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'nkItemTitle' },
										'Shop our ',
										_react2.default.createElement(
											'span',
											{ className: 'itemEm' },
											'online auction'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'nkItemCopy' },
										_react2.default.createElement(
											'span',
											{ className: 'itemEm' },
											'100% of the proceeds'
										),
										' will benefit ',
										_react2.default.createElement(
											'span',
											{ className: 'itemEm' },
											'No Kid Hungry'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'nkInvolvedItem' },
									_react2.default.createElement(
										'div',
										{ className: 'nkItemIcon' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/register.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'nkItemTitle' },
										_react2.default.createElement(
											'span',
											{ className: 'itemEm' },
											'Donate'
										),
										' at the ',
										_react2.default.createElement(
											'span',
											{ className: 'itemEm' },
											'Register'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'nkItemCopy' },
										'at a ',
										_react2.default.createElement(
											'span',
											{ className: 'itemEm' },
											'Diamonds Direct'
										),
										' location. Visit our location page to find the ',
										_react2.default.createElement(
											'span',
											{ className: 'itemEm' },
											'location nearest you.'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'nkInvolvedItem', onClick: function onClick() {
											return _this2.openNew('https://www.instagram.com/diamondsdirect/');
										}, style: { cursor: 'pointer' } },
									_react2.default.createElement(
										'div',
										{ className: 'nkItemIcon' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/instagram.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'nkItemTitle' },
										_react2.default.createElement(
											'span',
											{ className: 'itemEm' },
											'Follow us'
										),
										' on ',
										_react2.default.createElement(
											'span',
											{ className: 'itemEm' },
											'Instagram'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'nkItemCopy' },
										'for the most up to date information on events and partnerships in each of our markets that will raise funds and awareness for this great cause.'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'nkBody' },
						_react2.default.createElement(
							'div',
							{ className: 'nkBodyTitle' },
							'Silent Auction'
						),
						_react2.default.createElement(
							'div',
							{ className: 'noKidText' },
							'Diamonds Direct, in association with the Diamonds Direct Foundation is hosting online silent auctions with all proceeds benefitting No Kid Hungry. With stunning diamond classics, perfect for any occasion and unique, one-of-a-kind pieces ideal for a night on the town, why not let your next gift give back to those hit hardest by the widespread effects of COVID-19?'
						),
						_react2.default.createElement(
							'div',
							{ className: 'lotWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'lotTitle' },
								'Current Assortment'
							),
							_react2.default.createElement(
								'div',
								{ className: 'itemsWrapper', style: { margin: '20px 0', fontSize: '24px' } },
								'Check back soon for our next auction assortment!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'itemsWrapper', style: { display: 'none' } },
								_react2.default.createElement(
									'div',
									{ className: 'lotItem', onClick: function onClick() {
											return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905602');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'lotImage' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/am_pendant.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemTitle' },
										'This amethyst and diamond necklace makes the perfect gift.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'lotItem', onClick: function onClick() {
											return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905689');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'lotImage' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/dia_loop.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemTitle' },
										'Dazzling diamond hoops add the perfect touch of sparkle to any wardrobe.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'lotItem', onClick: function onClick() {
											return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905525');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'lotImage' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/tanzanite_pendant.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemTitle' },
										'It\'s all in the details of this exquisite tanzanite and diamond halo necklace.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'lotItem', onClick: function onClick() {
											return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905615');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'lotImage' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/dia_cross.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemTitle' },
										'A diamond cross pendant perfect for everyday wear.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'lotItem', onClick: function onClick() {
											return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905458');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'lotImage' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/tennis.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemTitle' },
										'A sparkling tennis bracelet flaunting 42 round brilliant cut diamonds.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'lotItem', onClick: function onClick() {
											return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905626');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'lotImage' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/orange_sapphire.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemTitle' },
										'A one-of-a-kind orange sapphire and diamond halo necklace.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'lotItem', onClick: function onClick() {
											return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905473');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'lotImage' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/geo_diamond_earrings.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemTitle' },
										'Make a statement with these geometric diamond earrings.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'lotItem', onClick: function onClick() {
											return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905502');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'lotImage' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/diamond_halo.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemTitle' },
										'A diamond halo necklace that sparkles from every angle.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'lotItem', onClick: function onClick() {
											return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905645');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'lotImage' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/ruby_halo_earrings.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemTitle' },
										'A stunning pair of ruby and diamond halo earrings that are perfect for any occasion.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'lotItem', onClick: function onClick() {
											return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807/auction_items/2905487');
										} },
									_react2.default.createElement(
										'div',
										{ className: 'lotImage' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nokid/items0423/diamond_drop.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemTitle' },
										'Showcasing stunning details, these diamond design drop earrings make the perfect gift.'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'nkButtonWrapper', style: { display: 'none' } },
							_react2.default.createElement(
								'div',
								{ className: 'nkSeeAllButton', onClick: function onClick() {
										return _this2.openNew('https://www.32auctions.com/organizations/63382/auctions/101807?r=1&t=all');
									} },
								'View All Auction Items'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'nkDisclaimer', style: { display: 'none' } },
							'Product in the online silent auction will be exchanged every two weeks until May 31st 2021. Select each jewelry piece to view its unique minimum starting bid.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'nkTermo', style: { display: 'none' } },
							_react2.default.createElement(
								'div',
								{ className: 'nkTermoWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'nkGoalText' },
									'$100,000+'
								),
								_react2.default.createElement(
									'div',
									{ className: 'nkBarWrapper' },
									_react2.default.createElement('div', { className: 'nkBarFill' }),
									_react2.default.createElement('div', { className: 'nkBubble' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'nkCurrentText' },
									'+$48,000'
								)
							)
						)
					)
				);
			}
		}]);
	
		return NoKidHungry;
	}(_react2.default.Component);
	
	NoKidHungry.propTypes = {
		location: _react.PropTypes.object
	};
	NoKidHungry.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = NoKidHungry;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var NoKidHungryContainer = exports.NoKidHungryContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(NoKidHungry);

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NolaFlood2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var NolaFlood2021 = function (_React$Component) {
	  _inherits(NolaFlood2021, _React$Component);
	
	  function NolaFlood2021(props) {
	    _classCallCheck(this, NolaFlood2021);
	
	    return _possibleConstructorReturn(this, (NolaFlood2021.__proto__ || Object.getPrototypeOf(NolaFlood2021)).call(this, props));
	  }
	
	  // componentDidMount() {
	  //   let link = document.createElement('meta');
	  //   link.setAttribute('property', 'og:image');
	  //   link.content = 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/DSC_0893.jpg';
	  //   document.getElementsByTagName('head')[0].appendChild(link);
	  // }
	
	  _createClass(NolaFlood2021, [{
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'NolaFlood2021' },
	        _react2.default.createElement(
	          'div',
	          { className: 'productHeader' },
	          _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/nola_banner.png' }),
	          _react2.default.createElement('img', { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/nola_banner.png' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'itemArray' },
	          _react2.default.createElement(
	            'div',
	            { className: 'nolaNotice' },
	            _react2.default.createElement(
	              'div',
	              { className: 'nolaNoticeWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'nolaTitle' },
	                'The New Orleans Collection'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'nolaLine' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/icons/lines/iconline_thin.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'nolaCopy' },
	                'Thank you for your interest in donating to the Diamonds Direct Foundation\u2019s Hurricane Ida relief efforts.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'nolaCopy' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'nolaEm' },
	                  '100% of the proceeds'
	                ),
	                ' from purchases within this collection will support one of the three New Orleans based charitable organizations we\u2019ve selected to help our friends and neighbors during this critical time; ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'nolaEm' },
	                  'Cajun Navy Ground Force'
	                ),
	                ', ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'nolaEm' },
	                  'Second Harvest Foodbank'
	                ),
	                ', and ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'nolaEm' },
	                  'The Diamonds Direct Employee Relief Fund'
	                ),
	                '.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'nolaCopy' },
	                'We are grateful for your generosity and support!'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('band/BLDSM08583');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Straight Bar Diamond Band'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/BLDSM08583.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Straight Bar Diamond Band'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$390'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('band/BLDMD26933');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Narrow "X" Diamond Band'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/BLDMD26933.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Narrow "X" Diamond Band'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$1,100'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('band/BLDSM07123');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Geometric Diamond Wedding Band'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/BLDSM07123.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Geometric Diamond Wedding Band'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$500'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/EFAND07300');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Contemporary Dimond Accented Stud Earrings'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/EFAND07300.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Contemporary Dimond Accented Stud Earrings'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$475'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/EFAND14535');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Flower Diamond Stud Earrings'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/EFAND14535.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Flower Diamond Stud Earrings'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$1,050'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/EFAND10724');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Two-Tone Geometric Drop Earrings'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/EFAND10724.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Two-Tone Geometric Drop Earrings'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$795'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/NFANC06219');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Lowercase Initial "M" Pendant'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/NFANC06219.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Lowercase Initial "M" Pendant'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$450'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/NFANC21445');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Baguette Diamond Bar Pendant'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/NFANC21445.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Baguette Diamond Bar Pendant'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$620'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/NFANC23846');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Diamond Bezel Solitaire Pendant'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/NFANC23846.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Diamond Bezel Solitaire Pendant'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$375'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/TBMIS03975');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Diamonds By The Yard Bracelet'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/TBMIS03975.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Diamonds By The Yard Bracelet'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$330'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/TBMIS02595');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Five Bar Diamond Bracelet'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/TBMIS02595.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Five Bar Diamond Bracelet'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$790'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/GBANG00738');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Classic Diamond Bangle'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/GBANG00738.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Classic Diamond Bangle'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$1,150'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/CUSTM00017');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Cash Donation'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/blank_thumb2.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Cash Donation'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$25'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/CUSTM00018');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Cash Donation'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/blank_thumb2.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Cash Donation'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$50'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'itemElement',
	              onClick: function onClick() {
	                _this2.internalNav('jewelry/CUSTM00019');
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'itemThumb' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgOverlay' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'overlayTitle' },
	                  'Cash Donation'
	                )
	              ),
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/blank_thumb2.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'labelWrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'itemName' },
	                'Cash Donation'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'itemPrice' },
	                '$100'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NolaFlood2021;
	}(_react2.default.Component);
	
	NolaFlood2021.propTypes = {
	  location: _react.PropTypes.object
	};
	NolaFlood2021.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = NolaFlood2021;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var NolaFlood2021Container = exports.NolaFlood2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(NolaFlood2021);

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Sept2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Sept2021 = function (_React$Component) {
		_inherits(Sept2021, _React$Component);
	
		function Sept2021(props) {
			_classCallCheck(this, Sept2021);
	
			var _this = _possibleConstructorReturn(this, (Sept2021.__proto__ || Object.getPrototypeOf(Sept2021)).call(this, props));
	
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputDesigner: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesigner: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Sept2021, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					console.log(this.props);
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputDesigner: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Sept2021' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/sept2021/store/nola/lander.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/sept2021/store/nola/lander_m.jpg', alt: 'Diamonds Direct' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'cheersBlock' },
						_react2.default.createElement(
							'div',
							{ className: 'cheersBlockWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'cbBlockWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'cbLeft' },
									_react2.default.createElement(
										'div',
										{ className: 'cbLeftWrapper' },
										_react2.default.createElement(
											'div',
											{ className: 'cbLeftCopy' },
											'Let the special someone in your life know that your love is forever with our Made to Last September Financing Event!'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'cbRight' },
									_react2.default.createElement(
										'div',
										{ className: 'cbRightWrapper' },
										_react2.default.createElement(
											'div',
											{ className: 'cbrCopy' },
											'Shop with us online or in-store and take advantage of'
										),
										_react2.default.createElement(
											'div',
											{ className: 'cbrTitle' },
											'0% APR for 5 Years*'
										),
										_react2.default.createElement(
											'div',
											{ className: 'cbrDisc' },
											'Subject to credit approval.'
										),
										_react2.default.createElement(
											'div',
											{ className: 'cbrDates' },
											'Available Now - October 23'
										),
										_react2.default.createElement(
											'div',
											{ className: 'cbrButton', onClick: function onClick() {
													return _this7.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
												} },
											'Ready to Apply'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'itemRow cbItems', style: { marginBottom: '25px' } },
								_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/sept2021/landing/jewelry.jpg', alt: 'Diamonds Direct' }),
								_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/sept2021/landing/jewelry_m.jpg', alt: 'Diamonds Direct' }),
								_react2.default.createElement('div', { className: 'cbiLink cbiTopLeft', onClick: function onClick() {
										return _this7.internalNav('jewelry/GBANG02230');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbiTopRight', onClick: function onClick() {
										return _this7.internalNav('diamond-studs');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbiBottomLeft', onClick: function onClick() {
										return _this7.internalNav('band/BLDMD18924');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbiRight', onClick: function onClick() {
										return _this7.internalNav('setting/SMD1817108');
									} })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formBoxWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formInnerWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formP' },
								'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'formWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorName ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Full Name*',
										value: this.state.inputName,
										onChange: this.changeName.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorEmail ? 'textInput error' : 'textInput',
										type: 'email',
										placeholder: 'Email Address*',
										value: this.state.inputEmail,
										onChange: this.changeEmail.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorPhone ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Telephone',
										value: this.state.inputPhone,
										onChange: this.changePhone.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement(_RhinoSelect2.default, {
										selectClass: 'summerSelect',
										required: true,
										value: this.state.inputLocation,
										options: this.state.locations,
										changeMethod: function changeMethod(evt) {
											return _this7.changeLocation(evt);
										},
										error: this.state.errorLocation !== null })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formActionRow' },
									_react2.default.createElement(
										'button',
										{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
										'Request an appointment'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'blockSection', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'blockSectionWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'blockItem fianceBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/fiancees.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock rightCopy' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbTitle' },
												'CHEERS TO THE FIANCEES'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbCopy' },
												'To the ones who are ready to open a new chapter.'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.openNew('https://gifts.diamondsdirect.com/summer');
													} },
												'Shop Summer Weddings'
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'itemRow' },
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('band/B147M01806');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/B147M01806.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('setting/SMD1444401');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/SMD1444401.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('band/BLDSM22659');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/BLDSM22659.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('setting/SMD1439174');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/wedding4.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'blockItem newlywedBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock mobileMakeup' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/newlyweds.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbTitle' },
												'CHEERS TO THE NEWLYWEDS'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbCopy' },
												'To the ones whose love endured through it all.'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.openNew('https://gifts.diamondsdirect.com/anniversary');
													} },
												'Shop Anniversary Gifts'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock rightImg' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/newlyweds.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'itemRow' },
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock doubleItem', onClick: function onClick() {
												return _this7.internalNav('jewelry/BLDXL05912');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/anniversary2.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('diamond-studs');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/ddrhe.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.internalNav('diamond-pendants');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/ddrhp.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'blockItem gradBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/grads.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock rightCopy' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbTitle' },
												'CHEERS TO THE GRADUATES'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbCopy' },
												'To the ones who worked so hard to succeed.'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.openNew('https://gifts.diamondsdirect.com/under-1k');
													} },
												'Shop Gifts Under $1000'
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'blockItem dadBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock mobileMakeup' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/dads.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrbTitle' },
												'CHEERS TO THE DADS'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbCopy' },
												'To the ones who you can always count on.'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrbButton', onClick: function onClick() {
														return _this7.openNew('https://gifts.diamondsdirect.com/watches');
													} },
												'Shop Watches'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock rightImg' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/dads.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'itemRow' },
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.openNew('https://ecjluxenc.com/collections/hublot/products/big-bang-steel-ceramic');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/bb_steel_ceramic.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.openNew('https://ecjluxenc.com/collections/blancpain/products/fifty-fathoms-bathyscaphe-10');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/ff_bathyscaphe.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.openNew('https://ecjluxenc.com/collections/blancpain/products/fifty-fathoms-automatique-titanium-on-blue-sail-canvas');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/FF_automatique.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'itemBlock', onClick: function onClick() {
												return _this7.openNew('https://ecjluxenc.com/collections/maurice-lacroix/products/copy-of-aikon-automatic-42mm-anthracite');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/aikon.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Sept2021;
	}(_react2.default.Component);
	
	Sept2021.propTypes = {
		location: _react.PropTypes.object
	};
	Sept2021.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Sept2021;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Sept2021Container = exports.Sept2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Sept2021);

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Sept2022Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Sept2022 = function (_React$Component) {
		_inherits(Sept2022, _React$Component);
	
		function Sept2022(props) {
			_classCallCheck(this, Sept2022);
	
			var _this = _possibleConstructorReturn(this, (Sept2022.__proto__ || Object.getPrototypeOf(Sept2022)).call(this, props));
	
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputDesigner: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesigner: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Sept2022, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					console.log(this.props);
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputDesigner: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Sept2022' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/banner.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/banner_m.jpg', alt: 'Diamonds Direct' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'blockSection' },
						_react2.default.createElement(
							'div',
							{ className: 'blockSectionWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'blockItem newlywedBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock mobileMakeup', onClick: function onClick() {
												return _this7.internalNav('jewelry/NFANC30055');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/hero_m.jpg', alt: 'Diamonds Direct' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrHeaderCopy' },
												'Start your forever with a purchase of a lifetime online or in-store and take advantage of'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrHeadline' },
												'0% APR for 5 Years',
												_react2.default.createElement(
													'sup',
													{ style: { fontWeight: '300', fontSize: '18px' } },
													'1'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrSubheader' },
												'Subject to credit approval.'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrDates' },
												'Now - October 2'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrSubheader' },
												'Special Sunday Hours',
												_react2.default.createElement('br', null),
												'October 2nd 12pm-5pm'
											),
											_react2.default.createElement(
												'div',
												{ className: 'mrButton', onClick: function onClick() {
														return _this7.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
													} },
												'Ready to Apply'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock rightImg', onClick: function onClick() {
												return _this7.internalNav('jewelry/NFANC30055');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/hero.jpg', alt: 'Diamonds Direct' })
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'cheersBlock' },
						_react2.default.createElement(
							'div',
							{ className: 'cheersBlockWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'itemRow cbItems', style: { marginBottom: '25px' } },
								_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/collage.jpg', alt: 'Diamonds Direct' }),
								_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/collage_m.jpg', alt: 'Diamonds Direct' }),
								_react2.default.createElement('div', { className: 'cbiLink cbi1', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDMD23367');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbi2', onClick: function onClick() {
										return _this7.internalNav('jewelry/NFANC30016');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbi3', onClick: function onClick() {
										return _this7.internalNav('band/BLDMD33675');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbi4', onClick: function onClick() {
										return _this7.internalNav('setting/SMD1459007');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbi5', onClick: function onClick() {
										return _this7.internalNav('jewelry/EHOOP05011');
									} })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formBoxWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formInnerWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formP' },
								'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'formWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorName ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Full Name*',
										value: this.state.inputName,
										onChange: this.changeName.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorEmail ? 'textInput error' : 'textInput',
										type: 'email',
										placeholder: 'Email Address*',
										value: this.state.inputEmail,
										onChange: this.changeEmail.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorPhone ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Telephone',
										value: this.state.inputPhone,
										onChange: this.changePhone.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement(_RhinoSelect2.default, {
										selectClass: 'summerSelect',
										required: true,
										value: this.state.inputLocation,
										options: this.state.locations,
										changeMethod: function changeMethod(evt) {
											return _this7.changeLocation(evt);
										},
										error: this.state.errorLocation !== null })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formActionRow' },
									_react2.default.createElement(
										'button',
										{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
										'Request an appointment'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Sept2022;
	}(_react2.default.Component);
	
	Sept2022.propTypes = {
		location: _react.PropTypes.object
	};
	Sept2022.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Sept2022;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Sept2022Container = exports.Sept2022Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Sept2022);

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SingleDesigner2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var SingleDesigner2021 = function (_React$Component) {
		_inherits(SingleDesigner2021, _React$Component);
	
		function SingleDesigner2021(props) {
			_classCallCheck(this, SingleDesigner2021);
	
			var _this = _possibleConstructorReturn(this, (SingleDesigner2021.__proto__ || Object.getPrototypeOf(SingleDesigner2021)).call(this, props));
	
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputDesigner: '',
	
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesigner: null,
				errorDesignerLocation: null,
	
				designerLocation: null
			};
	
			_this.designerData = {
				'atx': {
					url: 'austin',
					designer: 'Verragio',
					week: 3
				},
				'bhm': {
					url: 'birmingham',
					designer: 'Tacori',
					week: 2
				},
				'boc': {
					url: 'boca-raton',
					designer: 'Tacori',
					week: 3
				},
				'chs': {
					url: 'charleston',
					designer: 'Verragio',
					week: 2
				},
				'cle': {
					url: 'cleveland',
					designer: 'Classique',
					week: 3
				},
				'clt': {
					url: 'charlotte',
					designer: 'Tacori',
					week: 3
				},
				'coh': {
					url: 'columbus',
					designer: 'SimonG',
					week: 2
				},
				'dfw': {
					url: 'dallas',
					designer: 'Verragio',
					week: 2
				},
				'ftx': {
					url: 'frisco',
					designer: 'Verragio',
					week: 2
				},
				'gsc': {
					url: 'greenville',
					designer: 'SimonG',
					week: 3
				},
				'hou': {
					url: 'houston',
					designer: 'Tacori',
					week: 3
				},
				'ind': {
					url: 'indianapolis',
					designer: 'Verragio',
					week: 2
				},
				'jax': {
					url: 'jacksonville',
					designer: 'Tacori',
					week: 2
				},
				'kcy': {
					url: 'kansas-city',
					designer: 'SimonG',
					week: 3
				},
				'okc': {
					url: 'oklahoma-city',
					designer: 'Amden',
					week: 3
				},
				'pit': {
					url: 'pittsburgh',
					designer: 'SimonG',
					week: 1
				},
				'ral': {
					url: 'raleigh',
					designer: 'Verragio',
					week: 1
				},
				'rva': {
					url: 'richmond',
					designer: 'SimonG',
					week: 3
				},
				'stl': {
					url: 'st-louis',
					designer: 'Tacori',
					week: 1
				},
				'san': {
					url: 'san-antonio',
					designer: 'Verragio',
					week: 3
				},
				'vab': {
					url: 'virginia-beach',
					designer: 'Verragio',
					week: 2
				}
			};
	
			_this.designerLocationArray = [{
				display: 'Select Location',
				value: ''
			}, {
				display: 'Austin, TX',
				value: 'atx'
			}, {
				display: 'Birmingham, AL',
				value: 'bhm'
			}, {
				display: 'Boca Raton, FL',
				value: 'boc'
			}, {
				display: 'Charleston, SC',
				value: 'chs'
			}, {
				display: 'Charlotte, NC',
				value: 'clt'
			}, {
				display: 'Cleveland, OH',
				value: 'cle'
			}, {
				display: 'Columbus, OH',
				value: 'coh'
			}, {
				display: 'Dallas, TX',
				value: 'dfw'
			}, {
				display: 'Frisco, TX',
				value: 'ftx'
			}, {
				display: 'Greenville, SC',
				value: 'gsc'
			}, {
				display: 'Houston, TX',
				value: 'hou'
			}, {
				display: 'Indianapolis, IN',
				value: 'ind'
			}, {
				display: 'Jacksonville, FL',
				value: 'jax'
			}, {
				display: 'Kansas City, KS',
				value: 'kcy'
			}, {
				display: 'Oklahoma City, OK',
				value: 'okc'
			}, {
				display: 'Pittsburgh, PA',
				value: 'pit'
			}, {
				display: 'Raleigh, NC',
				value: 'ral'
			}, {
				display: 'Richmond, VA',
				value: 'rva'
			}, {
				display: 'St. Louis, MO',
				value: 'stl'
			}, {
				display: 'San Antonio, TX',
				value: 'san'
			}, {
				display: 'Virginia Beach, VA',
				value: 'vab'
			}];
			return _this;
		}
	
		_createClass(SingleDesigner2021, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					console.log(this.props);
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputDesigner: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({
					designerLocation: evt.target.value
				});
			}
		}, {
			key: 'getFirstDay',
			value: function getFirstDay() {
				if (!this.state.designerLocation || !this.designerData[this.state.designerLocation].week) {
					return '';
				}
	
				switch (this.designerData[this.state.designerLocation].week) {
					case 1:
						return 'Friday, Sept 10';
					case 2:
						return 'Friday, Sept 17';
					case 3:
						return 'Friday, Sept 24';
				}
				return '';
			}
		}, {
			key: 'getSecondDay',
			value: function getSecondDay() {
				if (!this.state.designerLocation || !this.designerData[this.state.designerLocation].week) {
					return '';
				}
	
				switch (this.designerData[this.state.designerLocation].week) {
					case 1:
						return 'Saturday, Sept 11';
					case 2:
						return 'Saturday, Sept 18';
					case 3:
						return 'Saturday, Sept 25';
				}
				return '';
			}
		}, {
			key: 'getDesignerImg',
			value: function getDesignerImg() {
				if (!this.state.designerLocation || !this.designerData[this.state.designerLocation].designer) {
					return '';
				}
	
				switch (this.designerData[this.state.designerLocation].designer) {
					case 'SimonG':
						return 'simong.svg';
					case 'Amden':
						return 'amden.png';
					case 'Classique':
						return 'classique.svg';
					case 'Tacori':
						return 'tacori.svg';
					case 'Verragio':
						return 'verragio.svg';
				}
				return '';
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'SingleDesigner2021' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/header.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/headerm.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement(
							'div',
							{ className: 'headerSelectWrapper' },
							_react2.default.createElement(_RhinoSelect2.default, {
								selectClass: 'singleSelect',
								value: this.state.designerLocation,
								options: this.designerLocationArray,
								changeMethod: function changeMethod(evt) {
									return _this7.changeDesignerLocation(evt);
								} })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'designersWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'designerBlock' },
							_react2.default.createElement(
								'div',
								{ className: 'designerBanner' },
								this.state.designerLocation ? _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/' + this.getDesignerImg() }) : null
							),
							this.state.designerLocation ? _react2.default.createElement(
								'div',
								{ className: 'designerDisplay' },
								_react2.default.createElement(
									'div',
									{ className: 'daysWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'dayBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'dayValue' },
											this.getFirstDay()
										),
										_react2.default.createElement(
											'div',
											{ className: 'timeValue' },
											'10 a.m. - 7 p.m.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dayBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'dayValue' },
											this.getSecondDay()
										),
										_react2.default.createElement(
											'div',
											{ className: 'timeValue' },
											'10 a.m. - 7 p.m.'
										)
									)
								)
							) : null
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formBoxWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formInnerWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formP' },
								'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'formWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorName ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Full Name*',
										value: this.state.inputName,
										onChange: this.changeName.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorEmail ? 'textInput error' : 'textInput',
										type: 'email',
										placeholder: 'Email Address*',
										value: this.state.inputEmail,
										onChange: this.changeEmail.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorPhone ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Telephone',
										value: this.state.inputPhone,
										onChange: this.changePhone.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement(_RhinoSelect2.default, {
										selectClass: 'summerSelect',
										required: true,
										value: this.state.inputLocation,
										options: this.state.locations,
										changeMethod: function changeMethod(evt) {
											return _this7.changeLocation(evt);
										},
										error: this.state.errorLocation !== null })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formActionRow' },
									_react2.default.createElement(
										'button',
										{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
										'Request an appointment'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'boxSection' },
						_react2.default.createElement(
							'div',
							{ className: 'fuImage' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/madetolast.svg', alt: 'Diamonds Direct' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'fuP' },
							'Let the special someone in your life know that your love is forever with our Made to Last September Financing Event!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'fuP' },
							'Shop with us online or in-store and take advantage of:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'fuBox' },
							_react2.default.createElement(
								'div',
								{ className: 'box1' },
								'0% APR for 5 Years*'
							),
							_react2.default.createElement(
								'div',
								{ className: 'box2' },
								'Subject to credit approval.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'box3' },
								'Available August 30 - October 2'
							),
							_react2.default.createElement(
								'div',
								{ className: 'boxButton', onClick: function onClick() {
										return _this7.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
									} },
								_react2.default.createElement(
									'div',
									null,
									'Ready to Apply'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'fuLegal' },
							'*The Wells Fargo Jewelry Advantage\xAE credit card is issued by Wells Fargo Bank, N.A. Special terms for 5 years (60 months) apply to qualifying purchases charged with approved credit. The special terms APR will continue to apply until all qualifying purchases are paid in full. The monthly payment for this purchase will be the amount that will pay for the purchase in full in equal payments during the promotional (special terms) period. The APR for purchases will apply to certain fees such as a late payment fee or if you use the card for other transactions. For new accounts, the APR for Purchases is 28.99%. If you are charged interest in any billing cycle, the minimum interest charge will be $1.00. This information is accurate as of 08/01/2021 and is subject to change. For current information, call us at 1-800-431-5921. Offer valid 08/30/2021 till 10/2/2021.'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'imagesSection' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/jewelry.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/jewelrym.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('div', { className: 'img1 imgLink', onClick: function onClick() {
								return _this7.internalNav('setting/SMD1450915');
							} }),
						_react2.default.createElement('div', { className: 'img2 imgLink', onClick: function onClick() {
								return _this7.internalNav('jewelry/TACSS00087');
							} }),
						_react2.default.createElement('div', { className: 'img3 imgLink', onClick: function onClick() {
								return _this7.internalNav('jewelry/BLDXL08952');
							} }),
						_react2.default.createElement('div', { className: 'img4 imgLink', onClick: function onClick() {
								return _this7.internalNav('setting/SMD1810217');
							} }),
						_react2.default.createElement('div', { className: 'img5 imgLink', onClick: function onClick() {
								return _this7.internalNav('jewelry/EFAND12750');
							} })
					)
				);
			}
		}]);
	
		return SingleDesigner2021;
	}(_react2.default.Component);
	
	SingleDesigner2021.propTypes = {
		location: _react.PropTypes.object
	};
	SingleDesigner2021.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = SingleDesigner2021;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var SingleDesigner2021Container = exports.SingleDesigner2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(SingleDesigner2021);

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SingleDesigner2022Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var SingleDesigner2022 = function (_React$Component) {
		_inherits(SingleDesigner2022, _React$Component);
	
		function SingleDesigner2022(props) {
			_classCallCheck(this, SingleDesigner2022);
	
			var _this = _possibleConstructorReturn(this, (SingleDesigner2022.__proto__ || Object.getPrototypeOf(SingleDesigner2022)).call(this, props));
	
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputDesigner: '',
	
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesigner: null,
				errorDesignerLocation: null,
	
				designerLocation: null
			};
	
			_this.designerData = {
				'atx': {
					url: 'austin',
					designer: 'Tacori',
					week: 4
				},
				'bay': {
					url: 'baybrook',
					designer: 'SimonG',
					week: 2
				},
				'bhm': {
					url: 'birmingham',
					designer: 'Tacori',
					week: 1
				},
				'boc': {
					url: 'boca-raton',
					designer: 'SimonG',
					week: 3
				},
				'chs': {
					url: 'charleston',
					designer: 'Tacori',
					week: 1
				},
				'cle': {
					url: 'cleveland',
					designer: 'Verragio',
					week: 1
				},
				'clt': {
					url: 'charlotte',
					designer: 'Tacori',
					week: 2
				},
				'coh': {
					url: 'columbus',
					designer: 'Tacori',
					week: 2
				},
				'dfw': {
					url: 'dallas',
					designer: 'SimonG',
					week: 3
				},
				'ftx': {
					url: 'frisco',
					designer: 'SimonG',
					week: 3
				},
				'gsc': {
					url: 'greenville',
					designer: 'Tacori',
					week: 4
				},
				'hou': {
					url: 'houston',
					designer: 'SimonG',
					week: 2
				},
				'ind': {
					url: 'indianapolis',
					designer: 'Christopher',
					week: 2
				},
				'jax': {
					url: 'jacksonville',
					designer: 'Christopher',
					week: 4
				},
				'kcy': {
					url: 'kansas-city',
					designer: 'Divine',
					week: 2
				},
				'nol': {
					url: 'new-orleans',
					designer: 'Verragio',
					week: 3
				},
				'nva': {
					url: 'tysons',
					designer: 'MichaelM',
					week: 3
				},
				'okc': {
					url: 'oklahoma-city',
					designer: 'Christopher',
					week: 4
				},
				'pit': {
					url: 'pittsburgh',
					designer: 'Tacori',
					week: 1
				},
				'ral': {
					url: 'raleigh',
					designer: 'Tacori',
					week: 2
				},
				'rva': {
					url: 'richmond',
					designer: 'Uneek',
					week: 3
				},
				'stl': {
					url: 'st-louis',
					designer: 'Verragio',
					week: 1
				},
				'san': {
					url: 'san-antonio',
					designer: 'MichaelM',
					week: 1
				},
				'try': {
					url: 'troy',
					designer: 'SimonG',
					week: 3
				},
				'vab': {
					url: 'virginia-beach',
					designer: 'SimonG',
					week: 2
				}
			};
	
			_this.designerLocationArray = [{
				display: 'Select Location',
				value: ''
			}, {
				display: 'Austin, TX',
				value: 'atx'
			}, {
				display: 'Birmingham, AL',
				value: 'bhm'
			}, {
				display: 'Boca Raton, FL',
				value: 'boc'
			}, {
				display: 'Charleston, SC',
				value: 'chs'
			}, {
				display: 'Charlotte, NC',
				value: 'clt'
			}, {
				display: 'Cleveland, OH',
				value: 'cle'
			}, {
				display: 'Columbus, OH',
				value: 'coh'
			}, {
				display: 'Dallas, TX',
				value: 'dfw'
			}, {
				display: 'Frisco, TX',
				value: 'ftx'
			}, {
				display: 'Greenville, SC',
				value: 'gsc'
			}, {
				display: 'Houston, TX (Baybrook)',
				value: 'bay'
			}, {
				display: 'Houston, TX (Galleria)',
				value: 'hou'
			}, {
				display: 'Indianapolis, IN',
				value: 'ind'
			}, {
				display: 'Jacksonville, FL',
				value: 'jax'
			}, {
				display: 'Kansas City, KS',
				value: 'kcy'
			}, {
				display: 'New Orleans, LA',
				value: 'nol'
			}, {
				display: 'Oklahoma City, OK',
				value: 'okc'
			}, {
				display: 'Pittsburgh, PA',
				value: 'pit'
			}, {
				display: 'Raleigh, NC',
				value: 'ral'
			}, {
				display: 'Richmond, VA',
				value: 'rva'
			}, {
				display: 'St. Louis, MO',
				value: 'stl'
			}, {
				display: 'San Antonio, TX',
				value: 'san'
			}, {
				display: 'Troy, MI',
				value: 'try'
			}, {
				display: 'Tysons, VA',
				value: 'nva'
			}, {
				display: 'Virginia Beach, VA',
				value: 'vab'
			}];
			return _this;
		}
	
		_createClass(SingleDesigner2022, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					console.log(this.props);
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputDesigner: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				var _this7 = this;
	
				this.setState({
					designerLocation: evt.target.value
				}, function () {
					_this7.scrollDown();
				});
			}
		}, {
			key: 'getFirstDay',
			value: function getFirstDay() {
				if (!this.state.designerLocation || !this.designerData[this.state.designerLocation].week) {
					return '';
				}
	
				switch (this.designerData[this.state.designerLocation].week) {
					case 1:
						return 'Friday, Sept 9';
					case 2:
						return 'Friday, Sept 16';
					case 3:
						return 'Friday, Sept 23';
					case 4:
						return 'Friday, Sept 30';
				}
				return '';
			}
		}, {
			key: 'getSecondDay',
			value: function getSecondDay() {
				if (!this.state.designerLocation || !this.designerData[this.state.designerLocation].week) {
					return '';
				}
	
				switch (this.designerData[this.state.designerLocation].week) {
					case 1:
						return 'Saturday, Sept 10';
					case 2:
						return 'Saturday, Sept 17';
					case 3:
						return 'Saturday, Sept 24';
					case 4:
						return 'Saturday, Oct 1';
				}
				return '';
			}
		}, {
			key: 'getDesignerImg',
			value: function getDesignerImg() {
				if (!this.state.designerLocation || !this.designerData[this.state.designerLocation].designer) {
					return '';
				}
	
				switch (this.designerData[this.state.designerLocation].designer) {
					case 'SimonG':
						return 'simong.svg';
					case 'Tacori':
						return 'tacori.svg';
					case 'Verragio':
						return 'verragio.svg';
					case 'Christopher':
						return 'christopher.svg';
					case 'Divine':
						return 'divine.svg';
					case 'MichaelM':
						return 'michael.svg';
					case 'Uneek':
						return 'uneek.svg';
				}
				return '';
			}
		}, {
			key: 'getDesignerLink',
			value: function getDesignerLink() {
				if (!this.state.designerLocation || !this.designerData[this.state.designerLocation].designer) {
					return '';
				}
	
				if (this.designerData[this.state.designerLocation].week === 4) {
					return this.designerData[this.state.designerLocation].url + '?scroll=event';
				}
	
				switch (this.designerData[this.state.designerLocation].designer) {
					case 'SimonG':
						return 'designer/simon-g-jewelry';
					case 'Tacori':
						return 'designer/tacori';
					case 'Verragio':
						return 'designer/verragio';
					case 'Christopher':
						return 'designer/christopher-designs';
					case 'Divine':
						return '';
					case 'MichaelM':
						return 'designer/michael-m';
					case 'Uneek':
						return 'designer/uneek';
				}
				return '';
			}
		}, {
			key: 'scrollDown',
			value: function scrollDown() {
				(0, _reactScrollToComponent2.default)(this.designerWrapper, {
					offset: -100,
					align: 'top',
					duration: 1000,
					ease: 'inOutCube'
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this8 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'SingleDesigner2022' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/header.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/header_m.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement(
							'div',
							{ className: 'headerSelectWrapper' },
							_react2.default.createElement(_RhinoSelect2.default, {
								selectClass: 'singleSelect',
								value: this.state.designerLocation,
								options: this.designerLocationArray,
								changeMethod: function changeMethod(evt) {
									return _this8.changeDesignerLocation(evt);
								} })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'designersWrapper', ref: function ref(div) {
								_this8.designerWrapper = div;
							} },
						_react2.default.createElement(
							'div',
							{ className: 'designerBlock' },
							this.getDesignerLink() ? _react2.default.createElement(
								'div',
								{ className: 'designerBanner', onClick: function onClick() {
										return _this8.internalNav(_this8.getDesignerLink());
									}, style: { cursor: 'pointer' } },
								this.state.designerLocation ? _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/' + this.getDesignerImg() }) : null
							) : _react2.default.createElement(
								'div',
								{ className: 'designerBanner' },
								this.state.designerLocation ? _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/' + this.getDesignerImg() }) : null
							),
							this.state.designerLocation ? _react2.default.createElement(
								'div',
								{ className: 'designerDisplay' },
								_react2.default.createElement(
									'div',
									{ className: 'daysWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'dayBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'dayValue' },
											this.getFirstDay()
										),
										_react2.default.createElement(
											'div',
											{ className: 'timeValue' },
											'10 a.m. - 7 p.m.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dayBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'dayValue' },
											this.getSecondDay()
										),
										_react2.default.createElement(
											'div',
											{ className: 'timeValue' },
											'10 a.m. - 6 p.m.'
										)
									)
								)
							) : null
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formBoxWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formInnerWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formP' },
								'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'formWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorName ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Full Name*',
										value: this.state.inputName,
										onChange: this.changeName.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorEmail ? 'textInput error' : 'textInput',
										type: 'email',
										placeholder: 'Email Address*',
										value: this.state.inputEmail,
										onChange: this.changeEmail.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorPhone ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Telephone',
										value: this.state.inputPhone,
										onChange: this.changePhone.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement(_RhinoSelect2.default, {
										selectClass: 'summerSelect',
										required: true,
										value: this.state.inputLocation,
										options: this.state.locations,
										changeMethod: function changeMethod(evt) {
											return _this8.changeLocation(evt);
										},
										error: this.state.errorLocation !== null })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formActionRow' },
									_react2.default.createElement(
										'button',
										{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
										'Request an appointment'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'imagesSection' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/editorial.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/editorial_m.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('div', { className: 'img1 imgLink', onClick: function onClick() {
								return _this8.internalNav('band/BDEMD00781');
							} }),
						_react2.default.createElement('div', { className: 'img2 imgLink', onClick: function onClick() {
								return _this8.internalNav('setting/SMD1455187');
							} }),
						_react2.default.createElement('div', { className: 'img3 imgLink', onClick: function onClick() {
								return _this8.internalNav('setting/SMD1818611');
							} })
					)
				);
			}
		}]);
	
		return SingleDesigner2022;
	}(_react2.default.Component);
	
	SingleDesigner2022.propTypes = {
		location: _react.PropTypes.object
	};
	SingleDesigner2022.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = SingleDesigner2022;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var SingleDesigner2022Container = exports.SingleDesigner2022Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(SingleDesigner2022);

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Spring2019Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var Spring2019 = function (_React$Component) {
		_inherits(Spring2019, _React$Component);
	
		function Spring2019(props) {
			_classCallCheck(this, Spring2019);
	
			return _possibleConstructorReturn(this, (Spring2019.__proto__ || Object.getPrototypeOf(Spring2019)).call(this, props));
		}
	
		_createClass(Spring2019, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'Spring2019' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner', style: { display: 'none' } },
						_react2.default.createElement('img', { className: 'desktop600', src: '/img/promopages/spring2019/banner.jpg', alt: 'Diamonds Direct Spring' }),
						_react2.default.createElement('img', { className: 'mobile600', src: '/img/promopages/spring2019/banner_mobile.jpg', alt: 'Diamonds Direct Spring' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'promoBodyInner' },
							_react2.default.createElement(
								'div',
								{ className: 'promoText' },
								'Spring is the ',
								_react2.default.createElement(
									'span',
									{ className: 'color-em' },
									'perfect'
								),
								' season for lovers! This Spring, Diamonds Direct invites you to find your ',
								_react2.default.createElement(
									'span',
									{ className: 'color-em' },
									'perfect pair'
								),
								' with our Spring event and enjoy:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoTitle' },
								'Special 20% Savings*'
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoText', style: { margin: '0 10%' } },
								'Internationally renowned designers have curated exclusive collections for each of our stores. Visit our stores during our Spring Designer Showcase to learn more!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'springLocationBlock' },
								_react2.default.createElement(
									'div',
									{ className: "springLocationItem" },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										'April 5 - 7'
									),
									_react2.default.createElement(
										'div',
										{ className: "springLocations singleLine" },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/dallas' },
											'Dallas,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/virginia-beach' },
											'Virginia\xA0Beach,\xA0VA'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'springLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										'April 12 - 14'
									),
									_react2.default.createElement(
										'div',
										{ className: 'springLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/birmingham' },
											'Birmingham,\xA0AL'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/charleston' },
											'Charleston,\xA0SC'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/cleveland' },
											'Cleveland,\xA0OH'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/indianapolis' },
											'Indianapolis,\xA0IN'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'springLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										'April 26 - 28'
									),
									_react2.default.createElement(
										'div',
										{ className: 'springLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/columbus' },
											'Columbus,\xA0OH'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/charlotte' },
											'Charlotte,\xA0NC'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/jacksonville' },
											'Jacksonville,\xA0FL'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/oklahoma-city' },
											'Oklahoma\xA0City,\xA0OK'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/kansas-city' },
											'Kansas\xA0City,\xA0KS'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'springLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										'May 3 - 5'
									),
									_react2.default.createElement(
										'div',
										{ className: 'springLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/austin' },
											'Austin,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/salt-lake-city' },
											'Salt\xA0Lake\xA0City,\xA0UT'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/st-louis' },
											'St.\xA0Louis,\xA0MO'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/richmond' },
											'Richmond,\xA0VA'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/san-antonio' },
											'San\xA0Antonio,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/raleigh' },
											'Raleigh,\xA0NC'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoLegal' },
						'*Valid in store only. Discount excludes certified diamonds and price protected lines. Cannot be combined with other offers.'
					)
				);
			}
		}]);
	
		return Spring2019;
	}(_react2.default.Component);
	
	Spring2019.propTypes = {
		location: _react.PropTypes.object
	};
	Spring2019.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Spring2019;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Spring2019Container = exports.Spring2019Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Spring2019);

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Spring2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdownSpring = __webpack_require__(612);
	
	var locations = _interopRequireWildcard(_dropdownSpring);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Spring2021 = function (_React$Component) {
		_inherits(Spring2021, _React$Component);
	
		function Spring2021(props) {
			_classCallCheck(this, Spring2021);
	
			var _this = _possibleConstructorReturn(this, (Spring2021.__proto__ || Object.getPrototypeOf(Spring2021)).call(this, props));
	
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputDesigner: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesigner: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Spring2021, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					console.log(this.props);
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputDesigner: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Spring2021' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/home/promo-banners/spring2021/landing/summer_banner.jpg', alt: 'Diamonds Direct Spring' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/home/promo-banners/spring2021/landing/summer_banner_mob.jpg', alt: 'Diamonds Direct Spring' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'promoBodyInner' },
							_react2.default.createElement(
								'div',
								{ className: 'promoText' },
								'Spring is the perfect time to start fresh, and what better way to start your forever? With Diamonds Direct\u2019s unmatched selection, the perfect gift for yourself or the one you love is within reach! Shop with us online or in-store to take advantage of:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoTitle' },
								'20% Special Savings'
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoText' },
								'Visit us and enjoy an expanded selection from top designers at a location near you!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'springLocationBlock' },
								_react2.default.createElement(
									'div',
									{ className: "springLocationItem" },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										'April 9 - 17'
									),
									_react2.default.createElement('div', { className: 'springDatesHr' }),
									_react2.default.createElement(
										'div',
										{ className: "springLocations singleLine" },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/oklahoma-city' },
											'Oklahoma\xA0City,\xA0OK'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/cleveland' },
											'Cleveland,\xA0OH'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/indianapolis' },
											'Indianapolis,\xA0IN'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/san-antonio' },
											'San\xA0Antonio,\xA0TX'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/new-orleans' },
											'New\xA0Orleans,\xA0LA'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/boca-raton' },
											'Boca\xA0Raton,\xA0FL'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/virginia-beach' },
											'Virginia\xA0Beach,\xA0VA'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'springLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										'April 16 - 24'
									),
									_react2.default.createElement('div', { className: 'springDatesHr' }),
									_react2.default.createElement(
										'div',
										{ className: 'springLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/charlotte' },
											'Charlotte,\xA0NC'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/raleigh' },
											'Raleigh,\xA0NC'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/dallas' },
											'Dallas,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/frisco' },
											'Frisco,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/austin' },
											'Austin,\xA0TX'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/houston' },
											'Houston,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/richmond' },
											'Richmond,\xA0VA'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/charleston' },
											'Charleston,\xA0SC'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/st-louis' },
											'St.\xA0Louis,\xA0MO'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/jacksonville' },
											'Jacksonville,\xA0FL'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/columbus' },
											'Columbus,\xA0OH'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/kansas-city' },
											'Kansas\xA0City,\xA0KS'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/birmingham' },
											'Birmingham,\xA0AL'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoLegal' },
								'*Discount excludes price protected lines and certified diamonds. Cannot be combined with other offers. Discount applied in cart online.'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formBoxWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formInnerWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formP' },
								'Walk-in visits are always welcome, but due to precautions and state and local ordinances, showroom space may be limited. We also have our virtual appointment tool so you can continue to shop from the comfort of your own home!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'formWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorName ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Full Name*',
										value: this.state.inputName,
										onChange: this.changeName.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorEmail ? 'textInput error' : 'textInput',
										type: 'email',
										placeholder: 'Email Address*',
										value: this.state.inputEmail,
										onChange: this.changeEmail.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorPhone ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Telephone',
										value: this.state.inputPhone,
										onChange: this.changePhone.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement(_RhinoSelect2.default, {
										selectClass: 'summerSelect',
										required: true,
										value: this.state.inputLocation,
										options: this.state.locations,
										changeMethod: function changeMethod(evt) {
											return _this7.changeLocation(evt);
										},
										error: this.state.errorLocation !== null })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formActionRow' },
									_react2.default.createElement(
										'button',
										{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
										'Request an appointment'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'trendsWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'trendsTitle' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/home/promo-banners/spring2021/landing/spring_trends.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'trendsImg' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/home/promo-banners/spring2021/landing/jewelry_block.jpg', alt: 'Diamonds Direct Spring' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/home/promo-banners/spring2021/landing/jewelry_block_mob.jpg', alt: 'Diamonds Direct Spring' }),
							_react2.default.createElement('div', { className: 'linkScreen1', onClick: function onClick() {
									return _this7.externalNav('setting/MTG1411881');
								} }),
							_react2.default.createElement('div', { className: 'linkScreen2', onClick: function onClick() {
									return _this7.externalNav('jewelry/BLDMD06217');
								} }),
							_react2.default.createElement('div', { className: 'linkScreen3', onClick: function onClick() {
									return _this7.externalNav('jewelry/ECLST04668');
								} }),
							_react2.default.createElement('div', { className: 'linkScreen4', onClick: function onClick() {
									return _this7.externalNav('jewelry/NCOST02488');
								} })
						)
					)
				);
			}
		}]);
	
		return Spring2021;
	}(_react2.default.Component);
	
	Spring2021.propTypes = {
		location: _react.PropTypes.object
	};
	Spring2021.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Spring2021;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Spring2021Container = exports.Spring2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Spring2021);

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Spring2022Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Spring2022 = function (_React$Component) {
		_inherits(Spring2022, _React$Component);
	
		function Spring2022(props) {
			_classCallCheck(this, Spring2022);
	
			var _this = _possibleConstructorReturn(this, (Spring2022.__proto__ || Object.getPrototypeOf(Spring2022)).call(this, props));
	
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputDesigner: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesigner: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Spring2022, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					console.log(this.props);
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputDesigner: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Spring2022' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/landing_header_c.jpg', alt: 'Diamonds Direct' }),
						_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/landing_header_m_c.jpg', alt: 'Diamonds Direct' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'topSection' },
						_react2.default.createElement(
							'div',
							{ className: 'topTitle' },
							'Our Spring Style is in Full Bloom'
						),
						_react2.default.createElement(
							'div',
							{ className: 'topSubtitle', style: { display: 'none' } },
							'20% Spring Savings Event'
						),
						_react2.default.createElement(
							'div',
							{ className: 'topCopy' },
							_react2.default.createElement(
								'span',
								{ style: { fontSize: '20px' } },
								'Shop Online Now!'
							),
							_react2.default.createElement('br', null),
							'Or visit us in-store for a Spring Event you don\u2019t want to miss!',
							_react2.default.createElement('br', null),
							'Enjoy 20% savings PLUS an expanded selection of designer jewelry,',
							_react2.default.createElement('br', null),
							'expert-led guidance from our diamond consultants',
							_react2.default.createElement('br', null),
							'and pop-ups from your favorite local businesses.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'Select the location nearest you for more information.'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'blockSection', style: { display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'blockSectionWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'blockItem fianceBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock', onClick: function onClick() {
												return _this7.internalNav('jewelry/BLDMD35086');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/dateimage1.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock rightCopy' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrDate' },
												'April 22 - 24'
											),
											_react2.default.createElement('div', { className: 'mrHr' }),
											_react2.default.createElement(
												'div',
												{ className: 'mrLinkWrapper' },
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('charleston');
														} },
													'Charleston, SC'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('oklahoma-city');
														} },
													'Oklahoma City, OK'
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('virginia-beach');
														} },
													'Virginia Beach, VA'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('indianapolis');
														} },
													'Indianapolis, IN'
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('jacksonville');
														} },
													'Jacksonville, FL'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('columbus');
														} },
													'Columbus, OH'
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('kansas-city');
														} },
													'Kansas City, KS'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('new-orleans');
														} },
													'New Orleans, LA'
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('houston');
														} },
													'Houston, TX'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('baybrook');
														} },
													'Baybrook, TX'
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('pittsburgh');
														} },
													'Pittsburgh, PA'
												),
												_react2.default.createElement('br', null)
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'blockSection' },
						_react2.default.createElement(
							'div',
							{ className: 'blockSectionWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'blockItem newlywedBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'mainRow' },
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock mobileMakeup', onClick: function onClick() {
												return _this7.internalNav('setting/SMD1455201');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/dateimage2.jpg', alt: 'Diamonds Direct Mothers Day' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock copyBlock' },
										_react2.default.createElement(
											'div',
											{ className: 'mrBlockWrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'mrDate' },
												'April 29 - May 1'
											),
											_react2.default.createElement('div', { className: 'mrHr' }),
											_react2.default.createElement(
												'div',
												{ className: 'mrLinkWrapper' },
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('charlotte');
														} },
													'Charlotte, NC'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('birmingham');
														} },
													'Birmingham, AL'
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('richmond');
														} },
													'Richmond, VA'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('san-antonio');
														} },
													'San Antonio, TX'
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('dallas');
														} },
													'Dallas, TX'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('frisco');
														} },
													'Frisco, TX'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('austin');
														} },
													'Austin, TX'
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('st-louis');
														} },
													'St. Louis, MO'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('cleveland');
														} },
													'Cleveland, OH'
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('boca-raton');
														} },
													'Boca Raton, FL'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrSeparation' },
													'|'
												),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('greenville');
														} },
													'Greenville, SC'
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'div',
													{ className: 'mrLink', onClick: function onClick() {
															return _this7.internalNav('raleigh');
														} },
													'Raleigh, NC'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'mrBlock imgBlock rightImg', onClick: function onClick() {
												return _this7.internalNav('setting/SMD1455201');
											} },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/dateimage2.jpg', alt: 'Diamonds Direct Mothers Day' })
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'midBlock' },
						_react2.default.createElement(
							'div',
							{ className: 'midBlockCopy' },
							'With so much to choose from, here are some of our freshest picks for you:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'midBlockButtons' },
							_react2.default.createElement(
								'div',
								{ className: 'midBlockButton', onClick: function onClick() {
										return _this7.internalNav('gallery/engagement-rings?mode=setting');
									} },
								'Shop',
								_react2.default.createElement('br', null),
								'Engagement Rings'
							),
							_react2.default.createElement(
								'div',
								{ className: 'midBlockButton', onClick: function onClick() {
										return _this7.internalNav('gallery/fine-jewelry?type=ring');
									} },
								'Shop',
								_react2.default.createElement('br', null),
								'Trending Jewelry'
							),
							_react2.default.createElement(
								'div',
								{ className: 'midBlockButton', onClick: function onClick() {
										return _this7.internalNav('diamond-studs');
									} },
								'Shop',
								_react2.default.createElement('br', null),
								'Diamond Studs'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formBoxWrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'formInnerWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formP' },
								'Looking for something? We\u2019ll connect you with an expert nearest you!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'formWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorName ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Full Name*',
										value: this.state.inputName,
										onChange: this.changeName.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorEmail ? 'textInput error' : 'textInput',
										type: 'email',
										placeholder: 'Email Address*',
										value: this.state.inputEmail,
										onChange: this.changeEmail.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement('input', {
										className: this.state.errorPhone ? 'textInput error' : 'textInput',
										type: 'text',
										placeholder: 'Telephone',
										value: this.state.inputPhone,
										onChange: this.changePhone.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formInputWrapper' },
									_react2.default.createElement(_RhinoSelect2.default, {
										selectClass: 'summerSelect',
										required: true,
										value: this.state.inputLocation,
										options: this.state.locations,
										changeMethod: function changeMethod(evt) {
											return _this7.changeLocation(evt);
										},
										error: this.state.errorLocation !== null })
								),
								_react2.default.createElement(
									'div',
									{ className: 'formActionRow' },
									_react2.default.createElement(
										'button',
										{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
										'Request an appointment'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'copySection' },
						'Missed your local showroom\u2019s event? Enjoy 20% savings online now!'
					),
					_react2.default.createElement(
						'div',
						{ className: 'cheersBlock' },
						_react2.default.createElement(
							'div',
							{ className: 'cheersBlockWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'itemRow cbItems', style: { marginBottom: '25px' } },
								_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/collagea.jpg', alt: 'Diamonds Direct' }),
								_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/spring2022/landing/collagea_m.jpg', alt: 'Diamonds Direct' }),
								_react2.default.createElement('div', { className: 'cbiLink cbiLeft', onClick: function onClick() {
										return _this7.internalNav('jewelry/NCOST07518');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbiTopLeft', onClick: function onClick() {
										return _this7.internalNav('jewelry/ECLST08000');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbiTopRight', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDMD35086');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbiBottomMiddle', onClick: function onClick() {
										return _this7.internalNav('jewelry/E4FAN00077');
									} }),
								_react2.default.createElement('div', { className: 'cbiLink cbiRight', onClick: function onClick() {
										return _this7.internalNav('setting/SMD1455963');
									} })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'legalRow' },
						'*Discount excludes certified diamonds and price-protected lines. Cannot be combined with other offers.'
					)
				);
			}
		}]);
	
		return Spring2022;
	}(_react2.default.Component);
	
	Spring2022.propTypes = {
		location: _react.PropTypes.object
	};
	Spring2022.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Spring2022;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Spring2022Container = exports.Spring2022Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Spring2022);

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Summer2018Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var Summer2018 = function (_React$Component) {
		_inherits(Summer2018, _React$Component);
	
		function Summer2018(props) {
			_classCallCheck(this, Summer2018);
	
			return _possibleConstructorReturn(this, (Summer2018.__proto__ || Object.getPrototypeOf(Summer2018)).call(this, props));
		}
	
		_createClass(Summer2018, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'Summer2018' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { src: '/summer_landing_header_1.jpg', alt: 'Diamonds Direct Summer' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'promoText' },
							'This summer, make Diamonds Direct your destination for diamonds with our in-store exclusive Summer Event. Enjoy:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'promoHighlightSection' },
							'20% Special Savings'
						),
						_react2.default.createElement(
							'div',
							{ className: 'promoText', style: { margin: '0' } },
							'Internationally renowned designers have curated ',
							_react2.default.createElement(
								'span',
								{ className: 'light-em' },
								'exclusive collections'
							),
							' for each of our stores. Explore our designers in-store for a chance to win exclusive prizes! Visit our locations to learn more!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'summerLocationBlock' },
							_react2.default.createElement(
								'div',
								{ className: 'summerLocationItem' },
								_react2.default.createElement(
									'div',
									{ className: 'summerDates' },
									'July 13-15'
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocations' },
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/indianapolis' },
										'Indianapolis,\xA0IN'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/oklahoma-city' },
										'Oklahoma\xA0City,\xA0OK'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/salt-lake-city' },
										'Salt\xA0Lake\xA0City,\xA0UT'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/virginia-beach' },
										'Virginia\xA0Beach,\xA0VA'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'summerLocationItem' },
								_react2.default.createElement(
									'div',
									{ className: 'summerDates' },
									'July 20-22'
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocations' },
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/charlotte' },
										'Charlotte,\xA0NC'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/dallas' },
										'Dallas,\xA0TX'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/richmond' },
										'Richmond,\xA0VA'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'summerLocationItem' },
								_react2.default.createElement(
									'div',
									{ className: 'summerDates' },
									'July 27-29'
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocations' },
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/birmingham' },
										'Birmingham,\xA0AL'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/charleston' },
										'Charleston,\xA0SC'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/raleigh' },
										'Raleigh,\xA0NC'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/sanantonio' },
										'San\xA0Antonio,\xA0TX'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'summerLocationItem' },
								_react2.default.createElement(
									'div',
									{ className: 'summerDates' },
									'August 3-5'
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocations' },
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/austin' },
										'Austin,\xA0TX'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'link-em' },
										'|'
									),
									'\xA0',
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: 'http://globaldiamondsusa.com' },
										'Jacksonville,\xA0FL'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'a',
										{ className: 'holiday-location-link', href: '/st-louis' },
										'St.\xA0Louis,\xA0MO'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Summer2018;
	}(_react2.default.Component);
	
	Summer2018.propTypes = {
		location: _react.PropTypes.object
	};
	Summer2018.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Summer2018;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Summer2018Container = exports.Summer2018Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Summer2018);

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Summer2019Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var Summer2019 = function (_React$Component) {
		_inherits(Summer2019, _React$Component);
	
		function Summer2019(props) {
			_classCallCheck(this, Summer2019);
	
			return _possibleConstructorReturn(this, (Summer2019.__proto__ || Object.getPrototypeOf(Summer2019)).call(this, props));
		}
	
		_createClass(Summer2019, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'Summer2019' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: '/img/promopages/summer2019/banner.jpg', alt: 'Diamonds Direct Summer' }),
						_react2.default.createElement('img', { className: 'mobile600', src: '/img/promopages/summer2019/banner_mobile.jpg', alt: 'Diamonds Direct Summer' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'promoBodyInner' },
							_react2.default.createElement(
								'div',
								{ className: 'promoText' },
								'Internationally renowned designers have curated exclusive collections for each of our stores. Visit our stores during our Summer Design Showcase to learn more!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'springLocationBlock' },
								_react2.default.createElement(
									'div',
									{ className: "springLocationItem" },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2019/july12-14.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: "springLocations" },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/charleston' },
											'Charleston,\xA0SC'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/indianapolis' },
											'Indianapolis,\xA0IN'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/richmond' },
											'Richmond,\xA0VA'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/salt-lake-city' },
											'Salt\xA0Lake\xA0City,\xA0UT'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'springLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2019/july19-21.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'springLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/birmingham' },
											'Birmingham,\xA0AL'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/charlotte' },
											'Charlotte,\xA0NC'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/cleveland' },
											'Cleveland,\xA0OH'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/kansas-city' },
											'Kansas\xA0City,\xA0KS'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/st-louis' },
											'St.\xA0Louis,\xA0MO'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'springLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2019/july26-28.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'springLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/oklahoma-city' },
											'Oklahoma\xA0City,\xA0OK'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/raleigh' },
											'Raleigh,\xA0NC'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/san-antonio' },
											'San\xA0Antonio,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/virginia-beach' },
											'Virginia\xA0Beach,\xA0VA'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'springLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'springDates' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2019/aug2-4.svg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'springLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/austin' },
											'Austin,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/columbus' },
											'Columbus,\xA0OH'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/dallas' },
											'Dallas,\xA0TX'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/frisco' },
											'Frisco,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/jacksonville' },
											'Jacksonville,\xA0FL'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoLegal' },
								'*Discount excludes certified diamonds and price protected lines.',
								_react2.default.createElement('br', null),
								'Cannot be combined with other offers.'
							)
						)
					)
				);
			}
		}]);
	
		return Summer2019;
	}(_react2.default.Component);
	
	Summer2019.propTypes = {
		location: _react.PropTypes.object
	};
	Summer2019.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Summer2019;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Summer2019Container = exports.Summer2019Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Summer2019);

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Summer2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Summer2021 = function (_React$Component) {
		_inherits(Summer2021, _React$Component);
	
		function Summer2021(props) {
			_classCallCheck(this, Summer2021);
	
			var _this = _possibleConstructorReturn(this, (Summer2021.__proto__ || Object.getPrototypeOf(Summer2021)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			// Link format:
			// https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg
	
	
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			var displayArray = [{
				display: 'Designer',
				image: '',
				stores: '|'
			}, {
				display: 'A.JAFFE',
				image: 'ajaffe.svg',
				stores: '|chs|bhm|nol|ind|coh|ksc|stl|atx|dfw|ftx|boc|gsc|pit|vab|kcy|hou|',
				link: 'designer/a-jaffe'
			}, {
				display: 'Amden Jewelry',
				image: 'amden.svg',
				stores: '|coh|cle|',
				link: 'designer/amden'
			}, {
				display: 'ArtCarved',
				image: '',
				stores: '|hou|coh|cle|ksc|dfw|ftx|gsc|ral|pit|kcy|clt|chs|',
				link: 'designer/artcarved'
			}, {
				display: 'Benchmark',
				image: '',
				stores: '|bhm|nol|san|ral|',
				link: 'designer/benchmark'
			}, {
				display: 'Christopher Designs',
				image: '',
				stores: '|rva|okc|ind|coh|ksc|dfw|ftx|boc|jax|gsc|ral|kcy|',
				link: 'designer/christopher-designs'
			}, {
				display: 'Christian Bauer',
				image: '',
				stores: '|rva|bhm|hou|jax|pit|',
				link: 'designer/christian-bauer'
			}, {
				display: 'Classique Creations',
				image: '',
				stores: '|bhm|nol|okc|stl|dfw|ftx|pit|vab|',
				link: 'designer/classique'
			}, {
				display: 'Color Jewels',
				image: '',
				stores: '|clt|dfw|ral|',
				link: ''
			}, {
				display: 'Fana',
				image: '',
				stores: '|okc|ind|ind|san|atx|boc|jax|',
				link: 'designer/fana'
			}, {
				display: 'Furrer Jacot',
				image: '',
				stores: '|chs|clt|ind|coh|cle|san|atx|dfw|ftx|boc|',
				link: 'designer/furrer-jacot'
			}, {
				display: 'Gabriel & Co.',
				image: '',
				stores: '|stl|bhm|',
				link: 'designer/gabriel'
			}, {
				display: 'C. Gonshor',
				image: '',
				stores: '|rva|hou|atx|dfw|',
				link: 'designer/c-gonshor'
			}, {
				display: 'Heera Motti',
				image: 'simong.svg',
				stores: '|chs|clt|ral|',
				link: ''
			}, {
				display: 'Kirk Kara',
				image: '',
				stores: '|clt|bhm|boc|ral|',
				link: 'designer/kirk-kara'
			}, {
				display: 'Jeff Cooper',
				image: '',
				stores: '|nol|hou|san|atx|',
				link: 'designer/jeff-cooper'
			}, {
				display: 'Mastoloni',
				image: 'simong.svg',
				stores: '|chs|nol|san|gsc|pit|',
				link: 'designer/mastoloni3'
			}, {
				display: 'Michael M',
				image: 'mm.svg',
				stores: '|chs|clt|nol|okc|boc|',
				link: 'designer/michael-m'
			}, {
				display: 'Novell',
				image: '',
				stores: '|rva|okc|ksc|vab|kcy|',
				link: 'designer/novell'
			}, {
				display: 'PeJay',
				image: '',
				stores: '|cle|',
				link: 'designer/pejay'
			}, {
				display: 'Simon G.',
				image: 'simong.svg',
				stores: '|chs|clt|hou|okc|cle|san|dfw|ftx|ral|vab|',
				link: 'designer/simon-g-jewelry'
			}, {
				display: 'Tacori',
				image: 'tacori.svg',
				stores: '|chs|rva|ind|coh|cle|atx|vab|',
				link: 'designer/tacori'
			}, {
				display: 'Uneek',
				image: 'uneek.svg',
				stores: '|hou|boc|jax|',
				link: 'designer/uneek'
			}, {
				display: 'Verragio',
				image: 'ver.svg',
				stores: '|clt|rva|bhm|nol|coh|ksc|stl|dfw|ftx|jax|gsc|ral|pit|kcy|',
				link: 'designer/verragio'
			}];
	
			var designerLocationArray = [{
				display: 'Select Location',
				value: '',
				dates: '',
				page: ''
			}, {
				display: 'Austin, TX',
				value: 'atx',
				dates: 'July 21 - 25',
				page: 'austin'
			}, {
				display: 'Birmingham, AL',
				value: 'bhm',
				dates: 'July 14 - 18',
				page: 'birmingham'
			}, {
				display: 'Boca Raton, FL',
				value: 'boc',
				dates: 'July 21 - 25',
				page: 'boca-raton'
			}, {
				display: 'Charleston, SC',
				value: 'chs',
				dates: 'July 14 - 18',
				page: 'charleston'
			}, {
				display: 'Charlotte, NC',
				value: 'clt',
				dates: 'July 14 - 18',
				page: 'charlotte'
			}, {
				display: 'Cleveland, OH',
				value: 'cle',
				dates: 'July 14 - 18',
				page: 'cleveland'
			}, {
				display: 'Columbus, OH',
				value: 'coh',
				dates: 'July 14 - 18',
				page: 'columbus'
			}, {
				display: 'Dallas, TX',
				value: 'dfw',
				dates: 'July 21 - 25',
				page: 'dallas'
			}, {
				display: 'Frisco, TX',
				value: 'ftx',
				dates: 'July 21 - 25',
				page: 'frisco'
			}, {
				display: 'Greenville, SC',
				value: 'gsc',
				dates: 'July 21 - 25',
				page: 'greenville'
			}, {
				display: 'Houston, TX',
				value: 'hou',
				dates: 'July 14 - 18',
				page: 'houston'
			}, {
				display: 'Indianapolis, IN',
				value: 'ind',
				dates: 'July 14 - 18',
				page: 'indianapolis'
			}, {
				display: 'Jacksonville, FL',
				value: 'jax',
				dates: 'July 21 - 25',
				page: 'jacksonville'
			}, {
				display: 'Kansas City, KS',
				value: 'kcy',
				dates: 'July 21 - 25',
				page: 'kansas-city'
			}, {
				display: 'New Orleans, LA',
				value: 'nol',
				dates: 'July 14 - 18',
				page: 'new-orleans'
			}, {
				display: 'Oklahoma City, OK',
				value: 'okc',
				dates: 'July 14 - 18',
				page: 'oklahoma-city'
			}, {
				display: 'Pittsburgh, PA',
				value: 'pit',
				dates: 'July 21 - 25',
				page: 'pittsburgh'
			}, {
				display: 'Raleigh, NC',
				value: 'ral',
				dates: 'July 21 - 25',
				page: 'raleigh'
			}, {
				display: 'Richmond, VA',
				value: 'rva',
				dates: 'July 14 - 18',
				page: 'richmond'
			}, {
				display: 'St. Louis, MO',
				value: 'stl',
				dates: 'July 21 - 25',
				page: 'st-louis'
			}, {
				display: 'San Antonio, TX',
				value: 'san',
				dates: 'July 21 - 25',
				page: 'san-antonio'
			}, {
				display: 'Virginia Beach, VA',
				value: 'vab',
				dates: 'July 21 - 25',
				page: 'virginia-beach'
			}];
	
			_this.state = {
				locations: newArray,
				// designers: designerArray,
				designerLocationArray: designerLocationArray,
				displayArray: displayArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Summer2021, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'getLocationDesigners',
			value: function getLocationDesigners() {
				return [];
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeDesigner',
			value: function changeDesigner(evt) {
				this.setState({ inputDesigner: evt.target.value });
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'getShowDates',
			value: function getShowDates(code) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = this.state.designerLocationArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var l = _step.value;
	
						if (l.value === code) {
							return l.dates;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'getShowLink',
			value: function getShowLink(code) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = this.state.designerLocationArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var l = _step2.value;
	
						if (l.value === code) {
							return l.page;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'designerNav',
			value: function designerNav(page) {
				if (!page) {
					return;
				}
				this.internalNav(page);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Summer2021' },
					_react2.default.createElement(
						'div',
						{ className: 'headerSection' },
						_react2.default.createElement(
							'div',
							{ className: 'headerSectionWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2021/v2/landing/header.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2021/v2/landing/headerm.jpg' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'topSection' },
						_react2.default.createElement(
							'div',
							{ className: 'topRow' },
							_react2.default.createElement(
								'div',
								{ className: 'topRowLeft copyBlock copyBlock1' },
								_react2.default.createElement(
									'div',
									{ className: 'topP' },
									'Make your summer golden with special summer savings and exclusively curated jewelry!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'topP' },
									'Shop with us online or in-store and take advantage of:'
								),
								_react2.default.createElement(
									'div',
									{ className: 'topTitle' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2021/v2/landing/copy.svg' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'topRowRight imgBlock imgBlock1' },
								_react2.default.createElement('div', { className: 'linkBlock linkBlock1', onClick: function onClick() {
										return _this7.internalNav('setting/SMD1447730');
									} })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'topRow' },
							_react2.default.createElement(
								'div',
								{ className: 'topRowLeft imgBlock imgBlock2 desktopMakeup' },
								_react2.default.createElement('div', { className: 'linkBlock linkBlock1', onClick: function onClick() {
										return _this7.internalNav('jewelry/EHOOP03859');
									} }),
								_react2.default.createElement('div', { className: 'linkBlock linkBlock2', onClick: function onClick() {
										return _this7.internalNav('jewelry/BDSAP03498');
									} }),
								_react2.default.createElement('div', { className: 'linkBlock linkBlock3', onClick: function onClick() {
										return _this7.internalNav('jewelry/PRLFE00688');
									} })
							),
							_react2.default.createElement(
								'div',
								{ className: 'topRowRight copyBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'topDates' },
									'July 14 - 18'
								),
								_react2.default.createElement('div', { className: 'topDatesHr' }),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('charlotte');
											} },
										'Charlotte,\xA0NC'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('birmingham');
											} },
										'Birmingham,\xA0AL'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('richmond');
											} },
										'Richmond,\xA0VA'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('charleston');
											} },
										'Charleston,\xA0SC'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('oklahoma-city');
											} },
										'Oklahoma\xA0City,\xA0OK'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('indianapolis');
											} },
										'Indianapolis,\xA0IN'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('columbus');
											} },
										'Columbus,\xA0OH'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('cleveland');
											} },
										'Cleveland,\xA0OH'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('new-orleans');
											} },
										'New\xA0Orleans,\xA0LA'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('houston');
											} },
										'Houston,\xA0TX'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'topRowLeft imgBlock imgBlock2 mobileMakeup' },
								_react2.default.createElement('div', { className: 'linkBlock linkBlock1', onClick: function onClick() {
										return _this7.internalNav('jewelry/EHOOP03859');
									} }),
								_react2.default.createElement('div', { className: 'linkBlock linkBlock2', onClick: function onClick() {
										return _this7.internalNav('jewelry/BDSAP03498');
									} }),
								_react2.default.createElement('div', { className: 'linkBlock linkBlock3', onClick: function onClick() {
										return _this7.internalNav('jewelry/PRLFE00688');
									} })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'topRow' },
							_react2.default.createElement(
								'div',
								{ className: 'topRowLeft copyBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'topDates' },
									'July 21 - 25'
								),
								_react2.default.createElement('div', { className: 'topDatesHr' }),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('raleigh');
											} },
										'Raleigh,\xA0NC'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('austin');
											} },
										'Austin,\xA0TX'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('virginia-beach');
											} },
										'Virginia\xA0Beach,\xA0VA'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('san-antonio');
											} },
										'San\xA0Antonio,\xA0TX'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('dallas');
											} },
										'Dallas,\xA0TX'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('frisco');
											} },
										'Frisco,\xA0TX'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('st-louis');
											} },
										'St.\xA0Louis,\xA0MO'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('jacksonville');
											} },
										'Jacksonville,\xA0FL'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('kansas-city');
											} },
										'Kansas\xA0City,\xA0KS'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('boca-raton');
											} },
										'Boca\xA0Raton,\xA0FL'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('greenville');
											} },
										'Greenville,\xA0SC'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('pittsburgh');
											} },
										'Pittsburgh,\xA0PA'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'topRowRight imgBlock imgBlock3' },
								_react2.default.createElement('div', { className: 'linkBlock linkBlock1', onClick: function onClick() {
										return _this7.internalNav('setting/SMD1412162');
									} }),
								_react2.default.createElement('div', { className: 'linkBlock linkBlock2', onClick: function onClick() {
										return _this7.internalNav('jewelry/EFAND13818');
									} }),
								_react2.default.createElement('div', { className: 'linkBlock linkBlock3', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDLG11587');
									} })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'shopStripe' },
						_react2.default.createElement(
							'div',
							{ className: 'shopTitle' },
							'Shop Online July 14 - 25'
						),
						_react2.default.createElement(
							'div',
							{ className: 'shopSubtitle' },
							'Discount applied in cart'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'designersSection' },
						_react2.default.createElement(
							'div',
							{ className: 'designersLeft' },
							_react2.default.createElement(
								'div',
								{ className: 'designersP' },
								'Select your Diamonds Direct location below to see which designers will be coming to your area.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'designersSelectWrapper' },
								_react2.default.createElement(_RhinoSelect2.default, {
									selectClass: 'summerSelect',
									value: this.state.designerLocation,
									options: this.state.designerLocationArray,
									changeMethod: function changeMethod(evt) {
										return _this7.changeDesignerLocation(evt);
									} })
							),
							_react2.default.createElement(
								'div',
								{ className: 'designerResultsWrapper' },
								this.state.designerLocation ? _react2.default.createElement(
									'div',
									{ className: 'designerResultsDates' },
									this.getShowDates(this.state.designerLocation)
								) : null,
								this.state.designerLocation ? _react2.default.createElement(
									'div',
									{ className: 'designerResultsHours' },
									_react2.default.createElement(
										'div',
										{ className: 'hourLine' },
										_react2.default.createElement(
											'div',
											{ className: 'hourDay' },
											'Mon-Fri'
										),
										_react2.default.createElement(
											'div',
											{ className: 'hourTime' },
											'10am-7pm'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'hourDash' },
										'\u2014'
									),
									_react2.default.createElement(
										'div',
										{ className: 'hourLine' },
										_react2.default.createElement(
											'div',
											{ className: 'hourDay' },
											'Sat'
										),
										_react2.default.createElement(
											'div',
											{ className: 'hourTime' },
											'10am-7pm'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'hourDash' },
										'\u2014'
									),
									_react2.default.createElement(
										'div',
										{ className: 'hourLine' },
										_react2.default.createElement(
											'div',
											{ className: 'hourDay' },
											'Sun'
										),
										_react2.default.createElement(
											'div',
											{ className: 'hourTime' },
											'12pm-5pm'
										)
									)
								) : null,
								_react2.default.createElement('div', { className: 'designerHr' }),
								_react2.default.createElement(
									'div',
									{ className: 'dWrap' },
									this.state.displayArray.map(function (designer, i) {
	
										if (_this7.state.designerLocation === '') {
											return;
										}
	
										if (designer.stores.includes(_this7.state.designerLocation)) {
											console.log(designer);
											return _react2.default.createElement(
												'div',
												{ className: !designer.link ? 'designerWrapper noHover' : 'designerWrapper', key: i },
												_react2.default.createElement(
													'span',
													{ className: !designer.link ? 'dName noHover' : 'dName', onClick: function onClick() {
															return _this7.designerNav(designer.link);
														} },
													designer.display
												)
											);
										} else {
											return null;
										}
									})
								),
								this.state.designerLocation ? _react2.default.createElement(
									'div',
									{ className: 'designerResultsButton', onClick: function onClick() {
											return _this7.internalNav(_this7.getShowLink(_this7.state.designerLocation));
										} },
									'Learn More'
								) : null
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'looksSection' },
						_react2.default.createElement(
							'div',
							{ className: 'looksWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2021/jewelry.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2021/jewelrym.jpg' }),
							_react2.default.createElement('div', { className: 'lb lb1', onClick: function onClick() {
									return _this7.internalNav('setting/SMD1447730');
								} }),
							_react2.default.createElement('div', { className: 'lb lb2', onClick: function onClick() {
									return _this7.internalNav('setting/SMD1412162');
								} }),
							_react2.default.createElement('div', { className: 'lb lb3', onClick: function onClick() {
									return _this7.internalNav('jewelry/EFAND13818');
								} }),
							_react2.default.createElement('div', { className: 'lb lb4', onClick: function onClick() {
									return _this7.internalNav('jewelry/BLDLG11587');
								} })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Walk-in visits are always welcome! But if you\'d prefer to set up an appointment online or in-store, please use the form below and we will follow up to confirm!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Full Name*',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email Address*',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Telephone',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											selectClass: 'summerSelect',
											required: true,
											value: this.state.inputLocation,
											options: this.state.locations,
											changeMethod: function changeMethod(evt) {
												return _this7.changeLocation(evt);
											},
											error: this.state.errorLocation !== null })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Request an appointment'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Prefer to shop online? Need some guidance before heading into the store?'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.openIntercom.bind(this) },
											'Chat with a virtual expert'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'legalSection' },
						_react2.default.createElement(
							'div',
							{ className: 'legalInnerWrapper' },
							'*Discount excludes certified diamonds and price protected lines. Cannot be combined with other offers, financing, or previous purchases. ',
							_react2.default.createElement(
								'span',
								null,
								'Discount applied in cart online.'
							),
							' Other exclusions may apply.'
						)
					)
				);
			}
		}]);
	
		return Summer2021;
	}(_react2.default.Component);
	
	Summer2021.propTypes = {
		location: _react.PropTypes.object
	};
	Summer2021.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Summer2021;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Summer2021Container = exports.Summer2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Summer2021);

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Summer2022Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Summer2022 = function (_React$Component) {
		_inherits(Summer2022, _React$Component);
	
		function Summer2022(props) {
			_classCallCheck(this, Summer2022);
	
			var _this = _possibleConstructorReturn(this, (Summer2022.__proto__ || Object.getPrototypeOf(Summer2022)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			_this.state = {
				locations: newArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Summer2022, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'getLocationDesigners',
			value: function getLocationDesigners() {
				return [];
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeDesigner',
			value: function changeDesigner(evt) {
				this.setState({ inputDesigner: evt.target.value });
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'getShowDates',
			value: function getShowDates(code) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = this.state.designerLocationArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var l = _step.value;
	
						if (l.value === code) {
							return l.dates;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'getShowLink',
			value: function getShowLink(code) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = this.state.designerLocationArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var l = _step2.value;
	
						if (l.value === code) {
							return l.page;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'designerNav',
			value: function designerNav(page) {
				if (!page) {
					return;
				}
				this.internalNav(page);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Summer2022' },
					_react2.default.createElement(
						'div',
						{ className: 'headerSection' },
						_react2.default.createElement(
							'div',
							{ className: 'headerSectionWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2022/landing_banner.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2022/landing_banner_m.jpg' }),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'shopButton', onClick: function onClick() {
										return _this7.internalNav('gallery/engagement-rings');
									} },
								'Shop Now'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'shopSection' },
						_react2.default.createElement(
							'div',
							{ className: 'shopButtonWrapper' },
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'shopButton', onClick: function onClick() {
										return _this7.internalNav('gallery/engagement-rings');
									} },
								'Shop Online Now'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'shopTilesWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'shopTile', onClick: function onClick() {
										return _this7.internalNav('diamond-studs');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'shopImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2022/studs.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'shopTileButton' },
									_react2.default.createElement(
										'div',
										null,
										'Shop Studs'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'shopTile', onClick: function onClick() {
										return _this7.internalNav('gallery/engagement-rings?mode=setting');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'shopImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2022/engagement.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'shopTileButton' },
									_react2.default.createElement(
										'div',
										null,
										'Shop Engagement'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'shopTile', onClick: function onClick() {
										return _this7.internalNav('gallery/fine-jewelry?type=necklace');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'shopImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2022/pendants.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'shopTileButton' },
									_react2.default.createElement(
										'div',
										null,
										'Shop Pendants'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'titleSection' },
						_react2.default.createElement(
							'div',
							{ className: 'mainTitle' },
							'VISIT US IN STORE'
						),
						_react2.default.createElement(
							'div',
							{ className: 'iconLineWrapper' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2022/iconline.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'titleP' },
							'And take advantage of'
						),
						_react2.default.createElement(
							'div',
							{ className: 'titleBig' },
							'20% SAVINGS*'
						),
						_react2.default.createElement(
							'div',
							{ className: 'titleP' },
							'PLUS special designer appearances AND an expanded selection of top trending bridal and fashion jewelry'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'topSection' },
						_react2.default.createElement(
							'div',
							{ className: 'topRow' },
							_react2.default.createElement(
								'div',
								{ className: 'topRowRight copyBlock', style: { display: 'none' } },
								_react2.default.createElement(
									'div',
									{ className: 'topDates' },
									'July 15 - 17'
								),
								_react2.default.createElement('div', { className: 'topDatesHr' }),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('charleston');
											} },
										'Charleston,\xA0SC'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('oklahoma-city');
											} },
										'Oklahoma\xA0City,\xA0OK'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('virginia-beach');
											} },
										'Virginia\xA0Beach,\xA0VA'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('indianapolis');
											} },
										'Indianapolis,\xA0IN'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('columbus');
											} },
										'Columbus,\xA0OH'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('kansas-city');
											} },
										'Kansas\xA0City,\xA0KS'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('new-orleans');
											} },
										'New\xA0Orleans,\xA0LA'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('boca-raton');
											} },
										'Boca\xA0Raton,\xA0FL'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('houston');
											} },
										'Houston,\xA0TX'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('baybrook');
											} },
										'Baybrook,\xA0TX'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'topRowLeft copyBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'topDates' },
									'July 22 - 24'
								),
								_react2.default.createElement('div', { className: 'topDatesHr' }),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('charlotte');
											} },
										'Charlotte,\xA0NC'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('birmingham');
											} },
										'Birmingham,\xA0AL'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('raleigh');
											} },
										'Raleigh,\xA0NC'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('austin');
											} },
										'Austin,\xA0TX'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('richmond');
											} },
										'Richmond,\xA0VA'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('san-antonio');
											} },
										'San\xA0Antonio,\xA0TX'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('dallas');
											} },
										'Dallas,\xA0TX'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('frisco');
											} },
										'Frisco,\xA0TX'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('st-louis');
											} },
										'St.\xA0Louis,\xA0MO'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('jacksonville');
											} },
										'Jacksonville,\xA0FL'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('cleveland');
											} },
										'Cleveland,\xA0OH'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storePipe' },
										'|'
									),
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('greenville');
											} },
										'Greenville,\xA0SC'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'topDatesRow' },
									_react2.default.createElement(
										'span',
										{ className: 'storeLink', onClick: function onClick() {
												return _this7.internalNav('pittsburgh');
											} },
										'Pittsburgh,\xA0PA'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Walk-in visits are always welcome! But if you\'d prefer to set up an appointment online or in-store, please use the form below and we will follow up to confirm!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Full Name*',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email Address*',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Telephone',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											selectClass: 'summerSelect',
											required: true,
											value: this.state.inputLocation,
											options: this.state.locations,
											changeMethod: function changeMethod(evt) {
												return _this7.changeLocation(evt);
											},
											error: this.state.errorLocation !== null })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Request an appointment'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement('div', { className: '' }),
					_react2.default.createElement(
						'div',
						{ className: 'midSection' },
						_react2.default.createElement(
							'div',
							{ className: 'midP' },
							'Missed your local showroom\u2019s event? Enjoy 20% savings online now!'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'looksSection' },
						_react2.default.createElement(
							'div',
							{ className: 'looksWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2022/collage.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/summer2022/collage_m.jpg' }),
							_react2.default.createElement('div', { className: 'lb lb1', onClick: function onClick() {
									return _this7.internalNav('band/BLDSM27440');
								} }),
							_react2.default.createElement('div', { className: 'lb lb2', onClick: function onClick() {
									return _this7.internalNav('jewelry/BLDMD36461');
								} }),
							_react2.default.createElement('div', { className: 'lb lb3', onClick: function onClick() {
									return _this7.internalNav('jewelry/BLDMD36429');
								} }),
							_react2.default.createElement('div', { className: 'lb lb4', onClick: function onClick() {
									return _this7.internalNav('setting/SMD1473342');
								} }),
							_react2.default.createElement('div', { className: 'lb lb5', onClick: function onClick() {
									return _this7.internalNav('jewelry/GMISC17598');
								} })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'legalSection' },
						_react2.default.createElement(
							'div',
							{ className: 'legalInnerWrapper' },
							'*Discount excludes certified diamonds and price-protected lines. Cannot be combined with other offers.'
						)
					)
				);
			}
		}]);
	
		return Summer2022;
	}(_react2.default.Component);
	
	Summer2022.propTypes = {
		location: _react.PropTypes.object
	};
	Summer2022.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Summer2022;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Summer2022Container = exports.Summer2022Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Summer2022);

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Valentines2019Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _contacts = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as headerActionCreators from '../../../actions/header';
	var allActionCreators = Object.assign({});
	
	var Valentines2019 = function (_React$Component) {
		_inherits(Valentines2019, _React$Component);
	
		function Valentines2019(props) {
			_classCallCheck(this, Valentines2019);
	
			return _possibleConstructorReturn(this, (Valentines2019.__proto__ || Object.getPrototypeOf(Valentines2019)).call(this, props));
		}
	
		_createClass(Valentines2019, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Valentines2019' },
					_react2.default.createElement(
						'div',
						{ className: 'promoBanner' },
						_react2.default.createElement('img', { className: 'desktop600', src: '/img/promopages/valentines2019/landing_bannera.jpg', alt: 'Diamonds Direct Valentines' }),
						_react2.default.createElement('img', { className: 'mobile600', src: '/img/promopages/valentines2019/landing_mobilea.jpg', alt: 'Diamonds Direct Valentines' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'promoBody' },
						_react2.default.createElement(
							'div',
							{ className: 'promoBodyInner' },
							_react2.default.createElement(
								'div',
								{ className: 'promoText' },
								'Diamonds Direct invites you to share the ',
								_react2.default.createElement(
									'span',
									{ className: 'light-em' },
									'gift of love'
								),
								' with your special someone at our special Valentine\'s event and enjoy:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoActionBox' },
								_react2.default.createElement(
									'div',
									{ className: 'boxTitle' },
									'0% APR for 60 Months*'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxDisclaimer' },
									'*Subject to credit approval.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxDates' },
									'Available Feb. 4-14'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxButton', onClick: function onClick() {
											return _this2.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
										} },
									'Learn More & Apply'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'promoText', style: { margin: '0' } },
								_react2.default.createElement(
									'span',
									{ className: 'light-em' },
									'Internationally renowned'
								),
								' designers have curated ',
								_react2.default.createElement(
									'span',
									{ className: 'light-em' },
									'exclusive collections'
								),
								' for each of our stores. ',
								_react2.default.createElement(
									'span',
									{ className: 'color-em' },
									'February 8 & 9 only!'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'summerLocationBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'summerLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'summerDates' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2019/simong.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'summerLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/austin' },
											'Austin,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/birmingham' },
											'Birmingham,\xA0AL'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/jacksonville' },
											'Jacksonville,\xA0FL'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/kansas-city' },
											'Kansas\xA0City,\xA0KS'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/oklahoma-city' },
											'Oklahoma\xA0City,\xA0OK'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'summerDates' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2019/christopher.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'summerLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/charleston' },
											'Charleston,\xA0SC'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/columbus' },
											'Columbus,\xA0OH'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/indianapolis' },
											'Indianapolis,\xA0IN'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/salt-lake-city' },
											'Salt\xA0Lake\xA0City,\xA0UT'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/virginia-beach' },
											'Virginia\xA0Beach,\xA0VA'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'summerDates' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2019/tacori.jpg', style: { height: '30px', margin: '5px 0 0 0' } })
									),
									_react2.default.createElement(
										'div',
										{ className: 'summerLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/charlotte' },
											'Charlotte,\xA0NC'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/raleigh' },
											'Raleigh,\xA0NC'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/sanantonio' },
											'San\xA0Antonio,\xA0TX'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/dallas' },
											'Dallas,\xA0TX'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'summerDates' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2019/ajaffe.jpg' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'summerLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/richmond' },
											'Richmond,\xA0VA'
										),
										'\xA0',
										_react2.default.createElement(
											'span',
											{ className: 'link-em' },
											'|'
										),
										'\xA0',
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/st-louis' },
											'St.\xA0Louis,\xA0MO'
										),
										_react2.default.createElement('br', null),
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'summerLocationItem' },
									_react2.default.createElement(
										'div',
										{ className: 'summerDates' },
										_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2019/amden.jpg', style: { height: '80px' } })
									),
									_react2.default.createElement(
										'div',
										{ className: 'summerLocations' },
										_react2.default.createElement(
											'a',
											{ className: 'holiday-location-link', href: '/cleveland' },
											'Cleveland,\xA0OH'
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Valentines2019;
	}(_react2.default.Component);
	
	Valentines2019.propTypes = {
		location: _react.PropTypes.object
	};
	Valentines2019.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Valentines2019;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Valentines2019Container = exports.Valentines2019Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Valentines2019);

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Valentines2021Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Valentines2021 = function (_React$Component) {
		_inherits(Valentines2021, _React$Component);
	
		function Valentines2021(props) {
			_classCallCheck(this, Valentines2021);
	
			var _this = _possibleConstructorReturn(this, (Valentines2021.__proto__ || Object.getPrototypeOf(Valentines2021)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			// Link format:
			// https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg
	
	
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
			var designerArray = [{
				display: 'Designer',
				value: '',
				page: '',
				image: '',
				stores: '|'
			}, {
				display: 'Simon G.',
				value: 'Simon G.',
				page: 'simon-g-jewelry',
				image: 'simong.svg',
				stores: '|cle|ftx|nol|boc|ral|okc|vab|san|dfw|ind|'
			}, {
				display: 'Tacori',
				value: 'Tacori',
				page: 'tacori',
				image: 'tacori.svg',
				stores: '|atx|chs|'
			}, {
				display: 'Uneek',
				value: 'Uneek',
				page: 'uneek',
				image: 'uneek.svg',
				stores: '|jax|'
			}, {
				display: 'Verragio',
				value: 'Verragio',
				page: 'verragio',
				image: 'ver.svg',
				stores: '|clt|bhm|coh|rva|stl|'
			}];
	
			var designerLocationArray = [{
				display: 'Select Location',
				value: ''
			}, {
				display: 'Austin, TX',
				value: 'atx'
			}, {
				display: 'Birmingham, AL',
				value: 'bhm'
			}, {
				display: 'Boca Raton, FL',
				value: 'boc'
			}, {
				display: 'Charleston, SC',
				value: 'chs'
			}, {
				display: 'Charlotte, NC',
				value: 'clt'
			}, {
				display: 'Cleveland, OH',
				value: 'cle'
			}, {
				display: 'Columbus, OH',
				value: 'coh'
			}, {
				display: 'Dallas, TX',
				value: 'dfw'
			}, {
				display: 'Frisco, TX',
				value: 'ftx'
			}, {
				display: 'Indianapolis, IN',
				value: 'ind'
			}, {
				display: 'Jacksonville, FL',
				value: 'jax'
			}, {
				display: 'Kansas City, KS',
				value: 'kcy'
			}, {
				display: 'New Orleans, LA',
				value: 'nol'
			}, {
				display: 'Oklahoma City, OK',
				value: 'okc'
			}, {
				display: 'Raleigh, NC',
				value: 'ral'
			}, {
				display: 'Richmond, VA',
				value: 'rva'
			}, {
				display: 'St. Louis, MO',
				value: 'stl'
			}, {
				display: 'San Antonio, TX',
				value: 'san'
			}, {
				display: 'Virginia Beach, VA',
				value: 'vab'
			}];
	
			_this.state = {
				locations: newArray,
				designers: designerArray,
				designerLocationArray: designerLocationArray,
				// displayArray: designerArray,
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputDesigner: '',
				designerLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesigner: null,
				errorDesignerLocation: null
			};
			return _this;
		}
	
		_createClass(Valentines2021, [{
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'dd1Nav',
			value: function dd1Nav(page) {
				window.location.href = 'https://diamondsdirect.com/' + page;
			}
		}, {
			key: 'giftsNav',
			value: function giftsNav(page) {
				window.location.href = 'https://gifts.diamondsdirect.com';
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'getLoctionUrl',
			value: function getLoctionUrl(locationCode) {
	
				switch (locationCode) {
					case 'atx':
						return 'austin';
					case 'bhm':
						return 'birmingham';
					case 'boc':
						return 'boca-raton';
					case 'chs':
						return 'charleston';
					case 'clt':
						return 'charlotte';
					case 'cle':
						return 'cleveland';
					case 'coh':
						return 'columbus';
					case 'dfw':
						return 'dallas';
					case 'ftx':
						return 'frisco';
					case 'ind':
						return 'indianapolis';
					case 'jax':
						return 'jacksonville';
					case 'kcy':
						return 'kansas-city';
					case 'nol':
						return 'new-orleans';
					case 'okc':
						return 'oklahoma-city';
					case 'ral':
						return 'raleigh';
					case 'rva':
						return 'richmond';
					case 'stl':
						return 'st-louis';
					case 'san':
						return 'san-antonio';
					case 'vab':
						return 'virginia-beach';
				}
				return '';
			}
		}, {
			key: 'getLocationDesigners',
			value: function getLocationDesigners() {
				return [];
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeDesigner',
			value: function changeDesigner(evt) {
				this.setState({ inputDesigner: evt.target.value });
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						inputDesigner: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.nameValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Valentines2021' },
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formHeader' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/val_land_head.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/val_land_head_m.jpg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'formUpperSection' },
							_react2.default.createElement(
								'div',
								{ className: 'fuP' },
								'This Valentine\'s Day, give the one you love the gift that lets them know you want them to be yours forever!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'fuP' },
								'Shop with us online or in-store to take advantage of:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'fuBox' },
								_react2.default.createElement(
									'div',
									{ className: 'box1' },
									'0% APR for 60 Months*'
								),
								_react2.default.createElement(
									'div',
									{ className: 'box2' },
									'Subject to credit approval.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'box3' },
									'Available Now - Feb 15'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxButton', onClick: function onClick() {
											return _this7.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
										} },
									_react2.default.createElement(
										'div',
										null,
										'Learn More & Apply'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'fuP' },
								_react2.default.createElement(
									'span',
									{ className: 'fuPBold' },
									'Special hours Valentine\'s Day, February 14th'
								),
								_react2.default.createElement('br', null),
								'12 p.m. - 5 p.m.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'designersSection' },
							_react2.default.createElement(
								'div',
								{ className: 'designersP' },
								'Internationally renowned designers will be showcasing expanded, one-of-a-kind collections of fine jewelry February 12-14. Select your Diamonds Direct location below to see which designer will be coming to your area!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'designersSelectWrapper' },
								_react2.default.createElement(_RhinoSelect2.default, {
									selectClass: 'summerSelect',
									required: true,
									value: this.state.designerLocation,
									options: this.state.designerLocationArray,
									changeMethod: function changeMethod(evt) {
										return _this7.changeDesignerLocation(evt);
									},
									error: this.state.errorLocation })
							),
							_react2.default.createElement(
								'div',
								{ className: 'designerResultsWrapper' },
								this.state.designers.map(function (designer, i) {
	
									if (_this7.state.designerLocation === '') {
										return;
									}
	
									if (designer.stores.includes(_this7.state.designerLocation)) {
										return _react2.default.createElement(
											'div',
											{ className: 'designerWrapper', key: i, onClick: function onClick() {
													return _this7.internalNav(_this7.getLoctionUrl(_this7.state.designerLocation));
												} },
											_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2020/' + designer.image })
										);
									} else {
										return null;
									}
								})
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Walk-in visits are always welcome, but due to precautions and state and local ordinances, showroom space may be limited. We also have our virtual appointment tool so you can continue to shop from the comfort of your own home!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Full Name*',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email Address*',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Telephone',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											selectClass: 'summerSelect',
											required: true,
											value: this.state.inputLocation,
											options: this.state.locations,
											changeMethod: function changeMethod(evt) {
												return _this7.changeLocation(evt);
											},
											error: this.state.errorLocation !== null })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Request an appointment'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'trendsSection' },
						_react2.default.createElement(
							'div',
							{ className: 'trendsTitle' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/romantic.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'trendsBlock' },
							_react2.default.createElement(
								'div',
								{ className: 'trendsLeft trendsImgBlock' },
								_react2.default.createElement(
									'div',
									{ className: 'trendsFirst trendsImgBlock' },
									_react2.default.createElement('div', { className: 'trendsTop trendsImgBlock', onClick: function onClick() {
											return _this7.externalNav('tacori-chain-amethyst-bracelet-SB16701.html');
										} }),
									_react2.default.createElement('div', { className: 'trendsBottom trendsImgBlock', onClick: function onClick() {
											return _this7.externalNav('diamonds-direct-designs-engagement-ring-4P1814E.html');
										} })
								),
								_react2.default.createElement('div', { className: 'trendsSecond trendsImgBlock', onClick: function onClick() {
										return _this7.externalNav('simon-g-diamond-butterfly-pendant-NFANC19655.html');
									} })
							),
							_react2.default.createElement('div', { className: 'trendsRight trendsImgBlock', onClick: function onClick() {
									return _this7.externalNav('verragio-engagement-ring--5.html');
								} })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'designersSection' },
						_react2.default.createElement(
							'div',
							{ className: 'designersTitle' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/val_gg.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'designersHr' },
							_react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/trunkshow_line.svg' }),
							_react2.default.createElement('img', { className: 'mobileOnly', src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/trunkshow_line.svg' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'designersP' },
							'Diamonds Direct invites you to enjoy this season with a little extra sparkle!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'designersP' },
							'Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'designersSelectWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'ggButton', onClick: this.giftsNav.bind(this) },
								'SHOP VALENTINE GIFTS'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'footerSection' },
						_react2.default.createElement(
							'div',
							{ className: 'footerWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'footerProduct', onClick: function onClick() {
										return _this7.dd1Nav('diamonds-direct-designs-14k-rose-gold-fashion-ring-RNGSP03465.html');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'footerImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/oval.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'footerLabel' },
									'Oval Morganite and Diamond Bezel Ring'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'footerProduct', onClick: function onClick() {
										return _this7.dd1Nav('tacori-stud-earrings-TACSS00295.html');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'footerImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/amethyst.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'footerLabel' },
									'Tacori Purple Amethyst Stud Earrings'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'footerProduct', onClick: function onClick() {
										return _this7.dd1Nav('odelia-14k-white-gold-fashion-ring-BLDXL07221.html');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'footerImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/xdesign.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'footerLabel' },
									'"X" Design Ring'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'footerProduct', onClick: function onClick() {
										return _this7.dd1Nav('amden-necklace-necklace-NFANC23870.html');
									} },
								_react2.default.createElement(
									'div',
									{ className: 'footerImg' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/pendants.jpg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'footerLabel' },
									'Mixed-Cut Diamond Mosaic Double Row Necklace'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'footerLegal' },
							'*Subject to credit approval. Cannot be combined with other offers or discounts.'
						)
					)
				);
			}
		}]);
	
		return Valentines2021;
	}(_react2.default.Component);
	
	Valentines2021.propTypes = {
		location: _react.PropTypes.object
	};
	Valentines2021.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Valentines2021;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Valentines2021Container = exports.Valentines2021Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Valentines2021);

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Valentines2022Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(23);
	
	var locations = _interopRequireWildcard(_dropdown);
	
	var _itemValidation = __webpack_require__(17);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	var _RhinoSelect = __webpack_require__(14);
	
	var _RhinoSelect2 = _interopRequireDefault(_RhinoSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Valentines2022 = function (_React$Component) {
		_inherits(Valentines2022, _React$Component);
	
		function Valentines2022(props) {
			_classCallCheck(this, Valentines2022);
	
			var _this = _possibleConstructorReturn(this, (Valentines2022.__proto__ || Object.getPrototypeOf(Valentines2022)).call(this, props));
	
			var firstEntry = [{ display: 'Location*', 'value': '' }];
			var firstEntryNotReq = [{ display: 'Location', 'value': '' }];
			var finalEntry = [{ display: 'Other', 'value': 'online@diamondsdirect.com' }];
	
			var newArray = firstEntryNotReq.concat(locations.locations).concat(finalEntry);
	
			var designerLocationArray = [{
				display: 'Select Location',
				value: '',
				dates: '',
				page: ''
			}, {
				display: 'Austin, TX',
				value: 'atx',
				dates: 'simong_11-13.png',
				page: 'austin'
			}, {
				display: 'Birmingham, AL',
				value: 'bhm',
				dates: 'heera_11-12.png',
				page: 'birmingham'
			}, {
				display: 'Boca Raton, FL',
				value: 'boc',
				dates: 'tacori.png',
				page: 'boca-raton'
			}, {
				display: 'Charleston, SC',
				value: 'chs',
				dates: 'simong_11-13.png',
				page: 'charleston'
			}, {
				display: 'Charlotte, NC',
				value: 'clt',
				dates: 'simong_11-13.png',
				page: 'charlotte'
			}, {
				display: 'Cleveland, OH',
				value: 'cle',
				dates: 'fana_11-13.png',
				page: 'cleveland'
			}, {
				display: 'Columbus, OH',
				value: 'coh',
				dates: 'ajaffe.png',
				page: 'columbus'
			}, {
				display: 'Dallas, TX',
				value: 'dfw',
				dates: 'tacori.png',
				page: 'dallas'
			}, {
				display: 'Frisco, TX',
				value: 'ftx',
				dates: 'tacori.png',
				page: 'frisco'
			}, {
				display: 'Greenville, SC',
				value: 'gsc',
				dates: 'pejay.png',
				page: 'greenville'
			}, {
				display: 'Houston, TX',
				value: 'hou',
				dates: 'uneek.png',
				page: 'houston'
			}, {
				display: 'Indianapolis, IN',
				value: 'ind',
				dates: 'simong_11-13.png',
				page: 'indianapolis'
			}, {
				display: 'Jacksonville, FL',
				value: 'jax',
				dates: 'simong_11-12.png',
				page: 'jacksonville'
			}, {
				display: 'Kansas City, KS',
				value: 'kcy',
				dates: 'divine.png',
				page: 'kansas-city'
			}, {
				display: 'New Orleans, LA',
				value: 'nol',
				dates: 'ajaffe.png',
				page: 'new-orleans'
			}, {
				display: 'Oklahoma City, OK',
				value: 'okc',
				dates: 'fana_11-12.png',
				page: 'oklahoma-city'
			}, {
				display: 'Pittsburgh, PA',
				value: 'pit',
				dates: 'ajaffe.png',
				page: 'pittsburgh'
			}, {
				display: 'Raleigh, NC',
				value: 'ral',
				dates: 'amden.png',
				page: 'raleigh'
			}, {
				display: 'Richmond, VA',
				value: 'rva',
				dates: 'simong_11-12.png',
				page: 'richmond'
			}, {
				display: 'St. Louis, MO',
				value: 'stl',
				dates: 'ajaffe.png',
				page: 'st-louis'
			}, {
				display: 'San Antonio, TX',
				value: 'san',
				dates: 'simong_11-13.png',
				page: 'san-antonio'
			}, {
				display: 'Virginia Beach, VA',
				value: 'vab',
				dates: 'amden.png',
				page: 'virginia-beach'
			}];
	
			_this.state = {
	
				locations: newArray,
	
				designerLocation: '',
				designerLocationArray: designerLocationArray,
	
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
	
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
				errorMessage: null,
				errorDesignerLocation: null,
	
				bgWidth: 0,
				bgHeight: 0
			};
	
			return _this;
		}
	
		_createClass(Valentines2022, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {}
		}, {
			key: 'internalNav',
			value: function internalNav(page) {
				this.context.router.push('/' + page);
			}
		}, {
			key: 'externalNav',
			value: function externalNav(page) {
				window.location.href = '/' + page;
			}
		}, {
			key: 'openNew',
			value: function openNew(page) {
				var win = window.open(page, '_blank');
				win.focus();
			}
		}, {
			key: 'giftsNav',
			value: function giftsNav() {
				window.location.href = 'https://gifts.diamondsdirect.com';
			}
		}, {
			key: 'openIntercom',
			value: function openIntercom() {
				acquireIO.max();
			}
		}, {
			key: 'getLocationDesigners',
			value: function getLocationDesigners() {
				return [];
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ inputName: evt.target.value }, function () {
					if (_this2.state.errorName && !(0, _itemValidation.nameValidation)(_this2.state.inputName)) {
						_this2.setState({ errorName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ inputEmail: evt.target.value }, function () {
					if (_this3.state.errorEmail && !(0, _itemValidation.emailValidation)(_this3.state.inputEmail)) {
						_this3.setState({ errorEmail: null });
					}
				});
			}
		}, {
			key: 'changePhone',
			value: function changePhone(evt) {
				var _this4 = this;
	
				this.setState({ inputPhone: evt.target.value }, function () {
					if (_this4.state.errorPhone && !(0, _itemValidation.phoneValidation)(_this4.state.inputPhone)) {
						_this4.setState({ errorPhone: null });
					}
				});
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(evt) {
				var _this5 = this;
	
				this.setState({ inputLocation: evt.target.value }, function () {
					if (_this5.state.errorLocation !== false && _this5.state.inputLocation !== '') {
						_this5.setState({ errorLocation: null });
					}
				});
			}
		}, {
			key: 'changeDesigner',
			value: function changeDesigner(evt) {
				this.setState({ inputDesigner: evt.target.value });
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'submitContactRequest',
			value: function submitContactRequest() {
				if (this.validateAll()) {
	
					var contactData = {
						full_name: this.state.inputName,
						email: this.state.inputEmail,
						phone: this.state.inputPhone,
						location: this.state.inputLocation
					};
	
					this.props.commonSummerContactRequest(contactData);
					// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
					this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
					this.setState({
						inputName: '',
						inputEmail: '',
						inputPhone: '',
						inputLocation: '',
						errorName: null,
						errorEmail: null,
						errorPhone: null,
						errorLocation: null
					});
				}
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
				var _this6 = this;
	
				var hasErrors = true;
	
				// Required params
				var nameError = (0, _itemValidation.nameValidation)(this.state.inputName);
				var emailError = (0, _itemValidation.emailValidation)(this.state.inputEmail);
				var locationError = (0, _itemValidation.locationValidation)(this.state.inputLocation);
	
				// Optional params
				var phoneError = null;
				if (this.state.inputPhone) {
					phoneError = (0, _itemValidation.phoneValidation)(this.state.inputPhone);
				}
	
				if (nameError === null && emailError === null && phoneError === null && locationError === null) {
					hasErrors = false;
				}
	
				this.setState({
					errorName: nameError,
					errorEmail: emailError,
					errorPhone: phoneError,
					errorLocation: locationError
				}, function () {
					console.log(_this6.state);
				});
	
				return !hasErrors;
			}
		}, {
			key: 'getShowDates',
			value: function getShowDates(code) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = this.state.designerLocationArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var l = _step.value;
	
						if (l.value === code) {
							return l.dates;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'getShowLink',
			value: function getShowLink(code) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = this.state.designerLocationArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var l = _step2.value;
	
						if (l.value === code) {
							return l.page;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return '';
			}
		}, {
			key: 'designerNav',
			value: function designerNav(page) {
				if (!page) {
					return;
				}
				this.internalNav(page);
			}
		}, {
			key: 'changeDesignerLocation',
			value: function changeDesignerLocation(evt) {
				this.setState({ designerLocation: evt.target.value });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Valentines2022' },
					_react2.default.createElement('img', { src: 'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=lead&pixid=7333a400-055a-4ea4-a1b7-835149f34435', width: '1', height: '1' }),
					_react2.default.createElement(
						'div',
						{ className: 'headerSection' },
						_react2.default.createElement(
							'div',
							{ className: 'headerSectionWrapper' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/dec_landing_banner.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/dec_landing_banner_m.jpg' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'topSection' },
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'This Valentine\u2019s Day, give the one you love the gift that lets them feel your love forever!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'topP' },
							'Shop with us in-store or online and take advantage of:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'boxSection' },
							_react2.default.createElement(
								'div',
								{ className: 'fuBox' },
								_react2.default.createElement(
									'div',
									{ className: 'box1' },
									'0% APR for 5 Years',
									_react2.default.createElement(
										'sup',
										null,
										'1'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'box2' },
									'Subject to credit approval.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'box3' },
									'Now - Feb. 14'
								),
								_react2.default.createElement(
									'div',
									{ className: 'boxButton', onClick: function onClick() {
											return _this7.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826');
										} },
									_react2.default.createElement(
										'div',
										null,
										'Ready to Apply'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'topP darkBold' },
							'Enjoy Special Sunday Hours February 13th'
						),
						_react2.default.createElement(
							'div',
							{ className: 'topP dark' },
							'11 a.m. - 4 p.m.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'topGallery' },
							_react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/editorial.jpg' }),
							_react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/editorial_m.jpg' }),
							_react2.default.createElement('div', { className: 'ol ol1', onClick: function onClick() {
									return _this7.internalNav('setting/SMD1410732');
								} }),
							_react2.default.createElement('div', { className: 'ol ol2', onClick: function onClick() {
									return _this7.internalNav('jewelry/BLDMD31653');
								} }),
							_react2.default.createElement('div', { className: 'ol ol4', onClick: function onClick() {
									return _this7.internalNav('diamond-studs');
								} }),
							_react2.default.createElement('div', { className: 'ol ol5', onClick: function onClick() {
									return _this7.internalNav('setting/SMD1444410');
								} })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'designersSection' },
						_react2.default.createElement(
							'div',
							{ className: 'designersLeft' },
							_react2.default.createElement(
								'div',
								{ className: 'designersTitle' },
								'Exclusive Designer Trunk Shows'
							),
							_react2.default.createElement(
								'div',
								{ className: 'designersLine' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/trunkline.png' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'designersP' },
								'Internationally renowned designers will be in-store; showcasing expanded, one-of-a-kind collections of fine jewelry.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'designersP' },
								'Select your Diamonds Direct location below to see which designers will be coming to your area!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'designersSelectWrapper' },
								_react2.default.createElement(_RhinoSelect2.default, {
									selectClass: 'summerSelect',
									value: this.state.designerLocation,
									options: this.state.designerLocationArray,
									changeMethod: function changeMethod(evt) {
										return _this7.changeDesignerLocation(evt);
									} })
							),
							_react2.default.createElement(
								'div',
								{ className: 'designerResultsWrapper' },
								this.state.designerLocation && this.getShowDates(this.state.designerLocation) ? _react2.default.createElement(
									'div',
									{ className: 'designerResultsDates' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/' + this.getShowDates(this.state.designerLocation) })
								) : null
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'formSection' },
						_react2.default.createElement(
							'div',
							{ className: 'formBoxWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'formInnerWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'formP' },
									'Walk-in visits are always welcome! But if you\u2019d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!'
								),
								_react2.default.createElement(
									'div',
									{ className: 'formWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorName ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Full Name*',
											value: this.state.inputName,
											onChange: this.changeName.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorEmail ? 'textInput error' : 'textInput',
											type: 'email',
											placeholder: 'Email Address*',
											value: this.state.inputEmail,
											onChange: this.changeEmail.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement('input', {
											className: this.state.errorPhone ? 'textInput error' : 'textInput',
											type: 'text',
											placeholder: 'Telephone',
											value: this.state.inputPhone,
											onChange: this.changePhone.bind(this) })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formInputWrapper' },
										_react2.default.createElement(_RhinoSelect2.default, {
											selectClass: 'summerSelect',
											required: true,
											value: this.state.inputLocation,
											options: this.state.locations,
											changeMethod: function changeMethod(evt) {
												return _this7.changeLocation(evt);
											},
											error: this.state.errorLocation !== null })
									),
									_react2.default.createElement(
										'div',
										{ className: 'formActionRow' },
										_react2.default.createElement(
											'button',
											{ className: 'formAction', onClick: this.submitContactRequest.bind(this) },
											'Request an appointment'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'ggSection' },
						_react2.default.createElement(
							'div',
							{ className: 'ggTitle' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/gg.png' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggLine' },
							_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/ggline.png' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Diamonds Direct invites you to enjoy this Valentine\'s Day with a little extra sparkle!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggP' },
							'Shop our favorite gift guide items in our showrooms or from the comfort of your own home!'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggButton', onClick: this.giftsNav.bind(this) },
							'Shop Valentine\'s Gifts'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ggItemRow' },
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/EHOOP05406');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg1' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Tacori Diamond Crescent Hoop Earrings'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/BLDXL19649');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg2' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Emerald Diamond Eternity Band'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/PBZ0200075');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg3' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Diamond Bezel Solitaire Pendant'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ggItem', onClick: function onClick() {
										return _this7.internalNav('jewelry/TBMIS05129');
									} },
								_react2.default.createElement('div', { className: 'ggItemImg ggItemImg4' }),
								_react2.default.createElement(
									'div',
									{ className: 'ggItemLabel' },
									'Pear Shape Diamond Tennis Bracelet'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Valentines2022;
	}(_react2.default.Component);
	
	Valentines2022.propTypes = {
		location: _react.PropTypes.object
	};
	Valentines2022.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Valentines2022;
	
	
	function mapStateToProps(state) {
		return {};
	}
	
	var Valentines2022Container = exports.Valentines2022Container = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Valentines2022);

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScheduleAppointmentContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _ScheduleShoppingForm = __webpack_require__(218);
	
	var _ScheduleServiceForm = __webpack_require__(217);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var ScheduleAppointment = function (_React$Component) {
	  _inherits(ScheduleAppointment, _React$Component);
	
	  function ScheduleAppointment(props) {
	    _classCallCheck(this, ScheduleAppointment);
	
	    var _this = _possibleConstructorReturn(this, (ScheduleAppointment.__proto__ || Object.getPrototypeOf(ScheduleAppointment)).call(this, props));
	
	    _this.state = {
	      selectedForm: null
	    };
	    return _this;
	  }
	
	  _createClass(ScheduleAppointment, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.title = 'Diamonds Direct - Schedule an Appointment';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // setTimeout(() => {
	      // 	this.props.commonNotify();
	      // }, 1000);
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'selectShop',
	    value: function selectShop() {
	      var _this2 = this;
	
	      this.setState({ selectedForm: 'SHOP' }, function () {
	        _this2.scrollDown();
	      });
	    }
	  }, {
	    key: 'selectService',
	    value: function selectService() {
	      var _this3 = this;
	
	      this.setState({ selectedForm: 'SERVICE' }, function () {
	        _this3.scrollDown();
	      });
	    }
	  }, {
	    key: 'scrollDown',
	    value: function scrollDown() {
	      (0, _reactScrollToComponent2.default)(this.formWrapper, {
	        offset: -100,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'closeAllForms',
	    value: function closeAllForms() {
	      this.setState({ selectedForm: null });
	      (0, _reactScrollToComponent2.default)(this.parentForm, {
	        offset: -100,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ScheduleAppointment', ref: function ref(div) {
	            _this4.parentForm = div;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleHeader' },
	          'Request an Appointment'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'scheduleBody' },
	          _react2.default.createElement('div', { className: 'scheduleBr' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbText desktop600' },
	            'Our promise to you is the very best diamond education, personal guidance, and customer service in the industry. Our appointment request feature is provided for your convenience; however, an appointment is not required for shopping\xA0or\xA0service.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbText mobile600' },
	            'Our promise to you is the very best diamond education, personal guidance, and customer service in the industry. Our appointment request feature is provided for your convenience; however, an appointment is not required for shopping\xA0or\xA0service.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbPrompt' },
	            'Select a Service'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbButtonRow', ref: function ref(div) {
	                _this4.buttonRow = div;
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.selectedForm === 'SHOP' ? 'sbButton selected' : 'sbButton', onClick: this.selectShop.bind(this) },
	              _react2.default.createElement('div', { className: 'sbButtonIcon jewelryIcon' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'sbButtonLabel' },
	                'Shop\xA0In\xA0Store'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.selectedForm === 'SERVICE' ? 'sbButton selected' : 'sbButton', onClick: this.selectService.bind(this) },
	              _react2.default.createElement('div', { className: 'sbButtonIcon bellIcon' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'sbButtonLabel' },
	                'Service\xA0and\xA0Repairs'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbFormWrapper', ref: function ref(div) {
	                _this4.formWrapper = div;
	              } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: this.state.selectedForm === 'SHOP' ? 'block' : 'none' } },
	              _react2.default.createElement(_ScheduleShoppingForm.ScheduleShoppingFormContainer, { closeMethod: this.closeAllForms.bind(this) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: this.state.selectedForm === 'SERVICE' ? 'block' : 'none' } },
	              _react2.default.createElement(_ScheduleServiceForm.ScheduleServiceFormContainer, { closeMethod: this.closeAllForms.bind(this) })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sbText' },
	            'If you prefer to bypass the form, you can contact the store nearest you by ',
	            _react2.default.createElement(
	              'span',
	              { className: 'inlineLink', onClick: function onClick() {
	                  return _this4.internalNav('locations');
	                } },
	              'clicking here'
	            ),
	            ' or contact us at ',
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:8008855050', className: 'inlineLink' },
	              '(800) 885-5050'
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'scheduleFooterSpacer' })
	      );
	    }
	  }]);
	
	  return ScheduleAppointment;
	}(_react2.default.Component);
	
	ScheduleAppointment.propTypes = {
	  location: _react.PropTypes.object
	};
	ScheduleAppointment.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = ScheduleAppointment;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var ScheduleAppointmentContainer = exports.ScheduleAppointmentContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(ScheduleAppointment);

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchResultsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _url = __webpack_require__(56);
	
	var _product = __webpack_require__(26);
	
	var productActionCreators = _interopRequireWildcard(_product);
	
	var _ProductGrid = __webpack_require__(538);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, productActionCreators);
	
	var SearchResults = function (_React$Component) {
	  _inherits(SearchResults, _React$Component);
	
	  function SearchResults(props) {
	    _classCallCheck(this, SearchResults);
	
	    var _this = _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).call(this, props));
	
	    var urlData = (0, _url.getJsonFromUrl)();
	    var hasQuerystring = Object.entries(urlData).length > 0 && urlData.constructor === Object;
	
	    console.log(urlData);
	
	    var searchQuery = '';
	    if (hasQuerystring && urlData.q) {
	      searchQuery = urlData.q;
	    }
	
	    var initPageVal = hasQuerystring && urlData.p ? urlData.p : null;
	
	    _this.state = {
	      searchQuery: searchQuery,
	      searchResults: [],
	      searchCount: 0,
	      hasSearched: false,
	      searchPending: false,
	      sortValue: '',
	      initPage: initPageVal
	    };
	    return _this;
	  }
	
	  _createClass(SearchResults, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Search Results';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	
	      if (this.state.searchQuery) {
	        this.fetchSearchResults(true);
	      }
	
	      if (window.location.host.indexOf('staging') >= 0) {
	        cls_InovaDiamonds_Iframe.put_Flag_Cataloge();
	        cls_InovaDiamonds_Iframe.init_Session();
	      }
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'changeSearchQuery',
	    value: function changeSearchQuery(evt) {
	      this.setState({ searchQuery: evt.target.value });
	    }
	  }, {
	    key: 'keyPressSearch',
	    value: function keyPressSearch(evt) {
	      if (evt.key === 'Enter') {
	        this.fetchSearchResults();
	      }
	    }
	  }, {
	    key: 'fetchSearchResults',
	    value: function fetchSearchResults() {
	      var _this2 = this;
	
	      var firstCall = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.state.searchQuery) {
	
	        if (firstCall === true) {
	          this.props.productSetPage(this.state.initPage ? parseInt(this.state.initPage) : 1);
	        } else {
	          this.props.productSetPage(1);
	        }
	
	        var searchString = this.state.searchQuery.toLowerCase();
	        if (searchString.toLowerCase().includes('paper clip')) {
	          searchString = searchString.replace('paper clip', 'paperclip');
	        }
	        if (searchString.toLowerCase().includes('fresh water')) {
	          searchString = searchString.replace('fresh water', 'freshwater');
	        }
	        if (searchString.toLowerCase().includes('three stone')) {
	          searchString = searchString.replace('three stone', 'three-stone');
	        }
	        if (searchString.toLowerCase().includes('5 stone')) {
	          searchString = searchString.replace('5 stone', 'five-stone');
	        }
	        if (searchString.toLowerCase().includes('5-stone')) {
	          searchString = searchString.replace('5-stone', 'five-stone');
	        }
	        if (searchString.toLowerCase().includes('five stone')) {
	          searchString = searchString.replace('five stone', 'five-stone');
	        }
	        if (searchString.toLowerCase().includes('3 stone')) {
	          searchString = searchString.replace('3 stone', 'three-stone');
	        }
	        if (searchString.toLowerCase().includes('3-stone')) {
	          searchString = searchString.replace('3-stone', 'three-stone');
	        }
	        if (searchString.toLowerCase().includes('four row')) {
	          searchString = searchString.replace('four row', 'four-row');
	        }
	        if (searchString.toLowerCase().includes('five row')) {
	          searchString = searchString.replace('five row', 'five-row');
	        }
	        if (searchString.toLowerCase().includes('tri tone')) {
	          searchString = searchString.replace('tri tone', 'tri-tone');
	        }
	        if (searchString.toLowerCase().includes('tritone')) {
	          searchString = searchString.replace('tritone', 'tri-tone');
	        }
	        if (searchString.toLowerCase().includes('two tone')) {
	          searchString = searchString.replace('two tone', 'two-tone');
	        }
	        if (searchString.toLowerCase().includes('anniversary bands')) {
	          searchString = searchString.replace('anniversary bands', 'anniversary band');
	        }
	        if (searchString.toLowerCase().includes('eternity bands')) {
	          searchString = searchString.replace('eternity bands', 'eternity band');
	        }
	        if (searchString.toLowerCase().includes('wedding bands')) {
	          searchString = searchString.replace('wedding bands', 'wedding band');
	        }
	        if (searchString.toLowerCase().includes('hoops')) {
	          searchString = searchString.replace('hoops', 'hoop');
	        }
	        if (searchString.toLowerCase().includes('chains')) {
	          searchString = searchString.replace('chains', 'chain');
	        }
	        if (searchString.toLowerCase().includes('pavé')) {
	          searchString = searchString.replace('pavé', 'pavÃ©');
	        }
	        if (searchString.toLowerCase().includes('pave')) {
	          searchString = searchString.replace('pave', 'pavÃ©');
	        }
	
	        this.setState({
	          searchResults: [],
	          searchCount: 0,
	          hasSearched: true,
	          searchPending: true
	        }, function () {
	          console.log(searchString);
	          _this2.props.productFetchSearchResults(searchString, _this2.state.sortValue).then(function (resp) {
	
	            var prodResp = resp.success.products;
	            var prodCount = resp.success.count;
	
	            _this2.props.productFetchDiamondById(_this2.state.searchQuery).then(function (respData) {
	
	              var diamondResp = respData;
	              diamondResp['product_type'] = 'diamond';
	
	              _this2.setState({
	                searchResults: prodResp.push(diamondResp),
	                searchCount: prodCount + 1,
	                searchPending: false
	              });
	            }).catch(function (errResp) {
	              if (resp && resp.success) {
	                _this2.setState({
	                  searchResults: prodResp,
	                  searchCount: prodCount,
	                  searchPending: false
	                });
	              }
	            });
	          });
	        });
	      }
	    }
	  }, {
	    key: 'scrollToResults',
	    value: function scrollToResults() {
	      if (!this.resultsSection) {
	        return;
	      }
	      (0, _reactScrollToComponent2.default)(this.resultsSection, {
	        offset: 0,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'updateMethod',
	    value: function updateMethod(sortVal) {
	      var _this3 = this;
	
	      this.setState({ sortValue: sortVal }, function () {
	        _this3.fetchSearchResults();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'SearchResults' },
	        _react2.default.createElement(
	          'div',
	          { className: 'searchTitle' },
	          'Diamonds Direct Search'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'searchControls' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inputWrapper' },
	            _react2.default.createElement('input', {
	              type: 'text',
	              placeholder: 'Search Diamonds Direct',
	              value: this.state.searchQuery,
	              onChange: this.changeSearchQuery.bind(this),
	              onKeyPress: this.keyPressSearch.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'buttonWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'searchIconButton', onClick: this.fetchSearchResults.bind(this) },
	              _react2.default.createElement(
	                'div',
	                { className: 'buttonIcon' },
	                _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/search/search_icon.svg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'buttonText' },
	                'Search'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'resultsWrapper', ref: function ref(div) {
	              _this4.resultsSection = div;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsTabWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'resultTab selectedTab' },
	              'Search Results'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'resultsBody', ref: function ref(div) {
	                _this4.resultsBody = div;
	              } },
	            !this.state.hasSearched ? _react2.default.createElement(
	              'div',
	              { className: 'searchPrompt' },
	              'Enter query above to search Diamonds Direct.'
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_ProductGrid.ProductGridContainer, {
	                updateMethod: this.updateMethod.bind(this),
	                scrollUp: this.scrollToResults.bind(this),
	                searchPending: this.state.searchPending,
	                products: this.state.searchResults,
	                productCount: this.state.searchCount,
	                searchQuery: this.state.searchQuery })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SearchResults;
	}(_react2.default.Component);
	
	SearchResults.propTypes = {
	  location: _react.PropTypes.object
	};
	SearchResults.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = SearchResults;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var SearchResultsContainer = exports.SearchResultsContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(SearchResults);

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StoreContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactMailto = __webpack_require__(142);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _AntiModal = __webpack_require__(119);
	
	var _AntiModal2 = _interopRequireDefault(_AntiModal);
	
	var _TeamModal = __webpack_require__(319);
	
	var _formatting = __webpack_require__(21);
	
	var _stores = __webpack_require__(321);
	
	var stores = _interopRequireWildcard(_stores);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Store = function (_React$Component) {
	  _inherits(Store, _React$Component);
	
	  function Store(props) {
	    _classCallCheck(this, Store);
	
	    var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, props));
	
	    var isMobile = window.innerWidth <= 768;
	
	    _this.state = {
	      store: stores.ALL[_this.props.route.store_id],
	      // activePromo: this.props.route.store_id === 'coh' || this.props.route.store_id === 'vab',
	      holidayHours: false,
	      hoursNotice: false,
	      biosOpen: false,
	      openModal: false,
	      selectedMember: null,
	      biosClass: stores.ALL[_this.props.route.store_id].team && stores.ALL[_this.props.route.store_id].team.length < 8 && !isMobile ? 'biosSection limitedBios' : 'biosSection',
	
	      openHoursModal: false
	    };
	
	    // Bind event listeners
	    _this.setBiosClass = _this.setBiosClass.bind(_this);
	    return _this;
	  }
	
	  _createClass(Store, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.title = this.state.store.title;
	      document.getElementsByTagName("META")[7].content = this.state.store.description;
	
	      window.addEventListener('resize', this.setBiosClass, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.setBiosClass, false);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (window.location.href.includes('scroll=event')) {
	        setTimeout(function () {
	          _this2.scrollToPromo();
	        }, 250);
	      }
	    }
	  }, {
	    key: 'scrollToTeam',
	    value: function scrollToTeam() {
	      (0, _reactScrollToComponent2.default)(this.biosSection, {
	        offset: 0,
	        align: 'middle',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'scrollToPromo',
	    value: function scrollToPromo() {
	      if (!this.promoSection) {
	        return;
	      }
	      (0, _reactScrollToComponent2.default)(this.promoSection, {
	        offset: 200,
	        align: 'top',
	        duration: 1000,
	        ease: 'inOutCube'
	      });
	    }
	  }, {
	    key: 'facebookNav',
	    value: function facebookNav() {
	      var win = window.open(this.state.store.facebookUrl, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'instagramNav',
	    value: function instagramNav() {
	      var win = window.open(this.state.store.instagramUrl, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'pinterestNav',
	    value: function pinterestNav() {
	      var win = window.open('https://www.pinterest.com/diamondsdirect/', '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'instagramDefault',
	    value: function instagramDefault() {
	      var win = window.open('https://www.instagram.com/diamondsdirect/', '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'userNav',
	    value: function userNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'giftsNav',
	    value: function giftsNav(page) {
	      window.location.href = 'https://gifts.diamondsdirect.com';
	    }
	  }, {
	    key: 'fetchHours',
	    value: function fetchHours() {
	      return this.state.holidayHours ? this.state.store.hours.holiday : this.state.store.hours.default;
	    }
	  }, {
	    key: 'setBiosClass',
	    value: function setBiosClass() {
	      var isMobile = window.innerWidth <= 768;
	      this.setState({
	        biosClass: this.state.store.team && this.state.store.team.length < 8 && !isMobile ? 'biosSection limitedBios' : 'biosSection'
	      });
	    }
	  }, {
	    key: 'toggleBios',
	    value: function toggleBios() {
	      this.setState({
	        biosOpen: !this.state.biosOpen
	      });
	    }
	  }, {
	    key: 'openTeamModal',
	    value: function openTeamModal(member) {
	      this.setState({
	        openModal: true,
	        selectedMember: member
	      });
	    }
	  }, {
	    key: 'openHoursModal',
	    value: function openHoursModal() {
	      this.setState({
	        openHoursModal: true
	      });
	    }
	  }, {
	    key: 'closeTeamModal',
	    value: function closeTeamModal() {
	      var _this3 = this;
	
	      this.setState({
	        openModal: false
	      }, function () {
	        setTimeout(function () {
	          _this3.setState({
	            selectedMember: null
	          });
	        }, 400);
	      });
	    }
	  }, {
	    key: 'closeHoursModal',
	    value: function closeHoursModal() {
	      this.setState({
	        openHoursModal: false
	      });
	    }
	  }, {
	    key: 'nextSlide',
	    value: function nextSlide() {
	      this.sliderObject.slickNext();
	    }
	  }, {
	    key: 'prevSlide',
	    value: function prevSlide() {
	      this.sliderObject.slickPrev();
	    }
	  }, {
	    key: 'renderRotatingBanner',
	    value: function renderRotatingBanner() {
	      var _this4 = this;
	
	      var settings = {
	        dots: false,
	        infinite: true,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: true,
	        speed: 500,
	        autoplaySpeed: 10000,
	        cssEase: "linear",
	        arrows: false
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'storeRotatingBanner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'bannerLeft', onClick: this.prevSlide.bind(this) },
	          _react2.default.createElement('div', { className: 'leftArrow' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bannerRight', onClick: this.nextSlide.bind(this) },
	          _react2.default.createElement('div', { className: 'rightArrow' })
	        ),
	        _react2.default.createElement(
	          _reactSlick2.default,
	          _extends({ ref: function ref(slider) {
	              _this4.sliderObject = slider;
	            } }, settings),
	          _react2.default.createElement(
	            'div',
	            { className: 'rotatingBannerItem fall2018promoBanner' },
	            _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/store/promo-banners/' + this.props.route.store_id + '/vd20_banner.jpg' }),
	            _react2.default.createElement('img', { className: 'midMobile', src: 'https://ddw2.diamondsdirect.com/img/store/promo-banners/' + this.props.route.store_id + '/vd20_banner_midmobile.jpg' }),
	            _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/store/promo-banners/' + this.props.route.store_id + '/vd20_banner_mobile.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'rotatingBannerItem' },
	            _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/promopages/fall2019/store_banner.jpg' }),
	            _react2.default.createElement('img', { className: 'midMobile', src: 'https://ddw2.diamondsdirect.com/img/promopages/fall2019/store_banner_midmobile.jpg' }),
	            _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/fall2019/store_banner_mobile.jpg' })
	          )
	        )
	      );
	    }
	
	    // For Valentine's 2019 Promo
	
	  }, {
	    key: 'getDesignerFullName',
	    value: function getDesignerFullName(code) {
	      switch (code) {
	        case 'ajaffe':
	          return 'A. Jaffe Designer';
	        case 'christopher':
	          return 'Christopher Designs Designer';
	        case 'amden':
	          return 'Amden Designer';
	        case 'simong':
	          return 'Simon G. Designer';
	        default:
	          return 'Designer';
	      }
	    }
	  }, {
	    key: 'covidPreRedText',
	    value: function covidPreRedText() {
	
	      return null;
	
	      // let useDefault = [
	      //      'atx',
	      //      'bhm',
	      //      'dfw',
	      //      'ftx',
	      //      'san',
	      //    ];
	      //    if(useDefault.includes(this.props.route.store_id)) {
	      //      return <div style={{fontStyle: 'italic', fontWeight: '300'}}>As of Friday, April 24<sup>th</sup></div>;
	      //    } else {
	      //      return null;
	      //    }
	    }
	  }, {
	    key: 'covidBottomText',
	    value: function covidBottomText() {
	      switch (this.props.route.store_id) {
	        case 'chs':
	          return this.reopenedBottomText();
	        case 'bhm':
	          return this.reopenedBottomText();
	        case 'atx':
	          return this.reopenedBottomText();
	        case 'dfw':
	          return this.reopenedBottomText();
	        case 'ftx':
	          return this.reopenedBottomText();
	        case 'san':
	          return this.reopenedBottomText();
	        case 'nol':
	          return this.reopenedBottomText();
	        case 'okc':
	          return this.reopenedBottomText();
	        case 'jax':
	          return this.reopenedBottomText();
	        case 'coh':
	          return this.reopenedBottomText();
	        case 'cle':
	          return this.reopenedBottomText();
	        case 'vab':
	          return this.reopenedBottomText();
	        case 'rva':
	          return this.reopenedBottomText();
	        default:
	          return this.reopenedBottomText();
	      }
	    }
	  }, {
	    key: 'covidHours',
	    value: function covidHours() {
	      var useDefault = ['atx', 'bhm', 'boc', 'chs', 'dfw', 'ftx', 'san', 'nol', 'okc', 'jax', 'coh', 'cle', 'vab', 'rva', 'clt', 'ral', 'kcy', 'stl', 'ind', 'pit', 'hou', 'gsc', 'nva', 'bay', 'try'];
	      return useDefault.includes(this.props.route.store_id);
	    }
	  }, {
	    key: 'reopenedBottomText',
	    value: function reopenedBottomText() {
	      var _this5 = this;
	
	      if (this.props.route.store_id === 'boc' && false) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '10px', color: '#4B2D53', display: 'none' } },
	            'Special Sunday Hours: We will be open on 6/27 from 12 p.m. to 5 p.m.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '10px' } },
	            'No appointment is necessary for in-store shopping. You can also shop with us from the comfort of your home with our new ',
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: '700', cursor: 'pointer' }, onClick: function onClick() {
	                  return _this5.userNav('virtual');
	                } },
	              'remote and virtual shopping tools'
	            ),
	            '. ',
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: '700', cursor: 'pointer' }, onClick: function onClick() {
	                  return _this5.userNav('covid-19-updates');
	                } },
	              'Click here'
	            ),
	            ' for information on safe shopping protocols.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '10px' } },
	            'For special hours ',
	            _react2.default.createElement(
	              'a',
	              { href: this.state.store.facebookUrl, target: '_blank' },
	              'visit Facebook'
	            ),
	            '.'
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '10px', color: '#4B2D53', display: 'none' } },
	            'Closed Monday, Sept 6th for Labor Day'
	          ),
	          this.state.store.facebookUrl ? _react2.default.createElement(
	            'div',
	            { style: { marginTop: '10px' } },
	            'For special hours ',
	            _react2.default.createElement(
	              'a',
	              { href: this.state.store.facebookUrl, target: '_blank' },
	              'visit Facebook'
	            ),
	            '.'
	          ) : null
	        );
	      }
	    }
	  }, {
	    key: 'defaultCovidBottomText',
	    value: function defaultCovidBottomText() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        'Although our showrooms are temporarily closed due to COVID-19, we are still available to help you! Our diamond experts are on-call and have the tools to educate and guide you from the comfort of your home.'
	      );
	    }
	  }, {
	    key: 'departmentChat',
	    value: function departmentChat(deptId) {}
	  }, {
	    key: 'agentChat',
	    value: function agentChat(agentId) {
	      if (agentId) {
	        acquireIO.max('text', agentId);
	      } else {
	        acquireIO.max('text');
	      }
	    }
	  }, {
	    key: 'agentVideo',
	    value: function agentVideo(agentId) {
	      if (agentId) {
	        acquireIO.max('video', agentId);
	      } else {
	        acquireIO.max('video');
	      }
	    }
	
	    // Back to Dec
	    // <img className='desktopOnly' src={`https://ddw2.diamondsdirect.com/img/promopages/december2022/store/storepage.jpg`} />
	    // <img className='midMobile' src={`https://ddw2.diamondsdirect.com/img/promopages/december2022/store/storepage_m_landscape.jpg`} />
	    // <img className='mobile600' src={`https://ddw2.diamondsdirect.com/img/promopages/december2022/store/storepage_m.jpg`} />
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var hasMultipleBanners = ['kcy', 'cle', 'ftx', 'boc', 'hou', 'pit', 'gsc', 'nva', 'bay', 'try'].includes(this.props.route.store_id);
	
	      var isWeek1 = ['atx', 'chs', 'okc', 'vab', 'san', 'ind', 'coh', 'kcy', 'nol', 'nva', 'try'].includes(this.props.route.store_id);
	      var isWeek2 = ['clt', 'bhm', 'ral', 'rva', 'dfw', 'ftx', 'stl', 'cle', 'boc', 'hou', 'bay', 'pit', 'jax', 'gsc'].includes(this.props.route.store_id);
	
	      var isWeek1Custom = ['coh', 'ind', 'san', 'vab'].includes(this.props.route.store_id);
	      var isWeek2Custom = ['bhm', 'cle', 'clt', 'ftx', 'hou', 'pit', 'ral', 'rva', 'stl', 'jax'].includes(this.props.route.store_id);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Store' },
	        _react2.default.createElement(
	          'div',
	          { className: 'bannerSection' },
	          this.state.store.currentPromo || true ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/store-page-banner.jpg' }),
	                _react2.default.createElement('img', { className: 'midMobile', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/storepage_banner_mobilelandscape.jpg' }),
	                _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/store-page-mobile.jpg' }),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'bannerSectionButton',
	                    onClick: function onClick() {
	                      return _this6.internalNav('mothers-day');
	                    },
	                    style: { display: 'none' } },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Shop Gifts for Mom'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'bannerSectionButton', onClick: function onClick() {
	                    return _this6.internalNav('holiday');
	                  }, style: { display: 'none' } },
	                'Learn More'
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              hasMultipleBanners ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('img', { className: 'desktopOnly', src: 'https://ddw2.diamondsdirect.com/img/store/homepage-banners/' + this.props.route.store_id + '/storepage_banner-c.jpg' }),
	                _react2.default.createElement('img', { className: 'midMobile', src: 'https://ddw2.diamondsdirect.com/img/store/homepage-banners/' + this.props.route.store_id + '/storepage_banner_mobilelandscape-c.jpg' }),
	                _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/store/homepage-banners/' + this.props.route.store_id + '/storepage_mobile-c.jpg' })
	              ) : _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/homepage-banners/' + this.props.route.store_id + '/default.jpg' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'infoSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'infoTitle' },
	            this.state.store.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'infoDescriptionWrapper' },
	            this.state.store.mainDescription.map(function (desc, i) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'infoDescriptionP', key: i },
	                desc
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'infoRowWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'infoRow' },
	              _react2.default.createElement(
	                'div',
	                { className: 'locationWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'locationTitle' },
	                  'Location'
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { className: 'locationLink', href: this.state.store.googleMapsLink, target: '_blank' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'locationBody' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'locationBodyRow' },
	                      this.state.store.address.line1
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'locationBodyRow' },
	                      this.state.store.address.line2
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'locationTitle contactTitle' },
	                  'Contact Us'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'phoneWrapper' },
	                  _react2.default.createElement('div', { className: 'phoneIcon' }),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'tel:' + this.state.store.phone },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'phoneValue' },
	                      (0, _formatting.displayPhone)(this.state.store.phone)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'emailWrapper' },
	                  _react2.default.createElement('div', { className: 'emailIcon' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'emailValue' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'mailto:' + this.state.store.email },
	                      this.state.store.email
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'hoursWrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hoursTitle' },
	                  'Hours'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hoursBody' },
	                  this.covidPreRedText(),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { style: { display: 'none' } },
	                      this.fetchHours().map(function (hour, i) {
	                        if (_this6.covidHours()) {
	                          return _react2.default.createElement(
	                            'div',
	                            { className: 'hoursBodyRow', key: i },
	                            hour.days,
	                            ': ',
	                            hour.hours
	                          );
	                        } else {
	                          if (i === 0) {
	                            return _react2.default.createElement(
	                              'div',
	                              { className: 'hoursBodyRow', key: i },
	                              'Opening soon!'
	                            );
	                          } else {
	                            return null;
	                          }
	                        }
	                      })
	                    ),
	                    true ? _react2.default.createElement(
	                      'div',
	                      { className: 'hoursBodyRow hoursNoticeNormal hoursLink', onClick: this.openHoursModal.bind(this) },
	                      'See Special Holiday Hours'
	                    ) : null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hoursBodyRow hoursNotice', style: { color: '#4B2D53', display: isWeek1 ? 'none' : 'none' } },
	                      'Special Holiday Hours:',
	                      _react2.default.createElement('br', null),
	                      'Nov 11: 10am-8pm',
	                      _react2.default.createElement('br', null),
	                      'Nov 12: 10am-7pm',
	                      _react2.default.createElement('br', null),
	                      'Nov 13: 12pm-6pm'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'covidBottomWrapper' },
	                      this.covidBottomText()
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'none' } },
	                    this.state.store.hours.notice ? _react2.default.createElement('div', { className: 'hoursBodyRow hoursNotice', dangerouslySetInnerHTML: { __html: this.state.store.hours.notice } }) : _react2.default.createElement(
	                      'div',
	                      null,
	                      this.state.store.facebookUrl ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'hoursBodyRow hoursNoticeNormal' },
	                          'Please visit ',
	                          _react2.default.createElement(
	                            'a',
	                            { href: this.state.store.facebookUrl, target: '_blank' },
	                            'Facebook'
	                          ),
	                          ' for weather-related closings and other delays'
	                        )
	                      ) : null
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'infoRow' })
	          ),
	          this.props.route.store_id === 'clt' ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'infoCTA', onClick: function onClick() {
	                  return _this6.openNew('https://diamondsdirecttimepieces.com/');
	                }, style: { width: '280px' } },
	              'Diamonds Direct Timepieces'
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'infoCTA', onClick: this.scrollToTeam.bind(this) },
	            'Meet the Team'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'infoCTA', onClick: function onClick() {
	                return _this6.internalNav('contact-us');
	              } },
	            'Book Appointment'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'infoSocial' },
	            _react2.default.createElement(
	              'div',
	              { className: 'infoSocialHeader' },
	              'Let\u2019s Get Social'
	            ),
	            this.state.store.facebookUrl ? _react2.default.createElement(
	              'div',
	              { className: 'infoSocialIcon', onClick: this.facebookNav.bind(this) },
	              _react2.default.createElement('i', { className: 'fab fa-facebook-f' })
	            ) : null,
	            this.state.store.instagramUrl ? _react2.default.createElement(
	              'div',
	              { className: 'infoSocialIcon', onClick: this.instagramNav.bind(this) },
	              _react2.default.createElement('i', { className: 'fab fa-instagram' })
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'infoSocialIcon', onClick: this.instagramDefault.bind(this) },
	              _react2.default.createElement('i', { className: 'fab fa-instagram' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'infoSocialIcon', onClick: this.pinterestNav.bind(this) },
	              _react2.default.createElement('i', { className: 'fab fa-pinterest' })
	            )
	          ),
	          this.state.store.sponsorships && this.state.store.sponsorships.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'sponsorshipSection' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sponsorshipSubtitle' },
	              'Home Team Pride'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sponsorshipLogos' },
	              this.state.store.sponsorships.map(function (sponsorship, i) {
	                var sponsorSrc = 'https://ddw2.diamondsdirect.com/img/store/sponsorships/' + _this6.props.route.store_id + '/' + sponsorship.image;
	                return _react2.default.createElement(
	                  'div',
	                  { className: _this6.state.store.sponsorships.length === 1 ? 'sponsorLogo single' : 'sponsorLogo', key: i },
	                  _react2.default.createElement('img', { src: sponsorSrc, alt: sponsorship.name })
	                );
	              })
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reviewSection' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLine' },
	              'We\u2019d love to hear from you! '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLine' },
	              'Leave\xA0us\xA0a\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerButton', onClick: function onClick() {
	                  _this6.openNew(_this6.state.store.reviews.googleWrite);
	                } },
	              'Review'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLine' },
	              '\xA0or\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerButton', onClick: function onClick() {
	                  _this6.openNew(_this6.state.store.reviews.googleRead);
	                } },
	              'Read'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footerLine' },
	              '\xA0what\xA0others\xA0have\xA0to say.'
	            )
	          )
	        ),
	        this.state.store.currentPromo || true ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'promoSection', ref: function ref(div) {
	                _this6.promoSection = div;
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'promoBanner' },
	              _react2.default.createElement('img', { className: 'desktop600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/Event-Banner.jpg' }),
	              _react2.default.createElement('img', { className: 'mobile600', src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/event-mobile.jpg' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'promoContentDefault', style: { position: 'relative' } },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/event.jpg' })
	            )
	          )
	        ) : null,
	        this.state.store.video ? _react2.default.createElement(
	          'div',
	          { className: 'videoSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'videoWrapper' },
	            _react2.default.createElement('iframe', { src: this.state.store.video, frameborder: '0', allow: 'autoplay; fullscreen', allowFullScreen: true })
	          )
	        ) : null,
	        this.props.route.store_id === 'nol' ? _react2.default.createElement(
	          'div',
	          { className: 'audioSection', style: { display: 'none' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'audioLabel' },
	            'Listen to an interview with our general manager:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'audioWrapper' },
	            _react2.default.createElement('audio', {
	              controls: true,
	              src: 'https://ddw2.diamondsdirect.com/img/store/audio/nol.mp3' })
	          )
	        ) : null,
	        this.props.route.store_id === 'ftx' && false ? _react2.default.createElement(
	          'div',
	          { className: 'videoSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'videoWrapper' },
	            _react2.default.createElement('iframe', { src: 'https://player.vimeo.com/video/365145124', frameborder: '0', allow: 'autoplay; fullscreen', allowFullScreen: true })
	          )
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { className: this.state.biosClass, ref: function ref(div) {
	              _this6.biosSection = div;
	            }, style: { display: this.state.store.team.length === 0 ? 'none' : 'block' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'biosTitle' },
	            'Meet Your ',
	            this.state.store.shortName,
	            ' Team'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.biosOpen ? 'biosWrapper open' : 'biosWrapper' },
	            this.state.store.team.map(function (member, i) {
	              var bioSrc = 'https://ddw2.diamondsdirect.com/img/store/team/' + _this6.props.route.store_id + '/' + member.picture;
	              return _react2.default.createElement(
	                'div',
	                { className: 'memberBio', key: i, onClick: function onClick() {
	                    _this6.openTeamModal(member);
	                  } },
	                _react2.default.createElement('img', { src: bioSrc }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'memberOverlay' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'memberInfo' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'memberName' },
	                      member.name
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'memberTitle' },
	                      member.title
	                    )
	                  )
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'biosViewControls' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.biosOpen ? 'biosViewMore hidden' : 'biosViewMore', onClick: this.toggleBios.bind(this) },
	              _react2.default.createElement(
	                'div',
	                { className: 'moreText' },
	                'View More'
	              ),
	              _react2.default.createElement('div', { className: 'downArrow' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.biosOpen ? 'biosViewLess' : 'biosViewLess hidden', onClick: this.toggleBios.bind(this) },
	              _react2.default.createElement('div', { className: 'upArrow' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'lessText' },
	                'View Less'
	              )
	            )
	          )
	        ),
	        this.state.store.awards && this.state.store.awards.length > 0 ? _react2.default.createElement(
	          'div',
	          { className: 'awardsSection' },
	          _react2.default.createElement(
	            'div',
	            { className: 'awardsSubtitle' },
	            'Awards and Recognition'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'awardsLogos' },
	            this.state.store.awards.map(function (sponsorship, i) {
	              var sponsorSrc = 'https://ddw2.diamondsdirect.com/img/store/awards/' + _this6.props.route.store_id + '/' + sponsorship.image;
	              return _react2.default.createElement(
	                'div',
	                { className: _this6.state.store.awards.length === 1 ? 'awardLogo single' : 'awardLogo', key: i },
	                _react2.default.createElement('img', { src: sponsorSrc, alt: sponsorship.name })
	              );
	            })
	          )
	        ) : null,
	        _react2.default.createElement(
	          _AntiModal2.default,
	          {
	            open: this.state.openModal,
	            closeMethod: this.closeTeamModal.bind(this),
	            resize: this.props.common.modalResize,
	            theme: 'teamBio' },
	          _react2.default.createElement(_TeamModal.TeamModalContainer, {
	            member: this.state.selectedMember,
	            location: this.state.store,
	            store_id: this.props.route.store_id,
	            closeMethod: this.closeTeamModal.bind(this),
	            modalOpen: this.state.openModal })
	        ),
	        _react2.default.createElement(
	          _AntiModal2.default,
	          {
	            open: this.state.openHoursModal,
	            closeMethod: this.closeHoursModal.bind(this),
	            resize: this.props.common.modalResize },
	          _react2.default.createElement(
	            'div',
	            { className: 'hoursModalWrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hmImage' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/hours_dec.jpg', alt: 'Holiday Hours' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'hmAction' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'actionButton', onClick: this.closeHoursModal.bind(this) },
	                'Close'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Store;
	}(_react2.default.Component);
	
	Store.propTypes = {
	  location: _react.PropTypes.object
	};
	Store.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Store;
	
	
	function mapStateToProps(state) {
	  return {
	    common: state.common
	  };
	}
	
	var StoreContainer = exports.StoreContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Store);

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.WatchContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactMailto = __webpack_require__(142);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	var _reactScrollToComponent = __webpack_require__(36);
	
	var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);
	
	var _reactSlick = __webpack_require__(39);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _AntiModal = __webpack_require__(119);
	
	var _AntiModal2 = _interopRequireDefault(_AntiModal);
	
	var _TeamModal = __webpack_require__(319);
	
	var _itemValidation = __webpack_require__(17);
	
	var _formatting = __webpack_require__(21);
	
	var _stores = __webpack_require__(321);
	
	var stores = _interopRequireWildcard(_stores);
	
	var _common = __webpack_require__(13);
	
	var commonActionCreators = _interopRequireWildcard(_common);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allActionCreators = Object.assign({}, commonActionCreators);
	
	var Watch = function (_React$Component) {
		_inherits(Watch, _React$Component);
	
		function Watch(props) {
			_classCallCheck(this, Watch);
	
			var _this = _possibleConstructorReturn(this, (Watch.__proto__ || Object.getPrototypeOf(Watch)).call(this, props));
	
			var initSlickSettings = {
				dots: true,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 3000,
				centerMode: true,
				infinite: true,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true
			};
	
			_this.state = {
				store: stores.ALL[_this.props.route.store_id],
				activePromo: false,
				holidayHours: false,
				hoursNotice: false,
				biosOpen: false,
				openModal: false,
				selectedMember: null,
				slickSettings: initSlickSettings,
	
				contactName: '',
				contactEmail: '',
				contactSubject: '',
				contactMessage: '',
	
				errorContactName: false,
				errorContactEmail: false,
				errorContactSubject: false,
				errorContactMessage: false
			};
			return _this;
		}
	
		_createClass(Watch, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				document.title = this.state.store.title;
				document.getElementsByTagName("META")[7].content = this.state.store.description;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				// setTimeout(() => {
				// 	this.props.commonNotify();
				// }, 1000);
			}
		}, {
			key: 'scrollDown',
			value: function scrollDown() {
				(0, _reactScrollToComponent2.default)(this.biosSection, {
					offset: 0,
					align: 'middle',
					duration: 1000,
					ease: 'inOutCube'
				});
			}
		}, {
			key: 'facebookNav',
			value: function facebookNav() {
				var win = window.open(this.state.store.facebookUrl, '_blank');
				win.focus();
			}
		}, {
			key: 'instagramNav',
			value: function instagramNav() {
				var win = window.open(this.state.store.instagramUrl, '_blank');
				win.focus();
			}
		}, {
			key: 'userNav',
			value: function userNav(page) {
				// this.context.router.push('/' + page);
				window.location.href = '/' + page;
			}
		}, {
			key: 'fetchHours',
			value: function fetchHours() {
				return this.state.holidayHours ? this.state.store.hours.holiday : this.state.store.hours.default;
			}
		}, {
			key: 'toggleBios',
			value: function toggleBios() {
				this.setState({
					biosOpen: !this.state.biosOpen
				});
			}
		}, {
			key: 'bestsellerImg',
			value: function bestsellerImg(img) {
				return { backgroundImage: 'url(/img/store/watch/bestsellers/' + img + ')' };
			}
		}, {
			key: 'openContactModal',
			value: function openContactModal(member) {
				this.setState({
					openModal: true
				});
			}
		}, {
			key: 'closeContactModal',
			value: function closeContactModal() {
				this.setState({
					openModal: false
				});
			}
		}, {
			key: 'scrollTop',
			value: function scrollTop() {
				(0, _reactScrollToComponent2.default)(this.topSection, {
					offset: 0,
					align: 'middle',
					duration: 1000,
					ease: 'inOutCube'
				});
			}
		}, {
			key: 'scrollBest',
			value: function scrollBest() {
				(0, _reactScrollToComponent2.default)(this.bestSection, {
					offset: 0,
					align: 'middle',
					duration: 1000,
					ease: 'inOutCube'
				});
			}
		}, {
			key: 'scrollAbout',
			value: function scrollAbout() {
				(0, _reactScrollToComponent2.default)(this.aboutSection, {
					offset: 0,
					align: 'middle',
					duration: 1000,
					ease: 'inOutCube'
				});
			}
		}, {
			key: 'scrollBrands',
			value: function scrollBrands() {
				(0, _reactScrollToComponent2.default)(this.designersSection, {
					offset: 0,
					align: 'middle',
					duration: 1000,
					ease: 'inOutCube'
				});
			}
		}, {
			key: 'scrollService',
			value: function scrollService() {
				(0, _reactScrollToComponent2.default)(this.serviceSection, {
					offset: 0,
					align: 'middle',
					duration: 1000,
					ease: 'inOutCube'
				});
			}
		}, {
			key: 'scrollContact',
			value: function scrollContact() {
				(0, _reactScrollToComponent2.default)(this.contactSection, {
					offset: 0,
					align: 'middle',
					duration: 1000,
					ease: 'inOutCube'
				});
			}
		}, {
			key: 'changeName',
			value: function changeName(evt) {
				var _this2 = this;
	
				this.setState({ contactName: evt.target.value }, function () {
					if (_this2.state.errorContactName && !(0, _itemValidation.nameValidation)(_this2.state.contactName)) {
						_this2.setState({ errorContactName: null });
					}
				});
			}
		}, {
			key: 'changeEmail',
			value: function changeEmail(evt) {
				var _this3 = this;
	
				this.setState({ contactEmail: evt.target.value }, function () {
					if (_this3.state.errorContactEmail && !(0, _itemValidation.emailValidation)(_this3.state.contactEmail)) {
						_this3.setState({ errorContactEmail: null });
					}
				});
			}
		}, {
			key: 'changeSubject',
			value: function changeSubject(evt) {
				var _this4 = this;
	
				this.setState({ contactSubject: evt.target.value }, function () {
					if (_this4.state.errorContactSubject && !(0, _itemValidation.locationValidation)(_this4.state.contactSubject)) {
						_this4.setState({ errorContactSubject: null });
					}
				});
			}
		}, {
			key: 'changeMessage',
			value: function changeMessage(evt) {
				var _this5 = this;
	
				this.setState({ contactMessage: evt.target.value }, function () {
					if (_this5.state.errorContactMessage && !(0, _itemValidation.messageTextValidation)(_this5.state.contactMessage)) {
						_this5.setState({ errorContactMessage: null });
					}
				});
			}
		}, {
			key: 'validateAll',
			value: function validateAll() {
	
				var nameError = (0, _itemValidation.nameValidation)(this.state.contactName) !== null;
				var emailError = (0, _itemValidation.emailValidation)(this.state.contactEmail) !== null;
				var subjectError = (0, _itemValidation.locationValidation)(this.state.contactSubject) !== null;
				var messageError = (0, _itemValidation.messageTextValidation)(this.state.contactMessage) !== null;
	
				this.setState({
					errorContactName: nameError,
					errorContactEmail: emailError,
					errorContactSubject: subjectError,
					errorContactMessage: messageError
				});
	
				return !nameError && !emailError && !subjectError && !messageError;
			}
		}, {
			key: 'contactRequest',
			value: function contactRequest() {
				var _this6 = this;
	
				if (this.validateAll()) {
	
					var watchData = {
						"full_name": this.state.contactName,
						"email": this.state.contactEmail,
						"subject": this.state.contactSubject,
						"message": this.state.contactMessage
					};
	
					this.props.commonWatchRequest(watchData);
					this.props.commonAlert('We have received your submission and will be in touch shortly.', 'Continue');
					this.closeContactModal();
					this.setState({
						contactName: '',
						contactEmail: '',
						contactSubject: '',
						contactMessage: '',
	
						errorContactName: false,
						errorContactEmail: false,
						errorContactSubject: false,
						errorContactMessage: false
					}, function () {
						console.log(_this6.state);
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'Watch' },
					_react2.default.createElement(
						'div',
						{ className: 'bannerSection', ref: function ref(div) {
								_this7.topSection = div;
							} },
						_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/hublot_header.jpg' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'infoSection watchInfo' },
						_react2.default.createElement(
							'div',
							{ className: 'tabbedNavigation' },
							_react2.default.createElement(
								'div',
								{ className: 'singleTab', onClick: this.scrollBest.bind(this) },
								'Best\xA0Sellers'
							),
							_react2.default.createElement(
								'div',
								{ className: 'singleTab', onClick: this.scrollAbout.bind(this) },
								'About Us'
							),
							_react2.default.createElement(
								'div',
								{ className: 'singleTab', onClick: this.scrollBrands.bind(this) },
								'Brands'
							),
							_react2.default.createElement(
								'div',
								{ className: 'singleTab', onClick: this.scrollService.bind(this) },
								'Service'
							),
							_react2.default.createElement(
								'div',
								{ className: 'singleTab', onClick: this.scrollContact.bind(this) },
								'Contact'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'infoTitle' },
							'Our Designer & Luxury Brand Watches'
						),
						_react2.default.createElement(
							'div',
							{ className: 'infoDescriptionWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'infoDescriptionP' },
								'Timepieces are one of the few items you wear on a daily basis, and it reflects your uniqueness. Here at Diamonds Direct, we offer a range of luxury watches that conform to your identity, personality, and lifestyle. No matter what you want to convey with your watch, our team will work with you to select the right luxury watch suited to your liking. Our watch styles range from classic, to sporty and rugged, and even ultra-modern and trendy. All of the watches we carry are meticulously chosen with form, function, luxury, and style in mind.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'infoRowWrapper locationHoursParent' },
							_react2.default.createElement(
								'div',
								{ className: 'infoRow locationHoursRow', style: { marginBottom: '15px' } },
								_react2.default.createElement(
									'div',
									{ className: 'locationWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'locationTitle' },
										'Location'
									),
									_react2.default.createElement(
										'div',
										{ className: 'locationBody' },
										_react2.default.createElement(
											'div',
											{ className: 'locationBodyRow' },
											this.state.store.address.line1
										),
										_react2.default.createElement(
											'div',
											{ className: 'locationBodyRow' },
											this.state.store.address.line2
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'hoursWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'hoursTitle' },
										'Hours'
									),
									_react2.default.createElement(
										'div',
										{ className: 'hoursBody' },
										_react2.default.createElement(
											'div',
											null,
											this.fetchHours().map(function (hour, i) {
												return _react2.default.createElement(
													'div',
													{ className: 'hoursBodyRow', key: i },
													hour.days,
													': ',
													hour.hours
												);
											})
										),
										_react2.default.createElement(
											'div',
											null,
											this.state.hoursNotice ? _react2.default.createElement(
												'div',
												{ className: 'hoursBodyRow hoursNotice' },
												this.state.store.hours.notice
											) : null
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'infoRow', style: { marginBottom: '50px' } },
								_react2.default.createElement(
									'div',
									{ className: 'phoneWrapper' },
									_react2.default.createElement(
										'a',
										{ href: 'tel:' + this.state.store.phone },
										_react2.default.createElement('div', { className: 'phoneIcon' }),
										_react2.default.createElement(
											'div',
											{ className: 'phoneValue' },
											(0, _formatting.displayPhone)(this.state.store.phone)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'emailWrapper' },
									_react2.default.createElement('div', { className: 'emailIcon' }),
									_react2.default.createElement(
										'div',
										{ className: 'emailValue' },
										_react2.default.createElement(
											_reactMailto2.default,
											{ email: this.state.store.email },
											this.state.store.email
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'bestsellerSection', ref: function ref(div) {
								_this7.bestSection = div;
							} },
						_react2.default.createElement(
							'div',
							{ className: 'bestTitle' },
							this.state.store.bestsellersNew.title
						),
						_react2.default.createElement(
							'div',
							{ className: 'bestItems' },
							_react2.default.createElement(
								'div',
								{ className: 'bestLHS' },
								_react2.default.createElement(
									'div',
									{ className: 'largeItemWrapper' },
									_react2.default.createElement('div', { className: 'largeImg', style: this.bestsellerImg(this.state.store.bestsellersNew.items.primary[0].image) }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											this.state.store.bestsellersNew.items.primary[0].title
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											this.state.store.bestsellersNew.items.primary[0].subtitle
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'bestRHS' },
								_react2.default.createElement(
									'div',
									{ className: 'itemGridWrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'smallItemRow' },
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper' },
											_react2.default.createElement('div', { className: 'smallImg', style: this.bestsellerImg(this.state.store.bestsellersNew.items.secondary[0].image) }),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													this.state.store.bestsellersNew.items.secondary[0].title
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													this.state.store.bestsellersNew.items.secondary[0].subtitle
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper' },
											_react2.default.createElement('div', { className: 'smallImg', style: this.bestsellerImg(this.state.store.bestsellersNew.items.secondary[1].image) }),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													this.state.store.bestsellersNew.items.secondary[1].title
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													this.state.store.bestsellersNew.items.secondary[1].subtitle
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'smallItemRow' },
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper' },
											_react2.default.createElement('div', { className: 'smallImg', style: this.bestsellerImg(this.state.store.bestsellersNew.items.secondary[2].image) }),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													this.state.store.bestsellersNew.items.secondary[2].title
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													this.state.store.bestsellersNew.items.secondary[2].subtitle
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'smallItemWrapper' },
											_react2.default.createElement('div', { className: 'smallImg', style: this.bestsellerImg(this.state.store.bestsellersNew.items.secondary[3].image) }),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabel' },
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelName' },
													this.state.store.bestsellersNew.items.secondary[3].title
												),
												_react2.default.createElement(
													'div',
													{ className: 'itemLabelPrice' },
													this.state.store.bestsellersNew.items.secondary[3].subtitle
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'bestMobile mobileOnly' },
								_react2.default.createElement(
									'div',
									{ className: 'mobileItemWrapper' },
									_react2.default.createElement('div', { className: 'mobileImg', style: this.bestsellerImg(this.state.store.bestsellersNew.items.primary[0].image) }),
									_react2.default.createElement(
										'div',
										{ className: 'itemLabel' },
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelName' },
											this.state.store.bestsellersNew.items.primary[0].title
										),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabelPrice' },
											this.state.store.bestsellersNew.items.primary[0].subtitle
										)
									)
								),
								this.state.store.bestsellersNew.items.secondary.map(function (item, i) {
									return _react2.default.createElement(
										'div',
										{ className: 'mobileItemWrapper', key: i },
										_react2.default.createElement('div', { className: 'mobileImg', style: _this7.bestsellerImg(item.image) }),
										_react2.default.createElement(
											'div',
											{ className: 'itemLabel' },
											_react2.default.createElement(
												'div',
												{ className: 'itemLabelName' },
												item.title
											),
											_react2.default.createElement(
												'div',
												{ className: 'itemLabelPrice' },
												item.subtitle
											)
										)
									);
								})
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'aboutSection', ref: function ref(div) {
								_this7.aboutSection = div;
							} },
						_react2.default.createElement(
							'div',
							{ className: 'infoTitle' },
							'About Us'
						),
						_react2.default.createElement(
							'div',
							{ className: 'infoDescriptionWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'infoDescriptionP' },
								'For 20 years, Diamonds Direct has provided the highest quality diamonds and jewelry to clients across the United States. But we were missing a crucial aspect of the business: a luxury timepiece boutique.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'infoDescriptionP' },
								'So, in 2014, we launched the Diamonds Direct Watch boutique. We didn\'t want to carry the same brands as anyone else in the area so we looked for brands typically sold in New York on Fifth Ave or on Rodeo Drive in California and brought them to Charlotte. Our team regularly travels to the heart of watchmaking - Switzerland - to hand select the finest timepieces at the best value.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'infoDescriptionP' },
								'Want to learn more about our watches? Stop by and see us. Our comfortable no-pressure environment features relaxing couches, fine cigars, sports on TV, and of course, high-quality watches.'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'designersSection', ref: function ref(div) {
								_this7.designersSection = div;
							} },
						_react2.default.createElement(
							'div',
							{ className: 'bestTitle' },
							'Our Brands'
						),
						_react2.default.createElement(
							'div',
							{ className: 'brandsWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/hublot_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/frankmuller_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/blancpain_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/zenith_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/lacroix_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/ernst_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/shorokhoff_logo.png' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/perrelet_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/bedat_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/giorgio_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/waldan_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/junghans_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/brm_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/alpina_logo.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'brandsElement' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/logos/graham_logo.png' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'serviceSection', ref: function ref(div) {
								_this7.serviceSection = div;
							} },
						_react2.default.createElement(
							'div',
							{ className: 'infoTitle' },
							'Service'
						),
						_react2.default.createElement(
							'div',
							{ className: 'infoDescriptionWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'infoDescriptionP' },
								'At the Diamonds Direct Watch Boutique, we pride ourselves on service. This doesn\'t just mean providing first class service when you purchase a new timepiece but also taking care of your existing watches. From batteries to vintage watch repair, our trained experts will guide you through the process flawlessly and will have your watches running like new. Feel free to call or stop by and ask any of our experts for an estimate or assistance.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'backTopWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'backTopLink', onClick: this.scrollTop.bind(this) },
								_react2.default.createElement(
									'div',
									{ className: 'backLabel' },
									'Back to Top'
								),
								_react2.default.createElement(
									'div',
									{ className: 'backArrow' },
									_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/store/watch/up_arrow.svg' })
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'contactSection', ref: function ref(div) {
								_this7.contactSection = div;
							} },
						_react2.default.createElement(
							'div',
							{ className: 'bestTitle' },
							'Contact'
						),
						_react2.default.createElement(
							'div',
							{ className: 'contactP' },
							'Have further questions? Need more information? Feel free to ',
							_react2.default.createElement(
								'span',
								{ className: 'contactLink', onClick: this.openContactModal.bind(this) },
								'contact us!'
							)
						)
					),
					_react2.default.createElement(
						_AntiModal2.default,
						{
							open: this.state.openModal,
							closeMethod: this.closeContactModal.bind(this),
							resize: this.props.common.modalResize,
							theme: 'teamBio' },
						_react2.default.createElement(
							'div',
							{ className: 'contactModalWrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'closeIcon', onClick: this.closeContactModal.bind(this) },
								_react2.default.createElement(
									'div',
									{ className: 'closeX' },
									'\xD7'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'requestTitle' },
								'Contact Us'
							),
							_react2.default.createElement(
								'div',
								{ className: 'requestBr' },
								_react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/icons/lines/iconline_thin.svg' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'watchFormWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'inputWrapper halfWidth' },
									_react2.default.createElement(
										'div',
										{ className: 'inputLabel' },
										'Your Name*:'
									),
									_react2.default.createElement('input', {
										className: this.state.errorContactName ? 'inputError' : 'inputNoError',
										value: this.state.contactName,
										onChange: this.changeName.bind(this),
										type: 'text' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'inputWrapper halfWidth secondInput' },
									_react2.default.createElement(
										'div',
										{ className: 'inputLabel' },
										'Email*:'
									),
									_react2.default.createElement('input', {
										className: this.state.errorContactEmail ? 'inputError' : 'inputNoError',
										value: this.state.contactEmail,
										onChange: this.changeEmail.bind(this),
										type: 'email' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'inputWrapper fullWidth' },
									_react2.default.createElement(
										'div',
										{ className: 'inputLabel' },
										'Subject*:'
									),
									_react2.default.createElement('input', {
										className: this.state.errorContactSubject ? 'inputError' : 'inputNoError',
										value: this.state.contactSubject,
										onChange: this.changeSubject.bind(this),
										type: 'text' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'inputWrapper fullWidth' },
									_react2.default.createElement(
										'div',
										{ className: 'inputLabel' },
										'How can we help you?*:'
									),
									_react2.default.createElement('textarea', {
										className: this.state.errorContactMessage ? 'inputError' : 'inputNoError',
										value: this.state.contactMessage,
										onChange: this.changeMessage.bind(this) })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'submitWrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'submitButton actionButton', onClick: this.contactRequest.bind(this) },
									'Contact Us'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Watch;
	}(_react2.default.Component);
	
	Watch.propTypes = {
		location: _react.PropTypes.object
	};
	Watch.contextTypes = {
		store: _react.PropTypes.any,
		router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Watch;
	
	
	function mapStateToProps(state) {
		return {
			common: state.common
		};
	}
	
	var WatchContainer = exports.WatchContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Watch);

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WarrantiesContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as commonActionCreators from '../../../actions/common';
	var allActionCreators = Object.assign({});
	
	var Warranties = function (_React$Component) {
	  _inherits(Warranties, _React$Component);
	
	  function Warranties(props) {
	    _classCallCheck(this, Warranties);
	
	    var _this = _possibleConstructorReturn(this, (Warranties.__proto__ || Object.getPrototypeOf(Warranties)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Warranties, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = 'Diamonds Direct - Warranties and Guarantees';
	      document.getElementsByTagName("META")[7].content = "Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	    }
	  }, {
	    key: 'newTabNav',
	    value: function newTabNav(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'externalNav',
	    value: function externalNav(page) {
	      window.location.href = '/' + page;
	    }
	  }, {
	    key: 'internalNav',
	    value: function internalNav(page) {
	      this.context.router.push('/' + page);
	    }
	  }, {
	    key: 'openIntercom',
	    value: function openIntercom() {
	      acquireIO.max();
	    }
	  }, {
	    key: 'openNew',
	    value: function openNew(page) {
	      var win = window.open(page, '_blank');
	      win.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Warranties' },
	        _react2.default.createElement(
	          'div',
	          { className: 'warPageTitle' },
	          'Warranties & Guarantees'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'warBlockWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'warBlock' },
	            _react2.default.createElement(
	              'div',
	              { className: 'warIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/warranties/direct_diamond.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warTitle' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'DIRECT DIAMOND IMPORTER'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warBody' },
	              'Diamonds Direct is proud to be America\'s leading direct diamond importer. We have the advantage of being able to pick the best quality diamonds the cutters have to offer. Direct diamond importers can offer lower prices than other jewelry stores because we buy from the original supplier and there is no middleman markup. We can offer a richer selection of diamonds and shapes that may be harder to find at your local jeweler.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'warBlock' },
	            _react2.default.createElement(
	              'div',
	              { className: 'warIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/warranties/personalised_education.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warTitle' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'PERSONALIZED EDUCATION'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warBody' },
	              'We understand choosing the right diamond is a huge decision, and our diamond experts provide an educational experience that is second to none. Every Diamonds Direct customer receives a personalized diamond education, providing each of our customers the tools and resources needed to select the right diamond for their specifications and budget.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'warBlock' },
	            _react2.default.createElement(
	              'div',
	              { className: 'warIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/warranties/money.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warTitle' },
	              _react2.default.createElement(
	                'div',
	                null,
	                '30 DAY MONEY BACK GUARANTEE'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warBody' },
	              'If for any reason, you are not satisfied with the purchase of your diamond, return your purchase within 30 days for a full refund. If a special order was manufactured and/or delivered- restocking fees and restrictions may apply, as we are unable to restock jewelry items that are uniquely created or previously worn. Satisfaction is our goal, and we will work on an individual basis with each customer to develop solutions for returned orders.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'warBlock' },
	            _react2.default.createElement(
	              'div',
	              { className: 'warIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/warranties/complementary.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warTitle' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'COMPLIMENTARY SERVICES, AFTER THE SALE'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warBody' },
	              'Diamonds Direct delivers the highest level of customer service, even after the sale. We offer unrivaled complimentary services, including complimentary jewelry maintenance, complimentary cleaning, complimentary sizing, complimentary appraisal for insurance purposes and complimentary lifetime upgrade on engagement.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'warBlock' },
	            _react2.default.createElement(
	              'div',
	              { className: 'warIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/warranties/liftime_warrenty.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warTitle' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'LIFETIME WARRANTY'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warBody' },
	              'The lifetime warranty covers all the services for cleaning and tightening, as well as the loss of side diamonds, assuming the loss was not caused by damage. However, even with the warranty, it\u2019s critical to have your jewelry insured in the event of loss, damage or theft. We recommend ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://lavalier.com/', target: '_blank' },
	                'Lavalier insurance'
	              ),
	              '.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'warBlock' },
	            _react2.default.createElement(
	              'div',
	              { className: 'warIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/warranties/lifetime_upgrade.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warTitle' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'LIFETIME UPGRADE'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warBody' },
	              'Diamonds Direct\u2019s lifetime upgrade allows customers to trade their original engagement diamond, solitaire diamond pendant, and diamond studs for a different size, quality or shape. Think of it as a diamond savings account - you can come in as often as desired to trade in the original diamond and you\u2019re only required to pay the difference between the two diamonds. It\u2019s easy, you get 110% of your original purchase toward your new purchase. Our upgrade policy applies one year after your original purchase and is applicable to natural diamonds only.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'warBlock' },
	            _react2.default.createElement(
	              'div',
	              { className: 'warIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/warranties/risk_free.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warTitle' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'RISK-FREE SHOPPING ENVIRONMENT'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warBody' },
	              'Diamonds Direct offers a risk-free shopping environment, supported by our 30-Day money back guarantee, on the purchase of a diamond. If within 30 days of your purchase you find a lower price on a diamond with the same quality and specifications anywhere in the United States that is certified by the same laboratory, Diamonds Direct will match the price, terms and conditions. These warranties ensure you get the right diamond at the guaranteed lowest price in the country.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'warBlock' },
	            _react2.default.createElement(
	              'div',
	              { className: 'warIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/warranties/free_delivery.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warTitle' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'FREE DELIVERY'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warBody' },
	              'Diamonds Direct offers fast, free shipping on all orders placed online, regardless of amount. International customers will be responsible for any duties, VAT, taxes or surcharges levied by their country. Please check with your local authorities to confirm taxes and fees before ordering. Orders for military personnel located overseas will be shipped for free to their APO/FOP. Please keep in mind that these locations are served by the US Post Office and may take up to three weeks to deliver.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'warBlock' },
	            _react2.default.createElement(
	              'div',
	              { className: 'warIcon' },
	              _react2.default.createElement('img', { src: 'https://ddw2.diamondsdirect.com/img/warranties/financial_option.png' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warTitle' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'FINANCING OPTIONS'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'warBody' },
	              'Diamonds Direct offers special financing options with approved credit through Wells Fargo Bank, N.A. to help you purchase the jewelry of your dreams. Learn more about the best special financing option for you and ',
	              _react2.default.createElement(
	                'a',
	                { href: '/financing' },
	                'apply here'
	              ),
	              '.'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Warranties;
	}(_react2.default.Component);
	
	Warranties.propTypes = {
	  location: _react.PropTypes.object
	};
	Warranties.contextTypes = {
	  store: _react.PropTypes.any,
	  router: _react2.default.PropTypes.object.isRequired
	};
	exports.default = Warranties;
	
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var WarrantiesContainer = exports.WarrantiesContainer = (0, _reactRedux.connect)(mapStateToProps, allActionCreators)(Warranties);

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var locations = exports.locations = [{
	  display: 'Austin, TX',
	  value: 'atx'
	}, {
	  display: 'Birmingham, AL',
	  value: 'bhm'
	}, {
	  display: 'Boca Raton, FL',
	  value: 'boc'
	}, {
	  display: 'Charleston, SC',
	  value: 'chs'
	}, {
	  display: 'Charlotte, NC',
	  value: 'clt'
	}, {
	  display: 'Cleveland, OH',
	  value: 'cle'
	}, {
	  display: 'Columbus, OH',
	  value: 'coh'
	}, {
	  display: 'Dallas, TX',
	  value: 'dfw'
	}, {
	  display: 'Frisco, TX',
	  value: 'ftx'
	}, {
	  display: 'Greenville, SC',
	  value: 'gsc'
	}, {
	  display: 'Houston, TX',
	  value: 'hou'
	}, {
	  display: 'Indianapolis, IN',
	  value: 'ind'
	}, {
	  display: 'Jacksonville, FL',
	  value: 'jax'
	}, {
	  display: 'Kansas City, KS',
	  value: 'kcy'
	}, {
	  display: 'New Orleans, LA',
	  value: 'nol'
	}, {
	  display: 'Oklahoma City, OK',
	  value: 'okc'
	}, {
	  display: 'Pittsburgh, PA',
	  value: 'pit'
	}, {
	  display: 'Raleigh, NC',
	  value: 'ral'
	}, {
	  display: 'Richmond, VA',
	  value: 'rva'
	}, {
	  display: 'St. Louis, MO',
	  value: 'stl'
	}, {
	  display: 'San Antonio, TX',
	  value: 'san'
	}, {
	  display: 'Tysons, VA',
	  value: 'nva'
	}, {
	  display: 'Virginia Beach, VA',
	  value: 'vab'
	}];

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var template = {
		template: 'designer',
		name: '',
		titleName: '',
		displayName: '',
		shopLink: '',
		logoImg: '',
		description: ['', '', '']
	};
	
	var ajaffe = {
		template: 'designer',
		name: 'A.JAFFE',
		titleName: 'A. Jaffe Designer',
		displayName: 'A.JAFFE',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=ajaffe',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=ajaffe' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=ajaffe' }],
		description: ['Passion and devotion are the cornerstones to any good relationship. They are also the signature qualities of A.JAFFE engagement bands and wedding rings. For over 100 years, A. JAFFE has been steadfast in the commitment to honor love in a way that is as lasting as it is beautiful. All bands are painstakingly forged from platinum or gold that is nickel free and ensconced in palladium to ensure that like your love, our rings are strong and will never fade, dull or fracture. A.JAFFE celebrates the rare beauty of your relationship with handpicked diamonds selected by experienced master jewelers guaranteeing utmost comfort. Individually hewn prongs, ergonomic squared shank and secure setting, in addition to six polishing stages, safe-guard against potential spinning and snags on clothing.', 'Make a one of a kind ring for your loved one. Make a ring as unique as your story. A.JAFFE doesn’t just welcome customization, we encourage it. Choose from a variety of precious metals and diamonds that capture not only who you are as a couple, but also the uniqueness of the love you possess. Commemorate the unforgettable moment your beloved caught your eye with an eye catching engagement ring or wedding band customized by an A. JAFFE master craftsman. A.Jaffe creates more than just rings. A.Jaffe upholds tradition. Let us be a part of yours.']
	};
	
	var artcarved = {
		template: 'designer',
		name: 'Art Carved',
		titleName: 'ArtCarved Designer',
		displayName: 'Art Carved',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=artcarved',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=artcarved' }, { name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=artcarved' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=artcarved' }],
		description: ['ArtCarved beams with pride for having the ability to handcraft the highest quality, graceful and timeless engagement rings and wedding bands. ArtCarved believes in finding the one. Like your love story, ArtCarved rings are one-of-a-kind. Exquisitely crafted and thoughtfully designed, ArtCarved is the ultimate expression of devotion that sparkles with joy. Made with happiness, passion and love since 1850.']
	};
	
	var cgonshor = {
		template: 'designer',
		name: 'C. Gonshor',
		titleName: 'C. Gonshor',
		displayName: 'C. Gonshor',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=cgonshor',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=cgonshor' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=cgonshor' }],
		logoImg: 'gonshor.svg',
		description: ['C. Gonshor has become synonymous with highly evolved style and quality. While there are many avenues to choose from, what sets C. Gonshor apart and what will ultimately affects our relationship, is the finished piece you receive from us.', 'Every C. Gonshor engagement ring and wedding band is created by highly skilled craftsmen who are proud of and accomplished by their work.']
	};
	
	var christianbauer = {
		template: 'designer',
		name: 'Christian Bauer',
		titleName: 'Christian Bauer',
		displayName: 'Christian Bauer',
		shopLink: 'gallery/wedding-bands/mens?designers=christianbauer',
		logoImg: 'bauer.svg',
		description: ['Christian Bauer is a German company specializing in the construction of wedding rings. The brand offers an attractive wedding band collection made of high quality resources like gold and platinum, as well as handpicked diamonds and gems. Every Christian Bauer wedding ring is unique and crafted with high precision and innovation.']
	};
	
	var christopherdesigns = {
		template: 'designer',
		name: 'Christopher Designs',
		titleName: 'Christopher Designs',
		displayName: 'Christopher Designs',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=christopherdesigns',
		logoImg: 'christopher.svg',
		description: ['Christopher Slowinski founded Christopher Designs in 1981 after he apprenticed under master jewelry craftsmen in his native country of Poland and once he moved to the United States.', 'Today, he combines his classic training with modern technology to create exclusive engagement ring and wedding band designs that include his patented Crisscut® diamonds. The original Crisscut® was launched with great fanfare: the arrangement of the 77 “crisscrossed” facets redefined just how brilliant a diamond could be. Choosing a Christopher Designs engagement ring or wedding band truly brings your love to life.']
	};
	
	var coast = {
		template: 'designer',
		name: 'Coast',
		titleName: 'Coast Designer',
		displayName: 'Coast',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=coast',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=coast' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=coast' }],
		description: ['Elegant design and excellent quality. Since 1978, Coast has designed traditional and romantic engagement rings and wedding bands to the highest standards imaginable. Coast continuously introduces beautiful designs that are both graceful and stylish – the hardest of feats to accomplish.']
	};
	
	var fana = {
		template: 'designer',
		name: 'Fana',
		titleName: 'Fana Designer',
		displayName: 'Fana',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=fana',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=fana' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=fana' }, { name: "Fashion", url: 'gallery/fine-jewelry?designer=fana' }],
		description: ['The designers at Fana strive to capture elegance and style in their creations, handcrafting remarkably detailed rings and fine jewelry pieces. Fana takes pride in their extra attention to detail, personal craftsmanship, and the stunning beauty of their designs, offering a wide selection of fine jewelry designed and crafted with the finest diamonds and precious stones.']
	};
	
	var furrerjacot = {
		template: 'designer',
		name: 'Furrer Jacot',
		titleName: 'Furrer Jacot',
		displayName: 'Furrer Jacot',
		shopLink: 'gallery/wedding-bands/mens?designers=furrerjacot',
		description: ['Since 1858, Swiss manufacturer Furrer Jacot has built a strong market position worldwide by embracing individuality, authenticity, creativity, and a high degree of exclusivity. Furrer Jacot has become a leader in creating diamond rings, carbon fiber rings, and wedding bands, and their designs bear the label of the highest quality for rings with a lifetime warranty.']
	};
	
	var gottlieb = {
		template: 'designer',
		name: 'Gottlieb',
		titleName: 'Gottlieb & Sons',
		displayName: 'Gottlieb',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=gattlieb',
		logoImg: 'gottlieb.png',
		logoStyle: {
			top: '10%',
			height: '80%'
		},
		description: ['Gottlieb & Sons has become a trailblazer in the jewelry industry. With the one goal of creating engagement rings and wedding bands that reflect the highest of standards. Gottlieb & Sons engagement rings and wedding bands are fashion forward, upscale, and uniquely distinctive. The brand fits a lifestyle driven, sophisticated customer with a keen eye for luxury.']
	};
	
	var henridaussi = {
		template: 'designer',
		name: 'Henri Daussi',
		titleName: 'Henri Daussi',
		displayName: 'Henri Daussi',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=henridaussi',
		logoImg: 'daussi.svg',
		description: ['Henri Daussi is an example of expertise and passion for diamonds passed on over many generations. Cutting the world’s most brilliant diamonds and creating only the finest engagement rings and wedding bands has forever been a Loots family tradition. Henri Daussi is humbled and honored to provide the same excellence in craftsmanship and design set forth by founder, Henri Daussi Loots. We ensure every Henri Daussi engagement ring and wedding band will be a part of your family for years to come.']
	};
	
	var jackkelege = {
		template: 'designer',
		name: 'Jack Kelége',
		titleName: 'Jack Kelége',
		displayName: 'Jack Kelége',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=jackkelege',
		logoImg: 'kelege.svg',
		description: ['Headquartered in Los Angeles, Jack Kelége & Co. employs some of the world’s most elite jewelers in the world; all of whom were hand-picked and mentored by Jack Kelége himself. In this day and age, it is extraordinarily rare to find so many astonishing individuals in one place.', 'Jack Kelége is distinctive in that he is both designer and manufacturer of his own engagement ring and wedding band collections. Jack’s attention to each individual engagement ring and wedding band is what makes his jewelry “heirlooms in the making.” Jack & Co. frequently work for months on a single design to guarantee that their clients receive nothing short of perfection.']
	};
	
	var jeffcooper = {
		template: 'designer',
		name: 'Jeff Cooper',
		titleName: 'Jeff Cooper',
		displayName: 'Jeff Cooper',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=jeffcooper',
		description: ['Jeff Cooper engagement rings and wedding bands are crafted one at a time, by hand, and are rigorously inspected by founder Jeff Cooper to ensure that each one reflects its wearer and the memories it symbolizes. Jeff’s designs radiate with clean lines, elegance and a focus on classics that honor his design philosophy of refined simplicity.']
	};
	
	var kirkkara = {
		template: 'designer',
		name: 'Kirk Kara',
		titleName: 'Kirk Kara Designer',
		displayName: 'Kirk Kara',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=kirkkara',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=kirkkara' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=kirkkara' }],
		description: ['You’re on this journey to find The One: a diamond engagement ring that will leave you breathless. With every Kirk Kara engagement ring and wedding band, mesmerizing details are designed to evoke love at first sight. Fall madly in love with a Kirk Kara engagement ring or wedding band and see why they are ‘Forever Captivating’. Every piece is crafted delicately by hand so no two are identical. This means the Kirk Kara engagement ring or wedding band that slides onto your finger - is truly one of a kind.']
	};
	
	var mastoloni = {
		template: 'designer',
		name: 'Mastoloni',
		titleName: 'Mastoloni Designer',
		displayName: 'Mastoloni',
		shopLink: 'gallery/fine-jewelry?designer=mastoloni',
		description: ['Mastoloni cultured pearl jewelry and necklaces have decorated ladies for over a century. Today, at the height of the cultured pearl industry, Mastoloni is proud to be one of the oldest sources in North America. Celebrated for meticulous design and craftsmanship, the name Mastoloni has become synonymous with pure beauty.']
	};
	
	var michaelm = {
		template: 'designer',
		name: 'Michael M',
		titleName: 'Michael M Designer',
		displayName: 'Michael M',
		shopLink: 'gallery/engagement-rings?mode=setting&designer=michaelm',
		logoImg: 'michaelm2.svg',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=michaelm' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=michaelm' }],
		description: ['Founded by the Meksian family and based in Los Angeles, Michael M designs reflect modern elegance and classic beauty. Artfully designed and masterfully handcrafted, every Michael M engagement ring and bridal set is customized to reflect your unique love story.']
	};
	
	var novell = {
		template: 'designer',
		name: 'Novell',
		titleName: 'Novell Designer',
		displayName: 'Novell',
		shopLink: 'gallery/engagement-rings?mode=setting&designer=novel',
		links: [
		// {name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=novel'},
		{ name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=novel' }, { name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=novel' }],
		description: ['Based in New Jersey, Novell Design Studio offers a beautiful, customized range of bridal jewelry designs proudly Made in America for more than 30 years.']
	};
	
	var pejay = {
		template: 'designer',
		name: 'PeJay',
		titleName: 'PeJay Creations',
		displayName: 'PeJay',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=pejay',
		links: [
		// {name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=pejay'},
		// {name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=pejay'},
		// {name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=pejay'},
		{ name: "Fashion", url: 'gallery/fine-jewelry?designer=pejay' }],
		logoImg: 'pejay.svg',
		description: ['Pe Jay Creations, a 60+ year-old family-owned and operated company, prides itself on its designs, quality of production, and, most of all, its attention to detail. Pe Jay offers a full line of women\'s diamond jewelry, including an extensive assortment of fashion jewelry in a variety of textures and colors. In addition, Pe Jay’s offers complete customization to create one-of-a-kind pieces based on your unique needs and desires.']
	};
	
	var ses = {
		template: 'designer',
		name: 'SES',
		titleName: 'SES Creations',
		displayName: 'SES',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=ses',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=ses' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=ses' }, { name: "Fashion", url: 'gallery/fine-jewelry?designer=ses' }],
		description: ['SES Creations is one of the country’s leading designers and manufacturers of bridal, diamond, and precious stone jewelry. Located in New York City, SES Creations takes pride in their wide selection of beautifully-crafted jewelry, including diamond and precious stone rings, earrings, pendants, necklaces, and bracelets, which are available in platinum, 18k and 14k white, yellow or rose gold.']
	};
	
	var simong = {
		template: 'designer',
		name: 'Simon G.',
		titleName: 'Simon G Designer',
		displayName: 'Simon G.',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=simong',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=simong' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=simong' }, { name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=simong' }, { name: "Fashion", url: 'gallery/fine-jewelry?designer=simong' }],
		description: ['Elegance, craftsmanship, functionality and affordability are the foundational pillars of the highly desirable and sought after Simon G. engagement rings and wedding bands. Offered in over 7 dozen style combinations, there is a Simon G. for everyone. With over 30 years’ experience, honing finely crafted jewelry making skills, Simon G. has been lauded as one of the most popular and requested names in the industry, specializing in well-known and memorable designs for both men and women.', 'Unique to his vast and enviable collection of engagement rings and wedding bands is the forward thinking and innovative “double band” concept. Glimpsed on the fingers of even celebrities, this award-winning and intelligent double band configuration combines both wedding and engagement rings with a locking mechanism that keeps the rings together and free from spinning and snagging; making Simon G. engagement rings and wedding bands as comfortable as they are eye-catching.', 'Some of the more beloved styles include Simon G. TR, LP, NR, LG, MR and Caviar collections. Using only the highest-quality precious metals such as white gold, yellow gold and platinum, in addition to delicately harvested precious carat diamonds available in round, princess, and marquis cuts, Simon G. engagement rings and wedding bands are sure to be more than your next trend; they will become the next family legacy.']
	};
	
	var sylvie = {
		template: 'designer',
		name: 'Sylvie',
		titleName: 'Sylvie Collection',
		displayName: 'Sylvie',
		shopLink: 'gallery/engagement-rings?mode=setting&designer=sylvie',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=sylvie' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=sylvie' }],
		logoStyle: {
			maxWidth: '60%'
		},
		description: ['The splendor and passion Sylvie sees around the world is reflected in each one of her engagement ring designs. Sylvie truly believes that by building relationships you will find real joy and passion in life. Throughout Sylvie’s bridal and engagement ring collections, you will find a new standard for attainable luxury and the highest example of expertise.']
	};
	
	var tacori = {
		template: 'designer',
		name: 'Tacori',
		titleName: 'Tacori Designer',
		displayName: 'Tacori',
		shopLink: 'gallery/engagement-rings?mode=setting&designer=tacori',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=tacori' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=tacori' }, { name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=tacori' }, { name: "Fashion", url: 'gallery/fine-jewelry?designer=tacorif' }],
		description: ['Beneath the California sun\'s warm glow, Tacori creates the most intricately crafted artisan jewelry in the world. Each Tacori engagement ring, wedding band, or fashion piece echoes the passion the Tacori family has for creating gorgeous heirlooms to be cherished for generations.  When you wear Tacori, your treasured piece will become a part of the tangible memories that become your legacy.']
	};
	
	var trueromance = {
		template: 'designer',
		name: 'True Romance',
		titleName: 'True Romance',
		displayName: 'True Romance',
		shopLink: 'gallery/wedding-bands/mens?designers=trueromanace',
		links: [{ name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=trueromanace' }, { name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=trueromanace' }],
		logoImg: 'trueromance.png',
		logoStyle: {
			top: '30%',
			width: '80%',
			height: 'auto'
		},
		description: ['True Romance was founded in New York City in 1984 and remains devoted to the vision of creating a line of classic, luxury diamond engagement rings. True Romance’s design team works with great skill to ensure that each piece maximizes the brilliance of the diamonds. Their graceful designs are crafted with clean, classic lines for exceptional beauty and brilliance.']
	};
	
	var verragio = {
		template: 'designer',
		name: 'Verragio',
		titleName: 'Verragio Designer',
		displayName: 'Verragio',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=verragio',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=verragio' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=verragio' }, { name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=verragio' }],
		description: ['"A beautiful mounting should only enhance the beauty of a diamond in the same way a beautiful dress makes a woman even more beautiful." As said by Barry Verragio, this simple and honest philosophy is reflected in all Verragio engagement rings and wedding bands. With over 20 years experience as a designer of fine jewelry, Verragio has learned the value of craftsmanship and dedication to quality, breathtaking, handcrafted engagement rings and wedding bands.']
	};
	
	var amden = {
		template: 'designer',
		name: 'Amden',
		titleName: 'Amden Designer',
		displayName: 'Amden',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=amden',
		links: [
		// {name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=amden'},
		{ name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=amden' },
		// {name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=amden'},
		{ name: "Fashion", url: 'gallery/fine-jewelry?designer=amden' }],
		logoImg: 'amden.png',
		logoStyle: {
			top: '10%',
			height: '80%'
		},
		description: ['Amden Jewelry crafts an all-embracing collection of fashion and bridal rings, pendants, earrings, bracelets and necklaces that are made to be loved forever. Amden, whose reputation rests on professionalism, honors special requests, keeping a detailed eye on every facet of production to ensure the highest quality in their beautiful finished pieces.']
	};
	
	var uneek = {
		template: 'designer',
		name: 'Uneek',
		titleName: 'Uneek Designer',
		displayName: 'Uneek',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=uneek',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=uneek' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=uneek' }, { name: "Fashion", url: 'gallery/fine-jewelry?designer=uneek' }],
		description: ['Uneek\'s unerring eye for the finest quality diamonds and exceptional commitment to quality craftsmanship shine through the most in their award-winning bridal and engagement ring styles. Recognizing that these are the most meaningful pieces of jewelry that a woman will ever wear, and at the same time taking into consideration that today\'s brides are as diverse as they are savvy, Benjamin Javaheri has whipped up a number of bridal collections, each with its own distinctive character and unique styling aspect, to cater to every bride imaginable. Each and every piece in these collections are beautiful works of art, handcrafted in a process that is propelled by technological advancements in fine jewelry making and dictated by centuries-old metalsmithing disciplines, resulting in heirloom-worthy pieces that will last for generations to come.', 'When you choose Uneek, you are assured of excellence and complete satisfaction with every aspect. Uneek\'s uncompromising dedication to providing only the best quality, the finest workmanship, and true personal service is their promise to Diamonds Direct customers. Also, all Uneek pieces are proudly designed and handcrafted in Los Angeles, CA, so when you choose a Uneek piece, not only are you guaranteed of topnotch quality, you are stamping your support for American artisanship, as well, and contributing to the commitment of keeping the craft alive here in our home.']
	};
	
	var odelia = {
		template: 'designer',
		name: 'Odelia',
		titleName: 'Odelia Designer',
		displayName: 'Odelia',
		shopLink: 'gallery/fine-jewelry?designer=odelia',
		logoImg: 'odelia2.png',
		logoStyle: {
			top: '10%',
			height: '80%'
		},
		description: ['Over two decades ago in the heart of Manhattan, a family began their journey as purveyors of fine jewelry. With a cemented reputation and driven by their desire to provide a stunning line of affordable diamond jewelry, they set out to become designers and manufacturers, and the Odelia brand was born. Odelia is known for their stunning collection of fashion jewelry that is perfect for any occasion.']
	};
	
	// const gabriel = {
	// 	template: 'designer',
	// 	name: 'Gabriel',
	// 	titleName: 'Gabriel Designer',
	// 	displayName: 'Gabriel',
	// 	// shopLink: 'gallery/engagement-rings?mode=setting&designer=gabrielco',
	// 	links: [
	// 		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=gabrielco'},
	// 		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=gabrielco'},
	// 		// {name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=gabrielco'},
	// 		{name: "Fashion", url: 'gallery/fine-jewelry?designer=gabrielco'},
	// 	],
	// 	description: [
	// 		'Gabriel & Co. celebrates life and love through the art & science of fine jewelry. Over the past 30 years, Gabriel & Co. has earned the reputation as being passionate, dependable, and artistic designers, creators and manufacturers. Our extensive line of timeless pieces encompasses classic and fashion-forward design, ultimately bringing together impeccable artistry with enduring technology, perfect for every unforgettable moment.',
	// 	],
	// };
	
	var classique = {
		template: 'designer',
		name: 'Classique Creations',
		titleName: 'Classique Creations',
		displayName: 'Classique Creations',
		shopLink: 'gallery/engagement-rings?mode=setting&designer=classique',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=classique' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=classique' }, { name: "Fashion", url: 'gallery/fine-jewelry?designer=classique' }],
		description: ['Classique Creations has their finger on the pulse of what\'s trending in the jewelry world. Their unique, fashion-forward bridal designs, including Pinterest-inspired settings and stackable rings, are sure to stand the test of time and be a symbol of your love and devotion for years to come.']
	};
	
	var peramore = {
		template: 'designer',
		name: 'Per Amoré',
		titleName: 'Per Amore Designer',
		displayName: 'Per Amoré',
		shopLink: '',
		description: ['Over four generations ago, Per Amoré began crafting the finest wedding bands and to this day continues with exceptional hand craftsmanship. With simple, elegant, unique styling using the finest precious metals, Per Amore pays great attention to detail with excellent design execution.  Per Amore passionately creates quality jewelry that remains distinctive and timeless.']
	};
	
	var benchmark = {
		template: 'designer',
		name: 'Benchmark',
		titleName: 'Benchmark Designer',
		displayName: 'Benchmark',
		shopLink: 'gallery/wedding-bands/mens?designers=benchmark',
		description: ['Benchmark offers stunning, sustainable, high-quality men\'s bands crafted using recycled precious metals of the same high quality as newly mined metals, showing the brand\'s commitment to environmental responsibility. Benchmark is proud to manufacture right here in the United States, and provides a lifetime guarantee for every product.']
	};
	
	var dddesigns = {
		template: 'designer',
		name: 'Diamonds Direct Designs',
		titleName: 'Diamonds Direct Designs',
		displayName: 'Diamonds Direct Designs',
		// shopLink: 'gallery/engagement-rings?mode=setting&designer=dddesigns',
		links: [{ name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=dddesigns' }, { name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=dddesigns' },
		// {name: "Men's Bands", url: 'gallery/wedding-bands/womens?designers=dddesigns'},
		{ name: "Fashion", url: 'gallery/fine-jewelry?designer=dddesigns' }],
		description: ['At Diamonds Direct, we believe in selection and empowering our customers with the freedom of choice. While our stores feature an expansive line-up of world-renowned fine jewelry designers, we’re also proud to introduce our exclusive collection of engagement rings and wedding bands, Diamonds Direct Designs. From modern simplicity to classic elegance, our master jewelers have created a collection of bridal jewelry that is uniquely ours and is sure to be uniquely yours. It’s the Diamonds Direct Designs promise.']
	};
	
	var ALL = exports.ALL = {
		'ajaffe': ajaffe,
		'artcarved': artcarved,
		'cgonshor': cgonshor,
		'christianbauer': christianbauer,
		'christopherdesigns': christopherdesigns,
		'coast': coast,
		'fana': fana,
		'furrerjacot': furrerjacot,
		'gottlieb': gottlieb,
		'henridaussi': henridaussi,
		'jackkelege': jackkelege,
		'jeffcooper': jeffcooper,
		'kirkkara': kirkkara,
		'mastoloni': mastoloni,
		'michaelm': michaelm,
		'novell': novell,
		'pejay': pejay,
		'ses': ses,
		'simong': simong,
		'sylvie': sylvie,
		'tacori': tacori,
		'trueromance': trueromance,
		'verragio': verragio,
		'amden': amden,
		'uneek': uneek,
		'odelia': odelia,
		'classique': classique,
		'peramore': peramore,
		'benchmark': benchmark,
		'dddesigns': dddesigns
	};

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var locations = exports.locations = [{
	  display: 'Austin, TX',
	  value: 'infoAUS@diamondsdirect.com'
	}, {
	  display: 'Baybrook, TX',
	  value: 'infoBAY@diamondsdirect.com'
	}, {
	  display: 'Birmingham, AL',
	  value: 'infoBHM@diamondsdirect.com'
	}, {
	  display: 'Boca Raton, FL',
	  value: 'infoBOCA@diamondsdirect.com'
	}, {
	  display: 'Charleston, SC',
	  value: 'infoCHS@diamondsdirect.com'
	}, {
	  display: 'Charlotte, NC',
	  value: 'infoCLT@diamondsdirect.com'
	}, {
	  display: 'Cleveland, OH',
	  value: 'infoCLE@diamondsdirect.com'
	}, {
	  display: 'Columbus, OH',
	  value: 'infocol@diamondsdirect.com'
	}, {
	  display: 'Dallas, TX',
	  value: 'infoDTX@diamondsdirect.com'
	}, {
	  display: 'Frisco, TX',
	  value: 'infoFRISCO@diamondsdirect.com'
	}, {
	  display: 'Houston, TX',
	  value: 'infoHOU@diamondsdirect.com'
	}, {
	  display: 'Indianapolis, IN',
	  value: 'infoindy@diamondsdirect.com'
	}, {
	  display: 'Jacksonville, FL',
	  value: 'infojax@diamondsdirect.com'
	}, {
	  display: 'Kansas City, KS',
	  value: 'infoKSC@diamondsdirect.com'
	}, {
	  display: 'New Orleans, LA',
	  value: 'infoNOLA@diamondsdirect.com'
	}, {
	  display: 'Oklahoma City, OK',
	  value: 'infoOKC@diamondsdirect.com'
	}, {
	  display: 'Pittsburgh, PA',
	  value: 'infoPITT@diamondsdirect.com'
	}, {
	  display: 'Raleigh, NC',
	  value: 'infoRal@diamondsdirect.com'
	}, {
	  display: 'Richmond, VA',
	  value: 'infoRic@diamondsdirect.com'
	}, {
	  display: 'St. Louis, MO',
	  value: 'infostl@diamondsdirect.com'
	}, {
	  display: 'San Antonio, TX',
	  value: 'infoSAT@diamondsdirect.com'
	}, {
	  display: 'Tysons, VA',
	  value: 'infoTYS@diamondsdirect.com'
	}, {
	  display: 'Virginia Beach, VA',
	  value: 'infoVAB@diamondsdirect.com'
	}];

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var QUESTIONS = exports.QUESTIONS = [{
	  subject: 'ordering',
	  title: 'WHAT IS YOUR TYPICAL TURNAROUND TIME FOR NEW PURCHASES?',
	  body: 'We work hard to deliver a quality product to our customers in the quickest time frame possible. A good general rule of thumb is 4-8 weeks from the time of order. That said, turnaround time is completely dependent upon the kind of product you are ordering, if your order is placed online or in store, and if you are picking up your order in store or require shipping.<br /><br />Here are some general guidelines on turnaround time for your consideration:<br /><br /><table style="margin: 20px auto;" border="1"><tbody><tr><td style="padding: 2px 5px;"></td><td style="padding: 2px 5px;">In Store Purchase</td><td style="padding: 2px 5px;">Online Purchase</td></tr><tr><td style="padding: 2px 5px;">Fashion Jewelry<br />(In-Stock)</td><td style="padding: 2px 5px;">As soon as same day, depending on jewelry item</td><td style="padding: 2px 5px;">3 - 10 days from order date</td></tr><tr><td style="padding: 2px 5px;">Bridal Jewelry<br />(In-Stock)</td><td style="padding: 2px 5px;">As soon as same day up to 2 weeks</td><td style="padding: 2px 5px;">3 - 10 days from order date</td></tr><tr><td style="padding: 2px 5px;">Special Orders</td><td style="padding: 2px 5px;">3 - 6 weeks, depending on designer</td><td style="padding: 2px 5px;">3 - 8 weeks, depending on designer</td></tr><tr><td style="padding: 2px 5px;">Loose Diamonds<br />(no setting)</td><td style="padding: 2px 5px;">As soon as same day, depending on diamond location</td><td style="padding: 2px 5px;">12 - 18 days</td></tr></tbody></table><br />For questions regarding the turnaround time on a specific jewelry item or an order you placed, please <a href="/locations">contact the store nearest you</a> or give us a call at <a href="tel:8008855050">(800) 885-5050</a>.'
	}, {
	  subject: 'ordering',
	  title: 'I NEED MY ORDER SOONER THAN THE ESTIMATED FOUR TO EIGHT WEEKS - WHAT ARE MY OPTIONS?',
	  body: 'If you\'re hoping to propose or present a special jewelry item in 4 weeks or less, we can make specific recommendations on the jewelry items that can be available to you in that time frame! To talk to a diamond expert about your best options for your unique time frame, please <a href="/locations">contact the store nearest you</a> or give us a call at <a href="tel:8008855050">(800) 885-5050</a>.'
	},
	// {
	//   subject: 'ordering',
	//   title: 'WILL I BE CHARGED SALES TAX ON MY ORDER?',
	//   body: 'Sales tax is only collected on orders that are shipped to AL, CA, CT, FL, GA, IA, IL, IN, KS, KY, LA, MA, MD, MI, MN, MO, MS, NC, NE, NJ, NV, NY, OH, OK, PA, RI, SC, TN, TX, UT, VA, WA, WI, WV',
	// },
	{
	  subject: 'ordering',
	  title: 'DO YOU SHIP OUTSIDE OF THE UNITED STATES?',
	  body: 'Diamonds Direct ships throughout the US. We can deliver to your home, office or APO/FPO. Please note all packages are signature required.<br /><br />Please contact us directly if you are interested in shipping to another destination: <a href="tel:8008855050">(800) 885-5050</a> or <a href="mailto:online@diamondsdirect.com">online@diamondsdirect.com</a>.'
	}, {
	  subject: 'ordering',
	  title: 'DO YOU SHIP TO MILITARY APO’S OR PO BOXES?',
	  body: 'Yes, we will gladly ship your order to any APO/FPO using US Postal Registered Mail. Registered mail is fully insured, and can take up to three weeks for delivery.<br /><br />At this time, we cannot ship to a PO BOX or FedEx locations.'
	}, {
	  subject: 'ordering',
	  title: 'CAN I SHIP TO A DIFFERENT ADDRESS OTHER THAN MY BILLING ADDRESS?',
	  body: 'Yes! Your billing address and shipping address can be different. If you are shipping to a different shipping address than your billing we may ask for additional information for security reasons.'
	}, {
	  subject: 'ordering',
	  title: 'CAN YOU CHANGE A SHIPPING ADDRESS AFTER AN ORDER IS PLACED?',
	  body: 'It is possible to change your shipping address. However, this request must take place before the item ships out. Addresses cannot be changed after items have been shipped and are in transit with our shipping carriers.'
	}, {
	  subject: 'ordering',
	  title: 'HOW DO THE ITEMS SHIP AND DOES IT COST ANYTHING?',
	  body: 'Diamonds Direct offers fast, free shipping on all online orders, regardless of amount via FedEx. Please check with your local authorities to confirm taxes and fees before ordering.<br /><br />Orders for military personnel will be shipped for free to their APO/FPO. Please keep in mind that these locations are served by the US Post Office and may take up to three weeks to deliver.'
	}, {
	  subject: 'ordering',
	  title: 'ARE SHIPMENTS SIGNATURE REQUIRED?',
	  body: 'Yes, all items require a direct signature from anyone over the age of 18 at the receiving address. For that reason, we do not ship to PO boxes, FedEx locations, and packages cannot be rerouted to a new address after the item has been shipped.'
	}, {
	  subject: 'ordering',
	  title: 'ARE YOUR SHIPMENTS INSURED?',
	  body: 'Yes, all Diamonds Direct shipments are fully insured during transit. All purchases also require a signature at the time of delivery.'
	}, {
	  subject: 'ordering',
	  title: 'HOW DO I CHECK THE STATUS OF MY ORDER?',
	  body: 'To check the status of an order placed in store, please contact the store in which you made the purchase via phone or email. For store contact info, <a href="/locations">please click here</a>.<br /><br />To check the status of an order placed online, please login to <a href="/customer/account/login">your account here</a> or contact us at <a href="tel:8008855050">(800) 885-5050</a>.'
	}, {
	  subject: 'ordering',
	  title: 'I SAW SOMETHING I LOVE ONLINE. CAN I SEE IT IN STORE?',
	  body: 'Yes! If you see something you like on our website we will gladly ship this item the location nearest you to view and try on in person. In addition, the inventory on our website represents only a sampling of the unmatched selection of inventory we carry in each of our stores. If you live near a store, we recommend you come by to view our full inventory! Our diamond experts will be glad to set an appointment for you to see and try on a specific jewelry and can even curate a collection of specific items for you to browse and compare. To learn more, <a href="/locations">contact a store nearest you</a>, use our <a href="/appointments">book an appointment feature</a> or call us at <a href="tel:8008855050">(800) 885-5050</a>.'
	}, {
	  subject: 'ordering',
	  title: 'I SAW SOMETHING I LOVE IN STORE BUT CAN’T FIND IT ON THE WEBSITE?',
	  body: 'The inventory on our website represents only a sampling of the unmatched selection of inventory we carry in each of our stores. If you saw an item you love in store and can’t find it on the website, our diamond experts will be glad to send pricing, additional information, and even photos to you for your records and consideration. To get personal shopping help from one of our diamond experts, <a href="/locations">contact a store nearest you</a>, use our <a href="/appointments">book an appointment feature</a> or call us at <a href="tel:8008855050">(800) 885-5050</a>.'
	}, {
	  subject: 'ordering',
	  title: 'I DO NOT SEE A SPECIFIC FANCY SHAPE OR FANCY COLORED DIAMONDS ON YOUR WEBSITE? DO YOU CARRY THOSE?',
	  body: 'Yes! Diamonds Direct offers a vast selection of specialty cut diamonds as well as fancy shaped stones, and colored diamonds! Though our online loose diamond inventory does not display those specialty stones at this time, you can readily find specialty cut or colored diamonds in our showrooms! Our diamond experts are here to guide you through the diamond buying process, particularly if you are looking for a rare diamond. To get personal shopping help from one of our diamond experts, <a href="/locations">contact a store nearest you</a>, use our <a href="/appointments">book an appointment feature</a> or call us at <a href="tel:8008855050">(800) 885-5050</a>.'
	}, {
	  subject: 'ordering',
	  title: 'WHAT IS THE DIFFERENCE BETWEEN THE DIAMONDS ON YOUR WEBSITE AND THE DIAMONDS IN YOUR STORES?',
	  body: 'Simply, location. While each of our stores are fully stocked with hundreds of loose and mounted diamonds, the loose diamonds on our website are located with our manufacturers overseas. Buying a diamond can be a confusing process, and our diamond experts are here to help you navigate our entire diamond inventory to best maximize your budget and requirements!'
	}, {
	  subject: 'ordering',
	  title: 'CAN I DESIGN A CUSTOM ENGAGEMENT RING OR JEWELRY ITEM?',
	  body: 'Yes! Custom designed jewelry is a great way to create a unique expression of your love that’s as individual as you are. <a href="/custom-design/">Click here</a> to start the custom design process or <a href="/locations">contact a store nearest you</a> to learn more.'
	}, {
	  subject: 'ordering',
	  title: 'IF I PURCHASE A LOOSE DIAMOND AND A JEWELRY ITEM TO SET IT INTO, IS THERE A CHARGE TO HAVE THE DIAMOND SET?',
	  body: 'No! When purchasing a loose diamond and a mounting at Diamonds Direct, setting the diamond into the mounting is always complimentary service!'
	}, {
	  subject: 'ordering',
	  title: 'I HAVE MY OWN STONE BUT WOULD LIKE TO BUY A SETTING FROM DIAMONDS DIRECT. CAN YOU SET A STONE THAT WASN’T PURCHASED AT DIAMONDS DIRECT?',
	  body: 'Yes! We would be glad to set a stone you own into a setting you buy from us. We do require that you bring your diamond or loose stone to one of our locations to inspect and measure prior to ordering the mounting to ensure the stone can be safely set into the new mounting. This is a service only offered in our stores at this time.'
	}, {
	  subject: 'ordering',
	  title: 'DO I NEED AN APPOINTMENT TO COME TO YOUR SHOWROOM TO SHOP?',
	  body: 'No! You are not required to set up an appointment to come to one of our stores. Our showrooms are open for walk-ins 6 days a week! That said, if you\'d like the convenience of having a specific appointment time on the books, please <a href="/locations">contact a store nearest you</a>, use our <a href="/appointments">book an appointment feature</a> or call us at <a href="tel:8008855050">(800) 885-5050</a>.'
	}, {
	  subject: 'ordering',
	  title: 'DO YOU OFFER A MILITARY OR SERVICE DISCOUNT?',
	  body: 'We are proud to offer a service discount to our active and retired heroes in the military, police, fire and paramedics. This discount is 15% off your purchase with a member ID. To receive this discount please present a form of valid, non-classified form of ID or confirmation of service and/or employment at the time of purchase in-store. For online purchases, please email a photo of this ID to <a href="mailto:online@diamondsdirect.com">online@diamondsdirect.com</a> and our Customer Care Team will respond with a discount code that can be applied to your online purchase at the time of checkout.<br /><br />Please note this discount, as well as any of our promotional pricing year round, does not apply to certified diamonds or price protected designer lines and cannot be combined with any other offer or special financing promotions exceeding 12 months.'
	}, {
	  subject: 'payment',
	  title: 'WHAT TYPE OF PAYMENT DOES DIAMONDS DIRECT ACCEPT?',
	  body: 'We accept all major credit cards (Visa, MasterCard, American Express and Discover), as well as certified checks and money orders, wire transfers, personal checks and cash. However, personal checks cannot be used as a form of final payment upon item pickup. We also offer special financing offers on approved credit through Wells Fargo Bank, N.A. Please note some credit card transactions, wire transfers, and personal checks may require additional verification prior to processing the order.'
	}, {
	  subject: 'payment',
	  title: 'DO YOU OFFER FINANCING?',
	  body: 'Diamonds Direct offers special financing options with approved credit through Wells Fargo Bank, N.A. To learn more about our current financing offers or to apply online, please visit <a href="/financing">the financing page</a> of our website.'
	}, {
	  subject: 'payment',
	  title: 'CAN I SPREAD MY PAYMENT ACROSS MULTIPLE CREDIT CARDS?',
	  body: 'Yes, we will gladly accept multiple payments for a single transaction.<br /><br />For in store purchases, indicate you’d like to use multiple cards at the time of check out, and your diamond expert will be glad to comply.<br /><br />At this time, online customers must call to speak with a Customer Care Team Member to utilize multiple credit cards at the time of payment. Please contact us at <a href="tel:8008855050">(800) 885-5050</a> Monday - Friday between 9:30 a.m. and 6:00 p.m. eastern standard time.'
	}, {
	  subject: 'payment',
	  title: 'DOES DIAMONDS DIRECT OFFER A LAYAWAY POLICY?',
	  body: 'Our showrooms do offer a layaway policy to our customers. Articles placed on layaway will be held for a period of 120 days. Payment arrangements are required to be made in full before the end of this period or the item(s) will be returned to stock. At this time, we do not offer a layaway policy for online purchases.'
	}, {
	  subject: 'warranty',
	  title: 'DO I NEED TO MAKE AN APPOINTMENT FOR JEWELRY CLEANINGS?',
	  body: 'Walk-ins always welcome! No appointment needed for routine jewelry cleanings.'
	}, {
	  subject: 'warranty',
	  title: 'WHAT DOES THE DIAMONDS DIRECT® STORES LIFETIME WARRANTY COVER?',
	  body: 'All jewelry purchased from our DIAMONDS DIRECT<sup>®</sup> stores comes with our signature lifetime warranty which covers a lifetime of routine jewelry maintenance including (but not limited to):<br /><br /><ul><li>Complimentary accent diamond replacement</li><li>Complimentary sizing</li><li>Complimentary cleaning and polishing</li><li>Complimentary rhodium plating</li><li>Complimentary soldering</li><li>Complimentary prong adjustment and repair, and more!</li></ul>When you come to our DIAMONDS DIRECT<sup>®</sup> stores, be sure to take advantage of our DIAMOND DOCTOR<sup>®</sup> service for tips on how to care for your jewelry and make it sparkle for a lifetime!'
	}, {
	  subject: 'warranty',
	  title: 'I DO NOT LIVE NEAR A STORE. WILL DIAMONDS DIRECT STILL PROVIDE COMPLIMENTARY SERVICE TO ME AND MY JEWELRY?',
	  body: 'Whether you made a purchase online or you’ve relocated out of market - Diamonds Direct is still very much here to help you with your repair and jewelry service needs.<br /><br />For customers who purchased online- please contact our customer care team at <a href="mailto:online@diamondsdirect.com">online@diamondsdirect.com</a> to schedule a service related shipment.'
	}, {
	  subject: 'warranty',
	  title: 'MY WHITE GOLD RING IS TURNING YELLOW- IS THAT TYPICAL?',
	  body: 'Yes, rhodium is an alloy that is blended with naturally yellow gold to give it a pure white tone. This is the process applied to all white gold jewelry. Over time that rhodium can wear away, revealing a faint, golden tone. For that reason, one of the key maintenance requirements for white gold jewelry is periodic rhodium plating. Diamonds Direct is proud to offer free lifetime rhodium plating on all our jewelry to make sure your jewelry stays shiny and bright at all times! No appointment needed to have your ring rhodium plated. Just stop by!'
	}, {
	  subject: 'warranty',
	  title: 'I NEED MY RING SIZED.',
	  body: 'Diamonds Direct will gladly resize rings purchased from us free of charge! The turnaround time for ring sizing is dependent on the type of ring you have. In most cases, we can accommodate sizing requests within a few days to about a week. Our shop offers many options to fit your schedule and your sizing needs.<br /><br />Some of our designers do require us to send rings back to their studio for their artisan craftsman to size. If that is the case for your ring, sizing may take a few weeks.We will gladly coordinate the shipping of the ring to the designer on your behalf free of charge.<br /><br />Please also note some specialty rings, like eternity bands, tension set diamond rings, and alternative metals, may not accommodate sizing.<br /><br />In order to get the most accurate sizing recommendations for your specific ring please <a href="/locations">contact a store nearest you</a>, use our <a href="/appointments">book an appointment feature</a> or call us at <a href="tel:8008855050">(800) 885-5050</a>.<br /><br />If you are not located near a store, please email us at <a href="mailto:online@diamondsdirect.com">online@diamondsdirect.com</a> and one of our customer service team members will be glad to walk you through the process of determining your ring size and shipping your ring to us for sizing.'
	}, {
	  subject: 'warranty',
	  title: 'HOW LONG DOES JEWELRY REPAIRS/SERVICE TAKE?',
	  body: 'The turnaround time for jewelry repair work is dependent on the task at hand but generally ranges from 1 to 3 weeks. Please note some designer jewelry will need to be serviced at the designer’s studio and may require additional time. In addition, in rare cases, some specialty items may not accommodate repairs.<br /><br />In order to get the most accurate jewelry repair recommendations for your jewelry item, please <a href="/locations">contact a store nearest you</a>, use our <a href="/appointments">book an appointment feature</a>, or call us at <a href="tel:8008855050">(800) 885-5050</a>.'
	}, {
	  subject: 'warranty',
	  title: 'WHERE DO YOU DO THE REPAIRS/SERVICE WORK?',
	  body: 'We\'re proud to have master jewelers at each location who have decades of experience making and repairing jewelry. For that reason, most of our repair work is done in house. However, some of our designers do require repairs to their jewelry items to be completed in their own studio.<br /><br />If you\'d like to inquire about or make an appointment for jewelry repair we recommend you <a href="/locations">contact a local store</a>, use our <a href="/appointments">book an appointment feature</a>, or call us at <a href="tel:8008855050">(800) 885-5050</a>.'
	}, {
	  subject: 'warranty',
	  title: 'DO I NEED PERSONAL JEWELRY INSURANCE EVEN THOUGH YOU PROVIDE A LIFETIME WARRANTY?',
	  body: 'Even though Diamonds Direct offers a lifetime warranty that is second to none in the industry, it’s critical to have your fine jewelry insured with a private insurance company in the event of loss, damage, theft, or irreparable damage. We recommend considering <a href="https://lavalier.com/" target="_blank">Lavalier</a>. Your personal property insurance provider will also likely provide fine jewelry insurance programs as well.'
	}, {
	  subject: 'warranty',
	  title: 'DO YOU PROVIDE JEWELRY APPRAISALS FOR INSURANCE PURPOSES?',
	  body: 'Yes! All fine jewelry purchased from Diamonds Direct valued at or over $1,000.00 will be accompanied by an appraisal for you to provide to your insurance company. At this time, we do not provide appraisals for jewelry that was not purchased from Diamonds Direct.'
	}, {
	  subject: 'upgrade',
	  title: 'DO YOU HAVE AN UPGRADE POLICY?',
	  body: 'Yes! Diamonds Direct offers a 110% lifetime upgrade policy that is second to none in the industry! Our policy allows customers to upgrade your original engagement diamond, solitaire diamond pendant, and diamond studs for a different size, quality or shape. Think of it as a diamond savings account, you can come in as often as desired to upgrade in the original diamond and you’re only required to pay the difference between the two. It’s easy! You get 110% of your original purchase towards your new purchase. Our upgrade policy applies one year after your original purchase and is applicable to natural diamonds only.'
	}, {
	  subject: 'upgrade',
	  title: 'DOES DIAMONDS DIRECT ACCEPT TRADE INS TOWARD A NEW PURCHASE?',
	  body: 'Diamonds Direct will consider buying any loose diamond weighing a 0.50 carat or more, if that stone is needed in inventory at that time. One of our diamond experts will need to inspect the diamond in person, as well as any accompanying paperwork, to determine if the diamond can be purchased. You can then put that money toward a new purchase at Diamonds Direct.<br /><br />If you are no longer in need of the diamond you previously purchased from us, we welcome you to also consider our signature upgrade policy. This could permit you to take that diamond and transform it into something new! Our 110% upgrade policy allows Diamonds Direct customers to upgrade their original engagement diamond, solitaire diamond pendant, and diamond studs for a different size, quality or shape. Think of it as a diamond savings account, you can come in as often as desired to upgrade in the original diamond and you’re only required to pay the difference between the two. Our upgrade policy applies one year after your original purchase.<br /><br />Please note we do not buy any gold or jewelry because we do not sell consignment jewelry that has had prior ownership and wear and tear. To make an appointment to review the diamond, please <a href="/locations">contact a store nearest you</a>, or use our <a href="/appointments">book an appointment feature</a>.<br /><br />If you are not located near a store, please email us at <a href="mailto:online@diamondsdirect.com">online@diamondsdirect.com</a> or call our customer service number: <a href="tel:8008855050">(800) 885-5050</a> Monday - Friday between 9:30 a.m. and 5 p.m. eastern standard time and we will be glad to help with this!'
	}, {
	  subject: 'upgrade',
	  title: 'DO YOU PURCHASE OR CONSIGN DIAMONDS, GOLD OR JEWELRY?',
	  body: 'Diamonds Direct will consider buying loose diamonds weighing 0.50 carat or more, if that stone is needed in inventory at that time. One of our diamond experts will need to inspect the diamond in person, as well as any accompanying paperwork, to determine if the diamond can be purchased.'
	}, {
	  subject: 'returns',
	  title: 'WHAT IS THE DIAMONDS DIRECT RETURN POLICY?',
	  body: 'If for any reason, you are not satisfied with the purchase, you can return it within 30 days for a full refund. Customer satisfaction is our goal, and we will work on an individual basis with each customer to develop solutions for returned orders.'
	}, {
	  subject: 'returns',
	  title: 'WHAT CANNOT BE RETURNED?',
	  body: 'Custom orders are not returnable.'
	}, {
	  subject: 'returns',
	  title: 'HOW DO I RETURN TO A STORE?',
	  body: 'If you wish to return your item that was purchased online or in a store please bring all of your paperwork with you. Someone at the store will help you with the return process.'
	}, {
	  subject: 'returns',
	  title: 'HOW DO I RETURN BY MAIL?',
	  body: 'If you made the purchase online and you are not near a store please contact us at <a href="tel:8008855050">(800) 885-5050</a>. We will then email you a return form. Please package the item securely with all of the paperwork you received. When we receive the package and verify that all articles are in original condition we will then process your refund.'
	}, {
	  subject: 'returns',
	  title: 'HOW DO I EXCHANGE WHAT I HAVE PURCHASED?',
	  body: 'You are able to do an exchange within 30 days of the sale if articles are in original condition. In the event that you would like to exchange what you purchased and you are near a store please take the item and all paperwork into a store. If you are not close to a store please contact us at <a href="tel:8008855050">(800) 885-5050</a>.'
	}, {
	  subject: 'returns',
	  title: 'HOW WILL I GET MY REFUND?',
	  body: 'Refunds are issued in accordance with the original method of payment. Bank wires will be refunded by company check.'
	}, {
	  subject: 'returns',
	  title: 'WHEN WILL I GET MY REFUND?',
	  body: 'The credit will be returned to your credit card within 10 to 14 business days after we process the refund. If you sent us a bank wire or paid with a personal check we will mail you a check.'
	},
	// {
	//   subject: 'returns',
	//   title: 'WHAT IF I PURCHASED AN ITEM AND WOULD LIKE TO RETURN IT, BUT I LIVE IN CANADA?',
	//   body: 'Please give us a call at <a href="tel:8008855050">(800) 885-5050</a>. We will help you with your return process.',
	// },
	{
	  subject: 'returns',
	  title: 'WHAT IF I WOULD LIKE TO RETURN AN ITEM I RECEIVED AS A GIFT?',
	  body: 'Gift Recipients will be issued a merchandise credit only, no refunds.'
	}, {
	  subject: 'privacy',
	  title: 'IS SHOPPING ONLINE WITH DIAMONDS DIRECT SECURE?',
	  body: 'We use secure encryption and fraud protection for all credit card transactions. All sensitive data is encrypted via 256-bit SSL (Secure Socket Layer) encryption. You can view our security certificate to verify our encryption status.'
	}, {
	  subject: 'privacy',
	  title: 'WILL MY PERSONAL DATA BE SHARED WITH 3RD PARTIES?',
	  body: 'Diamonds Direct always keeps your information 100% private and confidential.'
	}];

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var states = exports.states = [{
	    "name": "Alabama",
	    "abbreviation": "AL"
	}, {
	    "name": "Alaska",
	    "abbreviation": "AK"
	}, {
	    "name": "American Samoa",
	    "abbreviation": "AS",
	    "territory": true
	}, {
	    "name": "Arizona",
	    "abbreviation": "AZ"
	}, {
	    "name": "Arkansas",
	    "abbreviation": "AR"
	}, {
	    "name": "California",
	    "abbreviation": "CA"
	}, {
	    "name": "Colorado",
	    "abbreviation": "CO"
	}, {
	    "name": "Connecticut",
	    "abbreviation": "CT"
	}, {
	    "name": "Delaware",
	    "abbreviation": "DE"
	}, {
	    "name": "District Of Columbia",
	    "abbreviation": "DC"
	}, {
	    "name": "Federated States Of Micronesia",
	    "abbreviation": "FM",
	    "territory": true
	}, {
	    "name": "Florida",
	    "abbreviation": "FL"
	}, {
	    "name": "Georgia",
	    "abbreviation": "GA"
	}, {
	    "name": "Guam Gu",
	    "abbreviation": "GU"
	}, {
	    "name": "Hawaii",
	    "abbreviation": "HI"
	}, {
	    "name": "Idaho",
	    "abbreviation": "ID"
	}, {
	    "name": "Illinois",
	    "abbreviation": "IL"
	}, {
	    "name": "Indiana",
	    "abbreviation": "IN"
	}, {
	    "name": "Iowa",
	    "abbreviation": "IA"
	}, {
	    "name": "Kansas",
	    "abbreviation": "KS"
	}, {
	    "name": "Kentucky",
	    "abbreviation": "KY"
	}, {
	    "name": "Louisiana",
	    "abbreviation": "LA"
	}, {
	    "name": "Maine",
	    "abbreviation": "ME"
	}, {
	    "name": "Marshall Islands",
	    "abbreviation": "MH",
	    "territory": true
	}, {
	    "name": "Maryland",
	    "abbreviation": "MD"
	}, {
	    "name": "Massachusetts",
	    "abbreviation": "MA"
	}, {
	    "name": "Michigan",
	    "abbreviation": "MI"
	}, {
	    "name": "Minnesota",
	    "abbreviation": "MN"
	}, {
	    "name": "Mississippi",
	    "abbreviation": "MS"
	}, {
	    "name": "Missouri",
	    "abbreviation": "MO"
	}, {
	    "name": "Montana",
	    "abbreviation": "MT"
	}, {
	    "name": "Nebraska",
	    "abbreviation": "NE"
	}, {
	    "name": "Nevada",
	    "abbreviation": "NV"
	}, {
	    "name": "New Hampshire",
	    "abbreviation": "NH"
	}, {
	    "name": "New Jersey",
	    "abbreviation": "NJ"
	}, {
	    "name": "New Mexico",
	    "abbreviation": "NM"
	}, {
	    "name": "New York",
	    "abbreviation": "NY"
	}, {
	    "name": "North Carolina",
	    "abbreviation": "NC"
	}, {
	    "name": "North Dakota",
	    "abbreviation": "ND"
	}, {
	    "name": "Northern Mariana Islands",
	    "abbreviation": "MP",
	    "territory": true
	}, {
	    "name": "Ohio",
	    "abbreviation": "OH"
	}, {
	    "name": "Oklahoma",
	    "abbreviation": "OK"
	}, {
	    "name": "Oregon",
	    "abbreviation": "OR"
	}, {
	    "name": "Palau",
	    "abbreviation": "PW"
	}, {
	    "name": "Pennsylvania",
	    "abbreviation": "PA"
	}, {
	    "name": "Puerto Rico",
	    "abbreviation": "PR"
	}, {
	    "name": "Rhode Island",
	    "abbreviation": "RI"
	}, {
	    "name": "South Carolina",
	    "abbreviation": "SC"
	}, {
	    "name": "South Dakota",
	    "abbreviation": "SD"
	}, {
	    "name": "Tennessee",
	    "abbreviation": "TN"
	}, {
	    "name": "Texas",
	    "abbreviation": "TX"
	}, {
	    "name": "Utah",
	    "abbreviation": "UT"
	}, {
	    "name": "Vermont",
	    "abbreviation": "VT"
	}, {
	    "name": "Virgin Islands",
	    "abbreviation": "VI"
	}, {
	    "name": "Virginia",
	    "abbreviation": "VA"
	}, {
	    "name": "Washington",
	    "abbreviation": "WA"
	}, {
	    "name": "West Virginia",
	    "abbreviation": "WV"
	}, {
	    "name": "Wisconsin",
	    "abbreviation": "WI"
	}, {
	    "name": "Wyoming",
	    "abbreviation": "WY"
	}];

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(63);
	
	var _redux = __webpack_require__(209);
	
	var _reactRedux = __webpack_require__(3);
	
	var _auth = __webpack_require__(88);
	
	var _configureStore = __webpack_require__(625);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _App = __webpack_require__(483);
	
	var _AppHeaderWrapper = __webpack_require__(484);
	
	var _Home = __webpack_require__(547);
	
	var _Store = __webpack_require__(607);
	
	var _Watch = __webpack_require__(608);
	
	var _Locations = __webpack_require__(556);
	
	var _Locations2 = _interopRequireDefault(_Locations);
	
	var _AboutUs = __webpack_require__(489);
	
	var _AboutUs2 = _interopRequireDefault(_AboutUs);
	
	var _Faq = __webpack_require__(515);
	
	var _Foundation = __webpack_require__(518);
	
	var _ScheduleAppointment = __webpack_require__(605);
	
	var _Designers = __webpack_require__(503);
	
	var _Designers2 = _interopRequireDefault(_Designers);
	
	var _SingleDesigner = __webpack_require__(504);
	
	var _SingleDesigner2 = _interopRequireDefault(_SingleDesigner);
	
	var _CustomDesign = __webpack_require__(502);
	
	var _Careers = __webpack_require__(497);
	
	var _Careers2 = _interopRequireDefault(_Careers);
	
	var _Heroes = __webpack_require__(546);
	
	var _Heroes2 = _interopRequireDefault(_Heroes);
	
	var _Heritage = __webpack_require__(545);
	
	var _Heritage2 = _interopRequireDefault(_Heritage);
	
	var _Privacy = __webpack_require__(554);
	
	var _Privacy2 = _interopRequireDefault(_Privacy);
	
	var _Terms = __webpack_require__(555);
	
	var _Terms2 = _interopRequireDefault(_Terms);
	
	var _Warranties = __webpack_require__(609);
	
	var _Warranties2 = _interopRequireDefault(_Warranties);
	
	var _AsSeen = __webpack_require__(496);
	
	var _AsSeen2 = _interopRequireDefault(_AsSeen);
	
	var _ContactPage = __webpack_require__(312);
	
	var _Press = __webpack_require__(499);
	
	var _ThankYou = __webpack_require__(500);
	
	var _ThankYou2 = _interopRequireDefault(_ThankYou);
	
	var _VideoChat = __webpack_require__(501);
	
	var _VideoChat2 = _interopRequireDefault(_VideoChat);
	
	var _Covid = __webpack_require__(574);
	
	var _Covid2 = _interopRequireDefault(_Covid);
	
	var _NoKidHungry = __webpack_require__(589);
	
	var _NoKidHungry2 = _interopRequireDefault(_NoKidHungry);
	
	var _NolaFlood = __webpack_require__(590);
	
	var _NolaFlood2 = _interopRequireDefault(_NolaFlood);
	
	var _Gallery = __webpack_require__(520);
	
	var _ProductPage = __webpack_require__(561);
	
	var _Account = __webpack_require__(490);
	
	var _Finance = __webpack_require__(516);
	
	var _Finance2 = _interopRequireDefault(_Finance);
	
	var _EngagementSplash = __webpack_require__(316);
	
	var _EngagementSplash2 = _interopRequireDefault(_EngagementSplash);
	
	var _MensBandsSplash = __webpack_require__(317);
	
	var _MensBandsSplash2 = _interopRequireDefault(_MensBandsSplash);
	
	var _WomensBandsSplash = __webpack_require__(318);
	
	var _WomensBandsSplash2 = _interopRequireDefault(_WomensBandsSplash);
	
	var _BraceletSplash = __webpack_require__(539);
	
	var _BraceletSplash2 = _interopRequireDefault(_BraceletSplash);
	
	var _EarringSplash = __webpack_require__(540);
	
	var _EarringSplash2 = _interopRequireDefault(_EarringSplash);
	
	var _NecklaceSplash = __webpack_require__(542);
	
	var _NecklaceSplash2 = _interopRequireDefault(_NecklaceSplash);
	
	var _RingSplash = __webpack_require__(543);
	
	var _RingSplash2 = _interopRequireDefault(_RingSplash);
	
	var _EducationDiamond = __webpack_require__(510);
	
	var _EducationDiamond2 = _interopRequireDefault(_EducationDiamond);
	
	var _EducationGem = __webpack_require__(511);
	
	var _EducationGem2 = _interopRequireDefault(_EducationGem);
	
	var _EducationMetal = __webpack_require__(513);
	
	var _EducationMetal2 = _interopRequireDefault(_EducationMetal);
	
	var _EducationStyle = __webpack_require__(514);
	
	var _EducationStyle2 = _interopRequireDefault(_EducationStyle);
	
	var _EducationConflict = __webpack_require__(509);
	
	var _EducationConflict2 = _interopRequireDefault(_EducationConflict);
	
	var _EducationLabGrown = __webpack_require__(512);
	
	var _Influencers = __webpack_require__(548);
	
	var _Influencers2 = _interopRequireDefault(_Influencers);
	
	var _InfluenceBrightonbutler = __webpack_require__(550);
	
	var _InfluenceCourtnwilliams = __webpack_require__(551);
	
	var _InfluenceAubreyalley = __webpack_require__(549);
	
	var _InfluenceHauteofftherack = __webpack_require__(552);
	
	var _InfluenceMeganrunionmcr = __webpack_require__(553);
	
	var _DiamondStuds = __webpack_require__(508);
	
	var _DiamondPendants = __webpack_require__(507);
	
	var _DiamondBracelets = __webpack_require__(505);
	
	var _DiamondNecklaces = __webpack_require__(506);
	
	var _SearchResults = __webpack_require__(606);
	
	var _Summer = __webpack_require__(598);
	
	var _Summer2 = _interopRequireDefault(_Summer);
	
	var _Fall = __webpack_require__(580);
	
	var _Fall2 = _interopRequireDefault(_Fall);
	
	var _Holiday = __webpack_require__(582);
	
	var _Holiday2 = _interopRequireDefault(_Holiday);
	
	var _December = __webpack_require__(575);
	
	var _December2 = _interopRequireDefault(_December);
	
	var _Valentines = __webpack_require__(602);
	
	var _Valentines2 = _interopRequireDefault(_Valentines);
	
	var _Spring = __webpack_require__(595);
	
	var _Spring2 = _interopRequireDefault(_Spring);
	
	var _Mothers = __webpack_require__(587);
	
	var _Mothers2 = __webpack_require__(588);
	
	var _Summer3 = __webpack_require__(599);
	
	var _Summer4 = _interopRequireDefault(_Summer3);
	
	var _Fall3 = __webpack_require__(581);
	
	var _Fall4 = _interopRequireDefault(_Fall3);
	
	var _Holiday3 = __webpack_require__(583);
	
	var _Holiday4 = _interopRequireDefault(_Holiday3);
	
	var _December3 = __webpack_require__(576);
	
	var _December4 = _interopRequireDefault(_December3);
	
	var _Valentines3 = __webpack_require__(603);
	
	var _Valentines4 = __webpack_require__(604);
	
	var _Spring3 = __webpack_require__(596);
	
	var _Summer5 = __webpack_require__(600);
	
	var _Sept = __webpack_require__(591);
	
	var _SingleDesigner3 = __webpack_require__(593);
	
	var _Holiday5 = __webpack_require__(584);
	
	var _BlackFriday = __webpack_require__(573);
	
	var _December5 = __webpack_require__(577);
	
	var _Earring = __webpack_require__(578);
	
	var _Spring4 = __webpack_require__(597);
	
	var _June = __webpack_require__(586);
	
	var _Summer6 = __webpack_require__(601);
	
	var _Sept2 = __webpack_require__(592);
	
	var _SingleDesigner4 = __webpack_require__(594);
	
	var _Auburn = __webpack_require__(572);
	
	var _Holiday6 = __webpack_require__(585);
	
	var _Earring2 = __webpack_require__(579);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Async components
	// const HomeContainer1 = React.lazy(() => import('./components/views/home/Home.jsx'));
	
	// Promo Page Imports
	
	
	// Splash pages
	
	
	// Diamonds Direct 2.0 Specfic Imports
	var store = (0, _configureStore2.default)();
	
	// Search Page
	
	
	// Diamond Jewelry pages
	
	
	// Influencer pages
	
	
	// Eduction pages
	
	
	__webpack_require__(1226);
	
	function requireAuth(nextState, replaceState, cb) {
	            if (!(0, _auth.isLoggedIn)()) {
	                        replaceState({ pathname: '/' });
	            }
	            cb();
	}
	
	function requireNoAuth(nextState, replaceState, cb) {
	            if ((0, _auth.isLoggedIn)()) {
	                        replaceState({ pathname: '/' });
	            }
	            cb();
	}
	
	_reactDom2.default.render(_react2.default.createElement(
	            _reactRedux.Provider,
	            { store: store },
	            _react2.default.createElement(
	                        _reactRouter.Router,
	                        { onUpdate: function onUpdate() {
	                                                return window.scroll(0, 0);
	                                    }, history: _reactRouter.browserHistory },
	                        _react2.default.createElement(
	                                    _reactRouter.Route,
	                                    { path: '/', component: _App.AppContainer },
	                                    _react2.default.createElement(
	                                                _reactRouter.Route,
	                                                { component: _AppHeaderWrapper.AppHeaderWrapperContainer },
	                                                _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home.HomeContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'index.html', component: _Home.HomeContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'austin', component: _Store.StoreContainer, store_id: 'atx' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'baybrook', component: _Store.StoreContainer, store_id: 'bay' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'birmingham', component: _Store.StoreContainer, store_id: 'bhm' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'boca-raton', component: _Store.StoreContainer, store_id: 'boc' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'charleston', component: _Store.StoreContainer, store_id: 'chs' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'charlotte', component: _Store.StoreContainer, store_id: 'clt' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'cleveland', component: _Store.StoreContainer, store_id: 'cle' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'columbus', component: _Store.StoreContainer, store_id: 'coh' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'dallas', component: _Store.StoreContainer, store_id: 'dfw' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'ecj-watch-boutique', component: _Watch.WatchContainer, store_id: 'ecj' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'frisco', component: _Store.StoreContainer, store_id: 'ftx' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'greenville', component: _Store.StoreContainer, store_id: 'gsc' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'houston', component: _Store.StoreContainer, store_id: 'hou' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'indianapolis', component: _Store.StoreContainer, store_id: 'ind' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'jacksonville', component: _Store.StoreContainer, store_id: 'jax' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'kansas-city', component: _Store.StoreContainer, store_id: 'kcy' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'new-orleans', component: _Store.StoreContainer, store_id: 'nol' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'pittsburgh', component: _Store.StoreContainer, store_id: 'pit' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'oklahoma-city', component: _Store.StoreContainer, store_id: 'okc' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'raleigh', component: _Store.StoreContainer, store_id: 'ral' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'richmond', component: _Store.StoreContainer, store_id: 'rva' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'st-louis', component: _Store.StoreContainer, store_id: 'stl' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'san-antonio', component: _Store.StoreContainer, store_id: 'san' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'sanantonio', component: _Store.StoreContainer, store_id: 'san' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'troy', component: _Store.StoreContainer, store_id: 'try' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'tysons', component: _Store.StoreContainer, store_id: 'nva' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'virginia-beach', component: _Store.StoreContainer, store_id: 'vab' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'locations', component: _Locations2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'about-us', component: _AboutUs2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'faq', component: _Faq.FaqContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'frequently-asked-questions', component: _Faq.FaqContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'our-foundation', component: _Foundation.FoundationContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'careers', component: _Careers2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'heroes', component: _Heroes2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'heroes-in-uniform', component: _Heroes2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'account', component: _Account.AccountContainer, onEnter: requireAuth }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'as-seen-in', component: _AsSeen2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'our-guarantees', component: _Warranties2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'our-heritage', component: _Heritage2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'heritage-of-60years', component: _Heritage2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'custom-design', component: _CustomDesign.CustomDesignContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'custom-design/', component: _CustomDesign.CustomDesignContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'schedule', component: _ScheduleAppointment.ScheduleAppointmentContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'appointments', component: _ScheduleAppointment.ScheduleAppointmentContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'diamonds-direct-search', component: _SearchResults.SearchResultsContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'privacy-policy', component: _Privacy2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'terms-of-use', component: _Terms2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'contact-us', component: _ContactPage.ContactPageContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'virtual', component: _ContactPage.ContactPageContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'press', component: _Press.PressContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'thank-you', component: _ThankYou2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'video-chat', component: _VideoChat2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'financing', component: _Holiday6.Holiday2022Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'financing-placeholder', component: _Finance2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'holiday', component: _Earring2.Earring2022Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'valentinesday', component: _Valentines4.Valentines2022Container }),
	                                                '_',
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'spring', component: _Spring4.Spring2022Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'pod', component: _Spring3.Spring2021Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'mothersday', component: _Mothers2.Mothers2022Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'mothers-day', component: _Mothers2.Mothers2022Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'june-financing', component: _Mothers.Mothers2021Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'summer', component: _Summer6.Summer2022Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: '5yearfinancing', component: _Sept2.Sept2022Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: '3yearfinancing', component: _Holiday6.Holiday2022Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'covid-19-updates', component: _Covid2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'no-kid-hungry', component: _NoKidHungry2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'hurricane-relief', component: _NolaFlood2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'new-orleans-financing', component: _Sept.Sept2021Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'single-designer', component: _SingleDesigner3.SingleDesigner2021Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'designer-spotlight', component: _SingleDesigner4.SingleDesigner2022Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'black-friday', component: _BlackFriday.BlackFriday2021Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'december-financing', component: _December5.December2021Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: '4yearfinancing', component: _December5.December2021Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'auburngiveaway', component: _Auburn.Auburn2022Container }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'designers', component: _Designers2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'designers-links', component: _Designers2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'diamond-studs', component: _DiamondStuds.DiamondStudsContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'diamond-pendants', component: _DiamondPendants.DiamondPendantsContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'diamond-bracelets', component: _DiamondBracelets.DiamondBraceletsContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'diamond-necklaces', component: _DiamondNecklaces.DiamondNecklacesContainer }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'engagement-rings', component: _EngagementSplash2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'mens-bands', component: _MensBandsSplash2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'womens-bands', component: _WomensBandsSplash2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'fashion-bracelets', component: _BraceletSplash2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'fashion-earrings', component: _EarringSplash2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'fashion-necklaces', component: _NecklaceSplash2.default }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'fashion-rings', component: _RingSplash2.default }),
	                                                _react2.default.createElement(
	                                                            _reactRouter.Route,
	                                                            { path: 'gallery' },
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'engagement-rings', component: _Gallery.GalleryContainer, productMode: 'engagement' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'wedding-bands/mens', component: _Gallery.GalleryContainer, productMode: 'mensbands' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'wedding-bands/womens', component: _Gallery.GalleryContainer, productMode: 'womensbands' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'fine-jewelry', component: _Gallery.GalleryContainer, productMode: 'fashion' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'mens-jewelry', component: _Gallery.GalleryContainer, productMode: 'mens' })
	                                                ),
	                                                _react2.default.createElement(
	                                                            _reactRouter.Route,
	                                                            { path: 'education' },
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'diamonds', component: _EducationDiamond2.default }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'gems-and-pearls', component: _EducationGem2.default }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'metals', component: _EducationMetal2.default }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'styles', component: _EducationStyle2.default }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'conflict-free', component: _EducationConflict2.default }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'lab-grown', component: _EducationLabGrown.EducationLabGrownContainer })
	                                                ),
	                                                _react2.default.createElement(
	                                                            _reactRouter.Route,
	                                                            { path: 'jewelry-box' },
	                                                            _react2.default.createElement(_reactRouter.IndexRoute, { component: _Influencers2.default }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'brightonbutler', component: _InfluenceBrightonbutler.InfluenceBrightonbutlerContainer }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'courtnwilliams', component: _InfluenceCourtnwilliams.InfluenceCourtnwilliamsContainer }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'meganrunionmcr', component: _InfluenceMeganrunionmcr.InfluenceMeganrunionmcrContainer }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'hauteofftherack', component: _InfluenceHauteofftherack.InfluenceHauteofftherackContainer }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'aubreyalley', component: _InfluenceAubreyalley.InfluenceAubreyalleyContainer })
	                                                ),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'setting/:lookupKey', component: _ProductPage.ProductPageContainer, product_type: 'setting' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'jewelry/:lookupKey', component: _ProductPage.ProductPageContainer, product_type: 'jewelry' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'diamond/:lookupKey', component: _ProductPage.ProductPageContainer, product_type: 'diamond' }),
	                                                _react2.default.createElement(_reactRouter.Route, { path: 'band/:lookupKey', component: _ProductPage.ProductPageContainer, product_type: 'jewelry' }),
	                                                _react2.default.createElement(
	                                                            _reactRouter.Route,
	                                                            { path: 'designer' },
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'a-jaffe', component: _SingleDesigner2.default, designer_code: 'ajaffe' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'artcarved', component: _SingleDesigner2.default, designer_code: 'artcarved' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'c-gonshor', component: _SingleDesigner2.default, designer_code: 'cgonshor' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'christian-bauer', component: _SingleDesigner2.default, designer_code: 'christianbauer' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'christopher-designs', component: _SingleDesigner2.default, designer_code: 'christopherdesigns' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'coast-diamond', component: _SingleDesigner2.default, designer_code: 'coast' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'fana', component: _SingleDesigner2.default, designer_code: 'fana' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'furrer-jacot', component: _SingleDesigner2.default, designer_code: 'furrerjacot' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'gottlieb', component: _SingleDesigner2.default, designer_code: 'gottlieb' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'henri-daussi', component: _SingleDesigner2.default, designer_code: 'henridaussi' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'jack-kelege', component: _SingleDesigner2.default, designer_code: 'jackkelege' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'jeff-cooper', component: _SingleDesigner2.default, designer_code: 'jeffcooper' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'kirk-kara', component: _SingleDesigner2.default, designer_code: 'kirkkara' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'mastoloni', component: _SingleDesigner2.default, designer_code: 'mastoloni' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'michael-m', component: _SingleDesigner2.default, designer_code: 'michaelm' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'novell', component: _SingleDesigner2.default, designer_code: 'novell' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'pejay', component: _SingleDesigner2.default, designer_code: 'pejay' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'ses', component: _SingleDesigner2.default, designer_code: 'ses' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'simon-g-jewelry', component: _SingleDesigner2.default, designer_code: 'simong' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'sylvie-collection', component: _SingleDesigner2.default, designer_code: 'sylvie' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'tacori', component: _SingleDesigner2.default, designer_code: 'tacori' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'true-romance', component: _SingleDesigner2.default, designer_code: 'trueromance' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'verragio', component: _SingleDesigner2.default, designer_code: 'verragio' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'amden', component: _SingleDesigner2.default, designer_code: 'amden' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'uneek', component: _SingleDesigner2.default, designer_code: 'uneek' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'odelia', component: _SingleDesigner2.default, designer_code: 'odelia' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'gabriel', component: _SingleDesigner2.default, designer_code: 'gabriel' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'classique', component: _SingleDesigner2.default, designer_code: 'classique' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'per-amore', component: _SingleDesigner2.default, designer_code: 'peramore' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'benchmark', component: _SingleDesigner2.default, designer_code: 'benchmark' }),
	                                                            _react2.default.createElement(_reactRouter.Route, { path: 'diamonds-direct-designs', component: _SingleDesigner2.default, designer_code: 'dddesigns' })
	                                                )
	                                    )
	                        )
	            )
	), document.getElementById('diamonds-direct'));

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reducer;
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	var _storage = __webpack_require__(171);
	
	var storage = _interopRequireWildcard(_storage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	  token: storage.get('token'),
	  expiry: storage.get('tokenExpiry')
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.AUTH_SAVE:
	      return authSave(state, action);
	    default:
	      return state;
	  }
	}
	
	function authSave(state, action) {
	  return Object.assign({}, state, {
	    token: action.token,
	    tokenExpiry: action.tokenExpiry
	  });
	}

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reducer;
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	  // resultsSource: 'online',
	  // resultsStore: null,
	  // resultsSortParam: null,
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // case constants.RESULTS_SET_SOURCE:
	    //   return resultsSetSource(state, action);
	    // case constants.RESULTS_SET_SOURCE_LOCATION:
	    //   return resultsSetSourceLocation(state, action);
	    // case constants.RESULTS_SET_SORT:
	    //   return resultsSetSort(state, action);
	    default:
	      return state;
	  }
	}
	
	// function resultsSetSource(state, action) {
	//   return Object.assign({}, state, {
	//     resultsSource: action.source,
	//   });
	// }
	
	// function resultsSetSourceLocation(state, action) {
	//   return Object.assign({}, state, {
	//     resultsStore: action.store,
	//   });
	// }
	
	// function resultsSetSort(state, action) {
	//   return Object.assign({}, state, {
	//     resultsSortParam: action.param,
	//   });
	// }

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reducer;
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	  alertOpen: false,
	  alertText: '',
	  alertPrompt: null,
	  alertTheme: null,
	  alertNav: null,
	  modalResize: 1,
	  contactOpen: false,
	  notifyOpen: false,
	  loginOpen: false,
	  registerNavChange: 1
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.COMMON_ALERT:
	      return commonOpenAlert(state, action);
	    case constants.COMMON_CLOSE_ALERT:
	      return commonCloseAlert(state, action);
	    case constants.COMMON_MODAL_RESIZE:
	      return commonModalResize(state, action);
	    case constants.COMMON_OPEN_CONTACT:
	      return commonOpenContact(state, action);
	    case constants.COMMON_CLOSE_CONTACT:
	      return commonCloseContact(state, action);
	    case constants.COMMON_NOTIFY:
	      return commonOpenNotify(state, action);
	    case constants.COMMON_CLOSE_NOTIFY:
	      return commonCloseNotify(state, action);
	    case constants.COMMON_OPEN_LOGIN:
	      return commonOpenLogin(state, action);
	    case constants.COMMON_CLOSE_LOGIN:
	      return commonCloseLogin(state, action);
	    case constants.COMMON_NAV_CHANGE:
	      return commonNavChange(state, action);
	    default:
	      return state;
	  }
	}
	
	function commonOpenAlert(state, action) {
	  return Object.assign({}, state, {
	    alertOpen: true,
	    alertText: action.text,
	    alertPrompt: action.prompt,
	    alertTheme: action.theme,
	    alertNav: action.nav
	  });
	}
	
	function commonCloseAlert(state, action) {
	  return Object.assign({}, state, {
	    alertOpen: false,
	    alertText: '',
	    alertPrompt: null,
	    alertTheme: null,
	    alertNav: null
	  });
	}
	
	function commonModalResize(state, action) {
	  return Object.assign({}, state, {
	    modalResize: state.modalResize + 0.1
	  });
	}
	
	function commonOpenContact(state, action) {
	  return Object.assign({}, state, {
	    contactOpen: true
	  });
	}
	
	function commonCloseContact(state, action) {
	  return Object.assign({}, state, {
	    contactOpen: false
	  });
	}
	
	function commonOpenNotify(state, action) {
	  return Object.assign({}, state, {
	    notifyOpen: true
	  });
	}
	
	function commonCloseNotify(state, action) {
	  return Object.assign({}, state, {
	    notifyOpen: false
	  });
	}
	
	function commonOpenLogin(state, action) {
	  return Object.assign({}, state, {
	    loginOpen: true
	  });
	}
	
	function commonCloseLogin(state, action) {
	  return Object.assign({}, state, {
	    loginOpen: false
	  });
	}
	
	function commonNavChange(state, action) {
	  return Object.assign({}, state, {
	    registerNavChange: state.registerNavChange + 0.1
	  });
	}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reducer;
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	  menuOpen: false,
	  menuSubmenu: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.HEADER_TOGGLE:
	      return headerToggle(state, action);
	    case constants.HEADER_SUBMENU:
	      return headerSubmenu(state, action);
	    default:
	      return state;
	  }
	}
	
	function headerToggle(state, action) {
	  var nextState = !state.menuOpen;
	  return Object.assign({}, state, {
	    menuOpen: nextState,
	    menuSubmenu: null
	  });
	}
	
	function headerSubmenu(state, action) {
	  return Object.assign({}, state, {
	    menuSubmenu: action.submenu
	  });
	}

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(209);
	
	var _auth = __webpack_require__(616);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _cart = __webpack_require__(617);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _common = __webpack_require__(618);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _header = __webpack_require__(619);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _product = __webpack_require__(621);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _results = __webpack_require__(622);
	
	var _results2 = _interopRequireDefault(_results);
	
	var _user = __webpack_require__(623);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appReducer = (0, _redux.combineReducers)({
	  auth: _auth2.default,
	  cart: _cart2.default,
	  common: _common2.default,
	  header: _header2.default,
	  product: _product2.default,
	  results: _results2.default,
	  user: _user2.default
	});
	
	exports.default = function (state, action) {
	  if (action.type === 'AUTH_CLEAR') {
	    state = undefined;
	  }
	
	  return appReducer(state, action);
	};

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reducer;
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	var _storage = __webpack_require__(171);
	
	var storage = _interopRequireWildcard(_storage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initDiamonds = {
	  // shape: 'Round,Oval,Cushion',
	  // caratMin: 0.50,
	  // caratMax: 4.00,
	  // color: 'F,G,H,I',
	  // clarityMin: 'SI2',
	  // clarityMax: 'VS2',
	};
	
	var initSettings = {
	  type: 'engagement'
	  // priceMin: 500,
	};
	
	var initMensBand = {
	  type: 'mensband'
	  // finish: 'polished,matte',
	  // carved: 'classic,milgrain,textured,engraved,diamond',
	  // priceMin: 500,
	};
	
	var initWomensBand = {
	  type: 'womensband'
	  // priceMin: 300,
	};
	
	var initFashion = {
	  type: 'ring,earring,necklace,bracelet'
	  // priceMin: 100,
	};
	
	var initMensJewelry = {
	  type: 'mring,mnecklace,chains,mbracelet'
	  // priceMin: 100,
	};
	
	// const initFashionRing = {
	//   type: 'ring',
	//   // settingtype: 'Solitaire,ThreeStone,Halo,Pave',
	// };
	
	// const initFashionEarring = {
	//   type: 'engagement',
	//   // settingtype: 'Solitaire,ThreeStone,Halo,Pave',
	// };
	
	// const initFashionNecklace = {
	//   type: 'engagement',
	//   // settingtype: 'Solitaire,ThreeStone,Halo,Pave',
	// };
	
	// const initFashionBracelet = {
	//   type: 'engagement',
	//   // settingtype: 'Solitaire,ThreeStone,Halo,Pave',
	// };
	
	var selDiamond = storage.get('selectedDiamond') ? JSON.parse(storage.get('selectedDiamond')) : null;
	var selSetting = storage.get('selectedSetting') ? JSON.parse(storage.get('selectedSetting')) : null;
	
	var initialState = {
	  diamondResults: null,
	  diamondResultsCount: null,
	  // diamondFilters: storage.get('diamondFilters') ? JSON.parse(storage.get('diamondFilters')) : initDiamonds,
	  diamondFilters: initDiamonds,
	
	  productResults: null,
	  productResultsCount: null,
	  productResultsType: null,
	  // productFilters: storage.get('productFilters') ? JSON.parse(storage.get('productFilters')) : initSettings,
	  productFilters: {},
	
	  selectedDiamond: selDiamond,
	  selectedSetting: selSetting,
	
	  floatingHeaderOpen: false,
	  // floatingHeaderOpen: selDiamond !== null || selSetting !== null,
	
	  compareDiamonds: [],
	  compareSettings: [],
	  compareBands: [],
	  compareFashion: [],
	
	  currentPage: 1,
	  currentDiamondPage: 1,
	
	  attrSize: storage.get('attrSize') ? storage.get('attrSize') : '',
	  attrMetal: storage.get('attrMetal') ? storage.get('attrMetal') : ''
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.PRODUCT_SAVE_DIAMONDS:
	      return productSaveDiamondResults(state, action);
	    case constants.PRODUCT_SAVE_SETTINGS:
	      return productSaveSettingResults(state, action);
	    case constants.PRODUCT_SAVE_DIAMOND_QUERY:
	      return productSaveDiamondFilters(state, action);
	    case constants.PRODUCT_SAVE_SETTING_QUERY:
	      return productSaveSettingFilters(state, action);
	    case constants.PRODUCT_SELECT_SETTING:
	      return productSelectSetting(state, action);
	    case constants.PRODUCT_SELECT_DIAMOND:
	      return productSelectDiamond(state, action);
	    case constants.PRODUCT_COMPARE_SETTING:
	      return productCompareSetting(state, action);
	    case constants.PRODUCT_COMPARE_DIAMOND:
	      return productCompareDiamond(state, action);
	    case constants.PRODUCT_COMPARE_BAND:
	      return productCompareBand(state, action);
	    case constants.PRODUCT_COMPARE_FASHION:
	      return productCompareFashion(state, action);
	    case constants.PRODUCT_CLEAR_QUERY:
	      return productClearQuery(state, action);
	    case constants.PRODUCT_SET_PAGE:
	      return productSetPage(state, action);
	    case constants.PRODUCT_ADD_DIAMONDS:
	      return productAddDiamondsResults(state, action);
	
	    case constants.PRODUCT_RESET_DIAMOND_QUERY:
	      return productResetDiamondFilters(state, action);
	    case constants.PRODUCT_RESET_PRODUCT_QUERY:
	      return productResetProductFilters(state, action);
	
	    case constants.PRODUCT_ATTR_SIZE:
	      return productAttrSize(state, action);
	    case constants.PRODUCT_ATTR_METAL:
	      return productAttrMetal(state, action);
	    case constants.PRODUCT_FLOATING_HEADER_TOGGLE:
	      return productToggleFloatingHeader(state, action);
	
	    case constants.PRODUCT_APPEND_DIAMONDS:
	      return productAppendDiamondResults(state, action);
	
	    default:
	      return state;
	  }
	}
	
	function productSaveDiamondResults(state, action) {
	  return Object.assign({}, state, {
	    diamondResults: action.diamonds,
	    diamondResultsCount: action.diamondCount,
	    currentDiamondPage: 1
	  });
	}
	
	function productAppendDiamondResults(state, action) {
	  var moreDiamonds = state.diamondResults.concat(action.diamonds);
	  return Object.assign({}, state, {
	    diamondResults: moreDiamonds,
	    currentDiamondPage: state.currentDiamondPage + 1
	  });
	}
	
	function productAddDiamondsResults(state, action) {
	
	  var newDiamonds = [];
	  for (var i = 0; i < state.diamondResults.length; i++) {
	    newDiamonds.push(state.diamondResults[i]);
	  }
	
	  for (var j = 0; j < action.diamonds.length; j++) {
	    newDiamonds.push(action.diamonds[j]);
	  }
	
	  return Object.assign({}, state, {
	    diamondResults: newDiamonds,
	    currentDiamondPage: action.diamondPage
	  });
	}
	
	function productSaveSettingResults(state, action) {
	  return Object.assign({}, state, {
	    productResults: action.products,
	    productResultsCount: action.productCount
	  });
	}
	
	function productSaveDiamondFilters(state, action) {
	
	  var mergedFilters = Object.assign({}, state.diamondFilters, action.filters);
	  // storage.put('diamondFilters', JSON.stringify(mergedFilters));
	
	  return Object.assign({}, state, {
	    diamondFilters: mergedFilters,
	    productResultsType: action.queryType,
	    diamondResults: null,
	    currentPage: action.pageNum,
	    currentDiamondPage: 1
	  });
	}
	
	function productResetDiamondFilters(state, action) {
	
	  var mergedFilters = Object.assign({}, initDiamonds);
	  return Object.assign({}, state, {
	    diamondFilters: initDiamonds,
	    diamondResults: null,
	    currentPage: 1,
	    currentDiamondPage: 1
	  });
	}
	
	function productSaveSettingFilters(state, action) {
	
	  // queryType options:
	  // setting
	  // mensband
	  // womensband
	  // fashion
	
	  var mergedFilters = null;
	  switch (action.queryType) {
	    case 'setting':
	      mergedFilters = Object.assign({}, initSettings, state.productFilters, action.filters);
	      break;
	    case 'mensband':
	      mergedFilters = Object.assign({}, initMensBand, state.productFilters, action.filters);
	      break;
	    case 'womensband':
	      mergedFilters = Object.assign({}, initWomensBand, state.productFilters, action.filters);
	      break;
	    case 'fashion':
	      mergedFilters = Object.assign({}, initFashion, state.productFilters, action.filters);
	      break;
	    case 'mens':
	      mergedFilters = Object.assign({}, initMensJewelry, state.productFilters, action.filters);
	      break;
	    default:
	      mergedFilters = Object.assign({}, state.productFilters, action.filters);
	  }
	
	  // storage.put('productFilters', JSON.stringify(mergedFilters));
	
	  return Object.assign({}, state, {
	    productFilters: mergedFilters,
	    productResults: null,
	    currentPage: action.pageNum
	  });
	}
	
	function productResetProductFilters(state, action) {
	
	  // queryType options:
	  // setting
	  // mensband
	  // womensband
	  // fashion
	
	  var mergedFilters = null;
	  switch (action.queryType) {
	    case 'setting':
	      mergedFilters = Object.assign({}, initSettings);
	      break;
	    case 'mensband':
	      mergedFilters = Object.assign({}, initMensBand);
	      break;
	    case 'womensband':
	      mergedFilters = Object.assign({}, initWomensBand);
	      break;
	    case 'fashion':
	      mergedFilters = Object.assign({}, initFashion);
	      break;
	    default:
	      mergedFilters = Object.assign({});
	  }
	
	  return Object.assign({}, state, {
	    productFilters: mergedFilters,
	    productResults: null,
	    currentPage: 1
	  });
	}
	
	function productSelectSetting(state, action) {
	
	  storage.put('selectedSetting', JSON.stringify(action.setting));
	
	  if (action.metalType) {
	    storage.put('attrMetal', action.metalType);
	  }
	
	  if (action.ringSize) {
	    storage.put('attrSize', action.ringSize);
	  }
	
	  return Object.assign({}, state, {
	    selectedSetting: action.setting,
	    attrSize: action.ringSize,
	    attrMetal: action.metalType
	  });
	}
	
	function productSelectDiamond(state, action) {
	
	  storage.put('selectedDiamond', JSON.stringify(action.diamond));
	
	  return Object.assign({}, state, {
	    selectedDiamond: action.diamond
	  });
	}
	
	function productCompareSetting(state, action) {
	  return Object.assign({}, state, {
	    compareSettings: action.setting
	  });
	}
	
	function productCompareDiamond(state, action) {
	
	  storage.put('compareDiamonds', JSON.stringify(action.diamond));
	
	  return Object.assign({}, state, {
	    compareDiamonds: action.diamond
	  });
	}
	
	function productCompareBand(state, action) {
	  return Object.assign({}, state, {
	    compareBands: action.band
	  });
	}
	
	function productCompareFashion(state, action) {
	  return Object.assign({}, state, {
	    compareFashion: action.jewelry
	  });
	}
	
	function productClearQuery(state, action) {
	
	  // storage.put('diamondFilters', JSON.stringify(initDiamonds));
	  // storage.put('productFilters', JSON.stringify(initSettings));
	
	  return Object.assign({}, state, {
	    diamondResults: null,
	    diamondResultsCount: null,
	    diamondFilters: initDiamonds,
	
	    productResults: null,
	    productResultsCount: null,
	    productResultsType: null,
	    productFilters: {},
	    currentPage: 1,
	    currentDiamondPage: 1
	  });
	}
	
	function productSetPage(state, action) {
	  return Object.assign({}, state, {
	    currentPage: action.page
	  });
	}
	
	function productAttrSize(state, action) {
	  return Object.assign({}, state, {
	    attrSize: action.size
	  });
	}
	
	function productAttrMetal(state, action) {
	  return Object.assign({}, state, {
	    attrMetal: action.metal
	  });
	}
	
	function productToggleFloatingHeader(state, action) {
	  return Object.assign({}, state, {
	    floatingHeaderOpen: action.position
	  });
	}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reducer;
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	  resultsSource: 'online',
	  resultsStore: null,
	  resultsSortParam: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.RESULTS_SET_SOURCE:
	      return resultsSetSource(state, action);
	    case constants.RESULTS_SET_SOURCE_LOCATION:
	      return resultsSetSourceLocation(state, action);
	    case constants.RESULTS_SET_SORT:
	      return resultsSetSort(state, action);
	    default:
	      return state;
	  }
	}
	
	function resultsSetSource(state, action) {
	  return Object.assign({}, state, {
	    resultsSource: action.source
	  });
	}
	
	function resultsSetSourceLocation(state, action) {
	  return Object.assign({}, state, {
	    resultsStore: action.store
	  });
	}
	
	function resultsSetSort(state, action) {
	  return Object.assign({}, state, {
	    resultsSortParam: action.param
	  });
	}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reducer;
	
	var _actions = __webpack_require__(48);
	
	var constants = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	  userCore: null,
	  userProfile: null,
	  wishlists: null,
	  orders: null,
	  externalOrders: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case constants.USER_CORE_SET:
	      return userCoreSet(state, action);
	    case constants.USER_PROFILE_SET:
	      return userProfileSet(state, action);
	    case constants.USER_WISHLISTS_SET:
	      return userWishlistsSet(state, action);
	    case constants.USER_ORDERS_SET:
	      return userOrdersSet(state, action);
	    case constants.USER_EXTERNAL_ORDERS_SET:
	      return userExternalOrdersSet(state, action);
	    default:
	      return state;
	  }
	}
	
	function userCoreSet(state, action) {
	  return Object.assign({}, state, {
	    userCore: action.user
	  });
	}
	
	function userProfileSet(state, action) {
	  return Object.assign({}, state, {
	    userProfile: action.user
	  });
	}
	
	function userWishlistsSet(state, action) {
	  return Object.assign({}, state, {
	    wishlists: action.wishlists
	  });
	}
	
	function userOrdersSet(state, action) {
	  return Object.assign({}, state, {
	    orders: action.orders
	  });
	}
	
	function userExternalOrdersSet(state, action) {
	  return Object.assign({}, state, {
	    externalOrders: action.orders
	  });
	}

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(320);
	
	var colors = _interopRequireWildcard(_colors);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Colors = __webpack_require__(196);
	var ColorManipulator = __webpack_require__(85);
	var Spacing = __webpack_require__(418);
	
	exports.default = {
	  spacing: Spacing,
	  fontFamily: 'Lato, sans-serif',
	  palette: {
	    primary1Color: Colors.cyan700,
	    primary2Color: Colors.cyan700,
	    primary3Color: Colors.lightBlack,
	    accent1Color: Colors.grey100,
	    accent2Color: Colors.grey100,
	    accent3Color: Colors.grey500,
	    textColor: Colors.darkBlack,
	    alternateTextColor: Colors.white,
	    canvasColor: Colors.white,
	    borderColor: Colors.grey300,
	    disabledColor: ColorManipulator.fade(Colors.darkBlack, 0.3)
	  }
	};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(209);
	
	var _reduxThunk = __webpack_require__(1216);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _index = __webpack_require__(620);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStoreWithMiddleware = (0, _redux.applyMiddleware)(_reduxThunk2.default)(_redux.createStore);
	
	function configureStore(initialState) {
	  var store = createStoreWithMiddleware(_index2.default, initialState);
	  return store;
	}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.dynamicSort = dynamicSort;
	function dynamicSort(property) {
		var reverseOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		var sortOrder = reverseOrder ? -1 : 1;
		return function (a, b) {
			a[property] = a[property] === null ? '' : a[property];
			b[property] = b[property] === null ? '' : b[property];
			var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
			if (typeof a[property] === 'string' && typeof b[property] === 'string') {
				result = a[property].toLowerCase() < b[property].toLowerCase() ? -1 : a[property].toLowerCase() > b[property].toLowerCase() ? 1 : 0;
			}
			return result * sortOrder;
		};
	}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocationNameById = getLocationNameById;
	exports.getIdByLocation = getIdByLocation;
	exports.getStoreByNumber = getStoreByNumber;
	
	var _locations = __webpack_require__(220);
	
	function getLocationNameById(locNum) {
	
	  if (!locNum) {
	    return '';
	  }
	
	  switch (locNum) {
	    case 1:
	      return 'Charlotte';
	    case 2:
	      return 'Headquarters';
	    case 3:
	      return 'Birmingham';
	    case 4:
	      return 'Raleigh';
	    case 5:
	      return 'Austin';
	    case 6:
	      return 'Richmond';
	    case 7:
	      return 'Charleston';
	    case 8:
	      return 'Oklahoma City';
	    case 9:
	      return 'Virginia Beach';
	    case 10:
	      return 'San Antonio';
	    case 11:
	      return 'Dallas';
	    case 12:
	      return 'Indianapolis';
	    case 13:
	      return 'St. Louis';
	    case 14:
	      return 'Jacksonville';
	    case 15:
	      return 'Salt Lake City';
	    case 16:
	      return 'Columbus';
	    case 17:
	      return 'Cleveland';
	    case 18:
	      return 'Frisco';
	    case 19:
	      return 'Kansas City';
	    case 20:
	      return 'New Orleans';
	    case 21:
	      return 'Boca Raton';
	    default:
	      return '';
	  }
	}
	
	function getIdByLocation(locationDisplay) {
	  switch (locationDisplay) {
	    case 'Charlotte':
	      return 1;
	    case 'Headquarters':
	      return 2;
	    case 'Birmingham':
	      return 3;
	    case 'Raleigh':
	      return 4;
	    case 'Austin':
	      return 5;
	    case 'Richmond':
	      return 6;
	    case 'Charleston':
	      return 7;
	    case 'Oklahoma City':
	      return 8;
	    case 'Virginia Beach':
	      return 9;
	    case 'San Antonio':
	      return 10;
	    case 'Dallas':
	      return 11;
	    case 'Indianapolis':
	      return 12;
	    case 'St. Louis':
	      return 13;
	    case 'Jacksonville':
	      return 14;
	    case 'Salt Lake City':
	      return 15;
	    case 'Columbus':
	      return 16;
	    case 'Cleveland':
	      return 17;
	    case 'Frisco':
	      return 18;
	    case 'Kansas City':
	      return 19;
	    case 'New Orleans':
	      return 20;
	    case 'Boca Raton':
	      return 21;
	    default:
	      return '';
	  }
	}
	
	function getStoreByNumber(locNum) {
	
	  console.log(locNum);
	  console.log(_locations.locations);
	
	  for (var i = 0; i < _locations.locations.length; i++) {
	    if (_locations.locations[i].number == parseInt(locNum)) {
	      return _locations.locations[i];
	    }
	  }
	}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(883);
	
	__webpack_require__(1220);
	
	__webpack_require__(640);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(643), __esModule: true };

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(645), __esModule: true };

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(649), __esModule: true };

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(650), __esModule: true };

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(651), __esModule: true };

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(1229)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)(o|0)s/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/Whale/i.test(ua)) {
	      result = {
	        name: 'NAVER Whale browser'
	        , whale: t
	        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/MZBrowser/i.test(ua)) {
	      result = {
	        name: 'MZ Browser'
	        , mzbrowser: t
	        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/focus/i.test(ua)) {
	      result = {
	        name: 'Focus'
	        , focus: t
	        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
	        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
	        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ }),
/* 635 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var type;
	try {
	  type = __webpack_require__(224);
	} catch (_) {
	  type = __webpack_require__(224);
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = clone;
	
	/**
	 * Clones objects.
	 *
	 * @param {Mixed} any object
	 * @api public
	 */
	
	function clone(obj){
	  switch (type(obj)) {
	    case 'object':
	      var copy = {};
	      for (var key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          copy[key] = clone(obj[key]);
	        }
	      }
	      return copy;
	
	    case 'array':
	      var copy = new Array(obj.length);
	      for (var i = 0, l = obj.length; i < l; i++) {
	        copy[i] = clone(obj[i]);
	      }
	      return copy;
	
	    case 'regexp':
	      // from millermedeiros/amd-utils - MIT
	      var flags = '';
	      flags += obj.multiline ? 'm' : '';
	      flags += obj.global ? 'g' : '';
	      flags += obj.ignoreCase ? 'i' : '';
	      return new RegExp(obj.source, flags);
	
	    case 'date':
	      return new Date(obj.getTime());
	
	    default: // string, number, boolean, …
	      return obj;
	  }
	}


/***/ }),
/* 637 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 638 */
/***/ (function(module, exports) {

	/**
	 * Expose `requestAnimationFrame()`.
	 */
	
	exports = module.exports = window.requestAnimationFrame
	  || window.webkitRequestAnimationFrame
	  || window.mozRequestAnimationFrame
	  || fallback;
	
	/**
	 * Fallback implementation.
	 */
	
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime();
	  var ms = Math.max(0, 16 - (curr - prev));
	  var req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	/**
	 * Cancel.
	 */
	
	var cancel = window.cancelAnimationFrame
	  || window.webkitCancelAnimationFrame
	  || window.mozCancelAnimationFrame
	  || window.clearTimeout;
	
	exports.cancel = function(id){
	  cancel.call(window, id);
	};


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(637);
	var clone = __webpack_require__(636);
	var type = __webpack_require__(224);
	var ease = __webpack_require__(886);
	
	/**
	 * Expose `Tween`.
	 */
	
	module.exports = Tween;
	
	/**
	 * Initialize a new `Tween` with `obj`.
	 *
	 * @param {Object|Array} obj
	 * @api public
	 */
	
	function Tween(obj) {
	  if (!(this instanceof Tween)) return new Tween(obj);
	  this._from = obj;
	  this.ease('linear');
	  this.duration(500);
	}
	
	/**
	 * Mixin emitter.
	 */
	
	Emitter(Tween.prototype);
	
	/**
	 * Reset the tween.
	 *
	 * @api public
	 */
	
	Tween.prototype.reset = function(){
	  this.isArray = 'array' === type(this._from);
	  this._curr = clone(this._from);
	  this._done = false;
	  this._start = Date.now();
	  return this;
	};
	
	/**
	 * Tween to `obj` and reset internal state.
	 *
	 *    tween.to({ x: 50, y: 100 })
	 *
	 * @param {Object|Array} obj
	 * @return {Tween} self
	 * @api public
	 */
	
	Tween.prototype.to = function(obj){
	  this.reset();
	  this._to = obj;
	  return this;
	};
	
	/**
	 * Set duration to `ms` [500].
	 *
	 * @param {Number} ms
	 * @return {Tween} self
	 * @api public
	 */
	
	Tween.prototype.duration = function(ms){
	  this._duration = ms;
	  return this;
	};
	
	/**
	 * Set easing function to `fn`.
	 *
	 *    tween.ease('in-out-sine')
	 *
	 * @param {String|Function} fn
	 * @return {Tween}
	 * @api public
	 */
	
	Tween.prototype.ease = function(fn){
	  fn = 'function' == typeof fn ? fn : ease[fn];
	  if (!fn) throw new TypeError('invalid easing function');
	  this._ease = fn;
	  return this;
	};
	
	/**
	 * Stop the tween and immediately emit "stop" and "end".
	 *
	 * @return {Tween}
	 * @api public
	 */
	
	Tween.prototype.stop = function(){
	  this.stopped = true;
	  this._done = true;
	  this.emit('stop');
	  this.emit('end');
	  return this;
	};
	
	/**
	 * Perform a step.
	 *
	 * @return {Tween} self
	 * @api private
	 */
	
	Tween.prototype.step = function(){
	  if (this._done) return;
	
	  // duration
	  var duration = this._duration;
	  var now = Date.now();
	  var delta = now - this._start;
	  var done = delta >= duration;
	
	  // complete
	  if (done) {
	    this._from = this._to;
	    this._update(this._to);
	    this._done = true;
	    this.emit('end');
	    return this;
	  }
	
	  // tween
	  var from = this._from;
	  var to = this._to;
	  var curr = this._curr;
	  var fn = this._ease;
	  var p = (now - this._start) / duration;
	  var n = fn(p);
	
	  // array
	  if (this.isArray) {
	    for (var i = 0; i < from.length; ++i) {
	      curr[i] = from[i] + (to[i] - from[i]) * n;
	    }
	
	    this._update(curr);
	    return this;
	  }
	
	  // objech
	  for (var k in from) {
	    curr[k] = from[k] + (to[k] - from[k]) * n;
	  }
	
	  this._update(curr);
	  return this;
	};
	
	/**
	 * Set update function to `fn` or
	 * when no argument is given this performs
	 * a "step".
	 *
	 * @param {Function} fn
	 * @return {Tween} self
	 * @api public
	 */
	
	Tween.prototype.update = function(fn){
	  if (0 == arguments.length) return this.step();
	  this._update = fn;
	  return this;
	};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(691);
	module.exports = __webpack_require__(67).RegExp.escape;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(176);
	__webpack_require__(673);
	module.exports = __webpack_require__(43).Array.from;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(238);
	__webpack_require__(176);
	module.exports = __webpack_require__(671);


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(238);
	__webpack_require__(176);
	module.exports = __webpack_require__(672);


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(675);
	module.exports = __webpack_require__(43).Object.assign;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(676);
	var $Object = __webpack_require__(43).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(677);
	var $Object = __webpack_require__(43).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(678);
	module.exports = __webpack_require__(43).Object.getPrototypeOf;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(679);
	module.exports = __webpack_require__(43).Object.keys;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(680);
	module.exports = __webpack_require__(43).Object.setPrototypeOf;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(682);
	__webpack_require__(681);
	__webpack_require__(683);
	__webpack_require__(684);
	module.exports = __webpack_require__(43).Symbol;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(176);
	__webpack_require__(238);
	module.exports = __webpack_require__(237).f('iterator');


/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(128);
	var toLength = __webpack_require__(338);
	var toAbsoluteIndex = __webpack_require__(670);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(92);
	var createDesc = __webpack_require__(156);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(155);
	var gOPS = __webpack_require__(230);
	var pIE = __webpack_require__(174);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(91).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(127);
	var ITERATOR = __webpack_require__(65)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(225);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(101);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(229);
	var descriptor = __webpack_require__(156);
	var setToStringTag = __webpack_require__(231);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(125)(IteratorPrototype, __webpack_require__(65)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(65)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 663 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(175)('meta');
	var isObject = __webpack_require__(126);
	var has = __webpack_require__(102);
	var setDesc = __webpack_require__(92).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(124)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(89);
	var getKeys = __webpack_require__(155);
	var gOPS = __webpack_require__(230);
	var pIE = __webpack_require__(174);
	var toObject = __webpack_require__(129);
	var IObject = __webpack_require__(330);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(124)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(92);
	var anObject = __webpack_require__(101);
	var getKeys = __webpack_require__(155);
	
	module.exports = __webpack_require__(89) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(128);
	var gOPN = __webpack_require__(333).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(126);
	var anObject = __webpack_require__(101);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(226)(Function.call, __webpack_require__(332).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(234);
	var defined = __webpack_require__(227);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(234);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(101);
	var get = __webpack_require__(339);
	module.exports = __webpack_require__(43).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(327);
	var ITERATOR = __webpack_require__(65)('iterator');
	var Iterators = __webpack_require__(127);
	module.exports = __webpack_require__(43).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(226);
	var $export = __webpack_require__(90);
	var toObject = __webpack_require__(129);
	var call = __webpack_require__(660);
	var isArrayIter = __webpack_require__(658);
	var toLength = __webpack_require__(338);
	var createProperty = __webpack_require__(655);
	var getIterFn = __webpack_require__(339);
	
	$export($export.S + $export.F * !__webpack_require__(662)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(653);
	var step = __webpack_require__(663);
	var Iterators = __webpack_require__(127);
	var toIObject = __webpack_require__(128);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(331)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(90);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(665) });


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(90);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(229) });


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(90);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(89), 'Object', { defineProperty: __webpack_require__(92).f });


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(129);
	var $getPrototypeOf = __webpack_require__(334);
	
	__webpack_require__(336)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(129);
	var $keys = __webpack_require__(155);
	
	__webpack_require__(336)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(90);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(668).set });


/***/ }),
/* 681 */
/***/ (function(module, exports) {



/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(91);
	var has = __webpack_require__(102);
	var DESCRIPTORS = __webpack_require__(89);
	var $export = __webpack_require__(90);
	var redefine = __webpack_require__(337);
	var META = __webpack_require__(664).KEY;
	var $fails = __webpack_require__(124);
	var shared = __webpack_require__(233);
	var setToStringTag = __webpack_require__(231);
	var uid = __webpack_require__(175);
	var wks = __webpack_require__(65);
	var wksExt = __webpack_require__(237);
	var wksDefine = __webpack_require__(236);
	var enumKeys = __webpack_require__(656);
	var isArray = __webpack_require__(659);
	var anObject = __webpack_require__(101);
	var isObject = __webpack_require__(126);
	var toObject = __webpack_require__(129);
	var toIObject = __webpack_require__(128);
	var toPrimitive = __webpack_require__(235);
	var createDesc = __webpack_require__(156);
	var _create = __webpack_require__(229);
	var gOPNExt = __webpack_require__(667);
	var $GOPD = __webpack_require__(332);
	var $GOPS = __webpack_require__(230);
	var $DP = __webpack_require__(92);
	var $keys = __webpack_require__(155);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(333).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(174).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(173)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(125)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(236)('asyncIterator');


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(236)('observable');


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	var isArray = __webpack_require__(180);
	var SPECIES = __webpack_require__(27)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(22);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(16);
	var toPrimitive = __webpack_require__(78);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(107);
	var gOPS = __webpack_require__(184);
	var pIE = __webpack_require__(159);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(160)('native-function-to-string', Function.toString);


/***/ }),
/* 690 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(4);
	var $re = __webpack_require__(690)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(341) });
	
	__webpack_require__(93)('copyWithin');


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $every = __webpack_require__(75)(4);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Array', { fill: __webpack_require__(240) });
	
	__webpack_require__(93)('fill');


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $filter = __webpack_require__(75)(2);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(4);
	var $find = __webpack_require__(75)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(93)(KEY);


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(4);
	var $find = __webpack_require__(75)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(93)(KEY);


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $forEach = __webpack_require__(75)(0);
	var STRICT = __webpack_require__(69)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(68);
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(35);
	var call = __webpack_require__(352);
	var isArrayIter = __webpack_require__(248);
	var toLength = __webpack_require__(29);
	var createProperty = __webpack_require__(242);
	var getIterFn = __webpack_require__(264);
	
	$export($export.S + $export.F * !__webpack_require__(182)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $indexOf = __webpack_require__(177)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(69)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(180) });


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(60);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(158) != Object || !__webpack_require__(69)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(60);
	var toInteger = __webpack_require__(70);
	var toLength = __webpack_require__(29);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(69)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $map = __webpack_require__(75)(1);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var createProperty = __webpack_require__(242);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(22)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $reduce = __webpack_require__(343);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $reduce = __webpack_require__(343);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var html = __webpack_require__(246);
	var cof = __webpack_require__(66);
	var toAbsoluteIndex = __webpack_require__(111);
	var toLength = __webpack_require__(29);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(22)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $some = __webpack_require__(75)(3);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(44);
	var toObject = __webpack_require__(35);
	var fails = __webpack_require__(22);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(69)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(110)('Array');


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(4);
	var toISOString = __webpack_require__(686);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(35);
	var toPrimitive = __webpack_require__(78);
	
	$export($export.P + $export.F * __webpack_require__(22)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(27)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(49)(proto, TO_PRIMITIVE, __webpack_require__(687));


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(50)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Function', { bind: __webpack_require__(344) });


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(24);
	var getPrototypeOf = __webpack_require__(59);
	var HAS_INSTANCE = __webpack_require__(27)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(33).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(33).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(32) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(4);
	var log1p = __webpack_require__(355);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(4);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(4);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(4);
	var sign = __webpack_require__(252);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(4);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(4);
	var $expm1 = __webpack_require__(251);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { fround: __webpack_require__(354) });


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(4);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(4);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(22)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(355) });


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { sign: __webpack_require__(252) });


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(4);
	var expm1 = __webpack_require__(251);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(22)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(4);
	var expm1 = __webpack_require__(251);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(20);
	var has = __webpack_require__(57);
	var cof = __webpack_require__(66);
	var inheritIfRequired = __webpack_require__(247);
	var toPrimitive = __webpack_require__(78);
	var fails = __webpack_require__(22);
	var gOPN = __webpack_require__(106).f;
	var gOPD = __webpack_require__(58).f;
	var dP = __webpack_require__(33).f;
	var $trim = __webpack_require__(133).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(105)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(32) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(50)(global, NUMBER, $Number);
	}


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(4);
	var _isFinite = __webpack_require__(20).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(351) });


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(4);
	var isInteger = __webpack_require__(351);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseFloat = __webpack_require__(363);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseInt = __webpack_require__(364);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toInteger = __webpack_require__(70);
	var aNumberValue = __webpack_require__(340);
	var repeat = __webpack_require__(259);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(22)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $fails = __webpack_require__(22);
	var aNumberValue = __webpack_require__(340);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(4);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(357) });


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(105) });


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(32), 'Object', { defineProperties: __webpack_require__(358) });


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(32), 'Object', { defineProperty: __webpack_require__(33).f });


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(24);
	var meta = __webpack_require__(95).onFreeze;
	
	__webpack_require__(77)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(60);
	var $getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	__webpack_require__(77)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(77)('getOwnPropertyNames', function () {
	  return __webpack_require__(359).f;
	});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(35);
	var $getPrototypeOf = __webpack_require__(59);
	
	__webpack_require__(77)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(24);
	
	__webpack_require__(77)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(24);
	
	__webpack_require__(77)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(24);
	
	__webpack_require__(77)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(4);
	$export($export.S, 'Object', { is: __webpack_require__(367) });


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(35);
	var $keys = __webpack_require__(107);
	
	__webpack_require__(77)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(24);
	var meta = __webpack_require__(95).onFreeze;
	
	__webpack_require__(77)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(24);
	var meta = __webpack_require__(95).onFreeze;
	
	__webpack_require__(77)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(4);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(256).set });


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(130);
	var test = {};
	test[__webpack_require__(27)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(50)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseFloat = __webpack_require__(363);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseInt = __webpack_require__(364);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(94);
	var global = __webpack_require__(20);
	var ctx = __webpack_require__(68);
	var classof = __webpack_require__(130);
	var $export = __webpack_require__(4);
	var isObject = __webpack_require__(24);
	var aFunction = __webpack_require__(44);
	var anInstance = __webpack_require__(103);
	var forOf = __webpack_require__(104);
	var speciesConstructor = __webpack_require__(161);
	var task = __webpack_require__(261).set;
	var microtask = __webpack_require__(253)();
	var newPromiseCapabilityModule = __webpack_require__(254);
	var perform = __webpack_require__(365);
	var userAgent = __webpack_require__(190);
	var promiseResolve = __webpack_require__(366);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(27)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(109)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(132)($Promise, PROMISE);
	__webpack_require__(110)(PROMISE);
	Wrapper = __webpack_require__(67)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(182)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(44);
	var anObject = __webpack_require__(16);
	var rApply = (__webpack_require__(20).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(22)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(4);
	var create = __webpack_require__(105);
	var aFunction = __webpack_require__(44);
	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(24);
	var fails = __webpack_require__(22);
	var bind = __webpack_require__(344);
	var rConstruct = (__webpack_require__(20).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(33);
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(16);
	var toPrimitive = __webpack_require__(78);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(22)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(4);
	var gOPD = __webpack_require__(58).f;
	var anObject = __webpack_require__(16);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(16);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(249)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(58);
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(16);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(4);
	var getProto = __webpack_require__(59);
	var anObject = __webpack_require__(16);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(58);
	var getPrototypeOf = __webpack_require__(59);
	var has = __webpack_require__(57);
	var $export = __webpack_require__(4);
	var isObject = __webpack_require__(24);
	var anObject = __webpack_require__(16);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(16);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(362) });


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(16);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(4);
	var setProto = __webpack_require__(256);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(33);
	var gOPD = __webpack_require__(58);
	var getPrototypeOf = __webpack_require__(59);
	var has = __webpack_require__(57);
	var $export = __webpack_require__(4);
	var createDesc = __webpack_require__(108);
	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(24);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(20);
	var inheritIfRequired = __webpack_require__(247);
	var dP = __webpack_require__(33).f;
	var gOPN = __webpack_require__(106).f;
	var isRegExp = __webpack_require__(181);
	var $flags = __webpack_require__(157);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(32) && (!CORRECT_NEW || __webpack_require__(22)(function () {
	  re2[__webpack_require__(27)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(50)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(110)('RegExp');


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(16);
	var toLength = __webpack_require__(29);
	var advanceStringIndex = __webpack_require__(239);
	var regExpExec = __webpack_require__(185);
	
	// @@match logic
	__webpack_require__(179)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(16);
	var toObject = __webpack_require__(35);
	var toLength = __webpack_require__(29);
	var toInteger = __webpack_require__(70);
	var advanceStringIndex = __webpack_require__(239);
	var regExpExec = __webpack_require__(185);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(179)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(16);
	var sameValue = __webpack_require__(367);
	var regExpExec = __webpack_require__(185);
	
	// @@search logic
	__webpack_require__(179)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(181);
	var anObject = __webpack_require__(16);
	var speciesConstructor = __webpack_require__(161);
	var advanceStringIndex = __webpack_require__(239);
	var toLength = __webpack_require__(29);
	var callRegExpExec = __webpack_require__(185);
	var regexpExec = __webpack_require__(255);
	var fails = __webpack_require__(22);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(179)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(373);
	var anObject = __webpack_require__(16);
	var $flags = __webpack_require__(157);
	var DESCRIPTORS = __webpack_require__(32);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(50)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(22)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(51)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(51)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(51)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(51)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $at = __webpack_require__(188)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(4);
	var toLength = __webpack_require__(29);
	var context = __webpack_require__(258);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(245)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(51)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(51)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(51)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var toAbsoluteIndex = __webpack_require__(111);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(4);
	var context = __webpack_require__(258);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(245)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(51)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(188)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(250)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(51)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(60);
	var toLength = __webpack_require__(29);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(259)
	});


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(51)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(4);
	var toLength = __webpack_require__(29);
	var context = __webpack_require__(258);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(245)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(51)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(51)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(51)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(133)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(20);
	var has = __webpack_require__(57);
	var DESCRIPTORS = __webpack_require__(32);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(50);
	var META = __webpack_require__(95).KEY;
	var $fails = __webpack_require__(22);
	var shared = __webpack_require__(160);
	var setToStringTag = __webpack_require__(132);
	var uid = __webpack_require__(112);
	var wks = __webpack_require__(27);
	var wksExt = __webpack_require__(370);
	var wksDefine = __webpack_require__(263);
	var enumKeys = __webpack_require__(688);
	var isArray = __webpack_require__(180);
	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(24);
	var toObject = __webpack_require__(35);
	var toIObject = __webpack_require__(60);
	var toPrimitive = __webpack_require__(78);
	var createDesc = __webpack_require__(108);
	var _create = __webpack_require__(105);
	var gOPNExt = __webpack_require__(359);
	var $GOPD = __webpack_require__(58);
	var $GOPS = __webpack_require__(184);
	var $DP = __webpack_require__(33);
	var $keys = __webpack_require__(107);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(106).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(159).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(94)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(49)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $typed = __webpack_require__(189);
	var buffer = __webpack_require__(262);
	var anObject = __webpack_require__(16);
	var toAbsoluteIndex = __webpack_require__(111);
	var toLength = __webpack_require__(29);
	var isObject = __webpack_require__(24);
	var ArrayBuffer = __webpack_require__(20).ArrayBuffer;
	var speciesConstructor = __webpack_require__(161);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(22)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(110)(ARRAY_BUFFER);


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	$export($export.G + $export.W + $export.F * !__webpack_require__(189).ABV, {
	  DataView: __webpack_require__(262).DataView
	});


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(347);
	var validate = __webpack_require__(113);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(178)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(348);
	var toObject = __webpack_require__(35);
	var toLength = __webpack_require__(29);
	var aFunction = __webpack_require__(44);
	var arraySpeciesCreate = __webpack_require__(241);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(93)('flatMap');


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(348);
	var toObject = __webpack_require__(35);
	var toLength = __webpack_require__(29);
	var toInteger = __webpack_require__(70);
	var arraySpeciesCreate = __webpack_require__(241);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(93)('flatten');


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(4);
	var $includes = __webpack_require__(177)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(93)('includes');


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(4);
	var microtask = __webpack_require__(253)();
	var process = __webpack_require__(20).process;
	var isNode = __webpack_require__(66)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(4);
	var cof = __webpack_require__(66);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(4);
	
	$export($export.G, { global: __webpack_require__(20) });


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(186)('Map');


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(187)('Map');


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(4);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(346)('Map') });


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var scale = __webpack_require__(356);
	var fround = __webpack_require__(354);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { scale: __webpack_require__(356) });


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(35);
	var aFunction = __webpack_require__(44);
	var $defineProperty = __webpack_require__(33);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(32) && $export($export.P + __webpack_require__(183), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(35);
	var aFunction = __webpack_require__(44);
	var $defineProperty = __webpack_require__(33);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(32) && $export($export.P + __webpack_require__(183), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(4);
	var $entries = __webpack_require__(361)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(4);
	var ownKeys = __webpack_require__(362);
	var toIObject = __webpack_require__(60);
	var gOPD = __webpack_require__(58);
	var createProperty = __webpack_require__(242);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(35);
	var toPrimitive = __webpack_require__(78);
	var getPrototypeOf = __webpack_require__(59);
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(32) && $export($export.P + __webpack_require__(183), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(35);
	var toPrimitive = __webpack_require__(78);
	var getPrototypeOf = __webpack_require__(59);
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(32) && $export($export.P + __webpack_require__(183), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(4);
	var $values = __webpack_require__(361)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(4);
	var global = __webpack_require__(20);
	var core = __webpack_require__(67);
	var microtask = __webpack_require__(253)();
	var OBSERVABLE = __webpack_require__(27)('observable');
	var aFunction = __webpack_require__(44);
	var anObject = __webpack_require__(16);
	var anInstance = __webpack_require__(103);
	var redefineAll = __webpack_require__(109);
	var hide = __webpack_require__(49);
	var forOf = __webpack_require__(104);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(110)('Observable');


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(4);
	var core = __webpack_require__(67);
	var global = __webpack_require__(20);
	var speciesConstructor = __webpack_require__(161);
	var promiseResolve = __webpack_require__(366);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(4);
	var newPromiseCapability = __webpack_require__(254);
	var perform = __webpack_require__(365);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(81);
	var anObject = __webpack_require__(16);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(81);
	var anObject = __webpack_require__(16);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(374);
	var from = __webpack_require__(342);
	var metadata = __webpack_require__(81);
	var anObject = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(81);
	var anObject = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(81);
	var anObject = __webpack_require__(16);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(81);
	var anObject = __webpack_require__(16);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(81);
	var anObject = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(81);
	var anObject = __webpack_require__(16);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(81);
	var anObject = __webpack_require__(16);
	var aFunction = __webpack_require__(44);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(186)('Set');


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(187)('Set');


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(4);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(346)('Set') });


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(4);
	var $at = __webpack_require__(188)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(4);
	var defined = __webpack_require__(76);
	var toLength = __webpack_require__(29);
	var isRegExp = __webpack_require__(181);
	var getFlags = __webpack_require__(157);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(249)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(4);
	var $pad = __webpack_require__(368);
	var userAgent = __webpack_require__(190);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(4);
	var $pad = __webpack_require__(368);
	var userAgent = __webpack_require__(190);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(133)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(133)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(263)('asyncIterator');


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(263)('observable');


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(4);
	
	$export($export.S, 'System', { global: __webpack_require__(20) });


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(186)('WeakMap');


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(187)('WeakMap');


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(186)('WeakSet');


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(187)('WeakSet');


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(265);
	var getKeys = __webpack_require__(107);
	var redefine = __webpack_require__(50);
	var global = __webpack_require__(20);
	var hide = __webpack_require__(49);
	var Iterators = __webpack_require__(131);
	var wks = __webpack_require__(27);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $task = __webpack_require__(261);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(20);
	var $export = __webpack_require__(4);
	var userAgent = __webpack_require__(190);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(811);
	__webpack_require__(750);
	__webpack_require__(752);
	__webpack_require__(751);
	__webpack_require__(754);
	__webpack_require__(756);
	__webpack_require__(761);
	__webpack_require__(755);
	__webpack_require__(753);
	__webpack_require__(763);
	__webpack_require__(762);
	__webpack_require__(758);
	__webpack_require__(759);
	__webpack_require__(757);
	__webpack_require__(749);
	__webpack_require__(760);
	__webpack_require__(764);
	__webpack_require__(765);
	__webpack_require__(717);
	__webpack_require__(719);
	__webpack_require__(718);
	__webpack_require__(767);
	__webpack_require__(766);
	__webpack_require__(737);
	__webpack_require__(747);
	__webpack_require__(748);
	__webpack_require__(738);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(741);
	__webpack_require__(742);
	__webpack_require__(743);
	__webpack_require__(744);
	__webpack_require__(745);
	__webpack_require__(746);
	__webpack_require__(720);
	__webpack_require__(721);
	__webpack_require__(722);
	__webpack_require__(723);
	__webpack_require__(724);
	__webpack_require__(725);
	__webpack_require__(726);
	__webpack_require__(727);
	__webpack_require__(728);
	__webpack_require__(729);
	__webpack_require__(730);
	__webpack_require__(731);
	__webpack_require__(732);
	__webpack_require__(733);
	__webpack_require__(734);
	__webpack_require__(735);
	__webpack_require__(736);
	__webpack_require__(798);
	__webpack_require__(803);
	__webpack_require__(810);
	__webpack_require__(801);
	__webpack_require__(793);
	__webpack_require__(794);
	__webpack_require__(799);
	__webpack_require__(804);
	__webpack_require__(806);
	__webpack_require__(789);
	__webpack_require__(790);
	__webpack_require__(791);
	__webpack_require__(792);
	__webpack_require__(795);
	__webpack_require__(796);
	__webpack_require__(797);
	__webpack_require__(800);
	__webpack_require__(802);
	__webpack_require__(805);
	__webpack_require__(807);
	__webpack_require__(808);
	__webpack_require__(809);
	__webpack_require__(712);
	__webpack_require__(714);
	__webpack_require__(713);
	__webpack_require__(716);
	__webpack_require__(715);
	__webpack_require__(701);
	__webpack_require__(699);
	__webpack_require__(705);
	__webpack_require__(702);
	__webpack_require__(708);
	__webpack_require__(710);
	__webpack_require__(698);
	__webpack_require__(704);
	__webpack_require__(695);
	__webpack_require__(709);
	__webpack_require__(693);
	__webpack_require__(707);
	__webpack_require__(706);
	__webpack_require__(700);
	__webpack_require__(703);
	__webpack_require__(692);
	__webpack_require__(694);
	__webpack_require__(697);
	__webpack_require__(696);
	__webpack_require__(711);
	__webpack_require__(265);
	__webpack_require__(783);
	__webpack_require__(372);
	__webpack_require__(788);
	__webpack_require__(373);
	__webpack_require__(784);
	__webpack_require__(785);
	__webpack_require__(786);
	__webpack_require__(787);
	__webpack_require__(768);
	__webpack_require__(371);
	__webpack_require__(374);
	__webpack_require__(375);
	__webpack_require__(823);
	__webpack_require__(812);
	__webpack_require__(813);
	__webpack_require__(818);
	__webpack_require__(821);
	__webpack_require__(822);
	__webpack_require__(816);
	__webpack_require__(819);
	__webpack_require__(817);
	__webpack_require__(820);
	__webpack_require__(814);
	__webpack_require__(815);
	__webpack_require__(769);
	__webpack_require__(770);
	__webpack_require__(771);
	__webpack_require__(772);
	__webpack_require__(773);
	__webpack_require__(776);
	__webpack_require__(774);
	__webpack_require__(775);
	__webpack_require__(777);
	__webpack_require__(778);
	__webpack_require__(779);
	__webpack_require__(780);
	__webpack_require__(782);
	__webpack_require__(781);
	__webpack_require__(826);
	__webpack_require__(824);
	__webpack_require__(825);
	__webpack_require__(867);
	__webpack_require__(870);
	__webpack_require__(869);
	__webpack_require__(871);
	__webpack_require__(872);
	__webpack_require__(868);
	__webpack_require__(873);
	__webpack_require__(874);
	__webpack_require__(848);
	__webpack_require__(851);
	__webpack_require__(847);
	__webpack_require__(845);
	__webpack_require__(846);
	__webpack_require__(849);
	__webpack_require__(850);
	__webpack_require__(832);
	__webpack_require__(866);
	__webpack_require__(831);
	__webpack_require__(865);
	__webpack_require__(877);
	__webpack_require__(879);
	__webpack_require__(830);
	__webpack_require__(864);
	__webpack_require__(876);
	__webpack_require__(878);
	__webpack_require__(829);
	__webpack_require__(875);
	__webpack_require__(828);
	__webpack_require__(833);
	__webpack_require__(834);
	__webpack_require__(835);
	__webpack_require__(836);
	__webpack_require__(837);
	__webpack_require__(839);
	__webpack_require__(838);
	__webpack_require__(840);
	__webpack_require__(841);
	__webpack_require__(842);
	__webpack_require__(844);
	__webpack_require__(843);
	__webpack_require__(853);
	__webpack_require__(854);
	__webpack_require__(855);
	__webpack_require__(856);
	__webpack_require__(858);
	__webpack_require__(857);
	__webpack_require__(860);
	__webpack_require__(859);
	__webpack_require__(861);
	__webpack_require__(862);
	__webpack_require__(863);
	__webpack_require__(827);
	__webpack_require__(852);
	__webpack_require__(882);
	__webpack_require__(881);
	__webpack_require__(880);
	module.exports = __webpack_require__(67);


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(885)();
	// imports
	
	
	// module
	exports.push([module.id, "#diamonds-direct{box-sizing:border-box;color:#333;font-family:Lusitana,serif}#diamonds-direct .desktopOnly{display:block}@media (max-width:768px){#diamonds-direct .desktopOnly{display:none}}#diamonds-direct .mobileOnly{display:none}@media (max-width:768px){#diamonds-direct .mobileOnly{display:block}}#diamonds-direct .midMobile{display:none}@media (max-width:768px){#diamonds-direct .midMobile{display:block}}@media (max-width:600px){#diamonds-direct .midMobile{display:none}}#diamonds-direct .desktop1024{display:block}@media (max-width:1024px){#diamonds-direct .desktop1024{display:none}}#diamonds-direct .mobile1024{display:none}@media (max-width:1024px){#diamonds-direct .mobile1024{display:block}}#diamonds-direct .desktop600{display:block}@media (max-width:600px){#diamonds-direct .desktop600{display:none}}#diamonds-direct .mobile600{display:none}@media (max-width:600px){#diamonds-direct .mobile600{display:block}}#diamonds-direct .actionButton{cursor:pointer;display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:Lato,sans-serif;background:#ceacd3;color:#fff;text-align:center;text-transform:uppercase;font-size:20px;font-weight:700;letter-spacing:1px;border:0;padding:0 25px;width:auto;height:60px;line-height:60px;border-radius:0;transition:background-color .25s ease-in-out 0ms}#diamonds-direct .actionButton:disabled{background-color:#95989a;cursor:not-allowed}#diamonds-direct .actionButton:disabled:hover{background-color:#4e4352}#diamonds-direct .actionButton:focus,#diamonds-direct .actionButton:hover{background-color:#bf92c5}#diamonds-direct .actionButton:active{background-color:#c69fcc}#diamonds-direct .dd2ActionButton{cursor:pointer;display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:Lato,sans-serif;background:#563a5f;color:#fff;text-align:center;text-transform:uppercase;font-size:20px;font-weight:700;letter-spacing:1px;border:0;padding:0 25px;width:100%;height:40px;line-height:40px;border-radius:0;outline:none;transition:background-color .25s ease-in-out 0ms}#diamonds-direct .dd2ActionButton:disabled{background-color:#95989a;cursor:not-allowed}#diamonds-direct .dd2ActionButton:disabled:hover{background-color:#4e4352}#diamonds-direct .dd2ActionButton:focus,#diamonds-direct .dd2ActionButton:hover{background-color:#442e4c}#diamonds-direct .dd2ActionButton:active{background-color:#664d6f}#diamonds-direct .iconButton{position:relative;padding:0 25px 0 75px}#diamonds-direct .iconButton .buttonIcon{position:absolute;top:25%;left:25px;height:50%;padding:1px}#diamonds-direct .iconButton .buttonIcon img{height:100%;vertical-align:top}#diamonds-direct .secondaryButton{cursor:pointer;display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:Lato,sans-serif;background:#fff;color:#333;text-align:center;text-transform:uppercase;font-size:16px;font-weight:300;border:none;padding:0 25px;width:auto;height:50px;line-height:50px;border-radius:0;transition:background-color .25s ease-in-out 0ms,color .1s ease-in-out 0ms}#diamonds-direct .secondaryButton:disabled{color:#bf92c5;cursor:not-allowed}#diamonds-direct .secondaryButton:disabled:hover{background-color:#c69fcc}#diamonds-direct .secondaryButton:focus,#diamonds-direct .secondaryButton:hover{background-color:#f2f2f2}#diamonds-direct .secondaryButton:active{background-color:silver}#diamonds-direct .EllipsisElement{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}#diamonds-direct .RhinoCheckbox,#diamonds-direct .RhinoRadio{position:absolute;top:0;left:0}#diamonds-direct .RhinoCheckbox .control,#diamonds-direct .RhinoRadio .control{position:relative;display:inline-block;padding:0 0 0 20px;height:20px;line-height:20px;cursor:pointer}#diamonds-direct .RhinoCheckbox .control input,#diamonds-direct .RhinoRadio .control input{position:absolute;top:8px;left:8px;width:18px;height:18px;z-index:-1;opacity:0}#diamonds-direct .RhinoCheckbox .control__indicator,#diamonds-direct .RhinoRadio .control__indicator{position:absolute;top:0;left:0;width:18px;height:18px;border:1px solid #000;border-radius:0;background:#fff}#diamonds-direct .RhinoCheckbox .control--radio .control__indicator,#diamonds-direct .RhinoRadio .control--radio .control__indicator{border-radius:50%}#diamonds-direct .RhinoCheckbox .control:hover input~.control__indicator,#diamonds-direct .RhinoRadio .control:hover input~.control__indicator{background:#eeebee}#diamonds-direct .RhinoCheckbox .control input:checked~.control__indicator,#diamonds-direct .RhinoRadio .control input:checked~.control__indicator{background:#fff}#diamonds-direct .RhinoCheckbox .control:hover input:not([disabled]):checked~.control__indicator,#diamonds-direct .RhinoRadio .control:hover input:not([disabled]):checked~.control__indicator{background:#eeebee}#diamonds-direct .RhinoCheckbox .control input:not([disabled]):checked:focus~.control__indicator,#diamonds-direct .RhinoRadio .control input:not([disabled]):checked:focus~.control__indicator{background:#eeebee;box-shadow:0 0 3px 0 #000}#diamonds-direct .RhinoCheckbox .control input:disabled~.control__indicator,#diamonds-direct .RhinoRadio .control input:disabled~.control__indicator{pointer-events:none;opacity:.6;background:silver;border-color:#95989a}#diamonds-direct .RhinoCheckbox .control__indicator:after,#diamonds-direct .RhinoRadio .control__indicator:after{position:absolute;display:none;content:\"\"}#diamonds-direct .RhinoCheckbox .control input:checked~.control__indicator:after,#diamonds-direct .RhinoRadio .control input:checked~.control__indicator:after{display:block}#diamonds-direct .RhinoCheckbox .control--checkbox .control__indicator:after,#diamonds-direct .RhinoRadio .control--checkbox .control__indicator:after{top:3px;left:3px;right:3px;bottom:3px;background:#000}#diamonds-direct .RhinoCheckbox .control--checkbox input:disabled~.control__indicator:after,#diamonds-direct .RhinoRadio .control--checkbox input:disabled~.control__indicator:after{border-color:#95989a}#diamonds-direct .RhinoCheckbox .control--radio .control__indicator:after,#diamonds-direct .RhinoRadio .control--radio .control__indicator:after{top:4px;left:4px;width:8px;height:8px;border-radius:50%;background:#fff}#diamonds-direct .RhinoCheckbox .control--radio input:disabled~.control__indicator:after,#diamonds-direct .RhinoRadio .control--radio input:disabled~.control__indicator:after{background:#95989a}#diamonds-direct .RhinoSelect.error select{border:1px solid #eb3533;color:#eb3533}#diamonds-direct .RhinoSelect.error .select__arrow{border-color:#eb3533 transparent transparent}#diamonds-direct .RhinoSelect.error select:focus~.select__arrow,#diamonds-direct .RhinoSelect.error select:hover~.select__arrow{border-top-color:#eb3533}#diamonds-direct .RhinoSelect{position:relative;display:inline-block;width:100%}#diamonds-direct .RhinoSelect select{display:inline-block;width:100%;padding:10px 8px;cursor:pointer;color:#4e4352;background:none;border:1px solid #4b2d53;border-radius:0;outline:0;appearance:none;-webkit-appearance:none;-moz-appearance:none}#diamonds-direct .RhinoSelect select::-ms-expand{display:none}#diamonds-direct .RhinoSelect select:disabled{pointer-events:none;border-color:#95989a}#diamonds-direct .RhinoSelect .select__arrow{position:absolute;top:16px;right:8px;width:0;height:0;pointer-events:none;border-width:8px 5px 0;border-style:solid;border-color:#4b2d53 transparent transparent}#diamonds-direct .RhinoSelect select:focus~.select__arrow,#diamonds-direct .RhinoSelect select:hover~.select__arrow{border-top-color:#4b2d53}#diamonds-direct .RhinoSelect select:disabled~.select__arrow{border-top-color:#95989a}#diamonds-direct .RhinoLoading .loadingImgWrapper{display:block;margin:0 auto;width:100px}@media (max-width:480px){#diamonds-direct .RhinoLoading .loadingImgWrapper{display:none}}#diamonds-direct .RhinoLoading .loadingImgWrapper img{width:100%}#diamonds-direct .RhinoLoading .loadingImgPhoneWrapper{display:none;margin:0 auto;width:100px}@media (max-width:480px){#diamonds-direct .RhinoLoading .loadingImgPhoneWrapper{display:block}}#diamonds-direct .RhinoLoading .loadingImgPhoneWrapper img{width:100%}#diamonds-direct .RhinoLoading .loadingMessage{font-weight:300;font-size:18px;text-align:center;margin:20px 0 0}#diamonds-direct .AntiModal.out{background:transparent;opacity:0;animation-name:fadeout;animation-duration:.4s}#diamonds-direct .AntiModal{position:fixed;overflow:auto;top:0;left:0;width:100%;height:100%;z-index:200;background:rgba(0,0,0,.55);animation-name:fadein;animation-duration:.4s}#diamonds-direct .AntiModal .modalError{text-align:center;color:#eb3533;font-weight:700;margin:0 0 10px}#diamonds-direct .AntiModal .modalBody{position:relative;top:0;width:75%;max-width:768px;margin:0 auto;padding:0;background:#fff;box-shadow:0 14px 45px rgba(0,0,0,.25),0 10px 18px rgba(0,0,0,.22);transition:top .35s linear 0ms,height .35s linear 0ms}#diamonds-direct .AntiModal .modalBody .modalTitle{color:#333;font-size:22px;font-weight:400}#diamonds-direct .AntiModal .modalBody .modalTitlePositioning{margin:0;padding:20px}#diamonds-direct .AntiModal .modalBody .modalChildren{margin:0;padding:0}#diamonds-direct .AntiModal .modalBody .modalActions{overflow:auto}#diamonds-direct .AntiModal .modalBody .modalActionsPositioning{padding:8px 20px}#diamonds-direct .AntiModal .modalBody .modalError.hasError{height:1.2em}#diamonds-direct .AntiModal .modalBody .modalError{text-align:center;color:#eb3533;font-weight:700;margin:0 0 10px;height:0;transition:height .1s ease-in-out 0ms}#diamonds-direct .AntiModal .modalBody.teamBio{width:75%;max-width:768px}@media (max-width:768px){#diamonds-direct .AntiModal .modalBody.teamBio{width:320px}}#diamonds-direct .AntiModal .modalBody.customDesignVideo{width:640px;max-width:640px}@media (max-width:768px){#diamonds-direct .AntiModal .modalBody.customDesignVideo{width:320px}}#diamonds-direct .AntiModal .modalBody.wishlistShare{max-width:380px}#diamonds-direct .AntiModal .DeleteWarning{text-align:center}#diamonds-direct .AntiModal .DeleteWarning .confirmTitle{font-size:20px;font-weight:700}#diamonds-direct .AntiModal .DeleteWarning .confirmSubtitle{font-size:18px;font-weight:500}#diamonds-direct .EarringAlert.RhinoAlert .alertBody{max-width:600px;width:50%}#diamonds-direct .EarringAlert.RhinoAlert .alertBody .desktopBackground{display:block}#diamonds-direct .EarringAlert.RhinoAlert .alertBody .mobileBackground{display:none}#diamonds-direct .EarringAlert.RhinoAlert .alertBody img{width:100%}@media (max-width:768px){#diamonds-direct .EarringAlert.RhinoAlert .alertBody{width:33%}#diamonds-direct .EarringAlert.RhinoAlert .alertBody .desktopBackground{display:none}#diamonds-direct .EarringAlert.RhinoAlert .alertBody .mobileBackground{display:block}}#diamonds-direct .EarringAlert.RhinoAlert .alertBody .closeIcon{position:absolute;cursor:pointer;color:#a70019;background-image:radial-gradient(#a70019,#a70019);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:10px;right:10px;width:18px;height:18px;border:1px solid #a70019;transform:rotate(45deg);z-index:1;transition:top .35s linear 0ms,right .35s linear 0ms,width .35s linear 0ms,height .35s linear 0ms,background-size .25s ease-in-out 0ms}#diamonds-direct .EarringAlert.RhinoAlert .alertBody .closeIcon:hover{background-size:100% 100%}#diamonds-direct .EarringAlert.RhinoAlert .alertBody .closeIcon:hover .closeX{color:#fff}#diamonds-direct .EarringAlert.RhinoAlert .alertBody .closeIcon .closeX{margin:-1px 0 0 -2px;transform:rotate(-45deg);line-height:18px;text-align:center;font-size:18px;font-weight:300;transition:font-size .35s linear 0ms,line-height .35s linear 0ms,color .25s ease-in-out 0ms}#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper{position:relative}#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper .earringBannerButton{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;margin:0;padding:0;text-transform:uppercase;font-family:Lusitana,serif;cursor:pointer;font-size:14px;border:1px solid #6d4d92;color:#6d4d92;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,font-size .35s linear 0ms,padding .35s linear 0ms}#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper .earringBannerButton:hover{background:#4b2d53;color:#fff;border:1px solid #4b2d53}#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper .shopStoreButton{top:58%;left:18%;width:30%;height:10%}@media (max-width:768px){#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper .shopStoreButton{top:56%;left:20%;width:60%;height:8%}}#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper .shopOnlineButton{top:58%;right:18%;width:30%;height:10%}@media (max-width:768px){#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper .shopOnlineButton{top:67%;left:20%;width:60%;height:8%}}#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper .holidayTextLink{position:absolute;color:#fff;bottom:4.2%;left:25%;width:50%;height:5%;text-align:center;font-size:14px;text-decoration:underline;cursor:pointer}@media (max-width:1024px){#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper .holidayTextLink{font-size:12px}}@media (max-width:900px){#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper .holidayTextLink{font-size:8px}}@media (max-width:768px){#diamonds-direct .EarringAlert.RhinoAlert .earringBackgroundWrapper .holidayTextLink{bottom:.5%;left:36%;width:40%;height:3%}}#diamonds-direct .RhinoAlert.out{background:transparent;opacity:0;animation-name:fadeout;animation-duration:.4s}#diamonds-direct .RhinoAlert{position:fixed;overflow:auto;top:0;left:0;width:100%;height:100%;z-index:200;background:rgba(0,0,0,.25);text-align:center;animation-name:fadein;animation-duration:.4s}#diamonds-direct .RhinoAlert .alertBody.notifyBody{width:80%;max-width:500px;margin:0 auto}@media (max-width:768px){#diamonds-direct .RhinoAlert .alertBody.notifyBody{max-width:320px}}#diamonds-direct .RhinoAlert .alertBody.notifyBody .notifyImg{display:block}@media (max-width:768px){#diamonds-direct .RhinoAlert .alertBody.notifyBody .notifyImg{display:none}}#diamonds-direct .RhinoAlert .alertBody.notifyBody .notifyImg img{display:block;width:100%}#diamonds-direct .RhinoAlert .alertBody.notifyBody .notifyImgMobile{display:none}@media (max-width:768px){#diamonds-direct .RhinoAlert .alertBody.notifyBody .notifyImgMobile{display:block}}#diamonds-direct .RhinoAlert .alertBody.notifyBody .notifyImgMobile img{display:block;width:100%}#diamonds-direct .RhinoAlert .alertBody.notifyBody .closeIcon{color:#fff;background-image:radial-gradient(#fff,#fff);border:1px solid #fff}#diamonds-direct .RhinoAlert .alertBody.notifyBody .closeIcon:hover .closeX{color:#030c1c}#diamonds-direct .RhinoAlert .alertBody{position:relative;overflow:hidden;top:0;width:33%;min-width:280px;margin:0 auto;padding:0;font-weight:700;background:#fff;box-shadow:0 14px 45px rgba(0,0,0,.45),0 10px 18px rgba(0,0,0,.42);transition:top .35s linear 0ms,height .35s linear 0ms}#diamonds-direct .RhinoAlert .alertBody .alertContentWrapper.visit .visitHeader{margin:30px 0 0;font-size:28px;font-weight:400;color:#4f4f4f}#diamonds-direct .RhinoAlert .alertBody .alertContentWrapper.visit .visitBr{margin:0 auto}#diamonds-direct .RhinoAlert .alertBody .alertContentWrapper.default .defaultBr,#diamonds-direct .RhinoAlert .alertBody .alertContentWrapper.visit .visitBr{width:80%;height:50px;background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/ddline.svg\");background-repeat:no-repeat;background-position:50%;background-size:cover}#diamonds-direct .RhinoAlert .alertBody .alertContentWrapper.default .defaultBr{margin:-20px auto 0}#diamonds-direct .RhinoAlert .alertBody .alertText.visit{font-size:16px;margin-top:10px;color:#5e5e5e}#diamonds-direct .RhinoAlert .alertBody .alertText{margin:20px 10px;color:#333;font-size:24px;font-weight:300}#diamonds-direct .RhinoAlert .alertBody .alertButton.visit{background:#ddd;color:#333;margin-bottom:25px}#diamonds-direct .RhinoAlert .alertBody .alertButton.visit:hover{background:#bf98c3;color:#fff}#diamonds-direct .RhinoAlert .alertBody .alertButton{margin:0 auto 10px;height:50px;line-height:50px;font-size:14px}#diamonds-direct .RhinoAlert .alertBody .closeIcon{position:absolute;cursor:pointer;color:#fff;background-image:radial-gradient(#fff,#fff);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:10px;right:10px;width:18px;height:18px;border:1px solid #fff;transform:rotate(45deg);z-index:1;transition:top .35s linear 0ms,right .35s linear 0ms,width .35s linear 0ms,height .35s linear 0ms,background-size .25s ease-in-out 0ms}#diamonds-direct .RhinoAlert .alertBody .closeIcon:hover{background-size:100% 100%}#diamonds-direct .RhinoAlert .alertBody .closeIcon:hover .closeX{color:#cdadd2}#diamonds-direct .RhinoAlert .alertBody .closeIcon .closeX{margin:-1px 0 0 -2px;transform:rotate(-45deg);line-height:18px;text-align:center;font-size:18px;font-weight:300;transition:font-size .35s linear 0ms,line-height .35s linear 0ms,color .25s ease-in-out 0ms}#diamonds-direct .AntiConfirm.out{background:transparent;opacity:0;animation-name:fadeout;animation-duration:.4s}#diamonds-direct .AntiConfirm{position:fixed;overflow:auto;top:0;left:0;width:100%;height:100%;z-index:200;background:rgba(0,0,0,.55);animation-name:fadein;animation-duration:.4s}#diamonds-direct .AntiConfirm .confirmBody{position:relative;overflow:auto;top:0;width:33%;min-width:280px;margin:0 auto;padding:0;background:#fff;box-shadow:0 14px 45px rgba(0,0,0,.25),0 10px 18px rgba(0,0,0,.22);transition:top .35s linear 0ms,height .35s linear 0ms}#diamonds-direct .AntiConfirm .confirmBody .confirmText{margin:20px 10px 10px;text-align:center;color:#333}#diamonds-direct .AntiConfirm .confirmBody .confirmButtons{overflow:auto;margin:20px 10px 10px}#diamonds-direct .AntiConfirm .confirmBody .confirmButtons button{float:right}#diamonds-direct .Footer{margin:0 50px;transition:margin .35s linear 0ms;color:#95989a}@media (max-width:768px){#diamonds-direct .Footer{margin:0 20px}}#diamonds-direct .Footer .topFooter{position:relative;border-top:2px solid #f4f5f7;border-bottom:2px solid #f4f5f7;height:80px}#diamonds-direct .Footer .topFooter .newsletterWrapper{position:absolute;top:25px;left:0;height:30px;width:300px;font-family:Lato,sans-serif}#diamonds-direct .Footer .topFooter .newsletterWrapper input{width:200px;height:100%;border:none;color:#95989a;background:#f4f5f7;text-align:center;font-weight:300}#diamonds-direct .Footer .topFooter .newsletterWrapper .newsletterSubmit{display:inline-block;margin:0 0 0 10px;padding:0 15px;color:#95989a;background:#f4f5f7;vertical-align:top;cursor:pointer;text-align:center;text-transform:uppercase;font-size:12px;font-weight:700;height:32px;line-height:32px;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Footer .topFooter .newsletterWrapper .newsletterSubmit:hover{background:#4b2d53;color:#fff}#diamonds-direct .Footer .topFooter .newsletterWrapper .newsletterConfirmation{line-height:30px;color:#4b2d53;font-weight:700;text-align:center}#diamonds-direct .Footer .topFooter .midLogoWrapper{width:300px;margin:18px auto;cursor:pointer}#diamonds-direct .Footer .topFooter .midLogoWrapper .footerLogo{display:block}@media (max-width:1024px){#diamonds-direct .Footer .topFooter .midLogoWrapper .footerLogo{display:none}}@media (max-width:768px){#diamonds-direct .Footer .topFooter .midLogoWrapper .footerLogo{display:block}}#diamonds-direct .Footer .topFooter .midLogoWrapper .footerIcon{display:none}@media (max-width:1024px){#diamonds-direct .Footer .topFooter .midLogoWrapper .footerIcon{display:block;width:50px;margin:0 auto}}@media (max-width:768px){#diamonds-direct .Footer .topFooter .midLogoWrapper .footerIcon{display:none}}#diamonds-direct .Footer .topFooter .midLogoWrapper img{width:100%}#diamonds-direct .Footer .topFooter .locateWrapper{position:absolute;top:25px;right:0;height:30px;width:200px}#diamonds-direct .Footer .topFooter .locateWrapper select{width:100%;height:100%;border:none;color:#95989a;background:#f4f5f7;text-align:center;font-family:Lato,sans-serif;font-weight:300;-webkit-appearance:none;-moz-appearance:none;padding:0 8px}#diamonds-direct .Footer .topFooter .locateWrapper .selectArrow{position:absolute;top:0;right:0;bottom:0;width:20px;background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/downarrow.svg\");background-position:50%;background-repeat:no-repeat;background-size:10px 5px}#diamonds-direct .Footer .midDesktop.midFooter{display:block}@media (max-width:768px){#diamonds-direct .Footer .midDesktop.midFooter{display:none}}#diamonds-direct .Footer .midMobile.midFooter{display:none}@media (max-width:768px){#diamonds-direct .Footer .midMobile.midFooter{display:block}}#diamonds-direct .Footer .midFooter{width:90%;margin:20px auto;padding:0 0 0 10%;transition:padding .35s linear 0ms,width .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Footer .midFooter{width:100%;padding:0}}@media (max-width:768px){#diamonds-direct .Footer .midFooter{width:85%;padding:0 0 0 20%}}@media (max-width:600px){#diamonds-direct .Footer .midFooter{width:85%;padding:0 0 0 15%}}@media (max-width:480px){#diamonds-direct .Footer .midFooter{width:85%;padding:0 0 0 15%}}#diamonds-direct .Footer .midFooter .linkColumn{display:inline-block;vertical-align:top;width:33%;color:#aeb0b2;transition:width .35s linear 0ms,font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Footer .midFooter .linkColumn{width:calc(50% - 10px)}}@media (max-width:480px){#diamonds-direct .Footer .midFooter .linkColumn{font-size:12px}}#diamonds-direct .Footer .midFooter .linkColumn .footerTitle{color:#333;font-weight:700;margin:15px 0}#diamonds-direct .Footer .midFooter .linkColumn .footerLink{margin:15px 0 15px 10px;cursor:default;text-decoration:none;transition:color .25s ease-in-out 0ms}@media (max-width:768px){#diamonds-direct .Footer .midFooter .linkColumn .footerLink{margin:10px 0}}#diamonds-direct .Footer .midFooter .linkColumn .footerLink:hover{cursor:pointer;color:#4b2d53}#diamonds-direct .Footer .midFooter .linkColumn .footerLink.longLink{display:block}@media (max-width:900px){#diamonds-direct .Footer .midFooter .linkColumn .footerLink.longLink{display:none}}@media (max-width:768px){#diamonds-direct .Footer .midFooter .linkColumn .footerLink.longLink{display:block}}#diamonds-direct .Footer .midFooter .linkColumn .footerLink.shortLink{display:none}@media (max-width:900px){#diamonds-direct .Footer .midFooter .linkColumn .footerLink.shortLink{display:block}}@media (max-width:768px){#diamonds-direct .Footer .midFooter .linkColumn.desktopOnly,#diamonds-direct .Footer .midFooter .linkColumn .footerLink.shortLink{display:none}}#diamonds-direct .Footer .bottomFooter{position:relative;border-top:1px solid silver;height:80px;color:#95989a}@media (max-width:768px){#diamonds-direct .Footer .bottomFooter{height:40px}}#diamonds-direct .Footer .bottomFooter .footerLHS{position:absolute;bottom:5px;left:0;font-family:Lato,sans-serif;font-weight:300}@media (max-width:768px){#diamonds-direct .Footer .bottomFooter .footerLHS{bottom:0}}@media (max-width:480px){#diamonds-direct .Footer .bottomFooter .footerLHS{position:relative;text-align:center;margin:15px 0 10px}}#diamonds-direct .Footer .bottomFooter .footerLHS .bottomLink{display:inline-block;margin:0 25px 0 0;font-size:14px;cursor:default;text-decoration:none}@media (max-width:480px){#diamonds-direct .Footer .bottomFooter .footerLHS .bottomLink{margin:0 10px}}#diamonds-direct .Footer .bottomFooter .footerLHS .bottomLink:hover{cursor:pointer;color:#4b2d53}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper{position:relative;margin:20px auto;height:40px;text-align:center;font-family:Lato,sans-serif;font-weight:300}@media (max-width:768px){#diamonds-direct .Footer .bottomFooter .bottomMidWrapper{height:20px;margin:0 auto}}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .phonePrompt{position:absolute;top:5px;left:0;width:180px;height:40px;line-height:40px;text-align:left;margin:0}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .phonePrompt a{text-decoration:none;color:#95989a}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .phonePrompt a:hover{color:#4b2d53}@media (max-width:768px){#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .phonePrompt{top:0}}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial{display:inline-block;text-align:center;width:200px}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .footerIconWrapper{display:inline-block;margin:10px 5px 0;height:26px;width:26px;background-position:50%;background-repeat:no-repeat;background-size:contain;cursor:default}@media (max-width:768px){#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .footerIconWrapper{height:18px;width:18px}}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .footerIconWrapper img{height:100%}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .footerIconWrapper:hover{cursor:pointer}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .facebookIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/footer/face.png\")}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .facebookIcon:hover{background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/footer/face_active.png\")}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .glassdoorIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/footer/glassdoor.png\")}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .glassdoorIcon:hover{background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/footer/glassdoor_active.png\")}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .instagramIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/footer/instgrm.png\")}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .instagramIcon:hover{background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/footer/instgrm_active.png\")}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .linkedinIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/footer/linkedin1.png\")}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .linkedinIcon:hover{background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/footer/linkedin1_active.png\")}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .pinterestIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/footer/pintrst.png\")}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .footerSocial .pinterestIcon:hover{background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/footer/pintrst_active.png\")}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .emailPrompt{display:inline-block;vertical-align:top;width:100px;line-height:40px;text-align:left;margin:0 0 0 50px;cursor:pointer}@media (max-width:1024px){#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .emailPrompt{display:none}}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .emailPrompt:hover{color:#4b2d53}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .blogPrompt{display:inline-block;vertical-align:top;width:60px;line-height:40px;text-align:left;margin:0 0 0 10px;cursor:pointer}@media (max-width:1024px){#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .blogPrompt{display:none}}#diamonds-direct .Footer .bottomFooter .bottomMidWrapper .blogPrompt:hover{color:#4b2d53}#diamonds-direct .Footer .bottomFooter .footerRHS{position:absolute;top:10px;right:0;height:60px;transition:height .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Footer .bottomFooter .footerRHS{height:30px}}@media (max-width:480px){#diamonds-direct .Footer .bottomFooter .footerRHS{display:none}}#diamonds-direct .Footer .bottomFooter .footerRHS .badgeWrapper{display:inline-block;width:65px;margin:0 0 0 10px;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Footer .bottomFooter .footerRHS .badgeWrapper{width:35px}}#diamonds-direct .Footer .bottomFooter .footerRHS .badgeWrapper img{width:100%}#diamonds-direct .AboutUs{font-family:Lato,sans-serif;text-transform:uppercase;text-align:center;font-weight:400;margin:0 auto}#diamonds-direct .AboutUs .aboutButton{text-align:center}#diamonds-direct .AboutUs .aboutButton:before{content:\"\";display:inline-block;height:100%;vertical-align:middle;margin-right:-.25em}#diamonds-direct .AboutUs .aboutButtonText{display:inline-block;width:auto;height:auto;vertical-align:middle}#diamonds-direct .AboutUs .aboutNumbers{background:#4a2e52}#diamonds-direct .AboutUs .aboutNumbers img{display:block;width:100%}#diamonds-direct .AboutUs .aboutConception{width:840px;margin:50px auto 0}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutConception{width:70%;margin:50px 15% 0}}#diamonds-direct .AboutUs .aboutConception img{display:block;width:100%}#diamonds-direct .AboutUs .aboutYears{position:relative;width:840px;margin:50px auto 0}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutYears{width:70%;margin:50px 15% 0}}#diamonds-direct .AboutUs .aboutYears .heritageButton{position:absolute;cursor:pointer;top:70%;left:68.5%;width:31%;height:23%;line-height:100%;color:#3f9cda;background:#fff;border:3px solid #3f9cda;font-size:32px;font-weight:700;transition:border .35s linear 0ms,font-size .35s linear 0ms,color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutYears .heritageButton{font-size:28px}}@media (max-width:1024px){#diamonds-direct .AboutUs .aboutYears .heritageButton{font-size:24px}}@media (max-width:768px){#diamonds-direct .AboutUs .aboutYears .heritageButton{font-size:20px;border-width:2px}}@media (max-width:600px){#diamonds-direct .AboutUs .aboutYears .heritageButton{font-size:16px}}@media (max-width:480px){#diamonds-direct .AboutUs .aboutYears .heritageButton{font-size:12px}}#diamonds-direct .AboutUs .aboutYears .heritageButton:hover{background:#3f9cda;color:#fff}#diamonds-direct .AboutUs .aboutYears img{display:block;width:100%}#diamonds-direct .AboutUs .aboutChoic{text-align:center;margin:40px auto;padding:40px 0;background:#f4f5f7}#diamonds-direct .AboutUs .aboutChoic img{display:inline-block;width:100%;max-width:840px}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutChoic img{width:70%;max-width:70%}}#diamonds-direct .AboutUs .aboutConfidenceTitle{width:840px;margin:0 auto}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutConfidenceTitle{width:70%;margin:0 15%}}#diamonds-direct .AboutUs .aboutConfidenceTitle img{display:block;width:100%}#diamonds-direct .AboutUs .aboutConfidence{position:relative;padding:0 0 20%;width:840px;margin:50px auto 0}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutConfidence{width:70%;margin:50px 15% 0}}#diamonds-direct .AboutUs .aboutConfidence .guaranteeButton{position:absolute;cursor:pointer;top:85%;left:36%;width:28%;height:4%;color:#4a2e52;background:#fff;border:3px solid #4a2e52;font-size:32px;font-weight:700;transition:border .35s linear 0ms,font-size .35s linear 0ms,color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutConfidence .guaranteeButton{font-size:28px}}@media (max-width:1024px){#diamonds-direct .AboutUs .aboutConfidence .guaranteeButton{font-size:22px}}@media (max-width:768px){#diamonds-direct .AboutUs .aboutConfidence .guaranteeButton{font-size:18px;border-width:2px}}@media (max-width:600px){#diamonds-direct .AboutUs .aboutConfidence .guaranteeButton{font-size:14px}}@media (max-width:480px){#diamonds-direct .AboutUs .aboutConfidence .guaranteeButton{font-size:11px}}#diamonds-direct .AboutUs .aboutConfidence .guaranteeButton:hover{background:#4a2e52;color:#fff}#diamonds-direct .AboutUs .aboutConfidence img{display:block;width:100%}#diamonds-direct .AboutUs .aboutCommunity{position:relative}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay{position:absolute;top:14.3%;left:21.5%;width:38.85%;height:22.5%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .map-location-wrapper{position:absolute;cursor:pointer;min-height:10px;min-width:10px}@media (max-width:480px){#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .map-location-wrapper{min-width:6px;min-height:6px}}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .map-location-wrapper:hover .store-label{display:block}@media (max-width:480px){#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .map-location-wrapper:hover .store-label{display:none}}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .map-location-wrapper:hover .store-marker{border-bottom-color:#000}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .map-location-wrapper:hover .store-marker:after{border-top-color:#000}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .map-location-wrapper:hover .store-circle-marker{background-color:#000}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .map-location-wrapper.double-wrapper{cursor:default}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .marker-wrapper{position:absolute;overflow:hidden;left:0;bottom:0;width:10px;height:10px}@media (max-width:480px){#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .marker-wrapper{width:6px;height:6px}}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-austin{bottom:16%;left:47.1%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-birmingham{bottom:29%;left:68.2%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-charleston{bottom:31%;left:81.9%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-clt{bottom:38.5%;left:79.7%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-columbus{bottom:56%;left:73.7%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-dallas{bottom:24.1%;left:48.5%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-indy{bottom:54.8%;left:67.6%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-okc{bottom:35.5%;left:46.5%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-raleigh{bottom:41.5%;left:82.7%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-richmond{bottom:49.5%;left:84.2%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-stl{bottom:48.2%;left:59.8%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-slc{bottom:57.5%;left:21.6%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-san{bottom:12.8%;left:45.4%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-vab{bottom:47.6%;left:86.8%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-globaldiamonds{bottom:17.5%;left:80%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-kcy{bottom:49.2%;left:52%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-cle{bottom:62.2%;left:76.1%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-nol{bottom:15%;left:62.5%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-boc{bottom:8%;left:84%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-pit{bottom:61%;left:80%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-hou{bottom:13.5%;left:51%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-gsc{bottom:36.5%;left:77%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-nva{bottom:54.3%;left:85%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay #marker-try{bottom:65.5%;left:72.4%}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-circle-marker{width:10px;height:10px;border-radius:50%;background-color:#fff}@media (max-width:480px){#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-circle-marker{width:5px;height:5px;border-radius:50%;background-color:#fff}}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-marker{width:0;height:0;border:5px solid transparent;border-bottom-color:#fff;position:relative;top:-5px}@media (max-width:480px){#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-marker{border:3px solid transparent;border-bottom-color:#fff;top:-3px}}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-marker:after{content:\"\";position:absolute;left:-5px;top:5px;width:0;height:0;border:5px solid transparent;border-top-color:#fff}@media (max-width:480px){#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-marker:after{left:-3px;top:3px;border:3px solid transparent;border-top-color:#fff}}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-label{position:relative;overflow:hidden;display:none;left:0;bottom:0;margin:0 0 0 16px;padding:5px 12px;border:1px solid hsla(0,0%,95%,.7);background:#000;opacity:.8;text-align:center;color:#fff;z-index:1}@media (max-width:480px){#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-label{margin:0 0 0 12px}}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-label .store-name{font-size:14px;font-weight:900}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-label .store-link{font-size:12px;font-weight:300}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-label .store-link:hover{cursor:pointer;color:#bf98c3}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .store-label .store-link:active{color:#98799c}#diamonds-direct .AboutUs .aboutCommunity .mapOverlay .horizontal-rule{width:100%;height:0;margin:3px auto;border-top:1px solid hsla(0,0%,95%,.7)}#diamonds-direct .AboutUs .aboutCommunity .locateStoreButton{position:absolute;cursor:pointer;top:34.9%;left:62%;width:15.8%;height:3.5%;line-height:100%;color:#3f9cda;background:none;border:3px solid #3f9cda;font-size:26px;font-weight:700;transition:border .35s linear 0ms,font-size .35s linear 0ms,color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutCommunity .locateStoreButton{font-size:22px}}@media (max-width:1024px){#diamonds-direct .AboutUs .aboutCommunity .locateStoreButton{font-size:16px}}@media (max-width:768px){#diamonds-direct .AboutUs .aboutCommunity .locateStoreButton{font-size:14px;border-width:2px}}@media (max-width:600px){#diamonds-direct .AboutUs .aboutCommunity .locateStoreButton{font-size:11px}}@media (max-width:480px){#diamonds-direct .AboutUs .aboutCommunity .locateStoreButton{font-size:9px}}#diamonds-direct .AboutUs .aboutCommunity .locateStoreButton:hover{background:#3f9cda;color:#fff}#diamonds-direct .AboutUs .aboutCommunity .joinTeamButton{position:absolute;cursor:pointer;top:58.3%;left:53.2%;width:20.5%;height:2.8%;line-height:100%;color:#fff;background:none;border:2px solid #3f9cda;font-size:26px;font-weight:400;transition:border .35s linear 0ms,font-size .35s linear 0ms,color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutCommunity .joinTeamButton{font-size:22px}}@media (max-width:1024px){#diamonds-direct .AboutUs .aboutCommunity .joinTeamButton{font-size:16px}}@media (max-width:768px){#diamonds-direct .AboutUs .aboutCommunity .joinTeamButton{border-width:1px;font-size:13px}}@media (max-width:600px){#diamonds-direct .AboutUs .aboutCommunity .joinTeamButton{font-size:10px}}@media (max-width:480px){#diamonds-direct .AboutUs .aboutCommunity .joinTeamButton{font-size:8px}}#diamonds-direct .AboutUs .aboutCommunity .joinTeamButton:hover{background:#3f9cda;color:#fff}#diamonds-direct .AboutUs .aboutCommunity img,#diamonds-direct .AboutUs .aboutMeet img{display:block;width:100%}#diamonds-direct .AboutUs .aboutSocial{position:relative;padding:0 0 10%}@media (max-width:480px){#diamonds-direct .AboutUs .aboutSocial{padding:0 0 18%}}#diamonds-direct .AboutUs .aboutSocial .socialWrapper{width:1080px;margin:20px auto}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutSocial .socialWrapper{width:90%;margin:20px 5%}}#diamonds-direct .AboutUs .aboutSocial .socialWrapper .socialLHS{display:inline-block;width:calc(50% - 5px);vertical-align:top}#diamonds-direct .AboutUs .aboutSocial .socialWrapper .socialLHS img{display:block;width:100%}#diamonds-direct .AboutUs .aboutSocial .socialWrapper .socialRHS{display:inline-block;width:calc(50% - 5px);vertical-align:top;margin:0 0 0 10px}#diamonds-direct .AboutUs .aboutSocial .socialWrapper .socialRHS .rhsWrapper{display:inline-block;width:calc(50% - 5px);vertical-align:top;margin:0 0 10px}#diamonds-direct .AboutUs .aboutSocial .socialWrapper .socialRHS .rhsWrapper:nth-child(2n){margin:0 0 10px 10px}#diamonds-direct .AboutUs .aboutSocial .socialWrapper .socialRHS .rhsWrapper img{display:block;width:100%}#diamonds-direct .AboutUs .aboutSocial .mobileSocialWrapper{margin:20px 5% 0;text-align:left}#diamonds-direct .AboutUs .aboutSocial .mobileSocialWrapper .mobSocialImg{display:inline-block;margin:0 5px 10px;width:calc(50% - 10px);transition:width .35s linear 0ms}@media (max-width:480px){#diamonds-direct .AboutUs .aboutSocial .mobileSocialWrapper .mobSocialImg{width:calc(100% - 10px)}}#diamonds-direct .AboutUs .aboutSocial .mobileSocialWrapper .mobSocialImg img{display:block;width:100%}#diamonds-direct .AboutUs .aboutSocial .visitUsButton{position:absolute;cursor:pointer;top:82%;left:39%;width:22%;height:10%;line-height:100%;color:#4b2d53;background:#fff;border:2px solid #4b2d53;font-size:32px;font-weight:700;transition:border .35s linear 0ms,font-size .35s linear 0ms,color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutSocial .visitUsButton{font-size:28px}}@media (max-width:1024px){#diamonds-direct .AboutUs .aboutSocial .visitUsButton{font-size:24px}}@media (max-width:768px){#diamonds-direct .AboutUs .aboutSocial .visitUsButton{top:93%;height:5%;font-size:20px;border-width:1px}}@media (max-width:600px){#diamonds-direct .AboutUs .aboutSocial .visitUsButton{font-size:16px}}@media (max-width:480px){#diamonds-direct .AboutUs .aboutSocial .visitUsButton{top:96.3%;left:32%;width:36%;height:2.5%;font-size:24px}}#diamonds-direct .AboutUs .aboutSocial .visitUsButton:hover{background:#4b2d53;color:#fff}#diamonds-direct .AboutUs .aboutDonated{position:relative;margin:0 0 50px}#diamonds-direct .AboutUs .aboutDonated .foundationButton{position:absolute;cursor:pointer;top:85.5%;left:41%;width:18%;height:8%;line-height:100%;color:#5e5e5e;background:none;border:3px solid #29c565;font-size:24px;font-weight:700;transition:border .35s linear 0ms,font-size .35s linear 0ms,font-weight .35s linear 0ms,color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}@media (max-width:1200px){#diamonds-direct .AboutUs .aboutDonated .foundationButton{font-size:22px}}@media (max-width:1024px){#diamonds-direct .AboutUs .aboutDonated .foundationButton{font-weight:400;font-size:18px}}@media (max-width:768px){#diamonds-direct .AboutUs .aboutDonated .foundationButton{font-size:14px;border-width:2px}}@media (max-width:600px){#diamonds-direct .AboutUs .aboutDonated .foundationButton{font-size:10px}}@media (max-width:480px){#diamonds-direct .AboutUs .aboutDonated .foundationButton{font-size:8px}}#diamonds-direct .AboutUs .aboutDonated .foundationButton:hover{background:#29c565;color:#fff}#diamonds-direct .AboutUs .aboutDonated img{display:block;width:100%}#diamonds-direct .AsSeen{margin:0 auto 50px;max-width:1024px;font-family:Lato,sans-serif;transition:max-width .35s linear 0ms}#diamonds-direct .AsSeen .asSeenTitle{color:#666;font-family:Lusitana,serif;text-transform:uppercase;font-size:36px;font-weight:700;padding:10px 0;transition:padding .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .AsSeen .asSeenTitle{padding-left:50px}}@media (max-width:768px){#diamonds-direct .AsSeen .asSeenTitle{padding-left:25px}}#diamonds-direct .AsSeen .asSeenRow.rightBox{text-align:right}#diamonds-direct .AsSeen .asSeenRow{position:relative;overflow:auto;margin:-100px 0 0;text-align:left}@media (max-width:600px){#diamonds-direct .AsSeen .asSeenRow{margin:0}}#diamonds-direct .AsSeen .asSeenRow .imageRight.assRowImg{right:0}#diamonds-direct .AsSeen .asSeenRow .imageLeft.assRowImg{left:0}#diamonds-direct .AsSeen .asSeenRow .assRowImg{position:absolute;top:0;width:60%;height:100%;overflow:hidden}#diamonds-direct .AsSeen .asSeenRow .assRowImg img{width:100%}@media (max-width:600px){#diamonds-direct .AsSeen .asSeenRow .assRowImg{position:relative;width:100%;height:auto}}#diamonds-direct .AsSeen .asSeenRow .assRowBox{position:relative;display:inline-block;vertical-align:top;margin:300px 100px;width:50%;background:#fff;border:1px solid #dbdbdb;z-index:1;transition:margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .AsSeen .asSeenRow .assRowBox{margin:240px 100px}}@media (max-width:900px){#diamonds-direct .AsSeen .asSeenRow .assRowBox{margin:200px 100px}}@media (max-width:768px){#diamonds-direct .AsSeen .asSeenRow .assRowBox{margin:160px 100px}}@media (max-width:600px){#diamonds-direct .AsSeen .asSeenRow .assRowBox{display:block;margin:0;border:none;text-align:center;width:100%}}#diamonds-direct .AsSeen .asSeenRow .assRowBox .assBoxWrapper{margin:50px;text-align:center}#diamonds-direct .AsSeen .asSeenRow .assRowBox .assBoxWrapper .assBoxTitle{display:inline-block;overflow:visible;height:0;border-bottom:10px solid #e3ddec;margin:0 0 25px;padding:0 10px 12px;width:auto;font-family:Lusitana,serif;color:#666;text-transform:uppercase;font-size:22px;transition:font-size .35s linear 0ms}#diamonds-direct .AsSeen .asSeenRow .assRowBox .assBoxWrapper .assBoxSubtitle{font-size:16px;color:#666}#diamonds-direct .AsSeen .asSeenRow .assRowBox .assBoxWrapper .assBoxButtonRow{text-align:center}#diamonds-direct .AsSeen .asSeenRow .assRowBox .assBoxWrapper .assBoxButtonRow .assBoxButton{display:inline-block;width:160px;border:1px solid #8c8c8c;color:#8c8c8c;background:#fff;font-size:12px;text-transform:uppercase;font-weight:700;margin:25px 10px 0;padding:10px 0;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}@media (max-width:600px){#diamonds-direct .AsSeen .asSeenRow .assRowBox .assBoxWrapper .assBoxButtonRow .assBoxButton{width:180px;padding:15px 0;font-family:Lato,sans-serif;font-size:14px}}#diamonds-direct .AsSeen .asSeenRow .assRowBox .assBoxWrapper .assBoxButtonRow .assBoxButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .Careers{font-family:Lato,sans-serif;color:#000}#diamonds-direct .Careers .whoWeAreBlock{overflow:auto;position:relative;margin:0}#diamonds-direct .Careers .whoWeAreBlock .imageTile{position:absolute;top:0;bottom:80px;left:5%;width:65%;max-height:100%;background-image:url(\"https://ddw2.diamondsdirect.com/img/careers/header_2.jpg\");background-repeat:no-repeat;background-position:0 0;background-size:cover}@media (max-width:768px){#diamonds-direct .Careers .whoWeAreBlock .imageTile{position:relative;width:100%;padding-bottom:40%;left:0;bottom:0}}#diamonds-direct .Careers .whoWeAreBlock .imageTile .imageLabel{position:absolute;top:calc(50% - 24px);left:5%;font-size:46px;color:#fff;font-weight:900;text-transform:uppercase}@media (max-width:600px){#diamonds-direct .Careers .whoWeAreBlock .imageTile .imageLabel{font-size:32px}}#diamonds-direct .Careers .whoWeAreBlock .imageTile img{height:100%}#diamonds-direct .Careers .whoWeAreBlock .copyTile{overflow:auto;position:relative;margin:120px 5% 20px 50%;background:#fff;box-shadow:10px 10px 0 rgba(0,0,0,.15)}@media (max-width:768px){#diamonds-direct .Careers .whoWeAreBlock .copyTile{position:relative;margin:0;box-shadow:none}}#diamonds-direct .Careers .whoWeAreBlock .copyTile .mainCopy{font-weight:400;font-size:19px;margin:25px 10% 0;line-height:1.3}@media (max-width:600px){#diamonds-direct .Careers .whoWeAreBlock .copyTile .mainCopy{font-size:16px}}#diamonds-direct .Careers .whoWeAreBlock .copyTile .mainCopy .textEm{font-weight:700;font-size:21px}#diamonds-direct .Careers .whoWeAreBlock .copyTile .copyWrapper{position:relative;margin:20px 0;text-align:center}#diamonds-direct .Careers .whoWeAreBlock .copyTile .copyWrapper .copyButton{display:inline-block;padding:20px 30px;font-size:16px;font-weight:400;text-transform:uppercase;border:1px solid #000;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Careers .whoWeAreBlock .copyTile .copyWrapper .copyButton:hover{color:#fff;background:#4b2d53;border-color:#4b2d53}#diamonds-direct .Careers .whoWeAreBlock .whoWeAreBackground{position:absolute;top:60px;left:0;right:0;bottom:0;background:#bf98c3}#diamonds-direct .Careers .cultureBlock .cultureHeader{position:relative}#diamonds-direct .Careers .cultureBlock .cultureHeader .cultureLabel{position:absolute;bottom:10px;left:0;right:0;height:auto;font-size:46px;color:#fff;font-weight:900;text-transform:uppercase;text-align:center;transition:font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Careers .cultureBlock .cultureHeader .cultureLabel{font-size:32px;font-size:28px}}#diamonds-direct .Careers .cultureBlock .cultureHeader img{width:100%;display:block}#diamonds-direct .Careers .cultureBlock .cultureButtons{position:relative;background-image:url(\"https://ddw2.diamondsdirect.com/img/careers/rhino.svg\");background-repeat:no-repeat;background-size:100% auto;background-position:0}#diamonds-direct .Careers .cultureBlock .cultureButtons .copyWrapper{position:absolute;top:0;left:10%;width:35%;bottom:0;text-align:left}@media (max-width:1024px){#diamonds-direct .Careers .cultureBlock .cultureButtons .copyWrapper{left:5%;width:40%}}@media (max-width:900px){#diamonds-direct .Careers .cultureBlock .cultureButtons .copyWrapper{left:3%;width:42%}}@media (max-width:768px){#diamonds-direct .Careers .cultureBlock .cultureButtons .copyWrapper{position:relative;left:0;width:70%;padding:0 15%}}#diamonds-direct .Careers .cultureBlock .cultureButtons .copyWrapper .copyTitle{margin:80px 0 25px;font-weight:700;font-size:28px}@media (max-width:1024px){#diamonds-direct .Careers .cultureBlock .cultureButtons .copyWrapper .copyTitle{margin:50px 0 20px}}@media (max-width:900px){#diamonds-direct .Careers .cultureBlock .cultureButtons .copyWrapper .copyTitle{margin:20px 0}}#diamonds-direct .Careers .cultureBlock .cultureButtons .copyWrapper .copyTitle .titleEm{font-weight:900}#diamonds-direct .Careers .cultureBlock .cultureButtons .copyWrapper .copyBody{font-size:20px}#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper{display:block;margin:0 100px 0 calc(100% - 600px);padding:15px 0;overflow:auto;max-width:500px}@media (max-width:1200px){#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper{max-width:500px;margin-right:50px;margin-left:55%}}@media (max-width:768px){#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper{margin:0 auto;width:100%;max-width:400px}}#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper .cultureButton{display:inline-block;margin:10px 20px;width:calc(50% - 40px);padding-bottom:40%;cursor:pointer;background-size:contain;background-repeat:no-repeat;background-position:50%}#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper .humilityButton{background-image:url(\"https://ddw2.diamondsdirect.com/img/careers/humility.svg\")}#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper .humilityButton.selected{background-image:url(\"https://ddw2.diamondsdirect.com/img/careers/humility_alt.svg\")}#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper .ethicButton{background-image:url(\"https://ddw2.diamondsdirect.com/img/careers/wethic.svg\")}#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper .ethicButton.selected{background-image:url(\"https://ddw2.diamondsdirect.com/img/careers/wethic_alt.svg\")}#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper .passionButton{background-image:url(\"https://ddw2.diamondsdirect.com/img/careers/passion.svg\")}#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper .passionButton.selected{background-image:url(\"https://ddw2.diamondsdirect.com/img/careers/passion_alt.svg\")}#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper .ownershipButton{background-image:url(\"https://ddw2.diamondsdirect.com/img/careers/ownership.svg\")}#diamonds-direct .Careers .cultureBlock .cultureButtons .buttonWrapper .ownershipButton.selected{background-image:url(\"https://ddw2.diamondsdirect.com/img/careers/ownership_alt.svg\")}#diamonds-direct .Careers .cultureBlock .buttonResults{color:#fff;font-size:18px}#diamonds-direct .Careers .cultureBlock .buttonResults .buttonResult{display:none;overflow:auto}#diamonds-direct .Careers .cultureBlock .buttonResults .buttonResult ul{margin:25px 0 25px 60px}@media (max-width:768px){#diamonds-direct .Careers .cultureBlock .buttonResults .buttonResult ul{margin:20px 0 20px 20px}}#diamonds-direct .Careers .cultureBlock .buttonResults .buttonResult.selected{display:block}#diamonds-direct .Careers .cultureBlock .buttonResults .humilityResult{background:#30bce2}#diamonds-direct .Careers .cultureBlock .buttonResults .ethicResult{background:#e6c615}#diamonds-direct .Careers .cultureBlock .buttonResults .passionResult{background:#e63970}#diamonds-direct .Careers .cultureBlock .buttonResults .ownershipResult{background:#bf98c3}#diamonds-direct .Careers .differenceBlock img{width:100%}#diamonds-direct .Careers .differenceBlock img.diffDesktop{display:block}@media (max-width:768px){#diamonds-direct .Careers .differenceBlock img.diffDesktop{display:none}}#diamonds-direct .Careers .differenceBlock img.diffMobile{display:none}@media (max-width:768px){#diamonds-direct .Careers .differenceBlock img.diffMobile{display:block}}#diamonds-direct .Careers .familyBlock{background:#4b2d53;color:#fff;text-align:center;overflow:auto}#diamonds-direct .Careers .familyBlock .familyTitle{margin:20px 0 10px;font-weight:700;font-size:42px}#diamonds-direct .Careers .familyBlock .familyTitle .titleEm{font-weight:900}@media (max-width:768px){#diamonds-direct .Careers .familyBlock .familyTitle{font-size:32px}}@media (max-width:480px){#diamonds-direct .Careers .familyBlock .familyTitle{font-size:26px}}#diamonds-direct .Careers .familyBlock .familySubtitle{margin:20px 0;font-weight:400;font-size:32px}@media (max-width:768px){#diamonds-direct .Careers .familyBlock .familySubtitle{font-size:26px}}@media (max-width:480px){#diamonds-direct .Careers .familyBlock .familySubtitle{font-size:24px}}#diamonds-direct .Careers .familyBlock .familySocialWrapper{font-size:28px;font-weight:400;margin:0 0 30px}@media (max-width:768px){#diamonds-direct .Careers .familyBlock .familySocialWrapper{font-size:22px}}#diamonds-direct .Careers .familyBlock .familySocialWrapper .socialIcon{display:inline-block;width:36px;vertical-align:middle;margin:0 15px;cursor:pointer}@media (max-width:768px){#diamonds-direct .Careers .familyBlock .familySocialWrapper .socialIcon{width:30px;margin:0 10px}}#diamonds-direct .Careers .familyBlock .familySocialWrapper .socialIcon img{width:100%}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper{margin:0 100px}@media (max-width:768px){#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper{margin:0 40px}}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner{position:relative}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .rotatingBannerItem img{width:100%}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerLeft{position:absolute;cursor:pointer;top:calc(50% - 20px);left:-50px;height:40px;z-index:1;transition:left .4s ease-in-out}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerLeft:hover{left:-60px}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerLeft:active{left:-65px}@media (max-width:768px){#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerLeft{top:calc(50% - 6px);left:-20px;height:12px}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerLeft:hover{left:-25px}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerLeft:active{left:-30px}}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerLeft .leftArrow{width:0;height:0;border-top:20px solid transparent;border-bottom:20px solid transparent;border-right:20px solid #fff;transition:border-right .2s ease-in-out}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerLeft .leftArrow:hover{border-right:20px solid hsla(0,0%,100%,.8)}@media (max-width:768px){#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerLeft .leftArrow{border-top:12px solid transparent;border-bottom:12px solid transparent;border-right:12px solid #fff}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerLeft .leftArrow:hover{border-right:12px solid hsla(0,0%,100%,.8)}}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerRight{position:absolute;cursor:pointer;top:calc(50% - 20px);right:-50px;height:40px;z-index:1;transition:right .4s ease-in-out}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerRight:hover{right:-60px}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerRight:active{right:-65px}@media (max-width:768px){#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerRight{top:calc(50% - 6px);right:-20px;height:12px}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerRight:hover{right:-25px}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerRight:active{right:-30px}}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerRight .rightArrow{width:0;height:0;border-top:20px solid transparent;border-bottom:20px solid transparent;border-left:20px solid #fff;transition:border-left .2s ease-in-out}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerRight .rightArrow:hover{border-left:20px solid hsla(0,0%,100%,.8)}@media (max-width:768px){#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerRight .rightArrow{border-top:12px solid transparent;border-bottom:12px solid transparent;border-left:12px solid #fff}#diamonds-direct .Careers .familyBlock .rotatingBannerWrapper .familyRotatingBanner .bannerRight .rightArrow:hover{border-left:12px solid hsla(0,0%,100%,.8)}}#diamonds-direct .Careers .benefitsBlock{background:#f4f4f5;color:#707070;overflow:auto;text-align:center}#diamonds-direct .Careers .benefitsBlock .benefitsTitle{color:#4b2d53;margin:25px 100px 15px;font-size:36px;font-weight:900;text-align:left}@media (max-width:768px){#diamonds-direct .Careers .benefitsBlock .benefitsTitle{margin:25px 30px 15px}}#diamonds-direct .Careers .benefitsBlock .benefitsText{margin:0 100px 15px;font-size:18px;text-align:left}@media (max-width:768px){#diamonds-direct .Careers .benefitsBlock .benefitsText{margin:0 30px 15px}}#diamonds-direct .Careers .benefitsBlock .learnMoreBody.open{max-height:2000px}#diamonds-direct .Careers .benefitsBlock .learnMoreBody{max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .Careers .benefitsBlock .learnMoreBody ul{display:inline-block;vertical-align:top;width:20%;list-style-type:none;font-size:17px}@media (max-width:768px){#diamonds-direct .Careers .benefitsBlock .learnMoreBody ul{width:70%;margin:0}}#diamonds-direct .Careers .benefitsBlock .learnMoreBody ul li{text-align:left}#diamonds-direct .Careers .benefitsBlock .learnMoreBody ul li:before{content:\"\\2022   \";color:#cf9bdd;font-weight:400}#diamonds-direct .Careers .benefitsBlock .learnMoreBody ul .indent{margin-left:20px}#diamonds-direct .Careers .benefitsBlock .learnMoreToggle{display:inline-block;width:140px;margin:15px 0;font-weight:900;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Careers .benefitsBlock .learnMoreToggle .learnMoreText{font-size:18px;text-transform:uppercase}#diamonds-direct .Careers .buttonBlock{text-align:center;margin:25px 0 0}#diamonds-direct .Careers .buttonBlock .jobsButton{background:#4b2d53;font-size:16px}#diamonds-direct .Careers .buttonBlock .jobsButton:hover{background:#623b6c}#diamonds-direct .Careers .buttonSubtext{text-align:center;margin:35px 200px 25px;font-size:15px;color:#707070}@media (max-width:768px){#diamonds-direct .Careers .buttonSubtext{margin:25px 30px}}#diamonds-direct .Careers .buttonSubtext a{color:#bf98c3;text-decoration:none;font-weight:700}#diamonds-direct .Careers .buttonSubtext a:visited{color:#bf98c3}#diamonds-direct .Careers .eeoStatement{text-align:center;margin:25px 300px;font-size:15px;color:#707070}@media (max-width:768px){#diamonds-direct .Careers .eeoStatement{margin:25px 30px}}@keyframes fadein{0%{background:transparent}to{background:rgba(0,0,0,.25)}}@keyframes fadeout{0%{background:rgba(0,0,0,.25)}to{background:transparent}}@keyframes slidein{0%{right:-100%}to{right:0}}@keyframes slideout{0%{right:0}to{right:-100%}}#diamonds-direct .Contact,#diamonds-direct .ContactPage,#diamonds-direct .Press{background:rgba(0,0,0,.25);transition:opacity .1s ease-in-out 0ms}#diamonds-direct .Contact .repairNotice,#diamonds-direct .ContactPage .repairNotice,#diamonds-direct .Press .repairNotice{text-align:center;font-size:18px;font-family:Lusitana,serif;margin:20px 0 0}#diamonds-direct .Contact .contactBody,#diamonds-direct .ContactPage .contactBody,#diamonds-direct .Press .contactBody{position:relative}#diamonds-direct .Contact .contactBody .closeContact,#diamonds-direct .ContactPage .contactBody .closeContact,#diamonds-direct .Press .contactBody .closeContact{position:absolute;cursor:pointer;background-image:radial-gradient(#fff,#fff);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:20px;right:20px;width:28px;height:28px;border:1px solid #fff;transform:rotate(45deg);transition:background-size .25s ease-in-out 0ms}#diamonds-direct .Contact .contactBody .closeContact:hover,#diamonds-direct .ContactPage .contactBody .closeContact:hover,#diamonds-direct .Press .contactBody .closeContact:hover{background-size:100% 100%}#diamonds-direct .Contact .contactBody .closeContact:hover .closeX,#diamonds-direct .ContactPage .contactBody .closeContact:hover .closeX,#diamonds-direct .Press .contactBody .closeContact:hover .closeX{color:#95989a}#diamonds-direct .Contact .contactBody .closeContact .closeX,#diamonds-direct .ContactPage .contactBody .closeContact .closeX,#diamonds-direct .Press .contactBody .closeContact .closeX{color:#fff;margin:-1px 0 0 -2px;transform:rotate(-45deg);line-height:28px;text-align:center;font-size:28px;font-weight:300;transition:color .25s ease-in-out 0ms}#diamonds-direct .Contact .contactBody .formWrapper,#diamonds-direct .ContactPage .contactBody .formWrapper,#diamonds-direct .Press .contactBody .formWrapper{padding:0 180px;width:600px;overflow-y:auto;height:100%;text-align:center;transition:padding .35s linear 0ms}#diamonds-direct .Contact .contactBody .formWrapper .formLogo,#diamonds-direct .ContactPage .contactBody .formWrapper .formLogo,#diamonds-direct .Press .contactBody .formWrapper .formLogo{width:55%;margin:40px auto 0}#diamonds-direct .Contact .contactBody .formWrapper .formLogo img,#diamonds-direct .ContactPage .contactBody .formWrapper .formLogo img,#diamonds-direct .Press .contactBody .formWrapper .formLogo img{width:100%}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formTitle,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formTitle,#diamonds-direct .Press .contactBody .formWrapper .formBody .formTitle{font-size:36px;font-weight:300;text-align:center;margin:15px 0;color:#fff;transition:font-size .35s linear 0ms}@media (max-width:480px){#diamonds-direct .Contact .contactBody .formWrapper .formBody .formTitle,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formTitle,#diamonds-direct .Press .contactBody .formWrapper .formBody .formTitle{font-size:28px}}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formText,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formText,#diamonds-direct .Press .contactBody .formWrapper .formBody .formText{color:#fff;margin:0 0 10px}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formText .inlineLink,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formText .inlineLink,#diamonds-direct .Press .contactBody .formWrapper .formBody .formText .inlineLink{color:#fff;font-weight:700;text-decoration:underline}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow{width:100%;text-align:center}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow input,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow input,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow input{display:inline-block;margin:5px;padding:10px;width:calc(50% - 30px);border:none;outline:none}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow input::-webkit-input-placeholder,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow input::-webkit-input-placeholder,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow input::-webkit-input-placeholder{color:#95989a}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow input:-moz-placeholder,#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow input::-moz-placeholder,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow input:-moz-placeholder,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow input::-moz-placeholder,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow input:-moz-placeholder,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow input::-moz-placeholder{color:#95989a}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow input:-ms-input-placeholder,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow input:-ms-input-placeholder,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow input:-ms-input-placeholder{color:#95989a}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow input.error,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow input.error,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow input.error{border:2px solid #eb3533;width:calc(50% - 34px)}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow .contactSelect,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow .contactSelect,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow .contactSelect{margin:5px;width:calc(50% - 10px)}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow .contactSelect select,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow .contactSelect select,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow .contactSelect select{border:none;background:#fff;color:#95989a}@media (max-width:600px){#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow .contactSelect,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow .contactSelect,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow .contactSelect{width:calc(100% - 10px)}}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow .contactSelect.error select,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow .contactSelect.error select,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow .contactSelect.error select{border:2px solid #eb3533;color:#95989a}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow .contactSelect.error .select__arrow,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow .contactSelect.error .select__arrow,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow .contactSelect.error .select__arrow{border-color:#95989a transparent transparent}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow .contactSelect.error select:focus~.select__arrow,#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow .contactSelect.error select:hover~.select__arrow,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow .contactSelect.error select:focus~.select__arrow,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow .contactSelect.error select:hover~.select__arrow,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow .contactSelect.error select:focus~.select__arrow,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow .contactSelect.error select:hover~.select__arrow{border-top-color:#95989a}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow textarea,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow textarea,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow textarea{margin:5px;padding:10px;width:calc(100% - 30px);height:150px;border:none;outline:none}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow textarea::-webkit-input-placeholder,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow textarea::-webkit-input-placeholder,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow textarea::-webkit-input-placeholder{color:#95989a}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow textarea:-moz-placeholder,#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow textarea::-moz-placeholder,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow textarea:-moz-placeholder,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow textarea::-moz-placeholder,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow textarea:-moz-placeholder,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow textarea::-moz-placeholder{color:#95989a}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow textarea:-ms-input-placeholder,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow textarea:-ms-input-placeholder,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow textarea:-ms-input-placeholder{color:#95989a}#diamonds-direct .Contact .contactBody .formWrapper .formBody .formRow textarea.error,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .formRow textarea.error,#diamonds-direct .Press .contactBody .formWrapper .formBody .formRow textarea.error{border:2px solid #eb3533;width:calc(100% - 34px)}#diamonds-direct .Contact .contactBody .formWrapper .formBody .contactSubmit,#diamonds-direct .ContactPage .contactBody .formWrapper .formBody .contactSubmit,#diamonds-direct .Press .contactBody .formWrapper .formBody .contactSubmit{padding:0 50px;margin:5px auto 0}#diamonds-direct .Contact .contactBody .formWrapper .phonePrompt,#diamonds-direct .ContactPage .contactBody .formWrapper .phonePrompt,#diamonds-direct .Press .contactBody .formWrapper .phonePrompt{margin:25px 0 0;color:#fff;text-align:center}#diamonds-direct .Contact .contactBody .formWrapper .phonePrompt a,#diamonds-direct .ContactPage .contactBody .formWrapper .phonePrompt a,#diamonds-direct .Press .contactBody .formWrapper .phonePrompt a{text-decoration:none;color:#fff}#diamonds-direct .Contact .contactBody .formWrapper .chatButton,#diamonds-direct .ContactPage .contactBody .formWrapper .chatButton,#diamonds-direct .Press .contactBody .formWrapper .chatButton{margin:20px 0;font-weight:400}@media (max-width:1024px){#diamonds-direct .Contact .contactBody .formWrapper,#diamonds-direct .ContactPage .contactBody .formWrapper,#diamonds-direct .Press .contactBody .formWrapper{padding:0 80px}}@media (max-width:768px){#diamonds-direct .Contact .contactBody .formWrapper,#diamonds-direct .ContactPage .contactBody .formWrapper,#diamonds-direct .Press .contactBody .formWrapper{width:80%;margin:0 auto;padding:0}}@media (max-width:600px){#diamonds-direct .Contact .contactBody .formWrapper,#diamonds-direct .ContactPage .contactBody .formWrapper,#diamonds-direct .Press .contactBody .formWrapper{width:90%}}@media (max-width:480px){#diamonds-direct .Contact .contactBody .formWrapper,#diamonds-direct .ContactPage .contactBody .formWrapper,#diamonds-direct .Press .contactBody .formWrapper{width:90%}}#diamonds-direct .Contact.closed{display:none;z-index:2}#diamonds-direct .Contact.closed .contactBody{right:-100%;width:auto;height:calc(100vh - 54px);z-index:3}#diamonds-direct .Contact.open{display:block;z-index:2;animation-name:fadein;animation-duration:.5s;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.25)}#diamonds-direct .Contact.open .contactBody{z-index:3;position:absolute;top:100px;right:0;width:auto;bottom:0;background:#95989a;transition:top .4s ease-in-out 0ms;animation-name:slidein;animation-duration:.5s}@media (max-width:768px){#diamonds-direct .Contact.open .contactBody{width:100%;top:55px}}#diamonds-direct .Contact.closing{z-index:2;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.25);animation-name:fadeout;animation-duration:.5s}#diamonds-direct .Contact.closing .contactBody{position:absolute;background:#95989a;opacity:1;top:100px;right:-100%;width:auto;bottom:0;z-index:3;animation-name:slideout;animation-duration:.5s}@media (max-width:768px){#diamonds-direct .Contact.closing .contactBody{width:100%;top:55px}}#diamonds-direct .Contact.scrolled .contactBody{top:60px}@media (max-width:768px){#diamonds-direct .Contact.scrolled .contactBody{top:50px}}#diamonds-direct .ContactPage,#diamonds-direct .Press,#diamonds-direct .VideoChat{overflow:hidden;position:relative;background:#fff}#diamonds-direct .ContactPage .scheduleLeftBg,#diamonds-direct .Press .scheduleLeftBg,#diamonds-direct .VideoChat .scheduleLeftBg{position:absolute;top:120px;left:0;width:20%;height:600px;background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/contact_bg_l.png\");background-repeat:no-repeat;background-position:0 0;background-size:contain}@media (max-width:1200px){#diamonds-direct .ContactPage .scheduleLeftBg,#diamonds-direct .Press .scheduleLeftBg,#diamonds-direct .VideoChat .scheduleLeftBg{width:15%}}@media (max-width:1024px){#diamonds-direct .ContactPage .scheduleLeftBg,#diamonds-direct .Press .scheduleLeftBg,#diamonds-direct .VideoChat .scheduleLeftBg{display:none}}#diamonds-direct .ContactPage .scheduleRightBg,#diamonds-direct .Press .scheduleRightBg,#diamonds-direct .VideoChat .scheduleRightBg{position:absolute;top:120px;right:0;width:20%;height:600px;background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/contact_bg_r.png\");background-repeat:no-repeat;background-position:100% 0;background-size:contain}@media (max-width:1200px){#diamonds-direct .ContactPage .scheduleRightBg,#diamonds-direct .Press .scheduleRightBg,#diamonds-direct .VideoChat .scheduleRightBg{width:15%}}@media (max-width:1024px){#diamonds-direct .ContactPage .scheduleRightBg,#diamonds-direct .Press .scheduleRightBg,#diamonds-direct .VideoChat .scheduleRightBg{display:none}}#diamonds-direct .ContactPage .scheduleHeader,#diamonds-direct .Press .scheduleHeader,#diamonds-direct .VideoChat .scheduleHeader{position:relative;z-index:1;text-align:center;font-size:40px;padding:40px 0;background:#f0f0f0}@media (max-width:768px){#diamonds-direct .ContactPage .scheduleHeader,#diamonds-direct .Press .scheduleHeader,#diamonds-direct .VideoChat .scheduleHeader{font-size:32px;margin-top:10px}}#diamonds-direct .ContactPage .scheduleBody,#diamonds-direct .Press .scheduleBody,#diamonds-direct .VideoChat .scheduleBody{position:relative;margin:0 auto 25px;width:90%;max-width:800px;z-index:2}#diamonds-direct .ContactPage .scheduleBody .scheduleBr,#diamonds-direct .Press .scheduleBody .scheduleBr,#diamonds-direct .VideoChat .scheduleBody .scheduleBr{width:100%;height:70px;margin:-35px auto 5px;background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/ddline.svg\");background-repeat:no-repeat;background-position:50%;background-size:cover}@media (max-width:900px){#diamonds-direct .ContactPage .scheduleBody .scheduleBr,#diamonds-direct .Press .scheduleBody .scheduleBr,#diamonds-direct .VideoChat .scheduleBody .scheduleBr{width:80%;height:50px;margin-top:-25px}}@media (max-width:480px){#diamonds-direct .ContactPage .scheduleBody .scheduleBr,#diamonds-direct .Press .scheduleBody .scheduleBr,#diamonds-direct .VideoChat .scheduleBody .scheduleBr{width:80%;height:40px;margin-top:-20px}}#diamonds-direct .ContactPage .scheduleBody .sbText,#diamonds-direct .Press .scheduleBody .sbText,#diamonds-direct .VideoChat .scheduleBody .sbText{text-align:center;font-size:18px;margin:0 0 15px}#diamonds-direct .ContactPage .scheduleBody .sbText .inlineLink,#diamonds-direct .Press .scheduleBody .sbText .inlineLink,#diamonds-direct .VideoChat .scheduleBody .sbText .inlineLink{text-decoration:underline;color:#bf98c3;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbText .inlineLink:hover,#diamonds-direct .Press .scheduleBody .sbText .inlineLink:hover,#diamonds-direct .VideoChat .scheduleBody .sbText .inlineLink:hover{color:#b07fb5}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper,#diamonds-direct .Press .scheduleBody .optionsWrapper,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper{text-align:center}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption{display:inline-block;vertical-align:top;margin:0 10px 25px;width:calc(33.33% - 62px);max-width:240px;min-width:160px}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem.selected,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem.selected,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem.selected{border-color:#4b2d53}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem{padding:20px;border:1px solid #f0f0f0;cursor:pointer;transition:border .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem:hover,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem:hover,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem:hover{border-color:#4b2d53}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem .optionImg,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem .optionImg,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem .optionImg{height:45px}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem .optionImg img,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem .optionImg img,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem .optionImg img{height:100%}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem .optionBr,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem .optionBr,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem .optionBr{height:3px;margin:10px 0 0;background:#d3d3d3}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem .optionTitle,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem .optionTitle,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem .optionTitle{position:relative;font-size:16px;color:#4b2d53;text-transform:none;line-height:1.1;font-weight:400;height:40px;font-family:Lato,sans-serif;margin:20px 0 0}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem .optionTitle div,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem .optionTitle div,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem .optionTitle div{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem .optionButton.selected,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem .optionButton.selected,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem .optionButton.selected{color:#fff;background:#4b2d53}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem .optionButton,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem .optionButton,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem .optionButton{display:none;color:#4b2d53;background:#fff;border:1px solid #4b2d53;font-size:12px;font-weight:700;margin:20px 0 0;font-family:Lato,sans-serif;text-transform:uppercase;text-align:center;padding:8px 0;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionItem .optionButton:hover,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionItem .optionButton:hover,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionItem .optionButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionRow.open,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionRow.open,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionRow.open{max-height:200px}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionRow,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionRow,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionRow{height:auto;max-height:0;overflow:hidden;padding:20px 0 0}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionRow .optionRowButton.selected,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionRow .optionRowButton.selected,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionRow .optionRowButton.selected{color:#fff;background:#4b2d53}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionRow .optionRowButton,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionRow .optionRowButton,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionRow .optionRowButton{display:block;color:#4b2d53;background:#fff;border:1px solid #4b2d53;font-size:12px;font-weight:700;margin:0 10px 20px;font-family:Lato,sans-serif;text-transform:uppercase;text-align:center;padding:8px 15px;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .optionsWrapper .singleOption .optionRow .optionRowButton:hover,#diamonds-direct .Press .scheduleBody .optionsWrapper .singleOption .optionRow .optionRowButton:hover,#diamonds-direct .VideoChat .scheduleBody .optionsWrapper .singleOption .optionRow .optionRowButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .ContactPage .scheduleBody .sbHours,#diamonds-direct .Press .scheduleBody .sbHours,#diamonds-direct .VideoChat .scheduleBody .sbHours{text-align:center;font-size:16px;margin:0}#diamonds-direct .ContactPage .scheduleBody .sbHours .inlineLink,#diamonds-direct .Press .scheduleBody .sbHours .inlineLink,#diamonds-direct .VideoChat .scheduleBody .sbHours .inlineLink{text-decoration:underline;color:#bf98c3;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbHours .inlineLink:hover,#diamonds-direct .Press .scheduleBody .sbHours .inlineLink:hover,#diamonds-direct .VideoChat .scheduleBody .sbHours .inlineLink:hover{color:#b07fb5}#diamonds-direct .ContactPage .scheduleBody .hoursSmall.sbHours,#diamonds-direct .Press .scheduleBody .hoursSmall.sbHours,#diamonds-direct .VideoChat .scheduleBody .hoursSmall.sbHours{font-size:15px;font-weight:300;margin:0 0 15px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody{overflow-x:auto;overflow-y:hidden;background:#eee;font-family:Lato,sans-serif;border-top:5px solid #b78dbb;margin:0 0 20px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .contactPageSelect,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .contactPageSelect,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .contactPageSelect{margin:5px 0 0}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .contactPageSelect select,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .contactPageSelect select,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .contactPageSelect select{background:#fff;color:#95989a;border:1px solid #ddd}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formSubheader,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formSubheader,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formSubheader{margin:15px 0;text-align:center}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow.emRow,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow.emRow,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow.emRow{background:#ddd;margin:0;padding:10px 0}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow.preBanner,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow.preBanner,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow.preBanner{margin:0 10px 10px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow{margin:10px 10px 0}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection{display:inline-block;vertical-align:top;overflow:hidden;margin:0 .5%;width:49%;transition:width .35s linear 0ms,margin .35s linear 0ms}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection input,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection input,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection input{width:calc(100% - 22px)}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection{width:100%;margin:0}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .expandableHalfSection.open,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .expandableHalfSection.open,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .expandableHalfSection.open{max-height:70px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .expandableHalfSection,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .expandableHalfSection,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .expandableHalfSection{height:auto;max-height:0;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneThirdSection,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneThirdSection,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneThirdSection{display:inline-block;margin:0 1.5%;width:30.3%;vertical-align:top;transition:width .35s linear 0ms,margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneThirdSection,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneThirdSection,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneThirdSection{width:100%;margin:0}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioYesNoLabel.error,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioYesNoLabel.error,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioYesNoLabel.error{color:#eb3533}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioYesNoLabel,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioYesNoLabel,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioYesNoLabel{font-size:14px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow{font-size:16px;text-align:left}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow .radioInputWrapper,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow .radioInputWrapper,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow .radioInputWrapper{margin:8px 40px 0 2px;transition:margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow .radioInputWrapper,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow .radioInputWrapper,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow .radioInputWrapper{margin-bottom:10px}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper{display:inline-block;width:auto}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper .radioInputElement,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper .radioInputElement,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper .radioInputElement{display:inline-block;width:20px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper .radioLabel,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper .radioLabel,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper .radioLabel{display:inline-block;width:auto;margin:0 0 0 8px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper{display:inline-block;width:auto}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper .checkboxInputElement,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper .checkboxInputElement,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper .checkboxInputElement{display:inline-block;width:20px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper .checkboxLabel,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper .checkboxLabel,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper .checkboxLabel{display:inline-block;width:auto}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.checkboxInput,#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.radioInput,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.checkboxInput,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.radioInput,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.checkboxInput,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.radioInput{width:auto}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input{display:inline-block;margin:5px 0;padding:10px;width:calc(100% - 20px);border:1px solid #ddd;outline:none}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input::-webkit-input-placeholder,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input::-webkit-input-placeholder,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input::-webkit-input-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input:-moz-placeholder,#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input::-moz-placeholder,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input:-moz-placeholder,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input::-moz-placeholder,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input:-moz-placeholder,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input::-moz-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input:-ms-input-placeholder,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input:-ms-input-placeholder,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input:-ms-input-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.error,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.error,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.error{border:1px solid #eb3533}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .textareaLabelWrapper,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .textareaLabelWrapper,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .textareaLabelWrapper{margin:8px 0 0;font-size:14px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .textareaInputWrapper,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .textareaInputWrapper,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .textareaInputWrapper{margin:8px 0 0}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea{margin:0;padding:10px;width:calc(100% - 20px);height:75px;border:1px solid #ddd;outline:none}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea::-webkit-input-placeholder,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea::-webkit-input-placeholder,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea::-webkit-input-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea:-moz-placeholder,#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea::-moz-placeholder,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea:-moz-placeholder,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea::-moz-placeholder,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea:-moz-placeholder,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea::-moz-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea:-ms-input-placeholder,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea:-ms-input-placeholder,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea:-ms-input-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea.error,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea.error,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea.error{border:2px solid #eb3533;width:calc(100% - 34px)}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .selectWrapper,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .selectWrapper,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .selectWrapper{margin-top:4px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .selectWrapper select,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .selectWrapper select,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .selectWrapper select{border:none;background:#fff}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .submitButton,#diamonds-direct .Press .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .submitButton,#diamonds-direct .VideoChat .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .submitButton{display:block;width:280px;font-weight:700;padding:10px 0;text-align:center;margin:25px auto;cursor:pointer;font-size:18px;font-weight:400;text-transform:none;height:25px;line-height:25px;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper.openForm{max-height:10000px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper{height:auto;max-height:0;overflow:hidden}#diamonds-direct .VideoChat .scheduleBody{max-width:1024px}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidLeftCol{display:inline-block;vertical-align:top;width:35%}@media (max-width:768px){#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidLeftCol{display:none}}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidLeftCol img{width:100%}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidRightCol{display:inline-block;vertical-align:top;width:65%}@media (max-width:768px){#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidRightCol{display:block;width:auto}}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidRightCol .vidTitle{font-size:24px;margin:0 0 40px 10px;text-align:center}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidRightCol .vidP{font-size:18px;margin:0 0 25px 10px;color:#626262;font-family:Lato,sans-serif}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidRightCol .vidButton{position:relative;margin:0 auto 25px;width:260px;height:60px;color:#fff;background:#4b2d53;text-align:center;text-transform:uppercase;font-family:Lato,sans-serif;font-size:14px;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidRightCol .vidButton:hover{background:#000}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidRightCol .vidButton div{position:absolute;top:0;right:20px;bottom:0;left:20px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidRightCol .vidLegal{display:none;color:#999;margin:0 0 25px 10px;font-size:14px;font-weight:400;font-family:Lato,sans-serif}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidMobileImg{display:none;text-align:center}@media (max-width:768px){#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidMobileImg{display:block}}#diamonds-direct .VideoChat .scheduleBody .vidWrapper .vidMobileImg img{width:100%}#diamonds-direct .CustomDesign{font-family:Lato,sans-serif;color:#000;background:#f8f8fa}#diamonds-direct .CustomDesign .designHeader{font-family:Lusitana,serif;color:#fff;font-size:54px;padding:15px 60px 50px;background:#4b2d53}#diamonds-direct .CustomDesign .designSubheader{position:relative;z-index:1;top:-20px;border:1px solid #707070;background:#fff;margin:0 150px;text-align:center;padding:40px 100px}@media (max-width:768px){#diamonds-direct .CustomDesign .designSubheader{margin:0}}#diamonds-direct .CustomDesign .designSubheader .subheaderDiamond{position:absolute;top:-45px;width:90px;height:90px;left:calc(50% - 45px)}#diamonds-direct .CustomDesign .designSubheader .subheaderDiamond img{width:100%}#diamonds-direct .CustomDesign .designSubheader .subheaderTitle{color:#4b2d53;text-transform:uppercase;margin:0 0 15px;font-size:24px;font-weight:900}#diamonds-direct .CustomDesign .stepsWrapper{position:relative}#diamonds-direct .CustomDesign .stepsWrapper .stepTop{position:relative;margin:0 auto;width:300px;top:-20px}#diamonds-direct .CustomDesign .stepsWrapper .stepTop img{width:100%}#diamonds-direct .CustomDesign .stepsWrapper .stepBody{position:relative;width:0;border:2px solid #4b2d53;margin:0 auto;top:-56px;height:520px}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody{height:1000px}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepOne{top:-5px}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepOne{top:20px}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepOne .stepArrow{top:20px;left:100%}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepOne .stepArrow{display:none}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepTwo{top:140px}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepTwo{top:360px}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepTwo .stepArrow{top:10px;right:100%}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepTwo .stepArrow{display:none}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepThree{top:150px}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepThree{top:500px}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepThree .stepArrow{top:80px;left:100%}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepThree .stepArrow{display:none}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepFour{top:300px}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepFour{top:800px}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepFour .stepArrow{bottom:10px;right:100%}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement.stepFour .stepArrow{display:none}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement{position:absolute;background:#fff;border:1px solid #d3d3d3;width:325px;height:auto;min-height:120px;box-shadow:6px 6px 0 rgba(191,152,195,.6)}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement .stepNumber{position:absolute;font-size:88px;line-height:88px;font-family:Lusitana,serif;color:#ebebeb;top:20px;width:70px;text-align:center;font-weight:700}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement .stepText{padding-top:25px;padding-bottom:20px}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement .stepArrow{position:absolute;width:20px;height:auto}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .stepElement .stepArrow img{width:100%}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .leftStep.stepElement{right:40px}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .leftStep.stepElement{left:-162px}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .leftStep.stepElement .stepNumber{left:0}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .leftStep.stepElement .stepText{padding-left:80px;padding-right:20px;text-align:left}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .rightStep.stepElement{left:40px}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .rightStep.stepElement{left:-162px}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .rightStep.stepElement .stepNumber{right:0}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .rightStep.stepElement .stepText{padding-left:20px;padding-right:80px;text-align:right}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .imgElement.imgOne{top:-60px;left:100px;width:180px;height:auto}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .imgElement.imgOne{top:155px;left:-90px}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .imgElement.imgTwo{bottom:60px;right:80px;width:240px;height:auto}@media (max-width:768px){#diamonds-direct .CustomDesign .stepsWrapper .stepBody .imgElement.imgTwo{top:645px;left:-100px;width:200px}}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .imgElement{position:absolute}#diamonds-direct .CustomDesign .stepsWrapper .stepBody .imgElement img{width:100%}#diamonds-direct .CustomDesign .stepsWrapper .stepBottom{position:relative;width:240px;margin:0 auto;top:-70px;left:-3px}#diamonds-direct .CustomDesign .stepsWrapper .stepBottom img{width:100%}#diamonds-direct .CustomDesign .buttonWrapper{text-align:center;position:relative;top:-20px}#diamonds-direct .CustomDesign .buttonWrapper .formButton{display:inline-block;cursor:pointer;background:#fff;color:#4b2d53;border:2px solid #4b2d53;padding:8px 25px;font-size:18px;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .CustomDesign .buttonWrapper .formButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .CustomDesign .formExpansionWrapper.open{max-height:1000px}#diamonds-direct .CustomDesign .formExpansionWrapper{height:auto;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper{margin:25px auto;width:90%;max-width:800px}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid gray;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid gray;background:#fff}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .formInputWrapper .RhinoSelect.error select{border:2px solid #eb3533}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .textareaInputWrapper{display:inline-block;vertical-align:top;width:calc(100% - 20px);margin:5px 10px}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .textareaInputWrapper textarea{vertical-align:top;border:1px solid gray;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .textareaInputWrapper textarea.error{border:2px solid #eb3533}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .formActionRow .formAction{color:#472f51;background:#fff;border:1px solid #472f51;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .CustomDesign .formExpansionWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#472f51}#diamonds-direct .CustomDesign .imagesWrapper{margin:50px 50px 0;padding:0 0 50px}@media (max-width:768px){#diamonds-direct .CustomDesign .imagesWrapper{margin:0;padding:0}}#diamonds-direct .CustomDesign .imagesWrapper .videoIcon{display:inline-block;width:calc(33.3% - 5px);vertical-align:top;cursor:pointer}#diamonds-direct .CustomDesign .imagesWrapper .videoIcon img{width:100%}@media (max-width:768px){#diamonds-direct .CustomDesign .imagesWrapper .videoIcon{display:block;width:100%}}#diamonds-direct .CustomDesign .imagesWrapper .imagesSlider{position:relative;display:inline-block;width:calc(66.6% - 5px - 10%);vertical-align:top;margin:0 0 0 10px;overflow:auto}@media (max-width:768px){#diamonds-direct .CustomDesign .imagesWrapper .imagesSlider{display:block;width:100%}}#diamonds-direct .CustomDesign .imagesWrapper .imagesSlider .rotatingBannerItem.gridItem img{display:inline-block;width:calc(50% - 10px);vertical-align:top}#diamonds-direct .CustomDesign .imagesWrapper .imagesSlider .rotatingBannerItem.gridItem img:nth-child(odd){margin-right:10px}#diamonds-direct .CustomDesign .imagesWrapper .imagesSlider .rotatingBannerItem{width:calc(25% - 20px);margin:0;text-align:center}#diamonds-direct .CustomDesign .imagesWrapper .imagesSlider .rotatingBannerItem img{width:calc(100% - 10px)}#diamonds-direct .CustomDesign .customDesignVideo{position:relative}#diamonds-direct .CustomDesign .customDesignVideo .closeIcon{position:absolute;cursor:pointer;color:#fff;font-size:36px;height:36px;line-height:36px;font-weight:300;top:-5px;left:calc(100% + 5px);z-index:1;transition:top .35s linear 0ms,right .35s linear 0ms,width .35s linear 0ms,height .35s linear 0ms,background-size .25s ease-in-out 0ms}#diamonds-direct .CustomDesign .customDesignVideo .closeIcon:hover{background-size:100% 100%}#diamonds-direct .CustomDesign .customDesignVideo .closeIcon:hover .closeX{color:#fff}@media (max-width:768px){#diamonds-direct .CustomDesign .customDesignVideo .closeIcon{top:-5px;left:calc(100% + 5px);font-size:28px;height:28px;line-height:28px}}#diamonds-direct .CustomDesign .modalVideo{width:640px;height:360px;border:none;display:block}@media (max-width:768px){#diamonds-direct .CustomDesign .modalVideo{width:320px;height:180px}}#diamonds-direct .Designers{font-family:Lato,sans-serif}#diamonds-direct .Designers .bannerHeader{position:relative;display:inline-block;width:auto;color:#3d3d3d}#diamonds-direct .Designers .bannerHeader .textWrapper{position:relative;font-size:42px;font-weight:700;bottom:-18px}@media (max-width:768px){#diamonds-direct .Designers .bannerHeader .textWrapper{font-size:36px}}@media (max-width:480px){#diamonds-direct .Designers .bannerHeader .textWrapper{font-size:28px}}#diamonds-direct .Designers .bannerHeader .underlineWrapper{background:#efe2f1;height:20px}#diamonds-direct .Designers .bannerSubheader{text-align:center;color:#4b2d53;font-weight:300;font-size:18px}@media (max-width:480px){#diamonds-direct .Designers .bannerSubheader{font-size:16px}}#diamonds-direct .Designers .linksWrapper{margin:30px auto;text-align:left;width:90%}#diamonds-direct .Designers .linksWrapper .linkColumn{display:inline-block;width:calc(25% - 1px);border-left:1px solid #dcdcdc;vertical-align:top;height:100%}#diamonds-direct .Designers .linksWrapper .linkColumn:first-child{border-left:none}@media (max-width:768px){#diamonds-direct .Designers .linksWrapper .linkColumn{width:calc(50% - 1px)}#diamonds-direct .Designers .linksWrapper .linkColumn:nth-child(3){border-left:none}}#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink.fourRow{display:block}@media (max-width:768px){#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink.fourRow{display:none}}#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink.twoRow{display:none}@media (max-width:768px){#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink.twoRow{display:block;border-right:1px solid #dcdcdc}}#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink.noLink{cursor:default}#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink.noLink:hover{color:#858585}#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink{text-align:center;cursor:pointer;color:#858585;font-size:20px;font-weight:400;height:50px;line-height:50px;transition:color .25s ease-in-out 0ms}@media (max-width:900px){#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink{font-size:16px}}@media (max-width:768px){#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink{font-size:20px}}@media (max-width:480px){#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink{font-size:16px}}#diamonds-direct .Designers .linksWrapper .linkColumn .designerLink:hover{color:#e2cce4}#diamonds-direct .Designers .designersHeader{cursor:pointer}#diamonds-direct .Designers .designersHeader img{width:100%}#diamonds-direct .Designers .dddBanner{background:#f4f4f4;position:relative;text-align:center}#diamonds-direct .Designers .dddBanner .dddLogoSide{width:35%;max-width:400px;vertical-align:top;display:inline-block;margin:30px 0 40px}@media (max-width:768px){#diamonds-direct .Designers .dddBanner .dddLogoSide{width:90%;margin:30px 0 0}}#diamonds-direct .Designers .dddBanner .dddLogoSide .dddLogoWrapper{width:80%;max-width:300px;margin:0 auto}#diamonds-direct .Designers .dddBanner .dddLogoSide .dddLogoWrapper img{width:100%}#diamonds-direct .Designers .dddBanner .dddLogoSide .dddTextWrapper{text-align:left;font-family:Lusitana,serif;color:#5e5e5e;font-size:19px;font-weight:400;margin:15px 0 0}@media (max-width:768px){#diamonds-direct .Designers .dddBanner .dddLogoSide .dddTextWrapper{text-align:center}}#diamonds-direct .Designers .dddBanner .dddImageSide{width:50%;margin:25px 0 10px 50px;max-width:500px;vertical-align:top;display:inline-block}@media (max-width:768px){#diamonds-direct .Designers .dddBanner .dddImageSide{width:80%;margin:20px 0 10px}}#diamonds-direct .Designers .dddBanner .dddImageSide img{width:100%}#diamonds-direct .Designers .premierBanner{text-align:center;width:80%;margin:0 auto}@media (max-width:768px){#diamonds-direct .Designers .premierBanner{width:90%}}#diamonds-direct .Designers .premierBanner .elementWrapper{margin:25px 0 20px}#diamonds-direct .Designers .premierBanner .elementWrapper .premierElement{display:inline-block;width:25%;height:100px;margin:0 2% 10px;cursor:pointer}@media (max-width:768px){#diamonds-direct .Designers .premierBanner .elementWrapper .premierElement{width:40%;margin:0 2% 5px}}@media (max-width:480px){#diamonds-direct .Designers .premierBanner .elementWrapper .premierElement{position:relative;width:65%;margin:0 2%;top:-10px}}#diamonds-direct .Designers .premierBanner .elementWrapper .premierElement img{width:100%;height:100%;position:auto;top:0;left:0;right:0;bottom:0;margin:auto}#diamonds-direct .Designers .premierBanner .elementWrapper .tacori.premierElement img{max-width:75%}#diamonds-direct .Designers .premierBanner .elementWrapper .verragio.premierElement img{max-width:70%}#diamonds-direct .Designers .premierBanner .elementWrapper .simonG.premierElement img{max-width:60%}#diamonds-direct .Designers .bridalBanner{background:#f4f4f4;border-top:4px solid #e2cce4;border-bottom:4px solid #e2cce4;text-align:center}#diamonds-direct .Designers .fashionBanner{text-align:center}#diamonds-direct .Designers .displayBlock{position:relative;margin:30px auto 0;width:95%;max-width:1024px}#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton.selected,#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton.selected:hover{color:#fff;background:#4b2d53}#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton.selected .arrowWrapper .arrowDown{display:none;border-top:14px solid #fff}@media (max-width:768px){#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton.selected .arrowWrapper .arrowDown{border-top:10px solid #fff}}#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton.selected .arrowWrapper .arrowUp{display:inline-block;border-bottom:14px solid #fff}@media (max-width:768px){#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton.selected .arrowWrapper .arrowUp{border-bottom:10px solid #fff}}#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton{display:inline-block;margin:0 10px;padding:10px 0;width:calc(33.3% - 20px);vertical-align:top;color:#000;font-size:18px;font-weight:700;cursor:pointer;background:#ebebeb;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,font-size .35s linear 0ms,margin .35s linear 0ms,width .35s linear 0ms}#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton:hover{background:#d7d7d7}@media (max-width:768px){#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton{font-size:16px;margin:0 5px;width:calc(33.3% - 10px)}}@media (max-width:600px){#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton{font-size:15px}}@media (max-width:480px){#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton{font-size:12px}}#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton .textWrapper{display:-ms-flexbox;display:flex;text-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;margin:0 0 10px}#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton .arrowWrapper{text-align:center}#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton .arrowWrapper .arrowDown{display:inline-block;width:0;height:0;border-left:14px solid transparent;border-right:14px solid transparent;border-top:14px solid #b78dbb}@media (max-width:768px){#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton .arrowWrapper .arrowDown{border-left:10px solid transparent;border-right:10px solid transparent;border-top:10px solid #b78dbb}}#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton .arrowWrapper .arrowUp{display:none;width:0;height:0;border-left:14px solid transparent;border-right:14px solid transparent;border-bottom:14px solid #b78dbb}@media (max-width:768px){#diamonds-direct .Designers .displayBlock .controlsWrapper .controlButton .arrowWrapper .arrowUp{border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #b78dbb}}#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement.open{max-height:1000px}#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement{height:auto;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement .logosWrapper{width:80%;margin:30px auto 0;border-left:1px solid #d7d7d7}#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement .logosWrapper .logoElement.noLink{cursor:default}#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement .logosWrapper .logoElement{position:relative;display:inline-block;width:calc(20% - 1px);height:100px;vertical-align:top;text-align:center;border-right:1px solid #d7d7d7;cursor:pointer;transition:width .35s linear 0ms,height .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement .logosWrapper .logoElement{width:calc(25% - 1px);height:90px}}@media (max-width:768px){#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement .logosWrapper .logoElement{width:calc(33.3% - 1px);height:90px}}@media (max-width:600px){#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement .logosWrapper .logoElement{width:calc(50% - 1px);height:90px}}#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement .logosWrapper .logoElement img{max-width:90%;max-height:95%;width:auto;height:auto;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement .closeIcon .arrowWrapper{text-align:center}#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement .closeIcon .arrowWrapper .closeArrow{display:inline-block;width:0;height:0;margin-top:10px;margin-bottom:0;cursor:pointer;border-left:20px solid transparent;border-right:20px solid transparent;border-bottom:20px solid #8a8d8f;transition:border-bottom .25s ease-in-out 0ms,margin-top .25s ease-in-out 0ms,margin-bottom .25s ease-in-out 0ms}#diamonds-direct .Designers .displayBlock .displayWrapper .toggleElement .closeIcon .arrowWrapper .closeArrow:hover{margin-top:5px;margin-bottom:5px;border-bottom:20px solid #6e7072}#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper{margin:30px 0 80px;text-align:center;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper{margin:30px 0 50px}}@media (max-width:600px){#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper{margin:30px 0}}#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton.selected,#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton.selected:hover{border:1px solid #4b2d53;color:#fff;background:#4b2d53}#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton{position:relative;display:inline-block;width:300px;border:1px solid #000;color:#000;background:#fff;font-size:24px;font-family:Lusitana,serif;margin:0 25px;cursor:pointer;transition:background .25s ease-in-out 0ms,color .1s ease-in-out 0ms,border,.1s ease-in-out 0ms,width .35s linear 0ms,font-size .35s linear 0ms}#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton:hover{background:#f0e8f1}@media (max-width:768px){#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton{width:220px;font-size:22px}}@media (max-width:600px){#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton{width:180px;margin:0 15px;font-size:20px}}@media (max-width:480px){#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton{width:140px;margin:0 10px;font-size:18px}}#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton .bandButtonText{padding:30px 0 60px;transition:padding .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton .bandButtonText{padding:20px 0 50px}}@media (max-width:600px){#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton .bandButtonText{padding:15px 0 40px}}@media (max-width:480px){#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton .bandButtonText{padding:15px 0 30px}}#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton .bandButtonImage{position:absolute;top:60%;left:0;right:0;height:100%}#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton .bandButtonImage img{width:70%}@media (max-width:480px){#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandsControlWrapper .bandControlButton .bandButtonImage img{width:80%}}#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandToggleElement.open{max-height:1000px}#diamonds-direct .Designers .displayBlock .displayWrapper .bandDesignersWrapper .bandToggleElement{height:auto;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .Designers .bottomWrapper{position:relative;margin:50px auto 30px;width:95%;max-width:1024px;text-align:center;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Designers .bottomWrapper{margin:30px auto 20px}}#diamonds-direct .Designers .bottomWrapper .bottomBlock{display:inline-block;width:calc(50% - 14px);vertical-align:top;margin:0 4px 0 10px;transition:margin .35s linear 0ms,width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Designers .bottomWrapper .bottomBlock{width:calc(100% - 10px);margin:0 5px}}#diamonds-direct .Designers .bottomWrapper .bottomBlock:nth-child(2n){margin:0 10px 0 4px}@media (max-width:768px){#diamonds-direct .Designers .bottomWrapper .bottomBlock:nth-child(2n){margin:0 5px}}#diamonds-direct .Designers .bottomWrapper .bottomBlock .halfBlock{margin-bottom:2.5%;vertical-align:top;border:1px solid #e7e7e7;cursor:pointer}@media (max-width:768px){#diamonds-direct .Designers .bottomWrapper .bottomBlock .halfBlock{margin-bottom:10px}}#diamonds-direct .Designers .bottomWrapper .bottomBlock .halfBlock img{width:100%;display:block}#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock{position:relative;vertical-align:top;border:1px solid #e7e7e7;cursor:pointer}#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock img{width:100%;display:block}#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay{position:absolute;top:25%;left:10%;width:80%;height:50%;text-align:center;border:1px solid #fff;color:#fff;background:rgba(0,0,0,.4)}#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay .overlayTitle{position:absolute;bottom:50%;left:0;right:0;height:36px;line-height:36px;font-size:32px;font-weight:700;vertical-align:bottom;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay .overlayTitle{font-size:25px}}@media (max-width:768px){#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay .overlayTitle{font-size:36px}}@media (max-width:600px){#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay .overlayTitle{font-size:28px}}@media (max-width:480px){#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay .overlayTitle{font-size:23px}}#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay .overlaySubtitle{position:absolute;top:50%;left:0;right:0;height:24px;line-height:24px;font-size:20px;font-weight:300;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay .overlaySubtitle{font-size:16px}}@media (max-width:768px){#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay .overlaySubtitle{font-size:22px}}@media (max-width:600px){#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay .overlaySubtitle{font-size:18px}}@media (max-width:480px){#diamonds-direct .Designers .bottomWrapper .bottomBlock .fullBlock .imgOverlay .overlaySubtitle{font-size:16px}}#diamonds-direct .SingleDesigner{font-family:Lato,sans-serif}#diamonds-direct .SingleDesigner .designerBanner{overflow:auto;background-size:cover;background-position:50%;background-repeat:no-repeat}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay{position:relative;overflow:hidden;background:hsla(0,0%,100%,.5);margin:4% 5% 4% 45%;height:auto;min-height:380px;transition:margin .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay{margin:4% 5% 4% 40%}}@media (max-width:1024px){#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay{margin:3% 3% 3% 38%}}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerLogo{position:absolute;top:0;left:0;right:0;height:110px;text-align:center}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerLogo img{position:relative;height:120%;top:-10%}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerDescription.multipleLinks{margin:110px 0 105px}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerDescription{margin:110px 0 60px;padding:0 15px;text-align:center;font-size:14px;color:#333}@media (max-width:1024px){#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerDescription{font-size:13px}}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerDescription .descriptionP{margin:0 0 15px}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerButtons.multipleButtons{height:105px}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerButtons{position:absolute;bottom:0;left:0;right:0;height:60px;text-align:center}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerButtons .bannerButton.shortButton{width:190px}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerButtons .bannerButton{position:relative;margin:15px 15px 0;display:inline-block;color:#4b2d53;background:#fff;width:280px;height:30px;line-height:30px;border:none;cursor:pointer;vertical-align:bottom;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerButtons .bannerButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerButtons .bannerButton .buttonText{position:absolute;top:0;left:0;right:0;bottom:0;font-size:15px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .SingleDesigner .designerBanner .bannerOverlay .bannerButtons .bannerButton .buttonText .buttonArrow{font-size:22px}#diamonds-direct .SingleDesigner .designerMobileWrapper{position:relative}#diamonds-direct .SingleDesigner .designerMobileWrapper .designerMobileBanner img{width:100%;display:block}#diamonds-direct .SingleDesigner .designerMobileWrapper .mobileLogo{position:relative;display:block;width:90%;height:140px;margin:0 auto 10px;vertical-align:top;text-align:center}#diamonds-direct .SingleDesigner .designerMobileWrapper .mobileLogo img{max-width:100%;max-height:100%;width:auto;height:auto;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}#diamonds-direct .SingleDesigner .designerMobileWrapper .mobileDescription{color:#333;padding:0 15px}#diamonds-direct .SingleDesigner .designerMobileWrapper .mobileDescription .descriptionP{margin:0 0 15px}#diamonds-direct .SingleDesigner .designerMobileWrapper .mobileButtons{position:relative;text-align:center}#diamonds-direct .SingleDesigner .designerMobileWrapper .mobileButtons .mobileBannerButton{position:relative;margin:15px 25px;display:inline-block;color:#4b2d53;background:#fff;width:280px;height:30px;line-height:30px;border:1px solid #4b2d53;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .SingleDesigner .designerMobileWrapper .mobileButtons .mobileBannerButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .SingleDesigner .designerMobileWrapper .mobileButtons .mobileBannerButton .buttonText{position:absolute;top:0;left:0;right:0;bottom:0;font-size:15px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .SingleDesigner .designerMobileWrapper .mobileButtons .mobileBannerButton .buttonText .buttonArrow{font-size:22px}#diamonds-direct .DiamondPage{font-family:Lato,sans-serif;color:#666}#diamonds-direct .DiamondPage .dpBreadcrumbs{background:#ebebeb;color:#4b2d53;padding:10px 60px;font-size:20px;font-weight:400;text-transform:uppercase}#diamonds-direct .DiamondPage .dpLegal{margin:20px auto;width:90%;max-width:1200px;text-align:left;color:#999;font-size:14px;font-weight:300}#diamonds-direct .DiamondPage .dpLegal a{color:#666}#diamonds-direct .DiamondPage .dpProductsWrapper{margin:50px auto 10px;width:90%;max-width:1200px;text-align:center}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct{display:inline-block;vertical-align:top;margin:0 10px 50px;width:calc(50% - 20px);max-width:360px;transition:width .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct{width:calc(50% - 20px)}}@media (max-width:768px){#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct{width:calc(100% - 20px)}}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .studSizing.dpProductImg{width:150px}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductImg{margin:0 auto;height:150px;position:relative}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductImg img{height:100%}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductImg .diamondPositioning{display:none;position:absolute;background-image:url(\"https://ddw2.diamondsdirect.com/img/diamondpages/round_diamond.png\");background-position:50%;background-size:contain;background-repeat:no-repeat}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductImg .diamondPositioning img{width:100%}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductImg .imageToggle{display:none;position:absolute;top:0;right:-35px;width:25px;height:25px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductImg .imageToggle:hover{color:#4b2d53}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductTitle{font-size:20px;margin:0 0 20px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductConfigElement.inline.middle{border-left:1px solid #333;border-right:1px solid #333;margin:0 10px 10px}@media (max-width:900px){#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductConfigElement.inline.middle{border-left:none;border-right:none;margin:0 auto 10px}}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductConfigElement.inline{display:inline-block;vertical-align:top;width:auto;min-width:200px}@media (max-width:900px){#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductConfigElement.inline{display:block;max-width:240px}}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductConfigElement{margin:0 auto 10px;width:55%}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductConfigElement .dpErrorMessage{font-size:14px;margin:10px 0;text-align:center;color:#eb3533}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductConfigElement .productSelect select{border:1px solid #fff}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpBr{margin:0 auto 10px;width:50%;height:2px;background:#4b2d53}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpPrice{color:#999;font-size:24px;margin:0 0 20px}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpText{margin:0 auto 15px;width:70%}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpAddToCart.dpLoading{background:#4b2d53;color:#fff;border:1px solid #666}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpAddToCart{position:relative;color:#666;border:1px solid #666;background:#fff;width:200px;height:30px;margin:0 auto;cursor:pointer;font-size:14px;font-weight:700;text-transform:uppercase;transition:color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpAddToCart:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .DiamondPage .dpProductsWrapper .dpProduct .dpItemWrapper .dpAddToCart div{position:absolute;top:0;right:0;left:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .DiamondStuds .studsCustomSection{background:#f8f8f8;overflow:auto}#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper{position:relative;margin:25px auto;width:90%;max-width:1200px}#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper .studsCustomLeft{position:absolute;top:0;left:0;width:160px;height:auto}@media (max-width:768px){#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper .studsCustomLeft{position:relative;margin:0 auto 20px}}#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper .studsCustomLeft img{width:100%}#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper .studsCustomRight{position:relative;padding-left:200px}@media (max-width:768px){#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper .studsCustomRight{padding-left:0}}#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper .studsCustomRight .scTitle{display:inline-block;width:auto;font-size:20px;text-transform:uppercase;padding:0 50px 5px 0;border-bottom:2px solid #4b2d53;margin:0 0 20px}#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper .studsCustomRight .scBody{margin:0 0 20px}#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper .studsCustomRight .scButtonWrapper{position:relative;color:#666;border:1px solid #666;background:#fff;width:200px;height:30px;margin:0 auto;cursor:pointer;font-size:14px;font-weight:700;text-transform:uppercase;transition:color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper .studsCustomRight .scButtonWrapper:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .DiamondStuds .studsCustomSection .scWrapper .studsCustomRight .scButtonWrapper .scButton{position:absolute;top:0;right:0;left:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .DiamondBracelets .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductImg.braceletImg{height:400px}#diamonds-direct .DiamondBracelets .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductImg.braceletImg img{max-width:100%;max-height:100%}#diamonds-direct .DiamondBracelets .dpProductsWrapper .dpProduct .dpItemWrapper .dpProductImg.braceletImg .imageToggle{right:0}#diamonds-direct .DiamondBracelets .braceletsCustomSection{background:#f8f8f8;overflow:auto}#diamonds-direct .DiamondBracelets .braceletsCustomSection .scWrapper{position:relative;margin:25px auto;width:90%;max-width:1200px}#diamonds-direct .DiamondBracelets .braceletsCustomSection .scWrapper .braceletsCustomRight{position:relative;padding-left:0}#diamonds-direct .DiamondBracelets .braceletsCustomSection .scWrapper .braceletsCustomRight .scTitle{display:inline-block;width:auto;font-size:20px;text-transform:uppercase;padding:0 50px 5px 0;border-bottom:2px solid #4b2d53;margin:0 0 20px}#diamonds-direct .DiamondBracelets .braceletsCustomSection .scWrapper .braceletsCustomRight .scBody{margin:0 0 20px}#diamonds-direct .DiamondBracelets .braceletsCustomSection .scWrapper .braceletsCustomRight .scButtonWrapper{position:relative;color:#666;border:1px solid #666;background:#fff;width:200px;height:30px;margin:0 auto;cursor:pointer;font-size:14px;font-weight:700;text-transform:uppercase;transition:color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .DiamondBracelets .braceletsCustomSection .scWrapper .braceletsCustomRight .scButtonWrapper:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .DiamondBracelets .braceletsCustomSection .scWrapper .braceletsCustomRight .scButtonWrapper .scButton{position:absolute;top:0;right:0;left:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .DiamondNecklaces{position:relative}#diamonds-direct .DiamondNecklaces .dPagePreload{position:absolute;top:0;left:0;width:0;height:0;overflow:hidden;opacity:0}#diamonds-direct .DiamondNecklaces .dpProductsWrapper .dpProduct.single{width:calc(90% - 20px);max-width:unset}#diamonds-direct .DiamondNecklaces .dpProductsWrapper .dpProduct.single .dpItemWrapper .dpProductImg.necklaceImg{position:relative;width:auto;max-width:400px;height:auto;max-height:400px}#diamonds-direct .DiamondNecklaces .dpProductsWrapper .dpProduct.single .dpItemWrapper .dpProductImg.necklaceImg img{width:auto;max-width:100%;height:auto;max-height:100%}#diamonds-direct .DiamondNecklaces .dpProductsWrapper .dpProduct.single .dpItemWrapper .dpProductImg.necklaceImg .imageToggle{right:-25px}#diamonds-direct .Faq .faqHeader{position:relative;overflow:auto;color:#5e5e5e;background:#f4f4f5}#diamonds-direct .Faq .faqHeader .headerInnerWrapper{position:relative;margin:30px 150px;transition:margin .35s linear 0ms}@media (max-width:900px){#diamonds-direct .Faq .faqHeader .headerInnerWrapper{margin:30px 50px}}@media (max-width:600px){#diamonds-direct .Faq .faqHeader .headerInnerWrapper{margin:20px 25px}}#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqIcon{position:relative;display:inline-block;vertical-align:top;font-family:Lusitana,serif;font-size:72px;line-height:72px;width:200px;text-align:left;text-transform:uppercase;transition:width .35s linear 0ms,font-size .35s linear 0ms}@media (max-width:900px){#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqIcon{width:160px;font-size:60px;line-height:60px}}@media (max-width:600px){#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqIcon{width:100%;font-size:48px;line-height:48px;margin:0 0 15px;text-align:center}}#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqHeaderText{position:relative;display:inline-block;vertical-align:top;font-family:Lato,sans-serif;width:calc(100% - 325px);font-size:18px;transition:width .35s linear 0ms,font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqHeaderText{width:calc(100% - 200px)}}@media (max-width:900px){#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqHeaderText{width:calc(100% - 160px);font-size:16px}}@media (max-width:600px){#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqHeaderText{width:100%;font-size:16px}}#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqHeaderText .headerLink,#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqHeaderText a{text-decoration:none;color:#bf98c3;transition:color .25s ease-in-out 0ms;cursor:pointer}#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqHeaderText .headerLink:hover,#diamonds-direct .Faq .faqHeader .headerInnerWrapper .faqHeaderText a:hover{color:#4e2b52}#diamonds-direct .Faq .faqSearch{text-align:center;font-family:Lato,sans-serif;margin:30px 0}#diamonds-direct .Faq .faqSearch .searchTitleWrapper{color:#5e5e5e;font-size:32px;font-weight:700;text-transform:uppercase;transition:font-size .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Faq .faqSearch .searchTitleWrapper{font-size:24px}}#diamonds-direct .Faq .faqSearch .searchInputWrapper{position:relative;display:inline-block;width:90%;max-width:600px;margin:10px 0 0}#diamonds-direct .Faq .faqSearch .searchInputWrapper input{width:calc(100% - 22px);border:1px solid #707070;padding:10px;font-size:24px;transition:padding .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Faq .faqSearch .searchInputWrapper input{padding:5px 10px}}#diamonds-direct .Faq .faqSearch .searchInputWrapper input::-webkit-input-placeholder{color:#d3d3d3;font-size:24px;font-weight:300}#diamonds-direct .Faq .faqSearch .searchInputWrapper input::-moz-placeholder{color:#d3d3d3;font-size:24px;font-weight:300}#diamonds-direct .Faq .faqSearch .searchInputWrapper input:-ms-input-placeholder{color:#d3d3d3;font-size:24px;font-weight:300}#diamonds-direct .Faq .faqSearch .searchInputWrapper input:-moz-placeholder{color:#d3d3d3;font-size:24px;font-weight:300}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchIcon{position:absolute;top:12px;right:10px;width:24px;height:24px;color:#bf98c3;font-size:28px;display:-ms-flexbox;display:flex;text-align:center;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;transition:font-size .35s linear 0ms,top .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchIcon{top:8px;font-size:22px}}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchSuggestions.open{max-height:600px}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchSuggestions{position:relative;height:auto;max-height:0;overflow:hidden;font-family:Lato,sans-serif;text-align:left;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchSuggestions .searchInnerWrapper{border:1px solid #707070;border-top:none;overflow:auto}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchSuggestions .searchInnerWrapper .suggestionsWrapper{border-bottom:1px solid #707070;margin:15px 0;padding-bottom:15px}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchSuggestions .searchInnerWrapper .suggestionsWrapper .suggestionEntry{margin:4px 0;padding:3px 15px;font-size:18px;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchSuggestions .searchInnerWrapper .suggestionsWrapper .suggestionEntry .searchEm{font-weight:900}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchSuggestions .searchInnerWrapper .suggestionsWrapper .suggestionEntry:hover{background:rgba(190,153,194,.2)}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchSuggestions .searchInnerWrapper .suggestionContact{margin:15px;font-size:18px}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchSuggestions .searchInnerWrapper .suggestionContact .contactLink{color:#bf98c3;font-weight:700;cursor:pointer}#diamonds-direct .Faq .faqSearch .searchInputWrapper .searchSuggestions .searchInnerWrapper .suggestionContact .contactLink:hover{color:#4e2b52}#diamonds-direct .Faq .faqBlocks{width:90%;max-width:1024px;margin:0 auto 40px;text-align:center}#diamonds-direct .Faq .faqBlocks .orderingBlock.faqSubjectBlock .blockIcon{top:-22%;height:44%;background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/ordering.svg\")}#diamonds-direct .Faq .faqBlocks .orderingBlock.faqSubjectBlock.open .blockIcon{top:-22%;height:44%;background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/ordering_alt.svg\")}#diamonds-direct .Faq .faqBlocks .paymentBlock.faqSubjectBlock .blockIcon{top:-16%;height:32%;background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/payment.svg\")}#diamonds-direct .Faq .faqBlocks .paymentBlock.faqSubjectBlock.open .blockIcon{top:-16%;height:32%;background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/payment_alt.svg\")}#diamonds-direct .Faq .faqBlocks .warrantyBlock.faqSubjectBlock .blockIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/warranties.svg\")}#diamonds-direct .Faq .faqBlocks .warrantyBlock.faqSubjectBlock.open .blockIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/warranties_alt.svg\")}#diamonds-direct .Faq .faqBlocks .upgradeBlock.faqSubjectBlock .blockIcon{top:-16%;background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/upgrades.svg\")}#diamonds-direct .Faq .faqBlocks .upgradeBlock.faqSubjectBlock.open .blockIcon{top:-16%;background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/upgrades_alt.svg\")}#diamonds-direct .Faq .faqBlocks .returnBlock.faqSubjectBlock .blockIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/return.svg\")}#diamonds-direct .Faq .faqBlocks .returnBlock.faqSubjectBlock.open .blockIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/return_alt.svg\")}#diamonds-direct .Faq .faqBlocks .privacyBlock.faqSubjectBlock .blockIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/security.svg\")}#diamonds-direct .Faq .faqBlocks .privacyBlock.faqSubjectBlock.open .blockIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/security_alt.svg\")}#diamonds-direct .Faq .faqBlocks .faqSubjectBlock.open .blockPrompt{color:#4e2b52}#diamonds-direct .Faq .faqBlocks .faqSubjectBlock{position:relative;display:inline-block;margin:7% 5px 0;width:calc(33.3% - 12px);border:1px solid #707070;padding-bottom:23.33331%;font-family:Lato,sans-serif;cursor:pointer;transition:width .35s linear 0ms,padding-bottom .35s linear 0ms}@media (max-width:900px){#diamonds-direct .Faq .faqBlocks .faqSubjectBlock{width:calc(50% - 12px);padding-bottom:35%;margin:10% 5px 0}}@media (max-width:600px){#diamonds-direct .Faq .faqBlocks .faqSubjectBlock{width:calc(100% - 12px);padding-bottom:70%;margin:16% 5px 0}}#diamonds-direct .Faq .faqBlocks .faqSubjectBlock .blockIcon{position:absolute;top:-18%;height:36%;width:100%;background-repeat:no-repeat;background-position:50%}#diamonds-direct .Faq .faqBlocks .faqSubjectBlock .blockTitle{position:absolute;top:0;left:10%;right:10%;bottom:0;display:-ms-flexbox;display:flex;text-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-size:24px;font-weight:700;color:#5e5e5e;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Faq .faqBlocks .faqSubjectBlock .blockTitle{font-size:20px}}@media (max-width:900px){#diamonds-direct .Faq .faqBlocks .faqSubjectBlock .blockTitle{font-size:24px}}@media (max-width:768px){#diamonds-direct .Faq .faqBlocks .faqSubjectBlock .blockTitle{font-size:20px}}@media (max-width:600px){#diamonds-direct .Faq .faqBlocks .faqSubjectBlock .blockTitle{font-size:24px}}#diamonds-direct .Faq .faqBlocks .faqSubjectBlock .blockPrompt{position:absolute;left:0;right:0;bottom:0;height:30%;display:-ms-flexbox;display:flex;text-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-size:20px;font-weight:700;color:#bf98c3;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:color .25s ease-in-out 0ms}#diamonds-direct .Faq .faqBlocks .faqSubjectBlock:hover .blockPrompt{color:#4e2b52}#diamonds-direct .Faq .faqBlocks .desktopAccordian{display:block}@media (max-width:900px){#diamonds-direct .Faq .faqBlocks .desktopAccordian{display:none}}#diamonds-direct .Faq .faqBlocks .tabletAccordian{display:none}@media (max-width:900px){#diamonds-direct .Faq .faqBlocks .tabletAccordian{display:block}}@media (max-width:600px){#diamonds-direct .Faq .faqBlocks .tabletAccordian{display:none}}#diamonds-direct .Faq .faqBlocks .mobileAccordian{display:none}@media (max-width:600px){#diamonds-direct .Faq .faqBlocks .mobileAccordian{display:block}}#diamonds-direct .Faq .faqBlocks .questionAccordian.open{max-height:10000px}#diamonds-direct .Faq .faqBlocks .questionAccordian{position:relative;text-align:left;height:auto;max-height:0;overflow:hidden;font-family:Lato,sans-serif;margin:0 5px;padding:0;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper{position:relative;margin:10px 0 0}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .accordianClose{position:absolute;top:0;right:0;width:20px;height:20px;cursor:pointer;transition:width .35s linear 0ms,height .35s linear 0ms}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .accordianClose img{width:100%}@media (max-width:600px){#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .accordianClose{width:16px;height:16px}}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .accordianTitle{text-align:center;font-size:22px;font-weight:700;color:#5e5e5e;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin:10px 25px 0;transition:font-size .35s linear 0ms,margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .accordianTitle{font-size:18px;margin:10px 25px 0}}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .accordianBr{width:85%;height:auto;text-align:center;margin:10px auto;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .accordianBr{width:100%}}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .accordianBr img{width:100%}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry.open .questionTitle{font-weight:700}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry.open .questionTitle .titleArrow{background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/arrow_dpurp.svg\")}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry.open .questionBody{max-height:1000px}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry{background:#fff;cursor:pointer}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry:nth-child(2n){background:#f4f4f5}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry .questionTitle{position:relative;padding:6px 10px 6px 30px}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry .questionTitle .titleArrow{position:absolute;top:6px;left:3px;width:18px;height:18px;background-image:url(\"https://ddw2.diamondsdirect.com/img/faq/arrow_rlav.svg\");background-position:50%;background-size:contain;background-repeat:no-repeat}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry .questionBody.open{max-height:1000px}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry .questionBody{height:auto;max-height:0;overflow:hidden;padding:0 30px}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry .questionBody .bodyWrapper{padding:15px 0 20px}#diamonds-direct .Faq .faqBlocks .questionAccordian .accordianWrapper .questionEntry .questionBody .bodyWrapper a{color:#bf98c3;text-decoration:none}#diamonds-direct .Finance .finHeader{width:100%;margin:0 auto;box-shadow:0 8px 8px 0 #ebebeb}#diamonds-direct .Finance .finHeader .finTitle{text-align:center;font-size:36px;color:#472f51;margin:25px 0 0}@media (max-width:768px){#diamonds-direct .Finance .finHeader .finTitle{font-size:24px}}#diamonds-direct .Finance .finHeader .finTitle .sup{font-size:16px;vertical-align:top;margin-left:5px}#diamonds-direct .Finance .finHeader .finBr{width:90%;max-width:1024px;margin:10px auto}#diamonds-direct .Finance .finHeader .finBr img{width:100%}#diamonds-direct .Finance .finHeader .finIconRow{text-align:center;width:90%;max-width:1024px;margin:20px auto 0}#diamonds-direct .Finance .finHeader .finIconRow .finIcon{display:inline-block;vertical-align:top;width:calc(20% - 30px);margin:0 15px 20px}@media (max-width:768px){#diamonds-direct .Finance .finHeader .finIconRow .finIcon{width:calc(50% - 30px)}}#diamonds-direct .Finance .finHeader .finIconRow .finIcon .finIconImg{height:40px}#diamonds-direct .Finance .finHeader .finIconRow .finIcon .finIconImg img{height:100%}#diamonds-direct .Finance .finHeader .finIconRow .finIcon .finIconLabel{margin:10px 0 0;font-size:16px}@media (max-width:1024px){#diamonds-direct .Finance .finHeader .finIconRow .finIcon .finIconLabel{font-size:14px}}@media (max-width:768px){#diamonds-direct .Finance .finHeader .finIconRow .finIcon .finIconLabel{font-size:16px}}#diamonds-direct .Finance .finBody{position:relative;font-family:Lato,sans-serif;overflow:auto}#diamonds-direct .Finance .finBody .finBackgroundWrapper{position:absolute;left:0;right:0;bottom:0;height:auto;z-index:-1}@media (max-width:768px){#diamonds-direct .Finance .finBody .finBackgroundWrapper{display:none}}#diamonds-direct .Finance .finBody .finBackgroundWrapper .finBackgroundLeft{position:absolute;left:0;bottom:0;width:30%;height:auto}#diamonds-direct .Finance .finBody .finBackgroundWrapper .finBackgroundLeft img{width:100%}#diamonds-direct .Finance .finBody .finBackgroundWrapper .finBackgroundRight{position:absolute;right:0;bottom:0;width:18%;height:auto}#diamonds-direct .Finance .finBody .finBackgroundWrapper .finBackgroundRight img{width:100%}#diamonds-direct .Finance .finBody .finCardSection{position:relative;width:90%;max-width:1024px;margin:0 auto}#diamonds-direct .Finance .finBody .finCardSection .finCardLeft{display:inline-block;vertical-align:top;width:calc(50% - 1px);margin:30px 0 0}@media (max-width:768px){#diamonds-direct .Finance .finBody .finCardSection .finCardLeft{display:block;width:100%}}#diamonds-direct .Finance .finBody .finCardSection .finCardLeft .finCardLeftImageWrapper{margin:0 10% 0 20%}@media (max-width:768px){#diamonds-direct .Finance .finBody .finCardSection .finCardLeft .finCardLeftImageWrapper{margin:0 10%}}#diamonds-direct .Finance .finBody .finCardSection .finCardLeft .finCardLeftImageWrapper img{width:100%}#diamonds-direct .Finance .finBody .finCardSection .finCardRight{display:inline-block;vertical-align:top;width:calc(50% - 1px);margin:30px 0 0}@media (max-width:768px){#diamonds-direct .Finance .finBody .finCardSection .finCardRight{display:block;width:100%}}#diamonds-direct .Finance .finBody .finCardSection .finCardRight .finCardRightTextWrapper{margin:10% 10% 0}@media (max-width:900px){#diamonds-direct .Finance .finBody .finCardSection .finCardRight .finCardRightTextWrapper{margin-top:3%}}@media (max-width:768px){#diamonds-direct .Finance .finBody .finCardSection .finCardRight .finCardRightTextWrapper{margin:0 10%}}#diamonds-direct .Finance .finBody .finColumnsHeader{position:relative;width:90%;max-width:1024px;margin:20px auto 0}#diamonds-direct .Finance .finBody .finColumnsHeader .finColHeaderTitle{text-align:center;font-size:36px;color:#472f51;margin:25px 0 0;text-transform:uppercase;font-family:Lusitana,serif}@media (max-width:768px){#diamonds-direct .Finance .finBody .finColumnsHeader .finColHeaderTitle{font-size:24px}}#diamonds-direct .Finance .finBody .finColumnsHeader .finColHeaderLine{width:90%;margin:0 auto}#diamonds-direct .Finance .finBody .finColumnsHeader .finColHeaderLine img{width:100%}#diamonds-direct .Finance .finBody .finColumnsWrapper{position:relative;width:90%;max-width:1024px;margin:0 auto}#diamonds-direct .Finance .finBody .finColumnsWrapper .finColumn.firstCol{border-right:2px solid #ebebeb}@media (max-width:768px){#diamonds-direct .Finance .finBody .finColumnsWrapper .finColumn.firstCol{border-right:none}}#diamonds-direct .Finance .finBody .finColumnsWrapper .finColumn{display:inline-block;vertical-align:top;width:calc(50% - 1px);margin:30px 0 20px}@media (max-width:768px){#diamonds-direct .Finance .finBody .finColumnsWrapper .finColumn{width:100%;margin:15px 0 0}}#diamonds-direct .Finance .finBody .finColumnsWrapper .finColumn .finColTitle{color:#472f51;text-align:center;font-size:24px;font-weight:700;width:90%;margin:0 auto 5px}#diamonds-direct .Finance .finBody .finColumnsWrapper .finColumn .finColSubtitle{color:#472f51;text-align:center;font-size:16px;font-weight:700;width:90%;margin:0 auto 20px}#diamonds-direct .Finance .finBody .finColumnsWrapper .finColumn .finColP{color:#4d4d4d;width:86%;margin:0 auto 20px}#diamonds-direct .Finance .finBody .finColumnsWrapper .finColumn .finColP a{color:#4d4d4d}#diamonds-direct .Finance .finBody .finColumnsWrapper .finColumn .finColP.finPBold{font-weight:700;text-align:center}#diamonds-direct .Finance .finBody .finColumnsWrapper .finColumn .finColLearnMore{text-align:center;font-size:20px;color:#472f51;text-decoration:underline;margin:0 0 20px;cursor:pointer}#diamonds-direct .Finance .finBody .finColumnsWrapper .finOr{position:absolute;left:calc(50% - 10px);top:calc(50% - 15px);width:20px;height:30px;color:#472f51;background:#fff;text-align:center;font-size:20px;font-family:Lusitana,serif;line-height:20px;padding:20px 0 15px}@media (max-width:768px){#diamonds-direct .Finance .finBody .finColumnsWrapper .finOr{position:relative;left:0;top:0;text-align:center;border-top:2px solid #ebebeb;border-bottom:2px solid #ebebeb;padding:8px 25px 0;margin:0 auto}}#diamonds-direct .Finance .finBody .finBox{position:relative;width:90%;max-width:1024px;margin:0 auto;background:#fff;border:1px solid #472f51}#diamonds-direct .Finance .finBody .finBox .finBoxSection{display:inline-block;vertical-align:top;width:50%;text-align:center;margin:25px 0}@media (max-width:768px){#diamonds-direct .Finance .finBody .finBox .finBoxSection{display:block;width:100%}}#diamonds-direct .Finance .finBody .finBox .finBoxSection .finBoxTitle{font-size:32px;font-family:Lusitana,serif;color:#472f51;font-weight:700;margin:0 5%}#diamonds-direct .Finance .finBody .finBox .finBoxSection .finBoxCopy{margin:25px 20%}#diamonds-direct .Finance .finBody .finBox .finBoxSection .finBoxButton{display:inline-block;vertical-align:top;padding:8px 40px;color:#fff;background:#472f51;cursor:pointer;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms}#diamonds-direct .Finance .finBody .finBox .finBoxSection .finBoxButton:hover{background:#382540}#diamonds-direct .Finance .finBody .finApply{position:relative;width:90%;max-width:600px;text-align:center;margin:30px auto 50px}#diamonds-direct .Finance .finBody .finApply .finApplyQuestion{margin:0 0 20px}#diamonds-direct .Finance .finBody .finApply .finApplyButton{display:inline-block;vertical-align:top;padding:8px 60px;background:#ddd;cursor:pointer;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms}#diamonds-direct .Finance .finBody .finApply .finApplyButton:hover{color:#fff;background:#472f51}#diamonds-direct .Finance .finBody .finLegal{margin:30px 0;text-align:center;font-size:14px;font-weight:300;color:#4d4d4d}#diamonds-direct .Foundation .foundationHeader{background:#f4f5f7;color:#333;font-family:Lusitana,serif;font-size:48px;text-align:left;padding:40px 0 40px 40px}@media (max-width:1024px){#diamonds-direct .Foundation .foundationHeader{font-size:40px;padding:0;height:120px;line-height:120px}}@media (max-width:768px){#diamonds-direct .Foundation .foundationHeader{font-size:32px;height:100px;line-height:100px}}@media (max-width:600px){#diamonds-direct .Foundation .foundationHeader{font-size:24px}}@media (max-width:480px){#diamonds-direct .Foundation .foundationHeader{font-size:22px;height:80px;line-height:80px}}#diamonds-direct .Foundation .foundationHeader .headerLogo{display:none;vertical-align:middle}@media (max-width:1024px){#diamonds-direct .Foundation .foundationHeader .headerLogo{display:inline-block;width:80px;margin:0 15px}}@media (max-width:768px){#diamonds-direct .Foundation .foundationHeader .headerLogo{width:60px;margin:0 10px}}@media (max-width:480px){#diamonds-direct .Foundation .foundationHeader .headerLogo{display:none}}#diamonds-direct .Foundation .foundationHeader .textWrapper{display:inline-block;vertical-align:middle}@media (max-width:480px){#diamonds-direct .Foundation .foundationHeader .textWrapper{padding:0 0 0 20px}}#diamonds-direct .Foundation .nkBanner{position:relative}#diamonds-direct .Foundation .nkBanner img{width:100%}#diamonds-direct .Foundation .foundationBodyWrapper{margin:25px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock{display:inline-block;width:597px;background:#ece2ee;height:590px;vertical-align:top}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock{display:none}}@media (max-width:768px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock{display:none}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper{margin:10px 10px 10px 0;display:block}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageTopRow{height:200px}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageTopRow{height:130px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageBottomRow{margin:10px 0 0;height:357.5px}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageBottomRow{height:232px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement.firstBottom{width:230px}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement.firstBottom{width:151px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement.firstBottom img{width:100%;height:100%}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement.secondBottom{width:335px}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement.secondBottom{width:212px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement{height:100%;display:inline-block;margin:0 0 0 10px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement img{height:100%}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement .foundationInnerElementWrapper{height:100%;width:auto;display:inline-block}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement .foundationInnerElementWrapper .foundationInnerElementTopRow{height:185px}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement .foundationInnerElementWrapper .foundationInnerElementTopRow{height:119px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement .foundationInnerElementWrapper .foundationInnerElementBottomRow{height:162.5px;margin:10px 0 0}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement .foundationInnerElementWrapper .foundationInnerElementBottomRow{height:102px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement .foundationInnerElementWrapper .foundationInnerElementImage.innerTop{width:100%}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement .foundationInnerElementWrapper .foundationInnerElementImage.innerTop img{width:auto;height:100%}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement .foundationInnerElementWrapper .foundationInnerElementImage{height:100%;display:inline-block;margin:0 0 10px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationImageBlock .foundationImageWrapper .foundationImageElement .foundationInnerElementWrapper .foundationInnerElementImage img{height:100%}#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock{display:inline-block;width:calc(100% - 700px);vertical-align:top;margin:0 0 0 60px;font-family:Lato,sans-serif;text-align:center}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock{width:100%;margin:0}}@media (max-width:768px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock{width:100%;margin:0}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock .foundationIconWrapper{width:100px;margin:35px auto 25px}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock .foundationIconWrapper{display:none}}@media (max-width:768px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock .foundationIconWrapper{margin:10px auto 25px}}@media (max-width:480px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock .foundationIconWrapper{display:block;width:90px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock .foundationIconWrapper img{width:100%}#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock .foundationCopyP{margin:0 0 25px;color:#333;font-size:18px;text-align:left;transition:margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock .foundationCopyP{margin:0 50px 25px}}@media (max-width:600px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock .foundationCopyP{margin:0 0 25px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationCopyBlock .foundationOpenRequestButton{font-size:14px;text-transform:none;width:180px;margin:0 auto;height:40px;line-height:40px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper{display:none;background:#ece2ee;margin:25px 0 0}@media (max-width:1024px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper{display:block}}@media (max-width:768px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper{display:block}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner{position:relative;margin:0 40px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerLeft{position:absolute;cursor:pointer;top:calc(50% - 20px);left:-25px;height:40px;z-index:1;transition:left .4s ease-in-out}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerLeft:hover{left:-30px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerLeft:active{left:-33px}@media (max-width:768px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerLeft{top:calc(50% - 15px);left:-25px;height:20px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerLeft:hover{left:-30px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerLeft:active{left:-33px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerLeft .leftArrow{width:0;height:0;border-top:20px solid transparent;border-bottom:20px solid transparent;border-right:20px solid #4b2e52;transition:border-right .2s ease-in-out}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerLeft .leftArrow:hover{border-right:20px solid #4b2e52}@media (max-width:768px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerLeft .leftArrow{border-top:16px solid transparent;border-bottom:16px solid transparent;border-right:16px solid #4b2e52}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerLeft .leftArrow:hover{border-right:16px solid #4b2e52}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerRight{position:absolute;cursor:pointer;top:calc(50% - 20px);right:-25px;height:40px;z-index:1;transition:right .4s ease-in-out}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerRight:hover{right:-30px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerRight:active{right:-33px}@media (max-width:768px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerRight{top:calc(50% - 15px);right:-25px;height:20px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerRight:hover{right:-30px}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerRight:active{right:-33px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerRight .rightArrow{width:0;height:0;border-top:20px solid transparent;border-bottom:20px solid transparent;border-left:20px solid #4b2e52;transition:border-left .2s ease-in-out}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerRight .rightArrow:hover{border-left:20px solid #4b2e52}@media (max-width:768px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerRight .rightArrow{border-top:16px solid transparent;border-bottom:16px solid transparent;border-left:16px solid #4b2e52}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .bannerRight .rightArrow:hover{border-left:16px solid #4b2e52}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .rotatingBannerItem{height:180px;margin:10px 10px 5px}@media (max-width:600px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .rotatingBannerItem{height:160px;margin:10px 5px 5px}}@media (max-width:480px){#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .rotatingBannerItem{height:90px;margin:10px 5px 5px}}#diamonds-direct .Foundation .foundationBodyWrapper .foundationBannerWrapper .foundationRotatingBanner .rotatingBannerItem img{height:100%}#diamonds-direct .FoundationRequest{position:relative;overflow-x:hidden;overflow-y:auto;font-family:Lusitana,serif;padding:0 10px}#diamonds-direct .FoundationRequest .closeIcon{position:absolute;cursor:pointer;color:#707070;background-image:radial-gradient(#707070,#707070);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:16px;right:16px;width:28px;height:28px;border:1px solid #707070;transform:rotate(45deg);z-index:1;transition:top .35s linear 0ms,right .35s linear 0ms,width .35s linear 0ms,height .35s linear 0ms,background-size .25s ease-in-out 0ms}#diamonds-direct .FoundationRequest .closeIcon:hover{background-size:100% 100%}#diamonds-direct .FoundationRequest .closeIcon:hover .closeX{color:#fff}#diamonds-direct .FoundationRequest .closeIcon .closeX{margin:-1px 0 0 -2px;transform:rotate(-45deg);line-height:28px;text-align:center;font-size:28px;font-weight:300;transition:font-size .35s linear 0ms,line-height .35s linear 0ms,color .25s ease-in-out 0ms}@media (max-width:768px){#diamonds-direct .FoundationRequest .closeIcon{top:10px;right:10px;width:18px;height:18px}#diamonds-direct .FoundationRequest .closeIcon .closeX{font-size:18px;line-height:18px}}#diamonds-direct .FoundationRequest .requestTitle{margin:15px 0 5px;text-align:center;font-size:30px}@media (max-width:768px){#diamonds-direct .FoundationRequest .requestTitle{margin:10px 0;font-size:22px}}#diamonds-direct .FoundationRequest .requestBr{text-align:center;height:35px}#diamonds-direct .FoundationRequest .requestBr img{height:100%}@media (max-width:768px){#diamonds-direct .FoundationRequest .requestBr{height:23px}}#diamonds-direct .FoundationRequest .requestColumn{display:inline-block;vertical-align:top;margin:10px 9px 0;width:calc(50% - 20px);font-family:Lato,sans-serif}@media (max-width:768px){#diamonds-direct .FoundationRequest .requestColumn{width:calc(100% - 20px)}}#diamonds-direct .FoundationRequest .requestColumn .inputLabel{font-size:14px;margin:0 0 2px}#diamonds-direct .FoundationRequest .requestColumn .inputWrapper{display:inline-block;margin:0 0 8px}#diamonds-direct .FoundationRequest .requestColumn .inputWrapper input{border:1px solid #d3d3d3;outline:none;padding:5px;width:calc(100% - 12px);font-size:14px;font-weight:300}#diamonds-direct .FoundationRequest .requestColumn .inputWrapper textarea{border:1px solid #d3d3d3;outline:none;padding:2px 5px;width:calc(100% - 12px);height:51.5px;font-size:16px;font-weight:300}#diamonds-direct .FoundationRequest .requestColumn .inputWrapper .radioWrapper{text-align:left;font-size:14px}#diamonds-direct .FoundationRequest .requestColumn .inputWrapper .radioWrapper .radioElement{display:inline-block;width:70px;margin:0 10px 0 0}#diamonds-direct .FoundationRequest .requestColumn .inputWrapper .radioWrapper .radioElement input{display:inline-block;vertical-align:top;margin:1px 0 0;width:20px;text-align:center}#diamonds-direct .FoundationRequest .requestColumn .inputWrapper .radioWrapper .radioElement .radioLabel{display:inline-block;vertical-align:top;margin:0 0 0 5px}#diamonds-direct .FoundationRequest .requestColumn .inputWrapper.secondInput{margin-right:0}#diamonds-direct .FoundationRequest .requestColumn .fullWidth{width:100%}#diamonds-direct .FoundationRequest .requestColumn .twoThirdsWidth{width:calc(66.6% - 10px);margin-right:20px}#diamonds-direct .FoundationRequest .requestColumn .oneThirdsWidth{width:calc(33.3% - 10px);margin-right:20px}#diamonds-direct .FoundationRequest .requestColumn .halfWidth{width:calc(50% - 10px);margin-right:20px}#diamonds-direct .FoundationRequest .submitWrapper{margin:15px auto 25px;text-align:center}#diamonds-direct .FoundationRequest .submitWrapper .submitButton{height:32px;line-height:32px;text-transform:none;font-weight:400;width:120px}#diamonds-direct .Heritage .heritageSection{background-image:url(\"https://ddw2.diamondsdirect.com/img/heritage/heritage.jpg\");background-repeat:no-repeat;background-position:0 0;background-size:contain}#diamonds-direct .Heritage .heritageSection .colsWrapper{position:relative;width:90%;margin:0 auto;transition:width .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .Heritage .heritageSection .colsWrapper{width:100%}}#diamonds-direct .Heritage .heritageSection .colsWrapper .heritageCol1{display:inline-block;vertical-align:top;width:40%}#diamonds-direct .Heritage .heritageSection .colsWrapper .heritageCol1 .heritageSpacer{padding-bottom:85%}#diamonds-direct .Heritage .heritageSection .colsWrapper .heritageCol1 .hRingsWrapper{position:relative;margin:0 -25% 0 20%;z-index:1}#diamonds-direct .Heritage .heritageSection .colsWrapper .heritageCol1 .hRingsWrapper img{width:100%}#diamonds-direct .Heritage .heritageSection .colsWrapper .heritageCol2{display:inline-block;vertical-align:top;width:60%}#diamonds-direct .Heritage .heritageSection .colsWrapper .heritageCol2 .pageWrapper{background-image:url(\"https://ddw2.diamondsdirect.com/img/heritage/whiterect.png\");background-repeat:no-repeat;background-position:0 0;background-size:100% 100%;padding:7% 20%;font-size:18px;transition:padding .35s linear 0ms,font-size .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .Heritage .heritageSection .colsWrapper .heritageCol2 .pageWrapper{padding:7% 15%;font-size:16px}}@media (max-width:1024px){#diamonds-direct .Heritage .heritageSection .colsWrapper .heritageCol2 .pageWrapper{font-size:15px}}@media (max-width:900px){#diamonds-direct .Heritage .heritageSection .colsWrapper .heritageCol2 .pageWrapper{font-size:15px;padding:7% 12%}}#diamonds-direct .Heritage .heritageSection .pageTitle{color:#472f51;font-size:36px;font-weight:400;text-transform:uppercase}#diamonds-direct .Heritage .heritageSection .pageP{font-family:Lato,sans-serif;margin:1em 0}#diamonds-direct .Heritage .heritageSection .pageBreak{margin:0 auto;width:90%}#diamonds-direct .Heritage .heritageSection .pageBreak img{width:100%}#diamonds-direct .Heritage .heritageSection .quoteWrapper{margin:-10% 10% 0 20%;font-size:24px;color:#472f51;transition:margin .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .Heritage .heritageSection .quoteWrapper{margin:-15% 0 0 20%}}@media (max-width:1024px){#diamonds-direct .Heritage .heritageSection .quoteWrapper{margin:-10% 0 0 20%}}#diamonds-direct .Heritage .heritageSection .nameWrapper{color:#979a9b;margin:0 10% 12% 15%;font-size:24px;text-align:right}#diamonds-direct .Heritage .heritageMobileSection .heritageMobBanner img{width:100%}#diamonds-direct .Heritage .heritageMobileSection .pageWrapper{position:relative;margin:-40% auto 0;width:80%;padding:0 5% 20%;z-index:1;background:#fff;box-shadow:4px 4px 4px #d7d7d7}#diamonds-direct .Heritage .heritageMobileSection .hRingsWrapper{position:relative;margin:-18% auto 0;width:85%;z-index:1}#diamonds-direct .Heritage .heritageMobileSection .hRingsWrapper img{width:100%}#diamonds-direct .Heritage .heritageMobileSection .noPageWrapper{margin:0 auto;width:85%;background:#fff}#diamonds-direct .Heritage .heritageMobileSection .mobQuoteWrapper{margin:0 auto;width:85%}#diamonds-direct .Heritage .heritageMobileSection .mobQuoteWrapper .quoteWrapper{margin:30px auto 0}#diamonds-direct .Heritage .heritageMobileSection .mobQuoteWrapper .nameWrapper{margin:0 auto 30px}#diamonds-direct .Heritage .awardsSection{background:#d7d7d7;margin:0 auto;padding:0 5%;transition:margin .35s linear 0ms;overflow:auto}@media (max-width:1200px){#diamonds-direct .Heritage .awardsSection{margin-top:-5%}}@media (max-width:768px){#diamonds-direct .Heritage .awardsSection{margin-top:0}}#diamonds-direct .Heritage .awardsSection .awardsTitle{font-size:24px;color:#4d4d4d;font-weight:700;font-family:Lato,sans-serif;text-transform:uppercase;margin:.5em 0}#diamonds-direct .Heritage .awardsSection .awardsWrapper{position:relative;margin-bottom:25px}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerLeft{display:none;position:absolute;cursor:pointer;top:calc(50% - 15px);left:-30px;height:30px;z-index:1;transition:left .4s ease-in-out}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerLeft:hover{left:-35px}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerLeft:active{left:-40px}@media (max-width:768px){#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerLeft{display:block;top:calc(50% - 10px);left:8px;height:20px}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerLeft:hover{left:5px}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerLeft:active{left:3px}}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerLeft .leftArrow{width:0;height:0;border-top:10px solid transparent;border-bottom:10px solid transparent;border-right:15px solid rgba(0,0,0,.6);transition:border-right .2s ease-in-out}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerLeft .leftArrow:hover{border-right:15px solid rgba(0,0,0,.9)}@media (max-width:768px){#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerLeft .leftArrow{border-top:16px solid transparent;border-bottom:16px solid transparent;border-right:16px solid rgba(0,0,0,.6)}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerLeft .leftArrow:hover{border-right:16px solid rgba(0,0,0,.9)}}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerRight{display:none;position:absolute;cursor:pointer;top:calc(50% - 15px);right:-30px;height:30px;z-index:1;transition:right .4s ease-in-out}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerRight:hover{right:-35px}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerRight:active{right:-40px}@media (max-width:768px){#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerRight{display:block;top:calc(50% - 10px);right:8px;height:20px}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerRight:hover{right:5px}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerRight:active{right:3px}}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerRight .rightArrow{width:0;height:0;border-top:10px solid transparent;border-bottom:10px solid transparent;border-left:15px solid rgba(0,0,0,.6);transition:border-left .2s ease-in-out}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerRight .rightArrow:hover{border-left:15px solid rgba(0,0,0,.9)}@media (max-width:768px){#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerRight .rightArrow{border-top:16px solid transparent;border-bottom:16px solid transparent;border-left:16px solid rgba(0,0,0,.6)}#diamonds-direct .Heritage .awardsSection .awardsWrapper .bannerRight .rightArrow:hover{border-left:16px solid rgba(0,0,0,.9)}}#diamonds-direct .Heritage .awardsSection .awardsWrapper .awardItem{text-align:center;outline:none;height:170px}#diamonds-direct .Heritage .awardsSection .awardsWrapper .awardItem img{margin:0 auto;height:100%;outline:none}#diamonds-direct .Heroes .blocksWrapper{position:relative;margin:50px 75px;font-family:Lato,sans-serif;transition:margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Heroes .blocksWrapper{margin:25px 35px}}@media (max-width:768px){#diamonds-direct .Heroes .blocksWrapper{margin:15px 25px}}#diamonds-direct .Heroes .blocksWrapper .imageBlock{position:absolute;top:0;left:0;width:45%;height:100%;background-image:url(\"https://ddw2.diamondsdirect.com/img/heroes/military_bg_half1.png\");background-repeat:no-repeat;background-position:50%;background-size:cover}@media (max-width:768px){#diamonds-direct .Heroes .blocksWrapper .imageBlock{position:relative;width:100%;height:auto;padding-bottom:54.7%;background-image:url(\"https://ddw2.diamondsdirect.com/img/heroes/military_mobilebanner1.png\");background-size:cover}}#diamonds-direct .Heroes .blocksWrapper .contentBlock{background:#f4f5f7;margin-left:calc(45% + 10px);overflow:auto;text-align:center;transition:margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Heroes .blocksWrapper .contentBlock{margin-left:calc(45% + 10px)}}@media (max-width:768px){#diamonds-direct .Heroes .blocksWrapper .contentBlock{margin-left:0}}#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesTitle{font-size:48px;text-transform:uppercase;font-weight:900;margin:20px 10px 0;color:#2b2b2b;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesTitle{font-size:36px}}#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesSubtitle{color:#4c214d;font-size:38px;font-weight:700;margin:0 10px;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesSubtitle{font-size:28px}}#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesOr{font-size:28px;font-weight:300;margin:-5px 0;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesOr{font-size:22px}}#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesText{color:#707070;margin:20px 25px 0;font-size:20px;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesText{font-size:16px}}#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesText a{color:#b78dbb;text-decoration:none;transition:color .25s ease-in-out 0ms}#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesText a:hover{color:#755a78}#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesText .textEm{font-weight:700}#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesHandwriting{font-family:Just Another Hand,cursive;margin:20px 25px;color:#4c214d;font-size:48px;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesHandwriting{font-size:36px}}@media (max-width:480px){#diamonds-direct .Heroes .blocksWrapper .contentBlock .heroesHandwriting{font-size:30px}}#diamonds-direct .Heroes .blocksWrapper .contentBlock .hereosLegal{font-size:14px;color:#707070;margin:0 40px 25px;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Heroes .blocksWrapper .contentBlock .hereosLegal{font-size:12px}}#diamonds-direct .pandoraBannerItem{position:relative}#diamonds-direct .pandoraBannerItem .pandoraButton{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;margin:0;top:82%;left:41%;width:18%;height:10%;padding:0;text-transform:uppercase;font-family:Lato,sans-serif;cursor:pointer;border:1px solid #fff;color:#fff;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,font-size .35s linear 0ms,padding .35s linear 0ms}#diamonds-direct .pandoraBannerItem .pandoraButton:hover{background:#fff;color:#c5c2de;border:1px solid #fff}@media (max-width:600px){#diamonds-direct .pandoraBannerItem .pandoraButton{top:72%;height:8%;width:32%;left:34%}}#diamonds-direct .thanksgivingBanner{position:relative}#diamonds-direct .thanksgivingBanner .thanksgivingButton{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;margin:0;top:67%;left:58%;width:17%;height:9%;padding:0;text-transform:uppercase;font-size:18px;font-family:Lato,sans-serif;cursor:pointer;border:none;color:#553b75;background:#ffc94a;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,font-size .35s linear 0ms,padding .35s linear 0ms}#diamonds-direct .thanksgivingBanner .thanksgivingButton:hover{border:none;color:#553b75;background:#ffd36e}@media (max-width:768px){#diamonds-direct .thanksgivingBanner .thanksgivingButton{font-size:14px}}@media (max-width:600px){#diamonds-direct .thanksgivingBanner .thanksgivingButton{top:91%;height:6%;width:32%;left:34%;font-weight:18px}}#diamonds-direct .winterBannerOverlay{position:relative}#diamonds-direct .winterBannerOverlay .winterBannerButton{position:absolute}#diamonds-direct .mothersBannerButton{position:absolute;top:80%;left:61%;width:28%;height:9%;display:-ms-flexbox;display:flex;cursor:pointer;text-align:center;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;color:#fff;background:#541b75;font-family:Lato,sans-serif;font-size:22px;transition:background .25s ease-in-out 0ms}#diamonds-direct .mothersBannerButton:hover{background:#2b0e3c}@media (max-width:1024px){#diamonds-direct .mothersBannerButton{font-size:20px}}@media (max-width:900px){#diamonds-direct .mothersBannerButton{font-size:18px}}@media (max-width:768px){#diamonds-direct .mothersBannerButton{font-size:15px}}@media (max-width:600px){#diamonds-direct .mothersBannerButton{top:90%;left:30%;width:40%;height:6%;font-size:16px}}@media (max-width:480px){#diamonds-direct .mothersBannerButton{font-size:12px}}#diamonds-direct .motherOverlay{position:absolute;top:45%;left:92%;height:5%;width:2%;cursor:pointer}@media (max-width:600px){#diamonds-direct .motherOverlay{top:70.5%;left:87%;height:3%;width:4%}}#diamonds-direct .noKidBannerButton.mothersBannerButton{top:75%;left:61.5%;width:24%;height:8%;color:#fff;background:hsla(0,0%,100%,0);border:1px solid #fff}#diamonds-direct .noKidBannerButton.mothersBannerButton:hover{background:#fff;color:#a8a0c0}@media (max-width:600px){#diamonds-direct .noKidBannerButton.mothersBannerButton{top:90%;left:20%;width:60%;height:6%}}#diamonds-direct .promoBannerButton{position:absolute;top:61%;left:57.7%;width:17.5%;height:auto;padding:1.3% 0;color:#b9aa70;background:hsla(48,34%,58%,0);border:1px solid #b9aa70;cursor:pointer;font-size:22px;font-weight:700;font-family:Lato,sans-serif;text-align:center;transition:background .25s ease-in-out 0ms,border .25s ease-in-out 0ms,color .25s ease-in-out 0ms,font-size .35s linear 0ms}#diamonds-direct .promoBannerButton:hover{background:#b9aa70;color:#fff;border:1px solid #b9aa70}@media (max-width:1024px){#diamonds-direct .promoBannerButton{font-size:20px}}@media (max-width:900px){#diamonds-direct .promoBannerButton{font-size:16px}}@media (max-width:768px){#diamonds-direct .promoBannerButton{font-size:14px}}@media (max-width:600px){#diamonds-direct .promoBannerButton{top:80%;left:30%;width:40%;height:5%;font-size:20px}}#diamonds-direct .promoBannerButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .promoBannerButton img{width:80%!important}#diamonds-direct .promoBannerButton.variant2{top:70%;left:62%;width:22%;height:10%;padding:0;font-size:22px;font-weight:700;color:#733678;background:rgba(115,54,120,0);border:2px solid #733678}#diamonds-direct .promoBannerButton.variant2:hover{background:#733678;color:#fff;border:2px solid #733678}@media (max-width:1024px){#diamonds-direct .promoBannerButton.variant2{font-size:18px}}@media (max-width:900px){#diamonds-direct .promoBannerButton.variant2{font-size:16px}}@media (max-width:768px){#diamonds-direct .promoBannerButton.variant2{font-size:14px}}@media (max-width:600px){#diamonds-direct .promoBannerButton.variant2{top:86%;left:14.5%;width:70%;height:7%;font-size:20px}}#diamonds-direct .promoBannerButton.variant3{top:67%;left:61.5%;width:24%;height:9%;padding:0;font-size:22px;font-weight:700;color:#733678;background:rgba(115,54,120,0);border:2px solid #733678}#diamonds-direct .promoBannerButton.variant3:hover{background:#733678;color:#fff;border:2px solid #733678}@media (max-width:1024px){#diamonds-direct .promoBannerButton.variant3{font-size:18px}}@media (max-width:900px){#diamonds-direct .promoBannerButton.variant3{font-size:16px}}@media (max-width:768px){#diamonds-direct .promoBannerButton.variant3{font-size:14px}}@media (max-width:600px){#diamonds-direct .promoBannerButton.variant3{top:85%;left:14.5%;width:70%;height:7%;font-size:20px}}#diamonds-direct .promoBannerButton.variant4{top:67%;left:63%;width:18%;height:9%;padding:0;font-size:22px;font-weight:700;color:#fff;background:hsla(0,0%,100%,0);border:2px solid #fff}#diamonds-direct .promoBannerButton.variant4:hover{background:#fff;color:#a59dc7;border:2px solid #fff}@media (max-width:1024px){#diamonds-direct .promoBannerButton.variant4{font-size:18px}}@media (max-width:900px){#diamonds-direct .promoBannerButton.variant4{font-size:16px}}@media (max-width:768px){#diamonds-direct .promoBannerButton.variant4{font-size:14px}}@media (max-width:600px){#diamonds-direct .promoBannerButton.variant4{top:84.5%;left:14.5%;width:70%;height:7%;font-size:20px}}#diamonds-direct .Home{margin-top:-18px}#diamonds-direct .Home .homePreBanner{display:none;position:relative;font-family:Lato,sans-serif;font-weight:300}#diamonds-direct .Home .homePreBanner img{width:100%}#diamonds-direct .Home .homePreBanner .preBannerOverlay{position:absolute;top:0;left:0;right:0;bottom:0;color:#fff;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;text-align:center}@media (max-width:768px){#diamonds-direct .Home .homePreBanner .preBannerOverlay{color:#4d4d4d;font-weight:400}}#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent{position:absolute;top:20%;left:0;right:0;height:60%;font-size:20px;transition:font-size .35s linear 0ms}@media (min-width:1800px){#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent{font-size:18px}}@media (max-width:1200px){#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent{font-size:16px}}@media (max-width:1024px){#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent{top:15%}}@media (max-width:900px){#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent{font-size:14px}}@media (max-width:768px){#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent{font-size:18px}}@media (max-width:600px){#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent{font-size:14px;top:0;height:70%}}@media (max-width:480px){#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent{font-size:12px}}#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent img{height:100%;width:auto;vertical-align:middle;cursor:pointer}#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent .listenLink{font-weight:400;text-decoration:underline;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent .listenLink:hover{color:#f4f0f6}@media (max-width:768px){#diamonds-direct .Home .homePreBanner .preBannerOverlay .preBannerContent .listenLink:hover{color:#666}}#diamonds-direct .Home .hurricaneBanner{background-image:url(\"/img/home/hurricane.jpg\");background-repeat:no-repeat;background-position:50%;background-size:cover;background-attachment:fixed;color:#fff;text-align:left;font-size:14px;padding:10px 0;font-family:Lato,sans-serif;font-weight:400;color:hsla(0,0%,100%,.8)}@media (max-width:600px){#diamonds-direct .Home .hurricaneBanner{background-image:url(\"/img/home/hurricane_mobile.jpg\")}}#diamonds-direct .Home .hurricaneBanner .hurricaneContentWrapper{margin:0 20px;padding:5px 0;background:rgba(3,18,46,.5)}#diamonds-direct .Home .hurricaneBanner .hurricaneContentWrapper .hurricaneInnerWrapper{margin:0 5px;padding:10px 20px 10px 30px;border:1px solid hsla(0,0%,100%,.9)}#diamonds-direct .Home .hurricaneBanner .hurricaneContentWrapper .hurricaneInnerWrapper .hurricaneStrong{font-weight:700;color:#fff;cursor:pointer}#diamonds-direct .Home .hurricaneBanner .hurricaneContentWrapper .hurricaneInnerWrapper .hurricaneStrong a{color:#fff;text-decoration:none}#diamonds-direct .Home .hurricaneBanner .hurricaneContentWrapper .hurricaneInnerWrapper .hurricaneStrong a:active,#diamonds-direct .Home .hurricaneBanner .hurricaneContentWrapper .hurricaneInnerWrapper .hurricaneStrong a:hover,#diamonds-direct .Home .hurricaneBanner .hurricaneContentWrapper .hurricaneInnerWrapper .hurricaneStrong a:visited{color:#fff}#diamonds-direct .Home .hurricaneBanner .hurricaneContentWrapper .hurricaneInnerWrapper .hurricaneLarge{margin:5px 0 0;font-size:18px;text-align:center;color:#fff}#diamonds-direct .Home .homeBanner,#diamonds-direct .Home .homeBanner2{position:relative;width:100%}#diamonds-direct .Home .homeBanner2 video.desktop600,#diamonds-direct .Home .homeBanner video.desktop600{display:block;width:100%}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 video.desktop600,#diamonds-direct .Home .homeBanner video.desktop600{display:none}}#diamonds-direct .Home .homeBanner2 video.mobile600,#diamonds-direct .Home .homeBanner video.mobile600{display:none;width:100%}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 video.mobile600,#diamonds-direct .Home .homeBanner video.mobile600{display:block}}#diamonds-direct .Home .homeBanner2 img.desktop600,#diamonds-direct .Home .homeBanner img.desktop600{display:block;width:100%}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 img.desktop600,#diamonds-direct .Home .homeBanner img.desktop600{display:none}}#diamonds-direct .Home .homeBanner2 img.mobile600,#diamonds-direct .Home .homeBanner img.mobile600{display:none;width:100%}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 img.mobile600,#diamonds-direct .Home .homeBanner img.mobile600{display:block}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.newyearsBannerOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.newyearsBannerOverlay{position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .Home .homeBanner2 .bannerOverlay.newyearsBannerOverlay .newyearsBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.newyearsBannerOverlay .newyearsBannerButton{position:absolute;top:68%;left:64.5%;width:15.5%;height:8.5%;cursor:pointer;color:#4b2e52;border:1px solid #4b2e52;background:rgba(75,46,82,0);font-family:Lato,sans-serif;font-size:22px;font-weight:700;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center;transition:background .2s linear 0ms,color .2s linear 0ms,background .2s linear 0ms}@media (max-width:900px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.newyearsBannerOverlay .newyearsBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.newyearsBannerOverlay .newyearsBannerButton{font-size:18px}}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.newyearsBannerOverlay .newyearsBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.newyearsBannerOverlay .newyearsBannerButton{font-size:22px;top:87.5%;left:30%;width:40%;height:7%}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.newyearsBannerOverlay .newyearsBannerButton:hover,#diamonds-direct .Home .homeBanner .bannerOverlay.newyearsBannerOverlay .newyearsBannerButton:hover{background:#4b2e52;color:#fff}#diamonds-direct .Home .homeBanner2 .bannerOverlay.fallBannerOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.fallBannerOverlay{position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .Home .homeBanner2 .bannerOverlay.fallBannerOverlay .fallBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.fallBannerOverlay .fallBannerButton{position:absolute;top:72.5%;left:58.5%;width:22%;height:7%;cursor:pointer;color:#fff;border:1px solid #fff;background:rgba(75,46,82,0);font-family:Lato,sans-serif;font-size:18px;font-weight:400;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center;transition:background .2s linear 0ms,color .2s linear 0ms,background .2s linear 0ms}@media (max-width:1200px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.fallBannerOverlay .fallBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.fallBannerOverlay .fallBannerButton{font-size:21px}}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.fallBannerOverlay .fallBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.fallBannerOverlay .fallBannerButton{font-size:18px}}@media (max-width:900px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.fallBannerOverlay .fallBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.fallBannerOverlay .fallBannerButton{font-size:16px}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.fallBannerOverlay .fallBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.fallBannerOverlay .fallBannerButton{font-size:13px}}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.fallBannerOverlay .fallBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.fallBannerOverlay .fallBannerButton{font-size:22px;top:80%;left:25%;width:50%;height:5.5%;font-size:16px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.fallBannerOverlay .fallBannerButton:hover,#diamonds-direct .Home .homeBanner .bannerOverlay.fallBannerOverlay .fallBannerButton:hover{background:#fff;color:#133d35}#diamonds-direct .Home .homeBanner2 .bannerOverlay.ggBannerOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.ggBannerOverlay{position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .Home .homeBanner2 .bannerOverlay.ggBannerOverlay .ggBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.ggBannerOverlay .ggBannerButton{position:absolute;top:68%;left:62%;width:22%;height:7%;cursor:pointer;color:#3e2941;border:1px solid #3e2941;background:rgba(75,46,82,0);font-family:Lato,sans-serif;font-size:18px;font-weight:400;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center;transition:background .2s linear 0ms,color .2s linear 0ms,background .2s linear 0ms}@media (max-width:1200px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.ggBannerOverlay .ggBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.ggBannerOverlay .ggBannerButton{font-size:18px}}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.ggBannerOverlay .ggBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.ggBannerOverlay .ggBannerButton{font-size:18px}}@media (max-width:900px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.ggBannerOverlay .ggBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.ggBannerOverlay .ggBannerButton{font-size:16px}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.ggBannerOverlay .ggBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.ggBannerOverlay .ggBannerButton{font-size:13px}}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.ggBannerOverlay .ggBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.ggBannerOverlay .ggBannerButton{font-size:22px;top:88%;left:25%;width:50%;height:5.5%;font-size:16px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.ggBannerOverlay .ggBannerButton:hover,#diamonds-direct .Home .homeBanner .bannerOverlay.ggBannerOverlay .ggBannerButton:hover{background:#3e2941;color:#fff}#diamonds-direct .Home .homeBanner2 .bannerOverlay.decBannerOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.decBannerOverlay{position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .Home .homeBanner2 .bannerOverlay.decBannerOverlay .decBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.decBannerOverlay .decBannerButton{position:absolute;top:78%;left:56%;width:28%;height:7%;cursor:pointer;color:#fff;border:1px solid #fff;background:hsla(0,0%,100%,0);font-family:Lato,sans-serif;font-size:18px;font-weight:400;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center;text-transform:uppercase;transition:background .2s linear 0ms,color .2s linear 0ms,background .2s linear 0ms}@media (max-width:1200px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.decBannerOverlay .decBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.decBannerOverlay .decBannerButton{font-size:17px}}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.decBannerOverlay .decBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.decBannerOverlay .decBannerButton{font-size:17px}}@media (max-width:900px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.decBannerOverlay .decBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.decBannerOverlay .decBannerButton{font-size:15px}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.decBannerOverlay .decBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.decBannerOverlay .decBannerButton{font-size:12px}}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.decBannerOverlay .decBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.decBannerOverlay .decBannerButton{font-size:22px;top:88%;left:20%;width:60%;height:5.5%;font-size:16px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.decBannerOverlay .decBannerButton:hover,#diamonds-direct .Home .homeBanner .bannerOverlay.decBannerOverlay .decBannerButton:hover{background:#fff;color:#1e1323}#diamonds-direct .Home .homeBanner2 .bannerOverlay.valentinesBannerOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.valentinesBannerOverlay{position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .Home .homeBanner2 .bannerOverlay.valentinesBannerOverlay .valentinesBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.valentinesBannerOverlay .valentinesBannerButton{position:absolute;top:62.5%;left:57%;width:26%;height:10%;cursor:pointer;color:#fff;border:1px solid #fff;background:rgba(75,46,82,0);font-family:Lato,sans-serif;font-size:24px;font-weight:700;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center;transition:background .2s linear 0ms,color .2s linear 0ms,background .2s linear 0ms}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.valentinesBannerOverlay .valentinesBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.valentinesBannerOverlay .valentinesBannerButton{font-size:24px}}@media (max-width:900px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.valentinesBannerOverlay .valentinesBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.valentinesBannerOverlay .valentinesBannerButton{font-size:18px}}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.valentinesBannerOverlay .valentinesBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.valentinesBannerOverlay .valentinesBannerButton{font-size:22px;top:78%;left:20%;width:60%;height:7%}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.valentinesBannerOverlay .valentinesBannerButton:hover,#diamonds-direct .Home .homeBanner .bannerOverlay.valentinesBannerOverlay .valentinesBannerButton:hover{background:#fff;color:#4b2d53}#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay{position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay .secondaryHomeButton.earring2020BannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay .secondaryHomeButton.earring2020BannerButton{top:70%;left:70%;width:22%;height:8%}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay .secondaryHomeButton.earring2020BannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay .secondaryHomeButton.earring2020BannerButton{font-size:18px;top:50.5%;left:23%;width:54%;height:5%}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton{position:absolute;top:70%;left:56.9%;width:30.5%;height:8%;cursor:pointer;color:#fff;border:2px solid #fff;background:none;font-family:Lato,sans-serif;font-size:22px;font-weight:900;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center;transition:background .2s linear 0ms,color .2s linear 0ms,background .2s linear 0ms,border .2s linear 0ms}@media (max-width:1200px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton{font-size:20px;font-weight:700}}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton{font-size:16px;font-weight:700}}@media (max-width:900px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton{font-size:15px;border:1px solid #fff}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton{font-size:13px;font-weight:400}}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton{font-size:18px;top:90%;left:15%;width:70%;height:5%}}@media (max-width:480px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton{font-size:15px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton:hover,#diamonds-direct .Home .homeBanner .bannerOverlay.earring2020BannerOverlay .earring2020BannerButton:hover{background:#fff;color:#7b6a92;border-color:#fff}#diamonds-direct .Home .homeBanner2 .bannerOverlay.earringBannerOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.earringBannerOverlay{position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .Home .homeBanner2 .bannerOverlay.earringBannerOverlay .shopStoreButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earringBannerOverlay .shopStoreButton{top:82%;left:26%;width:21%;height:8%}@media (max-width:600px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.earringBannerOverlay .shopStoreButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earringBannerOverlay .shopStoreButton{top:80%;left:32%;width:36%}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.earringBannerOverlay .shopOnlineButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earringBannerOverlay .shopOnlineButton{top:82%;left:51%;width:21%;height:8%}#diamonds-direct .Home .homeBanner2 .bannerOverlay.earringBannerOverlay .earringText,#diamonds-direct .Home .homeBanner .bannerOverlay.earringBannerOverlay .earringText{position:absolute;text-align:center;top:88%;left:30%;width:40%}#diamonds-direct .Home .homeBanner2 .bannerOverlay.earringBannerOverlay .earringBannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay.earringBannerOverlay .earringBannerButton{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;margin:0;padding:0;text-transform:uppercase;font-family:Lusitana,serif;cursor:pointer;font-size:18px;border:1px solid #6d4d92;color:#6d4d92;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,font-size .35s linear 0ms,padding .35s linear 0ms}#diamonds-direct .Home .homeBanner2 .bannerOverlay.earringBannerOverlay .earringBannerButton:hover,#diamonds-direct .Home .homeBanner .bannerOverlay.earringBannerOverlay .earringBannerButton:hover{background:#4b2d53;color:#fff;border:1px solid #4b2d53}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay{top:calc(50% - 160px);width:55%;font-weight:400;font-family:Lato,sans-serif}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay{top:calc(50% - 120px)}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay{top:calc(50% - 120px)}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoHeadline,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoHeadline{font-family:Lusitana,serif;color:#fff;font-size:48px}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoHeadline,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoHeadline{font-size:38px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoTagline,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoTagline{color:#fff;margin:5px 0 0;font-size:36px}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoTagline .light,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoTagline .light{font-weight:300}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoTagline .heavy,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoTagline .heavy{font-weight:700}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoTagline,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoTagline{font-size:22px}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoTagline,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoTagline{font-size:20px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoSubTagline,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoSubTagline{color:#fff;margin:0;font-weight:300;font-size:22px}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoSubTagline,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoSubTagline{font-size:14px}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoSubTagline,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoSubTagline{font-size:13px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoDates,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoDates{color:#fff;margin:10px 0 0;font-size:24px;font-weight:300}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoDates,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoDates{font-size:16px}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoDates,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoDates{font-size:14px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoButton,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoButton{color:#fff;margin:20px 0 0;text-transform:none;font-size:22px}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoButton:hover,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoButton:hover{background:#fff;color:#000}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoButton,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoButton{font-size:18px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoSpecialHours,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoSpecialHours{color:#fff;margin:15px 0 0;font-weight:400;font-size:22px}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoSpecialHours,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoSpecialHours{font-size:14px}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoSpecialHours,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoSpecialHours{font-size:14px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoSpecialHoursDate,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoSpecialHoursDate{color:#fff;margin:0;font-weight:300;font-size:20px}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoSpecialHoursDate,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoSpecialHoursDate{font-size:14px}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay.promoOverlay .promoSpecialHoursDate,#diamonds-direct .Home .homeBanner .bannerOverlay.promoOverlay .promoSpecialHoursDate{font-size:14px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay.caBannerOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay.caBannerOverlay{top:0;right:0;width:100%;height:100%}#diamonds-direct .Home .homeBanner2 .bannerOverlay,#diamonds-direct .Home .homeBanner .bannerOverlay{position:absolute;top:calc(50% - 55px);right:0;width:50%;height:110px;color:#4f4f4f;text-align:center}#diamonds-direct .Home .homeBanner2 .bannerOverlay .bannerHeadline,#diamonds-direct .Home .homeBanner .bannerOverlay .bannerHeadline{font-size:40px;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay .bannerHeadline,#diamonds-direct .Home .homeBanner .bannerOverlay .bannerHeadline{font-size:32px}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay .bannerHeadline,#diamonds-direct .Home .homeBanner .bannerOverlay .bannerHeadline{font-size:28px}}#diamonds-direct .Home .homeBanner2 .bannerOverlay .caBannerButton.bannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay .caBannerButton.bannerButton{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;margin:0;top:75%;left:56.5%;width:16%;height:8%;padding:0;border:1px solid #000;color:#000;font-weight:700}#diamonds-direct .Home .homeBanner2 .bannerOverlay .caBannerButton.bannerButton:hover,#diamonds-direct .Home .homeBanner .bannerOverlay .caBannerButton.bannerButton:hover{background:#000;color:#fff;border:1px solid #000}#diamonds-direct .Home .homeBanner2 .bannerOverlay .bannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay .bannerButton{display:inline-block;margin:30px 0 0;padding:8px 30px;border:1px solid #95989a;text-transform:uppercase;font-size:18px;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,font-size .35s linear 0ms,padding .35s linear 0ms}#diamonds-direct .Home .homeBanner2 .bannerOverlay .bannerButton:hover,#diamonds-direct .Home .homeBanner .bannerOverlay .bannerButton:hover{background:#4b2d53;color:#fff;border:1px solid #4b2d53}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2 .bannerOverlay .bannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay .bannerButton{font-size:16px;padding:6px 22px}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2 .bannerOverlay .bannerButton,#diamonds-direct .Home .homeBanner .bannerOverlay .bannerButton{font-size:15px;padding:5px 18px}}#diamonds-direct .Home .homeBanner2 .mobileBannerOverlay,#diamonds-direct .Home .homeBanner .mobileBannerOverlay{position:absolute;top:70%;right:15%;width:70%;height:110px;color:#4f4f4f;text-align:center;transition:top .35s linear 0ms}@media (max-width:480px){#diamonds-direct .Home .homeBanner2 .mobileBannerOverlay,#diamonds-direct .Home .homeBanner .mobileBannerOverlay{top:66%}}#diamonds-direct .Home .homeBanner2 .mobileBannerOverlay .bannerHeadline,#diamonds-direct .Home .homeBanner .mobileBannerOverlay .bannerHeadline{font-size:30px;transition:font-size .35s linear 0ms}@media (max-width:480px){#diamonds-direct .Home .homeBanner2 .mobileBannerOverlay .bannerHeadline,#diamonds-direct .Home .homeBanner .mobileBannerOverlay .bannerHeadline{font-size:24px}}#diamonds-direct .Home .homeBanner2 .mobileBannerOverlay .caBannerButton.bannerButton,#diamonds-direct .Home .homeBanner .mobileBannerOverlay .caBannerButton.bannerButton{margin:20% 0 0;border:1px solid #000;color:#000;font-weight:700}#diamonds-direct .Home .homeBanner2 .mobileBannerOverlay .caBannerButton.bannerButton:hover,#diamonds-direct .Home .homeBanner .mobileBannerOverlay .caBannerButton.bannerButton:hover{background:#000;color:#fff;border:1px solid #000}@media (max-width:480px){#diamonds-direct .Home .homeBanner2 .mobileBannerOverlay .caBannerButton.bannerButton,#diamonds-direct .Home .homeBanner .mobileBannerOverlay .caBannerButton.bannerButton{margin:26% 0 0}}#diamonds-direct .Home .homeBanner2 .mobileBannerOverlay .bannerButton,#diamonds-direct .Home .homeBanner .mobileBannerOverlay .bannerButton{display:inline-block;margin:30px 0 0;padding:5px 25px;border:1px solid #95989a;text-transform:uppercase;font-size:18px;cursor:default;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,font-size .35s linear 0ms}@media (max-width:480px){#diamonds-direct .Home .homeBanner2 .mobileBannerOverlay .bannerButton,#diamonds-direct .Home .homeBanner .mobileBannerOverlay .bannerButton{font-size:14px;padding:5px 20px;margin:15px 0 0}}#diamonds-direct .Home .homeBanner2 .mobileBannerOverlay .bannerButton:hover,#diamonds-direct .Home .homeBanner .mobileBannerOverlay .bannerButton:hover{cursor:pointer;background:#4b2d53;color:#fff;border:1px solid #4b2d53}#diamonds-direct .Home .homeBanner2.newBanner22 .bannerOverlay{position:absolute;top:0;right:0;left:0;bottom:0;width:unset;height:unset;text-align:center}#diamonds-direct .Home .homeBanner2.newBanner22 .bannerOverlay .bannerButton{display:block;position:absolute;top:62%;left:15.5%;width:24%;height:10%;margin:0;padding:0;border:1px solid #fff;color:#fff;text-transform:uppercase;font-size:20px;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,font-size .35s linear 0ms,padding .35s linear 0ms}#diamonds-direct .Home .homeBanner2.newBanner22 .bannerOverlay .bannerButton:hover{background:#fff;color:#6c6c6c;border:1px solid #fff}@media (max-width:1024px){#diamonds-direct .Home .homeBanner2.newBanner22 .bannerOverlay .bannerButton{font-size:16px;padding:0}}@media (max-width:768px){#diamonds-direct .Home .homeBanner2.newBanner22 .bannerOverlay .bannerButton{font-size:13px;padding:0}}#diamonds-direct .Home .homeBanner2.newBanner22 .bannerOverlay .bannerButton div{position:absolute;top:0;right:0;left:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;text-align:center}#diamonds-direct .Home .homeBanner2.newBanner22 .mobileBannerOverlay{position:absolute;top:0;right:0;left:0;bottom:0;width:unset;height:unset;text-align:center}#diamonds-direct .Home .homeBanner2.newBanner22 .mobileBannerOverlay .bannerButton{display:block;position:absolute;top:85%;left:15%;width:70%;height:10%;margin:0;padding:0;border:1px solid #fff;color:#fff;text-transform:uppercase;font-size:24px;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms,border .25s ease-in-out 0ms,font-size .35s linear 0ms}@media (max-width:480px){#diamonds-direct .Home .homeBanner2.newBanner22 .mobileBannerOverlay .bannerButton{font-size:18px;padding:0;margin:0}}#diamonds-direct .Home .homeBanner2.newBanner22 .mobileBannerOverlay .bannerButton:hover{cursor:pointer;background:#fff;color:#6c6c6c;border:1px solid #fff}#diamonds-direct .Home .homeBanner2.newBanner22 .mobileBannerOverlay .bannerButton div{position:absolute;top:0;right:0;left:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;text-align:center}#diamonds-direct .Home .homeRotatingBanner{position:relative;margin-bottom:-5px}#diamonds-direct .Home .homeRotatingBanner .bannerLeft{position:absolute;cursor:pointer;top:calc(50% - 20px);left:30px;height:40px;z-index:1;transition:left .4s ease-in-out}#diamonds-direct .Home .homeRotatingBanner .bannerLeft:hover{left:20px}#diamonds-direct .Home .homeRotatingBanner .bannerLeft:active{left:15px}@media (max-width:768px){#diamonds-direct .Home .homeRotatingBanner .bannerLeft{top:calc(50% - 10px);left:8px;height:20px}#diamonds-direct .Home .homeRotatingBanner .bannerLeft:hover{left:5px}#diamonds-direct .Home .homeRotatingBanner .bannerLeft:active{left:3px}}#diamonds-direct .Home .homeRotatingBanner .bannerLeft .leftArrow{width:0;height:0;border-top:20px solid transparent;border-bottom:20px solid transparent;border-right:20px solid hsla(0,0%,100%,.3);transition:border-right .2s ease-in-out}#diamonds-direct .Home .homeRotatingBanner .bannerLeft .leftArrow:hover{border-right:20px solid hsla(0,0%,100%,.8)}@media (max-width:768px){#diamonds-direct .Home .homeRotatingBanner .bannerLeft .leftArrow{border-top:16px solid transparent;border-bottom:16px solid transparent;border-right:16px solid hsla(0,0%,100%,.3)}#diamonds-direct .Home .homeRotatingBanner .bannerLeft .leftArrow:hover{border-right:16px solid hsla(0,0%,100%,.8)}}#diamonds-direct .Home .homeRotatingBanner .bannerRight{position:absolute;cursor:pointer;top:calc(50% - 20px);right:30px;height:40px;z-index:1;transition:right .4s ease-in-out}#diamonds-direct .Home .homeRotatingBanner .bannerRight:hover{right:20px}#diamonds-direct .Home .homeRotatingBanner .bannerRight:active{right:15px}@media (max-width:768px){#diamonds-direct .Home .homeRotatingBanner .bannerRight{top:calc(50% - 10px);right:8px;height:20px}#diamonds-direct .Home .homeRotatingBanner .bannerRight:hover{right:5px}#diamonds-direct .Home .homeRotatingBanner .bannerRight:active{right:3px}}#diamonds-direct .Home .homeRotatingBanner .bannerRight .rightArrow{width:0;height:0;border-top:20px solid transparent;border-bottom:20px solid transparent;border-left:20px solid hsla(0,0%,100%,.3);transition:border-left .2s ease-in-out}#diamonds-direct .Home .homeRotatingBanner .bannerRight .rightArrow:hover{border-left:20px solid hsla(0,0%,100%,.8)}@media (max-width:768px){#diamonds-direct .Home .homeRotatingBanner .bannerRight .rightArrow{border-top:16px solid transparent;border-bottom:16px solid transparent;border-left:16px solid hsla(0,0%,100%,.3)}#diamonds-direct .Home .homeRotatingBanner .bannerRight .rightArrow:hover{border-left:16px solid hsla(0,0%,100%,.8)}}#diamonds-direct .Home .homeRotatingBanner .rotatingBannerItem{height:100%}#diamonds-direct .Home .homeRotatingBanner .rotatingBannerItem img{width:100%}#diamonds-direct .Home .homeMidWrapper{margin:0}#diamonds-direct .Home .homeMidWrapper .sectionRow{position:relative}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowImage{width:50%;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowImage{width:100%}}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowImage img{display:block;width:100%}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowImage.imageLeft{margin:0 50% 0 0;transition:margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowImage.imageLeft{margin:0}}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowImage.imageRight{margin:0 0 0 50%;transition:margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowImage.imageRight{margin:0}}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent{position:absolute;top:0;width:50%;bottom:0;color:#5e5e5e}@media (max-width:600px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent{position:relative;height:auto;width:100%}}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper{position:absolute;top:25%;left:0;right:0;height:50%;text-align:center;transition:top .35s linear 0ms,margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper{top:18%}}@media (max-width:768px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper{top:10%}}@media (max-width:600px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper{position:relative;margin:25px 0}}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentTitle{font-size:40px;transition:font-size .35s linear 0ms}@media (min-width:1800px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentTitle{font-size:40px}}@media (max-width:1024px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentTitle{font-size:32px}}@media (max-width:768px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentTitle{font-size:28px}}@media (max-width:600px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentTitle{font-size:32px}}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentBody{font-family:Lato,sans-serif;font-size:18px;font-weight:300;margin:25px 110px;transition:margin .35s linear 0ms,font-size .35s linear 0ms}@media (min-width:1800px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentBody{font-size:18px}}@media (max-width:1200px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentBody{font-size:16px}}@media (max-width:1024px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentBody{margin:14px 50px}}@media (max-width:900px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentBody{font-size:14px}}@media (max-width:768px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentBody{margin:10px 30px;font-size:12px}}@media (max-width:600px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentBody{font-size:14px;margin:18px 50px}}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA{cursor:pointer}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA .ctaLabel.videoLabel{font-size:22px}@media (max-width:768px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA .ctaLabel.videoLabel{font-size:18px}}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA .ctaLabel{font-size:24px;transition:font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA .ctaLabel{font-size:20px}}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA .ctaUnderline{height:50px;background-repeat:no-repeat;background-position:0 0}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA .ctaAppointment{margin:0 auto;width:200px;height:27px;background-size:200px 54px;background-image:url(\"https://s3.amazonaws.com/dd-website/img/home/shopengagement.gif\")}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA .ctaVisitUs{margin:0 auto;width:100px;height:24px;background-size:100px 48px;background-image:url(\"https://s3.amazonaws.com/dd-website/img/home/visitus.gif\")}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA .ctaEngagement{margin:0 auto;width:200px;height:27px;background-size:200px 54px;background-image:url(\"https://s3.amazonaws.com/dd-website/img/home/shopengagement.gif\")}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA .ctaFashion{margin:0 auto;width:200px;height:26px;background-size:200px 52px;background-image:url(\"https://s3.amazonaws.com/dd-website/img/home/shopfinejewelry.gif\")}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA:hover .ctaLabel{color:#4b2d53}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA:hover .ctaEngagement,#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA:hover .ctaFashion,#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent .contentWrapper .contentCTA:hover .ctaVisitUs{background-position:0 100%}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent.contentLeft{left:0}#diamonds-direct .Home .homeMidWrapper .sectionRow .rowContent.contentRight{right:0}#diamonds-direct .Home .bestsellersWrapper{margin:0 auto 25px;width:90%;max-width:1200px;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Home .bestsellersWrapper{margin:0 20px}}#diamonds-direct .Home .bestsellersWrapper .bestTitle{margin:50px 0 30px;text-align:center;font-size:46px;color:#4e4352;transition:font-size .35s linear 0ms}#diamonds-direct .Home .bestsellersWrapper .bestTitle .titleDesigner{margin:8px auto 0;width:250px}@media (max-width:768px){#diamonds-direct .Home .bestsellersWrapper .bestTitle .titleDesigner{width:215px}}@media (max-width:600px){#diamonds-direct .Home .bestsellersWrapper .bestTitle .titleDesigner{width:185px}}@media (max-width:480px){#diamonds-direct .Home .bestsellersWrapper .bestTitle .titleDesigner{width:160px}}@media (max-width:768px){#diamonds-direct .Home .bestsellersWrapper .bestTitle{font-size:42px}}@media (max-width:600px){#diamonds-direct .Home .bestsellersWrapper .bestTitle{font-size:36px}}@media (max-width:480px){#diamonds-direct .Home .bestsellersWrapper .bestTitle{font-size:32px}}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestLHS{display:inline-block;width:calc(49.8% - 25px)}@media (max-width:1024px){#diamonds-direct .Home .bestsellersWrapper .bestItems .bestLHS{width:calc(49.8% - 10px)}}@media (max-width:768px){#diamonds-direct .Home .bestsellersWrapper .bestItems .bestLHS{display:none}}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestLHS .largeItemWrapper{position:relative;cursor:pointer}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestLHS .largeItemWrapper .largeImg{position:relative;width:100%;padding:100% 0 0;background-position:50%;background-repeat:no-repeat;background-size:cover}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestLHS .largeItemWrapper .largeScreen{position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;background:#fff;transition:opacity .25s ease-in-out 0ms}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestLHS .largeItemWrapper .largeScreen:hover{opacity:.7}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestLHS .largeItemWrapper .largeScreen .largeScreenText{position:absolute;top:40%;left:0;right:0;height:20%;text-align:center}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestLHS .largeItemWrapper .largeScreen .largeScreenText .largeScreenTitle{font-size:28px;font-weight:700}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestLHS .largeItemWrapper .largeScreen .largeScreenText .largeScreenSubtitle{font-size:24px;font-weight:400}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS{display:inline-block;width:calc(49.8% - 25px);margin:0 0 0 50px}@media (max-width:1024px){#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS{width:calc(49.8% - 10px);margin:0 0 0 20px}}@media (max-width:768px){#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS{display:none}}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow:first-child{margin-bottom:0}@media (max-width:1024px){#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow:first-child{margin-bottom:15px}}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper{position:relative;display:inline-block;width:calc(49.9% - 25px);cursor:pointer}@media (max-width:1024px){#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper{width:calc(49.9% - 10px)}}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper:nth-child(2){margin-left:50px}@media (max-width:1024px){#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper:nth-child(2){margin-left:20px}}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper .smallScreen{position:absolute;top:0;left:0;right:0;bottom:0;background:#fff;opacity:0;transition:opacity .25s ease-in-out 0ms}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper .smallScreen:hover{opacity:.7}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper .smallScreen .smallScreenText{position:absolute;top:40%;left:0;right:0;height:20%;text-align:center}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper .smallScreen .smallScreenText .smallScreenTitle{font-size:16px;font-weight:700}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper .smallScreen .smallScreenText .smallScreenSubtitle{font-size:14px;font-weight:400}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper .smallImg{position:relative;width:100%;padding:100% 0 0;background-position:50%;background-repeat:no-repeat;background-size:cover}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestMobile{text-align:left}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestMobile .mobileItemWrapper{display:inline-block;width:calc(49.9% - 10px);margin:0 0 10px 10px;transition:width .35s linear 0ms,margin .35s linear 0ms}@media (max-width:480px){#diamonds-direct .Home .bestsellersWrapper .bestItems .bestMobile .mobileItemWrapper{width:100%;margin:0 0 10px}}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestMobile .mobileItemWrapper:nth-child(odd){margin:0 10px 10px 0}@media (max-width:480px){#diamonds-direct .Home .bestsellersWrapper .bestItems .bestMobile .mobileItemWrapper:nth-child(odd){margin:0 0 10px}}#diamonds-direct .Home .bestsellersWrapper .bestItems .bestMobile .mobileItemWrapper .mobileImg{width:100%;padding:100% 0 0;background-position:50%;background-repeat:no-repeat;background-size:cover}#diamonds-direct .Home .bestsellersWrapper .bestItems .itemLabel{height:50px;color:#5e5e5e}@media (max-width:1024px){#diamonds-direct .Home .bestsellersWrapper .bestItems .itemLabel{display:none}}@media (max-width:768px){#diamonds-direct .Home .bestsellersWrapper .bestItems .itemLabel{display:block}}#diamonds-direct .Home .bestsellersWrapper .bestItems .itemLabel .itemLabelName{font-size:16px;transition:font-size .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .Home .bestsellersWrapper .bestItems .itemLabel .itemLabelName{font-size:14px}}#diamonds-direct .Home .bestsellersWrapper .bestItems .itemLabel .itemLabelPrice{font-family:Lato,sans-serif;font-size:14px;font-weight:300}@media (max-width:1200px){#diamonds-direct .Home .bestsellersWrapper .bestItems .itemLabel .itemLabelPrice{font-size:13px}}#diamonds-direct .Home .bestsellersWrapper .bestItems .haloImg{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/halo_thumb_1.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .studImg{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/3prong_thumb.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .kelegeImg{background-image:url(\"https://s3.amazonaws.com/dd-website/img/home/sesfband_thumb.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .pearImg{background-image:url(\"https://s3.amazonaws.com/dd-website/img/home/threestone_thumb.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .tennisImg{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/tennis_thumb.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .verragioImgLarge{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/verragio/verlarge.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .verragioImg1{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/verragio/ver1sm.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .verragioImg2{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/verragio/ver2sm.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .verragioImg3{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/verragio/ver3sm.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .verragioImg4{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/verragio/ver4sm.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .blueImgLarge{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/blue/sblarge.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .blueImg1{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/blue/sb1.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .blueImg2{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/blue/sb2.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .blueImg3{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/blue/sb3.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .blueImg4{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/blue/sb4.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .augImgLarge{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/aug/kcdesigns_earrings_lg.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .augImg1{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/aug/hd_xring.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .augImg2{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/aug/dddesigns_bolo.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .augImg3{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/aug/gabny_bezelneck.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .augImg4{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/aug/amden_ovalring.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .septImgLarge{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/sept/large.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .septImg1{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/sept/1.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .septImg2{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/sept/2.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .septImg3{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/sept/3.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .septImg4{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/sept/4.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .novImgLarge{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/bf2/smd1817108_L.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .novImg1{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/bf2/bldmd19406.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .novImg2{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/bf2/bldsm20917.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .novImg3{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/bf2/smd1463388.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .novImg4{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/bf2/bdsap03625.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .holidayImgLarge{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/bf2/efand20939_L.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .holidayImg1{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/bf2/efand17698.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .holidayImg2{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/bf2/efand19614.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .holidayImg3{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/bf2/efand17563.jpg\")}#diamonds-direct .Home .bestsellersWrapper .bestItems .holidayImg4{background-image:url(\"https://s3.amazonaws.com/dd-website/img/bestsellers/bf2/stud.jpg\")}#diamonds-direct .Home .storyWrapper{position:relative;margin:25px 50px 0;background:#fafafa;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Home .storyWrapper{margin:25px 20px 0}}#diamonds-direct .Home .storyWrapper .videoElement{position:relative;display:block;width:65%;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Home .storyWrapper .videoElement{width:100%}}#diamonds-direct .Home .storyWrapper .videoElement .videoSprite{position:absolute;top:calc(50% - 69px);left:calc(50% - 69px);width:138px;height:138px;cursor:pointer;background-image:url(\"https://s3.amazonaws.com/dd-website/img/home/playbutton.png\");background-repeat:no-repeat;background-size:138px 272px;background-position:0 0}#diamonds-direct .Home .storyWrapper .videoElement .videoSprite:hover{background-position:0 100%}#diamonds-direct .Home .storyWrapper .videoElement.imgCover img{display:block;width:100%}#diamonds-direct .Home .storyWrapper .videoElement.imgCover .videoSprite{display:block}#diamonds-direct .Home .storyWrapper .videoElement.imgCover video,#diamonds-direct .Home .storyWrapper .videoElement.watchVideo .videoSprite,#diamonds-direct .Home .storyWrapper .videoElement.watchVideo img{display:none}#diamonds-direct .Home .storyWrapper .videoElement.watchVideo video{display:block;width:100%}#diamonds-direct .Home .storyWrapper .videoDescription{position:absolute;top:0;right:0;width:35%;bottom:0;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Home .storyWrapper .videoDescription{position:relative;width:100%}}#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper{position:absolute;top:25%;left:0;right:0;height:50%;text-align:center;transition:top .35s linear 0ms,margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper{top:15%;margin:20px 0}}@media (max-width:768px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper{position:relative}}#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinTitle{color:#4b2d53;font-size:32px;text-transform:uppercase;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinTitle{font-size:24px}}@media (max-width:768px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinTitle{font-size:32px}}#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinBody{color:#5e5e5e;font-family:Lato,sans-serif;font-size:18px;font-weight:300;margin:25px 50px;transition:margin .35s linear 0ms,font-size .35s linear 0ms}@media (min-width:1800px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinBody{font-size:18px}}@media (max-width:1200px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinBody{font-size:16px}}@media (max-width:1024px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinBody{margin:10px 20px 15px;font-size:13px}}@media (max-width:768px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinBody{margin:15px auto;width:300px;font-size:18px}}#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA{cursor:pointer;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA{margin:0 0 20px}}#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA .videoCtaLabel{font-size:24px}#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA .videoCtaLabel:hover{color:#4b2d53}@media (max-width:1024px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA .videoCtaLabel{font-size:20px}}@media (max-width:768px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA .videoCtaLabel{font-size:24px}}#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA .videoCtaUnderline{height:40px}#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA .videoCtaDiscover{margin:0 auto;width:190px;height:27px;cursor:pointer;background-image:url(\"https://s3.amazonaws.com/dd-website/img/home/discovermore.gif\");background-repeat:no-repeat;background-position:0 0;background-size:190px 54px;transition:width .35s linear 0ms}#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA .videoCtaDiscover:hover{background-position:0 100%}@media (max-width:1024px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA .videoCtaDiscover{width:160px;height:23px;background-size:160px 46px}}@media (max-width:768px){#diamonds-direct .Home .storyWrapper .videoDescription .videoDescriptoinWrapper .videoDescriptoinCTA .videoCtaDiscover{width:190px;height:27px;background-size:190px 54px}}#diamonds-direct .Home .bottomLinks{position:relative;margin:40px 50px;text-align:center;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Home .bottomLinks{margin:40px 20px;text-align:left}}#diamonds-direct .Home .bottomLinks .linkWrapper{display:inline-block;width:calc(33.3% - 11px);transition:width .35s linear 0ms;vertical-align:top;cursor:pointer}@media (max-width:768px){#diamonds-direct .Home .bottomLinks .linkWrapper{width:calc(50% - 10px);margin-bottom:30px}}@media (max-width:480px){#diamonds-direct .Home .bottomLinks .linkWrapper{width:100%}}#diamonds-direct .Home .bottomLinks .linkWrapper:first-child{position:absolute;top:0;left:0}@media (max-width:768px){#diamonds-direct .Home .bottomLinks .linkWrapper:first-child{position:relative}}#diamonds-direct .Home .bottomLinks .linkWrapper:nth-child(2){margin:0}@media (max-width:768px){#diamonds-direct .Home .bottomLinks .linkWrapper:nth-child(2){margin:0 0 30px 20px}}@media (max-width:480px){#diamonds-direct .Home .bottomLinks .linkWrapper:nth-child(2){margin-left:0}}#diamonds-direct .Home .bottomLinks .linkWrapper:nth-child(3){position:absolute;top:0;right:0}@media (max-width:768px){#diamonds-direct .Home .bottomLinks .linkWrapper:nth-child(3){position:relative}}#diamonds-direct .Home .bottomLinks .linkWrapper .linkImgWrapper img{display:block;width:100%}#diamonds-direct .Home .bottomLinks .linkWrapper .linkLabelWrapper{text-align:center}#diamonds-direct .Home .bottomLinks .linkWrapper .linkLabelWrapper .linkLabelTitle{color:#4e4352;margin:25px 0 0;font-size:28px;transition:margin .35s linear 0ms,font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Home .bottomLinks .linkWrapper .linkLabelWrapper .linkLabelTitle{margin:10px 0 0}}@media (max-width:600px){#diamonds-direct .Home .bottomLinks .linkWrapper .linkLabelWrapper .linkLabelTitle{font-size:22px}}@media (max-width:480px){#diamonds-direct .Home .bottomLinks .linkWrapper .linkLabelWrapper .linkLabelTitle{font-size:28px}}#diamonds-direct .Home .bottomLinks .linkWrapper .linkLabelWrapper .linkLabelBody{font-family:Lato,sans-serif;color:#b2b2b2;margin:10px 20px 0;transition:font-size .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Home .bottomLinks .linkWrapper .linkLabelWrapper .linkLabelBody{font-size:13px;margin:5px 0 0}}@media (max-width:480px){#diamonds-direct .Home .bottomLinks .linkWrapper .linkLabelWrapper .linkLabelBody{font-size:16px}}#diamonds-direct .Influencers{font-family:Lato,sans-serif;color:#5e5e5e}#diamonds-direct .Influencers .influencerWrapper{width:90%;max-width:1024px;margin:0 auto}#diamonds-direct .Influencers .influencerWrapper .influencersTitle{font-family:Lusitana,serif;color:#5e5e5e;font-size:36px;margin:20px 0;text-transform:uppercase;transition:font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Influencers .influencerWrapper .influencersTitle{font-size:24px}}#diamonds-direct .Influencers .influencerWrapper .copyLeft.influencerRow .influencerCopy{margin:0 50% 0 0}@media (max-width:768px){#diamonds-direct .Influencers .influencerWrapper .copyLeft.influencerRow .influencerCopy{margin:0}}#diamonds-direct .Influencers .influencerWrapper .copyLeft.influencerRow .influencerImg{left:50%}@media (max-width:768px){#diamonds-direct .Influencers .influencerWrapper .copyLeft.influencerRow .influencerImg{left:unset}}#diamonds-direct .Influencers .influencerWrapper .copyRight.influencerRow .influencerCopy{margin:0 0 0 50%}@media (max-width:768px){#diamonds-direct .Influencers .influencerWrapper .copyRight.influencerRow .influencerCopy{margin:0}}#diamonds-direct .Influencers .influencerWrapper .copyRight.influencerRow .influencerImg{left:0}@media (max-width:768px){#diamonds-direct .Influencers .influencerWrapper .copyRight.influencerRow .influencerImg{left:unset}}#diamonds-direct .Influencers .influencerWrapper .influencerRow{position:relative}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy{width:50%}@media (max-width:768px){#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy{width:100%}}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy .icWrapper{padding:160px 25px;transition:padding .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy .icWrapper{padding:130px 25px}}@media (max-width:900px){#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy .icWrapper{padding:110px 25px}}@media (max-width:768px){#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy .icWrapper{padding:20px 25px 50px}}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy .icWrapper .icTitle{font-family:Lusitana,serif;color:#5e5e5e;font-size:32px;margin:0 0 10px;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy .icWrapper .icTitle{font-size:28px}}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy .icWrapper .icHandle{font-size:24px;color:#a9a0ba;cursor:pointer;margin:0 0 25px}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy .icWrapper .icLink{position:relative;display:inline-block;font-size:16px;text-transform:uppercase;text-align:left;cursor:pointer;color:#000;padding:0 20px 0 0}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy .icWrapper .icLink:hover{color:#4b2d53}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCopy .icWrapper .icLink .icLinkArrow{background-image:url(\"https://ddw2.diamondsdirect.com/img/influence/triangle.svg\");background-repeat:no-repeat;background-position:50%;background-size:contain;position:absolute;top:2px;right:0;width:16px;height:14px}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerBkb.influencerImg{background-image:url(\"https://ddw2.diamondsdirect.com/img/influence/bkb.jpg\")}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerCw.influencerImg{background-image:url(\"https://ddw2.diamondsdirect.com/img/influence/cw.jpg\")}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerJp.influencerImg{background-image:url(\"https://ddw2.diamondsdirect.com/img/influence/jp.jpg\")}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerMr.influencerImg{background-image:url(\"https://ddw2.diamondsdirect.com/img/influence/mr.jpg\")}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerAa.influencerImg{background-image:url(\"https://ddw2.diamondsdirect.com/img/influence/aa.jpg\")}#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerImg{position:absolute;top:0;width:50%;height:100%;background-repeat:no-repeat;background-size:cover;background-position:50%}@media (max-width:768px){#diamonds-direct .Influencers .influencerWrapper .influencerRow .influencerImg{position:relative;top:unset;width:100%;height:auto;padding-bottom:84.1%}}#diamonds-direct .InfluencePage{font-family:Lato,sans-serif}#diamonds-direct .InfluencePage .desktopLink{display:block}@media (max-width:768px){#diamonds-direct .InfluencePage .desktopLink{display:none}}#diamonds-direct .InfluencePage .mobileLink{display:none}@media (max-width:768px){#diamonds-direct .InfluencePage .mobileLink{display:block}}#diamonds-direct .InfluencePage .overlayLink{position:absolute;cursor:pointer}#diamonds-direct .InfluencePage .infLink{position:absolute;font-size:18px;font-weight:700;text-transform:uppercase;padding:0 20px 0 0;color:#000;cursor:pointer;transition:color .25s ease-in-out 0ms;width:auto;height:auto}#diamonds-direct .InfluencePage .infLink:hover{color:#4b2d53}#diamonds-direct .InfluencePage .infLink .infLinkArrow{background-image:url(\"https://ddw2.diamondsdirect.com/img/influence/triangle.svg\");background-repeat:no-repeat;background-position:50%;background-size:contain;position:absolute;top:2px;right:0;width:16px;height:16px}#diamonds-direct .InfluencePage .ipHeader{position:relative}#diamonds-direct .InfluencePage .ipHeader img{width:100%}#diamonds-direct .InfluencePage .ipHeader .desktopHeader{display:block}@media (max-width:768px){#diamonds-direct .InfluencePage .ipHeader .desktopHeader{display:none}}#diamonds-direct .InfluencePage .ipHeader .mobileHeader{display:none}@media (max-width:768px){#diamonds-direct .InfluencePage .ipHeader .mobileHeader{display:block}}#diamonds-direct .InfluencePage .ipBody{width:90%;max-width:1024px;margin:0 auto}#diamonds-direct .InfluencePage .ipBody .ipRow{position:relative}#diamonds-direct .InfluencePage .ipBody .ipRow img{width:100%}#diamonds-direct .InfluencePage .ipBody .ipRow .desktopRow{display:block}@media (max-width:768px){#diamonds-direct .InfluencePage .ipBody .ipRow .desktopRow{display:none}}#diamonds-direct .InfluencePage .ipBody .ipRow .mobileRow{display:none}@media (max-width:768px){#diamonds-direct .InfluencePage .ipBody .ipRow .mobileRow{display:block}}#diamonds-direct .InfluencePage .ipCustom{width:90%;max-width:1024px;margin:20px auto}#diamonds-direct .InfluencePage .ipCustom .customTitleWrapper{border-bottom:1px solid #000;padding:0 0 20px 20px;max-width:600px}#diamonds-direct .InfluencePage .ipCustom .customTitleWrapper .customTitle{font-family:Lusitana,serif;font-size:32px;color:#000}#diamonds-direct .InfluencePage .ipCustom .customBody{font-size:18px;margin:20px 20px 20px 60px}#diamonds-direct .InfluencePage .ipForm{position:relative;overflow:auto;background:#f0f0f0;margin:0 auto}@media (max-width:600px){#diamonds-direct .InfluencePage .ipForm{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper{width:90%;max-width:1024px;margin:25px auto}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formP{color:#000;text-align:center;margin:0 0 25px;padding-top:15px;font-size:20px;font-weight:400}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #000;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #000;background:#fff}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formWrapper .formInputWrapper .influenceSelect.error select{border:2px solid #eb3533}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formWrapper .formActionRow .formAction{color:#000;background:#fff;border:1px solid #000;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .InfluencePage .ipForm .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#000}#diamonds-direct .InfluenceBrightonbutler .ipHeader .linkH1m{top:40%;left:35%;width:60%;height:40%}#diamonds-direct .InfluenceBrightonbutler .ipBody{margin-top:-110px}@media (max-width:1200px){#diamonds-direct .InfluenceBrightonbutler .ipBody{margin-top:-11%}}@media (max-width:768px){#diamonds-direct .InfluenceBrightonbutler .ipBody{margin-top:0}}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow1 .link11{top:0;left:60%;width:40%;height:99%}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow2 .link21{top:0;left:0;width:55%;height:99%}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow2 .link21m{top:0;left:0;width:100%;height:49%}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow3 .link31{top:0;left:0;width:28%;height:55%}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow3 .link32{top:45%;left:45%;width:27%;height:54%}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow3 .link33{top:0;left:73%;width:27%;height:70%}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow3 .link31m{top:0;left:0;width:100%;height:69%}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow4 .link41{top:0;left:0;width:55%;height:99%}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow4 .link41m{top:0;left:0;width:100%;height:70%}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow5 .link51m{top:0;left:0;width:100%;height:80%}#diamonds-direct .InfluenceBrightonbutler .ipBody .ipRow6 .link61m{top:0;left:0;width:100%;height:59%}#diamonds-direct .InfluenceCourtnwilliams .ipHeader .linkH1{top:35%;left:5%;width:55%;height:40%}#diamonds-direct .InfluenceCourtnwilliams .ipBody{margin-top:-90px}@media (max-width:1200px){#diamonds-direct .InfluenceCourtnwilliams .ipBody{margin-top:-9%}}@media (max-width:768px){#diamonds-direct .InfluenceCourtnwilliams .ipBody{margin-top:0}}#diamonds-direct .InfluenceCourtnwilliams .ipBody .ipRow1 .link11{top:0;left:0;width:33%;height:99%}#diamonds-direct .InfluenceCourtnwilliams .ipBody .ipRow2 .link21{top:0;left:55%;width:45%;height:99%}#diamonds-direct .InfluenceCourtnwilliams .ipBody .ipRow2 .link21m{top:0;left:0;width:100%;height:68%}#diamonds-direct .InfluenceCourtnwilliams .ipBody .ipRow3 .link31{top:0;left:0;width:44%;height:99%}#diamonds-direct .InfluenceCourtnwilliams .ipBody .ipRow3 .link32{top:53%;left:45%;width:28%;height:50%}#diamonds-direct .InfluenceCourtnwilliams .ipBody .ipRow3 .link33{top:53%;left:73.1%;width:28%;height:50%}#diamonds-direct .InfluenceCourtnwilliams .ipBody .ipRow3 .link31m{top:0;left:0;width:100%;height:74%}#diamonds-direct .InfluenceCourtnwilliams .ipBody .ipRow4 .link41{top:1%;left:10%;width:40%;height:95%}#diamonds-direct .InfluenceCourtnwilliams .ipBody .ipRow4 .link42{top:1%;left:51%;width:42%;height:95%}#diamonds-direct .InfluenceHauteofftherack .ipBody{margin-top:-110px}@media (max-width:1200px){#diamonds-direct .InfluenceHauteofftherack .ipBody{margin-top:-11%}}@media (max-width:768px){#diamonds-direct .InfluenceHauteofftherack .ipBody{margin-top:-20%}}#diamonds-direct .InfluenceHauteofftherack .ipBody .ipRow1 .link11{top:0;left:0;width:63%;height:100%}#diamonds-direct .InfluenceHauteofftherack .ipBody .ipRow1 .link12{top:0;left:64%;width:36%;height:100%}#diamonds-direct .InfluenceHauteofftherack .ipBody .ipRow1 .link11m{top:0;left:0;width:100%;height:99%}#diamonds-direct .InfluenceHauteofftherack .ipBody .ipRow2 .link21{top:0;left:0;width:45%;height:50%}#diamonds-direct .InfluenceHauteofftherack .ipBody .ipRow2 .link22{top:0;left:51%;width:49%;height:100%}#diamonds-direct .InfluenceHauteofftherack .ipBody .ipRow2 .link23{top:51%;left:0;width:50%;height:49%}#diamonds-direct .InfluenceHauteofftherack .ipBody .ipRow2 .link21m,#diamonds-direct .InfluenceHauteofftherack .ipBody .ipRow3 .link31,#diamonds-direct .InfluenceHauteofftherack .ipBody .ipRow4 .link41,#diamonds-direct .InfluenceHauteofftherack .ipBody .ipRow5 .link51{top:0;left:0;width:100%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody{margin-top:0}@media (max-width:1200px){#diamonds-direct .InfluenceAubreyalley .ipBody{margin-top:0}}@media (max-width:768px){#diamonds-direct .InfluenceAubreyalley .ipBody{margin-top:0}}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow1 .link11{top:0;left:0;width:45%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow1 .link11m{top:0;left:0;width:100%;height:70%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow2 .link21{top:30%;left:0;width:45%;height:69%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow2 .link22{top:0;left:46%;width:25%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow2 .link23{top:0;left:74%;width:25%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow2 .link21m{top:0;left:0;width:100%;height:39%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow2 .link22m{top:40%;left:0;width:49%;height:59%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow2 .link23m{top:40%;left:50%;width:50%;height:59%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow3 .link31{top:0;left:0;width:30%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow3 .link32{top:0;left:37%;width:30%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow3 .link33{top:0;left:69%;width:30%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow3 .link31m{top:0;left:0;width:100%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow4 .link41{top:50%;left:0;width:30%;height:49%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow4 .link42{top:50%;left:33%;width:28%;height:49%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow4 .link43{top:0;left:63%;width:37%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow4 .link41m{top:0;left:0;width:49%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow4 .link42m{top:0;left:50%;width:50%;height:99%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow5 .link51{top:0;left:0;width:63%;height:100%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow5 .link52{top:0;left:64%;width:36%;height:100%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow5 .link51m{top:30%;left:0;width:43%;height:35%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow5 .link52m{top:66%;left:0;width:43%;height:33%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow5 .link53m{top:30%;left:44%;width:56%;height:69%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow6 .link61m{top:0;left:0;width:100%;height:39%}#diamonds-direct .InfluenceAubreyalley .ipBody .ipRow6 .link62m{top:40%;left:0;width:100%;height:59%}#diamonds-direct .InfluenceMeganrunionmcr .ipHeader .linkH1{top:0;left:45%;width:55%;height:99%}#diamonds-direct .InfluenceMeganrunionmcr .ipHeader .linkH1m{top:0;left:0;width:100%;height:99%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow1 .link11{top:0;left:0;width:34%;height:99%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow1 .link12{top:0;left:35%;width:65%;height:39%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow1 .link14{top:40%;left:35%;width:65%;height:59%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow1 .link11m{top:0;left:0;width:100%;height:99%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow2 .link21{top:0;left:0;width:66%;height:42%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow2 .link22{top:43%;left:0;width:30%;height:59%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow2 .link23{top:43%;left:35%;width:30%;height:59%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow2 .link24{top:0;left:67%;width:33%;height:99%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow2 .link21m{top:0;left:0;width:100%;height:39%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow2 .link23m{top:40%;left:0;width:100%;height:59%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow3 .link31m{top:0;left:0;width:100%;height:39%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow3 .link32m{top:40%;left:0;width:49%;height:59%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow3 .link33m{top:40%;left:50%;width:50%;height:59%}#diamonds-direct .InfluenceMeganrunionmcr .ipBody .ipRow4 .link41m{top:0;left:0;width:100%;height:99%}#diamonds-direct .Locations{font-family:Lato,sans-serif}#diamonds-direct .Locations .locations-wrapper{overflow:auto;background-image:url(\"https://ddw2.diamondsdirect.com/img/locations/largemapbg2.jpg\");background-repeat:no-repeat;background-size:cover;background-position:50%}#diamonds-direct .Locations .map-wrapper{position:relative;margin:25px auto;width:70%;max-width:700px}#diamonds-direct .Locations .map-wrapper img{display:block;width:100%}#diamonds-direct .Locations .appointmentButtonWrapper{margin:25px 0;text-align:center}#diamonds-direct .Locations .appointmentButtonWrapper .appointmentButton{display:inline-block;border:1px solid #fff;font-size:14px;font-weight:300;text-transform:uppercase;color:#fff;cursor:pointer;background:rgba(0,0,0,.4);padding:10px 35px;transition:background .25s ease-in-out 0ms}#diamonds-direct .Locations .appointmentButtonWrapper .appointmentButton:hover{background:rgba(0,0,0,.7)}#diamonds-direct .Locations .map-location-wrapper{position:absolute;cursor:pointer;min-height:12px;min-width:12px}@media (max-width:480px){#diamonds-direct .Locations .map-location-wrapper{min-width:6px;min-height:6px}}#diamonds-direct .Locations .map-location-wrapper:hover .store-label{display:block}@media (max-width:480px){#diamonds-direct .Locations .map-location-wrapper:hover .store-label{display:none}}#diamonds-direct .Locations .map-location-wrapper:hover .store-marker{border-bottom-color:#fff}#diamonds-direct .Locations .map-location-wrapper:hover .store-marker:after{border-top-color:#fff}#diamonds-direct .Locations .map-location-wrapper:hover .store-circle-marker{background-color:#fff}#diamonds-direct .Locations .map-location-wrapper.double-wrapper{cursor:default}#diamonds-direct .Locations .marker-wrapper{position:absolute;overflow:hidden;left:0;bottom:0;width:12px;height:12px}@media (max-width:480px){#diamonds-direct .Locations .marker-wrapper{width:6px;height:6px}}#diamonds-direct .Locations #marker-austin{bottom:17%;left:47%}#diamonds-direct .Locations #marker-birmingham{bottom:31%;left:68.5%}#diamonds-direct .Locations #marker-charleston{bottom:31%;left:82.5%}#diamonds-direct .Locations #marker-clt{bottom:38.8%;left:80%}#diamonds-direct .Locations #marker-cleveland{bottom:62.8%;left:76%}#diamonds-direct .Locations #marker-columbus{bottom:57.5%;left:73.8%}#diamonds-direct .Locations #marker-dallas{bottom:25%;left:49%}#diamonds-direct .Locations #marker-indy{bottom:55%;left:68%}#diamonds-direct .Locations #marker-kansas-city{bottom:49.7%;left:52.6%}#diamonds-direct .Locations #marker-nol{bottom:15.6%;left:62.9%}#diamonds-direct .Locations #marker-okc{bottom:36%;left:47%}#diamonds-direct .Locations #marker-pit{bottom:61%;left:80%}#diamonds-direct .Locations #marker-hou{bottom:13.5%;left:51%}#diamonds-direct .Locations #marker-raleigh{bottom:42.5%;left:83%}#diamonds-direct .Locations #marker-richmond{bottom:50%;left:85%}#diamonds-direct .Locations #marker-stl{bottom:48.5%;left:60.5%}#diamonds-direct .Locations #marker-slc{bottom:59%;left:22%}#diamonds-direct .Locations #marker-san{bottom:14%;left:45%}#diamonds-direct .Locations #marker-vab{bottom:48%;left:87.5%}#diamonds-direct .Locations #marker-boc{bottom:7%;left:84.3%}#diamonds-direct .Locations #marker-globaldiamonds{bottom:19.2%;left:80.1%}#diamonds-direct .Locations #marker-gsc{bottom:36.5%;left:77%}#diamonds-direct .Locations #marker-cle{bottom:62.7%;left:76%}#diamonds-direct .Locations #marker-nva{bottom:54.3%;left:85%}#diamonds-direct .Locations #marker-try{bottom:65.5%;left:72.8%}#diamonds-direct .Locations .store-circle-marker{width:10px;height:10px;border-radius:50%;background-color:#bf98c3}@media (max-width:480px){#diamonds-direct .Locations .store-circle-marker{width:6px;height:6px;border-radius:50%;background-color:#bf98c3}}#diamonds-direct .Locations .store-marker{width:0;height:0;border:6px solid transparent;border-bottom-color:#bf98c3;position:relative;top:-6px}@media (max-width:480px){#diamonds-direct .Locations .store-marker{border:3px solid transparent;border-bottom-color:#bf98c3;top:-3px}}#diamonds-direct .Locations .store-marker:after{content:\"\";position:absolute;left:-6px;top:6px;width:0;height:0;border:6px solid transparent;border-top-color:#bf98c3}@media (max-width:480px){#diamonds-direct .Locations .store-marker:after{left:-3px;top:3px;border:3px solid transparent;border-top-color:#bf98c3}}#diamonds-direct .Locations .store-label{position:relative;overflow:hidden;display:none;left:0;bottom:0;margin:0 0 0 16px;padding:5px 12px;border:1px solid hsla(0,0%,95%,.7);background:#000;opacity:.8;text-align:center;color:#fff;z-index:1}@media (max-width:480px){#diamonds-direct .Locations .store-label{margin:0 0 0 12px}}#diamonds-direct .Locations .store-label .store-name{font-size:14px;font-weight:900}#diamonds-direct .Locations .store-label .store-link{font-size:12px;font-weight:300}#diamonds-direct .Locations .store-label .store-link:hover{cursor:pointer;color:#bf98c3}#diamonds-direct .Locations .store-label .store-link:active{color:#98799c}#diamonds-direct .Locations .horizontal-rule{width:100%;height:0;margin:3px auto;border-top:1px solid hsla(0,0%,95%,.7)}#diamonds-direct .Locations .locations-grid{overflow:auto;background:#fff;padding-bottom:20px}#diamonds-direct .Locations .block-link-section{position:relative;overflow:auto;top:0;left:100px;width:calc(100% - 185px);margin:50px 0 0;cursor:pointer}@media (max-width:768px){#diamonds-direct .Locations .block-link-section{top:0;left:60px;width:calc(100% - 105px)}}@media (max-width:600px){#diamonds-direct .Locations .block-link-section{top:0;left:40px;width:calc(100% - 65px)}}#diamonds-direct .Locations .block-link{text-decoration:none;display:block;width:calc(25% - 15px);margin:0 15px 15px 0;float:left}@media (max-width:1024px){#diamonds-direct .Locations .block-link{width:calc(33% - 15px);margin:0 15px 15px 0}}@media (max-width:600px){#diamonds-direct .Locations .block-link{width:calc(50% - 10px);margin:0 10px 10px 0}}#diamonds-direct .Locations .location-block{overflow:auto;display:block;height:80px;line-height:80px;background:#f4f5f7;text-align:center;text-transform:uppercase;font-size:16px;font-weight:700;color:#95989a;transition:font-size .35s linear 0ms}@media (max-width:900px){#diamonds-direct .Locations .location-block{font-size:14px}}@media (max-width:768px){#diamonds-direct .Locations .location-block{font-size:12px}}#diamonds-direct .Locations .location-block:hover{background:#bf98c3;color:#fff}#diamonds-direct .Locations .location-block:active{background:#98799c;color:#fff}#diamonds-direct .Locations .block-header{margin:20px 0 0;height:20px;line-height:20px}#diamonds-direct .Locations .block-subheader{height:20px;line-height:20px;padding:0 10px;font-size:12px;font-weight:300}@media (max-width:768px){#diamonds-direct .Locations .block-subheader{font-size:10px}}#diamonds-direct .Locations .locationsFooter{background:#4b2d53;color:#fff;font-weight:400;text-align:center;padding:20px 0;font-size:22px}#diamonds-direct .Locations .locationsFooter .footerLine{display:inline-block;width:auto}#diamonds-direct .Locations .locationsFooter .footerButton{display:inline-block;width:auto;font-weight:300;text-transform:uppercase;vertical-align:middle;border:1px solid #fff;margin:0 0 0 10px;padding:3px 10px;font-size:18px;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Locations .locationsFooter .footerButton:hover{color:#4b2d53;background:#fff}#diamonds-direct .Locations .locationsFooter .footerButton a{color:#fff;text-decoration:none}#diamonds-direct .Locations .locationsFooter .footerButton a:active,#diamonds-direct .Locations .locationsFooter .footerButton a:visited{color:#fff}#diamonds-direct .Locations .locationsFooter .footerButton a:hover{color:#4b2d53}#diamonds-direct .December2018{font-family:Lato,sans-serif;background:#1b464c;padding:0 0 30px}#diamonds-direct .December2018 .promoBanner{width:100%;position:relative}#diamonds-direct .December2018 .promoBanner .phoneLinkOverlay{position:absolute;bottom:10.5%;left:32%;width:11%;height:5%}@media (max-width:600px){#diamonds-direct .December2018 .promoBanner .phoneLinkOverlay{bottom:3.5%;left:62%;width:20%;height:4%}}#diamonds-direct .December2018 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .December2018 .promoBanner img.desktop600{display:none}}#diamonds-direct .December2018 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .December2018 .promoBanner img.mobile600{display:block}}#diamonds-direct .December2018 .promoBody{padding:0 0 20px;background:#fff;text-align:center;margin:0 auto;width:80%;max-width:700px}#diamonds-direct .December2018 .promoBody .promoText{margin:0 10%;padding:20px 0;font-weight:400;font-size:24px;color:#4d4d4d;font-family:Lusitana,serif}@media (max-width:768px){#diamonds-direct .December2018 .promoBody .promoText{font-size:16px}}#diamonds-direct .December2018 .promoBody .promoActionBox{margin:0 auto;width:70%;max-width:500px;border:1px solid #d5b557}#diamonds-direct .December2018 .promoBody .promoActionBox .boxTitle{color:#1b464c;font-size:30px;font-weight:700;margin:10px 20px 0}@media (max-width:768px){#diamonds-direct .December2018 .promoBody .promoActionBox .boxTitle{font-size:22px}}#diamonds-direct .December2018 .promoBody .promoActionBox .boxDisclaimer{color:#4d4d4d;font-size:20px;font-weight:300}@media (max-width:768px){#diamonds-direct .December2018 .promoBody .promoActionBox .boxDisclaimer{font-size:14px}}#diamonds-direct .December2018 .promoBody .promoActionBox .boxDisclaimer2{color:#4d4d4d;font-size:14px;font-weight:300;margin:15px 0 20px}@media (max-width:768px){#diamonds-direct .December2018 .promoBody .promoActionBox .boxDisclaimer2{font-size:12px}}#diamonds-direct .December2018 .promoBody .promoActionBox .boxDates{color:#4d4d4d;margin:10px 0 0;font-size:24px;font-weight:300}@media (max-width:768px){#diamonds-direct .December2018 .promoBody .promoActionBox .boxDates{font-size:20px}}#diamonds-direct .December2018 .promoBody .promoActionBox .boxButton{display:inline-block;width:auto;margin:20px 0 0;color:#1b464c;background:#d5b557;padding:10px 20px;text-transform:uppercase;font-size:14px;font-weight:400;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .December2018 .promoBody .promoActionBox .boxButton:hover{background:#ddc376}#diamonds-direct .December2018 .promoBody .promoActionBox .boxButton:action{background:#e5d196}#diamonds-direct .December2018 .promoBody .specialHoursTitle{color:#551266;margin:20px 0 0;font-weight:700;font-size:20px}#diamonds-direct .December2018 .promoBody .specialHoursInfo{color:#4d4d4d;margin:5px 10px 0;padding:0 0 15px;font-weight:300;font-size:20px}@media (max-width:768px){#diamonds-direct .December2018 .promoBody .specialHoursInfo{font-size:16px}}#diamonds-direct .December2018 .promoBody .promoHighlightSection{margin:0 0 25px;color:#d5b557;font-size:46px;font-weight:900}#diamonds-direct .December2018 .summerLocationBlock{margin:0 auto 50px;text-align:center}#diamonds-direct .December2018 .summerLocationItem{position:relative;display:inline-block;vertical-align:top;width:calc(50% - 25px);margin:40px 10px 0}#diamonds-direct .December2018 .summerDates{position:relative;color:#d5b557;border-bottom:1px solid #4d4d4d;font-size:32px;font-weight:900;padding:0 0 8px;margin:0 0 8px}#diamonds-direct .December2018 .summerLocations{font-size:22px}#diamonds-direct .December2018 .link-em{font-weight:900;font-size:22px;color:#d5b557}#diamonds-direct .December2018 a.holiday-location-link{font-weight:300;color:#4d4d4d;text-decoration:none;cursor:pointer;transition:color .15s ease-in-out}#diamonds-direct .December2018 a.holiday-location-link:active,#diamonds-direct .December2018 a.holiday-location-link:hover{color:#d5b557}#diamonds-direct .December2018 .holiday-button-wrapper{margin:30px 0}#diamonds-direct .December2018 .holiday-button-wrapper a{text-decoration:none}#diamonds-direct .December2018 .dislaimerLine{text-align:center;margin:20px 0 5px;font-size:16px;font-weight:300}@media (max-width:900px){#diamonds-direct .December2018 .summerLocations{font-size:18px}}@media (max-width:768px){#diamonds-direct .December2018 .holiday-mid-banner{font-size:36px;margin:0 0 20px}#diamonds-direct .December2018 .holiday-text{font-size:22px;margin:0 0 20px}#diamonds-direct .December2018 .summerLocationItem{width:80%;margin:40px 0 0}#diamonds-direct .December2018 .summerLocations{font-size:20px}#diamonds-direct .December2018 .link-em{font-size:22px}}@media (max-width:480px){#diamonds-direct .December2018 .holiday-mid-banner{font-size:36px;margin:0 0 15px}#diamonds-direct .December2018 .holiday-text{font-size:18px;margin:0 0 15px}#diamonds-direct .December2018 .summerLocationItem{width:90%;margin:25px 0 0}#diamonds-direct .December2018 .summerDates{font-size:26px}#diamonds-direct .December2018 .summerLocations{font-size:16px}#diamonds-direct .December2018 .link-em{font-size:18px}}#diamonds-direct .Holiday2018{font-family:Lato,sans-serif}#diamonds-direct .Holiday2018 .promoBanner{width:100%}#diamonds-direct .Holiday2018 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Holiday2018 .promoBanner img.desktop600{display:none}}#diamonds-direct .Holiday2018 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Holiday2018 .promoBanner img.mobile600{display:block}}#diamonds-direct .Holiday2018 .promoBody{padding:0 0 20px;background:#fff;color:#4d4d4d;text-align:center;margin:0 auto;width:80%;max-width:700px}#diamonds-direct .Holiday2018 .promoBody .promoText{margin:0 10%;padding:20px 0;font-weight:300;font-size:24px;color:#4d4d4d}@media (max-width:768px){#diamonds-direct .Holiday2018 .promoBody .promoText{font-size:16px}}#diamonds-direct .Holiday2018 .promoBody .promoActionBox{margin:0 auto;width:70%;max-width:500px;border:1px solid #b3b3b3}#diamonds-direct .Holiday2018 .promoBody .promoActionBox .boxTitle{color:#551266;font-size:30px;font-weight:700;margin:10px 20px 0}@media (max-width:768px){#diamonds-direct .Holiday2018 .promoBody .promoActionBox .boxTitle{font-size:22px}}#diamonds-direct .Holiday2018 .promoBody .promoActionBox .boxDisclaimer{color:#4d4d4d;font-size:20px;font-weight:100}@media (max-width:768px){#diamonds-direct .Holiday2018 .promoBody .promoActionBox .boxDisclaimer{font-size:14px}}#diamonds-direct .Holiday2018 .promoBody .promoActionBox .boxDates{color:#4d4d4d;margin:10px 0 0;font-size:24px;font-weight:300}@media (max-width:768px){#diamonds-direct .Holiday2018 .promoBody .promoActionBox .boxDates{font-size:20px}}#diamonds-direct .Holiday2018 .promoBody .promoActionBox .boxButton{display:inline-block;width:auto;margin:20px 0 25px;color:#fff;background:#370a42;padding:10px 20px;text-transform:uppercase;font-size:14px;font-weight:300;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Holiday2018 .promoBody .promoActionBox .boxButton:hover{background:#551266}#diamonds-direct .Holiday2018 .promoBody .promoActionBox .boxButton:action{background:#631577}#diamonds-direct .Holiday2018 .promoBody .specialHoursTitle{color:#551266;margin:20px 0 0;font-weight:700;font-size:20px}#diamonds-direct .Holiday2018 .promoBody .specialHoursInfo{color:#4d4d4d;margin:5px 10px 0;padding:0 0 15px;font-weight:300;font-size:20px}@media (max-width:768px){#diamonds-direct .Holiday2018 .promoBody .specialHoursInfo{font-size:16px}}#diamonds-direct .Holiday2018 .promoBody .promoHighlightSection{margin:0 0 25px;color:#8e78a4;font-size:46px;font-weight:900}#diamonds-direct .Holiday2018 .summerLocationBlock{margin:0 auto 50px;text-align:center}#diamonds-direct .Holiday2018 .summerLocationItem{position:relative;display:inline-block;vertical-align:top;width:calc(50% - 25px);margin:40px 10px 0}#diamonds-direct .Holiday2018 .summerDates{position:relative;color:#8e78a4;border-bottom:1px solid #4d4d4d;font-size:32px;font-weight:900;padding:0 0 8px;margin:0 0 8px}#diamonds-direct .Holiday2018 .summerLocations{font-size:22px}#diamonds-direct .Holiday2018 .link-em{font-weight:900;font-size:22px;color:#8e78a4}#diamonds-direct .Holiday2018 a.holiday-location-link{font-weight:300;color:#4d4d4d;text-decoration:none;cursor:pointer;transition:color .15s ease-in-out}#diamonds-direct .Holiday2018 a.holiday-location-link:active,#diamonds-direct .Holiday2018 a.holiday-location-link:hover{color:#8e78a4}#diamonds-direct .Holiday2018 .holiday-button-wrapper{margin:30px 0}#diamonds-direct .Holiday2018 .holiday-button-wrapper a{text-decoration:none}#diamonds-direct .Holiday2018 .dislaimerLine{text-align:center;margin:20px 0 5px;font-size:16px;font-weight:300}@media (max-width:900px){#diamonds-direct .Holiday2018 .summerLocations{font-size:18px}}@media (max-width:768px){#diamonds-direct .Holiday2018 .holiday-mid-banner{font-size:36px;margin:0 0 20px}#diamonds-direct .Holiday2018 .holiday-text{font-size:22px;margin:0 0 20px}#diamonds-direct .Holiday2018 .summerLocationItem{width:80%;margin:40px 0 0}#diamonds-direct .Holiday2018 .summerLocations{font-size:20px}#diamonds-direct .Holiday2018 .link-em{font-size:22px}}@media (max-width:480px){#diamonds-direct .Holiday2018 .holiday-mid-banner{font-size:36px;margin:0 0 15px}#diamonds-direct .Holiday2018 .holiday-text{font-size:18px;margin:0 0 15px}#diamonds-direct .Holiday2018 .summerLocationItem{width:90%;margin:25px 0 0}#diamonds-direct .Holiday2018 .summerDates{font-size:26px}#diamonds-direct .Holiday2018 .summerLocations{font-size:16px}#diamonds-direct .Holiday2018 .link-em{font-size:18px}}#diamonds-direct .Valentines2019{font-family:Lato,sans-serif;background:#fffafd;overflow:auto}#diamonds-direct .Valentines2019 .promoBanner{width:100%}#diamonds-direct .Valentines2019 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Valentines2019 .promoBanner img.desktop600{display:none}}#diamonds-direct .Valentines2019 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Valentines2019 .promoBanner img.mobile600{display:block}}#diamonds-direct .Valentines2019 .promoBody{background:#fff;color:#4d4d4d;text-align:center;box-shadow:10px 10px 0 rgba(223,205,229,.6);overflow:auto;margin:0 auto 40px;width:80%;max-width:900px}#diamonds-direct .Valentines2019 .promoBody .promoBodyInner{margin:10px;border:1px solid #eaeaea}#diamonds-direct .Valentines2019 .promoBody .promoWarningText{margin:0 10%;padding:25px 0 0;font-weight:400;font-size:18px;color:#960c3a;font-family:Lusitana,serif}@media (max-width:768px){#diamonds-direct .Valentines2019 .promoBody .promoWarningText{font-size:14px;padding:20px 0 0}}#diamonds-direct .Valentines2019 .promoBody .promoText{margin:0 10%;padding:20px 75px;font-weight:300;font-size:24px;color:#4d4d4d}@media (max-width:768px){#diamonds-direct .Valentines2019 .promoBody .promoText{font-size:16px;padding:20px}}#diamonds-direct .Valentines2019 .promoBody .promoText .light-em{font-weight:400}#diamonds-direct .Valentines2019 .promoBody .promoText .color-em{font-weight:400;color:#960c3a}#diamonds-direct .Valentines2019 .promoBody .promoActionBox{margin:20px auto;width:70%;max-width:500px;border:1px solid #e95a80}#diamonds-direct .Valentines2019 .promoBody .promoActionBox .boxTitle{color:#960c3a;font-size:36px;font-weight:900;margin:10px 20px 0}@media (max-width:768px){#diamonds-direct .Valentines2019 .promoBody .promoActionBox .boxTitle{font-size:22px}}#diamonds-direct .Valentines2019 .promoBody .promoActionBox .boxDisclaimer{color:#4d4d4d;font-size:20px;font-weight:300}@media (max-width:768px){#diamonds-direct .Valentines2019 .promoBody .promoActionBox .boxDisclaimer{font-size:14px}}#diamonds-direct .Valentines2019 .promoBody .promoActionBox .boxDates{color:#4d4d4d;margin:10px 0 0;font-size:28px;font-weight:300}@media (max-width:768px){#diamonds-direct .Valentines2019 .promoBody .promoActionBox .boxDates{font-size:20px}}#diamonds-direct .Valentines2019 .promoBody .promoActionBox .boxButton{display:inline-block;width:auto;margin:20px 0 25px;color:#960c3a;background:#fff;border:2px solid #960c3a;padding:10px 20px;text-transform:uppercase;font-size:14px;font-weight:700;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Valentines2019 .promoBody .promoActionBox .boxButton:active,#diamonds-direct .Valentines2019 .promoBody .promoActionBox .boxButton:hover{background:#960c3a;color:#fff}@media (max-width:768px){#diamonds-direct .Valentines2019 .promoBody .promoActionBox .boxButton{border:1px solid #960c3a;font-size:12px;padding:10px}}#diamonds-direct .Valentines2019 .promoBody .specialHoursTitle{color:#551266;margin:20px 0 0;font-weight:700;font-size:20px}#diamonds-direct .Valentines2019 .promoBody .specialHoursInfo{color:#4d4d4d;margin:5px 10px 0;padding:0 0 15px;font-weight:300;font-size:20px}@media (max-width:768px){#diamonds-direct .Valentines2019 .promoBody .specialHoursInfo{font-size:16px}}#diamonds-direct .Valentines2019 .promoBody .promoHighlightSection{margin:0 0 25px;color:#8e78a4;font-size:46px;font-weight:900}#diamonds-direct .Valentines2019 .summerLocationBlock{margin:0 auto 50px;padding:0;text-align:center}@media (max-width:768px){#diamonds-direct .Valentines2019 .summerLocationBlock{padding:0}}#diamonds-direct .Valentines2019 .summerLocationItem{position:relative;display:inline-block;vertical-align:top;width:calc(50% - 100px);margin:40px 10px 0}#diamonds-direct .Valentines2019 .summerDates{position:relative;color:#8e78a4;border-bottom:1px solid #d29cad;font-size:32px;font-weight:900;padding:0 0 2px;margin:0 0 8px}#diamonds-direct .Valentines2019 .summerDates img{height:35px}#diamonds-direct .Valentines2019 .summerLocations{font-size:18px}#diamonds-direct .Valentines2019 .link-em{font-weight:900;font-size:20px;color:#960c3a}#diamonds-direct .Valentines2019 a.holiday-location-link{font-weight:300;color:#4d4d4d;text-decoration:none;cursor:pointer;transition:color .15s ease-in-out}#diamonds-direct .Valentines2019 a.holiday-location-link:active,#diamonds-direct .Valentines2019 a.holiday-location-link:hover{color:#960c3a}#diamonds-direct .Valentines2019 .holiday-button-wrapper{margin:30px 0}#diamonds-direct .Valentines2019 .holiday-button-wrapper a{text-decoration:none}#diamonds-direct .Valentines2019 .dislaimerLine{text-align:center;margin:20px 0 5px;font-size:16px;font-weight:300}@media (max-width:900px){#diamonds-direct .Valentines2019 .summerLocations{font-size:14px}#diamonds-direct .Valentines2019 .link-em{font-size:16px}}@media (max-width:768px){#diamonds-direct .Valentines2019 .holiday-mid-banner{font-size:36px;margin:0 0 20px}#diamonds-direct .Valentines2019 .holiday-text{font-size:22px;margin:0 0 20px}#diamonds-direct .Valentines2019 .summerLocationItem{width:80%;margin:40px 0 0}#diamonds-direct .Valentines2019 .summerLocations{font-size:20px}#diamonds-direct .Valentines2019 .link-em{font-size:22px}}@media (max-width:480px){#diamonds-direct .Valentines2019 .holiday-mid-banner{font-size:36px;margin:0 0 15px}#diamonds-direct .Valentines2019 .holiday-text{font-size:18px;margin:0 0 15px}#diamonds-direct .Valentines2019 .summerLocationItem{width:90%;margin:25px 0 0}#diamonds-direct .Valentines2019 .summerDates{font-size:26px}#diamonds-direct .Valentines2019 .summerLocations{font-size:16px}#diamonds-direct .Valentines2019 .link-em{font-size:18px}}#diamonds-direct .Spring2019{background:#fae8e8;overflow:auto}#diamonds-direct .Spring2019 .promoBanner{width:100%}#diamonds-direct .Spring2019 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBanner img.desktop600{display:none}}#diamonds-direct .Spring2019 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBanner img.mobile600{display:block}}#diamonds-direct .Spring2019 .promoBody{position:relative;background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/spring2019/banner.jpg\");background-color:#fae8e8;background-position:top;background-repeat:no-repeat;background-size:contain;padding-top:34%}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBody{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/spring2019/banner_mobile.jpg\");padding-top:116%}}#diamonds-direct .Spring2019 .promoBodyInner{position:relative;background:#fff;color:#4d4d4e;text-align:center;box-shadow:10px 10px 0 #e0acbb;overflow:auto;margin:0 auto 40px;width:80%;max-width:900px}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBodyInner{width:90%}}#diamonds-direct .Spring2019 .promoBodyInner .promoTitle{margin:0 10%;font-size:48px;font-weight:700;font-family:Lusitana,serif;color:#936;text-align:center}@media (max-width:768px){#diamonds-direct .Spring2019 .promoBodyInner .promoTitle{font-size:32px}}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBodyInner .promoTitle{font-size:26px}}#diamonds-direct .Spring2019 .promoBodyInner .promoText{margin:30px 10% 0;padding:20px 25px;font-weight:400;font-size:24px;color:#4d4d4e;font-family:Lato,sans-serif}@media (max-width:768px){#diamonds-direct .Spring2019 .promoBodyInner .promoText{font-size:16px;padding:20px}}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBodyInner .promoText{margin:15px 5% 0;font-size:16px;padding:10px 5px}}#diamonds-direct .Spring2019 .promoBodyInner .promoText .light-em{font-weight:400}#diamonds-direct .Spring2019 .promoBodyInner .promoText .color-em{font-weight:400;color:#936}#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock{margin:20px 140px 50px;font-family:Lato,sans-serif}@media (max-width:1200px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock{margin:20px 50px 50px}}@media (max-width:900px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock{margin:25px}}@media (max-width:768px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock{margin:10px 0}}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock{margin:10px 0}}#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem{display:block;margin:0 0 20px;overflow:hidden}#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{display:inline-block;width:170px;padding:0 22px 0 0;height:60px;line-height:60px;font-size:28px;font-weight:700;text-align:right;border-right:3px solid #936;vertical-align:top}@media (max-width:900px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{width:150px;font-size:22px;padding:0 12px 0 0;height:50px;line-height:50px}}@media (max-width:768px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{font-size:18px;width:100px;padding:0 7px 0 0}}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{font-size:20px;width:auto;padding:0 5px 0 0;border-right:none;border-bottom:2px solid #936;height:25px;line-height:25px;margin:0 0 10px}}#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations.singleLine{line-height:60px}@media (max-width:900px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations.singleLine{line-height:50px}}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations.singleLine{height:20px;line-height:20px}}#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{display:inline-block;width:calc(100% - 220px);height:60px;line-height:27px;vertical-align:top;text-align:left;padding:0 0 0 20px}@media (max-width:900px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{padding:0 0 0 10px;line-height:22px;width:calc(100% - 175px)}}@media (max-width:768px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{padding:0 0 0 5px;font-size:18px;width:calc(100% - 175px)}}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{padding:0;line-height:19px;width:100%;text-align:center}}#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{text-decoration:none;color:#4d4d4e;cursor:pointer;font-size:20px;transition:color .25s ease-in-out 0ms}@media (max-width:900px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:18px}}@media (max-width:768px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:16px}}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:13px}}#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link:hover{color:#936}#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{color:#bf7e90;font-weight:700;font-size:22px}@media (max-width:900px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:20px}}@media (max-width:768px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:18px}}@media (max-width:600px){#diamonds-direct .Spring2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:14px}}#diamonds-direct .Spring2019 .promoLegal{text-align:center;font-size:20px;font-weight:300;color:#936;font-family:Lato,sans-serif;margin:-15px 10px 30px}@media (max-width:768px){#diamonds-direct .Spring2019 .promoLegal{font-size:18px}}@media (max-width:600px){#diamonds-direct .Spring2019 .promoLegal{font-size:16px}}#diamonds-direct .Mothers2019{font-family:Lato,sans-serif;background:#fffafd;overflow:auto}#diamonds-direct .Mothers2019 .promoBanner{width:100%}#diamonds-direct .Mothers2019 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Mothers2019 .promoBanner img.desktop600{display:none}}#diamonds-direct .Mothers2019 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Mothers2019 .promoBanner img.mobile600{display:block}}#diamonds-direct .Mothers2019 .promoBody{background:#fff;color:#4d4d4d;text-align:center;overflow:auto;margin:0;border-bottom:3px solid #bfc5db}#diamonds-direct .Mothers2019 .promoBody .mothersLegal{color:gray;text-align:left;font-size:14px;margin:20px 50px 0}#diamonds-direct .Mothers2019 .promoBody .mothersLegal a{color:gray;text-decoration:none}@media (max-width:600px){#diamonds-direct .Mothers2019 .promoBody .mothersLegal{margin:20px 20px 0;font-size:11px}}#diamonds-direct .Mothers2019 .promoBody .promoText{margin:30px 20% 0;font-weight:400;font-size:22px;color:#541b75}@media (max-width:768px){#diamonds-direct .Mothers2019 .promoBody .promoText{font-size:16px;margin:30px 10% 0}}#diamonds-direct .Mothers2019 .promoBody .promoActionBox{margin:30px auto;width:70%;max-width:500px;border:1px solid #bfc5db}#diamonds-direct .Mothers2019 .promoBody .promoActionBox .boxTitle{color:#541b75;font-size:36px;font-weight:900;margin:20px 20px 0}@media (max-width:768px){#diamonds-direct .Mothers2019 .promoBody .promoActionBox .boxTitle{font-size:22px}}#diamonds-direct .Mothers2019 .promoBody .promoActionBox .boxDisclaimer{color:#120b13;font-size:20px;font-weight:300}@media (max-width:768px){#diamonds-direct .Mothers2019 .promoBody .promoActionBox .boxDisclaimer{font-size:14px}}#diamonds-direct .Mothers2019 .promoBody .promoActionBox .boxDates{color:gray;margin:10px 0 0;font-size:28px;font-weight:700}@media (max-width:768px){#diamonds-direct .Mothers2019 .promoBody .promoActionBox .boxDates{font-size:20px}}#diamonds-direct .Mothers2019 .promoBody .promoActionBox .boxButton{display:inline-block;width:auto;margin:20px 0 25px;color:#fff;background:#541b75;padding:10px 20px;text-transform:uppercase;font-size:14px;font-weight:700;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Mothers2019 .promoBody .promoActionBox .boxButton:active,#diamonds-direct .Mothers2019 .promoBody .promoActionBox .boxButton:hover{background:#2b0e3c;color:#fff}@media (max-width:768px){#diamonds-direct .Mothers2019 .promoBody .promoActionBox .boxButton{font-size:12px;padding:10px}}#diamonds-direct .Mothers2019 .promoBody .specialHoursTitle{color:#551266;margin:20px 0 0;font-weight:700;font-size:20px}#diamonds-direct .Mothers2019 .promoBody .specialHoursInfo{color:#4d4d4d;margin:5px 10px 0;padding:0 0 15px;font-weight:300;font-size:20px}@media (max-width:768px){#diamonds-direct .Mothers2019 .promoBody .specialHoursInfo{font-size:16px}}#diamonds-direct .Mothers2019 .promoBody .promoHighlightSection{margin:0 0 25px;color:#8e78a4;font-size:46px;font-weight:900}#diamonds-direct .Mothers2019 .summerLocationBlock{margin:0 auto 50px;padding:0;text-align:center}@media (max-width:768px){#diamonds-direct .Mothers2019 .summerLocationBlock{padding:0}}#diamonds-direct .Mothers2019 .summerLocationItem{position:relative;display:inline-block;vertical-align:top;width:calc(50% - 100px);margin:40px 10px 0}#diamonds-direct .Mothers2019 .summerDates{position:relative;color:#8e78a4;border-bottom:1px solid #d29cad;font-size:32px;font-weight:900;padding:0 0 2px;margin:0 0 8px}#diamonds-direct .Mothers2019 .summerDates img{height:35px}#diamonds-direct .Mothers2019 .summerLocations{font-size:18px}#diamonds-direct .Mothers2019 .link-em{font-weight:900;font-size:20px;color:#960c3a}#diamonds-direct .Mothers2019 a.holiday-location-link{font-weight:300;color:#4d4d4d;text-decoration:none;cursor:pointer;transition:color .15s ease-in-out}#diamonds-direct .Mothers2019 a.holiday-location-link:active,#diamonds-direct .Mothers2019 a.holiday-location-link:hover{color:#960c3a}#diamonds-direct .Mothers2019 .holiday-button-wrapper{margin:30px 0}#diamonds-direct .Mothers2019 .holiday-button-wrapper a{text-decoration:none}#diamonds-direct .Mothers2019 .dislaimerLine{text-align:center;margin:20px 0 5px;font-size:16px;font-weight:300}@media (max-width:900px){#diamonds-direct .Mothers2019 .summerLocations{font-size:14px}#diamonds-direct .Mothers2019 .link-em{font-size:16px}}@media (max-width:768px){#diamonds-direct .Mothers2019 .holiday-mid-banner{font-size:36px;margin:0 0 20px}#diamonds-direct .Mothers2019 .holiday-text{font-size:22px;margin:0 0 20px}#diamonds-direct .Mothers2019 .summerLocationItem{width:80%;margin:40px 0 0}#diamonds-direct .Mothers2019 .summerLocations{font-size:20px}#diamonds-direct .Mothers2019 .link-em{font-size:22px}}@media (max-width:480px){#diamonds-direct .Mothers2019 .holiday-mid-banner{font-size:36px;margin:0 0 15px}#diamonds-direct .Mothers2019 .holiday-text{font-size:18px;margin:0 0 15px}#diamonds-direct .Mothers2019 .summerLocationItem{width:90%;margin:25px 0 0}#diamonds-direct .Mothers2019 .summerDates{font-size:26px}#diamonds-direct .Mothers2019 .summerLocations{font-size:16px}#diamonds-direct .Mothers2019 .link-em{font-size:18px}}#diamonds-direct .Summer2019{overflow:auto}#diamonds-direct .Summer2019 .promoBanner{width:100%}#diamonds-direct .Summer2019 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBanner img.desktop600{display:none}}#diamonds-direct .Summer2019 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBanner img.mobile600{display:block}}#diamonds-direct .Summer2019 .promoBody{margin:-60px 0 0}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBody{margin:0}}#diamonds-direct .Summer2019 .promoBodyInner{position:relative;background:#fff;color:#4d4d4e;text-align:center;box-shadow:10px 10px 0 #ba9dbf;overflow:auto;margin:0 auto 40px;width:80%;max-width:900px}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBodyInner{width:90%}}#diamonds-direct .Summer2019 .promoBodyInner .promoText{margin:30px 10% 0;padding:20px 25px;font-weight:400;font-size:22px;color:#4d4d4e;font-family:Lato,sans-serif}@media (max-width:768px){#diamonds-direct .Summer2019 .promoBodyInner .promoText{font-size:16px;padding:20px}}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBodyInner .promoText{margin:15px 5% 0;font-size:16px;padding:10px 5px}}#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock{margin:20px 140px 50px;font-family:Lato,sans-serif}@media (max-width:1200px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock{margin:20px 50px 50px}}@media (max-width:900px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock{margin:25px}}@media (max-width:768px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock{margin:10px 0}}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock{margin:10px 0}}#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem{display:block;margin:0 0 20px;overflow:hidden}#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{position:relative;display:inline-block;width:190px;padding:0;height:60px;text-align:right;border-right:3px solid #ba9dbf;vertical-align:top}@media (max-width:900px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{width:150px;padding:0;height:50px;line-height:50px}}@media (max-width:768px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{font-size:18px;width:100px;padding:0 7px 0 0}}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{font-size:20px;width:150px;padding:0;border-right:none;border-bottom:2px solid #ba9dbf;height:35px;margin:0 0 10px}}#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates img{max-width:85%;max-height:100%;width:auto;height:auto;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates img{height:25px}}#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations.singleLine{line-height:60px}@media (max-width:900px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations.singleLine{line-height:50px}}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations.singleLine{height:20px;line-height:20px}}#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{display:inline-block;width:calc(100% - 220px);height:60px;line-height:27px;vertical-align:top;text-align:left;padding:0 0 0 20px}@media (max-width:900px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{padding:0 0 0 10px;line-height:22px;width:calc(100% - 175px)}}@media (max-width:768px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{padding:0 0 0 5px;font-size:18px;width:calc(100% - 175px)}}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{padding:0;line-height:19px;width:100%;text-align:center}}#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{text-decoration:none;color:#4d4d4e;cursor:pointer;font-size:20px;transition:color .25s ease-in-out 0ms}@media (max-width:900px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:18px}}@media (max-width:768px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:16px}}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:13px}}#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link:hover{color:#ba9dbf}#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{color:#ba9dbf;font-weight:700;font-size:22px}@media (max-width:900px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:20px}}@media (max-width:768px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:18px}}@media (max-width:600px){#diamonds-direct .Summer2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:14px}}#diamonds-direct .Summer2019 .promoLegal{text-align:center;font-size:20px;font-weight:300;color:#ba9dbf;font-family:Lato,sans-serif;margin:-15px 10px 30px}@media (max-width:768px){#diamonds-direct .Summer2019 .promoLegal{font-size:18px}}@media (max-width:600px){#diamonds-direct .Summer2019 .promoLegal{font-size:16px}}#diamonds-direct .Fall2019{overflow:auto;font-family:Lato,sans-serif}#diamonds-direct .Fall2019 .promoBanner{width:100%}#diamonds-direct .Fall2019 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Fall2019 .promoBanner img.desktop600{display:none}}#diamonds-direct .Fall2019 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Fall2019 .promoBanner img.mobile600{display:block}}#diamonds-direct .Fall2019 .promoBody{margin:-12% 0 0}@media (max-width:600px){#diamonds-direct .Fall2019 .promoBody{margin:0}}#diamonds-direct .Fall2019 .promoBody .bodyWrapper{background:#000;overflow:auto}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent{border:1px solid #fff;margin:0 auto 30px;width:80%;position:relative;z-index:1}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .leftBackground{background:#fff;position:absolute;top:0;left:0;bottom:0;width:50%}@media (max-width:600px){#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .leftBackground{bottom:50%;width:100%}}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentLeft{position:relative;display:inline-block;width:50%;height:100%;color:#270642;text-align:center;padding:0 0 20px}@media (max-width:600px){#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentLeft{width:100%}}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentLeft .leftText{color:#000;margin:20px 10% 0;font-size:18px}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentLeft .leftDateTitle{margin:15px 15px 3px;font-weight:900;font-size:24px}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentLeft .leftDate{margin:-2px 15px 0;font-weight:300;font-size:20px}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight{position:relative;display:inline-block;width:50%;vertical-align:top;text-align:center;padding:20px 0}@media (max-width:600px){#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight{width:100%}}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxTitle{color:#fae8aa;font-size:30px;font-weight:700;margin:0 15px}@media (max-width:768px){#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxTitle{font-size:26px}}@media (max-width:480px){#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxTitle{font-size:22px}}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxDisclaimer{color:#fff;font-size:20px;font-weight:300;padding:0 10px}@media (max-width:768px){#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxDisclaimer{font-size:17px}}@media (max-width:480px){#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxDisclaimer{font-size:14px}}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxDates{color:#fff;margin:10px 0 0;font-size:24px;font-weight:300;padding:0 10px}@media (max-width:768px){#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxDates{font-size:20px}}@media (max-width:480px){#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxDates{font-size:20px}}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxButton{display:inline-block;width:auto;margin:20px 0 0;color:#270642;background:#fae8aa;padding:10px 20px;text-transform:uppercase;font-size:14px;font-weight:400;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxButton:action,#diamonds-direct .Fall2019 .promoBody .bodyWrapper .bodyContent .contentRight .boxButton:hover{background:#fbeec3}#diamonds-direct .ContactPage .closeContact,#diamonds-direct .ScheduleAppointment .closeContact{position:absolute;cursor:pointer;background-image:radial-gradient(#b78dbb,#b78dbb);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:10px;right:10px;width:22px;height:22px;border:1px solid #b78dbb;transform:rotate(45deg);transition:background-size .25s ease-in-out 0ms}#diamonds-direct .ContactPage .closeContact:hover,#diamonds-direct .ScheduleAppointment .closeContact:hover{background-size:100% 100%}#diamonds-direct .ContactPage .closeContact:hover .closeX,#diamonds-direct .ScheduleAppointment .closeContact:hover .closeX{color:#ddd}#diamonds-direct .ContactPage .closeContact .closeX,#diamonds-direct .ScheduleAppointment .closeContact .closeX{color:#b78dbb;margin:-1px 0 0 -2px;transform:rotate(-45deg);line-height:22px;text-align:center;font-size:22px;font-weight:300;transition:color .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleSelect,#diamonds-direct .ScheduleAppointment .scheduleSelect{background:#fff;border:1px solid #ddd;margin:1px;width:calc(100% - 3px)}#diamonds-direct .ContactPage .scheduleSelect select,#diamonds-direct .ScheduleAppointment .scheduleSelect select{border:1px solid #fff}#diamonds-direct .ContactPage .scheduleHeader,#diamonds-direct .ScheduleAppointment .scheduleHeader{text-align:center;font-size:40px;padding:3% 0;background:#eee}#diamonds-direct .ContactPage .scheduleBody,#diamonds-direct .ScheduleAppointment .scheduleBody{position:relative;margin:0 auto 25px;width:90%;max-width:800px}#diamonds-direct .ContactPage .scheduleBody .scheduleBr,#diamonds-direct .ScheduleAppointment .scheduleBody .scheduleBr{width:100%;height:70px;margin:-35px auto 5px;background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/ddline.svg\");background-repeat:no-repeat;background-position:50%;background-size:cover}@media (max-width:900px){#diamonds-direct .ContactPage .scheduleBody .scheduleBr,#diamonds-direct .ScheduleAppointment .scheduleBody .scheduleBr{width:80%;height:50px;margin-top:-25px}}@media (max-width:480px){#diamonds-direct .ContactPage .scheduleBody .scheduleBr,#diamonds-direct .ScheduleAppointment .scheduleBody .scheduleBr{width:80%;height:40px;margin-top:-20px}}#diamonds-direct .ContactPage .scheduleBody .sbText,#diamonds-direct .ScheduleAppointment .scheduleBody .sbText{text-align:center;font-size:18px;margin:0 0 15px}#diamonds-direct .ContactPage .scheduleBody .sbText .inlineLink,#diamonds-direct .ScheduleAppointment .scheduleBody .sbText .inlineLink{text-decoration:underline;color:#bf98c3;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbText .inlineLink:hover,#diamonds-direct .ScheduleAppointment .scheduleBody .sbText .inlineLink:hover{color:#b07fb5}#diamonds-direct .ContactPage .scheduleBody .sbPrompt,#diamonds-direct .ScheduleAppointment .scheduleBody .sbPrompt{text-align:center;font-size:32px;margin:10px 0 0}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow{text-align:center;font-family:Lato,sans-serif}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton.selected,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton.selected{background:#b78dbb}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton.selected .sbButtonLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton.selected .sbButtonLabel{color:#fff}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton.selected .jewelryIcon,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton.selected .jewelryIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/shop_a.svg\")}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton.selected .bellIcon,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton.selected .bellIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/bell_a.svg\")}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton.selected .virtualIcon,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton.selected .virtualIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/virtual_a.svg\")}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton{display:inline-block;overflow:auto;cursor:pointer;background:#eee;border:1px solid #bf98c3;width:200px;margin:10px 60px;transition:background .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton:hover,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton:hover{background:#bf98c3}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton:hover .sbButtonLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton:hover .sbButtonLabel{color:#fff}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton:hover .jewelryIcon,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton:hover .jewelryIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/shop_a.svg\")}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton:hover .bellIcon,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton:hover .bellIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/bell_a.svg\")}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton:hover .virtualIcon,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton:hover .virtualIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/virtual_a.svg\")}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton .sbButtonIcon,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton .sbButtonIcon{width:50px;height:50px;margin:10px auto 5px;background-size:contain;background-position:50%;background-repeat:no-repeat}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton .jewelryIcon,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton .jewelryIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/shop_1.svg\")}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton .bellIcon,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton .bellIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/bell.svg\")}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton .virtualIcon,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton .virtualIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/virtual.svg\")}#diamonds-direct .ContactPage .scheduleBody .sbButtonRow .sbButton .sbButtonLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton .sbButtonLabel{margin:8px 0;font-size:16px;font-weight:400;text-transform:uppercase;text-align:center}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper{margin:0 0 20px;transition:height .4s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formHeader,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formHeader{text-align:center;font-size:32px;padding:2% 0;background:#ddd;border-bottom:5px solid #b78dbb}@media (max-width:480px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formHeader,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formHeader{margin:15px 0 0;font-size:24px;padding:2% 10%}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody{overflow-x:auto;overflow-y:hidden;background:#eee;font-family:Lato,sans-serif}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formSubheader,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formSubheader{margin:15px 0;text-align:center}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow.emRow,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow.emRow{background:#ddd;margin:0;padding:10px 0}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow.darkBg,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow.darkBg{background:#ddd;padding:10px 10px 0;margin:0}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow.darkBg.bottomRow,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow.darkBg.bottomRow{padding:10px 10px 20px;margin:0 0 -20px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow.preBanner,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow.preBanner{margin:0 10px 10px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow{margin:10px 10px 0}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .oneHalfSection,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .oneHalfSection{display:inline-block;vertical-align:top;overflow:hidden;margin:0 .5%;width:49%;transition:width .35s linear 0ms,margin .35s linear 0ms}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .oneHalfSection input,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .oneHalfSection input{width:calc(100% - 22px)}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .oneHalfSection,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .oneHalfSection{width:100%;margin:0}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .expandableHalfSection.open,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .expandableHalfSection.open{max-height:70px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .expandableHalfSection,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .expandableHalfSection{height:auto;max-height:0;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .oneThirdSection,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .oneThirdSection{display:inline-block;margin:0 1.5%;width:30.3%;vertical-align:top;transition:width .35s linear 0ms,margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .oneThirdSection,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .oneThirdSection{width:100%;margin:0}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .radioYesNoLabel.error,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .radioYesNoLabel.error{color:#eb3533}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .radioYesNoLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .radioYesNoLabel{font-size:14px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .radioInputRow,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .radioInputRow{font-size:16px;text-align:left}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .radioInputRow .radioInputWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .radioInputRow .radioInputWrapper{margin:8px 40px 0 2px;transition:margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .radioInputRow .radioInputWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .radioInputRow .radioInputWrapper{margin-bottom:10px}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .radioInputWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .radioInputWrapper{display:inline-block;width:auto}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .radioInputWrapper .radioInputElement,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .radioInputWrapper .radioInputElement{display:inline-block;width:20px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .radioInputWrapper .radioLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .radioInputWrapper .radioLabel{display:inline-block;width:auto;margin:0 0 0 8px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .checkboxInputWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .checkboxInputWrapper{display:inline-block;width:auto}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .checkboxInputWrapper .checkboxInputElement,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .checkboxInputWrapper .checkboxInputElement{display:inline-block;width:20px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .checkboxInputWrapper .checkboxLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .checkboxInputWrapper .checkboxLabel{display:inline-block;width:auto}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow input.checkboxInput,#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow input.radioInput,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow input.checkboxInput,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow input.radioInput{width:auto}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow input,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow input{display:inline-block;margin:5px 0;padding:10px;width:calc(100% - 20px);border:1px solid #ddd;outline:none}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow input::-webkit-input-placeholder,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow input::-webkit-input-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow input:-moz-placeholder,#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow input::-moz-placeholder,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow input:-moz-placeholder,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow input::-moz-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow input:-ms-input-placeholder,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow input:-ms-input-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow input.error,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow input.error{border:1px solid #eb3533}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .textareaLabelWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .textareaLabelWrapper{margin:8px 0 0;font-size:14px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .textareaInputWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .textareaInputWrapper{margin:8px 0 0}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow textarea,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow textarea{margin:0;padding:10px;width:calc(100% - 20px);height:75px;border:1px solid #ddd;outline:none}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow textarea::-webkit-input-placeholder,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow textarea::-webkit-input-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow textarea:-moz-placeholder,#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow textarea::-moz-placeholder,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow textarea:-moz-placeholder,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow textarea::-moz-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow textarea:-ms-input-placeholder,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow textarea:-ms-input-placeholder{color:#95989a}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow textarea.error,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow textarea.error{border:2px solid #eb3533;width:calc(100% - 34px)}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .selectWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .selectWrapper{margin-top:4px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .selectWrapper select,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .selectWrapper select{border:none;background:#fff}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .formBody .formRow .submitButton,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .formBody .formRow .submitButton{display:block;width:280px;font-weight:700;padding:10px 0;text-align:center;margin:25px auto;cursor:pointer;font-size:18px;font-weight:400;text-transform:none;height:25px;line-height:25px;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm{position:relative}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper.lightBg .shoppingForPrimary,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper.lightBg .shoppingForPrimary{margin-left:10px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper.lightBg .shoppingForSecondary,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper.lightBg .shoppingForSecondary{margin-left:10px;margin-bottom:10px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper{display:inline-block;width:30%;vertical-align:top;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper{width:45%}}@media (max-width:480px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper{width:40%}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForPrimary,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForPrimary{font-size:20px;font-weight:700;display:inline-block;width:80%;margin:10px 0 0 10%;transition:font-size .35s linear 0ms}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForPrimary,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForPrimary{font-size:18px}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForSecondary,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForSecondary{font-size:16px;font-weight:400;display:inline-block;width:80%;margin:0 0 0 10%;transition:font-size .35s linear 0ms}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForSecondary,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForSecondary{font-size:12px}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper{display:inline-block;width:70%;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper{width:55%}}@media (max-width:480px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper{width:60%}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .checkboxInputWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .checkboxInputWrapper{margin:5px 0}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .checkboxInputWrapper .checkboxLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .checkboxInputWrapper .checkboxLabel{width:200px}@media (max-width:480px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .checkboxInputWrapper .checkboxLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .checkboxInputWrapper .checkboxLabel{width:140px;margin:0 0 0 8px}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:40px 10px 20px}@media (max-width:900px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement{width:calc(100% - 20px);margin:10px 10px 20px}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper{position:relative;background:#fff}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .selected.dropElement,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .selected.dropElement{background:#f6f6f6;color:#523c5d;font-weight:700}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .dropElement,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .dropElement{cursor:pointer;padding:5px 10px}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .expanded.expandSection,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .expanded.expandSection{max-height:200px;z-index:1}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .expandSection,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .expandSection{position:absolute;top:100%;left:0;right:0;height:auto;max-height:0;overflow:hidden;background:#fff;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .expandSection .dropElement,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .expandSection .dropElement{transition:background .25s ease-in-out 0ms}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .expandSection .dropElement:hover,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .timeElement .timeWrapper .expandSection .dropElement:hover{background:#f6f6f6}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .apptDaySelection,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .apptDaySelection{text-align:center}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper{margin:2px 0;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper{width:80px}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper .radioLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper .radioLabel{width:55px;transition:width .35s linear 0ms;text-align:left}@media (max-width:600px){#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper .radioLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper .radioLabel{width:55px}}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleServiceForm,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleServiceForm{position:relative}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleServiceForm .thirdRow .oneHalfSection,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleServiceForm .thirdRow .oneHalfSection{vertical-align:top}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleServiceForm .thirdRow .oneHalfSection .radioYesNoLabel,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleServiceForm .thirdRow .oneHalfSection .radioYesNoLabel{margin-top:10px;vertical-align:top}#diamonds-direct .ContactPage .scheduleBody .sbFormWrapper .ScheduleServiceForm .thirdRow .oneHalfSection .radioInputRow,#diamonds-direct .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleServiceForm .thirdRow .oneHalfSection .radioInputRow{vertical-align:top}#diamonds-direct .ContactPage .scheduleFooterSpacer,#diamonds-direct .ScheduleAppointment .scheduleFooterSpacer{width:100%;height:5px;background:#bf98c3;margin:50px 0 0}#diamonds-direct .decFinancingPromoWrapper{position:relative}#diamonds-direct .decFinancingPromoWrapper .decFinancingPromoWrapperButton{cursor:pointer;position:absolute;top:68%;left:33%;width:34%;height:auto}#diamonds-direct .decFinancingPromoWrapper .decFinancingPromoWrapperButton img{width:100%}#diamonds-direct .Store .hoursModalWrapper,#diamonds-direct .Watch .hoursModalWrapper{overflow:auto}#diamonds-direct .Store .hoursModalWrapper .hmImage img,#diamonds-direct .Watch .hoursModalWrapper .hmImage img{width:100%}#diamonds-direct .Store .hoursModalWrapper .hmAction,#diamonds-direct .Watch .hoursModalWrapper .hmAction{margin:10px 0;text-align:center}#diamonds-direct .Store .hoursModalWrapper .hmAction button,#diamonds-direct .Watch .hoursModalWrapper .hmAction button{height:40px;line-height:40px}#diamonds-direct .Store .bannerSection,#diamonds-direct .Watch .bannerSection{position:relative}#diamonds-direct .Store .bannerSection img,#diamonds-direct .Watch .bannerSection img{width:100%}#diamonds-direct .Store .bannerSection .bannerSectionButton,#diamonds-direct .Watch .bannerSection .bannerSectionButton{position:absolute;top:70%;left:9.5%;width:30%;height:10%;cursor:pointer;color:#fff;border:1px solid #fff;background:none;font-family:Lato,sans-serif;font-size:22px;font-weight:700;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center;text-transform:uppercase;transition:background .2s linear 0ms,color .2s linear 0ms,background .2s linear 0ms}@media (max-width:1200px){#diamonds-direct .Store .bannerSection .bannerSectionButton,#diamonds-direct .Watch .bannerSection .bannerSectionButton{font-size:20px;font-weight:700}}@media (max-width:1024px){#diamonds-direct .Store .bannerSection .bannerSectionButton,#diamonds-direct .Watch .bannerSection .bannerSectionButton{font-size:16px;font-weight:700}}@media (max-width:900px){#diamonds-direct .Store .bannerSection .bannerSectionButton,#diamonds-direct .Watch .bannerSection .bannerSectionButton{top:70%;font-size:15px;border:1px solid #fff}}@media (max-width:768px){#diamonds-direct .Store .bannerSection .bannerSectionButton,#diamonds-direct .Watch .bannerSection .bannerSectionButton{top:79%;left:9.5%;width:30%;height:10%;font-size:13px;font-weight:400}}@media (max-width:600px){#diamonds-direct .Store .bannerSection .bannerSectionButton,#diamonds-direct .Watch .bannerSection .bannerSectionButton{font-size:18px;font-weight:700;top:88%;left:20%;width:60%;height:7%}}#diamonds-direct .Store .bannerSection .bannerSectionButton:hover,#diamonds-direct .Watch .bannerSection .bannerSectionButton:hover{background:#fff;color:#8e8e8e}#diamonds-direct .Store .bannerSection .storeRotatingBanner,#diamonds-direct .Watch .bannerSection .storeRotatingBanner{position:relative}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerLeft,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerLeft{position:absolute;cursor:pointer;top:calc(50% - 20px);left:30px;height:40px;z-index:1;transition:left .4s ease-in-out}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerLeft:hover,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerLeft:hover{left:20px}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerLeft:active,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerLeft:active{left:15px}@media (max-width:768px){#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerLeft,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerLeft{top:calc(50% - 10px);left:8px;height:20px}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerLeft:hover,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerLeft:hover{left:5px}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerLeft:active,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerLeft:active{left:3px}}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerLeft .leftArrow,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerLeft .leftArrow{width:0;height:0;border-top:20px solid transparent;border-bottom:20px solid transparent;border-right:20px solid hsla(0,0%,100%,.3);transition:border-right .2s ease-in-out}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerLeft .leftArrow:hover,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerLeft .leftArrow:hover{border-right:20px solid hsla(0,0%,100%,.8)}@media (max-width:768px){#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerLeft .leftArrow,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerLeft .leftArrow{border-top:16px solid transparent;border-bottom:16px solid transparent;border-right:16px solid hsla(0,0%,100%,.3)}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerLeft .leftArrow:hover,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerLeft .leftArrow:hover{border-right:16px solid hsla(0,0%,100%,.8)}}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerRight,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerRight{position:absolute;cursor:pointer;top:calc(50% - 20px);right:30px;height:40px;z-index:1;transition:right .4s ease-in-out}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerRight:hover,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerRight:hover{right:20px}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerRight:active,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerRight:active{right:15px}@media (max-width:768px){#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerRight,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerRight{top:calc(50% - 10px);right:8px;height:20px}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerRight:hover,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerRight:hover{right:5px}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerRight:active,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerRight:active{right:3px}}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerRight .rightArrow,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerRight .rightArrow{width:0;height:0;border-top:20px solid transparent;border-bottom:20px solid transparent;border-left:20px solid hsla(0,0%,100%,.3);transition:border-left .2s ease-in-out}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerRight .rightArrow:hover,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerRight .rightArrow:hover{border-left:20px solid hsla(0,0%,100%,.8)}@media (max-width:768px){#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerRight .rightArrow,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerRight .rightArrow{border-top:16px solid transparent;border-bottom:16px solid transparent;border-left:16px solid hsla(0,0%,100%,.3)}#diamonds-direct .Store .bannerSection .storeRotatingBanner .bannerRight .rightArrow:hover,#diamonds-direct .Watch .bannerSection .storeRotatingBanner .bannerRight .rightArrow:hover{border-left:16px solid hsla(0,0%,100%,.8)}}@media (max-width:600px){#diamonds-direct .Store .bannerSection .fall2018promoBanner.chsSpecial .fallLearnMore,#diamonds-direct .Watch .bannerSection .fall2018promoBanner.chsSpecial .fallLearnMore{display:none}}#diamonds-direct .Store .bannerSection .fall2018promoBanner,#diamonds-direct .Watch .bannerSection .fall2018promoBanner{position:relative}#diamonds-direct .Store .bannerSection .fall2018promoBanner .fallLearnMore,#diamonds-direct .Watch .bannerSection .fall2018promoBanner .fallLearnMore{display:-ms-flexbox;display:flex;position:absolute;top:64%;left:61.5%;width:14%;height:11%;line-height:100%;color:#fff;background:hsla(0,0%,100%,0);border:1px solid #fff;text-transform:uppercase;font-family:Lato,sans-serif;font-size:16px;font-weight:300;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,font-size .35s linear 0ms}#diamonds-direct .Store .bannerSection .fall2018promoBanner .fallLearnMore:active,#diamonds-direct .Store .bannerSection .fall2018promoBanner .fallLearnMore:hover,#diamonds-direct .Watch .bannerSection .fall2018promoBanner .fallLearnMore:active,#diamonds-direct .Watch .bannerSection .fall2018promoBanner .fallLearnMore:hover{color:#150f19;background:#fff}@media (min-width:1800px){#diamonds-direct .Store .bannerSection .fall2018promoBanner .fallLearnMore,#diamonds-direct .Watch .bannerSection .fall2018promoBanner .fallLearnMore{font-size:24px}}@media (max-width:768px){#diamonds-direct .Store .bannerSection .fall2018promoBanner .fallLearnMore,#diamonds-direct .Watch .bannerSection .fall2018promoBanner .fallLearnMore{top:73%;left:60%;width:17%;height:13%;font-size:14px}}@media (max-width:600px){#diamonds-direct .Store .bannerSection .fall2018promoBanner .fallLearnMore,#diamonds-direct .Watch .bannerSection .fall2018promoBanner .fallLearnMore{top:85%;left:33%;width:34%;height:8%;font-size:16px}}#diamonds-direct .Store .infoSection,#diamonds-direct .Watch .infoSection{position:relative;z-index:1;top:-60px;background:#fff;margin:0 180px;font-family:Lato,sans-serif;text-align:center;transition:margin .35s linear 0ms,top .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Store .infoSection,#diamonds-direct .Watch .infoSection{margin:0 80px}}@media (max-width:768px){#diamonds-direct .Store .infoSection,#diamonds-direct .Watch .infoSection{margin:0;top:0}}#diamonds-direct .Store .infoSection .infoTitle,#diamonds-direct .Watch .infoSection .infoTitle{padding:25px 0;text-align:center;text-transform:uppercase;font-weight:700;font-size:34px;color:#5e5e5e;margin:0 25px;transition:font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoTitle,#diamonds-direct .Watch .infoSection .infoTitle{font-size:28px}}#diamonds-direct .Store .infoSection .infoDescriptionWrapper,#diamonds-direct .Watch .infoSection .infoDescriptionWrapper{margin:0 25%;font-size:16px;text-align:center;color:#95989a;transition:margin .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .Store .infoSection .infoDescriptionWrapper,#diamonds-direct .Watch .infoSection .infoDescriptionWrapper{margin:0 15%}}#diamonds-direct .Store .infoSection .infoDescriptionWrapper .infoDescriptionP,#diamonds-direct .Watch .infoSection .infoDescriptionWrapper .infoDescriptionP{margin:0 0 25px}#diamonds-direct .Store .infoSection .infoRowWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper{color:#95989a;margin:0 0 0 25%;text-align:left;transition:margin .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .Store .infoSection .infoRowWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper{margin:0 0 0 15%}}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper{margin:0 0 0 10%}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow{margin:0 0 25px;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow{margin:0 0 0 30%}}@media (max-width:600px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow{margin:0 0 0 20%}}@media (max-width:480px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow{margin:0 0 0 10%}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper{display:inline-block;vertical-align:top;width:50%;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper{width:100%;margin:0 0 25px}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper .locationTitle,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper .locationTitle{color:#4b2d53;font-weight:700;margin:0 0 20px;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper .locationTitle,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper .locationTitle{margin:0 0 10px}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper .contactTitle.locationTitle,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper .contactTitle.locationTitle{margin:20px 0}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper .contactTitle.locationTitle,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper .contactTitle.locationTitle{margin:50px 0 10px}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper a.locationLink,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper a.locationLink{text-decoration:none;color:#95989a}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper .locationBody .locationBodyRow,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper .locationBody .locationBodyRow{margin:0 0 3px}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper .locationNote,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper .locationNote{font-weight:700;margin:28px 15px 0 0;color:#95989a}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper .locationNote,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper .locationNote{margin:8px 75px 0 0}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .locationWrapper .locationNote a,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .locationWrapper .locationNote a{color:#95989a}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper{display:inline-block;vertical-align:top;width:50%;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper{width:100%;margin:0 0 25px}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursTitle,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursTitle{color:#4b2d53;font-weight:700;margin:0 0 20px;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursTitle,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursTitle{margin:0 0 10px}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody a,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody a{color:#95989a;text-decoration:none;font-weight:700}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursBodyRow,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursBodyRow{margin:0 0 3px}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursLink.hoursNoticeNormal,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursLink.hoursNoticeNormal{cursor:pointer;font-size:20px;margin:15px 0 0;color:#4b2d53;transition:color .25s ease-in-out 0ms}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursLink.hoursNoticeNormal:hover,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursLink.hoursNoticeNormal:hover{color:#000}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNoticeNormal,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNoticeNormal{font-weight:700;margin:8px 0 0;color:#95989a}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNoticeNormal,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNoticeNormal{margin:8px 75px 0 0}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNoticeNormal a,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNoticeNormal a{color:#95989a}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNotice,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNotice{font-weight:700;margin:8px 0 0;color:#eb3533}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNotice,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNotice{margin:8px 75px 0 0}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNotice a,#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNotice a:hover,#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNotice a:visited,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNotice a,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNotice a:hover,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .hoursBody .hoursNotice a:visited{color:#eb3533}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .hoursWrapper .comingSoonNotice,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .hoursWrapper .comingSoonNotice{font-size:18px;font-weight:700}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .phoneWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .phoneWrapper{position:relative;margin:0 0 15px;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .phoneWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .phoneWrapper{width:100%;margin:0 0 15px}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .phoneWrapper a,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .phoneWrapper a{text-decoration:none;color:#95989a}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .phoneWrapper .phoneIcon,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .phoneWrapper .phoneIcon{position:absolute;top:0;left:0;width:30px;height:30px;background-image:url(\"https://ddw2.diamondsdirect.com/img/store/phone.svg\");background-repeat:no-repeat;background-size:contain;background-position:50%}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .phoneWrapper .phoneValue,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .phoneWrapper .phoneValue{padding:0 0 0 35px;line-height:30px}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .emailWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .emailWrapper{position:relative;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .emailWrapper,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .emailWrapper{width:100%;margin:0 0 25px}}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .emailWrapper .emailIcon,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .emailWrapper .emailIcon{position:absolute;top:0;left:0;width:30px;height:30px;background-image:url(\"https://ddw2.diamondsdirect.com/img/store/mail.svg\");background-repeat:no-repeat;background-size:contain;background-position:50%}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .emailWrapper .emailValue,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .emailWrapper .emailValue{padding:0 0 0 40px;line-height:30px;font-size:14px}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .emailWrapper .emailValue a,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .emailWrapper .emailValue a{color:#95989a;text-decoration:none}#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .emailWrapper .emailValue a:active,#diamonds-direct .Store .infoSection .infoRowWrapper .infoRow .emailWrapper .emailValue a:visited,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .emailWrapper .emailValue a:active,#diamonds-direct .Watch .infoSection .infoRowWrapper .infoRow .emailWrapper .emailValue a:visited{color:#95989a}#diamonds-direct .Store .infoSection .infoCTA,#diamonds-direct .Watch .infoSection .infoCTA{display:inline-block;margin:10px;border:1px solid #95989a;color:#95989a;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:8px 0;font-weight:300;font-size:18px;width:180px;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border-color .25s ease-in-out 0ms}#diamonds-direct .Store .infoSection .infoCTA:hover,#diamonds-direct .Watch .infoSection .infoCTA:hover{cursor:pointer;color:#fff;background:#4b2d53;border-color:#4b2d53}#diamonds-direct .Store .infoSection .infoSocial,#diamonds-direct .Watch .infoSection .infoSocial{text-align:center;margin:10px 0 0;padding:0 0 30px}#diamonds-direct .Store .infoSection .infoSocial .infoSocialHeader,#diamonds-direct .Watch .infoSection .infoSocial .infoSocialHeader{color:#4b2d53;font-weight:700;margin:0 0 15px}#diamonds-direct .Store .infoSection .infoSocial .infoSocialIcon,#diamonds-direct .Watch .infoSection .infoSocial .infoSocialIcon{display:inline-block;color:#95989a;width:30px;height:30px;cursor:pointer;font-size:30px;line-height:30px;margin:0 10px;transition:color .25s ease-in-out 0ms}#diamonds-direct .Store .infoSection .infoSocial .infoSocialIcon:hover,#diamonds-direct .Watch .infoSection .infoSocial .infoSocialIcon:hover{color:#4b2d53}#diamonds-direct .Store .infoSection .sponsorshipSection,#diamonds-direct .Watch .infoSection .sponsorshipSection{font-family:Lato,sans-serif;text-align:center}#diamonds-direct .Store .infoSection .sponsorshipSection .sponsorshipSubtitle,#diamonds-direct .Watch .infoSection .sponsorshipSection .sponsorshipSubtitle{margin:0 0 20px;font-size:24px;font-weight:400;text-transform:uppercase}#diamonds-direct .Store .infoSection .sponsorshipSection .sponsorshipLogos .sponsorLogo,#diamonds-direct .Watch .infoSection .sponsorshipSection .sponsorshipLogos .sponsorLogo{display:inline-block;width:auto;height:100px;margin:0 50px 30px;transition:height .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .infoSection .sponsorshipSection .sponsorshipLogos .sponsorLogo,#diamonds-direct .Watch .infoSection .sponsorshipSection .sponsorshipLogos .sponsorLogo{height:75px}}#diamonds-direct .Store .infoSection .sponsorshipSection .sponsorshipLogos .sponsorLogo img,#diamonds-direct .Watch .infoSection .sponsorshipSection .sponsorshipLogos .sponsorLogo img{display:block;height:100%}#diamonds-direct .Store .infoSection .sponsorshipSection .sponsorshipLogos .sponsorLogo.single,#diamonds-direct .Watch .infoSection .sponsorshipSection .sponsorshipLogos .sponsorLogo.single{height:130px}#diamonds-direct .Store .videoSection,#diamonds-direct .Watch .videoSection{margin:25px 0 100px}@media (max-width:768px){#diamonds-direct .Store .videoSection,#diamonds-direct .Watch .videoSection{margin:25px 0 0}}@media (max-width:600px){#diamonds-direct .Store .videoSection,#diamonds-direct .Watch .videoSection{margin:25px 0 0}}#diamonds-direct .Store .videoSection .videoWrapper,#diamonds-direct .Watch .videoSection .videoWrapper{max-width:640px;margin:0 auto}@media (max-width:768px){#diamonds-direct .Store .videoSection .videoWrapper,#diamonds-direct .Watch .videoSection .videoWrapper{max-width:480px;margin:50px auto 0}}@media (max-width:600px){#diamonds-direct .Store .videoSection .videoWrapper,#diamonds-direct .Watch .videoSection .videoWrapper{max-width:320px;margin:50px auto 0}}#diamonds-direct .Store .videoSection .videoWrapper iframe,#diamonds-direct .Watch .videoSection .videoWrapper iframe{border:none;width:640px;height:320px}@media (max-width:768px){#diamonds-direct .Store .videoSection .videoWrapper iframe,#diamonds-direct .Watch .videoSection .videoWrapper iframe{width:480px;height:240px}}@media (max-width:600px){#diamonds-direct .Store .videoSection .videoWrapper iframe,#diamonds-direct .Watch .videoSection .videoWrapper iframe{width:320px;height:160px}}#diamonds-direct .Store .audioSection,#diamonds-direct .Watch .audioSection{margin:-50px 0 100px;text-align:center;overflow:auto}@media (max-width:768px){#diamonds-direct .Store .audioSection,#diamonds-direct .Watch .audioSection{margin:-50px 0 0}}@media (max-width:600px){#diamonds-direct .Store .audioSection,#diamonds-direct .Watch .audioSection{margin:-50px 0 0}}#diamonds-direct .Store .audioSection .audioLabel,#diamonds-direct .Watch .audioSection .audioLabel{font-family:Lato,sans-serif;color:#95989a;font-size:20px}#diamonds-direct .Store .audioSection .audioWrapper,#diamonds-direct .Watch .audioSection .audioWrapper{max-width:640px;margin:15px auto 25px}@media (max-width:768px){#diamonds-direct .Store .audioSection .audioWrapper,#diamonds-direct .Watch .audioSection .audioWrapper{max-width:480px;margin:50px auto 15px}}@media (max-width:600px){#diamonds-direct .Store .audioSection .audioWrapper,#diamonds-direct .Watch .audioSection .audioWrapper{max-width:320px;margin:50px auto 15px}}#diamonds-direct .Store .promoSection,#diamonds-direct .Watch .promoSection{margin:0 5%;transition:margin 0}@media (max-width:768px){#diamonds-direct .Store .promoSection,#diamonds-direct .Watch .promoSection{margin:25px 0}}#diamonds-direct .Store .promoSection .promoBanner img,#diamonds-direct .Watch .promoSection .promoBanner img{width:100%}#diamonds-direct .Store .promoSection .promoContentDefault,#diamonds-direct .Watch .promoSection .promoContentDefault{position:relative;overflow:auto;top:-50px;text-align:center;background:#fff;margin:0 10%;z-index:1;transition:top .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .promoSection .promoContentDefault,#diamonds-direct .Watch .promoSection .promoContentDefault{top:0;margin:0}}#diamonds-direct .Store .promoSection .promoContentDefault img,#diamonds-direct .Watch .promoSection .promoContentDefault img{width:100%;display:block}#diamonds-direct .Store .promoSection .promoContentDefault .promoContentText,#diamonds-direct .Watch .promoSection .promoContentDefault .promoContentText{font-weight:300;color:#4f4f4f;font-family:Lato,sans-serif;font-size:20px;padding:30px 100px 40px}@media (max-width:768px){#diamonds-direct .Store .promoSection .promoContentDefault .promoContentText,#diamonds-direct .Watch .promoSection .promoContentDefault .promoContentText{padding:20px 10%}}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox{font-family:Lato,sans-serif;margin:5px;padding:30px 0 3px;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox{max-width:1000px}}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox img,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox img{display:block;width:100%}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoTitle,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoTitle{margin:5px 10% 20px;color:#4d4d4d;font-size:28px;font-weight:700;text-transform:uppercase}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoP,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoP{color:#4d4d4d;font-size:22px;font-weight:300;max-width:500px;margin:0 auto 20px}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoP .promoPem,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoP .promoPem{font-weight:400}@media (max-width:768px){#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoP,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoP{font-size:18px}}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoDateLabel,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoDateLabel{color:#4d4d4d;font-size:14px}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoDate,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoDate{color:#c4a162;font-size:24px;font-weight:700;margin:0 0 20px;text-transform:uppercase}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoDisclaimer,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoDisclaimer{margin:5px 0 0;color:#878787;font-size:16px;text-decoration:underline}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoSubbox,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoSubbox{margin:25px auto 15px;width:70%;max-width:400px;border:1px solid #b3b3b3}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxHeader,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxHeader{color:#000;margin:15px 0 0;font-size:28px;font-weight:700}@media (max-width:768px){#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxHeader,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxHeader{font-size:20px}}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxDates,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxDates{color:#333;margin:5px 0 0;font-size:20px}@media (max-width:768px){#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxDates,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxDates{font-size:14px}}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxButton,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxButton{display:inline-block;width:auto;margin:20px 0 15px;color:#fff;background:#960c3a;padding:10px 20px;text-transform:uppercase;font-size:14px;font-weight:300;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxButton:action,#diamonds-direct .Store .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxButton:hover,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxButton:action,#diamonds-direct .Watch .promoSection .promoContentDefault .promoCtaBox .promoSubbox .promoSubboxButton:hover{background:#ba0f48}#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault{background:#c0c5da}@media (max-width:768px){#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault{top:0;margin:0}}#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault img,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault img{width:100%;display:block}#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault .promoContentText,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault .promoContentText{font-weight:400;color:#fff;font-family:Lato,sans-serif;font-size:20px;padding:30px 100px 40px}@media (max-width:768px){#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault .promoContentText,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault .promoContentText{padding:20px 10%}}#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox{border:1px solid #fff;width:80%;max-width:500px;margin:0 auto 30px;padding:15px 0}#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox .promoTitle,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox .promoTitle{color:#532173;text-transform:none;margin-bottom:5px}#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox .promoDate,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox .promoDate{color:#fff;text-transform:none;font-weight:400;font-size:20px;margin-bottom:10px}#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox .promoDisclaimer,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox .promoDisclaimer{color:#fff;cursor:pointer;font-weight:300;margin-top:5px}#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox .mothersButton,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox .mothersButton{display:inline-block;color:#532173;background:#fff;cursor:pointer;text-transform:uppercase;text-align:center;padding:10px 30px;margin:15px 0 0;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Store .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox .mothersButton:hover,#diamonds-direct .Watch .promoSection.mothersDayPromo .promoContentDefault .promoCtaBox .mothersButton:hover{background:#532173;color:#fff}#diamonds-direct .Store .promoSection.coltsPromos .promoContentDefault,#diamonds-direct .Watch .promoSection.coltsPromos .promoContentDefault{position:relative}#diamonds-direct .Store .promoSection.coltsPromos .promoContentDefault .invButton,#diamonds-direct .Watch .promoSection.coltsPromos .promoContentDefault .invButton{position:absolute;cursor:pointer;top:68%;height:28%;width:13%}#diamonds-direct .Store .promoSection.coltsPromos .promoContentDefault .mainButton,#diamonds-direct .Watch .promoSection.coltsPromos .promoContentDefault .mainButton{top:39%;left:32%;height:10%;width:36%}#diamonds-direct .Store .promoSection.coltsPromos .promoContentDefault .des01,#diamonds-direct .Watch .promoSection.coltsPromos .promoContentDefault .des01{left:12%;width:12.5%}#diamonds-direct .Store .promoSection.coltsPromos .promoContentDefault .des02,#diamonds-direct .Watch .promoSection.coltsPromos .promoContentDefault .des02{left:26%;width:16%}#diamonds-direct .Store .promoSection.coltsPromos .promoContentDefault .des03,#diamonds-direct .Watch .promoSection.coltsPromos .promoContentDefault .des03{left:43.5%;width:13%}#diamonds-direct .Store .promoSection.coltsPromos .promoContentDefault .des04,#diamonds-direct .Watch .promoSection.coltsPromos .promoContentDefault .des04{left:58%;width:16.5%}#diamonds-direct .Store .promoSection.coltsPromos .promoContentDefault .des05,#diamonds-direct .Watch .promoSection.coltsPromos .promoContentDefault .des05{left:75%;width:14%}#diamonds-direct .Store .biosSection,#diamonds-direct .Watch .biosSection{position:relative;top:0;margin:0 5% 25px;background:#f4f5f7;font-family:Lato,sans-serif}@media (max-width:768px){#diamonds-direct .Store .biosSection,#diamonds-direct .Watch .biosSection{margin:0 5% 25px;padding:25px 0 0}}#diamonds-direct .Store .biosSection .biosTitle,#diamonds-direct .Watch .biosSection .biosTitle{text-align:center;padding:60px 0 30px;font-weight:700;font-size:32px;color:#666}@media (max-width:768px){#diamonds-direct .Store .biosSection .biosTitle,#diamonds-direct .Watch .biosSection .biosTitle{padding:10px 0 30px}}#diamonds-direct .Store .biosSection .biosWrapper,#diamonds-direct .Watch .biosSection .biosWrapper{margin:10px 50px;text-align:center;height:100%;max-height:403px;overflow:hidden;transition:max-height .4s ease-in-out 0ms,margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .biosSection .biosWrapper,#diamonds-direct .Watch .biosSection .biosWrapper{margin:0 20px 10px;max-height:303px}}@media (max-width:480px){#diamonds-direct .Store .biosSection .biosWrapper,#diamonds-direct .Watch .biosSection .biosWrapper{margin:0 10px 10px;max-height:303px}}#diamonds-direct .Store .biosSection .biosWrapper .memberBio,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio{position:relative;margin:1px 2px;display:inline-block;height:198px;cursor:pointer;transition:height .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .biosSection .biosWrapper .memberBio,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio{height:148px}}#diamonds-direct .Store .biosSection .biosWrapper .memberBio img,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio img{display:block;height:100%}#diamonds-direct .Store .biosSection .biosWrapper .memberBio .memberOverlay,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio .memberOverlay{position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;background:rgba(0,0,0,.7);transition:opacity .25s ease-in-out 0ms}#diamonds-direct .Store .biosSection .biosWrapper .memberBio .memberOverlay:hover,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio .memberOverlay:hover{opacity:1}#diamonds-direct .Store .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo{position:absolute;left:0;right:0;top:80px;height:auto;color:#fff;text-align:center;transition:top .35s linear 0ms}#diamonds-direct .Store .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo .memberName,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo .memberName{font-size:18px;font-weight:400;transition:font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo .memberName,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo .memberName{font-size:16px}}#diamonds-direct .Store .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo .memberTitle,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo .memberTitle{font-size:16px;font-weight:300;transition:font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo .memberTitle,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo .memberTitle{font-size:14px}}@media (max-width:768px){#diamonds-direct .Store .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo,#diamonds-direct .Watch .biosSection .biosWrapper .memberBio .memberOverlay .memberInfo{top:55px}}#diamonds-direct .Store .biosSection .biosWrapper.open,#diamonds-direct .Watch .biosSection .biosWrapper.open{max-height:5000px}#diamonds-direct .Store .biosSection .biosViewControls,#diamonds-direct .Watch .biosSection .biosViewControls{position:relative;text-align:center;text-transform:uppercase;font-size:18px;color:#4e4352;height:55px}#diamonds-direct .Store .biosSection .biosViewControls .biosViewMore,#diamonds-direct .Watch .biosSection .biosViewControls .biosViewMore{position:absolute;top:5px;left:calc(50% - 70px);width:140px;transition:top .25s ease-in-out 0ms}#diamonds-direct .Store .biosSection .biosViewControls .biosViewMore .downArrow,#diamonds-direct .Watch .biosSection .biosViewControls .biosViewMore .downArrow{width:20px;height:14px;margin:0 auto;background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/store/downarrow.svg\");background-position:50%;background-repeat:no-repeat}#diamonds-direct .Store .biosSection .biosViewControls .biosViewMore:hover,#diamonds-direct .Watch .biosSection .biosViewControls .biosViewMore:hover{top:12px;cursor:pointer}#diamonds-direct .Store .biosSection .biosViewControls .biosViewMore:active,#diamonds-direct .Watch .biosSection .biosViewControls .biosViewMore:active{top:17px;cursor:pointer}#diamonds-direct .Store .biosSection .biosViewControls .biosViewLess,#diamonds-direct .Watch .biosSection .biosViewControls .biosViewLess{position:absolute;top:12px;left:calc(50% - 70px);width:140px;transition:top .25s ease-in-out 0ms}#diamonds-direct .Store .biosSection .biosViewControls .biosViewLess .upArrow,#diamonds-direct .Watch .biosSection .biosViewControls .biosViewLess .upArrow{width:20px;height:14px;margin:0 auto;background-image:url(\"https://ddw2.diamondsdirect.com/img/icons/store/uparrow.svg\");background-position:50%;background-repeat:no-repeat}#diamonds-direct .Store .biosSection .biosViewControls .biosViewLess:hover,#diamonds-direct .Watch .biosSection .biosViewControls .biosViewLess:hover{top:5px;cursor:pointer}#diamonds-direct .Store .biosSection .biosViewControls .biosViewLess:active,#diamonds-direct .Watch .biosSection .biosViewControls .biosViewLess:active{top:2px;cursor:pointer}#diamonds-direct .Store .biosSection .biosViewControls .hidden,#diamonds-direct .Watch .biosSection .biosViewControls .hidden{display:none}#diamonds-direct .Store .biosSection.limitedBios .biosWrapper,#diamonds-direct .Watch .biosSection.limitedBios .biosWrapper{margin:10px 50px;padding:0 0 40px;text-align:center;height:100%;overflow:hidden;transition:max-height .4s ease-in-out 0ms,margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Store .biosSection.limitedBios .biosWrapper,#diamonds-direct .Watch .biosSection.limitedBios .biosWrapper{margin:10px}}@media (max-width:768px){#diamonds-direct .Store .biosSection.limitedBios .biosWrapper,#diamonds-direct .Watch .biosSection.limitedBios .biosWrapper{margin:0 20px 10px;max-height:303px}}@media (max-width:480px){#diamonds-direct .Store .biosSection.limitedBios .biosWrapper,#diamonds-direct .Watch .biosSection.limitedBios .biosWrapper{margin:0 10px 10px;max-height:303px}}#diamonds-direct .Store .biosSection.limitedBios .biosWrapper .memberBio,#diamonds-direct .Watch .biosSection.limitedBios .biosWrapper .memberBio{position:relative;margin:1px 25px;display:inline-block;height:198px;transition:height .35s linear 0ms,margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Store .biosSection.limitedBios .biosWrapper .memberBio,#diamonds-direct .Watch .biosSection.limitedBios .biosWrapper .memberBio{margin:1px 12px}}@media (max-width:768px){#diamonds-direct .Store .biosSection.limitedBios .biosWrapper .memberBio,#diamonds-direct .Watch .biosSection.limitedBios .biosWrapper .memberBio{height:148px}}@media (max-width:480px){#diamonds-direct .Store .biosSection.limitedBios .biosWrapper .memberBio,#diamonds-direct .Watch .biosSection.limitedBios .biosWrapper .memberBio{margin:1px 12px 20px}}#diamonds-direct .Store .biosSection.limitedBios .biosWrapper .memberBio img,#diamonds-direct .Watch .biosSection.limitedBios .biosWrapper .memberBio img{display:block;height:100%}#diamonds-direct .Store .biosSection.limitedBios .biosViewControls,#diamonds-direct .Watch .biosSection.limitedBios .biosViewControls{display:none}#diamonds-direct .Store .awardsSection,#diamonds-direct .Watch .awardsSection{font-family:Lato,sans-serif;text-align:center}#diamonds-direct .Store .awardsSection .awardsSubtitle,#diamonds-direct .Watch .awardsSection .awardsSubtitle{text-align:center;margin:0 0 20px;padding:0;font-weight:700;font-size:28px;color:#666}@media (max-width:768px){#diamonds-direct .Store .awardsSection .awardsSubtitle,#diamonds-direct .Watch .awardsSection .awardsSubtitle{padding:0}}#diamonds-direct .Store .awardsSection .awardsLogos .awardLogo,#diamonds-direct .Watch .awardsSection .awardsLogos .awardLogo{display:inline-block;width:auto;height:100px;margin:0 25px 30px;transition:height .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Store .awardsSection .awardsLogos .awardLogo,#diamonds-direct .Watch .awardsSection .awardsLogos .awardLogo{height:75px}}#diamonds-direct .Store .awardsSection .awardsLogos .awardLogo img,#diamonds-direct .Watch .awardsSection .awardsLogos .awardLogo img{display:block;height:100%}#diamonds-direct .Store .awardsSection .awardsLogos .awardLogo.single,#diamonds-direct .Watch .awardsSection .awardsLogos .awardLogo.single{height:130px}#diamonds-direct .Store .reviewSection,#diamonds-direct .Watch .reviewSection{background:#4b2d53;color:#fff;font-weight:400;text-align:center;padding:20px 0;font-size:22px;transition:font-size .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Store .reviewSection,#diamonds-direct .Watch .reviewSection{font-size:18px}}#diamonds-direct .Store .reviewSection .footerLine,#diamonds-direct .Watch .reviewSection .footerLine{display:inline-block;vertical-align:top;width:auto}#diamonds-direct .Store .reviewSection .footerButton,#diamonds-direct .Watch .reviewSection .footerButton{display:inline-block;vertical-align:top;width:auto;font-weight:300;text-transform:uppercase;vertical-align:middle;border:1px solid #fff;margin:0 10px;padding:3px 10px;font-size:18px;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,margin .35s linear 0ms,padding .35s linear 0ms,font-size .35s linear 0ms}#diamonds-direct .Store .reviewSection .footerButton:hover,#diamonds-direct .Watch .reviewSection .footerButton:hover{color:#4b2d53;background:#fff}@media (max-width:600px){#diamonds-direct .Store .reviewSection .footerButton,#diamonds-direct .Watch .reviewSection .footerButton{margin:0 6px;padding:3px 6px;font-size:16px}}#diamonds-direct .Watch{margin-bottom:-240px}@media (max-width:768px){#diamonds-direct .Watch{margin-bottom:0}}#diamonds-direct .Watch .watchInfo.infoSection{border:1px solid #dbdbdb;box-shadow:8px 8px 0 0 rgba(0,0,0,.16)}@media (max-width:768px){#diamonds-direct .Watch .watchInfo.infoSection{box-shadow:none;border:0}}#diamonds-direct .Watch .watchInfo.infoSection .tabbedNavigation .singleTab{border:1px solid #dbdbdb;width:calc(20% - 2px);height:45px;line-height:45px;cursor:pointer;display:inline-block;text-transform:uppercase;font-size:14px;transition:background .25s ease-in-out 0ms}#diamonds-direct .Watch .watchInfo.infoSection .tabbedNavigation .singleTab:hover{background:#f0f0f0}@media (max-width:600px){#diamonds-direct .Watch .watchInfo.infoSection .tabbedNavigation .singleTab{height:30px;line-height:30px;font-size:12px}}@media (max-width:480px){#diamonds-direct .Watch .watchInfo.infoSection .tabbedNavigation .singleTab{font-size:10px}}#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent{margin:0 125px!important}@media (max-width:1200px){#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent{margin:0 100px!important}}@media (max-width:600px){#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent{margin:0 75px!important}}@media (max-width:480px){#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent{margin:0 25px!important}}#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent .locationHoursRow{text-align:center}#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent .locationHoursRow .locationWrapper{text-align:left;width:35%;margin:0 0 0 10%}@media (max-width:1200px){#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent .locationHoursRow .locationWrapper{width:38%;margin:0}}@media (max-width:900px){#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent .locationHoursRow .locationWrapper{width:50%;margin:0}}@media (max-width:768px){#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent .locationHoursRow .locationWrapper{width:100%;margin:0 0 20px}}#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent .locationHoursRow .hoursWrapper{text-align:left;width:40%;margin:0 0 0 15%}@media (max-width:1200px){#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent .locationHoursRow .hoursWrapper{width:50%;margin:0 0 0 12%}}@media (max-width:900px){#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent .locationHoursRow .hoursWrapper{width:50%;margin:0}}@media (max-width:768px){#diamonds-direct .Watch .watchInfo.infoSection .locationHoursParent .locationHoursRow .hoursWrapper{width:100%;margin:0}}#diamonds-direct .Watch .watchInfo.infoSection .hoursTitle,#diamonds-direct .Watch .watchInfo.infoSection .locationTitle{color:#5e5e5e}@media (max-width:768px){#diamonds-direct .Watch .watchInfo.infoSection .infoTitle{padding:15px 0;font-size:24px}}#diamonds-direct .Watch .watchInfo.infoSection .infoDescriptionWrapper{margin:0 125px}@media (max-width:1200px){#diamonds-direct .Watch .watchInfo.infoSection .infoDescriptionWrapper{margin:0 100px}}@media (max-width:600px){#diamonds-direct .Watch .watchInfo.infoSection .infoDescriptionWrapper{margin:0 75px}}@media (max-width:480px){#diamonds-direct .Watch .watchInfo.infoSection .infoDescriptionWrapper{margin:0 25px}}#diamonds-direct .Watch .watchInfo.infoSection .infoDescriptionWrapper .infoDescriptionP{text-align:left}#diamonds-direct .Watch .watchInfo.infoSection .infoRowWrapper{margin:0 125px}@media (max-width:600px){#diamonds-direct .Watch .watchInfo.infoSection .infoRowWrapper{margin:0 75px}}@media (max-width:480px){#diamonds-direct .Watch .watchInfo.infoSection .infoRowWrapper{margin:0 25px}}#diamonds-direct .Watch .watchInfo.infoSection .shopNowButtonWrapper{position:relative;text-align:center;margin:10px 0 15px}#diamonds-direct .Watch .watchInfo.infoSection .shopNowButtonWrapper .shopNowButton{position:relative;display:inline-block;width:210px;height:45px;border:1px solid #5e5e5e;color:#5e5e5e;background:#fff;cursor:pointer;font-size:16px;font-weight:700;margin:5px;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}#diamonds-direct .Watch .watchInfo.infoSection .shopNowButtonWrapper .shopNowButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .Watch .watchInfo.infoSection .shopNowButtonWrapper .shopNowButton div{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-transform:uppercase}#diamonds-direct .Watch .bestsellerSection{padding:70px 50px 50px;transition:margin .35s linear 0ms;background:#eeeff2;position:relative;top:-100px;overflow:auto}@media (max-width:768px){#diamonds-direct .Watch .bestsellerSection{top:0;padding:0 20px 25px}}#diamonds-direct .Watch .bestsellerSection .bestTitle{margin:0 0 30px;text-align:center;font-size:28px;font-weight:700;text-transform:uppercase;color:#000;font-family:Lato,sans-serif;transition:font-size .35s linear 0ms,margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Watch .bestsellerSection .bestTitle{margin:25px 0 15px;font-size:28px}}@media (max-width:600px){#diamonds-direct .Watch .bestsellerSection .bestTitle{font-size:26px}}@media (max-width:768px){#diamonds-direct .Watch .bestsellerSection .bestTitle{font-size:22px}}#diamonds-direct .Watch .bestsellerSection .bestItems{margin:0}@media (max-width:1024px){#diamonds-direct .Watch .bestsellerSection .bestItems{margin:0 0 20px}}@media (max-width:768px){#diamonds-direct .Watch .bestsellerSection .bestItems{margin:0}}#diamonds-direct .Watch .bestsellerSection .bestItems .bestLHS{display:inline-block;width:calc(50% - 25px)}@media (max-width:1024px){#diamonds-direct .Watch .bestsellerSection .bestItems .bestLHS{width:50%}}@media (max-width:768px){#diamonds-direct .Watch .bestsellerSection .bestItems .bestLHS{display:none}}#diamonds-direct .Watch .bestsellerSection .bestItems .bestLHS .largeItemWrapper .largeImg{width:100%;padding:100% 0 0;background-position:50%;background-repeat:no-repeat;background-size:cover}#diamonds-direct .Watch .bestsellerSection .bestItems .bestRHS{display:inline-block;width:calc(50% - 25px);margin:0 0 0 50px}@media (max-width:1024px){#diamonds-direct .Watch .bestsellerSection .bestItems .bestRHS{width:calc(50% - 20px);margin:0 0 0 20px}}@media (max-width:768px){#diamonds-direct .Watch .bestsellerSection .bestItems .bestRHS{display:none}}#diamonds-direct .Watch .bestsellerSection .bestItems .bestRHS .itemGridWrapper .smallItemRow:first-child{margin-bottom:0}@media (max-width:1024px){#diamonds-direct .Watch .bestsellerSection .bestItems .bestRHS .itemGridWrapper .smallItemRow:first-child{margin-bottom:15px}}#diamonds-direct .Watch .bestsellerSection .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper{display:inline-block;width:calc(50% - 25px)}@media (max-width:1024px){#diamonds-direct .Watch .bestsellerSection .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper{width:calc(50% - 10px)}}#diamonds-direct .Watch .bestsellerSection .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper:nth-child(2){margin-left:50px}@media (max-width:1024px){#diamonds-direct .Watch .bestsellerSection .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper:nth-child(2){margin-left:20px}}#diamonds-direct .Watch .bestsellerSection .bestItems .bestRHS .itemGridWrapper .smallItemRow .smallItemWrapper .smallImg{width:100%;padding:100% 0 0;background-position:50%;background-repeat:no-repeat;background-size:cover}#diamonds-direct .Watch .bestsellerSection .bestItems .bestMobile{text-align:left}#diamonds-direct .Watch .bestsellerSection .bestItems .bestMobile .mobileItemWrapper{display:inline-block;width:calc(50% - 10px);margin:0 0 10px 10px;transition:width .35s linear 0ms,margin .35s linear 0ms}@media (max-width:480px){#diamonds-direct .Watch .bestsellerSection .bestItems .bestMobile .mobileItemWrapper{width:100%;margin:0 0 10px}}#diamonds-direct .Watch .bestsellerSection .bestItems .bestMobile .mobileItemWrapper:nth-child(odd){margin:0 10px 10px 0}@media (max-width:480px){#diamonds-direct .Watch .bestsellerSection .bestItems .bestMobile .mobileItemWrapper:nth-child(odd){margin:0 0 10px}}#diamonds-direct .Watch .bestsellerSection .bestItems .bestMobile .mobileItemWrapper .mobileImg{width:100%;padding:100% 0 0;background-position:50%;background-repeat:no-repeat;background-size:cover}#diamonds-direct .Watch .bestsellerSection .bestItems .itemLabel{height:50px;color:#5e5e5e}@media (max-width:1024px){#diamonds-direct .Watch .bestsellerSection .bestItems .itemLabel{height:20px}}@media (max-width:768px){#diamonds-direct .Watch .bestsellerSection .bestItems .itemLabel{display:block;height:25px}}#diamonds-direct .Watch .bestsellerSection .bestItems .itemLabel .itemLabelName{padding:5px 0 0;font-size:16px;transition:font-size .35s linear 0ms}#diamonds-direct .Watch .bestsellerSection .bestItems .itemLabel .itemLabelPrice{display:none;font-family:Lato,sans-serif;font-size:14px;font-weight:300}@media (max-width:1200px){#diamonds-direct .Watch .bestsellerSection .bestItems .itemLabel .itemLabelPrice{font-size:13px}}#diamonds-direct .Watch .biosSection{display:none}#diamonds-direct .Watch .aboutSection,#diamonds-direct .Watch .serviceSection{border:1px solid #dbdbdb;box-shadow:8px 8px 0 0 rgba(0,0,0,.16);position:relative;z-index:1;background:#fff;margin:0 180px;font-family:Lato,sans-serif;text-align:center;overflow:auto;transition:margin .35s linear 0ms,top .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Watch .aboutSection,#diamonds-direct .Watch .serviceSection{margin:0 80px}}@media (max-width:768px){#diamonds-direct .Watch .aboutSection,#diamonds-direct .Watch .serviceSection{margin:0;top:0;border:none;box-shadow:none}}#diamonds-direct .Watch .aboutSection .infoTitle,#diamonds-direct .Watch .serviceSection .infoTitle{padding:25px 0;text-align:center;text-transform:uppercase;font-weight:700;font-size:34px;color:#5e5e5e;margin:0 25px;transition:font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Watch .aboutSection .infoTitle,#diamonds-direct .Watch .serviceSection .infoTitle{font-size:28px}}#diamonds-direct .Watch .aboutSection .infoDescriptionWrapper,#diamonds-direct .Watch .serviceSection .infoDescriptionWrapper{margin:0 125px;text-align:left;color:#95989a;transition:margin .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .Watch .aboutSection .infoDescriptionWrapper,#diamonds-direct .Watch .serviceSection .infoDescriptionWrapper{margin:0 100px!important}}@media (max-width:600px){#diamonds-direct .Watch .aboutSection .infoDescriptionWrapper,#diamonds-direct .Watch .serviceSection .infoDescriptionWrapper{margin:0 75px!important}}@media (max-width:480px){#diamonds-direct .Watch .aboutSection .infoDescriptionWrapper,#diamonds-direct .Watch .serviceSection .infoDescriptionWrapper{margin:0 25px!important}}#diamonds-direct .Watch .aboutSection .infoDescriptionWrapper .infoDescriptionP,#diamonds-direct .Watch .serviceSection .infoDescriptionWrapper .infoDescriptionP{margin:0 0 25px}#diamonds-direct .Watch .aboutSection{top:-150px;padding:0 0 25px}@media (max-width:768px){#diamonds-direct .Watch .aboutSection{top:0}}#diamonds-direct .Watch .serviceSection{top:-220px;padding:0 0 20px}@media (max-width:768px){#diamonds-direct .Watch .serviceSection{top:0}}#diamonds-direct .Watch .serviceSection .backTopWrapper{height:30px;margin:0 0 10px}#diamonds-direct .Watch .serviceSection .backTopWrapper .backTopLink{display:inline-block;width:auto;position:relative;top:0;cursor:pointer;transition:top .4s ease-in-out 0ms}#diamonds-direct .Watch .serviceSection .backTopWrapper .backTopLink:hover{top:-10px}#diamonds-direct .Watch .serviceSection .backTopWrapper .backTopLink:active{top:-15px}#diamonds-direct .Watch .serviceSection .backTopWrapper .backTopLink .backLabel{font-size:14px;text-transform:uppercase;font-size:300;color:#4e4352;height:14px;line-height:14px;padding:0 0 7px}#diamonds-direct .Watch .serviceSection .backTopWrapper .backTopLink .backArrow{position:relative;top:-13px;height:7px}#diamonds-direct .Watch .serviceSection .backTopWrapper .backTopLink .backArrow img{height:100%}#diamonds-direct .Watch .designersSection{padding:50px 50px 30px;transition:margin .35s linear 0ms;background:#eeeff2;position:relative;overflow:auto;top:-180px}@media (max-width:768px){#diamonds-direct .Watch .designersSection{top:0;padding:0}}#diamonds-direct .Watch .designersSection .bestTitle{margin:0 0 30px;text-align:center;font-size:28px;font-weight:700;text-transform:uppercase;color:#000;font-family:Lato,sans-serif;transition:font-size .35s linear 0ms,margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Watch .designersSection .bestTitle{margin:25px 0 15px;font-size:28px}}@media (max-width:600px){#diamonds-direct .Watch .designersSection .bestTitle{font-size:26px}}@media (max-width:768px){#diamonds-direct .Watch .designersSection .bestTitle{font-size:22px}}#diamonds-direct .Watch .designersSection .brandsWrapper{margin:0 25px;text-align:center}#diamonds-direct .Watch .designersSection .brandsWrapper .brandsElement{display:inline-block;height:60px;width:auto;max-width:150px;margin:0 10px 25px;overflow:hidden}#diamonds-direct .Watch .designersSection .brandsWrapper .brandsElement img{height:100%;width:100%;object-fit:contain}#diamonds-direct .Watch .contactSection{padding:50px 50px 40px;transition:margin .35s linear 0ms;background:#eeeff2;position:relative;overflow:auto;top:-240px}@media (max-width:768px){#diamonds-direct .Watch .contactSection{top:0;padding:0 20px 25px}}#diamonds-direct .Watch .contactSection .bestTitle{margin:0 0 10px;text-align:center;font-size:28px;font-weight:700;text-transform:uppercase;color:#000;font-family:Lato,sans-serif;transition:font-size .35s linear 0ms,margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Watch .contactSection .bestTitle{margin:25px 0 15px;font-size:28px}}@media (max-width:600px){#diamonds-direct .Watch .contactSection .bestTitle{font-size:26px}}@media (max-width:768px){#diamonds-direct .Watch .contactSection .bestTitle{font-size:22px}}#diamonds-direct .Watch .contactSection .contactP{color:#000;text-align:center;font-size:18px;font-family:Lato,sans-serif}#diamonds-direct .Watch .contactSection .contactP .contactLink{cursor:pointer;color:#09f;transition:color .25s ease-in-out 0ms}#diamonds-direct .Watch .contactSection .contactP .contactLink:hover{color:#006ab1}#diamonds-direct .TeamModal{font-family:Lato,sans-serif}#diamonds-direct .TeamModal .contentWrapper .closeIcon{position:absolute;cursor:pointer;color:#4b2d53;background-image:radial-gradient(#4b2d53,#4b2d53);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:16px;right:16px;width:28px;height:28px;border:1px solid #4b2d53;transform:rotate(45deg);z-index:1;transition:top .35s linear 0ms,right .35s linear 0ms,width .35s linear 0ms,height .35s linear 0ms,background-size .25s ease-in-out 0ms}#diamonds-direct .TeamModal .contentWrapper .closeIcon:hover{background-size:100% 100%}#diamonds-direct .TeamModal .contentWrapper .closeIcon:hover .closeX{color:#fff}#diamonds-direct .TeamModal .contentWrapper .closeIcon .closeX{margin:-1px 0 0 -2px;transform:rotate(-45deg);line-height:28px;text-align:center;font-size:28px;font-weight:300;transition:font-size .35s linear 0ms,line-height .35s linear 0ms,color .25s ease-in-out 0ms}@media (max-width:768px){#diamonds-direct .TeamModal .contentWrapper .closeIcon{top:10px;right:10px;width:18px;height:18px}#diamonds-direct .TeamModal .contentWrapper .closeIcon .closeX{font-size:18px;line-height:18px}}#diamonds-direct .TeamModal .contentWrapper .modalLhs{display:inline-block;width:270px;vertical-align:top;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .TeamModal .contentWrapper .modalLhs{width:100%}}#diamonds-direct .TeamModal .contentWrapper .modalLhs .mobileName{margin:10px;height:40px;line-height:40px;font-family:Lusitana,serif;font-size:24px;color:#4b2d53}#diamonds-direct .TeamModal .contentWrapper .modalLhs .mobileTitle{margin:-15px 10px 10px;font-size:20px;font-weight:300;color:#95989a}#diamonds-direct .TeamModal .contentWrapper .modalLhs .teamPhoto{margin:10px}#diamonds-direct .TeamModal .contentWrapper .modalLhs .teamPhoto img{width:100%}#diamonds-direct .TeamModal .contentWrapper .modalLhs .contactEmail{margin:10px 0 0 10px;height:30px;line-height:30px;font-size:16px;color:#95989a;padding:0 0 0 35px;background-image:url(\"https://ddw2.diamondsdirect.com/img/store/mail_purple.svg\");background-repeat:no-repeat;background-size:25px 30px;background-position:0 0;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .TeamModal .contentWrapper .modalLhs .contactEmail{margin:15px 0 0 25px}}#diamonds-direct .TeamModal .contentWrapper .modalLhs .contactEmail a{color:#95989a;text-decoration:none}#diamonds-direct .TeamModal .contentWrapper .modalLhs .contactEmail a:active,#diamonds-direct .TeamModal .contentWrapper .modalLhs .contactEmail a:visited{color:#95989a}#diamonds-direct .TeamModal .contentWrapper .modalLhs .contactPhone{margin:10px 0 20px 10px;height:30px;line-height:30px;font-size:18px;color:#95989a;padding:0 0 0 35px;background-image:url(\"https://ddw2.diamondsdirect.com/img/store/phone_purple.svg\");background-repeat:no-repeat;background-size:15px 25px;background-position:4px 3px;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .TeamModal .contentWrapper .modalLhs .contactPhone{margin:5px 0 0 25px}}#diamonds-direct .TeamModal .contentWrapper .modalRhs{display:inline-block;width:calc(100% - 270px);vertical-align:top;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .TeamModal .contentWrapper .modalRhs{width:100%}}#diamonds-direct .TeamModal .contentWrapper .modalRhs .teamName{margin:10px 20px;height:40px;line-height:40px;font-family:Lusitana,serif;font-size:24px;color:#4b2d53}#diamonds-direct .TeamModal .contentWrapper .modalRhs .teamTitle{margin:-15px 20px 20px;font-size:20px;font-weight:300;color:#95989a}#diamonds-direct .TeamModal .contentWrapper .modalRhs .teamBioWrapper{margin:0;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .TeamModal .contentWrapper .modalRhs .teamBioWrapper{margin:20px 0 0}}#diamonds-direct .TeamModal .contentWrapper .modalRhs .teamBioWrapper .teamBioP{margin:0 20px 20px;color:#5e5e5e}#diamonds-direct .contactModalWrapper{position:relative;overflow-x:hidden;overflow-y:auto;font-family:Lusitana,serif;padding:0 10px}#diamonds-direct .contactModalWrapper .closeIcon{position:absolute;cursor:pointer;color:#707070;background-image:radial-gradient(#707070,#707070);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:16px;right:16px;width:28px;height:28px;border:1px solid #707070;transform:rotate(45deg);z-index:1;transition:top .35s linear 0ms,right .35s linear 0ms,width .35s linear 0ms,height .35s linear 0ms,background-size .25s ease-in-out 0ms}#diamonds-direct .contactModalWrapper .closeIcon:hover{background-size:100% 100%}#diamonds-direct .contactModalWrapper .closeIcon:hover .closeX{color:#fff}#diamonds-direct .contactModalWrapper .closeIcon .closeX{margin:-1px 0 0 -2px;transform:rotate(-45deg);line-height:28px;text-align:center;font-size:28px;font-weight:300;transition:font-size .35s linear 0ms,line-height .35s linear 0ms,color .25s ease-in-out 0ms}@media (max-width:768px){#diamonds-direct .contactModalWrapper .closeIcon{top:10px;right:10px;width:18px;height:18px}#diamonds-direct .contactModalWrapper .closeIcon .closeX{font-size:18px;line-height:18px}}#diamonds-direct .contactModalWrapper .requestTitle{margin:15px 0 5px;text-align:center;font-size:30px}@media (max-width:768px){#diamonds-direct .contactModalWrapper .requestTitle{margin:10px 0;font-size:22px}}#diamonds-direct .contactModalWrapper .requestBr{text-align:center;height:35px}#diamonds-direct .contactModalWrapper .requestBr img{height:100%}@media (max-width:768px){#diamonds-direct .contactModalWrapper .requestBr{height:23px}}#diamonds-direct .contactModalWrapper .watchFormWrapper{padding:0 40px}@media (max-width:768px){#diamonds-direct .contactModalWrapper .watchFormWrapper{padding:0 20px}}#diamonds-direct .contactModalWrapper .watchFormWrapper .inputLabel{font-size:14px;margin:0 0 2px;font-family:Lato,sans-serif}#diamonds-direct .contactModalWrapper .watchFormWrapper .inputWrapper{display:inline-block;margin:0 0 8px}#diamonds-direct .contactModalWrapper .watchFormWrapper .inputWrapper input{border:1px solid #d3d3d3;outline:none;padding:5px;width:calc(100% - 12px);font-size:14px;font-weight:300}#diamonds-direct .contactModalWrapper .watchFormWrapper .inputWrapper textarea{border:1px solid #d3d3d3;outline:none;padding:2px 5px;width:calc(100% - 12px);height:100px;font-size:16px;font-weight:300}#diamonds-direct .contactModalWrapper .watchFormWrapper .inputWrapper input.inputError,#diamonds-direct .contactModalWrapper .watchFormWrapper .inputWrapper textarea.inputError{border:1px solid #eb3533}#diamonds-direct .contactModalWrapper .watchFormWrapper .inputWrapper.secondInput{margin-right:0}#diamonds-direct .contactModalWrapper .watchFormWrapper .fullWidth{width:100%}#diamonds-direct .contactModalWrapper .watchFormWrapper .halfWidth{width:calc(50% - 10px);margin-right:20px}@media (max-width:768px){#diamonds-direct .contactModalWrapper .watchFormWrapper .halfWidth{width:100%;margin:0}}#diamonds-direct .contactModalWrapper .submitWrapper{margin:15px auto 25px;text-align:center}#diamonds-direct .contactModalWrapper .submitWrapper .submitButton{height:32px;line-height:32px;text-transform:none;font-weight:400;width:120px}#diamonds-direct .SaltLakeCity.Store{position:relative}#diamonds-direct .SaltLakeCity.Store .closeContact{position:absolute;cursor:pointer;background-image:radial-gradient(#b78dbb,#b78dbb);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:10px;right:10px;width:22px;height:22px;border:1px solid #b78dbb;transform:rotate(45deg);transition:background-size .25s ease-in-out 0ms}#diamonds-direct .SaltLakeCity.Store .closeContact:hover{background-size:100% 100%}#diamonds-direct .SaltLakeCity.Store .closeContact:hover .closeX{color:#ddd}#diamonds-direct .SaltLakeCity.Store .closeContact .closeX{color:#b78dbb;margin:-1px 0 0 -2px;transform:rotate(-45deg);line-height:22px;text-align:center;font-size:22px;font-weight:300;transition:color .25s ease-in-out 0ms}#diamonds-direct .SaltLakeCity.Store .scheduleSelect{background:#fff;border:1px solid #ddd;margin:1px;width:calc(100% - 3px)}#diamonds-direct .SaltLakeCity.Store .scheduleSelect select{border:1px solid #fff}#diamonds-direct .SaltLakeCity.Store .infoSection{padding-bottom:25px}#diamonds-direct .SaltLakeCity.Store .infoSection .slcLine{width:80%;max-width:600px;margin:0 auto 20px}#diamonds-direct .SaltLakeCity.Store .infoSection .infoDescriptionWrapper .infoDescriptionP{color:#707070}#diamonds-direct .SaltLakeCity.Store .infoSection .infoCTA{width:240px;border:1px solid #797979;color:#3d3d3d;background:#fff;font-size:14px;font-weight:700;margin:10px 20px;text-transform:uppercase}#diamonds-direct .SaltLakeCity.Store .infoSection .infoCTA:hover{color:#fff;background:#797979}#diamonds-direct .SaltLakeCity.Store .slcAppointment{position:relative;top:-120px;padding:50px 0;background:#f4f5f7;z-index:0}#diamonds-direct .SaltLakeCity.Store .slcSocial{position:relative;top:-100px;text-align:center;font-family:Lato,sans-serif}#diamonds-direct .SaltLakeCity.Store .slcSocial .infoSocialHeader{color:#4f4351;font-weight:700;font-size:26px;margin:0 0 15px}#diamonds-direct .SaltLakeCity.Store .slcSocial .infoSocialIcon{display:inline-block;color:#95989a;width:30px;height:30px;cursor:pointer;font-size:30px;line-height:30px;margin:0 10px;transition:color .25s ease-in-out 0ms}#diamonds-direct .SaltLakeCity.Store .slcSocial .infoSocialIcon:hover{color:#4b2d53}#diamonds-direct .SaltLakeCity.Store .slcSocial .slcContactTitle{font-weight:700;font-size:24px;color:#4f4351;margin:20px 0 0}#diamonds-direct .SaltLakeCity.Store .slcSocial .slcContactEmail{font-size:20px;font-weight:300}#diamonds-direct .SaltLakeCity.Store .slcSocial .slcContactEmail a{color:#5e5e5e;text-decoration:none}#diamonds-direct .SaltLakeCity.Store .slcAppointment .open.slcAppointmentWrapper{max-height:1000px}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper{height:auto;position:relative;margin:0 auto 25px;width:90%;max-width:800px;max-height:0;overflow:hidden;text-align:center;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbPrompt{color:#4b2d53;font-size:36px;font-weight:400;margin:25px 0 0}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow{text-align:center;font-family:Lato,sans-serif}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton.selected{background:#b78dbb;border:1px solid #b78dbb}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton.selected .sbButtonLabel{color:#fff}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton.selected .jewelryIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/shop_a.svg\")}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton.selected .bellIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/bell_a.svg\")}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton{display:inline-block;overflow:auto;cursor:pointer;background:#fff;border:1px solid #797979;width:200px;margin:10px 60px;transition:background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton:hover{background:#bf98c3;border:1px solid #b78dbb}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton:hover .sbButtonLabel{color:#fff}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton:hover .jewelryIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/shop_a.svg\")}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton:hover .bellIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/bell_a.svg\")}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton .sbButtonIcon{width:50px;height:50px;margin:10px auto 5px;background-size:contain;background-position:50%;background-repeat:no-repeat}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton .jewelryIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/shop_1.svg\")}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton .bellIcon{background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/bell.svg\")}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbButtonRow .sbButton .sbButtonLabel{margin:8px 0;font-size:16px;font-weight:400;text-transform:uppercase;text-align:center}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper{margin:0 0 20px;transition:height .4s ease-in-out 0ms}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formHeader{text-align:center;font-size:32px;padding:2% 0;background:#ddd;border-bottom:5px solid #b78dbb}@media (max-width:480px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formHeader{margin:15px 0 0;font-size:24px;padding:2% 10%}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody{overflow-x:auto;overflow-y:hidden;font-family:Lato,sans-serif}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formSubheader{margin:15px 0;text-align:center}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow.emRow{background:#e6e6ea;margin:0;padding:10px 0}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow.preBanner{margin:0 10px 10px}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow{margin:10px 10px 0}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .oneHalfSection{display:inline-block;vertical-align:top;overflow:hidden;margin:0 .5%;width:49%;transition:width .35s linear 0ms,margin .35s linear 0ms}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .oneHalfSection input{width:calc(100% - 22px)}@media (max-width:600px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .oneHalfSection{width:100%;margin:0}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .expandableHalfSection.open{max-height:70px}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .expandableHalfSection{height:auto;max-height:0;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .oneThirdSection{display:inline-block;margin:0 1.5%;width:30.3%;vertical-align:top;transition:width .35s linear 0ms,margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .oneThirdSection{width:100%;margin:0}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .radioYesNoLabel.error{color:#eb3533}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .radioYesNoLabel{text-align:left;font-size:14px}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .radioInputRow{font-size:16px;text-align:left}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .radioInputRow .radioInputWrapper{margin:8px 40px 0 2px;transition:margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .radioInputRow .radioInputWrapper{margin-bottom:10px}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .radioInputWrapper{display:inline-block;width:auto}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .radioInputWrapper .radioInputElement{display:inline-block;width:20px}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .radioInputWrapper .radioLabel{display:inline-block;width:auto;margin:0 0 0 8px}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .checkboxInputWrapper{display:inline-block;width:auto}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .checkboxInputWrapper .checkboxInputElement{display:inline-block;width:20px}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .checkboxInputWrapper .checkboxLabel{text-align:left;display:inline-block;width:auto}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow input.checkboxInput,#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow input.radioInput{width:auto}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow input{display:inline-block;margin:5px 0;padding:10px;width:calc(100% - 20px);border:1px solid #ddd;outline:none}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow input::-webkit-input-placeholder{color:#95989a}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow input:-moz-placeholder,#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow input::-moz-placeholder{color:#95989a}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow input:-ms-input-placeholder{color:#95989a}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow input.error{border:1px solid #eb3533}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .textareaLabelWrapper{text-align:left;margin:8px 0 0;font-size:14px}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .textareaInputWrapper{margin:8px 0 0}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow textarea{margin:0;padding:10px;width:calc(100% - 20px);height:75px;border:1px solid #ddd;outline:none}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow textarea::-webkit-input-placeholder{color:#95989a}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow textarea:-moz-placeholder,#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow textarea::-moz-placeholder{color:#95989a}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow textarea:-ms-input-placeholder{color:#95989a}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow textarea.error{border:2px solid #eb3533;width:calc(100% - 34px)}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .selectWrapper{margin-top:4px}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .selectWrapper select{border:none;background:#fff}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .formBody .formRow .submitButton{display:block;width:280px;font-weight:700;padding:10px 0;text-align:center;margin:25px auto;cursor:pointer;font-size:18px;font-weight:400;text-transform:none;height:25px;line-height:25px;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm{position:relative}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper{display:inline-block;width:30%;vertical-align:top;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper{width:45%}}@media (max-width:480px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper{width:40%}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForPrimary{font-size:20px;font-weight:700;display:inline-block;width:80%;margin:10px 0 0 10%;transition:font-size .35s linear 0ms}@media (max-width:600px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForPrimary{font-size:18px}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForSecondary{font-size:16px;font-weight:400;display:inline-block;width:80%;margin:0 0 0 10%;transition:font-size .35s linear 0ms}@media (max-width:600px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForLabelWrapper .shoppingForSecondary{font-size:12px}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper{display:inline-block;width:70%;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper{width:55%}}@media (max-width:480px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper{width:60%}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .checkboxInputWrapper{margin:5px 0}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .checkboxInputWrapper .checkboxLabel{width:200px}@media (max-width:480px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .shoppingForBodyWrapper .checkboxInputWrapper .checkboxLabel{width:140px;margin:0 0 0 8px}}@media (max-width:600px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .apptDaySelection{text-align:center}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper{margin:2px 0;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper{width:80px}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper .radioLabel{width:55px;transition:width .35s linear 0ms;text-align:left}@media (max-width:600px){#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleShoppingForm .apptDaySelection .radioInputWrapper .radioLabel{width:55px}}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleServiceForm{position:relative}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleServiceForm .thirdRow .oneHalfSection{vertical-align:top}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleServiceForm .thirdRow .oneHalfSection .radioYesNoLabel{margin-top:10px;vertical-align:top}#diamonds-direct .SaltLakeCity.Store .slcAppointment .slcAppointmentWrapper .sbFormWrapper .ScheduleServiceForm .thirdRow .oneHalfSection .radioInputRow{vertical-align:top}#diamonds-direct .Terms .termsWrapper{position:relative;margin:0 auto 50px;width:90%;max-width:1024px}#diamonds-direct .Terms .termsWrapper .legalLink{color:#472f51;text-decoration:none}#diamonds-direct .Terms .termsWrapper .legalLink:hover{text-decoration:underline}#diamonds-direct .Terms .termsWrapper .termsTitle{color:#000;font-size:32px;font-weight:400;margin:20px 0 0;text-align:center}#diamonds-direct .Terms .termsWrapper .termsBr{margin:0 auto 20px;width:90%}#diamonds-direct .Terms .termsWrapper .termsBr img{width:100%}#diamonds-direct .Terms .termsWrapper .termsHeader{color:#472f51;font-size:18px;margin:25px 0 15px}#diamonds-direct .Terms .termsWrapper .termsP{font-family:Lato,sans-serif;margin:0 0 15px}#diamonds-direct .ThankYou .thankYouHeader{text-align:center;font-size:40px;padding:3% 0;background:#f0f0f2}#diamonds-direct .ThankYou .thankYouBody{position:relative;margin:0 auto 25px;width:90%;max-width:800px}#diamonds-direct .ThankYou .thankYouBody .thankYouBr{width:100%;height:70px;margin:-35px auto 5px;background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/ddline.svg\");background-repeat:no-repeat;background-position:50%;background-size:cover}@media (max-width:900px){#diamonds-direct .ThankYou .thankYouBody .thankYouBr{width:80%;height:50px;margin-top:-25px}}@media (max-width:480px){#diamonds-direct .ThankYou .thankYouBody .thankYouBr{width:80%;height:40px;margin-top:-20px}}#diamonds-direct .ThankYou .thankYouBody .tyText{text-align:center;font-size:18px;margin:0 0 15px}#diamonds-direct .ThankYou .thankYouBody .tyButtonRow{text-align:center;margin:10px 0}#diamonds-direct .ThankYou .thankYouBody .tyButtonRow .tyButton.tyButtonPrimary{border:1px solid #bf97c2;color:#fff;background:#bf97c2}#diamonds-direct .ThankYou .thankYouBody .tyButtonRow .tyButton.tyButtonPrimary:hover{border:1px solid #b07fb5;color:#fff;background:#b07fb5}#diamonds-direct .ThankYou .thankYouBody .tyButtonRow .tyButton{position:relative;display:inline-block;vertical-align:top;width:240px;height:40px;margin:10px;cursor:pointer;font-weight:700;font-family:Lato,sans-serif;border:1px solid #4e4453;color:#4e4453;background:#fff;transition:border .25s ease-in-out 0ms,color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .ThankYou .thankYouBody .tyButtonRow .tyButton:hover{border:1px solid #bf97c2;color:#fff;background:#bf97c2}#diamonds-direct .ThankYou .thankYouBody .tyButtonRow .tyButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .ThankYou .thankYouBody .tyHoursSection{font-family:Lato,sans-serif;text-align:center;color:#000;margin:10px 0 30px}#diamonds-direct .ThankYou .thankYouBody .tyHoursSection .tyHoursHeader{font-size:22px;font-weight:700}#diamonds-direct .ThankYou .thankYouBody .tyHoursSection .tyHoursWrapper .tyHoursBlock{display:inline-block;vertical-align:top;width:240px;margin:20px 5px 0}#diamonds-direct .ThankYou .thankYouBody .tyHoursSection .tyHoursWrapper .tyHoursBlock .tyBlockDays{font-size:18px;font-weight:700}#diamonds-direct .ThankYou .thankYouBody .tyHoursSection .tyHoursWrapper .tyHoursBlock .tyBlockHours{font-size:18px;font-weight:400}#diamonds-direct .ThankYou .thankYouBody .tyHoursSection .tyHoursTimezone{margin:20px 0 0;font-size:16px;font-weight:300}#diamonds-direct .Warranties{font-family:Lato,sans-serif}#diamonds-direct .Warranties .warPageTitle{color:#000;margin:.5em 0 1.5em 5%;font-size:32px;text-transform:uppercase}#diamonds-direct .Warranties .warBlockWrapper{margin:0 auto 50px;width:90%;max-width:1024px}#diamonds-direct .Warranties .warBlockWrapper .warBlock{position:relative;display:inline-block;vertical-align:top;margin:0 10px 60px;width:calc(33.33% - 20px);background:#f3f3f3;transition:width .35s linear 0ms}@media (max-width:900px){#diamonds-direct .Warranties .warBlockWrapper .warBlock{width:calc(50% - 20px)}}@media (max-width:600px){#diamonds-direct .Warranties .warBlockWrapper .warBlock{width:calc(100% - 20px)}}#diamonds-direct .Warranties .warBlockWrapper .warBlock .warIcon{position:absolute;top:-20px;left:calc(50% - 25px);width:50px;height:50px}#diamonds-direct .Warranties .warBlockWrapper .warBlock .warIcon img{height:100%}#diamonds-direct .Warranties .warBlockWrapper .warBlock .warTitle{position:relative;margin:40px 5% 0;height:40px;color:#000;font-size:18px;font-weight:700;text-align:center}#diamonds-direct .Warranties .warBlockWrapper .warBlock .warTitle div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Warranties .warBlockWrapper .warBlock .warBody{margin:20px 5%;height:270px;text-align:center;transition:height .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .Warranties .warBlockWrapper .warBlock .warBody{height:300px}}@media (max-width:1024px){#diamonds-direct .Warranties .warBlockWrapper .warBlock .warBody{height:350px}}@media (max-width:900px){#diamonds-direct .Warranties .warBlockWrapper .warBlock .warBody{height:270px}}@media (max-width:768px){#diamonds-direct .Warranties .warBlockWrapper .warBlock .warBody{height:350px;height:auto}}#diamonds-direct .Warranties .warBlockWrapper .warBlock .warBody a{color:#000}#diamonds-direct .Account{margin:25px auto;font-family:Lato,sans-serif;width:90%;max-width:1200px}#diamonds-direct .Account .accountMenu{background:#f4f5f7;margin:0 10px 0 0;width:30%;display:inline-block;vertical-align:top}@media (max-width:768px){#diamonds-direct .Account .accountMenu{width:100%;display:block;background:none}}#diamonds-direct .Account .accountMenu .accountMenuWrapper{margin:40px 20px}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountMenuHeader .accountMenuTitle{font-family:Lusitana,serif;font-size:26px}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountMenuHeader .accountMenuSubtitle{font-size:16px;font-weight:300}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper{margin:25px 0 0}@media (max-width:768px){#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper{display:none}}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .selected.accountItem{color:#fff;background-color:#563a5f}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .selected.accountItem:hover{background:#664d6f}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .selected.accountItem .accountInfoItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/account_a.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .selected.accountItem .wishlistItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/wish_a.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .selected.accountItem .openOrdersItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/openo_a.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .selected.accountItem .orderHistoryItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/ohist_a.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .selected.accountItem .appointmentItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/appt_a.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .selected.accountItem .logoutItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/logoff_a.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .accountItem{position:relative;padding:6px 0;font-size:16px;font-weight:300;margin:0 0 2px;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .accountItem:hover{background:#eeebee}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .accountItem .accountInfoItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/account.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .accountItem .wishlistItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/wish.svg\");background-position:9px 3px;background-size:16px}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .accountItem .openOrdersItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/openo.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .accountItem .orderHistoryItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/ohist.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .accountItem .logoutItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/logoff.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .accountItem .appointmentItem.accountLabel{background-image:url(\"https://ddw2.diamondsdirect.com/img/account/appt.svg\")}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemWrapper .accountItem .accountLabel{padding:0 0 0 35px;background-repeat:no-repeat;background-position:10px 2px;background-size:13px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemDropdownWrapper{display:none}@media (max-width:768px){#diamonds-direct .Account .accountMenu .accountMenuWrapper .accountItemDropdownWrapper{display:block}}#diamonds-direct .Account .infoBody.accountBody{background:#f4f5f7}#diamonds-direct .Account .accountBody{width:calc(70% - 10px);display:inline-block;vertical-align:top;color:#707070}@media (max-width:768px){#diamonds-direct .Account .accountBody{width:100%;display:block}}#diamonds-direct .Account .accountBody .accountBodyWrapper .sectionTitle{position:relative;padding:10px;margin:0 0 15px;font-size:20px;font-weight:700}#diamonds-direct .AccountInfo .infoSectionWrapper{margin:0 25px;max-width:800px}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement{display:inline-block;vertical-align:top;margin:0 10px 35px 0}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .emailRow .emailInput{display:inline-block;vertical-align:top;width:30px;text-align:center}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .emailRow .emailLabel{display:inline-block;vertical-align:top;width:calc(100% - 30px);text-align:left}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .elementLabel{font-size:16px;font-weight:700;margin:0 0 10px}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .elementValue{font-size:15px;font-weight:400}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .elementEdit{color:#563a5f;cursor:pointer;font-size:15px;text-decoration:underline;margin:5px 0 0;width:auto;display:inline-block;transition:color .25s ease-in-out 0ms}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .elementEdit:hover{color:#664d6f}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .addressInput.editInput,#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .oldPasswordInput.editInput{margin:0 0 5px}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .editInput input{margin:0;padding:5px;border:1px solid #dedede;width:calc(90% - 12px)}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .editInput input.error{border:1px solid #eb3533}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .editInput select{margin:0;padding:5px;border:1px solid #dedede;width:calc(90% - 12px)}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .editInput select.fingerSelect{width:calc(60% - 12px);font-size:12px}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .editInput select.sizeSelect{width:calc(38% - 12px);margin:0 0 0 5px;font-size:12px}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .editInput select.error{border:1px solid #eb3533}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .editError{margin:5px 0 0;color:#eb3533;font-size:12px;font-weight:400}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .cityWrapper{margin:0 0 5px}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .stateWrapper{display:inline-block;width:45%}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .stateWrapper select{width:calc(100% - 12px)}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .zipWrapper{display:inline-block;width:45%}#diamonds-direct .AccountInfo .infoSectionWrapper .accountElement .editWrapper .zipWrapper input{width:calc(100% - 12px)}#diamonds-direct .AccountInfo .infoSectionWrapper .singleItemElement.accountElement{width:calc(25% - 10px)}@media (max-width:1024px){#diamonds-direct .AccountInfo .infoSectionWrapper .singleItemElement.accountElement{width:calc(50% - 10px)}}@media (max-width:480px){#diamonds-direct .AccountInfo .infoSectionWrapper .singleItemElement.accountElement{width:calc(100% - 10px)}}#diamonds-direct .AccountInfo .infoSectionWrapper .addressItemElement.accountElement{width:calc(50% - 10px)}@media (max-width:480px){#diamonds-direct .AccountInfo .infoSectionWrapper .addressItemElement.accountElement{width:calc(100% - 10px)}}#diamonds-direct .AccountInfo .infoSectionWrapper .addressItemElement.accountElement .elementEmail a,#diamonds-direct .AccountInfo .infoSectionWrapper .addressItemElement.accountElement .elementPhone a{color:#707070;text-decoration:none}#diamonds-direct .AccountInfo .infoSectionWrapper .addressItemElement.accountElement .elementPhone{margin:0 0 5px}#diamonds-direct .AccountInfo .infoSectionWrapper .passwordItemElement.accountElement{width:calc(50% - 10px)}#diamonds-direct .AccountInfo .infoSectionWrapper .optElement.accountElement{width:calc(100% - 10px)}#diamonds-direct .AccountWishlist .sectionTitle{position:relative;padding-left:0;color:#5e5e5e;border-bottom:1px solid #707070}#diamonds-direct .AccountWishlist .sectionTitle .open.wishlistSortDropdown .wishlistLabel .wlIcon{transform:rotate(90deg)}#diamonds-direct .AccountWishlist .sectionTitle .open.wishlistSortDropdown .wishlistLabelBody{max-height:200px}#diamonds-direct .AccountWishlist .sectionTitle .wishlistSortDropdown{position:absolute;top:10px;right:10px;width:200px;bottom:10px;display:none;font-size:16px;font-weight:300}#diamonds-direct .AccountWishlist .sectionTitle .wishlistSortDropdown .wishlistLabel{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:center;align-items:center}#diamonds-direct .AccountWishlist .sectionTitle .wishlistSortDropdown .wishlistLabel .wlLabelValue{margin:0 25px 0 0}#diamonds-direct .AccountWishlist .sectionTitle .wishlistSortDropdown .wishlistLabel .wlIcon{position:absolute;z-index:2;top:5px;right:5px;bottom:2px;width:15px;font-size:14px;text-align:center;transition:transform .4s ease-in-out 0ms}#diamonds-direct .AccountWishlist .sectionTitle .wishlistSortDropdown .wishlistLabelBody{position:relative;z-index:1;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms;background:#fff}#diamonds-direct .AccountWishlist .sectionTitle .wishlistSortDropdown .wishlistLabelBody .wishlistLabelBodyWrapper{border:1px solid #707070}#diamonds-direct .AccountWishlist .sectionTitle .wishlistSortDropdown .wishlistLabelBody .wishlistLabelBodyWrapper .sortItem{margin:3px 10px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .AccountWishlist .sectionTitle .wishlistSortDropdown .wishlistLabelBody .wishlistLabelBodyWrapper .sortItem:hover{color:#4b2d53}#diamonds-direct .AccountWishlist .wishlistSectionWrapper{border-bottom:1px solid #707070}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .nullOrder{margin:40px auto;font-size:24px;font-weight:300}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper{margin:10px 25px}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistNameWrapper{position:relative}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistNameWrapper .wishlistNameValue{display:inline-block;vertical-align:top;width:auto;margin:0 25px 0 0;font-size:20px;font-weight:400}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistNameWrapper .wishlistShare{display:inline-block;vertical-align:top;width:auto;cursor:pointer;color:#4b2d53;margin:3px 0 0}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistNameWrapper .wishlistShare .shareIcon{display:inline-block;vertical-align:top;width:15px}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistNameWrapper .wishlistShare .shareIcon img{width:100%}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistNameWrapper .wishlistShare .shareText{display:inline-block;vertical-align:top;width:auto;margin:1px 0 0 5px;font-size:14px}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistNameWrapper .wishlistDeleteIcon{position:absolute;top:0;right:0;width:20px;height:20px;cursor:pointer}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistNameWrapper .wishlistDeleteIcon img{width:100%}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .nullOrder{margin:0 0 10px;font-size:18px;text-align:left}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct{position:relative;display:inline-block;vertical-align:top;margin:0 5px;width:calc(33.33% - 10px)}@media (max-width:768px){#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct{width:calc(50% - 10px)}}@media (max-width:480px){#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct{width:calc(90% - 10px)}}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .loadingPlaceholder .lpImg{width:30px;margin:0 auto}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .loadingPlaceholder .lpImg img{width:100%}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .loadingPlaceholder .lbText{font-weight:300;text-align:center;margin:0 0 10px}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productImageWrapper{height:200px;text-align:center;margin:20px 0 0;cursor:pointer}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productImageWrapper img{max-height:100%;max-width:100%;object-fit:contain;object-position:center}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productNameWrapper{position:relative;text-align:center;margin:-10px 0 0;padding:20px 0 0;height:30px;cursor:pointer}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productNameWrapper .shareIcon{position:absolute;top:0;right:10px;width:20px;height:20px;cursor:pointer}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productNameWrapper .shareIcon img{max-height:100%;max-width:100%;object-fit:contain;object-position:center}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productNameWrapper .productNameValue{position:absolute;bottom:0;left:0;right:0;height:auto}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productPriceWrapper{margin:10px 0 0;height:25px;font-size:18px;text-align:center;color:#4b2d53}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productNoteWrapper{text-align:center;font-size:14px;text-decoration:none;color:#4b2d53;cursor:pointer}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productNoteWrapper:hover{text-decoration:underline}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productRemoveIcon{position:absolute;top:20px;right:10px;width:12px;height:12px;cursor:pointer}#diamonds-direct .AccountWishlist .wishlistSectionWrapper .wishlistWrapper .wishlistProductsWrapper .WishlistProduct .productWrapper .productRemoveIcon img{max-height:100%;max-width:100%;object-fit:contain;object-position:center}#diamonds-direct .AccountWishlist .createWrapper .createLink{cursor:pointer;color:#4b2d53;margin:5px 0 0;font-size:20px;text-transform:uppercase}#diamonds-direct .AccountWishlist .createWrapper .createLink .createLinkIcon{display:inline-block;vertical-align:top;font-weight:700;margin:-5px 5px 0 0;font-size:26px}#diamonds-direct .AccountWishlist .createWrapper .createLink .createLinkValue{display:inline-block;vertical-align:top;font-weight:400;cursor:pointer}#diamonds-direct .AccountWishlist .createWrapper .createLink .expanded.createForm{max-height:200px}#diamonds-direct .AccountWishlist .createWrapper .createLink .createForm{display:block;overflow:hidden;height:auto;max-height:0;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .AccountWishlist .createWrapper .createLink .createForm .cfInner .cfInput{display:inline-block;vertical-align:top;margin:0 20px 10px 0;width:calc(100% - 100px)}#diamonds-direct .AccountWishlist .createWrapper .createLink .createForm .cfInner .cfInput input{padding:5px 10px;font-size:18px;border:1px solid #adadad;width:calc(100% - 24px)}@media (max-width:768px){#diamonds-direct .AccountWishlist .createWrapper .createLink .createForm .cfInner .cfInput{display:block;width:100%;margin:0 0 10px}}#diamonds-direct .AccountWishlist .createWrapper .createLink .createForm .cfInner .cfButton{display:inline-block;vertical-align:top;margin:0 0 10px;width:70px;height:20px;background:#4b2d53;color:#fff;cursor:pointer;font-size:16px;padding:6px 5px;transition:background .25s ease-in-out 0ms}#diamonds-direct .AccountWishlist .createWrapper .createLink .createForm .cfInner .cfButton:hover{background:#4b2d53}@media (max-width:768px){#diamonds-direct .AccountWishlist .createWrapper .createLink .createForm .cfInner .cfButton{display:block;width:100%}}#diamonds-direct .AccountWishlist .shareModalWrapper{position:relative;overflow:hidden auto}#diamonds-direct .AccountWishlist .shareModalWrapper .shareClose{position:absolute;cursor:pointer;background-image:radial-gradient(#707070,#707070);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:10px;right:10px;width:18px;height:18px;border:1px solid #707070;transform:rotate(45deg);transition:background-size .25s ease-in-out 0ms}#diamonds-direct .AccountWishlist .shareModalWrapper .shareClose:hover{background-size:100% 100%}#diamonds-direct .AccountWishlist .shareModalWrapper .shareClose:hover .closeX{color:#fff}#diamonds-direct .AccountWishlist .shareModalWrapper .shareClose .closeX{color:#707070;margin:-1px 0 0 -2px;transform:rotate(-45deg);line-height:18px;text-align:center;font-size:18px;font-weight:300;transition:color .25s ease-in-out 0ms}#diamonds-direct .AccountWishlist .shareModalWrapper .shareModalTitle{margin:25px 0 10px;font-family:Lusitana,serif;text-transform:uppercase;font-size:22px;text-align:center;color:#3d3d3d}#diamonds-direct .AccountWishlist .shareModalWrapper .shareModalHr{margin:0 auto;width:90%}#diamonds-direct .AccountWishlist .shareModalWrapper .shareModalHr img{width:100%}#diamonds-direct .AccountWishlist .shareModalWrapper .shareModalText{margin:10px 0 20px;text-align:center}#diamonds-direct .AccountWishlist .shareModalWrapper .shareButtonWrapper{text-align:center}#diamonds-direct .AccountWishlist .shareModalWrapper .shareButtonWrapper .shareSecondary{border:1px solid #4b2d53;color:#4b2d53;background:#fff;cursor:pointer;width:120px;margin:0 20px 20px;display:inline-block;vertical-align:top;padding:6px 10px;text-transform:uppercase;font-size:14px;font-weight:400}#diamonds-direct .AccountWishlist .shareModalWrapper .shareButtonWrapper .sharePrimary{border:1px solid #4b2d53;color:#fff;background:#4b2d53;cursor:pointer;width:120px;margin:0 20px 20px;display:inline-block;vertical-align:top;padding:6px 10px;text-transform:uppercase;font-size:14px;font-weight:700}#diamonds-direct .AccountWishlist .shareModalWrapper .shareFormWrapper{margin:0 10% 25px}#diamonds-direct .AccountWishlist .shareModalWrapper .shareFormWrapper .shareForm .shareInputRow{margin:10px 0 0}#diamonds-direct .AccountWishlist .shareModalWrapper .shareFormWrapper .shareForm .shareInputRow .shareInputLabel{font-size:12px;font-weight:700}#diamonds-direct .AccountWishlist .shareModalWrapper .shareFormWrapper .shareForm .shareInputRow .shareInputWrapper .error.shareInput{border:1px solid #eb3533}#diamonds-direct .AccountWishlist .shareModalWrapper .shareFormWrapper .shareForm .shareInputRow .shareInputWrapper .shareInput{padding:3px 10px;border:1px solid #707070;width:calc(100% - 22px);margin:3px 0 0;font-weight:300}#diamonds-direct .AccountWishlist .shareModalWrapper .shareFormWrapper .shareForm .shareInputRow .shareInputError{color:#eb3533;font-size:12px;font-weight:700}#diamonds-direct .AccountWishlist .shareModalWrapper .shareFormWrapper .shareForm .shareInputRow .shareSubmitWrapper{margin:20px 0 0;text-align:center}#diamonds-direct .AccountWishlist .shareModalWrapper .shareFormWrapper .shareForm .shareInputRow .shareSubmitWrapper .shareSubmitButton{font-size:14px;width:140px;height:35px;line-height:35px}#diamonds-direct .AccountOrders{font-family:Lato,sans-serif;color:#5e5e5e}#diamonds-direct .AccountOrders .sectionTitle{position:relative;padding-left:0;color:#707070}#diamonds-direct .AccountOrders .sectionTitle .open.ordersDropdown .ordersDropdownHead .dropdownIcon{transform:rotate(90deg)}#diamonds-direct .AccountOrders .sectionTitle .open.ordersDropdown .ordersDropdownBody{max-height:200px}#diamonds-direct .AccountOrders .sectionTitle .ordersDropdown{position:absolute;top:10px;right:10px;width:140px;bottom:10px;font-size:16px;font-weight:300}#diamonds-direct .AccountOrders .sectionTitle .ordersDropdown .ordersDropdownHead{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:center;align-items:center}#diamonds-direct .AccountOrders .sectionTitle .ordersDropdown .ordersDropdownHead .headDropdownValue{margin:0 25px 0 0}#diamonds-direct .AccountOrders .sectionTitle .ordersDropdown .ordersDropdownHead .dropdownIcon{position:absolute;z-index:2;top:5px;right:5px;bottom:2px;width:15px;font-size:14px;text-align:center;transition:transform .4s ease-in-out 0ms}#diamonds-direct .AccountOrders .sectionTitle .ordersDropdown .ordersDropdownBody{position:relative;z-index:1;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms;background:#fff}#diamonds-direct .AccountOrders .sectionTitle .ordersDropdown .ordersDropdownBody .dropdownBodyWrapper{border:1px solid #707070}#diamonds-direct .AccountOrders .sectionTitle .ordersDropdown .ordersDropdownBody .dropdownBodyWrapper .dropdownItem{margin:3px 10px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .AccountOrders .sectionTitle .ordersDropdown .ordersDropdownBody .dropdownBodyWrapper .dropdownItem:hover{color:#563a5f}#diamonds-direct .AccountOrders .ordersWrapper{position:relative;margin:0 10px}#diamonds-direct .AccountOrders .ordersWrapper .optWrapper{margin:20px 0 0;padding:0 0 10px;border:1px solid ountOrdersHeaderColor}#diamonds-direct .AccountOrders .ordersWrapper .optWrapper .optText{margin:0 0 10px;text-align:left;font-size:16px}@media (max-width:768px){#diamonds-direct .AccountOrders .ordersWrapper .optWrapper .optText{font-size:14px}}#diamonds-direct .AccountOrders .ordersWrapper .optWrapper .optText a{color:#5e5e5e}#diamonds-direct .AccountOrders .ordersWrapper .optWrapper .optButton{display:block;position:relative;margin:0 auto 40px;width:160px;height:40px;background:#4b2d53;color:#fff;cursor:pointer;text-transform:uppercase;font-size:18px;font-weight:700;transition:background .25s ease-in-out 0ms}#diamonds-direct .AccountOrders .ordersWrapper .optWrapper .optButton:hover{background:#623b6c}#diamonds-direct .AccountOrders .ordersWrapper .optWrapper .optButton div{position:absolute;top:0;right:0;left:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .AccountOrders .ordersWrapper .openOrdersNotice{margin:0 0 10px}#diamonds-direct .AccountOrders .ordersWrapper .openOrdersNotice .openNoticeLink{font-weight:700;cursor:pointer;color:#4b2d53}#diamonds-direct .AccountOrders .ordersWrapper .openOrdersNotice .openNoticeLink:hover{text-decoration:underline;color:#623b6c}#diamonds-direct .AccountOrders .ordersWrapper .nullOrder{margin:40px auto;font-size:24px;font-weight:300}#diamonds-direct .AccountOrders .ordersWrapper .open.orderItem .orderBody{max-height:1000px}#diamonds-direct .AccountOrders .ordersWrapper .orderItem{position:relative;border-bottom:1px solid #707070}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderHead{position:relative;color:#707070}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderHead .ohDate{position:relative;margin:12px 10px;width:80px;font-size:16px;font-weight:700;display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderHead .ohCount{position:absolute;top:0;bottom:0;left:100px;right:45%;font-size:15px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderHead .ohNotes{position:absolute;top:0;bottom:0;left:55%;right:150px;font-size:15px;display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center}@media (max-width:768px){#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderHead .ohNotes{display:none}}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderHead .ohPriceWrapper{position:absolute;top:0;bottom:0;width:100px;right:50px;display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:center;align-items:center;font-size:18px}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderHead .ohPriceWrapper .ohPriceSign{display:inline-block;vertical-align:top;font-size:11px;margin-top:-3px}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderHead .ohPriceWrapper .ohPriceDollars{display:inline-block;vertical-align:top}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderHead .ohPriceWrapper .ohPriceCents{display:inline-block;vertical-align:top;font-size:11px;margin-top:-3px}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderHead .ohIconWrapper{position:absolute;top:0;bottom:0;width:20px;right:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;font-size:24px;font-weight:700;cursor:pointer}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody{height:auto;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper{position:relative}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper{position:relative;margin:0 0 15px}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodImageWrapper{display:inline-block;vertical-align:top;margin:5px 10px;height:100px;width:80px}@media (max-width:768px){#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodImageWrapper{height:60px}}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodImageWrapper img{max-width:100%;max-height:100%;object-fit:contain;object-position:center}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodNameWrapper{display:inline-block;vertical-align:top;width:calc(55% - 100px)}@media (max-width:768px){#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodNameWrapper{display:block;width:100%}}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodNameWrapper .prodNamePrimary{font-family:Lusitana,serif;margin:5px 25px 0;font-size:16px;font-weight:700}@media (max-width:768px){#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodNameWrapper .prodNamePrimary{margin:0 10px 5px}}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodNameWrapper .prodNameSku{margin:0 25px;font-size:14px;font-weight:300}@media (max-width:768px){#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodNameWrapper .prodNameSku{margin:0 10px}}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodNameWrapper .prodDescription{margin:0 25px;font-size:14px;font-weight:300}@media (max-width:768px){#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodNameWrapper .prodDescription{margin:0 10px}}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .inStoreNotes.prodNotesWrapper{display:block;text-align:center}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .inStoreNotes.prodNotesWrapper .iconsLabel{margin:0 0 3px}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .inStoreNotes.prodNotesWrapper .emailIcon{display:inline-block;vertical-align:top;width:25px;font-size:24px;color:#4b2d53;cursor:pointer;margin:0 10px}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .inStoreNotes.prodNotesWrapper .emailIcon:hover{color:#623b6c}@media (max-width:768px){#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .inStoreNotes.prodNotesWrapper .emailIcon{width:20px;margin:3px 5px;font-size:18px}}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .inStoreNotes.prodNotesWrapper .phoneIcon{display:inline-block;vertical-align:top;width:25px;font-size:24px;color:#4b2d53;cursor:pointer;margin:0 10px}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .inStoreNotes.prodNotesWrapper .phoneIcon:hover{color:#623b6c}@media (max-width:768px){#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .inStoreNotes.prodNotesWrapper .phoneIcon{width:20px;margin:3px 5px;font-size:18px}}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodNotesWrapper{display:none;position:absolute;top:0;bottom:0;left:55%;right:150px;margin:20px 0 0;font-size:15px;font-weight:300}#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodPriceWrapper{position:absolute;top:0;bottom:0;width:100px;right:10px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;font-family:Lusitana,serif;font-size:18px}@media (max-width:768px){#diamonds-direct .AccountOrders .ordersWrapper .orderItem .orderBody .orderBodyWrapper .productWrapper .prodPriceWrapper{bottom:auto;height:60px}}#diamonds-direct .AccountOrders .ordersWrapper .haveExternal .inStoreDisclaimer{margin:10px 0;font-size:13px}#diamonds-direct .AccountOrders .ordersWrapper .haveExternal .inStoreDisclaimer .disclaimerLink{font-weight:700;cursor:pointer;color:#4b2d53}#diamonds-direct .AccountOrders .ordersWrapper .haveExternal .inStoreDisclaimer .disclaimerLink:hover{text-decoration:underline;color:#623b6c}#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbPrompt{color:#523c5d;font-family:Lusitana,serif}#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton{margin:10px 20px;width:180px;background:#f0f0f2}#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton:hover{background:#bf98c3}#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbButtonRow .sbButton .sbButtonLabel{text-transform:none}#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ContactPage .closeContact,#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleServiceForm .closeContact,#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .closeContact{display:none}#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ContactPage .formHeader,#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ContactPage .scheduleHeader,#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleServiceForm .formHeader,#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleServiceForm .scheduleHeader,#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .formHeader,#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ScheduleShoppingForm .scheduleHeader{background:#f0f0f2;font-family:Lusitana,serif;margin-top:0;font-size:32px;padding:2% 0;border-bottom:5px solid #b78dbb}#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ContactPage .scheduleBody{width:100%;margin-top:20px}#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ContactPage .scheduleBody .scheduleBr,#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .ContactPage .scheduleFooterSpacer{display:none}#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .sbFormClose{position:absolute;top:5px;right:5px;height:20px;width:60px;text-align:right;cursor:pointer;color:#858585;transition:color .25s ease-in-out 0ms}#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .sbFormClose:hover{color:#333}@media (max-width:768px){#diamonds-direct .AccountAppointment .ScheduleAppointment .scheduleBody .sbFormWrapper .sbFormClose{top:-25px}}#diamonds-direct .EducationPage .eduHeader{background:#472f51;color:#fff;padding:15px 3%;font-size:32px}#diamonds-direct .EducationDiamond.EducationPage .eduBody{font-family:Lato,sans-serif;margin:0 auto;width:auto;max-width:1024px}#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader{width:90%;margin:25px auto}#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edhTitle{display:inline-block;vertical-align:top;width:calc(40% - 51px);padding-right:50px;border-right:1px solid #472f51}@media (max-width:768px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edhTitle{display:block;width:100%;padding:0;border-right:none}}#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edhTitle img{width:100%}#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edBr{display:none}@media (max-width:768px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edBr{display:block;width:70%;height:2px;background:#472f51;margin:30px auto}}#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edHeaderText{display:inline-block;vertical-align:top;width:60%}@media (max-width:768px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edHeaderText{display:block;width:100%}}#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edHeaderText .edhTextWrapper{margin:10px 100px 20px 50px;font-size:28px}@media (max-width:1200px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edHeaderText .edhTextWrapper{margin:0 40px 10px 30px;font-size:24px}}@media (max-width:900px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edHeaderText .edhTextWrapper{margin:0 10px 10px 20px;font-size:20px}}@media (max-width:768px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .edHeader .edHeaderText .edhTextWrapper{display:block;width:100%;margin:0}}#diamonds-direct .EducationDiamond.EducationPage .eduBody .shopDiamondsWrapper{text-align:center;margin:0 0 20px}#diamonds-direct .EducationDiamond.EducationPage .eduBody .shopDiamondsWrapper .ttLink{text-align:center;text-transform:uppercase;font-size:26px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .EducationDiamond.EducationPage .eduBody .shopDiamondsWrapper .ttLink:hover{color:#acacac}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection{width:100%;margin:0 auto;position:relative}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection img{width:100%;display:block}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection .fsMobTopImage{position:relative;z-index:-1}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection .fsMobTopImage img{width:100%}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection .fsMobInfoElement{position:relative;z-index:1;width:90%;margin:0 auto 20px}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection .fsMobInfoElement img{width:100%}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection .fsElem1.fsMobInfoElement{margin-top:-35%}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection .fsElem2.fsMobInfoElement{margin-bottom:-30%}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection .fsElem3.fsMobInfoElement{margin-top:-40%}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection .fsElem4.fsMobInfoElement{margin-bottom:-10%}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection .fsMobMidImage{position:relative;z-index:-1}#diamonds-direct .EducationDiamond.EducationPage .eduBody .fourSection .fsMobMidImage img{width:100%}#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection{position:relative;padding:25px 5%;margin:0 auto;background:#e4e5e6}@media (max-width:768px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection{padding-top:22%}}#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingDiamonds{position:absolute;top:-160px;right:0;width:25%;height:auto;z-index:2}#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingDiamonds img{width:100%}@media (max-width:1200px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingDiamonds{top:-140px}}@media (max-width:900px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingDiamonds{top:-80px}}#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingTitle{color:#000;font-size:22px;font-weight:700;text-transform:uppercase}@media (max-width:768px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingTitle{font-size:26px;text-align:center}}#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingWrapper{margin:25px 0 0;text-align:center}#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingWrapper .gradingItem{display:inline-block;vertical-align:top;width:calc(33.3% - 40px);margin:0 20px 20px}@media (max-width:768px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingWrapper .gradingItem{width:calc(90% - 40px)}}#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingWrapper .gradingItem .giImg{margin:0;height:70px;text-align:center}#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingWrapper .gradingItem .giImg img{height:100%}#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingWrapper .gradingItem .giLabel{margin:10px 0 0;text-align:center;font-size:18px;font-weight:700;color:#472f51}#diamonds-direct .EducationDiamond.EducationPage .eduBody .gradingSection .gradingWrapper .gradingItem .giText{margin:10px 0 0;font-size:16px;color:#000}#diamonds-direct .EducationDiamond.EducationPage .eduBody .measurementSection{width:90%;margin:0 auto;color:#000}#diamonds-direct .EducationDiamond.EducationPage .eduBody .measurementSection .msTitle{color:#000;text-align:center;margin:25px 0;font-family:Lusitana,serif;font-size:32px}#diamonds-direct .EducationDiamond.EducationPage .eduBody .measurementSection .msCopy{margin:10px 0 35px;font-size:16px}#diamonds-direct .EducationDiamond.EducationPage .eduBody .measurementSection .msBody img{width:100%}#diamonds-direct .EducationDiamond.EducationPage .eduBody .certSection{margin:50px 0}#diamonds-direct .EducationDiamond.EducationPage .eduBody .certSection .csInnerWrapper{position:relative;padding:25px 5%;background:#e4e5e6}#diamonds-direct .EducationDiamond.EducationPage .eduBody .certSection .csInnerWrapper .csText{margin:0 35% 0 0}@media (max-width:768px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .certSection .csInnerWrapper .csText{margin:0}}#diamonds-direct .EducationDiamond.EducationPage .eduBody .certSection .csInnerWrapper .csText .cstTitle{color:#000;text-align:left;margin:0 0 25px;font-family:Lusitana,serif;font-size:32px}@media (max-width:768px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .certSection .csInnerWrapper .csText .cstTitle{text-align:center;margin:0 0 10px;font-size:36px}}#diamonds-direct .EducationDiamond.EducationPage .eduBody .certSection .csInnerWrapper .csImage{position:absolute;top:-50px;right:5%;bottom:-50px;width:30%;background-image:url(\"https://ddw2.diamondsdirect.com/img/education/diamond/desktop/certificate.png\");background-repeat:no-repeat;background-position:50%;background-size:contain}@media (max-width:768px){#diamonds-direct .EducationDiamond.EducationPage .eduBody .certSection .csInnerWrapper .csImage{position:relative;padding-bottom:80.3%;width:90%;margin:0 auto;right:0;top:0;bottom:0;background-image:url(\"https://ddw2.diamondsdirect.com/img/education/diamond/mobile/certificate_m.png\")}}#diamonds-direct .EducationGem.EducationPage .gemLink{text-align:center;text-transform:uppercase;font-size:26px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .EducationGem.EducationPage .gemLink:hover{color:#acacac}#diamonds-direct .EducationGem.EducationPage .eduBody{font-family:Lato,sans-serif}#diamonds-direct .EducationGem.EducationPage .eduBody .gemTitle{color:#472f51;font-family:Lusitana,serif;font-size:36px;margin:25px 0}@media (max-width:1024px){#diamonds-direct .EducationGem.EducationPage .eduBody .gemTitle{margin:10px 0}}#diamonds-direct .EducationGem.EducationPage .eduBody .gemTitle.titleSmall{font-size:32px}#diamonds-direct .EducationGem.EducationPage .eduBody .gemP{margin:0 0 20px;font-size:16px}@media (max-width:1024px){#diamonds-direct .EducationGem.EducationPage .eduBody .gemP{margin:0 0 10px;font-size:14px}}#diamonds-direct .EducationGem.EducationPage .eduBody .gemP.halfWidth{margin-right:50%}#diamonds-direct .EducationGem.EducationPage .eduBody .gemSection .gemImg{display:inline-block;vertical-align:top;width:50%}@media (max-width:768px){#diamonds-direct .EducationGem.EducationPage .eduBody .gemSection .gemImg{display:block;width:100%}}#diamonds-direct .EducationGem.EducationPage .eduBody .gemSection .gemImg img{width:100%}#diamonds-direct .EducationGem.EducationPage .eduBody .gemSection .gemText{display:inline-block;vertical-align:top;width:40%}@media (max-width:768px){#diamonds-direct .EducationGem.EducationPage .eduBody .gemSection .gemText{display:block;width:90%;margin:0 auto}}#diamonds-direct .EducationGem.EducationPage .eduBody .gemSection .gemText .gemP{font-size:20px;line-height:1.3}@media (max-width:1500px){#diamonds-direct .EducationGem.EducationPage .eduBody .gemSection .gemText .gemP{font-size:18px;line-height:1.2}}@media (max-width:1200px){#diamonds-direct .EducationGem.EducationPage .eduBody .gemSection .gemText .gemP{font-size:16px;line-height:1.1}}@media (max-width:1024px){#diamonds-direct .EducationGem.EducationPage .eduBody .gemSection .gemText .gemP{font-size:16px;line-height:1.1}}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection{background-image:url(\"https://ddw2.diamondsdirect.com/img/education/gem/desktop/pearl_neck.jpg\");background-repeat:no-repeat;background-size:50% 100%;background-position:100%;padding-bottom:25%}@media (max-width:768px){#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection{background:none;padding-bottom:0}}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox{position:relative;width:80%;margin:-18% auto 0;box-shadow:6px 6px 6px 0 #ebebeb;background:#fff;overflow:auto;z-index:1;transition:margin .35s linear 0ms}@media (max-width:1500px){#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox{margin-top:-15%}}@media (max-width:1200px){#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox{margin-top:-12%}}@media (max-width:1024px){#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox{margin-top:-8%}}@media (max-width:900px){#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox{margin-top:0}}@media (max-width:768px){#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox{width:100%;margin:25px 0 0}}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper{margin:25px 50px}@media (max-width:768px){#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper{margin:10px 15px}}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .gemTitle{text-align:center}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxBr{margin:-10px 0 10px}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxBr img{width:100%}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxP{margin:0 0 20px}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxGemWrapper{text-align:center}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxGemWrapper .boxGemItem{display:inline-block;vertical-align:top;margin:0 10px 20px;width:calc(25% - 20px);transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxGemWrapper .boxGemItem{width:calc(33% - 20px)}}@media (max-width:480px){#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxGemWrapper .boxGemItem{width:calc(50% - 20px)}}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxGemWrapper .boxGemItem .boxGemImg{height:50px}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxGemWrapper .boxGemItem .boxGemImg img{height:100%}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxGemWrapper .boxGemItem .boxGemMonth{color:#4d4d4d;margin:5px 0 0;font-weight:700}#diamonds-direct .EducationGem.EducationPage .eduBody .birthSection .birthBox .boxWrapper .boxGemWrapper .boxGemItem .boxGemLabel{color:#4d4d4d;font-weight:400}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection{width:80%;margin:-15% auto 0}@media (max-width:768px){#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection{width:100%;margin:0 auto}}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .pearlMobTopImg{margin:-10px 0 0}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .pearlMobTopImg img{width:100%}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .pearlMobileTitle{width:90%;margin:-10% auto 20px}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .pearlGemP{width:90%;margin:0 auto 10px}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .gemInfo{position:relative;width:80%;margin:0 auto 35px;box-shadow:6px 6px 6px 0 #ebebeb;z-index:1}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .gemInfo img{width:100%}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .gemInfo3{margin-top:-70%}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .gemMobMidImage{margin:-35% 0 0}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .gemMobMidImage img{width:100%}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .gemMobLastImage{position:relative;margin-top:-22%;z-index:1}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .gemMobLastImage img{width:100%}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .gemOriginSection{position:relative;margin:-80% auto 0;padding:80% 5% 0;background-image:url(\"https://ddw2.diamondsdirect.com/img/education/gem/mobile/origins_m.jpg\");background-repeat:no-repeat;background-size:cover}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlSection .gemOriginSection .pearlLocation .plName{color:#472f51;font-family:Lusitana,serif;font-size:24px;margin:20px 0 10px}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlCharSection{width:100%;margin:0 auto}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlCharSection .pearlTopArea{position:relative}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlCharSection .pearlTopArea img{width:100%}@media (max-width:1200px){#diamonds-direct .EducationGem.EducationPage .eduBody .pearlCharSection .pearlTopArea img{margin-top:20px}}@media (max-width:1024px){#diamonds-direct .EducationGem.EducationPage .eduBody .pearlCharSection .pearlTopArea img{margin-top:60px}}@media (max-width:900px){#diamonds-direct .EducationGem.EducationPage .eduBody .pearlCharSection .pearlTopArea img{margin-top:100px}}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlCharSection .pearlTopArea .pearlTextArea{position:absolute;top:0;left:10%;width:40%;height:auto}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlCharSection .pearlBottomArea{margin:-35% auto 0}#diamonds-direct .EducationGem.EducationPage .eduBody .pearlCharSection .pearlBottomArea img{width:100%}#diamonds-direct .EducationMetal.EducationPage{font-family:Lato,sans-serif}#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection{position:relative;text-align:center}#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topImgBlock{display:inline-block;vertical-align:top;width:30%;transition:width .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topImgBlock{width:40%}}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topImgBlock{display:block;width:100%}}#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topImgBlock img{width:100%}#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock{display:inline-block;vertical-align:top;width:70%;text-align:left;padding:60px 0 0;font-size:26px;transition:padding .35s linear 0ms,width .35s linear 0ms}@media (max-width:1500px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock{padding:20px 0 0;font-size:18px}}@media (max-width:1200px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock{padding:10px 0 0;font-size:18px}}@media (max-width:1024px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock{padding:10px 0 0;width:60%}}@media (max-width:900px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock{padding:20px 0 0}}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock{position:relative;display:block;width:90%;margin:-45% auto 0;border:1px solid #4d4d4d;background:#fff;z-index:1}}#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock .ttP{margin:0 35px 30px 50px;transition:font-size .35s linear 0ms}@media (max-width:1500px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock .ttP{font-size:20px}}@media (max-width:1200px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock .ttP{font-size:18px}}@media (max-width:1024px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock .ttP{font-size:14px}}@media (max-width:900px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock .ttP{margin:0 35px 20px 50px}}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock .ttP{font-size:18px}}#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock .ttLink{text-align:center;text-transform:uppercase;font-size:26px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock .ttLink:hover{color:#472f51}@media (max-width:1024px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock .ttLink{font-size:20px}}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .topSection .topTextBlock .ttLink{margin:0 0 25px}}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection{margin:-10% 0 0}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection{margin:-4% 0 0}}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper{width:90%;max-width:1024px;margin:0 auto}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .imgLeft.metalItem .miImgWrapper{left:0}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .imgLeft.metalItem .miTextWrapper{margin-left:10%}@media (max-width:1500px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .imgLeft.metalItem .miTextWrapper{margin-left:12%}}@media (max-width:1200px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .imgLeft.metalItem .miTextWrapper{margin-left:18%}}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .imgLeft.metalItem .miTextWrapper{margin-left:auto}}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .imgRight.metalItem .miImgWrapper{right:0}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .imgRight.metalItem .miTextWrapper{margin-right:10%}@media (max-width:1500px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .imgRight.metalItem .miTextWrapper{margin-right:12%}}@media (max-width:1200px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .imgRight.metalItem .miTextWrapper{margin-right:18%}}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .imgRight.metalItem .miTextWrapper{margin-right:auto}}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem{position:relative;margin:0 0 25px}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miImgWrapper{position:absolute;top:0;width:13%;height:100%;z-index:1;text-align:center}@media (max-width:1500px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miImgWrapper{width:15%}}@media (max-width:1200px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miImgWrapper{width:21%}}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miImgWrapper{position:relative;width:60%;margin:0 auto}}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miImgWrapper img{max-width:100%;max-height:100%;vertical-align:top}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miTextWrapper{position:relative;border:1px solid #acacac;width:calc(100% - 10% - 2px);background:#fff;padding:0 0 20px;transition:width .35s linear 0ms,margin .35s linear 0ms}@media (max-width:1500px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miTextWrapper{width:calc(100% - 12% - 2px)}}@media (max-width:1200px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miTextWrapper{width:calc(100% - 18% - 2px)}}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miTextWrapper{border:1px solid #4d4d4d;width:90%;margin:-30% auto 0}}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miTextWrapper .miElemNumber{position:absolute;top:0;left:5px;width:auto;height:auto;color:#acacac;font-size:12px}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miTextWrapper .miElemSymbol{position:absolute;top:0;right:5px;width:auto;height:auto;color:#acacac;font-size:32px;font-weight:700}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miTextWrapper .miTitle{width:90%;margin:40px auto 25px;font-family:Lusitana,serif;font-size:20px;color:#472f51;text-transform:uppercase}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miTextWrapper .miTitle{margin-top:140px;font-size:32px}}@media (max-width:480px){#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miTextWrapper .miTitle{margin-top:80px;font-size:26px}}#diamonds-direct .EducationMetal.EducationPage .eduBody .metalsSection .metalsWrapper .metalItem .miTextWrapper .miP{width:90%;margin:0 auto 20px}#diamonds-direct .EducationMetal.EducationPage .eduBody .altSection{background:#e4e5e6;padding:25px 0}#diamonds-direct .EducationMetal.EducationPage .eduBody .altSection .asTitle{width:90%;margin:0 auto 25px;font-family:Lusitana,serif;font-size:20px;color:#472f51;text-transform:uppercase}#diamonds-direct .EducationMetal.EducationPage .eduBody .altSection .asP{width:90%;margin:0 auto 20px}#diamonds-direct .EducationMetal.EducationPage .eduBody .altSection .asLink{text-align:center;text-transform:uppercase;font-size:26px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .EducationMetal.EducationPage .eduBody .altSection .asLink:hover{color:#472f51}@media (max-width:1024px){#diamonds-direct .EducationMetal.EducationPage .eduBody .altSection .asLink{font-size:20px}}@media (max-width:768px){#diamonds-direct .EducationMetal.EducationPage .eduBody .altSection .asLink{font-size:18px}}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStyleHeaderSection{background:#472f51;padding:0 0 60px;transition:padding .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStyleHeaderSection{padding:0 0 5%}}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper{margin:-100px auto 0;width:90%;max-width:1024px;text-align:center}@media (max-width:1200px){#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper{margin-top:-10%}}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem{display:inline-block;vertical-align:top;margin:0 10px 20px;width:calc(33.33% - 20px);font-family:Lato,sans-serif;transition:width .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem{width:calc(50% - 20px)}}@media (max-width:600px){#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem{width:calc(90% - 20px)}}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiImgWrapper{width:100%;position:relative;z-index:1}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiImgWrapper img{width:100%}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiBoxWrapper{position:relative;overflow:auto;margin:-80px 0 0;background:#fff}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiBoxWrapper .esiBoxInnerWrapper{position:relative;padding:55px 0 24px;margin:5px;border:1px solid #bbb2be}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiBoxWrapper .esiBoxInnerWrapper .esbTitle{color:#472f51;font-family:Lusitana,serif;font-weight:700;font-size:22px}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiBoxWrapper .esiBoxInnerWrapper .esbBr{width:90%;margin:0 auto}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiBoxWrapper .esiBoxInnerWrapper .esbBr img{width:100%}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiBoxWrapper .esiBoxInnerWrapper .esbP{width:90%;margin:0 auto;color:#472f51;font-size:14px;height:140px;transition:height .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiBoxWrapper .esiBoxInnerWrapper .esbP{height:160px}}@media (max-width:900px){#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiBoxWrapper .esiBoxInnerWrapper .esbP{height:200px}}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStylesWrapper .esInnerWrapper .esItem .esiBoxWrapper .esiBoxInnerWrapper .esbLink{color:#472f51;line-height:24px;font-size:16px;font-weight:700;cursor:pointer;position:absolute;left:0;right:0;height:24px;bottom:5px}#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStyleFooterSection{background:#e4e5e6;padding:0 0 84px;margin:-60px 0 0;transition:padding .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStyleFooterSection{padding:0 0 7%}}@media (max-width:768px){#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStyleFooterSection{margin:-30px 0 0}}@media (max-width:480px){#diamonds-direct .EducationStyle.EducationPage .eduBody .eduStyleFooterSection{margin:0}}#diamonds-direct .EducationConflict .ecTopBr{background:#472f51;width:100%;height:2px}@media (max-width:768px){#diamonds-direct .EducationConflict .ecTopBr{display:none}}#diamonds-direct .EducationConflict .ecBody{background-image:url(\"https://ddw2.diamondsdirect.com/img/education/conflict/bgmap.jpg\");background-repeat:no-repeat;background-position:50%;background-size:cover}@media (max-width:768px){#diamonds-direct .EducationConflict .ecBody{background-image:url(\"https://ddw2.diamondsdirect.com/img/education/conflict/bgmap_m.jpg\")}}#diamonds-direct .EducationConflict .ecBody .ecTr{position:relative;display:block;width:100%;max-width:1200px;margin:0 auto}#diamonds-direct .EducationConflict .ecBody .ecTr .tdDesktop.ecTd{display:inline-block}@media (max-width:768px){#diamonds-direct .EducationConflict .ecBody .ecTr .tdDesktop.ecTd{display:none}}#diamonds-direct .EducationConflict .ecBody .ecTr .tdMobile.ecTd{display:none}@media (max-width:768px){#diamonds-direct .EducationConflict .ecBody .ecTr .tdMobile.ecTd{display:block}}#diamonds-direct .EducationConflict .ecBody .ecTr .ecTd{display:inline-block;vertical-align:top;width:50%;color:#000}@media (max-width:768px){#diamonds-direct .EducationConflict .ecBody .ecTr .ecTd{display:block;width:100%}}#diamonds-direct .EducationConflict .ecBody .ecTr .ecTd img{width:100%}#diamonds-direct .EducationConflict .ecBody .ecTr .ecTd .ecTitle{margin:20px 5%;font-size:40px}#diamonds-direct .EducationConflict .ecBody .ecTr .ecTd .ecP{margin:0 5% 20px;font-size:20px;font-family:Lato,sans-serif}#diamonds-direct .EducationLabGrown .labHoliday .holidayWrapper{position:relative}#diamonds-direct .EducationLabGrown .labHoliday .holidayWrapper img{width:100%}#diamonds-direct .EducationLabGrown .labHoliday .holidayWrapper .holidayAction{position:absolute;top:60%;left:65%;width:20%;height:20px;cursor:pointer;background:#4b2d53;padding:8px 0;text-align:center;color:#fff;font-size:18px;font-weight:400;font-family:Lato,sans-serif;transition:background .25s ease-in-out 0ms}@media (max-width:1200px){#diamonds-direct .EducationLabGrown .labHoliday .holidayWrapper .holidayAction{font-size:18px}}@media (max-width:1024px){#diamonds-direct .EducationLabGrown .labHoliday .holidayWrapper .holidayAction{font-size:16px;left:63%;width:24%}}@media (max-width:900px){#diamonds-direct .EducationLabGrown .labHoliday .holidayWrapper .holidayAction{font-size:14px}}@media (max-width:768px){#diamonds-direct .EducationLabGrown .labHoliday .holidayWrapper .holidayAction{top:82%;left:20%;width:60%;height:6%;font-size:20px}}@media (max-width:600px){#diamonds-direct .EducationLabGrown .labHoliday .holidayWrapper .holidayAction{font-size:16px}}#diamonds-direct .EducationLabGrown .labHoliday .holidayWrapper .holidayAction:hover{background:#000}#diamonds-direct .EducationLabGrown .labHoliday .holidayWrapper .holidayAction div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .EducationLabGrown .eduBody{color:#000;font-family:Lato,sans-serif;margin:25px auto;width:90%;max-width:1024px}#diamonds-direct .EducationLabGrown .eduBody .labHeader .labHeaderImage img{width:100%}#diamonds-direct .EducationLabGrown .eduBody .labCopy .mobile.labCopyBlock{display:none}@media (max-width:768px){#diamonds-direct .EducationLabGrown .eduBody .labCopy .mobile.labCopyBlock{display:block}}#diamonds-direct .EducationLabGrown .eduBody .labCopy .labCopyBlock{margin:25px 0 0}#diamonds-direct .EducationLabGrown .eduBody .labCopy .labCopyBlock .copyTitle{margin:0 0 10px;font-size:22px;font-weight:700}#diamonds-direct .EducationLabGrown .eduBody .labCopy .labCopyBlock .copyP{margin:0 0 15px}#diamonds-direct .EducationLabGrown .eduBody .labCopy .labCopyBlock .copySubheader{margin:20px 0 5px;height:22px}#diamonds-direct .EducationLabGrown .eduBody .labCopy .labCopyBlock .copySubheader .ci{display:inline-block;vertical-align:top;width:26px;height:22px}#diamonds-direct .EducationLabGrown .eduBody .labCopy .labCopyBlock .copySubheader .ci img{width:100%}#diamonds-direct .EducationLabGrown .eduBody .labCopy .labCopyBlock .copySubheader .cb{display:inline-block;vertical-align:top;width:auto;margin:0 0 0 5px;font-size:18px;font-weight:700;line-height:22px;padding:2px 0 0}#diamonds-direct .EducationLabGrown .eduBody .labCompare{margin:50px 0 0}#diamonds-direct .EducationLabGrown .eduBody .labCompare .blockWrapper{text-align:center}#diamonds-direct .EducationLabGrown .eduBody .labCompare .blockWrapper .compareBlock{position:relative;display:inline-block;vertical-align:top;width:33%;max-width:320px;margin:0 10px 40px;padding:25px 10px;background:#f2f2f2}@media (max-width:1024px){#diamonds-direct .EducationLabGrown .eduBody .labCompare .blockWrapper .compareBlock{width:90%;margin:0 10px 70px}}#diamonds-direct .EducationLabGrown .eduBody .labCompare .blockWrapper .compareBlock .compareIcon{position:absolute;top:-40px;left:calc(50% - 40px);width:80px;height:80px;border-radius:50%;background:#fff}#diamonds-direct .EducationLabGrown .eduBody .labCompare .blockWrapper .compareBlock .compareIcon .compareIconWrapper{margin:10px}#diamonds-direct .EducationLabGrown .eduBody .labCompare .blockWrapper .compareBlock .compareIcon .compareIconWrapper img{width:100%}#diamonds-direct .EducationLabGrown .eduBody .labCompare .blockWrapper .compareBlock .compareTitle{margin:40px 0 25px;font-size:900;font-size:26px}#diamonds-direct .EducationLabGrown .eduBody .labCompare .blockWrapper .compareBlock .compareProConWrapper .compareLabel{font-size:15px;font-weight:700;text-transform:uppercase;margin:10px 0}#diamonds-direct .EducationLabGrown .eduBody .labCompare .blockWrapper .compareBlock .compareProConWrapper .compareValue{font-size:15px;margin:0 0 20px}#diamonds-direct .EducationLabGrown .eduBody .labCompare .compareCopyWrapper .ccTitle{color:#4b2d53;font-size:24px;font-weight:700;margin:0 0 25px;text-align:center}#diamonds-direct .EducationLabGrown .eduBody .labCompare .compareCopyWrapper .ccP{margin:0 auto;width:80%}#diamonds-direct .EducationLabGrown .eduBody .labGrid{margin:40px auto}@media (max-width:768px){#diamonds-direct .EducationLabGrown .eduBody .labGrid{max-width:600px}}#diamonds-direct .EducationLabGrown .eduBody .labGrid .copyRight.labRow .copyBlock{margin-left:50%;text-align:center}@media (max-width:768px){#diamonds-direct .EducationLabGrown .eduBody .labGrid .copyRight.labRow .copyBlock{margin-left:0}}#diamonds-direct .EducationLabGrown .eduBody .labGrid .copyRight.labRow .copyBlock .rcTitle{font-size:24px;font-weight:700;margin:0 0 25px}#diamonds-direct .EducationLabGrown .eduBody .labGrid .copyRight.labRow .copyBlock .em.rcP{margin:20px 0 0;font-weight:700}#diamonds-direct .EducationLabGrown .eduBody .labGrid .copyRight.labRow .copyBlock .rcP{margin:10px 0 0;font-size:16px}#diamonds-direct .EducationLabGrown .eduBody .labGrid .copyRight.labRow .imageBlock{left:0;background-image:url(\"https://ddw2.diamondsdirect.com/img/education/lab/collection.jpg\")}#diamonds-direct .EducationLabGrown .eduBody .labGrid .copyLeft.labRow .copyBlock .lcP{width:80%;margin:0 auto 25px}#diamonds-direct .EducationLabGrown .eduBody .labGrid .copyLeft.labRow .copyBlock .lcTitle{font-size:20px;font-weight:700;text-align:center}#diamonds-direct .EducationLabGrown .eduBody .labGrid .copyLeft.labRow .imageBlock{left:50%;background-image:url(\"https://ddw2.diamondsdirect.com/img/education/lab/expert.jpg\")}@media (max-width:768px){#diamonds-direct .EducationLabGrown .eduBody .labGrid .copyLeft.labRow .imageBlock{left:0}}#diamonds-direct .EducationLabGrown .eduBody .labGrid .labRow{position:relative;min-height:240px}#diamonds-direct .EducationLabGrown .eduBody .labGrid .labRow .copyBlock{overflow:auto;width:50%}@media (max-width:768px){#diamonds-direct .EducationLabGrown .eduBody .labGrid .labRow .copyBlock{width:100%}}#diamonds-direct .EducationLabGrown .eduBody .labGrid .labRow .copyBlock .lcActions{text-align:center;margin:25px 0 0}#diamonds-direct .EducationLabGrown .eduBody .labGrid .labRow .copyBlock .lcActions .lcAction{display:inline-block;vertical-align:top;margin:0 10px 10px;cursor:pointer;background:#4b2d53;width:200px;padding:8px 0;text-align:center;color:#fff;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms}#diamonds-direct .EducationLabGrown .eduBody .labGrid .labRow .copyBlock .lcActions .lcAction:hover{background:#000}#diamonds-direct .EducationLabGrown .eduBody .labGrid .labRow .copyBlock .copyBlockLiner{padding:35px 10px}#diamonds-direct .EducationLabGrown .eduBody .labGrid .labRow .imageBlock{position:absolute;top:0;width:50%;height:100%;background-size:cover;background-position:50%;background-repeat:no-repeat}@media (max-width:768px){#diamonds-direct .EducationLabGrown .eduBody .labGrid .labRow .imageBlock{position:relative;padding-bottom:75%;width:100%;height:auto}}#diamonds-direct .Gallery{top:-10px;position:relative;font-family:Lato,sans-serif}#diamonds-direct .Gallery .rbBreadcrumbsWrapper{position:relative}#diamonds-direct .Gallery .rbBreadcrumbsWrapper .productBreadcrumbElement.desktopView,#diamonds-direct .Gallery .rbBreadcrumbsWrapper .productBreadcrumbElement.mobileView{display:none!important}#diamonds-direct .Gallery .rbBreadcrumbsWrapper .splashBreadcrumbElement.desktopView{display:inline-block}@media (max-width:1024px){#diamonds-direct .Gallery .rbBreadcrumbsWrapper .splashBreadcrumbElement.desktopView{display:none}}#diamonds-direct .Gallery .rbBreadcrumbsWrapper .splashBreadcrumbElement.mobileView{display:none}@media (max-width:1024px){#diamonds-direct .Gallery .rbBreadcrumbsWrapper .splashBreadcrumbElement.mobileView{display:inline-block}}@media (max-width:1024px){#diamonds-direct .Gallery .rbFiltersWrapper.filtersOpen{width:100%}}#diamonds-direct .Gallery .rbFiltersWrapper{position:absolute;top:36px;left:0;width:80px;height:calc(100% - 36px);cursor:pointer;background:#f9f9f9;z-index:4;transition:width .4s ease-in-out 0ms}@media (max-width:1024px){#diamonds-direct .Gallery .rbFiltersWrapper{width:0}}#diamonds-direct .Gallery .rbFiltersWrapper .filtersIndicator{position:absolute;top:0;left:0;right:0;bottom:0}#diamonds-direct .Gallery .rbFiltersWrapper .filtersIndicator .indicatorIcon.floating{position:fixed;top:80px;left:15px;width:50px;height:auto}#diamonds-direct .Gallery .rbFiltersWrapper .filtersIndicator .indicatorIcon{position:absolute;top:15px;left:15px;width:50px;height:auto}@media (max-width:1024px){#diamonds-direct .Gallery .rbFiltersWrapper .filtersIndicator .indicatorIcon{display:none}}#diamonds-direct .Gallery .rbFiltersWrapper .filtersIndicator .indicatorIcon img{width:100%}#diamonds-direct .Gallery .rbFiltersWrapper .filtersOpen.filterWrapper{margin-left:0}#diamonds-direct .Gallery .rbFiltersWrapper .filterWrapper{position:absolute;top:0;margin-left:-400px;width:400px;height:auto;z-index:3;background:#fff;transition:left .4s ease-in-out 0ms,margin .4s ease-in-out 0ms}@media (max-width:1024px){#diamonds-direct .Gallery .rbFiltersWrapper .filterWrapper{margin-right:80px;width:100%;height:calc(100% - 36px)}}#diamonds-direct .Gallery .rbFiltersWrapper .filterWrapper .closeFilters{position:absolute;top:15px;right:15px;width:20px;height:20px;cursor:pointer;font-size:36px;font-weight:100;z-index:4}#diamonds-direct .Gallery .rbFiltersWrapper .filterWrapper .closeFilters div{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .Gallery .rbResultsWrapper.filtersOpen{left:400px;width:calc(100% - 400px);transition:left .35s linear 0ms,width .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Gallery .rbResultsWrapper.filtersOpen{left:0;width:100%}}#diamonds-direct .Gallery .rbResultsWrapper{position:relative;display:inline-block;width:calc(100% - 80px);vertical-align:top;left:80px;transition:left .4s ease-in-out 0ms,width .4s ease-in-out 0ms}@media (max-width:1024px){#diamonds-direct .Gallery .rbResultsWrapper{left:0;width:100%}}#diamonds-direct .Gallery .rbResultsWrapper .loadingWrapper{margin:50px 0 0;min-height:1200px}#diamonds-direct .Gallery .rbResultsWrapper .rbResultsLoaded .rbProductResults{margin:25px 75px 25px 25px}@media (max-width:1024px){#diamonds-direct .Gallery .rbResultsWrapper .rbResultsLoaded .rbProductResults{margin:25px}}#diamonds-direct .Gallery .mobileFooterButton{display:none;position:fixed;bottom:0;left:0;height:60px;width:100%;font-family:Lato,sans-serif;font-weight:700;font-size:26px;color:#fff;background:#4b2d53;z-index:10;transition:background .25s ease-in-out 0ms}#diamonds-direct .Gallery .mobileFooterButton:active,#diamonds-direct .Gallery .mobileFooterButton:hover{background:#000}@media (max-width:1024px){#diamonds-direct .Gallery .mobileFooterButton{display:block}}#diamonds-direct .Gallery .mobileFooterButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .NumericSlider{overflow:hidden;max-width:600px;margin:0 auto}#diamonds-direct .NumericSlider .sliderWrapper{position:relative;width:calc(100% - 18px);height:30px}#diamonds-direct .NumericSlider .sliderWrapper .sliderDot{position:absolute;top:calc(50% - 9px);width:12px;height:12px;border:3px solid #4b2d53;border-radius:50%;background:#fff;cursor:grab}#diamonds-direct .NumericSlider .sliderWrapper .sliderDot:active{cursor:grabbing}#diamonds-direct .NumericSlider .sliderWrapper .leftBar.sliderBar{background:#d3d3d3;left:0}#diamonds-direct .NumericSlider .sliderWrapper .middleBar.sliderBar{background:#4b2d53}#diamonds-direct .NumericSlider .sliderWrapper .rightBar.sliderBar{background:#d3d3d3;right:0}#diamonds-direct .NumericSlider .sliderWrapper .rightBarTail.sliderBar{background:#d3d3d3;left:100%;width:15px}#diamonds-direct .NumericSlider .sliderWrapper .sliderBar{position:absolute;top:calc(50% - 1.5px);height:3px}#diamonds-direct .NumericSlider .inputWrapper{position:relative}#diamonds-direct .NumericSlider .inputWrapper .minValWrapper{position:absolute;top:0;width:45%;bottom:0;left:0}#diamonds-direct .NumericSlider .inputWrapper .minValWrapper input{width:calc(100% - 12px);height:calc(100% - 18px);border:1px solid #707070;padding:8px 5px;font-size:18px;font-weight:300;color:#5e5e5e;text-align:center}#diamonds-direct .NumericSlider .inputWrapper .minValWrapper .currencySymbol{position:absolute;top:0;left:0;bottom:0;width:20px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .NumericSlider .inputWrapper .dashWrapper{position:relative;text-align:center;padding:5px 0;margin:10px 0 0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .NumericSlider .inputWrapper .maxValWrapper{position:absolute;top:0;width:45%;bottom:0;right:0}#diamonds-direct .NumericSlider .inputWrapper .maxValWrapper input{width:calc(100% - 12px);height:calc(100% - 18px);border:1px solid #707070;padding:8px 5px;font-size:18px;font-weight:300;color:#5e5e5e;text-align:center}#diamonds-direct .NumericSlider .inputWrapper .maxValWrapper .currencySymbol{left:0}#diamonds-direct .NumericSlider .inputWrapper .maxValWrapper .currencySymbol,#diamonds-direct .NumericSlider .inputWrapper .maxValWrapper .plusOverlay{position:absolute;top:0;bottom:0;width:20px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .NumericSlider .inputWrapper .maxValWrapper .plusOverlay{right:calc(50% - 20px)}#diamonds-direct .ValuesSlider.disabled .sliderWrapper .sliderDot{cursor:default;border:3px solid #d3d3d3}#diamonds-direct .ValuesSlider.disabled .sliderWrapper .middleBar.sliderBar{background:#d3d3d3}#diamonds-direct .ValuesSlider{overflow:hidden}#diamonds-direct .ValuesSlider .sliderWrapper{position:relative;width:calc(100% - 18px);height:30px}#diamonds-direct .ValuesSlider .sliderWrapper .sliderDot{position:absolute;top:calc(50% - 9px);width:12px;height:12px;border:3px solid #4b2d53;border-radius:50%;background:#fff;cursor:grab;z-index:1}#diamonds-direct .ValuesSlider .sliderWrapper .sliderDot:active{cursor:grabbing}#diamonds-direct .ValuesSlider .sliderWrapper .leftBar.sliderBar{background:#d3d3d3;left:0}#diamonds-direct .ValuesSlider .sliderWrapper .middleBar.sliderBar{background:#4b2d53}#diamonds-direct .ValuesSlider .sliderWrapper .rightBar.sliderBar{background:#d3d3d3;right:0}#diamonds-direct .ValuesSlider .sliderWrapper .rightBarTail.sliderBar{background:#d3d3d3;left:100%;width:15px}#diamonds-direct .ValuesSlider .sliderWrapper .sliderBar{position:absolute;top:calc(50% - 1.5px);height:3px}#diamonds-direct .ValuesSlider .sliderWrapper .ticWrapper{position:absolute;top:0;left:7.5px;width:100%;bottom:0}#diamonds-direct .ValuesSlider .sliderWrapper .ticWrapper .ticElement{position:absolute;top:20%;bottom:20%;width:1px;background:#d3d3d3}#diamonds-direct .ValuesSlider .inputWrapper{position:relative}#diamonds-direct .ValuesSlider .inputWrapper .minValWrapper{position:absolute;top:0;width:45%;bottom:0;left:0}#diamonds-direct .ValuesSlider .inputWrapper .minValWrapper .minValData{border:1px solid #707070;margin:0 auto;text-align:center;padding:5px 0 3px;font-size:18px;text-transform:none}#diamonds-direct .ValuesSlider .inputWrapper .minValWrapper .currencySymbol{position:absolute;top:0;left:0;bottom:0;width:20px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .ValuesSlider .inputWrapper .dashWrapper{position:relative;text-align:center;padding:7px 0;margin:10px 0 0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .ValuesSlider .inputWrapper .maxValWrapper{position:absolute;top:0;width:45%;bottom:0;right:0}#diamonds-direct .ValuesSlider .inputWrapper .maxValWrapper .maxValData{border:1px solid #707070;margin:0 auto;text-align:center;padding:5px 0 3px;font-size:18px;text-transform:none}#diamonds-direct .ValuesSlider .inputWrapper .maxValWrapper .currencySymbol{position:absolute;top:0;left:0;bottom:0;width:20px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .ShapeIcons .iconsWrapper{position:relative}#diamonds-direct .ShapeIcons .iconsWrapper .hiddenLoading{position:absolute;top:0;left:0;width:1px;height:1px;visibility:hidden}#diamonds-direct .ShapeIcons .iconsWrapper .iconRow{text-align:center;position:relative;height:55px;margin:0 0 20px}#diamonds-direct .ShapeIcons .iconsWrapper .iconRow .shapeIconWrapper.selected .imgSelected{display:inline-block}#diamonds-direct .ShapeIcons .iconsWrapper .iconRow .shapeIconWrapper.selected .imgNotSelected{display:none}#diamonds-direct .ShapeIcons .iconsWrapper .iconRow .shapeIconWrapper.selected .iconLabel{color:#4b2d53}#diamonds-direct .ShapeIcons .iconsWrapper .iconRow .shapeIconWrapper{position:relative;display:inline-block;width:40px;height:100%;margin:0 2.5%;text-align:center;vertical-align:top;cursor:pointer}#diamonds-direct .ShapeIcons .iconsWrapper .iconRow .shapeIconWrapper img{height:100%;max-height:40px;object-fit:contain}#diamonds-direct .ShapeIcons .iconsWrapper .iconRow .shapeIconWrapper .imgSelected{display:none}#diamonds-direct .ShapeIcons .iconsWrapper .iconRow .shapeIconWrapper .imgNotSelected{display:inline-block}#diamonds-direct .ShapeIcons .iconsWrapper .iconRow .shapeIconWrapper .iconLabel{position:absolute;bottom:0;left:0;right:0;height:9px;font-size:9px;color:#666}#diamonds-direct .ShapeIcons .allLinkWrapper{text-align:center;margin:5px 0}#diamonds-direct .ShapeIcons .allLinkWrapper .allLink{display:inline-block;width:auto;padding:5px;color:#563a5f;text-decoration:underline;cursor:pointer}#diamonds-direct .StyleIcons .iconsWrapper{position:relative}#diamonds-direct .StyleIcons .iconsWrapper .hiddenLoading{position:absolute;top:0;left:0;width:1px;height:1px;visibility:hidden}#diamonds-direct .StyleIcons .iconsWrapper .iconRow{text-align:center;position:relative;height:40px;margin:0 0 20px}#diamonds-direct .StyleIcons .iconsWrapper .iconRow .shapeIconWrapper.selected .imgSelected{display:inline-block}#diamonds-direct .StyleIcons .iconsWrapper .iconRow .shapeIconWrapper.selected .imgNotSelected{display:none}#diamonds-direct .StyleIcons .iconsWrapper .iconRow .shapeIconWrapper.selected .iconLabel{color:#4b2d53}#diamonds-direct .StyleIcons .iconsWrapper .iconRow .shapeIconWrapper{position:relative;display:inline-block;vertical-align:top;width:60px;height:100%;margin:0 2%;text-align:center;cursor:pointer}#diamonds-direct .StyleIcons .iconsWrapper .iconRow .shapeIconWrapper img{width:90%;object-fit:contain}#diamonds-direct .StyleIcons .iconsWrapper .iconRow .shapeIconWrapper .imgSelected{display:none}#diamonds-direct .StyleIcons .iconsWrapper .iconRow .shapeIconWrapper .imgNotSelected{display:inline-block}#diamonds-direct .StyleIcons .iconsWrapper .iconRow .shapeIconWrapper .iconLabel{position:absolute;bottom:0;left:0;right:0;height:9px;font-size:9px;color:#666}#diamonds-direct .StyleIcons .allLinkWrapper{text-align:center;margin:5px 0}#diamonds-direct .StyleIcons .allLinkWrapper .allLink{display:inline-block;width:auto;padding:5px;color:#563a5f;text-decoration:underline;cursor:pointer}#diamonds-direct .GemstoneIcons.StyleIcons .iconsWrapper{margin-bottom:25px}#diamonds-direct .GemstoneIcons.StyleIcons .iconsWrapper .iconRow .shapeIconWrapper{height:50px}#diamonds-direct .GemstoneIcons.StyleIcons .iconsWrapper .iconRow .shapeIconWrapper img{height:calc(100% - 12px);width:auto}#diamonds-direct .SettingTypeIcons .iconsWrapper{position:relative}#diamonds-direct .SettingTypeIcons .iconsWrapper .hiddenLoading{position:absolute;top:0;left:0;width:1px;height:1px;visibility:hidden}#diamonds-direct .SettingTypeIcons .iconsWrapper .iconRow{text-align:center;position:relative;height:40px;margin:0 0 20px}#diamonds-direct .SettingTypeIcons .iconsWrapper .iconRow .shapeIconWrapper.selected .imgSelected{display:inline-block}#diamonds-direct .SettingTypeIcons .iconsWrapper .iconRow .shapeIconWrapper.selected .imgNotSelected{display:none}#diamonds-direct .SettingTypeIcons .iconsWrapper .iconRow .shapeIconWrapper.selected .iconLabel{color:#4b2d53}#diamonds-direct .SettingTypeIcons .iconsWrapper .iconRow .shapeIconWrapper{position:relative;display:inline-block;vertical-align:top;width:55px;height:100%;margin:0 2%;text-align:center;cursor:pointer}#diamonds-direct .SettingTypeIcons .iconsWrapper .iconRow .shapeIconWrapper img{width:90%;object-fit:contain}#diamonds-direct .SettingTypeIcons .iconsWrapper .iconRow .shapeIconWrapper .imgSelected{display:none}#diamonds-direct .SettingTypeIcons .iconsWrapper .iconRow .shapeIconWrapper .imgNotSelected{display:inline-block}#diamonds-direct .SettingTypeIcons .iconsWrapper .iconRow .shapeIconWrapper .iconLabel{position:absolute;bottom:0;left:0;right:0;height:9px;font-size:9px;color:#666}#diamonds-direct .SettingTypeIcons .allLinkWrapper{text-align:center;margin:5px 0}#diamonds-direct .SettingTypeIcons .allLinkWrapper .allLink{display:inline-block;width:auto;padding:5px;color:#563a5f;text-decoration:underline;cursor:pointer}#diamonds-direct .ColorRadios .radioRowWrapper{position:relative;text-align:center}#diamonds-direct .ColorRadios .radioRowWrapper .radioItem.selected .radioPip{color:#fff;background:#4e4352}#diamonds-direct .ColorRadios .radioRowWrapper .radioItem{position:relative;display:inline-block;vertical-align:top;margin:0 5px 5px;width:22px;height:22px;border:2px solid #d9d9d9;border-radius:50%;cursor:pointer}#diamonds-direct .ColorRadios .radioRowWrapper .radioItem .allPip.radioPip{font-size:8px;padding:2px 0 0}#diamonds-direct .ColorRadios .radioRowWrapper .radioItem .radioPip{position:absolute;top:2px;right:2px;bottom:2px;left:2px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:2px 0 0;color:#4e4352;background:#fff;border-radius:50%;font-size:14px}#diamonds-direct .ColorRadios .allLinkWrapper{text-align:center;margin:5px 0}#diamonds-direct .ColorRadios .allLinkWrapper .allLink{display:inline-block;width:auto;padding:5px;color:#563a5f;text-decoration:underline;cursor:pointer}#diamonds-direct .CheckboxList .checkboxDisclaimer{text-transform:none;font-size:13px;text-align:center;margin:0 0 20px}#diamonds-direct .CheckboxList .checkboxListWrapper{margin:0 0 25px}#diamonds-direct .CheckboxList .checkboxListWrapper .checkboxHr{background:#707070;margin:8px 50px 8px 25px;height:1px}#diamonds-direct .CheckboxList .checkboxListWrapper .checkboxItem{position:relative;height:20px;margin:0 0 2px}#diamonds-direct .CheckboxList .checkboxListWrapper .checkboxItem .boxWrapper{position:absolute;top:0;left:0;width:20px;height:20px}#diamonds-direct .CheckboxList .checkboxListWrapper .checkboxItem .boxWrapper input{border:1px solid #707070;border-radius:0}#diamonds-direct .CheckboxList .checkboxListWrapper .checkboxItem .itemLabel{font-family:Lato,sans-serif;margin:0 0 0 25px;height:20px;text-transform:none}#diamonds-direct .GalleryBreadcrumbs{position:relative;color:#5e5e5e;background:#ebebeb}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS{width:calc(100% - 300px)}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS .breadcrumbWrapper{margin:0 0 0 75px;padding:8px 0}@media (max-width:768px){#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS .breadcrumbWrapper .desktopView.breadcrumbElement{display:none}}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS .breadcrumbWrapper .mobileView.breadcrumbElement{display:none}@media (max-width:768px){#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS .breadcrumbWrapper .mobileView.breadcrumbElement{display:inline-block}}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS .breadcrumbWrapper .clickableElement.breadcrumbElement{color:#4b2d53;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS .breadcrumbWrapper .clickableElement.breadcrumbElement:hover{color:#563a5f}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS .breadcrumbWrapper .currentElement.breadcrumbElement{display:inline-block;font-weight:700;color:#4b2d53}@media (max-width:768px){#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS .breadcrumbWrapper .currentElement.breadcrumbElement{display:none}}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS .breadcrumbWrapper .breadcrumbElement{display:inline-block;margin:0 15px 0 0;text-transform:uppercase;font-weight:400;font-size:18px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsLHS .breadcrumbWrapper .breadcrumbArrow{display:inline-block;margin:0 15px 0 0;font-weight:400;font-size:22px;color:#707070}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsRHS{position:absolute;top:0;right:0;width:300px;bottom:0;margin:0 75px 0 0;text-align:right}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsRHS .pageIndicator{position:relative;display:inline-block;width:auto;border-right:2px solid #707070;height:calc(100% - 10px);margin:5px 15px 5px 0;padding:0 15px 0 0}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsRHS .pageIndicator .pageInnerElement{height:100%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsRHS .pageSizeControls{display:inline-block;width:auto;text-transform:uppercase}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsRHS .pageSizeControls .pageInnerElement.selected{font-weight:700;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsRHS .pageSizeControls .pageInnerElement{display:inline-block;width:auto;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .GalleryBreadcrumbs .breadcrumbsRHS .pageSizeControls .pageSeparationElement{display:inline-block;width:auto;color:#707070;margin:0 5px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .FashionFilters,#diamonds-direct .MensBandsFilters,#diamonds-direct .MensJewelryFilters,#diamonds-direct .WomensBandsFilters{position:relative;color:#000;background:#fff}@media (max-width:1024px){#diamonds-direct .FashionFilters,#diamonds-direct .MensBandsFilters,#diamonds-direct .MensJewelryFilters,#diamonds-direct .WomensBandsFilters{min-height:calc(100vh - 136px)}}@media (max-width:768px){#diamonds-direct .FashionFilters,#diamonds-direct .MensBandsFilters,#diamonds-direct .MensJewelryFilters,#diamonds-direct .WomensBandsFilters{min-height:calc(100vh - 91px)}}#diamonds-direct .FashionFilters .rbFilterWrapper,#diamonds-direct .MensBandsFilters .rbFilterWrapper,#diamonds-direct .MensJewelryFilters .rbFilterWrapper,#diamonds-direct .WomensBandsFilters .rbFilterWrapper{position:relative;background:#fff}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper{margin:25px 50px 25px 25px;background:#fff}@media (max-width:1024px){#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper{margin-top:0}}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .diamondSection.disabled .headerItem.filterItem,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .diamondSection.disabled .headerItem.filterItem,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .diamondSection.disabled .headerItem.filterItem,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .diamondSection.disabled .headerItem.filterItem{color:#000}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .diamondSection.disabled .filterItem,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .diamondSection.disabled .filterItem,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .diamondSection.disabled .filterItem,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .diamondSection.disabled .filterItem{color:#d3d3d3;cursor:pointer}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .settingSection.disabled .headerItem.filterItem,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .settingSection.disabled .headerItem.filterItem,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .settingSection.disabled .headerItem.filterItem,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .settingSection.disabled .headerItem.filterItem{color:#000}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .settingSection.disabled .filterItem,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .settingSection.disabled .filterItem,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .settingSection.disabled .filterItem,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .settingSection.disabled .filterItem{color:#d3d3d3;cursor:pointer}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIcon,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIcon,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIcon,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIcon{font-weight:300;font-family:Josefin Sans,sans-serif}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead,#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead{font-family:Lusitana,serif;font-weight:700;font-size:18px}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterValue{display:inline-block;vertical-align:top}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset{display:inline-block;vertical-align:top;height:16px;margin:0 0 0 8px;cursor:pointer;text-decoration:none;font-size:12px;line-height:12px;font-family:Lato,sans-serif;font-weight:300;text-transform:none}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset img{height:100%;transition:transform .4s ease-in-out 0ms}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset:hover,#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset:hover,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset:hover,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset:hover,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset:hover,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset:hover,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset:hover,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset:hover{text-decoration:underline}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset:hover img,#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset:hover img,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset:hover img,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset:hover img,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset:hover img,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset:hover img,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset:hover img,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset:hover img{transform:rotate(180deg)}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIconRadio,#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterIconRadio,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIconRadio,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterIconRadio,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIconRadio,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterIconRadio,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIconRadio,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterIconRadio{position:absolute;top:12px;right:5px;bottom:12px;width:14px;font-size:32px;border:1px solid #000}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIconRadio .filterIconRadioInner,#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterIconRadio .filterIconRadioInner,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIconRadio .filterIconRadioInner,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterIconRadio .filterIconRadioInner,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIconRadio .filterIconRadioInner,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterIconRadio .filterIconRadioInner,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIconRadio .filterIconRadioInner,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterIconRadio .filterIconRadioInner{position:absolute;top:3px;left:3px;right:3px;bottom:3px;background:#000}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterHead .filterIcon.openIcon,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterHead .filterIcon.openIcon,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterHead .filterIcon.openIcon,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterHead .filterIcon.openIcon{display:-ms-flexbox;display:flex}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterHead .filterIcon,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterHead .filterIcon,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterHead .filterIcon,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterHead .filterIcon{display:none}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterBody,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterBody,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterBody,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterBody{max-height:200px}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterHead .filterIcon.openIcon,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterHead .filterIcon.openIcon,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterHead .filterIcon.openIcon,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterHead .filterIcon.openIcon{display:-ms-flexbox;display:flex}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterHead .filterIcon,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterHead .filterIcon,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterHead .filterIcon,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterHead .filterIcon{display:none}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterBody,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterBody,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterBody,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterBody{max-height:400px}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterHead .filterIcon.openIcon,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterHead .filterIcon.openIcon,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterHead .filterIcon.openIcon,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterHead .filterIcon.openIcon{display:-ms-flexbox;display:flex}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterHead .filterIcon,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterHead .filterIcon,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterHead .filterIcon,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterHead .filterIcon{display:none}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterBody,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterBody,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterBody,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterBody{max-height:1000px}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem{position:relative;border-bottom:1px solid #707070;font-family:Josefin Sans,sans-serif;font-weight:300;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:color .1s ease-in-out 0ms}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead{position:relative;cursor:pointer;font-size:16px}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel{padding:13px 0 9px;line-height:1;display:-ms-flexbox;display:flex;-ms-flex-pack:left;justify-content:left;-ms-flex-align:center;align-items:center}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterValue{display:inline-block;vertical-align:top}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset{display:inline-block;vertical-align:top;height:12px;margin:-5px 0 0 8px;cursor:pointer}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset img{height:100%}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterIcon.openIcon,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterIcon.openIcon,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterIcon.openIcon,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterIcon.openIcon{display:none}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterIcon,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterIcon,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterIcon,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterIcon{position:absolute;top:0;right:0;bottom:0;width:25px;font-size:32px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody{height:auto;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper{margin:10px auto;max-width:600px}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper{margin:0 0 20px 10px}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle{font-size:14px;font-weight:700}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .cutNote,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .cutNote,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .cutNote,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .cutNote{text-transform:none;text-align:center;margin:10px 0}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .submitSection,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .submitSection,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .submitSection,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .submitSection{margin:25px 0 0}#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .submitSection .filterSubmitButton,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .submitSection .filterSubmitButton,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .submitSection .filterSubmitButton,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .submitSection .filterSubmitButton{font-size:18px}@media (max-width:1024px){#diamonds-direct .FashionFilters .rbFilterWrapper .rbInternalWrapper .submitSection,#diamonds-direct .MensBandsFilters .rbFilterWrapper .rbInternalWrapper .submitSection,#diamonds-direct .MensJewelryFilters .rbFilterWrapper .rbInternalWrapper .submitSection,#diamonds-direct .WomensBandsFilters .rbFilterWrapper .rbInternalWrapper .submitSection{display:none}}#diamonds-direct .FashionFilters .filterSeparation,#diamonds-direct .MensBandsFilters .filterSeparation,#diamonds-direct .MensJewelryFilters .filterSeparation,#diamonds-direct .WomensBandsFilters .filterSeparation{position:absolute;top:0;right:0;width:6px;bottom:0;background:#ebebeb;border-radius:3px}#diamonds-direct .BandResults .mixedResultsButton,#diamonds-direct .FashionResults .mixedResultsButton{border:1px solid #d3d3d3;background:#fff;margin:0 auto;padding:3px 0;font-size:14px;text-transform:uppercase;text-align:center;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .BandResults .mixedResultsButton:hover,#diamonds-direct .FashionResults .mixedResultsButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .BandResults .resultsWrapper.open,#diamonds-direct .FashionResults .resultsWrapper.open{max-height:800px}#diamonds-direct .BandResults .resultsWrapper,#diamonds-direct .FashionResults .resultsWrapper{position:relative}#diamonds-direct .BandResults .resultsWrapper .resultsCountWrapper,#diamonds-direct .FashionResults .resultsWrapper .resultsCountWrapper{position:absolute;top:0;right:0;height:auto;width:auto}@media (max-width:768px){#diamonds-direct .BandResults .resultsWrapper .resultsCountWrapper,#diamonds-direct .FashionResults .resultsWrapper .resultsCountWrapper{display:none}}#diamonds-direct .BandResults .resultsWrapper .resultsTabWrapper,#diamonds-direct .FashionResults .resultsWrapper .resultsTabWrapper{border-left:2px solid #4b2d53}#diamonds-direct .BandResults .resultsWrapper .resultsTabWrapper .selectedTab.resultsTab,#diamonds-direct .FashionResults .resultsWrapper .resultsTabWrapper .selectedTab.resultsTab{color:#fff;background:#4b2d53;cursor:default}#diamonds-direct .BandResults .resultsWrapper .resultsTabWrapper .selectedTab.resultsTab:hover,#diamonds-direct .FashionResults .resultsWrapper .resultsTabWrapper .selectedTab.resultsTab:hover{color:#fff;background:#4b2d53}#diamonds-direct .BandResults .resultsWrapper .resultsTabWrapper .resultsTab,#diamonds-direct .FashionResults .resultsWrapper .resultsTabWrapper .resultsTab{display:inline-block;width:260px;height:30px;line-height:30px;text-align:center;font-size:16px;font-weight:400;text-transform:uppercase;border-right:2px solid #4b2d53;color:#4b2d53;background:#fff;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .BandResults .resultsWrapper .resultsTabWrapper .resultsTab,#diamonds-direct .FashionResults .resultsWrapper .resultsTabWrapper .resultsTab{width:calc(50% - 2px)}}#diamonds-direct .BandResults .resultsWrapper .resultsTabWrapper .resultsTab:hover,#diamonds-direct .FashionResults .resultsWrapper .resultsTabWrapper .resultsTab:hover{color:#fff;background:#000}#diamonds-direct .BandResults .resultsWrapper .resultsBody,#diamonds-direct .FashionResults .resultsWrapper .resultsBody{position:relative;border:1px solid #d3d3d3;margin:0 0 10px;padding:10px 0}#diamonds-direct .BandResults .resultsWrapper .resultsBody .bodyLabel,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .bodyLabel{text-align:center;margin:0 0 25px;font-size:20px;font-weight:300}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper{text-align:center}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.favProduct .productItemInnerWrapper,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.favProduct .productItemInnerWrapper{border:1px solid #4b2d53}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .adInnerWrapper,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .adInnerWrapper{cursor:pointer;margin:0 auto;max-width:350px;background-position:50%;background-repeat:no-repeat;background-size:contain}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .adInnerWrapper .adPrompt,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .adInnerWrapper .adPrompt{position:absolute;width:210px;height:36px;left:calc(50% - 105px);bottom:20px;cursor:pointer;color:#fff;background:#b99ac0;transition:background .25s ease-in-out 0ms}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .adInnerWrapper .adPrompt:hover,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .adInnerWrapper .adPrompt:hover{background:#98799c}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .adInnerWrapper .adPrompt div,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .adInnerWrapper .adPrompt div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .womensBandAd,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .womensBandAd{height:250px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/bands/ads/womens/wband_1.jpg\")}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .mensBandAd,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .mensBandAd{height:250px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/bands/ads/mens/mband_1.jpg\")}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionRingAd1,#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionRingAd2,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionRingAd1,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionRingAd2{height:250px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/ads/f_ring.jpg\")}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionEarringAd1,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionEarringAd1{height:250px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/ads/f_earring.jpg\")}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionEarringAd2,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionEarringAd2{height:250px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/ads/d_studs.jpg\")}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionNecklaceAd1,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionNecklaceAd1{height:250px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/ads/f_necklace.jpg\")}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionNecklaceAd2,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionNecklaceAd2{height:250px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/ads/d_pendant.jpg\")}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionBraceletAd1,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionBraceletAd1{height:250px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/ads/d_bracelet.jpg\")}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionBraceletAd2,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem.adBannerItem .fashionBraceletAd2{height:250px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/ads/f_bracelet.jpg\")}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem{position:relative;display:inline-block;vertical-align:top;width:25%;min-width:250px;margin:0 0 25px;text-align:center;outline:none}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper{border:1px solid #fff;margin:5px 10px;padding:0 0 10px}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .favSelectWrapper,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .favSelectWrapper{position:absolute;top:10px;right:15px;width:20px;height:20px;cursor:pointer}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .favSelectWrapper img,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .favSelectWrapper img{width:100%}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .diamondItemImgWrapper,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .diamondItemImgWrapper{height:160px;width:180px;margin:0 auto;cursor:pointer;outline:none}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .diamondItemImgWrapper img,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .diamondItemImgWrapper img{max-width:180px;max-height:160px}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .productItemTitle,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .productItemTitle{display:block;position:relative;margin:0 0 5px;font-size:15px;height:36px;cursor:pointer;outline:none;color:#333;text-decoration:none}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .productItemTitle div,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .productItemTitle div{position:absolute;top:0;left:5%;right:5%;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .diamondItemPrice,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .diamondItemPrice{display:inline-block;width:auto;margin:0 0 5px;font-size:18px;font-weight:300;border-top:2px solid #4b2d53;padding:5px 20px;cursor:pointer;outline:none;color:#333;text-decoration:none}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .selected.diamondItemAction,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .selected.diamondItemAction{cursor:default;color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .BandResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .diamondItemAction,#diamonds-direct .FashionResults .resultsWrapper .resultsBody .resultItemsWrapper .bandItem .productItemInnerWrapper .diamondItemAction{width:170px}#diamonds-direct .BandResults .resultsWrapper .picksPreview,#diamonds-direct .FashionResults .resultsWrapper .picksPreview{position:relative;border:1px solid #d3d3d3;margin:0 0 10px;padding:10px 0}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper{text-align:center}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .noItemsMessage,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .noItemsMessage{display:none;font-family:Lusitana,serif;font-size:18px;text-transform:uppercase;margin:10px 0}@media (max-width:900px){#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .noItemsMessage,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .noItemsMessage{display:block}}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveBr,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveBr{background:#5e5e5e;width:1px;height:100%}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem{position:relative;display:inline-block;vertical-align:top;margin:10px 0;width:calc(25% - 1px);transition:width .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem{width:calc(50% - 1px)}}@media (max-width:768px){#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem{width:calc(100% - 1px)}}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .compareNumber,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .compareNumber{position:absolute;top:0;right:10px;width:auto;height:auto;text-align:center;font-size:90px;font-family:Lusitana,serif;color:#eee}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveRemove,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveRemove{position:absolute;top:-20px;right:10px;width:auto;height:auto;text-align:center;font-size:36px;font-weight:300;cursor:pointer;color:#eee;transition:color .25s ease-in-out 0ms}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveRemove:hover,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveRemove:hover{color:#5e5e5e}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveImg,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveImg{text-align:center;height:120px;cursor:pointer}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveImg img,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveImg img{height:100%;max-width:100%}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveTitle,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveTitle{position:relative;height:70px;margin:0 10px;font-family:Lusitana,serif;color:#5e5e5e;text-transform:uppercase;font-size:20px;line-height:1.1}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveTitle div,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveTitle div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveDataRow,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveDataRow{background:#fff;padding:5px 0;font-size:16px}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveDataRow:nth-child(2n),#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveDataRow:nth-child(2n){background:#f5f5f5}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveDataRow .faveDataLabel,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveDataRow .faveDataLabel{display:inline-block;vertical-align:top;width:calc(50% - 5px);margin:0;text-align:right;font-size:14px;font-weight:400}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveDataRow .faveDataValue,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveDataRow .faveDataValue{display:inline-block;vertical-align:top;width:calc(50% - 10px);margin:0 0 0 10px;text-align:left;font-size:14px;font-weight:300}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .favePrice,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .favePrice{margin:10px 0;font-family:Lusitana,serif;color:#5e5e5e;text-transform:uppercase;font-size:20px}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveAdd.selected,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveAdd.selected{color:#fff;background:#4b2d53;border:1px solid #4b2d53;cursor:default}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveAdd,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveAdd{margin:0 auto 25px;width:200px;color:#5e5e5e;background:#fff;border:1px solid #5e5e5e;font-family:Lato,sans-serif;text-transform:uppercase;font-size:14px;font-weight:700;padding:8px 0;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveAdd:hover,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveItem .faveAdd:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}@media (max-width:900px){#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveEmpty.faveItem,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveEmpty.faveItem{display:none}}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveEmpty.faveItem .heartSection,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveEmpty.faveItem .heartSection{position:relative;margin:75px 0 20px;font-family:Lusitana,serif;color:#5e5e5e;text-transform:uppercase;text-align:center}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveEmpty.faveItem .heartSection img,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveEmpty.faveItem .heartSection img{width:90%}#diamonds-direct .BandResults .resultsWrapper .picksPreview .favesWrapper .faveEmpty.faveItem .heartSection div,#diamonds-direct .FashionResults .resultsWrapper .picksPreview .favesWrapper .faveEmpty.faveItem .heartSection div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .BraceletSplash{color:#5e5e5e;margin:0 auto 50px;max-width:1024px;transition:max-width .35s linear 0ms;font-family:Lato,sans-serif}#diamonds-direct .BraceletSplash .bsBoxButton{display:inline-block;width:auto;border:1px solid #5e5e5e;color:#5e5e5e;background:#fff;font-size:12px;text-transform:uppercase;font-weight:700;padding:20px 30px;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}@media (max-width:600px){#diamonds-direct .BraceletSplash .bsBoxButton{width:180px;padding:15px 0;font-family:Lato,sans-serif;font-size:14px}}#diamonds-direct .BraceletSplash .bsBoxButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .BraceletSplash .bsTitle{font-size:36px;font-family:Lusitana,serif;color:#5e5e5e;margin:25px 0;text-transform:uppercase}@media (max-width:1024px){#diamonds-direct .BraceletSplash .bsTitle{display:none}}#diamonds-direct .BraceletSplash .bsTop{position:relative;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bracelet/trendy.jpg\");background-position:50%;background-size:cover;background-repeat:no-repeat;padding-bottom:34%;text-align:center}@media (max-width:1024px){#diamonds-direct .BraceletSplash .bsTop{background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bracelet/trendy_m.jpg\");padding-bottom:78%;margin-bottom:50%}}#diamonds-direct .BraceletSplash .bsTop .bsBox{position:absolute;top:25px;right:25px;width:300px;height:auto;border:1px solid #5e5e5e;background:#fff;padding:50px 10px 25px;z-index:2}@media (max-width:1024px){#diamonds-direct .BraceletSplash .bsTop .bsBox{position:absolute;top:calc(100% - 50px);right:calc(50% - 151px)}}#diamonds-direct .BraceletSplash .bsTop .bsBox .bsBoxTitle{display:inline-block;overflow:visible;height:0;border-bottom:20px solid #e3dced;margin:0 0 50px;padding:0 15px 12px;width:auto;font-family:Lusitana,serif;text-transform:uppercase;font-size:26px}#diamonds-direct .BraceletSplash .bsTop .bsBox .bsBoxCopy{font-weight:300;font-size:16px;margin:0 10% 75px;text-align:left}#diamonds-direct .BraceletSplash .bsTop .bsBox .bsBoxButtonWrapper{margin:0 0 25px}#diamonds-direct .BraceletSplash .bsMid{position:relative;margin:100px 0 0}#diamonds-direct .BraceletSplash .bsMid .bsMidLeft{position:absolute;top:-50px;bottom:-50px;left:50px;width:calc(50% - 100px);background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bracelet/tennis.jpg\");background-position:50%;background-size:cover;background-repeat:no-repeat}@media (max-width:1024px){#diamonds-direct .BraceletSplash .bsMid .bsMidLeft{position:relative;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bracelet/tennis_m.jpg\");width:100%;left:unset;bottom:unset;top:0;padding-bottom:105%}}#diamonds-direct .BraceletSplash .bsMid .bsMidRight{margin-left:calc(50% - 50px);text-align:center}@media (max-width:1024px){#diamonds-direct .BraceletSplash .bsMid .bsMidRight{margin:0}}#diamonds-direct .BraceletSplash .bsMid .bsMidRight .bsMidImgWrapper{position:relative;margin:50px -100px;z-index:1}@media (max-width:1024px){#diamonds-direct .BraceletSplash .bsMid .bsMidRight .bsMidImgWrapper{margin:50px 0}}#diamonds-direct .BraceletSplash .bsMid .bsMidRight .bsMidImgWrapper img{position:relative;width:100%}#diamonds-direct .BraceletSplash .bsMid .bsMidRight .bsMidTitle{display:inline-block;overflow:visible;height:0;border-bottom:20px solid #e3dced;margin:0 0 50px;padding:0 15px 12px;width:auto;font-family:Lusitana,serif;text-transform:uppercase;font-size:26px}#diamonds-direct .BraceletSplash .bsMid .bsMidRight .bsMidCopy{font-weight:300;font-size:16px;margin:0 20% 75px;text-align:left}#diamonds-direct .BraceletSplash .bsMid .bsMidRight .bsMidButtonWrapper{margin:0 0 25px}#diamonds-direct .BraceletSplash .bsBottom .bsBottomLeft{position:relative;display:inline-block;vertical-align:top;width:50%;margin:100px 0 0}@media (max-width:1024px){#diamonds-direct .BraceletSplash .bsBottom .bsBottomLeft{display:block;width:100%;margin:0}}#diamonds-direct .BraceletSplash .bsBottom .bsBottomLeft img{width:100%}#diamonds-direct .BraceletSplash .bsBottom .bsBottomLeft .bsButtonBottomLeft{position:relative;left:30%;width:40%;bottom:75px}#diamonds-direct .BraceletSplash .bsBottom .bsBottomRight{position:relative;display:inline-block;vertical-align:top;width:50%}@media (max-width:1024px){#diamonds-direct .BraceletSplash .bsBottom .bsBottomRight{display:block;width:100%}}#diamonds-direct .BraceletSplash .bsBottom .bsBottomRight img{width:100%}#diamonds-direct .BraceletSplash .bsBottom .bsBottomRight .bsButtonBottomRight{position:relative;left:30%;width:40%;bottom:75px}#diamonds-direct .CompareProducts{position:relative;border:1px solid #d3d3d3;margin:0 0 10px;padding:10px 0}#diamonds-direct .CompareProducts .favesWrapper{text-align:center}#diamonds-direct .CompareProducts .favesWrapper .noItemsMessage{display:none;font-family:Lusitana,serif;font-size:18px;text-transform:uppercase;margin:10px 0}@media (max-width:900px){#diamonds-direct .CompareProducts .favesWrapper .noItemsMessage{display:block}}#diamonds-direct .CompareProducts .favesWrapper .faveBr{background:#5e5e5e;width:1px;height:100%}#diamonds-direct .CompareProducts .favesWrapper .faveItem{position:relative;display:inline-block;vertical-align:top;margin:10px 0;width:calc(25% - 1px);transition:width .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .CompareProducts .favesWrapper .faveItem{width:calc(50% - 1px)}}@media (max-width:768px){#diamonds-direct .CompareProducts .favesWrapper .faveItem{width:calc(100% - 1px)}}#diamonds-direct .CompareProducts .favesWrapper .faveItem .compareNumber{position:absolute;top:0;right:10px;width:auto;height:auto;text-align:center;font-size:90px;font-family:Lusitana,serif;color:#eee}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveRemove{position:absolute;top:-20px;right:10px;width:auto;height:auto;text-align:center;font-size:36px;font-weight:300;cursor:pointer;color:#eee;transition:color .25s ease-in-out 0ms}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveRemove:hover{color:#5e5e5e}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveImg{text-align:center;height:120px;cursor:pointer}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveImg img{height:100%;max-width:100%}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveTitle{position:relative;height:70px;margin:0 10px;font-family:Lusitana,serif;color:#5e5e5e;text-transform:uppercase;font-size:20px;line-height:1.1}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveTitle div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveDataRow{background:#fff;padding:5px 0;font-size:16px}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveDataRow:nth-child(2n){background:#f5f5f5}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveDataRow .faveDataLabel{display:inline-block;vertical-align:top;width:calc(50% - 5px);margin:0;text-align:right;font-size:14px;font-weight:400}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveDataRow .faveDataValue{display:inline-block;vertical-align:top;width:calc(50% - 10px);margin:0 0 0 10px;text-align:left;font-size:14px;font-weight:300}#diamonds-direct .CompareProducts .favesWrapper .faveItem .favePrice{margin:10px 0;font-family:Lusitana,serif;color:#5e5e5e;text-transform:uppercase;font-size:20px}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveAdd.selected{color:#fff;background:#4b2d53;border:1px solid #4b2d53;cursor:default}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveAdd{margin:0 auto 25px;width:200px;color:#5e5e5e;background:#fff;border:1px solid #5e5e5e;font-family:Lato,sans-serif;text-transform:uppercase;font-size:14px;font-weight:700;padding:8px 0;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}#diamonds-direct .CompareProducts .favesWrapper .faveItem .faveAdd:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}@media (max-width:900px){#diamonds-direct .CompareProducts .favesWrapper .faveEmpty.faveItem{display:none}}#diamonds-direct .CompareProducts .favesWrapper .faveEmpty.faveItem .heartSection{position:relative;margin:75px 0 20px;font-family:Lusitana,serif;color:#5e5e5e;text-transform:uppercase;text-align:center}#diamonds-direct .CompareProducts .favesWrapper .faveEmpty.faveItem .heartSection img{width:90%}#diamonds-direct .CompareProducts .favesWrapper .faveEmpty.faveItem .heartSection div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .EngagementFilters{position:relative;color:#000}#diamonds-direct .EngagementFilters .rbFilterWrapper{position:relative;background:#fff;padding-bottom:25px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper{margin:25px 50px 25px 25px;background:#fff}@media (max-width:1024px){#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper{margin-top:0}}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .diamondSection.disabled .headerItem.filterItem{color:#000}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .diamondSection.disabled .filterItem{color:#d3d3d3;cursor:pointer}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .settingSection.disabled .headerItem.filterItem{color:#000}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .settingSection.disabled .filterItem{color:#d3d3d3;cursor:pointer}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIcon{font-weight:300;font-family:Josefin Sans,sans-serif}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead,#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead{font-family:Lusitana,serif;font-weight:700;font-size:18px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterValue,#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterValue{display:inline-block;vertical-align:top}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset{display:inline-block;vertical-align:top;height:16px;margin:0 0 0 8px;cursor:pointer;text-decoration:none;font-size:12px;line-height:12px;font-family:Lato,sans-serif;font-weight:300;text-transform:none}@media (max-width:1024px){#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset,#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset{display:none}}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset img,#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset img{height:100%;transition:transform .4s ease-in-out 0ms}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset:hover,#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset:hover{text-decoration:underline}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterLabel .filterReset:hover img,#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterLabel .filterReset:hover img{transform:rotate(180deg)}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIconRadio,#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterIconRadio{position:absolute;top:12px;right:5px;bottom:12px;width:14px;font-size:32px;border:1px solid #000}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .budgetItem.filterItem .filterHead .filterIconRadio .filterIconRadioInner,#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .headerItem.filterItem .filterHead .filterIconRadio .filterIconRadioInner{position:absolute;top:3px;left:3px;right:3px;bottom:3px;background:#000}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterHead .filterIcon.openIcon{display:-ms-flexbox;display:flex}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterHead .filterIcon{display:none}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem.open .filterBody{max-height:200px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterHead .filterIcon.openIcon{display:-ms-flexbox;display:flex}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterHead .filterIcon{display:none}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem.midOpen .filterBody{max-height:400px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterHead .filterIcon.openIcon{display:-ms-flexbox;display:flex}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterHead .filterIcon{display:none}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem.longOpen .filterBody{max-height:1000px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem{position:relative;border-bottom:1px solid #707070;font-family:Josefin Sans,sans-serif;font-weight:300;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:color .1s ease-in-out 0ms}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead{position:relative;cursor:pointer;font-size:16px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel{padding:13px 0 9px;line-height:1;display:-ms-flexbox;display:flex;-ms-flex-pack:left;justify-content:left;-ms-flex-align:center;align-items:center}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterValue{display:inline-block;vertical-align:top}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset{position:relative;display:inline-block;vertical-align:top;height:12px;margin:-5px 0 0 8px;cursor:pointer}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset:hover .infoVal{display:block}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset img{height:100%}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterLabel .filterReset .infoVal{display:none;border:1px solid #000;background:#fff;padding:8px 10px;position:absolute;left:25px;top:0;width:200px;height:auto;z-index:2;text-transform:none}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterIcon.openIcon{display:none}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterHead .filterIcon{position:absolute;top:0;right:0;bottom:0;width:25px;font-size:32px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody{height:auto;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper{margin:10px auto;max-width:600px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .disabled.advancedItemWrapper{color:#d3d3d3}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper{margin:0 0 20px 10px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle{font-size:14px;font-weight:700}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle .advTitleLabel{display:inline-block;vertical-align:top;width:auto}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle .advancedInfo{position:relative;display:inline-block;vertical-align:top;width:12px;height:12px;margin:0 0 0 8px;cursor:pointer;text-decoration:none;font-size:12px;line-height:12px;font-family:Lato,sans-serif;font-weight:300;text-transform:none}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle .advancedInfo:hover .infoVal{display:block}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle .advancedInfo img{height:100%}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle .advancedInfo .upInfo.infoVal{top:auto;bottom:25px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .controlsWrapper .advancedItemWrapper .advancedTitle .advancedInfo .infoVal{display:none;border:1px solid #000;background:#fff;padding:8px 10px;color:#000;position:absolute;left:-20px;top:25px;width:200px;height:auto;font-size:16px;z-index:2;text-transform:none;line-height:16px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .filterItem .filterBody .cutNote{text-transform:none;text-align:center;margin:0 0 10px}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .submitSection{margin:25px 0 0}#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .submitSection .filterSubmitButton{font-size:18px}@media (max-width:1024px){#diamonds-direct .EngagementFilters .rbFilterWrapper .rbInternalWrapper .submitSection{display:none}}#diamonds-direct .EngagementFilters .filterSeparation{position:absolute;top:0;right:0;width:6px;bottom:0;background:#ebebeb;border-radius:3px}#diamonds-direct .EarringSplash{position:relative;color:#5e5e5e;margin:0 auto 50px;max-width:1024px;transition:max-width .35s linear 0ms;font-family:Lato,sans-serif}#diamonds-direct .EarringSplash .esItemButton{display:inline-block;width:auto;border:1px solid #5e5e5e;color:#5e5e5e;background:#fff;font-size:12px;text-transform:uppercase;font-weight:700;padding:20px 30px;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}@media (max-width:600px){#diamonds-direct .EarringSplash .esItemButton{width:180px;padding:15px 0;font-family:Lato,sans-serif;font-size:14px}}#diamonds-direct .EarringSplash .esItemButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .EarringSplash .esItem{display:inline-block;vertical-align:top;margin:0 10px;width:calc(33.33% - 20px)}@media (max-width:1024px){#diamonds-direct .EarringSplash .esItem{display:block;width:calc(100% - 20px);max-width:400px;margin:0 auto 25px}}#diamonds-direct .EarringSplash .esItem .esItemImg{height:300px;margin:0 0 10px}#diamonds-direct .EarringSplash .esItem .esItemImg img{width:100%;height:100%;object-fit:contain}#diamonds-direct .EarringSplash .esItem .esItemButtonWrapper{text-align:center}#diamonds-direct .EarringSplash .esTop{position:relative;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/fashion.jpg\");background-position:50%;background-size:cover;background-repeat:no-repeat;padding-bottom:48%}@media (max-width:1024px){#diamonds-direct .EarringSplash .esTop{background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/fashion_m.jpg\");background-position:0 0;background-size:contain;overflow:auto;padding-bottom:20px}}#diamonds-direct .EarringSplash .esTop .esTopRow{position:absolute;top:60%;left:0;width:100%;height:auto}@media (max-width:1024px){#diamonds-direct .EarringSplash .esTop .esTopRow{position:relative;top:unset;left:unset;margin-top:70%}}#diamonds-direct .EarringSplash .esMid{position:relative;margin:20% 0 0}@media (max-width:1024px){#diamonds-direct .EarringSplash .esMid{margin:0}}#diamonds-direct .EarringSplash .esMid .esMidLeft{position:absolute;top:0;left:0;bottom:0;width:50%;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/butterfly.jpg\");background-position:50%;background-size:cover;background-repeat:no-repeat}@media (max-width:1024px){#diamonds-direct .EarringSplash .esMid .esMidLeft{position:relative;top:unset;left:unset;bottom:unset;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/butterfly_m.jpg\");width:100%;padding-bottom:132%}}#diamonds-direct .EarringSplash .esMid .esMidRight{position:relative;overflow:auto;width:50%;margin:0 0 0 50%}@media (max-width:1024px){#diamonds-direct .EarringSplash .esMid .esMidRight{width:100%;margin:0}}#diamonds-direct .EarringSplash .esMid .esMidRight .esMidItemImg{margin:0}#diamonds-direct .EarringSplash .esMid .esMidRight .esMidItemImg img{width:100%}#diamonds-direct .EarringSplash .esMid .esMidRight .esMidItemTitle{border-bottom:20px solid #e3dced;margin:0 15% 50px;padding:0;width:auto;font-family:Lusitana,serif;text-transform:uppercase;font-size:26px;text-align:center}@media (max-width:1024px){#diamonds-direct .EarringSplash .esMid .esMidRight .esMidItemTitle{margin:0 5% 35px}}#diamonds-direct .EarringSplash .esMid .esMidRight .esMidItemCopy{font-weight:300;font-size:16px;margin:0 20% 75px;text-align:center}@media (max-width:1024px){#diamonds-direct .EarringSplash .esMid .esMidRight .esMidItemCopy{margin:0 10% 35px}}#diamonds-direct .EarringSplash .esMid .esMidRight .esMidItemButtonWrapper{margin:0 0 50px;text-align:center}@media (max-width:1024px){#diamonds-direct .EarringSplash .esMid .esMidRight .esMidItemButtonWrapper{margin:0 0 25px}}#diamonds-direct .EarringSplash .esBottom{background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/coloredstones.jpg\");background-position:50%;background-size:cover;background-repeat:no-repeat;position:relative;padding-bottom:36%;margin:20% 0 0}@media (max-width:1024px){#diamonds-direct .EarringSplash .esBottom{background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/coloredstones_m.jpg\");background-position:0 0;background-size:contain;overflow:auto}}#diamonds-direct .EarringSplash .esBottom .esBottomRow{position:absolute;top:-50%;left:0;width:100%;height:auto}@media (max-width:1024px){#diamonds-direct .EarringSplash .esBottom .esBottomRow{position:relative;top:unset;left:unset;margin-top:80%}}#diamonds-direct .rbResultsWrapper.filtersOpen .MixedResults .FloatingHeader .floatingHeader{left:400px}#diamonds-direct .FloatingHeader .floatingHeader.open{max-height:500px}#diamonds-direct .FloatingHeader .floatingHeader{position:fixed;top:80px;left:80px;right:0;height:auto;max-height:0;background:none;overflow:hidden;z-index:3;transition:max-height .4s ease-in-out 0ms,top .35s linear 0ms,left .4s ease-in-out 0ms}@media (max-width:1024px){#diamonds-direct .FloatingHeader .floatingHeader{left:0}}@media (max-width:768px){#diamonds-direct .FloatingHeader .floatingHeader{top:50px}}#diamonds-direct .FloatingHeader .floatingHeader .backgroundSection{background:#fff;overflow:auto}#diamonds-direct .FloatingHeader .floatingHeader .labelSection{position:relative;margin:15px 25px;height:40px}#diamonds-direct .FloatingHeader .floatingHeader .labelSection .labelTitle{width:280px}#diamonds-direct .FloatingHeader .floatingHeader .labelSection .toggleWrapper{position:absolute;top:10px;right:5px;bottom:5px;width:30px;cursor:pointer}#diamonds-direct .FloatingHeader .floatingHeader .labelSection .toggleWrapper .toggleIcon{position:relative;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;font-size:32px;font-weight:700;color:#4b2d53}#diamonds-direct .FloatingHeader .floatingHeader .fhOuterWrapper.closed{max-height:0}#diamonds-direct .FloatingHeader .floatingHeader .fhOuterWrapper{height:auto;max-height:400px;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper{position:relative;margin:10px 25px;border:1px solid #707070;text-align:center}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhImageSection{display:inline-block;vertical-align:top;width:calc(33.33% - 21px);margin:25px 10px 0}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhImageSection img{width:100%;max-width:180px}@media (max-width:768px){#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhImageSection{display:none}}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhImageSection .fhMessage{margin:10px 5%;text-align:center;font-family:Lusitana,serif;font-size:18px;text-transform:uppercase}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhImageSection .fhPrice{font-size:20px;font-family:Lusitana,serif}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhImageSection .addToCartWrapper{margin:10px 0}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhImageSection .addToCartWrapper .addButton.mixedResultsButton{width:160px;height:30px;line-height:30px;background:#4b2d53;color:#fff}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhImageSection .addToCartWrapper .addButton.mixedResultsButton:hover{color:#fff;background:#000;border-color:#000}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection{border-left:1px solid #707070;border-right:1px solid #707070;border-bottom:none}@media (max-width:768px){#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection{border-left:none;border-right:none}}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection{display:inline-block;vertical-align:top;width:calc(33.33% - 21px);margin:15px 0;padding:0 10px;position:relative;text-align:left;transition:width .35s linear 0ms,padding .35s linear 0ms}@media (max-width:768px){#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection{width:calc(50% - 11px);padding:0 5px}}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .removeX,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .removeX{position:absolute;top:-8px;right:0;width:25px;height:25px;cursor:pointer;font-size:24px;font-weight:300;transition:color .25s ease-in-out 0ms}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .removeX:hover,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .removeX:hover{color:#4b2d53}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .fhMessage,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .fhMessage{position:relative;margin:25px 5%;text-align:center;font-family:Lusitana,serif;font-size:18px;text-transform:uppercase}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .fhMessage div,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .fhMessage div{position:absolute;top:0;right:0;left:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .imageWrapper,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .imageWrapper{display:inline-block;vertical-align:top;width:40%;text-align:center}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .imageWrapper img,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .imageWrapper img{width:100%;max-width:160px}@media (max-width:600px){#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .imageWrapper img,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .imageWrapper img{width:auto;max-width:none;height:100%}}@media (max-width:600px){#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .imageWrapper,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .imageWrapper{display:block;width:auto;height:100px;height:80px}}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper{display:inline-block;vertical-align:top;width:calc(60% - 20px);margin:0 10px;text-align:center}@media (max-width:600px){#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper{display:block;width:auto}}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper .sectionName,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper .sectionName{font-family:Lusitana,serif;text-transform:uppercase;margin:25px 0 0;font-size:16px}@media (max-width:1024px){#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper .sectionName,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper .sectionName{margin:0;font-size:14px}}@media (max-width:768px){#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper .sectionName,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper .sectionName{font-size:12px}}@media (max-width:600px){#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper .sectionName,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper .sectionName{margin:10px 0 0}}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper .sectionPrice,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper .sectionPrice{font-family:Lusitana,serif;text-transform:uppercase;margin:10px 0 0;font-size:20px}@media (max-width:600px){#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper .sectionPrice,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper .sectionPrice{margin:5px 0 0}}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper .sectionPriceNotice,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper .sectionPriceNotice{font-family:Lato,sans-serif;margin:0;font-size:12px;font-weight:300}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper .diamondInfoButtonRow,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper .diamondInfoButtonRow{margin:10px 0}#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhDiamondSection .sectionWrapper .diamondInfoButtonRow .fhButton,#diamonds-direct .FloatingHeader .floatingHeader .fhWrapper .fhSettingSection .sectionWrapper .diamondInfoButtonRow .fhButton{width:100px}#diamonds-direct .FloatingHeader .floatingHeader .controlsWrapper{position:relative;display:inline-block;vertical-align:top;width:80px;height:80px;cursor:pointer}#diamonds-direct .FloatingHeader .floatingHeader .controlsWrapper .floatingIndicatorIcon{display:inline-block;vertical-align:top;margin:15px}#diamonds-direct .FloatingHeader .floatingHeader .controlsWrapper .floatingIndicatorIcon img{width:100%}#diamonds-direct .NecklaceSplash{position:relative;overflow:auto;color:#5e5e5e;margin:0 auto 50px;max-width:1024px;transition:max-width .35s linear 0ms;font-family:Lato,sans-serif}#diamonds-direct .NecklaceSplash .nsFloatingImg{position:absolute;top:0;left:55%;width:35%;height:auto;z-index:2}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsFloatingImg{display:none}}#diamonds-direct .NecklaceSplash .nsFloatingImg img{width:100%}#diamonds-direct .NecklaceSplash .nsTitle{font-size:36px;font-family:Lusitana,serif;color:#5e5e5e;margin:25px 0;text-transform:uppercase}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTitle{display:none}}#diamonds-direct .NecklaceSplash .nsTopSection{position:relative}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBg{position:absolute;top:0;left:0;width:100%;height:100%}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBg{position:relative;height:auto}}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBg .nsTopBgImg1{position:absolute;top:0;left:0;width:33%;height:auto}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBg .nsTopBgImg1{position:relative;width:100%}}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBg .nsTopBgImg1 img{width:100%}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBg .nsTopBgImg2{position:absolute;bottom:0;right:0;width:33%;height:auto}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBg .nsTopBgImg2{display:none}}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBg .nsTopBgImg2 img{width:100%}#diamonds-direct .NecklaceSplash .nsTopSection .nsMobileInterloper{display:none;margin:-50px 0 0}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTopSection .nsMobileInterloper{display:block}}#diamonds-direct .NecklaceSplash .nsTopSection .nsMobileInterloper img{width:100%}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper{position:relative;margin:0 auto;width:50%}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper{width:auto;margin:0 10px}}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper:nth-child(2) .nsTopBlock{top:25px}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper:nth-child(2) .nsTopBlock{top:unset;margin:-50px 0 0}}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper:last-child .nsTopBlock{margin:35px 0 0}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper:last-child .nsTopBlock{margin:-50px 0 0}}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsWeirdHangingOutImg{position:absolute;top:0;left:0;width:30%;height:auto;z-index:2}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsWeirdHangingOutImg{display:none}}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsWeirdHangingOutImg img{width:100%}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock{position:relative;border:1px solid #5e5e5e;background:#fff;padding:25px 0;z-index:1}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock .nsTopBlockWrapper{text-align:center}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock .nsTopBlockWrapper .nsTopBlockTitle{display:inline-block;overflow:visible;height:0;border-bottom:20px solid #e3dced;margin:0 0 25px;padding:0 15px 12px;width:auto;font-family:Lusitana,serif;text-transform:uppercase;font-size:26px;text-align:center}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock .nsTopBlockWrapper .nsTopBlockCopy{font-weight:300;font-size:16px;margin:0 10% 75px;text-align:left}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock .nsTopBlockWrapper .nsTopBlockButton{display:inline-block;width:auto;border:1px solid #5e5e5e;color:#5e5e5e;background:#fff;font-size:12px;text-transform:uppercase;font-weight:700;padding:20px 30px;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}@media (max-width:600px){#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock .nsTopBlockWrapper .nsTopBlockButton{width:180px;padding:15px 0;font-family:Lato,sans-serif;font-size:14px}}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock .nsTopBlockWrapper .nsTopBlockButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock .nsTopBlockWrapperLeft{margin-right:25%}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock .nsTopBlockWrapperLeft{margin:0}}#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock .nsTopBlockWrapperRight{margin-left:25%}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsTopSection .nsTopBlockOuterWrapper .nsTopBlock .nsTopBlockWrapperRight{margin:0}}#diamonds-direct .NecklaceSplash .nsBottomSection{margin:75px 0 0}#diamonds-direct .NecklaceSplash .nsBottomSection .nsbLeft{display:inline-block;vertical-align:top;width:calc(30.22% - 15px)}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsBottomSection .nsbLeft{display:block;width:100%}}#diamonds-direct .NecklaceSplash .nsBottomSection .nsbMid{display:inline-block;vertical-align:top;width:calc(100% - 2*30.22% - 15px);margin:0 0 0 15px}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsBottomSection .nsbMid{display:block;width:100%;margin:0}}#diamonds-direct .NecklaceSplash .nsBottomSection .nsbMid .midImg img{width:100%}#diamonds-direct .NecklaceSplash .nsBottomSection .nsbRight{display:inline-block;vertical-align:top;width:calc(30.22% - 15px);margin:0 0 0 15px}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsBottomSection .nsbRight{display:block;width:100%;margin:0}}#diamonds-direct .NecklaceSplash .nsBottomSection .outerImg img{width:100%}#diamonds-direct .NecklaceSplash .nsBottomSection .nsbLabel{height:20px;font-family:Lusitana,serif;text-align:right;font-size:14px}@media (max-width:1024px){#diamonds-direct .NecklaceSplash .nsBottomSection .nsbLabel{text-align:center;margin:0 0 10px}}#diamonds-direct .EngagementSplash{margin:25px 0 0}@media (max-width:600px){#diamonds-direct .EngagementSplash{margin:0}}#diamonds-direct .EngagementSplash .esSection{margin:0 auto 50px;max-width:1024px;transition:max-width .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .EngagementSplash .esSection{max-width:768px}}@media (max-width:600px){#diamonds-direct .EngagementSplash .esSection{margin:0 auto}}#diamonds-direct .EngagementSplash .esSection .promptBox{position:relative}#diamonds-direct .EngagementSplash .esSection .promptBox .promptImg{position:absolute;width:90%;left:5%;height:auto}#diamonds-direct .EngagementSplash .esSection .promptBox .promptImg img{width:100%}#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper{text-align:center;background:#fff;border:1px solid #dbdbdb;padding:25px}#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper .promptTitle{display:inline-block;overflow:visible;height:0;border-bottom:10px solid #e3ddec;margin:0 0 25px;padding:0 10px 12px;width:auto;font-family:Lusitana,serif;color:#666;text-transform:uppercase;font-size:22px;transition:font-size .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper .promptTitle{font-size:16px}}@media (max-width:1024px){#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper .promptTitle{font-size:20px}}@media (max-width:600px){#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper .promptTitle{font-size:24px}}#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper .promptCopy{font-size:18px;font-weight:300;color:#666;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper .promptCopy{font-size:16px}}@media (max-width:600px){#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper .promptCopy{font-family:Lato,sans-serif}}#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper .promptButton{display:inline-block;width:120px;border:1px solid #8c8c8c;color:#8c8c8c;background:#fff;font-size:12px;text-transform:uppercase;font-weight:700;margin:25px 0 0;padding:10px 0;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}@media (max-width:600px){#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper .promptButton{width:180px;padding:15px 0;font-family:Lato,sans-serif;font-size:14px}}#diamonds-direct .EngagementSplash .esSection .promptBox .promptWrapper .promptButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .EngagementSplash .topSection{padding:20px 0}@media (max-width:600px){#diamonds-direct .EngagementSplash .topSection{padding:0}}#diamonds-direct .EngagementSplash .topSection .topLeftWrapper{display:inline-block;vertical-align:top;width:50%;margin:0}@media (max-width:600px){#diamonds-direct .EngagementSplash .topSection .topLeftWrapper{display:block;width:100%}}#diamonds-direct .EngagementSplash .topSection .topLeftWrapper .imgWrapper{margin:0 0 25px}#diamonds-direct .EngagementSplash .topSection .topLeftWrapper .imgWrapper img{width:100%}#diamonds-direct .EngagementSplash .topSection .topLeftWrapper .promptBoxTopLeft .promptImg{bottom:90%}#diamonds-direct .EngagementSplash .topSection .mobileSpacer{display:none}@media (max-width:600px){#diamonds-direct .EngagementSplash .topSection .mobileSpacer{display:block}}#diamonds-direct .EngagementSplash .topSection .mobileSpacer img{width:100%;display:block}#diamonds-direct .EngagementSplash .topSection .topRightWrapper{display:inline-block;vertical-align:top;width:50%}@media (max-width:600px){#diamonds-direct .EngagementSplash .topSection .topRightWrapper{display:block;width:100%}}#diamonds-direct .EngagementSplash .topSection .topRightWrapper .imgWrapper{margin:25px 0 0}#diamonds-direct .EngagementSplash .topSection .topRightWrapper .imgWrapper img{width:100%}#diamonds-direct .EngagementSplash .topSection .topRightWrapper .promptBoxTopRight .promptImg{top:90%}#diamonds-direct .EngagementSplash .middleSection .midLeftWrapper{display:inline-block;vertical-align:top;width:40%}@media (max-width:600px){#diamonds-direct .EngagementSplash .middleSection .midLeftWrapper{display:none}}#diamonds-direct .EngagementSplash .middleSection .midLeftWrapper img{width:100%}#diamonds-direct .EngagementSplash .middleSection .midRightWrapper{display:inline-block;vertical-align:top;width:60%}@media (max-width:600px){#diamonds-direct .EngagementSplash .middleSection .midRightWrapper{display:block;width:100%}}#diamonds-direct .EngagementSplash .middleSection .midRightWrapper .midRightImgWrapper{margin-top:25px}@media (max-width:600px){#diamonds-direct .EngagementSplash .middleSection .midRightWrapper .midRightImgWrapper{margin-top:5px}}#diamonds-direct .EngagementSplash .middleSection .midRightWrapper .midRightImgWrapper img{width:100%}#diamonds-direct .EngagementSplash .middleSection .midRightWrapper .promptBoxMid{margin:25% 0 0}#diamonds-direct .EngagementSplash .middleSection .midRightWrapper .promptBoxMid .promptImg{width:50%;left:25%;bottom:90%}@media (max-width:600px){#diamonds-direct .EngagementSplash .middleSection .midRightWrapper .promptBoxMid .promptImg{width:80%;left:10%;bottom:95%}}#diamonds-direct .EngagementSplash .middleSection .midRightWrapper .promptBoxMid .promptWrapper{border:none}#diamonds-direct .EngagementSplash .bottomSection{position:relative}#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper{display:inline-block;vertical-align:top;width:50%}@media (max-width:600px){#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper{display:block;width:100%}}#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper .blImg{width:60%}@media (max-width:600px){#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper .blImg{width:100%;margin:0}}#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper .blImg img{width:100%}#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper .promptBoxBottomLeft{position:absolute;top:10%;left:20%;width:50%;height:auto}@media (max-width:600px){#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper .promptBoxBottomLeft{position:relative;top:0;left:0;width:100%;height:auto}}#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper .promptBoxBottomLeft .promptImg{bottom:50%;width:70%;left:15%}@media (max-width:600px){#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper .promptBoxBottomLeft .promptImg{bottom:60%}}#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper .promptBoxBottomLeft .promptWrapper{border:none;box-shadow:2px 2px 5px 0 #dbdbdb;padding-top:25%}#diamonds-direct .EngagementSplash .bottomSection .bottomLeftWrapper .promptBoxBottomLeft .promptWrapper .promptButton{margin-top:0}#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper{display:inline-block;vertical-align:top;width:50%}@media (max-width:600px){#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper{display:block;width:100%}}#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .brImg{width:60%;margin:0 0 0 40%}@media (max-width:600px){#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .brImg{width:100%;margin:0}}#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .brImg img{width:100%}#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .promptBoxBottomRight{position:absolute;top:60%;right:20%;width:50%;height:auto}@media (max-width:600px){#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .promptBoxBottomRight{position:relative;top:0;left:0;width:100%;height:auto}}#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .promptBoxBottomRight .promptImg{bottom:50%;width:50%;left:25%}@media (max-width:600px){#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .promptBoxBottomRight .promptImg{bottom:60%;width:70%;left:15%}}#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .promptBoxBottomRight .promptWrapper{border:none;box-shadow:2px 2px 5px 0 #dbdbdb;padding-top:25%}@media (max-width:600px){#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .promptBoxBottomRight .promptWrapper .promptTitle{padding:0 10px 20px}}#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .promptBoxBottomRight .promptWrapper .promptButton{margin-top:0}@media (max-width:600px){#diamonds-direct .EngagementSplash .bottomSection .bottomRightWrapper .promptBoxBottomRight .promptWrapper .promptButton{margin-top:8px}}#diamonds-direct .MensBandsSplash{margin:25px auto;width:calc(100% - 50px);max-width:1024px}@media (max-width:600px){#diamonds-direct .MensBandsSplash{margin:0;width:100%}}#diamonds-direct .MensBandsSplash .promptBox{position:relative}#diamonds-direct .MensBandsSplash .promptBox .promptImg{position:relative;width:50%;min-width:250px;height:auto;margin:25px auto 0}#diamonds-direct .MensBandsSplash .promptBox .promptImg img{width:100%}#diamonds-direct .MensBandsSplash .promptBox .promptWrapper{text-align:center;background:#fff;border:2px solid #dbdbdb;padding:25px}#diamonds-direct .MensBandsSplash .promptBox .promptWrapper .promptTitle{display:inline-block;overflow:visible;height:0;border-bottom:20px solid #e3ddec;margin:0 0 25px;padding:0 10px 12px;width:60%;font-family:Lusitana,serif;color:#666;text-transform:uppercase;font-size:26px;transition:font-size .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .MensBandsSplash .promptBox .promptWrapper .promptTitle{font-size:22px}}#diamonds-direct .MensBandsSplash .promptBox .promptWrapper .promptCopy{text-align:left;font-size:18px;font-weight:300;color:#666;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .MensBandsSplash .promptBox .promptWrapper .promptCopy{font-size:16px}}@media (max-width:600px){#diamonds-direct .MensBandsSplash .promptBox .promptWrapper .promptCopy{font-family:Lato,sans-serif}}#diamonds-direct .MensBandsSplash .promptBox .promptButton{display:inline-block;width:120px;border:1px solid #8c8c8c;color:#8c8c8c;background:#fff;font-size:12px;text-transform:uppercase;font-weight:700;margin:25px 0 0;padding:10px 0;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}@media (max-width:600px){#diamonds-direct .MensBandsSplash .promptBox .promptButton{width:180px;font-family:Lato,sans-serif;font-size:14px;padding:15px 0}}#diamonds-direct .MensBandsSplash .promptBox .promptButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .MensBandsSplash .mbTopSection{background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/twotone.jpg\");background-repeat:no-repeat;background-position:0 0;background-size:contain;overflow:auto;margin:0 0 40px}@media (max-width:600px){#diamonds-direct .MensBandsSplash .mbTopSection{width:100%;margin:0;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/mobile/twotone_m.jpg\")}}#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper{margin:25px 0 25px 40%;transition:margin .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper{margin-left:28%}}@media (max-width:600px){#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper{margin:81% 0 25px}}#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper .topPrompt .promptWrapper{padding:25px 50px 100px}@media (max-width:600px){#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper .topPrompt .promptWrapper{border:none;box-shadow:none;padding:25px 20px 100px}}@media (max-width:600px){#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper .topPrompt .ringsWrapper{margin:-20% 0 0}}#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper .topPrompt .ringsWrapper .ringItem{display:inline-block;vertical-align:top;margin:-75px 10px 0;width:calc(33.33% - 20px);text-align:center}@media (max-width:600px){#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper .topPrompt .ringsWrapper .ringItem{display:block;margin:0 auto 25px;width:55%}}#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper .topPrompt .ringsWrapper .ringItem .ringItemImgWrapper{margin:0 5%;height:80px;text-align:center}#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper .topPrompt .ringsWrapper .ringItem .ringItemImgWrapper img{width:100%;max-width:100%;max-height:100%}#diamonds-direct .MensBandsSplash .mbTopSection .topPromptWrapper .topPrompt .ringsWrapper .ringItem .promptButton{margin-top:10px}#diamonds-direct .MensBandsSplash .mbBottomSection{margin:0 0 25px}#diamonds-direct .MensBandsSplash .mbBottomSection .bottomPromptWrapper{display:inline-block;vertical-align:top;width:50%;overflow:auto;margin:4% 0 0}@media (max-width:600px){#diamonds-direct .MensBandsSplash .mbBottomSection .bottomPromptWrapper{display:block;width:100%}}#diamonds-direct .MensBandsSplash .mbBottomSection .bottomPromptWrapper .bottomPrompt .promptWrapper{border:none;padding:25px 0}#diamonds-direct .MensBandsSplash .mbBottomSection .bottomPromptWrapper .bottomPrompt .promptWrapper .promptCopy{padding:0 5%}#diamonds-direct .MensBandsSplash .mbBottomSection .bottomPromptWrapper .bottomPrompt .promptWrapper .promptButton{width:200px;padding:15px 0}@media (max-width:600px){#diamonds-direct .MensBandsSplash .mbBottomSection .bottomImgWrapper.desktopBottomImgWrapper{display:none}}#diamonds-direct .MensBandsSplash .mbBottomSection .bottomImgWrapper.mobileBottomImgWrapper{display:none}@media (max-width:600px){#diamonds-direct .MensBandsSplash .mbBottomSection .bottomImgWrapper.mobileBottomImgWrapper{display:block}}#diamonds-direct .MensBandsSplash .mbBottomSection .bottomImgWrapper{display:inline-block;vertical-align:top;width:50%}@media (max-width:600px){#diamonds-direct .MensBandsSplash .mbBottomSection .bottomImgWrapper{width:100%}}#diamonds-direct .MensBandsSplash .mbBottomSection .bottomImgWrapper img{width:100%}#diamonds-direct .WomensBandsSplash{margin:25px auto;width:calc(100% - 50px);max-width:1024px}@media (max-width:600px){#diamonds-direct .WomensBandsSplash{margin:0;width:100%}}#diamonds-direct .WomensBandsSplash .promptBox{position:relative}#diamonds-direct .WomensBandsSplash .promptBox .promptImg{position:absolute;width:90%;left:5%;height:auto}#diamonds-direct .WomensBandsSplash .promptBox .promptImg img{width:100%}#diamonds-direct .WomensBandsSplash .promptBox .promptWrapper{text-align:center;background:#fff;border:none;padding:25px}#diamonds-direct .WomensBandsSplash .promptBox .promptWrapper .promptTitle{display:inline-block;overflow:visible;height:0;border-bottom:20px solid #e3ddec;margin:0 0 25px;padding:0 10px 12px;width:auto;font-family:Lusitana,serif;color:#666;text-transform:uppercase;font-size:26px;transition:font-size .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .WomensBandsSplash .promptBox .promptWrapper .promptTitle{font-size:22px}}#diamonds-direct .WomensBandsSplash .promptBox .promptWrapper .promptCopy{font-size:18px;font-weight:300;line-height:1.4;color:#666;transition:font-size .35s linear 0ms}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .promptBox .promptWrapper .promptCopy{font-family:Lato,sans-serif}}#diamonds-direct .WomensBandsSplash .promptBox .promptWrapper .promptButton{display:inline-block;width:200px;border:1px solid #8c8c8c;color:#8c8c8c;background:#fff;font-size:12px;text-transform:uppercase;font-weight:700;margin:25px 0 10px;padding:15px 0;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .promptBox .promptWrapper .promptButton{font-family:Lato,sans-serif;width:180px}}#diamonds-direct .WomensBandsSplash .promptBox .promptWrapper .promptButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .WomensBandsSplash .wbsSection{position:relative}#diamonds-direct .WomensBandsSplash .wbsSection .wbCol1{width:45%}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsSection .wbCol1{width:100%}}#diamonds-direct .WomensBandsSplash .wbsSection .wbCol2{width:55%}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsSection .wbCol2{width:100%}}#diamonds-direct .WomensBandsSplash .wbsSection .wbImgCol{background-repeat:no-repeat;background-position:50%;background-size:cover;position:absolute;top:0;height:100%}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsSection .wbImgCol{position:relative;padding-bottom:20%}}#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol1{left:0;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/dainty1.jpg\")}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol1{padding-bottom:73%;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/mobile/dainty1_m.jpg\")}}#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol2{margin:0 0 0 45%;overflow:auto}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol2{margin:0}}#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol2 .topPromptHeader{margin:25px 0 0}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol2 .topPromptHeader{margin:0}}#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol2 .topPromptHeader img{width:100%}#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol2 .topPromptWrapper .promptTop .promptImg{width:34%;left:33%;bottom:78%}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol2 .topPromptWrapper .promptTop .promptImg{left:15%;width:70%}}#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol2 .topPromptWrapper .promptTop .promptWrapper{padding-top:75px;padding-bottom:60px}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsTopSection .wbCol2 .topPromptWrapper .promptTop .promptWrapper{padding-top:100px}}#diamonds-direct .WomensBandsSplash .wbsMidSection{margin:-50px 0 0}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsMidSection{margin:-50px 0 0}}#diamonds-direct .WomensBandsSplash .wbsMidSection .wbCol1{position:relative;margin:0 55% 0 0;z-index:1}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsMidSection .wbCol1{margin:0}}#diamonds-direct .WomensBandsSplash .wbsMidSection .wbCol1 .midPromptWrapper{margin:50px -30% 35px 0}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsMidSection .wbCol1 .midPromptWrapper{margin:50px 0 35px}}#diamonds-direct .WomensBandsSplash .wbsMidSection .wbCol1 .midPromptWrapper .promptMid .promptImg{width:44%;left:28%;bottom:75%}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsMidSection .wbCol1 .midPromptWrapper .promptMid .promptImg{width:70%;left:15%;bottom:80%}}#diamonds-direct .WomensBandsSplash .wbsMidSection .wbCol1 .midPromptWrapper .promptMid .promptWrapper{padding-top:75px}#diamonds-direct .WomensBandsSplash .wbsMidSection .wbCol2{top:-50px;bottom:-35px;height:auto;left:45%;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/exquisite.jpg\")}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsMidSection .wbCol2{top:0;bottom:0;height:auto;left:0;padding-bottom:75%;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/mobile/exquisite_m.jpg\")}}#diamonds-direct .WomensBandsSplash .wbsBottomSection{margin:-35px 0 0}#diamonds-direct .WomensBandsSplash .wbsBottomSection .wbCol1{left:0;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/twist.jpg\")}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsBottomSection .wbCol1{padding-bottom:89%;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/mobile/twist_m.jpg\")}}#diamonds-direct .WomensBandsSplash .wbsBottomSection .wbCol2{margin:0 0 0 45%;overflow:auto}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsBottomSection .wbCol2{margin:0;overflow-y:visible}}#diamonds-direct .WomensBandsSplash .wbsBottomSection .wbCol2 .bottomPromptWrapper .promptBottom .promptImg{width:44%;left:28%;bottom:60%}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsBottomSection .wbCol2 .bottomPromptWrapper .promptBottom .promptImg{width:70%;left:15%;bottom:70%;z-index:3}}#diamonds-direct .WomensBandsSplash .wbsBottomSection .wbCol2 .bottomPromptWrapper .promptBottom .promptWrapper{margin-top:35px;padding-top:200px;padding-bottom:60px}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsBottomSection .wbCol2 .bottomPromptWrapper .promptBottom .promptWrapper{padding:110px 0 30px}}#diamonds-direct .WomensBandsSplash .wbsFooter{position:relative;margin:-5% 0 0}#diamonds-direct .WomensBandsSplash .wbsFooter img{width:100%}#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper{position:absolute;top:16%;left:0;width:49%;bottom:16%;color:#fff;text-align:center}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper{top:42%;left:10%;width:80%;bottom:5%}}#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyTitle{margin:20px 0 0;font-family:Lusitana,serif;text-transform:uppercase;font-size:26px;transition:font-size .35s linear 0ms,margin .35s linear 0ms}@media (max-width:1500px){#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyTitle{margin:15px 0 0;font-size:24px}}@media (max-width:1200px){#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyTitle{margin:10px 0 0;font-size:20px}}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyTitle{font-size:36px}}#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyBody{margin:15px 5% 0;line-height:1.3;font-weight:300;font-size:18px;transition:font-size .35s linear 0ms,margin .35s linear 0ms,line-height .35s linear 0ms}@media (max-width:1500px){#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyBody{margin:10px 4% 0;font-size:15px;line-height:1.2}}@media (max-width:1200px){#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyBody{margin:5px 4% 0;font-size:12px;line-height:1.1}}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyBody{margin-top:15px;font-size:22px;line-height:1.4;font-family:Lato,sans-serif}}#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyButton{display:inline-block;width:200px;border:1px solid #8c8c8c;color:#fff;background:#000;font-size:12px;text-transform:uppercase;font-weight:700;margin:25px 0 0;padding:15px 0;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,margin .35s linear 0ms,padding .35s linear 0ms}#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyButton:hover{color:#000;background:#fff}@media (max-width:1500px){#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyButton{margin:20px 0 0}}@media (max-width:1200px){#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyButton{margin:10px 0 0;padding:10px 0;width:160px}}@media (max-width:600px){#diamonds-direct .WomensBandsSplash .wbsFooter .footerCopyWrapper .footerCopyButton{margin:25px 0 0;padding:10px 0;width:220px;padding:20px 0;font-family:Lato,sans-serif}}#diamonds-direct .FashionSplash{margin:25px auto;width:calc(100% - 50px);max-width:1024px}@media (max-width:1024px){#diamonds-direct .FashionSplash{display:none}}#diamonds-direct .FashionSplash .promptBox{position:relative}#diamonds-direct .FashionSplash .promptBox .promptImg{position:relative;width:70%;margin:0 auto 25px;height:auto}#diamonds-direct .FashionSplash .promptBox .promptImg img{width:100%}#diamonds-direct .FashionSplash .promptBox .promptWrapper{text-align:center;background:#fff;padding:25px}@media (max-width:1200px){#diamonds-direct .FashionSplash .promptBox .promptWrapper{padding:10px}}#diamonds-direct .FashionSplash .promptBox .promptWrapper .promptTitle{display:inline-block;overflow:visible;height:0;border-bottom:20px solid #e3ddec;margin:0 0 25px;padding:0 10px 12px;width:auto;font-family:Lusitana,serif;color:#666;text-transform:uppercase;font-size:26px;transition:font-size .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .FashionSplash .promptBox .promptWrapper .promptTitle{font-size:20px}}#diamonds-direct .FashionSplash .promptBox .promptWrapper .promptCopy{font-size:18px;font-weight:300;color:#666;transition:font-size .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .FashionSplash .promptBox .promptWrapper .promptCopy{font-size:16px}}#diamonds-direct .FashionSplash .promptBox .promptWrapper .promptButton{display:inline-block;width:200px;border:1px solid #8c8c8c;color:#8c8c8c;background:#fff;font-size:12px;text-transform:uppercase;font-weight:700;margin:25px 0 0;padding:15px 0;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .FashionSplash .promptBox .promptWrapper .promptButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .FashionSplash .fsTitle{color:#666;font-size:30px;font-family:Lusitana,serif;margin:0 0 20px;text-transform:uppercase}#diamonds-direct .FashionSplash .fsTopSection{margin:0 0 50px}#diamonds-direct .FashionSplash .fsTopSection .fsBanner img{width:100%}#diamonds-direct .FashionSplash .fsTopSection .itemWrapper{margin:-150px 0 0;transition:margin .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .FashionSplash .fsTopSection .itemWrapper{margin:-100px 0 0}}#diamonds-direct .FashionSplash .fsTopSection .itemWrapper .fashionItem{display:inline-block;vertical-align:top;margin:0 10px;width:calc(33.33% - 20px);text-align:center}#diamonds-direct .FashionSplash .fsTopSection .itemWrapper .fashionItem .fashionItemImg{width:100%;height:220px;margin:0 auto;transition:height .35s linear 0ms}#diamonds-direct .FashionSplash .fsTopSection .itemWrapper .fashionItem .fashionItemImg img{max-width:100%;max-height:100%}@media (max-width:1200px){#diamonds-direct .FashionSplash .fsTopSection .itemWrapper .fashionItem .fashionItemImg{height:160px}}#diamonds-direct .FashionSplash .fsTopSection .itemWrapper .fashionItem .fashionItemButton{display:inline-block;width:90%;border:1px solid #8c8c8c;color:#8c8c8c;background:#fff;font-size:12px;text-transform:uppercase;font-weight:700;margin:15px 0 0;padding:15px 0;cursor:pointer;text-align:center;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .FashionSplash .fsTopSection .itemWrapper .fashionItem .fashionItemButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}#diamonds-direct .FashionSplash .fsMidSection{margin:0 0 50px}#diamonds-direct .FashionSplash .fsMidSection .midCol1{display:inline-block;vertical-align:top;width:50%}#diamonds-direct .FashionSplash .fsMidSection .midCol1 img{width:100%}#diamonds-direct .FashionSplash .fsMidSection .midCol2{display:inline-block;vertical-align:top;width:50%}#diamonds-direct .FashionSplash .fsMidSection .midCol2 .midPromptWrapper{width:80%;margin:25% auto 0;transition:width .35s linear 0ms,margin .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .FashionSplash .fsMidSection .midCol2 .midPromptWrapper{width:90%;margin:15% auto 0}}#diamonds-direct .FashionSplash .fsBottomSection{margin:0 0 25px}#diamonds-direct .FashionSplash .fsBottomSection .bottomCol1{display:inline-block;vertical-align:top;width:50%}#diamonds-direct .FashionSplash .fsBottomSection .bottomCol1 .smallItem{display:inline-block;vertical-align:top;margin:0 18px 10px 0;width:calc(50% - 18px)}#diamonds-direct .FashionSplash .fsBottomSection .bottomCol1 .smallItem .smallItemImg img{width:100%}#diamonds-direct .FashionSplash .fsBottomSection .bottomCol2{display:inline-block;vertical-align:top;width:50%}#diamonds-direct .FashionSplash .fsBottomSection .bottomCol2 .largeItem .largeItemImg img{width:100%}#diamonds-direct .FashionSplash .fsBottomSection .smallItemLabel{color:#666;font-size:15px;font-family:Lusitana,serif;height:24px;transition:font-size .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .FashionSplash .fsBottomSection .smallItemLabel{font-size:13px}}#diamonds-direct .FashionSplash .fsBottomSection .smallItemLabel .itemName{display:inline-block;vertical-align:top;width:calc(100% - 55px);text-align:left;transition:width .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .FashionSplash .fsBottomSection .smallItemLabel .itemName{width:calc(100% - 40px)}}#diamonds-direct .FashionSplash .fsBottomSection .smallItemLabel .itemPrice{display:inline-block;vertical-align:top;width:55px;text-align:right;transition:width .35s linear 0ms}@media (max-width:1200px){#diamonds-direct .FashionSplash .fsBottomSection .smallItemLabel .itemPrice{width:40px}}#diamonds-direct .ResultsControls{position:relative;margin:0 0 10px;height:40px;transition:margin .35s linear 0ms,height .35s linear 0ms}@media (max-width:768px){#diamonds-direct .ResultsControls{margin:0 0 10px;height:100px}}#diamonds-direct .ResultsControls .countWrapper{position:absolute;top:10px;left:20px;bottom:10px;width:auto;text-align:left}@media (max-width:768px){#diamonds-direct .ResultsControls .countWrapper{position:relative;width:100%;right:0;margin:0 auto 10px;padding-bottom:5px}}#diamonds-direct .ResultsControls .editWrapper{display:none;text-align:center}@media (max-width:1024px){#diamonds-direct .ResultsControls .editWrapper{display:block}}#diamonds-direct .ResultsControls .editWrapper .editButton{position:relative;cursor:pointer;color:#fff;background:#4b2d53;width:120px;height:32px;margin:20px auto;transition:background .25s ease-in-out 0ms,width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .ResultsControls .editWrapper .editButton{width:calc(100% - 40px);margin:10px auto 0}}#diamonds-direct .ResultsControls .editWrapper .editButton:hover{background:#000}#diamonds-direct .ResultsControls .editWrapper .editButton div{display:-ms-flexbox;display:flex;position:absolute;font-weight:700;top:0;left:0;right:0;bottom:0;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .ResultsControls .sortWrapper{position:absolute;top:0;right:20px;width:250px;bottom:0;transition:width .35s linear 0ms,margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .ResultsControls .sortWrapper{position:relative;width:calc(100% - 40px);right:0;margin:10px auto 0}}#diamonds-direct .ResultsControls .sortWrapper .sortSelect select{height:32px;padding-top:2px;padding-bottom:2px}#diamonds-direct .ResultsControls .sortWrapper .sortSelect .select__arrow{top:13px}#diamonds-direct .ResultsPagination{position:relative;height:40px}#diamonds-direct .ResultsPagination .prevPageWrapper{position:absolute;top:10px;left:10px;bottom:0;width:120px;text-align:left;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .ResultsPagination .prevPageWrapper:hover{color:#4b2d53}@media (max-width:768px){#diamonds-direct .ResultsPagination .prevPageWrapper{width:80px}}#diamonds-direct .ResultsPagination .nextPageWrapper{position:absolute;top:10px;right:10px;bottom:0;width:120px;text-align:right;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .ResultsPagination .nextPageWrapper:hover{color:#4b2d53}@media (max-width:768px){#diamonds-direct .ResultsPagination .nextPageWrapper{width:70px}}#diamonds-direct .ResultsPagination .pageLabelWrapper{position:absolute;top:0;left:calc(50% - 115px);bottom:10px;height:40px;width:230px;text-align:center}#diamonds-direct .ResultsPagination .pageLabelWrapper .pageLabelLHS{position:absolute;top:9px;left:0;width:95px;bottom:0;text-align:right}#diamonds-direct .ResultsPagination .pageLabelWrapper .pageLabelRHS{position:absolute;top:9px;right:0;width:95px;bottom:0;text-align:left}#diamonds-direct .ResultsPagination .pageLabelWrapper .pageLabelCenter{position:absolute;top:0;left:95px;width:40px;height:31px;padding-top:9px;background:#dedede;border-radius:50%;bottom:0;text-align:center;font-weight:700}#diamonds-direct .ResultsPagination .pageLabelWrapper .pageClickable,#diamonds-direct .ResultsPagination .pageLabelWrapper .pageElipsis{display:inline-block;vertical-align:top;width:auto;margin:0 5px}#diamonds-direct .ResultsPagination .pageLabelWrapper .pageClickable{cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .ResultsPagination .pageLabelWrapper .pageClickable:hover{text-decoration:underline;color:#666}#diamonds-direct .RingSplash{position:relative;color:#5e5e5e;margin:25px auto 50px;max-width:1024px;transition:max-width .35s linear 0ms;font-family:Lato,sans-serif}@media (max-width:1024px){#diamonds-direct .RingSplash{margin-top:0}}#diamonds-direct .RingSplash .rsTop{color:#fff;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/fine.jpg\");background-position:50%;background-size:cover;background-repeat:no-repeat;overflow:auto}@media (max-width:1024px){#diamonds-direct .RingSplash .rsTop{background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/fine_m.jpg\")}}#diamonds-direct .RingSplash .rsTop .rsTopWrapper{margin:50px 50% 50px 10%;text-align:left}@media (max-width:1024px){#diamonds-direct .RingSplash .rsTop .rsTopWrapper{margin:120% auto 40px;width:90%;max-width:280px}}#diamonds-direct .RingSplash .rsTop .rsTopWrapper .rsTopTitle{font-family:Lusitana,serif;text-transform:uppercase;font-size:24px;font-weight:400;margin:0 0 25px}#diamonds-direct .RingSplash .rsTop .rsTopWrapper .rsTopCopy{margin:0 0 25px;font-weight:100;width:70%}@media (max-width:1024px){#diamonds-direct .RingSplash .rsTop .rsTopWrapper .rsTopCopy{width:100%}}#diamonds-direct .RingSplash .rsTop .rsTopWrapper .rsTopButtonWrapper .rsTopButton{display:inline-block;width:auto;border:1px solid #fff;color:#fff;background:none;font-size:12px;text-transform:uppercase;font-weight:400;padding:10px 40px;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}@media (max-width:600px){#diamonds-direct .RingSplash .rsTop .rsTopWrapper .rsTopButtonWrapper .rsTopButton{width:180px;padding:15px 0;font-family:Lato,sans-serif;font-size:14px}}#diamonds-direct .RingSplash .rsTop .rsTopWrapper .rsTopButtonWrapper .rsTopButton:hover{color:#000;background:#fff;border:1px solid #fff}#diamonds-direct .RingSplash .rsMid{position:relative;overflow:auto;margin:10px 0 0}#diamonds-direct .RingSplash .rsMid .rsMidImg.rsMidImgDesktop{display:block}@media (max-width:1024px){#diamonds-direct .RingSplash .rsMid .rsMidImg.rsMidImgDesktop{display:none}}#diamonds-direct .RingSplash .rsMid .rsMidImg.rsMidImgMobile{display:none}@media (max-width:1024px){#diamonds-direct .RingSplash .rsMid .rsMidImg.rsMidImgMobile{display:block}}#diamonds-direct .RingSplash .rsMid .rsMidImg{position:absolute;top:0;left:10px;width:calc(50% - 20px);height:100%;background-position:50%;background-size:cover;background-repeat:no-repeat}@media (max-width:1024px){#diamonds-direct .RingSplash .rsMid .rsMidImg{position:relative;top:unset;left:unset;width:100%}}#diamonds-direct .RingSplash .rsMid .rsMidBody{width:50%}@media (max-width:1024px){#diamonds-direct .RingSplash .rsMid .rsMidBody{width:100%}}#diamonds-direct .RingSplash .rsMid .rsMidBody .rsMidBodyWrapper{text-align:center}#diamonds-direct .RingSplash .rsMid .rsMidBody .rsMidBodyWrapper .rsMidBodyImg{width:60%;margin:25px auto 0}#diamonds-direct .RingSplash .rsMid .rsMidBody .rsMidBodyWrapper .rsMidBodyImg img{width:100%}#diamonds-direct .RingSplash .rsMid .rsMidBody .rsMidBodyWrapper .rsMidBodyTitle{display:inline-block;overflow:visible;height:0;border-bottom:20px solid #e3dced;margin:0 0 25px;padding:0 15px 12px;width:auto;font-family:Lusitana,serif;text-transform:uppercase;font-size:26px;text-align:center}#diamonds-direct .RingSplash .rsMid .rsMidBody .rsMidBodyWrapper .rsMidBodyCopy{font-weight:300;font-size:16px;margin:0 20% 75px;text-align:center}@media (max-width:1024px){#diamonds-direct .RingSplash .rsMid .rsMidBody .rsMidBodyWrapper .rsMidBodyCopy{margin:0 10% 35px}}#diamonds-direct .RingSplash .rsMid .rsMidBody .rsMidBodyWrapper .rsMidBodyButtonWrapper{margin:0 0 25px}#diamonds-direct .RingSplash .rsMid .rsMidBody .rsMidBodyWrapper .rsMidBodyButtonWrapper .rsMidBodyButton{display:inline-block;width:auto;border:1px solid #5e5e5e;color:#5e5e5e;background:#fff;font-size:12px;text-transform:uppercase;font-weight:700;padding:10px 40px;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}@media (max-width:600px){#diamonds-direct .RingSplash .rsMid .rsMidBody .rsMidBodyWrapper .rsMidBodyButtonWrapper .rsMidBodyButton{width:180px;padding:15px 0;font-family:Lato,sans-serif;font-size:14px}}#diamonds-direct .RingSplash .rsMid .rsMidBody .rsMidBodyWrapper .rsMidBodyButtonWrapper .rsMidBodyButton:hover{color:#fff;background:#4b2d53;border:1px solid #4b2d53}@media (max-width:1024px){#diamonds-direct .RingSplash .rsMid1{margin:0 auto}}#diamonds-direct .RingSplash .rsMid1 .rsMidImg{left:10px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/statement.jpg\")}@media (max-width:1024px){#diamonds-direct .RingSplash .rsMid1 .rsMidImg{background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/statement_m.jpg\");padding-bottom:116%;left:unset}}#diamonds-direct .RingSplash .rsMid1 .rsMidBody{margin:0 0 0 50%}@media (max-width:1024px){#diamonds-direct .RingSplash .rsMid1 .rsMidBody{margin:0}}#diamonds-direct .RingSplash .rsMid2 .rsMidImg{left:calc(50% + 10px);background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/bands.jpg\")}@media (max-width:1024px){#diamonds-direct .RingSplash .rsMid2 .rsMidImg{background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/bands_m.jpg\");padding-bottom:116%;left:unset}}#diamonds-direct .RingSplash .rsMid2 .rsMidBody{margin:0 50% 0 0}@media (max-width:1024px){#diamonds-direct .RingSplash .rsMid2 .rsMidBody{margin:0}}#diamonds-direct .RingSplash .rsBottom{color:#000;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/gemstone.jpg\");background-position:50%;background-size:cover;background-repeat:no-repeat;overflow:auto;margin:10px 0 0}@media (max-width:1024px){#diamonds-direct .RingSplash .rsBottom{background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/gemstone_m.jpg\");margin:0}}#diamonds-direct .RingSplash .rsBottom .rsBottomWrapper{margin:75px 10% 75px 50%;text-align:left}@media (max-width:1024px){#diamonds-direct .RingSplash .rsBottom .rsBottomWrapper{margin:100% auto 50px;width:90%;max-width:280px}}#diamonds-direct .RingSplash .rsBottom .rsBottomWrapper .rsBottomTitle{font-family:Lusitana,serif;text-transform:uppercase;font-size:24px;font-weight:400;margin:0 0 25px}#diamonds-direct .RingSplash .rsBottom .rsBottomWrapper .rsBottomCopy{margin:0 0 25px;font-weight:100;width:70%}#diamonds-direct .RingSplash .rsBottom .rsBottomWrapper .rsBottomButtonWrapper .rsBottomButton{display:inline-block;width:auto;border:1px solid #000;color:#000;background:none;font-size:12px;text-transform:uppercase;font-weight:700;padding:10px 40px;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}@media (max-width:600px){#diamonds-direct .RingSplash .rsBottom .rsBottomWrapper .rsBottomButtonWrapper .rsBottomButton{width:180px;padding:15px 0;font-family:Lato,sans-serif;font-size:14px}}#diamonds-direct .RingSplash .rsBottom .rsBottomWrapper .rsBottomButtonWrapper .rsBottomButton:hover{color:#fff;background:#000;border:1px solid #4b2d53}#diamonds-direct .DiamondResults .diamondResultsWrapper{text-align:left}#diamonds-direct .DiamondResults .diamondResultsWrapper .diamondResultItemWrapper{display:inline-block;background:#fff;width:33.33%;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .DiamondResults .diamondResultsWrapper .diamondResultItemWrapper:hover{background:#fff}#diamonds-direct .DiamondResults .diamondResultsWrapper .diamondResultItemWrapper .diamondReultsItemInnerWrapper{margin:10px;text-align:center;overflow:auto;position:relative}#diamonds-direct .DiamondResults .diamondResultsWrapper .diamondResultItemWrapper .diamondReultsItemInnerWrapper .drImageWrapper{height:180px;margin:10px 0}#diamonds-direct .DiamondResults .diamondResultsWrapper .diamondResultItemWrapper .diamondReultsItemInnerWrapper .drImageWrapper img{height:100%}#diamonds-direct .DiamondResults .diamondResultsWrapper .diamondResultItemWrapper .diamondReultsItemInnerWrapper .drNameWrapper{color:#5e5e5e;margin:10px 0;font-size:28px;font-weight:300;height:30px}#diamonds-direct .DiamondResults .diamondResultsWrapper .diamondResultItemWrapper .diamondReultsItemInnerWrapper .drPriceWrapper{color:#4b2d53;margin:10px 0;font-size:22px;font-weight:400;height:40px}#diamonds-direct .SettingResults .settingResultsWrapper{text-align:left}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper{display:inline-block;width:25%;transition:background .25s ease-in-out 0ms,width .35s linear 0ms}@media (max-width:1800px){#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper{width:33.33%}}@media (max-width:1200px){#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper{width:50%}}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper{margin:10px;text-align:center;overflow:auto;position:relative;cursor:pointer}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper:hover{border:1px solid #707070;margin:9px}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper:hover .srStaticDisplay{display:none}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper:hover .similarWrapper,#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper:hover .srHoverDisplay,#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper:hover .wishlistWrapper{display:block}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .wishlistWrapper{display:none;position:absolute;top:8px;right:8px;height:16px;width:auto}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .wishlistWrapper img{height:100%}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .similarWrapper{display:none;position:absolute;top:8px;left:8px;height:16px;width:auto}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .similarWrapper:hover .similarLabel{display:inline-block}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .similarWrapper .similarIcon{display:inline-block;width:auto;height:16px;cursor:pointer}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .similarWrapper .similarIcon img{height:100%}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .similarWrapper .similarLabel{display:none;color:#ba93be;font-size:14px;font-weight:300;width:auto;margin:0 0 0 8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srImageWrapper{display:block;height:160px;margin:10px 0}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srImageWrapper img{height:100%}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srStaticDisplay{display:block;height:82px}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srStaticDisplay .srNameWrapper{display:block;position:relative;height:40px;width:100%;margin:-20px auto 0;font-weight:400;font-size:17px;text-align:center;color:#5e5e5e;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srStaticDisplay .srNameWrapper div{position:absolute;left:0;right:0;bottom:0;height:auto;overflow:hidden}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srStaticDisplay .srHrWrapper{display:block;height:2px;width:60%;margin:10px auto;background:#563a5f}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srStaticDisplay .srPriceWrapper{display:block;height:20px;font-weight:300;font-size:16px;color:#5e5e5e;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay{display:none;height:82px;position:relative}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay .srAltImageWrapper{margin:-25px 0 0;text-align:center;position:relative}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay .srAltImageWrapper .srAltImage.selected{width:calc(12% - 2px);padding-bottom:calc(12% - 2px);border:2px solid #95989a}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay .srAltImageWrapper .srAltImage{display:inline-block;margin:0 5px;width:12%;height:auto;border:1px solid #95989a;vertical-align:top;padding-bottom:12%;background-position:50%;background-size:cover;background-repeat:no-repeat}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay .srMetalTypeWrapper{margin:10px 0 0;height:25px}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay .srMetalTypeWrapper .metal1.srMetalType{border:4px solid #d9d9d9}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay .srMetalTypeWrapper .metal1.srMetalType .srMetalTypeHole{position:absolute;top:3px;left:3px;right:3px;bottom:3px;background:#d9d9d9;border-radius:50%}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay .srMetalTypeWrapper .metal2.srMetalType{border:4px solid #f4de95}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay .srMetalTypeWrapper .metal3.srMetalType{border:4px solid #e7b79e}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay .srMetalTypeWrapper .metal4.srMetalType{border:4px solid #ebebeb}#diamonds-direct .SettingResults .settingResultsWrapper .settingResultItemWrapper .settingReultsItemInnerWrapper .srHoverDisplay .srMetalTypeWrapper .srMetalType{position:relative;display:inline-block;vertical-align:top;margin:0 8px;width:14px;height:14px;border-radius:50%}#diamonds-direct .DiamondResults .priceNotice,#diamonds-direct .MixedResults .priceNotice,#diamonds-direct .SettingResults .priceNotice{margin:0 0 25px;font-size:12px;font-weight:300;letter-spacing:-.5px;text-align:center}#diamonds-direct .DiamondResults .labelSection,#diamonds-direct .MixedResults .labelSection,#diamonds-direct .SettingResults .labelSection{position:relative;margin:0 0 20px}#diamonds-direct .DiamondResults .labelSection .labelTitle,#diamonds-direct .MixedResults .labelSection .labelTitle,#diamonds-direct .SettingResults .labelSection .labelTitle{font-family:Lusitana,serif;font-size:26px;margin:5px 0;text-transform:uppercase;display:inline-block;vertical-align:top;width:280px}#diamonds-direct .DiamondResults .labelSection .labelText.compareLabel,#diamonds-direct .MixedResults .labelSection .labelText.compareLabel,#diamonds-direct .SettingResults .labelSection .labelText.compareLabel{cursor:pointer;color:#4b2d53}@media (max-width:768px){#diamonds-direct .DiamondResults .labelSection .labelText.compareLabel,#diamonds-direct .MixedResults .labelSection .labelText.compareLabel,#diamonds-direct .SettingResults .labelSection .labelText.compareLabel{margin:-6px 0 0}}#diamonds-direct .DiamondResults .labelSection .labelText.compareLabel .compareIcon,#diamonds-direct .MixedResults .labelSection .labelText.compareLabel .compareIcon,#diamonds-direct .SettingResults .labelSection .labelText.compareLabel .compareIcon{display:inline-block;vertical-align:top;margin:0 8px 0 0;width:20px}#diamonds-direct .DiamondResults .labelSection .labelText.compareLabel .compareIcon img,#diamonds-direct .MixedResults .labelSection .labelText.compareLabel .compareIcon img,#diamonds-direct .SettingResults .labelSection .labelText.compareLabel .compareIcon img{width:100%}#diamonds-direct .DiamondResults .labelSection .labelText,#diamonds-direct .MixedResults .labelSection .labelText,#diamonds-direct .SettingResults .labelSection .labelText{font-size:18px;display:inline-block;vertical-align:top;margin:12px 0 0;width:calc(100% - 280px)}@media (max-width:768px){#diamonds-direct .DiamondResults .labelSection .labelText,#diamonds-direct .MixedResults .labelSection .labelText,#diamonds-direct .SettingResults .labelSection .labelText{display:block;width:100%;margin:10px auto 0}}#diamonds-direct .DiamondResults .mixedResultsButton,#diamonds-direct .MixedResults .mixedResultsButton,#diamonds-direct .SettingResults .mixedResultsButton{border:1px solid #707070;background:#fff;margin:0 auto;padding:3px 0;font-size:14px;text-transform:uppercase;text-align:center;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .DiamondResults .mixedResultsButton:hover,#diamonds-direct .MixedResults .mixedResultsButton:hover,#diamonds-direct .SettingResults .mixedResultsButton:hover{color:#fff;background:#563a5f;border:1px solid #563a5f}#diamonds-direct .DiamondResults .mixedResultsActionButton,#diamonds-direct .MixedResults .mixedResultsActionButton,#diamonds-direct .SettingResults .mixedResultsActionButton{border:1px solid #563a5f;background:#563a5f;color:#fff;margin:0 auto;padding:3px 0;font-size:14px;text-transform:uppercase;text-align:center;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .DiamondResults .mixedResultsActionButton:hover,#diamonds-direct .MixedResults .mixedResultsActionButton:hover,#diamonds-direct .SettingResults .mixedResultsActionButton:hover{color:#fff;background:#000;border:1px solid #000}#diamonds-direct .DiamondResults .assembledWrapper.opened,#diamonds-direct .MixedResults .assembledWrapper.opened,#diamonds-direct .SettingResults .assembledWrapper.opened{overflow:visible}#diamonds-direct .DiamondResults .assembledWrapper.open,#diamonds-direct .MixedResults .assembledWrapper.open,#diamonds-direct .SettingResults .assembledWrapper.open{max-height:400px;margin-bottom:0}#diamonds-direct .DiamondResults .assembledWrapper,#diamonds-direct .MixedResults .assembledWrapper,#diamonds-direct .SettingResults .assembledWrapper{position:relative;overflow:hidden;height:auto;max-height:31px;margin-bottom:10px;transition:max-height .4s ease-in-out 0ms,margin .4s ease-in-out 0ms}#diamonds-direct .DiamondResults .assembledWrapper .assembledToggle,#diamonds-direct .MixedResults .assembledWrapper .assembledToggle,#diamonds-direct .SettingResults .assembledWrapper .assembledToggle{position:absolute;top:0;right:0;width:30px;height:30px;cursor:pointer}#diamonds-direct .DiamondResults .assembledWrapper .assembledToggle .assembledToggleIcon,#diamonds-direct .MixedResults .assembledWrapper .assembledToggle .assembledToggleIcon,#diamonds-direct .SettingResults .assembledWrapper .assembledToggle .assembledToggleIcon{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;font-size:28px}#diamonds-direct .DiamondResults .assembledWrapper .assembledTabsWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledTabsWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledTabsWrapper{border-left:2px solid #4b2d53}#diamonds-direct .DiamondResults .assembledWrapper .assembledTabsWrapper .selectedTab.assembledTab,#diamonds-direct .MixedResults .assembledWrapper .assembledTabsWrapper .selectedTab.assembledTab,#diamonds-direct .SettingResults .assembledWrapper .assembledTabsWrapper .selectedTab.assembledTab{color:#fff;background:#4b2d53;cursor:default}#diamonds-direct .DiamondResults .assembledWrapper .assembledTabsWrapper .selectedTab.assembledTab:hover,#diamonds-direct .MixedResults .assembledWrapper .assembledTabsWrapper .selectedTab.assembledTab:hover,#diamonds-direct .SettingResults .assembledWrapper .assembledTabsWrapper .selectedTab.assembledTab:hover{color:#fff;background:#4b2d53}#diamonds-direct .DiamondResults .assembledWrapper .assembledTabsWrapper .assembledTab,#diamonds-direct .MixedResults .assembledWrapper .assembledTabsWrapper .assembledTab,#diamonds-direct .SettingResults .assembledWrapper .assembledTabsWrapper .assembledTab{display:inline-block;width:260px;height:30px;line-height:30px;text-align:center;font-size:16px;font-weight:400;text-transform:uppercase;border-right:2px solid #4b2d53;color:#4b2d53;background:#fff;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .DiamondResults .assembledWrapper .assembledTabsWrapper .assembledTab,#diamonds-direct .MixedResults .assembledWrapper .assembledTabsWrapper .assembledTab,#diamonds-direct .SettingResults .assembledWrapper .assembledTabsWrapper .assembledTab{width:calc(50% - 2px - 20px)}}#diamonds-direct .DiamondResults .assembledWrapper .assembledTabsWrapper .assembledTab:hover,#diamonds-direct .MixedResults .assembledWrapper .assembledTabsWrapper .assembledTab:hover,#diamonds-direct .SettingResults .assembledWrapper .assembledTabsWrapper .assembledTab:hover{color:#fff;background:#000}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview{position:relative;border:1px solid #d3d3d3;margin:0 0 10px;padding:10px 0}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData{display:inline-block;width:25%;transition:width .35s linear 0ms}@media (max-width:1500px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData{width:25%}}@media (max-width:1024px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData{display:none}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData .ringDiagram,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData .ringDiagram,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData .ringDiagram{display:inline-block;vertical-align:top;width:calc(100% - 1px);text-align:center;transition:width .35s linear 0ms}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData .ringDiagram img,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData .ringDiagram img,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData .ringDiagram img{width:90%;max-width:240px}@media (max-width:1500px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData .ringDiagram,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData .ringDiagram,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData .ringDiagram{display:block;width:calc(100% - 1px)}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary{display:inline-block;vertical-align:top;width:calc(50% - 20px);max-width:240px;margin:0 10px}@media (max-width:1500px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary{display:block;width:calc(100% - 60px);margin:25px auto 10px}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary .ringDataItem,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary .ringDataItem,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary .ringDataItem{font-size:11px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary .ringDataItem .ringDataLabel,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary .ringDataItem .ringDataLabel,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary .ringDataItem .ringDataLabel{display:inline-block;vertical-align:top;width:100px;font-weight:700}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary .ringDataItem .ringDataValue,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary .ringDataItem .ringDataValue,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembedData .ringDataSummary .ringDataItem .ringDataValue{display:inline-block;vertical-align:top;width:calc(100% - 100px);font-weight:400}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper.smallViews,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper.smallViews,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper.smallViews{display:none}@media (max-width:900px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper.smallViews,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper.smallViews,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper.smallViews{display:block;width:calc(100% - 20px);margin:0 10px}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper{display:inline-block;vertical-align:top;width:25%;color:#707070;transition:width .35s linear 0ms}@media (max-width:900px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper{display:none}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage.fullRing,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage.fullRing,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage.fullRing{padding:10px 10%}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage{text-align:center;font-family:Lusitana,serif;font-size:18px;text-transform:uppercase;padding:110px 10% 0}@media (max-width:1024px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage{padding-top:100px}}@media (max-width:900px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledMessage{padding:20px 10%}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledImage,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledImage,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledImage{width:90%;max-width:220px;margin:0 auto}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledImage img,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledImage img,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledImage img{width:100%}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledPrice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledPrice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledPrice{font-size:24px;margin:0 0 10px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .addToCartWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .addToCartWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .addToCartWrapper{margin:10px 0}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .addToCartWrapper .addButton.mixedResultsButton,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .addToCartWrapper .addButton.mixedResultsButton,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .addToCartWrapper .addButton.mixedResultsButton{width:160px;height:30px;line-height:30px;background:#4b2d53;color:#fff}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .addToCartWrapper .addButton.mixedResultsButton:hover,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .addToCartWrapper .addButton.mixedResultsButton:hover,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .addToCartWrapper .addButton.mixedResultsButton:hover{color:#fff;background:#000;border-color:#000}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledNotice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledNotice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledNotice{font-size:13px;margin:25px 0 0;padding:0 0 10px;text-align:center;font-weight:300}@media (max-width:900px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledNotice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledNotice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledImageWrapper .assembledNotice{border-bottom:1px solid #d3d3d3}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledVBR,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledVBR,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledVBR{display:none;position:absolute;top:10px;bottom:10px;width:1px;left:400px;background:#d3d3d3;transition:left .35s linear 0ms}@media (max-width:1500px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledVBR,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledVBR,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledVBR{left:300px}}@media (max-width:1024px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledVBR,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledVBR,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledVBR{display:none}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth{width:100%}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentImageWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentImageWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentImageWrapper{width:200px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentInfoWrapper{width:calc(100% - 200px)}@media (max-width:600px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentInfoWrapper{display:block;margin:10px auto;width:auto}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow{font-size:24px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentImageWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentImageWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentImageWrapper{width:200px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentInfoWrapper{width:calc(100% - 200px)}@media (max-width:600px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentInfoWrapper{display:block;margin:10px auto;width:auto}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper.fullWidth .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow{font-size:24px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper{display:inline-block;width:75%;vertical-align:top;transition:width .35s linear 0ms}@media (max-width:900px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper{width:100%}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsInCart,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsInCart,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsInCart{position:relative;margin:0 auto 60px;width:260px;height:30px;border:1px solid #4b2d53;color:#fff;background:#4b2d53;font-size:14px;text-transform:uppercase;font-weight:700}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsInCart div,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsInCart div,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsInCart div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper{position:relative;margin:0 0 10px;height:30px;overflow:visible;text-align:center}@media (max-width:768px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper{margin-bottom:20px}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement{position:relative;border:1px solid #5e5e5e;width:260px;margin:0 auto;cursor:pointer;background:#fff;z-index:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead{position:relative}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsLabel,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsLabel,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsLabel{padding:5px 0;font-size:20px;font-weight:300;text-transform:uppercase}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon{position:absolute;top:8px;right:5px;width:30px;height:12px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon img,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon img,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon img{height:100%}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .open.nextStepsBody,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .open.nextStepsBody,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .open.nextStepsBody{max-height:200px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody{max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper{margin:0 10px 10px;padding:10px 0 0;border-top:1px solid #5e5e5e}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem{text-align:left;text-transform:uppercase;padding:5px 0;font-size:16px;font-weight:400}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem:hover,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem:hover,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem:hover{background:#eee}@media (max-width:900px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper.nullElement,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper.nullElement,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper.nullElement{display:none}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingMessageWrapper .settingNullMessage,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingMessageWrapper .settingNullMessage,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingMessageWrapper .settingNullMessage{position:relative;margin:20px 10px;font-family:Lusitana,serif;color:#5e5e5e;text-transform:uppercase;font-size:20px;line-height:1.1;text-align:center}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper{position:relative;margin:0 10px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentImageWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentImageWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentImageWrapper{display:inline-block;width:100px;vertical-align:top}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentImageWrapper img,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentImageWrapper img,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentImageWrapper img{width:100%}@media (max-width:600px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentImageWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentImageWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentImageWrapper{display:block;margin:10px auto}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .settingInfoTitleRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .settingInfoTitleRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .settingInfoTitleRow{margin:30px 0 0}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .scrollButton,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .scrollButton,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .scrollButton{position:relative;color:#4b2d53;background:#fff;border:1px solid #ddd;cursor:pointer;width:160px;height:36px;margin:20px auto 30px;text-align:center;text-transform:uppercase;font-size:14px;font-weight:700;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .scrollButton:hover,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .scrollButton:hover,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .scrollButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .scrollButton div,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .scrollButton div,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper.nullElement .scrollButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper{display:inline-block;width:calc(100% - 100px);vertical-align:top;margin:10px 0;transition:width .35s linear 0ms}@media (max-width:1500px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper{width:calc(100% - 100px)}}@media (max-width:600px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper{margin:10px auto;width:100%}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow{text-align:center;font-family:Lusitana,serif;font-size:18px;text-transform:uppercase;margin:0}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow .settingInfoTitle,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow .settingInfoTitle,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow .settingInfoTitle,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow .settingInfoTitle,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow .settingInfoTitle,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow .settingInfoTitle{display:inline-block;vertical-align:middle}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow .removeLink,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow .removeLink,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow .removeLink,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow .removeLink,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow .removeLink,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow .removeLink{cursor:pointer;font-size:12px;font-family:Lato,sans-serif;color:#4b2d53;vertical-align:middle;margin:5px 0 0 5px;text-transform:none}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow .removeLink:hover,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow .removeLink:hover,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow .removeLink:hover,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow .removeLink:hover,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTitleRow .removeLink:hover,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTitleRow .removeLink:hover{text-decoration:underline}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTiny,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTiny,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTiny,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTiny,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoTiny,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoTiny{font-size:14px;text-align:center;font-weight:300;margin:-10px 0 0}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow{margin:5px 25px 15px;height:30px;position:relative}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoMetal,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoMetal,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoMetal,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoMetal,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoMetal,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoMetal{display:none;position:absolute;top:0;bottom:0;left:0;width:45%;text-align:left;font-size:15px;font-weight:300;padding:4px 0}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoSize,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoSize,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoSize,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoSize,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoSize,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoSize{display:none;position:absolute;top:0;bottom:0;left:45%;right:30%;text-align:center;font-size:15px;font-weight:300;padding:4px 0;border-left:2px solid #707070;border-right:2px solid #707070}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoPrice,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoPrice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoPrice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoPrice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoPrice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoPrice{text-align:center;font-family:Lusitana,serif;font-size:20px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoPriceNotice,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoPriceNotice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoPriceNotice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoPriceNotice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomRow .settingInfoPriceNotice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomRow .settingInfoPriceNotice{margin:-3px 0 0;font-size:14px;font-weight:300;font-family:Lato,sans-serif;text-align:center}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper{margin:0 auto 10px;width:100%;max-width:600px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .configError,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .configError,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .configError,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .configError,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .configError,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .configError{margin:0 0 5px;font-size:14px;color:#eb3533;text-align:center}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .metalTypeOptions,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .metalTypeOptions,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .metalTypeOptions,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .metalTypeOptions,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .metalTypeOptions,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .metalTypeOptions{position:relative;display:inline-block;vertical-align:top;padding:15px 15px 12px;width:calc(50% - 35px);border-right:1px solid #563a5f;text-align:right}@media (max-width:1200px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .metalTypeOptions,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .metalTypeOptions,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .metalTypeOptions,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .metalTypeOptions,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .metalTypeOptions,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .metalTypeOptions{border-right:none;width:calc(100% - 31px)}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .ringSizeSelect,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .ringSizeSelect,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .ringSizeSelect,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .ringSizeSelect,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .ringSizeSelect,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .ringSizeSelect{position:relative;display:inline-block;vertical-align:top;width:calc(50% - 35px);padding:15px 15px 12px;text-align:left}@media (max-width:1200px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .ringSizeSelect,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .ringSizeSelect,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .ringSizeSelect,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .ringSizeSelect,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoCustomWrapper .ringSizeSelect,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoCustomWrapper .ringSizeSelect{width:calc(100% - 30px)}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow{text-align:center}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .validationMessage,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .validationMessage,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .validationMessage,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .validationMessage,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .validationMessage,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .validationMessage{color:#eb3533;margin:5px 0}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .assembledButton,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .assembledButton,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .assembledButton,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .assembledButton,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .assembledButton,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .assembledButton{display:inline-block;vertical-align:top;width:100px;height:30px;line-height:30px;margin:10px 5px;border:1px solid #ddd}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .dropdownWrapper,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .dropdownWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .dropdownWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .dropdownWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .dropdownWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .dropdownWrapper{display:inline-block;vertical-align:top;width:160px;height:32px;margin:10px 5px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .dropdownWrapper .resultsSelect select,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .dropdownWrapper .resultsSelect select,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .dropdownWrapper .resultsSelect select,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .dropdownWrapper .resultsSelect select,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentInfoWrapper .settingInfoButtonRow .dropdownWrapper .resultsSelect select,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .settingComponentWrapper .settingComponentNullWrapper .settingInfoButtonRow .dropdownWrapper .resultsSelect select{border:1px solid #ddd;font-size:14px;text-transform:uppercase}@media (max-width:900px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper.nullElement,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper.nullElement,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper.nullElement{display:none}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondMessageWrapper .diamondNullMessage,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondMessageWrapper .diamondNullMessage,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondMessageWrapper .diamondNullMessage{position:relative;margin:20px 10px;font-family:Lusitana,serif;color:#5e5e5e;text-transform:uppercase;font-size:20px;line-height:1.1;text-align:center}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper{position:relative;margin:0 0 0 10px}@media (max-width:900px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper{border-bottom:none}}@media (max-width:768px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper{margin:0 0 0 10px;width:calc(100% - 20px);border-bottom:1px solid #d3d3d3}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentImageWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentImageWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentImageWrapper{display:inline-block;vertical-align:top;margin:10px 0;width:100px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentImageWrapper img,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentImageWrapper img,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentImageWrapper img{width:90%}@media (max-width:600px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentImageWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentImageWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentImageWrapper{display:block;margin:10px auto}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .diamondInfoTitleRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .diamondInfoTitleRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .diamondInfoTitleRow{margin:30px 0 0}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .scrollButton,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .scrollButton,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .scrollButton{position:relative;color:#4b2d53;background:#fff;border:1px solid #ddd;cursor:pointer;width:160px;height:36px;margin:20px auto 30px;text-align:center;text-transform:uppercase;font-size:14px;font-weight:700;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .scrollButton:hover,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .scrollButton:hover,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .scrollButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .scrollButton div,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .scrollButton div,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper.nullElement .scrollButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper{display:inline-block;width:calc(100% - 100px);vertical-align:top;margin:10px 0;transition:width .35s linear 0ms}@media (max-width:1500px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper{width:calc(100% - 100px)}}@media (max-width:600px){#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper{margin:10px auto;width:100%}}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow{text-align:center;font-family:Lusitana,serif;font-size:18px;text-transform:uppercase;margin:0}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow .diamondInfoTitle,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow .diamondInfoTitle,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow .diamondInfoTitle,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow .diamondInfoTitle,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow .diamondInfoTitle,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow .diamondInfoTitle{display:inline-block;vertical-align:middle}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow .removeLink,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow .removeLink,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow .removeLink,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow .removeLink,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow .removeLink,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow .removeLink{cursor:pointer;font-size:12px;font-family:Lato,sans-serif;color:#4b2d53;vertical-align:middle;margin:5px 0 0 5px;text-transform:none}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow .removeLink:hover,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow .removeLink:hover,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow .removeLink:hover,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow .removeLink:hover,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoTitleRow .removeLink:hover,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoTitleRow .removeLink:hover{text-decoration:underline}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoCustomRow,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoCustomRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoCustomRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoCustomRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoCustomRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoCustomRow{margin:5px 25px 15px;height:30px;position:relative}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoCustomRow .diamondInfoPrice,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoCustomRow .diamondInfoPrice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoCustomRow .diamondInfoPrice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoCustomRow .diamondInfoPrice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoCustomRow .diamondInfoPrice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoCustomRow .diamondInfoPrice{text-align:center;font-family:Lusitana,serif;font-size:20px}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoCustomRow .diamondInfoPriceNotice,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoCustomRow .diamondInfoPriceNotice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoCustomRow .diamondInfoPriceNotice,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoCustomRow .diamondInfoPriceNotice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoCustomRow .diamondInfoPriceNotice,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoCustomRow .diamondInfoPriceNotice{margin:-3px 0 0;font-size:14px;font-weight:300;font-family:Lato,sans-serif;text-align:center}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoButtonRow,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoButtonRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoButtonRow,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoButtonRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoButtonRow,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoButtonRow{margin:0 0 10px;text-align:center}#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoButtonRow .assembledButton,#diamonds-direct .DiamondResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoButtonRow .assembledButton,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoButtonRow .assembledButton,#diamonds-direct .MixedResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoButtonRow .assembledButton,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentInfoWrapper .diamondInfoButtonRow .assembledButton,#diamonds-direct .SettingResults .assembledWrapper .assembledPreview .assembledComponentWrapper .diamondComponentWrapper .diamondComponentNullWrapper .diamondInfoButtonRow .assembledButton{display:inline-block;vertical-align:top;width:100px;height:30px;line-height:30px;margin:0 5px;border:1px solid #d3d3d3}#diamonds-direct .DiamondResults .resultsWrapper,#diamonds-direct .MixedResults .resultsWrapper,#diamonds-direct .SettingResults .resultsWrapper{position:relative}#diamonds-direct .DiamondResults .resultsWrapper .resultsCountWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsCountWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsCountWrapper{position:absolute;top:0;right:0;height:auto;width:auto}@media (max-width:768px){#diamonds-direct .DiamondResults .resultsWrapper .resultsCountWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsCountWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsCountWrapper{display:none}}#diamonds-direct .DiamondResults .resultsWrapper .resultsTabWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsTabWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsTabWrapper{border-left:2px solid #4b2d53}#diamonds-direct .DiamondResults .resultsWrapper .resultsTabWrapper .selectedTab.resultTab,#diamonds-direct .MixedResults .resultsWrapper .resultsTabWrapper .selectedTab.resultTab,#diamonds-direct .SettingResults .resultsWrapper .resultsTabWrapper .selectedTab.resultTab{color:#fff;background:#4b2d53;cursor:default}#diamonds-direct .DiamondResults .resultsWrapper .resultsTabWrapper .selectedTab.resultTab:hover,#diamonds-direct .MixedResults .resultsWrapper .resultsTabWrapper .selectedTab.resultTab:hover,#diamonds-direct .SettingResults .resultsWrapper .resultsTabWrapper .selectedTab.resultTab:hover{color:#fff;background:#4b2d53}#diamonds-direct .DiamondResults .resultsWrapper .resultsTabWrapper .resultTab,#diamonds-direct .MixedResults .resultsWrapper .resultsTabWrapper .resultTab,#diamonds-direct .SettingResults .resultsWrapper .resultsTabWrapper .resultTab{display:inline-block;width:200px;height:30px;line-height:30px;text-align:center;font-size:16px;font-weight:400;text-transform:uppercase;border-right:2px solid #4b2d53;color:#4b2d53;background:#fff;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}@media (max-width:768px){#diamonds-direct .DiamondResults .resultsWrapper .resultsTabWrapper .resultTab,#diamonds-direct .MixedResults .resultsWrapper .resultsTabWrapper .resultTab,#diamonds-direct .SettingResults .resultsWrapper .resultsTabWrapper .resultTab{width:calc(50% - 2px)}}#diamonds-direct .DiamondResults .resultsWrapper .resultsTabWrapper .resultTab:hover,#diamonds-direct .MixedResults .resultsWrapper .resultsTabWrapper .resultTab:hover,#diamonds-direct .SettingResults .resultsWrapper .resultsTabWrapper .resultTab:hover{color:#fff;background:#000}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody,#diamonds-direct .MixedResults .resultsWrapper .resultsBody,#diamonds-direct .SettingResults .resultsWrapper .resultsBody{position:relative;border:1px solid #d3d3d3;margin:0 0 10px;padding:10px 0}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .bodyLabel,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .bodyLabel,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .bodyLabel{text-align:center;margin:0 0 25px;font-size:20px;font-weight:300}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper{text-align:center}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem.favProduct .diamondItemInnerWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem.favProduct .diamondItemInnerWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem.favProduct .diamondItemInnerWrapper{border:1px solid #4b2d53}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem{position:relative;display:inline-block;vertical-align:top;width:25%;min-width:250px;margin:0 0 25px;text-align:center;outline:none}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper{border:1px solid #fff;margin:5px 10px;padding:10px 0}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .favSelectWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .favSelectWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .favSelectWrapper{position:absolute;top:10px;right:15px;width:20px;height:20px;cursor:pointer}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .favSelectWrapper img,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .favSelectWrapper img,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .favSelectWrapper img{width:100%}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemImgWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemImgWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemImgWrapper{display:block;height:150px;width:150px;margin:0 auto;cursor:pointer;outline:none}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemImgWrapper img,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemImgWrapper img,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemImgWrapper img{max-height:100%;max-width:100%}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemTitle,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemTitle,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemTitle{margin:10px 0 5px;font-size:16px;cursor:pointer}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemPrice,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemPrice,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemPrice{display:inline-block;width:auto;margin:0 0 5px;font-size:18px;font-weight:300;border-top:2px solid #4b2d53;padding:5px 20px;cursor:pointer;outline:none}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .selected.diamondItemAction,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .selected.diamondItemAction,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .selected.diamondItemAction{cursor:default;color:#fff;background:#563a5f;border:1px solid #563a5f}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemAction,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemAction,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemAction{width:170px;margin:0 auto 20px}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.favProduct .productItemInnerWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.favProduct .productItemInnerWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.favProduct .productItemInnerWrapper{border:1px solid #4b2d53}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper{cursor:pointer;margin:0 auto;max-width:350px;background-position:50%;background-repeat:no-repeat;background-size:contain}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper .adPrompt,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper .adPrompt,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper .adPrompt{position:absolute;width:180px;height:36px;left:calc(50% - 90px);bottom:20px;cursor:pointer;color:#fff;background:#b99ac0;transition:background .25s ease-in-out 0ms}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper .adPrompt:hover,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper .adPrompt:hover,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper .adPrompt:hover{background:#98799c}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper .adPrompt div,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper .adPrompt div,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .adInnerWrapper .adPrompt div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .engagementAd,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .engagementAd,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem.adBannerItem .engagementAd{height:300px;background-image:url(\"https://ddw2.diamondsdirect.com/img/gallery/engagement/ads/engage_1.jpg\")}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem{position:relative;display:inline-block;vertical-align:top;width:25%;min-width:250px;margin:0 0 25px;text-align:center;outline:none}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper{border:1px solid #fff;margin:5px 10px;padding:0 0 10px}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .favSelectWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .favSelectWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .favSelectWrapper{position:absolute;top:10px;right:15px;width:20px;height:20px;cursor:pointer}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .favSelectWrapper img,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .favSelectWrapper img,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .favSelectWrapper img{width:100%}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemImgWrapper,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemImgWrapper,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemImgWrapper{display:block;height:180px;width:180px;margin:0 auto;cursor:pointer;outline:none}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemImgWrapper img,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemImgWrapper img,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemImgWrapper img{max-height:100%;max-width:100%}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .productItemTitle,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .productItemTitle,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .productItemTitle{display:block;position:relative;margin:0 0 5px;font-size:15px;height:36px;cursor:pointer;outline:none;color:#333;text-decoration:none}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .productItemTitle div,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .productItemTitle div,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .productItemTitle div{position:absolute;top:0;left:5%;right:5%;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemPrice,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemPrice,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemPrice{display:inline-block;width:auto;margin:0 0 5px;font-size:18px;font-weight:300;border-top:2px solid #4b2d53;padding:5px 20px;cursor:pointer;outline:none;color:#333;text-decoration:none}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .selected.diamondItemAction,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .selected.diamondItemAction,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .selected.diamondItemAction{cursor:default;color:#fff;background:#563a5f;border:1px solid #563a5f}#diamonds-direct .DiamondResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemAction,#diamonds-direct .MixedResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemAction,#diamonds-direct .SettingResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemAction{width:170px}#diamonds-direct .DiamondResults .mixedIndividualResults .settingResults,#diamonds-direct .MixedResults .mixedIndividualResults .settingResults,#diamonds-direct .SettingResults .mixedIndividualResults .settingResults{display:inline-block;vertical-align:top;width:50%}#diamonds-direct .DiamondResults .mixedIndividualResults .settingResults .settingItemWrapper,#diamonds-direct .MixedResults .mixedIndividualResults .settingResults .settingItemWrapper,#diamonds-direct .SettingResults .mixedIndividualResults .settingResults .settingItemWrapper{margin:0 0 15px}#diamonds-direct .DiamondResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingImageWrapper,#diamonds-direct .MixedResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingImageWrapper,#diamonds-direct .SettingResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingImageWrapper{height:160px;text-align:center}#diamonds-direct .DiamondResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingImageWrapper img,#diamonds-direct .MixedResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingImageWrapper img,#diamonds-direct .SettingResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingImageWrapper img{height:100%}#diamonds-direct .DiamondResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper,#diamonds-direct .MixedResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper,#diamonds-direct .SettingResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper{height:90px;margin:-10px 0 0}#diamonds-direct .DiamondResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingTitleWrapper,#diamonds-direct .MixedResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingTitleWrapper,#diamonds-direct .SettingResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingTitleWrapper{display:block;position:relative;height:40px;width:90%;margin:0 auto;font-weight:400;font-size:17px;text-align:center;color:#5e5e5e;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .DiamondResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingTitleWrapper div,#diamonds-direct .MixedResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingTitleWrapper div,#diamonds-direct .SettingResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingTitleWrapper div{position:absolute;left:0;right:0;bottom:0;height:auto;overflow:hidden}#diamonds-direct .DiamondResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingPrice,#diamonds-direct .MixedResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingPrice,#diamonds-direct .SettingResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingPrice{text-align:center;width:35%;margin:10px auto;padding:10px 0;border-top:2px solid #563a5f;font-size:18px;font-weight:300}#diamonds-direct .DiamondResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingItemButtonWrapper,#diamonds-direct .MixedResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingItemButtonWrapper,#diamonds-direct .SettingResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingItemButtonWrapper{height:25px}#diamonds-direct .DiamondResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingItemButtonWrapper .itemButton,#diamonds-direct .MixedResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingItemButtonWrapper .itemButton,#diamonds-direct .SettingResults .mixedIndividualResults .settingResults .settingItemWrapper .settingItemInnerWrapper .settingItemButtonWrapper .itemButton{width:200px}#diamonds-direct .DiamondResults .mixedIndividualResults .diamondResults,#diamonds-direct .MixedResults .mixedIndividualResults .diamondResults,#diamonds-direct .SettingResults .mixedIndividualResults .diamondResults{display:inline-block;vertical-align:top;border-left:1px solid #707070;width:calc(50% - 1px)}#diamonds-direct .DiamondResults .mixedIndividualResults .diamondResults .diamondItemWrapper,#diamonds-direct .MixedResults .mixedIndividualResults .diamondResults .diamondItemWrapper,#diamonds-direct .SettingResults .mixedIndividualResults .diamondResults .diamondItemWrapper{margin:25px 0}#diamonds-direct .DiamondResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondImageWrapper,#diamonds-direct .MixedResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondImageWrapper,#diamonds-direct .SettingResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondImageWrapper{height:140px;margin:10px 0;text-align:center}#diamonds-direct .DiamondResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondImageWrapper img,#diamonds-direct .MixedResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondImageWrapper img,#diamonds-direct .SettingResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondImageWrapper img{height:100%}#diamonds-direct .DiamondResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper,#diamonds-direct .MixedResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper,#diamonds-direct .SettingResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper{height:90px;margin:-10px 0 0}#diamonds-direct .DiamondResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondTitleWrapper,#diamonds-direct .MixedResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondTitleWrapper,#diamonds-direct .SettingResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondTitleWrapper{display:block;position:relative;height:40px;width:90%;margin:0 auto;font-weight:400;font-size:20px;text-align:center;color:#5e5e5e;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .DiamondResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondTitleWrapper div,#diamonds-direct .MixedResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondTitleWrapper div,#diamonds-direct .SettingResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondTitleWrapper div{position:absolute;left:0;right:0;bottom:0;height:auto;overflow:hidden}#diamonds-direct .DiamondResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondPrice,#diamonds-direct .MixedResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondPrice,#diamonds-direct .SettingResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondPrice{text-align:center;width:35%;margin:10px auto;padding:10px 0;font-size:18px;font-weight:400;color:#4b2d53}#diamonds-direct .DiamondResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondItemButtonWrapper,#diamonds-direct .MixedResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondItemButtonWrapper,#diamonds-direct .SettingResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondItemButtonWrapper{height:25px}#diamonds-direct .DiamondResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondItemButtonWrapper .itemButton,#diamonds-direct .MixedResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondItemButtonWrapper .itemButton,#diamonds-direct .SettingResults .mixedIndividualResults .diamondResults .diamondItemWrapper .diamondItemInnerWrapper .diamondItemButtonWrapper .itemButton{width:200px}#diamonds-direct .Header.following .earringEventBanner{z-index:-1;top:calc(100% - 2px)}#diamonds-direct .Header .earringEventBanner{display:none;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center;color:#fff;font-size:16px;position:absolute;left:0;right:0;top:calc(100% - 10px);height:35px;font-family:Lato,sans-serif;background:#432748}#diamonds-direct .earringEventBanner .desktopMessage{display:-ms-flexbox;display:flex}#diamonds-direct .earringEventBanner .mobileMessage{display:none}#diamonds-direct .earringEventBanner .earringClickable{cursor:pointer;font-weight:700;text-decoration:underline}#diamonds-direct .earringEventBanner .earringEm{font-weight:700;margin:0 5px}@media (max-width:1024px){#diamonds-direct .Header .earringEventBanner{top:calc(100% - 6px);height:20px;font-size:11px}#diamonds-direct .earringEventBanner .desktopMessage{display:none}#diamonds-direct .earringEventBanner .mobileMessage{display:-ms-flexbox;display:flex}}#diamonds-direct .AppHeaderWrapper{padding:100px 0 0;transition:padding .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .AppHeaderWrapper{padding:55px 0 0}}#diamonds-direct .Header{position:fixed;top:0;left:0;right:0;height:100px;z-index:5;background:#fff;transition:background .4s ease-in-out 0ms,height .4s ease-in-out 0ms}@media (max-width:1024px){#diamonds-direct .Header{height:55px}}#diamonds-direct .Header .open.loginWrapper{max-height:100vh}#diamonds-direct .Header .loginWrapper{position:absolute;top:0;right:0;width:360px;height:100vh;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .Header .ggLink{display:inline-block;width:120px;height:35px;float:right;cursor:pointer;background-image:url(\"https://ddw2.diamondsdirect.com/img/header/gift-guide/ggprupler.svg\");background-size:120px 35px;background-position:50%;background-repeat:no-repeat}#diamonds-direct .Header .ggLink:hover{background-image:url(\"https://ddw2.diamondsdirect.com/img/header/gift-guide/gggrayr.svg\")}#diamonds-direct .Header .lhs{position:absolute;top:25px;left:20px;width:220px;height:45px}@media (max-width:480px){#diamonds-direct .Header .lhs{width:140px}}#diamonds-direct .Header .lhs .menuWrapper{position:absolute;top:0;left:5px;width:40px;height:50px;cursor:pointer;background-image:url(\"https://ddw2.diamondsdirect.com/img/header/menu_gray.svg\");background-size:40px 50px;background-position:50%;background-repeat:no-repeat;transition:top .4s ease-in-out 0ms,left .4s ease-in-out 0ms,width .4s ease-in-out 0ms,height .4s ease-in-out 0ms}#diamonds-direct .Header .lhs .menuWrapper:hover{background-image:url(\"https://ddw2.diamondsdirect.com/img/header/menu_purple.svg\")}#diamonds-direct .Header .lhs .mobileMenu{position:absolute;top:-10px;left:-5px;height:25px;cursor:pointer}#diamonds-direct .Header .lhs .mobileMenu img{height:100%}#diamonds-direct .Header .centerIcon{cursor:pointer}#diamonds-direct .Header .centerIcon .iconWrapper{margin:0 auto;padding:10px 0;width:200px;transition:width .35s linear 0ms,padding .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Header .centerIcon .iconWrapper{padding:5px 0;width:50px}}#diamonds-direct .Header .centerIcon .iconWrapper img{width:100%}#diamonds-direct .Header .centerIcon .iconNoFollow{display:block}#diamonds-direct .Header .centerIcon .iconNoFollow .desktopIcon{display:inline-block}@media (max-width:1024px){#diamonds-direct .Header .centerIcon .iconNoFollow .desktopIcon{display:none}}#diamonds-direct .Header .centerIcon .iconNoFollow .mobileIcon{display:none}@media (max-width:1024px){#diamonds-direct .Header .centerIcon .iconNoFollow .mobileIcon{display:inline-block}}#diamonds-direct .Header .centerIcon .iconFollow{display:none}#diamonds-direct .Header .rhs{position:absolute;top:5px;right:20px;width:500px;height:60px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media (max-width:1024px){#diamonds-direct .Header .rhs{width:140px}}#diamonds-direct .Header .rhs .open.iconSearchWrapper{height:45px}@media (max-width:1024px){#diamonds-direct .Header .rhs .open.iconSearchWrapper{height:50px;z-index:1}}#diamonds-direct .Header .rhs .iconSearchWrapper{position:absolute;overflow:hidden;top:calc(100% - 15px);right:-20px;width:300px;height:0;background:hsla(0,0%,100%,.95);font-family:Lato,sans-serif;transition:height .4s ease-in-out 0ms,top .35s linear 0ms,right .35s linear 0ms,width .35s linear 0ms,height .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Header .rhs .iconSearchWrapper{position:fixed;top:48px;right:0;width:360px}}@media (max-width:600px){#diamonds-direct .Header .rhs .iconSearchWrapper{width:100%}}#diamonds-direct .Header .rhs .iconSearchWrapper .iconSearch{position:absolute;top:5px;right:15px;left:0;bottom:5px}#diamonds-direct .Header .rhs .iconSearchWrapper .iconSearch .inputWrapper{position:absolute;left:10px;right:30px;top:0;bottom:0}@media (max-width:1024px){#diamonds-direct .Header .rhs .iconSearchWrapper .iconSearch .inputWrapper{bottom:5px}}#diamonds-direct .Header .rhs .iconSearchWrapper .iconSearch .inputWrapper input{border:1px solid #999;border-radius:none;outline:none;padding:5px 10px;width:calc(100% - 22px);height:calc(100% - 12px);background:#fff;transition:border .1s ease-in-out 0ms}#diamonds-direct .Header .rhs .iconSearchWrapper .iconSearch .inputWrapper input:focus{border:1px solid #4b2d53}#diamonds-direct .Header .rhs .iconSearchWrapper .iconSearch .actionWrapper{position:absolute;top:0;right:0;width:30px;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;font-size:18px;cursor:pointer;color:#4b2d53;transition:color .25s ease-in-out 0ms}@media (max-width:1024px){#diamonds-direct .Header .rhs .iconSearchWrapper .iconSearch .actionWrapper{bottom:5px;font-size:22px}}#diamonds-direct .Header .rhs .iconSearchWrapper .iconSearch .actionWrapper:hover{color:#000}#diamonds-direct .Header .rhs .smallLinkWrapper{color:#999;height:20px;font-size:14px;text-align:right;font-family:Lato,sans-serif;font-weight:300}#diamonds-direct .Header .rhs .smallLinkWrapper .smallLink{float:right;margin:0 0 0 20px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Header .rhs .smallLinkWrapper .smallLink:hover{color:#4b2d53}#diamonds-direct .Header .rhs .smallLinkWrapper .smallLink img{width:20px}#diamonds-direct .Header .rhs .smallLinkWrapper .smallLink a{color:#999;text-decoration:none}#diamonds-direct .Header .rhs .smallLinkWrapper .smallLink a:active,#diamonds-direct .Header .rhs .smallLinkWrapper .smallLink a:visited{color:#999}#diamonds-direct .Header .rhs .smallLinkWrapper .smallLink a:hover{color:#4b2d53}#diamonds-direct .Header .rhs .smallLinkWrapper .smallLink.headerChat{background-position:0;background-repeat:no-repeat;width:55px;text-align:right}#diamonds-direct .Header .rhs .smallLinkWrapper .smallLink.headerChat,#diamonds-direct .Header .rhs .smallLinkWrapper .smallLink.headerChat:hover{background-image:url(\"https://ddw2.diamondsdirect.com/img/header/chat.svg\")}#diamonds-direct .Header .rhs .iconLinkWrapper{position:relative;color:#999;height:30px;font-size:18px;margin:3px 0 0}#diamonds-direct .Header .rhs .iconLinkWrapper .iconLink{position:relative;margin:0 0 0 30px;width:auto;height:30px;cursor:pointer;float:right}#diamonds-direct .Header .rhs .iconLinkWrapper .iconLink .cartImg.iconImg{position:relative}#diamonds-direct .Header .rhs .iconLinkWrapper .iconLink .cartImg.iconImg .cartBubble{color:#fff;background:#4b2d53;border-radius:50%;font-size:8px;font-weight:700;font-family:Lato,sans-serif;position:absolute;top:-2px;right:-8px;width:14px;height:14px}#diamonds-direct .Header .rhs .iconLinkWrapper .iconLink .cartImg.iconImg .cartBubble div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Header .rhs .iconLinkWrapper .iconLink .iconImg{display:inline-block;height:20px}#diamonds-direct .Header .rhs .iconLinkWrapper .iconLink .iconImg img{height:100%}#diamonds-direct .Header .rhs .iconLinkWrapper .iconLink .iconLabel{height:30px;display:inline-block;margin:0 0 0 8px;line-height:30px;text-decoration:none;transition:color .25s ease-in-out 0ms}#diamonds-direct .Header .rhs .iconLinkWrapper .iconLink:hover{color:#4b2d53}#diamonds-direct .Header .rhs .cartIcon{position:absolute;top:4px;right:-5px;height:33px;cursor:pointer}#diamonds-direct .Header .rhs .cartIcon img{height:100%}#diamonds-direct .Header .rhs .cartIcon .cartBubble{color:#fff;background:#4b2d53;border-radius:50%;font-size:12px;font-weight:700;font-family:Lato,sans-serif;position:absolute;top:9px;right:4px;width:20px;height:20px}#diamonds-direct .Header .rhs .cartIcon .cartBubble div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Header .rhs .giftIcon{position:absolute;top:4px;right:35px;height:33px;cursor:pointer}#diamonds-direct .Header .rhs .giftIcon img{height:100%}#diamonds-direct .Header .rhs .giftIcon.mobileThird{right:75px}#diamonds-direct .Header.following{height:60px;z-index:5;background:hsla(0,0%,100%,.95)}@media (max-width:1024px){#diamonds-direct .Header.following{height:50px}}#diamonds-direct .Header.following .iconWrapper{width:50px}#diamonds-direct .Header.following .iconNoFollow{display:none}#diamonds-direct .Header.following .iconFollow{display:block}#diamonds-direct .Header.following .menuWrapper{top:-18px;left:-8px;background-size:30px 40px}@media (max-width:1024px){#diamonds-direct .Header.following .menuWrapper{top:-10px}}#diamonds-direct .Login,#diamonds-direct .Register{position:relative;background:#fafafa;z-index:10;overflow-x:auto;overflow-y:auto;font-family:Lato,sans-serif;height:100%}#diamonds-direct .Login .loginClose,#diamonds-direct .Register .loginClose{position:absolute;cursor:pointer;background-image:radial-gradient(#707070,#707070);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:15px;left:15px;width:20px;height:20px;border:1px solid #707070;transform:rotate(45deg);transition:background-size .25s ease-in-out 0ms}#diamonds-direct .Login .loginClose:hover,#diamonds-direct .Register .loginClose:hover{background-size:100% 100%}#diamonds-direct .Login .loginClose:hover .closeX,#diamonds-direct .Register .loginClose:hover .closeX{color:#fafafa}#diamonds-direct .Login .loginClose .closeX,#diamonds-direct .Register .loginClose .closeX{color:#707070;margin:-1px 0 0 -2px;transform:rotate(-45deg);line-height:20px;text-align:center;font-size:20px;font-weight:300;transition:color .25s ease-in-out 0ms}#diamonds-direct .Login .loginInnerWrapper,#diamonds-direct .Register .loginInnerWrapper{position:relative;margin:50px 0 0;overflow:auto}#diamonds-direct .Login .loginInnerWrapper .errorWrapper .signInLink,#diamonds-direct .Register .loginInnerWrapper .errorWrapper .signInLink{font-size:14px;text-decoration:underline;cursor:pointer;color:#4b2d53!important;padding:0;margin:0 0 0 10px;transition:color .25s ease-in-out 0ms}#diamonds-direct .Login .loginInnerWrapper .errorWrapper .signInLink:hover,#diamonds-direct .Register .loginInnerWrapper .errorWrapper .signInLink:hover{color:#000}#diamonds-direct .Login .loginInnerWrapper .loginTitle,#diamonds-direct .Register .loginInnerWrapper .loginTitle{text-align:center;font-family:Lusitana,serif;font-size:28px;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .Login .loginInnerWrapper .loginHr,#diamonds-direct .Register .loginInnerWrapper .loginHr{background:#5e5e5e;width:60%;height:2px;margin:15px auto}#diamonds-direct .Login .loginInnerWrapper .loginText,#diamonds-direct .Register .loginInnerWrapper .loginText{text-align:center;font-size:18px;width:80%;margin:0 auto}#diamonds-direct .Login .loginInnerWrapper .errorMessage,#diamonds-direct .Register .loginInnerWrapper .errorMessage{color:#eb3533;text-align:center;margin:10px;font-size:14px}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper{width:70%;margin:25px auto}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .loginFormError,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .loginFormError{color:#eb3533;text-align:center;font-weight:400}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow{margin:0 0 10px}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow .loginInputLabel,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow .loginInputLabel{font-size:13px;margin:0 0 3px}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow input.error,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow input.error{border:1px solid #eb3533}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow input,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow input{padding:5px 8px;border:1px solid #707070;width:calc(100% - 12px)}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow .loginInputError,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow .loginInputError{color:#eb3533;font-size:12px;text-align:left}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow .loginFormButtonWrapper,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow .loginFormButtonWrapper{margin:20px auto;width:70%}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow .loginFormButtonWrapper .loginFormButton,#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow .loginFormButtonWrapper .registerFormButton,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow .loginFormButtonWrapper .loginFormButton,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .loginFormRow .loginFormButtonWrapper .registerFormButton{color:#fafafa;font-size:16px}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .forgotPasswordRow,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .forgotPasswordRow{text-align:right;font-size:14px;font-weight:700;color:#4b2d53}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .forgotPasswordRow:hover,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .forgotPasswordRow:hover{text-decoration:underline}#diamonds-direct .Login .loginInnerWrapper .loginFormWrapper .loginForm .forgotPasswordRow .fpLink,#diamonds-direct .Register .loginInnerWrapper .loginFormWrapper .loginForm .forgotPasswordRow .fpLink{cursor:pointer;width:auto;display:inline-block}#diamonds-direct .Login .loginInnerWrapper .toggleArea,#diamonds-direct .Register .loginInnerWrapper .toggleArea{text-align:center;margin:10px 0 75px}#diamonds-direct .Login .loginInnerWrapper .toggleArea .toggleText,#diamonds-direct .Register .loginInnerWrapper .toggleArea .toggleText{font-size:16px;font-weight:300}#diamonds-direct .Login .loginInnerWrapper .toggleArea .toggleLink,#diamonds-direct .Register .loginInnerWrapper .toggleArea .toggleLink{margin:5px 0 0;font-size:16px;font-weight:700;color:#563a5f;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Login .loginInnerWrapper .toggleArea .toggleLink:hover,#diamonds-direct .Register .loginInnerWrapper .toggleArea .toggleLink:hover{color:#442e4c}#diamonds-direct .Login .loginInnerWrapper .toggleArea .toggleLink:active,#diamonds-direct .Register .loginInnerWrapper .toggleArea .toggleLink:active{color:#664d6f}#diamonds-direct .Login .loginInnerWrapper .toggleArea .privacyLink,#diamonds-direct .Register .loginInnerWrapper .toggleArea .privacyLink{margin-top:30px}#diamonds-direct .ggWrapper{text-align:center;height:40px;width:200px;margin:20px auto 0}#diamonds-direct .ggWrapper .ggLink{width:200px;height:40px;cursor:pointer;background-image:url(\"https://ddw2.diamondsdirect.com/img/header/gift-guide/ggprupler.svg\");background-size:100% 100%;background-position:50%;background-repeat:no-repeat}#diamonds-direct .ggWrapper .ggLink:hover{background-image:url(\"https://ddw2.diamondsdirect.com/img/header/gift-guide/gggrayr.svg\")}#diamonds-direct .Menu{height:740px;display:block;position:absolute;left:-425px;top:0;width:375px;max-height:100vh;background:#fafafa;z-index:3;color:#fff;overflow-x:hidden;overflow-y:auto;transition:left .4s ease-in-out 0ms,top .4s ease-in-out 0ms}@media (max-width:768px){#diamonds-direct .Menu{display:none}}#diamonds-direct .Menu .closeIcon{position:absolute;cursor:pointer;color:#95989a;background-image:radial-gradient(#95989a,#95989a);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:16px;left:16px;width:20px;height:20px;border:1px solid #95989a;transform:rotate(45deg);z-index:1;transition:top .35s linear 0ms,right .35s linear 0ms,width .35s linear 0ms,height .35s linear 0ms,background-size .25s ease-in-out 0ms}#diamonds-direct .Menu .closeIcon:hover{background-size:100% 100%;border:1px solid #95989a}#diamonds-direct .Menu .closeIcon:hover .closeX{color:#fafafa}#diamonds-direct .Menu .closeIcon .closeX{margin:0 0 0 -1px;transform:rotate(-45deg);line-height:20px;text-align:center;font-size:20px;font-weight:300;transition:font-size .35s linear 0ms,line-height .35s linear 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Menu .menuWrapper{margin:10px 30px 20px;text-align:center}#diamonds-direct .Menu .menuWrapper .logoWrapper{width:70%;margin:0 auto 10px;cursor:pointer}#diamonds-direct .Menu .menuWrapper .menuEntry{position:relative;margin:0 25px;border-top:1px solid #95989a;height:auto;line-height:40px;font-size:20px;cursor:pointer;color:#95989a;text-align:left;transition:color .25s ease-in-out 0ms}#diamonds-direct .Menu .menuWrapper .menuEntry:nth-child(2){border-top:none}#diamonds-direct .Menu .menuWrapper .menuEntry:hover{color:#4b2d53}#diamonds-direct .Menu .menuWrapper .menuEntry .drawerLabel{padding:0 0 0 70px}#diamonds-direct .Menu .menuWrapper .menuEntry .drawerSubmenu{text-align:center;background:#fff;height:auto;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .Menu .menuWrapper .menuEntry .drawerSubmenu .itemWrapper{margin:0;border-bottom:1px solid #b2b2b2;text-align:left;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Menu .menuWrapper .menuEntry .drawerSubmenu .itemWrapper:hover .ringLabel{color:#4b2d53}#diamonds-direct .Menu .menuWrapper .menuEntry .drawerSubmenu .itemWrapper .ringImg{display:inline-block;height:45px;vertical-align:middle}#diamonds-direct .Menu .menuWrapper .menuEntry .drawerSubmenu .itemWrapper .ringImg img{height:100%}#diamonds-direct .Menu .menuWrapper .menuEntry .drawerSubmenu .itemWrapper .ringLabel{display:inline-block;width:auto;margin:0 0 0 10px;color:#95989a;vertical-align:middle}#diamonds-direct .Menu .menuWrapper .menuEntry .drawerArrow{display:inline-block;position:absolute;top:-5px;width:25px;height:50px;transition:right .4s ease-in-out 0ms}#diamonds-direct .Menu .menuWrapper .menuEntry .drawerArrow img{display:none;width:100%}#diamonds-direct .Menu .menuWrapper .expandable{background-image:url(\"https://ddw2.diamondsdirect.com/img/menu/plus.svg\");background-repeat:no-repeat;background-size:15px 15px;background-position:40px 13px}#diamonds-direct .Menu .menuWrapper .expandable .drawerSubmenu{max-height:0}#diamonds-direct .Menu .menuWrapper .expandable .drawerArrow{right:-50px}#diamonds-direct .Menu .menuWrapper .expanded{background-image:url(\"https://ddw2.diamondsdirect.com/img/menu/minus.svg\");background-repeat:no-repeat;background-size:15px 15px;background-position:40px 13px;color:#4b2d53}#diamonds-direct .Menu .menuWrapper .expanded .drawerSubmenu{max-height:600px}#diamonds-direct .Menu .menuWrapper .expanded .drawerArrow{right:-80px}#diamonds-direct .Menu .menuWrapper .menuSearch{position:relative;margin:0 25px}#diamonds-direct .Menu .menuWrapper .menuSearch input{width:100%;text-align:center;background:none;border-top:1px solid #95989a;border-left:0;border-right:0;border-bottom:2px solid #95989a;height:40px;font-size:20px;color:#4e4352}#diamonds-direct .Menu .menuWrapper .menuSearch input::-webkit-input-placeholder{color:#bababa;font-size:16px}#diamonds-direct .Menu .menuWrapper .menuSearch input:-moz-placeholder,#diamonds-direct .Menu .menuWrapper .menuSearch input::-moz-placeholder{color:#bababa;font-size:16px}#diamonds-direct .Menu .menuWrapper .menuSearch input:-ms-input-placeholder{color:#bababa;font-size:16px}#diamonds-direct .Menu .menuWrapper .menuSearch .searchButton{position:absolute;top:8px;right:5%;height:30px;width:30px;line-height:30px;text-align:right;font-size:20px;color:#95989a;transition:color .25s ease-in-out 0ms}#diamonds-direct .Menu .menuWrapper .menuSearch .searchButton:hover{color:#fff}#diamonds-direct .Menu .menuWrapper .menuButton{margin:20px auto 0;display:inline-block;width:auto;text-transform:uppercase;font-size:16px;font-weight:700;color:#95989a;border:2px solid #95989a;padding:5px 20px;text-align:center;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}#diamonds-direct .Menu .menuWrapper .menuButton:hover{color:#fff;background:#4b2d53;border:2px solid #4b2d53}#diamonds-direct .Menu.open{top:0;left:0}#diamonds-direct .menuSubmenu{position:absolute;top:0;left:-375px;width:375px;height:700px;max-height:100vh;background:#fff;z-index:2;overflow-y:auto;transition:left .4s ease-in-out 0ms}@media (max-width:768px){#diamonds-direct .menuSubmenu{display:none}}#diamonds-direct .menuSubmenu .diamondsSub{padding-top:30px}#diamonds-direct .menuSubmenu .diamondsSub .subTitle{font-size:24px}#diamonds-direct .menuSubmenu .diamondsSub .diamondsWrapper{margin:0 30px;padding:10px 0;border-top:1px solid #b2b2b2;text-align:center;cursor:pointer}#diamonds-direct .menuSubmenu .diamondsSub .diamondsWrapper:hover .diamondsLabel{color:#4b2d53}#diamonds-direct .menuSubmenu .diamondsSub .diamondsWrapper:first-child{border-top:none}#diamonds-direct .menuSubmenu .diamondsSub .diamondsWrapper .diamondsImg{display:inline-block;width:125px}#diamonds-direct .menuSubmenu .diamondsSub .diamondsWrapper .diamondsImg img{width:100%}#diamonds-direct .menuSubmenu .diamondsSub .diamondsWrapper .diamondsLabel{color:#95989a}#diamonds-direct .menuSubmenu .diamondsSub .diamondsWrapper .diamondsLabel:hover{color:#4b2d53}#diamonds-direct .menuSubmenu .engagementSub .subTitle{color:#95989a;cursor:pointer}#diamonds-direct .menuSubmenu .engagementSub .ringWrapper{margin:0 30px;padding:80px 0;border-top:1px solid #b2b2b2;text-align:center;cursor:pointer}#diamonds-direct .menuSubmenu .engagementSub .ringWrapper:hover .ringLabel{color:#4b2d53}#diamonds-direct .menuSubmenu .engagementSub .ringWrapper .ringImg{display:inline-block;width:135px}#diamonds-direct .menuSubmenu .engagementSub .ringWrapper .ringImg img{width:100%}#diamonds-direct .menuSubmenu .engagementSub .ringWrapper .ringLabel{color:#95989a}#diamonds-direct .menuSubmenu .engagementSub .ringWrapper .ringLabel:hover{color:#4b2d53}#diamonds-direct .menuSubmenu .weddingSub .subTitle{font-size:24px}#diamonds-direct .menuSubmenu .weddingSub .bandWrapper{margin:0 30px;padding:35px 0;border-top:1px solid #b2b2b2;text-align:center;cursor:pointer}#diamonds-direct .menuSubmenu .weddingSub .bandWrapper:hover .bandLabel{color:#4b2d53}#diamonds-direct .menuSubmenu .weddingSub .bandWrapper .bandImg{display:inline-block;width:135px;margin:25px 0}#diamonds-direct .menuSubmenu .weddingSub .bandWrapper .bandImg img{width:100%}#diamonds-direct .menuSubmenu .weddingSub .bandWrapper .bandLabel{color:#95989a;font-size:20px}#diamonds-direct .menuSubmenu .weddingSub .bandWrapper .bandLabel:hover{color:#4b2d53}#diamonds-direct .menuSubmenu .designersSub{padding-top:30px}#diamonds-direct .menuSubmenu .designersSub .subTitle{font-size:24px}#diamonds-direct .menuSubmenu .designersSub .designersWrapper{margin:0 30px;padding:25px 0;border-top:1px solid #b2b2b2;text-align:center;cursor:pointer}#diamonds-direct .menuSubmenu .designersSub .designersWrapper:hover .designersLabel{color:#4b2d53}#diamonds-direct .menuSubmenu .designersSub .designersWrapper:first-child{border-top:none}#diamonds-direct .menuSubmenu .designersSub .designersWrapper .designersImg{display:inline-block;width:135px}#diamonds-direct .menuSubmenu .designersSub .designersWrapper .designersImg img{width:100%}#diamonds-direct .menuSubmenu .designersSub .designersWrapper .designersLabel{color:#95989a}#diamonds-direct .menuSubmenu .designersSub .designersWrapper .designersLabel:hover{color:#4b2d53}#diamonds-direct .menuSubmenu .fineJewelrySub .menuSectionHeader{text-align:center;font-size:26px;margin:15px 0}#diamonds-direct .menuSubmenu .fineJewelrySub .menuSectionSubHeader{text-align:center;font-size:18px;margin:-15px 0 15px;font-family:Lato,sans-serif;font-weight:300}#diamonds-direct .menuSubmenu .fineJewelrySub .itemWrapper{margin:0 30px;border-top:1px solid #b2b2b2;position:relative;height:60px;cursor:pointer}#diamonds-direct .menuSubmenu .fineJewelrySub .itemWrapper:hover .ringLabel{color:#4b2d53}#diamonds-direct .menuSubmenu .fineJewelrySub .itemWrapper .ringImg{display:inline-block;position:absolute;top:5px;left:0;width:90px;height:50px;text-align:center}#diamonds-direct .menuSubmenu .fineJewelrySub .itemWrapper .ringImg img{height:100%}#diamonds-direct .menuSubmenu .fineJewelrySub .itemWrapper .ringLabel{padding:0 0 0 100px;line-height:60px;font-size:20px;color:#95989a}#diamonds-direct .menuSubmenu .fineJewelrySub .itemWrappper.firstEntry{border-top:0}#diamonds-direct .menuSubmenu .educationSub{padding-top:30px}#diamonds-direct .menuSubmenu .educationSub .subTitle{font-size:24px}#diamonds-direct .menuSubmenu .educationSub .educationWrapper{margin:0 30px;padding:10px 0;border-top:1px solid #b2b2b2;text-align:center;cursor:pointer}#diamonds-direct .menuSubmenu .educationSub .educationWrapper:hover .educationLabel{color:#4b2d53}#diamonds-direct .menuSubmenu .educationSub .educationWrapper:first-child{border-top:none}#diamonds-direct .menuSubmenu .educationSub .educationWrapper .educationImg{display:inline-block;width:90px}#diamonds-direct .menuSubmenu .educationSub .educationWrapper .educationImg img{width:100%}#diamonds-direct .menuSubmenu .educationSub .educationWrapper .educationLabel{color:#95989a}#diamonds-direct .menuSubmenu .educationSub .educationWrapper .educationLabel:hover{color:#4b2d53}#diamonds-direct .menuSubmenu .aboutUsSub .ringWrapper{margin:0 30px;padding:10px 0;border-top:1px solid #b2b2b2;text-align:center;cursor:pointer}#diamonds-direct .menuSubmenu .aboutUsSub .ringWrapper:hover .ringLabel{color:#4b2d53}#diamonds-direct .menuSubmenu .aboutUsSub .ringWrapper .ringImg{display:inline-block;width:80px}#diamonds-direct .menuSubmenu .aboutUsSub .ringWrapper .ringImg img{width:100%}#diamonds-direct .menuSubmenu .aboutUsSub .ringWrapper .ringLabel{color:#95989a}#diamonds-direct .menuSubmenu .subTitle{text-align:center;font-size:20px;color:#4f4f4f;margin:20px 0}#diamonds-direct .menuSubmenu.open{left:375px}#diamonds-direct .MobileMenu{display:none;position:absolute;left:0;top:-1000px;width:100%;max-width:400px;height:100vh;max-height:100vh;background:#fafafa;z-index:3;color:#fff;overflow-y:scroll;transition:top .4s ease-in-out 0ms}@media (max-width:768px){#diamonds-direct .MobileMenu{display:block}}#diamonds-direct .MobileMenu .closeIcon{position:absolute;cursor:pointer;color:#95989a;background-image:radial-gradient(#95989a,#95989a);background-position:50% 50%;background-repeat:no-repeat;background-size:0 0;top:16px;left:16px;width:20px;height:20px;border:1px solid #95989a;transform:rotate(45deg);z-index:1;transition:top .35s linear 0ms,right .35s linear 0ms,width .35s linear 0ms,height .35s linear 0ms,background-size .25s ease-in-out 0ms}#diamonds-direct .MobileMenu .closeIcon:hover{border:1px solid #95989a;background-size:100% 100%}#diamonds-direct .MobileMenu .closeIcon:hover .closeX{color:#fafafa}#diamonds-direct .MobileMenu .closeIcon .closeX{margin:0 0 0 -1px;transform:rotate(-45deg);line-height:20px;text-align:center;font-size:20px;font-weight:300;transition:font-size .35s linear 0ms,line-height .35s linear 0ms,color .25s ease-in-out 0ms}#diamonds-direct .MobileMenu .menuWrapper{margin:30px 15px;text-align:center}#diamonds-direct .MobileMenu .menuWrapper .logoWrapper{width:70%;max-width:300px;margin:0 auto 30px;cursor:pointer;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .MobileMenu .menuWrapper .logoWrapper{width:60%}}#diamonds-direct .MobileMenu .menuWrapper .menuEntry{margin:0 15px;border-top:1px solid #95989a;padding:0;height:auto;min-height:40px;line-height:40px;font-size:20px;cursor:pointer;color:#95989a;text-align:left;transition:color .25s ease-in-out 0ms}#diamonds-direct .MobileMenu .menuWrapper .menuEntry:nth-child(2){border-top:none}#diamonds-direct .MobileMenu .menuWrapper .menuEntry:hover{color:#4b2d53}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileLabel{padding:0 0 0 5%}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu{text-align:center;background:#fff;height:auto;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu .mobileSubmenuButton{display:inline-block;margin:10px auto;color:#4b2d53;border:1px solid #4b2d53;width:auto;font-size:16px;text-align:center;padding:8px 20px;line-height:16px;transition:color .35s linear 0ms,background .35s linear 0ms}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu .mobileSubmenuButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu .mobileMenuSectionHeader{color:#4e4352}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu .mobileMenuSectionSubHeader{font-family:Lato,sans-serif;font-size:16px;font-weight:300;margin:-15px 0 5px}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu .itemWrapper{margin:0;border-bottom:1px solid #b2b2b2;text-align:left}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu .itemWrapper .ringImg{display:inline-block;height:45px;width:90px;text-align:center;vertical-align:middle}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu .itemWrapper .ringImg img{height:100%}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu .itemWrapper .ringLabel{display:inline-block;width:auto;margin:0 0 0 10px;color:#4f4f4f;vertical-align:middle}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu .weddingSub .itemWrapper .ringImg{margin:3px 0 0}#diamonds-direct .MobileMenu .menuWrapper .menuEntry .mobileSubmenu .weddingSub .itemWrapper .ringImg img{max-width:80%;max-height:80px}#diamonds-direct .MobileMenu .menuWrapper .expandable{background-image:url(\"https://ddw2.diamondsdirect.com/img/menu/plus.svg\");background-repeat:no-repeat;background-size:15px 15px;background-position:95% 13px}#diamonds-direct .MobileMenu .menuWrapper .expandable .mobileSubmenu{max-height:0}#diamonds-direct .MobileMenu .menuWrapper .expanded{background-image:url(\"https://ddw2.diamondsdirect.com/img/menu/minus.svg\");background-repeat:no-repeat;background-size:15px 15px;background-position:95% 13px;color:#4b2d53}#diamonds-direct .MobileMenu .menuWrapper .expanded .mobileSubmenu{max-height:500px}#diamonds-direct .MobileMenu .menuWrapper .menuButton{margin:15px auto 75px;display:inline-block;width:auto;text-transform:uppercase;font-size:16px;font-weight:700;color:#95989a;border:2px solid #95989a;padding:5px 20px;text-align:center;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}#diamonds-direct .MobileMenu .menuWrapper .menuButton:hover{color:#fff;background:#4b2d53;border:2px solid #4b2d53}#diamonds-direct .MobileMenu .menuWrapper .menuSearch{position:relative;margin:0 25px}#diamonds-direct .MobileMenu .menuWrapper .menuSearch input{width:100%;text-align:center;background:none;border-top:1px solid #95989a;border-left:0;border-right:0;border-bottom:2px solid #95989a;height:40px;font-size:20px;color:#4e4352}#diamonds-direct .MobileMenu .menuWrapper .menuSearch input::-webkit-input-placeholder{color:#bababa;font-size:16px}#diamonds-direct .MobileMenu .menuWrapper .menuSearch input:-moz-placeholder,#diamonds-direct .MobileMenu .menuWrapper .menuSearch input::-moz-placeholder{color:#bababa;font-size:16px}#diamonds-direct .MobileMenu .menuWrapper .menuSearch input:-ms-input-placeholder{color:#bababa;font-size:16px}#diamonds-direct .MobileMenu .menuWrapper .menuSearch .searchButton{position:absolute;top:8px;right:5%;height:30px;width:30px;line-height:30px;text-align:right;font-size:20px;color:#95989a;transition:color .25s ease-in-out 0ms}#diamonds-direct .MobileMenu .menuWrapper .menuSearch .searchButton:hover{color:#fff}#diamonds-direct .MobileMenu.open{top:0}#diamonds-direct .Privacy{color:#000;font-family:Lato,sans-serif}#diamonds-direct .Privacy .legalLink{color:#472f51;text-decoration:none}#diamonds-direct .Privacy .legalLink:hover{text-decoration:underline}#diamonds-direct .Privacy .headerSection{position:relative;margin:0 auto;width:90%;max-width:1024px}#diamonds-direct .Privacy .headerSection .privacyTitle{font-family:Lusitana,serif;font-size:36px;margin:25px 0 5px}#diamonds-direct .Privacy .headerSection .prBr{background:#000;width:100%;height:1px;margin:25px 0}#diamonds-direct .Privacy .headerSection .prIconTitle{margin:0}#diamonds-direct .Privacy .headerSection .prIconWrapper{position:relative;margin:25px 0 75px;text-align:center;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Privacy .headerSection .prIconWrapper{margin-bottom:25px}}#diamonds-direct .Privacy .headerSection .prIconWrapper .prIcon{display:inline-block;vertical-align:top;width:calc(33.33% - 20px);margin:0 10px 20px;transition:width .35s linear 0ms,margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Privacy .headerSection .prIconWrapper .prIcon{width:calc(80% - 20px);margin-bottom:40px}}#diamonds-direct .Privacy .headerSection .prIconWrapper .prIcon .priImgWrapper{height:50px;text-align:center}#diamonds-direct .Privacy .headerSection .prIconWrapper .prIcon .priImgWrapper img{height:100%}#diamonds-direct .Privacy .headerSection .prIconWrapper .prIcon .priTitle{position:relative;height:60px;font-weight:700}#diamonds-direct .Privacy .headerSection .prIconWrapper .prIcon .priTitle div{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Privacy .headerSection .prIconWrapper .prIcon .priItems{margin:0}#diamonds-direct .Privacy .headerSection .prIconWrapper .prIcon .priData{margin:20px 0 0}@media (max-width:768px){#diamonds-direct .Privacy .headerSection .prIconWrapper .prIcon .priData{margin:8px 0 0}}#diamonds-direct .Privacy .contactSection{position:relative;margin:5px auto 0;width:90%;max-width:1024px;box-shadow:0 0 6px #d7d7d7;background:#fff!important;z-index:1;text-align:center}@media (max-width:768px){#diamonds-direct .Privacy .contactSection{box-shadow:none}}#diamonds-direct .Privacy .contactSection .ppContactTitle{font-size:22px;margin:20px 0;font-weight:700}#diamonds-direct .Privacy .contactSection .ppContactP{margin:0 0 40px}#diamonds-direct .Privacy .policySection{padding-top:60px;transition:padding .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Privacy .policySection{padding-top:0}}#diamonds-direct .Privacy .contactSection,#diamonds-direct .Privacy .policySection{position:relative;background:#e4e5e7;overflow:auto;margin:-50px auto 0}@media (max-width:768px){#diamonds-direct .Privacy .contactSection,#diamonds-direct .Privacy .policySection{margin:0 auto}}#diamonds-direct .Privacy .contactSection .policyWrapper,#diamonds-direct .Privacy .policySection .policyWrapper{width:90%;margin:0 auto;max-width:1024px;transition:margin .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Privacy .contactSection .policyWrapper,#diamonds-direct .Privacy .policySection .policyWrapper{margin:0 auto}}#diamonds-direct .Privacy .contactSection .policyWrapper .policyPage,#diamonds-direct .Privacy .policySection .policyWrapper .policyPage{position:relative;background:#fff;box-shadow:0 0 6px #d7d7d7;overflow:auto;padding:10px 10%}#diamonds-direct .Privacy .contactSection .policyWrapper .policyPage .ppMainTitle,#diamonds-direct .Privacy .policySection .policyWrapper .policyPage .ppMainTitle{font-family:Lusitana,serif;font-size:26px;text-align:center;color:#472f51;margin:15px 0 5px}#diamonds-direct .Privacy .contactSection .policyWrapper .policyPage .ppBr,#diamonds-direct .Privacy .policySection .policyWrapper .policyPage .ppBr{margin:0 auto;width:100%}#diamonds-direct .Privacy .contactSection .policyWrapper .policyPage .ppBr img,#diamonds-direct .Privacy .policySection .policyWrapper .policyPage .ppBr img{width:100%}#diamonds-direct .Privacy .contactSection .policyWrapper .policyPage .ppSectionTitle,#diamonds-direct .Privacy .policySection .policyWrapper .policyPage .ppSectionTitle{font-family:Lusitana,serif;color:#472f51;font-size:24px;margin:20px 0 10px}#diamonds-direct .Privacy .contactSection .policyWrapper .policyPage .ppp.ppIndent,#diamonds-direct .Privacy .policySection .policyWrapper .policyPage .ppp.ppIndent{margin-left:40px}#diamonds-direct .Privacy .contactSection .policyWrapper .policyPage .ppp,#diamonds-direct .Privacy .policySection .policyWrapper .policyPage .ppp{margin:0 0 20px}#diamonds-direct .Privacy .contactSection .policyWrapper .policyPage .ppp .ppEm,#diamonds-direct .Privacy .policySection .policyWrapper .policyPage .ppp .ppEm{font-weight:700;padding-right:6px}#diamonds-direct .Privacy .contactSection .policyWrapper .policyPage .ppProvider,#diamonds-direct .Privacy .policySection .policyWrapper .policyPage .ppProvider{font-weight:700;font-size:18px;margin:0 0 10px 20px}#diamonds-direct .Privacy .contactSection .policyWrapper .policyGrey .greyMainTitle,#diamonds-direct .Privacy .policySection .policyWrapper .policyGrey .greyMainTitle{font-family:Lusitana,serif;font-size:32px;text-align:center;margin:20px 0 5px}#diamonds-direct .Privacy .contactSection .policyWrapper .policyGrey .greyBr,#diamonds-direct .Privacy .policySection .policyWrapper .policyGrey .greyBr{margin:0 auto;width:90%}#diamonds-direct .Privacy .contactSection .policyWrapper .policyGrey .greyBr img,#diamonds-direct .Privacy .policySection .policyWrapper .policyGrey .greyBr img{width:100%}#diamonds-direct .Privacy .contactSection .policyWrapper .policyGrey .greySectionTitle,#diamonds-direct .Privacy .policySection .policyWrapper .policyGrey .greySectionTitle{font-family:Lusitana,serif;font-size:28px;margin:20px 0 10px}#diamonds-direct .Privacy .contactSection .policyWrapper .policyGrey .greyP.ppIndent,#diamonds-direct .Privacy .policySection .policyWrapper .policyGrey .greyP.ppIndent{margin-left:40px}#diamonds-direct .Privacy .contactSection .policyWrapper .policyGrey .greyP,#diamonds-direct .Privacy .policySection .policyWrapper .policyGrey .greyP{margin:0 0 20px}#diamonds-direct .Privacy .contactSection .policyWrapper .policyGrey .greySubtitle,#diamonds-direct .Privacy .policySection .policyWrapper .policyGrey .greySubtitle{font-weight:700;font-size:18px;margin:0 0 10px 20px}#diamonds-direct .ProductPage .productPageWrapper{margin:0 auto;width:95%;max-width:1000px}#diamonds-direct .ProductJewelryBanner,#diamonds-direct .ProductSettingBanner{font-family:Lato,sans-serif}#diamonds-direct .ProductJewelryBanner .imageSection,#diamonds-direct .ProductSettingBanner .imageSection{position:relative;display:inline-block;vertical-align:top;width:35%}@media (max-width:768px){#diamonds-direct .ProductJewelryBanner .imageSection,#diamonds-direct .ProductSettingBanner .imageSection{display:block;width:90%;max-width:400px;margin:0 auto}}#diamonds-direct .ProductJewelryBanner .imageSection .primaryImageWrapper,#diamonds-direct .ProductSettingBanner .imageSection .primaryImageWrapper{width:100%;margin:25px 0 130px}#diamonds-direct .ProductJewelryBanner .imageSection .primaryImageWrapper img,#diamonds-direct .ProductJewelryBanner .imageSection .primaryImageWrapper video,#diamonds-direct .ProductSettingBanner .imageSection .primaryImageWrapper img,#diamonds-direct .ProductSettingBanner .imageSection .primaryImageWrapper video{max-width:100%;max-height:100%}#diamonds-direct .ProductJewelryBanner .imageSection .thumbnailsWrapper,#diamonds-direct .ProductSettingBanner .imageSection .thumbnailsWrapper{position:absolute;left:0;width:100%;height:auto;bottom:25px;text-align:center}@media (max-width:768px){#diamonds-direct .ProductJewelryBanner .imageSection .thumbnailsWrapper,#diamonds-direct .ProductSettingBanner .imageSection .thumbnailsWrapper{bottom:-125px}}#diamonds-direct .ProductJewelryBanner .imageSection .thumbnailsWrapper .thumbWrapper,#diamonds-direct .ProductSettingBanner .imageSection .thumbnailsWrapper .thumbWrapper{position:relative;display:inline-block;vertical-align:top;margin:0 5px;width:calc(16.66% - 10px);cursor:pointer}#diamonds-direct .ProductJewelryBanner .imageSection .thumbnailsWrapper .thumbWrapper img,#diamonds-direct .ProductSettingBanner .imageSection .thumbnailsWrapper .thumbWrapper img{width:100%}#diamonds-direct .ProductJewelryBanner .imageSection .thumbnailsWrapper .thumbWrapper .playWrapper,#diamonds-direct .ProductSettingBanner .imageSection .thumbnailsWrapper .thumbWrapper .playWrapper{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;color:#5e5e5e;line-height:1;opacity:.7;font-size:28px;transition:opacity .25s ease-in-out 0ms}#diamonds-direct .ProductJewelryBanner .imageSection .thumbnailsWrapper .thumbWrapper:hover .playWrapper,#diamonds-direct .ProductSettingBanner .imageSection .thumbnailsWrapper .thumbWrapper:hover .playWrapper{opacity:1}#diamonds-direct .ProductJewelryBanner .descriptionSection,#diamonds-direct .ProductSettingBanner .descriptionSection{position:relative;display:inline-block;vertical-align:top;width:calc(65% - 20px);margin:0 0 25px 20px;text-align:center;color:#5e5e5e}@media (max-width:768px){#diamonds-direct .ProductJewelryBanner .descriptionSection,#diamonds-direct .ProductSettingBanner .descriptionSection{display:block;width:90%;margin:20px auto}}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingTitle,#diamonds-direct .ProductSettingBanner .descriptionSection .settingTitle{font-family:Lusitana,serif;font-size:26px;margin:30px 0;text-transform:uppercase}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingDescription,#diamonds-direct .ProductSettingBanner .descriptionSection .settingDescription{font-size:18px;font-weight:300;margin:0 auto 30px;color:#707070;width:80%}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingRoyalTNotice,#diamonds-direct .ProductSettingBanner .descriptionSection .settingRoyalTNotice{margin:0 0 15px;font-size:13px;font-weight:700;color:#4b2d53}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper{margin:0 0 10px}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .configError,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .configError{margin:0 0 5px;font-size:14px;color:#eb3533}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .singleOption.metalTypeOptions,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .singleOption.metalTypeOptions{border-right:none}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions{position:relative;display:inline-block;vertical-align:top;padding:15px 15px 12px;width:calc(49% - 31px);border-right:1px solid #5e5e5e;text-align:right}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType{position:relative;display:inline-block;vertical-align:top;margin:0 5px;width:24px;height:24px;border-radius:50%;cursor:pointer}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType .settingMetalTypeHole,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType .settingMetalTypeHole{position:absolute;top:2px;left:2px;right:2px;bottom:2px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-size:10px}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType .open.metalTypeBody,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType .open.metalTypeBody{max-height:200px}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType .metalTypeBody,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType .metalTypeBody{position:absolute;top:calc(100% + 5px);left:-5px;width:120px;height:auto;max-height:0;background:#fff;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType .metalTypeBody .metalTypeBodyWrapper,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType .metalTypeBody .metalTypeBodyWrapper{padding:0 5px;border:1px solid #5e5e5e}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType .metalTypeBody .metalTypeBodyWrapper .metalTypeItem,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .settingMetalType .metalTypeBody .metalTypeBodyWrapper .metalTypeItem{text-align:left;text-transform:uppercase;padding:5px 0;font-size:16px;font-weight:400}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal1.settingMetalType,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal1.settingMetalType{border:4px solid #d9d9d9}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal1.settingMetalType .settingMetalTypeHole,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal1.settingMetalType .settingMetalTypeHole{background:#d9d9d9}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal2.settingMetalType,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal2.settingMetalType{border:4px solid #f4de95}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal2.settingMetalType .settingMetalTypeHole,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal2.settingMetalType .settingMetalTypeHole{font-size:14px;color:#f4de95;background:#fff}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal3.settingMetalType,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal3.settingMetalType{border:4px solid #e7b79e}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal3.settingMetalType .settingMetalTypeHole,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal3.settingMetalType .settingMetalTypeHole{font-size:14px;color:#e7b79e;background:#fff}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal4.settingMetalType,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal4.settingMetalType{border:4px solid #ebebeb}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal4.settingMetalType .settingMetalTypeHole,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .metalTypeOptions .metal4.settingMetalType .settingMetalTypeHole{font-size:14px;color:#ebebeb;background:#fff}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .ringSizeSelect,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .ringSizeSelect{position:relative;display:inline-block;vertical-align:top;width:calc(49% - 30px);padding:15px 15px 12px;text-align:left}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .ringSizeSelect .ringSizeDisplay,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .ringSizeSelect .ringSizeDisplay{position:relative;display:inline-block;width:auto;overflow:auto;cursor:pointer}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .ringSizeSelect .ringSizeDisplay .ringSizeLabel,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .ringSizeSelect .ringSizeDisplay .ringSizeLabel{display:inline-block;width:auto;font-size:22px;font-weight:100;text-transform:uppercase;margin:0 30px 0 0}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .ringSizeSelect .ringSizeDisplay .ringSizeIcon,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .ringSizeSelect .ringSizeDisplay .ringSizeIcon{position:absolute;top:3px;right:0;height:20px;width:20px}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingConfigWrapper .ringSizeSelect .ringSizeDisplay .ringSizeIcon img,#diamonds-direct .ProductSettingBanner .descriptionSection .settingConfigWrapper .ringSizeSelect .ringSizeDisplay .ringSizeIcon img{width:100%}#diamonds-direct .ProductJewelryBanner .descriptionSection .priceWrapper,#diamonds-direct .ProductSettingBanner .descriptionSection .priceWrapper{margin:0;font-family:Lusitana,serif}#diamonds-direct .ProductJewelryBanner .descriptionSection .priceWrapper .priceSign,#diamonds-direct .ProductSettingBanner .descriptionSection .priceWrapper .priceSign{display:inline-block;vertical-align:top;font-size:18px;width:auto;margin:5px 0 0}#diamonds-direct .ProductJewelryBanner .descriptionSection .priceWrapper .priceValue,#diamonds-direct .ProductSettingBanner .descriptionSection .priceWrapper .priceValue{display:inline-block;vertical-align:top;font-size:48px;width:auto}#diamonds-direct .ProductJewelryBanner .descriptionSection .settingPriceNotice.priceNotice,#diamonds-direct .ProductSettingBanner .descriptionSection .settingPriceNotice.priceNotice{font-size:16px;font-weight:400;color:#4b2d53}#diamonds-direct .ProductJewelryBanner .descriptionSection .priceNotice,#diamonds-direct .ProductSettingBanner .descriptionSection .priceNotice{margin:0 0 25px;font-size:12px;font-weight:300;letter-spacing:-.5px}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsInCart,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsInCart{position:relative;margin:0 auto 60px;width:260px;height:30px;border:1px solid #4b2d53;color:#fff;background:#4b2d53;font-size:14px;text-transform:uppercase;font-weight:700}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsInCart div,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsInCart div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper{position:relative;margin:0 0 30px;height:30px;overflow:visible}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper .nextStepsElement,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper .nextStepsElement{position:relative;border:1px solid #5e5e5e;width:260px;margin:0 auto;cursor:pointer;background:#fff;z-index:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead{position:relative}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsLabel,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsLabel{padding:5px 0;font-size:20px;font-weight:300;text-transform:uppercase}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon{position:absolute;top:8px;right:5px;width:30px;height:12px}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon img,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon img{height:100%}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper .nextStepsElement .open.nextStepsBody,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper .nextStepsElement .open.nextStepsBody{max-height:200px}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody{max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper{margin:0 10px 10px;padding:10px 0 0;border-top:1px solid #5e5e5e}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem{text-align:left;text-transform:uppercase;padding:5px 0;font-size:16px;font-weight:400}#diamonds-direct .ProductJewelryBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem:hover,#diamonds-direct .ProductSettingBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem:hover{background:#eee}#diamonds-direct .ProductJewelryBanner .descriptionSection .shippingInfoWrapper,#diamonds-direct .ProductSettingBanner .descriptionSection .shippingInfoWrapper{font-size:13px;font-weight:300;margin:0 0 30px}#diamonds-direct .ProductJewelryBanner .descriptionSection .shippingInfoWrapper .shippingContactLine,#diamonds-direct .ProductSettingBanner .descriptionSection .shippingInfoWrapper .shippingContactLine{margin:0 0 10px}#diamonds-direct .ProductJewelryBanner .descriptionSection .shippingInfoWrapper .clickableText,#diamonds-direct .ProductSettingBanner .descriptionSection .shippingInfoWrapper .clickableText{color:#4b2d53;cursor:pointer;font-weight:400}#diamonds-direct .ProductJewelryBanner .descriptionSection .shippingInfoWrapper .clickableText:hover,#diamonds-direct .ProductSettingBanner .descriptionSection .shippingInfoWrapper .clickableText:hover{text-decoration:underline}#diamonds-direct .ProductJewelryBanner .descriptionSection .actionsWrapper,#diamonds-direct .ProductSettingBanner .descriptionSection .actionsWrapper{margin:0}#diamonds-direct .ProductJewelryBanner .descriptionSection .actionsWrapper .actionItem,#diamonds-direct .ProductSettingBanner .descriptionSection .actionsWrapper .actionItem{display:inline-block;vertical-align:top;width:auto;margin:0 10px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .ProductJewelryBanner .descriptionSection .actionsWrapper .actionItem .actionIcon.hint img,#diamonds-direct .ProductSettingBanner .descriptionSection .actionsWrapper .actionItem .actionIcon.hint img{margin:4px 0 0}#diamonds-direct .ProductJewelryBanner .descriptionSection .actionsWrapper .actionItem .actionIcon,#diamonds-direct .ProductSettingBanner .descriptionSection .actionsWrapper .actionItem .actionIcon{display:inline-block;vertical-align:top;width:15px;margin:0 5px 0 0}#diamonds-direct .ProductJewelryBanner .descriptionSection .actionsWrapper .actionItem .actionIcon img,#diamonds-direct .ProductSettingBanner .descriptionSection .actionsWrapper .actionItem .actionIcon img{margin:2px 0 0;width:100%;vertical-align:top}#diamonds-direct .ProductJewelryBanner .descriptionSection .actionsWrapper .actionItem .actionLabel,#diamonds-direct .ProductSettingBanner .descriptionSection .actionsWrapper .actionItem .actionLabel{display:inline-block;vertical-align:top;width:auto;font-size:12px;font-weight:300;text-transform:uppercase;letter-spacing:-.5px}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs.expanded,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs.expanded{max-height:400px}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs{display:block;overflow:hidden;height:auto;max-height:0;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .noWishlistPrompt,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .noWishlistPrompt{text-align:center}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .noWishlistPrompt .nwText,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .noWishlistPrompt .nwText{padding:8px 0;font-size:20px;font-weight:300}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .noWishlistPrompt .nwButton,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .noWishlistPrompt .nwButton{font-size:16px;font-weight:700;color:#4b2d53;cursor:pointer}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt{text-align:center}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .wlPrompt,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .wlPrompt{margin:0 0 10px;color:#eb3533;font-size:14px;text-align:center}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .selectPrompt,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .selectPrompt{margin:20px 0 5px;text-align:center;font-size:14px}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .wishlistDropdownLoading,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .wishlistDropdownLoading{position:relative;margin:0 auto 20px;width:200px;height:40px}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .wishlistDropdownLoading div,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .wishlistDropdownLoading div{position:absolute;top:0;right:0;left:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .selectWrapper,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .selectWrapper{margin:0 auto 20px;width:200px}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .selectButtonWrapper,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .selectButtonWrapper{position:relative;display:inline-block;vertical-align:top;color:#fff;background:#4b2d53;width:200px;height:36px;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .selectButtonWrapper:hover,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .selectButtonWrapper:hover{background:#623b6c}#diamonds-direct .ProductJewelryBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .selectButtonWrapper div,#diamonds-direct .ProductSettingBanner .descriptionSection .wishlistConfigs .selectWishlistPrompt .selectButtonWrapper div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .ProductDiamondBanner{font-family:Lato,sans-serif}#diamonds-direct .ProductDiamondBanner .imageSection{position:relative;display:inline-block;vertical-align:top;width:35%}@media (max-width:768px){#diamonds-direct .ProductDiamondBanner .imageSection{display:block;width:90%;max-width:400px;margin:0 auto}}#diamonds-direct .ProductDiamondBanner .imageSection .primaryImageWrapper{width:100%;margin:50px 0 100px;text-align:center}#diamonds-direct .ProductDiamondBanner .imageSection .primaryImageWrapper img{max-width:80%;max-height:80%}#diamonds-direct .ProductDiamondBanner .imageSection .thumbnailsWrapper{position:absolute;left:0;width:100%;height:auto;bottom:25px;text-align:center}@media (max-width:768px){#diamonds-direct .ProductDiamondBanner .imageSection .thumbnailsWrapper{bottom:-75px}}#diamonds-direct .ProductDiamondBanner .imageSection .thumbnailsWrapper .thumbWrapper{display:inline-block;vertical-align:top;margin:0 5px;width:calc(16.66% - 10px);cursor:pointer}#diamonds-direct .ProductDiamondBanner .imageSection .thumbnailsWrapper .thumbWrapper img{width:100%}#diamonds-direct .ProductDiamondBanner .descriptionSection{position:relative;display:inline-block;vertical-align:top;width:calc(65% - 20px);margin:0 0 25px 20px;text-align:center;color:#5e5e5e}@media (max-width:768px){#diamonds-direct .ProductDiamondBanner .descriptionSection{display:block;width:90%;margin:20px auto}}#diamonds-direct .ProductDiamondBanner .descriptionSection .diamondTitle{font-family:Lusitana,serif;font-size:26px;margin:80px 0 30px;text-transform:uppercase}@media (max-width:768px){#diamonds-direct .ProductDiamondBanner .descriptionSection .diamondTitle{margin-bottom:10px}}#diamonds-direct .ProductDiamondBanner .descriptionSection .priceWrapper{margin:0;font-family:Lusitana,serif}#diamonds-direct .ProductDiamondBanner .descriptionSection .priceWrapper .priceSign{display:inline-block;vertical-align:top;font-size:18px;width:auto;margin:5px 0 0}#diamonds-direct .ProductDiamondBanner .descriptionSection .priceWrapper .priceValue{display:inline-block;vertical-align:top;font-size:48px;width:auto}#diamonds-direct .ProductDiamondBanner .descriptionSection .priceNotice{margin:0 0 25px;font-size:12px;font-weight:300;letter-spacing:-.5px}#diamonds-direct .ProductDiamondBanner .descriptionSection .oosNotice{font-weight:700;color:#eb3533;margin:20px 0}#diamonds-direct .ProductDiamondBanner .descriptionSection .oosNotice .oosLink{cursor:pointer;text-decoration:underline;transition:color .25s ease-in-out 0ms}#diamonds-direct .ProductDiamondBanner .descriptionSection .oosNotice .oosLink:hover{color:#8d1f1e}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsInCart{position:relative;margin:0 auto 60px;width:260px;height:30px;border:1px solid #4b2d53;color:#fff;background:#4b2d53;font-size:14px;text-transform:uppercase;font-weight:700}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsInCart div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper{position:relative;margin:0 0 60px;height:30px;overflow:visible}@media (max-width:768px){#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper{margin-bottom:20px}}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper .nextStepsElement{position:relative;border:1px solid #5e5e5e;width:260px;margin:0 auto;cursor:pointer;background:#fff;z-index:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead{position:relative}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsLabel{padding:5px 0;font-size:20px;font-weight:300;text-transform:uppercase}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon{position:absolute;top:8px;right:5px;width:30px;height:12px}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsHead .nextStepsIcon img{height:100%}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper .nextStepsElement .open.nextStepsBody{max-height:200px}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody{max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper{margin:0 10px 10px;padding:10px 0 0;border-top:1px solid #5e5e5e}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem{text-align:left;text-transform:uppercase;padding:5px 0;font-size:16px;font-weight:400}#diamonds-direct .ProductDiamondBanner .descriptionSection .nextStepsWrapper .nextStepsElement .nextStepsBody .nextStepsBodyWrapper .nextStepsItem:hover{background:#eee}#diamonds-direct .ProductDiamondBanner .descriptionSection .shippingInfoWrapper{font-size:13px;font-weight:300;margin:0 0 30px}#diamonds-direct .ProductDiamondBanner .descriptionSection .shippingInfoWrapper .shippingContactLine{margin:0 0 10px}#diamonds-direct .ProductDiamondBanner .descriptionSection .shippingInfoWrapper .clickableText{color:#4b2d53;cursor:pointer;font-weight:400}#diamonds-direct .ProductDiamondBanner .descriptionSection .shippingInfoWrapper .clickableText:hover{text-decoration:underline}#diamonds-direct .ProductDiamondBanner .descriptionSection .actionsWrapper{margin:0}#diamonds-direct .ProductDiamondBanner .descriptionSection .actionsWrapper .actionItem{display:inline-block;vertical-align:top;width:auto;margin:0 10px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .ProductDiamondBanner .descriptionSection .actionsWrapper .actionItem .actionIcon.hint img{margin:4px 0 0}#diamonds-direct .ProductDiamondBanner .descriptionSection .actionsWrapper .actionItem .actionIcon{display:inline-block;vertical-align:top;width:15px;margin:0 5px 0 0}#diamonds-direct .ProductDiamondBanner .descriptionSection .actionsWrapper .actionItem .actionIcon img{margin:2px 0 0;width:100%;vertical-align:top}#diamonds-direct .ProductDiamondBanner .descriptionSection .actionsWrapper .actionItem .actionLabel{display:inline-block;vertical-align:top;width:auto;font-size:12px;font-weight:300;text-transform:uppercase;letter-spacing:-.5px}#diamonds-direct .ProductDetails{position:relative;color:#5e5e5e;border-top:1px solid #5e5e5e}#diamonds-direct .ProductDetails .detailsHeader{position:relative;margin:10px 25px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .ProductDetails .detailsHeader .headerLabel{font-size:24px}#diamonds-direct .ProductDetails .detailsHeader .headerIcon{position:absolute;top:-2px;right:0;bottom:0;width:25px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-family:Lato,sans-serif;font-size:32px;font-weight:300}#diamonds-direct .ProductDetails .expanded.detailsBody{max-height:500px}#diamonds-direct .ProductDetails .detailsBody{font-family:Lato,sans-serif;height:auto;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms;text-align:center}#diamonds-direct .ProductDetails .detailsBody .detailSettingDiagram{display:inline-block;vertical-align:top;width:35%;margin:0 0 25px 10%}#diamonds-direct .ProductDetails .detailsBody .detailSettingDiagram img{width:100%}#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper.settingDetail{width:50%}#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper{display:inline-block;vertical-align:top;width:100%;margin:20px 0}#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper .diamondDetail.detailItem .detailLabel{width:40%;margin:0}@media (max-width:768px){#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper .diamondDetail.detailItem .detailLabel{width:50%}}#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper .diamondDetail.detailItem .detailValue{width:60%;margin:0}@media (max-width:768px){#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper .diamondDetail.detailItem .detailValue{width:50%}}#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper .settingDetail.detailItem{width:65%}#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper .detailItem{display:inline-block;vertical-align:top;width:35%;margin:0 10px 10px;text-align:left;font-size:16px}@media (max-width:768px){#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper .detailItem{width:80%}}#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper .detailItem .detailLabel{width:auto;display:inline-block;vertical-align:top;font-weight:400;margin:0 10px 0 0}#diamonds-direct .ProductDetails .detailsBody .detailBodyWrapper .detailItem .detailValue{width:auto;display:inline-block;vertical-align:top;font-weight:300}#diamonds-direct .ProductDiamondCarat{position:relative;color:#5e5e5e;border-top:1px solid #5e5e5e}#diamonds-direct .ProductDiamondCarat .caratHeader{position:relative;margin:10px 25px}#diamonds-direct .ProductDiamondCarat .caratHeader .headerLabel{font-size:24px}#diamonds-direct .ProductDiamondCarat .caratHeader .headerIcon{position:absolute;top:-2px;right:0;bottom:0;width:25px;cursor:pointer;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-family:Lato,sans-serif;font-size:32px;font-weight:300}#diamonds-direct .ProductDiamondCarat .expanded.caratBodyWrapper{max-height:500px}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper{text-align:center;font-family:Lato,sans-serif;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .handSection{display:inline-block;vertical-align:top;width:40%}@media (max-width:768px){#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .handSection{width:80%;max-width:250px;margin-right:0 auto}}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .handSection .handImgWrapper{position:relative;margin:0 0 0 25%}@media (max-width:768px){#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .handSection .handImgWrapper{margin:0}}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .handSection .handImgWrapper img{width:100%}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .handSection .handImgWrapper .diamondImgWrapper{position:absolute}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .sliderSection{display:inline-block;vertical-align:top;width:60%}@media (max-width:768px){#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .sliderSection{width:80%;max-width:400px;margin-right:0 auto}}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .sliderSection .caratSliderWrapper{position:relative;margin:15% auto 0;width:90%;height:18px;max-width:600px;overflow:auto}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .sliderSection .caratSliderWrapper .caratSliderTrack{position:absolute;top:calc(50% - 1.5px);height:6px;width:100%;background:#d3d3d3;border-radius:3px}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .sliderSection .caratSliderWrapper .caratSliderElement{position:absolute;top:calc(50% - 6.75px);width:9px;height:9px;border:3px solid #792575;border-radius:50%;background:#fff}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .sliderSection .caratSliderLabelWrapper{position:relative;margin:0 auto;width:90%;max-width:600px;overflow:auto;font-size:14px}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .sliderSection .caratSliderLabelWrapper .labelLeft{text-align:left}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .sliderSection .caratSliderLabelWrapper .labelCurrent{position:absolute;top:0;width:50px;bottom:0;text-align:center}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .sliderSection .caratSliderLabelWrapper .labelRight{position:absolute;top:0;width:50px;bottom:0;right:0;text-align:right}#diamonds-direct .ProductDiamondCarat .caratBodyWrapper .sliderSection .caratTextWrapper{text-align:left;margin:50px 50px 25px;font-size:18px;font-weight:300}#diamonds-direct .ProductSimilarSetting{position:relative;color:#5e5e5e;border-top:1px solid #5e5e5e;font-family:Lato,sans-serif}#diamonds-direct .ProductSimilarSetting .productSimilarTitle{margin:25px;font-size:18px;font-weight:700;text-transform:uppercase}#diamonds-direct .ProductSimilarSetting .productSimilarRefresh{position:absolute;top:25px;right:25px;width:20px;height:20px;cursor:pointer}#diamonds-direct .ProductSimilarSetting .productSimilarRefresh img{width:100%;transition:transform .4s ease-in-out 0ms}#diamonds-direct .ProductSimilarSetting .productSimilarRefresh:hover img{transform:rotate(180deg)}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper{text-align:center}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper{margin:0 10px 15px;display:inline-block;width:calc(30% - 20px)}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper .settingItemInnerWrapper .settingImageWrapper{height:160px;text-align:center}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper .settingItemInnerWrapper .settingImageWrapper img{height:100%}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper{height:90px;margin:-10px 0 0}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingTitleWrapper{display:block;position:relative;height:40px;width:90%;margin:0 auto;font-weight:400;font-size:17px;text-align:center;color:#5e5e5e;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingTitleWrapper div{position:absolute;left:0;right:0;bottom:0;height:auto;overflow:hidden}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingPrice{text-align:center;width:35%;margin:10px auto;padding:10px 0;border-top:2px solid #563a5f;font-size:18px;font-weight:300}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper .settingItemInnerWrapper .settingItemButtonWrapper{height:25px}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper .settingItemInnerWrapper .settingItemButtonWrapper .itemButton{width:120px}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper .settingItemInnerWrapper .settingItemButtonWrapper .productSimilarButton{border:1px solid #5e5e5e;background:#fff;margin:0 auto;padding:3px 0;font-size:14px;text-transform:uppercase;text-align:center;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .ProductSimilarSetting .productSimilarWrapper .settingItemWrapper .settingItemInnerWrapper .settingItemButtonWrapper .productSimilarButton:hover{color:#fff;background:#563a5f;border:1px solid #563a5f}#diamonds-direct .ProductSimilarDiamond{position:relative;color:#5e5e5e;border-top:1px solid #5e5e5e;font-family:Lato,sans-serif}#diamonds-direct .ProductSimilarDiamond .productSimilarTitle{margin:25px;font-size:18px;font-weight:700;text-transform:uppercase}#diamonds-direct .ProductSimilarDiamond .productSimilarRefresh{position:absolute;top:25px;right:25px;width:20px;height:20px;cursor:pointer}#diamonds-direct .ProductSimilarDiamond .productSimilarRefresh img{width:100%;transition:transform .4s ease-in-out 0ms}#diamonds-direct .ProductSimilarDiamond .productSimilarRefresh:hover img{transform:rotate(180deg)}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper{text-align:center;margin:0 0 20px}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper{margin:0 10px 15px;display:inline-block;width:calc(30% - 20px)}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper .diamondItemInnerWrapper .diamondImageWrapper{height:160px;text-align:center}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper .diamondItemInnerWrapper .diamondImageWrapper img{height:100%}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper{height:90px;margin:-10px 0 0}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondTitleWrapper{display:block;position:relative;height:40px;width:90%;margin:0 auto;font-weight:400;font-size:17px;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondTitleWrapper div{position:absolute;left:0;right:0;bottom:0;height:auto;overflow:hidden}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper .diamondItemInnerWrapper .diamondInfoWrapper .diamondPrice{text-align:center;width:35%;margin:10px auto;padding:10px 0;font-size:18px;font-weight:400;color:#4b2d53}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper .diamondItemInnerWrapper .diamondItemButtonWrapper{height:25px}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper .diamondItemInnerWrapper .diamondItemButtonWrapper .itemButton{width:150px}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper .diamondItemInnerWrapper .diamondItemButtonWrapper .productSimilarButton{border:1px solid #707070;background:#fff;margin:0 auto;padding:3px 0;font-size:12px;text-transform:uppercase;text-align:center;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms,border .25s ease-in-out 0ms}#diamonds-direct .ProductSimilarDiamond .productSimilarWrapper .diamondItemWrapper .diamondItemInnerWrapper .diamondItemButtonWrapper .productSimilarButton:hover{color:#fff;background:#563a5f;border:1px solid #563a5f}#diamonds-direct .ProductSettingPairs{position:relative;color:#5e5e5e;border-top:1px solid #5e5e5e;font-family:Lato,sans-serif}#diamonds-direct .ProductSettingPairs .productPairsHeader{position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .ProductSettingPairs .productPairsHeader .productPairsTitle{margin:25px;font-size:18px;font-weight:700;text-transform:uppercase}#diamonds-direct .ProductSettingPairs .productPairsHeader .headerIcon{position:absolute;top:-2px;right:25px;bottom:0;width:25px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-family:Lato,sans-serif;font-size:32px;font-weight:300}#diamonds-direct .ProductSettingPairs .expanded.productPairsWrapper{max-height:500px}#diamonds-direct .ProductSettingPairs .productPairsWrapper{height:auto;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .ProductSettingPairs .productPairsWrapper .settingItemWrapper{margin:0 10px 15px;display:inline-block;width:calc(30% - 20px);cursor:pointer}#diamonds-direct .ProductSettingPairs .productPairsWrapper .settingItemWrapper .settingItemInnerWrapper .settingImageWrapper{height:160px;text-align:center}#diamonds-direct .ProductSettingPairs .productPairsWrapper .settingItemWrapper .settingItemInnerWrapper .settingImageWrapper img{height:100%}#diamonds-direct .ProductSettingPairs .productPairsWrapper .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper{height:90px;margin:-10px 0 0}#diamonds-direct .ProductSettingPairs .productPairsWrapper .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingTitleWrapper{display:block;position:relative;height:40px;width:90%;margin:0 auto;font-weight:400;font-size:17px;text-align:center;color:#5e5e5e;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#diamonds-direct .ProductSettingPairs .productPairsWrapper .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingTitleWrapper div{position:absolute;left:0;right:0;bottom:0;height:auto;overflow:hidden}#diamonds-direct .ProductSettingPairs .productPairsWrapper .settingItemWrapper .settingItemInnerWrapper .settingInfoWrapper .settingPrice{text-align:center;width:35%;margin:0 auto;padding:10px 0;font-size:18px;font-weight:400;color:#4b2d53}#diamonds-direct .ProductDiamondsDirectDifference{position:relative;background:#f4f5f7;text-align:center;overflow:auto;color:#5e5e5e}#diamonds-direct .ProductDiamondsDirectDifference .differenceTitle{font-size:26px;margin:15px 0 5px;text-transform:uppercase;color:#4b2d53}#diamonds-direct .ProductDiamondsDirectDifference .differenceBrWrapper{width:95%;margin:0 auto}#diamonds-direct .ProductDiamondsDirectDifference .differenceBrWrapper img{width:100%}#diamonds-direct .ProductDiamondsDirectDifference .differencesWrapper{margin:20px auto;width:90%;text-align:center}#diamonds-direct .ProductDiamondsDirectDifference .differencesWrapper .differenceItem{margin:0 8px;width:calc(20% - 16px);display:inline-block;vertical-align:top}@media (max-width:768px){#diamonds-direct .ProductDiamondsDirectDifference .differencesWrapper .differenceItem{width:calc(50% - 16px);margin-bottom:10px}}@media (max-width:600px){#diamonds-direct .ProductDiamondsDirectDifference .differencesWrapper .differenceItem{width:calc(80% - 16px)}}#diamonds-direct .ProductDiamondsDirectDifference .differencesWrapper .differenceItem .differenceIcon{height:35px}#diamonds-direct .ProductDiamondsDirectDifference .differencesWrapper .differenceItem .differenceIcon img{height:100%}#diamonds-direct .ProductDiamondsDirectDifference .differencesWrapper .differenceItem .differenceItemTitle{margin:10px auto 0;color:#4b2d53;font-size:18px;width:90%;height:36px;line-height:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#diamonds-direct .ProductDiamondsDirectDifference .differencesWrapper .differenceItem .differenceText{font-family:Lato,sans-serif;margin:10px auto 0;width:95%;font-size:13px;font-weight:400;line-height:1.6}#diamonds-direct .ProductSocial{position:relative;color:#5e5e5e;text-align:center}#diamonds-direct .ProductSocial .socialTitle{font-size:22px;margin:40px 0 25px}#diamonds-direct .ProductSocial .socialImagesWrapper{margin:0 0 25px}#diamonds-direct .ProductSocial .socialImagesWrapper .socialImagesInnerWrapper{margin:0 auto;width:95%}#diamonds-direct .ProductSocial .socialImagesWrapper .socialImagesInnerWrapper .socialItem{display:inline-block;vertical-align:top;margin:0 5px;width:calc(20% - 10px);padding-bottom:calc(20% - 10px);cursor:pointer;background-repeat:no-repeat;background-position:50%;background-size:cover}#diamonds-direct .ProductSocial .socialImagesWrapper .socialImagesInnerWrapper .socialImage1{background-image:url(\"https://ddw2.diamondsdirect.com/img/productpage/social/social31h.png\")}#diamonds-direct .ProductSocial .socialImagesWrapper .socialImagesInnerWrapper .socialImage2{background-image:url(\"https://ddw2.diamondsdirect.com/img/productpage/social/social32h.png\")}#diamonds-direct .ProductSocial .socialImagesWrapper .socialImagesInnerWrapper .socialImage3{background-image:url(\"https://ddw2.diamondsdirect.com/img/productpage/social/social33h.png\")}#diamonds-direct .ProductSocial .socialImagesWrapper .socialImagesInnerWrapper .socialImage4{background-image:url(\"https://ddw2.diamondsdirect.com/img/productpage/social/social29h.png\")}#diamonds-direct .ProductSocial .socialImagesWrapper .socialImagesInnerWrapper .socialImage5{background-image:url(\"https://ddw2.diamondsdirect.com/img/productpage/social/social30h.png\")}#diamonds-direct .productSelect select{border:1px solid #ddd}#diamonds-direct .Holiday2019{overflow:auto;background:#133d35;font-family:Lato,sans-serif}#diamonds-direct .Holiday2019 .promoBanner{width:100%;position:relative}#diamonds-direct .Holiday2019 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBanner img.desktop600{display:none}}#diamonds-direct .Holiday2019 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBanner img.mobile600{display:block}}#diamonds-direct .Holiday2019 .preBoxText{margin:-25px auto 25px;color:#fff;position:relative;z-index:1;text-align:center;max-width:1000px;padding:0 5%}#diamonds-direct .Holiday2019 .preBoxText .holidayTextLarge{font-size:22px;font-weight:300;margin:0 auto 15px}@media (max-width:768px){#diamonds-direct .Holiday2019 .preBoxText .holidayTextLarge{font-size:18px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .preBoxText .holidayTextLarge{font-size:16px}}#diamonds-direct .Holiday2019 .preBoxText .notabutton{font-size:32px;font-weight:700;margin:0 auto 25px;border-bottom:1px solid #fff;width:90%;max-width:800px}@media (max-width:768px){#diamonds-direct .Holiday2019 .preBoxText .notabutton{font-size:32px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .preBoxText .notabutton{font-size:32px}}#diamonds-direct .Holiday2019 .preBoxText .holidayText{font-size:22px;font-weight:700;margin:0 auto 25px}@media (max-width:768px){#diamonds-direct .Holiday2019 .preBoxText .holidayText{font-size:18px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .preBoxText .holidayText{font-size:16px}}#diamonds-direct .Holiday2019 .preBoxText .holidayTextAgain{font-size:22px;font-weight:300;margin:0 auto 25px}@media (max-width:768px){#diamonds-direct .Holiday2019 .preBoxText .holidayTextAgain{font-size:18px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .preBoxText .holidayTextAgain{font-size:16px}}#diamonds-direct .Holiday2019 .preBoxText .holidayPercent{font-size:36px;font-weight:700;margin:0 auto 25px;text-transform:uppercase}@media (max-width:768px){#diamonds-direct .Holiday2019 .preBoxText .holidayPercent{font-size:32px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .preBoxText .holidayPercent{font-size:32px}}#diamonds-direct .Holiday2019 .preBoxText .holidayTextOnceMore{color:#fff;font-size:24px;font-weight:300;margin:0 auto 25px}@media (max-width:768px){#diamonds-direct .Holiday2019 .preBoxText .holidayTextOnceMore{font-size:18px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .preBoxText .holidayTextOnceMore{font-size:16px}}#diamonds-direct .Holiday2019 .preBoxText .holidayTextForTheFifthTimeInADifferentStyleWhyGodWhy{font-size:22px;font-weight:400;margin:0 auto 15px}@media (max-width:768px){#diamonds-direct .Holiday2019 .preBoxText .holidayTextForTheFifthTimeInADifferentStyleWhyGodWhy{font-size:24px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .preBoxText .holidayTextForTheFifthTimeInADifferentStyleWhyGodWhy{font-size:22px}}#diamonds-direct .Holiday2019 .promoBody{margin:0}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBody{margin:0}}#diamonds-direct .Holiday2019 .promoBodyInner{position:relative;background:#133d35;color:#fff;border:1px solid #fff;text-align:center;overflow:auto;margin:0 auto 40px;width:80%;max-width:900px}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBodyInner{width:90%}}#diamonds-direct .Holiday2019 .promoBodyInner .promoText{margin:30px 10% 0;padding:20px 25px;font-weight:400;font-size:22px;color:#4d4d4e;font-family:Lato,sans-serif}@media (max-width:768px){#diamonds-direct .Holiday2019 .promoBodyInner .promoText{font-size:16px;padding:20px}}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBodyInner .promoText{margin:15px 5% 0;font-size:16px;padding:10px 5px}}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock{margin:25px 100px;font-family:Lato,sans-serif}@media (max-width:1200px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock{margin:25px 90px}}@media (max-width:1024px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock{margin:25px 45px}}@media (max-width:900px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock{margin:25px}}@media (max-width:768px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock{margin:25px 0 0}}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock{margin:10px 0}}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem.doubleLine .springDates{height:50px}@media (max-width:900px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem.doubleLine .springDates{height:40px}}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem.doubleLine .springLocations{height:50px}@media (max-width:900px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem.doubleLine .springLocations{height:40px}}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem{display:block;margin:0 0 20px;overflow:hidden}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates.pastDate{color:hsla(0,0%,100%,.5)}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{position:relative;display:inline-block;width:130px;padding:0;height:75px;text-align:right;border-right:3px solid #229943;vertical-align:top;font-size:22px}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates .desktopOnly{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;text-align:right;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:center;align-items:center}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates .desktopOnly{display:none}}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates .mobileOnly{position:absolute;top:0;right:0;bottom:0;left:0;display:none;text-align:center;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates .mobileOnly{display:-ms-flexbox;display:flex}}@media (max-width:900px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{width:150px;padding:0;height:60px;line-height:50px}}@media (max-width:768px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{font-size:18px;width:95px;padding:0 7px 0 0}}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springDates{font-size:20px;width:150px;padding:0;border-right:none;border-bottom:2px solid #229943;height:35px;margin:0 0 10px}}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations.pastDate .holiday-location-link{color:hsla(0,0%,100%,.5)}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{display:inline-block;width:calc(100% - 160px);height:60px;line-height:23px;vertical-align:top;text-align:left;padding:0 0 0 20px}@media (max-width:900px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{padding:0 0 0 10px;line-height:18px;width:calc(100% - 175px)}}@media (max-width:768px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{padding:0 0 0 5px;font-size:18px;width:calc(100% - 150px)}}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{padding:0;line-height:19px;width:100%;text-align:center}}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{text-decoration:none;color:#fff;cursor:pointer;font-size:20px;transition:color .25s ease-in-out 0ms}@media (max-width:900px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:18px}}@media (max-width:768px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:16px}}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:13px}}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link:hover{color:#e7faed}#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{color:#229943;font-weight:700;font-size:22px}@media (max-width:900px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:20px}}@media (max-width:768px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:18px}}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:14px}}#diamonds-direct .Holiday2019 .footerButton{margin:0 0 25px}#diamonds-direct .Holiday2019 .footerButton .onlineButton{width:240px;height:40px;font-weight:700;position:relative;margin:0 auto;line-height:1;font-size:20px;text-transform:uppercase;color:#fff;border:1px solid #fff;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Holiday2019 .footerButton .onlineButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;text-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#diamonds-direct .Holiday2019 .footerButton .onlineButton:hover{color:#133d35;background:#fff}#diamonds-direct .Holiday2019 .footerText1{font-size:40px;text-transform:uppercase;margin:0 auto;color:#fff;text-align:center;padding:0 5%;font-size:700}@media (max-width:768px){#diamonds-direct .Holiday2019 .footerText1{font-size:32px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .footerText1{font-size:28px}}#diamonds-direct .Holiday2019 .footerText2{font-size:22px;margin:0 auto;color:#fff;text-align:center;padding:0 5%;font-weight:300;margin:0 0 25px}@media (max-width:768px){#diamonds-direct .Holiday2019 .footerText2{font-size:18px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .footerText2{font-size:16px}}#diamonds-direct .Holiday2019 .footerText3{font-size:32px;margin:0 auto;color:#fff;text-align:center;padding:0 5%;font-weight:700}@media (max-width:768px){#diamonds-direct .Holiday2019 .footerText3{font-size:24px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .footerText3{font-size:20px}}#diamonds-direct .Holiday2019 .footerText4{font-size:18px;margin:0 auto;color:#fff;text-align:center;padding:0 5%;font-weight:300;margin:0 0 25px}@media (max-width:768px){#diamonds-direct .Holiday2019 .footerText4{font-size:16px}}@media (max-width:480px){#diamonds-direct .Holiday2019 .footerText4{font-size:15px}}#diamonds-direct .Holiday2019 .promoLegal{text-align:center;font-size:20px;font-weight:300;color:#229943;margin:25px 10px 30px}@media (max-width:768px){#diamonds-direct .Holiday2019 .promoLegal{font-size:18px}}@media (max-width:600px){#diamonds-direct .Holiday2019 .promoLegal{font-size:16px}}#diamonds-direct .December2019{font-family:Lato,sans-serif;background:#1d1322;padding:0 0 30px}#diamonds-direct .December2019 .promoBanner{width:100%;position:relative}#diamonds-direct .December2019 .promoBanner .phoneLinkOverlay{position:absolute;bottom:10.5%;left:32%;width:11%;height:5%}@media (max-width:600px){#diamonds-direct .December2019 .promoBanner .phoneLinkOverlay{bottom:3.5%;left:62%;width:20%;height:4%}}#diamonds-direct .December2019 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .December2019 .promoBanner img.desktop600{display:none}}#diamonds-direct .December2019 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .December2019 .promoBanner img.mobile600{display:block}}#diamonds-direct .December2019 .promoBody{padding:0 0 20px;text-align:center;margin:0 auto;width:80%;max-width:700px}#diamonds-direct .December2019 .promoBody .promoText{margin:0 10%;padding:20px 0;font-weight:400;font-size:24px;color:#fff}@media (max-width:768px){#diamonds-direct .December2019 .promoBody .promoText{font-size:16px}}#diamonds-direct .December2019 .promoBody .promoActionBox{margin:0 auto;width:70%;max-width:500px;border:1px solid #fff}#diamonds-direct .December2019 .promoBody .promoActionBox .boxTitle{color:#fff;font-size:30px;font-weight:700;margin:10px 20px 0}@media (max-width:768px){#diamonds-direct .December2019 .promoBody .promoActionBox .boxTitle{font-size:22px}}#diamonds-direct .December2019 .promoBody .promoActionBox .boxDisclaimer{color:#fff;font-size:20px;font-weight:300}@media (max-width:768px){#diamonds-direct .December2019 .promoBody .promoActionBox .boxDisclaimer{font-size:14px}}#diamonds-direct .December2019 .promoBody .promoActionBox .boxDisclaimer2{display:none;color:#fff;font-size:14px;font-weight:300;margin:15px 0 20px}@media (max-width:768px){#diamonds-direct .December2019 .promoBody .promoActionBox .boxDisclaimer2{font-size:12px}}#diamonds-direct .December2019 .promoBody .promoActionBox .boxDates{color:#fff;margin:10px 0 0;font-size:24px;font-weight:300}@media (max-width:768px){#diamonds-direct .December2019 .promoBody .promoActionBox .boxDates{font-size:20px}}#diamonds-direct .December2019 .promoBody .promoActionBox .boxButton{display:inline-block;width:auto;margin:20px 0;color:#1d1322;background:#fff;padding:10px 20px;text-transform:uppercase;font-size:14px;font-weight:400;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .December2019 .promoBody .promoActionBox .boxButton:action,#diamonds-direct .December2019 .promoBody .promoActionBox .boxButton:hover{background:#d2cfd3}#diamonds-direct .Earring2019{font-family:Lato,sans-serif;background:#efefef;padding:0 0 30px;color:#777e80}#diamonds-direct .Earring2019 .promoBanner{width:100%;position:relative}#diamonds-direct .Earring2019 .promoBanner .position1.eeButton{top:84%;right:55%;width:20%;height:7%}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBanner .position1.eeButton{top:75%;right:15%;width:calc(70% - 2px);height:4%}}#diamonds-direct .Earring2019 .promoBanner .position2.eeButton{top:84%;left:55%;width:20%;height:7%}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBanner .position2.eeButton{top:82%;left:15%;width:calc(70% - 2px);height:4%}}#diamonds-direct .Earring2019 .promoBanner .phoneLinkOverlay{position:absolute;bottom:10.5%;left:32%;width:11%;height:5%}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBanner .phoneLinkOverlay{bottom:3.5%;left:62%;width:20%;height:4%}}#diamonds-direct .Earring2019 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBanner img.desktop600{display:none}}#diamonds-direct .Earring2019 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBanner img.mobile600{display:block}}#diamonds-direct .Earring2019 .promoBody{position:relative;padding:0 0 20px;text-align:center;margin:-90px auto 0;width:80%;max-width:700px;z-index:1}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBody{margin:-60% auto 0}}#diamonds-direct .Earring2019 .promoBody .earringText{font-size:20px;margin:25px 0 0}#diamonds-direct .Earring2019 .promoBody .earringPercent{font-size:64px;font-weight:400;text-transform:uppercase;margin:25px 0 0}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBody .earringPercent{font-weight:900}}#diamonds-direct .Earring2019 .promoBody .earringPercentSub{font-size:32px;font-weight:300;margin:-15px 0 0}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBody .earringPercentSub{font-size:28px}}#diamonds-direct .Earring2019 .promoBody .earringDayWrapper{width:90%;max-width:600px;margin:25px auto 0;text-align:center}#diamonds-direct .Earring2019 .promoBody .earringDayWrapper .earringDayItem{display:inline-block;width:33.33%;font-size:20px;vertical-align:top}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBody .earringDayWrapper .earringDayItem{width:50%;margin-bottom:10px}}#diamonds-direct .Earring2019 .promoBody .earringDayWrapper .earringDayItem .itemDay{font-size:22px;font-weight:700;text-transform:uppercase}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBody .earringDayWrapper .earringDayItem .itemDay{font-size:18px}}#diamonds-direct .Earring2019 .promoBody .earringDayWrapper .earringDayItem .itemTime{font-weight:400;text-transform:uppercase}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBody .earringDayWrapper .earringDayItem .itemTime{font-size:16px}}#diamonds-direct .Earring2019 .promoBody .earringButtonRow{text-align:center;margin:40px 0 0}#diamonds-direct .Earring2019 .promoBody .earringButtonRow .eeButton{position:relative;display:inline-block;margin:0 10px;width:200px;height:40px;cursor:pointer;color:#523554;text-transform:uppercase;font-weight:700;border:1px solid #523554;background:hsla(0,0%,100%,0);font-family:Lato,sans-serif;font-size:18px;transition:background .2s linear 0ms,color .2s linear 0ms,background .2s linear 0ms}#diamonds-direct .Earring2019 .promoBody .earringButtonRow .eeButton div{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center}@media (max-width:1200px){#diamonds-direct .Earring2019 .promoBody .earringButtonRow .eeButton{font-size:18px}}@media (max-width:1024px){#diamonds-direct .Earring2019 .promoBody .earringButtonRow .eeButton{font-size:18px}}@media (max-width:900px){#diamonds-direct .Earring2019 .promoBody .earringButtonRow .eeButton{font-size:16px}}@media (max-width:768px){#diamonds-direct .Earring2019 .promoBody .earringButtonRow .eeButton{font-size:13px}}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBody .earringButtonRow .eeButton{font-size:16px;width:280px;margin-bottom:10px}}#diamonds-direct .Earring2019 .promoBody .earringButtonRow .eeButton:hover{background:#523554;color:#fff}#diamonds-direct .Earring2019 .promoBody .earringSubText{margin:40px 0 0;font-size:18px}@media (max-width:600px){#diamonds-direct .Earring2019 .promoBody .earringSubText{margin:25px 0 0}}#diamonds-direct .Earring2019 .promoBody .earringSubText .locationLink{color:#523554;font-weight:700;text-decoration:none}#diamonds-direct .Earring2019 .promoBody .earringSubText .locationLink:hover{text-decoration:underline}#diamonds-direct .Earring2019 .promoBody .earringDisclosure{margin:20px 0 25px;font-size:14px}#diamonds-direct .Earring2021{font-family:Lato,sans-serif;color:#787878}#diamonds-direct .Earring2021 .headerSection .headerSectionWrapper img{width:100%}#diamonds-direct .Earring2021 .topSection{position:relative;margin:0 auto;width:90%;max-width:800px;padding:20px 0 0}@media (max-width:600px){#diamonds-direct .Earring2021 .topSection{margin:0 auto;width:90%}}#diamonds-direct .Earring2021 .topSection .topP{font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .Earring2021 .topSection .topTitleImg{position:relative;width:80%;margin:40px auto;max-width:600px}#diamonds-direct .Earring2021 .topSection .topTitleImg img{width:100%}#diamonds-direct .Earring2021 .topSection .boxSection{text-align:center;color:#787878;margin:0 auto;font-family:Lusitana,serif;width:90%;max-width:1200px;padding:0}@media (max-width:600px){#diamonds-direct .Earring2021 .topSection .boxSection{margin:0 auto}}#diamonds-direct .Earring2021 .topSection .boxSection .fuBox{color:#dbe6eb;border:1px solid #dbe6eb;margin:25px auto;padding:30px 10px 10px;font-family:Lato,sans-serif;width:90%;max-width:480px}#diamonds-direct .Earring2021 .topSection .boxSection .fuBox .box1{font-weight:900;font-size:26px}#diamonds-direct .Earring2021 .topSection .boxSection .fuBox .box2{font-weight:300}#diamonds-direct .Earring2021 .topSection .boxSection .fuBox .box3{font-weight:400;margin:5px 0 0;font-size:20px}#diamonds-direct .Earring2021 .topSection .boxSection .fuBox .boxButton{position:relative;font-size:14px;border:1px solid #dbe6eb;color:#dbe6eb;background:#fff;width:180px;height:36px;margin:25px auto;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Earring2021 .topSection .boxSection .fuBox .boxButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Earring2021 .topSection .boxSection .fuBox .boxButton:hover{color:#fff;background:#dbe6eb}#diamonds-direct .Earring2021 .topSection .topBox{position:relative;padding:50px 25px;width:calc(90% - 50px);margin:0 auto 20px;background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/notrectangle.jpg\");background-repeat:no-repeat;background-position:50%;background-size:100% 100%;text-align:center;transition:padding .35s linear 0ms}@media (max-width:480px){#diamonds-direct .Earring2021 .topSection .topBox{padding:30px 10px;width:calc(95% - 20px)}}#diamonds-direct .Earring2021 .topSection .topBox .topBoxBg{display:none;position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .Earring2021 .topSection .topBox .topBoxBg img{width:100%;height:100%}#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper{margin:0 0 30px}#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper .weekDate{font-size:24px;font-weight:400;font-family:Lusitana,serif}#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper .weekHr{width:100px;height:4px;margin:15px auto;background:#dbe6eb}#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper .weekDateRow{margin:0 0 5px}#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{display:inline-block;vertical-align:top;width:auto;cursor:pointer;transition:color .25s ease-in-out 0ms,font-size .25s ease-in-out 0ms}#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink:hover{color:#dbe6eb}@media (max-width:768px){#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{font-size:14px}}@media (max-width:480px){#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{font-size:11px}}#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{display:inline-block;vertical-align:top;width:auto;font-weight:900;color:#dbe6eb;margin:0 5px}@media (max-width:768px){#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{font-size:14px}}@media (max-width:600px){#diamonds-direct .Earring2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{margin:0 3px}}#diamonds-direct .Earring2021 .topSection .topGallery{position:relative;width:100%;margin:0 auto}#diamonds-direct .Earring2021 .topSection .topGallery img{width:100%}#diamonds-direct .Earring2021 .topSection .topGallery .ol{position:absolute;cursor:pointer}#diamonds-direct .Earring2021 .topSection .topGallery .ol1{top:0;left:0;width:25%;height:100%}@media (max-width:600px){#diamonds-direct .Earring2021 .topSection .topGallery .ol1{top:0;left:0;width:49%;height:49%}}#diamonds-direct .Earring2021 .topSection .topGallery .ol2{top:0;left:26%;width:24%;height:48%}@media (max-width:600px){#diamonds-direct .Earring2021 .topSection .topGallery .ol2{top:0;left:52%;width:48%;height:24%}}#diamonds-direct .Earring2021 .topSection .topGallery .ol3{top:52%;left:26%;width:24%;height:48%}@media (max-width:600px){#diamonds-direct .Earring2021 .topSection .topGallery .ol3{top:25%;left:52%;width:48%;height:24%}}#diamonds-direct .Earring2021 .topSection .topGallery .ol4{top:0;left:51%;width:49%;height:100%}@media (max-width:600px){#diamonds-direct .Earring2021 .topSection .topGallery .ol4{top:50%;left:0;width:100%;height:50%}}#diamonds-direct .Earring2021 .topSection .topGallery .ol5{top:0;right:0;width:31%;height:100%}@media (max-width:600px){#diamonds-direct .Earring2021 .topSection .topGallery .ol5{top:65%;left:0;width:100%;height:35%}}#diamonds-direct .Earring2021 .topSection .topLegal{font-size:14px;margin:10px 0;text-align:center}#diamonds-direct .Earring2021 .formSection{position:relative;background:#dbe6eb;overflow:auto;margin:25px auto;width:90%;max-width:800px}#diamonds-direct .Earring2021 .formSection .formHeader img{width:100%}#diamonds-direct .Earring2021 .formSection .formBoxWrapper{position:relative;width:90%;max-width:800px;margin:0 auto;overflow:auto}@media (max-width:600px){#diamonds-direct .Earring2021 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%}}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#000;font-size:18px;text-align:center;margin:0 0 25px}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#dbe6eb;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:#f2e8f2;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:1px solid #eb3533}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #dbe6eb;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #dbe6eb;background:#fff}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select option{background:#fff}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper .error select{border:1px solid #eb3533}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#000;background:#dbe6eb;border:1px solid #000;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#000;border-color:#000}#diamonds-direct .Earring2021 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#f2e8f2;font-size:13px;text-align:center}#diamonds-direct .Earring2021 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Earring2021 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Earring2021 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Earring2021 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Earring2021 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Earring2021 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Earring2021 .ggSection{margin:10px auto 0;width:90%;max-width:800px;text-align:center}#diamonds-direct .Earring2021 .ggSection .ggTitle{width:80%;max-width:400px;margin:0 auto}#diamonds-direct .Earring2021 .ggSection .ggLine img,#diamonds-direct .Earring2021 .ggSection .ggTitle img{width:100%}#diamonds-direct .Earring2021 .ggSection .ggP{font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .Earring2021 .ggSection .ggButton{display:inline-block;margin:0 0 20px;background:#fff;color:#000;border:1px solid #000;font-size:14px;text-transform:uppercase;text-align:center;padding:10px 50px;width:auto;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Earring2021 .ggSection .ggButton:hover{background:#000;color:#fff}#diamonds-direct .Earring2021 .ggSection .ggItemRow .ggItem{display:inline-block;vertical-align:top;margin:5px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Earring2021 .ggSection .ggItemRow .ggItem{width:calc(50% - 12px)}}#diamonds-direct .Earring2021 .ggSection .ggItemRow .ggItem:hover .ggItemLabel{color:#dbe6eb}#diamonds-direct .Earring2021 .ggSection .ggItemRow .ggItem .ggItemImg{border:2px solid #ccd8de;background-repeat:no-repeat;background-position:50%;background-size:cover;padding-bottom:100%}#diamonds-direct .Earring2021 .ggSection .ggItemRow .ggItem .ggItemImg1{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/bldxl18079.jpg\")}#diamonds-direct .Earring2021 .ggSection .ggItemRow .ggItem .ggItemImg2{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/bldmd30060.jpg\")}#diamonds-direct .Earring2021 .ggSection .ggItemRow .ggItem .ggItemImg3{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/nfanc29328.jpg\")}#diamonds-direct .Earring2021 .ggSection .ggItemRow .ggItem .ggItemImg4{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/efand14379.jpg\")}#diamonds-direct .Earring2021 .ggSection .ggItemRow .ggItem .ggItemLabel{text-align:left;height:40px;transition:color .25s ease-in-out 0ms}#diamonds-direct .Earring2021 .legalSection .legalInnerWrapper{margin:20px auto;width:90%;font-size:14px;color:#f2e8f2;text-align:center}#diamonds-direct .Valentines2020{overflow:auto;font-family:Lato,sans-serif}#diamonds-direct .Valentines2020 .promoBanner{width:100%}#diamonds-direct .Valentines2020 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Valentines2020 .promoBanner img.desktop600{display:none}}#diamonds-direct .Valentines2020 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Valentines2020 .promoBanner img.mobile600{display:block}}#diamonds-direct .Valentines2020 .promoBannerDisclaimer{color:#adadad;font-size:13px;font-weight:400;margin:-4% 5% 8%}#diamonds-direct .Valentines2020 .promoBannerDisclaimer a{color:#adadad;text-decoration:none}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBannerDisclaimer{margin:-4% 5% 10%}}@media (max-width:600px){#diamonds-direct .Valentines2020 .promoBannerDisclaimer{margin:5% 5% 0}}#diamonds-direct .Valentines2020 .promoBody{margin:-60px 0 0}@media (max-width:600px){#diamonds-direct .Valentines2020 .promoBody{margin:0}}#diamonds-direct .Valentines2020 .promoBodyInner{position:relative;background:#fff;color:#4d4d4e;text-align:center;overflow:auto;margin:0 auto 40px;width:95%;max-width:1200px}@media (max-width:600px){#diamonds-direct .Valentines2020 .promoBodyInner{width:90%}}#diamonds-direct .Valentines2020 .promoBodyInner .promoStrong.promoText{font-weight:700;padding-top:0}#diamonds-direct .Valentines2020 .promoBodyInner .promoText{margin:0 auto 15px;width:80%;padding:20px 25px;font-weight:400;font-size:22px;color:#4e4e4e}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .promoText{font-size:16px;padding:20px}}@media (max-width:600px){#diamonds-direct .Valentines2020 .promoBodyInner .promoText{margin:15px 5%;font-size:16px;padding:10px 5px}}#diamonds-direct .Valentines2020 .promoBodyInner .promoText .light-em{font-weight:700}#diamonds-direct .Valentines2020 .promoBodyInner .promoText .purple-em{font-weight:700;color:#b5a9c9}#diamonds-direct .Valentines2020 .promoBodyInner .promoText .color-em{font-weight:700;color:#dc147d}#diamonds-direct .Valentines2020 .promoBodyInner .promoTextSecond.promoText{margin:10px auto 0;font-size:20px;max-width:600px}#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox{margin:0 auto;width:70%;max-width:450px;border:1px solid #b5a9c9}#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox .boxTitle{color:#000;font-size:30px;font-weight:900;margin:10px 20px 0}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox .boxTitle{font-size:22px}}#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox .boxTitle .color-em{color:#dc147d}#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox .boxDisclaimer{color:#4e4e4e;font-size:20px;font-weight:300;margin:5px 0 0}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox .boxDisclaimer{font-size:14px}}#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox .boxDates{color:#4e4e4e;margin:10px 0 0;font-size:24px;font-weight:300}#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox .boxDates .color-em{color:#dc147d}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox .boxDates{font-size:20px}}#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox .boxButton{display:inline-block;width:auto;margin:20px 0 25px;color:#dc147d;background:#fff;border:1px solid #dc147d;padding:10px 20px;text-transform:uppercase;font-size:14px;font-weight:700;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Valentines2020 .promoBodyInner .promoActionBox .boxButton:hover{color:#fff;background:#dc147d}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock{margin:20px 140px 50px;font-family:Lato,sans-serif}@media (max-width:1200px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock{margin:20px 50px 50px}}@media (max-width:900px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock{margin:25px}}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock{margin:10px 0}}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem{display:block;margin:0 0 20px;overflow:hidden}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .uneekDates.valDates img{margin-right:0}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .uneekDates.valDates img{margin-right:auto;height:35px}}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valDates{position:relative;display:inline-block;width:190px;padding:0;height:60px;text-align:right;border-right:3px solid #ba9dbf;vertical-align:top}@media (max-width:900px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valDates{width:150px;padding:0;height:50px;line-height:50px}}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valDates{font-size:20px;width:150px;padding:0;border-right:none;border-bottom:2px solid #ba9dbf;height:35px;margin:0 0 10px}}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valDates img{max-width:85%;max-height:100%;width:auto;height:auto;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valDates img{height:25px}}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations.singleLine{line-height:60px}@media (max-width:900px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations.singleLine{line-height:50px}}@media (max-width:600px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations.singleLine{height:20px;line-height:20px}}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .desktopLocations.valLocations{display:inline-block}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .desktopLocations.valLocations{display:none}}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .mobileLocations.valLocations{display:none}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .mobileLocations.valLocations{display:inline-block}}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations{display:inline-block;width:calc(100% - 220px);height:60px;line-height:27px;vertical-align:top;text-align:left;padding:0 0 0 20px}@media (max-width:900px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations{padding:0 0 0 10px;line-height:22px;width:calc(100% - 175px)}}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations{padding:0;line-height:19px;width:100%;text-align:center}}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations .holiday-location-link{text-decoration:none;color:#4d4d4e;cursor:pointer;font-size:20px;transition:color .25s ease-in-out 0ms}@media (max-width:900px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations .holiday-location-link{font-size:18px}}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations .holiday-location-link{font-size:13px}}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations .holiday-location-link:hover{color:#ba9dbf}#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations .link-em{color:#ba9dbf;font-weight:700;font-size:22px}@media (max-width:900px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations .link-em{font-size:20px}}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoBodyInner .valLocationBlock .valLocationItem .valLocations .link-em{font-size:14px}}#diamonds-direct .Valentines2020 .promoLegal{text-align:center;font-size:20px;font-weight:300;color:#ba9dbf;font-family:Lato,sans-serif;margin:-15px 10px 30px}@media (max-width:768px){#diamonds-direct .Valentines2020 .promoLegal{font-size:18px}}@media (max-width:600px){#diamonds-direct .Valentines2020 .promoLegal{font-size:16px}}#diamonds-direct .Covid19{overflow:auto;font-family:Lato,sans-serif}#diamonds-direct .Covid19 .promoBanner{width:100%}#diamonds-direct .Covid19 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Covid19 .promoBanner img.desktop600{display:none}}#diamonds-direct .Covid19 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Covid19 .promoBanner img.mobile600{display:block}}#diamonds-direct .Covid19 .promoBody{position:relative;background:#fff;margin:-6% auto 25px;z-index:2;width:90%;max-width:1000px}@media (max-width:1024px){#diamonds-direct .Covid19 .promoBody{margin:0 auto}}@media (max-width:768px){#diamonds-direct .Covid19 .promoBody{width:100%}}#diamonds-direct .Covid19 .promoBody .titleArea{background:#fff;overflow:auto;margin:0 0 20px}#diamonds-direct .Covid19 .promoBody .titleArea .mainTitle{text-align:center;margin:20px 0 30px;font-family:Lusitana,serif;font-size:36px;color:#000;text-transform:uppercase}#diamonds-direct .Covid19 .promoBody .titleArea .titleCopy{margin:0 8% 10px;color:#000}#diamonds-direct .Covid19 .promoBody .titleArea .titleCopy .titleLink{text-decoration:underline;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Covid19 .promoBody .titleArea .titleCopy .titleLink:hover{color:#000}#diamonds-direct .Covid19 .promoBody .bodyArea{display:table-row}@media (max-width:768px){#diamonds-direct .Covid19 .promoBody .bodyArea{display:block}}#diamonds-direct .Covid19 .promoBody .bodyArea .bodyTitle{font-size:20px;font-weight:700;margin:25px 10px;text-align:center;color:#4b2d53}#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea{background:#fff;display:table-cell;vertical-align:top;width:65%}@media (max-width:768px){#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea{display:block;width:100%}}#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea .iconWrapper{margin:0 10px}#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea .iconWrapper .iconItem{display:inline-block;vertical-align:top;width:calc(33% - 10px);margin:0 5px 20px}@media (max-width:600px){#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea .iconWrapper .iconItem{width:calc(50% - 10px)}}#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea .iconWrapper .iconItem .itemIcon{text-align:center;height:40px}#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea .iconWrapper .iconItem .itemIcon img{height:100%}#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea .iconWrapper .iconItem .rulerIcon.itemIcon{text-align:center;height:40px;width:120px;margin:0 auto}#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea .iconWrapper .iconItem .rulerIcon.itemIcon img{width:100%}#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea .iconWrapper .iconItem .itemTitle{margin:20px 0;text-align:center;font-size:18px;font-weight:700;color:#4b2d53}#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea .iconWrapper .iconItem .itemBody .itemLink{cursor:pointer;text-decoration:underline;transition:color .25s ease-in-out 0ms}#diamonds-direct .Covid19 .promoBody .bodyArea .iconArea .iconWrapper .iconItem .itemBody .itemLink:hover{color:#000}#diamonds-direct .Covid19 .promoBody .bodyArea .storeArea{display:none;vertical-align:top;width:35%;overflow:auto;background:#f2f2f2}@media (max-width:768px){#diamonds-direct .Covid19 .promoBody .bodyArea .storeArea{display:block;width:100%}}#diamonds-direct .Covid19 .promoBody .bodyArea .storeArea .bodyTitle{text-align:left}#diamonds-direct .Covid19 .promoBody .bodyArea .storeArea .storeDropDownWrapper{margin:0 10%}#diamonds-direct .Covid19 .promoBody .bodyArea .storeArea .storeDropDownWrapper select{background:#fff}#diamonds-direct .Covid19 .promoBody .bodyArea .storeArea .storeResultsWrapper{margin:0 10%;color:#000}#diamonds-direct .Covid19 .promoBody .bodyArea .storeArea .storeResultsWrapper .covidLocation{font-size:18px;font-weight:700;margin:20px 0 15px}#diamonds-direct .Covid19 .promoBody .covidDrawer.open{max-height:1200px}#diamonds-direct .Covid19 .promoBody .covidDrawer{height:auto;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .Covid19 .promoBody .covidP.sectionHeader{cursor:pointer}#diamonds-direct .Covid19 .promoBody .covidP{margin:25px 0 0}#diamonds-direct .Covid19 .promoBody .covidP a{color:#444;transition:color .25s ease-in-out 0ms}#diamonds-direct .Covid19 .promoBody .covidP a:hover{color:#000}#diamonds-direct .Covid19 .promoBody .covidP .covidLarge{font-size:20px;font-weight:700}#diamonds-direct .Covid19 .promoBody .covidP .openIndicator{font-size:20px;font-weight:700;padding-right:10px}#diamonds-direct .Covid19 .promoBody .covidP .covidPLabel{font-weight:700;display:inline-block}#diamonds-direct .Covid19 .promoBody .covidP ul{margin-top:0}#diamonds-direct .Covid19 .promoBody .covidP ul.primaryList li{margin-bottom:15px}#diamonds-direct .Covid19 .promoBody .covidP ul.primaryList li ul li{margin-bottom:0}#diamonds-direct .Covid19 .promoBody .covidP ul.primaryList li .scrollLink{color:#444;cursor:pointer;text-decoration:underline;transition:color .25s ease-in-out 0ms}#diamonds-direct .Covid19 .promoBody .covidP ul.primaryList li .scrollLink:hover{color:#000}#diamonds-direct .Covid19 .promoBody .covidP ul.primaryList li.chatLink{color:#444;cursor:pointer;text-decoration:underline;transition:color .25s ease-in-out 0ms}#diamonds-direct .Covid19 .promoBody .covidP ul.primaryList li.chatLink:hover{color:#000}#diamonds-direct .Covid19 .promoBody .covidEffective{font-style:italic;margin-bottom:0;font-size:15px;font-weight:300}#diamonds-direct .Covid19 .promoBody .covidP.covidPIndent.covidHour{position:relative;margin-left:28%}@media (max-width:600px){#diamonds-direct .Covid19 .promoBody .covidP.covidPIndent.covidHour{margin-left:18%}}#diamonds-direct .Covid19 .promoBody .covidP.covidPIndent.covidHour .hourWrapper{display:inline-block;vertical-align:top;width:160px;text-decoration:underline}#diamonds-direct .Covid19 .promoBody .covidP.covidPIndent.covidHour .hourValue{display:inline-block;vertical-align:top;width:calc(100% - 160px)}#diamonds-direct .Covid19 .promoBody .covidP.covidPIndent.covidHour .dayUnderline{text-decoration:underline}#diamonds-direct .Covid19 .covidContact .covidTitle{position:relative;text-align:center;margin:20px auto;width:90%;max-width:800px;font-family:Lusitana,serif;font-size:36px;color:#000;text-transform:uppercase;z-index:1}#diamonds-direct .Covid19 .covidContact .covidCopy{margin:0 auto 20px;width:90%;max-width:800px}#diamonds-direct .Covid19 .covidContact .scheduleBody{position:relative;margin:0 auto 25px;width:90%;max-width:800px}#diamonds-direct .Covid19 .covidContact .scheduleBody .scheduleBr{width:100%;height:70px;margin:-35px auto 5px;background-image:url(\"https://ddw2.diamondsdirect.com/img/schedule/ddline.svg\");background-repeat:no-repeat;background-position:50%;background-size:cover}@media (max-width:900px){#diamonds-direct .Covid19 .covidContact .scheduleBody .scheduleBr{width:80%;height:50px;margin-top:-25px}}@media (max-width:480px){#diamonds-direct .Covid19 .covidContact .scheduleBody .scheduleBr{width:80%;height:40px;margin-top:-20px}}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbText{text-align:center;font-size:18px;margin:0 0 15px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbText .inlineLink{text-decoration:underline;color:#bf98c3;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbText .inlineLink:hover{color:#b07fb5}#diamonds-direct .Covid19 .covidContact .scheduleBody .optionsWrapper{text-align:center}#diamonds-direct .Covid19 .covidContact .scheduleBody .optionsWrapper .optionItem{display:inline-block;vertical-align:top;margin:0 25px 25px;width:calc(33.33% - 50px);max-width:240px;min-width:210px}#diamonds-direct .Covid19 .covidContact .scheduleBody .optionsWrapper .optionItem .optionImg{height:45px}#diamonds-direct .Covid19 .covidContact .scheduleBody .optionsWrapper .optionItem .optionImg img{height:100%}#diamonds-direct .Covid19 .covidContact .scheduleBody .optionsWrapper .optionItem .optionBr{height:3px;margin:10px 0 0;background:#d3d3d3}#diamonds-direct .Covid19 .covidContact .scheduleBody .optionsWrapper .optionItem .optionTitle{position:relative;font-size:18px;color:#4b2d53;text-transform:uppercase;line-height:1.1;font-weight:400;height:40px;font-family:Lato,sans-serif;margin:20px 0 0}#diamonds-direct .Covid19 .covidContact .scheduleBody .optionsWrapper .optionItem .optionTitle div{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Covid19 .covidContact .scheduleBody .optionsWrapper .optionItem .optionButton.selected{color:#fff;background:#4b2d53}#diamonds-direct .Covid19 .covidContact .scheduleBody .optionsWrapper .optionItem .optionButton{color:#4b2d53;background:#fff;border:1px solid #4b2d53;font-size:12px;font-weight:700;margin:20px 0 0;font-family:Lato,sans-serif;text-transform:uppercase;text-align:center;padding:8px 0;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Covid19 .covidContact .scheduleBody .optionsWrapper .optionItem .optionButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbHours{text-align:center;font-size:16px;margin:0}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbHours .inlineLink{text-decoration:underline;color:#bf98c3;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbHours .inlineLink:hover{color:#b07fb5}#diamonds-direct .Covid19 .covidContact .scheduleBody .hoursSmall.sbHours{font-size:15px;font-weight:300;margin:0 0 15px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper.openForm{max-height:500px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper{height:auto;max-height:0;overflow:hidden;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody{overflow-x:auto;overflow-y:hidden;background:#eee;font-family:Lato,sans-serif;border-top:5px solid #b78dbb;margin:0 0 20px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .contactPageSelect{margin:5px 0 0}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .contactPageSelect select{background:#fff;color:#95989a;border:1px solid #ddd}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formSubheader{margin:15px 0;text-align:center}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow.emRow{background:#ddd;margin:0;padding:10px 0}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow.preBanner{margin:0 10px 10px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow{margin:10px 10px 0}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection{display:inline-block;vertical-align:top;overflow:hidden;margin:0 .5%;width:49%;transition:width .35s linear 0ms,margin .35s linear 0ms}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection input{width:calc(100% - 22px)}@media (max-width:600px){#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneHalfSection{width:100%;margin:0}}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .expandableHalfSection.open{max-height:70px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .expandableHalfSection{height:auto;max-height:0;transition:max-height .4s ease-in-out 0ms}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneThirdSection{display:inline-block;margin:0 1.5%;width:30.3%;vertical-align:top;transition:width .35s linear 0ms,margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .oneThirdSection{width:100%;margin:0}}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioYesNoLabel.error{color:#eb3533}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioYesNoLabel{font-size:14px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow{font-size:16px;text-align:left}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow .radioInputWrapper{margin:8px 40px 0 2px;transition:margin .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputRow .radioInputWrapper{margin-bottom:10px}}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper{display:inline-block;width:auto}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper .radioInputElement{display:inline-block;width:20px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .radioInputWrapper .radioLabel{display:inline-block;width:auto;margin:0 0 0 8px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper{display:inline-block;width:auto}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper .checkboxInputElement{display:inline-block;width:20px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .checkboxInputWrapper .checkboxLabel{display:inline-block;width:auto}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.checkboxInput,#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.radioInput{width:auto}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input{display:inline-block;margin:5px 0;padding:10px;width:calc(100% - 20px);border:1px solid #ddd;outline:none}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input::-webkit-input-placeholder{color:#95989a}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input:-moz-placeholder,#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input::-moz-placeholder{color:#95989a}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input:-ms-input-placeholder{color:#95989a}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow input.error{border:1px solid #eb3533}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .textareaLabelWrapper{margin:8px 0 0;font-size:14px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .textareaInputWrapper{margin:8px 0 0}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea{margin:0;padding:10px;width:calc(100% - 20px);height:75px;border:1px solid #ddd;outline:none}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea::-webkit-input-placeholder{color:#95989a}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea:-moz-placeholder,#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea::-moz-placeholder{color:#95989a}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea:-ms-input-placeholder{color:#95989a}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow textarea.error{border:2px solid #eb3533;width:calc(100% - 34px)}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .selectWrapper{margin-top:4px}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .selectWrapper select{border:none;background:#fff}#diamonds-direct .Covid19 .covidContact .scheduleBody .sbFormWrapper .contactPageForm .formBody .formRow .submitButton{display:block;width:280px;font-weight:700;padding:10px 0;text-align:center;margin:25px auto;cursor:pointer;font-size:18px;font-weight:400;text-transform:none;height:25px;line-height:25px;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Holiday2021{font-family:Lato,sans-serif;color:#666}#diamonds-direct .Holiday2021 .headerSection .headerSectionWrapper img{width:100%}#diamonds-direct .Holiday2021 .topSection{position:relative;margin:0 auto;width:90%;max-width:800px;padding:20px 0 0}@media (max-width:600px){#diamonds-direct .Holiday2021 .topSection{margin:0 auto;width:100%}}#diamonds-direct .Holiday2021 .topSection .topP{font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .Holiday2021 .topSection .topTitleImg{position:relative;width:80%;margin:40px auto;max-width:600px}#diamonds-direct .Holiday2021 .topSection .topTitleImg img{width:100%}#diamonds-direct .Holiday2021 .topSection .topTitleImg .star{position:absolute;top:64%;left:76.5%;width:15px;height:15px;color:#aa8ba2;font-size:18px;font-weight:400}@media (max-width:600px){#diamonds-direct .Holiday2021 .topSection .topTitleImg .star{top:60%}}#diamonds-direct .Holiday2021 .topSection .topBox{position:relative;padding:50px 25px;width:calc(90% - 50px);margin:0 auto 20px;background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/notrectangle.jpg\");background-repeat:no-repeat;background-position:50%;background-size:100% 100%;text-align:center;transition:padding .35s linear 0ms}@media (max-width:480px){#diamonds-direct .Holiday2021 .topSection .topBox{padding:30px 10px;width:calc(95% - 20px)}}#diamonds-direct .Holiday2021 .topSection .topBox .topBoxBg{display:none;position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .Holiday2021 .topSection .topBox .topBoxBg img{width:100%;height:100%}#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper{margin:0 0 30px}#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper .weekDate{font-size:24px;font-weight:400;font-family:Lusitana,serif}#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper .weekHr{width:100px;height:4px;margin:15px auto;background:#aa8ba2}#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper .weekDateRow{margin:0 0 5px}#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{display:inline-block;vertical-align:top;width:auto;cursor:pointer;transition:color .25s ease-in-out 0ms,font-size .25s ease-in-out 0ms}#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink:hover{color:#aa8ba2}@media (max-width:768px){#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{font-size:14px}}@media (max-width:480px){#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{font-size:11px}}#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{display:inline-block;vertical-align:top;width:auto;font-weight:900;color:#aa8ba2;margin:0 5px}@media (max-width:768px){#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{font-size:14px}}@media (max-width:600px){#diamonds-direct .Holiday2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{margin:0 3px}}#diamonds-direct .Holiday2021 .topSection .topGallery{position:relative;width:100%}#diamonds-direct .Holiday2021 .topSection .topGallery img{width:100%}#diamonds-direct .Holiday2021 .topSection .topGallery .ol{position:absolute;cursor:pointer}#diamonds-direct .Holiday2021 .topSection .topGallery .ol1{top:0;left:0;width:19%;height:100%}@media (max-width:600px){#diamonds-direct .Holiday2021 .topSection .topGallery .ol1{top:0;left:0;width:100%;height:33%}}#diamonds-direct .Holiday2021 .topSection .topGallery .ol2{top:0;left:20%;width:20%;height:48%}@media (max-width:600px){#diamonds-direct .Holiday2021 .topSection .topGallery .ol2{top:34%;left:0;width:48%;height:15%}}#diamonds-direct .Holiday2021 .topSection .topGallery .ol3{top:0;left:41.5%;width:20%;height:48%}@media (max-width:600px){#diamonds-direct .Holiday2021 .topSection .topGallery .ol3{top:34%;left:52%;width:48%;height:15%}}#diamonds-direct .Holiday2021 .topSection .topGallery .ol4{top:53%;left:20%;width:41%;height:47%}@media (max-width:600px){#diamonds-direct .Holiday2021 .topSection .topGallery .ol4{top:50.5%;left:0;width:100%;height:15%}}#diamonds-direct .Holiday2021 .topSection .topGallery .ol5{top:0;left:62%;width:38%;height:100%}@media (max-width:600px){#diamonds-direct .Holiday2021 .topSection .topGallery .ol5{top:66%;left:0;width:100%;height:34%}}#diamonds-direct .Holiday2021 .formSection{position:relative;background:#f2e8f2;overflow:auto;margin:25px auto;width:90%;max-width:800px}#diamonds-direct .Holiday2021 .formSection .formHeader img{width:100%}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper{position:relative;width:90%;max-width:800px;margin:0 auto;overflow:auto}@media (max-width:600px){#diamonds-direct .Holiday2021 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%}}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#666;font-size:18px;text-align:center;margin:0 0 25px}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#aa8ba2;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:#787878;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:1px solid #eb3533}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #997490;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #997490;background:#fff}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select option{background:#fff}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper .error select{border:1px solid #eb3533}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#666;background:none;border:1px solid #666;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#997490;border-color:#997490}#diamonds-direct .Holiday2021 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#787878;font-size:13px;text-align:center}#diamonds-direct .Holiday2021 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Holiday2021 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Holiday2021 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Holiday2021 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Holiday2021 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Holiday2021 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Holiday2021 .ggSection{margin:10px auto 0;width:90%;max-width:800px;text-align:center}#diamonds-direct .Holiday2021 .ggSection .ggTitle{width:80%;max-width:400px;margin:0 auto}#diamonds-direct .Holiday2021 .ggSection .ggLine img,#diamonds-direct .Holiday2021 .ggSection .ggTitle img{width:100%}#diamonds-direct .Holiday2021 .ggSection .ggP{font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .Holiday2021 .ggSection .ggButton{display:inline-block;margin:0 0 20px;background:#aa8ba2;color:#fff;font-size:14px;text-transform:uppercase;text-align:center;padding:10px 25px;width:auto;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Holiday2021 .ggSection .ggButton:hover{background:#787878;color:#fff}#diamonds-direct .Holiday2021 .ggSection .ggItemRow .ggItem{display:inline-block;vertical-align:top;margin:5px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Holiday2021 .ggSection .ggItemRow .ggItem{width:calc(50% - 12px)}}#diamonds-direct .Holiday2021 .ggSection .ggItemRow .ggItem:hover .ggItemLabel{color:#aa8ba2}#diamonds-direct .Holiday2021 .ggSection .ggItemRow .ggItem .ggItemImg{border:2px solid #aa8ba2;background-repeat:no-repeat;background-position:50%;background-size:cover;padding-bottom:100%}#diamonds-direct .Holiday2021 .ggSection .ggItemRow .ggItem .ggItemImg1{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/bldxl18079.jpg\")}#diamonds-direct .Holiday2021 .ggSection .ggItemRow .ggItem .ggItemImg2{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/bldmd30060.jpg\")}#diamonds-direct .Holiday2021 .ggSection .ggItemRow .ggItem .ggItemImg3{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/nfanc29328.jpg\")}#diamonds-direct .Holiday2021 .ggSection .ggItemRow .ggItem .ggItemImg4{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/efand14379.jpg\")}#diamonds-direct .Holiday2021 .ggSection .ggItemRow .ggItem .ggItemLabel{text-align:left;height:40px;transition:color .25s ease-in-out 0ms}#diamonds-direct .Holiday2021 .legalSection .legalInnerWrapper{margin:20px auto;width:90%;font-size:14px;color:#787878;text-align:center}#diamonds-direct .Holiday2022{color:#000;font-family:Lato,sans-serif}#diamonds-direct .Holiday2022 .headerSection .headerSectionWrapper{position:relative}#diamonds-direct .Holiday2022 .headerSection .headerSectionWrapper img{width:100%}#diamonds-direct .Holiday2022 .headerSection .headerSectionWrapper .shopButton{position:absolute;top:73%;left:61%;width:20%;height:10%;background:transparent;color:#000;border:1px solid #000;outline:none;font-size:16px;font-weight:700;text-transform:uppercase;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Holiday2022 .headerSection .headerSectionWrapper .shopButton:hover{color:#fff;background:#000}@media (max-width:900px){#diamonds-direct .Holiday2022 .headerSection .headerSectionWrapper .shopButton{font-size:14px}}@media (max-width:600px){#diamonds-direct .Holiday2022 .headerSection .headerSectionWrapper .shopButton{top:85%;left:20%;width:60%;height:8%;font-size:18px}}#diamonds-direct .Holiday2022 .shopSection{position:relative;margin:25px auto 0;width:90%;max-width:1024px}#diamonds-direct .Holiday2022 .shopSection .shopButtonWrapper .shopButton{width:100%;height:60px;background:#fff;color:#000;border:none;outline:none;font-size:32px;font-weight:400;font-family:Lusitana,serif;text-transform:uppercase;cursor:default;transition:background .25s ease-in-out 0ms,font-size .35s linear 0ms}#diamonds-direct .Holiday2022 .shopSection .shopButtonWrapper .shopButton:hover{background:#fff}@media (max-width:600px){#diamonds-direct .Holiday2022 .shopSection .shopButtonWrapper .shopButton{font-size:28px}}#diamonds-direct .Holiday2022 .shopSection .shopTilesWrapper{margin:0;padding:0 0 25px;text-align:center;border-top:2px solid #bca972;border-bottom:2px solid #bca972}#diamonds-direct .Holiday2022 .shopSection .shopTilesWrapper .shopTile{position:relative;display:inline-block;margin:25px 15px 0;width:calc(33.33% - 30px);cursor:pointer}@media (max-width:900px){#diamonds-direct .Holiday2022 .shopSection .shopTilesWrapper .shopTile{width:calc(40% - 30px)}}@media (max-width:600px){#diamonds-direct .Holiday2022 .shopSection .shopTilesWrapper .shopTile{width:calc(80% - 30px)}}#diamonds-direct .Holiday2022 .shopSection .shopTilesWrapper .shopTile:hover .shopTileButton{background:#79327a}#diamonds-direct .Holiday2022 .shopSection .shopTilesWrapper .shopTile .shopImg img{width:100%}#diamonds-direct .Holiday2022 .shopSection .shopTilesWrapper .shopTile .shopTileButton{position:relative;margin:-20px auto 0;width:80%;height:35px;background:#000;color:#fff;font-size:14px;font-weight:700;text-transform:uppercase;transition:background .25s ease-in-out 0ms}#diamonds-direct .Holiday2022 .shopSection .shopTilesWrapper .shopTile .shopTileButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Holiday2022 .titleSection{margin:40px auto 0;width:90%;max-width:768px;text-align:center}#diamonds-direct .Holiday2022 .titleSection .mainTitle{font-size:32px;font-weight:400;font-family:Lusitana,serif}#diamonds-direct .Holiday2022 .titleSection .iconLineWrapper{margin:10px auto;width:70%}#diamonds-direct .Holiday2022 .titleSection .iconLineWrapper img{width:100%}#diamonds-direct .Holiday2022 .titleSection .titleP{margin:0 0 20px;font-size:20px;font-family:Lusitana,serif;color:#787878}#diamonds-direct .Holiday2022 .titleSection .titleBox{margin:0 auto;width:90%;max-width:600px;border:1px solid #bca972}#diamonds-direct .Holiday2022 .titleSection .titleBox .titleBoxLiner{padding:25px;text-align:center}#diamonds-direct .Holiday2022 .titleSection .titleDates{margin:0 0 20px;font-size:22px;color:#bca972}#diamonds-direct .Holiday2022 .titleSection .titleBig{font-size:28px;font-weight:900;color:#bca972}#diamonds-direct .Holiday2022 .titleSection .titleDisclaimer{font-size:18px;font-weight:100;margin:0 0 10px;color:#787878}#diamonds-direct .Holiday2022 .titleSection .titleAction{display:inline-block;width:auto;padding:10px 25px;font-size:14px;font-weight:700;color:#fff;background:#bca972;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Holiday2022 .titleSection .titleAction:hover{background:#000}#diamonds-direct .Holiday2022 .topSection{position:relative;margin:0 auto;width:90%;max-width:1024px}@media (max-width:600px){#diamonds-direct .Holiday2022 .topSection{margin:0 auto;width:100%}}#diamonds-direct .Holiday2022 .topSection .topRow{position:relative;text-align:center}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock{padding:30px 0;display:inline-block;width:45%;vertical-align:top}@media (max-width:1024px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock{width:70%}}@media (max-width:600px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock{width:90%}}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topP{color:#787878;font-size:22px;width:70%;margin:0 auto 20px;text-align:center}@media (max-width:768px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topP{font-size:20px;width:90%}}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topTitle{width:65%;margin:10px auto}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topTitle img{width:100%}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDates{color:#000;text-align:center;margin:0 auto 20px 0;font-size:32px;font-family:Lusitana,serif}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesHr{display:none;width:100px;height:5px;margin:0 auto 25px;background:#79327a}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDateColumnWrapper{position:relative}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDateColumnWrapper .topDateColumn{display:inline-block;vertical-align:top;padding:0 0 0 40px;width:calc(50% - 40px)}@media (max-width:600px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDateColumnWrapper .topDateColumn{padding:0 0 0 20px;width:calc(50% - 20px)}}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDateColumnWrapper .topDateColumn .storeLink{display:block;color:#787878;font-size:20px;cursor:pointer;margin:0 0 5px;text-align:left;text-decoration:none;transition:color .25s ease-in-out 0ms}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDateColumnWrapper .topDateColumn .storeLink:hover{color:#79327a}@media (max-width:600px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDateColumnWrapper .topDateColumn .storeLink{font-size:16px}}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDateColumnWrapper .topDateVr{position:absolute;top:0;left:calc(50% - 1px);width:2px;height:100%;background:#79327a}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesRow{text-align:center;width:90%;margin:0 auto 2px}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesRow .storeLink{color:#787878;font-size:20px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesRow .storeLink:hover{color:#79327a}@media (max-width:900px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesRow .storeLink{font-size:18px}}@media (max-width:768px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesRow .storeLink{font-size:14px}}@media (max-width:600px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesRow .storeLink{font-size:18px}}#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesRow .storePipe{font-size:22px;font-weight:700;color:#bca972;margin:0 5px}@media (max-width:900px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesRow .storePipe{font-size:20px}}@media (max-width:768px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesRow .storePipe{font-size:16px;margin:0 3px}}@media (max-width:600px){#diamonds-direct .Holiday2022 .topSection .topRow .copyBlock .topDatesRow .storePipe{font-size:20px}}#diamonds-direct .Holiday2022 .formSection{position:relative;padding:0 0 25px;margin:25px auto 0;width:90%;max-width:1024px;background:#bca972;overflow:auto}#diamonds-direct .Holiday2022 .formSection .formHeader img{width:100%}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper{position:relative;width:90%;max-width:800px;margin:25px auto 0;overflow:auto}@media (max-width:600px){#diamonds-direct .Holiday2022 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%}}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#fff;font-size:18px;text-align:center;margin:0 0 25px}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#787878;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:#787878;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:1px solid #eb3533}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #fff;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #fff;background:#fff}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select option{background:#fff}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper .error select{border:1px solid #eb3533}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#fff;background:transparent;border:1px solid #fff;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms,border .25s ease-in-out 0ms}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#000;border:1px solid #000}#diamonds-direct .Holiday2022 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#787878;font-size:13px;text-align:center}#diamonds-direct .Holiday2022 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Holiday2022 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Holiday2022 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Holiday2022 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Holiday2022 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Holiday2022 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Holiday2022 .midSection .midP{color:#000;text-align:center;margin:0 auto 20px 0;font-size:32px;font-family:Lusitana,serif}#diamonds-direct .Holiday2022 .looksSection{position:relative;margin:30px auto;width:90%;max-width:1000px}@media (max-width:600px){#diamonds-direct .Holiday2022 .looksSection{padding:0}}#diamonds-direct .Holiday2022 .looksSection .looksWrapper{position:relative}#diamonds-direct .Holiday2022 .looksSection .looksWrapper img{width:100%}#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb{position:absolute;cursor:pointer}#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb1{top:0;left:0;width:23%;height:100%}@media (max-width:600px){#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb1{width:100%;height:27%}}#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb2{top:0;left:24%;width:33%;height:50%}@media (max-width:600px){#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb2{top:28%;left:0;width:55%;height:19%}}#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb3{top:0;left:58%;width:19%;height:50%}@media (max-width:600px){#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb3{top:28%;left:57%;width:43%;height:19%}}#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb4{top:53%;left:24%;width:17%;height:47%}@media (max-width:600px){#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb4{top:48%;left:0;width:41%;height:18%}}#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb5{top:53%;left:41.5%;width:35%;height:47%}@media (max-width:600px){#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb5{top:48%;left:43%;width:57%;height:18%}}#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb6{bottom:0;right:0;width:22.5%;height:100%}@media (max-width:600px){#diamonds-direct .Holiday2022 .looksSection .looksWrapper .lb6{width:100%;height:32%}}#diamonds-direct .Holiday2022 .ggSection{margin:25px auto 0;width:90%;max-width:800px;text-align:center}#diamonds-direct .Holiday2022 .ggSection .ggTitle{width:80%;max-width:400px;margin:0 auto}#diamonds-direct .Holiday2022 .ggSection .ggLine img,#diamonds-direct .Holiday2022 .ggSection .ggTitle img{width:100%}#diamonds-direct .Holiday2022 .ggSection .ggP{color:#787878;font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .Holiday2022 .ggSection .ggButton{display:inline-block;margin:0 0 20px;border:none;background:#bca972;color:#fff;font-size:14px;text-transform:uppercase;text-align:center;padding:10px 40px;width:auto;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Holiday2022 .ggSection .ggButton:hover{color:#fff;background:#000}#diamonds-direct .Holiday2022 .ggSection .ggItemRow .ggItem{display:inline-block;text-decoration:none;vertical-align:top;margin:5px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Holiday2022 .ggSection .ggItemRow .ggItem{width:calc(50% - 12px)}}#diamonds-direct .Holiday2022 .ggSection .ggItemRow .ggItem:hover .ggItemImg{border-color:#000}#diamonds-direct .Holiday2022 .ggSection .ggItemRow .ggItem:hover .ggItemLabel{color:#000}#diamonds-direct .Holiday2022 .ggSection .ggItemRow .ggItem .ggItemImg{border:2px solid #bca972;background-repeat:no-repeat;background-position:50%;background-size:cover;padding-bottom:100%;transition:border .4s ease-in-out 0ms}#diamonds-direct .Holiday2022 .ggSection .ggItemRow .ggItem .ggItemImg1{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/BLDLG15656.jpg\")}#diamonds-direct .Holiday2022 .ggSection .ggItemRow .ggItem .ggItemImg2{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/PRLFE01094.jpg\")}#diamonds-direct .Holiday2022 .ggSection .ggItemRow .ggItem .ggItemImg3{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/NFANC29328.jpg\")}#diamonds-direct .Holiday2022 .ggSection .ggItemRow .ggItem .ggItemImg4{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/EMER03342.jpg\")}#diamonds-direct .Holiday2022 .ggSection .ggItemRow .ggItem .ggItemLabel{color:#bca972;text-decoration:none;text-align:left;height:40px;transition:color .4s ease-in-out 0ms}#diamonds-direct .Holiday2022 .legalSection .legalInnerWrapper{margin:20px auto;width:90%;font-size:14px;color:#787878;text-align:center}#diamonds-direct .Mothers2020{font-family:Lato,sans-serif;overflow:auto;position:relative}#diamonds-direct .Mothers2020 .promoBanner{width:100%;position:relative;display:block}#diamonds-direct .Mothers2020 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Mothers2020 .promoBanner img.desktop600{display:none}}#diamonds-direct .Mothers2020 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Mothers2020 .promoBanner img.mobile600{display:block}}#diamonds-direct .Mothers2020 .promoBody{background:none;color:#8f9394;text-align:center;overflow:auto;margin:-8% 0 0;position:relative;z-index:1}@media (max-width:600px){#diamonds-direct .Mothers2020 .promoBody{margin:-30% 0 0}}#diamonds-direct .Mothers2020 .promoBody .promoLegal{margin:0 5%;text-align:left;color:#adadad;position:relative}#diamonds-direct .Mothers2020 .promoBody .promoLegal a{color:#adadad;text-decoration:none}#diamonds-direct .Mothers2020 .promoBody .promoDisclaimer{color:#adadad;text-align:center;font-size:15px;margin:0 0 20px}#diamonds-direct .Mothers2020 .promoBody .promoDisclaimer a{color:#adadad}#diamonds-direct .Mothers2020 .promoBody .promoText{margin:30px 20% 0;font-weight:700;font-size:32px;color:#8f9394}@media (max-width:768px){#diamonds-direct .Mothers2020 .promoBody .promoText{font-size:16px;margin:30px 10% 0}}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper{position:relative;text-align:center;margin:20px 0 30px}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .boxOr{position:absolute;top:calc(50% - 30px);left:calc(50% - 20px);height:60px;width:40px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;color:#d67e91;background:#fff;font-size:32px}@media (max-width:1024px){#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .boxOr{position:relative;top:0;right:0;margin-top:-32px;margin-bottom:-30px;width:60px;font-size:24px}}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox{width:40%;max-width:500px;display:inline-block;vertical-align:top}@media (max-width:1024px){#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox{display:block;margin:0 auto;width:90%}}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox:first-child{border-right:1px solid #8f9394}@media (max-width:1024px){#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox:first-child{border-right:none;border-bottom:1px solid #8f9394}}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxTitle{color:#8f9394;font-size:38px;font-weight:700;margin:30px 20px 0}@media (max-width:768px){#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxTitle{font-size:22px}}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxDisclaimer{color:#8f9394;font-size:20px;font-weight:300}@media (max-width:768px){#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxDisclaimer{font-size:14px}}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxDates{color:gray;margin:10px 0 0;font-size:28px;font-weight:300}@media (max-width:768px){#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxDates{font-size:20px}}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxButton{display:inline-block;width:auto;margin:20px 0 25px;color:#d67e91;background:none;border:2px solid #d67e91;padding:10px 20px;text-transform:uppercase;font-size:14px;font-weight:700;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxButton:hover{background:#d67e91;color:#fff}@media (max-width:768px){#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxButton{font-size:12px;padding:10px}}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxPercent{text-transform:uppercase;font-weight:400;font-size:72px;color:#d67e91;margin:30px 0 0}@media (max-width:768px){#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxPercent{font-size:48px;font-size:32px}}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxText{text-transform:uppercase;font-weight:400;font-size:32px;margin:0 0 40px}@media (max-width:768px){#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxText{font-size:28px;font-size:24px}}#diamonds-direct .Mothers2020 .promoBody .promoBoxWrapper .promoActionBox .boxAmp{color:#d67e91}#diamonds-direct .Mothers2021{color:#5e5e5e;background:#fff;font-family:Lato,sans-serif;overflow:auto}#diamonds-direct .Mothers2021 .itemRow{margin:0}#diamonds-direct .Mothers2021 .itemRow .itemBlock.doubleItem{width:calc(50% - 12px)}@media (max-width:768px){#diamonds-direct .Mothers2021 .itemRow .itemBlock.doubleItem{width:calc(100% - 12px)}}#diamonds-direct .Mothers2021 .itemRow .itemBlock{display:inline-block;vertical-align:top;margin:6px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Mothers2021 .itemRow .itemBlock{width:calc(50% - 12px)}}#diamonds-direct .Mothers2021 .itemRow .itemBlock img,#diamonds-direct .Mothers2021 .promoBanner{width:100%}#diamonds-direct .Mothers2021 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Mothers2021 .promoBanner img.desktop600{display:none}}#diamonds-direct .Mothers2021 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Mothers2021 .promoBanner img.mobile600{display:block}}#diamonds-direct .Mothers2021 .cheersBlock{background:#fff;margin:0 auto;width:90%;max-width:1024px}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper{position:relative}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft{display:inline-block;vertical-align:top;width:calc(50% - 10px);margin:20px 5px;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft{width:calc(100% - 10px)}}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{text-align:center;padding:125px 12% 0;font-size:26px;font-weight:300;color:#000;transition:font-size .35s linear 0ms,margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{font-size:18px;padding:25px 12% 0}}@media (max-width:900px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{padding:0 5%;font-size:16px}}@media (max-width:768px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{font-size:18px}}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .titlePurple{margin:1em 0;font-size:32px;color:#8c74ba;font-weight:300;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .titlePurple{font-size:26px}}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .cbLeftCopy{margin:0 0 40px}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .cbLeftButton{display:inline-block;color:#5a4b78;background:#fff;border:1px solid #5a4b78;cursor:pointer;padding:10px 35px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .cbLeftButton:hover{color:#fff;background:#5a4b78}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbRight{display:inline-block;vertical-align:top;margin:20px 5px;width:calc(50% - 10px);transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbRight{width:calc(100% - 10px);margin:0 0 20px}}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper{margin:0;padding:75px 25px;color:#000;background:#deecfa;text-align:center}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper img{width:100%}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrSuperTitle{font-size:28px;font-weight:700;margin:0 0 10px}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrTitle{font-size:24px;font-weight:700}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrDisc{font-size:18px;font-weight:300;margin:0 0 25px}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrDates{font-size:20px;font-weight:400}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrButton{display:inline-block;margin:20px 0;padding:10px 20px;font-size:14px;text-transform:uppercase;font-weight:700;background:#deecfa;color:#000;border:1px solid #000;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrButton:hover{background:#000;color:#fff}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems{position:relative;display:block;margin:0 0 20px;width:100%;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems{width:calc(100% - 10px)}}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiLink{position:absolute;cursor:pointer}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopLeft{top:0;left:0;width:25%;height:60%}@media (max-width:600px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopLeft{top:52%;left:0;width:50%;height:28%}}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopRight{top:0;left:25%;width:25%;height:60%}@media (max-width:600px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopRight{top:52%;left:50%;width:50%;height:28%}}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiBottomLeft{top:60%;left:0;width:50%;height:40%}@media (max-width:600px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiBottomLeft{top:80%;left:0;width:100%;height:20%}}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiRight{top:0;left:50%;width:50%;height:100%}@media (max-width:600px){#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiRight{top:0;left:0;width:100%;height:50%}}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock.doubleItem{width:calc(100% - 12px)}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock{width:calc(50% - 12px)}#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock img,#diamonds-direct .Mothers2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems img{width:100%}#diamonds-direct .Mothers2021 .formBoxWrapper{position:relative;overflow:auto;background:#538498;margin:0 auto;z-index:3;font-family:Lato,sans-serif}@media (max-width:600px){#diamonds-direct .Mothers2021 .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper{width:90%;max-width:1024px;margin:25px auto}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formP{color:#fff;text-align:center;margin:0 0 25px;padding-top:15px;font-size:20px;font-weight:400}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formTitle{color:#5e5e5e;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formDates{color:#5e5e5e;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #5e5e5e;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #5e5e5e;background:#fff}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#000;background:none;border:1px solid #000;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#000}#diamonds-direct .Mothers2021 .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#5e5e5e;font-size:13px;text-align:center}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper{width:90%;max-width:1024px;margin:12px auto}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .fianceBlock .mainRow .copyBlock{background:#e8eaff}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .newlywedBlock .mainRow .copyBlock{background:#f7e8ff}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .gradBlock .mainRow .copyBlock{background:#e8f5ff}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .dadBlock .mainRow .copyBlock{background:#f7f7f7}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow{position:relative}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock{margin:6px}@media (max-width:768px){#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock{margin:6px}}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock img{width:100%;display:block}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock{position:absolute;top:6px;left:6px;height:calc(100% - 12px);text-align:center}@media (max-width:768px){#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock{position:relative;top:0;left:0;height:auto;margin:6px}}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:20% 0;padding:0 5%;overflow:auto}@media (max-width:900px){#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:15% 0}}@media (max-width:768px){#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:0;padding:10% 5%}}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbTitle{margin:1em 0;font-size:32px;color:#8c74ba;font-weight:300}@media (max-width:1024px){#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbTitle{font-size:26px}}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbCopy{font-size:20px}@media (max-width:1024px){#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbCopy{font-size:18px}}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbButton{display:inline-block;color:#5a4b78;background:#fff;border:1px solid #5a4b78;cursor:pointer;margin:20px 0 0;padding:10px 25px;width:auto;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbButton:hover{color:#fff;background:#5a4b78}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .rightImg.mrBlock{margin-left:calc(50% + 12px/2)}@media (max-width:768px){#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .rightImg.mrBlock{display:none;margin-left:6px}}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .rightCopy.mrBlock{left:calc(50% + 12px/2)}@media (max-width:768px){#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .rightCopy.mrBlock{left:0}}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .mobileMakeup.mrBlock{display:none}@media (max-width:768px){#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .mobileMakeup.mrBlock{display:block}}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock{display:inline-block;vertical-align:top;width:calc(50% - 12px)}@media (max-width:768px){#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock{display:block;width:calc(100% - 12px)}#diamonds-direct .Mothers2021 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock:first-child{margin-bottom:12px}}#diamonds-direct .Mothers2022{color:#000;background:#fff;font-family:Lato,sans-serif;overflow:auto}#diamonds-direct .Mothers2022 .promoBanner{width:100%}#diamonds-direct .Mothers2022 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Mothers2022 .promoBanner img.desktop600{display:none}}#diamonds-direct .Mothers2022 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Mothers2022 .promoBanner img.mobile600{display:block}}#diamonds-direct .Mothers2022 .copySection{margin:20px auto 0;width:90%;max-width:1024px;text-align:center}#diamonds-direct .Mothers2022 .copySection .copyTitle{margin:0 0 20px;font-size:32px;font-family:Lusitana,serif}#diamonds-direct .Mothers2022 .copySection .copyCopy{margin:0 auto 20px;width:80%;font-size:18px;font-weight:300}#diamonds-direct .Mothers2022 .formBoxWrapper{position:relative;overflow:auto;background:#8c8c8c;margin:20px auto 0;width:90%;max-width:1024px;font-family:Lato,sans-serif}@media (max-width:600px){#diamonds-direct .Mothers2022 .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper{width:90%;max-width:1024px;margin:25px auto}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formP{color:#fff;text-align:center;margin:0 0 25px;padding-top:15px;font-size:20px;font-weight:400}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formTitle{color:#000;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formDates{color:#000;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #000;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #000;background:#fff}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#000;background:transparent;border:1px solid #000;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#000}#diamonds-direct .Mothers2022 .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#000;font-size:13px;text-align:center}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper{width:90%;max-width:1024px;margin:12px auto}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .fianceBlock .mainRow .copyBlock,#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .gradBlock .mainRow .copyBlock,#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .newlywedBlock .mainRow .copyBlock{background:#f2f2f2}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow{position:relative}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock{margin:6px}@media (max-width:768px){#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock{margin:6px}}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock img{width:100%;display:block}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock{position:absolute;top:6px;left:6px;height:calc(100% - 12px);text-align:center}@media (max-width:768px){#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock{position:relative;top:0;left:0;height:160px;margin:6px}}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{position:absolute;top:0;left:0;right:0;bottom:0}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbButton{position:absolute;top:calc(50% - 20px);left:40px;width:calc(100% - 80px - 2px);height:40px;color:#000;background:transparent;border:1px solid #000;cursor:pointer;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbButton:hover{color:#fff;background:#000}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightImg.mrBlock{margin-left:calc(50% + 12px/2)}@media (max-width:768px){#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightImg.mrBlock{display:none;margin-left:6px}}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightCopy.mrBlock{left:calc(50% + 12px/2)}@media (max-width:768px){#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightCopy.mrBlock{left:0}}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mobileMakeup.mrBlock{display:none}@media (max-width:768px){#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mobileMakeup.mrBlock{display:block}}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock{display:inline-block;vertical-align:top;width:calc(50% - 12px)}@media (max-width:768px){#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock{display:block;width:calc(100% - 12px)}#diamonds-direct .Mothers2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock:first-child{margin-top:12px;margin-bottom:12px}}#diamonds-direct .Mothers2022 .legalSection{margin:20px auto;width:90%;max-width:1024px;font-size:14px;text-align:center}#diamonds-direct .June2020{font-family:Lato,sans-serif;background:#fffaf7;padding:0 0 30px}#diamonds-direct .June2020 .colorEm{color:#7b9a95}#diamonds-direct .June2020 .promoBanner{width:100%;position:relative}#diamonds-direct .June2020 .promoBanner .phoneLinkOverlay{position:absolute;bottom:10.5%;left:32%;width:11%;height:5%}@media (max-width:600px){#diamonds-direct .June2020 .promoBanner .phoneLinkOverlay{bottom:3.5%;left:62%;width:20%;height:4%}}#diamonds-direct .June2020 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .June2020 .promoBanner img.desktop600{display:none}}#diamonds-direct .June2020 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .June2020 .promoBanner img.mobile600{display:block}}#diamonds-direct .June2020 .promoBody{padding:0 0 20px;text-align:center;margin:0 auto;width:80%;max-width:700px}#diamonds-direct .June2020 .promoBody .promoText{margin:0 10%;padding:20px 0;font-weight:400;font-size:24px;color:#666463}@media (max-width:768px){#diamonds-direct .June2020 .promoBody .promoText{font-size:16px}}#diamonds-direct .June2020 .promoBody .promoActionBox{margin:0 auto;width:70%;max-width:500px;border:1px solid #666463}#diamonds-direct .June2020 .promoBody .promoActionBox .boxTitle{color:#666463;font-size:30px;font-weight:700;margin:10px 20px 0}@media (max-width:768px){#diamonds-direct .June2020 .promoBody .promoActionBox .boxTitle{font-size:22px}}#diamonds-direct .June2020 .promoBody .promoActionBox .boxDisclaimer{color:#666463;font-size:20px;font-weight:300}@media (max-width:768px){#diamonds-direct .June2020 .promoBody .promoActionBox .boxDisclaimer{font-size:14px}}#diamonds-direct .June2020 .promoBody .promoActionBox .boxDisclaimer2{display:none;color:#666463;font-size:14px;font-weight:300;margin:15px 0 20px}@media (max-width:768px){#diamonds-direct .June2020 .promoBody .promoActionBox .boxDisclaimer2{font-size:12px}}#diamonds-direct .June2020 .promoBody .promoActionBox .boxDates{color:#666463;margin:10px 0 0;font-size:24px;font-weight:300}@media (max-width:768px){#diamonds-direct .June2020 .promoBody .promoActionBox .boxDates{font-size:20px}}#diamonds-direct .June2020 .promoBody .promoActionBox .boxButton{display:inline-block;width:auto;margin:20px 0;color:#fff;background:#7b9a95;padding:10px 20px;text-transform:uppercase;font-size:14px;font-weight:400;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .June2020 .promoBody .promoActionBox .boxButton:action,#diamonds-direct .June2020 .promoBody .promoActionBox .boxButton:hover{background:#95aeaa}#diamonds-direct .June2020 .promoBody .promoActionBox .boxLegal{margin:0 15% 20px;font-size:13px;font-weight:300}#diamonds-direct .June2022{color:#000;background:#fff;font-family:Lato,sans-serif;overflow:auto}#diamonds-direct .June2022 .promoBanner{width:100%}#diamonds-direct .June2022 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .June2022 .promoBanner img.desktop600{display:none}}#diamonds-direct .June2022 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .June2022 .promoBanner img.mobile600{display:block}}#diamonds-direct .June2022 .formBoxWrapper{position:relative;overflow:auto;background:#fff;border-top:2px solid #b5912e;margin:20px auto 0;width:90%;max-width:1024px;font-family:Lato,sans-serif}@media (max-width:600px){#diamonds-direct .June2022 .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper{width:90%;max-width:1024px;margin:25px auto}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formP{color:#787878;text-align:center;margin:0 0 25px;padding-top:15px;font-size:20px;font-weight:400}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formTitle{color:#000;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formDates{color:#000;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #000;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #000;background:#fff}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#fff;background:#000;border:none;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#4b2d53}#diamonds-direct .June2022 .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#000;font-size:13px;text-align:center}#diamonds-direct .June2022 .midSection .midSectionWrapper{position:relative;width:90%;max-width:1024px;margin:12px auto}@media (max-width:1024px){#diamonds-direct .June2022 .midSection .midSectionWrapper{max-width:600px}}#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumn,#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumnMobile{position:relative;display:inline-block;vertical-align:top;width:50%;transition:width .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumn,#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumnMobile{display:block;width:100%}}#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumn img,#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumnMobile img{width:100%}#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumn .imageOverlay,#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumnMobile .imageOverlay{position:absolute;cursor:pointer}@media (max-width:1024px){#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumn{display:none}}#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumn .img1{top:0;left:0;width:100%;height:57%}#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumn .img2{top:58%;left:0;width:49%;height:42%}#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumn .img3{top:58%;left:51%;width:49%;height:42%}#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumnMobile{display:none}@media (max-width:1024px){#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumnMobile{display:block}}#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumnMobile .img1{top:0;left:0;width:100%;height:57%}#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumnMobile .img2{top:58%;left:0;width:49%;height:42%}#diamonds-direct .June2022 .midSection .midSectionWrapper .imageColumnMobile .img3{top:58%;left:51%;width:49%;height:42%}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn{display:inline-block;vertical-align:top;width:50%;transition:width .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn{display:block;width:100%}}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn .copyColumnWrapper{text-align:center;padding:60px 20px 30px}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn .copyColumnWrapper .copyP{color:#787878;font-size:24px;margin:0 0 20px}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn .copyColumnWrapper .copyVr{width:80%;height:2px;background:#b5912e;margin:40px auto}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn .copyColumnWrapper .copyTitle{color:#000;font-size:32px;font-weight:700;margin:0 0 5px}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn .copyColumnWrapper .copyTitle sup{font-size:24px;font-weight:100}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn .copyColumnWrapper .copySubtitle{color:#000;font-size:20px;font-weight:300;margin:0 0 20px}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn .copyColumnWrapper .copyDates{color:#000;font-size:28px;margin:0 0 40px}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn .copyColumnWrapper .copyButton{position:relative;width:240px;height:50px;color:#b5912e;background:#fff;border:1px solid #b5912e;cursor:pointer;margin:0 auto;font-size:18px;font-weight:700;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn .copyColumnWrapper .copyButton:hover{color:#fff;background:#b5912e}#diamonds-direct .June2022 .midSection .midSectionWrapper .copyColumn .copyColumnWrapper .copyButton div{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .June2022 .legalSection{margin:20px auto;width:90%;max-width:1024px;font-size:14px;text-align:center}#diamonds-direct .NoKidHungry{font-family:Lato,sans-serif;overflow:auto}#diamonds-direct .NoKidHungry .nkHeader{position:relative;margin:10px 0 0;background:#f5f5f5;text-align:center;height:80px}#diamonds-direct .NoKidHungry .nkHeader img{height:calc(100% - 20px);margin:10px auto}#diamonds-direct .NoKidHungry .nkCopyRow{background:#fff;overflow:auto}#diamonds-direct .NoKidHungry .nkCopyRow .nkCopyWrapper{width:90%;max-width:800px;margin:15px auto}#diamonds-direct .NoKidHungry .nkCopyRow .nkCopyWrapper img{width:100%}#diamonds-direct .NoKidHungry .nkInvolved{background:#f5f5f5;text-align:center;overflow:auto}#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper{width:90%;max-width:800px;margin:15px auto}#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper .nkInvolvedTitle{color:#000;margin:20px 0;font-size:24px;font-weight:700}@media (max-width:600px){#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper .nkInvolvedTitle{font-size:18px}}#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper .nkInvolvedItemWrapper{text-align:center}#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper .nkInvolvedItemWrapper .nkInvolvedItem{display:inline-block;width:calc(33.33% - 20px);margin:0 10px;vertical-align:top}@media (max-width:600px){#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper .nkInvolvedItemWrapper .nkInvolvedItem{width:calc(70% - 20px);margin:0 10px 25px}}#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper .nkInvolvedItemWrapper .nkInvolvedItem .nkItemIcon{height:40px}#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper .nkInvolvedItemWrapper .nkInvolvedItem .nkItemIcon img{height:100%}#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper .nkInvolvedItemWrapper .nkInvolvedItem .nkItemTitle{color:#616161;font-size:20px;font-weight:700;margin:10px 0}#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper .nkInvolvedItemWrapper .nkInvolvedItem .nkItemCopy{color:#000;text-align:left}#diamonds-direct .NoKidHungry .nkInvolved .nkInvolvedWrapper .nkInvolvedItemWrapper .nkInvolvedItem .itemEm{color:#d27044}#diamonds-direct .NoKidHungry .nkBody{position:relative;margin:0 auto 30px;width:90%;max-width:800px}#diamonds-direct .NoKidHungry .nkBody .nkBodyTitle{font-family:Lusitana,serif;color:#000;font-size:42px;margin:25px 0;text-align:center;text-transform:uppercase}@media (max-width:600px){#diamonds-direct .NoKidHungry .nkBody .nkBodyTitle{font-size:28px}}#diamonds-direct .NoKidHungry .nkBody .noKidText{margin:0 0 20px;font-size:17px;color:#000}#diamonds-direct .NoKidHungry .nkBody .lotWrapper{margin:0 0 20px}#diamonds-direct .NoKidHungry .nkBody .lotWrapper .lotTitle{font-size:36px;font-weight:700;text-align:center;color:#d27044;border-bottom:2px solid #d27044;margin-bottom:20px}@media (max-width:600px){#diamonds-direct .NoKidHungry .nkBody .lotWrapper .lotTitle{font-size:22px}}#diamonds-direct .NoKidHungry .nkBody .lotWrapper .itemsWrapper{text-align:center}#diamonds-direct .NoKidHungry .nkBody .lotWrapper .itemsWrapper .lotItem{display:inline-block;vertical-align:top;width:calc(25% - 10px);margin:0 5px 25px;cursor:pointer}@media (max-width:600px){#diamonds-direct .NoKidHungry .nkBody .lotWrapper .itemsWrapper .lotItem{width:calc(50% - 10px)}}#diamonds-direct .NoKidHungry .nkBody .lotWrapper .itemsWrapper .lotItem .lotImage img{width:100%}#diamonds-direct .NoKidHungry .nkBody .lotWrapper .itemsWrapper .lotItem .itemTitle{height:70px;font-weight:700;font-size:14px;color:#d27044;text-align:left;overflow:hidden}@media (max-width:1024px){#diamonds-direct .NoKidHungry .nkBody .lotWrapper .itemsWrapper .lotItem .itemTitle{height:80px;font-size:12px}}@media (max-width:600px){#diamonds-direct .NoKidHungry .nkBody .lotWrapper .itemsWrapper .lotItem .itemTitle{height:70px;font-size:12px}}#diamonds-direct .NoKidHungry .nkBody .nkWays{margin-bottom:20px;color:#000}#diamonds-direct .NoKidHungry .nkBody .nkWays .wayTitle{font-size:20px;font-weight:700}#diamonds-direct .NoKidHungry .nkBody .nkWays .wayText{font-size:18px}#diamonds-direct .NoKidHungry .nkBody .nkDisclaimer{font-size:12px;font-weight:300;color:#848484}#diamonds-direct .NoKidHungry .nkBody .nkButtonWrapper{text-align:center}#diamonds-direct .NoKidHungry .nkBody .nkButtonWrapper .nkSeeAllButton{display:inline-block;width:240px;height:50px;line-height:50px;cursor:pointer;font-size:15px;text-transform:uppercase;color:#d27044;background:hsla(0,0%,100%,0);border:1px solid #d27044;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .NoKidHungry .nkBody .nkButtonWrapper .nkSeeAllButton:hover{background:#d27044;color:#fff}#diamonds-direct .NoKidHungry .nkBody .nkTermo{margin:20px 0;font-weight:700;font-size:16px;overflow:auto}#diamonds-direct .NoKidHungry .nkBody .nkTermo .nkTermoWrapper{width:auto;max-width:600px;margin:0 auto;text-align:right}#diamonds-direct .NoKidHungry .nkBody .nkTermo .nkTermoWrapper .nkGoalText{color:#848484}#diamonds-direct .NoKidHungry .nkBody .nkTermo .nkTermoWrapper .nkBarWrapper{border:2px solid #d0d0d0;background:#e2e2e2;height:4px;border-radius:4px;position:relative}#diamonds-direct .NoKidHungry .nkBody .nkTermo .nkTermoWrapper .nkBarWrapper .nkBarFill{position:absolute;top:0;left:0;width:48%;bottom:0;background:#d27044;border-radius:2px}#diamonds-direct .NoKidHungry .nkBody .nkTermo .nkTermoWrapper .nkBarWrapper .nkBubble{position:absolute;top:-2px;left:calc(48% - 5px);width:4px;bottom:-2px;border-radius:4px;background:#fff;border:2px solid #d27044}#diamonds-direct .NoKidHungry .nkBody .nkTermo .nkTermoWrapper .nkCurrentText{width:calc(48% - 8px);padding:6px 6px 0 0;color:#d27044;border-right:2px solid #d27044}#diamonds-direct .NolaFlood2021 .productHeader img{width:100%}#diamonds-direct .NolaFlood2021 .itemArray{position:relative;overflow:auto;padding:30px 2%;width:80%;margin:-18% auto 25px}#diamonds-direct .NolaFlood2021 .itemArray .nolaNotice{background:#fff;width:calc(100% - 20px);margin:0 auto 25px;box-shadow:8px 8px 8px rgba(0,0,0,.4)}#diamonds-direct .NolaFlood2021 .itemArray .nolaNotice .nolaNoticeWrapper{padding:25px;background:#fff}#diamonds-direct .NolaFlood2021 .itemArray .nolaNotice .nolaNoticeWrapper .nolaTitle{text-align:center;font-size:32px;margin:0 0 20px}#diamonds-direct .NolaFlood2021 .itemArray .nolaNotice .nolaNoticeWrapper .nolaLine{width:60%;margin:0 auto 10px}#diamonds-direct .NolaFlood2021 .itemArray .nolaNotice .nolaNoticeWrapper .nolaLine img{width:100%}#diamonds-direct .NolaFlood2021 .itemArray .nolaNotice .nolaNoticeWrapper .nolaCopy{font-family:Lato,sans-serif;width:80%;margin:0 auto 15px;font-size:18px}#diamonds-direct .NolaFlood2021 .itemArray .nolaNotice .nolaNoticeWrapper .nolaCopy .nolaEm{font-weight:700}#diamonds-direct .NolaFlood2021 .itemArray .itemElement{cursor:pointer;width:calc(33.3% - 20px);float:left;margin:10px}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .itemThumb{position:relative}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .itemThumb .imgOverlay{position:absolute;cursor:pointer;background:#fff;opacity:0;top:0;left:0;width:100%;height:100%;transition:opacity .25s ease-in-out 0ms}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .itemThumb .imgOverlay .overlayTitle{position:absolute;top:0;left:10%;right:10%;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center;font-size:24px;font-weight:700;font-family:Lusitana,serif}@media (max-width:768px){#diamonds-direct .NolaFlood2021 .itemArray .itemElement .itemThumb .imgOverlay{display:none}}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .itemThumb img{width:100%}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .itemThumb:hover .imgOverlay{opacity:.75}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper{position:relative;overflow:hidden;height:100px;line-height:20px;font-size:18px;font-weight:700;color:#95989a;margin:5px 0 0}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper .itemName{position:relative;overflow:hidden;color:#000;padding:0;max-height:40px}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper .itemPrice{position:relative;height:20px;font-weight:300;text-align:left}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper .itemPriceAddendum{position:relative;height:40px;font-weight:300;text-align:left}#diamonds-direct .NolaFlood2021 .itemArray .actionItem{position:relative;background:#f7f9f8;background-image:url(\"/img/products/question.jpg\");background-size:cover;background-repeat:no-repeat;background-position:50%;padding-top:calc(33.3% - 20px);transition:background .25s ease-in-out 0ms;line-height:28px;font-size:26px;margin-bottom:130px}@media (max-width:768px){#diamonds-direct .NolaFlood2021 .itemArray .actionItem{margin-bottom:110px}}#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionPromptWrapper{display:block;top:calc(50% - 28px);height:56px;color:#333}#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionPromptHoverWrapper,#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionPromptWrapper{position:absolute;left:0;width:100%;text-align:center;transition:font-size .35s linear 0ms,line-height .35s linear 0ms,height .35s linear 0ms,opacity .35s linear 0ms}#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionPromptHoverWrapper{display:none;top:25%;height:50%;color:#fff}#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionPromptHoverWrapper .hoverIcon{position:absolute;left:0;bottom:0;width:100%}#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionPromptHoverWrapper .hoverIcon img{margin:0 auto;width:25%}#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionEm{font-weight:700}#diamonds-direct .NolaFlood2021 .itemArray .actionItem:hover{background:#ceacd3}#diamonds-direct .NolaFlood2021 .itemArray .actionItem:hover .actionPromptWrapper{display:none}#diamonds-direct .NolaFlood2021 .itemArray .actionItem:hover .actionPromptHoverWrapper{display:block}#diamonds-direct .NolaFlood2021 .itemArray .actionItem:active{background:#c69fcc}@media (max-width:1024px){#diamonds-direct .NolaFlood2021 .itemArray .actionItem{padding-top:calc(33.3% - 20px);line-height:22px;font-size:20px}#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionPromptWrapper{height:44px}}@media (max-width:768px){#diamonds-direct .NolaFlood2021 .itemArray .itemElement{width:calc(50% - 20px)}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper{height:90px;line-height:18px;font-size:16px}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper .itemName{max-height:36px}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper .itemPrice{height:18px}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper .itemPriceAddendum{height:36px}#diamonds-direct .NolaFlood2021 .itemArray .actionItem{padding-top:calc(50% - 20px);line-height:24px;font-size:22px}#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionPromptWrapper{height:48px}}@media (max-width:600px){#diamonds-direct .NolaFlood2021 .itemArray .actionItem{padding-top:calc(50% - 20px);line-height:22px;font-size:20px}#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionPromptWrapper{height:40px;line-height:20px;font-size:18px}}@media (max-width:480px){#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper{height:70px;line-height:14px;font-size:12px}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper .itemName{padding:0;max-height:28px}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper .itemPrice{height:14px}#diamonds-direct .NolaFlood2021 .itemArray .itemElement .labelWrapper .itemPriceAddendum{height:28px}#diamonds-direct .NolaFlood2021 .itemArray .actionItem{padding-top:calc(50% - 20px);line-height:18px;font-size:16px}#diamonds-direct .NolaFlood2021 .itemArray .actionItem .actionPromptWrapper{height:36px}}#diamonds-direct .Summer2020{font-family:Lato,sans-serif}#diamonds-direct .Summer2020 .formSection{position:relative;background:#f5f5f5;padding:0 0 25px}#diamonds-direct .Summer2020 .formSection .formHeader img{width:100%}#diamonds-direct .Summer2020 .formSection .formBoxWrapper{position:relative;background:#fff;border:1px solid #4d4d4d;width:90%;max-width:800px;margin:-25% auto 25px;z-index:3}@media (max-width:600px){#diamonds-direct .Summer2020 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#4d4d4d;text-align:center;margin:0 0 25px}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#29583f;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:gray;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid gray;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid gray}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#fff;background:#29583f;border:none;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{background:#204632}#diamonds-direct .Summer2020 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:gray;font-size:13px;text-align:center}#diamonds-direct .Summer2020 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Summer2020 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Summer2020 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Summer2020 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Summer2020 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Summer2020 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Summer2020 .designersSection{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/summer2020/designerbg.jpg\");background-repeat:no-repeat;background-position:0 0;background-size:100% 100%;overflow:auto}@media (max-width:600px){#diamonds-direct .Summer2020 .designersSection{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/summer2020/designerbg_m.jpg\")}}#diamonds-direct .Summer2020 .designersSection .designersTitle{width:90%;max-width:400px;margin:40px auto 20px}#diamonds-direct .Summer2020 .designersSection .designersTitle img{width:100%}#diamonds-direct .Summer2020 .designersSection .designersP{width:90%;max-width:800px;margin:0 auto 25px}#diamonds-direct .Summer2020 .designersSection .designersSelectWrapper{position:relative;width:80%;max-width:300px;margin:0 auto 25px;z-index:2}#diamonds-direct .Summer2020 .designersSection .designerResultsWrapper{width:90%;max-width:800px;margin:0 auto 25px;text-align:center}#diamonds-direct .Summer2020 .designersSection .designerResultsWrapper .designerWrapper{display:inline-block;height:75px;width:auto;max-width:160px;margin:0 10px 25px;overflow:hidden;cursor:pointer}@media (max-width:600px){#diamonds-direct .Summer2020 .designersSection .designerResultsWrapper .designerWrapper{max-width:140px;height:75px}}#diamonds-direct .Summer2020 .designersSection .designerResultsWrapper .designerWrapper img{height:100%;width:100%;object-fit:contain}#diamonds-direct .Summer2020 .looksSection{position:relative;background:#f5f5f5;padding:30px 0;overflow:auto}@media (max-width:600px){#diamonds-direct .Summer2020 .looksSection{padding:0}}#diamonds-direct .Summer2020 .looksSection .looksTop{position:relative;width:90%;max-width:800px;margin:0 auto 25px;z-index:1}@media (max-width:600px){#diamonds-direct .Summer2020 .looksSection .looksTop{width:100%}}#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopImgWrapper{position:relative;width:40%;display:inline-block;vertical-align:top}@media (max-width:600px){#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopImgWrapper{display:block;width:100%}}#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopImgWrapper img{width:100%}#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopImgWrapper img.mobile_title{position:absolute;left:15%;width:70%;bottom:5%}#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper{width:60%;display:inline-block;vertical-align:top}@media (max-width:600px){#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper{width:100%;display:block}}#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper .looksTitle{margin:30px 20% 0;transition:margin .35s linear 0ms}@media (max-width:900px){#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper .looksTitle{margin:20px 25% 0}}#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper .looksTitle img{width:100%}#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper .looksLeaf{width:40px;margin:0 auto;transition:width .35s linear 0ms}@media (max-width:900px){#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper .looksLeaf{width:30px}}#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper .looksLeaf img{width:100%}#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper .looksP{margin:20px 20% 0;text-align:left;color:#000;font-size:16px}@media (max-width:900px){#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper .looksP{font-size:14px}}@media (max-width:600px){#diamonds-direct .Summer2020 .looksSection .looksTop .lookTopTitleWrapper .looksP{font-size:16px;margin:25px 10%}}#diamonds-direct .Summer2020 .looksSection .looksBottom{width:90%;max-width:800px;margin:25px auto;z-index:1}@media (max-width:600px){#diamonds-direct .Summer2020 .looksSection .looksBottom{width:100%}}#diamonds-direct .Summer2020 .looksSection .looksBottom .gridWrapper{position:relative;display:inline-block;vertical-align:top;width:calc(57.5% - 10px);margin:0 10px 0 0;z-index:1}@media (max-width:600px){#diamonds-direct .Summer2020 .looksSection .looksBottom .gridWrapper{width:100%;display:block}}#diamonds-direct .Summer2020 .looksSection .looksBottom .gridWrapper .gridItemWrapper{position:relative;display:inline-block;vertical-align:top;width:calc(50% - 5px);margin:0 0 10px}#diamonds-direct .Summer2020 .looksSection .looksBottom .gridWrapper .gridItemWrapper:nth-child(odd){margin:0 10px 10px 0}#diamonds-direct .Summer2020 .looksSection .looksBottom .gridWrapper .gridItemWrapper .gridImgWrapper img{width:100%}#diamonds-direct .Summer2020 .looksSection .looksBottom .gridWrapper .gridItemWrapper .gridLabel{display:none;position:absolute;left:0;right:0;bottom:0;height:12%;font-size:14px}#diamonds-direct .Summer2020 .looksSection .looksBottom .singleWrapper{display:inline-block;vertical-align:top;width:42.5%;position:relative;z-index:1}@media (max-width:600px){#diamonds-direct .Summer2020 .looksSection .looksBottom .singleWrapper{width:100%;display:block;margin:0 0 40px}}#diamonds-direct .Summer2020 .looksSection .looksBottom .singleWrapper .singleImgWrapper img{width:100%}#diamonds-direct .Summer2020 .looksSection .looksBottom .singleWrapper .singleLabel{display:none;position:absolute;left:0;right:0;top:100%;height:30px;font-size:14px}#diamonds-direct .Summer2020 .looksSection .looksFooter{position:absolute;left:0;right:0;bottom:0;height:auto}#diamonds-direct .Summer2020 .looksSection .looksFooter img{width:100%}#diamonds-direct .Fall2020{background:#000;overflow:auto}#diamonds-direct .Fall2020 .topHeader{position:relative}#diamonds-direct .Fall2020 .topHeader img{width:100%}#diamonds-direct .Fall2020 .topHeader .buttonWrapper{position:absolute;cursor:pointer;top:45%;left:60%;width:16%}@media (max-width:768px){#diamonds-direct .Fall2020 .topHeader .buttonWrapper{top:60%;left:35%;width:30%}}#diamonds-direct .Fall2020 .topHeader .buttonWrapper img{width:100%}#diamonds-direct .Fall2020 .topHeader .nkWrapper{position:absolute;cursor:pointer;top:52%;left:63.5%;width:10%}@media (max-width:768px){#diamonds-direct .Fall2020 .topHeader .nkWrapper{top:65%;left:40%;width:20%}}#diamonds-direct .Fall2020 .topHeader .nkWrapper img{width:100%}#diamonds-direct .Fall2020 .topHeader .linkWrapper{text-decoration:underline;text-align:center;position:absolute;cursor:pointer;color:#fff;font-family:Lato,sans-serif;font-size:14px;top:58.5%;left:42%;width:52%}@media (max-width:900px){#diamonds-direct .Fall2020 .topHeader .linkWrapper{font-size:12px}}@media (max-width:768px){#diamonds-direct .Fall2020 .topHeader .linkWrapper{font-size:14px;top:72%;left:20%;width:60%}}#diamonds-direct .Fall2020 .midSection{position:relative;margin:-13% 0 0}@media (max-width:768px){#diamonds-direct .Fall2020 .midSection{margin:0}}#diamonds-direct .Fall2020 .midSection .leafWrapper{position:absolute;top:-2.5%;right:0;width:25%}@media (max-width:768px){#diamonds-direct .Fall2020 .midSection .leafWrapper{display:none}}#diamonds-direct .Fall2020 .midSection .leafWrapper img{width:100%}#diamonds-direct .Fall2020 .midSection .midSectionWrapper{margin:0 auto;width:90%;max-width:800px}@media (max-width:768px){#diamonds-direct .Fall2020 .midSection .midSectionWrapper{width:100%}}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .leftColumn{display:inline-block;vertical-align:top;width:50%}@media (max-width:768px){#diamonds-direct .Fall2020 .midSection .midSectionWrapper .leftColumn{display:block;width:100%}}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .leftColumn img{width:100%}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn{position:relative;display:inline-block;vertical-align:top;width:50%}@media (max-width:768px){#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn{display:block;width:100%}}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .leafMobile{position:absolute;top:-5px;right:0;width:50%}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .leafMobile img{width:100%;display:block}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .rightWrapper{margin:45% 0 0;color:#fff;text-align:center;overflow:auto}@media (max-width:900px){#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .rightWrapper{margin:30% 0 0}}@media (max-width:768px){#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .rightWrapper{margin:0}}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .rightWrapper .timelessTitle{height:120px}@media (max-width:768px){#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .rightWrapper .timelessTitle{height:100px;margin:60px 0 0}}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .rightWrapper .timelessTitle img{height:100%}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .rightWrapper .timelessLeaf{height:40px;margin:10px 0}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .rightWrapper .timelessLeaf img{height:100%}#diamonds-direct .Fall2020 .midSection .midSectionWrapper .rightColumn .rightWrapper .timelessBody{font-family:Lato,sans-serif;width:80%;margin:0 auto}#diamonds-direct .Fall2020 .bottomSection{position:relative;margin:25px 0 50px}#diamonds-direct .Fall2020 .bottomSection .topLeaf{position:absolute;top:-100px;left:0;width:25%}#diamonds-direct .Fall2020 .bottomSection .topLeaf img{width:100%}#diamonds-direct .Fall2020 .bottomSection .bottomLeaf{position:absolute;bottom:-50px;right:0;width:25%}#diamonds-direct .Fall2020 .bottomSection .bottomLeaf img{width:100%}#diamonds-direct .Fall2020 .bottomSection .imgSection{position:relative;z-index:1}#diamonds-direct .Fall2020 .bottomSection .imgSection .smallWrapper{width:50%;margin:0 0 10px 50%;text-align:right}#diamonds-direct .Fall2020 .bottomSection .imgSection .largeWrapper img,#diamonds-direct .Fall2020 .bottomSection .imgSection .smallWrapper img{width:100%}#diamonds-direct .Fall2020 .bottomSection .imgSection .col1,#diamonds-direct .Fall2020 .bottomSection .imgSection .col3{display:inline-block;vertical-align:top;width:calc(39.4% - 8px)}#diamonds-direct .Fall2020 .bottomSection .imgSection .col2{display:inline-block;vertical-align:top;width:calc(21.2% - 8px);margin:0 12px}#diamonds-direct .Fall2020 .bottomSection .imgSection .col2 img{width:100%;margin:0 0 10px}#diamonds-direct .Fall2020 .bottomSection .imgSection .col3 .smallWrapper{margin-top:10px;margin:10px 50% 10px 0}#diamonds-direct .Fall2020 .bottomSection .imgSection2{position:relative;z-index:1}#diamonds-direct .Fall2020 .bottomSection .imgSection2 img{width:100%}#diamonds-direct .Fall2020 .bottomSection .imgSection2 .imgLink{position:absolute;width:23%;height:32%;cursor:pointer}#diamonds-direct .Fall2020 .bottomSection .imgSection2 .link01.imgLink{top:34%;left:38.5%}#diamonds-direct .Fall2020 .bottomSection .imgSection2 .link02.imgLink{top:0;left:14%}#diamonds-direct .Fall2020 .bottomSection .imgSection2 .link03.imgLink{top:0;left:38.5%}#diamonds-direct .Fall2020 .bottomSection .imgSection2 .link04.imgLink{top:34%;left:0;width:38%;height:65%}#diamonds-direct .Fall2020 .bottomSection .imgSection2 .link05.imgLink{top:0;left:63%;width:38%;height:65%}#diamonds-direct .Fall2020 .bottomSection .imgSection2 .link06.imgLink{top:68%;left:38.5%}#diamonds-direct .Fall2020 .bottomSection .imgSection2 .link07.imgLink{top:68%;left:63%}#diamonds-direct .Fall2020 .bottomMobileSection{margin:50px 0 0}#diamonds-direct .Fall2020 .bottomMobileSection .smImgRow{margin:0 0 10px}#diamonds-direct .Fall2020 .bottomMobileSection .smImgRow .smImg{display:inline-block;vertical-align:top;width:calc(50% - 10px);margin:0 5px}#diamonds-direct .Fall2020 .bottomMobileSection .smImgRow .smImg img{width:100%;cursor:pointer}#diamonds-direct .Fall2020 .bottomMobileSection .lgImgRow{margin:0 5px 10px}#diamonds-direct .Fall2020 .bottomMobileSection .lgImgRow img{width:100%;cursor:pointer}#diamonds-direct .SingleDesigner2020{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/singledesigner2020/landing_top.jpg\");background-repeat:no-repeat;background-position:0 0;background-size:100% auto}@media (max-width:600px){#diamonds-direct .SingleDesigner2020{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/singledesigner2020/landing_top_m.jpg\")}}#diamonds-direct .SingleDesigner2020 .formSection{position:relative;padding:0 0 25px}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper{position:relative;background:#fff;overflow:auto;width:90%;max-width:800px;margin:25px auto;z-index:3}@media (max-width:600px){#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper{margin:10px;border:1px solid #ba5db7;padding:25px}@media (max-width:600px){#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper{border:none}}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#4d4d4d;text-align:center;margin:0 0 25px}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#29583f;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:gray;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid gray;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid gray}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:20px 0 10px}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#fff;background:#48365c;border:none;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;font-family:Lato,sans-serif;transition:background .25s ease-in-out 0ms}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{background:#ba5db7}#diamonds-direct .SingleDesigner2020 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:gray;font-size:13px;text-align:center}#diamonds-direct .SingleDesigner2020 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .SingleDesigner2020 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .SingleDesigner2020 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .SingleDesigner2020 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .SingleDesigner2020 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .SingleDesigner2020 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .SingleDesigner2020 .designersSection{overflow:auto}#diamonds-direct .SingleDesigner2020 .designersSection .designersTitle{width:90%;max-width:500px;margin:13% auto 20px}@media (max-width:768px){#diamonds-direct .SingleDesigner2020 .designersSection .designersTitle{max-width:400px;max-width:320px;margin:22% auto 20px}}#diamonds-direct .SingleDesigner2020 .designersSection .designersTitle img{width:100%}#diamonds-direct .SingleDesigner2020 .designersSection .designersP{color:#4d4d4d;width:90%;max-width:800px;margin:0 auto 25px;text-align:center}#diamonds-direct .SingleDesigner2020 .designersSection .designersSelectWrapper{position:relative;width:80%;max-width:300px;margin:0 auto 25px;z-index:2;font-family:Lato,sans-serif}#diamonds-direct .SingleDesigner2020 .designersSection .designerResultsWrapper{width:90%;max-width:800px;margin:0 auto 25px;text-align:center}#diamonds-direct .SingleDesigner2020 .designersSection .designerResultsWrapper .designerWrapper{display:inline-block;height:75px;width:auto;max-width:160px;margin:0 10px 25px;overflow:hidden;cursor:pointer}@media (max-width:600px){#diamonds-direct .SingleDesigner2020 .designersSection .designerResultsWrapper .designerWrapper{max-width:140px;height:75px}}#diamonds-direct .SingleDesigner2020 .designersSection .designerResultsWrapper .designerWrapper img{height:100%;width:100%;object-fit:contain}#diamonds-direct .SingleDesigner2020 .looksSection{overflow:auto;margin:-10% 0 0}#diamonds-direct .SingleDesigner2020 .looksSection .looksWrapper .looksColumn{display:inline-block;vertical-align:top;width:50%}@media (max-width:600px){#diamonds-direct .SingleDesigner2020 .looksSection .looksWrapper .looksColumn{display:block;width:100%}}#diamonds-direct .SingleDesigner2020 .looksSection .looksWrapper .looksColumn .largeCell{margin:0 5px 10px}#diamonds-direct .SingleDesigner2020 .looksSection .looksWrapper .looksColumn .largeCell img{width:100%;cursor:pointer}#diamonds-direct .SingleDesigner2020 .looksSection .looksWrapper .looksColumn .smallCell{margin:0 0 10px}#diamonds-direct .SingleDesigner2020 .looksSection .looksWrapper .looksColumn .smallCell .smallCellImg{display:inline-block;vertical-align:top;width:calc(50% - 10px);margin:0 5px}#diamonds-direct .SingleDesigner2020 .looksSection .looksWrapper .looksColumn .smallCell .smallCellImg img{width:100%;cursor:pointer}#diamonds-direct .SingleDesigner2021 .promoBanner{position:relative;width:100%}#diamonds-direct .SingleDesigner2021 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .promoBanner img.desktop600{display:none}}#diamonds-direct .SingleDesigner2021 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .promoBanner img.mobile600{display:block}}#diamonds-direct .SingleDesigner2021 .promoBanner .headerSelectWrapper{position:absolute;top:55%;left:30%;width:40%;height:5%}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .promoBanner .headerSelectWrapper{top:70%;left:20%;width:60%}}#diamonds-direct .SingleDesigner2021 .promoBanner .headerSelectWrapper .singleSelect{background:#fff}#diamonds-direct .SingleDesigner2021 .designersWrapper{margin:-7% 0 0;position:relative;z-index:10;min-height:100px}#diamonds-direct .SingleDesigner2021 .designersWrapper .designerBlock .designerBanner{margin:25px auto;width:60%;max-width:240px;text-align:center}#diamonds-direct .SingleDesigner2021 .designersWrapper .designerBlock .designerBanner img{max-width:100%;max-height:100%}#diamonds-direct .SingleDesigner2021 .designersWrapper .designerBlock .designerDisplay{margin:0 0 40px}#diamonds-direct .SingleDesigner2021 .designersWrapper .designerBlock .designerDisplay .daysWrapper{text-align:center}#diamonds-direct .SingleDesigner2021 .designersWrapper .designerBlock .designerDisplay .daysWrapper .dayBlock{display:inline-block;width:calc(50% - 1px);max-width:240px;vertical-align:top}#diamonds-direct .SingleDesigner2021 .designersWrapper .designerBlock .designerDisplay .daysWrapper .dayBlock:first-child{border-right:1px solid #333}#diamonds-direct .SingleDesigner2021 .designersWrapper .designerBlock .designerDisplay .daysWrapper .dayBlock .dayValue{font-size:24px;font-weight:700}#diamonds-direct .SingleDesigner2021 .designersWrapper .designerBlock .designerDisplay .daysWrapper .dayBlock .timeValue{font-family:Lato,sans-serif;font-size:20px}#diamonds-direct .SingleDesigner2021 .formBoxWrapper{position:relative;overflow:auto;background:#f0f0f0;margin:0 auto;z-index:3;font-family:Lato,sans-serif}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper{width:90%;max-width:1024px;margin:25px auto}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formP{color:#333;text-align:center;margin:0 0 25px;padding-top:15px;font-size:20px;font-weight:400}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formTitle{color:#5e5e5e;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formDates{color:#5e5e5e;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #5e5e5e;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #5e5e5e;background:#fff}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#333;background:#fff;border:1px solid #333;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#333}#diamonds-direct .SingleDesigner2021 .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#5e5e5e;font-size:13px;text-align:center}#diamonds-direct .SingleDesigner2021 .boxSection{text-align:center;color:#532282;margin:0 auto;font-family:Lusitana,serif;width:90%;max-width:1200px;padding:25px 0}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .boxSection{margin:0 auto}}#diamonds-direct .SingleDesigner2021 .boxSection .fuImage{margin:0 auto 30px;width:60%;max-width:450px}#diamonds-direct .SingleDesigner2021 .boxSection .fuImage img{width:100%}#diamonds-direct .SingleDesigner2021 .boxSection .fuP{font-size:20px;margin:0 0 10px;color:#5e5e5e}#diamonds-direct .SingleDesigner2021 .boxSection .fuP .fuPBold{font-weight:700}#diamonds-direct .SingleDesigner2021 .boxSection .fuLegal{text-align:left;font-size:13px;font-weight:300;color:#5e5e5e;padding:0 25px}#diamonds-direct .SingleDesigner2021 .boxSection .fuBox{color:#532282;border:1px solid #5e5e5e;margin:10px auto;padding:10px;font-family:Lato,sans-serif;width:90%;max-width:480px}#diamonds-direct .SingleDesigner2021 .boxSection .fuBox .box1{font-weight:900;font-size:26px}#diamonds-direct .SingleDesigner2021 .boxSection .fuBox .box2{font-weight:300}#diamonds-direct .SingleDesigner2021 .boxSection .fuBox .box3{font-weight:400;margin:5px 0 0;font-size:20px}#diamonds-direct .SingleDesigner2021 .boxSection .fuBox .boxButton{position:relative;font-size:14px;border:1px solid #532282;color:#532282;background:#fff;width:180px;height:36px;margin:25px auto;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .SingleDesigner2021 .boxSection .fuBox .boxButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .SingleDesigner2021 .boxSection .fuBox .boxButton:hover{color:#fff;background:#532282}#diamonds-direct .SingleDesigner2021 .boxSection .fuSave{height:35px}#diamonds-direct .SingleDesigner2021 .boxSection .fuSave img{height:100%}#diamonds-direct .SingleDesigner2021 .boxSection .fuDates{font-size:28px;margin:5px auto 10px;width:300px}#diamonds-direct .SingleDesigner2021 .boxSection .fuDates img{width:100%}#diamonds-direct .SingleDesigner2021 .imagesSection{position:relative;width:100%}#diamonds-direct .SingleDesigner2021 .imagesSection img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .imagesSection img.desktop600{display:none}}#diamonds-direct .SingleDesigner2021 .imagesSection img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .imagesSection img.mobile600{display:block}}#diamonds-direct .SingleDesigner2021 .imagesSection .imgLink{position:absolute;cursor:pointer}#diamonds-direct .SingleDesigner2021 .imagesSection .img1{top:0;left:0;width:30%;height:100%}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .imagesSection .img1{top:0;left:0;width:100%;height:36%}}#diamonds-direct .SingleDesigner2021 .imagesSection .img2{top:0;left:31%;width:34.5%;height:50%}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .imagesSection .img2{top:36.5%;left:0;width:100%;height:15%}}#diamonds-direct .SingleDesigner2021 .imagesSection .img3{top:50%;left:31%;width:16.5%;height:50%}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .imagesSection .img3{top:52%;left:0;width:50%;height:16%}}#diamonds-direct .SingleDesigner2021 .imagesSection .img4{top:50%;left:48.5%;width:17%;height:50%}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .imagesSection .img4{top:52%;left:50%;width:50%;height:16%}}#diamonds-direct .SingleDesigner2021 .imagesSection .img5{top:0;left:66%;width:34%;height:100%}@media (max-width:600px){#diamonds-direct .SingleDesigner2021 .imagesSection .img5{top:68%;left:0;width:100%;height:32%}}#diamonds-direct .Holiday2020{font-family:Lato,sans-serif}#diamonds-direct .Holiday2020 .formSection{position:relative;background:#13133d;padding:0}#diamonds-direct .Holiday2020 .formSection .formHeader img{width:100%}#diamonds-direct .Holiday2020 .formSection .formUpperSection{text-align:center;color:#fff;margin:10px auto 0;font-family:Lusitana,serif;width:90%;max-width:1200px}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuP{font-size:20px;margin:0 0 10px}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuBox{color:#fff;border:1px solid #fff;margin:25px auto;padding:10px;font-family:Lato,sans-serif;width:90%;max-width:480px}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuBox .box1{font-weight:900;font-size:26px}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuBox .box2{font-weight:300}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuBox .box3{font-weight:400;margin:5px 0 0;font-size:20px}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuBox .boxButton{position:relative;font-size:14px;text-transform:uppercase;border:1px solid #fff;color:#fff;background:#13133d;width:180px;height:36px;margin:15px auto;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuBox .boxButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuBox .boxButton:hover{color:#13133d;background:#fff}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuSave{height:35px}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuSave img{height:100%}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuDates{font-size:28px;margin:5px auto 10px;width:300px}#diamonds-direct .Holiday2020 .formSection .formUpperSection .fuDates img{width:100%}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper{position:relative;overflow:auto;color:#000;background:#fff;width:100%;margin:0 auto 25px;z-index:3}@media (max-width:600px){#diamonds-direct .Holiday2020 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper{width:90%;max-width:800px;margin:25px auto}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#000;text-align:center;margin:0 0 25px;padding-top:15px}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#29583f;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:gray;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid gray;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid gray;background:#fff}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#13133d;background:#fff;border:1px solid #13133d;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#13133d}#diamonds-direct .Holiday2020 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:gray;font-size:13px;text-align:center}#diamonds-direct .Holiday2020 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Holiday2020 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Holiday2020 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Holiday2020 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Holiday2020 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Holiday2020 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Holiday2020 .designersSection{width:100%;margin:0 auto;padding:25px 0;background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2020/dec/gg_bg.jpg\");background-repeat:no-repeat;background-position:50%;background-size:cover}@media (max-width:768px){#diamonds-direct .Holiday2020 .designersSection{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2020/dec/gg_bg_mob.jpg\")}}#diamonds-direct .Holiday2020 .designersSection .designersTitle{width:90%;max-width:400px;margin:20px auto 0}#diamonds-direct .Holiday2020 .designersSection .designersTitle img{width:100%}#diamonds-direct .Holiday2020 .designersSection .designersHr{width:90%;max-width:800px;margin:0 auto 25px}#diamonds-direct .Holiday2020 .designersSection .designersHr img{width:100%}#diamonds-direct .Holiday2020 .designersSection .designersP{text-align:center;color:#fff;font-family:Lusitana,serif;font-size:20px;margin:0 3% 10px}#diamonds-direct .Holiday2020 .designersSection .designersSelectWrapper{position:relative;width:80%;max-width:300px;margin:0 auto 25px}#diamonds-direct .Holiday2020 .designersSection .designersSelectWrapper .ggButton{color:#fff;background:#13133d;border:1px solid #fff;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;text-align:center;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Holiday2020 .designersSection .designersSelectWrapper .ggButton:hover{color:#13133d;background:#fff}#diamonds-direct .Holiday2020 .designersSection .designerResultsWrapper{width:90%;max-width:800px;margin:0 auto 25px;text-align:center}#diamonds-direct .Holiday2020 .designersSection .designerResultsWrapper .designerWrapper{display:inline-block;height:75px;width:auto;max-width:160px;margin:0 10px 25px;overflow:hidden;cursor:pointer}@media (max-width:600px){#diamonds-direct .Holiday2020 .designersSection .designerResultsWrapper .designerWrapper{max-width:140px;height:75px}}#diamonds-direct .Holiday2020 .designersSection .designerResultsWrapper .designerWrapper img{height:100%;width:100%;object-fit:contain}#diamonds-direct .Holiday2020 .footerSection{background-color:#13133d;background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2020/dec/footer.png\");background-repeat:no-repeat;background-position:0 0;background-size:100% 100%;overflow:auto}@media (max-width:768px){#diamonds-direct .Holiday2020 .footerSection{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2020/dec/footer_mob.png\")}}#diamonds-direct .Holiday2020 .footerSection .footerWrapper{width:90%;max-width:1200px;margin:0 auto 25px;text-align:center}#diamonds-direct .Holiday2020 .footerSection .footerWrapper .footerProduct{display:inline-block;vertical-align:top;margin:0 5px 10px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Holiday2020 .footerSection .footerWrapper .footerProduct{width:calc(50% - 12px)}}#diamonds-direct .Holiday2020 .footerSection .footerWrapper .footerProduct .footerImg{border:2px solid #000;background:#fff}#diamonds-direct .Holiday2020 .footerSection .footerWrapper .footerProduct .footerImg img{width:100%}#diamonds-direct .Holiday2020 .footerSection .footerWrapper .footerProduct .footerLabel{margin:3px 0 0;font-weight:700;color:#000;text-align:left}#diamonds-direct .Holiday2020 .footerSection .footerLegal{font-size:14px;font-weight:400;font-family:Lato,sans-serif;color:#000;margin:5px 0;text-align:center}#diamonds-direct .JaxClub{text-align:center;color:#000}#diamonds-direct .JaxClub .jaxHeader img{width:100%}#diamonds-direct .JaxClub .jaxMiddle .jaxMiddleWrapper{width:90%;max-width:1024px;margin:25px auto 0}#diamonds-direct .JaxClub .jaxMiddle .jaxMiddleWrapper .jaxP{font-size:18px;margin:0 0 25px}#diamonds-direct .JaxClub .jaxMiddle .jaxMiddleWrapper .jaxShopButton{position:relative;color:#000;background:#fff;border:1px solid #000;margin:15px auto;cursor:pointer;width:200px;height:36px;font-size:15px;font-family:Lato,sans-serif;font-weight:700;text-transform:uppercase;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .JaxClub .jaxMiddle .jaxMiddleWrapper .jaxShopButton:hover{color:#fff;background:#000}#diamonds-direct .JaxClub .jaxMiddle .jaxMiddleWrapper .jaxShopButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .JaxClub .jaxMiddle .jaxMiddleWrapper .jaxHr{width:70%;margin:10px auto 0}#diamonds-direct .JaxClub .jaxMiddle .jaxMiddleWrapper .jaxHr img{width:100%}#diamonds-direct .JaxClub .jaxFooter{font-family:Lato,sans-serif;background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/jaxclub2020/4840foot.jpg\");background-repeat:no-repeat;background-position:50%;background-size:cover;overflow:auto}@media (max-width:768px){#diamonds-direct .JaxClub .jaxFooter{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/jaxclub2020/4840footm.jpg\")}}#diamonds-direct .JaxClub .jaxFooter .jaxFooterWrapper{width:90%;max-width:1024px;margin:0 auto}#diamonds-direct .JaxClub .jaxFooter .jaxFooterWrapper .jaxFootP{font-size:20px;font-weight:700;margin:10px 0}@media (max-width:768px){#diamonds-direct .JaxClub .jaxFooter .jaxFooterWrapper .jaxFootP{font-size:18px}}#diamonds-direct .JaxClub .jaxFooter .jaxFooterWrapper .jaxFootIcon{font-size:24px;margin:10px 0}#diamonds-direct .JaxClub .jaxFooter .jaxFooterWrapper .jaxLegal{font-size:13px;margin:20px 0}#diamonds-direct .Valentines2021{font-family:Lato,sans-serif}#diamonds-direct .Valentines2021 .formSection{position:relative;background:#fff;padding:0}#diamonds-direct .Valentines2021 .formSection .formHeader img{width:100%}#diamonds-direct .Valentines2021 .formSection .formUpperSection{text-align:center;color:#000;margin:-20px auto 0;font-family:Lusitana,serif;width:90%;max-width:1200px}@media (max-width:600px){#diamonds-direct .Valentines2021 .formSection .formUpperSection{margin:0 auto}}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuP{font-size:20px;margin:0 0 10px}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuP .fuPBold{font-weight:700}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuBox{color:#000;border:1px solid #000;margin:25px auto;padding:10px;font-family:Lato,sans-serif;width:90%;max-width:480px}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuBox .box1{font-weight:900;font-size:26px}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuBox .box2{font-weight:300}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuBox .box3{font-weight:400;margin:5px 0 0;font-size:20px}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuBox .boxButton{position:relative;font-size:14px;text-transform:uppercase;border:1px solid #000;color:#000;background:#fff;width:180px;height:36px;margin:15px auto;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuBox .boxButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuBox .boxButton:hover{color:#fff;background:#000}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuSave{height:35px}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuSave img{height:100%}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuDates{font-size:28px;margin:5px auto 10px;width:300px}#diamonds-direct .Valentines2021 .formSection .formUpperSection .fuDates img{width:100%}#diamonds-direct .Valentines2021 .formSection .designersSection{overflow:auto}#diamonds-direct .Valentines2021 .formSection .designersSection .designersTitle{width:90%;max-width:500px;margin:13% auto 20px}@media (max-width:768px){#diamonds-direct .Valentines2021 .formSection .designersSection .designersTitle{max-width:400px;max-width:320px;margin:22% auto 20px}}#diamonds-direct .Valentines2021 .formSection .designersSection .designersTitle img{width:100%}#diamonds-direct .Valentines2021 .formSection .designersSection .designersP{color:#4d4d4d;width:90%;max-width:800px;margin:0 auto 25px;text-align:center}#diamonds-direct .Valentines2021 .formSection .designersSection .designersSelectWrapper{position:relative;width:80%;max-width:300px;margin:0 auto 25px;z-index:2;font-family:Lato,sans-serif}#diamonds-direct .Valentines2021 .formSection .designersSection .designerResultsWrapper{width:90%;max-width:800px;margin:0 auto 25px;text-align:center}#diamonds-direct .Valentines2021 .formSection .designersSection .designerResultsWrapper .designerWrapper{display:inline-block;height:75px;width:auto;max-width:160px;margin:0 10px 25px;overflow:hidden;cursor:pointer}@media (max-width:600px){#diamonds-direct .Valentines2021 .formSection .designersSection .designerResultsWrapper .designerWrapper{max-width:140px;height:75px}}#diamonds-direct .Valentines2021 .formSection .designersSection .designerResultsWrapper .designerWrapper img{height:100%;width:100%;object-fit:contain}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper{position:relative;overflow:auto;color:valentines211;background:#ded0f2;width:100%;max-width:1200px;margin:0 auto 25px;z-index:3}@media (max-width:600px){#diamonds-direct .Valentines2021 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper{width:90%;max-width:800px;margin:25px auto}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#000;text-align:center;margin:0 0 25px;padding-top:15px}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#29583f;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:gray;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid gray;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid gray;background:#fff}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#000;background:#fff;border:1px solid #000;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#000}#diamonds-direct .Valentines2021 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:gray;font-size:13px;text-align:center}#diamonds-direct .Valentines2021 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Valentines2021 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Valentines2021 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Valentines2021 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Valentines2021 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Valentines2021 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Valentines2021 .trendsSection{margin:0 auto;width:90%;max-width:1200px}#diamonds-direct .Valentines2021 .trendsSection .trendsTitle{width:90%;max-width:400px;margin:20px auto 0}#diamonds-direct .Valentines2021 .trendsSection .trendsTitle img{width:100%}#diamonds-direct .Valentines2021 .trendsSection .trendsBlock{position:relative;width:100%;height:500px;margin:20px 0 0}@media (max-width:768px){#diamonds-direct .Valentines2021 .trendsSection .trendsBlock{height:auto}}#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsImgBlock{position:absolute;height:100%;background-repeat:no-repeat;background-position:0 0;background-size:cover;cursor:pointer}#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsLeft{top:0;left:0;width:calc(50% - 5px)}@media (max-width:768px){#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsLeft{width:100%;padding-bottom:50%;position:relative;margin:0 0 10px}}#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsLeft .trendsFirst{top:0;left:0;width:calc(50% - 5px)}@media (max-width:768px){#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsLeft .trendsFirst{width:100%}}#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsLeft .trendsFirst .trendsTop{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/trend1.jpg\");position:absolute;top:0;left:0;width:100%;height:calc(50% - 5px)}@media (max-width:768px){#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsLeft .trendsFirst .trendsTop{top:0;left:0;width:calc(50% - 5px);height:100%}}#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsLeft .trendsFirst .trendsBottom{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/trend2.jpg\");bottom:0;left:0;width:100%;height:calc(50% - 5px)}@media (max-width:768px){#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsLeft .trendsFirst .trendsBottom{top:0;left:calc(50% + 5px);width:calc(50% - 5px);height:100%}}#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsLeft .trendsSecond{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/trend3.jpg\");top:0;right:0;width:calc(50% - 5px)}@media (max-width:768px){#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsLeft .trendsSecond{display:none}}#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsRight{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/valentines2021/landing/assets/trend4.jpg\");top:0;right:0;width:calc(50% - 5px)}@media (max-width:768px){#diamonds-direct .Valentines2021 .trendsSection .trendsBlock .trendsRight{width:100%;padding-bottom:100%;position:relative}}#diamonds-direct .Valentines2021 .designersSection{width:100%;margin:0 auto;padding:25px 0}#diamonds-direct .Valentines2021 .designersSection .designersTitle{width:90%;max-width:400px;margin:20px auto 0}#diamonds-direct .Valentines2021 .designersSection .designersTitle img{width:100%}#diamonds-direct .Valentines2021 .designersSection .designersHr{width:90%;max-width:800px;margin:10px auto 25px}#diamonds-direct .Valentines2021 .designersSection .designersHr img{width:100%}#diamonds-direct .Valentines2021 .designersSection .designersP{text-align:center;color:#000;font-family:Lusitana,serif;font-size:20px;margin:0 3% 10px}#diamonds-direct .Valentines2021 .designersSection .designersSelectWrapper{position:relative;width:80%;max-width:300px;margin:0 auto 25px}#diamonds-direct .Valentines2021 .designersSection .designersSelectWrapper .ggButton{color:#fff;background:#7a619e;border:1px solid #7a619e;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;text-align:center;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Valentines2021 .designersSection .designersSelectWrapper .ggButton:hover{color:#7a619e;background:#fff}#diamonds-direct .Valentines2021 .designersSection .designerResultsWrapper{width:90%;max-width:800px;margin:0 auto 25px;text-align:center}#diamonds-direct .Valentines2021 .designersSection .designerResultsWrapper .designerWrapper{display:inline-block;height:75px;width:auto;max-width:160px;margin:0 10px 25px;overflow:hidden;cursor:pointer}@media (max-width:600px){#diamonds-direct .Valentines2021 .designersSection .designerResultsWrapper .designerWrapper{max-width:140px;height:75px}}#diamonds-direct .Valentines2021 .designersSection .designerResultsWrapper .designerWrapper img{height:100%;width:100%;object-fit:contain}#diamonds-direct .Valentines2021 .footerSection{overflow:auto}#diamonds-direct .Valentines2021 .footerSection .footerWrapper{width:90%;max-width:1200px;margin:0 auto 25px;text-align:center}#diamonds-direct .Valentines2021 .footerSection .footerWrapper .footerProduct{display:inline-block;vertical-align:top;margin:0 5px 10px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Valentines2021 .footerSection .footerWrapper .footerProduct{width:calc(50% - 12px)}}#diamonds-direct .Valentines2021 .footerSection .footerWrapper .footerProduct .footerImg{border:2px solid #7a619e;background:#fff}#diamonds-direct .Valentines2021 .footerSection .footerWrapper .footerProduct .footerImg img{width:100%}#diamonds-direct .Valentines2021 .footerSection .footerWrapper .footerProduct .footerLabel{margin:3px 0 0;font-weight:400;color:#000;text-align:left}#diamonds-direct .Valentines2021 .footerSection .footerLegal{display:none;font-size:14px;font-weight:400;font-family:Lato,sans-serif;color:#000;margin:5px 0;text-align:center}#diamonds-direct .Spring2021{background:#fff;overflow:auto}#diamonds-direct .Spring2021 .promoBanner{width:100%}#diamonds-direct .Spring2021 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBanner img.desktop600{display:none}}#diamonds-direct .Spring2021 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBanner img.mobile600{display:block}}#diamonds-direct .Spring2021 .promoBody{position:relative}#diamonds-direct .Spring2021 .promoBodyInner{position:relative;background:#fff;color:#000;text-align:center;overflow:auto;margin:-20% auto 40px;width:80%;max-width:900px;font-family:Lusitana,serif}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBodyInner{width:90%;margin-top:-5%}}#diamonds-direct .Spring2021 .promoBodyInner .promoTitle{margin:20px 10% 0;font-size:48px;font-weight:700;font-family:Lusitana,serif;color:#000;text-align:center}@media (max-width:768px){#diamonds-direct .Spring2021 .promoBodyInner .promoTitle{font-size:32px}}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBodyInner .promoTitle{font-size:26px}}#diamonds-direct .Spring2021 .promoBodyInner .promoText{margin:30px 10% 0;padding:20px 25px;font-weight:400;font-size:24px;color:#000;font-family:Lato,sans-serif}@media (max-width:768px){#diamonds-direct .Spring2021 .promoBodyInner .promoText{font-size:16px;padding:20px}}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBodyInner .promoText{margin:15px 5% 0;font-size:16px;padding:10px 5px}}#diamonds-direct .Spring2021 .promoBodyInner .promoText .light-em{font-weight:400}#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock{margin:20px 140px 0;font-family:Lato,sans-serif}@media (max-width:1200px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock{margin:20px 50px 0}}@media (max-width:900px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock{margin:25px 0}}@media (max-width:768px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock{margin:10px 0}}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock{margin:10px 0}}#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem{display:inline-block;vertical-align:top;margin:0 10px 20px;width:calc(50% - 20px)}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem{width:calc(80% - 20px)}}#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springDates{display:block;font-size:28px;font-weight:700;text-align:center}@media (max-width:900px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springDates{font-size:22px}}@media (max-width:768px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springDates{font-size:18px}}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springDates{font-size:20px}}#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springDatesHr{margin:20px auto;width:100px;height:5px;background:#f7e3de}#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springLocations{display:block;text-align:center;padding:0 2%}#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{text-decoration:none;color:#000;cursor:pointer;font-size:16px;transition:color .25s ease-in-out 0ms}@media (max-width:768px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:16px}}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link{font-size:14px}}#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .holiday-location-link:hover{color:#815a5a}#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{color:#f7e3de;font-weight:700;font-size:18px}@media (max-width:900px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:18px}}@media (max-width:768px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:18px}}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBodyInner .springLocationBlock .springLocationItem .springLocations .link-em{font-size:16px}}#diamonds-direct .Spring2021 .promoBodyInner .promoLegal{text-align:center;font-size:14px;font-weight:300;color:#000;font-family:Lato,sans-serif;margin:0 10px 30px}@media (max-width:768px){#diamonds-direct .Spring2021 .promoBodyInner .promoLegal{font-size:14px}}@media (max-width:600px){#diamonds-direct .Spring2021 .promoBodyInner .promoLegal{font-size:14px}}#diamonds-direct .Spring2021 .formBoxWrapper{position:relative;overflow:auto;color:#000;background:#f7e3de;margin:0 auto 25px;z-index:3;width:80%;max-width:900px;font-family:Lato,sans-serif}@media (max-width:600px){#diamonds-direct .Spring2021 .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper{width:90%;max-width:800px;margin:25px auto}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formP{color:#000;text-align:center;margin:0 0 25px;padding-top:15px}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formTitle{color:#29583f;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formDates{color:gray;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid gray;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid gray;background:#fff}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#000;background:#fff;border:1px solid #000;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#000}#diamonds-direct .Spring2021 .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:gray;font-size:13px;text-align:center}#diamonds-direct .Spring2021 .trendsWrapper{width:80%;max-width:900px;margin:0 auto 40px}#diamonds-direct .Spring2021 .trendsWrapper .trendsTitle{width:80%;max-width:400px;margin:10px auto 0}#diamonds-direct .Spring2021 .trendsWrapper .trendsTitle img{width:100%}#diamonds-direct .Spring2021 .trendsWrapper .trendsImg{position:relative;width:100%}#diamonds-direct .Spring2021 .trendsWrapper .trendsImg img{width:100%}#diamonds-direct .Spring2021 .trendsWrapper .trendsImg .linkScreen1{position:absolute;cursor:pointer;top:0;left:0;width:32%;height:100%}@media (max-width:600px){#diamonds-direct .Spring2021 .trendsWrapper .trendsImg .linkScreen1{top:33%;left:0;width:48%;height:67%}}#diamonds-direct .Spring2021 .trendsWrapper .trendsImg .linkScreen2{position:absolute;cursor:pointer;top:0;left:34%;width:66%;height:47%}@media (max-width:600px){#diamonds-direct .Spring2021 .trendsWrapper .trendsImg .linkScreen2{top:0;left:0;width:100%;height:31%}}#diamonds-direct .Spring2021 .trendsWrapper .trendsImg .linkScreen3{position:absolute;cursor:pointer;top:50%;left:34%;width:32%;height:50%}@media (max-width:600px){#diamonds-direct .Spring2021 .trendsWrapper .trendsImg .linkScreen3{top:68%;left:52%;width:48%;height:32%}}#diamonds-direct .Spring2021 .trendsWrapper .trendsImg .linkScreen4{position:absolute;cursor:pointer;top:50%;left:68%;width:32%;height:50%}@media (max-width:600px){#diamonds-direct .Spring2021 .trendsWrapper .trendsImg .linkScreen4{top:33%;left:52%;width:48%;height:32%}}#diamonds-direct .Summer2021{font-family:Lato,sans-serif}#diamonds-direct .Summer2021 .headerSection .headerSectionWrapper img{width:100%}#diamonds-direct .Summer2021 .topSection{position:relative;margin:-15% auto 0;width:90%;max-width:800px}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection{margin:0 auto;width:100%}}#diamonds-direct .Summer2021 .topSection .topRow{position:relative}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock{position:absolute;top:0;height:100%;background-repeat:no-repeat;background-position:50%;background-size:cover}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection .topRow .imgBlock{position:relative;height:auto;padding-bottom:100%}}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock .linkBlock{cursor:pointer;position:absolute}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock1{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/summer2021/v2/landing/3stone.jpg\")}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock1 .linkBlock1{top:0;left:0;width:100%;height:100%}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock2{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/summer2021/v2/landing/2ndset.jpg\")}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock2 .linkBlock1{top:0;left:0;width:50%;height:50%}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock2 .linkBlock2{top:50%;left:0;width:50%;height:50%}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock2 .linkBlock3{top:0;left:50%;width:50%;height:100%}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock3{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/summer2021/v2/landing/3rdset.jpg\")}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock3 .linkBlock1{top:0;left:0;width:100%;height:50%}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock3 .linkBlock2{top:50%;left:0;width:50%;height:50%}#diamonds-direct .Summer2021 .topSection .topRow .imgBlock3 .linkBlock3{top:50%;left:50%;width:50%;height:50%}#diamonds-direct .Summer2021 .topSection .topRow .copyBlock{padding:40px 0}#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topP{color:gray;font-size:22px;width:70%;margin:0 auto 20px;text-align:center}@media (max-width:768px){#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topP{font-size:20px;width:90%}}#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topTitle{width:65%;margin:10px auto}#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topTitle img{width:100%}#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDates{color:#4d4d4d;text-align:center;margin:0 auto 20px 0;font-size:32px;font-weight:700}#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDatesHr{width:100px;height:5px;margin:0 auto 25px;background:#e7cbba}#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDatesRow{text-align:center;width:90%;margin:0 auto 2px}#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDatesRow .storeLink{color:gray;font-size:20px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDatesRow .storeLink:hover{color:#cca596}@media (max-width:900px){#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDatesRow .storeLink{font-size:18px}}@media (max-width:768px){#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDatesRow .storeLink{font-size:14px}}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDatesRow .storeLink{font-size:20px}}#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDatesRow .storePipe{font-size:22px;font-weight:700;color:#cca596;margin:0 5px}@media (max-width:900px){#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDatesRow .storePipe{font-size:20px}}@media (max-width:768px){#diamonds-direct .Summer2021 .topSection .topRow .copyBlock .topDatesRow .storePipe{font-size:16px;margin:0 3px}}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection .topRow .copyBlock1{padding:0 0 20px}}#diamonds-direct .Summer2021 .topSection .topRow .topRowLeft{width:50%}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection .topRow .topRowLeft{width:100%}}#diamonds-direct .Summer2021 .topSection .topRow .topRowLeft.imgBlock{left:0}#diamonds-direct .Summer2021 .topSection .topRow .topRowLeft.copyBlock{margin-left:0;margin-right:50%}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection .topRow .topRowLeft.copyBlock{margin-right:0}}#diamonds-direct .Summer2021 .topSection .topRow .topRowLeft.mobileMakeup{display:none}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection .topRow .topRowLeft.mobileMakeup{display:block}}#diamonds-direct .Summer2021 .topSection .topRow .topRowLeft.desktopMakeup{display:block}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection .topRow .topRowLeft.desktopMakeup{display:none}}#diamonds-direct .Summer2021 .topSection .topRow .topRowRight{width:50%}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection .topRow .topRowRight{width:100%}}#diamonds-direct .Summer2021 .topSection .topRow .topRowRight.imgBlock{left:50%}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection .topRow .topRowRight.imgBlock{left:unset}}#diamonds-direct .Summer2021 .topSection .topRow .topRowRight.copyBlock{margin-left:50%;margin-right:0}@media (max-width:600px){#diamonds-direct .Summer2021 .topSection .topRow .topRowRight.copyBlock{margin-left:0}}#diamonds-direct .Summer2021 .shopStripe{color:#4d4d4d;background:#fbebd3;text-align:center;margin:25px 0;padding:20px 0}#diamonds-direct .Summer2021 .shopStripe .shopTitle{font-size:32px;font-weight:700;margin:0 0 15px}@media (max-width:600px){#diamonds-direct .Summer2021 .shopStripe .shopTitle{font-size:26px;margin:0 0 5px}}#diamonds-direct .Summer2021 .shopStripe .shopSubtitle{font-size:24px;font-weight:300}#diamonds-direct .Summer2021 .formSection{position:relative;padding:0 0 25px;background:#e7cbba;overflow:auto}#diamonds-direct .Summer2021 .formSection .formHeader img{width:100%}#diamonds-direct .Summer2021 .formSection .formBoxWrapper{position:relative;width:90%;max-width:800px;margin:25px auto 0;overflow:auto}@media (max-width:600px){#diamonds-direct .Summer2021 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%}}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#fff;font-size:18px;text-align:center;margin:0 0 25px}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#e7cbba;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:gray;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:1px solid #eb3533}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #cca596;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #cca596;background:#fff}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select option{background:#fff}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper .error select{border:1px solid #eb3533}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#cca596;background:#fff;border:1px solid #cca596;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#cca596}#diamonds-direct .Summer2021 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:gray;font-size:13px;text-align:center}#diamonds-direct .Summer2021 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Summer2021 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Summer2021 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Summer2021 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Summer2021 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Summer2021 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Summer2021 .designersSection{position:relative;margin:0 auto;width:90%;max-width:1000px}@media (max-width:600px){#diamonds-direct .Summer2021 .designersSection{margin:0 auto}}#diamonds-direct .Summer2021 .designersSection .designersLeft{position:relative;width:100%;margin:0 50% 0 0;padding:20px 0}@media (max-width:600px){#diamonds-direct .Summer2021 .designersSection .designersLeft{width:100%;margin:0;padding:10px 0}}#diamonds-direct .Summer2021 .designersSection .designersLeft .designersTitle{color:#e7cbba;width:90%;max-width:400px;margin:30px auto}#diamonds-direct .Summer2021 .designersSection .designersLeft .designersTitle img{width:100%}#diamonds-direct .Summer2021 .designersSection .designersLeft .designersP{color:#4d4d4d;width:70%;font-size:20px;margin:0 auto 25px;text-align:center}#diamonds-direct .Summer2021 .designersSection .designersLeft .designersSelectWrapper{position:relative;width:80%;max-width:300px;margin:0 auto 25px;z-index:2}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper{width:90%;max-width:800px;margin:0 auto 25px;text-align:center}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerWrapper.noHover{cursor:default}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerWrapper.noHover:hover{color:#4d4d4d}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerWrapper{display:inline-block;color:#4d4d4d;margin:0 0 10px;width:auto;padding:0 10px;border-left:2px solid #cca596;cursor:pointer;font-size:18px;transition:color .25s ease-in-out 0ms}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerWrapper:first-child{border:none}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerWrapper:hover{color:#cca596}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerWrapper img{height:100%;width:100%;object-fit:contain}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerResultsDates{display:inline-block;text-align:center;margin:0 auto 15px;text-transform:uppercase;font-size:32px;font-weight:700;width:auto;color:#4d4d4d}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours{position:relative;color:#4d4d4d;margin:0 0 30px}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourLine{display:inline-block;vertical-align:top;font-size:20px;margin:0 0 10px}@media (max-width:600px){#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourLine{display:block;font-size:16px}}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourLine .hourDay{display:inline-block;vertical-align:top;font-weight:700}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourLine .hourTime{display:inline-block;vertical-align:top;margin:0 0 0 5px}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourDash{display:inline-block;vertical-align:top;font-size:20px;font-weight:900;margin:0 5px;color:#cca596}@media (max-width:600px){#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourDash{display:none}}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerResultsButton{width:180px;margin:20px auto;color:#cca596;background:#fff;border:1px solid #cca596;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Summer2021 .designersSection .designersLeft .designerResultsWrapper .designerResultsButton:hover{color:#fff;background:#cca596}#diamonds-direct .Summer2021 .designersSection .designersRight{position:absolute;top:0;right:0;width:48.2%;height:100%;background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/summer2021/earrings.jpg\");background-repeat:no-repeat;background-position:50%;background-size:cover;cursor:pointer}@media (max-width:600px){#diamonds-direct .Summer2021 .designersSection .designersRight{position:relative;width:100%;height:auto;padding-bottom:100%}}#diamonds-direct .Summer2021 .looksSection{display:none;position:relative;margin:30px auto;width:90%;max-width:1000px}@media (max-width:600px){#diamonds-direct .Summer2021 .looksSection{padding:0}}#diamonds-direct .Summer2021 .looksSection .looksWrapper{position:relative}#diamonds-direct .Summer2021 .looksSection .looksWrapper img{width:100%}#diamonds-direct .Summer2021 .looksSection .looksWrapper .lb{position:absolute;cursor:pointer}#diamonds-direct .Summer2021 .looksSection .looksWrapper .lb1{top:0;left:0;width:52%;height:100%}@media (max-width:600px){#diamonds-direct .Summer2021 .looksSection .looksWrapper .lb1{width:100%;height:48%}}#diamonds-direct .Summer2021 .looksSection .looksWrapper .lb2{top:0;right:0;width:48%;height:50%}@media (max-width:600px){#diamonds-direct .Summer2021 .looksSection .looksWrapper .lb2{top:49%;width:100%;height:25%}}#diamonds-direct .Summer2021 .looksSection .looksWrapper .lb3{bottom:0;right:24%;width:24%;height:50%}@media (max-width:600px){#diamonds-direct .Summer2021 .looksSection .looksWrapper .lb3{right:50%;width:50%;height:25%}}#diamonds-direct .Summer2021 .looksSection .looksWrapper .lb4{bottom:0;right:0;width:24%;height:50%}@media (max-width:600px){#diamonds-direct .Summer2021 .looksSection .looksWrapper .lb4{width:50%;height:25%}}#diamonds-direct .Summer2021 .legalSection .legalInnerWrapper{margin:20px auto;width:90%;font-size:14px;color:gray;text-align:center}#diamonds-direct .Sept2021{color:#5e5e5e;background:#fff;font-family:Lato,sans-serif;overflow:auto}#diamonds-direct .Sept2021 .itemRow{margin:0}#diamonds-direct .Sept2021 .itemRow .itemBlock.doubleItem{width:calc(50% - 12px)}@media (max-width:768px){#diamonds-direct .Sept2021 .itemRow .itemBlock.doubleItem{width:calc(100% - 12px)}}#diamonds-direct .Sept2021 .itemRow .itemBlock{display:inline-block;vertical-align:top;margin:6px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Sept2021 .itemRow .itemBlock{width:calc(50% - 12px)}}#diamonds-direct .Sept2021 .itemRow .itemBlock img,#diamonds-direct .Sept2021 .promoBanner{width:100%}#diamonds-direct .Sept2021 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Sept2021 .promoBanner img.desktop600{display:none}}#diamonds-direct .Sept2021 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Sept2021 .promoBanner img.mobile600{display:block}}#diamonds-direct .Sept2021 .cheersBlock{background:#fff;margin:0 auto;width:90%;max-width:1024px}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper,#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper{position:relative}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbLeft{position:absolute;top:0;left:0;bottom:0;width:calc(50% - 20px);transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbLeft{position:relative;top:unset;right:unset;width:unset;bottom:unset;height:auto;width:100%;margin:40px 0}}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbLeft .cbLeftWrapper{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center;padding:0 10%;font-size:26px;font-weight:300;color:#5e5e5e;border:2px solid #f0f0f0;transition:font-size .35s linear 0ms,margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbLeft .cbLeftWrapper{border:none;font-size:24px}}@media (max-width:900px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbLeft .cbLeftWrapper{font-size:22px}}@media (max-width:768px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbLeft .cbLeftWrapper{position:relative;top:unset;left:unset;right:unset;height:auto;margin:0}}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbLeft .cbLeftWrapper .titlePurple{margin:1em 0;font-size:32px;color:#8c74ba;font-weight:300;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbLeft .cbLeftWrapper .titlePurple{font-size:26px}}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbLeft .cbLeftWrapper .cbLeftButton{display:inline-block;color:#5a4b78;background:#fff;border:1px solid #5a4b78;cursor:pointer;padding:10px 35px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbLeft .cbLeftWrapper .cbLeftButton:hover{color:#fff;background:#5a4b78}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight{display:block;margin:20px 0 20px 50%;background:#e9e2f7;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight{position:relative;top:unset;right:unset;width:unset;height:auto;width:calc(100% - 10px);margin:0 0 20px}}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight .cbRightWrapper{margin:0;padding:75px 25px;color:#532282;text-align:center}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight .cbRightWrapper img{width:100%}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight .cbRightWrapper .cbrSuperTitle{font-size:28px;font-weight:700;margin:0 0 10px}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight .cbRightWrapper .cbrTitle{font-size:36px;font-weight:700}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight .cbRightWrapper .cbrDisc{font-size:18px;font-weight:300;margin:0 0 25px}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight .cbRightWrapper .cbrDates{font-size:24px;font-weight:400}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight .cbRightWrapper .cbrCopy{font-size:20px;font-weight:400;margin:0 0 10px}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight .cbRightWrapper .cbrButton{display:inline-block;margin:20px 0;padding:10px 20px;font-size:14px;text-transform:none;font-weight:700;background:#e9e2f7;color:#532282;border:1px solid #532282;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .cbBlockWrapper .cbRight .cbRightWrapper .cbrButton:hover{background:#532282;color:#fff}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems{position:relative;display:block;margin:0 0 20px;width:100%;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems{width:calc(100% - 10px)}}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiLink{position:absolute;cursor:pointer}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopLeft{top:0;left:0;width:32%;height:100%}@media (max-width:600px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopLeft{top:0;left:0;width:100%;height:29%}}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopRight{top:0;left:32%;width:36%;height:50%}@media (max-width:600px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopRight{top:30%;left:0;width:100%;height:20%}}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiBottomLeft{top:50%;left:32%;width:36%;height:50%}@media (max-width:600px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiBottomLeft{top:52%;left:0;width:100%;height:20%}}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiRight{top:0;left:68%;width:32%;height:100%}@media (max-width:600px){#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiRight{top:74%;left:0;width:100%;height:26%}}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock.doubleItem{width:calc(100% - 12px)}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock{width:calc(50% - 12px)}#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock img,#diamonds-direct .Sept2021 .cheersBlock .cheersBlockWrapper .itemRow.cbItems img{width:100%}#diamonds-direct .Sept2021 .formBoxWrapper{position:relative;overflow:auto;background:#c1b6d4;margin:0 auto;z-index:3;font-family:Lato,sans-serif}@media (max-width:600px){#diamonds-direct .Sept2021 .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper{width:90%;max-width:1024px;margin:25px auto}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formP{color:#fff;text-align:center;margin:0 0 25px;padding-top:15px;font-size:20px;font-weight:400}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formTitle{color:#5e5e5e;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formDates{color:#5e5e5e;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #5e5e5e;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #5e5e5e;background:#fff}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#532282;background:#fff;border:1px solid #532282;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#532282}#diamonds-direct .Sept2021 .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#5e5e5e;font-size:13px;text-align:center}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper{width:90%;max-width:1024px;margin:12px auto}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .fianceBlock .mainRow .copyBlock{background:#e8eaff}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .newlywedBlock .mainRow .copyBlock{background:#f7e8ff}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .gradBlock .mainRow .copyBlock{background:#e8f5ff}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .dadBlock .mainRow .copyBlock{background:#f7f7f7}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow{position:relative}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock{margin:6px}@media (max-width:768px){#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock{margin:6px}}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock img{width:100%;display:block}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock{position:absolute;top:6px;left:6px;height:calc(100% - 12px);text-align:center}@media (max-width:768px){#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock{position:relative;top:0;left:0;height:auto;margin:6px}}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:20% 0;padding:0 5%;overflow:auto}@media (max-width:900px){#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:15% 0}}@media (max-width:768px){#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:0;padding:10% 5%}}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbTitle{margin:1em 0;font-size:32px;color:#8c74ba;font-weight:300}@media (max-width:1024px){#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbTitle{font-size:26px}}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbCopy{font-size:20px}@media (max-width:1024px){#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbCopy{font-size:18px}}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbButton{display:inline-block;color:#5a4b78;background:#fff;border:1px solid #5a4b78;cursor:pointer;margin:20px 0 0;padding:10px 25px;width:auto;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrbButton:hover{color:#fff;background:#5a4b78}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .rightImg.mrBlock{margin-left:calc(50% + 12px/2)}@media (max-width:768px){#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .rightImg.mrBlock{display:none;margin-left:6px}}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .rightCopy.mrBlock{left:calc(50% + 12px/2)}@media (max-width:768px){#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .rightCopy.mrBlock{left:0}}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .mobileMakeup.mrBlock{display:none}@media (max-width:768px){#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .mobileMakeup.mrBlock{display:block}}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock{display:inline-block;vertical-align:top;width:calc(50% - 12px)}@media (max-width:768px){#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock{display:block;width:calc(100% - 12px)}#diamonds-direct .Sept2021 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock:first-child{margin-bottom:12px}}#diamonds-direct .Sept2022{color:#787878;background:#fff;font-family:Lato,sans-serif;overflow:auto}#diamonds-direct .Sept2022 .promoBanner{width:100%}#diamonds-direct .Sept2022 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Sept2022 .promoBanner img.desktop600{display:none}}#diamonds-direct .Sept2022 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Sept2022 .promoBanner img.mobile600{display:block}}#diamonds-direct .Sept2022 .topSection{margin:-7% auto 0;width:90%;max-width:1024px;text-align:center}@media (max-width:768px){#diamonds-direct .Sept2022 .topSection{margin:20px auto 0}}#diamonds-direct .Sept2022 .topSection .topCopy{width:70%;margin:0 auto 20px;font-size:18px}#diamonds-direct .Sept2022 .topSection .topTitle{margin:0 auto 20px;color:#383838;font-size:36px;font-weight:700;text-transform:uppercase;transition:font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Sept2022 .topSection .topTitle{font-size:28px}}#diamonds-direct .Sept2022 .topSection .topSubtitle{color:#383838;font-size:24px;margin:0 0 20px}#diamonds-direct .Sept2022 .midBlock{margin:25px auto 10px;width:90%;max-width:1024px;text-align:center;font-size:18px}#diamonds-direct .Sept2022 .midBlock .midBlockCopy{margin:0 auto 20px;font-size:18px}#diamonds-direct .Sept2022 .midBlock .midBlockButtons .midBlockButton{display:inline-block;vertical-align:top;width:200px;padding:10px 0;font-size:16px;cursor:pointer;text-align:center;margin:0 10px 20px;color:#4b2d53;border:1px solid #4b2d53;background:#fff;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Sept2022 .midBlock .midBlockButtons .midBlockButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .Sept2022 .cheersBlock{background:#fff;margin:0 auto;width:90%;max-width:900px}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper{position:relative}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft{display:inline-block;vertical-align:top;width:calc(50% - 10px);margin:20px 5px;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft{width:calc(100% - 10px)}}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{text-align:center;padding:125px 12% 0;font-size:26px;font-weight:300;color:#000;transition:font-size .35s linear 0ms,margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{font-size:18px;padding:25px 12% 0}}@media (max-width:900px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{padding:0 5%;font-size:16px}}@media (max-width:768px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{font-size:18px}}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .titlePurple{margin:1em 0;font-size:32px;color:#787878;font-weight:300;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .titlePurple{font-size:26px}}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .cbLeftCopy{margin:0 0 40px}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .cbLeftButton{display:inline-block;color:#e8dace;background:#fff;border:1px solid #e8dace;cursor:pointer;padding:10px 35px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .cbLeftButton:hover{color:#fff;background:#e8dace}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbRight{display:inline-block;vertical-align:top;margin:20px 5px;width:calc(50% - 10px);transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbRight{width:calc(100% - 10px);margin:0 0 20px}}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper{margin:0;padding:75px 25px;color:#000;background:#deecfa;text-align:center}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper img{width:100%}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrSuperTitle{font-size:28px;font-weight:700;margin:0 0 10px}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrTitle{font-size:24px;font-weight:700}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrDisc{font-size:18px;font-weight:300;margin:0 0 25px}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrDates{font-size:20px;font-weight:400}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrButton{display:inline-block;margin:20px 0;padding:10px 20px;font-size:14px;text-transform:uppercase;font-weight:700;background:#deecfa;color:#000;border:1px solid #000;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrButton:hover{background:#000;color:#fff}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems{position:relative;display:block;margin:0 0 20px;width:100%;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems{width:calc(100% - 10px)}}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiLink{position:absolute;cursor:pointer}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbi1{top:0;left:0;width:20%;height:48%}@media (max-width:600px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbi1{top:0;left:0;width:40%;height:32%}}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbi2{top:0;left:22%;width:50%;height:48%}@media (max-width:600px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbi2{top:0;left:43%;width:57%;height:32%}}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbi3{top:52%;left:0;width:50%;height:48%}@media (max-width:600px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbi3{top:34%;left:0;width:52.5%;height:32%}}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbi4{top:52%;left:52%;width:20%;height:48%}@media (max-width:600px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbi4{top:67%;left:0;width:52.5%;height:33%}}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbi5{top:0;right:0;width:27%;height:100%}@media (max-width:600px){#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbi5{top:34%;left:56%;width:44%;height:66%}}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock.doubleItem{width:calc(100% - 0px)}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock{width:calc(50% - 0px)}#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock img,#diamonds-direct .Sept2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems img{width:100%}#diamonds-direct .Sept2022 .formBoxWrapper{position:relative;overflow:auto;background:#c3b8b1;margin:0 auto 25px;width:90%;max-width:900px;z-index:3;font-family:Lato,sans-serif}@media (max-width:600px){#diamonds-direct .Sept2022 .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper{width:90%;max-width:1024px;margin:25px auto}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formP{color:#fff;text-align:center;margin:0 0 25px;padding-top:15px;font-size:20px;font-weight:400}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formTitle{color:#383838;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formDates{color:#383838;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #383838;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #383838;background:#fff}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#fff;background:none;border:1px solid #fff;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#383838;background:#fff}#diamonds-direct .Sept2022 .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#383838;font-size:13px;text-align:center}#diamonds-direct .Sept2022 .copySection{margin:40px auto;max-width:900px;width:90%;font-size:24px;font-weight:700;text-align:center;font-family:Lusitana,serif}#diamonds-direct .Sept2022 .blockSection{margin:25px 0}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper{width:90%;max-width:900px;margin:0 auto}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .fianceBlock .mainRow .copyBlock,#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .newlywedBlock .mainRow .copyBlock{background:#fff}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow{position:relative}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock{margin:0;cursor:pointer}@media (max-width:768px){#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock{margin:0}}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock img{width:100%;display:block}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock{position:absolute;top:0;right:0;height:calc(100% - 0px);text-align:center}@media (max-width:768px){#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock{position:relative;top:0;right:0;height:auto;margin:0}}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:15% 0;padding:0 5%;overflow:auto}@media (max-width:900px){#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:3% 0}}@media (max-width:768px){#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:0;padding:10% 5%}}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrHeaderCopy{padding:25px 10% 50px;font-size:22px}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrHeadline{font-size:32px;font-weight:700;color:#383838}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrDates{font-size:32px;font-weight:300;color:#383838;margin:25px 0 0}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrSubheader{font-size:18px;font-weight:300;color:#383838;margin:0}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrButton{display:inline-block;padding:12px 40px;margin:50px auto 0;width:auto;color:#383838;background:#e8dace;font-size:13px;font-weight:700}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightImg.mrBlock{margin-right:calc(50% + 0px/2)}@media (max-width:768px){#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightImg.mrBlock{display:none;margin-left:0}}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightCopy.mrBlock{left:calc(50% + 0px/2)}@media (max-width:768px){#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightCopy.mrBlock{left:0}}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mobileMakeup.mrBlock{display:none}@media (max-width:768px){#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mobileMakeup.mrBlock{display:block}}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock{display:inline-block;vertical-align:top;width:calc(50% - 0px)}@media (max-width:768px){#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock{display:block;width:calc(100% - 0px)}#diamonds-direct .Sept2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock:first-child{margin-bottom:0}}#diamonds-direct .Sept2022 .legalRow{width:90%;max-width:1024px;margin:15px auto 25px;font-size:16px;text-align:center}#diamonds-direct .BlackFriday2021{font-family:Lato,sans-serif;color:#666}#diamonds-direct .BlackFriday2021 .headerSection .headerSectionWrapper img{width:100%}#diamonds-direct .BlackFriday2021 .topSection{position:relative;margin:0 auto;width:90%;max-width:800px;padding:20px 0 0}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .topSection{margin:0 auto;width:100%}}#diamonds-direct .BlackFriday2021 .topSection .topP{font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .BlackFriday2021 .topSection .topDate{color:#4f4f4f;font-size:36px;margin:0 0 20px;text-align:center;font-family:Lato,sans-serif}#diamonds-direct .BlackFriday2021 .topSection .topTitleImg{position:relative;width:80%;margin:40px auto 10px;max-width:600px}#diamonds-direct .BlackFriday2021 .topSection .topTitleImg img{width:100%}#diamonds-direct .BlackFriday2021 .topSection .topTitleImg .star{position:absolute;top:64%;left:76.5%;width:15px;height:15px;color:#aa8ba2;font-size:18px;font-weight:400}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .topSection .topTitleImg .star{top:60%}}#diamonds-direct .BlackFriday2021 .topSection .topBox{position:relative;padding:50px 25px;width:calc(90% - 50px);margin:0 auto 20px;background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/notrectangle.jpg\");background-repeat:no-repeat;background-position:50%;background-size:100% 100%;text-align:center;transition:padding .35s linear 0ms}@media (max-width:480px){#diamonds-direct .BlackFriday2021 .topSection .topBox{padding:30px 10px;width:calc(95% - 20px)}}#diamonds-direct .BlackFriday2021 .topSection .topBox .topBoxBg{display:none;position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .BlackFriday2021 .topSection .topBox .topBoxBg img{width:100%;height:100%}#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper{margin:0 0 30px}#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper .weekDate{font-size:24px;font-weight:400;font-family:Lusitana,serif}#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper .weekHr{width:100px;height:4px;margin:15px auto;background:#aa8ba2}#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper .weekDateRow{margin:0 0 5px}#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{display:inline-block;vertical-align:top;width:auto;cursor:pointer;transition:color .25s ease-in-out 0ms,font-size .25s ease-in-out 0ms}#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink:hover{color:#aa8ba2}@media (max-width:768px){#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{font-size:14px}}@media (max-width:480px){#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{font-size:11px}}#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{display:inline-block;vertical-align:top;width:auto;font-weight:900;color:#aa8ba2;margin:0 5px}@media (max-width:768px){#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{font-size:14px}}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{margin:0 3px}}#diamonds-direct .BlackFriday2021 .topSection .topGallery{position:relative;width:100%}#diamonds-direct .BlackFriday2021 .topSection .topGallery img{width:100%}#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol{position:absolute;cursor:pointer}#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol1{top:0;left:0;width:19%;height:100%}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol1{top:0;left:0;width:100%;height:33%}}#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol2{top:0;left:20%;width:20%;height:48%}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol2{top:34%;left:0;width:48%;height:15%}}#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol3{top:0;left:41.5%;width:20%;height:48%}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol3{top:34%;left:52%;width:48%;height:15%}}#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol4{top:53%;left:20%;width:41%;height:47%}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol4{top:50.5%;left:0;width:100%;height:15%}}#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol5{top:0;left:62%;width:38%;height:100%}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .topSection .topGallery .ol5{top:66%;left:0;width:100%;height:34%}}#diamonds-direct .BlackFriday2021 .formSection{position:relative;background:#4f4f4f;overflow:auto;margin:25px auto;width:90%;max-width:800px}#diamonds-direct .BlackFriday2021 .formSection .formHeader img{width:100%}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper{position:relative;width:90%;max-width:800px;margin:0 auto;overflow:auto}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%}}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#fff;font-size:18px;text-align:center;margin:0 0 25px}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#aa8ba2;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:#787878;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:1px solid #eb3533}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #4f4f4f;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #4f4f4f;background:#fff}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select option{background:#fff}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper .error select{border:1px solid #eb3533}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#fff;background:none;border:1px solid #fff;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#4f4f4f;background:#fff;border-color:#fff}#diamonds-direct .BlackFriday2021 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#787878;font-size:13px;text-align:center}#diamonds-direct .BlackFriday2021 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .BlackFriday2021 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .BlackFriday2021 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .BlackFriday2021 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .BlackFriday2021 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .BlackFriday2021 .holidaySection{margin:25px auto;width:90%;max-width:800px;cursor:pointer}#diamonds-direct .BlackFriday2021 .holidaySection img{width:100%}#diamonds-direct .BlackFriday2021 .ggSection{margin:10px auto 0;width:90%;max-width:800px;text-align:center}#diamonds-direct .BlackFriday2021 .ggSection .ggTitle{width:80%;max-width:400px;margin:0 auto}#diamonds-direct .BlackFriday2021 .ggSection .ggLine img,#diamonds-direct .BlackFriday2021 .ggSection .ggTitle img{width:100%}#diamonds-direct .BlackFriday2021 .ggSection .ggP{font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .BlackFriday2021 .ggSection .ggButton{display:inline-block;margin:0 0 20px;background:#aa8ba2;color:#fff;font-size:14px;text-transform:uppercase;text-align:center;padding:10px 25px;width:auto;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .BlackFriday2021 .ggSection .ggButton:hover{background:#787878;color:#fff}#diamonds-direct .BlackFriday2021 .ggSection .ggItemRow .ggItem{display:inline-block;vertical-align:top;margin:5px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .BlackFriday2021 .ggSection .ggItemRow .ggItem{width:calc(50% - 12px)}}#diamonds-direct .BlackFriday2021 .ggSection .ggItemRow .ggItem:hover .ggItemLabel{color:#aa8ba2}#diamonds-direct .BlackFriday2021 .ggSection .ggItemRow .ggItem .ggItemImg{border:2px solid #aa8ba2;background-repeat:no-repeat;background-position:50%;background-size:cover;padding-bottom:100%}#diamonds-direct .BlackFriday2021 .ggSection .ggItemRow .ggItem .ggItemImg1{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/bldxl18079.jpg\")}#diamonds-direct .BlackFriday2021 .ggSection .ggItemRow .ggItem .ggItemImg2{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/bldmd30060.jpg\")}#diamonds-direct .BlackFriday2021 .ggSection .ggItemRow .ggItem .ggItemImg3{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/nfanc29328.jpg\")}#diamonds-direct .BlackFriday2021 .ggSection .ggItemRow .ggItem .ggItemImg4{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/efand14379.jpg\")}#diamonds-direct .BlackFriday2021 .ggSection .ggItemRow .ggItem .ggItemLabel{text-align:left;height:40px;transition:color .25s ease-in-out 0ms}#diamonds-direct .BlackFriday2021 .legalSection .legalInnerWrapper{margin:20px auto;width:90%;font-size:14px;color:#787878;text-align:center}#diamonds-direct .December2021{font-family:Lato,sans-serif;color:#787878}#diamonds-direct .December2021 .headerSection .headerSectionWrapper img{width:100%}#diamonds-direct .December2021 .topSection{position:relative;margin:0 auto;width:90%;max-width:800px;padding:20px 0 0}@media (max-width:600px){#diamonds-direct .December2021 .topSection{margin:0 auto;width:100%}}#diamonds-direct .December2021 .topSection .topP{font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .December2021 .topSection .boxSection{text-align:center;color:#532282;margin:0 auto;font-family:Lusitana,serif;width:90%;max-width:1200px;padding:0}@media (max-width:600px){#diamonds-direct .December2021 .topSection .boxSection{margin:0 auto}}#diamonds-direct .December2021 .topSection .boxSection .fuBox{color:#00381e;border:1px solid #00381e;margin:25px auto;padding:30px 10px 10px;font-family:Lato,sans-serif;width:90%;max-width:480px}#diamonds-direct .December2021 .topSection .boxSection .fuBox .box1{font-weight:900;font-size:26px}#diamonds-direct .December2021 .topSection .boxSection .fuBox .box2{font-weight:300}#diamonds-direct .December2021 .topSection .boxSection .fuBox .box3{font-weight:400;margin:5px 0 0;font-size:20px}#diamonds-direct .December2021 .topSection .boxSection .fuBox .boxButton{position:relative;font-size:14px;border:1px solid #00381e;color:#00381e;background:#fff;width:180px;height:36px;margin:25px auto;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .December2021 .topSection .boxSection .fuBox .boxButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .December2021 .topSection .boxSection .fuBox .boxButton:hover{color:#fff;background:#00381e}#diamonds-direct .December2021 .topSection .topBox{position:relative;padding:50px 25px;width:calc(90% - 50px);margin:0 auto 20px;background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/notrectangle.jpg\");background-repeat:no-repeat;background-position:50%;background-size:100% 100%;text-align:center;transition:padding .35s linear 0ms}@media (max-width:480px){#diamonds-direct .December2021 .topSection .topBox{padding:30px 10px;width:calc(95% - 20px)}}#diamonds-direct .December2021 .topSection .topBox .topBoxBg{display:none;position:absolute;top:0;left:0;width:100%;height:100%}#diamonds-direct .December2021 .topSection .topBox .topBoxBg img{width:100%;height:100%}#diamonds-direct .December2021 .topSection .topBox .weekWrapper{margin:0 0 30px}#diamonds-direct .December2021 .topSection .topBox .weekWrapper .weekDate{font-size:24px;font-weight:400;font-family:Lusitana,serif}#diamonds-direct .December2021 .topSection .topBox .weekWrapper .weekHr{width:100px;height:4px;margin:15px auto;background:#00381e}#diamonds-direct .December2021 .topSection .topBox .weekWrapper .weekDateRow{margin:0 0 5px}#diamonds-direct .December2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{display:inline-block;vertical-align:top;width:auto;cursor:pointer;transition:color .25s ease-in-out 0ms,font-size .25s ease-in-out 0ms}#diamonds-direct .December2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink:hover{color:#00381e}@media (max-width:768px){#diamonds-direct .December2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{font-size:14px}}@media (max-width:480px){#diamonds-direct .December2021 .topSection .topBox .weekWrapper .weekDateRow .weekLink{font-size:11px}}#diamonds-direct .December2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{display:inline-block;vertical-align:top;width:auto;font-weight:900;color:#00381e;margin:0 5px}@media (max-width:768px){#diamonds-direct .December2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{font-size:14px}}@media (max-width:600px){#diamonds-direct .December2021 .topSection .topBox .weekWrapper .weekDateRow .weekVr{margin:0 3px}}#diamonds-direct .December2021 .topSection .topGallery{position:relative;width:100%}#diamonds-direct .December2021 .topSection .topGallery img{width:100%}#diamonds-direct .December2021 .topSection .topGallery .ol{position:absolute;cursor:pointer}#diamonds-direct .December2021 .topSection .topGallery .ol1{top:0;left:0;width:35%;height:100%}@media (max-width:600px){#diamonds-direct .December2021 .topSection .topGallery .ol1{top:0;left:0;width:100%;height:31%}}#diamonds-direct .December2021 .topSection .topGallery .ol2{top:0;left:36%;width:16%;height:48%}@media (max-width:600px){#diamonds-direct .December2021 .topSection .topGallery .ol2{top:32%;left:0;width:48%;height:16%}}#diamonds-direct .December2021 .topSection .topGallery .ol3{top:52%;left:36%;width:16%;height:48%}@media (max-width:600px){#diamonds-direct .December2021 .topSection .topGallery .ol3{top:49%;left:0;width:48%;height:15%}}#diamonds-direct .December2021 .topSection .topGallery .ol4{top:0;left:53%;width:15%;height:100%}@media (max-width:600px){#diamonds-direct .December2021 .topSection .topGallery .ol4{top:32%;left:52%;width:48%;height:32%}}#diamonds-direct .December2021 .topSection .topGallery .ol5{top:0;right:0;width:31%;height:100%}@media (max-width:600px){#diamonds-direct .December2021 .topSection .topGallery .ol5{top:65%;left:0;width:100%;height:35%}}#diamonds-direct .December2021 .formSection{position:relative;background:#00381e;overflow:auto;margin:25px auto;width:90%;max-width:800px}#diamonds-direct .December2021 .formSection .formHeader img{width:100%}#diamonds-direct .December2021 .formSection .formBoxWrapper{position:relative;width:90%;max-width:800px;margin:0 auto;overflow:auto}@media (max-width:600px){#diamonds-direct .December2021 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%}}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#fff;font-size:18px;text-align:center;margin:0 0 25px}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#00381e;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:#f2e8f2;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:1px solid #eb3533}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #00381e;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #00381e;background:#fff}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select option{background:#fff}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper .error select{border:1px solid #eb3533}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#fff;background:none;border:1px solid #fff;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#00381e;background:#fff;border-color:#fff}#diamonds-direct .December2021 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#f2e8f2;font-size:13px;text-align:center}#diamonds-direct .December2021 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .December2021 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .December2021 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .December2021 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .December2021 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .December2021 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .December2021 .ggSection{margin:10px auto 0;width:90%;max-width:800px;text-align:center}#diamonds-direct .December2021 .ggSection .ggTitle{width:80%;max-width:400px;margin:0 auto}#diamonds-direct .December2021 .ggSection .ggLine img,#diamonds-direct .December2021 .ggSection .ggTitle img{width:100%}#diamonds-direct .December2021 .ggSection .ggP{font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .December2021 .ggSection .ggButton{display:inline-block;margin:0 0 20px;background:#00381e;color:#fff;font-size:14px;text-transform:uppercase;text-align:center;padding:10px 50px;width:auto;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .December2021 .ggSection .ggButton:hover{background:#00381e;color:#fff}#diamonds-direct .December2021 .ggSection .ggItemRow .ggItem{display:inline-block;vertical-align:top;margin:5px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .December2021 .ggSection .ggItemRow .ggItem{width:calc(50% - 12px)}}#diamonds-direct .December2021 .ggSection .ggItemRow .ggItem:hover .ggItemLabel{color:#00381e}#diamonds-direct .December2021 .ggSection .ggItemRow .ggItem .ggItemImg{border:2px solid #badece;background-repeat:no-repeat;background-position:50%;background-size:cover;padding-bottom:100%}#diamonds-direct .December2021 .ggSection .ggItemRow .ggItem .ggItemImg1{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/bldxl18079.jpg\")}#diamonds-direct .December2021 .ggSection .ggItemRow .ggItem .ggItemImg2{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/bldmd30060.jpg\")}#diamonds-direct .December2021 .ggSection .ggItemRow .ggItem .ggItemImg3{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/nfanc29328.jpg\")}#diamonds-direct .December2021 .ggSection .ggItemRow .ggItem .ggItemImg4{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/efand14379.jpg\")}#diamonds-direct .December2021 .ggSection .ggItemRow .ggItem .ggItemLabel{text-align:left;height:40px;transition:color .25s ease-in-out 0ms}#diamonds-direct .December2021 .legalSection .legalInnerWrapper{margin:20px auto;width:90%;font-size:14px;color:#f2e8f2;text-align:center}#diamonds-direct .Valentines2022{font-family:Lato,sans-serif;color:#787878}#diamonds-direct .Valentines2022 .headerSection .headerSectionWrapper img{width:100%}#diamonds-direct .Valentines2022 .topSection{position:relative;margin:0 auto;width:90%;max-width:800px;padding:20px 0 0}@media (max-width:600px){#diamonds-direct .Valentines2022 .topSection{margin:0 auto;width:100%}}#diamonds-direct .Valentines2022 .topSection .topP.dark{color:#000}#diamonds-direct .Valentines2022 .topSection .topP.darkBold{color:#000;margin-bottom:5px;font-weight:700}#diamonds-direct .Valentines2022 .topSection .topP{font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .Valentines2022 .topSection .topTitleImg{position:relative;width:80%;margin:40px auto;max-width:600px}#diamonds-direct .Valentines2022 .topSection .topTitleImg img{width:100%}#diamonds-direct .Valentines2022 .topSection .topTitleImg .star{position:absolute;top:64%;left:76.5%;width:15px;height:15px;color:#383838;font-size:18px;font-weight:400}@media (max-width:600px){#diamonds-direct .Valentines2022 .topSection .topTitleImg .star{top:60%}}#diamonds-direct .Valentines2022 .topSection .boxSection{text-align:center;color:#787878;margin:0 auto;font-family:Lusitana,serif;width:90%;max-width:1200px;padding:25px 0}@media (max-width:600px){#diamonds-direct .Valentines2022 .topSection .boxSection{margin:0 auto}}#diamonds-direct .Valentines2022 .topSection .boxSection .fuImage{margin:0 auto 30px;width:60%;max-width:450px}#diamonds-direct .Valentines2022 .topSection .boxSection .fuImage img{width:100%}#diamonds-direct .Valentines2022 .topSection .boxSection .fuP{font-size:20px;margin:0 0 10px;color:#383838}#diamonds-direct .Valentines2022 .topSection .boxSection .fuP .fuPBold{font-weight:700}#diamonds-direct .Valentines2022 .topSection .boxSection .fuLegal{text-align:left;font-size:13px;font-weight:300;color:#383838;padding:0 25px}#diamonds-direct .Valentines2022 .topSection .boxSection .fuBox{color:#787878;border:1px solid #383838;margin:25px auto;padding:25px 10px;font-family:Lato,sans-serif;width:90%;max-width:480px}#diamonds-direct .Valentines2022 .topSection .boxSection .fuBox .box1{font-weight:900;font-size:26px;color:#000}#diamonds-direct .Valentines2022 .topSection .boxSection .fuBox .box2{font-weight:300;color:#000;margin:5px 0 0}#diamonds-direct .Valentines2022 .topSection .boxSection .fuBox .box3{font-weight:400;margin:5px 0 0;font-size:20px;color:#000}#diamonds-direct .Valentines2022 .topSection .boxSection .fuBox .boxButton{position:relative;font-size:14px;font-weight:700;border:none;color:#000;background:#f5eddd;width:180px;height:36px;margin:25px auto 10px;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Valentines2022 .topSection .boxSection .fuBox .boxButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Valentines2022 .topSection .boxSection .fuBox .boxButton:hover{background:#d6a88d}#diamonds-direct .Valentines2022 .topSection .boxSection .fuSave{height:35px}#diamonds-direct .Valentines2022 .topSection .boxSection .fuSave img{height:100%}#diamonds-direct .Valentines2022 .topSection .boxSection .fuDates{font-size:28px;margin:5px auto 10px;width:300px}#diamonds-direct .Valentines2022 .topSection .boxSection .fuDates img{width:100%}#diamonds-direct .Valentines2022 .topSection .topGallery{position:relative;width:100%}#diamonds-direct .Valentines2022 .topSection .topGallery img{width:100%}#diamonds-direct .Valentines2022 .topSection .topGallery .ol{position:absolute;cursor:pointer}#diamonds-direct .Valentines2022 .topSection .topGallery .ol1{top:0;left:0;width:35%;height:100%}@media (max-width:600px){#diamonds-direct .Valentines2022 .topSection .topGallery .ol1{top:0;left:0;width:100%;height:30.5%}}#diamonds-direct .Valentines2022 .topSection .topGallery .ol2{top:0;left:36%;width:28%;height:40%}@media (max-width:600px){#diamonds-direct .Valentines2022 .topSection .topGallery .ol2{top:31%;left:0;width:100%;height:16%}}#diamonds-direct .Valentines2022 .topSection .topGallery .ol4{top:43%;left:36%;width:28%;height:57%}@media (max-width:600px){#diamonds-direct .Valentines2022 .topSection .topGallery .ol4{top:47.5%;left:0;width:100%;height:22%}}#diamonds-direct .Valentines2022 .topSection .topGallery .ol5{top:0;left:65%;width:35%;height:100%}@media (max-width:600px){#diamonds-direct .Valentines2022 .topSection .topGallery .ol5{top:70%;left:0;width:100%;height:30%}}#diamonds-direct .Valentines2022 .designersSection{position:relative;margin:20px auto 0;width:90%;max-width:798px;border:2px solid #d6a88d}#diamonds-direct .Valentines2022 .designersSection .designersLeft{position:relative;padding:20px 0}@media (max-width:600px){#diamonds-direct .Valentines2022 .designersSection .designersLeft{width:100%;margin:0;padding:10px 0}}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designersTitle{color:#000;margin:20px auto 10px;font-family:Lusitana,serif;text-align:center;font-size:36px}@media (max-width:600px){#diamonds-direct .Valentines2022 .designersSection .designersLeft .designersTitle{font-size:28px}}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designersLine{width:90%;max-width:600px;margin:0 auto}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designersLine img{width:100%}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designersP{color:#787878;width:70%;font-size:20px;margin:0 auto 25px;text-align:center}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designersSelectWrapper{position:relative;width:80%;max-width:300px;margin:0 auto 25px;z-index:2}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper{width:90%;max-width:800px;margin:0 auto 25px;text-align:center}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerWrapper.noHover{cursor:default}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerWrapper.noHover:hover{color:#787878}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerWrapper{display:inline-block;color:#787878;margin:0 0 10px;width:auto;padding:0 10px;border-left:2px solid #d6a88d;cursor:pointer;font-size:18px;transition:color .25s ease-in-out 0ms}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerWrapper:first-child{border:none}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerWrapper:hover{color:#d6a88d}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerWrapper img{height:100%;width:100%;object-fit:contain}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsDates{width:90%;max-width:400px;margin:0 auto}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsDates img{width:100%}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours{position:relative;color:#787878;margin:0 0 30px}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourLine{display:inline-block;vertical-align:top;font-size:20px;margin:0 0 10px}@media (max-width:600px){#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourLine{display:block;font-size:16px}}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourLine .hourDay{display:inline-block;vertical-align:top;font-weight:700}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourLine .hourTime{display:inline-block;vertical-align:top;margin:0 0 0 5px}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourDash{display:inline-block;vertical-align:top;font-size:20px;font-weight:900;margin:0 5px;color:#d6a88d}@media (max-width:600px){#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsHours .hourDash{display:none}}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsButton{width:180px;margin:20px auto;color:#d6a88d;background:#fff;border:1px solid #d6a88d;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Valentines2022 .designersSection .designersLeft .designerResultsWrapper .designerResultsButton:hover{color:#fff;background:#d6a88d}#diamonds-direct .Valentines2022 .designersSection .designersRight{position:absolute;top:0;right:0;width:48.2%;height:100%;background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/summer2021/earrings.jpg\");background-repeat:no-repeat;background-position:50%;background-size:cover;cursor:pointer}@media (max-width:600px){#diamonds-direct .Valentines2022 .designersSection .designersRight{position:relative;width:100%;height:auto;padding-bottom:100%}}#diamonds-direct .Valentines2022 .formSection{position:relative;background:#f5eddd;overflow:auto;margin:25px auto;width:90%;max-width:800px}#diamonds-direct .Valentines2022 .formSection .formHeader img{width:100%}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper{position:relative;width:90%;max-width:800px;margin:0 auto;overflow:auto}@media (max-width:600px){#diamonds-direct .Valentines2022 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%}}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#787878;font-size:18px;text-align:center;margin:0 0 25px}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#383838;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:#f5eddd;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:1px solid #eb3533}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #787878;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #787878;background:#fff}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select option{background:#fff}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper .error select{border:1px solid #eb3533}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#787878;background:none;border:1px solid #787878;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#d6a88d;border-color:#d6a88d}#diamonds-direct .Valentines2022 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#f5eddd;font-size:13px;text-align:center}#diamonds-direct .Valentines2022 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Valentines2022 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Valentines2022 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Valentines2022 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Valentines2022 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Valentines2022 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Valentines2022 .ggSection{margin:10px auto 0;width:90%;max-width:800px;text-align:center}#diamonds-direct .Valentines2022 .ggSection .ggTitle{width:80%;max-width:400px;margin:0 auto}#diamonds-direct .Valentines2022 .ggSection .ggLine img,#diamonds-direct .Valentines2022 .ggSection .ggTitle img{width:100%}#diamonds-direct .Valentines2022 .ggSection .ggP{font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .Valentines2022 .ggSection .ggButton{display:inline-block;margin:0 0 20px;border:1px solid #383838;background:#fff;color:#383838;font-size:14px;text-transform:uppercase;text-align:center;padding:10px 25px;width:auto;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Valentines2022 .ggSection .ggButton:hover{background:#383838;color:#fff}#diamonds-direct .Valentines2022 .ggSection .ggItemRow .ggItem{display:inline-block;vertical-align:top;margin:5px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Valentines2022 .ggSection .ggItemRow .ggItem{width:calc(50% - 12px)}}#diamonds-direct .Valentines2022 .ggSection .ggItemRow .ggItem:hover .ggItemLabel{color:#383838}#diamonds-direct .Valentines2022 .ggSection .ggItemRow .ggItem .ggItemImg{border:2px solid #f5eddd;background-repeat:no-repeat;background-position:50%;background-size:cover;padding-bottom:100%}#diamonds-direct .Valentines2022 .ggSection .ggItemRow .ggItem .ggItemImg1{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/EHOOP05406.jpg\")}#diamonds-direct .Valentines2022 .ggSection .ggItemRow .ggItem .ggItemImg2{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/BLDXL19649.jpg\")}#diamonds-direct .Valentines2022 .ggSection .ggItemRow .ggItem .ggItemImg3{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/PBZ0200075.jpg\")}#diamonds-direct .Valentines2022 .ggSection .ggItemRow .ggItem .ggItemImg4{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/TBMIS05129.jpg\")}#diamonds-direct .Valentines2022 .ggSection .ggItemRow .ggItem .ggItemLabel{text-align:left;height:40px;transition:color .25s ease-in-out 0ms}#diamonds-direct .Valentines2022 .legalSection .legalInnerWrapper{margin:20px auto;width:90%;font-size:14px;color:#f5eddd;text-align:center}#diamonds-direct .Spring2022{color:#383838;background:#fff;font-family:Lato,sans-serif;overflow:auto}#diamonds-direct .Spring2022 .promoBanner{width:100%}#diamonds-direct .Spring2022 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .Spring2022 .promoBanner img.desktop600{display:none}}#diamonds-direct .Spring2022 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .Spring2022 .promoBanner img.mobile600{display:block}}#diamonds-direct .Spring2022 .topSection{margin:-7% auto 0;width:90%;max-width:1024px;text-align:center}@media (max-width:768px){#diamonds-direct .Spring2022 .topSection{margin:20px auto 0}}#diamonds-direct .Spring2022 .topSection .topCopy{width:70%;margin:0 auto 20px;font-size:18px}#diamonds-direct .Spring2022 .topSection .topTitle{margin:0 auto 20px;color:#c3b8b1;font-size:36px;font-weight:700;text-transform:uppercase;transition:font-size .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Spring2022 .topSection .topTitle{font-size:28px}}#diamonds-direct .Spring2022 .topSection .topSubtitle{color:#c3b8b1;font-size:24px;margin:0 0 20px}#diamonds-direct .Spring2022 .midBlock{margin:25px auto 10px;width:90%;max-width:1024px;text-align:center;font-size:18px}#diamonds-direct .Spring2022 .midBlock .midBlockCopy{margin:0 auto 20px;font-size:18px}#diamonds-direct .Spring2022 .midBlock .midBlockButtons .midBlockButton{display:inline-block;vertical-align:top;width:200px;padding:10px 0;font-size:16px;cursor:pointer;text-align:center;margin:0 10px 20px;color:#4b2d53;border:1px solid #4b2d53;background:#fff;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Spring2022 .midBlock .midBlockButtons .midBlockButton:hover{color:#fff;background:#4b2d53}#diamonds-direct .Spring2022 .cheersBlock{background:#fff;margin:0 auto;width:90%;max-width:1010px}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper{position:relative}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft{display:inline-block;vertical-align:top;width:calc(50% - 10px);margin:20px 5px;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft{width:calc(100% - 10px)}}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{text-align:center;padding:125px 12% 0;font-size:26px;font-weight:300;color:#000;transition:font-size .35s linear 0ms,margin .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{font-size:18px;padding:25px 12% 0}}@media (max-width:900px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{padding:0 5%;font-size:16px}}@media (max-width:768px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper{font-size:18px}}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .titlePurple{margin:1em 0;font-size:32px;color:#383838;font-weight:300;transition:font-size .35s linear 0ms}@media (max-width:1024px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .titlePurple{font-size:26px}}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .cbLeftCopy{margin:0 0 40px}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .cbLeftButton{display:inline-block;color:#e8dace;background:#fff;border:1px solid #e8dace;cursor:pointer;padding:10px 35px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbLeft .cbLeftWrapper .cbLeftButton:hover{color:#fff;background:#e8dace}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbRight{display:inline-block;vertical-align:top;margin:20px 5px;width:calc(50% - 10px);transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbRight{width:calc(100% - 10px);margin:0 0 20px}}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper{margin:0;padding:75px 25px;color:#000;background:#deecfa;text-align:center}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper img{width:100%}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrSuperTitle{font-size:28px;font-weight:700;margin:0 0 10px}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrTitle{font-size:24px;font-weight:700}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrDisc{font-size:18px;font-weight:300;margin:0 0 25px}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrDates{font-size:20px;font-weight:400}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrButton{display:inline-block;margin:20px 0;padding:10px 20px;font-size:14px;text-transform:uppercase;font-weight:700;background:#deecfa;color:#000;border:1px solid #000;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .cbRight .cbRightWrapper .cbrButton:hover{background:#000;color:#fff}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems{position:relative;display:block;margin:0 0 20px;width:100%;transition:width .35s linear 0ms}@media (max-width:768px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems{width:calc(100% - 10px)}}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiLink{position:absolute;cursor:pointer}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiLeft{top:0;left:0;width:32%;height:100%}@media (max-width:600px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiLeft{top:0;left:0;width:100%;height:33.3%}}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopLeft{top:0;left:33%;width:16.5%;height:52%}@media (max-width:600px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopLeft{top:34%;left:0;width:48.5%;height:16.5%}}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopRight{top:0;left:50%;width:16.5%;height:52%}@media (max-width:600px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiTopRight{top:34%;left:51.5%;width:48.5%;height:16.5%}}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiBottomMiddle{top:53%;left:33%;width:34%;height:47%}@media (max-width:600px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiBottomMiddle{top:51%;left:0;width:100%;height:15%}}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiRight{top:0;right:0;width:32%;height:100%}@media (max-width:600px){#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .cbiRight{top:66.7%;left:0;width:100%;height:33.3%}}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock.doubleItem{width:calc(100% - 12px)}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock{width:calc(50% - 12px)}#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems .itemBlock img,#diamonds-direct .Spring2022 .cheersBlock .cheersBlockWrapper .itemRow.cbItems img{width:100%}#diamonds-direct .Spring2022 .formBoxWrapper{position:relative;overflow:auto;background:#c3b8b1;margin:0 auto;z-index:3;font-family:Lato,sans-serif}@media (max-width:600px){#diamonds-direct .Spring2022 .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper{width:90%;max-width:1024px;margin:25px auto}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formP{color:#383838;text-align:center;margin:0 0 25px;padding-top:15px;font-size:20px;font-weight:400}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formTitle{color:#c3b8b1;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formDates{color:#c3b8b1;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #c3b8b1;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #c3b8b1;background:#fff}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#000;background:none;border:1px solid #000;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#000}#diamonds-direct .Spring2022 .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#c3b8b1;font-size:13px;text-align:center}#diamonds-direct .Spring2022 .copySection{margin:40px auto;max-width:1024px;width:90%;font-size:24px;font-weight:700;text-align:center;font-family:Lusitana,serif}#diamonds-direct .Spring2022 .blockSection{margin:25px 0 0}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper{width:90%;max-width:1024px;margin:12px auto}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .fianceBlock .mainRow .copyBlock{background:#c3b8b1}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .newlywedBlock .mainRow .copyBlock{background:#fff}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow{position:relative}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock{margin:6px;cursor:pointer}@media (max-width:768px){#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock{margin:6px}}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .imgBlock img{width:100%;display:block}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock{position:absolute;top:6px;right:6px;height:calc(100% - 12px);text-align:center}@media (max-width:768px){#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock{position:relative;top:0;right:0;height:auto;margin:6px}}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:5% 0;padding:0 5%;overflow:auto}@media (max-width:900px){#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:3% 0}}@media (max-width:768px){#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper{margin:0;padding:10% 5%}}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrDate{margin:75px 0 0;font-size:32px;font-weight:700}@media (max-width:768px){#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrDate{margin:0}}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrHr{width:120px;height:3px;background:#c3b8b1;margin:15px auto}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrLinkWrapper .mrLink{display:inline-block;vertical-align:top;width:auto;color:#383838;font-size:20px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrLinkWrapper .mrLink:hover{color:#c3b8b1}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .copyBlock .mrBlockWrapper .mrLinkWrapper .mrSeparation{display:inline-block;vertical-align:top;color:#c3b8b1;font-weight:900;font-size:24px;margin:0 5px}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightImg.mrBlock{margin-right:calc(50% + 12px/2)}@media (max-width:768px){#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightImg.mrBlock{display:none;margin-left:6px}}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightCopy.mrBlock{left:calc(50% + 12px/2)}@media (max-width:768px){#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .rightCopy.mrBlock{left:0}}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mobileMakeup.mrBlock{display:none}@media (max-width:768px){#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mobileMakeup.mrBlock{display:block}}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock{display:inline-block;vertical-align:top;width:calc(50% - 12px)}@media (max-width:768px){#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock{display:block;width:calc(100% - 12px)}#diamonds-direct .Spring2022 .blockSection .blockSectionWrapper .blockItem .mainRow .mrBlock:first-child{margin-bottom:12px}}#diamonds-direct .Spring2022 .legalRow{width:90%;max-width:1024px;margin:15px auto 25px;font-size:16px;text-align:center}#diamonds-direct .Summer2022{font-family:Lato,sans-serif}#diamonds-direct .Summer2022 .headerSection .headerSectionWrapper{position:relative}#diamonds-direct .Summer2022 .headerSection .headerSectionWrapper img{width:100%}#diamonds-direct .Summer2022 .headerSection .headerSectionWrapper .shopButton{position:absolute;top:73%;left:61%;width:20%;height:10%;background:transparent;color:#000;border:1px solid #000;outline:none;font-size:16px;font-weight:700;text-transform:uppercase;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Summer2022 .headerSection .headerSectionWrapper .shopButton:hover{color:#fff;background:#000}@media (max-width:900px){#diamonds-direct .Summer2022 .headerSection .headerSectionWrapper .shopButton{font-size:14px}}@media (max-width:600px){#diamonds-direct .Summer2022 .headerSection .headerSectionWrapper .shopButton{top:85%;left:20%;width:60%;height:8%;font-size:18px}}#diamonds-direct .Summer2022 .shopSection{position:relative;margin:0 auto;width:90%;max-width:1024px;padding:25px 0;border-bottom:2px solid #d3d690}#diamonds-direct .Summer2022 .shopSection .shopButtonWrapper .shopButton{width:100%;height:60px;background:#f6f7d2;color:#000;border:none;outline:none;font-size:18px;font-weight:700;text-transform:uppercase;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Summer2022 .shopSection .shopButtonWrapper .shopButton:hover{background:#d3d690}#diamonds-direct .Summer2022 .shopSection .shopTilesWrapper{margin:0;text-align:center}#diamonds-direct .Summer2022 .shopSection .shopTilesWrapper .shopTile{position:relative;display:inline-block;margin:25px 15px 0;width:calc(33.33% - 30px);cursor:pointer}@media (max-width:900px){#diamonds-direct .Summer2022 .shopSection .shopTilesWrapper .shopTile{width:calc(40% - 30px)}}@media (max-width:600px){#diamonds-direct .Summer2022 .shopSection .shopTilesWrapper .shopTile{width:calc(70% - 30px)}}#diamonds-direct .Summer2022 .shopSection .shopTilesWrapper .shopTile .shopImg img{width:100%}#diamonds-direct .Summer2022 .shopSection .shopTilesWrapper .shopTile .shopTileButton{position:relative;margin:-20px auto 0;width:80%;height:35px;background:#000;color:#fff;font-size:14px;font-weight:700;text-transform:uppercase}#diamonds-direct .Summer2022 .shopSection .shopTilesWrapper .shopTile .shopTileButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Summer2022 .titleSection{margin:25px auto 0;width:90%;max-width:768px;text-align:center}#diamonds-direct .Summer2022 .titleSection .mainTitle{font-size:24px;font-weight:900}#diamonds-direct .Summer2022 .titleSection .iconLineWrapper{margin:10px auto;width:70%}#diamonds-direct .Summer2022 .titleSection .iconLineWrapper img{width:100%}#diamonds-direct .Summer2022 .titleSection .titleP{margin:0 0 10px;font-size:20px}#diamonds-direct .Summer2022 .titleSection .titleBig{font-size:48px;font-family:Lusitana,serif;margin:0 0 10px}#diamonds-direct .Summer2022 .topSection{position:relative;margin:0 auto;width:90%;max-width:1024px}@media (max-width:600px){#diamonds-direct .Summer2022 .topSection{margin:0 auto;width:100%}}#diamonds-direct .Summer2022 .topSection .topRow{position:relative;text-align:center}#diamonds-direct .Summer2022 .topSection .topRow .copyBlock{padding:30px 0;display:inline-block;width:45%;vertical-align:top}@media (max-width:768px){#diamonds-direct .Summer2022 .topSection .topRow .copyBlock{width:70%}}#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topP{color:gray;font-size:22px;width:70%;margin:0 auto 20px;text-align:center}@media (max-width:768px){#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topP{font-size:20px;width:90%}}#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topTitle{width:65%;margin:10px auto}#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topTitle img{width:100%}#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDates{color:#000;text-align:center;margin:0 auto 20px 0;font-size:32px;font-family:Lusitana,serif}#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDatesHr{width:100px;height:5px;margin:0 auto 25px;background:#d3d690}#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDatesRow{text-align:center;width:90%;margin:0 auto 2px}#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDatesRow .storeLink{color:gray;font-size:20px;cursor:pointer;transition:color .25s ease-in-out 0ms}#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDatesRow .storeLink:hover{color:#d3d690}@media (max-width:900px){#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDatesRow .storeLink{font-size:18px}}@media (max-width:768px){#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDatesRow .storeLink{font-size:14px}}@media (max-width:600px){#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDatesRow .storeLink{font-size:20px}}#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDatesRow .storePipe{font-size:22px;font-weight:700;color:#d3d690;margin:0 5px}@media (max-width:900px){#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDatesRow .storePipe{font-size:20px}}@media (max-width:768px){#diamonds-direct .Summer2022 .topSection .topRow .copyBlock .topDatesRow .storePipe{font-size:16px;margin:0 3px}}#diamonds-direct .Summer2022 .formSection{position:relative;padding:0 0 25px;margin:25px auto 0;width:90%;max-width:1024px;background:#fff;border-top:2px solid #d3d690;overflow:auto}#diamonds-direct .Summer2022 .formSection .formHeader img{width:100%}#diamonds-direct .Summer2022 .formSection .formBoxWrapper{position:relative;width:90%;max-width:800px;margin:25px auto 0;overflow:auto}@media (max-width:600px){#diamonds-direct .Summer2022 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%}}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formP{color:gray;font-size:18px;text-align:center;margin:0 0 25px}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:gray;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:gray;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:1px solid #eb3533}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid gray;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #d3d690;background:#fff}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select option{background:#fff}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper .error select{border:1px solid #eb3533}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#000;background:#f1e1cb;border:none;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#000;background:#f6f7d2}#diamonds-direct .Summer2022 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:gray;font-size:13px;text-align:center}#diamonds-direct .Summer2022 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Summer2022 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Summer2022 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Summer2022 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Summer2022 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Summer2022 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Summer2022 .midSection .midP{color:#000;text-align:center;margin:0 auto 20px 0;font-size:32px;font-family:Lusitana,serif}#diamonds-direct .Summer2022 .looksSection{position:relative;margin:30px auto;width:90%;max-width:1000px}@media (max-width:600px){#diamonds-direct .Summer2022 .looksSection{padding:0}}#diamonds-direct .Summer2022 .looksSection .looksWrapper{position:relative}#diamonds-direct .Summer2022 .looksSection .looksWrapper img{width:100%}#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb{position:absolute;cursor:pointer}#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb1{top:0;left:0;width:35%;height:100%}@media (max-width:600px){#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb1{width:100%;height:35%}}#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb2{top:0;left:36%;width:41%;height:40%}@media (max-width:600px){#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb2{top:36%;left:0;width:100%;height:13%}}#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb3{top:43%;left:36%;width:20%;height:57%}@media (max-width:600px){#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb3{top:50%;left:0;width:48%;height:16.5%}}#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb4{top:43%;left:57%;width:20%;height:57%}@media (max-width:600px){#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb4{top:50%;left:52%;width:48%;height:16.5%}}#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb5{bottom:0;right:0;width:22%;height:100%}@media (max-width:600px){#diamonds-direct .Summer2022 .looksSection .looksWrapper .lb5{width:100%;height:33%}}#diamonds-direct .Summer2022 .legalSection .legalInnerWrapper{margin:20px auto;width:90%;font-size:14px;color:gray;text-align:center}#diamonds-direct .SingleDesigner2022 .promoBanner{position:relative;width:100%}#diamonds-direct .SingleDesigner2022 .promoBanner img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .promoBanner img.desktop600{display:none}}#diamonds-direct .SingleDesigner2022 .promoBanner img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .promoBanner img.mobile600{display:block}}#diamonds-direct .SingleDesigner2022 .promoBanner .headerSelectWrapper{position:absolute;top:60%;left:53.5%;width:35%;height:5%}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .promoBanner .headerSelectWrapper{top:40%;left:20%;width:60%}}#diamonds-direct .SingleDesigner2022 .promoBanner .headerSelectWrapper .singleSelect{background:#fff}#diamonds-direct .SingleDesigner2022 .designersWrapper{margin:-1% 0 0;position:relative;z-index:10;min-height:100px;transition:margin .35s linear 0ms}#diamonds-direct .SingleDesigner2022 .designersWrapper .designerBlock .designerBanner{margin:25px auto;width:60%;max-width:240px;text-align:center}#diamonds-direct .SingleDesigner2022 .designersWrapper .designerBlock .designerBanner img{max-width:100%;max-height:200px}#diamonds-direct .SingleDesigner2022 .designersWrapper .designerBlock .designerDisplay{margin:0 0 40px}#diamonds-direct .SingleDesigner2022 .designersWrapper .designerBlock .designerDisplay .daysWrapper{text-align:center}#diamonds-direct .SingleDesigner2022 .designersWrapper .designerBlock .designerDisplay .daysWrapper .dayBlock{display:inline-block;width:calc(50% - 1px);max-width:240px;vertical-align:top}#diamonds-direct .SingleDesigner2022 .designersWrapper .designerBlock .designerDisplay .daysWrapper .dayBlock:first-child{border-right:1px solid #333}#diamonds-direct .SingleDesigner2022 .designersWrapper .designerBlock .designerDisplay .daysWrapper .dayBlock .dayValue{font-size:24px;font-weight:700}#diamonds-direct .SingleDesigner2022 .designersWrapper .designerBlock .designerDisplay .daysWrapper .dayBlock .timeValue{font-family:Lato,sans-serif;font-size:20px}#diamonds-direct .SingleDesigner2022 .formBoxWrapper{position:relative;overflow:auto;background:#f0f0f0;margin:0 auto 25px;width:90%;max-width:1024px;z-index:3;font-family:Lato,sans-serif}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .formBoxWrapper{margin:0 auto 20px;border:none;width:100%;overflow:auto;z-index:0}}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper{width:90%;max-width:1024px;margin:25px auto}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formP{color:#333;text-align:center;margin:0 0 25px;padding-top:15px;font-size:20px;font-weight:400}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formTitle{color:#5e5e5e;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formDates{color:#5e5e5e;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #5e5e5e;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:2px solid #eb3533}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #5e5e5e;background:#fff}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select.error{border:2px solid #eb3533}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#333;background:#fff;border:1px solid #333;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#333}#diamonds-direct .SingleDesigner2022 .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#5e5e5e;font-size:13px;text-align:center}#diamonds-direct .SingleDesigner2022 .boxSection{text-align:center;color:#532282;margin:0 auto;font-family:Lusitana,serif;width:90%;max-width:1200px;padding:25px 0}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .boxSection{margin:0 auto}}#diamonds-direct .SingleDesigner2022 .boxSection .fuImage{margin:0 auto 30px;width:60%;max-width:450px}#diamonds-direct .SingleDesigner2022 .boxSection .fuImage img{width:100%}#diamonds-direct .SingleDesigner2022 .boxSection .fuP{font-size:20px;margin:0 0 10px;color:#5e5e5e}#diamonds-direct .SingleDesigner2022 .boxSection .fuP .fuPBold{font-weight:700}#diamonds-direct .SingleDesigner2022 .boxSection .fuLegal{text-align:left;font-size:13px;font-weight:300;color:#5e5e5e;padding:0 25px}#diamonds-direct .SingleDesigner2022 .boxSection .fuBox{color:#532282;border:1px solid #5e5e5e;margin:10px auto;padding:10px;font-family:Lato,sans-serif;width:90%;max-width:480px}#diamonds-direct .SingleDesigner2022 .boxSection .fuBox .box1{font-weight:900;font-size:26px}#diamonds-direct .SingleDesigner2022 .boxSection .fuBox .box2{font-weight:300}#diamonds-direct .SingleDesigner2022 .boxSection .fuBox .box3{font-weight:400;margin:5px 0 0;font-size:20px}#diamonds-direct .SingleDesigner2022 .boxSection .fuBox .boxButton{position:relative;font-size:14px;border:1px solid #532282;color:#532282;background:#fff;width:180px;height:36px;margin:25px auto;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}#diamonds-direct .SingleDesigner2022 .boxSection .fuBox .boxButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .SingleDesigner2022 .boxSection .fuBox .boxButton:hover{color:#fff;background:#532282}#diamonds-direct .SingleDesigner2022 .boxSection .fuSave{height:35px}#diamonds-direct .SingleDesigner2022 .boxSection .fuSave img{height:100%}#diamonds-direct .SingleDesigner2022 .boxSection .fuDates{font-size:28px;margin:5px auto 10px;width:300px}#diamonds-direct .SingleDesigner2022 .boxSection .fuDates img{width:100%}#diamonds-direct .SingleDesigner2022 .imagesSection{position:relative;margin:0 auto 25px;width:90%;max-width:1024px}#diamonds-direct .SingleDesigner2022 .imagesSection img.desktop600{width:100%;display:block}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .imagesSection img.desktop600{display:none}}#diamonds-direct .SingleDesigner2022 .imagesSection img.mobile600{width:100%;display:none}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .imagesSection img.mobile600{display:block}}#diamonds-direct .SingleDesigner2022 .imagesSection .imgLink{position:absolute;cursor:pointer}#diamonds-direct .SingleDesigner2022 .imagesSection .img1{top:0;left:0;width:33%;height:100%}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .imagesSection .img1{top:0;left:0;width:100%;height:33%}}#diamonds-direct .SingleDesigner2022 .imagesSection .img2{top:0;left:34%;width:32%;height:100%}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .imagesSection .img2{top:34%;left:0;width:100%;height:32%}}#diamonds-direct .SingleDesigner2022 .imagesSection .img3{top:0;left:67%;width:33%;height:100%}@media (max-width:600px){#diamonds-direct .SingleDesigner2022 .imagesSection .img3{top:67%;left:0;width:100%;height:33%}}#diamonds-direct .Auburn2022{font-family:Lato,sans-serif}#diamonds-direct .Auburn2022 .bannerWrapper img{width:100%}#diamonds-direct .Auburn2022 .legalWrapper{margin:30px auto 20px;width:90%;max-width:1060px;color:gray;font-size:14px;font-weight:300}#diamonds-direct .Auburn2022 .formSection{position:relative;overflow:auto;margin:-4% auto 0;width:90%;max-width:900px;background:#fff;box-shadow:10px 10px 0 0 rgba(0,0,0,.2)}@media (max-width:600px){#diamonds-direct .Auburn2022 .formSection{box-shadow:none;margin:0 auto}}#diamonds-direct .Auburn2022 .formSection .formHeader img{width:100%}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper{position:relative;margin:5px;border:1px solid #0f2c5a}@media (max-width:600px){#diamonds-direct .Auburn2022 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%}}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formP.left{text-align:left}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formP.narrow{padding:0 15%}@media (max-width:600px){#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formP.narrow{padding:0 5%}}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#000;font-size:18px;text-align:center;margin:0 0 25px}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formP .em{color:#e16e39}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formP .emBig{font-size:20px;font-weight:700;color:#e16e39}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:1px solid #eb3533}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid gray;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #d3d690;background:#fff}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select option{background:#fff}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper .error select{border:1px solid #eb3533}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#fff;background:#e16e39;border:none;cursor:pointer;padding:12px 35px;font-size:16px;font-weight:400;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#a1391e}#diamonds-direct .Auburn2022 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:gray;font-size:13px;text-align:center}#diamonds-direct .Auburn2022 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Auburn2022 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Auburn2022 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Auburn2022 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Auburn2022 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Auburn2022 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Earring2022{color:#000;font-family:Lato,sans-serif}#diamonds-direct .Earring2022 .headerSection .headerSectionWrapper{position:relative}#diamonds-direct .Earring2022 .headerSection .headerSectionWrapper img{width:100%}#diamonds-direct .Earring2022 .headerSection .headerSectionWrapper .shopButton{position:absolute;top:73%;left:61%;width:20%;height:10%;background:transparent;color:#000;border:1px solid #000;outline:none;font-size:16px;font-weight:700;text-transform:uppercase;cursor:pointer;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms}#diamonds-direct .Earring2022 .headerSection .headerSectionWrapper .shopButton:hover{color:#fff;background:#000}@media (max-width:900px){#diamonds-direct .Earring2022 .headerSection .headerSectionWrapper .shopButton{font-size:14px}}@media (max-width:600px){#diamonds-direct .Earring2022 .headerSection .headerSectionWrapper .shopButton{top:85%;left:20%;width:60%;height:8%;font-size:18px}}#diamonds-direct .Earring2022 .shopSection{position:relative;margin:25px auto 0;width:90%;max-width:1024px}#diamonds-direct .Earring2022 .shopSection .shopButtonWrapper .shopButton{width:100%;height:60px;background:#fff;color:#000;border:none;outline:none;font-size:32px;font-weight:400;font-family:Lusitana,serif;text-transform:uppercase;cursor:default;transition:background .25s ease-in-out 0ms,font-size .35s linear 0ms}#diamonds-direct .Earring2022 .shopSection .shopButtonWrapper .shopButton:hover{background:#fff}@media (max-width:600px){#diamonds-direct .Earring2022 .shopSection .shopButtonWrapper .shopButton{font-size:28px}}#diamonds-direct .Earring2022 .shopSection .shopTilesWrapper{margin:0;padding:0 0 25px;text-align:center;border-top:2px solid #a59dc7;border-bottom:2px solid #a59dc7}#diamonds-direct .Earring2022 .shopSection .shopTilesWrapper .shopTile{position:relative;display:inline-block;margin:25px 15px 0;width:calc(33.33% - 30px);cursor:pointer}@media (max-width:900px){#diamonds-direct .Earring2022 .shopSection .shopTilesWrapper .shopTile{width:calc(40% - 30px)}}@media (max-width:600px){#diamonds-direct .Earring2022 .shopSection .shopTilesWrapper .shopTile{width:calc(80% - 30px)}}#diamonds-direct .Earring2022 .shopSection .shopTilesWrapper .shopTile:hover .shopTileButton{background:#a59dc7}#diamonds-direct .Earring2022 .shopSection .shopTilesWrapper .shopTile .shopImg img{width:100%}#diamonds-direct .Earring2022 .shopSection .shopTilesWrapper .shopTile .shopTileButton{position:relative;margin:-20px auto 0;width:80%;height:35px;background:#000;color:#fff;font-size:14px;font-weight:700;text-transform:uppercase;transition:background .25s ease-in-out 0ms}#diamonds-direct .Earring2022 .shopSection .shopTilesWrapper .shopTile .shopTileButton div{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .Earring2022 .midHeaderSection{margin:40px auto 0;width:90%;max-width:1024px;cursor:pointer}#diamonds-direct .Earring2022 .midHeaderSection .midHeaderSectionWrapper{position:relative}#diamonds-direct .Earring2022 .midHeaderSection .midHeaderSectionWrapper img{width:100%}#diamonds-direct .Earring2022 .titleSection{margin:40px auto 0;width:90%;max-width:1024px;text-align:center}#diamonds-direct .Earring2022 .titleSection .title1{color:#787878;font-family:Lusitana,serif;font-size:18px;margin:0 0 10px}#diamonds-direct .Earring2022 .titleSection .title2{color:#000;font-size:36px;font-weight:700}#diamonds-direct .Earring2022 .titleSection .title3{color:#000;font-size:24px;margin:0 0 10px}#diamonds-direct .Earring2022 .titleSection .title4{color:#000;font-size:18px;margin:0 0 25px}#diamonds-direct .Earring2022 .titleSection .titleAction{display:inline-block;width:auto;padding:10px 40px;font-size:14px;font-weight:700;text-transform:uppercase;color:#fff;background:#a59dc7;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Earring2022 .titleSection .titleAction:hover{background:#000}#diamonds-direct .Earring2022 .formSection{position:relative;padding:0 0 25px;margin:25px auto 0;width:90%;max-width:1024px;background:#a59dc7;overflow:auto}#diamonds-direct .Earring2022 .formSection .formHeader img{width:100%}#diamonds-direct .Earring2022 .formSection .formBoxWrapper{position:relative;width:90%;max-width:800px;margin:25px auto 0;overflow:auto}@media (max-width:600px){#diamonds-direct .Earring2022 .formSection .formBoxWrapper{margin:0 auto 20px;border:none;width:100%}}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper{width:90%;margin:25px auto}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formP{color:#fff;font-size:18px;text-align:center;margin:0 0 25px}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formTitle{color:#787878;font-weight:900;font-size:36px;text-align:center;margin:0}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formDates{color:#787878;font-weight:700;font-size:26px;text-align:center;margin:0 0 25px}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper{text-align:left;margin:0 0 25px}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{display:inline-block;vertical-align:top;width:calc(50% - 20px);margin:5px 10px}@media (max-width:600px){#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper{width:calc(100% - 20px)}}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input.error{border:1px solid #eb3533}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper input{vertical-align:top;border:1px solid #fff;padding:10px 8px;width:calc(100% - 18px)}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select{vertical-align:top;border:1px solid #fff;background:#fff}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper select option{background:#fff}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formInputWrapper .error select{border:1px solid #eb3533}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow{text-align:center;margin:10px 0}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction{color:#fff;background:transparent;border:1px solid #fff;cursor:pointer;padding:10px 25px;text-transform:uppercase;font-size:14px;font-weight:700;transition:background .25s ease-in-out 0ms,color .25s ease-in-out 0ms,border .25s ease-in-out 0ms}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formWrapper .formActionRow .formAction:hover{color:#fff;background:#000;border:1px solid #000}#diamonds-direct .Earring2022 .formSection .formBoxWrapper .formInnerWrapper .formLegal{margin:0;color:#787878;font-size:13px;text-align:center}#diamonds-direct .Earring2022 .formSection .formSectionFooter{position:absolute;left:0;right:0;bottom:-22.5%;height:45%;z-index:1}@media (max-width:600px){#diamonds-direct .Earring2022 .formSection .formSectionFooter{bottom:-10%;height:17%}}#diamonds-direct .Earring2022 .formSection .formSectionFooter .footerLeftImage{position:absolute;top:0;bottom:0;width:50%;left:0;text-align:left}#diamonds-direct .Earring2022 .formSection .formSectionFooter .footerLeftImage img{height:100%}#diamonds-direct .Earring2022 .formSection .formSectionFooter .footerRightImage{position:absolute;top:0;bottom:0;width:50%;right:0;text-align:right}#diamonds-direct .Earring2022 .formSection .formSectionFooter .footerRightImage img{height:100%}#diamonds-direct .Earring2022 .looksSection{position:relative;margin:30px auto;width:90%;max-width:1024px}@media (max-width:600px){#diamonds-direct .Earring2022 .looksSection{padding:0}}#diamonds-direct .Earring2022 .looksSection .looksWrapper{position:relative}#diamonds-direct .Earring2022 .looksSection .looksWrapper img{width:100%}#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb{position:absolute;cursor:pointer}#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb1{top:0;left:0;width:43%;height:100%}@media (max-width:600px){#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb1{width:100%;height:55%}}#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb2{top:0;left:45%;width:21%;height:100%}@media (max-width:600px){#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb2{top:57%;left:0;width:40%;height:43%}}#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb3{top:0;right:0;width:32%;height:48%}@media (max-width:600px){#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb3{top:57%;right:0;width:59%;height:20%}}#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb4{top:52%;right:0;width:32%;height:48%}@media (max-width:600px){#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb4{top:79%;right:0;width:59%;height:21%}}#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb5{top:53%;left:41.5%;width:35%;height:47%}@media (max-width:600px){#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb5{top:48%;left:43%;width:57%;height:18%}}#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb6{bottom:0;right:0;width:22.5%;height:100%}@media (max-width:600px){#diamonds-direct .Earring2022 .looksSection .looksWrapper .lb6{width:100%;height:32%}}#diamonds-direct .Earring2022 .ggSection{margin:40px auto 0;width:90%;max-width:800px;text-align:center}#diamonds-direct .Earring2022 .ggSection .ggTitle{width:80%;max-width:400px;margin:0 auto}#diamonds-direct .Earring2022 .ggSection .ggLine img,#diamonds-direct .Earring2022 .ggSection .ggTitle img{width:100%}#diamonds-direct .Earring2022 .ggSection .ggP{color:#787878;font-size:22px;margin:0 0 20px;text-align:center;font-family:Lusitana,serif}#diamonds-direct .Earring2022 .ggSection .ggButton{display:inline-block;margin:0 0 20px;border:none;background:#a59dc7;color:#fff;font-size:14px;text-transform:uppercase;text-align:center;padding:10px 40px;width:auto;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .Earring2022 .ggSection .ggButton:hover{color:#fff;background:#000}#diamonds-direct .Earring2022 .ggSection .ggItemRow .ggItem{display:inline-block;text-decoration:none;vertical-align:top;margin:5px;width:calc(25% - 12px);cursor:pointer;transition:width .35s linear 0ms}@media (max-width:600px){#diamonds-direct .Earring2022 .ggSection .ggItemRow .ggItem{width:calc(50% - 12px)}}#diamonds-direct .Earring2022 .ggSection .ggItemRow .ggItem:hover .ggItemImg{border-color:#000}#diamonds-direct .Earring2022 .ggSection .ggItemRow .ggItem:hover .ggItemLabel{color:#000}#diamonds-direct .Earring2022 .ggSection .ggItemRow .ggItem .ggItemImg{border:2px solid #a59dc7;background-repeat:no-repeat;background-position:50%;background-size:cover;padding-bottom:100%;transition:border .4s ease-in-out 0ms}#diamonds-direct .Earring2022 .ggSection .ggItemRow .ggItem .ggItemImg1{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/bldx18079.jpg\")}#diamonds-direct .Earring2022 .ggSection .ggItemRow .ggItem .ggItemImg2{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/eclst07283.jpg\")}#diamonds-direct .Earring2022 .ggSection .ggItemRow .ggItem .ggItemImg3{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/nfanc22315.jpg\")}#diamonds-direct .Earring2022 .ggSection .ggItemRow .ggItem .ggItemImg4{background-image:url(\"https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/bldsm23102.jpg\")}#diamonds-direct .Earring2022 .ggSection .ggItemRow .ggItem .ggItemLabel{color:#787878;text-decoration:none;text-align:left;height:40px;transition:color .4s ease-in-out 0ms}#diamonds-direct .Earring2022 .legalSection .legalInnerWrapper{margin:20px auto;width:90%;font-size:14px;color:#787878;text-align:center}#diamonds-direct .SearchResults{margin:25px auto;width:90%;max-width:1200px;font-family:Lato,sans-serif}#diamonds-direct .SearchResults .searchTitle{margin:0 0 20px;font-size:36px;font-weight:400}@media (max-width:768px){#diamonds-direct .SearchResults .searchTitle{font-size:24px}}#diamonds-direct .SearchResults .searchControls{position:relative;margin:0 0 20px}#diamonds-direct .SearchResults .searchControls .inputWrapper{display:inline-block;vertical-align:top;width:calc(100% - 200px);margin:0}@media (max-width:768px){#diamonds-direct .SearchResults .searchControls .inputWrapper{display:block;width:100%;margin:0 0 10px}}#diamonds-direct .SearchResults .searchControls .inputWrapper input{border:1px solid #adadad;margin:0;padding:10px 15px;font-size:22px;width:calc(100% - 32px)}#diamonds-direct .SearchResults .searchControls .buttonWrapper{display:inline-block;vertical-align:top;width:180px;margin:0 0 0 20px}@media (max-width:768px){#diamonds-direct .SearchResults .searchControls .buttonWrapper{display:block;width:100%;margin:0 0 10px}}#diamonds-direct .SearchResults .searchControls .buttonWrapper .searchIconButton{position:relative;color:#fff;background:#4b2d53;border:none;height:46px;cursor:pointer;transition:background .25s ease-in-out 0ms}#diamonds-direct .SearchResults .searchControls .buttonWrapper .searchIconButton:hover{background:#623b6c}#diamonds-direct .SearchResults .searchControls .buttonWrapper .searchIconButton .buttonIcon{position:absolute;top:12px;bottom:10px;left:12px;width:22px}#diamonds-direct .SearchResults .searchControls .buttonWrapper .searchIconButton .buttonIcon img{width:100%}#diamonds-direct .SearchResults .searchControls .buttonWrapper .searchIconButton .buttonText{margin:0 0 0 50px;font-size:24px;padding:10px 0}#diamonds-direct .SearchResults .resultsWrapper{position:relative}#diamonds-direct .SearchResults .resultsWrapper .resultsTabWrapper{border-left:2px solid #4b2d53}#diamonds-direct .SearchResults .resultsWrapper .resultsTabWrapper .selectedTab.resultTab{color:#fff;background:#4b2d53;cursor:default}#diamonds-direct .SearchResults .resultsWrapper .resultsTabWrapper .selectedTab.resultTab:hover{color:#fff;background:#4b2d53}#diamonds-direct .SearchResults .resultsWrapper .resultsTabWrapper .resultTab{display:inline-block;width:200px;height:30px;line-height:30px;text-align:center;font-size:16px;font-weight:400;text-transform:uppercase;border-right:2px solid #4b2d53;color:#4b2d53;background:#fff;cursor:pointer;transition:color .25s ease-in-out 0ms,background .25s ease-in-out 0ms}@media (max-width:768px){#diamonds-direct .SearchResults .resultsWrapper .resultsTabWrapper .resultTab{width:calc(50% - 2px)}}#diamonds-direct .SearchResults .resultsWrapper .resultsTabWrapper .resultTab:hover{color:#fff;background:#000}#diamonds-direct .SearchResults .resultsWrapper .resultsBody{position:relative;border:1px solid #d3d3d3;margin:0 0 10px;padding:10px 0}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .bodyLabel{text-align:center;margin:0 0 25px;font-size:20px;font-weight:300}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .searchPrompt{margin:40px 10%;font-size:28px;font-weight:300;text-align:center}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper{text-align:center}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .resultItemsNoResults{margin:40px 10%;font-size:28px;font-weight:300;text-align:center}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem{position:relative;display:inline-block;vertical-align:top;width:25%;min-width:250px;margin:0 0 25px;text-align:center;outline:none}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper{border:1px solid #fff;margin:5px 10px;padding:10px 0}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .favSelectWrapper{position:absolute;top:10px;right:15px;width:20px;height:20px;cursor:pointer}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .favSelectWrapper img{width:100%}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemImgWrapper{display:block;height:150px;width:150px;margin:0 auto;cursor:pointer;outline:none}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemImgWrapper img{max-height:100%;max-width:100%}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemTitle{margin:10px 0 5px;font-size:16px;cursor:pointer}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .diamondBannerItem .diamondItemInnerWrapper .diamondItemPrice{display:inline-block;width:auto;margin:0 0 5px;font-size:18px;font-weight:300;border-top:2px solid #4b2d53;padding:5px 20px;cursor:pointer;outline:none}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem{position:relative;display:inline-block;vertical-align:top;width:25%;min-width:250px;margin:0 0 25px;text-align:center;outline:none}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper{border:1px solid #fff;margin:5px 10px;padding:0 0 10px}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .favSelectWrapper{position:absolute;top:10px;right:15px;width:20px;height:20px;cursor:pointer}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .favSelectWrapper img{width:100%}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemImgWrapper{display:block;height:180px;width:180px;margin:0 auto;cursor:pointer;outline:none}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemImgWrapper img{max-height:100%;max-width:100%}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .productItemTitle{display:block;position:relative;margin:0 0 5px;font-size:15px;height:36px;cursor:pointer;outline:none;color:#333;text-decoration:none}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .productItemTitle div{position:absolute;top:0;left:5%;right:5%;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#diamonds-direct .SearchResults .resultsWrapper .resultsBody .resultItemsWrapper .productBannerItem .productItemInnerWrapper .diamondItemPrice{display:inline-block;width:auto;margin:0 0 5px;font-size:18px;font-weight:300;border-top:2px solid #4b2d53;padding:5px 20px;cursor:pointer;outline:none;color:#333;text-decoration:none}#diamonds-direct input:focus,#diamonds-direct select:focus{outline:none}#diamonds-direct :invalid{box-shadow:none}#diamonds-direct :-moz-submit-invalid,#diamonds-direct :-moz-ui-invalid{box-shadow:none}", ""]);
	
	// exports


/***/ }),
/* 885 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 886 */
/***/ (function(module, exports) {

	
	// easing functions from "Tween.js"
	
	exports.linear = function(n){
	  return n;
	};
	
	exports.inQuad = function(n){
	  return n * n;
	};
	
	exports.outQuad = function(n){
	  return n * (2 - n);
	};
	
	exports.inOutQuad = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n;
	  return - 0.5 * (--n * (n - 2) - 1);
	};
	
	exports.inCube = function(n){
	  return n * n * n;
	};
	
	exports.outCube = function(n){
	  return --n * n * n + 1;
	};
	
	exports.inOutCube = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n * n;
	  return 0.5 * ((n -= 2 ) * n * n + 2);
	};
	
	exports.inQuart = function(n){
	  return n * n * n * n;
	};
	
	exports.outQuart = function(n){
	  return 1 - (--n * n * n * n);
	};
	
	exports.inOutQuart = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n * n * n;
	  return -0.5 * ((n -= 2) * n * n * n - 2);
	};
	
	exports.inQuint = function(n){
	  return n * n * n * n * n;
	}
	
	exports.outQuint = function(n){
	  return --n * n * n * n * n + 1;
	}
	
	exports.inOutQuint = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n * n * n * n;
	  return 0.5 * ((n -= 2) * n * n * n * n + 2);
	};
	
	exports.inSine = function(n){
	  return 1 - Math.cos(n * Math.PI / 2 );
	};
	
	exports.outSine = function(n){
	  return Math.sin(n * Math.PI / 2);
	};
	
	exports.inOutSine = function(n){
	  return .5 * (1 - Math.cos(Math.PI * n));
	};
	
	exports.inExpo = function(n){
	  return 0 == n ? 0 : Math.pow(1024, n - 1);
	};
	
	exports.outExpo = function(n){
	  return 1 == n ? n : 1 - Math.pow(2, -10 * n);
	};
	
	exports.inOutExpo = function(n){
	  if (0 == n) return 0;
	  if (1 == n) return 1;
	  if ((n *= 2) < 1) return .5 * Math.pow(1024, n - 1);
	  return .5 * (-Math.pow(2, -10 * (n - 1)) + 2);
	};
	
	exports.inCirc = function(n){
	  return 1 - Math.sqrt(1 - n * n);
	};
	
	exports.outCirc = function(n){
	  return Math.sqrt(1 - (--n * n));
	};
	
	exports.inOutCirc = function(n){
	  n *= 2
	  if (n < 1) return -0.5 * (Math.sqrt(1 - n * n) - 1);
	  return 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1);
	};
	
	exports.inBack = function(n){
	  var s = 1.70158;
	  return n * n * (( s + 1 ) * n - s);
	};
	
	exports.outBack = function(n){
	  var s = 1.70158;
	  return --n * n * ((s + 1) * n + s) + 1;
	};
	
	exports.inOutBack = function(n){
	  var s = 1.70158 * 1.525;
	  if ( ( n *= 2 ) < 1 ) return 0.5 * ( n * n * ( ( s + 1 ) * n - s ) );
	  return 0.5 * ( ( n -= 2 ) * n * ( ( s + 1 ) * n + s ) + 2 );
	};
	
	exports.inBounce = function(n){
	  return 1 - exports.outBounce(1 - n);
	};
	
	exports.outBounce = function(n){
	  if ( n < ( 1 / 2.75 ) ) {
	    return 7.5625 * n * n;
	  } else if ( n < ( 2 / 2.75 ) ) {
	    return 7.5625 * ( n -= ( 1.5 / 2.75 ) ) * n + 0.75;
	  } else if ( n < ( 2.5 / 2.75 ) ) {
	    return 7.5625 * ( n -= ( 2.25 / 2.75 ) ) * n + 0.9375;
	  } else {
	    return 7.5625 * ( n -= ( 2.625 / 2.75 ) ) * n + 0.984375;
	  }
	};
	
	exports.inOutBounce = function(n){
	  if (n < .5) return exports.inBounce(n * 2) * .5;
	  return exports.outBounce(n * 2 - 1) * .5 + .5;
	};
	
	// aliases
	
	exports['in-quad'] = exports.inQuad;
	exports['out-quad'] = exports.outQuad;
	exports['in-out-quad'] = exports.inOutQuad;
	exports['in-cube'] = exports.inCube;
	exports['out-cube'] = exports.outCube;
	exports['in-out-cube'] = exports.inOutCube;
	exports['in-quart'] = exports.inQuart;
	exports['out-quart'] = exports.outQuart;
	exports['in-out-quart'] = exports.inOutQuart;
	exports['in-quint'] = exports.inQuint;
	exports['out-quint'] = exports.outQuint;
	exports['in-out-quint'] = exports.inOutQuint;
	exports['in-sine'] = exports.inSine;
	exports['out-sine'] = exports.outSine;
	exports['in-out-sine'] = exports.inOutSine;
	exports['in-expo'] = exports.inExpo;
	exports['out-expo'] = exports.outExpo;
	exports['in-out-expo'] = exports.inOutExpo;
	exports['in-circ'] = exports.inCirc;
	exports['out-circ'] = exports.outCirc;
	exports['in-out-circ'] = exports.inOutCirc;
	exports['in-back'] = exports.inBack;
	exports['out-back'] = exports.outBack;
	exports['in-out-back'] = exports.inOutBack;
	exports['in-bounce'] = exports.inBounce;
	exports['out-bounce'] = exports.outBounce;
	exports['in-out-bounce'] = exports.inOutBounce;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(889);
	var each = __webpack_require__(377).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(887);
	var Util = __webpack_require__(377);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),
/* 889 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(888);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 891 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(891);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(901);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var createArrayFromMixed = __webpack_require__(894);
	var getMarkupWrap = __webpack_require__(896);
	var invariant = __webpack_require__(15);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(898);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(900);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ }),
/* 903 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var performance;
	
	if (ExecutionEnvironment.canUseDOM) {
	  performance = window.performance || window.msPerformance || window.webkitPerformance;
	}
	
	module.exports = performance || {};

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var performance = __webpack_require__(904);
	
	var performanceNow;
	
	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (performance.now) {
	  performanceNow = function performanceNow() {
	    return performance.now();
	  };
	} else {
	  performanceNow = function performanceNow() {
	    return Date.now();
	  };
	}
	
	module.exports = performanceNow;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// special flexbox specifications
	
	
	var _prefixAll2 = __webpack_require__(927);
	
	var _prefixAll3 = _interopRequireDefault(_prefixAll2);
	
	var _getBrowserInformation = __webpack_require__(928);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(929);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(266);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(383);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _prefixProps = __webpack_require__(917);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _position = __webpack_require__(913);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(907);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _zoomCursor = __webpack_require__(916);
	
	var _zoomCursor2 = _interopRequireDefault(_zoomCursor);
	
	var _grabCursor = __webpack_require__(911);
	
	var _grabCursor2 = _interopRequireDefault(_grabCursor);
	
	var _flex = __webpack_require__(908);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(914);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(912);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(915);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(909);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(910);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var plugins = [_position2.default, _calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
	// this must be run AFTER the flexbox specs
	_flex2.default];
	
	var Prefixer = function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
	    } else {
	      this._usePrefixAllFallback = true;
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        result[name] = true;
	        return result;
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      this._usePrefixAllFallback = true;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // use prefixAll as fallback if userAgent can not be resolved
	      if (this._usePrefixAllFallback) {
	        return (0, _prefixAll3.default)(styles);
	      }
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object && !Array.isArray(value)) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	        }
	      });
	
	      Object.keys(styles).forEach(function (property) {
	        [].concat(styles[property]).forEach(function (value) {
	          // resolve plugins
	          plugins.forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            assignStyles(styles, plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix
	            }), value, _this2._keepUnprefixed);
	          });
	        });
	      });
	
	      return (0, _sortPrefixedStyle2.default)(styles);
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      return (0, _prefixAll3.default)(styles);
	    }
	  }]);
	
	  return Prefixer;
	}();
	
	exports.default = Prefixer;
	
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var value = arguments[2];
	  var keepUnprefixed = arguments[3];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (val) {
	        if (base[property].indexOf(val) === -1) {
	          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
	        }
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(84);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(84);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { flex: true, 'inline-flex': true };
	
	function flex(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    return {
	      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(84);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(84);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = grabCursor;
	
	var _getPrefixedValue = __webpack_require__(84);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { grab: true, grabbing: true };
	
	function grabCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
	  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(84);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	
	var _getPrefixedValue = __webpack_require__(84);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function position(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'position' && value === 'sticky' && (browser === 'safari' || browser === 'ios_saf')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(84);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(381);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _unprefixProperty = __webpack_require__(931);
	
	var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = { transition: true, transitionProperty: true };
	
	function transition(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var requiresPrefix = _ref.requiresPrefix;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // also check for already prefixed transitions
	  var unprefixedProperty = (0, _unprefixProperty2.default)(property);
	
	  if (typeof value === 'string' && properties[unprefixedProperty]) {
	    var _ret = function () {
	      // TODO: memoize this array
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateStyleName2.default)(prop);
	      });
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: _defineProperty({}, property, multipleValues.join(','))
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = zoomCursor;
	
	var _getPrefixedValue = __webpack_require__(84);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { 'zoom-in': true, 'zoom-out': true };
	
	function zoomCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 917 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
	module.exports = exports["default"];

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(192);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(267);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(192);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 920 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 921 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(192);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(267);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 924 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return { position: ['-webkit-sticky', 'sticky'] };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(192);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(381);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(266);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(267);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(382);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(382);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(266);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(383);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _position = __webpack_require__(924);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(918);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(919);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(920);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(925);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(923);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(926);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(921);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(922);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return (0, _sortPrefixedStyle2.default)(styles);
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bowser = __webpack_require__(634);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	var browsers = {
	  chrome: [['chrome'], ['chromium']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  edge: [['msedge']],
	  opera: [['opera'], ['vivaldi']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie: [['msie']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	var browserByInfo = function browserByInfo(info) {
	  if (info.firefox) {
	    return 'firefox';
	  }
	  var name = '';
	
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  return name;
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports.default = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	  var info = _bowser2.default._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  info.browser = browserByInfo(info);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	  info.osversion = parseFloat(info.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (info.browser === 'ios_saf' && info.version > info.osversion) {
	    info.version = info.osversion;
	    info.safari = true;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 929 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 930 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 931 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
	  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
	};
	
	module.exports = exports['default'];

/***/ }),
/* 932 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(1224);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),
/* 934 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(465)(module)))

/***/ }),
/* 936 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(384),
	    getRawTag = __webpack_require__(940),
	    objectToString = __webpack_require__(941);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(942);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(384);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 941 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 942 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(938);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 944 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(222);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getStyles = getStyles;
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconButton = __webpack_require__(135);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _menu = __webpack_require__(1059);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      appBar = _context$muiTheme.appBar,
	      iconButtonSize = _context$muiTheme.button.iconButtonSize,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var flatButtonSize = 36;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      zIndex: zIndex.appBar,
	      width: '100%',
	      display: 'flex',
	      backgroundColor: appBar.color,
	      paddingLeft: appBar.padding,
	      paddingRight: appBar.padding
	    },
	    title: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      margin: 0,
	      paddingTop: 0,
	      letterSpacing: 0,
	      fontSize: 24,
	      fontWeight: appBar.titleFontWeight,
	      color: appBar.textColor,
	      height: appBar.height,
	      lineHeight: appBar.height + 'px'
	    },
	    mainElement: {
	      boxFlex: 1,
	      flex: '1'
	    },
	    iconButtonStyle: {
	      marginTop: (appBar.height - iconButtonSize) / 2,
	      marginRight: 8,
	      marginLeft: -16
	    },
	    iconButtonIconStyle: {
	      fill: appBar.textColor,
	      color: appBar.textColor
	    },
	    flatButton: {
	      color: appBar.textColor,
	      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
	    }
	  };
	
	  return styles;
	}
	
	var AppBar = function (_Component) {
	  (0, _inherits3.default)(AppBar, _Component);
	
	  function AppBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AppBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppBar.__proto__ || (0, _getPrototypeOf2.default)(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapLeftIconButton = function (event) {
	      if (_this.props.onLeftIconButtonTouchTap) {
	        _this.props.onLeftIconButtonTouchTap(event);
	      }
	    }, _this.handleTouchTapRightIconButton = function (event) {
	      if (_this.props.onRightIconButtonTouchTap) {
	        _this.props.onRightIconButtonTouchTap(event);
	      }
	    }, _this.handleTitleTouchTap = function (event) {
	      if (_this.props.onTitleTouchTap) {
	        _this.props.onTitleTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AppBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Material-UI: Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;
	
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Material-UI: Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          titleStyle = _props.titleStyle,
	          iconStyleLeft = _props.iconStyleLeft,
	          iconStyleRight = _props.iconStyleRight,
	          onTitleTouchTap = _props.onTitleTouchTap,
	          showMenuIconButton = _props.showMenuIconButton,
	          iconElementLeft = _props.iconElementLeft,
	          iconElementRight = _props.iconElementRight,
	          iconClassNameLeft = _props.iconClassNameLeft,
	          iconClassNameRight = _props.iconClassNameRight,
	          onLeftIconButtonTouchTap = _props.onLeftIconButtonTouchTap,
	          onRightIconButtonTouchTap = _props.onRightIconButtonTouchTap,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleTouchTap', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonTouchTap', 'onRightIconButtonTouchTap', 'className', 'style', 'zDepth', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var menuElementLeft = void 0;
	      var menuElementRight = void 0;
	
	      // If the title is a string, wrap in an h1 tag.
	      // If not, wrap in a div tag.
	      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';
	
	      var titleElement = _react2.default.createElement(titleComponent, {
	        onTouchTap: this.handleTitleTouchTap,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
	      }, title);
	
	      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);
	
	      if (showMenuIconButton) {
	        if (iconElementLeft) {
	          var iconElementLeftProps = {};
	
	          if (iconElementLeft.type.muiName === 'IconButton') {
	            var iconElemLeftChildren = iconElementLeft.props.children;
	            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementLeftProps.iconStyle = (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle);
	          }
	
	          if (!iconElementLeft.props.onTouchTap && this.props.onLeftIconButtonTouchTap) {
	            iconElementLeftProps.onTouchTap = this.handleTouchTapLeftIconButton;
	          }
	
	          menuElementLeft = _react2.default.createElement(
	            'div',
	            { style: prepareStyles(iconLeftStyle) },
	            (0, _keys2.default)(iconElementLeftProps).length > 0 ? (0, _react.cloneElement)(iconElementLeft, iconElementLeftProps) : iconElementLeft
	          );
	        } else {
	          menuElementLeft = _react2.default.createElement(
	            _IconButton2.default,
	            {
	              style: iconLeftStyle,
	              iconStyle: styles.iconButtonIconStyle,
	              iconClassName: iconClassNameLeft,
	              onTouchTap: this.handleTouchTapLeftIconButton
	            },
	            iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) })
	          );
	        }
	      }
	
	      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
	        marginRight: -16,
	        marginLeft: 'auto'
	      }, iconStyleRight);
	
	      if (iconElementRight) {
	        var iconElementRightProps = {};
	
	        switch (iconElementRight.type.muiName) {
	          case 'IconMenu':
	          case 'IconButton':
	            var iconElemRightChildren = iconElementRight.props.children;
	            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementRightProps.iconStyle = (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle);
	            break;
	
	          case 'FlatButton':
	            iconElementRightProps.style = (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style);
	            break;
	
	          default:
	        }
	
	        if (!iconElementRight.props.onTouchTap && this.props.onRightIconButtonTouchTap) {
	          iconElementRightProps.onTouchTap = this.handleTouchTapRightIconButton;
	        }
	
	        menuElementRight = _react2.default.createElement(
	          'div',
	          { style: prepareStyles(iconRightStyle) },
	          (0, _keys2.default)(iconElementRightProps).length > 0 ? (0, _react.cloneElement)(iconElementRight, iconElementRightProps) : iconElementRight
	        );
	      } else if (iconClassNameRight) {
	        menuElementRight = _react2.default.createElement(_IconButton2.default, {
	          style: iconRightStyle,
	          iconStyle: styles.iconButtonIconStyle,
	          iconClassName: iconClassNameRight,
	          onTouchTap: this.handleTouchTapRightIconButton
	        });
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, {
	          rounded: false,
	          className: className,
	          style: (0, _simpleAssign2.default)({}, styles.root, style),
	          zDepth: zDepth
	        }),
	        menuElementLeft,
	        titleElement,
	        menuElementRight,
	        children
	      );
	    }
	  }]);
	  return AppBar;
	}(_react.Component);
	
	AppBar.muiName = 'AppBar';
	AppBar.defaultProps = {
	  showMenuIconButton: true,
	  title: '',
	  zDepth: 1
	};
	AppBar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? AppBar.propTypes = {
	  /**
	   * Can be used to render a tab inside an app bar for instance.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Applied to the app bar's root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The classname of the icon on the left of the app bar.
	   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
	   */
	  iconClassNameLeft: _react.PropTypes.string,
	  /**
	   * Similiar to the iconClassNameLeft prop except that
	   * it applies to the icon displayed on the right of the app bar.
	   */
	  iconClassNameRight: _react.PropTypes.string,
	  /**
	   * The custom element to be displayed on the left side of the
	   * app bar such as an SvgIcon.
	   */
	  iconElementLeft: _react.PropTypes.element,
	  /**
	   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
	   */
	  iconElementRight: _react.PropTypes.element,
	  /**
	   * Override the inline-styles of the element displayed on the left side of the app bar.
	   */
	  iconStyleLeft: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the element displayed on the right side of the app bar.
	   */
	  iconStyleRight: _react.PropTypes.object,
	  /**
	   * Callback function for when the left icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the left `IconButton`.
	   */
	  onLeftIconButtonTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function for when the right icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the right `IconButton`.
	   */
	  onRightIconButtonTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function for when the title text is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the `title` node.
	   */
	  onTitleTouchTap: _react.PropTypes.func,
	  /**
	   * Determines whether or not to display the Menu icon next to the title.
	   * Setting this prop to false will hide the icon.
	   */
	  showMenuIconButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the app bar.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the app bar's title element.
	   */
	  titleStyle: _react.PropTypes.object,
	  /**
	   * The zDepth of the component.
	   * The shadow of the app bar is also dependent on this property.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = AppBar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AppBar = __webpack_require__(945);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AppBar2.default;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(100);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _TextField = __webpack_require__(163);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Menu = __webpack_require__(397);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(275);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Divider = __webpack_require__(393);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Popover = __webpack_require__(136);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var anchorEl = state.anchorEl;
	  var fullWidth = props.fullWidth;
	
	
	  var styles = {
	    root: {
	      display: 'inline-block',
	      position: 'relative',
	      width: fullWidth ? '100%' : 256
	    },
	    menu: {
	      width: '100%'
	    },
	    list: {
	      display: 'block',
	      width: fullWidth ? '100%' : 256
	    },
	    innerDiv: {
	      overflow: 'hidden'
	    }
	  };
	
	  if (anchorEl && fullWidth) {
	    styles.popover = {
	      width: anchorEl.clientWidth
	    };
	  }
	
	  return styles;
	}
	
	var AutoComplete = function (_Component) {
	  (0, _inherits3.default)(AutoComplete, _Component);
	
	  function AutoComplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoComplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoComplete.__proto__ || (0, _getPrototypeOf2.default)(AutoComplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      focusTextField: true,
	      open: false,
	      searchText: undefined
	    }, _this.handleRequestClose = function () {
	      // Only take into account the Popover clickAway when we are
	      // not focusing the TextField.
	      if (!_this.state.focusTextField) {
	        _this.close();
	      }
	    }, _this.handleMouseDown = function (event) {
	      // Keep the TextField focused
	      event.preventDefault();
	    }, _this.handleItemTouchTap = function (event, child) {
	      var dataSource = _this.props.dataSource;
	
	      var index = parseInt(child.key, 10);
	      var chosenRequest = dataSource[index];
	      var searchText = _this.chosenRequestText(chosenRequest);
	
	      _this.setState({
	        searchText: searchText
	      }, function () {
	        _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'touchTap'
	        });
	
	        _this.timerTouchTapCloseId = setTimeout(function () {
	          _this.timerTouchTapCloseId = null;
	          _this.close();
	          _this.props.onNewRequest(chosenRequest, index);
	        }, _this.props.menuCloseDelay);
	      });
	    }, _this.chosenRequestText = function (chosenRequest) {
	      if (typeof chosenRequest === 'string') {
	        return chosenRequest;
	      } else {
	        return chosenRequest[_this.props.dataSourceConfig.text];
	      }
	    }, _this.handleEscKeyDown = function () {
	      _this.close();
	    }, _this.handleKeyDown = function (event) {
	      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.close();
	          var searchText = _this.state.searchText;
	          if (searchText !== '') {
	            _this.props.onNewRequest(searchText, -1);
	          }
	          break;
	
	        case 'esc':
	          _this.close();
	          break;
	
	        case 'down':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            focusTextField: false,
	            anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	          });
	          break;
	
	        default:
	          break;
	      }
	    }, _this.handleChange = function (event) {
	      var searchText = event.target.value;
	
	      // Make sure that we have a new searchText.
	      // Fix an issue with a Cordova Webview
	      if (searchText === _this.state.searchText) {
	        return;
	      }
	
	      _this.setState({
	        searchText: searchText,
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	      }, function () {
	        _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'change'
	        });
	      });
	    }, _this.handleBlur = function (event) {
	      if (_this.state.focusTextField && _this.timerTouchTapCloseId === null) {
	        _this.timerBlurClose = setTimeout(function () {
	          _this.close();
	        }, 0);
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      if (!_this.state.open && _this.props.openOnFocus) {
	        _this.setState({
	          open: true,
	          anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	        });
	      }
	
	      _this.setState({
	        focusTextField: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoComplete, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.requestsList = [];
	      this.setState({
	        open: this.props.open,
	        searchText: this.props.searchText
	      });
	      this.timerTouchTapCloseId = null;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.searchText !== nextProps.searchText) {
	        this.setState({
	          searchText: nextProps.searchText
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerTouchTapCloseId);
	      clearTimeout(this.timerBlurClose);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        open: false,
	        anchorEl: null
	      });
	
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.refs.searchTextField.blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.refs.searchTextField.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          animated = _props.animated,
	          animation = _props.animation,
	          dataSource = _props.dataSource,
	          dataSourceConfig = _props.dataSourceConfig,
	          disableFocusRipple = _props.disableFocusRipple,
	          errorStyle = _props.errorStyle,
	          floatingLabelText = _props.floatingLabelText,
	          filter = _props.filter,
	          fullWidth = _props.fullWidth,
	          style = _props.style,
	          hintText = _props.hintText,
	          maxSearchResults = _props.maxSearchResults,
	          menuCloseDelay = _props.menuCloseDelay,
	          textFieldStyle = _props.textFieldStyle,
	          menuStyle = _props.menuStyle,
	          menuProps = _props.menuProps,
	          listStyle = _props.listStyle,
	          targetOrigin = _props.targetOrigin,
	          onClose = _props.onClose,
	          onNewRequest = _props.onNewRequest,
	          onUpdateInput = _props.onUpdateInput,
	          openOnFocus = _props.openOnFocus,
	          popoverProps = _props.popoverProps,
	          searchTextProp = _props.searchText,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'animated', 'animation', 'dataSource', 'dataSourceConfig', 'disableFocusRipple', 'errorStyle', 'floatingLabelText', 'filter', 'fullWidth', 'style', 'hintText', 'maxSearchResults', 'menuCloseDelay', 'textFieldStyle', 'menuStyle', 'menuProps', 'listStyle', 'targetOrigin', 'onClose', 'onNewRequest', 'onUpdateInput', 'openOnFocus', 'popoverProps', 'searchText']);
	
	      var _ref2 = popoverProps || {},
	          popoverStyle = _ref2.style,
	          popoverOther = (0, _objectWithoutProperties3.default)(_ref2, ['style']);
	
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl,
	          searchText = _state.searchText,
	          focusTextField = _state.focusTextField;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var requestsList = [];
	
	      dataSource.every(function (item, index) {
	        switch (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) {
	          case 'string':
	            if (filter(searchText, item, item)) {
	              requestsList.push({
	                text: item,
	                value: _react2.default.createElement(_MenuItem2.default, {
	                  innerDivStyle: styles.innerDiv,
	                  value: item,
	                  primaryText: item,
	                  disableFocusRipple: disableFocusRipple,
	                  key: index
	                })
	              });
	            }
	            break;
	
	          case 'object':
	            if (item && typeof item[_this2.props.dataSourceConfig.text] === 'string') {
	              var itemText = item[_this2.props.dataSourceConfig.text];
	              if (!_this2.props.filter(searchText, itemText, item)) break;
	
	              var itemValue = item[_this2.props.dataSourceConfig.value];
	              if (itemValue.type && (itemValue.type.muiName === _MenuItem2.default.muiName || itemValue.type.muiName === _Divider2.default.muiName)) {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.cloneElement(itemValue, {
	                    key: index,
	                    disableFocusRipple: disableFocusRipple
	                  })
	                });
	              } else {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.createElement(_MenuItem2.default, {
	                    innerDivStyle: styles.innerDiv,
	                    primaryText: itemText,
	                    disableFocusRipple: disableFocusRipple,
	                    key: index
	                  })
	                });
	              }
	            }
	            break;
	
	          default:
	          // Do nothing
	        }
	
	        return !(maxSearchResults && maxSearchResults > 0 && requestsList.length === maxSearchResults);
	      });
	
	      this.requestsList = requestsList;
	
	      var menu = open && requestsList.length > 0 && _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, menuProps, {
	          ref: 'menu',
	          autoWidth: false,
	          disableAutoFocus: focusTextField,
	          onEscKeyDown: this.handleEscKeyDown,
	          initiallyKeyboardFocused: true,
	          onItemTouchTap: this.handleItemTouchTap,
	          onMouseDown: this.handleMouseDown,
	          style: (0, _simpleAssign2.default)(styles.menu, menuStyle),
	          listStyle: (0, _simpleAssign2.default)(styles.list, listStyle)
	        }),
	        requestsList.map(function (i) {
	          return i.value;
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          ref: 'searchTextField',
	          autoComplete: 'off',
	          value: searchText,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          floatingLabelText: floatingLabelText,
	          hintText: hintText,
	          fullWidth: fullWidth,
	          multiLine: false,
	          errorStyle: errorStyle,
	          style: textFieldStyle
	        })),
	        _react2.default.createElement(
	          _Popover2.default,
	          (0, _extends3.default)({
	            style: (0, _simpleAssign2.default)({}, styles.popover, popoverStyle),
	            canAutoPosition: false,
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation
	          }, popoverOther),
	          menu
	        )
	      );
	    }
	  }]);
	  return AutoComplete;
	}(_react.Component);
	
	AutoComplete.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  dataSourceConfig: {
	    text: 'text',
	    value: 'value'
	  },
	  disableFocusRipple: true,
	  filter: function filter(searchText, key) {
	    return searchText !== '' && key.indexOf(searchText) !== -1;
	  },
	  fullWidth: false,
	  open: false,
	  openOnFocus: false,
	  onUpdateInput: function onUpdateInput() {},
	  onNewRequest: function onNewRequest() {},
	  searchText: '',
	  menuCloseDelay: 300,
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	AutoComplete.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? AutoComplete.propTypes = {
	  /**
	   * Location of the anchor for the auto complete.
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the auto complete is animated as it is toggled.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * Array of strings or nodes used to populate the list.
	   */
	  dataSource: _react.PropTypes.array.isRequired,
	  /**
	   * Config for objects list dataSource.
	   *
	   * @typedef {Object} dataSourceConfig
	   *
	   * @property {string} text `dataSource` element key used to find a string to be matched for search
	   * and shown as a `TextField` input value after choosing the result.
	   * @property {string} value `dataSource` element key used to find a string to be shown in search results.
	   */
	  dataSourceConfig: _react.PropTypes.object,
	  /**
	   * Disables focus ripple when true.
	   */
	  disableFocusRipple: _react.PropTypes.bool,
	  /**
	   * Override style prop for error.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * Callback function used to filter the auto complete.
	   *
	   * @param {string} searchText The text to search for within `dataSource`.
	   * @param {string} key `dataSource` element, or `text` property on that element if it's not a string.
	   * @returns {boolean} `true` indicates the auto complete list will include `key` when the input is `searchText`.
	   */
	  filter: _react.PropTypes.func,
	  /**
	   * The content to use for adding floating label element.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the field receives the property `width: 100%`.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * Override style for list.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The max number of search results to be shown.
	   * By default it shows all the items which matches filter.
	   */
	  maxSearchResults: _react.PropTypes.number,
	  /**
	   * Delay for closing time of the menu.
	   */
	  menuCloseDelay: _react.PropTypes.number,
	  /**
	   * Props to be passed to menu.
	   */
	  menuProps: _react.PropTypes.object,
	  /**
	   * Override style for menu.
	   */
	  menuStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when a list item is selected, or enter is pressed in the `TextField`.
	   *
	   * @param {string} chosenRequest Either the `TextField` input value, if enter is pressed in the `TextField`,
	   * or the text value of the corresponding list item that was selected.
	   * @param {number} index The index in `dataSource` of the list item selected, or `-1` if enter is pressed in the
	   * `TextField`.
	   */
	  onNewRequest: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the user updates the `TextField`.
	   *
	   * @param {string} searchText The auto-complete's `searchText` value.
	   * @param {array} dataSource The auto-complete's `dataSource` array.
	   * @param {object} params Additional information linked the update.
	   */
	  onUpdateInput: _react.PropTypes.func,
	  /**
	   * Auto complete menu is open if true.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * If true, the list item is showed when a focus event triggers.
	   */
	  openOnFocus: _react.PropTypes.bool,
	  /**
	   * Props to be passed to popover.
	   */
	  popoverProps: _react.PropTypes.object,
	  /**
	   * Text being input to auto complete.
	   */
	  searchText: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Origin for location of target.
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * Override the inline-styles of AutoComplete's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object
	} : void 0;
	
	
	AutoComplete.levenshteinDistance = function (searchText, key) {
	  var current = [];
	  var prev = void 0;
	  var value = void 0;
	
	  for (var i = 0; i <= key.length; i++) {
	    for (var j = 0; j <= searchText.length; j++) {
	      if (i && j) {
	        if (searchText.charAt(j - 1) === key.charAt(i - 1)) value = prev;else value = Math.min(current[j], current[j - 1], prev) + 1;
	      } else {
	        value = i + j;
	      }
	      prev = current[j];
	      current[j] = value;
	    }
	  }
	  return current.pop();
	};
	
	AutoComplete.noFilter = function () {
	  return true;
	};
	
	AutoComplete.defaultFilter = AutoComplete.caseSensitiveFilter = function (searchText, key) {
	  return searchText !== '' && key.indexOf(searchText) !== -1;
	};
	
	AutoComplete.caseInsensitiveFilter = function (searchText, key) {
	  return key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	};
	
	AutoComplete.levenshteinDistanceFilter = function (distanceLessThan) {
	  if (distanceLessThan === undefined) {
	    return AutoComplete.levenshteinDistance;
	  } else if (typeof distanceLessThan !== 'number') {
	    throw 'Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!';
	  }
	
	  return function (s, k) {
	    return AutoComplete.levenshteinDistance(s, k) < distanceLessThan;
	  };
	};
	
	AutoComplete.fuzzyFilter = function (searchText, key) {
	  var compareString = key.toLowerCase();
	  searchText = searchText.toLowerCase();
	
	  var searchTextIndex = 0;
	  for (var index = 0; index < key.length; index++) {
	    if (compareString[index] === searchText[searchTextIndex]) {
	      searchTextIndex += 1;
	    }
	  }
	
	  return searchTextIndex === searchText.length;
	};
	
	AutoComplete.Item = _MenuItem2.default;
	AutoComplete.Divider = _Divider2.default;
	
	exports.default = AutoComplete;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AutoComplete = __webpack_require__(947);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoComplete2.default;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var backgroundColor = props.backgroundColor,
	      color = props.color,
	      size = props.size;
	  var avatar = context.muiTheme.avatar;
	
	
	  var styles = {
	    root: {
	      color: color || avatar.color,
	      backgroundColor: backgroundColor || avatar.backgroundColor,
	      userSelect: 'none',
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      fontSize: size / 2,
	      borderRadius: '50%',
	      height: size,
	      width: size
	    },
	    icon: {
	      color: color || avatar.color,
	      width: size * 0.6,
	      height: size * 0.6,
	      fontSize: size * 0.6,
	      margin: size * 0.2
	    }
	  };
	
	  return styles;
	}
	
	var Avatar = function (_Component) {
	  (0, _inherits3.default)(Avatar, _Component);
	
	  function Avatar() {
	    (0, _classCallCheck3.default)(this, Avatar);
	    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Avatar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          src = _props.src,
	          style = _props.style,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      if (src) {
	        return _react2.default.createElement('img', (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other, {
	          src: src,
	          className: className
	        }));
	      } else {
	        return _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
	            className: className
	          }),
	          icon && _react2.default.cloneElement(icon, {
	            color: styles.icon.color,
	            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	          }),
	          this.props.children
	        );
	      }
	    }
	  }]);
	  return Avatar;
	}(_react.Component);
	
	Avatar.muiName = 'Avatar';
	Avatar.defaultProps = {
	  size: 40
	};
	Avatar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Avatar.propTypes = {
	  /**
	   * The backgroundColor of the avatar. Does not apply to image avatars.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Can be used, for instance, to render a letter inside the avatar.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root `div` or `img` element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The icon or letter's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the SvgIcon or FontIcon to be used inside the avatar.
	   */
	  icon: _react.PropTypes.element,
	  /**
	   * This is the size of the avatar in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
	   */
	  src: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Avatar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var primary = props.primary,
	      secondary = props.secondary;
	  var badge = context.muiTheme.badge;
	
	
	  var badgeBackgroundColor = void 0;
	  var badgeTextColor = void 0;
	
	  if (primary) {
	    badgeBackgroundColor = badge.primaryColor;
	    badgeTextColor = badge.primaryTextColor;
	  } else if (secondary) {
	    badgeBackgroundColor = badge.secondaryColor;
	    badgeTextColor = badge.secondaryTextColor;
	  } else {
	    badgeBackgroundColor = badge.color;
	    badgeTextColor = badge.textColor;
	  }
	
	  var radius = 12;
	  var radius2x = Math.floor(2 * radius);
	
	  return {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      padding: radius2x + 'px ' + radius2x + 'px ' + radius + 'px ' + radius + 'px'
	    },
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      fontWeight: badge.fontWeight,
	      fontSize: radius,
	      width: radius2x,
	      height: radius2x,
	      borderRadius: '50%',
	      backgroundColor: badgeBackgroundColor,
	      color: badgeTextColor
	    }
	  };
	}
	
	var Badge = function (_Component) {
	  (0, _inherits3.default)(Badge, _Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, (Badge.__proto__ || (0, _getPrototypeOf2.default)(Badge)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Badge, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          badgeContent = _props.badgeContent,
	          badgeStyle = _props.badgeStyle,
	          children = _props.children,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['badgeContent', 'badgeStyle', 'children', 'primary', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, styles.badge, badgeStyle)) },
	          badgeContent
	        )
	      );
	    }
	  }]);
	  return Badge;
	}(_react.Component);
	
	Badge.defaultProps = {
	  primary: false,
	  secondary: false
	};
	Badge.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Badge.propTypes = {
	  /**
	   * This is the content rendered within the badge.
	   */
	  badgeContent: _react.PropTypes.node.isRequired,
	  /**
	   * Override the inline-styles of the badge element.
	   */
	  badgeStyle: _react.PropTypes.object,
	  /**
	   * The badge will be added relativelty to this node.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the badge will use the primary badge colors.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * If true, the badge will use the secondary badge colors.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Badge;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Badge = __webpack_require__(950);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge2.default;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      width: '100%',
	      display: 'flex',
	      justifyContent: 'center',
	      backgroundColor: bottomNavigation.backgroundColor,
	      height: bottomNavigation.height
	    },
	    item: {
	      flex: '1'
	    }
	  };
	
	  return styles;
	}
	
	var BottomNavigation = function BottomNavigation(props, context) {
	  var children = props.children,
	      style = props.style,
	      selectedIndex = props.selectedIndex,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'style', 'selectedIndex']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var preparedChildren = _react.Children.map(children, function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      style: (0, _simpleAssign2.default)({}, styles.item, child.props.style),
	      selected: index === selectedIndex
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	    preparedChildren
	  );
	};
	
	process.env.NODE_ENV !== "production" ? BottomNavigation.propTypes = {
	  /**
	   * The `BottomNavigationItem`s to populate the element with.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The index of the currently selected navigation item.
	   */
	  selectedIndex: _react.PropTypes.number,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	BottomNavigation.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = BottomNavigation;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BottomNavigationItem = exports.BottomNavigation = undefined;
	
	var _BottomNavigation2 = __webpack_require__(952);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(386);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.default = _BottomNavigation3.default;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _CardExpandable = __webpack_require__(388);
	
	var _CardExpandable2 = _interopRequireDefault(_CardExpandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: null
	    }, _this.handleExpanding = function (event) {
	      event.preventDefault();
	      var newExpandedState = !_this.state.expanded;
	      // no automatic state update when the component is controlled
	      if (_this.props.expanded === null) {
	        _this.setState({ expanded: newExpandedState });
	      }
	      if (_this.props.onExpandChange) {
	        _this.props.onExpandChange(newExpandedState);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          containerStyle = _props.containerStyle,
	          children = _props.children,
	          expandable = _props.expandable,
	          expandedProp = _props.expanded,
	          initiallyExpanded = _props.initiallyExpanded,
	          onExpandChange = _props.onExpandChange,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);
	
	
	      var lastElement = void 0;
	      var expanded = this.state.expanded;
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        var doClone = false;
	        var newChild = undefined;
	        var newProps = {};
	        var element = currentChild;
	        if (!currentChild || !currentChild.props) {
	          return null;
	        }
	        if (expanded === false && currentChild.props.expandable === true) return;
	        if (currentChild.props.actAsExpander === true) {
	          doClone = true;
	          newProps.onTouchTap = _this2.handleExpanding;
	          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
	        }
	        if (currentChild.props.showExpandableButton === true) {
	          doClone = true;
	          newChild = _react2.default.createElement(_CardExpandable2.default, {
	            closeIcon: currentChild.props.closeIcon,
	            expanded: expanded,
	            onExpanding: _this2.handleExpanding,
	            openIcon: currentChild.props.openIcon
	          });
	        }
	        if (doClone) {
	          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
	        }
	        lastElement = element;
	        return element;
	      }, this);
	
	      // If the last element is text or a title we should add
	      // 8px padding to the bottom of the card
	      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        zIndex: 1
	      }, style);
	      var containerMergedStyles = (0, _simpleAssign2.default)({
	        paddingBottom: addBottomPadding ? 8 : 0
	      }, containerStyle);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, { style: mergedStyles }),
	        _react2.default.createElement(
	          'div',
	          { style: containerMergedStyles },
	          newChildren
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card.defaultProps = {
	  expandable: false,
	  expanded: null,
	  initiallyExpanded: false
	};
	process.env.NODE_ENV !== "production" ? Card.propTypes = {
	  /**
	   * Can be used to render elements inside the Card.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _react.PropTypes.object,
	  /**
	   * If true, this card component is expandable. Can be set on any child of the `Card` component.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Whether this card is expanded.
	   * If `true` or `false` the component is controlled.
	   * if `null` the component is uncontrolled.
	   */
	  expanded: _react.PropTypes.bool,
	  /**
	   * Whether this card is initially expanded.
	   */
	  initiallyExpanded: _react.PropTypes.bool,
	  /**
	   * Callback function fired when the `expandable` state of the card has changed.
	   *
	   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
	   */
	  onExpandChange: _react.PropTypes.func,
	  /**
	   * If true, this card component will include a button to expand the card. `CardTitle`,
	   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
	   * of `Card` can implements `showExpandableButton` or forwards the property to a child
	   * component supporting it.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Card;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(954);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardHeader2 = __webpack_require__(389);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardTitle2 = __webpack_require__(392);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(390);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardText2 = __webpack_require__(391);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActions2 = __webpack_require__(387);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardExpandable2 = __webpack_require__(388);
	
	var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardText = _CardText3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardExpandable = _CardExpandable3.default;
	exports.default = _Card3.default;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedSwitch = __webpack_require__(279);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(1060);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(1061);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var checkbox = context.muiTheme.checkbox;
	
	  var checkboxSize = 24;
	
	  return {
	    icon: {
	      height: checkboxSize,
	      width: checkboxSize
	    },
	    check: {
	      position: 'absolute',
	      opacity: 0,
	      transform: 'scale(0)',
	      transitionOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	      fill: checkbox.checkedColor
	    },
	    checkWhenSwitched: {
	      opacity: 1,
	      transform: 'scale(1)',
	      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	    },
	    checkWhenDisabled: {
	      fill: checkbox.disabledColor
	    },
	    box: {
	      position: 'absolute',
	      opacity: 1,
	      fill: checkbox.boxColor,
	      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
	    },
	    boxWhenSwitched: {
	      opacity: 0,
	      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
	      fill: checkbox.checkedColor
	    },
	    boxWhenDisabled: {
	      fill: props.checked ? 'transparent' : checkbox.disabledColor
	    },
	    label: {
	      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
	    }
	  };
	}
	
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleCheck = function (event, isInputChecked) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          checked = _props.checked,
	          defaultChecked = _props.defaultChecked,
	          valueLink = _props.valueLink;
	
	
	      if (checked || defaultChecked || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({
	          switched: nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          iconStyle = _props2.iconStyle,
	          onCheck = _props2.onCheck,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);
	
	      var styles = getStyles(this.props, this.context);
	      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_checkBox2.default, {
	        style: checkStyles
	      });
	
	      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	        style: boxStyles
	      });
	
	      var checkboxElement = _react2.default.createElement(
	        'div',
	        null,
	        unCheckedElement,
	        checkedElement
	      );
	
	      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switched: this.state.switched,
	        switchElement: checkboxElement,
	        rippleColor: rippleColor,
	        iconStyle: mergedIconStyle,
	        onSwitch: this.handleCheck,
	        labelStyle: labelStyle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.defaultProps = {
	  labelPosition: 'right',
	  disabled: false
	};
	Checkbox.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Checkbox.propTypes = {
	  /**
	   * Checkbox is checked if true.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * The SvgIcon to use for the checked state.
	   * This is useful to create icon toggles.
	   */
	  checkedIcon: _react.PropTypes.element,
	  /**
	   * The default state of our checkbox component.
	   * **Warning:** This cannot be used in conjunction with `checked`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultChecked: _react.PropTypes.bool,
	  /**
	   * Disabled if true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * Where the label will be placed next to the checkbox.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Checkbox element label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function that is fired when the checkbox is checked.
	   *
	   * @param {object} event `change` event targeting the underlying checkbox `input`.
	   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
	   */
	  onCheck: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  uncheckedIcon: _react.PropTypes.element,
	  /**
	   * ValueLink for when using controlled checkbox.
	   */
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = Checkbox;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _colorManipulator = __webpack_require__(85);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _cancel = __webpack_require__(1053);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var chip = context.muiTheme.chip;
	
	
	  var backgroundColor = props.backgroundColor || chip.backgroundColor;
	  var focusColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.08);
	  var pressedColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.12);
	
	  return {
	    avatar: {
	      marginRight: -4
	    },
	    deleteIcon: {
	      color: state.deleteHovered ? (0, _colorManipulator.fade)(chip.deleteIconColor, 0.4) : chip.deleteIconColor,
	      cursor: 'pointer',
	      margin: '4px 4px 0px -8px'
	    },
	    label: {
	      color: props.labelColor || chip.textColor,
	      fontSize: chip.fontSize,
	      fontWeight: chip.fontWeight,
	      lineHeight: '32px',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap'
	    },
	    root: {
	      backgroundColor: state.clicked ? pressedColor : state.focused || state.hovered ? focusColor : backgroundColor,
	      borderRadius: 16,
	      boxShadow: state.clicked ? chip.shadow : null,
	      cursor: props.onTouchTap ? 'pointer' : 'default',
	      display: 'flex',
	      whiteSpace: 'nowrap',
	      width: 'fit-content'
	    }
	  };
	}
	
	var Chip = function (_Component) {
	  (0, _inherits3.default)(Chip, _Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      clicked: false,
	      deleteHovered: false,
	      focused: false,
	      hovered: false
	    }, _this.handleBlur = function (event) {
	      _this.setState({ clicked: false, focused: false });
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (_this.props.onTouchTap || _this.props.onRequestDelete) {
	        _this.setState({ focused: true });
	      }
	      _this.props.onFocus(event);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused) {
	        _this.handleFocus();
	        _this.props.onFocus(event);
	      } else {
	        _this.handleBlur();
	      }
	
	      _this.props.onKeyboardFocus(event, keyboardFocused);
	    }, _this.handleKeyDown = function (event) {
	      if ((0, _keycode2.default)(event) === 'backspace') {
	        event.preventDefault();
	        if (_this.props.onRequestDelete) {
	          _this.props.onRequestDelete(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleMouseDown = function (event) {
	      // Only listen to left clicks
	      if (event.button === 0) {
	        event.stopPropagation();
	        if (_this.props.onTouchTap) {
	          _this.setState({ clicked: true });
	        }
	      }
	      _this.props.onMouseDown(event);
	    }, _this.handleMouseEnter = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.setState({ hovered: true });
	      }
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseEnterDeleteIcon = function () {
	      _this.setState({ deleteHovered: true });
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({
	        clicked: false,
	        hovered: false
	      });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseLeaveDeleteIcon = function () {
	      _this.setState({ deleteHovered: false });
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onMouseUp(event);
	    }, _this.handleTouchTapDeleteIcon = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      _this.props.onRequestDelete(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onTouchEnd(event);
	    }, _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      if (_this.props.onTouchTap) {
	        _this.setState({ clicked: true });
	      }
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Chip, [{
	    key: 'render',
	    value: function render() {
	      var buttonEventHandlers = {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchStart: this.handleTouchStart,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          style = _props.style,
	          className = _props.className,
	          labelStyle = _props.labelStyle,
	          labelColor = _props.labelColor,
	          backgroundColor = _props.backgroundColor,
	          onRequestDelete = _props.onRequestDelete,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style', 'className', 'labelStyle', 'labelColor', 'backgroundColor', 'onRequestDelete']);
	
	
	      var deletable = this.props.onRequestDelete;
	      var avatar = null;
	
	      var deleteIcon = deletable ? _react2.default.createElement(_cancel2.default, {
	        color: styles.deleteIcon.color,
	        style: styles.deleteIcon,
	        onTouchTap: this.handleTouchTapDeleteIcon,
	        onMouseEnter: this.handleMouseEnterDeleteIcon,
	        onMouseLeave: this.handleMouseLeaveDeleteIcon
	      }) : null;
	
	      var children = childrenProp;
	      var childCount = _react2.default.Children.count(children);
	
	      // If the first child is an avatar, extract it and style it
	      if (childCount > 1) {
	        children = _react2.default.Children.toArray(children);
	
	        if (_react2.default.isValidElement(children[0]) && children[0].type.muiName === 'Avatar') {
	          avatar = children.shift();
	
	          avatar = _react2.default.cloneElement(avatar, {
	            style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style),
	            size: 32
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, buttonEventHandlers, {
	          className: className,
	          containerElement: 'div' // Firefox doesn't support nested buttons
	          , disableTouchRipple: true,
	          disableFocusRipple: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	          children
	        ),
	        deleteIcon
	      );
	    }
	  }]);
	  return Chip;
	}(_react.Component);
	
	Chip.defaultProps = {
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseUp: function onMouseUp() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {}
	};
	Chip.contextTypes = { muiTheme: _react.PropTypes.object.isRequired };
	process.env.NODE_ENV !== "production" ? Chip.propTypes = {
	  /**
	   * Override the background color of the chip.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Used to render elements inside the Chip.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * CSS `className` of the root element.
	   */
	  className: _react.PropTypes.node,
	  /**
	   * Override the label color.
	   */
	  labelColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /** @ignore */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /**
	   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
	   * @param {object} event `touchTap` event targeting the element.
	   */
	  onRequestDelete: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `Chip` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the element.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Chip;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Chip = __webpack_require__(957);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chip2.default;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autoPrefix = __webpack_require__(114);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return clampedValue / (max - min);
	}
	
	function getArcLength(fraction, props) {
	  return fraction * Math.PI * (props.size - props.thickness);
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      size = props.size,
	      value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      width: size,
	      height: size
	    },
	    wrapper: {
	      width: size,
	      height: size,
	      display: 'inline-block',
	      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	      transitionTimingFunction: 'linear'
	    },
	    svg: {
	      width: size,
	      height: size,
	      position: 'relative'
	    },
	    path: {
	      stroke: props.color || palette.primary1Color,
	      strokeLinecap: 'round',
	      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	    }
	  };
	
	  if (props.mode === 'determinate') {
	    var relVal = getRelativeValue(value, min, max);
	    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	    styles.path.strokeDasharray = getArcLength(relVal, props) + ', ' + getArcLength(1, props);
	  }
	
	  return styles;
	}
	
	var CircularProgress = function (_Component) {
	  (0, _inherits3.default)(CircularProgress, _Component);
	
	  function CircularProgress() {
	    (0, _classCallCheck3.default)(this, CircularProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (CircularProgress.__proto__ || (0, _getPrototypeOf2.default)(CircularProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircularProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path) {
	      var _this2 = this;
	
	      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step %= 3;
	
	      if (step === 0) {
	        path.style.strokeDasharray = getArcLength(0, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = 0;
	        path.style.transitionDuration = '0ms';
	      } else if (step === 1) {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-0.3, this.props);
	        path.style.transitionDuration = '750ms';
	      } else {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-1, this.props);
	        path.style.transitionDuration = '850ms';
	      }
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, step + 1);
	      }, step ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          innerStyle = _props.innerStyle,
	          size = _props.size,
	          thickness = _props.thickness,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'innerStyle', 'size', 'thickness']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
	          _react2.default.createElement(
	            'svg',
	            {
	              viewBox: '0 0 ' + size + ' ' + size,
	              style: prepareStyles(styles.svg)
	            },
	            _react2.default.createElement('circle', {
	              ref: 'path',
	              style: prepareStyles(styles.path),
	              cx: size / 2,
	              cy: size / 2,
	              r: (size - thickness) / 2,
	              fill: 'none',
	              strokeWidth: thickness,
	              strokeMiterlimit: '20'
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return CircularProgress;
	}(_react.Component);
	
	CircularProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100,
	  size: 40,
	  thickness: 3.5
	};
	CircularProgress.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? CircularProgress.propTypes = {
	  /**
	   * Override the progress's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * Style for inner wrapper div.
	   */
	  innerStyle: _react.PropTypes.object,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _react.PropTypes.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _react.PropTypes.number,
	  /**
	   * The mode of show your progress, indeterminate
	   * for when there is no value for progress.
	   */
	  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
	  /**
	   * The diameter of the progress in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Stroke width in pixels.
	   */
	  thickness: _react.PropTypes.number,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = CircularProgress;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CircularProgress = __webpack_require__(959);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CircularProgress2.default;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toConsumableArray2 = __webpack_require__(154);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(87);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _CalendarActionButtons = __webpack_require__(962);
	
	var _CalendarActionButtons2 = _interopRequireDefault(_CalendarActionButtons);
	
	var _CalendarMonth = __webpack_require__(963);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarYear = __webpack_require__(965);
	
	var _CalendarYear2 = _interopRequireDefault(_CalendarYear);
	
	var _CalendarToolbar = __webpack_require__(964);
	
	var _CalendarToolbar2 = _interopRequireDefault(_CalendarToolbar);
	
	var _DateDisplay = __webpack_require__(966);
	
	var _DateDisplay2 = _interopRequireDefault(_DateDisplay);
	
	var _SlideIn = __webpack_require__(281);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	var _dateUtils = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var daysArray = [].concat((0, _toConsumableArray3.default)(Array(7)));
	
	var Calendar = function (_Component) {
	  (0, _inherits3.default)(Calendar, _Component);
	
	  function Calendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      displayDate: undefined,
	      displayMonthDay: true,
	      selectedDate: undefined,
	      transitionDirection: 'left',
	      transitionEnter: true
	    }, _this.handleTouchTapDay = function (event, date) {
	      _this.setSelectedDate(date);
	      if (_this.props.onTouchTapDay) _this.props.onTouchTapDay(event, date);
	    }, _this.handleMonthChange = function (months) {
	      _this.setState({
	        transitionDirection: months >= 0 ? 'left' : 'right',
	        displayDate: (0, _dateUtils.addMonths)(_this.state.displayDate, months)
	      });
	    }, _this.handleTouchTapYear = function (event, year) {
	      var date = (0, _dateUtils.cloneDate)(_this.state.selectedDate);
	      date.setFullYear(year);
	      _this.setSelectedDate(date, event);
	      _this.handleTouchTapDateDisplayMonthDay();
	    }, _this.handleTouchTapDateDisplayMonthDay = function () {
	      _this.setState({
	        displayMonthDay: true
	      });
	    }, _this.handleTouchTapDateDisplayYear = function () {
	      _this.setState({
	        displayMonthDay: false
	      });
	    }, _this.handleWindowKeyDown = function (event) {
	      if (_this.props.open) {
	        switch ((0, _keycode2.default)(event)) {
	          case 'up':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-7);
	            }
	            break;
	
	          case 'down':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(7);
	            }
	            break;
	
	          case 'right':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(1);
	            }
	            break;
	
	          case 'left':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-1);
	            }
	            break;
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Calendar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        displayDate: (0, _dateUtils.getFirstDayOfMonth)(this.props.initialDate),
	        selectedDate: this.props.initialDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.initialDate !== this.props.initialDate) {
	        var date = nextProps.initialDate || new Date();
	        this.setState({
	          displayDate: (0, _dateUtils.getFirstDayOfMonth)(date),
	          selectedDate: date
	        });
	      }
	    }
	  }, {
	    key: 'getSelectedDate',
	    value: function getSelectedDate() {
	      return this.state.selectedDate;
	    }
	  }, {
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      if (!this.state.displayMonthDay) {
	        return false;
	      }
	
	      return this.refs.calendar.isSelectedDateDisabled();
	    }
	  }, {
	    key: 'addSelectedDays',
	    value: function addSelectedDays(days) {
	      this.setSelectedDate((0, _dateUtils.addDays)(this.state.selectedDate, days));
	    }
	  }, {
	    key: 'addSelectedMonths',
	    value: function addSelectedMonths(months) {
	      this.setSelectedDate((0, _dateUtils.addMonths)(this.state.selectedDate, months));
	    }
	  }, {
	    key: 'addSelectedYears',
	    value: function addSelectedYears(years) {
	      this.setSelectedDate((0, _dateUtils.addYears)(this.state.selectedDate, years));
	    }
	  }, {
	    key: 'setDisplayDate',
	    value: function setDisplayDate(date, newSelectedDate) {
	      var newDisplayDate = (0, _dateUtils.getFirstDayOfMonth)(date);
	      var direction = newDisplayDate > this.state.displayDate ? 'left' : 'right';
	
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setState({
	          displayDate: newDisplayDate,
	          transitionDirection: direction,
	          selectedDate: newSelectedDate || this.state.selectedDate
	        });
	      }
	    }
	  }, {
	    key: 'setSelectedDate',
	    value: function setSelectedDate(date) {
	      var adjustedDate = date;
	      if ((0, _dateUtils.isBeforeDate)(date, this.props.minDate)) {
	        adjustedDate = this.props.minDate;
	      } else if ((0, _dateUtils.isAfterDate)(date, this.props.maxDate)) {
	        adjustedDate = this.props.maxDate;
	      }
	
	      var newDisplayDate = (0, _dateUtils.getFirstDayOfMonth)(adjustedDate);
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setDisplayDate(newDisplayDate, adjustedDate);
	      } else {
	        this.setState({
	          selectedDate: adjustedDate
	        });
	      }
	    }
	  }, {
	    key: 'getToolbarInteractions',
	    value: function getToolbarInteractions() {
	      return {
	        prevMonth: (0, _dateUtils.monthDiff)(this.state.displayDate, this.props.minDate) > 0,
	        nextMonth: (0, _dateUtils.monthDiff)(this.state.displayDate, this.props.maxDate) < 0
	      };
	    }
	  }, {
	    key: 'yearSelector',
	    value: function yearSelector() {
	      if (!this.props.disableYearSelection) {
	        return _react2.default.createElement(_CalendarYear2.default, {
	          key: 'years',
	          DateTimeFormat: this.props.DateTimeFormat,
	          locale: this.props.locale,
	          onTouchTapYear: this.handleTouchTapYear,
	          selectedDate: this.state.selectedDate,
	          minDate: this.props.minDate,
	          maxDate: this.props.maxDate
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var toolbarInteractions = this.getToolbarInteractions();
	      var isLandscape = this.props.mode === 'landscape';
	      var calendarTextColor = this.context.muiTheme.datePicker.calendarTextColor;
	
	
	      var styles = {
	        root: {
	          color: calendarTextColor,
	          userSelect: 'none',
	          width: isLandscape ? 479 : 310
	        },
	        calendar: {
	          display: 'flex',
	          flexDirection: 'column'
	        },
	        calendarContainer: {
	          display: 'flex',
	          alignContent: 'space-between',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          fontSize: 12,
	          fontWeight: 400,
	          padding: '0px 8px',
	          transition: _transitions2.default.easeOut()
	        },
	        yearContainer: {
	          display: 'flex',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          height: 272,
	          marginTop: 10,
	          overflow: 'hidden',
	          width: 310
	        },
	        weekTitle: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'space-between',
	          fontWeight: '500',
	          height: 20,
	          lineHeight: '15px',
	          opacity: '0.5',
	          textAlign: 'center'
	        },
	        weekTitleDay: {
	          width: 42
	        },
	        transitionSlide: {
	          height: 214
	        }
	      };
	
	      var weekTitleDayStyle = prepareStyles(styles.weekTitleDay);
	
	      var _props = this.props,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          cancelLabel = _props.cancelLabel,
	          DateTimeFormat = _props.DateTimeFormat,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          okLabel = _props.okLabel,
	          onTouchTapCancel = _props.onTouchTapCancel,
	          onTouchTapOk = _props.onTouchTapOk;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleWindowKeyDown
	        }),
	        _react2.default.createElement(_DateDisplay2.default, {
	          DateTimeFormat: DateTimeFormat,
	          disableYearSelection: this.props.disableYearSelection,
	          onTouchTapMonthDay: this.handleTouchTapDateDisplayMonthDay,
	          onTouchTapYear: this.handleTouchTapDateDisplayYear,
	          locale: locale,
	          monthDaySelected: this.state.displayMonthDay,
	          mode: this.props.mode,
	          selectedDate: this.state.selectedDate
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.calendar) },
	          this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.calendarContainer) },
	            _react2.default.createElement(_CalendarToolbar2.default, {
	              DateTimeFormat: DateTimeFormat,
	              locale: locale,
	              displayDate: this.state.displayDate,
	              onMonthChange: this.handleMonthChange,
	              prevMonth: toolbarInteractions.prevMonth,
	              nextMonth: toolbarInteractions.nextMonth
	            }),
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.weekTitle) },
	              daysArray.map(function (event, i) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: i, style: weekTitleDayStyle },
	                  (0, _dateUtils.localizedWeekday)(DateTimeFormat, locale, i, firstDayOfWeek)
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _SlideIn2.default,
	              { direction: this.state.transitionDirection, style: styles.transitionSlide },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                DateTimeFormat: DateTimeFormat,
	                locale: locale,
	                displayDate: this.state.displayDate,
	                firstDayOfWeek: this.props.firstDayOfWeek,
	                key: this.state.displayDate.toDateString(),
	                minDate: minDate,
	                maxDate: maxDate,
	                onTouchTapDay: this.handleTouchTapDay,
	                ref: 'calendar',
	                selectedDate: this.state.selectedDate,
	                shouldDisableDate: this.props.shouldDisableDate
	              })
	            )
	          ),
	          !this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.yearContainer) },
	            this.yearSelector()
	          ),
	          okLabel && _react2.default.createElement(_CalendarActionButtons2.default, {
	            autoOk: this.props.autoOk,
	            cancelLabel: cancelLabel,
	            okLabel: okLabel,
	            onTouchTapCancel: onTouchTapCancel,
	            onTouchTapOk: onTouchTapOk
	          })
	        )
	      );
	    }
	  }]);
	  return Calendar;
	}(_react.Component);
	
	Calendar.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  disableYearSelection: false,
	  initialDate: new Date(),
	  locale: 'en-US',
	  minDate: (0, _dateUtils.addYears)(new Date(), -100),
	  maxDate: (0, _dateUtils.addYears)(new Date(), 100)
	};
	Calendar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Calendar.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  disableYearSelection: _react.PropTypes.bool,
	  firstDayOfWeek: _react.PropTypes.number,
	  initialDate: _react.PropTypes.object,
	  locale: _react.PropTypes.string.isRequired,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  okLabel: _react.PropTypes.node,
	  onTouchTapCancel: _react.PropTypes.func,
	  onTouchTapDay: _react.PropTypes.func,
	  onTouchTapOk: _react.PropTypes.func,
	  open: _react.PropTypes.bool,
	  shouldDisableDate: _react.PropTypes.func
	} : void 0;
	exports.default = Calendar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FlatButton = __webpack_require__(193);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarActionButton = function (_Component) {
	  (0, _inherits3.default)(CalendarActionButton, _Component);
	
	  function CalendarActionButton() {
	    (0, _classCallCheck3.default)(this, CalendarActionButton);
	    return (0, _possibleConstructorReturn3.default)(this, (CalendarActionButton.__proto__ || (0, _getPrototypeOf2.default)(CalendarActionButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CalendarActionButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          okLabel = _props.okLabel;
	
	
	      var styles = {
	        root: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'flex-end',
	          margin: 0,
	          maxHeight: 48,
	          padding: 0
	        },
	        flatButtons: {
	          fontsize: 14,
	          margin: '4px 8px 8px 0px',
	          maxHeight: 36,
	          minWidth: 64,
	          padding: 0
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_FlatButton2.default, {
	          label: cancelLabel,
	          onTouchTap: this.props.onTouchTapCancel,
	          primary: true,
	          style: styles.flatButtons
	        }),
	        !this.props.autoOk && _react2.default.createElement(_FlatButton2.default, {
	          disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
	          label: okLabel,
	          onTouchTap: this.props.onTouchTapOk,
	          primary: true,
	          style: styles.flatButtons
	        })
	      );
	    }
	  }]);
	  return CalendarActionButton;
	}(_react.Component);
	
	process.env.NODE_ENV !== "production" ? CalendarActionButton.propTypes = {
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  okLabel: _react.PropTypes.node,
	  onTouchTapCancel: _react.PropTypes.func,
	  onTouchTapOk: _react.PropTypes.func
	} : void 0;
	exports.default = CalendarActionButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateUtils = __webpack_require__(134);
	
	var _DayButton = __webpack_require__(969);
	
	var _DayButton2 = _interopRequireDefault(_DayButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'flex-start',
	    fontWeight: 400,
	    height: 228,
	    lineHeight: 2,
	    position: 'relative',
	    textAlign: 'center',
	    MozPaddingStart: 0
	  },
	  week: {
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-around',
	    height: 34,
	    marginBottom: 2
	  }
	};
	
	var CalendarMonth = function (_Component) {
	  (0, _inherits3.default)(CalendarMonth, _Component);
	
	  function CalendarMonth() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarMonth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarMonth.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonth)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapDay = function (event, date) {
	      if (_this.props.onTouchTapDay) {
	        _this.props.onTouchTapDay(event, date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarMonth, [{
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      return this.selectedDateDisabled;
	    }
	  }, {
	    key: 'shouldDisableDate',
	    value: function shouldDisableDate(day) {
	      if (day === null) return false;
	      var disabled = !(0, _dateUtils.isBetweenDates)(day, this.props.minDate, this.props.maxDate);
	      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);
	
	      return disabled;
	    }
	  }, {
	    key: 'getWeekElements',
	    value: function getWeekElements() {
	      var _this2 = this;
	
	      var weekArray = (0, _dateUtils.getWeekArray)(this.props.displayDate, this.props.firstDayOfWeek);
	
	      return weekArray.map(function (week, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: styles.week },
	          _this2.getDayElements(week, i)
	        );
	      }, this);
	    }
	  }, {
	    key: 'getDayElements',
	    value: function getDayElements(week, i) {
	      var _this3 = this;
	
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          selectedDate = _props.selectedDate;
	
	
	      return week.map(function (day, j) {
	        var isSameDate = (0, _dateUtils.isEqualDate)(selectedDate, day);
	        var disabled = _this3.shouldDisableDate(day);
	        var selected = !disabled && isSameDate;
	
	        if (isSameDate) {
	          _this3.selectedDateDisabled = disabled;
	        }
	
	        return _react2.default.createElement(_DayButton2.default, {
	          DateTimeFormat: DateTimeFormat,
	          locale: locale,
	          date: day,
	          disabled: disabled,
	          key: 'db' + (i + j),
	          onTouchTap: _this3.handleTouchTapDay,
	          selected: selected
	        });
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        this.getWeekElements()
	      );
	    }
	  }]);
	  return CalendarMonth;
	}(_react.Component);
	
	process.env.NODE_ENV !== "production" ? CalendarMonth.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  autoOk: _react.PropTypes.bool,
	  displayDate: _react.PropTypes.object.isRequired,
	  firstDayOfWeek: _react.PropTypes.number,
	  locale: _react.PropTypes.string.isRequired,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  onTouchTapDay: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  shouldDisableDate: _react.PropTypes.func
	} : void 0;
	exports.default = CalendarMonth;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconButton = __webpack_require__(135);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _chevronLeft = __webpack_require__(1055);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(1056);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _SlideIn = __webpack_require__(281);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    backgroundColor: 'inherit',
	    height: 48
	  },
	  titleDiv: {
	    fontSize: 14,
	    fontWeight: '500',
	    textAlign: 'center',
	    width: '100%'
	  },
	  titleText: {
	    height: 'inherit',
	    paddingTop: 12
	  }
	};
	
	var CalendarToolbar = function (_Component) {
	  (0, _inherits3.default)(CalendarToolbar, _Component);
	
	  function CalendarToolbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarToolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarToolbar.__proto__ || (0, _getPrototypeOf2.default)(CalendarToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _this.handleTouchTapPrevMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(-1);
	      }
	    }, _this.handleTouchTapNextMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(1);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarToolbar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.displayDate !== this.props.displayDate) {
	        var direction = nextProps.displayDate > this.props.displayDate ? 'left' : 'right';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          displayDate = _props.displayDate;
	
	
	      var dateTimeFormatted = new DateTimeFormat(locale, {
	        month: 'long',
	        year: 'numeric'
	      }).format(displayDate);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.prevMonth,
	            onTouchTap: this.handleTouchTapPrevMonth
	          },
	          _react2.default.createElement(_chevronLeft2.default, null)
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          {
	            direction: this.state.transitionDirection,
	            style: styles.titleDiv
	          },
	          _react2.default.createElement(
	            'div',
	            { key: dateTimeFormatted, style: styles.titleText },
	            dateTimeFormatted
	          )
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.nextMonth,
	            onTouchTap: this.handleTouchTapNextMonth
	          },
	          _react2.default.createElement(_chevronRight2.default, null)
	        )
	      );
	    }
	  }]);
	  return CalendarToolbar;
	}(_react.Component);
	
	CalendarToolbar.defaultProps = {
	  nextMonth: true,
	  prevMonth: true
	};
	process.env.NODE_ENV !== "production" ? CalendarToolbar.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  displayDate: _react.PropTypes.object.isRequired,
	  locale: _react.PropTypes.string.isRequired,
	  nextMonth: _react.PropTypes.bool,
	  onMonthChange: _react.PropTypes.func,
	  prevMonth: _react.PropTypes.bool
	} : void 0;
	exports.default = CalendarToolbar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _YearButton = __webpack_require__(970);
	
	var _YearButton2 = _interopRequireDefault(_YearButton);
	
	var _dateUtils = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarYear = function (_Component) {
	  (0, _inherits3.default)(CalendarYear, _Component);
	
	  function CalendarYear() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarYear);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarYear.__proto__ || (0, _getPrototypeOf2.default)(CalendarYear)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapYear = function (event, year) {
	      if (_this.props.onTouchTapYear) {
	        _this.props.onTouchTapYear(event, year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarYear, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'getYears',
	    value: function getYears() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          selectedDate = _props.selectedDate;
	
	
	      var minYear = minDate.getFullYear();
	      var maxYear = maxDate.getFullYear();
	      var years = [];
	      var dateCheck = (0, _dateUtils.cloneDate)(selectedDate);
	
	      for (var year = minYear; year <= maxYear; year++) {
	        dateCheck.setFullYear(year);
	        var selected = selectedDate.getFullYear() === year;
	        var selectedProps = {};
	        if (selected) {
	          selectedProps.ref = 'selectedYearButton';
	        }
	
	        var yearFormated = new DateTimeFormat(locale, {
	          year: 'numeric'
	        }).format(dateCheck);
	
	        var yearButton = _react2.default.createElement(
	          _YearButton2.default,
	          (0, _extends3.default)({
	            key: 'yb' + year,
	            onTouchTap: this.handleTouchTapYear,
	            selected: selected,
	            year: year
	          }, selectedProps),
	          yearFormated
	        );
	
	        years.push(yearButton);
	      }
	
	      return years;
	    }
	  }, {
	    key: 'scrollToSelectedYear',
	    value: function scrollToSelectedYear() {
	      if (this.refs.selectedYearButton === undefined) {
	        return;
	      }
	
	      var container = _reactDom2.default.findDOMNode(this);
	      var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);
	
	      var containerHeight = container.clientHeight;
	      var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;
	
	      var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
	      container.scrollTop = scrollYOffset;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          calendarYearBackgroundColor = _context$muiTheme.datePicker.calendarYearBackgroundColor;
	
	
	      var styles = {
	        root: {
	          backgroundColor: calendarYearBackgroundColor,
	          height: 'inherit',
	          lineHeight: '35px',
	          overflowX: 'hidden',
	          overflowY: 'scroll',
	          position: 'relative'
	        },
	        child: {
	          display: 'flex',
	          flexDirection: 'column',
	          justifyContent: 'center',
	          minHeight: '100%'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.child) },
	          this.getYears()
	        )
	      );
	    }
	  }]);
	  return CalendarYear;
	}(_react.Component);
	
	CalendarYear.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? CalendarYear.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  locale: _react.PropTypes.string.isRequired,
	  maxDate: _react.PropTypes.object.isRequired,
	  minDate: _react.PropTypes.object.isRequired,
	  onTouchTapYear: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  wordings: _react.PropTypes.object
	} : void 0;
	exports.default = CalendarYear;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _SlideIn = __webpack_require__(281);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var datePicker = context.muiTheme.datePicker;
	  var selectedYear = state.selectedYear;
	
	  var isLandscape = props.mode === 'landscape';
	
	  var styles = {
	    root: {
	      width: isLandscape ? 165 : '100%',
	      height: isLandscape ? 330 : 'auto',
	      float: isLandscape ? 'left' : 'none',
	      fontWeight: 700,
	      display: 'inline-block',
	      backgroundColor: datePicker.selectColor,
	      borderTopLeftRadius: 2,
	      borderTopRightRadius: isLandscape ? 0 : 2,
	      borderBottomLeftRadius: isLandscape ? 2 : 0,
	      color: datePicker.textColor,
	      padding: 20,
	      boxSizing: 'border-box'
	    },
	    monthDay: {
	      display: 'block',
	      fontSize: 36,
	      lineHeight: '36px',
	      height: props.mode === 'landscape' ? '100%' : 38,
	      opacity: selectedYear ? 0.7 : 1,
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      fontWeight: '500'
	    },
	    monthDayTitle: {
	      cursor: !selectedYear ? 'default' : 'pointer',
	      width: '100%',
	      display: 'block'
	    },
	    year: {
	      margin: 0,
	      fontSize: 16,
	      fontWeight: '500',
	      lineHeight: '16px',
	      height: 16,
	      opacity: selectedYear ? 1 : 0.7,
	      transition: _transitions2.default.easeOut(),
	      marginBottom: 10
	    },
	    yearTitle: {
	      cursor: props.disableYearSelection ? 'not-allowed' : !selectedYear ? 'pointer' : 'default'
	    }
	  };
	
	  return styles;
	}
	
	var DateDisplay = function (_Component) {
	  (0, _inherits3.default)(DateDisplay, _Component);
	
	  function DateDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DateDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateDisplay.__proto__ || (0, _getPrototypeOf2.default)(DateDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedYear: false,
	      transitionDirection: 'up'
	    }, _this.handleTouchTapMonthDay = function () {
	      if (_this.props.onTouchTapMonthDay && _this.state.selectedYear) {
	        _this.props.onTouchTapMonthDay();
	      }
	
	      _this.setState({ selectedYear: false });
	    }, _this.handleTouchTapYear = function () {
	      if (_this.props.onTouchTapYear && !_this.props.disableYearSelection && !_this.state.selectedYear) {
	        _this.props.onTouchTapYear();
	      }
	
	      if (!_this.props.disableYearSelection) {
	        _this.setState({ selectedYear: true });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DateDisplay, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.monthDaySelected) {
	        this.setState({ selectedYear: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedDate !== this.props.selectedDate) {
	        var direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	
	      if (nextProps.monthDaySelected !== undefined) {
	        this.setState({
	          selectedYear: !nextProps.monthDaySelected
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          disableYearSelection = _props.disableYearSelection,
	          locale = _props.locale,
	          mode = _props.mode,
	          monthDaySelected = _props.monthDaySelected,
	          onTouchTapMonthDay = _props.onTouchTapMonthDay,
	          onTouchTapYear = _props.onTouchTapYear,
	          selectedDate = _props.selectedDate,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'disableYearSelection', 'locale', 'mode', 'monthDaySelected', 'onTouchTapMonthDay', 'onTouchTapYear', 'selectedDate', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var year = new DateTimeFormat(locale, {
	        year: 'numeric'
	      }).format(selectedDate);
	
	      var dateTime = new DateTimeFormat(locale, {
	        month: 'short',
	        weekday: 'short',
	        day: '2-digit'
	      }).format(selectedDate);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root, style) }),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.year, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            { key: year, style: styles.yearTitle, onTouchTap: this.handleTouchTapYear },
	            year
	          )
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.monthDay, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            {
	              key: dateTime,
	              onTouchTap: this.handleTouchTapMonthDay,
	              style: styles.monthDayTitle
	            },
	            dateTime
	          )
	        )
	      );
	    }
	  }]);
	  return DateDisplay;
	}(_react.Component);
	
	DateDisplay.defaultProps = {
	  disableYearSelection: false,
	  monthDaySelected: true
	};
	DateDisplay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? DateDisplay.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  disableYearSelection: _react.PropTypes.bool,
	  locale: _react.PropTypes.string.isRequired,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  monthDaySelected: _react.PropTypes.bool,
	  onTouchTapMonthDay: _react.PropTypes.func,
	  onTouchTapYear: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = DateDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateUtils = __webpack_require__(134);
	
	var _DatePickerDialog = __webpack_require__(968);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	var _TextField = __webpack_require__(163);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePicker = function (_Component) {
	  (0, _inherits3.default)(DatePicker, _Component);
	
	  function DatePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      date: undefined
	    }, _this.handleAccept = function (date) {
	      if (!_this.isControlled()) {
	        _this.setState({
	          date: date
	        });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(null, date);
	      }
	    }, _this.handleFocus = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	
	      if (!_this.props.disabled) {
	        setTimeout(function () {
	          _this.openDialog();
	        }, 0);
	      }
	    }, _this.formatDate = function (date) {
	      if (_this.props.locale) {
	        var DateTimeFormat = _this.props.DateTimeFormat || _dateUtils.dateTimeFormat;
	        return new DateTimeFormat(_this.props.locale, {
	          day: 'numeric',
	          month: 'numeric',
	          year: 'numeric'
	        }).format(date);
	      } else {
	        return (0, _dateUtils.formatIso)(date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        date: this.isControlled() ? this.getControlledDate() : this.props.defaultDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.isControlled()) {
	        var newDate = this.getControlledDate(nextProps);
	        if (!(0, _dateUtils.isEqualDate)(this.state.date, newDate)) {
	          this.setState({
	            date: newDate
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getDate',
	    value: function getDate() {
	      return this.state.date;
	    }
	
	    /**
	     * Open the date-picker dialog programmatically from a parent.
	     */
	
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      /**
	       * if the date is not selected then set it to new date
	       * (get the current system date while doing so)
	       * else set it to the currently selected date
	       */
	      if (this.state.date !== undefined) {
	        this.setState({
	          dialogDate: this.getDate()
	        }, this.refs.dialogWindow.show);
	      } else {
	        this.setState({
	          dialogDate: new Date()
	        }, this.refs.dialogWindow.show);
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'getControlledDate',
	    value: function getControlledDate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      if (props.value instanceof Date) {
	        return props.value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          className = _props.className,
	          container = _props.container,
	          defaultDate = _props.defaultDate,
	          dialogContainerStyle = _props.dialogContainerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          formatDateProp = _props.formatDate,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onDismiss = _props.onDismiss,
	          onFocus = _props.onFocus,
	          onShow = _props.onShow,
	          onTouchTap = _props.onTouchTap,
	          shouldDisableDate = _props.shouldDisableDate,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'className', 'container', 'defaultDate', 'dialogContainerStyle', 'disableYearSelection', 'firstDayOfWeek', 'formatDate', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onDismiss', 'onFocus', 'onShow', 'onTouchTap', 'shouldDisableDate', 'style', 'textFieldStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var formatDate = formatDateProp || this.formatDate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          onFocus: this.handleFocus,
	          onTouchTap: this.handleTouchTap,
	          ref: 'input',
	          style: textFieldStyle,
	          value: this.state.date ? formatDate(this.state.date) : ''
	        })),
	        _react2.default.createElement(_DatePickerDialog2.default, {
	          DateTimeFormat: DateTimeFormat,
	          autoOk: autoOk,
	          cancelLabel: cancelLabel,
	          container: container,
	          containerStyle: dialogContainerStyle,
	          disableYearSelection: disableYearSelection,
	          firstDayOfWeek: firstDayOfWeek,
	          initialDate: this.state.dialogDate,
	          locale: locale,
	          maxDate: maxDate,
	          minDate: minDate,
	          mode: mode,
	          okLabel: okLabel,
	          onAccept: this.handleAccept,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          ref: 'dialogWindow',
	          shouldDisableDate: shouldDisableDate
	        })
	      );
	    }
	  }]);
	  return DatePicker;
	}(_react.Component);
	
	DatePicker.defaultProps = {
	  autoOk: false,
	  container: 'dialog',
	  disabled: false,
	  disableYearSelection: false,
	  firstDayOfWeek: 1,
	  style: {}
	};
	DatePicker.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? DatePicker.propTypes = {
	  /**
	   * Constructor for date formatting for the specified `locale`.
	   * The constructor must follow this specification: ECMAScript Internationalization API 1.0 (ECMA-402).
	   * `Intl.DateTimeFormat` is supported by most modern browsers, see http://caniuse.com/#search=intl,
	   * otherwise https://github.com/andyearnshaw/Intl.js is a good polyfill.
	   *
	   * By default, a built-in `DateTimeFormat` is used which supports the 'en-US' `locale`.
	   */
	  DateTimeFormat: _react.PropTypes.func,
	  /**
	   * If true, automatically accept and close the picker on select a date.
	   */
	  autoOk: _react.PropTypes.bool,
	  /**
	   * Override the default text of the 'Cancel' button.
	   */
	  cancelLabel: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Used to control how the Date Picker will be displayed when the input field is focused.
	   * `dialog` (default) displays the DatePicker as a dialog with a modal.
	   * `inline` displays the DatePicker below the input field (similar to auto complete).
	   */
	  container: _react.PropTypes.oneOf(['dialog', 'inline']),
	  /**
	   * This is the initial date value of the component.
	   * If either `value` or `valueLink` is provided they will override this
	   * prop with `value` taking precedence.
	   */
	  defaultDate: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of DatePickerDialog's Container element.
	   */
	  dialogContainerStyle: _react.PropTypes.object,
	  /**
	   * Disables the year selection in the date picker.
	   */
	  disableYearSelection: _react.PropTypes.bool,
	  /**
	   * Disables the DatePicker.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Used to change the first day of week. It varies from
	   * Saturday to Monday between different locales.
	   * The allowed range is 0 (Sunday) to 6 (Saturday).
	   * The default is `1`, Monday, as per ISO 8601.
	   */
	  firstDayOfWeek: _react.PropTypes.number,
	  /**
	   * This function is called to format the date displayed in the input field, and should return a string.
	   * By default if no `locale` and `DateTimeFormat` is provided date objects are formatted to ISO 8601 YYYY-MM-DD.
	   *
	   * @param {object} date Date object to be formatted.
	   * @returns {any} The formatted date.
	   */
	  formatDate: _react.PropTypes.func,
	  /**
	   * Locale used for formatting the `DatePicker` date strings. Other than for 'en-US', you
	   * must provide a `DateTimeFormat` that supports the chosen `locale`.
	   */
	  locale: _react.PropTypes.string,
	  /**
	   * The ending of a range of valid dates. The range includes the endDate.
	   * The default value is current date + 100 years.
	   */
	  maxDate: _react.PropTypes.object,
	  /**
	   * The beginning of a range of valid dates. The range includes the startDate.
	   * The default value is current date - 100 years.
	   */
	  minDate: _react.PropTypes.object,
	  /**
	   * Tells the component to display the picker in portrait or landscape mode.
	   */
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  /**
	   * Override the default text of the 'OK' button.
	   */
	  okLabel: _react.PropTypes.node,
	  /**
	   * Callback function that is fired when the date value changes.
	   *
	   * @param {null} null Since there is no particular event associated with the change,
	   * the first argument will always be null.
	   * @param {object} date The new date.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is dismissed.
	   */
	  onDismiss: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's `TextField` gains focus.
	   */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is shown.
	   */
	  onShow: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when a touch tap event occurs on the Date Picker's `TextField`.
	   *
	   * @param {object} event TouchTap event targeting the `TextField`.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function used to determine if a day's entry should be disabled on the calendar.
	   *
	   * @param {object} day Date object of a day.
	   * @returns {boolean} Indicates whether the day should be disabled.
	   */
	  shouldDisableDate: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of DatePicker's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object,
	  /**
	   * Sets the date for the Date Picker programmatically.
	   */
	  value: _react.PropTypes.object
	} : void 0;
	exports.default = DatePicker;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(87);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Calendar = __webpack_require__(961);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Dialog = __webpack_require__(270);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Popover = __webpack_require__(136);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(276);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _dateUtils = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerDialog = function (_Component) {
	  (0, _inherits3.default)(DatePickerDialog, _Component);
	
	  function DatePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(DatePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.show = function () {
	      if (_this.props.onShow && !_this.state.open) {
	        _this.props.onShow();
	      }
	
	      _this.setState({
	        open: true
	      });
	    }, _this.dismiss = function () {
	      if (_this.props.onDismiss && _this.state.open) {
	        _this.props.onDismiss();
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleTouchTapDay = function () {
	      if (_this.props.autoOk) {
	        setTimeout(_this.handleTouchTapOk, 300);
	      }
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOk = function () {
	      if (_this.props.onAccept && !_this.refs.calendar.isSelectedDateDisabled()) {
	        _this.props.onAccept(_this.refs.calendar.getSelectedDate());
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleWindowKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOk();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePickerDialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          container = _props.container,
	          containerStyle = _props.containerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          initialDate = _props.initialDate,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onAccept = _props.onAccept,
	          onDismiss = _props.onDismiss,
	          onShow = _props.onShow,
	          shouldDisableDate = _props.shouldDisableDate,
	          style = _props.style,
	          animation = _props.animation,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'container', 'containerStyle', 'disableYearSelection', 'initialDate', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onAccept', 'onDismiss', 'onShow', 'shouldDisableDate', 'style', 'animation']);
	      var open = this.state.open;
	
	
	      var styles = {
	        dialogContent: {
	          width: mode === 'landscape' ? 479 : 310
	        },
	        dialogBodyContent: {
	          padding: 0,
	          minHeight: mode === 'landscape' ? 330 : 434,
	          minWidth: mode === 'landscape' ? 479 : 310
	        }
	      };
	
	      var Container = container === 'inline' ? _Popover2.default : _Dialog2.default;
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'root' }),
	        _react2.default.createElement(
	          Container,
	          {
	            anchorEl: this.refs.root // For Popover
	            , animation: animation || _PopoverAnimationVertical2.default // For Popover
	            , bodyStyle: styles.dialogBodyContent,
	            contentStyle: styles.dialogContent,
	            ref: 'dialog',
	            repositionOnUpdate: true,
	            open: open,
	            onRequestClose: this.handleRequestClose,
	            style: (0, _simpleAssign2.default)(styles.dialogBodyContent, containerStyle)
	          },
	          _react2.default.createElement(_reactEventListener2.default, {
	            target: 'window',
	            onKeyUp: this.handleWindowKeyUp
	          }),
	          _react2.default.createElement(_Calendar2.default, {
	            autoOk: autoOk,
	            DateTimeFormat: DateTimeFormat,
	            cancelLabel: cancelLabel,
	            disableYearSelection: disableYearSelection,
	            firstDayOfWeek: firstDayOfWeek,
	            initialDate: initialDate,
	            locale: locale,
	            onTouchTapDay: this.handleTouchTapDay,
	            maxDate: maxDate,
	            minDate: minDate,
	            mode: mode,
	            open: open,
	            ref: 'calendar',
	            onTouchTapCancel: this.handleTouchTapCancel,
	            onTouchTapOk: this.handleTouchTapOk,
	            okLabel: okLabel,
	            shouldDisableDate: shouldDisableDate
	          })
	        )
	      );
	    }
	  }]);
	  return DatePickerDialog;
	}(_react.Component);
	
	DatePickerDialog.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  cancelLabel: 'Cancel',
	  container: 'dialog',
	  locale: 'en-US',
	  okLabel: 'OK'
	};
	DatePickerDialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? DatePickerDialog.propTypes = {
	  DateTimeFormat: _react.PropTypes.func,
	  animation: _react.PropTypes.func,
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  container: _react.PropTypes.oneOf(['dialog', 'inline']),
	  containerStyle: _react.PropTypes.object,
	  disableYearSelection: _react.PropTypes.bool,
	  firstDayOfWeek: _react.PropTypes.number,
	  initialDate: _react.PropTypes.object,
	  locale: _react.PropTypes.string,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  okLabel: _react.PropTypes.node,
	  onAccept: _react.PropTypes.func,
	  onDismiss: _react.PropTypes.func,
	  onShow: _react.PropTypes.func,
	  open: _react.PropTypes.bool,
	  shouldDisableDate: _react.PropTypes.func,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = DatePickerDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _dateUtils = __webpack_require__(134);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var date = props.date,
	      disabled = props.disabled,
	      selected = props.selected;
	  var hover = state.hover;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	
	
	  var labelColor = baseTheme.palette.textColor;
	  var buttonStateOpacity = 0;
	  var buttonStateTransform = 'scale(0)';
	
	  if (hover || selected) {
	    labelColor = datePicker.selectTextColor;
	    buttonStateOpacity = selected ? 1 : 0.6;
	    buttonStateTransform = 'scale(1)';
	  } else if ((0, _dateUtils.isEqualDate)(date, new Date())) {
	    labelColor = datePicker.color;
	  }
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      fontWeight: '400',
	      opacity: disabled && '0.4',
	      padding: '4px 0px',
	      position: 'relative',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      width: 42
	    },
	    label: {
	      color: labelColor,
	      fontWeight: '400',
	      position: 'relative'
	    },
	    buttonState: {
	      backgroundColor: datePicker.selectColor,
	      borderRadius: '50%',
	      height: 34,
	      left: 4,
	      opacity: buttonStateOpacity,
	      position: 'absolute',
	      top: 0,
	      transform: buttonStateTransform,
	      transition: _transitions2.default.easeOut(),
	      width: 34
	    }
	  };
	}
	
	var DayButton = function (_Component) {
	  (0, _inherits3.default)(DayButton, _Component);
	
	  function DayButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DayButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DayButton.__proto__ || (0, _getPrototypeOf2.default)(DayButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: true });
	      }
	    }, _this.handleMouseLeave = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: false });
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (!_this.props.disabled && _this.props.onTouchTap) {
	        _this.props.onTouchTap(event, _this.props.date);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (!_this.props.disabled && _this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event, keyboardFocused, _this.props.date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DayButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          date = _props.date,
	          disabled = _props.disabled,
	          locale = _props.locale,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'date', 'disabled', 'locale', 'onTouchTap', 'selected']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return date ? _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchTap: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement('div', { style: prepareStyles(styles.buttonState) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          new DateTimeFormat(locale, {
	            day: 'numeric'
	          }).format(date)
	        )
	      ) : _react2.default.createElement('span', { style: prepareStyles(styles.root) });
	    }
	  }]);
	  return DayButton;
	}(_react.Component);
	
	DayButton.defaultProps = {
	  selected: false,
	  disabled: false
	};
	DayButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? DayButton.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  date: _react.PropTypes.object,
	  disabled: _react.PropTypes.bool,
	  locale: _react.PropTypes.string.isRequired,
	  onKeyboardFocus: _react.PropTypes.func,
	  onTouchTap: _react.PropTypes.func,
	  selected: _react.PropTypes.bool
	} : void 0;
	exports.default = DayButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var selected = props.selected,
	      year = props.year;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	  var hover = state.hover;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      color: year === new Date().getFullYear() && datePicker.color,
	      display: 'block',
	      fontSize: 14,
	      margin: '0 auto',
	      position: 'relative',
	      textAlign: 'center',
	      lineHeight: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    label: {
	      alignSelf: 'center',
	      color: hover || selected ? datePicker.color : baseTheme.palette.textColor,
	      fontSize: selected ? 26 : 17,
	      fontWeight: hover ? 450 : selected ? 500 : 400,
	      position: 'relative',
	      top: -1
	    }
	  };
	}
	
	var YearButton = function (_Component) {
	  (0, _inherits3.default)(YearButton, _Component);
	
	  function YearButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, YearButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = YearButton.__proto__ || (0, _getPrototypeOf2.default)(YearButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ hover: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ hover: false });
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event, _this.props.year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(YearButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          year = _props.year,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onTouchTap', 'selected', 'year']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchTap: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          children
	        )
	      );
	    }
	  }]);
	  return YearButton;
	}(_react.Component);
	
	YearButton.defaultProps = {
	  selected: false
	};
	YearButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? YearButton.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  onTouchTap: _react.PropTypes.func,
	  selected: _react.PropTypes.bool,
	  year: _react.PropTypes.number.isRequired
	} : void 0;
	exports.default = YearButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DatePicker = __webpack_require__(967);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DatePicker2.default;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(87);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(412);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RenderToLayer = __webpack_require__(413);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _reactAddonsTransitionGroup = __webpack_require__(166);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransitionItem = function (_Component) {
	  (0, _inherits3.default)(TransitionItem, _Component);
	
	  function TransitionItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TransitionItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionItem.__proto__ || (0, _getPrototypeOf2.default)(TransitionItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      style: {}
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TransitionItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimeout);
	      clearTimeout(this.leaveTimeout);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.componentWillAppear(callback);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      var spacing = this.context.muiTheme.baseTheme.spacing;
	
	      this.setState({
	        style: {
	          opacity: 1,
	          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
	        }
	      });
	
	      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({
	        style: {
	          opacity: 0,
	          transform: 'translate(0, 0)'
	        }
	      });
	
	      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
	        children
	      );
	    }
	  }]);
	  return TransitionItem;
	}(_react.Component);
	
	TransitionItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TransitionItem.propTypes = {
	  children: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	
	
	function getStyles(props, context) {
	  var autoScrollBodyContent = props.autoScrollBodyContent,
	      open = props.open;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      spacing = _context$muiTheme$bas.spacing,
	      palette = _context$muiTheme$bas.palette,
	      dialog = _context$muiTheme.dialog,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var gutter = spacing.desktopGutter;
	  var borderScroll = '1px solid ' + palette.borderColor;
	
	  return {
	    root: {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      zIndex: zIndex.dialog,
	      top: 0,
	      left: open ? 0 : -10000,
	      width: '100%',
	      height: '100%',
	      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	    },
	    content: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: zIndex.dialog
	    },
	    actionsContainer: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      padding: 8,
	      width: '100%',
	      textAlign: 'right',
	      marginTop: autoScrollBodyContent ? -1 : 0,
	      borderTop: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    overlay: {
	      zIndex: zIndex.dialogOverlay
	    },
	    title: {
	      margin: 0,
	      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
	      color: palette.textColor,
	      fontSize: dialog.titleFontSize,
	      lineHeight: '32px',
	      fontWeight: 400,
	      marginBottom: autoScrollBodyContent ? -1 : 0,
	      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    body: {
	      fontSize: dialog.bodyFontSize,
	      color: dialog.bodyColor,
	      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
	      boxSizing: 'border-box',
	      overflowY: autoScrollBodyContent ? 'auto' : 'hidden'
	    }
	  };
	}
	
	var DialogInline = function (_Component2) {
	  (0, _inherits3.default)(DialogInline, _Component2);
	
	  function DialogInline() {
	    var _ref2;
	
	    var _temp2, _this2, _ret2;
	
	    (0, _classCallCheck3.default)(this, DialogInline);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DialogInline.__proto__ || (0, _getPrototypeOf2.default)(DialogInline)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleTouchTapOverlay = function () {
	      _this2.requestClose(false);
	    }, _this2.handleKeyUp = function (event) {
	      if ((0, _keycode2.default)(event) === 'esc') {
	        _this2.requestClose(false);
	      }
	    }, _this2.handleResize = function () {
	      _this2.positionDialog();
	    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
	  }
	
	  (0, _createClass3.default)(DialogInline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'positionDialog',
	    value: function positionDialog() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          autoDetectWindowHeight = _props2.autoDetectWindowHeight,
	          autoScrollBodyContent = _props2.autoScrollBodyContent,
	          bodyStyle = _props2.bodyStyle,
	          open = _props2.open,
	          repositionOnUpdate = _props2.repositionOnUpdate,
	          title = _props2.title;
	
	
	      if (!open) {
	        return;
	      }
	
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = _reactDom2.default.findDOMNode(this);
	      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	      var minPaddingTop = 16;
	
	      // Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      // Vertically center the dialog window, but make sure it doesn't
	      // transition to that position.
	      if (repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (autoDetectWindowHeight || autoScrollBodyContent) {
	        var styles = getStyles(this.props, this.context);
	        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	        var maxDialogContentHeight = clientHeight - 2 * 64;
	
	        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	        if (_react2.default.Children.count(actions)) {
	          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	        }
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(buttonClicked) {
	      if (!buttonClicked && this.props.modal) {
	        return;
	      }
	
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(!!buttonClicked);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          actionsContainerClassName = _props3.actionsContainerClassName,
	          actionsContainerStyle = _props3.actionsContainerStyle,
	          bodyClassName = _props3.bodyClassName,
	          bodyStyle = _props3.bodyStyle,
	          children = _props3.children,
	          className = _props3.className,
	          contentClassName = _props3.contentClassName,
	          contentStyle = _props3.contentStyle,
	          overlayClassName = _props3.overlayClassName,
	          overlayStyle = _props3.overlayStyle,
	          open = _props3.open,
	          titleClassName = _props3.titleClassName,
	          titleStyle = _props3.titleStyle,
	          title = _props3.title,
	          style = _props3.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      styles.root = (0, _simpleAssign2.default)(styles.root, style);
	      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
	      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
	      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);
	
	      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
	        'div',
	        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
	        _react2.default.Children.toArray(actions)
	      );
	
	      var titleElement = title;
	      if (_react2.default.isValidElement(title)) {
	        titleElement = _react2.default.cloneElement(title, {
	          className: title.props.className || titleClassName,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
	        });
	      } else if (typeof title === 'string') {
	        titleElement = _react2.default.createElement(
	          'h3',
	          { className: titleClassName, style: prepareStyles(styles.title) },
	          title
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles(styles.root) },
	        open && _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyUp: this.handleKeyUp,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          {
	            component: 'div',
	            ref: 'dialogWindow',
	            transitionAppear: true,
	            transitionAppearTimeout: 450,
	            transitionEnter: true,
	            transitionEnterTimeout: 450
	          },
	          open && _react2.default.createElement(
	            TransitionItem,
	            {
	              className: contentClassName,
	              style: styles.content
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              { zDepth: 4 },
	              titleElement,
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: 'dialogContent',
	                  className: bodyClassName,
	                  style: prepareStyles(styles.body)
	                },
	                children
	              ),
	              actionsContainer
	            )
	          )
	        ),
	        _react2.default.createElement(_Overlay2.default, {
	          show: open,
	          className: overlayClassName,
	          style: styles.overlay,
	          onTouchTap: this.handleTouchTapOverlay
	        })
	      );
	    }
	  }]);
	  return DialogInline;
	}(_react.Component);
	
	DialogInline.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? DialogInline.propTypes = {
	  actions: _react.PropTypes.node,
	  actionsContainerClassName: _react.PropTypes.string,
	  actionsContainerStyle: _react.PropTypes.object,
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  autoScrollBodyContent: _react.PropTypes.bool,
	  bodyClassName: _react.PropTypes.string,
	  bodyStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  contentClassName: _react.PropTypes.string,
	  contentStyle: _react.PropTypes.object,
	  modal: _react.PropTypes.bool,
	  onRequestClose: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  overlayClassName: _react.PropTypes.string,
	  overlayStyle: _react.PropTypes.object,
	  repositionOnUpdate: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  title: _react.PropTypes.node,
	  titleClassName: _react.PropTypes.string,
	  titleStyle: _react.PropTypes.object
	} : void 0;
	
	var Dialog = function (_Component3) {
	  (0, _inherits3.default)(Dialog, _Component3);
	
	  function Dialog() {
	    var _ref3;
	
	    var _temp3, _this3, _ret3;
	
	    (0, _classCallCheck3.default)(this, Dialog);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref3, [this].concat(args))), _this3), _this3.renderLayer = function () {
	      return _react2.default.createElement(DialogInline, _this3.props);
	    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
	  }
	
	  (0, _createClass3.default)(Dialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	    }
	  }]);
	  return Dialog;
	}(_react.Component);
	
	Dialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	Dialog.defaultProps = {
	  autoDetectWindowHeight: true,
	  autoScrollBodyContent: false,
	  modal: false,
	  repositionOnUpdate: true
	};
	process.env.NODE_ENV !== "production" ? Dialog.propTypes = {
	  /**
	   * Action buttons to display below the Dialog content (`children`).
	   * This property accepts either a React element, or an array of React elements.
	   */
	  actions: _react.PropTypes.node,
	  /**
	   * The `className` to add to the actions container's root element.
	   */
	  actionsContainerClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the actions container's root element.
	   */
	  actionsContainerStyle: _react.PropTypes.object,
	  /**
	   * If set to true, the height of the `Dialog` will be auto detected. A max height
	   * will be enforced so that the content does not extend beyond the viewport.
	   */
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  /**
	   * If set to true, the body content of the `Dialog` will be scrollable.
	   */
	  autoScrollBodyContent: _react.PropTypes.bool,
	  /**
	   * The `className` to add to the content's root element under the title.
	   */
	  bodyClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content's root element under the title.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * The contents of the `Dialog`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The `className` to add to the content container.
	   */
	  contentClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content container.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * Force the user to use one of the actions in the `Dialog`.
	   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	   */
	  modal: _react.PropTypes.bool,
	  /**
	   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	   *
	   * @param {bool} buttonClicked Determines whether a button click triggered this request.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * Controls whether the Dialog is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	   */
	  repositionOnUpdate: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * The `className` to add to the title's root container element.
	   */
	  titleClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the title's root container element.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = Dialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider(props, context) {
	  var inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      prepareStyles = _context$muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }));
	};
	
	Divider.muiName = 'Divider';
	
	process.env.NODE_ENV !== "production" ? Divider.propTypes = {
	  /**
	   * If true, the `Divider` will be indented.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	Divider.defaultProps = {
	  inset: false
	};
	
	Divider.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = Divider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(87);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _autoPrefix = __webpack_require__(114);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(412);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openNavEventHandler = null;
	
	var Drawer = function (_Component) {
	  (0, _inherits3.default)(Drawer, _Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapOverlay = function (event) {
	      event.preventDefault();
	      _this.close('clickaway');
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
	        _this.close('escape');
	      }
	    }, _this.onBodyTouchStart = function (event) {
	      var swipeAreaWidth = _this.props.swipeAreaWidth;
	
	      var touchStartX = event.touches[0].pageX;
	      var touchStartY = event.touches[0].pageY;
	
	      // Open only if swiping from far left (or right) while closed
	      if (swipeAreaWidth !== null && !_this.state.open) {
	        if (_this.props.openSecondary) {
	          // If openSecondary is true calculate from the far right
	          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
	        } else {
	          // If openSecondary is false calculate from the far left
	          if (touchStartX > swipeAreaWidth) return;
	        }
	      }
	
	      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
	        return;
	      }
	
	      _this.maybeSwiping = true;
	      _this.touchStartX = touchStartX;
	      _this.touchStartY = touchStartY;
	
	      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _this.onBodyTouchMove = function (event) {
	      var currentX = event.touches[0].pageX;
	      var currentY = event.touches[0].pageY;
	
	      if (_this.state.swiping) {
	        event.preventDefault();
	        _this.setPosition(_this.getTranslateX(currentX));
	      } else if (_this.maybeSwiping) {
	        var dXAbs = Math.abs(currentX - _this.touchStartX);
	        var dYAbs = Math.abs(currentY - _this.touchStartY);
	        // If the user has moved his thumb ten pixels in either direction,
	        // we can safely make an assumption about whether he was intending
	        // to swipe or scroll.
	        var threshold = 10;
	
	        if (dXAbs > threshold && dYAbs <= threshold) {
	          _this.swipeStartX = currentX;
	          _this.setState({
	            swiping: _this.state.open ? 'closing' : 'opening'
	          });
	          _this.setPosition(_this.getTranslateX(currentX));
	        } else if (dXAbs <= threshold && dYAbs > threshold) {
	          _this.onBodyTouchEnd();
	        }
	      }
	    }, _this.onBodyTouchEnd = function (event) {
	      if (_this.state.swiping) {
	        var currentX = event.changedTouches[0].pageX;
	        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();
	
	        _this.maybeSwiping = false;
	        var swiping = _this.state.swiping;
	        _this.setState({
	          swiping: null
	        });
	
	        // We have to open or close after setting swiping to null,
	        // because only then CSS transition is enabled.
	        if (translateRatio > 0.5) {
	          if (swiping === 'opening') {
	            _this.setPosition(_this.getMaxTranslateX());
	          } else {
	            _this.close('swipe');
	          }
	        } else {
	          if (swiping === 'opening') {
	            _this.open('swipe');
	          } else {
	            _this.setPosition(0);
	          }
	        }
	      } else {
	        _this.maybeSwiping = false;
	      }
	
	      document.body.removeEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.removeEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.removeEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.maybeSwiping = false;
	      this.touchStartX = null;
	      this.touchStartY = null;
	      this.swipeStartX = null;
	
	      this.setState({
	        open: this.props.open !== null ? this.props.open : this.props.docked,
	        swiping: null
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If controlled then the open prop takes precedence.
	      if (nextProps.open !== null) {
	        this.setState({
	          open: nextProps.open
	        });
	        // Otherwise, if docked is changed, change the open state for when uncontrolled.
	      } else if (this.props.docked !== nextProps.docked) {
	        this.setState({
	          open: nextProps.docked
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.disableSwipeHandling();
	    }
	  }, {
	    key: 'getStyles',
	    value: function getStyles() {
	      var muiTheme = this.context.muiTheme;
	      var theme = muiTheme.drawer;
	
	      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());
	
	      var styles = {
	        root: {
	          height: '100%',
	          width: this.props.width || theme.width,
	          position: 'fixed',
	          zIndex: muiTheme.zIndex.drawer,
	          left: 0,
	          top: 0,
	          transform: 'translate(' + x + 'px, 0)',
	          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
	          backgroundColor: theme.color,
	          overflow: 'auto',
	          WebkitOverflowScrolling: 'touch' },
	        overlay: {
	          zIndex: muiTheme.zIndex.drawerOverlay,
	          pointerEvents: this.state.open ? 'auto' : 'none' },
	        rootWhenOpenRight: {
	          left: 'auto',
	          right: 0
	        }
	      };
	
	      return styles;
	    }
	  }, {
	    key: 'shouldShow',
	    value: function shouldShow() {
	      return this.state.open || !!this.state.swiping; // component is swiping
	    }
	  }, {
	    key: 'close',
	    value: function close(reason) {
	      if (this.props.open === null) this.setState({ open: false });
	      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
	      return this;
	    }
	  }, {
	    key: 'open',
	    value: function open(reason) {
	      if (this.props.open === null) this.setState({ open: true });
	      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
	      return this;
	    }
	  }, {
	    key: 'getMaxTranslateX',
	    value: function getMaxTranslateX() {
	      var width = this.props.width || this.context.muiTheme.drawer.width;
	      return width + 10;
	    }
	  }, {
	    key: 'getTranslateMultiplier',
	    value: function getTranslateMultiplier() {
	      return this.props.openSecondary ? 1 : -1;
	    }
	  }, {
	    key: 'enableSwipeHandling',
	    value: function enableSwipeHandling() {
	      if (!this.props.docked) {
	        document.body.addEventListener('touchstart', this.onBodyTouchStart);
	        if (!openNavEventHandler) {
	          openNavEventHandler = this.onBodyTouchStart;
	        }
	      } else {
	        this.disableSwipeHandling();
	      }
	    }
	  }, {
	    key: 'disableSwipeHandling',
	    value: function disableSwipeHandling() {
	      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
	      if (openNavEventHandler === this.onBodyTouchStart) {
	        openNavEventHandler = null;
	      }
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(translateX) {
	      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
	      var transformCSS = 'translate(' + this.getTranslateMultiplier() * translateX + 'px, 0)';
	      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
	      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
	    }
	  }, {
	    key: 'getTranslateX',
	    value: function getTranslateX(currentX) {
	      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          containerClassName = _props.containerClassName,
	          containerStyle = _props.containerStyle,
	          docked = _props.docked,
	          openSecondary = _props.openSecondary,
	          overlayClassName = _props.overlayClassName,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = this.getStyles();
	
	      var overlay = void 0;
	      if (!docked) {
	        overlay = _react2.default.createElement(_Overlay2.default, {
	          ref: 'overlay',
	          show: this.shouldShow(),
	          className: overlayClassName,
	          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
	          transitionEnabled: !this.state.swiping,
	          onTouchTap: this.handleTouchTapOverlay
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          style: style
	        },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        overlay,
	        _react2.default.createElement(
	          _Paper2.default,
	          {
	            ref: 'clickAwayableElement',
	            zDepth: zDepth,
	            rounded: false,
	            transitionEnabled: !this.state.swiping,
	            className: containerClassName,
	            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return Drawer;
	}(_react.Component);
	
	Drawer.defaultProps = {
	  disableSwipeToOpen: false,
	  docked: true,
	  open: null,
	  openSecondary: false,
	  swipeAreaWidth: 30,
	  width: null,
	  zDepth: 2
	};
	Drawer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Drawer.propTypes = {
	  /**
	   * The contents of the `Drawer`
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The CSS class name of the container element.
	   */
	  containerClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _react.PropTypes.object,
	  /**
	   * If true, swiping sideways when the `Drawer` is closed will not open it.
	   */
	  disableSwipeToOpen: _react.PropTypes.bool,
	  /**
	   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
	   * clicking on a menu item will not close the `Drawer`.
	   */
	  docked: _react.PropTypes.bool,
	  /**
	   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
	   *
	   * @param {boolean} open If true, the `Drawer` was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
	   * 'escape' (on escape key press), and 'swipe' for close requests.
	   */
	  onRequestChange: _react.PropTypes.func,
	  /**
	   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
	   * into a controlled component.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * If true, the `Drawer` is positioned to open from the opposite side.
	   */
	  openSecondary: _react.PropTypes.bool,
	  /**
	   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The width of the left most (or right most) area in pixels where the `Drawer` can be
	   * swiped open from. Setting this to `null` spans that area to the entire page
	   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
	   * swipeable `Tabs`: use at your own risk).
	   */
	  swipeAreaWidth: _react.PropTypes.number,
	  /**
	   * The width of the `Drawer` in pixels. Defaults to using the values from theme.
	   */
	  width: _react.PropTypes.number,
	  /**
	   * The zDepth of the `Drawer`.
	   */
	  zDepth: _propTypes2.default.zDepth
	
	} : void 0;
	exports.default = Drawer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Drawer = __webpack_require__(974);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer2.default;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(1052);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(194);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(1040);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(136);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(276);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _events = __webpack_require__(197);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _IconButton = __webpack_require__(135);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var anchorOrigin = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'not-allowed' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: accentColor,
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
	    },
	    iconChildren: {
	      fill: 'inherit'
	    },
	    label: {
	      color: disabled ? palette.disabledColor : palette.textColor,
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      overflow: 'hidden',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
	      textOverflow: 'ellipsis',
	      top: 0,
	      whiteSpace: 'nowrap'
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px ' + accentColor,
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = function (_Component) {
	  (0, _inherits3.default)(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleTouchTapControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.rootNode
	        });
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.close(false);
	    }, _this.handleEscKeyDownMenu = function () {
	      _this.close(true);
	    }, _this.handleKeyDown = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'up':
	        case 'down':
	        case 'space':
	        case 'enter':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            anchorEl: _this.rootNode
	          });
	          break;
	      }
	    }, _this.handleItemTouchTap = function (event, child, index) {
	      event.persist();
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onChange) {
	          _this.props.onChange(event, index, child.props.value);
	        }
	
	        _this.close(_events2.default.isKeyboard(event));
	      });
	    }, _this.close = function (isKeyboard) {
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	
	        if (isKeyboard) {
	          var dropArrow = _this.arrowNode;
	          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
	          dropNode.focus();
	          dropArrow.setKeyboardFocus(true);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  (0, _createClass3.default)(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.rootNode
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	  }, {
	    key: 'getInputNode',
	
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	    value: function getInputNode() {
	      var _this3 = this;
	
	      var rootNode = this.rootNode;
	
	      rootNode.focus = function () {
	        if (!_this3.props.disabled) {
	          _this3.setState({
	            open: !_this3.state.open,
	            anchorEl: _this3.rootNode
	          });
	        }
	      };
	
	      return rootNode;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.rootNode;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          animation = _props.animation,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          className = _props.className,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyleProp = _props.menuStyle,
	          onClose = _props.onClose,
	          openImmediately = _props.openImmediately,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          style = _props.style,
	          underlineStyle = _props.underlineStyle,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'children', 'className', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value']);
	      var _state = this.state,
	          anchorEl = _state.anchorEl,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      _react2.default.Children.forEach(children, function (child) {
	        if (child && value === child.props.value) {
	          // This will need to be improved (in case primaryText is a node)
	          displayValue = child.props.label || child.props.primaryText;
	        }
	      });
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = (0, _simpleAssign2.default)({
	          width: anchorEl.clientWidth
	        }, menuStyleProp);
	      } else {
	        menuStyle = menuStyleProp;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onTouchTap: this.handleTouchTapControl },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
	            displayValue
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              tabIndex: this.props.disabled ? -1 : undefined,
	              onKeyDown: this.handleKeyDown,
	              ref: function ref(node) {
	                _this4.arrowNode = node;
	              },
	              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
	              iconStyle: styles.iconChildren
	            },
	            _react2.default.createElement(_arrowDropDown2.default, null)
	          ),
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
	        ),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            anchorEl: anchorEl,
	            animation: animation || _PopoverAnimationVertical2.default,
	            open: open,
	            animated: animated,
	            onRequestClose: this.handleRequestCloseMenu
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              onEscKeyDown: this.handleEscKeyDownMenu,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemTouchTap: this.handleItemTouchTap,
	              menuItemStyle: menuItemStyle,
	              selectedMenuItemStyle: selectedMenuItemStyle
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return DropDownMenu;
	}(_react.Component);
	
	DropDownMenu.muiName = 'DropDownMenu';
	DropDownMenu.defaultProps = {
	  animated: true,
	  autoWidth: true,
	  disabled: false,
	  openImmediately: false,
	  maxHeight: 500
	};
	DropDownMenu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? DropDownMenu.propTypes = {
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} payload The `value` prop of the clicked menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _react.PropTypes.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value that is currently selected.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = DropDownMenu;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _childUtils = __webpack_require__(165);
	
	var _colorManipulator = __webpack_require__(85);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(978);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (process.env.NODE_ENV !== 'production') {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  (0, _inherits3.default)(FlatButton, _Component);
	
	  function FlatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          disabled = _props.disabled,
	          hoverColor = _props.hoverColor,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          primary = _props.primary,
	          rippleColor = _props.rippleColor,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'disabled', 'hoverColor', 'backgroundColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	      var _context$muiTheme = this.context.muiTheme,
	          _context$muiTheme$but = _context$muiTheme.button,
	          buttonHeight = _context$muiTheme$but.height,
	          buttonMinWidth = _context$muiTheme$but.minWidth,
	          buttonTextTransform = _context$muiTheme$but.textTransform,
	          _context$muiTheme$fla = _context$muiTheme.flatButton,
	          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
	          buttonColor = _context$muiTheme$fla.color,
	          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
	          fontSize = _context$muiTheme$fla.fontSize,
	          fontWeight = _context$muiTheme$fla.fontWeight,
	          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
	          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
	          textColor = _context$muiTheme$fla.textColor,
	          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
	          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: 2,
	        userSelect: 'none',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        var iconStyles = (0, _simpleAssign2.default)({
	          verticalAlign: 'middle',
	          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	          marginRight: label && labelPosition === 'before' ? 12 : 0
	        }, icon.props.style);
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: iconStyles
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.defaultProps = {
	  disabled: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? FlatButton.propTypes = {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _react.PropTypes.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FlatButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  (0, _inherits3.default)(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    (0, _classCallCheck3.default)(this, FlatButtonLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? FlatButtonLabel.propTypes = {
	  label: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FlatButtonLabel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(85);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(271);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _childUtils = __webpack_require__(165);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var floatingActionButton = context.muiTheme.floatingActionButton;
	
	
	  var backgroundColor = props.backgroundColor || floatingActionButton.color;
	  var iconColor = floatingActionButton.iconColor;
	
	  if (props.disabled) {
	    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
	    iconColor = floatingActionButton.disabledTextColor;
	  } else if (props.secondary) {
	    backgroundColor = floatingActionButton.secondaryColor;
	    iconColor = floatingActionButton.secondaryIconColor;
	  }
	
	  return {
	    root: {
	      transition: _transitions2.default.easeOut(),
	      display: 'inline-block',
	      backgroundColor: 'transparent'
	    },
	    container: {
	      backgroundColor: backgroundColor,
	      transition: _transitions2.default.easeOut(),
	      height: floatingActionButton.buttonSize,
	      width: floatingActionButton.buttonSize,
	      padding: 0,
	      overflow: 'hidden',
	      borderRadius: '50%',
	      textAlign: 'center',
	      verticalAlign: 'bottom'
	    },
	    containerWhenMini: {
	      height: floatingActionButton.miniSize,
	      width: floatingActionButton.miniSize
	    },
	    overlay: {
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    overlayWhenHovered: {
	      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
	    },
	    icon: {
	      height: floatingActionButton.buttonSize,
	      lineHeight: floatingActionButton.buttonSize + 'px',
	      fill: iconColor,
	      color: iconColor
	    },
	    iconWhenMini: {
	      height: floatingActionButton.miniSize,
	      lineHeight: floatingActionButton.miniSize + 'px'
	    }
	  };
	}
	
	var FloatingActionButton = function (_Component) {
	  (0, _inherits3.default)(FloatingActionButton, _Component);
	
	  function FloatingActionButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FloatingActionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloatingActionButton.__proto__ || (0, _getPrototypeOf2.default)(FloatingActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touch: false,
	      zDepth: undefined
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	      }
	      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ zDepth: _this.props.zDepth });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.container.isKeyboardFocused()) {
	        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth + 1
	      });
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth
	      });
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
	      } else if (!_this.state.hovered) {
	        _this.setState({ zDepth: _this.props.zDepth });
	        _this.refs.overlay.style.backgroundColor = 'transparent';
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FloatingActionButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        zDepth: this.props.disabled ? 0 : this.props.zDepth
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'Material-UI: You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextState = {};
	
	      if (nextProps.disabled !== this.props.disabled) {
	        nextState.zDepth = nextProps.disabled ? 0 : this.props.zDepth;
	      }
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          className = _props.className,
	          childrenProp = _props.children,
	          disabled = _props.disabled,
	          mini = _props.mini,
	          secondary = _props.secondary,
	          iconStyle = _props.iconStyle,
	          iconClassName = _props.iconClassName,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'className', 'children', 'disabled', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (iconClassName) {
	        iconElement = _react2.default.createElement(_FontIcon2.default, {
	          className: iconClassName,
	          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
	        });
	      }
	
	      var children = void 0;
	
	      if (childrenProp) {
	        children = (0, _childUtils.extendChildren)(childrenProp, function (child) {
	          return {
	            style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle, child.props.style)
	          };
	        });
	      }
	
	      var buttonEventHandlers = disabled ? null : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth,
	          circle: true
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
	            focusRippleColor: styles.icon.color,
	            touchRippleColor: styles.icon.color
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
	            },
	            iconElement,
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return FloatingActionButton;
	}(_react.Component);
	
	FloatingActionButton.defaultProps = {
	  disabled: false,
	  mini: false,
	  secondary: false,
	  zDepth: 2
	};
	FloatingActionButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? FloatingActionButton.propTypes = {
	  /**
	   * This value will override the default background color for the button.
	   * However it will not override the default disabled background color.
	   * This has to be set separately using the disabledColor attribute.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what displayed inside the floating action button; for example, a SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * This value will override the default background color for the button when it is disabled.
	   */
	  disabledColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The icon within the FloatingActionButton is a FontIcon component.
	   * This property is the classname of the icon to be displayed inside the button.
	   * An alternative to adding an iconClassName would be to manually insert a
	   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * This is the equivalent to iconClassName except that it is used for
	   * overriding the inline-styles of the FontIcon component.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will be a small floating action button.
	   */
	  mini: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, the button will use the secondary button colors.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The zDepth of the underlying `Paper` component.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = FloatingActionButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FloatingActionButton = __webpack_require__(979);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FloatingActionButton2.default;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var color = props.color,
	      hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  (0, _inherits3.default)(FontIcon, _Component);
	
	  function FontIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hoverColor = _props.hoverColor,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? FontIcon.propTypes = {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FontIcon;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    root: {
	      display: 'flex',
	      flexWrap: 'wrap',
	      margin: -props.padding / 2
	    },
	    item: {
	      boxSizing: 'border-box',
	      padding: props.padding / 2
	    }
	  };
	}
	
	var GridList = function (_Component) {
	  (0, _inherits3.default)(GridList, _Component);
	
	  function GridList() {
	    (0, _classCallCheck3.default)(this, GridList);
	    return (0, _possibleConstructorReturn3.default)(this, (GridList.__proto__ || (0, _getPrototypeOf2.default)(GridList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cols = _props.cols,
	          padding = _props.padding,
	          cellHeight = _props.cellHeight,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var wrappedChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (_react2.default.isValidElement(currentChild) && currentChild.type.muiName === 'Subheader') {
	          return currentChild;
	        }
	        var childCols = currentChild.props.cols || 1;
	        var childRows = currentChild.props.rows || 1;
	        var itemStyle = (0, _simpleAssign2.default)({}, styles.item, {
	          width: 100 / cols * childCols + '%',
	          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + padding
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { style: prepareStyles(itemStyle) },
	          currentChild
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles(mergedRootStyles) }, other),
	        wrappedChildren
	      );
	    }
	  }]);
	  return GridList;
	}(_react.Component);
	
	GridList.defaultProps = {
	  cols: 2,
	  padding: 4,
	  cellHeight: 180
	};
	GridList.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? GridList.propTypes = {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Number of columns.
	   */
	  cols: _react.PropTypes.number,
	  /**
	   * Number of px for the padding/spacing between items.
	   */
	  padding: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = GridList;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GridTile = exports.GridList = undefined;
	
	var _GridList2 = __webpack_require__(982);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(395);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.default = _GridList3.default;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(271);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(414);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'not-allowed'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  (0, _inherits3.default)(IconButton, _Component);
	
	  function IconButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      // Not to be confonded with the touch property.
	      // This state is to determined if it's a mobile device.
	      touch: false,
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.button.isKeyboardFocused()) {
	        _this.hideTooltip();
	      }
	      _this.setState({ hovered: false });
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus,
	          onBlur = _this$props.onBlur,
	          onKeyboardFocus = _this$props.onKeyboardFocus;
	
	      if (isKeyboardFocused && !disabled) {
	        _this.showTooltip();
	        if (onFocus) {
	          onFocus(event);
	        }
	      } else {
	        _this.hideTooltip();
	        if (onBlur) {
	          onBlur(event);
	        }
	      }
	
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      if (onKeyboardFocus) {
	        onKeyboardFocus(event, isKeyboardFocused);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({ hovered: false });
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          disabled = _props.disabled,
	          hoveredStyle = _props.hoveredStyle,
	          disableTouchRipple = _props.disableTouchRipple,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipPositionProp = _props.tooltipPosition,
	          tooltipStyles = _props.tooltipStyles,
	          touch = _props.touch,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor,
	            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);
	
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          ref: function ref(_ref2) {
	            return _this2.button = _ref2;
	          }
	        }, other, {
	          centerRipple: true,
	          disabled: disabled,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? IconButton.propTypes = {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _react.PropTypes.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element when the component is hovered.
	   */
	  hoveredStyle: _react.PropTypes.object,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the icon element.
	   * Note: you can specify iconHoverColor as a String inside this object.
	   */
	  iconStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseOut: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _react.PropTypes.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes2.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _react.PropTypes.object,
	  /**
	   * If true, increase the tooltip element's size. Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _react.PropTypes.bool
	} : void 0;
	exports.default = IconButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(197);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Menu = __webpack_require__(194);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Popover = __webpack_require__(136);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMenu = function (_Component) {
	  (0, _inherits3.default)(IconMenu, _Component);
	
	  function IconMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    }, _this.handleItemTouchTap = function (event, child) {
	      if (_this.props.touchTapCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
	        (function () {
	          var isKeyboard = _events2.default.isKeyboard(event);
	          _this.timerCloseId = setTimeout(function () {
	            _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
	          }, _this.props.touchTapCloseDelay);
	        })();
	      }
	
	      _this.props.onItemTouchTap(event, child);
	    }, _this.handleRequestClose = function (reason) {
	      _this.close(reason);
	    }, _this.handleEscKeyDownMenu = function (event) {
	      _this.close('escape', event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open != null) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: this.refs.iconMenuContainer
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerCloseId);
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.state.open;
	    }
	  }, {
	    key: 'close',
	    value: function close(reason, isKeyboard) {
	      var _this2 = this;
	
	      if (!this.state.open) {
	        return;
	      }
	
	      if (this.props.open !== null) {
	        this.props.onRequestChange(false, reason);
	      } else {
	        this.setState({ open: false }, function () {
	          // Set focus on the icon button when the menu close
	          if (isKeyboard) {
	            var iconButton = _this2.refs.iconButton;
	            _reactDom2.default.findDOMNode(iconButton).focus();
	            iconButton.setKeyboardFocus();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open(reason, event) {
	      if (this.props.open !== null) {
	        this.props.onRequestChange(true, reason);
	
	        return this.setState({
	          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	          anchorEl: event.currentTarget
	        });
	      }
	
	      this.setState({
	        open: true,
	        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	        anchorEl: event.currentTarget
	      });
	
	      event.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          className = _props.className,
	          animated = _props.animated,
	          animation = _props.animation,
	          iconButtonElement = _props.iconButtonElement,
	          iconStyle = _props.iconStyle,
	          onItemTouchTap = _props.onItemTouchTap,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseUp = _props.onMouseUp,
	          onRequestChange = _props.onRequestChange,
	          onTouchTap = _props.onTouchTap,
	          listStyle = _props.listStyle,
	          menuStyle = _props.menuStyle,
	          style = _props.style,
	          targetOrigin = _props.targetOrigin,
	          touchTapCloseDelay = _props.touchTapCloseDelay,
	          useLayerForClickAway = _props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onTouchTap', 'listStyle', 'menuStyle', 'style', 'targetOrigin', 'touchTapCloseDelay', 'useLayerForClickAway']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl;
	
	
	      var styles = {
	        root: {
	          display: 'inline-block',
	          position: 'relative'
	        },
	        menu: {
	          position: 'relative'
	        }
	      };
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);
	
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(iconButtonElement.type.muiName !== 'SvgIcon', 'Material-UI: You shoud not provide an <SvgIcon /> to the \'iconButtonElement\' property of <IconMenu />.\nYou should wrapped it with an <IconButton />.') : void 0;
	
	      var iconButtonProps = {
	        onKeyboardFocus: onKeyboardFocus,
	        onTouchTap: function onTouchTap(event) {
	          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
	          if (iconButtonElement.props.onTouchTap) {
	            iconButtonElement.props.onTouchTap(event);
	          }
	        },
	        ref: 'iconButton'
	      };
	      if (iconStyle || iconButtonElement.props.iconStyle) {
	        iconButtonProps.iconStyle = iconStyle ? (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle) : iconButtonElement.props.iconStyle;
	      }
	      var iconButton = _react2.default.cloneElement(iconButtonElement, iconButtonProps);
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, other, {
	          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	          onEscKeyDown: this.handleEscKeyDownMenu,
	          onItemTouchTap: this.handleItemTouchTap,
	          style: mergedMenuStyles,
	          listStyle: listStyle
	        }),
	        this.props.children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'iconMenuContainer',
	          className: className,
	          onMouseDown: onMouseDown,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          onMouseUp: onMouseUp,
	          onTouchTap: onTouchTap,
	          style: prepareStyles(mergedRootStyles)
	        },
	        iconButton,
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            childContextTypes: this.constructor.childContextTypes,
	            useLayerForClickAway: useLayerForClickAway,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation,
	            context: this.context
	          },
	          menu
	        )
	      );
	    }
	  }]);
	  return IconMenu;
	}(_react.Component);
	
	IconMenu.muiName = 'IconMenu';
	IconMenu.defaultProps = {
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  animated: true,
	  multiple: false,
	  open: null,
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseUp: function onMouseUp() {},
	  onRequestChange: function onRequestChange() {},
	  onTouchTap: function onTouchTap() {},
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  touchTapCloseDelay: 200,
	  useLayerForClickAway: false
	};
	IconMenu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? IconMenu.propTypes = {
	  /**
	   * This is the point on the icon where the menu
	   * `targetOrigin` will attach.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * Should be used to pass `MenuItem` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * This is the `IconButton` to render. This button will open the menu.
	   */
	  iconButtonElement: _react.PropTypes.element.isRequired,
	  /**
	   * Override the inline-styles of the underlying icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the menu element.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * If true, the value can an be array and allow the menu to be a multi-select.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item is selected with a touch-tap.
	   *
	   * @param {object} event TouchTap event targeting the selected menu item element.
	   * @param {object} child The selected element.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
	   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `open` state of the menu is requested to be changed.
	   *
	   * @param {boolean} open If true, the menu was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
	   * for close requests.
	   */
	  onRequestChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `IconButton` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the `IconButton` element.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, the `IconMenu` is opened.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the menu which will stick to the menu
	   * origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * Sets the delay in milliseconds before closing the
	   * menu when an item is clicked.
	   * If set to 0 then the auto close functionality
	   * will be disabled.
	   */
	  touchTapCloseDelay: _react.PropTypes.number,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying elements.
	   */
	  useLayerForClickAway: _react.PropTypes.bool
	} : void 0;
	exports.default = IconMenu;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.IconMenu = undefined;
	
	var _IconMenu2 = __webpack_require__(985);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _MenuItem2 = __webpack_require__(274);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IconMenu = _IconMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _IconMenu3.default;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  var rangeValue = max - min;
	  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
	  return relValue * 100;
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      height: 4,
	      display: 'block',
	      width: '100%',
	      backgroundColor: palette.primary3Color,
	      borderRadius: 2,
	      margin: 0,
	      overflow: 'hidden'
	    },
	    bar: {
	      height: '100%'
	    },
	    barFragment1: {},
	    barFragment2: {}
	  };
	
	  if (props.mode === 'indeterminate') {
	    styles.barFragment1 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
	    };
	
	    styles.barFragment2 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
	    };
	  } else {
	    styles.bar.backgroundColor = props.color || palette.primary1Color;
	    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
	    styles.bar.width = getRelativeValue(value, min, max) + '%';
	  }
	
	  return styles;
	}
	
	var LinearProgress = function (_Component) {
	  (0, _inherits3.default)(LinearProgress, _Component);
	
	  function LinearProgress() {
	    (0, _classCallCheck3.default)(this, LinearProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (LinearProgress.__proto__ || (0, _getPrototypeOf2.default)(LinearProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LinearProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.timers = {};
	
	      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]]);
	
	      this.timers.bar2 = setTimeout(function () {
	        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]]);
	      }, 850);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timers.bar1);
	      clearTimeout(this.timers.bar2);
	    }
	  }, {
	    key: 'barUpdate',
	    value: function barUpdate(id, step, barElement, stepValues) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step = step || 0;
	      step %= 4;
	
	      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
	      var left = this.context.muiTheme.isRtl ? 'right' : 'left';
	
	      if (step === 0) {
	        barElement.style[left] = stepValues[0][0] + '%';
	        barElement.style[right] = stepValues[0][1] + '%';
	      } else if (step === 1) {
	        barElement.style.transitionDuration = '840ms';
	      } else if (step === 2) {
	        barElement.style[left] = stepValues[1][0] + '%';
	        barElement.style[right] = stepValues[1][1] + '%';
	      } else if (step === 3) {
	        barElement.style.transitionDuration = '0ms';
	      }
	      this.timers[id] = setTimeout(function () {
	        return _this3.barUpdate(id, step + 1, barElement, stepValues);
	      }, 420);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.bar) },
	          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
	          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
	        )
	      );
	    }
	  }]);
	  return LinearProgress;
	}(_react.Component);
	
	LinearProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100
	};
	LinearProgress.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? LinearProgress.propTypes = {
	  /**
	   * The color of the progress bar, defaults to
	   * primary color of theme.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _react.PropTypes.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _react.PropTypes.number,
	  /**
	   * The mode of show your progress, indeterminate for when
	   * there is no value for progress.
	   */
	  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = LinearProgress;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LinearProgress = __webpack_require__(987);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LinearProgress2.default;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(272);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestedList = function NestedList(props) {
	  var children = props.children,
	      open = props.open,
	      nestedLevel = props.nestedLevel,
	      style = props.style;
	
	
	  if (!open) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _List2.default,
	    { style: style },
	    _react.Children.map(children, function (child) {
	      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
	        nestedLevel: nestedLevel + 1
	      }) : child;
	    })
	  );
	};
	
	process.env.NODE_ENV !== "production" ? NestedList.propTypes = {
	  children: _react.PropTypes.node,
	  nestedLevel: _react.PropTypes.number.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = NestedList;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeSelectable = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(272);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(273);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(396);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.default = _List3.default;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HotKeyHolder = undefined;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  (0, _createClass3.default)(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	  return HotKeyHolder;
	}();

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded,
	      circle = props.circle,
	      transitionEnabled = props.transitionEnabled,
	      zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      paper = _context$muiTheme.paper;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? '2px' : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  (0, _inherits3.default)(Paper, _Component);
	
	  function Paper() {
	    (0, _classCallCheck3.default)(this, Paper);
	    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          circle = _props.circle,
	          rounded = _props.rounded,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Paper;
	}(_react.Component);
	
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Paper.propTypes = {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Set to true to generate a circlular paper container.
	   */
	  circle: _react.PropTypes.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _react.PropTypes.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = Paper;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverAnimationDefault = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationDefault, _Component);
	
	  function PopoverAnimationDefault() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationDefault, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	  return PopoverAnimationDefault;
	}(_react.Component);
	
	PopoverAnimationDefault.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationDefault.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? PopoverAnimationDefault.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin.isRequired,
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = PopoverAnimationDefault;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;
	
	var _Popover2 = __webpack_require__(136);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _PopoverAnimationVertical2 = __webpack_require__(276);
	
	var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Popover = _Popover3.default;
	exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
	exports.default = _Popover3.default;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedSwitch = __webpack_require__(279);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _radioButtonUnchecked = __webpack_require__(1063);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _radioButtonChecked = __webpack_require__(1062);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var radioButton = context.muiTheme.radioButton;
	
	
	  return {
	    icon: {
	      height: radioButton.size,
	      width: radioButton.size
	    },
	    target: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(1)',
	      fill: radioButton.borderColor
	    },
	    fill: {
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(0)',
	      transformOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut(),
	      fill: radioButton.checkedColor
	    },
	    targetWhenChecked: {
	      opacity: 0,
	      transform: 'scale(0)'
	    },
	    fillWhenChecked: {
	      opacity: 1,
	      transform: 'scale(1)'
	    },
	    targetWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    fillWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    label: {
	      color: props.disabled ? radioButton.labelDisabledColor : radioButton.labelColor
	    },
	    ripple: {
	      color: props.checked ? radioButton.checkedColor : radioButton.borderColor
	    }
	  };
	}
	
	var RadioButton = function (_Component) {
	  (0, _inherits3.default)(RadioButton, _Component);
	
	  function RadioButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButton.__proto__ || (0, _getPrototypeOf2.default)(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSwitch = function (event) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, _this.props.value);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // Only called when selected, not when unselected.
	
	
	  (0, _createClass3.default)(RadioButton, [{
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	
	    // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
	    // RadioButton's checked value.
	
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.enhancedSwitch.getValue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onCheck = _props.onCheck,
	          uncheckedIcon = _props.uncheckedIcon,
	          disabled = _props.disabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checkedIcon', 'checked', 'iconStyle', 'labelStyle', 'labelPosition', 'onCheck', 'uncheckedIcon', 'disabled']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var uncheckedStyles = (0, _simpleAssign2.default)(styles.target, checked && styles.targetWhenChecked, iconStyle, disabled && styles.targetWhenDisabled);
	
	      var checkedStyles = (0, _simpleAssign2.default)(styles.fill, checked && styles.fillWhenChecked, iconStyle, disabled && styles.fillWhenDisabled);
	
	      var uncheckedElement = _react2.default.isValidElement(uncheckedIcon) ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(uncheckedStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonUnchecked2.default, { style: uncheckedStyles });
	
	      var checkedElement = _react2.default.isValidElement(checkedIcon) ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkedStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonChecked2.default, { style: checkedStyles });
	
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	      var mergedLabelStyle = (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, {
	        ref: 'enhancedSwitch',
	        inputType: 'radio',
	        checked: checked,
	        switched: checked,
	        disabled: disabled,
	        rippleColor: styles.ripple.color,
	        iconStyle: mergedIconStyle,
	        labelStyle: mergedLabelStyle,
	        labelPosition: labelPosition,
	        onSwitch: this.handleSwitch,
	        switchElement: _react2.default.createElement(
	          'div',
	          null,
	          uncheckedElement,
	          checkedElement
	        )
	      }));
	    }
	  }]);
	  return RadioButton;
	}(_react.Component);
	
	RadioButton.defaultProps = {
	  checked: false,
	  disabled: false,
	  labelPosition: 'right'
	};
	RadioButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? RadioButton.propTypes = {
	  /**
	   * @ignore
	   * checked if true
	   * Used internally by `RadioButtonGroup`.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * The icon element to show when the radio button is checked.
	   */
	  checkedIcon: _react.PropTypes.element,
	  /**
	   * If true, the radio button is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
	   * Where the label will be placed next to the radio button.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Override the inline-styles of the label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Callback function fired when the radio button is checked. Note that this
	   * function will not be called if the radio button is part of a
	   * radio button group: in this case, use the `onChange` property of
	   * `RadioButtonGroup`.
	   *
	   * @param {object} event `change` event targeting the element.
	   * @param {string} value The element's `value`.
	   */
	  onCheck: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The icon element to show when the radio button is unchecked.
	   */
	  uncheckedIcon: _react.PropTypes.element,
	  /**
	   * The value of the radio button.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = RadioButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(85);
	
	var _childUtils = __webpack_require__(165);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (process.env.NODE_ENV !== 'production') {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      raisedButton = _context$muiTheme.raisedButton;
	  var disabled = props.disabled,
	      disabledBackgroundColor = props.disabledBackgroundColor,
	      disabledLabelColor = props.disabledLabelColor,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      label = props.label,
	      labelPosition = props.labelPosition,
	      primary = props.primary,
	      secondary = props.secondary,
	      style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	  var borderRadius = 2;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  (0, _inherits3.default)(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          buttonStyle = _props.buttonStyle,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          disabledBackgroundColor = _props.disabledBackgroundColor,
	          disabledLabelColor = _props.disabledLabelColor,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          label = _props.label,
	          labelColor = _props.labelColor,
	          labelPosition = _props.labelPosition,
	          labelStyle = _props.labelStyle,
	          overlayStyle = _props.overlayStyle,
	          primary = _props.primary,
	          rippleStyle = _props.rippleStyle,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var iconCloned = icon && (0, _react.cloneElement)(icon, {
	        color: icon.props.color || styles.label.color,
	        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	      });
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle))
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? RaisedButton.propTypes = {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _react.PropTypes.object,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _react.PropTypes.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _react.PropTypes.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _react.PropTypes.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline style of the button overlay.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = RaisedButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(996);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _slicedToArray2 = __webpack_require__(223);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autoPrefix = __webpack_require__(114);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIEWBOX_SIZE = 32;
	
	function getStyles(props) {
	  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
	  return {
	    root: {
	      position: 'absolute',
	      zIndex: 2,
	      width: props.size,
	      height: props.size,
	      padding: padding,
	      top: -10000,
	      left: -10000,
	      transform: 'translate(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px)',
	      opacity: props.status === 'hide' ? 0 : 1,
	      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
	    }
	  };
	}
	
	var RefreshIndicator = function (_Component) {
	  (0, _inherits3.default)(RefreshIndicator, _Component);
	
	  function RefreshIndicator() {
	    (0, _classCallCheck3.default)(this, RefreshIndicator);
	    return (0, _possibleConstructorReturn3.default)(this, (RefreshIndicator.__proto__ || (0, _getPrototypeOf2.default)(RefreshIndicator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RefreshIndicator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var paperSize = this.getPaperSize();
	
	      var childrenCmp = null;
	      if (this.props.status !== 'ready') {
	        var circleStyle = this.getCircleStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'div',
	          {
	            ref: 'wrapper',
	            style: prepareStyles({
	              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	              width: '100%',
	              height: '100%'
	            })
	          },
	          _react2.default.createElement(
	            'svg',
	            {
	              style: {
	                width: paperSize,
	                height: paperSize
	              },
	              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	            },
	            _react2.default.createElement('circle', (0, _extends3.default)({
	              ref: 'path',
	              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
	                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	              }))
	            }, circleStyle.attr))
	          )
	        );
	      } else {
	        var _circleStyle = this.getCircleStyle(paperSize);
	        var polygonStyle = this.getPolygonStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'svg',
	          {
	            style: {
	              width: paperSize,
	              height: paperSize
	            },
	            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	          },
	          _react2.default.createElement('circle', (0, _extends3.default)({
	            style: prepareStyles(_circleStyle.style)
	          }, _circleStyle.attr)),
	          _react2.default.createElement('polygon', (0, _extends3.default)({
	            style: prepareStyles(polygonStyle.style)
	          }, polygonStyle.attr))
	        );
	      }
	
	      return childrenCmp;
	    }
	  }, {
	    key: 'getTheme',
	    value: function getTheme() {
	      return this.context.muiTheme.refreshIndicator;
	    }
	  }, {
	    key: 'getPaddingSize',
	    value: function getPaddingSize() {
	      var padding = this.props.size * 0.1;
	      return padding;
	    }
	  }, {
	    key: 'getPaperSize',
	    value: function getPaperSize() {
	      return this.props.size - this.getPaddingSize() * 2;
	    }
	  }, {
	    key: 'getCircleAttr',
	    value: function getCircleAttr() {
	      return {
	        radiu: VIEWBOX_SIZE / 2 - 5,
	        originX: VIEWBOX_SIZE / 2,
	        originY: VIEWBOX_SIZE / 2,
	        strokeWidth: 3
	      };
	    }
	  }, {
	    key: 'getArcDeg',
	    value: function getArcDeg() {
	      var p = this.props.percentage / 100;
	
	      var beginDeg = p * 120;
	      var endDeg = p * 410;
	      return [beginDeg, endDeg];
	    }
	  }, {
	    key: 'getFactor',
	    value: function getFactor() {
	      var p = this.props.percentage / 100;
	      var p1 = Math.min(1, p / 0.4);
	
	      return p1;
	    }
	  }, {
	    key: 'getCircleStyle',
	    value: function getCircleStyle() {
	      var isLoading = this.props.status === 'loading';
	      var p1 = isLoading ? 1 : this.getFactor();
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	
	      var _getArcDeg = this.getArcDeg(),
	          _getArcDeg2 = (0, _slicedToArray3.default)(_getArcDeg, 2),
	          beginDeg = _getArcDeg2[0],
	          endDeg = _getArcDeg2[1];
	
	      var arcLen = (endDeg - beginDeg) * perimeter / 360;
	      var dashOffset = -beginDeg * perimeter / 360;
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
	          strokeDashoffset: dashOffset,
	          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          strokeLinecap: 'round',
	          opacity: p1,
	          strokeWidth: circle.strokeWidth * p1,
	          fill: 'none'
	        },
	        attr: {
	          cx: circle.originX,
	          cy: circle.originY,
	          r: circle.radiu
	        }
	      };
	    }
	  }, {
	    key: 'getPolygonStyle',
	    value: function getPolygonStyle() {
	      var p1 = this.getFactor();
	      var circle = this.getCircleAttr();
	
	      var triangleCx = circle.originX + circle.radiu;
	      var triangleCy = circle.originY;
	      var dx = circle.strokeWidth * 7 / 4 * p1;
	      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);
	
	      var _getArcDeg3 = this.getArcDeg(),
	          _getArcDeg4 = (0, _slicedToArray3.default)(_getArcDeg3, 2),
	          endDeg = _getArcDeg4[1];
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          transform: 'rotate(' + endDeg + 'deg)',
	          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
	          opacity: p1
	        },
	        attr: {
	          points: trianglePath
	        }
	      };
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path, step) {
	      var _this2 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      var currStep = (step || 0) % 3;
	
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	      var arcLen = perimeter * 0.64;
	
	      var strokeDasharray = void 0;
	      var strokeDashoffset = void 0;
	      var transitionDuration = void 0;
	
	      if (currStep === 0) {
	        strokeDasharray = '1, 200';
	        strokeDashoffset = 0;
	        transitionDuration = '0ms';
	      } else if (currStep === 1) {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -15;
	        transitionDuration = '750ms';
	      } else {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -(perimeter - 1);
	        transitionDuration = '850ms';
	      }
	
	      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
	      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
	      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, currStep + 1);
	      }, currStep ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', null);
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      this.rotateWrapperSecondTimer = setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          top = _props.top,
	          left = _props.left,
	          percentage = _props.percentage,
	          status = _props.status,
	          loadingColor = _props.loadingColor,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'top', 'left', 'percentage', 'status', 'loadingColor']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({
	          circle: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }, other),
	        this.renderChildren()
	      );
	    }
	  }]);
	  return RefreshIndicator;
	}(_react.Component);
	
	RefreshIndicator.defaultProps = {
	  percentage: 0,
	  size: 40,
	  status: 'hide'
	};
	RefreshIndicator.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? RefreshIndicator.propTypes = {
	  /**
	   * Override the theme's color of the indicator while it's status is
	   * "ready" and it's percentage is less than 100.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * The absolute left position of the indicator in pixels.
	   */
	  left: _react.PropTypes.number.isRequired,
	  /**
	   * Override the theme's color of the indicator while
	   * it's status is "loading" or when it's percentage is 100.
	   */
	  loadingColor: _react.PropTypes.string,
	  /**
	   * The confirmation progress to fetch data. Max value is 100.
	   */
	  percentage: _react.PropTypes.number,
	  /**
	   * Size in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * The display status of the indicator. If the status is
	   * "ready", the indicator will display the ready state
	   * arrow. If the status is "loading", it will display
	   * the loading progress indicator. If the status is "hide",
	   * the indicator will be hidden.
	   */
	  status: _react.PropTypes.oneOf(['ready', 'loading', 'hide']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The absolute top position of the indicator in pixels.
	   */
	  top: _react.PropTypes.number.isRequired
	} : void 0;
	exports.default = RefreshIndicator;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RefreshIndicator = __webpack_require__(998);
	
	var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RefreshIndicator2.default;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(163);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DropDownMenu = __webpack_require__(394);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    label: {
	      paddingLeft: 0,
	      top: props.floatingLabelText ? 6 : -4
	    },
	    icon: {
	      right: 0,
	      top: props.floatingLabelText ? 8 : 0
	    },
	    hideDropDownUnderline: {
	      borderTop: 'none'
	    },
	    dropDownMenu: {
	      display: 'block'
	    }
	  };
	}
	
	var SelectField = function (_Component) {
	  (0, _inherits3.default)(SelectField, _Component);
	
	  function SelectField() {
	    (0, _classCallCheck3.default)(this, SelectField);
	    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SelectField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          iconStyle = _props.iconStyle,
	          id = _props.id,
	          underlineDisabledStyle = _props.underlineDisabledStyle,
	          underlineFocusStyle = _props.underlineFocusStyle,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          underlineStyle = _props.underlineStyle,
	          errorStyle = _props.errorStyle,
	          disabled = _props.disabled,
	          floatingLabelFixed = _props.floatingLabelFixed,
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          hintStyle = _props.hintStyle,
	          hintText = _props.hintText,
	          fullWidth = _props.fullWidth,
	          errorText = _props.errorText,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyle = _props.menuStyle,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'value']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _TextField2.default,
	        (0, _extends3.default)({}, other, {
	          style: style,
	          disabled: disabled,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelText: floatingLabelText,
	          floatingLabelStyle: floatingLabelStyle,
	          hintStyle: hintStyle,
	          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	          fullWidth: fullWidth,
	          errorText: errorText,
	          underlineStyle: underlineStyle,
	          errorStyle: errorStyle,
	          onFocus: onFocus,
	          onBlur: onBlur,
	          id: id,
	          underlineDisabledStyle: underlineDisabledStyle,
	          underlineFocusStyle: underlineFocusStyle
	        }),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          {
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
	            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
	            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
	            menuItemStyle: menuItemStyle,
	            selectedMenuItemStyle: selectedMenuItemStyle,
	            underlineStyle: styles.hideDropDownUnderline,
	            listStyle: listStyle,
	            autoWidth: autoWidth,
	            value: value,
	            onChange: onChange,
	            maxHeight: maxHeight
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return SelectField;
	}(_react.Component);
	
	SelectField.defaultProps = {
	  autoWidth: false,
	  disabled: false,
	  fullWidth: false
	};
	SelectField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? SelectField.propTypes = {
	  /**
	   * If true, the width will automatically be set according to the
	   * items inside the menu.
	   * To control the width in CSS instead, leave this prop set to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem` elements to populate the select field with.
	   * If the menu items have a `label` prop, that value will
	   * represent the selected menu item in the rendered select field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the select field will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the error element.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when no value is selected.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the floating label.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content of the floating label.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the select field will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the hint element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the label style when the select field is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * Override the default max-height of the underlying `DropDownMenu` element.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  menuStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item
	   * that was selected.
	   * @param {number} key The index of the selected menu item.
	   * @param {any} payload The `value` prop of the selected menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element when the select
	   * field is disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element when the select field
	   * is focused.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value that is currently selected.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = SelectField;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SelectField = __webpack_require__(1000);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(325);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(280);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _deprecatedPropType = __webpack_require__(1066);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Verifies min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if min >= max otherwise null.
	 */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    rest[_key - 3] = arguments[_key];
	  }
	
	  var error = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	 * Verifies value is within the min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	 */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	    rest[_key2 - 3] = arguments[_key2];
	  }
	
	  var error = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var crossAxisProperty = {
	  x: 'height',
	  'x-reverse': 'height',
	  y: 'width',
	  'y-reverse': 'width'
	};
	
	var crossAxisOffsetProperty = {
	  x: 'top',
	  'x-reverse': 'top',
	  y: 'left',
	  'y-reverse': 'left'
	};
	
	var mainAxisProperty = {
	  x: 'width',
	  'x-reverse': 'width',
	  y: 'height',
	  'y-reverse': 'height'
	};
	
	var mainAxisMarginFromEnd = {
	  x: 'marginRight',
	  'x-reverse': 'marginLeft',
	  y: 'marginTop',
	  'y-reverse': 'marginBottom'
	};
	
	var mainAxisMarginFromStart = {
	  x: 'marginLeft',
	  'x-reverse': 'marginRight',
	  y: 'marginBottom',
	  'y-reverse': 'marginTop'
	};
	
	var mainAxisOffsetProperty = {
	  x: 'left',
	  'x-reverse': 'right',
	  y: 'bottom',
	  'y-reverse': 'top'
	};
	
	var mainAxisClientProperty = {
	  x: 'clientWidth',
	  'x-reverse': 'clientWidth',
	  y: 'clientHeight',
	  'y-reverse': 'clientHeight'
	};
	
	var mainAxisClientOffsetProperty = {
	  x: 'clientX',
	  'x-reverse': 'clientX',
	  y: 'clientY',
	  'y-reverse': 'clientY'
	};
	
	var reverseMainAxisOffsetProperty = {
	  x: 'right',
	  'x-reverse': 'left',
	  y: 'top',
	  'y-reverse': 'bottom'
	};
	
	var isMouseControlInverted = function isMouseControlInverted(axis) {
	  return axis === 'x-reverse' || axis === 'y';
	};
	
	function getPercent(value, min, max) {
	  var percent = (value - min) / (max - min);
	  if (isNaN(percent)) {
	    percent = 0;
	  }
	
	  return percent;
	}
	
	var getStyles = function getStyles(props, context, state) {
	  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;
	
	  var axis = props.axis,
	      disabled = props.disabled,
	      max = props.max,
	      min = props.min;
	  var _context$muiTheme$sli = context.muiTheme.slider,
	      handleColorZero = _context$muiTheme$sli.handleColorZero,
	      handleFillColor = _context$muiTheme$sli.handleFillColor,
	      handleSize = _context$muiTheme$sli.handleSize,
	      handleSizeDisabled = _context$muiTheme$sli.handleSizeDisabled,
	      handleSizeActive = _context$muiTheme$sli.handleSizeActive,
	      trackSize = _context$muiTheme$sli.trackSize,
	      trackColor = _context$muiTheme$sli.trackColor,
	      trackColorSelected = _context$muiTheme$sli.trackColorSelected,
	      rippleColor = _context$muiTheme$sli.rippleColor,
	      selectionColor = _context$muiTheme$sli.selectionColor;
	
	
	  var fillGutter = handleSize / 2;
	  var disabledGutter = trackSize + handleSizeDisabled / 2;
	  var calcDisabledSpacing = disabled ? ' - ' + disabledGutter + 'px' : '';
	  var percent = getPercent(state.value, min, max);
	
	  var styles = {
	    slider: (_slider = {
	      touchCallout: 'none',
	      userSelect: 'none',
	      cursor: 'default'
	    }, (0, _defineProperty3.default)(_slider, crossAxisProperty[axis], handleSizeActive), (0, _defineProperty3.default)(_slider, mainAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_slider, 'position', 'relative'), (0, _defineProperty3.default)(_slider, 'marginTop', 24), (0, _defineProperty3.default)(_slider, 'marginBottom', 48), _slider),
	    track: (_track = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_track, crossAxisOffsetProperty[axis], (handleSizeActive - trackSize) / 2), (0, _defineProperty3.default)(_track, mainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_track, mainAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_track, crossAxisProperty[axis], trackSize), _track),
	    filledAndRemaining: (_filledAndRemaining = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_filledAndRemaining, crossAxisOffsetProperty, 0), (0, _defineProperty3.default)(_filledAndRemaining, crossAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
	    handle: (_handle = {
	      boxSizing: 'border-box',
	      position: 'absolute',
	      cursor: 'pointer',
	      pointerEvents: 'inherit'
	    }, (0, _defineProperty3.default)(_handle, crossAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_handle, mainAxisOffsetProperty[axis], percent === 0 ? '0%' : percent * 100 + '%'), (0, _defineProperty3.default)(_handle, 'zIndex', 1), (0, _defineProperty3.default)(_handle, 'margin', {
	      x: trackSize / 2 + 'px 0 0 0',
	      'x-reverse': trackSize / 2 + 'px 0 0 0',
	      y: '0 0 0 ' + trackSize / 2 + 'px',
	      'y-reverse': '0 0 0 ' + trackSize / 2 + 'px'
	    }[axis]), (0, _defineProperty3.default)(_handle, 'width', handleSize), (0, _defineProperty3.default)(_handle, 'height', handleSize), (0, _defineProperty3.default)(_handle, 'backgroundColor', selectionColor), (0, _defineProperty3.default)(_handle, 'backgroundClip', 'padding-box'), (0, _defineProperty3.default)(_handle, 'border', '0px solid transparent'), (0, _defineProperty3.default)(_handle, 'borderRadius', '50%'), (0, _defineProperty3.default)(_handle, 'transform', {
	      x: 'translate(-50%, -50%)',
	      'x-reverse': 'translate(50%, -50%)',
	      y: 'translate(-50%, 50%)',
	      'y-reverse': 'translate(-50%, -50%)'
	    }[axis]), (0, _defineProperty3.default)(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), (0, _defineProperty3.default)(_handle, 'overflow', 'visible'), (0, _defineProperty3.default)(_handle, 'outline', 'none'), _handle),
	    handleWhenDisabled: {
	      boxSizing: 'content-box',
	      cursor: 'not-allowed',
	      backgroundColor: trackColor,
	      width: handleSizeDisabled,
	      height: handleSizeDisabled,
	      border: 'none'
	    },
	    handleWhenPercentZero: {
	      border: trackSize + 'px solid ' + handleColorZero,
	      backgroundColor: handleFillColor,
	      boxShadow: 'none'
	    },
	    handleWhenPercentZeroAndDisabled: {
	      cursor: 'not-allowed',
	      width: handleSizeDisabled,
	      height: handleSizeDisabled
	    },
	    handleWhenPercentZeroAndFocused: {
	      border: trackSize + 'px solid ' + trackColorSelected
	    },
	    handleWhenActive: {
	      width: handleSizeActive,
	      height: handleSizeActive
	    },
	    ripple: {
	      height: handleSize,
	      width: handleSize,
	      overflow: 'visible'
	    },
	    rippleWhenPercentZero: {
	      top: -trackSize,
	      left: -trackSize
	    },
	    rippleInner: {
	      height: '300%',
	      width: '300%',
	      top: -handleSize,
	      left: -handleSize
	    },
	    rippleColor: {
	      fill: percent === 0 ? handleColorZero : rippleColor
	    }
	  };
	  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, (0, _defineProperty3.default)(_objectAssign2, mainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_objectAssign2, 'backgroundColor', disabled ? trackColor : selectionColor), (0, _defineProperty3.default)(_objectAssign2, mainAxisMarginFromEnd[axis], fillGutter), (0, _defineProperty3.default)(_objectAssign2, mainAxisProperty[axis], 'calc(' + percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
	  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, (0, _defineProperty3.default)(_objectAssign3, reverseMainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !disabled ? trackColorSelected : trackColor), (0, _defineProperty3.default)(_objectAssign3, mainAxisMarginFromStart[axis], fillGutter), (0, _defineProperty3.default)(_objectAssign3, mainAxisProperty[axis], 'calc(' + (1 - percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));
	
	  return styles;
	};
	
	var Slider = function (_Component) {
	  (0, _inherits3.default)(Slider, _Component);
	
	  function Slider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Slider);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      value: 0
	    }, _this.track = null, _this.handle = null, _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          min = _this$props.min,
	          max = _this$props.max,
	          step = _this$props.step;
	
	
	      var action = void 0;
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'page down':
	        case 'down':
	          if (axis === 'y-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'left':
	          if (axis === 'x-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'page up':
	        case 'up':
	          if (axis === 'y-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'right':
	          if (axis === 'x-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'home':
	          action = 'min';
	          break;
	        case 'end':
	          action = 'max';
	          break;
	      }
	
	      if (action) {
	        var newValue = void 0;
	
	        // Cancel scroll
	        event.preventDefault();
	
	        switch (action) {
	          case 'decrease':
	            newValue = _this.state.value - step;
	            break;
	          case 'increase':
	            newValue = _this.state.value + step;
	            break;
	          case 'min':
	            newValue = min;
	            break;
	          case 'max':
	            newValue = max;
	            break;
	        }
	
	        // We need to use toFixed() because of float point errors.
	        // For example, 0.01 + 0.06 = 0.06999999999999999
	        newValue = parseFloat(newValue.toFixed(5));
	
	        if (newValue > max) {
	          newValue = max;
	        } else if (newValue < min) {
	          newValue = min;
	        }
	
	        if (_this.state.value !== newValue) {
	          _this.setState({
	            value: newValue
	          });
	
	          if (_this.props.onChange) {
	            _this.props.onChange(event, newValue);
	          }
	        }
	      }
	    }, _this.handleDragMouseMove = function (event) {
	      _this.onDragUpdate(event, 'mouse');
	    }, _this.handleTouchMove = function (event) {
	      _this.onDragUpdate(event, 'touch');
	    }, _this.handleMouseEnd = function (event) {
	      document.removeEventListener('mousemove', _this.handleDragMouseMove);
	      document.removeEventListener('mouseup', _this.handleMouseEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchEnd = function (event) {
	      document.removeEventListener('touchmove', _this.handleTouchMove);
	      document.removeEventListener('touchup', _this.handleTouchEnd);
	      document.removeEventListener('touchend', _this.handleTouchEnd);
	      document.removeEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchStart = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      var position = void 0;
	      if (isMouseControlInverted(_this.props.axis)) {
	        position = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
	      } else {
	        position = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('touchmove', _this.handleTouchMove);
	      document.addEventListener('touchup', _this.handleTouchEnd);
	      document.addEventListener('touchend', _this.handleTouchEnd);
	      document.addEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStart(event);
	
	      // Cancel scroll and context menu
	      event.preventDefault();
	    }, _this.handleFocus = function (event) {
	      _this.setState({
	        focused: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false,
	        active: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      var position = void 0;
	      if (isMouseControlInverted(_this.props.axis)) {
	        position = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
	      } else {
	        position = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('mousemove', _this.handleDragMouseMove);
	      document.addEventListener('mouseup', _this.handleMouseEnd);
	
	      // Cancel text selection
	      event.preventDefault();
	
	      // Set focus manually since we called preventDefault()
	      _this.handle.focus();
	
	      _this.onDragStart(event);
	    }, _this.handleMouseUp = function () {
	      if (!_this.props.disabled) {
	        _this.setState({
	          active: false
	        });
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({
	        hovered: true
	      });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({
	        hovered: false
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Slider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          valueProp = _props.value,
	          defaultValue = _props.defaultValue,
	          min = _props.min,
	          max = _props.max;
	
	
	      var value = valueProp;
	      if (value === undefined) {
	        value = defaultValue !== undefined ? defaultValue : min;
	      }
	
	      if (value > max) {
	        value = max;
	      } else if (value < min) {
	        value = min;
	      }
	
	      this.setState({
	        value: value
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && !this.state.dragging) {
	        this.setState({
	          value: nextProps.value
	        });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI Slider: getValue() method is deprecated.\n      Use the onChange callbacks instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      return this.state.value;
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI Slider: clearValue() method is deprecated.\n      Use the value property to control the component instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      this.setState({
	        value: this.props.min
	      });
	    }
	  }, {
	    key: 'getTrackOffset',
	    value: function getTrackOffset() {
	      return this.track.getBoundingClientRect()[mainAxisOffsetProperty[this.props.axis]];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      this.setState({
	        dragging: true,
	        active: true
	      });
	
	      if (this.props.onDragStart) {
	        this.props.onDragStart(event);
	      }
	    }
	  }, {
	    key: 'onDragUpdate',
	    value: function onDragUpdate(event, type) {
	      var _this2 = this;
	
	      if (this.dragRunning) {
	        return;
	      }
	      this.dragRunning = true;
	
	      requestAnimationFrame(function () {
	        _this2.dragRunning = false;
	
	        var source = type === 'touch' ? event.touches[0] : event;
	
	        var position = void 0;
	        if (isMouseControlInverted(_this2.props.axis)) {
	          position = _this2.getTrackOffset() - source[mainAxisClientOffsetProperty[_this2.props.axis]];
	        } else {
	          position = source[mainAxisClientOffsetProperty[_this2.props.axis]] - _this2.getTrackOffset();
	        }
	
	        if (!_this2.props.disabled) {
	          _this2.setValueFromPosition(event, position);
	        }
	      });
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(event) {
	      this.setState({
	        dragging: false,
	        active: false
	      });
	
	      if (this.props.onDragStop) {
	        this.props.onDragStop(event);
	      }
	    }
	  }, {
	    key: 'setValueFromPosition',
	    value: function setValueFromPosition(event, position) {
	      var positionMax = this.track[mainAxisClientProperty[this.props.axis]];
	      if (position < 0) {
	        position = 0;
	      } else if (position > positionMax) {
	        position = positionMax;
	      }
	
	      var _props2 = this.props,
	          step = _props2.step,
	          min = _props2.min,
	          max = _props2.max;
	
	
	      var value = void 0;
	      value = position / positionMax * (max - min);
	      value = Math.round(value / step) * step + min;
	      value = parseFloat(value.toFixed(5));
	
	      if (value > max) {
	        value = max;
	      } else if (value < min) {
	        value = min;
	      }
	
	      if (this.state.value !== value) {
	        this.setState({
	          value: value
	        });
	
	        if (this.props.onChange) {
	          this.props.onChange(event, value);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          axis = _props3.axis,
	          description = _props3.description,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          error = _props3.error,
	          max = _props3.max,
	          min = _props3.min,
	          name = _props3.name,
	          onBlur = _props3.onBlur,
	          onChange = _props3.onChange,
	          onDragStart = _props3.onDragStart,
	          onDragStop = _props3.onDragStop,
	          onFocus = _props3.onFocus,
	          required = _props3.required,
	          sliderStyle = _props3.sliderStyle,
	          step = _props3.step,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['axis', 'description', 'disabled', 'disableFocusRipple', 'error', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style']);
	      var _state = this.state,
	          active = _state.active,
	          focused = _state.focused,
	          hovered = _state.hovered,
	          value = _state.value;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var percent = getPercent(value, min, max);
	
	      var handleStyles = {};
	      if (percent === 0) {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, active && styles.handleWhenActive, (hovered || focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
	      } else {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
	      }
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
	        _react2.default.createElement(
	          'span',
	          null,
	          description
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          error
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.slider, sliderStyle)),
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onMouseDown: this.handleMouseDown,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseUp: this.handleMouseUp,
	            onTouchStart: this.handleTouchStart,
	            onKeyDown: !disabled && this.handleKeyDown
	          },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(node) {
	                return _this3.track = node;
	              }, style: prepareStyles(styles.track) },
	            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
	            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
	            _react2.default.createElement(
	              'div',
	              {
	                ref: function ref(node) {
	                  return _this3.handle = node;
	                },
	                style: prepareStyles(handleStyles),
	                tabIndex: 0
	              },
	              !disabled && !disableFocusRipple && _react2.default.createElement(_FocusRipple2.default, {
	                style: rippleStyle,
	                innerStyle: styles.rippleInner,
	                show: (hovered || focused) && !active,
	                color: styles.rippleColor.fill
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          type: 'hidden',
	          name: name,
	          value: value,
	          required: required,
	          min: min,
	          max: max,
	          step: step
	        })
	      );
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	Slider.defaultProps = {
	  axis: 'x',
	  disabled: false,
	  disableFocusRipple: false,
	  max: 1,
	  min: 0,
	  required: true,
	  step: 0.01,
	  style: {}
	};
	Slider.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Slider.propTypes = {
	  /**
	   * The axis on which the slider will slide.
	   */
	  axis: _react.PropTypes.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * The default value of the slider.
	   */
	  defaultValue: valueInRangePropType,
	  /**
	   * Describe the slider.
	   */
	  description: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Use a sibling node element instead. It will be removed with v0.17.0.'),
	  /**
	   * Disables focus ripple if set to true.
	   */
	  disableFocusRipple: _react.PropTypes.bool,
	  /**
	   * If true, the slider will not be interactable.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * An error message for the slider.
	   */
	  error: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Use a sibling node element instead. It will be removed with v0.17.0.'),
	  /**
	   * The maximum value the slider can slide to on
	   * a scale from 0 to 1 inclusive. Cannot be equal to min.
	   */
	  max: minMaxPropType,
	  /**
	   * The minimum value the slider can slide to on a scale
	   * from 0 to 1 inclusive. Cannot be equal to max.
	   */
	  min: minMaxPropType,
	  /**
	   * The name of the slider. Behaves like the name attribute
	   * of an input element.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event KeyDown event targeting the slider.
	   * @param {number} newValue The new value of the slider.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slider has begun to move.
	   *
	   * @param {object} event MouseDown or TouchStart event targeting the slider.
	   */
	  onDragStart: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slide has stopped moving.
	   *
	   * @param {object} event MouseEnd or TouchEnd event targeting the slider.
	   */
	  onDragStop: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Whether or not the slider is required in a form.
	   */
	  required: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner slider element.
	   */
	  sliderStyle: _react.PropTypes.object,
	  /**
	   * The granularity the slider can step through values.
	   */
	  step: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the slider.
	   */
	  value: valueInRangePropType
	} : void 0;
	exports.default = Slider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Slider = __webpack_require__(1002);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider2.default;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ClickAwayListener = __webpack_require__(278);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _SnackbarBody = __webpack_require__(1005);
	
	var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
	      zIndex = _context$muiTheme.zIndex;
	  var open = state.open;
	
	
	  var styles = {
	    root: {
	      position: 'fixed',
	      left: '50%',
	      display: 'flex',
	      bottom: 0,
	      zIndex: zIndex.snackbar,
	      visibility: open ? 'visible' : 'hidden',
	      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
	      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
	    }
	  };
	
	  return styles;
	}
	
	var Snackbar = function (_Component) {
	  (0, _inherits3.default)(Snackbar, _Component);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
	      if (_this.timerTransitionId) {
	        // If transitioning, don't close the snackbar.
	        return;
	      }
	
	      if (_this.props.open !== null && _this.props.onRequestClose) {
	        _this.props.onRequestClose('clickaway');
	      } else {
	        _this.setState({ open: false });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open,
	        message: this.props.message,
	        action: this.props.action
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.open) {
	        this.setAutoHideTimer();
	        this.setTransitionTimer();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
	        this.setState({
	          open: false
	        });
	
	        clearTimeout(this.timerOneAtTheTimeId);
	        this.timerOneAtTheTimeId = setTimeout(function () {
	          _this2.setState({
	            message: nextProps.message,
	            action: nextProps.action,
	            open: true
	          });
	        }, 400);
	      } else {
	        var open = nextProps.open;
	
	        this.setState({
	          open: open !== null ? open : this.state.open,
	          message: nextProps.message,
	          action: nextProps.action
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.open !== this.state.open) {
	        if (this.state.open) {
	          this.setAutoHideTimer();
	          this.setTransitionTimer();
	        } else {
	          clearTimeout(this.timerAutoHideId);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHideId);
	      clearTimeout(this.timerTransitionId);
	      clearTimeout(this.timerOneAtTheTimeId);
	    }
	  }, {
	    key: 'setAutoHideTimer',
	
	
	    // Timer that controls delay before snackbar auto hides
	    value: function setAutoHideTimer() {
	      var _this3 = this;
	
	      var autoHideDuration = this.props.autoHideDuration;
	
	      if (autoHideDuration > 0) {
	        clearTimeout(this.timerAutoHideId);
	        this.timerAutoHideId = setTimeout(function () {
	          if (_this3.props.open !== null && _this3.props.onRequestClose) {
	            _this3.props.onRequestClose('timeout');
	          } else {
	            _this3.setState({ open: false });
	          }
	        }, autoHideDuration);
	      }
	    }
	
	    // Timer that controls delay before click-away events are captured (based on when animation completes)
	
	  }, {
	    key: 'setTransitionTimer',
	    value: function setTransitionTimer() {
	      var _this4 = this;
	
	      this.timerTransitionId = setTimeout(function () {
	        _this4.timerTransitionId = undefined;
	      }, 400);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoHideDuration = _props.autoHideDuration,
	          contentStyle = _props.contentStyle,
	          bodyStyle = _props.bodyStyle,
	          messageProp = _props.message,
	          onRequestClose = _props.onRequestClose,
	          onActionTouchTap = _props.onActionTouchTap,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionTouchTap', 'style']);
	      var _state = this.state,
	          action = _state.action,
	          message = _state.message,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: open ? this.componentClickAway : null },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	          _react2.default.createElement(_SnackbarBody2.default, {
	            action: action,
	            contentStyle: contentStyle,
	            message: message,
	            open: open,
	            onActionTouchTap: onActionTouchTap,
	            style: bodyStyle
	          })
	        )
	      );
	    }
	  }]);
	  return Snackbar;
	}(_react.Component);
	
	Snackbar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Snackbar.propTypes = {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _react.PropTypes.node,
	  /**
	   * The number of milliseconds to wait before automatically dismissing.
	   * If no value is specified the snackbar will dismiss normally.
	   * If a value is provided the snackbar can still be dismissed normally.
	   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
	   */
	  autoHideDuration: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the body element.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _react.PropTypes.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _react.PropTypes.func,
	  /**
	   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
	   * `autoHideDuration` timer expires.
	   *
	   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
	   * `open` prop.
	   *
	   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Snackbar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SnackbarBody = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _withWidth = __webpack_require__(1069);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _FlatButton = __webpack_require__(193);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var open = props.open,
	      width = props.width;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
	      desktopGutter = _context$muiTheme$bas2.desktopGutter,
	      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
	      fontFamily = _context$muiTheme$bas.fontFamily,
	      _context$muiTheme$sna = _context$muiTheme.snackbar,
	      backgroundColor = _context$muiTheme$sna.backgroundColor,
	      textColor = _context$muiTheme$sna.textColor,
	      actionColor = _context$muiTheme$sna.actionColor;
	
	
	  var isSmall = width === _withWidth.SMALL;
	
	  var styles = {
	    root: {
	      fontFamily: fontFamily,
	      backgroundColor: backgroundColor,
	      padding: '0 ' + desktopGutter + 'px',
	      height: desktopSubheaderHeight,
	      lineHeight: desktopSubheaderHeight + 'px',
	      borderRadius: isSmall ? 0 : 2,
	      maxWidth: isSmall ? 'inherit' : 568,
	      minWidth: isSmall ? 'inherit' : 288,
	      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
	      flexGrow: isSmall ? 1 : 0
	    },
	    content: {
	      fontSize: 14,
	      color: textColor,
	      opacity: open ? 1 : 0,
	      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
	    },
	    action: {
	      color: actionColor,
	      float: 'right',
	      marginTop: 6,
	      marginRight: -16,
	      marginLeft: desktopGutter,
	      backgroundColor: 'transparent'
	    }
	  };
	
	  return styles;
	}
	
	var SnackbarBody = exports.SnackbarBody = function SnackbarBody(props, context) {
	  var action = props.action,
	      contentStyle = props.contentStyle,
	      message = props.message,
	      open = props.open,
	      onActionTouchTap = props.onActionTouchTap,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionTouchTap', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
	    style: styles.action,
	    label: action,
	    onTouchTap: onActionTouchTap
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) },
	      _react2.default.createElement(
	        'span',
	        null,
	        message
	      ),
	      actionButton
	    )
	  );
	};
	
	process.env.NODE_ENV !== "production" ? SnackbarBody.propTypes = {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _react.PropTypes.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Width of the screen.
	   */
	  width: _react.PropTypes.number.isRequired
	} : void 0;
	
	SnackbarBody.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = (0, _withWidth2.default)()(SnackbarBody);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Snackbar = __webpack_require__(1004);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Snackbar2.default;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call.apply(_ref3, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props,
	          active = _this$props.active,
	          completed = _this$props.completed,
	          disabled = _this$props.disabled,
	          index = _this$props.index,
	          last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          index = _props.index,
	          last = _props.last,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	process.env.NODE_ENV !== "production" ? Step.propTypes = {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _react.PropTypes.number,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Step;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(72);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(400);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper,
	      backgroundColor = _context$muiTheme$ste.backgroundColor,
	      hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  (0, _inherits3.default)(StepButton, _Component);
	
	  function StepButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          iconContainerStyle = _props.iconContainerStyle,
	          last = _props.last,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'iconContainerStyle', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon, iconContainerStyle: iconContainerStyle })
	      );
	    }
	  }]);
	  return StepButton;
	}(_react.Component);
	
	StepButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	process.env.NODE_ENV !== "production" ? StepButton.propTypes = {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _react.PropTypes.object,
	  /** @ignore */
	  last: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = StepButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme,
	      stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	process.env.NODE_ENV !== "production" ? StepConnector.propTypes = propTypes : void 0;
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExpandTransition = __webpack_require__(1041);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  (0, _inherits3.default)(StepContent, _Component);
	
	  function StepContent() {
	    (0, _classCallCheck3.default)(this, StepContent);
	    return (0, _possibleConstructorReturn3.default)(this, (StepContent.__proto__ || (0, _getPrototypeOf2.default)(StepContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          last = _props.last,
	          style = _props.style,
	          transition = _props.transition,
	          transitionDuration = _props.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	      var _context = this.context,
	          stepper = _context.stepper,
	          prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	  return StepContent;
	}(_react.Component);
	
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	process.env.NODE_ENV !== "production" ? StepContent.propTypes = {
	  /**
	   * Expands the content
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Step content
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _react.PropTypes.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = StepContent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StepConnector = __webpack_require__(1009);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  (0, _inherits3.default)(Stepper, _Component);
	
	  function Stepper() {
	    (0, _classCallCheck3.default)(this, Stepper);
	    return (0, _possibleConstructorReturn3.default)(this, (Stepper.__proto__ || (0, _getPrototypeOf2.default)(Stepper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStep = _props.activeStep,
	          children = _props.children,
	          connector = _props.connector,
	          linear = _props.linear,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var numChildren = _react.Children.count(children);
	      var steps = _react.Children.map(children, function (step, index) {
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === numChildren) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && connector, _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	  return Stepper;
	}(_react.Component);
	
	Stepper.defaultProps = {
	  connector: _react2.default.createElement(_StepConnector2.default, null),
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _react.PropTypes.object.isRequired };
	Stepper.childContextTypes = { stepper: _react.PropTypes.object };
	process.env.NODE_ENV !== "production" ? Stepper.propTypes = {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _react.PropTypes.number,
	  /**
	   * Should be two or more `<Step />` components
	   */
	  children: _react.PropTypes.arrayOf(_react.PropTypes.node),
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _react.PropTypes.node,
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _react.PropTypes.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Stepper;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children,
	      inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      prepareStyles = _context$muiTheme.prepareStyles,
	      subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	
	process.env.NODE_ENV !== "production" ? Subheader.propTypes = {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the `Subheader` will be indented.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	Subheader.defaultProps = {
	  inset: false
	};
	
	Subheader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = Subheader;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgIcon = function (_Component) {
	  (0, _inherits3.default)(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          hoverColor = _props.hoverColor,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          style = _props.style,
	          viewBox = _props.viewBox,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	      var _context$muiTheme = this.context.muiTheme,
	          svgIcon = _context$muiTheme.svgIcon,
	          prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        (0, _extends3.default)({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _react.PropTypes.string
	} : void 0;
	exports.default = SvgIcon;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      table = _context$muiTheme.table;
	
	
	  return {
	    root: {
	      backgroundColor: table.backgroundColor,
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      tableLayout: 'fixed',
	      fontFamily: baseTheme.fontFamily
	    },
	    bodyTable: {
	      height: props.fixedHeader || props.fixedFooter ? props.height : 'auto',
	      overflowX: 'hidden',
	      overflowY: 'auto'
	    },
	    tableWrapper: {
	      height: props.fixedHeader || props.fixedFooter ? 'auto' : props.height,
	      overflow: 'auto'
	    }
	  };
	}
	
	var Table = function (_Component) {
	  (0, _inherits3.default)(Table, _Component);
	
	  function Table() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      allRowsSelected: false
	    }, _this.onCellClick = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellClick) _this.props.onCellClick(rowNumber, columnNumber, event);
	    }, _this.onCellHover = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHover) _this.props.onCellHover(rowNumber, columnNumber, event);
	    }, _this.onCellHoverExit = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(rowNumber, columnNumber, event);
	    }, _this.onRowHover = function (rowNumber) {
	      if (_this.props.onRowHover) _this.props.onRowHover(rowNumber);
	    }, _this.onRowHoverExit = function (rowNumber) {
	      if (_this.props.onRowHoverExit) _this.props.onRowHoverExit(rowNumber);
	    }, _this.onRowSelection = function (selectedRows) {
	      if (_this.state.allRowsSelected) _this.setState({ allRowsSelected: false });
	      if (_this.props.onRowSelection) _this.props.onRowSelection(selectedRows);
	    }, _this.onSelectAll = function () {
	      if (_this.props.onRowSelection) {
	        if (!_this.state.allRowsSelected) {
	          _this.props.onRowSelection('all');
	        } else {
	          _this.props.onRowSelection('none');
	        }
	      }
	
	      _this.setState({ allRowsSelected: !_this.state.allRowsSelected });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.allRowsSelected) {
	        this.setState({ allRowsSelected: true });
	      }
	    }
	  }, {
	    key: 'isScrollbarVisible',
	    value: function isScrollbarVisible() {
	      var tableDivHeight = this.refs.tableDiv.clientHeight;
	      var tableBodyHeight = this.refs.tableBody.clientHeight;
	
	      return tableBodyHeight > tableDivHeight;
	    }
	  }, {
	    key: 'createTableHeader',
	    value: function createTableHeader(base) {
	      return _react2.default.cloneElement(base, {
	        enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
	        onSelectAll: this.onSelectAll,
	        selectAllSelected: this.state.allRowsSelected
	      });
	    }
	  }, {
	    key: 'createTableBody',
	    value: function createTableBody(base) {
	      return _react2.default.cloneElement(base, {
	        allRowsSelected: this.state.allRowsSelected,
	        multiSelectable: this.props.multiSelectable,
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowSelection: this.onRowSelection,
	        selectable: this.props.selectable,
	        style: (0, _simpleAssign2.default)({ height: this.props.height }, base.props.style)
	      });
	    }
	  }, {
	    key: 'createTableFooter',
	    value: function createTableFooter(base) {
	      return base;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          fixedFooter = _props.fixedFooter,
	          fixedHeader = _props.fixedHeader,
	          style = _props.style,
	          wrapperStyle = _props.wrapperStyle,
	          headerStyle = _props.headerStyle,
	          bodyStyle = _props.bodyStyle,
	          footerStyle = _props.footerStyle;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var tHead = void 0;
	      var tFoot = void 0;
	      var tBody = void 0;
	
	      _react2.default.Children.forEach(children, function (child) {
	        if (!_react2.default.isValidElement(child)) return;
	
	        var muiName = child.type.muiName;
	
	        if (muiName === 'TableBody') {
	          tBody = _this2.createTableBody(child);
	        } else if (muiName === 'TableHeader') {
	          tHead = _this2.createTableHeader(child);
	        } else if (muiName === 'TableFooter') {
	          tFoot = _this2.createTableFooter(child);
	        } else {
	          process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: Children of the Table component must be TableBody or TableHeader or TableFooter.\n           Nothing is rendered.') : void 0;
	        }
	      });
	
	      // If we could not find a table-header and a table-body, do not attempt to display anything.
	      if (!tBody && !tHead) return null;
	
	      var mergedTableStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var headerTable = void 0;
	      var footerTable = void 0;
	      var inlineHeader = void 0;
	      var inlineFooter = void 0;
	
	      if (fixedHeader) {
	        headerTable = _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, headerStyle)) },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle },
	            tHead
	          )
	        );
	      } else {
	        inlineHeader = tHead;
	      }
	
	      if (tFoot !== undefined) {
	        if (fixedFooter) {
	          footerTable = _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, footerStyle)) },
	            _react2.default.createElement(
	              'table',
	              { className: className, style: prepareStyles(mergedTableStyle) },
	              tFoot
	            )
	          );
	        } else {
	          inlineFooter = tFoot;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.tableWrapper, wrapperStyle)) },
	        headerTable,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.bodyTable, bodyStyle)), ref: 'tableDiv' },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle, ref: 'tableBody' },
	            inlineHeader,
	            inlineFooter,
	            tBody
	          )
	        ),
	        footerTable
	      );
	    }
	  }]);
	  return Table;
	}(_react.Component);
	
	Table.defaultProps = {
	  allRowsSelected: false,
	  fixedFooter: true,
	  fixedHeader: true,
	  height: 'inherit',
	  multiSelectable: false,
	  selectable: true
	};
	Table.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Table.propTypes = {
	  /**
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the body's table element.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * Children passed to table.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the footer will appear fixed below the table.
	   * The default value is true.
	   */
	  fixedFooter: _react.PropTypes.bool,
	  /**
	   * If true, the header will appear fixed above the table.
	   * The default value is true.
	   */
	  fixedHeader: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the footer's table element.
	   */
	  footerStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the header's table element.
	   */
	  headerStyle: _react.PropTypes.object,
	  /**
	   * The height of the table.
	   */
	  height: _react.PropTypes.string,
	  /**
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _react.PropTypes.bool,
	  /**
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * Called when a row is selected.
	   * selectedRows is an array of all row selections.
	   * IF all rows have been selected, the string "all"
	   * will be returned instead to indicate that all rows have been selected.
	   */
	  onRowSelection: _react.PropTypes.func,
	  /**
	   * If true, table rows can be selected.
	   * If multiple row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the table's wrapper element.
	   */
	  wrapperStyle: _react.PropTypes.object
	} : void 0;
	exports.default = Table;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = undefined;
	
	var _Table2 = __webpack_require__(1014);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(402);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(403);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(404);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(277);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(405);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(195);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.default = _Table3.default;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var inkBar = context.muiTheme.inkBar;
	
	
	  return {
	    root: {
	      left: props.left,
	      width: props.width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: props.color || inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: _transitions2.default.easeOut('1s', 'left')
	    }
	  };
	}
	
	var InkBar = function (_Component) {
	  (0, _inherits3.default)(InkBar, _Component);
	
	  function InkBar() {
	    (0, _classCallCheck3.default)(this, InkBar);
	    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InkBar, [{
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
	    }
	  }]);
	  return InkBar;
	}(_react.Component);
	
	InkBar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? InkBar.propTypes = {
	  color: _react.PropTypes.string,
	  left: _react.PropTypes.string.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  width: _react.PropTypes.string.isRequired
	} : void 0;
	exports.default = InkBar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  width: '100%',
	  position: 'relative',
	  textAlign: 'initial'
	};
	
	var TabTemplate = function TabTemplate(_ref) {
	  var children = _ref.children,
	      selected = _ref.selected,
	      style = _ref.style;
	
	  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
	  if (!selected) {
	    templateStyle.height = 0;
	    templateStyle.overflow = 'hidden';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: templateStyle },
	    children
	  );
	};
	
	process.env.NODE_ENV !== "production" ? TabTemplate.propTypes = {
	  children: _react.PropTypes.node,
	  selected: _react.PropTypes.bool,
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = TabTemplate;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _TabTemplate = __webpack_require__(1017);
	
	var _TabTemplate2 = _interopRequireDefault(_TabTemplate);
	
	var _InkBar = __webpack_require__(1016);
	
	var _InkBar2 = _interopRequireDefault(_InkBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    tabItemContainer: {
	      width: '100%',
	      backgroundColor: tabs.backgroundColor,
	      whiteSpace: 'nowrap',
	      display: 'flex'
	    }
	  };
	}
	
	var Tabs = function (_Component) {
	  (0, _inherits3.default)(Tabs, _Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabTouchTap = function (value, event, tab) {
	      var valueLink = _this.getValueLink(_this.props);
	      var index = tab.props.index;
	
	      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
	        valueLink.requestChange(value, event, tab);
	      }
	
	      _this.setState({ selectedIndex: index });
	
	      if (tab.props.onActive) {
	        tab.props.onActive(tab);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tabs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var valueLink = this.getValueLink(this.props);
	      var initialIndex = this.props.initialSelectedIndex;
	
	      this.setState({
	        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps, nextContext) {
	      var valueLink = this.getValueLink(newProps);
	      var newState = {
	        muiTheme: nextContext.muiTheme || this.context.muiTheme
	      };
	
	      if (valueLink.value !== undefined) {
	        newState.selectedIndex = this.getSelectedIndex(newProps);
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var tabs = [];
	
	      _react.Children.forEach(props.children, function (tab) {
	        if ((0, _react.isValidElement)(tab)) {
	          tabs.push(tab);
	        }
	      });
	
	      return tabs;
	    }
	  }, {
	    key: 'getTabCount',
	    value: function getTabCount() {
	      return this.getTabs().length;
	    }
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	
	  }, {
	    key: 'getValueLink',
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props) {
	      var valueLink = this.getValueLink(props);
	      var selectedIndex = -1;
	
	      this.getTabs(props).forEach(function (tab, index) {
	        if (valueLink.value === tab.props.value) {
	          selectedIndex = index;
	        }
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected(tab, index) {
	      var valueLink = this.getValueLink(this.props);
	      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          contentContainerClassName = _props.contentContainerClassName,
	          contentContainerStyle = _props.contentContainerStyle,
	          initialSelectedIndex = _props.initialSelectedIndex,
	          inkBarStyle = _props.inkBarStyle,
	          onChange = _props.onChange,
	          style = _props.style,
	          tabItemContainerStyle = _props.tabItemContainerStyle,
	          tabTemplate = _props.tabTemplate,
	          tabTemplateStyle = _props.tabTemplateStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var valueLink = this.getValueLink(this.props);
	      var tabValue = valueLink.value;
	      var tabContent = [];
	      var width = 100 / this.getTabCount();
	
	      var tabs = this.getTabs().map(function (tab, index) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;
	
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;
	
	        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
	          key: index,
	          selected: _this2.getSelected(tab, index),
	          style: tabTemplateStyle
	        }, tab.props.children) : undefined);
	
	        return (0, _react.cloneElement)(tab, {
	          key: index,
	          index: index,
	          selected: _this2.getSelected(tab, index),
	          width: width + '%',
	          onTouchTap: _this2.handleTabTouchTap
	        });
	      });
	
	      var inkBar = this.state.selectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
	        left: width * this.state.selectedIndex + '%',
	        width: width + '%',
	        style: inkBarStyle
	      }) : null;
	
	      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
	          tabs
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: inkBarContainerWidth } },
	          inkBar
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
	            className: contentContainerClassName
	          },
	          tabContent
	        )
	      );
	    }
	  }]);
	  return Tabs;
	}(_react.Component);
	
	Tabs.defaultProps = {
	  initialSelectedIndex: 0,
	  onChange: function onChange() {}
	};
	Tabs.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Tabs.propTypes = {
	  /**
	   * Should be used to pass `Tab` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The css class name of the content's container.
	   */
	  contentContainerClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the content's container.
	   */
	  contentContainerStyle: _react.PropTypes.object,
	  /**
	   * Specify initial visible tab index.
	   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
	   * `initialSelectedIndex` will revert back to default.
	   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
	   */
	  initialSelectedIndex: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the InkBar.
	   */
	  inkBarStyle: _react.PropTypes.object,
	  /**
	   * Called when the selected value change.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the tab-labels container.
	   */
	  tabItemContainerStyle: _react.PropTypes.object,
	  /**
	   * Override the default tab template used to wrap the content of each tab element.
	   */
	  tabTemplate: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the tab template.
	   */
	  tabTemplateStyle: _react.PropTypes.object,
	  /**
	   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = Tabs;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Tabs = exports.Tab = undefined;
	
	var _Tab2 = __webpack_require__(406);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Tabs2 = __webpack_require__(1018);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab3.default;
	exports.Tabs = _Tabs3.default;
	exports.default = _Tabs3.default;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(87);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: 'inherit'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'initial'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  (0, _inherits3.default)(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(undefined, event);
	    }, _this.handleChange = function (event) {
	      _this.syncHeightWithShadow(event.target.value);
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.syncHeightWithShadow(nextProps.value);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event) {
	      var shadow = this.refs.shadow;
	
	      if (newValue !== undefined) {
	        shadow.value = newValue;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	      if (newHeight === undefined) return;
	
	      if (this.props.rowsMax >= this.props.rows) {
	        newHeight = Math.min(this.props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        this.setState({
	          height: newHeight
	        });
	
	        if (this.props.onHeightChange) {
	          this.props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onHeightChange = _props.onHeightChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          shadowStyle = _props.shadowStyle,
	          style = _props.style,
	          textareaStyle = _props.textareaStyle,
	          valueLink = _props.valueLink,
	          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'textareaStyle', 'valueLink']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = this.props.valueLink.value;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value,
	          valueLink: this.props.valueLink
	        }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? EnhancedTextarea.propTypes = {
	  defaultValue: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  onHeightChange: _react.PropTypes.func,
	  rows: _react.PropTypes.number,
	  rowsMax: _react.PropTypes.number,
	  shadowStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  textareaStyle: _react.PropTypes.object,
	  value: _react.PropTypes.string,
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = EnhancedTextarea;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(118);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedTextarea = __webpack_require__(1020);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(1022);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(1023);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(1024);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      _context$muiTheme$tex = _context$muiTheme.textField,
	      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
	      focusColor = _context$muiTheme$tex.focusColor,
	      textColor = _context$muiTheme$tex.textColor,
	      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
	      backgroundColor = _context$muiTheme$tex.backgroundColor,
	      errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height'),
	      cursor: props.disabled ? 'not-allowed' : 'auto'
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: props.disabled ? disabledTextColor : floatingLabelColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: 'inherit',
	      font: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    inputNative: {
	      appearance: 'textfield' }
	  };
	
	  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null;
	}
	
	var TextField = function (_Component) {
	  (0, _inherits3.default)(TextField, _Component);
	
	  function TextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleInputChange = function (event) {
	      _this.setState({ hasValue: isValid(event.target.value) });
	      if (_this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          hintText = _props.hintText,
	          floatingLabelText = _props.floatingLabelText,
	          id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value);
	
	        this.setState({
	          hasValue: hasValue
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) {
	        this.getInputNode().blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.getInputNode().focus();
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) {
	        this.getInputNode().select();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          errorStyle = _props2.errorStyle,
	          errorText = _props2.errorText,
	          floatingLabelFixed = _props2.floatingLabelFixed,
	          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
	          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
	          floatingLabelStyle = _props2.floatingLabelStyle,
	          floatingLabelText = _props2.floatingLabelText,
	          fullWidth = _props2.fullWidth,
	          hintText = _props2.hintText,
	          hintStyle = _props2.hintStyle,
	          id = _props2.id,
	          inputStyle = _props2.inputStyle,
	          multiLine = _props2.multiLine,
	          onBlur = _props2.onBlur,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          style = _props2.style,
	          type = _props2.type,
	          underlineDisabledStyle = _props2.underlineDisabledStyle,
	          underlineFocusStyle = _props2.underlineFocusStyle,
	          underlineShow = _props2.underlineShow,
	          underlineStyle = _props2.underlineStyle,
	          rows = _props2.rows,
	          rowsMax = _props2.rowsMax,
	          textareaStyle = _props2.textareaStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
	          shrinkStyle: floatingLabelShrinkStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus
	      };
	
	      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
	          style: childStyleMerged,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
	          rows: rows,
	          rowsMax: rowsMax
	        }, other, inputProps, {
	          onHeightChange: this.handleHeightChange
	        })) : _react2.default.createElement('input', (0, _extends3.default)({
	          type: type,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
	        }, other, inputProps));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	  return TextField;
	}(_react.Component);
	
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TextField.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _react.PropTypes.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override floating label styles when shrunk.
	   */
	  floatingLabelShrinkStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _react.PropTypes.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   *
	   * @param {object} event Change event targeting the text field.
	   * @param {string} newValue The new value of the text field.
	   */
	  onChange: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _react.PropTypes.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _react.PropTypes.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value of the text field.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = TextField;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor,
	      show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles,
	      style = props.style,
	      text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	process.env.NODE_ENV !== "production" ? TextFieldHint.propTypes = {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _react.PropTypes.node
	} : void 0;
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme,
	      className = props.className,
	      children = props.children,
	      htmlFor = props.htmlFor,
	      onTouchTap = props.onTouchTap;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onTouchTap: onTouchTap
	    },
	    children
	  );
	};
	
	process.env.NODE_ENV !== "production" ? TextFieldLabel.propTypes = {
	  /**
	   * The label contents.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _react.PropTypes.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the text field label.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element when shrunk.
	   */
	  shrinkStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled,
	      disabledStyle = props.disabledStyle,
	      error = props.error,
	      errorStyle = props.errorStyle,
	      focus = props.focus,
	      focusStyle = props.focusStyle,
	      muiTheme = props.muiTheme,
	      style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles,
	      _muiTheme$textField = muiTheme.textField,
	      borderColor = _muiTheme$textField.borderColor,
	      disabledTextColor = _muiTheme$textField.disabledTextColor,
	      errorColor = _muiTheme$textField.errorColor,
	      focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      borderTop: 'none',
	      borderLeft: 'none',
	      borderRight: 'none',
	      borderBottom: 'solid 1px',
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottom: 'dotted 2px',
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottom: 'solid 2px',
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { style: prepareStyles(focusedUnderline) })
	  );
	};
	
	process.env.NODE_ENV !== "production" ? TextFieldUnderline.propTypes = propTypes : void 0;
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimeDisplay = __webpack_require__(1028);
	
	var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);
	
	var _ClockHours = __webpack_require__(1026);
	
	var _ClockHours2 = _interopRequireDefault(_ClockHours);
	
	var _ClockMinutes = __webpack_require__(1027);
	
	var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Clock = function (_Component) {
	  (0, _inherits3.default)(Clock, _Component);
	
	  function Clock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Clock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Clock.__proto__ || (0, _getPrototypeOf2.default)(Clock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedTime: null,
	      mode: 'hour'
	    }, _this.setMode = function (mode) {
	      setTimeout(function () {
	        _this.setState({
	          mode: mode
	        });
	      }, 100);
	    }, _this.handleSelectAffix = function (affix) {
	      if (affix === _this.getAffix()) return;
	
	      var hours = _this.state.selectedTime.getHours();
	
	      if (affix === 'am') {
	        _this.handleChangeHours(hours - 12, affix);
	        return;
	      }
	
	      _this.handleChangeHours(hours + 12, affix);
	    }, _this.handleChangeHours = function (hours, finished) {
	      var time = new Date(_this.state.selectedTime);
	      var affix = void 0;
	
	      if (typeof finished === 'string') {
	        affix = finished;
	        finished = undefined;
	      }
	      if (!affix) {
	        affix = _this.getAffix();
	      }
	      if (affix === 'pm' && hours < 12) {
	        hours += 12;
	      }
	
	      time.setHours(hours);
	      _this.setState({
	        selectedTime: time
	      });
	
	      if (finished) {
	        setTimeout(function () {
	          _this.setState({
	            mode: 'minute'
	          });
	
	          var onChangeHours = _this.props.onChangeHours;
	
	          if (onChangeHours) {
	            onChangeHours(time);
	          }
	        }, 100);
	      }
	    }, _this.handleChangeMinutes = function (minutes, finished) {
	      var time = new Date(_this.state.selectedTime);
	      time.setMinutes(minutes);
	      _this.setState({
	        selectedTime: time
	      });
	
	      var onChangeMinutes = _this.props.onChangeMinutes;
	
	      if (onChangeMinutes && finished) {
	        setTimeout(function () {
	          onChangeMinutes(time);
	        }, 0);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Clock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        selectedTime: this.props.initialTime || new Date()
	      });
	    }
	  }, {
	    key: 'getAffix',
	    value: function getAffix() {
	      if (this.props.format !== 'ampm') return '';
	
	      var hours = this.state.selectedTime.getHours();
	      if (hours < 12) {
	        return 'am';
	      }
	
	      return 'pm';
	    }
	  }, {
	    key: 'getSelectedTime',
	    value: function getSelectedTime() {
	      return this.state.selectedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var clock = null;
	
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          userSelect: 'none'
	        },
	        container: {
	          height: 280,
	          padding: 10,
	          position: 'relative',
	          boxSizing: 'content-box'
	        },
	        circle: {
	          position: 'absolute',
	          top: 20,
	          width: 260,
	          height: 260,
	          borderRadius: '100%',
	          backgroundColor: timePicker.clockCircleColor
	        }
	      };
	
	      if (this.state.mode === 'hour') {
	        clock = _react2.default.createElement(_ClockHours2.default, {
	          key: 'hours',
	          format: this.props.format,
	          onChange: this.handleChangeHours,
	          initialHours: this.state.selectedTime.getHours()
	        });
	      } else {
	        clock = _react2.default.createElement(_ClockMinutes2.default, {
	          key: 'minutes',
	          onChange: this.handleChangeMinutes,
	          initialMinutes: this.state.selectedTime.getMinutes()
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_TimeDisplay2.default, {
	          selectedTime: this.state.selectedTime,
	          mode: this.state.mode,
	          format: this.props.format,
	          affix: this.getAffix(),
	          onSelectAffix: this.handleSelectAffix,
	          onSelectHour: this.setMode.bind(this, 'hour'),
	          onSelectMin: this.setMode.bind(this, 'minute')
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.container) },
	          _react2.default.createElement('div', { style: prepareStyles(styles.circle) }),
	          clock
	        )
	      );
	    }
	  }]);
	  return Clock;
	}(_react.Component);
	
	Clock.defaultProps = {
	  initialTime: new Date()
	};
	Clock.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Clock.propTypes = {
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialTime: _react.PropTypes.object,
	  onChangeHours: _react.PropTypes.func,
	  onChangeMinutes: _react.PropTypes.func
	} : void 0;
	exports.default = Clock;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ClockNumber = __webpack_require__(407);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(408);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockHours = function (_Component) {
	  (0, _inherits3.default)(ClockHours, _Component);
	
	  function ClockHours() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockHours);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockHours.__proto__ || (0, _getPrototypeOf2.default)(ClockHours)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) return;
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouchMove = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], false);
	    }, _this.handleTouchEnd = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], true);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockHours, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var hours = this.getHours(event.offsetX, event.offsetY);
	
	      this.props.onChange(hours, finish);
	    }
	  }, {
	    key: 'getHours',
	    value: function getHours(offsetX, offsetY) {
	      var step = 30;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      var delta = Math.pow(x, 2) + Math.pow(y, 2);
	      var distance = Math.sqrt(delta);
	
	      value = value || 12;
	      if (this.props.format === '24hr') {
	        if (distance < 90) {
	          value += 12;
	          value %= 24;
	        }
	      } else {
	        value %= 12;
	      }
	
	      return value;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      var hour = this.props.initialHours;
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      return hour;
	    }
	  }, {
	    key: 'getHourNumbers',
	    value: function getHourNumbers() {
	      var _this2 = this;
	
	      var style = {
	        pointerEvents: 'none'
	      };
	      var hourSize = this.props.format === 'ampm' ? 12 : 24;
	
	      var hours = [];
	      for (var i = 1; i <= hourSize; i++) {
	        hours.push(i % 24);
	      }
	
	      return hours.map(function (hour) {
	        var isSelected = _this2.getSelected() === hour;
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: hour,
	          style: style,
	          isSelected: isSelected,
	          type: 'hour',
	          value: hour
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var hours = this.getSelected();
	      var numbers = this.getHourNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { hasSelected: true, value: hours, type: 'hour' }),
	        numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask', style: prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockHours;
	}(_react.Component);
	
	ClockHours.defaultProps = {
	  initialHours: new Date().getHours(),
	  onChange: function onChange() {},
	  format: 'ampm'
	};
	ClockHours.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ClockHours.propTypes = {
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialHours: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	} : void 0;
	exports.default = ClockHours;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClockNumber = __webpack_require__(407);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(408);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockMinutes = function (_Component) {
	  (0, _inherits3.default)(ClockMinutes, _Component);
	
	  function ClockMinutes() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockMinutes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockMinutes.__proto__ || (0, _getPrototypeOf2.default)(ClockMinutes)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) {
	        return;
	      }
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouch = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], event.type === 'touchend');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockMinutes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = this.refs.mask;
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var minutes = this.getMinutes(event.offsetX, event.offsetY);
	
	      this.props.onChange(minutes, finish);
	    }
	  }, {
	    key: 'getMinutes',
	    value: function getMinutes(offsetX, offsetY) {
	      var step = 6;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      return value;
	    }
	  }, {
	    key: 'getMinuteNumbers',
	    value: function getMinuteNumbers() {
	      var minutes = [];
	      for (var i = 0; i < 12; i++) {
	        minutes.push(i * 5);
	      }
	      var selectedMinutes = this.props.initialMinutes;
	      var hasSelected = false;
	
	      var numbers = minutes.map(function (minute) {
	        var isSelected = selectedMinutes === minute;
	        if (isSelected) {
	          hasSelected = true;
	        }
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: minute,
	          isSelected: isSelected,
	          type: 'minute',
	          value: minute
	        });
	      });
	
	      return {
	        numbers: numbers,
	        hasSelected: hasSelected,
	        selected: selectedMinutes
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var minutes = this.getMinuteNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { value: minutes.selected, type: 'minute', hasSelected: minutes.hasSelected }),
	        minutes.numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask',
	          style: prepareStyles(styles.hitMask),
	          onTouchMove: this.handleTouch,
	          onTouchEnd: this.handleTouch,
	          onMouseUp: this.handleUp,
	          onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockMinutes;
	}(_react.Component);
	
	ClockMinutes.defaultProps = {
	  initialMinutes: new Date().getMinutes(),
	  onChange: function onChange() {}
	};
	ClockMinutes.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ClockMinutes.propTypes = {
	  initialMinutes: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	} : void 0;
	exports.default = ClockMinutes;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(223);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeDisplay = function (_Component) {
	  (0, _inherits3.default)(TimeDisplay, _Component);
	
	  function TimeDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimeDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeDisplay.__proto__ || (0, _getPrototypeOf2.default)(TimeDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimeDisplay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTime !== this.props.selectedTime) {
	        var direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';
	
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'sanitizeTime',
	    value: function sanitizeTime() {
	      var hour = this.props.selectedTime.getHours();
	      var min = this.props.selectedTime.getMinutes().toString();
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      hour = hour.toString();
	      if (hour.length < 2) hour = '0' + hour;
	      if (min.length < 2) min = '0' + min;
	
	      return [hour, min];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          affix = _props.affix,
	          format = _props.format,
	          mode = _props.mode,
	          onSelectAffix = _props.onSelectAffix,
	          onSelectHour = _props.onSelectHour,
	          onSelectMin = _props.onSelectMin,
	          selectedTime = _props.selectedTime,
	          other = (0, _objectWithoutProperties3.default)(_props, ['affix', 'format', 'mode', 'onSelectAffix', 'onSelectHour', 'onSelectMin', 'selectedTime']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          padding: '14px 0',
	          borderTopLeftRadius: 2,
	          borderTopRightRadius: 2,
	          backgroundColor: timePicker.headerColor,
	          color: timePicker.textColor
	        },
	        text: {
	          margin: '6px 0',
	          lineHeight: '58px',
	          height: 58,
	          fontSize: 58,
	          display: 'flex',
	          justifyContent: 'center',
	          alignItems: 'baseline'
	        },
	        time: {
	          margin: '0 10px'
	        },
	        affix: {
	          flex: 1,
	          position: 'relative',
	          lineHeight: '17px',
	          height: 17,
	          fontSize: 17
	        },
	        affixTop: {
	          position: 'absolute',
	          top: -20,
	          left: 0
	        },
	        clickable: {
	          cursor: 'pointer'
	        },
	        inactive: {
	          opacity: 0.7
	        }
	      };
	
	      var _sanitizeTime = this.sanitizeTime(),
	          _sanitizeTime2 = (0, _slicedToArray3.default)(_sanitizeTime, 2),
	          hour = _sanitizeTime2[0],
	          min = _sanitizeTime2[1];
	
	      var buttons = [];
	      if (format === 'ampm') {
	        buttons = [_react2.default.createElement(
	          'div',
	          {
	            key: 'pm',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, affix === 'pm' ? {} : styles.inactive)),
	            onTouchTap: function onTouchTap() {
	              return onSelectAffix('pm');
	            }
	          },
	          'PM'
	        ), _react2.default.createElement(
	          'div',
	          {
	            key: 'am',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.affixTop, styles.clickable, affix === 'am' ? {} : styles.inactive)),
	            onTouchTap: function onTouchTap() {
	              return onSelectAffix('am');
	            }
	          },
	          'AM'
	        )];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.text) },
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.time) },
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'hour' ? {} : styles.inactive)),
	                onTouchTap: onSelectHour
	              },
	              hour
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'minute' ? {} : styles.inactive)),
	                onTouchTap: onSelectMin
	              },
	              min
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) },
	            buttons
	          )
	        )
	      );
	    }
	  }]);
	  return TimeDisplay;
	}(_react.Component);
	
	TimeDisplay.defaultProps = {
	  affix: '',
	  mode: 'hour'
	};
	TimeDisplay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TimeDisplay.propTypes = {
	  affix: _react.PropTypes.oneOf(['', 'pm', 'am']),
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  mode: _react.PropTypes.oneOf(['hour', 'minute']),
	  onSelectAffix: _react.PropTypes.func,
	  onSelectHour: _react.PropTypes.func,
	  onSelectMin: _react.PropTypes.func,
	  selectedTime: _react.PropTypes.object.isRequired
	} : void 0;
	exports.default = TimeDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimePickerDialog = __webpack_require__(1030);
	
	var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);
	
	var _TextField = __webpack_require__(163);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _timeUtils = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyTime = new Date();
	emptyTime.setHours(0);
	emptyTime.setMinutes(0);
	emptyTime.setSeconds(0);
	emptyTime.setMilliseconds(0);
	
	var TimePicker = function (_Component) {
	  (0, _inherits3.default)(TimePicker, _Component);
	
	  function TimePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePicker.__proto__ || (0, _getPrototypeOf2.default)(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      time: null,
	      dialogTime: new Date()
	    }, _this.handleAcceptDialog = function (time) {
	      _this.setState({
	        time: time
	      });
	      if (_this.props.onChange) _this.props.onChange(null, time);
	    }, _this.handleFocusInput = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTapInput = function (event) {
	      event.preventDefault();
	
	      if (!_this.props.disabled) {
	        _this.openDialog();
	      }
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        time: this.isControlled() ? this.getControlledTime() : this.props.defaultTime
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({
	          time: this.getControlledTime(nextProps)
	        });
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      this.setState({
	        dialogTime: this.state.time
	      });
	      this.refs.dialogWindow.show();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.value !== null;
	    }
	  }, {
	    key: 'getControlledTime',
	    value: function getControlledTime() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var result = null;
	      if (props.value instanceof Date) {
	        result = props.value;
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          defaultTime = _props.defaultTime,
	          dialogBodyStyle = _props.dialogBodyStyle,
	          dialogStyle = _props.dialogStyle,
	          format = _props.format,
	          okLabel = _props.okLabel,
	          onFocus = _props.onFocus,
	          onTouchTap = _props.onTouchTap,
	          onShow = _props.onShow,
	          onDismiss = _props.onDismiss,
	          pedantic = _props.pedantic,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoOk', 'cancelLabel', 'defaultTime', 'dialogBodyStyle', 'dialogStyle', 'format', 'okLabel', 'onFocus', 'onTouchTap', 'onShow', 'onDismiss', 'pedantic', 'style', 'textFieldStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var time = this.state.time;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          style: textFieldStyle,
	          ref: 'input',
	          value: time === emptyTime ? null : (0, _timeUtils.formatTime)(time, format, pedantic),
	          onFocus: this.handleFocusInput,
	          onTouchTap: this.handleTouchTapInput
	        })),
	        _react2.default.createElement(_TimePickerDialog2.default, {
	          ref: 'dialogWindow',
	          bodyStyle: dialogBodyStyle,
	          initialTime: this.state.dialogTime,
	          onAccept: this.handleAcceptDialog,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          format: format,
	          okLabel: okLabel,
	          cancelLabel: cancelLabel,
	          autoOk: autoOk,
	          style: dialogStyle
	        })
	      );
	    }
	  }]);
	  return TimePicker;
	}(_react.Component);
	
	TimePicker.defaultProps = {
	  autoOk: false,
	  cancelLabel: 'Cancel',
	  defaultTime: null,
	  disabled: false,
	  format: 'ampm',
	  okLabel: 'OK',
	  pedantic: false,
	  style: {},
	  value: null
	};
	TimePicker.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TimePicker.propTypes = {
	  /**
	   * If true, automatically accept and close the picker on set minutes.
	   */
	  autoOk: _react.PropTypes.bool,
	  /**
	   * Override the label of the 'Cancel' button.
	   */
	  cancelLabel: _react.PropTypes.node,
	  /**
	   * The initial time value of the TimePicker.
	   */
	  defaultTime: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's body element.
	   */
	  dialogBodyStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's root element.
	   */
	  dialogStyle: _react.PropTypes.object,
	  /**
	   * If true, the TimePicker is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Tells the component to display the picker in `ampm` (12hr) format or `24hr` format.
	   */
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  /**
	   * Override the label of the 'OK' button.
	   */
	  okLabel: _react.PropTypes.node,
	  /**
	   * Callback function that is fired when the time value changes. The time value is passed in a Date Object.
	   * Since there is no particular event associated with the change the first argument will always be null
	   * and the second argument will be the new Date instance.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker dialog is dismissed.
	   */
	  onDismiss: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker `TextField` gains focus.
	   */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker dialog is shown.
	   */
	  onShow: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker is tapped or clicked.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, uses ("noon" / "midnight") instead of ("12 a.m." / "12 p.m.").
	   *
	   * It's technically more correct to refer to "12 noon" and "12 midnight" rather than "12 a.m." and "12 p.m."
	   * and it avoids confusion between different locales. By default (for compatibility reasons) TimePicker uses
	   * ("12 a.m." / "12 p.m.").
	   */
	  pedantic: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePicker's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object,
	  /**
	   * Sets the time for the Time Picker programmatically.
	   */
	  value: _react.PropTypes.object
	} : void 0;
	exports.default = TimePicker;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(87);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Clock = __webpack_require__(1025);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _Dialog = __webpack_require__(270);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(193);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimePickerDialog = function (_Component) {
	  (0, _inherits3.default)(TimePickerDialog, _Component);
	
	  function TimePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(TimePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOK = function () {
	      if (_this.props.onAccept) {
	        _this.props.onAccept(_this.refs.clock.getSelectedTime());
	      }
	      _this.setState({
	        open: false
	      });
	    }, _this.handleKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOK();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePickerDialog, [{
	    key: 'show',
	    value: function show() {
	      if (this.props.onShow && !this.state.open) this.props.onShow();
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      if (this.props.onDismiss && this.state.open) this.props.onDismiss();
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bodyStyle = _props.bodyStyle,
	          initialTime = _props.initialTime,
	          onAccept = _props.onAccept,
	          format = _props.format,
	          autoOk = _props.autoOk,
	          okLabel = _props.okLabel,
	          cancelLabel = _props.cancelLabel,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['bodyStyle', 'initialTime', 'onAccept', 'format', 'autoOk', 'okLabel', 'cancelLabel', 'style']);
	
	
	      var styles = {
	        root: {
	          fontSize: 14,
	          color: this.context.muiTheme.timePicker.clockColor
	        },
	        dialogContent: {
	          width: 280
	        },
	        body: {
	          padding: 0
	        }
	      };
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        key: 0,
	        label: cancelLabel,
	        primary: true,
	        onTouchTap: this.handleTouchTapCancel
	      }), _react2.default.createElement(_FlatButton2.default, {
	        key: 1,
	        label: okLabel,
	        primary: true,
	        onTouchTap: this.handleTouchTapOK
	      })];
	
	      var onClockChangeMinutes = autoOk === true ? this.handleTouchTapOK : undefined;
	      var open = this.state.open;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          bodyStyle: (0, _simpleAssign2.default)(styles.body, bodyStyle),
	          actions: actions,
	          contentStyle: styles.dialogContent,
	          repositionOnUpdate: false,
	          open: open,
	          onRequestClose: this.handleRequestClose
	        }),
	        open && _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        open && _react2.default.createElement(_Clock2.default, {
	          ref: 'clock',
	          format: format,
	          initialTime: initialTime,
	          onChangeMinutes: onClockChangeMinutes
	        })
	      );
	    }
	  }]);
	  return TimePickerDialog;
	}(_react.Component);
	
	TimePickerDialog.defaultProps = {
	  okLabel: 'OK',
	  cancelLabel: 'Cancel'
	};
	TimePickerDialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? TimePickerDialog.propTypes = {
	  autoOk: _react.PropTypes.bool,
	  bodyStyle: _react.PropTypes.object,
	  cancelLabel: _react.PropTypes.node,
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialTime: _react.PropTypes.object,
	  okLabel: _react.PropTypes.node,
	  onAccept: _react.PropTypes.func,
	  onDismiss: _react.PropTypes.func,
	  onShow: _react.PropTypes.func,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TimePickerDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TimePicker = __webpack_require__(1029);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TimePicker2.default;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(52);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _EnhancedSwitch = __webpack_require__(279);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var disabled = props.disabled,
	      elementStyle = props.elementStyle,
	      trackSwitchedStyle = props.trackSwitchedStyle,
	      thumbSwitchedStyle = props.thumbSwitchedStyle,
	      trackStyle = props.trackStyle,
	      thumbStyle = props.thumbStyle,
	      iconStyle = props.iconStyle,
	      rippleStyle = props.rippleStyle,
	      labelStyle = props.labelStyle;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toggle = _context$muiTheme.toggle;
	
	
	  var toggleSize = 20;
	  var toggleTrackWidth = 36;
	  var styles = {
	    icon: {
	      width: 36,
	      padding: '4px 0px 6px 2px'
	    },
	    ripple: {
	      top: -10,
	      left: -10,
	      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
	    },
	    toggleElement: {
	      width: toggleTrackWidth
	    },
	    track: {
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      height: 14,
	      borderRadius: 30,
	      backgroundColor: toggle.trackOffColor
	    },
	    thumb: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      top: 1,
	      left: 0,
	      width: toggleSize,
	      height: toggleSize,
	      lineHeight: '24px',
	      borderRadius: '50%',
	      backgroundColor: toggle.thumbOffColor
	    },
	    trackWhenSwitched: {
	      backgroundColor: toggle.trackOnColor
	    },
	    thumbWhenSwitched: {
	      backgroundColor: toggle.thumbOnColor,
	      left: '100%'
	    },
	    trackWhenDisabled: {
	      backgroundColor: toggle.trackDisabledColor
	    },
	    thumbWhenDisabled: {
	      backgroundColor: toggle.thumbDisabledColor
	    },
	    label: {
	      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
	      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
	    }
	  };
	
	  (0, _simpleAssign2.default)(styles.track, trackStyle, state.switched && styles.trackWhenSwitched, state.switched && trackSwitchedStyle, disabled && styles.trackWhenDisabled);
	
	  (0, _simpleAssign2.default)(styles.thumb, thumbStyle, state.switched && styles.thumbWhenSwitched, state.switched && thumbSwitchedStyle, disabled && styles.thumbWhenDisabled);
	
	  if (state.switched) {
	    styles.thumb.marginLeft = 0 - styles.thumb.width;
	  }
	
	  (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	  (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	  (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	  (0, _simpleAssign2.default)(styles.toggleElement, elementStyle);
	
	  return styles;
	}
	
	var Toggle = function (_Component) {
	  (0, _inherits3.default)(Toggle, _Component);
	
	  function Toggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Toggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleToggle = function (event, isInputChecked) {
	      if (_this.props.onToggle) {
	        _this.props.onToggle(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Toggle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          toggled = _props.toggled,
	          defaultToggled = _props.defaultToggled,
	          valueLink = _props.valueLink;
	
	
	      if (toggled || defaultToggled || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'isToggled',
	    value: function isToggled() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setToggled',
	    value: function setToggled(newToggledValue) {
	      this.refs.enhancedSwitch.setSwitched(newToggledValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          defaultToggled = _props2.defaultToggled,
	          elementStyle = _props2.elementStyle,
	          onToggle = _props2.onToggle,
	          trackSwitchedStyle = _props2.trackSwitchedStyle,
	          thumbSwitchedStyle = _props2.thumbSwitchedStyle,
	          toggled = _props2.toggled,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['defaultToggled', 'elementStyle', 'onToggle', 'trackSwitchedStyle', 'thumbSwitchedStyle', 'toggled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var toggleElement = _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, styles.toggleElement)) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.track)) }),
	        _react2.default.createElement(_Paper2.default, { style: styles.thumb, circle: true, zDepth: 1 })
	      );
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switchElement: toggleElement,
	        rippleStyle: styles.ripple,
	        rippleColor: styles.ripple.color,
	        iconStyle: styles.icon,
	        trackStyle: styles.track,
	        thumbStyle: styles.thumb,
	        labelStyle: styles.label,
	        switched: this.state.switched,
	        onSwitch: this.handleToggle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      if (this.props.hasOwnProperty('toggled')) {
	        enhancedSwitchProps.checked = toggled;
	      } else if (this.props.hasOwnProperty('defaultToggled')) {
	        enhancedSwitchProps.defaultChecked = defaultToggled;
	      }
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Toggle;
	}(_react.Component);
	
	Toggle.defaultProps = {
	  defaultToggled: false,
	  disabled: false,
	  labelPosition: 'left'
	};
	Toggle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Toggle.propTypes = {
	  /**
	   * Determines whether the Toggle is initially turned on.
	   * **Warning:** This cannot be used in conjunction with `toggled`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultToggled: _react.PropTypes.bool,
	  /**
	   * Will disable the toggle if true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the inline-styles of the Toggle element.
	   */
	  elementStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the Icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * Label for toggle.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * Where the label will be placed next to the toggle.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Toggle element label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function that is fired when the toggle switch is toggled.
	   */
	  onToggle: _react.PropTypes.func,
	  /**
	   * Override style of ripple.
	   */
	  rippleStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override style for thumb.
	   */
	  thumbStyle: _react.PropTypes.object,
	  /**
	  * Override the inline styles for thumb when the toggle switch is toggled on.
	  */
	  thumbSwitchedStyle: _react.PropTypes.object,
	  /**
	   * Toggled if set to true.
	   */
	  toggled: _react.PropTypes.bool,
	  /**
	   * Override style for track.
	   */
	  trackStyle: _react.PropTypes.object,
	  /**
	  * Override the inline styles for track when the toggle switch is toggled on.
	  */
	  trackSwitchedStyle: _react.PropTypes.object,
	  /**
	   * ValueLink prop for when using controlled toggle.
	   */
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = Toggle;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Toggle = __webpack_require__(1032);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toggle2.default;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var noGutter = props.noGutter;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      backgroundColor: toolbar.backgroundColor,
	      height: toolbar.height,
	      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
	      display: 'flex',
	      justifyContent: 'space-between'
	    }
	  };
	}
	
	var Toolbar = function (_Component) {
	  (0, _inherits3.default)(Toolbar, _Component);
	
	  function Toolbar() {
	    (0, _classCallCheck3.default)(this, Toolbar);
	    return (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          noGutter = _props.noGutter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'noGutter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Toolbar;
	}(_react.Component);
	
	Toolbar.defaultProps = {
	  noGutter: false
	};
	Toolbar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? Toolbar.propTypes = {
	  /**
	   * Can be a `ToolbarGroup` to render a group of related items.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Do not apply `desktopGutter` to the `Toolbar`.
	   */
	  noGutter: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Toolbar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;
	
	var _Toolbar2 = __webpack_require__(1034);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(409);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(410);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(411);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;
	exports.default = _Toolbar3.default;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = exports.Toggle = exports.TimePicker = exports.TextField = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = exports.Tab = exports.Tabs = exports.Snackbar = exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = exports.SvgIcon = exports.Subheader = exports.Slider = exports.SelectField = exports.RefreshIndicator = exports.RaisedButton = exports.RadioButtonGroup = exports.RadioButton = exports.Popover = exports.Paper = exports.MuiThemeProvider = exports.MenuItem = exports.Menu = exports.makeSelectable = exports.ListItem = exports.List = exports.LinearProgress = exports.IconMenu = exports.IconButton = exports.GridTile = exports.GridList = exports.FontIcon = exports.FloatingActionButton = exports.FlatButton = exports.DropDownMenu = exports.Drawer = exports.Divider = exports.Dialog = exports.DatePicker = exports.CircularProgress = exports.Chip = exports.Checkbox = exports.CardText = exports.CardTitle = exports.CardMedia = exports.CardHeader = exports.CardActions = exports.Card = exports.BottomNavigationItem = exports.BottomNavigation = exports.Badge = exports.Avatar = exports.AutoComplete = exports.AppBar = undefined;
	
	var _AppBar2 = __webpack_require__(946);
	
	var _AppBar3 = _interopRequireDefault(_AppBar2);
	
	var _AutoComplete2 = __webpack_require__(948);
	
	var _AutoComplete3 = _interopRequireDefault(_AutoComplete2);
	
	var _Avatar2 = __webpack_require__(385);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	var _Badge2 = __webpack_require__(951);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _BottomNavigation2 = __webpack_require__(953);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(386);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	var _Card2 = __webpack_require__(955);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardActions2 = __webpack_require__(387);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardHeader2 = __webpack_require__(389);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardMedia2 = __webpack_require__(390);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardTitle2 = __webpack_require__(392);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardText2 = __webpack_require__(391);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _Checkbox2 = __webpack_require__(269);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Chip2 = __webpack_require__(958);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	var _CircularProgress2 = __webpack_require__(960);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	var _DatePicker2 = __webpack_require__(971);
	
	var _DatePicker3 = _interopRequireDefault(_DatePicker2);
	
	var _Dialog2 = __webpack_require__(270);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	var _Divider2 = __webpack_require__(393);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	var _Drawer2 = __webpack_require__(975);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	var _DropDownMenu2 = __webpack_require__(394);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _FlatButton2 = __webpack_require__(193);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _FloatingActionButton2 = __webpack_require__(980);
	
	var _FloatingActionButton3 = _interopRequireDefault(_FloatingActionButton2);
	
	var _FontIcon2 = __webpack_require__(271);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	var _GridList2 = __webpack_require__(983);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(395);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	var _IconButton2 = __webpack_require__(135);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	var _IconMenu2 = __webpack_require__(986);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _LinearProgress2 = __webpack_require__(988);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _List2 = __webpack_require__(990);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(273);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(396);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	var _Menu2 = __webpack_require__(397);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(275);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _MuiThemeProvider2 = __webpack_require__(416);
	
	var _MuiThemeProvider3 = _interopRequireDefault(_MuiThemeProvider2);
	
	var _Paper2 = __webpack_require__(52);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	var _Popover2 = __webpack_require__(994);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _RadioButton2 = __webpack_require__(399);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(398);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	var _RaisedButton2 = __webpack_require__(997);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _RefreshIndicator2 = __webpack_require__(999);
	
	var _RefreshIndicator3 = _interopRequireDefault(_RefreshIndicator2);
	
	var _SelectField2 = __webpack_require__(1001);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	var _Slider2 = __webpack_require__(1003);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	var _Subheader2 = __webpack_require__(401);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	var _SvgIcon2 = __webpack_require__(38);
	
	var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);
	
	var _Step2 = __webpack_require__(1007);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(1008);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(1010);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(400);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(1011);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	var _Snackbar2 = __webpack_require__(1006);
	
	var _Snackbar3 = _interopRequireDefault(_Snackbar2);
	
	var _Tabs2 = __webpack_require__(1019);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(406);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Table2 = __webpack_require__(1015);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(402);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(403);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(404);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(277);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(405);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(195);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	var _TextField2 = __webpack_require__(163);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	var _TimePicker2 = __webpack_require__(1031);
	
	var _TimePicker3 = _interopRequireDefault(_TimePicker2);
	
	var _Toggle2 = __webpack_require__(1033);
	
	var _Toggle3 = _interopRequireDefault(_Toggle2);
	
	var _Toolbar2 = __webpack_require__(1035);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(409);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(410);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(411);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppBar = _AppBar3.default;
	exports.AutoComplete = _AutoComplete3.default;
	exports.Avatar = _Avatar3.default;
	exports.Badge = _Badge3.default;
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.Card = _Card3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardText = _CardText3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Chip = _Chip3.default;
	exports.CircularProgress = _CircularProgress3.default;
	exports.DatePicker = _DatePicker3.default;
	exports.Dialog = _Dialog3.default;
	exports.Divider = _Divider3.default;
	exports.Drawer = _Drawer3.default;
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.FloatingActionButton = _FloatingActionButton3.default;
	exports.FontIcon = _FontIcon3.default;
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.IconButton = _IconButton3.default;
	exports.IconMenu = _IconMenu3.default;
	exports.LinearProgress = _LinearProgress3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.MuiThemeProvider = _MuiThemeProvider3.default;
	exports.Paper = _Paper3.default;
	exports.Popover = _Popover3.default;
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.RefreshIndicator = _RefreshIndicator3.default;
	exports.SelectField = _SelectField3.default;
	exports.Slider = _Slider3.default;
	exports.Subheader = _Subheader3.default;
	exports.SvgIcon = _SvgIcon3.default;
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;
	exports.Snackbar = _Snackbar3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.TextField = _TextField3.default;
	exports.TimePicker = _TimePicker3.default;
	exports.Toggle = _Toggle3.default;
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var originalBodyOverflow = null;
	var lockingCounter = 0;
	
	var AutoLockScrolling = function (_Component) {
	  (0, _inherits3.default)(AutoLockScrolling, _Component);
	
	  function AutoLockScrolling() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoLockScrolling);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoLockScrolling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.lock === true) {
	        this.preventScrolling();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.lock !== nextProps.lock) {
	        if (nextProps.lock) {
	          this.preventScrolling();
	        } else {
	          this.allowScrolling();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.allowScrolling();
	    }
	
	    // force to only lock/unlock once
	
	  }, {
	    key: 'preventScrolling',
	    value: function preventScrolling() {
	      if (this.locked === true) {
	        return;
	      }
	
	      lockingCounter = lockingCounter + 1;
	      this.locked = true;
	
	      // only lock the first time the component is mounted.
	      if (lockingCounter === 1) {
	        var body = document.getElementsByTagName('body')[0];
	        originalBodyOverflow = body.style.overflow;
	        body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'allowScrolling',
	    value: function allowScrolling() {
	      if (this.locked === true) {
	        lockingCounter = lockingCounter - 1;
	        this.locked = false;
	      }
	
	      if (lockingCounter === 0 && originalBodyOverflow !== null) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflow = originalBodyOverflow || '';
	        originalBodyOverflow = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return AutoLockScrolling;
	}(_react.Component);
	
	process.env.NODE_ENV !== "production" ? AutoLockScrolling.propTypes = {
	  lock: _react.PropTypes.bool.isRequired
	} : void 0;
	exports.default = AutoLockScrolling;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var styles = {
	  box: {
	    boxSizing: 'border-box'
	  }
	};
	
	var BeforeAfterWrapper = function (_Component) {
	  (0, _inherits3.default)(BeforeAfterWrapper, _Component);
	
	  function BeforeAfterWrapper() {
	    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BeforeAfterWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          beforeStyle = _props.beforeStyle,
	          afterStyle = _props.afterStyle,
	          beforeElementType = _props.beforeElementType,
	          afterElementType = _props.afterElementType,
	          elementType = _props.elementType,
	          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var beforeElement = void 0;
	      var afterElement = void 0;
	
	      if (beforeStyle) {
	        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
	          key: '::before'
	        });
	      }
	
	      if (afterStyle) {
	        afterElement = _react2.default.createElement(this.props.afterElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
	          key: '::after'
	        });
	      }
	
	      var children = [beforeElement, this.props.children, afterElement];
	
	      var props = other;
	      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));
	
	      return _react2.default.createElement(this.props.elementType, props, children);
	    }
	  }]);
	  return BeforeAfterWrapper;
	}(_react.Component);
	
	BeforeAfterWrapper.defaultProps = {
	  beforeElementType: 'div',
	  afterElementType: 'div',
	  elementType: 'div'
	};
	BeforeAfterWrapper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? BeforeAfterWrapper.propTypes = {
	  afterElementType: _react.PropTypes.string,
	  afterStyle: _react.PropTypes.object,
	  beforeElementType: _react.PropTypes.string,
	  beforeStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  elementType: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = BeforeAfterWrapper;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(118);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(114);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleRipple = function (_Component) {
	  (0, _inherits3.default)(CircleRipple, _Component);
	
	  function CircleRipple() {
	    (0, _classCallCheck3.default)(this, CircleRipple);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          aborted = _props.aborted,
	          color = _props.color,
	          opacity = _props.opacity,
	          style = _props.style,
	          touchGenerated = _props.touchGenerated,
	          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? CircleRipple.propTypes = {
	  aborted: _react.PropTypes.bool,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  touchGenerated: _react.PropTypes.bool
	} : void 0;
	exports.default = CircleRipple;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BeforeAfterWrapper = __webpack_require__(1038);
	
	var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style,
	      children = _ref.children,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
	  return _react2.default.createElement(
	    _BeforeAfterWrapper2.default,
	    (0, _extends3.default)({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.muiName = 'ClearFix';
	
	process.env.NODE_ENV !== "production" ? ClearFix.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = ClearFix;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(166);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(1042);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandTransition = function (_Component) {
	  (0, _inherits3.default)(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    (0, _classCallCheck3.default)(this, ExpandTransition);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransition.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          enterDelay = _props2.enterDelay,
	          loading = _props2.loading,
	          open = _props2.open,
	          style = _props2.style,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: 'auto'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ExpandTransition.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  loading: _react.PropTypes.bool,
	  open: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = ExpandTransition;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  (0, _inherits3.default)(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    (0, _classCallCheck3.default)(this, ExpandTransitionChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransitionChild.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransitionChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this),
	          style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          enterDelay = _props3.enterDelay,
	          style = _props3.style,
	          transitionDelay = _props3.transitionDelay,
	          transitionDuration = _props3.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ExpandTransitionChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = ExpandTransitionChild;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(166);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ScaleInChild = __webpack_require__(1044);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleIn = function (_Component) {
	  (0, _inherits3.default)(ScaleIn, _Component);
	
	  function ScaleIn() {
	    (0, _classCallCheck3.default)(this, ScaleIn);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ScaleIn.propTypes = {
	  childStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ScaleIn;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(114);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInChild = function (_Component) {
	  (0, _inherits3.default)(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    (0, _classCallCheck3.default)(this, ScaleInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? ScaleInChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ScaleInChild;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(114);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideInChild = function (_Component) {
	  (0, _inherits3.default)(SlideInChild, _Component);
	
	  function SlideInChild() {
	    (0, _classCallCheck3.default)(this, SlideInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (SlideInChild.__proto__ || (0, _getPrototypeOf2.default)(SlideInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SlideInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
	      var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'translate(0,0)');
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var direction = this.props.getLeaveDirection();
	      var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
	      var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          getLeaveDirection = _props.getLeaveDirection,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return SlideInChild;
	}(_react.Component);
	
	SlideInChild.defaultProps = {
	  enterDelay: 0
	};
	SlideInChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	process.env.NODE_ENV !== "production" ? SlideInChild.propTypes = {
	  children: _react.PropTypes.node,
	  direction: _react.PropTypes.string,
	  enterDelay: _react.PropTypes.number,
	  // This callback is needed bacause the direction could change when leaving the DOM
	  getLeaveDirection: _react.PropTypes.func.isRequired,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = SlideInChild;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(196);
	
	var _colorManipulator = __webpack_require__(85);
	
	var _spacing = __webpack_require__(418);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _colors = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Typography = function Typography() {
	  (0, _classCallCheck3.default)(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	  );
	};
	HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
	HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
	HardwareKeyboardArrowDown.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowDown;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	  );
	};
	HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
	HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
	HardwareKeyboardArrowUp.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowUp;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	  );
	};
	NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
	NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
	NavigationArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDown;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCancel = function NavigationCancel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
	  );
	};
	NavigationCancel = (0, _pure2.default)(NavigationCancel);
	NavigationCancel.displayName = 'NavigationCancel';
	NavigationCancel.muiName = 'SvgIcon';
	
	exports.default = NavigationCancel;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronLeft = function NavigationChevronLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
	NavigationChevronLeft.displayName = 'NavigationChevronLeft';
	NavigationChevronLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronLeft;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronRight = function NavigationChevronRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
	NavigationChevronRight.displayName = 'NavigationChevronRight';
	NavigationChevronRight.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronRight;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMenu = function NavigationMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	  );
	};
	NavigationMenu = (0, _pure2.default)(NavigationMenu);
	NavigationMenu.displayName = 'NavigationMenu';
	NavigationMenu.muiName = 'SvgIcon';
	
	exports.default = NavigationMenu;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
	ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
	ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBoxOutlineBlank;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = function ToggleCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
	ToggleCheckBox.displayName = 'ToggleCheckBox';
	ToggleCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBox;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonChecked = function ToggleRadioButtonChecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonChecked = (0, _pure2.default)(ToggleRadioButtonChecked);
	ToggleRadioButtonChecked.displayName = 'ToggleRadioButtonChecked';
	ToggleRadioButtonChecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonChecked;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(40);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(38);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonUnchecked = function ToggleRadioButtonUnchecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonUnchecked = (0, _pure2.default)(ToggleRadioButtonUnchecked);
	ToggleRadioButtonUnchecked.displayName = 'ToggleRadioButtonUnchecked';
	ToggleRadioButtonUnchecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonUnchecked;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(100);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = function (muiTheme) {
	  var isClient = typeof navigator !== 'undefined';
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && isClient) {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	    process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
	      var stylePrefixed = _inlineStylePrefixer2.default.prefixAll(style);
	
	      if (isFlex) {
	        var display = stylePrefixed.display;
	        if (isClient) {
	          // We can't apply this join with react-dom:
	          // #https://github.com/facebook/react/issues/6467
	          stylePrefixed.display = display[display.length - 1];
	        } else {
	          stylePrefixed.display = display.join('; display: ');
	        }
	      }
	
	      return stylePrefixed;
	    };
	  } else {
	    var _ret = function () {
	      var prefixer = new _inlineStylePrefixer2.default({
	        userAgent: userAgent
	      });
	
	      return {
	        v: function v(style) {
	          return prefixer.prefix(style);
	        }
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	  }
	};
	
	var _inlineStylePrefixer = __webpack_require__(906);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (process.env.NODE_ENV !== 'production') {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {}; /**
	                  * This module is taken from https://github.com/react-bootstrap/react-prop-types.
	                  * It's not a dependency to reduce build size / install time.
	                  * It should be pretty stable.
	                  */
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason)) : void 0;
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	* Returns a number of pixels from the top of the screen for given dom element.
	*
	* @param {object} dom element
	* @returns {number} A position from the top of the screen in pixels
	*/
	var getOffsetTop = exports.getOffsetTop = function getOffsetTop(elem) {
	  var yPos = elem.offsetTop;
	  var tempEl = elem.offsetParent;
	
	  while (tempEl != null) {
	    yPos += tempEl.offsetTop;
	    tempEl = tempEl.offsetParent;
	  }
	
	  return yPos;
	};
	
	var isIOS = exports.isIOS = function isIOS() {
	  return (/iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream
	  );
	};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(222);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = rtl;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      if (style.directionInvariant === true) {
	        return style;
	      }
	
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      (0, _keys2.default)(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = withWidth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(87);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SMALL = exports.SMALL = 1;
	var MEDIUM = exports.MEDIUM = 2;
	var LARGE = exports.LARGE = 3;
	
	function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$largeWidth = options.largeWidth,
	      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
	      _options$mediumWidth = options.mediumWidth,
	      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
	      _options$resizeInterv = options.resizeInterval,
	      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;
	
	
	  return function (MyComponent) {
	    return function (_Component) {
	      (0, _inherits3.default)(WithWidth, _Component);
	
	      function WithWidth() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, WithWidth);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          width: null
	        }, _this.handleResize = function () {
	          clearTimeout(_this.deferTimer);
	          _this.deferTimer = setTimeout(function () {
	            _this.updateWidth();
	          }, resizeInterval);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	
	      (0, _createClass3.default)(WithWidth, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.deferTimer);
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth() {
	          var innerWidth = window.innerWidth;
	          var width = void 0;
	
	          if (innerWidth >= largeWidth) {
	            width = LARGE;
	          } else if (innerWidth >= mediumWidth) {
	            width = MEDIUM;
	          } else {
	            // innerWidth < 768
	            width = SMALL;
	          }
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var width = this.state.width;
	
	          /**
	           * When rendering the component on the server,
	           * we have no idea about the screen width.
	           * In order to prevent blinks and help the reconciliation
	           * we are not rendering the component.
	           *
	           * A better alternative would be to send client hints.
	           * But the browser support of this API is low:
	           * http://caniuse.com/#search=client%20hint
	           */
	          if (width === null) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            _react2.default.createElement(MyComponent, (0, _extends3.default)({
	              width: width
	            }, this.props))
	          );
	        }
	      }]);
	      return WithWidth;
	    }(_react.Component);
	  };
	}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = __webpack_require__(282);
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(282);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1223);
	var objectAssign = __webpack_require__(30);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(1073);
	exports.encode = exports.stringify = __webpack_require__(1074);


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var REACT_ELEMENT_TYPE =
	  (typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element')) ||
	  0xeac7;
	
	var emptyFunction = __webpack_require__(71);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	var didWarnAboutMaps = false;
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	function getIteratorFn(maybeIterable) {
	  var iteratorFn =
	    maybeIterable &&
	    ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
	      maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function(match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (
	    children === null ||
	    type === 'string' ||
	    type === 'number' ||
	    // The following is inlined from ReactElement. This means we can optimize
	    // some checks. React Fiber also inlines this logic for similar purposes.
	    (type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE)
	  ) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
	    );
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      if (process.env.NODE_ENV !== 'production') {
	        // Warn about using Maps as children
	        if (iteratorFn === children.entries) {
	          warning(
	            didWarnAboutMaps,
	            'Using Maps as children is unsupported and will likely yield ' +
	              'unexpected results. Convert it to a sequence/iterable of keyed ' +
	              'ReactElements instead.'
	          );
	          didWarnAboutMaps = true;
	        }
	      }
	
	      var iterator = iteratorFn.call(children);
	      var step;
	      var ii = 0;
	      while (!(step = iterator.next()).done) {
	        child = step.value;
	        nextName = nextNamePrefix + getComponentKey(child, ii++);
	        subtreeCount += traverseAllChildrenImpl(
	          child,
	          nextName,
	          callback,
	          traverseContext
	        );
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (process.env.NODE_ENV !== 'production') {
	        addendum =
	          ' If you meant to render a collection of children, use an array ' +
	          'instead or wrap the object using createFragment(object) from the ' +
	          'React add-ons.';
	      }
	      var childrenString = '' + children;
	      invariant(
	        false,
	        'Objects are not valid as a React child (found: %s).%s',
	        childrenString === '[object Object]'
	          ? 'object with keys {' + Object.keys(children).join(', ') + '}'
	          : childrenString,
	        addendum
	      );
	    }
	  }
	
	  return subtreeCount;
	}
	
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	function cloneAndReplaceKey(oldElement, newKey) {
	  return React.cloneElement(
	    oldElement,
	    {key: newKey},
	    oldElement.props !== undefined ? oldElement.props.children : undefined
	  );
	}
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  );
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function() {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(
	      mappedChild,
	      result,
	      childKey,
	      emptyFunction.thatReturnsArgument
	    );
	  } else if (mappedChild != null) {
	    if (React.isValidElement(mappedChild)) {
	      mappedChild = cloneAndReplaceKey(
	        mappedChild,
	        // Keep both the (mapped) and old keys if they differ, just as
	        // traverseAllChildren used to do for objects as children
	        keyPrefix +
	          (mappedChild.key && (!child || child.key !== mappedChild.key)
	            ? escapeUserProvidedKey(mappedChild.key) + '/'
	            : '') +
	          childKey
	      );
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(
	    array,
	    escapedPrefix,
	    func,
	    context
	  );
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	function createReactFragment(object) {
	  if (typeof object !== 'object' || !object || Array.isArray(object)) {
	    warning(
	      false,
	      'React.addons.createFragment only accepts a single object. Got: %s',
	      object
	    );
	    return object;
	  }
	  if (React.isValidElement(object)) {
	    warning(
	      false,
	      'React.addons.createFragment does not accept a ReactElement ' +
	        'without a wrapper object.'
	    );
	    return object;
	  }
	
	  invariant(
	    object.nodeType !== 1,
	    'React.addons.createFragment(...): Encountered an invalid child; DOM ' +
	      'elements are not valid children of React components.'
	  );
	
	  var result = [];
	
	  for (var key in object) {
	    if (process.env.NODE_ENV !== 'production') {
	      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	        warning(
	          false,
	          'React.addons.createFragment(...): Child objects should have ' +
	            'non-numeric keys so ordering is preserved.'
	        );
	        warnedAboutNumeric = true;
	      }
	    }
	    mapIntoWithKeyPrefixInternal(
	      object[key],
	      result,
	      key,
	      emptyFunction.thatReturnsArgument
	    );
	  }
	
	  return result;
	}
	
	module.exports = createReactFragment;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(34);
	
	var focusNode = __webpack_require__(379);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(139);
	var ExecutionEnvironment = __webpack_require__(37);
	var FallbackCompositionState = __webpack_require__(1086);
	var SyntheticCompositionEvent = __webpack_require__(1129);
	var SyntheticInputEvent = __webpack_require__(1132);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(422);
	var ExecutionEnvironment = __webpack_require__(37);
	var ReactInstrumentation = __webpack_require__(62);
	
	var camelizeStyleName = __webpack_require__(892);
	var dangerousStyleValue = __webpack_require__(1139);
	var hyphenateStyleName = __webpack_require__(899);
	var memoizeStringOnly = __webpack_require__(903);
	var warning = __webpack_require__(19);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (process.env.NODE_ENV !== 'production') {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (process.env.NODE_ENV !== 'production') {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (process.env.NODE_ENV !== 'production') {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (process.env.NODE_ENV !== 'production') {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(138);
	var EventPropagators = __webpack_require__(139);
	var ExecutionEnvironment = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(79);
	var SyntheticEvent = __webpack_require__(86);
	
	var inputValueTracking = __webpack_require__(438);
	var getEventTarget = __webpack_require__(294);
	var isEventSupported = __webpack_require__(295);
	var isTextInputElement = __webpack_require__(440);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var DOMLazyTree = __webpack_require__(137);
	var ExecutionEnvironment = __webpack_require__(37);
	
	var createNodesFromMarkup = __webpack_require__(895);
	var emptyFunction = __webpack_require__(71);
	var invariant = __webpack_require__(15);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(139);
	var ReactDOMComponentTree = __webpack_require__(34);
	var SyntheticMouseEvent = __webpack_require__(201);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = {
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	};
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes
	};
	
	module.exports = EventConstants;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var PooledClass = __webpack_require__(115);
	
	var getTextContentAccessor = __webpack_require__(437);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(96);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(140);
	
	var instantiateReactComponent = __webpack_require__(439);
	var KeyEscapeUtils = __webpack_require__(285);
	var shouldUpdateReactComponent = __webpack_require__(296);
	var traverseAllChildren = __webpack_require__(442);
	var warning = __webpack_require__(19);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(53);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (process.env.NODE_ENV !== 'production') {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = __webpack_require__(53);
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (process.env.NODE_ENV !== 'production') {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(283);
	var ReactDOMIDOperations = __webpack_require__(1096);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(30);
	
	var React = __webpack_require__(146);
	var ReactComponentEnvironment = __webpack_require__(287);
	var ReactCurrentOwner = __webpack_require__(80);
	var ReactErrorUtils = __webpack_require__(288);
	var ReactInstanceMap = __webpack_require__(167);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactNodeTypes = __webpack_require__(432);
	var ReactReconciler = __webpack_require__(140);
	
	if (process.env.NODE_ENV !== 'production') {
	  var checkReactTypeSpec = __webpack_require__(1138);
	}
	
	var emptyObject = __webpack_require__(191);
	var invariant = __webpack_require__(15);
	var shallowEqual = __webpack_require__(162);
	var shouldUpdateReactComponent = __webpack_require__(296);
	var warning = __webpack_require__(19);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (process.env.NODE_ENV !== 'production') {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (process.env.NODE_ENV !== 'production') {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (process.env.NODE_ENV !== 'production') {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (process.env.NODE_ENV !== 'production' && !doConstruct) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (process.env.NODE_ENV !== 'production') {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (process.env.NODE_ENV !== 'production') {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (process.env.NODE_ENV !== 'production') {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (process.env.NODE_ENV !== 'production') {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (process.env.NODE_ENV !== 'production') {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (process.env.NODE_ENV !== 'production') {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (process.env.NODE_ENV !== 'production') {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (process.env.NODE_ENV !== 'production') {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (process.env.NODE_ENV !== 'production') {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (process.env.NODE_ENV !== 'production') {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (process.env.NODE_ENV !== 'production') {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (process.env.NODE_ENV !== 'production') {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (process.env.NODE_ENV !== 'production') {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (process.env.NODE_ENV !== 'production') {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (process.env.NODE_ENV !== 'production') {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (process.env.NODE_ENV !== 'production') {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (process.env.NODE_ENV !== 'production') {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (process.env.NODE_ENV !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (process.env.NODE_ENV !== 'production') {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDefaultInjection = __webpack_require__(1108);
	var ReactMount = __webpack_require__(431);
	var ReactReconciler = __webpack_require__(140);
	var ReactUpdates = __webpack_require__(79);
	var ReactVersion = __webpack_require__(1123);
	
	var findDOMNode = __webpack_require__(1140);
	var getHostComponentFromComposite = __webpack_require__(436);
	var renderSubtreeIntoContainer = __webpack_require__(1147);
	var warning = __webpack_require__(19);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (process.env.NODE_ENV !== 'production') {
	  var ExecutionEnvironment = __webpack_require__(37);
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactInstrumentation = __webpack_require__(62);
	  var ReactDOMUnknownPropertyHook = __webpack_require__(1105);
	  var ReactDOMNullInputValuePropHook = __webpack_require__(1099);
	  var ReactDOMInvalidARIAHook = __webpack_require__(1098);
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(30);
	
	var AutoFocusUtils = __webpack_require__(1078);
	var CSSPropertyOperations = __webpack_require__(1080);
	var DOMLazyTree = __webpack_require__(137);
	var DOMNamespaces = __webpack_require__(284);
	var DOMProperty = __webpack_require__(96);
	var DOMPropertyOperations = __webpack_require__(424);
	var EventPluginHub = __webpack_require__(138);
	var EventPluginRegistry = __webpack_require__(198);
	var ReactBrowserEventEmitter = __webpack_require__(200);
	var ReactDOMComponentFlags = __webpack_require__(425);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMInput = __webpack_require__(1097);
	var ReactDOMOption = __webpack_require__(1100);
	var ReactDOMSelect = __webpack_require__(426);
	var ReactDOMTextarea = __webpack_require__(1103);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactMultiChild = __webpack_require__(1116);
	var ReactServerRenderingTransaction = __webpack_require__(1121);
	
	var emptyFunction = __webpack_require__(71);
	var escapeTextContentForBrowser = __webpack_require__(203);
	var invariant = __webpack_require__(15);
	var isEventSupported = __webpack_require__(295);
	var shallowEqual = __webpack_require__(162);
	var inputValueTracking = __webpack_require__(438);
	var validateDOMNesting = __webpack_require__(297);
	var warning = __webpack_require__(19);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	  process.env.NODE_ENV !== 'production' ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ? process.env.NODE_ENV !== 'production' ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (process.env.NODE_ENV !== 'production') {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (process.env.NODE_ENV !== 'production') {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ? process.env.NODE_ENV !== 'production' ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (process.env.NODE_ENV !== 'production') {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (process.env.NODE_ENV !== 'production') {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (process.env.NODE_ENV !== 'production') {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (process.env.NODE_ENV !== 'production') {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (process.env.NODE_ENV !== 'production') {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (process.env.NODE_ENV !== 'production') {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (process.env.NODE_ENV !== 'production') {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (process.env.NODE_ENV !== 'production') {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (process.env.NODE_ENV !== 'production') {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (process.env.NODE_ENV !== 'production') {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ? process.env.NODE_ENV !== 'production' ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (process.env.NODE_ENV !== 'production') {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(297);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (process.env.NODE_ENV !== 'production') {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var DOMLazyTree = __webpack_require__(137);
	var ReactDOMComponentTree = __webpack_require__(34);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(283);
	var ReactDOMComponentTree = __webpack_require__(34);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(30);
	
	var DOMPropertyOperations = __webpack_require__(424);
	var LinkedValueUtils = __webpack_require__(286);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(79);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (process.env.NODE_ENV !== 'production') {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (process.env.NODE_ENV !== 'production') {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(96);
	var ReactComponentTreeHook = __webpack_require__(53);
	
	var warning = __webpack_require__(19);
	
	var warnedProperties = {};
	var rARIA = new RegExp('^(aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	
	function validateProperty(tagName, name, debugID) {
	  if (warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	    return true;
	  }
	
	  if (rARIA.test(name)) {
	    var lowerCasedName = name.toLowerCase();
	    var standardName = DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // If this is an aria-* attribute, but is not listed in the known DOM
	    // DOM properties, then it is an invalid aria-* attribute.
	    if (standardName == null) {
	      warnedProperties[name] = true;
	      return false;
	    }
	    // aria-* attributes should be lowercase; suggest the lowercase version.
	    if (name !== standardName) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown ARIA attribute %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	      warnedProperties[name] = true;
	      return true;
	    }
	  }
	
	  return true;
	}
	
	function warnInvalidARIAProps(debugID, element) {
	  var invalidProps = [];
	
	  for (var key in element.props) {
	    var isValid = validateProperty(element.type, key, debugID);
	    if (!isValid) {
	      invalidProps.push(key);
	    }
	  }
	
	  var unknownPropString = invalidProps.map(function (prop) {
	    return '`' + prop + '`';
	  }).join(', ');
	
	  if (invalidProps.length === 1) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	  } else if (invalidProps.length > 1) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	  }
	}
	
	function handleElement(debugID, element) {
	  if (element == null || typeof element.type !== 'string') {
	    return;
	  }
	  if (element.type.indexOf('-') >= 0 || element.props.is) {
	    return;
	  }
	
	  warnInvalidARIAProps(debugID, element);
	}
	
	var ReactDOMInvalidARIAHook = {
	  onBeforeMountComponent: function (debugID, element) {
	    if (process.env.NODE_ENV !== 'production') {
	      handleElement(debugID, element);
	    }
	  },
	  onBeforeUpdateComponent: function (debugID, element) {
	    if (process.env.NODE_ENV !== 'production') {
	      handleElement(debugID, element);
	    }
	  }
	};
	
	module.exports = ReactDOMInvalidARIAHook;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactComponentTreeHook = __webpack_require__(53);
	
	var warning = __webpack_require__(19);
	
	var didWarnValueNull = false;
	
	function handleElement(debugID, element) {
	  if (element == null) {
	    return;
	  }
	  if (element.type !== 'input' && element.type !== 'textarea' && element.type !== 'select') {
	    return;
	  }
	  if (element.props != null && element.props.value === null && !didWarnValueNull) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.%s', element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	var ReactDOMNullInputValuePropHook = {
	  onBeforeMountComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  },
	  onBeforeUpdateComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  }
	};
	
	module.exports = ReactDOMNullInputValuePropHook;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var React = __webpack_require__(146);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMSelect = __webpack_require__(426);
	
	var warning = __webpack_require__(19);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var getNodeForCharacterOffset = __webpack_require__(1144);
	var getTextContentAccessor = __webpack_require__(437);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(30);
	
	var DOMChildrenOperations = __webpack_require__(283);
	var DOMLazyTree = __webpack_require__(137);
	var ReactDOMComponentTree = __webpack_require__(34);
	
	var escapeTextContentForBrowser = __webpack_require__(203);
	var invariant = __webpack_require__(15);
	var validateDOMNesting = __webpack_require__(297);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (process.env.NODE_ENV !== 'production') {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(30);
	
	var LinkedValueUtils = __webpack_require__(286);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(79);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (process.env.NODE_ENV !== 'production') {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (process.env.NODE_ENV !== 'production') {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ? process.env.NODE_ENV !== 'production' ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(96);
	var EventPluginRegistry = __webpack_require__(198);
	var ReactComponentTreeHook = __webpack_require__(53);
	
	var warning = __webpack_require__(19);
	
	if (process.env.NODE_ENV !== 'production') {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true,
	
	    autoFocus: true,
	    defaultValue: true,
	    valueLink: true,
	    defaultChecked: true,
	    checkedLink: true,
	    innerHTML: true,
	    suppressContentEditableWarning: true,
	    onFocusIn: true,
	    onFocusOut: true
	  };
	  var warnedProperties = {};
	
	  var validateProperty = function (tagName, name, debugID) {
	    if (DOMProperty.properties.hasOwnProperty(name) || DOMProperty.isCustomAttribute(name)) {
	      return true;
	    }
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return true;
	    }
	    if (EventPluginRegistry.registrationNameModules.hasOwnProperty(name)) {
	      return true;
	    }
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    var registrationName = EventPluginRegistry.possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? EventPluginRegistry.possibleRegistrationNames[lowerCasedName] : null;
	
	    if (standardName != null) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown DOM property %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	      return true;
	    } else if (registrationName != null) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown event handler property %s. Did you mean `%s`?%s', name, registrationName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	      return true;
	    } else {
	      // We were unable to guess which prop the user intended.
	      // It is likely that the user was just blindly spreading/forwarding props
	      // Components should be careful to only render valid props/attributes.
	      // Warning will be invoked in warnUnknownProperties to allow grouping.
	      return false;
	    }
	  };
	}
	
	var warnUnknownProperties = function (debugID, element) {
	  var unknownProps = [];
	  for (var key in element.props) {
	    var isValid = validateProperty(element.type, key, debugID);
	    if (!isValid) {
	      unknownProps.push(key);
	    }
	  }
	
	  var unknownPropString = unknownProps.map(function (prop) {
	    return '`' + prop + '`';
	  }).join(', ');
	
	  if (unknownProps.length === 1) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown prop %s on <%s> tag. Remove this prop from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	  } else if (unknownProps.length > 1) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown props %s on <%s> tag. Remove these props from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	  }
	};
	
	function handleElement(debugID, element) {
	  if (element == null || typeof element.type !== 'string') {
	    return;
	  }
	  if (element.type.indexOf('-') >= 0 || element.props.is) {
	    return;
	  }
	  warnUnknownProperties(debugID, element);
	}
	
	var ReactDOMUnknownPropertyHook = {
	  onBeforeMountComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  },
	  onBeforeUpdateComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  }
	};
	
	module.exports = ReactDOMUnknownPropertyHook;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactInvalidSetStateWarningHook = __webpack_require__(1114);
	var ReactHostOperationHistoryHook = __webpack_require__(1112);
	var ReactComponentTreeHook = __webpack_require__(53);
	var ExecutionEnvironment = __webpack_require__(37);
	
	var performanceNow = __webpack_require__(905);
	var warning = __webpack_require__(19);
	
	var hooks = [];
	var didHookThrowForEvent = {};
	
	function callHook(event, fn, context, arg1, arg2, arg3, arg4, arg5) {
	  try {
	    fn.call(context, arg1, arg2, arg3, arg4, arg5);
	  } catch (e) {
	    process.env.NODE_ENV !== 'production' ? warning(didHookThrowForEvent[event], 'Exception thrown by hook while handling %s: %s', event, e + '\n' + e.stack) : void 0;
	    didHookThrowForEvent[event] = true;
	  }
	}
	
	function emitEvent(event, arg1, arg2, arg3, arg4, arg5) {
	  for (var i = 0; i < hooks.length; i++) {
	    var hook = hooks[i];
	    var fn = hook[event];
	    if (fn) {
	      callHook(event, fn, hook, arg1, arg2, arg3, arg4, arg5);
	    }
	  }
	}
	
	var isProfiling = false;
	var flushHistory = [];
	var lifeCycleTimerStack = [];
	var currentFlushNesting = 0;
	var currentFlushMeasurements = [];
	var currentFlushStartTime = 0;
	var currentTimerDebugID = null;
	var currentTimerStartTime = 0;
	var currentTimerNestedFlushDuration = 0;
	var currentTimerType = null;
	
	var lifeCycleTimerHasWarned = false;
	
	function clearHistory() {
	  ReactComponentTreeHook.purgeUnmountedComponents();
	  ReactHostOperationHistoryHook.clearHistory();
	}
	
	function getTreeSnapshot(registeredIDs) {
	  return registeredIDs.reduce(function (tree, id) {
	    var ownerID = ReactComponentTreeHook.getOwnerID(id);
	    var parentID = ReactComponentTreeHook.getParentID(id);
	    tree[id] = {
	      displayName: ReactComponentTreeHook.getDisplayName(id),
	      text: ReactComponentTreeHook.getText(id),
	      updateCount: ReactComponentTreeHook.getUpdateCount(id),
	      childIDs: ReactComponentTreeHook.getChildIDs(id),
	      // Text nodes don't have owners but this is close enough.
	      ownerID: ownerID || parentID && ReactComponentTreeHook.getOwnerID(parentID) || 0,
	      parentID: parentID
	    };
	    return tree;
	  }, {});
	}
	
	function resetMeasurements() {
	  var previousStartTime = currentFlushStartTime;
	  var previousMeasurements = currentFlushMeasurements;
	  var previousOperations = ReactHostOperationHistoryHook.getHistory();
	
	  if (currentFlushNesting === 0) {
	    currentFlushStartTime = 0;
	    currentFlushMeasurements = [];
	    clearHistory();
	    return;
	  }
	
	  if (previousMeasurements.length || previousOperations.length) {
	    var registeredIDs = ReactComponentTreeHook.getRegisteredIDs();
	    flushHistory.push({
	      duration: performanceNow() - previousStartTime,
	      measurements: previousMeasurements || [],
	      operations: previousOperations || [],
	      treeSnapshot: getTreeSnapshot(registeredIDs)
	    });
	  }
	
	  clearHistory();
	  currentFlushStartTime = performanceNow();
	  currentFlushMeasurements = [];
	}
	
	function checkDebugID(debugID) {
	  var allowRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (allowRoot && debugID === 0) {
	    return;
	  }
	  if (!debugID) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDebugTool: debugID may not be empty.') : void 0;
	  }
	}
	
	function beginLifeCycleTimer(debugID, timerType) {
	  if (currentFlushNesting === 0) {
	    return;
	  }
	  if (currentTimerType && !lifeCycleTimerHasWarned) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'Did not expect %s timer to start while %s timer is still in ' + 'progress for %s instance.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
	    lifeCycleTimerHasWarned = true;
	  }
	  currentTimerStartTime = performanceNow();
	  currentTimerNestedFlushDuration = 0;
	  currentTimerDebugID = debugID;
	  currentTimerType = timerType;
	}
	
	function endLifeCycleTimer(debugID, timerType) {
	  if (currentFlushNesting === 0) {
	    return;
	  }
	  if (currentTimerType !== timerType && !lifeCycleTimerHasWarned) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'We did not expect %s timer to stop while %s timer is still in ' + 'progress for %s instance. Please report this as a bug in React.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
	    lifeCycleTimerHasWarned = true;
	  }
	  if (isProfiling) {
	    currentFlushMeasurements.push({
	      timerType: timerType,
	      instanceID: debugID,
	      duration: performanceNow() - currentTimerStartTime - currentTimerNestedFlushDuration
	    });
	  }
	  currentTimerStartTime = 0;
	  currentTimerNestedFlushDuration = 0;
	  currentTimerDebugID = null;
	  currentTimerType = null;
	}
	
	function pauseCurrentLifeCycleTimer() {
	  var currentTimer = {
	    startTime: currentTimerStartTime,
	    nestedFlushStartTime: performanceNow(),
	    debugID: currentTimerDebugID,
	    timerType: currentTimerType
	  };
	  lifeCycleTimerStack.push(currentTimer);
	  currentTimerStartTime = 0;
	  currentTimerNestedFlushDuration = 0;
	  currentTimerDebugID = null;
	  currentTimerType = null;
	}
	
	function resumeCurrentLifeCycleTimer() {
	  var _lifeCycleTimerStack$ = lifeCycleTimerStack.pop(),
	      startTime = _lifeCycleTimerStack$.startTime,
	      nestedFlushStartTime = _lifeCycleTimerStack$.nestedFlushStartTime,
	      debugID = _lifeCycleTimerStack$.debugID,
	      timerType = _lifeCycleTimerStack$.timerType;
	
	  var nestedFlushDuration = performanceNow() - nestedFlushStartTime;
	  currentTimerStartTime = startTime;
	  currentTimerNestedFlushDuration += nestedFlushDuration;
	  currentTimerDebugID = debugID;
	  currentTimerType = timerType;
	}
	
	var lastMarkTimeStamp = 0;
	var canUsePerformanceMeasure = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function';
	
	function shouldMark(debugID) {
	  if (!isProfiling || !canUsePerformanceMeasure) {
	    return false;
	  }
	  var element = ReactComponentTreeHook.getElement(debugID);
	  if (element == null || typeof element !== 'object') {
	    return false;
	  }
	  var isHostElement = typeof element.type === 'string';
	  if (isHostElement) {
	    return false;
	  }
	  return true;
	}
	
	function markBegin(debugID, markType) {
	  if (!shouldMark(debugID)) {
	    return;
	  }
	
	  var markName = debugID + '::' + markType;
	  lastMarkTimeStamp = performanceNow();
	  performance.mark(markName);
	}
	
	function markEnd(debugID, markType) {
	  if (!shouldMark(debugID)) {
	    return;
	  }
	
	  var markName = debugID + '::' + markType;
	  var displayName = ReactComponentTreeHook.getDisplayName(debugID) || 'Unknown';
	
	  // Chrome has an issue of dropping markers recorded too fast:
	  // https://bugs.chromium.org/p/chromium/issues/detail?id=640652
	  // To work around this, we will not report very small measurements.
	  // I determined the magic number by tweaking it back and forth.
	  // 0.05ms was enough to prevent the issue, but I set it to 0.1ms to be safe.
	  // When the bug is fixed, we can `measure()` unconditionally if we want to.
	  var timeStamp = performanceNow();
	  if (timeStamp - lastMarkTimeStamp > 0.1) {
	    var measurementName = displayName + ' [' + markType + ']';
	    performance.measure(measurementName, markName);
	  }
	
	  performance.clearMarks(markName);
	  if (measurementName) {
	    performance.clearMeasures(measurementName);
	  }
	}
	
	var ReactDebugTool = {
	  addHook: function (hook) {
	    hooks.push(hook);
	  },
	  removeHook: function (hook) {
	    for (var i = 0; i < hooks.length; i++) {
	      if (hooks[i] === hook) {
	        hooks.splice(i, 1);
	        i--;
	      }
	    }
	  },
	  isProfiling: function () {
	    return isProfiling;
	  },
	  beginProfiling: function () {
	    if (isProfiling) {
	      return;
	    }
	
	    isProfiling = true;
	    flushHistory.length = 0;
	    resetMeasurements();
	    ReactDebugTool.addHook(ReactHostOperationHistoryHook);
	  },
	  endProfiling: function () {
	    if (!isProfiling) {
	      return;
	    }
	
	    isProfiling = false;
	    resetMeasurements();
	    ReactDebugTool.removeHook(ReactHostOperationHistoryHook);
	  },
	  getFlushHistory: function () {
	    return flushHistory;
	  },
	  onBeginFlush: function () {
	    currentFlushNesting++;
	    resetMeasurements();
	    pauseCurrentLifeCycleTimer();
	    emitEvent('onBeginFlush');
	  },
	  onEndFlush: function () {
	    resetMeasurements();
	    currentFlushNesting--;
	    resumeCurrentLifeCycleTimer();
	    emitEvent('onEndFlush');
	  },
	  onBeginLifeCycleTimer: function (debugID, timerType) {
	    checkDebugID(debugID);
	    emitEvent('onBeginLifeCycleTimer', debugID, timerType);
	    markBegin(debugID, timerType);
	    beginLifeCycleTimer(debugID, timerType);
	  },
	  onEndLifeCycleTimer: function (debugID, timerType) {
	    checkDebugID(debugID);
	    endLifeCycleTimer(debugID, timerType);
	    markEnd(debugID, timerType);
	    emitEvent('onEndLifeCycleTimer', debugID, timerType);
	  },
	  onBeginProcessingChildContext: function () {
	    emitEvent('onBeginProcessingChildContext');
	  },
	  onEndProcessingChildContext: function () {
	    emitEvent('onEndProcessingChildContext');
	  },
	  onHostOperation: function (operation) {
	    checkDebugID(operation.instanceID);
	    emitEvent('onHostOperation', operation);
	  },
	  onSetState: function () {
	    emitEvent('onSetState');
	  },
	  onSetChildren: function (debugID, childDebugIDs) {
	    checkDebugID(debugID);
	    childDebugIDs.forEach(checkDebugID);
	    emitEvent('onSetChildren', debugID, childDebugIDs);
	  },
	  onBeforeMountComponent: function (debugID, element, parentDebugID) {
	    checkDebugID(debugID);
	    checkDebugID(parentDebugID, true);
	    emitEvent('onBeforeMountComponent', debugID, element, parentDebugID);
	    markBegin(debugID, 'mount');
	  },
	  onMountComponent: function (debugID) {
	    checkDebugID(debugID);
	    markEnd(debugID, 'mount');
	    emitEvent('onMountComponent', debugID);
	  },
	  onBeforeUpdateComponent: function (debugID, element) {
	    checkDebugID(debugID);
	    emitEvent('onBeforeUpdateComponent', debugID, element);
	    markBegin(debugID, 'update');
	  },
	  onUpdateComponent: function (debugID) {
	    checkDebugID(debugID);
	    markEnd(debugID, 'update');
	    emitEvent('onUpdateComponent', debugID);
	  },
	  onBeforeUnmountComponent: function (debugID) {
	    checkDebugID(debugID);
	    emitEvent('onBeforeUnmountComponent', debugID);
	    markBegin(debugID, 'unmount');
	  },
	  onUnmountComponent: function (debugID) {
	    checkDebugID(debugID);
	    markEnd(debugID, 'unmount');
	    emitEvent('onUnmountComponent', debugID);
	  },
	  onTestEvent: function () {
	    emitEvent('onTestEvent');
	  }
	};
	
	// TODO remove these when RN/www gets updated
	ReactDebugTool.addDevtool = ReactDebugTool.addHook;
	ReactDebugTool.removeDevtool = ReactDebugTool.removeHook;
	
	ReactDebugTool.addHook(ReactInvalidSetStateWarningHook);
	ReactDebugTool.addHook(ReactComponentTreeHook);
	var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	if (/[?&]react_perf\b/.test(url)) {
	  ReactDebugTool.beginProfiling();
	}
	
	module.exports = ReactDebugTool;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var ReactUpdates = __webpack_require__(79);
	var Transaction = __webpack_require__(202);
	
	var emptyFunction = __webpack_require__(71);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1077);
	var BeforeInputEventPlugin = __webpack_require__(1079);
	var ChangeEventPlugin = __webpack_require__(1081);
	var DefaultEventPluginOrder = __webpack_require__(1083);
	var EnterLeaveEventPlugin = __webpack_require__(1084);
	var HTMLDOMPropertyConfig = __webpack_require__(1087);
	var ReactComponentBrowserEnvironment = __webpack_require__(1089);
	var ReactDOMComponent = __webpack_require__(1092);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactDOMEmptyComponent = __webpack_require__(1094);
	var ReactDOMTreeTraversal = __webpack_require__(1104);
	var ReactDOMTextComponent = __webpack_require__(1102);
	var ReactDefaultBatchingStrategy = __webpack_require__(1107);
	var ReactEventListener = __webpack_require__(1111);
	var ReactInjection = __webpack_require__(1113);
	var ReactReconcileTransaction = __webpack_require__(1119);
	var SVGDOMPropertyConfig = __webpack_require__(1124);
	var SelectEventPlugin = __webpack_require__(1125);
	var SimpleEventPlugin = __webpack_require__(1126);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(138);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var EventListener = __webpack_require__(378);
	var ExecutionEnvironment = __webpack_require__(37);
	var PooledClass = __webpack_require__(115);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(79);
	
	var getEventTarget = __webpack_require__(294);
	var getUnboundedScrollPosition = __webpack_require__(897);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var history = [];
	
	var ReactHostOperationHistoryHook = {
	  onHostOperation: function (operation) {
	    history.push(operation);
	  },
	  clearHistory: function () {
	    if (ReactHostOperationHistoryHook._preventClearing) {
	      // Should only be used for tests.
	      return;
	    }
	
	    history = [];
	  },
	  getHistory: function () {
	    return history;
	  }
	};
	
	module.exports = ReactHostOperationHistoryHook;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(96);
	var EventPluginHub = __webpack_require__(138);
	var EventPluginUtils = __webpack_require__(199);
	var ReactComponentEnvironment = __webpack_require__(287);
	var ReactEmptyComponent = __webpack_require__(427);
	var ReactBrowserEventEmitter = __webpack_require__(200);
	var ReactHostComponent = __webpack_require__(429);
	var ReactUpdates = __webpack_require__(79);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var warning = __webpack_require__(19);
	
	if (process.env.NODE_ENV !== 'production') {
	  var processingChildContext = false;
	
	  var warnInvalidSetState = function () {
	    process.env.NODE_ENV !== 'production' ? warning(!processingChildContext, 'setState(...): Cannot call setState() inside getChildContext()') : void 0;
	  };
	}
	
	var ReactInvalidSetStateWarningHook = {
	  onBeginProcessingChildContext: function () {
	    processingChildContext = true;
	  },
	  onEndProcessingChildContext: function () {
	    processingChildContext = false;
	  },
	  onSetState: function () {
	    warnInvalidSetState();
	  }
	};
	
	module.exports = ReactInvalidSetStateWarningHook;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1137);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactComponentEnvironment = __webpack_require__(287);
	var ReactInstanceMap = __webpack_require__(167);
	var ReactInstrumentation = __webpack_require__(62);
	
	var ReactCurrentOwner = __webpack_require__(80);
	var ReactReconciler = __webpack_require__(140);
	var ReactChildReconciler = __webpack_require__(1088);
	
	var emptyFunction = __webpack_require__(71);
	var flattenChildren = __webpack_require__(1141);
	var invariant = __webpack_require__(15);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (process.env.NODE_ENV !== 'production') {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (process.env.NODE_ENV !== 'production') {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (process.env.NODE_ENV !== 'production') {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (process.env.NODE_ENV !== 'production') {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (process.env.NODE_ENV !== 'production') {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (process.env.NODE_ENV !== 'production') {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (process.env.NODE_ENV !== 'production') {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var CallbackQueue = __webpack_require__(423);
	var PooledClass = __webpack_require__(115);
	var ReactBrowserEventEmitter = __webpack_require__(200);
	var ReactInputSelection = __webpack_require__(430);
	var ReactInstrumentation = __webpack_require__(62);
	var Transaction = __webpack_require__(202);
	var ReactUpdateQueue = __webpack_require__(289);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (process.env.NODE_ENV !== 'production') {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1117);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var PooledClass = __webpack_require__(115);
	var Transaction = __webpack_require__(202);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactServerUpdateQueue = __webpack_require__(1122);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (process.env.NODE_ENV !== 'production') {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(289);
	
	var warning = __webpack_require__(19);
	
	function warnNoop(publicInstance, callerName) {
	  if (process.env.NODE_ENV !== 'production') {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(139);
	var ExecutionEnvironment = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInputSelection = __webpack_require__(430);
	var SyntheticEvent = __webpack_require__(86);
	
	var getActiveElement = __webpack_require__(380);
	var isTextInputElement = __webpack_require__(440);
	var shallowEqual = __webpack_require__(162);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var EventListener = __webpack_require__(378);
	var EventPropagators = __webpack_require__(139);
	var ReactDOMComponentTree = __webpack_require__(34);
	var SyntheticAnimationEvent = __webpack_require__(1127);
	var SyntheticClipboardEvent = __webpack_require__(1128);
	var SyntheticEvent = __webpack_require__(86);
	var SyntheticFocusEvent = __webpack_require__(1131);
	var SyntheticKeyboardEvent = __webpack_require__(1133);
	var SyntheticMouseEvent = __webpack_require__(201);
	var SyntheticDragEvent = __webpack_require__(1130);
	var SyntheticTouchEvent = __webpack_require__(1134);
	var SyntheticTransitionEvent = __webpack_require__(1135);
	var SyntheticUIEvent = __webpack_require__(141);
	var SyntheticWheelEvent = __webpack_require__(1136);
	
	var emptyFunction = __webpack_require__(71);
	var getEventCharCode = __webpack_require__(292);
	var invariant = __webpack_require__(15);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ? process.env.NODE_ENV !== 'production' ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(201);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(141);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(141);
	
	var getEventCharCode = __webpack_require__(292);
	var getEventKey = __webpack_require__(1142);
	var getEventModifierState = __webpack_require__(293);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(141);
	
	var getEventModifierState = __webpack_require__(293);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(201);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactPropTypeLocationNames = __webpack_require__(1118);
	var ReactPropTypesSecret = __webpack_require__(433);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(53);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (process.env.NODE_ENV !== 'production') {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = __webpack_require__(53);
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(422);
	var warning = __webpack_require__(19);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (process.env.NODE_ENV !== 'production') {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(80);
	var ReactDOMComponentTree = __webpack_require__(34);
	var ReactInstanceMap = __webpack_require__(167);
	
	var getHostComponentFromComposite = __webpack_require__(436);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (process.env.NODE_ENV !== 'production') {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(285);
	var traverseAllChildren = __webpack_require__(442);
	var warning = __webpack_require__(19);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(53);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (process.env.NODE_ENV !== 'production') {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = __webpack_require__(53);
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (process.env.NODE_ENV !== 'production') {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(292);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(203);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(431);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(221);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	exports.default = defineProperty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	function defineProperty(o, p, attr) {
	  return (0, _defineProperty2.default)(o, p, attr);
	}

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;
	
	var _defineProperty = __webpack_require__(1148);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
	var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;
	
	// IE8+ Support
	var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
	var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;
	
	// Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	var passiveOption = exports.passiveOption = function () {
	  var cache = null;
	
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (e) {} // eslint-disable-line no-empty
	
	    cache = supportsPassiveOption;
	
	    return supportsPassiveOption;
	  }();
	}();

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	
	  _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	var styles = {"instagramItems":"_2R-kh","instagramItem":"_wPDyp","instagramImg":"_vzTHL","instagramIcon":"_3xnQP","errorMessage":"_3lhLL"};
	
	var InstagramFeed = /*#__PURE__*/function (_Component) {
	  _inheritsLoose(InstagramFeed, _Component);
	
	  function InstagramFeed(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      feeds: [],
	      isError: '',
	      isLoaded: false
	    };
	    return _this;
	  }
	
	  var _proto = InstagramFeed.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var url = "https://graph.instagram.com/me/media?fields=media_count,media_type,permalink,media_url&&access_token=" + this.props.token;
	    fetch(url).then(function (response) {
	      return response.json();
	    }).then(function (data) {
	      if (data.hasOwnProperty('error')) {
	        _this2.setState({
	          isLoaded: true,
	          isError: true
	        });
	      } else {
	        _this2.setState({
	          isLoaded: true,
	          feeds: data.data,
	          isError: false
	        });
	      }
	    })["catch"](function (error) {
	      console.error('Error:', error);
	
	      _this2.setState({
	        isLoaded: true,
	        isError: true,
	        error: error
	      });
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$state = this.state,
	        isError = _this$state.isError,
	        isLoaded = _this$state.isLoaded,
	        feeds = _this$state.feeds;
	
	    if (isError) {
	      return /*#__PURE__*/React__default.createElement("div", {
	        className: styles.errorMessage
	      }, /*#__PURE__*/React__default.createElement("p", null, " the access token is not valid"));
	    } else if (!isLoaded) {
	      return /*#__PURE__*/React__default.createElement("div", null, " Loading... ");
	    } else {
	      console.log(feeds);
	      return /*#__PURE__*/React__default.createElement("div", {
	        className: styles.instagramItems
	      }, feeds.slice(0, this.props.counter).map(function (feed, index) {
	        return /*#__PURE__*/React__default.createElement("div", {
	          key: index,
	          className: styles.instagramItem
	        }, /*#__PURE__*/React__default.createElement("a", {
	          key: index,
	          href: feed.permalink,
	          className: "ig-instagram-link",
	          target: "_blank",
	          rel: "noreferrer"
	        }, feed.media_type === 'IMAGE' || feed.media_type === 'CAROUSEL_ALBUM' ? /*#__PURE__*/React__default.createElement("img", {
	          className: styles.instagramImg,
	          key: index,
	          src: feed.media_url,
	          alt: "description"
	        }) : /*#__PURE__*/React__default.createElement("video", {
	          className: styles.instagramImg,
	          key: index,
	          src: feed.media_url,
	          type: "video/mp4"
	        }), /*#__PURE__*/React__default.createElement("div", {
	          className: styles.instagramIcon
	        }, /*#__PURE__*/React__default.createElement("div", {
	          className: "instagram-count-item"
	        }, /*#__PURE__*/React__default.createElement("span", {
	          className: "icon"
	        }, /*#__PURE__*/React__default.createElement("svg", {
	          height: "18",
	          viewBox: "0 0 512 512",
	          width: "18"
	        }, /*#__PURE__*/React__default.createElement("path", {
	          fill: "currentColor",
	          d: "m256 386c-71.683 0-130-58.317-130-130 7.14-172.463 252.886-172.413 260 .001 0 71.682-58.317 129.999-130 129.999zm0-220c-49.626 0-90 40.374-90 90 4.944 119.397 175.074 119.362 180-.001 0-49.625-40.374-89.999-90-89.999zm236 346h-472c-11.046 0-20-8.954-20-20v-472c0-11.046 8.954-20 20-20h472c11.046 0 20 8.954 20 20v472c0 11.046-8.954 20-20 20zm-452-40h432v-432h-432zm372-392c-11.046 0-20 8.954-20 20 0 11.046 8.954 20 20 20 11.046 0 20-8.954 20-20 0-11.046-8.954-20-20-20z"
	        })))))));
	      }));
	    }
	  };
	
	  return InstagramFeed;
	}(React.Component);
	
	module.exports = InstagramFeed;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __importStar(__webpack_require__(1));
	var querystring_1 = __webpack_require__(1075);
	var InstagramEmbed = /** @class */ (function (_super) {
	    __extends(InstagramEmbed, _super);
	    function InstagramEmbed(props) {
	        var _this = _super.call(this, props) || this;
	        _this.request = null;
	        // Public
	        _this.cancel = function () {
	            if (_this.request) {
	                _this.request.cancel();
	            }
	        };
	        _this.handleFetchSuccess = function (response) {
	            if (_this.props.onSuccess) {
	                _this.props.onSuccess(response);
	            }
	            _this.setState({ html: response.html }, function () {
	                window.instgrm.Embeds.process();
	                if (_this.props.onAfterRender) {
	                    _this.props.onAfterRender();
	                }
	            });
	        };
	        _this.handleFetchFailure = function (error) {
	            clearTimeout(_this.timer);
	            if (_this.props.onFailure) {
	                _this.props.onFailure(error);
	            }
	        };
	        _this.createRequestPromise = function (url) {
	            var request = {};
	            request.promise = new Promise(function (resolve, reject) {
	                var promise = fetch(url, {
	                    headers: {
	                        Authorization: "Bearer " + _this.props.clientAccessToken,
	                    },
	                })
	                    .then(function (response) { return response.json(); })
	                    .then(function (json) { return resolve(json); })
	                    .catch(function (err) { return reject(err); });
	                request.cancel = function () { return reject(new Error('Cancelled')); };
	                return promise;
	            });
	            return request;
	        };
	        _this.state = { html: null };
	        return _this;
	    }
	    InstagramEmbed.prototype.componentDidMount = function () {
	        var _this = this;
	        if (window.instgrm) {
	            this.fetchEmbed(this.getQueryParams(this.props));
	        }
	        else {
	            if (this.props.injectScript && !document.getElementById('react-instagram-embed-script')) {
	                this.injectScript();
	            }
	            this.checkAPI().then(function () {
	                _this.fetchEmbed(_this.getQueryParams(_this.props));
	            });
	        }
	    };
	    InstagramEmbed.prototype.componentDidUpdate = function (prevProps) {
	        var _a = this.props, url = _a.url, clientAccessToken = _a.clientAccessToken, hideCaption = _a.hideCaption, maxWidth = _a.maxWidth, containerTagName = _a.containerTagName, className = _a.className;
	        if (prevProps.url !== url ||
	            prevProps.clientAccessToken !== clientAccessToken ||
	            prevProps.hideCaption !== hideCaption ||
	            prevProps.maxWidth !== maxWidth ||
	            prevProps.containerTagName !== containerTagName ||
	            prevProps.className !== className) {
	            this.request.cancel();
	            this.fetchEmbed(this.getQueryParams(this.props));
	        }
	    };
	    InstagramEmbed.prototype.componentWillUnmount = function () {
	        this.cancel();
	    };
	    InstagramEmbed.prototype.render = function () {
	        var Element = this.props.containerTagName;
	        return React.createElement(Element, __assign({}, this.omitComponentProps(), { dangerouslySetInnerHTML: { __html: this.state.html || '' } }));
	    };
	    InstagramEmbed.prototype.fetchEmbed = function (queryParams) {
	        this.request = this.createRequestPromise("https://graph.facebook.com/v11.0/instagram_oembed/?" + queryParams);
	        if (this.props.onLoading) {
	            this.props.onLoading();
	        }
	        this.request.promise.then(this.handleFetchSuccess).catch(this.handleFetchFailure);
	    };
	    InstagramEmbed.prototype.omitComponentProps = function () {
	        var _a = this.props, 
	        /* eslint-disable @typescript-eslint/no-unused-vars */
	        url = _a.url, clientAccessToken = _a.clientAccessToken, hideCaption = _a.hideCaption, maxWidth = _a.maxWidth, containerTagName = _a.containerTagName, onLoading = _a.onLoading, onSuccess = _a.onSuccess, onAfterRender = _a.onAfterRender, onFailure = _a.onFailure, protocol = _a.protocol, injectScript = _a.injectScript, 
	        /* eslint-enable @typescript-eslint/no-unused-vars */
	        rest = __rest(_a, ["url", "clientAccessToken", "hideCaption", "maxWidth", "containerTagName", "onLoading", "onSuccess", "onAfterRender", "onFailure", "protocol", "injectScript"]);
	        return rest;
	    };
	    InstagramEmbed.prototype.injectScript = function () {
	        var protocolToUse = window.location.protocol.indexOf('file') === 0 ? this.props.protocol : '';
	        var s = document.createElement('script');
	        s.async = s.defer = true;
	        s.src = protocolToUse + "//platform.instagram.com/en_US/embeds.js";
	        s.id = 'react-instagram-embed-script';
	        var body = document.body;
	        if (body) {
	            body.appendChild(s);
	        }
	    };
	    InstagramEmbed.prototype.checkAPI = function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            (function checkAPI(self) {
	                self.timer = window.setTimeout(function () {
	                    if (window.instgrm) {
	                        clearTimeout(self.timer);
	                        resolve();
	                    }
	                    else {
	                        checkAPI(self);
	                    }
	                }, 20);
	            })(_this);
	        });
	    };
	    InstagramEmbed.prototype.getQueryParams = function (_a) {
	        var url = _a.url, hideCaption = _a.hideCaption, maxWidth = _a.maxWidth;
	        var query = {
	            url: url,
	            hidecaption: hideCaption,
	            omitscript: true,
	            fields: 'html',
	        };
	        // "The request parameter 'maxwidth' must be an integer between 320 and 658."
	        if (typeof maxWidth === 'number' && 320 <= maxWidth && maxWidth <= 658) {
	            query.maxwidth = maxWidth;
	        }
	        return querystring_1.stringify(query);
	    };
	    InstagramEmbed.defaultProps = {
	        hideCaption: false,
	        containerTagName: 'div',
	        protocol: 'https:',
	        injectScript: true,
	    };
	    return InstagramEmbed;
	}(React.Component));
	exports.default = InstagramEmbed;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.13.1
	 * react-is.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	
	
	if (process.env.NODE_ENV !== "production") {
	  (function() {
	'use strict';
	
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?
	
	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
	
	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}
	
	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;
	
	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;
	
	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;
	
	          default:
	            var $$typeofType = type && type.$$typeof;
	
	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;
	
	              default:
	                return $$typeof;
	            }
	
	        }
	
	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }
	
	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode
	
	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
	
	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
	
	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }
	
	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	
	exports.AsyncMode = AsyncMode;
	exports.ConcurrentMode = ConcurrentMode;
	exports.ContextConsumer = ContextConsumer;
	exports.ContextProvider = ContextProvider;
	exports.Element = Element;
	exports.ForwardRef = ForwardRef;
	exports.Fragment = Fragment;
	exports.Lazy = Lazy;
	exports.Memo = Memo;
	exports.Portal = Portal;
	exports.Profiler = Profiler;
	exports.StrictMode = StrictMode;
	exports.Suspense = Suspense;
	exports.isAsyncMode = isAsyncMode;
	exports.isConcurrentMode = isConcurrentMode;
	exports.isContextConsumer = isContextConsumer;
	exports.isContextProvider = isContextProvider;
	exports.isElement = isElement;
	exports.isForwardRef = isForwardRef;
	exports.isFragment = isFragment;
	exports.isLazy = isLazy;
	exports.isMemo = isMemo;
	exports.isPortal = isPortal;
	exports.isProfiler = isProfiler;
	exports.isStrictMode = isStrictMode;
	exports.isSuspense = isSuspense;
	exports.isValidElementType = isValidElementType;
	exports.typeOf = typeOf;
	  })();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(443);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(444);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (process.env.NODE_ENV !== 'production') {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(443);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(1156);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(1157);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(444);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(268);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(1158);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (process.env.NODE_ENV !== 'production') {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (process.env.NODE_ENV !== 'production') {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (process.env.NODE_ENV !== 'production') {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (process.env.NODE_ENV !== 'production') {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (process.env.NODE_ENV !== 'production') {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (process.env.NODE_ENV !== 'production') {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(209);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(168);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(83);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(445);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(83);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(46);
	
	var _routerWarning = __webpack_require__(144);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(447);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(83);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(46);
	
	var _routerWarning = __webpack_require__(144);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(97);
	
	var _InternalPropTypes = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(83);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(46);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(97);
	
	var _InternalPropTypes = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(83);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(46);
	
	var _createTransitionManager2 = __webpack_require__(451);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(169);
	
	var _RouterContext = __webpack_require__(301);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(97);
	
	var _RouterUtils = __webpack_require__(448);
	
	var _routerWarning = __webpack_require__(144);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	    process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(298);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(301);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(144);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (process.env.NODE_ENV !== 'production') {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1178);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(450);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(143);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(298);
	
	var _PromiseUtils = __webpack_require__(446);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(143);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(1179);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(450);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(143);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(205);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(449);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(451);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(97);
	
	var _RouterUtils = __webpack_require__(448);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(298);
	
	var _PromiseUtils = __webpack_require__(446);
	
	var _PatternUtils = __webpack_require__(143);
	
	var _routerWarning = __webpack_require__(144);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(83);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(1181);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(299);
	
	var _PropTypes = __webpack_require__(300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(302);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(145);
	
	var _DOMUtils = __webpack_require__(206);
	
	var _DOMStateStorage = __webpack_require__(453);
	
	var _PathUtils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(302);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(145);
	
	var _PathUtils = __webpack_require__(98);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(303);
	
	var _BrowserProtocol = __webpack_require__(302);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(1177);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(206);
	
	var _createHistory = __webpack_require__(304);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(303);
	
	var _DOMUtils = __webpack_require__(206);
	
	var _HashProtocol = __webpack_require__(1176);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(304);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	  process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(145);
	
	var _PathUtils = __webpack_require__(98);
	
	var _createHistory = __webpack_require__(304);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(168);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(172);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { "slick-arrow": true, "slick-prev": true };
	    var prevHandler = this.clickHandler.bind(this, { message: "previous" });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses["slick-disabled"] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: "0",
	      "data-role": "none",
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: "block" },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "0", type: "button" }, prevArrowProps),
	        " ",
	        "Previous"
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.PureComponent);
	
	var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { "slick-arrow": true, "slick-next": true };
	    var nextHandler = this.clickHandler.bind(this, { message: "next" });
	
	    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	      nextClasses["slick-disabled"] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: "1",
	      "data-role": "none",
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: "block" },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "1", type: "button" }, nextArrowProps),
	        " ",
	        "Next"
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.PureComponent);

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react2.default.createElement(
	      "ul",
	      { style: { display: "block" } },
	      dots
	    );
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react2.default.createElement(
	      "button",
	      null,
	      i + 1
	    );
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	
	exports.default = defaultProps;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(172);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll,
	      slidesToShow: this.props.slidesToShow,
	      infinite: this.props.infinite
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: "dots",
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	      return _react2.default.createElement(
	        "li",
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
	      className: this.props.dotsClass
	    }, mouseEvents));
	  };
	
	  return Dots;
	}(_react2.default.PureComponent);

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false, // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
	  trackStyle: {},
	  trackWidth: 0
	};
	
	exports.default = initialState;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _initialState = __webpack_require__(1185);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _lodash = __webpack_require__(934);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(172);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(207);
	
	var _track = __webpack_require__(1188);
	
	var _dots = __webpack_require__(1184);
	
	var _arrows = __webpack_require__(1182);
	
	var _resizeObserverPolyfill = __webpack_require__(1221);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InnerSlider = exports.InnerSlider = function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    _classCallCheck(this, InnerSlider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.listRefHandler = function (ref) {
	      return _this.list = ref;
	    };
	
	    _this.trackRefHandler = function (ref) {
	      return _this.track = ref;
	    };
	
	    _this.adaptHeight = function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    };
	
	    _this.componentWillMount = function () {
	      _this.ssrInit();
	      _this.props.onInit && _this.props.onInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    };
	
	    _this.componentDidMount = function () {
	      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	      _this.ro = new _resizeObserverPolyfill2.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	      _this.ro.observe(_this.list);
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	      // To support server-side rendering
	      if (!window) {
	        return;
	      }
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    };
	
	    _this.componentWillUnmount = function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	        _this.callbackTimers = [];
	      }
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	      var setTrackStyle = false;
	      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var key = _ref;
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    };
	
	    _this.componentDidUpdate = function () {
	      _this.checkImagesLoad();
	      _this.props.onReInit && _this.props.onReInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	      _this.adaptHeight();
	    };
	
	    _this.onWindowResized = function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash2.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	      _this.debouncedResize();
	    };
	
	    _this.resizeWindow = function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!_reactDom2.default.findDOMNode(_this.track)) return;
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      });
	      // animating state should be cleared while resizing, otherwise autoplay stops working
	      _this.setState({
	        animating: false
	      });
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    };
	
	    _this.updateState = function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _extends({}, spec, { left: targetLeft });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	      _this.setState(updatedState, callback);
	    };
	
	    _this.ssrInit = function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	        if (_this.props.centerMode) {
	          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
	          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
	        }
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	        return;
	      }
	      var childrenCount = _react2.default.Children.count(_this.props.children);
	      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    };
	
	    _this.checkImagesLoad = function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    };
	
	    _this.progressiveLazyLoad = function () {
	      var slidesToLoad = [];
	      var spec = _extends({}, _this.props, _this.state);
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    };
	
	    _this.slideHandler = function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange;
	      // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({ animating: animating });
	            }, 10));
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    };
	
	    _this.changeSlide = function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _extends({}, _this.props, _this.state);
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    };
	
	    _this.clickHandler = function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      _this.clickable = true;
	    };
	
	    _this.keyHandler = function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({ message: dir });
	    };
	
	    _this.selectHandler = function (options) {
	      _this.changeSlide(options);
	    };
	
	    _this.disableBodyScroll = function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	      window.ontouchmove = preventDefault;
	    };
	
	    _this.enableBodyScroll = function () {
	      window.ontouchmove = null;
	    };
	
	    _this.swipeStart = function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    };
	
	    _this.swipeMove = function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	      _this.setState(state);
	    };
	
	    _this.swipeEnd = function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	      _this.setState(state);
	      if (triggerSlideHandler === undefined) return;
	      _this.slideHandler(triggerSlideHandler);
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    };
	
	    _this.slickPrev = function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "previous" });
	      }, 0));
	    };
	
	    _this.slickNext = function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "next" });
	      }, 0));
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    };
	
	    _this.play = function () {
	      var nextIndex;
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    };
	
	    _this.autoPlay = function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	      _this.setState({ autoplaying: "playing" });
	    };
	
	    _this.pause = function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (pauseType === "paused") {
	        _this.setState({ autoplaying: "paused" });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({ autoplaying: "focused" });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({ autoplaying: "hovered" });
	        }
	      }
	    };
	
	    _this.onDotsOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onDotsLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onTrackOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onTrackLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onSlideFocus = function () {
	      return _this.props.autoplay && _this.pause("focused");
	    };
	
	    _this.onSlideBlur = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    };
	
	    _this.render = function () {
	      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	      var spec = _extends({}, _this.props, _this.state);
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	
	      trackProps = _extends({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	
	      var dots;
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	
	        dotProps = _extends({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react2.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = { className: "slick-list" };
	        innerSliderProps = { className: className };
	      }
	      return _react2.default.createElement(
	        "div",
	        innerSliderProps,
	        !_this.props.unslick ? prevArrow : "",
	        _react2.default.createElement(
	          "div",
	          _extends({ ref: _this.listRefHandler }, listProps),
	          _react2.default.createElement(
	            _track.Track,
	            _extends({ ref: _this.trackRefHandler }, trackProps),
	            _this.props.children
	          )
	        ),
	        !_this.props.unslick ? nextArrow : "",
	        !_this.props.unslick ? dots : ""
	      );
	    };
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _extends({}, _initialState2.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react2.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react2.default.Component);

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(1186);
	
	var _json2mq = __webpack_require__(933);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(1183);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _innerSliderUtils = __webpack_require__(207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(890);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.innerSliderRefHandler = function (ref) {
	      return _this.innerSlider = ref;
	    };
	
	    _this.slickPrev = function () {
	      return _this.innerSlider.slickPrev();
	    };
	
	    _this.slickNext = function () {
	      return _this.innerSlider.slickNext();
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    };
	
	    _this.slickPause = function () {
	      return _this.innerSlider.pause("paused");
	    };
	
	    _this.slickPlay = function () {
	      return _this.innerSlider.autoPlay("play");
	    };
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  // handles responsive breakpoints
	
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // performance monitoring
	    //if (process.env.NODE_ENV !== 'production') {
	    //const { whyDidYouUpdate } = require('why-did-you-update')
	    //whyDidYouUpdate(React)
	    //}
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery = void 0;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({
	            minWidth: breakpoints[index - 1] + 1,
	            maxWidth: breakpoint
	          });
	        }
	        // when not using server side rendering
	        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = _extends({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
	        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && process.env.NODE_ENV !== "production") {
	        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
	        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === "string") {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    // rows and slidesPerRow logic is handled here
	    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	      settings.variableWidth = false;
	    }
	    var newChildren = [];
	    var currentWidth = null;
	    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	      var newSlide = [];
	      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	        var row = [];
	        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	          if (settings.variableWidth && children[k].props.style) {
	            currentWidth = children[k].props.style.width;
	          }
	          if (k >= children.length) break;
	          row.push(_react2.default.cloneElement(children[k], {
	            key: 100 * i + 10 * j + k,
	            tabIndex: -1,
	            style: {
	              width: 100 / settings.slidesPerRow + "%",
	              display: "inline-block"
	            }
	          }));
	        }
	        newSlide.push(_react2.default.createElement(
	          "div",
	          { key: 10 * i + j },
	          row
	        ));
	      }
	      if (settings.variableWidth) {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i, style: { width: currentWidth } },
	          newSlide
	        ));
	      } else {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i },
	          newSlide
	        ));
	      }
	    }
	
	    if (settings === "unslick") {
	      var className = "regular slider " + (this.props.className || "");
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        newChildren
	      );
	    } else if (newChildren.length <= settings.slidesToShow) {
	      settings.unslick = true;
	    }
	    return _react2.default.createElement(
	      _innerSlider.InnerSlider,
	      _extends({ ref: this.innerSliderRefHandler }, settings),
	      newChildren
	    );
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(172);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement("div", null);
	    }
	    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames2.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    }));
	
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        if (key >= startIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        if (key < endIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides(this.props);
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    return _react2.default.createElement(
	      "div",
	      _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents),
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.PureComponent);

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(1085);
	var EventPluginUtils = __webpack_require__(199);
	var EventPropagators = __webpack_require__(139);
	var SyntheticUIEvent = __webpack_require__(141);
	var TouchEventUtils = __webpack_require__(1190);
	var ViewportMetrics = __webpack_require__(290);
	
	var keyOf = __webpack_require__(902);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    'topTouchCancel',
	    'topTouchEnd',
	    'topTouchStart',
	    'topTouchMove'
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  'topTouchStart',
	  'topTouchCancel',
	  'topTouchEnd',
	  'topTouchMove',
	];
	
	var dependencies = [
	  'topMouseDown',
	  'topMouseMove',
	  'topMouseUp',
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var invariant = __webpack_require__(15);
	var defaultClickRejectionStrategy = __webpack_require__(1191);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (process.env.NODE_ENV !== 'production') {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(138).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(1189)(shouldRejectClick)
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(635);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	        process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(147);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1196);
	var ReactElement = __webpack_require__(117);
	
	var emptyFunction = __webpack_require__(71);
	var traverseAllChildren = __webpack_require__(1207);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(117);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (process.env.NODE_ENV !== 'production') {
	  var ReactElementValidator = __webpack_require__(458);
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (process.env.NODE_ENV !== 'production') {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(117),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(420);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(147);
	
	var ReactPropTypeLocationNames = __webpack_require__(1199);
	var ReactPropTypesSecret = __webpack_require__(1201);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(19);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(53);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (process.env.NODE_ENV !== 'production') {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = __webpack_require__(53);
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(456),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(117),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(459);
	var factory = __webpack_require__(376);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(147);
	
	var ReactElement = __webpack_require__(117);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(147);
	
	var ReactCurrentOwner = __webpack_require__(80);
	var REACT_ELEMENT_TYPE = __webpack_require__(457);
	
	var getIteratorFn = __webpack_require__(460);
	var invariant = __webpack_require__(15);
	var KeyEscapeUtils = __webpack_require__(1195);
	var warning = __webpack_require__(19);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (process.env.NODE_ENV !== 'production') {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (process.env.NODE_ENV !== 'production') {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(1214);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(1212);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	};
	
	exports.default = isClassComponent;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(1211);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && (process.env.NODE_ENV === 'production' || !Component.propTypes));
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(461);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(1209);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _class.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(1210);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(462);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(463);
	
	var _isPlainObject = __webpack_require__(268);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(464);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (process.env.NODE_ENV !== 'production') {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (process.env.NODE_ENV !== 'production') {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Tween = __webpack_require__(639);
	var raf = __webpack_require__(638);
	
	/**
	 * Expose `scrollTo`.
	 */
	
	module.exports = scrollTo;
	
	/**
	 * Scroll to `(x, y)`.
	 *
	 * @param {Number} x
	 * @param {Number} y
	 * @api public
	 */
	
	function scrollTo(x, y, options) {
	  options = options || {};
	
	  // start position
	  var start = scroll();
	
	  // setup tween
	  var tween = Tween(start)
	    .ease(options.ease || 'out-circ')
	    .to({ top: y, left: x })
	    .duration(options.duration || 1000);
	
	  // scroll
	  tween.update(function(o){
	    window.scrollTo(o.left | 0, o.top | 0);
	  });
	
	  // handle end
	  tween.on('end', function(){
	    animate = function(){};
	  });
	
	  // animate
	  function animate() {
	    raf(animate);
	    tween.update();
	  }
	
	  animate();
	  
	  return tween;
	}
	
	/**
	 * Return scroll position.
	 *
	 * @return {Object}
	 * @api private
	 */
	
	function scroll() {
	  var y = window.pageYOffset || document.documentElement.scrollTop;
	  var x = window.pageXOffset || document.documentElement.scrollLeft;
	  return { top: y, left: x };
	}


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(884);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1225)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js!../../node_modules/sass-loader/index.js!./main.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js!../../node_modules/sass-loader/index.js!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1228);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(465)(module)))

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js